var $a5056a6656605403$exports = {};
/*! For license information please see widget.module.js.LICENSE.txt */ (()=>{
    var e1 = {
        406: (e1, t, n)=>{
            var i = n(494), r = {
                ease: i(.25, .1, .25, 1),
                easeIn: i(.42, 0, 1, 1),
                easeOut: i(0, 0, .58, 1),
                easeInOut: i(.42, 0, .58, 1),
                linear: i(0, 0, 1, 1)
            };
            function a() {}
            function s() {
                var e1 = new Set, t = new Set, n = 0;
                return {
                    next: i,
                    cancel: i,
                    clearAll: function() {
                        e1.clear(), t.clear(), cancelAnimationFrame(n), n = 0;
                    }
                };
                function i(e1) {
                    t.add(e1), n || (n = requestAnimationFrame(r));
                }
                function r() {
                    n = 0;
                    var i = t;
                    t = e1, (e1 = i).forEach(function(e1) {
                        e1();
                    }), e1.clear();
                }
            }
            e1.exports = function(e1, t, n) {
                var i = Object.create(null), s = Object.create(null), o = "function" == typeof (n = n || {}).easing ? n.easing : r[n.easing];
                o || (n.easing && console.warn("Unknown easing function in amator: " + n.easing), o = r.ease);
                var l = "function" == typeof n.step ? n.step : a, c = "function" == typeof n.done ? n.done : a, u = function(e1) {
                    if (!e1) return "undefined" != typeof window && window.requestAnimationFrame ? {
                        next: window.requestAnimationFrame.bind(window),
                        cancel: window.cancelAnimationFrame.bind(window)
                    } : {
                        next: function(e1) {
                            return setTimeout(e1, 1e3 / 60);
                        },
                        cancel: function(e1) {
                            return clearTimeout(e1);
                        }
                    };
                    if ("function" != typeof e1.next) throw new Error("Scheduler is supposed to have next(cb) function");
                    if ("function" != typeof e1.cancel) throw new Error("Scheduler is supposed to have cancel(handle) function");
                    return e1;
                }(n.scheduler), h = Object.keys(t);
                h.forEach(function(n) {
                    i[n] = e1[n], s[n] = t[n] - e1[n];
                });
                var d, p = "number" == typeof n.duration ? n.duration : 400, f = Math.max(1, .06 * p), m = 0;
                return d = u.next(function t() {
                    var n = o(m / f);
                    m += 1, function(t) {
                        h.forEach(function(n) {
                            e1[n] = s[n] * t + i[n];
                        });
                    }(n), m <= f ? (d = u.next(t), l(e1)) : (d = 0, setTimeout(function() {
                        c(e1);
                    }, 0));
                }), {
                    cancel: function() {
                        u.cancel(d), d = 0;
                    }
                };
            }, e1.exports.makeAggregateRaf = s, e1.exports.sharedScheduler = s();
        },
        494: (e1)=>{
            var t = .1, n = "function" == typeof Float32Array;
            function i(e1, t) {
                return 1 - 3 * t + 3 * e1;
            }
            function r(e1, t) {
                return 3 * t - 6 * e1;
            }
            function a(e1) {
                return 3 * e1;
            }
            function s(e1, t, n) {
                return ((i(t, n) * e1 + r(t, n)) * e1 + a(t)) * e1;
            }
            function o(e1, t, n) {
                return 3 * i(t, n) * e1 * e1 + 2 * r(t, n) * e1 + a(t);
            }
            function l(e1) {
                return e1;
            }
            e1.exports = function(e1, i, r, a) {
                if (!(0 <= e1 && e1 <= 1 && 0 <= r && r <= 1)) throw new Error("bezier x values must be in [0, 1] range");
                if (e1 === i && r === a) return l;
                for(var c = n ? new Float32Array(11) : new Array(11), u = 0; u < 11; ++u)c[u] = s(u * t, e1, r);
                return function(n) {
                    return 0 === n ? 0 : 1 === n ? 1 : s(function(n) {
                        for(var i = 0, a = 1; 10 !== a && c[a] <= n; ++a)i += t;
                        --a;
                        var l = i + (n - c[a]) / (c[a + 1] - c[a]) * t, u = o(l, e1, r);
                        return u >= .001 ? function(e1, t, n, i) {
                            for(var r = 0; r < 4; ++r){
                                var a = o(t, n, i);
                                if (0 === a) return t;
                                t -= (s(t, n, i) - e1) / a;
                            }
                            return t;
                        }(n, l, e1, r) : 0 === u ? l : function(e1, t, n, i, r) {
                            var a, o, l = 0;
                            do (a = s(o = t + (n - t) / 2, i, r) - e1) > 0 ? n = o : t = o;
                            while (Math.abs(a) > 1e-7 && ++l < 10);
                            return o;
                        }(n, i, i + t, e1, r);
                    }(n), i, a);
                };
            };
        },
        89: (e1)=>{
            "use strict";
            e1.exports = function(e1) {
                var t = [];
                return t.toString = function() {
                    return this.map(function(t) {
                        var n = "", i = void 0 !== t[5];
                        return t[4] && (n += "@supports (".concat(t[4], ") {")), t[2] && (n += "@media ".concat(t[2], " {")), i && (n += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), n += e1(t), i && (n += "}"), t[2] && (n += "}"), t[4] && (n += "}"), n;
                    }).join("");
                }, t.i = function(e1, n, i, r, a) {
                    "string" == typeof e1 && (e1 = [
                        [
                            null,
                            e1,
                            void 0
                        ]
                    ]);
                    var s = {};
                    if (i) for(var o = 0; o < this.length; o++){
                        var l = this[o][0];
                        null != l && (s[l] = !0);
                    }
                    for(var c = 0; c < e1.length; c++){
                        var u = [].concat(e1[c]);
                        i && s[u[0]] || (void 0 !== a && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = a), n && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = n) : u[2] = n), r && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = r) : u[4] = "".concat(r)), t.push(u));
                    }
                }, t;
            };
        },
        492: (e1)=>{
            "use strict";
            e1.exports = function(e1, t) {
                return t || (t = {}), e1 ? (e1 = String(e1.__esModule ? e1.default : e1), /^['"].*['"]$/.test(e1) && (e1 = e1.slice(1, -1)), t.hash && (e1 += t.hash), /["'() \t\n]|(%20)/.test(e1) || t.needQuotes ? '"'.concat(e1.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"') : e1) : e1;
            };
        },
        248: (e1)=>{
            "use strict";
            e1.exports = function(e1) {
                return e1[1];
            };
        },
        657: (e1)=>{
            e1.exports = function(e1) {
                !function(e1) {
                    if (!e1) throw new Error("Eventify cannot use falsy object as events subject");
                    for(var t = [
                        "on",
                        "fire",
                        "off"
                    ], n = 0; n < t.length; ++n)if (e1.hasOwnProperty(t[n])) throw new Error("Subject cannot be eventified, since it already has property '" + t[n] + "'");
                }(e1);
                var t = function(e1) {
                    var t = Object.create(null);
                    return {
                        on: function(n, i, r) {
                            if ("function" != typeof i) throw new Error("callback is expected to be a function");
                            var a = t[n];
                            return a || (a = t[n] = []), a.push({
                                callback: i,
                                ctx: r
                            }), e1;
                        },
                        off: function(n, i) {
                            if (void 0 === n) return t = Object.create(null), e1;
                            if (t[n]) {
                                if ("function" != typeof i) delete t[n];
                                else for(var r = t[n], a = 0; a < r.length; ++a)r[a].callback === i && r.splice(a, 1);
                            }
                            return e1;
                        },
                        fire: function(n) {
                            var i, r = t[n];
                            if (!r) return e1;
                            arguments.length > 1 && (i = Array.prototype.splice.call(arguments, 1));
                            for(var a = 0; a < r.length; ++a){
                                var s = r[a];
                                s.callback.apply(s.ctx, i);
                            }
                            return e1;
                        }
                    };
                }(e1);
                return e1.on = t.on, e1.off = t.off, e1.fire = t.fire, e1;
            };
        },
        383: (e1)=>{
            "use strict";
            var t = Object.getOwnPropertySymbols, n = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
            e1.exports = function() {
                try {
                    if (!Object.assign) return !1;
                    var e1 = new String("abc");
                    if (e1[5] = "de", "5" === Object.getOwnPropertyNames(e1)[0]) return !1;
                    for(var t = {}, n = 0; n < 10; n++)t["_" + String.fromCharCode(n)] = n;
                    if ("0123456789" !== Object.getOwnPropertyNames(t).map(function(e1) {
                        return t[e1];
                    }).join("")) return !1;
                    var i = {};
                    return "abcdefghijklmnopqrst".split("").forEach(function(e1) {
                        i[e1] = e1;
                    }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, i)).join("");
                } catch (e1) {
                    return !1;
                }
            }() ? Object.assign : function(e1, r) {
                for(var a, s, o = function(e1) {
                    if (null == e1) throw new TypeError("Object.assign cannot be called with null or undefined");
                    return Object(e1);
                }(e1), l = 1; l < arguments.length; l++){
                    for(var c in a = Object(arguments[l]))n.call(a, c) && (o[c] = a[c]);
                    if (t) {
                        s = t(a);
                        for(var u = 0; u < s.length; u++)i.call(a, s[u]) && (o[s[u]] = a[s[u]]);
                    }
                }
                return o;
            };
        },
        300: (e1, t, n)=>{
            "use strict";
            var i = n(447), r = n(406), a = n(657), s = n(339), o = n(792), l = o(), c = o(!0), u = n(152), h = n(854), d = n(748);
            function p(e1, t) {
                var n = (t = t || {}).controller;
                if (n || (h.canAttach(e1) ? n = h(e1, t) : d.canAttach(e1) && (n = d(e1, t))), !n) throw new Error("Cannot create panzoom for the current type of dom element");
                var o = n.getOwner(), p = {
                    x: 0,
                    y: 0
                }, m = !1, M = new u;
                n.initTransform && n.initTransform(M);
                var y, x = "function" == typeof t.filterKey ? t.filterKey : g, _ = "number" == typeof t.pinchSpeed ? t.pinchSpeed : 1, b = t.bounds, w = "number" == typeof t.maxZoom ? t.maxZoom : Number.POSITIVE_INFINITY, E = "number" == typeof t.minZoom ? t.minZoom : 0, T = "number" == typeof t.boundsPadding ? t.boundsPadding : .05, S = "number" == typeof t.zoomDoubleClickSpeed ? t.zoomDoubleClickSpeed : 1.75, I = t.beforeWheel || g, N = t.beforeMouseDown || g, D = "number" == typeof t.zoomSpeed ? t.zoomSpeed : 1, C = f(t.transformOrigin), L = t.enableTextSelection ? c : l;
                !function(e1) {
                    var t = typeof e1;
                    if ("undefined" !== t && "boolean" !== t && !(A(e1.left) && A(e1.top) && A(e1.bottom) && A(e1.right))) throw new Error("Bounds object is not valid. It can be: undefined, boolean (true|false) or an object {left, top, right, bottom}");
                }(b), t.autocenter && function() {
                    var e1, t, i = 0, r = 0, a = ae();
                    if (a) i = a.left, r = a.top, e1 = a.right - a.left, t = a.bottom - a.top;
                    else {
                        var s = o.getBoundingClientRect();
                        e1 = s.width, t = s.height;
                    }
                    var l = n.getBBox();
                    if (0 !== l.width && 0 !== l.height) {
                        var c = t / l.height, u = e1 / l.width, h = Math.min(u, c);
                        M.x = -(l.left + l.width / 2) * h + e1 / 2 + i, M.y = -(l.top + l.height / 2) * h + t / 2 + r, M.scale = h;
                    }
                }();
                var R, z, O, P, U, k, j, B, F, H, V = 0, G = 0, Q = 0, W = null, Y = new Date, X = !1, Z = !1;
                j = "smoothScroll" in t && !t.smoothScroll ? {
                    start: g,
                    stop: g,
                    cancel: g
                } : s(function() {
                    return {
                        x: M.x,
                        y: M.y
                    };
                }, function(e1, t) {
                    Le(), ne(e1, t);
                }, t.smoothScroll);
                var q = !1;
                ue();
                var K = {
                    dispose: function() {
                        he();
                    },
                    moveBy: ce,
                    moveTo: ne,
                    smoothMoveTo: function(e1, t) {
                        ce(e1 - M.x, t - M.y, !0);
                    },
                    centerOn: function(e1) {
                        var t = e1.ownerSVGElement;
                        if (!t) throw new Error("ui element is required to be within the scene");
                        var n = e1.getBoundingClientRect(), i = n.left + n.width / 2, r = n.top + n.height / 2, a = t.getBoundingClientRect();
                        ce(a.width / 2 - i, a.height / 2 - r, !0);
                    },
                    zoomTo: Ce,
                    zoomAbs: le,
                    smoothZoom: Ne,
                    smoothZoomAbs: function(e1, t, n) {
                        var i = {
                            scale: M.scale
                        }, a = {
                            scale: n
                        };
                        j.cancel(), Le(), F = r(i, a, {
                            step: function(n) {
                                le(e1, t, n.scale);
                            }
                        });
                    },
                    showRectangle: function(e1) {
                        var t = o.getBoundingClientRect(), n = te(t.width, t.height), i = e1.right - e1.left, r = e1.bottom - e1.top;
                        if (!Number.isFinite(i) || !Number.isFinite(r)) throw new Error("Invalid rectangle");
                        var a = n.x / i, s = n.y / r, l = Math.min(a, s);
                        M.x = -(e1.left + i / 2) * l + n.x / 2, M.y = -(e1.top + r / 2) * l + n.y / 2, M.scale = l;
                    },
                    pause: function() {
                        he(), q = !0;
                    },
                    resume: function() {
                        q && (ue(), q = !1);
                    },
                    isPaused: function() {
                        return q;
                    },
                    getTransform: function() {
                        return M;
                    },
                    getMinZoom: function() {
                        return E;
                    },
                    setMinZoom: function(e1) {
                        E = e1;
                    },
                    getMaxZoom: function() {
                        return w;
                    },
                    setMaxZoom: function(e1) {
                        w = e1;
                    },
                    getTransformOrigin: function() {
                        return C;
                    },
                    setTransformOrigin: function(e1) {
                        C = f(e1);
                    },
                    getZoomSpeed: function() {
                        return D;
                    },
                    setZoomSpeed: function(e1) {
                        if (!Number.isFinite(e1)) throw new Error("Zoom speed should be a number");
                        D = e1;
                    }
                };
                a(K);
                var J = "number" == typeof t.initialX ? t.initialX : M.x, $ = "number" == typeof t.initialY ? t.initialY : M.y, ee = "number" == typeof t.initialZoom ? t.initialZoom : M.scale;
                return J == M.x && $ == M.y && ee == M.scale || le(J, $, ee), K;
                function te(e1, t) {
                    if (n.getScreenCTM) {
                        var i = n.getScreenCTM(), r = i.a, a = i.d, s = i.e, o = i.f;
                        p.x = e1 * r - s, p.y = t * a - o;
                    } else p.x = e1, p.y = t;
                    return p;
                }
                function ne(e1, t) {
                    M.x = e1, M.y = t, re(), Ue("pan"), se();
                }
                function ie(e1, t) {
                    ne(M.x + e1, M.y + t);
                }
                function re() {
                    var e1 = ae();
                    if (e1) {
                        var t, i, r, a, s = !1, o = (r = (t = n.getBBox()).left, a = t.top, {
                            left: (i = {
                                x: r * M.scale + M.x,
                                y: a * M.scale + M.y
                            }).x,
                            top: i.y,
                            right: t.width * M.scale + i.x,
                            bottom: t.height * M.scale + i.y
                        }), l = e1.left - o.right;
                        return l > 0 && (M.x += l, s = !0), (l = e1.right - o.left) < 0 && (M.x += l, s = !0), (l = e1.top - o.bottom) > 0 && (M.y += l, s = !0), (l = e1.bottom - o.top) < 0 && (M.y += l, s = !0), s;
                    }
                }
                function ae() {
                    if (b) {
                        if ("boolean" == typeof b) {
                            var e1 = o.getBoundingClientRect(), t = e1.width, n = e1.height;
                            return {
                                left: t * T,
                                top: n * T,
                                right: t * (1 - T),
                                bottom: n * (1 - T)
                            };
                        }
                        return b;
                    }
                }
                function se() {
                    m = !0, y = window.requestAnimationFrame(de);
                }
                function oe(e1, t, n) {
                    if (v(e1) || v(t) || v(n)) throw new Error("zoom requires valid numbers");
                    var i = M.scale * n;
                    if (i < E) {
                        if (M.scale === E) return;
                        n = E / M.scale;
                    }
                    if (i > w) {
                        if (M.scale === w) return;
                        n = w / M.scale;
                    }
                    var r = te(e1, t);
                    M.x = r.x - n * (r.x - M.x), M.y = r.y - n * (r.y - M.y), b && 1 === T && 1 === E ? (M.scale *= n, re()) : re() || (M.scale *= n), Ue("zoom"), se();
                }
                function le(e1, t, n) {
                    oe(e1, t, n / M.scale);
                }
                function ce(e1, t, n) {
                    if (!n) return ie(e1, t);
                    B && B.cancel();
                    var i = 0, a = 0;
                    B = r({
                        x: 0,
                        y: 0
                    }, {
                        x: e1,
                        y: t
                    }, {
                        step: function(e1) {
                            ie(e1.x - i, e1.y - a), i = e1.x, a = e1.y;
                        }
                    });
                }
                function ue() {
                    o.addEventListener("mousedown", _e, {
                        passive: !1
                    }), o.addEventListener("dblclick", xe, {
                        passive: !1
                    }), o.addEventListener("touchstart", fe, {
                        passive: !1
                    }), o.addEventListener("keydown", pe, {
                        passive: !1
                    }), i.addWheelListener(o, Se, {
                        passive: !1
                    }), se();
                }
                function he() {
                    i.removeWheelListener(o, Se), o.removeEventListener("mousedown", _e), o.removeEventListener("keydown", pe), o.removeEventListener("dblclick", xe), o.removeEventListener("touchstart", fe), y && (window.cancelAnimationFrame(y), y = 0), j.cancel(), Ee(), Te(), L.release(), Oe();
                }
                function de() {
                    m && (m = !1, n.applyTransform(M), Ue("transform"), y = 0);
                }
                function pe(e1) {
                    var t = 0, n = 0, i = 0;
                    if (38 === e1.keyCode ? n = 1 : 40 === e1.keyCode ? n = -1 : 37 === e1.keyCode ? t = 1 : 39 === e1.keyCode ? t = -1 : 189 === e1.keyCode || 109 === e1.keyCode ? i = 1 : 187 !== e1.keyCode && 107 !== e1.keyCode || (i = -1), !x(e1, t, n, i)) {
                        if (t || n) {
                            e1.preventDefault(), e1.stopPropagation();
                            var r = o.getBoundingClientRect();
                            ce(.05 * (a = Math.min(r.width, r.height)) * t, .05 * a * n);
                        }
                        if (i) {
                            var a, s = Re(100 * i);
                            Ce((a = C ? De() : {
                                x: (l = o.getBoundingClientRect()).width / 2,
                                y: l.height / 2
                            }).x, a.y, s);
                        }
                        var l;
                    }
                }
                function fe(e1) {
                    if (function(e1) {
                        t.onTouch && !t.onTouch(e1) || (e1.stopPropagation(), e1.preventDefault());
                    }(e1), Ae(), 1 === e1.touches.length) return function(e1) {
                        G = new Date;
                        var t = Ie(e1.touches[0]);
                        R = t;
                        var n = te(t.x, t.y);
                        z = n.x, O = n.y, P = z, U = O, j.cancel(), me();
                    }(e1, e1.touches[0]);
                    2 === e1.touches.length && (k = ye(e1.touches[0], e1.touches[1]), H = !0, me());
                }
                function me() {
                    X || (X = !0, document.addEventListener("touchmove", ge), document.addEventListener("touchend", Me), document.addEventListener("touchcancel", Me));
                }
                function ge(e1) {
                    if (1 === e1.touches.length) {
                        e1.stopPropagation();
                        var t = te((u = Ie(e1.touches[0])).x, u.y), n = t.x - z, i = t.y - O;
                        0 !== n && 0 !== i && ze(), z = t.x, O = t.y, ce(n, i);
                    } else if (2 === e1.touches.length) {
                        H = !0;
                        var r = e1.touches[0], a = e1.touches[1], s = ye(r, a), o = 1 + (s / k - 1) * _, l = Ie(r), c = Ie(a);
                        if (z = (l.x + c.x) / 2, O = (l.y + c.y) / 2, C) {
                            var u = De();
                            z = u.x, O = u.y;
                        }
                        Ce(z, O, o), k = s, e1.stopPropagation(), e1.preventDefault();
                    }
                }
                function Ae() {
                    Q && (clearTimeout(Q), Q = 0);
                }
                function ve(e1) {
                    if (t.onClick) {
                        Ae();
                        var n = z - P, i = O - U;
                        Math.sqrt(n * n + i * i) > 5 || (Q = setTimeout(function() {
                            Q = 0, t.onClick(e1);
                        }, 300));
                    }
                }
                function Me(e1) {
                    if (Ae(), e1.touches.length > 0) {
                        var t = te((n = Ie(e1.touches[0])).x, n.y);
                        z = t.x, O = t.y;
                    } else {
                        var n, i = new Date;
                        i - V < 300 ? C ? Ne((n = De()).x, n.y, S) : Ne(R.x, R.y, S) : i - G < 200 && ve(e1), V = i, Oe(), Te();
                    }
                }
                function ye(e1, t) {
                    var n = e1.clientX - t.clientX, i = e1.clientY - t.clientY;
                    return Math.sqrt(n * n + i * i);
                }
                function xe(e1) {
                    !function(e1) {
                        Ae(), t.onDoubleClick && !t.onDoubleClick(e1) || (e1.preventDefault(), e1.stopPropagation());
                    }(e1);
                    var n = Ie(e1);
                    C && (n = De()), Ne(n.x, n.y, S);
                }
                function _e(e1) {
                    if (Ae(), !N(e1)) {
                        if (W = e1, Y = new Date, X) return e1.stopPropagation(), !1;
                        if (1 === e1.button && null !== window.event || 0 === e1.button) {
                            j.cancel();
                            var t = Ie(e1), n = te(t.x, t.y);
                            return P = z = n.x, U = O = n.y, document.addEventListener("mousemove", be), document.addEventListener("mouseup", we), L.capture(e1.target || e1.srcElement), !1;
                        }
                    }
                }
                function be(e1) {
                    if (!X) {
                        ze();
                        var t = Ie(e1), n = te(t.x, t.y), i = n.x - z, r = n.y - O;
                        z = n.x, O = n.y, ce(i, r);
                    }
                }
                function we() {
                    new Date - Y < 200 && ve(W), L.release(), Oe(), Ee();
                }
                function Ee() {
                    document.removeEventListener("mousemove", be), document.removeEventListener("mouseup", we), Z = !1;
                }
                function Te() {
                    document.removeEventListener("touchmove", ge), document.removeEventListener("touchend", Me), document.removeEventListener("touchcancel", Me), Z = !1, H = !1, X = !1;
                }
                function Se(e1) {
                    if (!I(e1)) {
                        j.cancel();
                        var t = e1.deltaY;
                        e1.deltaMode > 0 && (t *= 100);
                        var n = Re(t);
                        if (1 !== n) {
                            var i = C ? De() : Ie(e1);
                            Ce(i.x, i.y, n), e1.preventDefault();
                        }
                    }
                }
                function Ie(e1) {
                    var t = o.getBoundingClientRect();
                    return {
                        x: e1.clientX - t.left,
                        y: e1.clientY - t.top
                    };
                }
                function Ne(e1, t, n) {
                    var i = M.scale, a = {
                        scale: i
                    }, s = {
                        scale: n * i
                    };
                    j.cancel(), Le(), F = r(a, s, {
                        step: function(n) {
                            le(e1, t, n.scale);
                        },
                        done: Pe
                    });
                }
                function De() {
                    var e1 = o.getBoundingClientRect();
                    return {
                        x: e1.width * C.x,
                        y: e1.height * C.y
                    };
                }
                function Ce(e1, t, n) {
                    return j.cancel(), Le(), oe(e1, t, n);
                }
                function Le() {
                    F && (F.cancel(), F = null);
                }
                function Re(e1) {
                    return 1 - Math.sign(e1) * Math.min(.25, Math.abs(D * e1 / 128));
                }
                function ze() {
                    Z || (Ue("panstart"), Z = !0, j.start());
                }
                function Oe() {
                    Z && (H || j.stop(), Ue("panend"));
                }
                function Pe() {
                    Ue("zoomend");
                }
                function Ue(e1) {
                    K.fire(e1, K);
                }
            }
            function f(e1) {
                if (e1) return "object" == typeof e1 ? (A(e1.x) && A(e1.y) || m(e1), e1) : void m();
            }
            function m(e1) {
                throw console.error(e1), new Error([
                    "Cannot parse transform origin.",
                    "Some good examples:",
                    '  "center center" can be achieved with {x: 0.5, y: 0.5}',
                    '  "top center" can be achieved with {x: 0.5, y: 0}',
                    '  "bottom right" can be achieved with {x: 1, y: 1}'
                ].join("\n"));
            }
            function g() {}
            function A(e1) {
                return Number.isFinite(e1);
            }
            function v(e1) {
                return Number.isNaN ? Number.isNaN(e1) : e1 != e1;
            }
            e1.exports = p, function() {
                if ("undefined" != typeof document) {
                    var e1 = document.getElementsByTagName("script");
                    if (e1) {
                        for(var t, n = 0; n < e1.length; ++n){
                            var i = e1[n];
                            if (i.src && i.src.match(/\bpanzoom(\.min)?\.js/)) {
                                t = i;
                                break;
                            }
                        }
                        if (t) {
                            var r = t.getAttribute("query");
                            if (r) {
                                var a = t.getAttribute("name") || "pz", s = Date.now();
                                !function e1() {
                                    var n = document.querySelector(r);
                                    if (!n) return Date.now() - s < 2e3 ? void setTimeout(e1, 100) : void console.error("Cannot find the panzoom element", a);
                                    var i = function(e1) {
                                        for(var t = e1.attributes, n = {}, i = 0; i < t.length; ++i){
                                            var r = o(t[i]);
                                            r && (n[r.name] = r.value);
                                        }
                                        return n;
                                    }(t);
                                    console.log(i), window[a] = p(n, i);
                                }();
                            }
                        }
                    }
                }
                function o(e1) {
                    if (e1.name && "p" === e1.name[0] && "z" === e1.name[1] && "-" === e1.name[2]) return {
                        name: e1.name.substr(3),
                        value: JSON.parse(e1.value)
                    };
                }
            }();
        },
        792: (e1)=>{
            function t(e1) {
                return e1.stopPropagation(), !1;
            }
            function n() {}
            e1.exports = function(e1) {
                if (e1) return {
                    capture: n,
                    release: n
                };
                var i, r, a, s = !1;
                return {
                    capture: function(e1) {
                        s = !0, r = window.document.onselectstart, a = window.document.ondragstart, window.document.onselectstart = t, (i = e1).ondragstart = t;
                    },
                    release: function() {
                        s && (s = !1, window.document.onselectstart = r, i && (i.ondragstart = a));
                    }
                };
            };
        },
        748: (e1)=>{
            function t(e1) {
                return e1 && e1.parentElement && e1.style;
            }
            e1.exports = function(e1, n) {
                if (!t(e1)) throw new Error("panzoom requires DOM element to be attached to the DOM tree");
                var i = e1.parentElement;
                return e1.scrollTop = 0, n.disableKeyboardInteraction || i.setAttribute("tabindex", 0), {
                    getBBox: function() {
                        return {
                            left: 0,
                            top: 0,
                            width: e1.clientWidth,
                            height: e1.clientHeight
                        };
                    },
                    getOwner: function() {
                        return i;
                    },
                    applyTransform: function(t) {
                        e1.style.transformOrigin = "0 0 0", e1.style.transform = "matrix(" + t.scale + ", 0, 0, " + t.scale + ", " + t.x + ", " + t.y + ")";
                    }
                };
            }, e1.exports.canAttach = t;
        },
        339: (e1)=>{
            function t() {
                return "function" == typeof cancelAnimationFrame ? cancelAnimationFrame : clearTimeout;
            }
            function n() {
                return "function" == typeof requestAnimationFrame ? requestAnimationFrame : function(e1) {
                    return setTimeout(e1, 16);
                };
            }
            e1.exports = function(e1, i, r) {
                "object" != typeof r && (r = {});
                var a, s, o, l, c, u, h, d, p, f, m = "number" == typeof r.minVelocity ? r.minVelocity : 5, g = "number" == typeof r.amplitude ? r.amplitude : .25, A = "function" == typeof r.cancelAnimationFrame ? r.cancelAnimationFrame : t(), v = "function" == typeof r.requestAnimationFrame ? r.requestAnimationFrame : n();
                return {
                    start: function() {
                        a = e1(), u = p = l = h = 0, s = new Date, A(o), A(f), o = v(M);
                    },
                    stop: function() {
                        A(o), A(f);
                        var t = e1();
                        c = t.x, d = t.y, s = Date.now(), (l < -m || l > m) && (c += u = g * l), (h < -m || h > m) && (d += p = g * h), f = v(y);
                    },
                    cancel: function() {
                        A(o), A(f);
                    }
                };
                function M() {
                    var t = Date.now(), n = t - s;
                    s = t;
                    var i = e1(), r = i.x - a.x, c = i.y - a.y;
                    a = i;
                    var u = 1e3 / (1 + n);
                    l = .8 * r * u + .2 * l, h = .8 * c * u + .2 * h, o = v(M);
                }
                function y() {
                    var e1 = Date.now() - s, t = !1, n = 0, r = 0;
                    u && ((n = -u * Math.exp(-e1 / 342)) > .5 || n < -0.5 ? t = !0 : n = u = 0), p && ((r = -p * Math.exp(-e1 / 342)) > .5 || r < -0.5 ? t = !0 : r = p = 0), t && (i(c + n, d + r), f = v(y));
                }
            };
        },
        854: (e1)=>{
            function t(e1) {
                return e1 && e1.ownerSVGElement && e1.getCTM;
            }
            e1.exports = function(e1, n) {
                if (!t(e1)) throw new Error("svg element is required for svg.panzoom to work");
                var i = e1.ownerSVGElement;
                if (!i) throw new Error("Do not apply panzoom to the root <svg> element. Use its child instead (e.g. <g></g>). As of March 2016 only FireFox supported transform on the root element");
                return n.disableKeyboardInteraction || i.setAttribute("tabindex", 0), {
                    getBBox: function() {
                        var t = e1.getBBox();
                        return {
                            left: t.x,
                            top: t.y,
                            width: t.width,
                            height: t.height
                        };
                    },
                    getScreenCTM: function() {
                        var e1 = i.getCTM();
                        return e1 || i.getScreenCTM();
                    },
                    getOwner: function() {
                        return i;
                    },
                    applyTransform: function(t) {
                        e1.setAttribute("transform", "matrix(" + t.scale + " 0 0 " + t.scale + " " + t.x + " " + t.y + ")");
                    },
                    initTransform: function(t) {
                        var n = e1.getCTM();
                        null === n && (n = document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGMatrix()), t.x = n.e, t.y = n.f, t.scale = n.a, i.removeAttributeNS(null, "viewBox");
                    }
                };
            }, e1.exports.canAttach = t;
        },
        152: (e1)=>{
            e1.exports = function() {
                this.x = 0, this.y = 0, this.scale = 1;
            };
        },
        230: (e1, t, n)=>{
            "use strict";
            var i = n(471), r = n(383), a = n(817);
            function s(e1) {
                for(var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e1, n = 1; n < arguments.length; n++)t += "&args[]=" + encodeURIComponent(arguments[n]);
                return "Minified React error #" + e1 + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            if (!i) throw Error(s(227));
            var o = new Set, l = {};
            function c(e1, t) {
                u(e1, t), u(e1 + "Capture", t);
            }
            function u(e1, t) {
                for(l[e1] = t, e1 = 0; e1 < t.length; e1++)o.add(t[e1]);
            }
            var h = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement), d = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, p = Object.prototype.hasOwnProperty, f = {}, m = {};
            function g(e1, t, n, i, r, a, s) {
                this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = i, this.attributeNamespace = r, this.mustUseProperty = n, this.propertyName = e1, this.type = t, this.sanitizeURL = a, this.removeEmptyString = s;
            }
            var A = {};
            "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(e1) {
                A[e1] = new g(e1, 0, !1, e1, null, !1, !1);
            }), [
                [
                    "acceptCharset",
                    "accept-charset"
                ],
                [
                    "className",
                    "class"
                ],
                [
                    "htmlFor",
                    "for"
                ],
                [
                    "httpEquiv",
                    "http-equiv"
                ]
            ].forEach(function(e1) {
                var t = e1[0];
                A[t] = new g(t, 1, !1, e1[1], null, !1, !1);
            }), [
                "contentEditable",
                "draggable",
                "spellCheck",
                "value"
            ].forEach(function(e1) {
                A[e1] = new g(e1, 2, !1, e1.toLowerCase(), null, !1, !1);
            }), [
                "autoReverse",
                "externalResourcesRequired",
                "focusable",
                "preserveAlpha"
            ].forEach(function(e1) {
                A[e1] = new g(e1, 2, !1, e1, null, !1, !1);
            }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(e1) {
                A[e1] = new g(e1, 3, !1, e1.toLowerCase(), null, !1, !1);
            }), [
                "checked",
                "multiple",
                "muted",
                "selected"
            ].forEach(function(e1) {
                A[e1] = new g(e1, 3, !0, e1, null, !1, !1);
            }), [
                "capture",
                "download"
            ].forEach(function(e1) {
                A[e1] = new g(e1, 4, !1, e1, null, !1, !1);
            }), [
                "cols",
                "rows",
                "size",
                "span"
            ].forEach(function(e1) {
                A[e1] = new g(e1, 6, !1, e1, null, !1, !1);
            }), [
                "rowSpan",
                "start"
            ].forEach(function(e1) {
                A[e1] = new g(e1, 5, !1, e1.toLowerCase(), null, !1, !1);
            });
            var v = /[\-:]([a-z])/g;
            function M(e1) {
                return e1[1].toUpperCase();
            }
            function y(e1, t, n, i) {
                var r = A.hasOwnProperty(t) ? A[t] : null;
                (null !== r ? 0 === r.type : !i && 2 < t.length && ("o" === t[0] || "O" === t[0]) && ("n" === t[1] || "N" === t[1])) || (function(e1, t, n, i) {
                    if (null == t || function(e1, t, n, i) {
                        if (null !== n && 0 === n.type) return !1;
                        switch(typeof t){
                            case "function":
                            case "symbol":
                                return !0;
                            case "boolean":
                                return !i && (null !== n ? !n.acceptsBooleans : "data-" !== (e1 = e1.toLowerCase().slice(0, 5)) && "aria-" !== e1);
                            default:
                                return !1;
                        }
                    }(e1, t, n, i)) return !0;
                    if (i) return !1;
                    if (null !== n) switch(n.type){
                        case 3:
                            return !t;
                        case 4:
                            return !1 === t;
                        case 5:
                            return isNaN(t);
                        case 6:
                            return isNaN(t) || 1 > t;
                    }
                    return !1;
                }(t, n, r, i) && (n = null), i || null === r ? function(e1) {
                    return !!p.call(m, e1) || !p.call(f, e1) && (d.test(e1) ? m[e1] = !0 : (f[e1] = !0, !1));
                }(t) && (null === n ? e1.removeAttribute(t) : e1.setAttribute(t, "" + n)) : r.mustUseProperty ? e1[r.propertyName] = null === n ? 3 !== r.type && "" : n : (t = r.attributeName, i = r.attributeNamespace, null === n ? e1.removeAttribute(t) : (n = 3 === (r = r.type) || 4 === r && !0 === n ? "" : "" + n, i ? e1.setAttributeNS(i, t, n) : e1.setAttribute(t, n))));
            }
            "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(e1) {
                var t = e1.replace(v, M);
                A[t] = new g(t, 1, !1, e1, null, !1, !1);
            }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(e1) {
                var t = e1.replace(v, M);
                A[t] = new g(t, 1, !1, e1, "http://www.w3.org/1999/xlink", !1, !1);
            }), [
                "xml:base",
                "xml:lang",
                "xml:space"
            ].forEach(function(e1) {
                var t = e1.replace(v, M);
                A[t] = new g(t, 1, !1, e1, "http://www.w3.org/XML/1998/namespace", !1, !1);
            }), [
                "tabIndex",
                "crossOrigin"
            ].forEach(function(e1) {
                A[e1] = new g(e1, 1, !1, e1.toLowerCase(), null, !1, !1);
            }), A.xlinkHref = new g("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), [
                "src",
                "href",
                "action",
                "formAction"
            ].forEach(function(e1) {
                A[e1] = new g(e1, 1, !1, e1.toLowerCase(), null, !0, !0);
            });
            var x = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, _ = 60103, b = 60106, w = 60107, E = 60108, T = 60114, S = 60109, I = 60110, N = 60112, D = 60113, C = 60120, L = 60115, R = 60116, z = 60121, O = 60128, P = 60129, U = 60130, k = 60131;
            if ("function" == typeof Symbol && Symbol.for) {
                var j = Symbol.for;
                _ = j("react.element"), b = j("react.portal"), w = j("react.fragment"), E = j("react.strict_mode"), T = j("react.profiler"), S = j("react.provider"), I = j("react.context"), N = j("react.forward_ref"), D = j("react.suspense"), C = j("react.suspense_list"), L = j("react.memo"), R = j("react.lazy"), z = j("react.block"), j("react.scope"), O = j("react.opaque.id"), P = j("react.debug_trace_mode"), U = j("react.offscreen"), k = j("react.legacy_hidden");
            }
            var B, F = "function" == typeof Symbol && Symbol.iterator;
            function H(e1) {
                return null === e1 || "object" != typeof e1 ? null : "function" == typeof (e1 = F && e1[F] || e1["@@iterator"]) ? e1 : null;
            }
            function V(e1) {
                if (void 0 === B) try {
                    throw Error();
                } catch (e1) {
                    var t = e1.stack.trim().match(/\n( *(at )?)/);
                    B = t && t[1] || "";
                }
                return "\n" + B + e1;
            }
            var G = !1;
            function Q(e1, t) {
                if (!e1 || G) return "";
                G = !0;
                var n = Error.prepareStackTrace;
                Error.prepareStackTrace = void 0;
                try {
                    if (t) {
                        if (t = function() {
                            throw Error();
                        }, Object.defineProperty(t.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        }), "object" == typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(t, []);
                            } catch (e1) {
                                var i = e1;
                            }
                            Reflect.construct(e1, [], t);
                        } else {
                            try {
                                t.call();
                            } catch (e1) {
                                i = e1;
                            }
                            e1.call(t.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (e1) {
                            i = e1;
                        }
                        e1();
                    }
                } catch (e1) {
                    if (e1 && i && "string" == typeof e1.stack) {
                        for(var r = e1.stack.split("\n"), a = i.stack.split("\n"), s = r.length - 1, o = a.length - 1; 1 <= s && 0 <= o && r[s] !== a[o];)o--;
                        for(; 1 <= s && 0 <= o; s--, o--)if (r[s] !== a[o]) {
                            if (1 !== s || 1 !== o) do {
                                if (s--, 0 > --o || r[s] !== a[o]) return "\n" + r[s].replace(" at new ", " at ");
                            }while (1 <= s && 0 <= o);
                            break;
                        }
                    }
                } finally{
                    G = !1, Error.prepareStackTrace = n;
                }
                return (e1 = e1 ? e1.displayName || e1.name : "") ? V(e1) : "";
            }
            function W(e1) {
                switch(e1.tag){
                    case 5:
                        return V(e1.type);
                    case 16:
                        return V("Lazy");
                    case 13:
                        return V("Suspense");
                    case 19:
                        return V("SuspenseList");
                    case 0:
                    case 2:
                    case 15:
                        return Q(e1.type, !1);
                    case 11:
                        return Q(e1.type.render, !1);
                    case 22:
                        return Q(e1.type._render, !1);
                    case 1:
                        return Q(e1.type, !0);
                    default:
                        return "";
                }
            }
            function Y(e1) {
                if (null == e1) return null;
                if ("function" == typeof e1) return e1.displayName || e1.name || null;
                if ("string" == typeof e1) return e1;
                switch(e1){
                    case w:
                        return "Fragment";
                    case b:
                        return "Portal";
                    case T:
                        return "Profiler";
                    case E:
                        return "StrictMode";
                    case D:
                        return "Suspense";
                    case C:
                        return "SuspenseList";
                }
                if ("object" == typeof e1) switch(e1.$$typeof){
                    case I:
                        return (e1.displayName || "Context") + ".Consumer";
                    case S:
                        return (e1._context.displayName || "Context") + ".Provider";
                    case N:
                        var t = e1.render;
                        return t = t.displayName || t.name || "", e1.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");
                    case L:
                        return Y(e1.type);
                    case z:
                        return Y(e1._render);
                    case R:
                        t = e1._payload, e1 = e1._init;
                        try {
                            return Y(e1(t));
                        } catch (e1) {}
                }
                return null;
            }
            function X(e1) {
                switch(typeof e1){
                    case "boolean":
                    case "number":
                    case "object":
                    case "string":
                    case "undefined":
                        return e1;
                    default:
                        return "";
                }
            }
            function Z(e1) {
                var t = e1.type;
                return (e1 = e1.nodeName) && "input" === e1.toLowerCase() && ("checkbox" === t || "radio" === t);
            }
            function q(e1) {
                e1._valueTracker || (e1._valueTracker = function(e1) {
                    var t = Z(e1) ? "checked" : "value", n = Object.getOwnPropertyDescriptor(e1.constructor.prototype, t), i = "" + e1[t];
                    if (!e1.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
                        var r = n.get, a = n.set;
                        return Object.defineProperty(e1, t, {
                            configurable: !0,
                            get: function() {
                                return r.call(this);
                            },
                            set: function(e1) {
                                i = "" + e1, a.call(this, e1);
                            }
                        }), Object.defineProperty(e1, t, {
                            enumerable: n.enumerable
                        }), {
                            getValue: function() {
                                return i;
                            },
                            setValue: function(e1) {
                                i = "" + e1;
                            },
                            stopTracking: function() {
                                e1._valueTracker = null, delete e1[t];
                            }
                        };
                    }
                }(e1));
            }
            function K(e1) {
                if (!e1) return !1;
                var t = e1._valueTracker;
                if (!t) return !0;
                var n = t.getValue(), i = "";
                return e1 && (i = Z(e1) ? e1.checked ? "true" : "false" : e1.value), (e1 = i) !== n && (t.setValue(e1), !0);
            }
            function J(e1) {
                if (void 0 === (e1 = e1 || ("undefined" != typeof document ? document : void 0))) return null;
                try {
                    return e1.activeElement || e1.body;
                } catch (t) {
                    return e1.body;
                }
            }
            function $(e1, t) {
                var n = t.checked;
                return r({}, t, {
                    defaultChecked: void 0,
                    defaultValue: void 0,
                    value: void 0,
                    checked: null != n ? n : e1._wrapperState.initialChecked
                });
            }
            function ee(e1, t) {
                var n = null == t.defaultValue ? "" : t.defaultValue, i = null != t.checked ? t.checked : t.defaultChecked;
                n = X(null != t.value ? t.value : n), e1._wrapperState = {
                    initialChecked: i,
                    initialValue: n,
                    controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
                };
            }
            function te(e1, t) {
                null != (t = t.checked) && y(e1, "checked", t, !1);
            }
            function ne(e1, t) {
                te(e1, t);
                var n = X(t.value), i = t.type;
                if (null != n) "number" === i ? (0 === n && "" === e1.value || e1.value != n) && (e1.value = "" + n) : e1.value !== "" + n && (e1.value = "" + n);
                else if ("submit" === i || "reset" === i) return void e1.removeAttribute("value");
                t.hasOwnProperty("value") ? re(e1, t.type, n) : t.hasOwnProperty("defaultValue") && re(e1, t.type, X(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e1.defaultChecked = !!t.defaultChecked);
            }
            function ie(e1, t, n) {
                if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
                    var i = t.type;
                    if (!("submit" !== i && "reset" !== i || void 0 !== t.value && null !== t.value)) return;
                    t = "" + e1._wrapperState.initialValue, n || t === e1.value || (e1.value = t), e1.defaultValue = t;
                }
                "" !== (n = e1.name) && (e1.name = ""), e1.defaultChecked = !!e1._wrapperState.initialChecked, "" !== n && (e1.name = n);
            }
            function re(e1, t, n) {
                "number" === t && J(e1.ownerDocument) === e1 || (null == n ? e1.defaultValue = "" + e1._wrapperState.initialValue : e1.defaultValue !== "" + n && (e1.defaultValue = "" + n));
            }
            function ae(e1, t) {
                return e1 = r({
                    children: void 0
                }, t), (t = function(e1) {
                    var t = "";
                    return i.Children.forEach(e1, function(e1) {
                        null != e1 && (t += e1);
                    }), t;
                }(t.children)) && (e1.children = t), e1;
            }
            function se(e1, t, n, i) {
                if (e1 = e1.options, t) {
                    t = {};
                    for(var r = 0; r < n.length; r++)t["$" + n[r]] = !0;
                    for(n = 0; n < e1.length; n++)r = t.hasOwnProperty("$" + e1[n].value), e1[n].selected !== r && (e1[n].selected = r), r && i && (e1[n].defaultSelected = !0);
                } else {
                    for(n = "" + X(n), t = null, r = 0; r < e1.length; r++){
                        if (e1[r].value === n) return e1[r].selected = !0, void (i && (e1[r].defaultSelected = !0));
                        null !== t || e1[r].disabled || (t = e1[r]);
                    }
                    null !== t && (t.selected = !0);
                }
            }
            function oe(e1, t) {
                if (null != t.dangerouslySetInnerHTML) throw Error(s(91));
                return r({}, t, {
                    value: void 0,
                    defaultValue: void 0,
                    children: "" + e1._wrapperState.initialValue
                });
            }
            function le(e1, t) {
                var n = t.value;
                if (null == n) {
                    if (n = t.children, t = t.defaultValue, null != n) {
                        if (null != t) throw Error(s(92));
                        if (Array.isArray(n)) {
                            if (!(1 >= n.length)) throw Error(s(93));
                            n = n[0];
                        }
                        t = n;
                    }
                    null == t && (t = ""), n = t;
                }
                e1._wrapperState = {
                    initialValue: X(n)
                };
            }
            function ce(e1, t) {
                var n = X(t.value), i = X(t.defaultValue);
                null != n && ((n = "" + n) !== e1.value && (e1.value = n), null == t.defaultValue && e1.defaultValue !== n && (e1.defaultValue = n)), null != i && (e1.defaultValue = "" + i);
            }
            function ue(e1) {
                var t = e1.textContent;
                t === e1._wrapperState.initialValue && "" !== t && null !== t && (e1.value = t);
            }
            var he = {
                html: "http://www.w3.org/1999/xhtml",
                mathml: "http://www.w3.org/1998/Math/MathML",
                svg: "http://www.w3.org/2000/svg"
            };
            function de(e1) {
                switch(e1){
                    case "svg":
                        return "http://www.w3.org/2000/svg";
                    case "math":
                        return "http://www.w3.org/1998/Math/MathML";
                    default:
                        return "http://www.w3.org/1999/xhtml";
                }
            }
            function pe(e1, t) {
                return null == e1 || "http://www.w3.org/1999/xhtml" === e1 ? de(t) : "http://www.w3.org/2000/svg" === e1 && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e1;
            }
            var fe, me, ge = (me = function(e1, t) {
                if (e1.namespaceURI !== he.svg || "innerHTML" in e1) e1.innerHTML = t;
                else {
                    for((fe = fe || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = fe.firstChild; e1.firstChild;)e1.removeChild(e1.firstChild);
                    for(; t.firstChild;)e1.appendChild(t.firstChild);
                }
            }, "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function(e1, t, n, i) {
                MSApp.execUnsafeLocalFunction(function() {
                    return me(e1, t);
                });
            } : me);
            function Ae(e1, t) {
                if (t) {
                    var n = e1.firstChild;
                    if (n && n === e1.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
                }
                e1.textContent = t;
            }
            var ve = {
                animationIterationCount: !0,
                borderImageOutset: !0,
                borderImageSlice: !0,
                borderImageWidth: !0,
                boxFlex: !0,
                boxFlexGroup: !0,
                boxOrdinalGroup: !0,
                columnCount: !0,
                columns: !0,
                flex: !0,
                flexGrow: !0,
                flexPositive: !0,
                flexShrink: !0,
                flexNegative: !0,
                flexOrder: !0,
                gridArea: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowSpan: !0,
                gridRowStart: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnSpan: !0,
                gridColumnStart: !0,
                fontWeight: !0,
                lineClamp: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                tabSize: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
                fillOpacity: !0,
                floodOpacity: !0,
                stopOpacity: !0,
                strokeDasharray: !0,
                strokeDashoffset: !0,
                strokeMiterlimit: !0,
                strokeOpacity: !0,
                strokeWidth: !0
            }, Me = [
                "Webkit",
                "ms",
                "Moz",
                "O"
            ];
            function ye(e1, t, n) {
                return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || ve.hasOwnProperty(e1) && ve[e1] ? ("" + t).trim() : t + "px";
            }
            function xe(e1, t) {
                for(var n in e1 = e1.style, t)if (t.hasOwnProperty(n)) {
                    var i = 0 === n.indexOf("--"), r = ye(n, t[n], i);
                    "float" === n && (n = "cssFloat"), i ? e1.setProperty(n, r) : e1[n] = r;
                }
            }
            Object.keys(ve).forEach(function(e1) {
                Me.forEach(function(t) {
                    t = t + e1.charAt(0).toUpperCase() + e1.substring(1), ve[t] = ve[e1];
                });
            });
            var _e = r({
                menuitem: !0
            }, {
                area: !0,
                base: !0,
                br: !0,
                col: !0,
                embed: !0,
                hr: !0,
                img: !0,
                input: !0,
                keygen: !0,
                link: !0,
                meta: !0,
                param: !0,
                source: !0,
                track: !0,
                wbr: !0
            });
            function be(e1, t) {
                if (t) {
                    if (_e[e1] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(s(137, e1));
                    if (null != t.dangerouslySetInnerHTML) {
                        if (null != t.children) throw Error(s(60));
                        if ("object" != typeof t.dangerouslySetInnerHTML || !("__html" in t.dangerouslySetInnerHTML)) throw Error(s(61));
                    }
                    if (null != t.style && "object" != typeof t.style) throw Error(s(62));
                }
            }
            function we(e1, t) {
                if (-1 === e1.indexOf("-")) return "string" == typeof t.is;
                switch(e1){
                    case "annotation-xml":
                    case "color-profile":
                    case "font-face":
                    case "font-face-src":
                    case "font-face-uri":
                    case "font-face-format":
                    case "font-face-name":
                    case "missing-glyph":
                        return !1;
                    default:
                        return !0;
                }
            }
            function Ee(e1) {
                return (e1 = e1.target || e1.srcElement || window).correspondingUseElement && (e1 = e1.correspondingUseElement), 3 === e1.nodeType ? e1.parentNode : e1;
            }
            var Te = null, Se = null, Ie = null;
            function Ne(e1) {
                if (e1 = nr(e1)) {
                    if ("function" != typeof Te) throw Error(s(280));
                    var t = e1.stateNode;
                    t && (t = rr(t), Te(e1.stateNode, e1.type, t));
                }
            }
            function De(e1) {
                Se ? Ie ? Ie.push(e1) : Ie = [
                    e1
                ] : Se = e1;
            }
            function Ce() {
                if (Se) {
                    var e1 = Se, t = Ie;
                    if (Ie = Se = null, Ne(e1), t) for(e1 = 0; e1 < t.length; e1++)Ne(t[e1]);
                }
            }
            function Le(e1, t) {
                return e1(t);
            }
            function Re(e1, t, n, i, r) {
                return e1(t, n, i, r);
            }
            function ze() {}
            var Oe = Le, Pe = !1, Ue = !1;
            function ke() {
                null === Se && null === Ie || (ze(), Ce());
            }
            function je(e1, t) {
                var n = e1.stateNode;
                if (null === n) return null;
                var i = rr(n);
                if (null === i) return null;
                n = i[t];
                e: switch(t){
                    case "onClick":
                    case "onClickCapture":
                    case "onDoubleClick":
                    case "onDoubleClickCapture":
                    case "onMouseDown":
                    case "onMouseDownCapture":
                    case "onMouseMove":
                    case "onMouseMoveCapture":
                    case "onMouseUp":
                    case "onMouseUpCapture":
                    case "onMouseEnter":
                        (i = !i.disabled) || (i = !("button" === (e1 = e1.type) || "input" === e1 || "select" === e1 || "textarea" === e1)), e1 = !i;
                        break e;
                    default:
                        e1 = !1;
                }
                if (e1) return null;
                if (n && "function" != typeof n) throw Error(s(231, t, typeof n));
                return n;
            }
            var Be = !1;
            if (h) try {
                var Fe = {};
                Object.defineProperty(Fe, "passive", {
                    get: function() {
                        Be = !0;
                    }
                }), window.addEventListener("test", Fe, Fe), window.removeEventListener("test", Fe, Fe);
            } catch (me) {
                Be = !1;
            }
            function He(e1, t, n, i, r, a, s, o, l) {
                var c = Array.prototype.slice.call(arguments, 3);
                try {
                    t.apply(n, c);
                } catch (e1) {
                    this.onError(e1);
                }
            }
            var Ve = !1, Ge = null, Qe = !1, We = null, Ye = {
                onError: function(e1) {
                    Ve = !0, Ge = e1;
                }
            };
            function Xe(e1, t, n, i, r, a, s, o, l) {
                Ve = !1, Ge = null, He.apply(Ye, arguments);
            }
            function Ze(e1) {
                var t = e1, n = e1;
                if (e1.alternate) for(; t.return;)t = t.return;
                else {
                    e1 = t;
                    do !!(1026 & (t = e1).flags) && (n = t.return), e1 = t.return;
                    while (e1);
                }
                return 3 === t.tag ? n : null;
            }
            function qe(e1) {
                if (13 === e1.tag) {
                    var t = e1.memoizedState;
                    if (null === t && null !== (e1 = e1.alternate) && (t = e1.memoizedState), null !== t) return t.dehydrated;
                }
                return null;
            }
            function Ke(e1) {
                if (Ze(e1) !== e1) throw Error(s(188));
            }
            function Je(e1) {
                if (e1 = function(e1) {
                    var t = e1.alternate;
                    if (!t) {
                        if (null === (t = Ze(e1))) throw Error(s(188));
                        return t !== e1 ? null : e1;
                    }
                    for(var n = e1, i = t;;){
                        var r = n.return;
                        if (null === r) break;
                        var a = r.alternate;
                        if (null === a) {
                            if (null !== (i = r.return)) {
                                n = i;
                                continue;
                            }
                            break;
                        }
                        if (r.child === a.child) {
                            for(a = r.child; a;){
                                if (a === n) return Ke(r), e1;
                                if (a === i) return Ke(r), t;
                                a = a.sibling;
                            }
                            throw Error(s(188));
                        }
                        if (n.return !== i.return) n = r, i = a;
                        else {
                            for(var o = !1, l = r.child; l;){
                                if (l === n) {
                                    o = !0, n = r, i = a;
                                    break;
                                }
                                if (l === i) {
                                    o = !0, i = r, n = a;
                                    break;
                                }
                                l = l.sibling;
                            }
                            if (!o) {
                                for(l = a.child; l;){
                                    if (l === n) {
                                        o = !0, n = a, i = r;
                                        break;
                                    }
                                    if (l === i) {
                                        o = !0, i = a, n = r;
                                        break;
                                    }
                                    l = l.sibling;
                                }
                                if (!o) throw Error(s(189));
                            }
                        }
                        if (n.alternate !== i) throw Error(s(190));
                    }
                    if (3 !== n.tag) throw Error(s(188));
                    return n.stateNode.current === n ? e1 : t;
                }(e1), !e1) return null;
                for(var t = e1;;){
                    if (5 === t.tag || 6 === t.tag) return t;
                    if (t.child) t.child.return = t, t = t.child;
                    else {
                        if (t === e1) break;
                        for(; !t.sibling;){
                            if (!t.return || t.return === e1) return null;
                            t = t.return;
                        }
                        t.sibling.return = t.return, t = t.sibling;
                    }
                }
                return null;
            }
            function $e(e1, t) {
                for(var n = e1.alternate; null !== t;){
                    if (t === e1 || t === n) return !0;
                    t = t.return;
                }
                return !1;
            }
            var et, tt, nt, it, rt = !1, at = [], st = null, ot = null, lt = null, ct = new Map, ut = new Map, ht = [], dt = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
            function pt(e1, t, n, i, r) {
                return {
                    blockedOn: e1,
                    domEventName: t,
                    eventSystemFlags: 16 | n,
                    nativeEvent: r,
                    targetContainers: [
                        i
                    ]
                };
            }
            function ft(e1, t) {
                switch(e1){
                    case "focusin":
                    case "focusout":
                        st = null;
                        break;
                    case "dragenter":
                    case "dragleave":
                        ot = null;
                        break;
                    case "mouseover":
                    case "mouseout":
                        lt = null;
                        break;
                    case "pointerover":
                    case "pointerout":
                        ct.delete(t.pointerId);
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                        ut.delete(t.pointerId);
                }
            }
            function mt(e1, t, n, i, r, a) {
                return null === e1 || e1.nativeEvent !== a ? (e1 = pt(t, n, i, r, a), null !== t && null !== (t = nr(t)) && tt(t), e1) : (e1.eventSystemFlags |= i, t = e1.targetContainers, null !== r && -1 === t.indexOf(r) && t.push(r), e1);
            }
            function gt(e1) {
                var t = tr(e1.target);
                if (null !== t) {
                    var n = Ze(t);
                    if (null !== n) {
                        if (13 === (t = n.tag)) {
                            if (null !== (t = qe(n))) return e1.blockedOn = t, void it(e1.lanePriority, function() {
                                a.unstable_runWithPriority(e1.priority, function() {
                                    nt(n);
                                });
                            });
                        } else if (3 === t && n.stateNode.hydrate) return void (e1.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
                    }
                }
                e1.blockedOn = null;
            }
            function At(e1) {
                if (null !== e1.blockedOn) return !1;
                for(var t = e1.targetContainers; 0 < t.length;){
                    var n = Jt(e1.domEventName, e1.eventSystemFlags, t[0], e1.nativeEvent);
                    if (null !== n) return null !== (t = nr(n)) && tt(t), e1.blockedOn = n, !1;
                    t.shift();
                }
                return !0;
            }
            function vt(e1, t, n) {
                At(e1) && n.delete(t);
            }
            function Mt() {
                for(rt = !1; 0 < at.length;){
                    var e1 = at[0];
                    if (null !== e1.blockedOn) {
                        null !== (e1 = nr(e1.blockedOn)) && et(e1);
                        break;
                    }
                    for(var t = e1.targetContainers; 0 < t.length;){
                        var n = Jt(e1.domEventName, e1.eventSystemFlags, t[0], e1.nativeEvent);
                        if (null !== n) {
                            e1.blockedOn = n;
                            break;
                        }
                        t.shift();
                    }
                    null === e1.blockedOn && at.shift();
                }
                null !== st && At(st) && (st = null), null !== ot && At(ot) && (ot = null), null !== lt && At(lt) && (lt = null), ct.forEach(vt), ut.forEach(vt);
            }
            function yt(e1, t) {
                e1.blockedOn === t && (e1.blockedOn = null, rt || (rt = !0, a.unstable_scheduleCallback(a.unstable_NormalPriority, Mt)));
            }
            function xt(e1) {
                function t(t) {
                    return yt(t, e1);
                }
                if (0 < at.length) {
                    yt(at[0], e1);
                    for(var n = 1; n < at.length; n++){
                        var i = at[n];
                        i.blockedOn === e1 && (i.blockedOn = null);
                    }
                }
                for(null !== st && yt(st, e1), null !== ot && yt(ot, e1), null !== lt && yt(lt, e1), ct.forEach(t), ut.forEach(t), n = 0; n < ht.length; n++)(i = ht[n]).blockedOn === e1 && (i.blockedOn = null);
                for(; 0 < ht.length && null === (n = ht[0]).blockedOn;)gt(n), null === n.blockedOn && ht.shift();
            }
            function _t(e1, t) {
                var n = {};
                return n[e1.toLowerCase()] = t.toLowerCase(), n["Webkit" + e1] = "webkit" + t, n["Moz" + e1] = "moz" + t, n;
            }
            var bt = {
                animationend: _t("Animation", "AnimationEnd"),
                animationiteration: _t("Animation", "AnimationIteration"),
                animationstart: _t("Animation", "AnimationStart"),
                transitionend: _t("Transition", "TransitionEnd")
            }, wt = {}, Et = {};
            function Tt(e1) {
                if (wt[e1]) return wt[e1];
                if (!bt[e1]) return e1;
                var t, n = bt[e1];
                for(t in n)if (n.hasOwnProperty(t) && t in Et) return wt[e1] = n[t];
                return e1;
            }
            h && (Et = document.createElement("div").style, "AnimationEvent" in window || (delete bt.animationend.animation, delete bt.animationiteration.animation, delete bt.animationstart.animation), "TransitionEvent" in window || delete bt.transitionend.transition);
            var St = Tt("animationend"), It = Tt("animationiteration"), Nt = Tt("animationstart"), Dt = Tt("transitionend"), Ct = new Map, Lt = new Map, Rt = [
                "abort",
                "abort",
                St,
                "animationEnd",
                It,
                "animationIteration",
                Nt,
                "animationStart",
                "canplay",
                "canPlay",
                "canplaythrough",
                "canPlayThrough",
                "durationchange",
                "durationChange",
                "emptied",
                "emptied",
                "encrypted",
                "encrypted",
                "ended",
                "ended",
                "error",
                "error",
                "gotpointercapture",
                "gotPointerCapture",
                "load",
                "load",
                "loadeddata",
                "loadedData",
                "loadedmetadata",
                "loadedMetadata",
                "loadstart",
                "loadStart",
                "lostpointercapture",
                "lostPointerCapture",
                "playing",
                "playing",
                "progress",
                "progress",
                "seeking",
                "seeking",
                "stalled",
                "stalled",
                "suspend",
                "suspend",
                "timeupdate",
                "timeUpdate",
                Dt,
                "transitionEnd",
                "waiting",
                "waiting"
            ];
            function zt(e1, t) {
                for(var n = 0; n < e1.length; n += 2){
                    var i = e1[n], r = e1[n + 1];
                    r = "on" + (r[0].toUpperCase() + r.slice(1)), Lt.set(i, t), Ct.set(i, r), c(r, [
                        i
                    ]);
                }
            }
            (0, a.unstable_now)();
            var Ot = 8;
            function Pt(e1) {
                if (1 & e1) return Ot = 15, 1;
                if (2 & e1) return Ot = 14, 2;
                if (4 & e1) return Ot = 13, 4;
                var t = 24 & e1;
                return 0 !== t ? (Ot = 12, t) : 32 & e1 ? (Ot = 11, 32) : 0 != (t = 192 & e1) ? (Ot = 10, t) : 256 & e1 ? (Ot = 9, 256) : 0 != (t = 3584 & e1) ? (Ot = 8, t) : 4096 & e1 ? (Ot = 7, 4096) : 0 != (t = 4186112 & e1) ? (Ot = 6, t) : 0 != (t = 62914560 & e1) ? (Ot = 5, t) : 67108864 & e1 ? (Ot = 4, 67108864) : 134217728 & e1 ? (Ot = 3, 134217728) : 0 != (t = 805306368 & e1) ? (Ot = 2, t) : 1073741824 & e1 ? (Ot = 1, 1073741824) : (Ot = 8, e1);
            }
            function Ut(e1, t) {
                var n = e1.pendingLanes;
                if (0 === n) return Ot = 0;
                var i = 0, r = 0, a = e1.expiredLanes, s = e1.suspendedLanes, o = e1.pingedLanes;
                if (0 !== a) i = a, r = Ot = 15;
                else if (0 != (a = 134217727 & n)) {
                    var l = a & ~s;
                    0 !== l ? (i = Pt(l), r = Ot) : 0 != (o &= a) && (i = Pt(o), r = Ot);
                } else 0 != (a = n & ~s) ? (i = Pt(a), r = Ot) : 0 !== o && (i = Pt(o), r = Ot);
                if (0 === i) return 0;
                if (i = n & ((0 > (i = 31 - Vt(i)) ? 0 : 1 << i) << 1) - 1, 0 !== t && t !== i && !(t & s)) {
                    if (Pt(t), r <= Ot) return t;
                    Ot = r;
                }
                if (0 !== (t = e1.entangledLanes)) for(e1 = e1.entanglements, t &= i; 0 < t;)r = 1 << (n = 31 - Vt(t)), i |= e1[n], t &= ~r;
                return i;
            }
            function kt(e1) {
                return 0 != (e1 = -1073741825 & e1.pendingLanes) ? e1 : 1073741824 & e1 ? 1073741824 : 0;
            }
            function jt(e1, t) {
                switch(e1){
                    case 15:
                        return 1;
                    case 14:
                        return 2;
                    case 12:
                        return 0 === (e1 = Bt(24 & ~t)) ? jt(10, t) : e1;
                    case 10:
                        return 0 === (e1 = Bt(192 & ~t)) ? jt(8, t) : e1;
                    case 8:
                        return 0 === (e1 = Bt(3584 & ~t)) && 0 === (e1 = Bt(4186112 & ~t)) && (e1 = 512), e1;
                    case 2:
                        return 0 === (t = Bt(805306368 & ~t)) && (t = 268435456), t;
                }
                throw Error(s(358, e1));
            }
            function Bt(e1) {
                return e1 & -e1;
            }
            function Ft(e1) {
                for(var t = [], n = 0; 31 > n; n++)t.push(e1);
                return t;
            }
            function Ht(e1, t, n) {
                e1.pendingLanes |= t;
                var i = t - 1;
                e1.suspendedLanes &= i, e1.pingedLanes &= i, (e1 = e1.eventTimes)[t = 31 - Vt(t)] = n;
            }
            var Vt = Math.clz32 ? Math.clz32 : function(e1) {
                return 0 === e1 ? 32 : 31 - (Gt(e1) / Qt | 0) | 0;
            }, Gt = Math.log, Qt = Math.LN2, Wt = a.unstable_UserBlockingPriority, Yt = a.unstable_runWithPriority, Xt = !0;
            function Zt(e1, t, n, i) {
                Pe || ze();
                var r = Kt, a = Pe;
                Pe = !0;
                try {
                    Re(r, e1, t, n, i);
                } finally{
                    (Pe = a) || ke();
                }
            }
            function qt(e1, t, n, i) {
                Yt(Wt, Kt.bind(null, e1, t, n, i));
            }
            function Kt(e1, t, n, i) {
                var r;
                if (Xt) {
                    if ((r = !(4 & t)) && 0 < at.length && -1 < dt.indexOf(e1)) e1 = pt(null, e1, t, n, i), at.push(e1);
                    else {
                        var a = Jt(e1, t, n, i);
                        if (null === a) r && ft(e1, i);
                        else {
                            if (r) {
                                if (-1 < dt.indexOf(e1)) return e1 = pt(a, e1, t, n, i), void at.push(e1);
                                if (function(e1, t, n, i, r) {
                                    switch(t){
                                        case "focusin":
                                            return st = mt(st, e1, t, n, i, r), !0;
                                        case "dragenter":
                                            return ot = mt(ot, e1, t, n, i, r), !0;
                                        case "mouseover":
                                            return lt = mt(lt, e1, t, n, i, r), !0;
                                        case "pointerover":
                                            var a = r.pointerId;
                                            return ct.set(a, mt(ct.get(a) || null, e1, t, n, i, r)), !0;
                                        case "gotpointercapture":
                                            return a = r.pointerId, ut.set(a, mt(ut.get(a) || null, e1, t, n, i, r)), !0;
                                    }
                                    return !1;
                                }(a, e1, t, n, i)) return;
                                ft(e1, i);
                            }
                            zi(e1, t, i, null, n);
                        }
                    }
                }
            }
            function Jt(e1, t, n, i) {
                var r = Ee(i);
                if (null !== (r = tr(r))) {
                    var a = Ze(r);
                    if (null === a) r = null;
                    else {
                        var s = a.tag;
                        if (13 === s) {
                            if (null !== (r = qe(a))) return r;
                            r = null;
                        } else if (3 === s) {
                            if (a.stateNode.hydrate) return 3 === a.tag ? a.stateNode.containerInfo : null;
                            r = null;
                        } else a !== r && (r = null);
                    }
                }
                return zi(e1, t, i, r, n), null;
            }
            var $t = null, en = null, tn = null;
            function nn() {
                if (tn) return tn;
                var e1, t, n = en, i = n.length, r = "value" in $t ? $t.value : $t.textContent, a = r.length;
                for(e1 = 0; e1 < i && n[e1] === r[e1]; e1++);
                var s = i - e1;
                for(t = 1; t <= s && n[i - t] === r[a - t]; t++);
                return tn = r.slice(e1, 1 < t ? 1 - t : void 0);
            }
            function rn(e1) {
                var t = e1.keyCode;
                return "charCode" in e1 ? 0 === (e1 = e1.charCode) && 13 === t && (e1 = 13) : e1 = t, 10 === e1 && (e1 = 13), 32 <= e1 || 13 === e1 ? e1 : 0;
            }
            function an() {
                return !0;
            }
            function sn() {
                return !1;
            }
            function on(e1) {
                function t(t, n, i, r, a) {
                    for(var s in this._reactName = t, this._targetInst = i, this.type = n, this.nativeEvent = r, this.target = a, this.currentTarget = null, e1)e1.hasOwnProperty(s) && (t = e1[s], this[s] = t ? t(r) : r[s]);
                    return this.isDefaultPrevented = (null != r.defaultPrevented ? r.defaultPrevented : !1 === r.returnValue) ? an : sn, this.isPropagationStopped = sn, this;
                }
                return r(t.prototype, {
                    preventDefault: function() {
                        this.defaultPrevented = !0;
                        var e1 = this.nativeEvent;
                        e1 && (e1.preventDefault ? e1.preventDefault() : "unknown" != typeof e1.returnValue && (e1.returnValue = !1), this.isDefaultPrevented = an);
                    },
                    stopPropagation: function() {
                        var e1 = this.nativeEvent;
                        e1 && (e1.stopPropagation ? e1.stopPropagation() : "unknown" != typeof e1.cancelBubble && (e1.cancelBubble = !0), this.isPropagationStopped = an);
                    },
                    persist: function() {},
                    isPersistent: an
                }), t;
            }
            var ln, cn, un, hn = {
                eventPhase: 0,
                bubbles: 0,
                cancelable: 0,
                timeStamp: function(e1) {
                    return e1.timeStamp || Date.now();
                },
                defaultPrevented: 0,
                isTrusted: 0
            }, dn = on(hn), pn = r({}, hn, {
                view: 0,
                detail: 0
            }), fn = on(pn), mn = r({}, pn, {
                screenX: 0,
                screenY: 0,
                clientX: 0,
                clientY: 0,
                pageX: 0,
                pageY: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                getModifierState: Sn,
                button: 0,
                buttons: 0,
                relatedTarget: function(e1) {
                    return void 0 === e1.relatedTarget ? e1.fromElement === e1.srcElement ? e1.toElement : e1.fromElement : e1.relatedTarget;
                },
                movementX: function(e1) {
                    return "movementX" in e1 ? e1.movementX : (e1 !== un && (un && "mousemove" === e1.type ? (ln = e1.screenX - un.screenX, cn = e1.screenY - un.screenY) : cn = ln = 0, un = e1), ln);
                },
                movementY: function(e1) {
                    return "movementY" in e1 ? e1.movementY : cn;
                }
            }), gn = on(mn), An = on(r({}, mn, {
                dataTransfer: 0
            })), vn = on(r({}, pn, {
                relatedTarget: 0
            })), Mn = on(r({}, hn, {
                animationName: 0,
                elapsedTime: 0,
                pseudoElement: 0
            })), yn = r({}, hn, {
                clipboardData: function(e1) {
                    return "clipboardData" in e1 ? e1.clipboardData : window.clipboardData;
                }
            }), xn = on(yn), _n = on(r({}, hn, {
                data: 0
            })), bn = {
                Esc: "Escape",
                Spacebar: " ",
                Left: "ArrowLeft",
                Up: "ArrowUp",
                Right: "ArrowRight",
                Down: "ArrowDown",
                Del: "Delete",
                Win: "OS",
                Menu: "ContextMenu",
                Apps: "ContextMenu",
                Scroll: "ScrollLock",
                MozPrintableKey: "Unidentified"
            }, wn = {
                8: "Backspace",
                9: "Tab",
                12: "Clear",
                13: "Enter",
                16: "Shift",
                17: "Control",
                18: "Alt",
                19: "Pause",
                20: "CapsLock",
                27: "Escape",
                32: " ",
                33: "PageUp",
                34: "PageDown",
                35: "End",
                36: "Home",
                37: "ArrowLeft",
                38: "ArrowUp",
                39: "ArrowRight",
                40: "ArrowDown",
                45: "Insert",
                46: "Delete",
                112: "F1",
                113: "F2",
                114: "F3",
                115: "F4",
                116: "F5",
                117: "F6",
                118: "F7",
                119: "F8",
                120: "F9",
                121: "F10",
                122: "F11",
                123: "F12",
                144: "NumLock",
                145: "ScrollLock",
                224: "Meta"
            }, En = {
                Alt: "altKey",
                Control: "ctrlKey",
                Meta: "metaKey",
                Shift: "shiftKey"
            };
            function Tn(e1) {
                var t = this.nativeEvent;
                return t.getModifierState ? t.getModifierState(e1) : !!(e1 = En[e1]) && !!t[e1];
            }
            function Sn() {
                return Tn;
            }
            var In = r({}, pn, {
                key: function(e1) {
                    if (e1.key) {
                        var t = bn[e1.key] || e1.key;
                        if ("Unidentified" !== t) return t;
                    }
                    return "keypress" === e1.type ? 13 === (e1 = rn(e1)) ? "Enter" : String.fromCharCode(e1) : "keydown" === e1.type || "keyup" === e1.type ? wn[e1.keyCode] || "Unidentified" : "";
                },
                code: 0,
                location: 0,
                ctrlKey: 0,
                shiftKey: 0,
                altKey: 0,
                metaKey: 0,
                repeat: 0,
                locale: 0,
                getModifierState: Sn,
                charCode: function(e1) {
                    return "keypress" === e1.type ? rn(e1) : 0;
                },
                keyCode: function(e1) {
                    return "keydown" === e1.type || "keyup" === e1.type ? e1.keyCode : 0;
                },
                which: function(e1) {
                    return "keypress" === e1.type ? rn(e1) : "keydown" === e1.type || "keyup" === e1.type ? e1.keyCode : 0;
                }
            }), Nn = on(In), Dn = on(r({}, mn, {
                pointerId: 0,
                width: 0,
                height: 0,
                pressure: 0,
                tangentialPressure: 0,
                tiltX: 0,
                tiltY: 0,
                twist: 0,
                pointerType: 0,
                isPrimary: 0
            })), Cn = on(r({}, pn, {
                touches: 0,
                targetTouches: 0,
                changedTouches: 0,
                altKey: 0,
                metaKey: 0,
                ctrlKey: 0,
                shiftKey: 0,
                getModifierState: Sn
            })), Ln = on(r({}, hn, {
                propertyName: 0,
                elapsedTime: 0,
                pseudoElement: 0
            })), Rn = r({}, mn, {
                deltaX: function(e1) {
                    return "deltaX" in e1 ? e1.deltaX : "wheelDeltaX" in e1 ? -e1.wheelDeltaX : 0;
                },
                deltaY: function(e1) {
                    return "deltaY" in e1 ? e1.deltaY : "wheelDeltaY" in e1 ? -e1.wheelDeltaY : "wheelDelta" in e1 ? -e1.wheelDelta : 0;
                },
                deltaZ: 0,
                deltaMode: 0
            }), zn = on(Rn), On = [
                9,
                13,
                27,
                32
            ], Pn = h && "CompositionEvent" in window, Un = null;
            h && "documentMode" in document && (Un = document.documentMode);
            var kn = h && "TextEvent" in window && !Un, jn = h && (!Pn || Un && 8 < Un && 11 >= Un), Bn = String.fromCharCode(32), Fn = !1;
            function Hn(e1, t) {
                switch(e1){
                    case "keyup":
                        return -1 !== On.indexOf(t.keyCode);
                    case "keydown":
                        return 229 !== t.keyCode;
                    case "keypress":
                    case "mousedown":
                    case "focusout":
                        return !0;
                    default:
                        return !1;
                }
            }
            function Vn(e1) {
                return "object" == typeof (e1 = e1.detail) && "data" in e1 ? e1.data : null;
            }
            var Gn = !1, Qn = {
                color: !0,
                date: !0,
                datetime: !0,
                "datetime-local": !0,
                email: !0,
                month: !0,
                number: !0,
                password: !0,
                range: !0,
                search: !0,
                tel: !0,
                text: !0,
                time: !0,
                url: !0,
                week: !0
            };
            function Wn(e1) {
                var t = e1 && e1.nodeName && e1.nodeName.toLowerCase();
                return "input" === t ? !!Qn[e1.type] : "textarea" === t;
            }
            function Yn(e1, t, n, i) {
                De(i), 0 < (t = Pi(t, "onChange")).length && (n = new dn("onChange", "change", null, n, i), e1.push({
                    event: n,
                    listeners: t
                }));
            }
            var Xn = null, Zn = null;
            function qn(e1) {
                Ii(e1, 0);
            }
            function Kn(e1) {
                if (K(ir(e1))) return e1;
            }
            function Jn(e1, t) {
                if ("change" === e1) return t;
            }
            var $n = !1;
            if (h) {
                var ei;
                if (h) {
                    var ti = "oninput" in document;
                    if (!ti) {
                        var ni = document.createElement("div");
                        ni.setAttribute("oninput", "return;"), ti = "function" == typeof ni.oninput;
                    }
                    ei = ti;
                } else ei = !1;
                $n = ei && (!document.documentMode || 9 < document.documentMode);
            }
            function ii() {
                Xn && (Xn.detachEvent("onpropertychange", ri), Zn = Xn = null);
            }
            function ri(e1) {
                if ("value" === e1.propertyName && Kn(Zn)) {
                    var t = [];
                    if (Yn(t, Zn, e1, Ee(e1)), e1 = qn, Pe) e1(t);
                    else {
                        Pe = !0;
                        try {
                            Le(e1, t);
                        } finally{
                            Pe = !1, ke();
                        }
                    }
                }
            }
            function ai(e1, t, n) {
                "focusin" === e1 ? (ii(), Zn = n, (Xn = t).attachEvent("onpropertychange", ri)) : "focusout" === e1 && ii();
            }
            function si(e1) {
                if ("selectionchange" === e1 || "keyup" === e1 || "keydown" === e1) return Kn(Zn);
            }
            function oi(e1, t) {
                if ("click" === e1) return Kn(t);
            }
            function li(e1, t) {
                if ("input" === e1 || "change" === e1) return Kn(t);
            }
            var ci = "function" == typeof Object.is ? Object.is : function(e1, t) {
                return e1 === t && (0 !== e1 || 1 / e1 == 1 / t) || e1 != e1 && t != t;
            }, ui = Object.prototype.hasOwnProperty;
            function hi(e1, t) {
                if (ci(e1, t)) return !0;
                if ("object" != typeof e1 || null === e1 || "object" != typeof t || null === t) return !1;
                var n = Object.keys(e1), i = Object.keys(t);
                if (n.length !== i.length) return !1;
                for(i = 0; i < n.length; i++)if (!ui.call(t, n[i]) || !ci(e1[n[i]], t[n[i]])) return !1;
                return !0;
            }
            function di(e1) {
                for(; e1 && e1.firstChild;)e1 = e1.firstChild;
                return e1;
            }
            function pi(e1, t) {
                var n, i = di(e1);
                for(e1 = 0; i;){
                    if (3 === i.nodeType) {
                        if (n = e1 + i.textContent.length, e1 <= t && n >= t) return {
                            node: i,
                            offset: t - e1
                        };
                        e1 = n;
                    }
                    e: {
                        for(; i;){
                            if (i.nextSibling) {
                                i = i.nextSibling;
                                break e;
                            }
                            i = i.parentNode;
                        }
                        i = void 0;
                    }
                    i = di(i);
                }
            }
            function fi(e1, t) {
                return !(!e1 || !t) && (e1 === t || (!e1 || 3 !== e1.nodeType) && (t && 3 === t.nodeType ? fi(e1, t.parentNode) : "contains" in e1 ? e1.contains(t) : !!e1.compareDocumentPosition && !!(16 & e1.compareDocumentPosition(t))));
            }
            function mi() {
                for(var e1 = window, t = J(); t instanceof e1.HTMLIFrameElement;){
                    try {
                        var n = "string" == typeof t.contentWindow.location.href;
                    } catch (e1) {
                        n = !1;
                    }
                    if (!n) break;
                    t = J((e1 = t.contentWindow).document);
                }
                return t;
            }
            function gi(e1) {
                var t = e1 && e1.nodeName && e1.nodeName.toLowerCase();
                return t && ("input" === t && ("text" === e1.type || "search" === e1.type || "tel" === e1.type || "url" === e1.type || "password" === e1.type) || "textarea" === t || "true" === e1.contentEditable);
            }
            var Ai = h && "documentMode" in document && 11 >= document.documentMode, vi = null, Mi = null, yi = null, xi = !1;
            function _i(e1, t, n) {
                var i = n.window === n ? n.document : 9 === n.nodeType ? n : n.ownerDocument;
                xi || null == vi || vi !== J(i) || (i = "selectionStart" in (i = vi) && gi(i) ? {
                    start: i.selectionStart,
                    end: i.selectionEnd
                } : {
                    anchorNode: (i = (i.ownerDocument && i.ownerDocument.defaultView || window).getSelection()).anchorNode,
                    anchorOffset: i.anchorOffset,
                    focusNode: i.focusNode,
                    focusOffset: i.focusOffset
                }, yi && hi(yi, i) || (yi = i, 0 < (i = Pi(Mi, "onSelect")).length && (t = new dn("onSelect", "select", null, t, n), e1.push({
                    event: t,
                    listeners: i
                }), t.target = vi)));
            }
            zt("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), zt("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), zt(Rt, 2);
            for(var bi = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), wi = 0; wi < bi.length; wi++)Lt.set(bi[wi], 0);
            u("onMouseEnter", [
                "mouseout",
                "mouseover"
            ]), u("onMouseLeave", [
                "mouseout",
                "mouseover"
            ]), u("onPointerEnter", [
                "pointerout",
                "pointerover"
            ]), u("onPointerLeave", [
                "pointerout",
                "pointerover"
            ]), c("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), c("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), c("onBeforeInput", [
                "compositionend",
                "keypress",
                "textInput",
                "paste"
            ]), c("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), c("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), c("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
            var Ei = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ti = new Set("cancel close invalid load scroll toggle".split(" ").concat(Ei));
            function Si(e1, t, n) {
                var i = e1.type || "unknown-event";
                e1.currentTarget = n, function(e1, t, n, i, r, a, o, l, c) {
                    if (Xe.apply(this, arguments), Ve) {
                        if (!Ve) throw Error(s(198));
                        var u = Ge;
                        Ve = !1, Ge = null, Qe || (Qe = !0, We = u);
                    }
                }(i, t, void 0, e1), e1.currentTarget = null;
            }
            function Ii(e1, t) {
                t = !!(4 & t);
                for(var n = 0; n < e1.length; n++){
                    var i = e1[n], r = i.event;
                    i = i.listeners;
                    e: {
                        var a = void 0;
                        if (t) for(var s = i.length - 1; 0 <= s; s--){
                            var o = i[s], l = o.instance, c = o.currentTarget;
                            if (o = o.listener, l !== a && r.isPropagationStopped()) break e;
                            Si(r, o, c), a = l;
                        }
                        else for(s = 0; s < i.length; s++){
                            if (l = (o = i[s]).instance, c = o.currentTarget, o = o.listener, l !== a && r.isPropagationStopped()) break e;
                            Si(r, o, c), a = l;
                        }
                    }
                }
                if (Qe) throw e1 = We, Qe = !1, We = null, e1;
            }
            function Ni(e1, t) {
                var n = ar(t), i = e1 + "__bubble";
                n.has(i) || (Ri(t, e1, 2, !1), n.add(i));
            }
            var Di = "_reactListening" + Math.random().toString(36).slice(2);
            function Ci(e1) {
                e1[Di] || (e1[Di] = !0, o.forEach(function(t) {
                    Ti.has(t) || Li(t, !1, e1, null), Li(t, !0, e1, null);
                }));
            }
            function Li(e1, t, n, i) {
                var r = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, a = n;
                if ("selectionchange" === e1 && 9 !== n.nodeType && (a = n.ownerDocument), null !== i && !t && Ti.has(e1)) {
                    if ("scroll" !== e1) return;
                    r |= 2, a = i;
                }
                var s = ar(a), o = e1 + "__" + (t ? "capture" : "bubble");
                s.has(o) || (t && (r |= 4), Ri(a, e1, r, t), s.add(o));
            }
            function Ri(e1, t, n, i) {
                var r = Lt.get(t);
                switch(void 0 === r ? 2 : r){
                    case 0:
                        r = Zt;
                        break;
                    case 1:
                        r = qt;
                        break;
                    default:
                        r = Kt;
                }
                n = r.bind(null, t, n, e1), r = void 0, !Be || "touchstart" !== t && "touchmove" !== t && "wheel" !== t || (r = !0), i ? void 0 !== r ? e1.addEventListener(t, n, {
                    capture: !0,
                    passive: r
                }) : e1.addEventListener(t, n, !0) : void 0 !== r ? e1.addEventListener(t, n, {
                    passive: r
                }) : e1.addEventListener(t, n, !1);
            }
            function zi(e1, t, n, i, r) {
                var a = i;
                if (!(1 & t || 2 & t || null === i)) e: for(;;){
                    if (null === i) return;
                    var s = i.tag;
                    if (3 === s || 4 === s) {
                        var o = i.stateNode.containerInfo;
                        if (o === r || 8 === o.nodeType && o.parentNode === r) break;
                        if (4 === s) for(s = i.return; null !== s;){
                            var l = s.tag;
                            if ((3 === l || 4 === l) && ((l = s.stateNode.containerInfo) === r || 8 === l.nodeType && l.parentNode === r)) return;
                            s = s.return;
                        }
                        for(; null !== o;){
                            if (null === (s = tr(o))) return;
                            if (5 === (l = s.tag) || 6 === l) {
                                i = a = s;
                                continue e;
                            }
                            o = o.parentNode;
                        }
                    }
                    i = i.return;
                }
                !function(e1, t, n) {
                    if (Ue) return e1();
                    Ue = !0;
                    try {
                        return Oe(e1, t, n);
                    } finally{
                        Ue = !1, ke();
                    }
                }(function() {
                    var i = a, r = Ee(n), s = [];
                    e: {
                        var o = Ct.get(e1);
                        if (void 0 !== o) {
                            var l = dn, c = e1;
                            switch(e1){
                                case "keypress":
                                    if (0 === rn(n)) break e;
                                case "keydown":
                                case "keyup":
                                    l = Nn;
                                    break;
                                case "focusin":
                                    c = "focus", l = vn;
                                    break;
                                case "focusout":
                                    c = "blur", l = vn;
                                    break;
                                case "beforeblur":
                                case "afterblur":
                                    l = vn;
                                    break;
                                case "click":
                                    if (2 === n.button) break e;
                                case "auxclick":
                                case "dblclick":
                                case "mousedown":
                                case "mousemove":
                                case "mouseup":
                                case "mouseout":
                                case "mouseover":
                                case "contextmenu":
                                    l = gn;
                                    break;
                                case "drag":
                                case "dragend":
                                case "dragenter":
                                case "dragexit":
                                case "dragleave":
                                case "dragover":
                                case "dragstart":
                                case "drop":
                                    l = An;
                                    break;
                                case "touchcancel":
                                case "touchend":
                                case "touchmove":
                                case "touchstart":
                                    l = Cn;
                                    break;
                                case St:
                                case It:
                                case Nt:
                                    l = Mn;
                                    break;
                                case Dt:
                                    l = Ln;
                                    break;
                                case "scroll":
                                    l = fn;
                                    break;
                                case "wheel":
                                    l = zn;
                                    break;
                                case "copy":
                                case "cut":
                                case "paste":
                                    l = xn;
                                    break;
                                case "gotpointercapture":
                                case "lostpointercapture":
                                case "pointercancel":
                                case "pointerdown":
                                case "pointermove":
                                case "pointerout":
                                case "pointerover":
                                case "pointerup":
                                    l = Dn;
                            }
                            var u = !!(4 & t), h = !u && "scroll" === e1, d = u ? null !== o ? o + "Capture" : null : o;
                            u = [];
                            for(var p, f = i; null !== f;){
                                var m = (p = f).stateNode;
                                if (5 === p.tag && null !== m && (p = m, null !== d && null != (m = je(f, d)) && u.push(Oi(f, m, p))), h) break;
                                f = f.return;
                            }
                            0 < u.length && (o = new l(o, c, null, n, r), s.push({
                                event: o,
                                listeners: u
                            }));
                        }
                    }
                    if (!(7 & t)) {
                        if (l = "mouseout" === e1 || "pointerout" === e1, (!(o = "mouseover" === e1 || "pointerover" === e1) || 16 & t || !(c = n.relatedTarget || n.fromElement) || !tr(c) && !c[$i]) && (l || o) && (o = r.window === r ? r : (o = r.ownerDocument) ? o.defaultView || o.parentWindow : window, l ? (l = i, null !== (c = (c = n.relatedTarget || n.toElement) ? tr(c) : null) && (c !== (h = Ze(c)) || 5 !== c.tag && 6 !== c.tag) && (c = null)) : (l = null, c = i), l !== c)) {
                            if (u = gn, m = "onMouseLeave", d = "onMouseEnter", f = "mouse", "pointerout" !== e1 && "pointerover" !== e1 || (u = Dn, m = "onPointerLeave", d = "onPointerEnter", f = "pointer"), h = null == l ? o : ir(l), p = null == c ? o : ir(c), (o = new u(m, f + "leave", l, n, r)).target = h, o.relatedTarget = p, m = null, tr(r) === i && ((u = new u(d, f + "enter", c, n, r)).target = p, u.relatedTarget = h, m = u), h = m, l && c) e: {
                                for(d = c, f = 0, p = u = l; p; p = Ui(p))f++;
                                for(p = 0, m = d; m; m = Ui(m))p++;
                                for(; 0 < f - p;)u = Ui(u), f--;
                                for(; 0 < p - f;)d = Ui(d), p--;
                                for(; f--;){
                                    if (u === d || null !== d && u === d.alternate) break e;
                                    u = Ui(u), d = Ui(d);
                                }
                                u = null;
                            }
                            else u = null;
                            null !== l && ki(s, o, l, u, !1), null !== c && null !== h && ki(s, h, c, u, !0);
                        }
                        if ("select" === (l = (o = i ? ir(i) : window).nodeName && o.nodeName.toLowerCase()) || "input" === l && "file" === o.type) var g = Jn;
                        else if (Wn(o)) {
                            if ($n) g = li;
                            else {
                                g = si;
                                var A = ai;
                            }
                        } else (l = o.nodeName) && "input" === l.toLowerCase() && ("checkbox" === o.type || "radio" === o.type) && (g = oi);
                        switch(g && (g = g(e1, i)) ? Yn(s, g, n, r) : (A && A(e1, o, i), "focusout" === e1 && (A = o._wrapperState) && A.controlled && "number" === o.type && re(o, "number", o.value)), A = i ? ir(i) : window, e1){
                            case "focusin":
                                (Wn(A) || "true" === A.contentEditable) && (vi = A, Mi = i, yi = null);
                                break;
                            case "focusout":
                                yi = Mi = vi = null;
                                break;
                            case "mousedown":
                                xi = !0;
                                break;
                            case "contextmenu":
                            case "mouseup":
                            case "dragend":
                                xi = !1, _i(s, n, r);
                                break;
                            case "selectionchange":
                                if (Ai) break;
                            case "keydown":
                            case "keyup":
                                _i(s, n, r);
                        }
                        var v;
                        if (Pn) e: {
                            switch(e1){
                                case "compositionstart":
                                    var M = "onCompositionStart";
                                    break e;
                                case "compositionend":
                                    M = "onCompositionEnd";
                                    break e;
                                case "compositionupdate":
                                    M = "onCompositionUpdate";
                                    break e;
                            }
                            M = void 0;
                        }
                        else Gn ? Hn(e1, n) && (M = "onCompositionEnd") : "keydown" === e1 && 229 === n.keyCode && (M = "onCompositionStart");
                        M && (jn && "ko" !== n.locale && (Gn || "onCompositionStart" !== M ? "onCompositionEnd" === M && Gn && (v = nn()) : (en = "value" in ($t = r) ? $t.value : $t.textContent, Gn = !0)), 0 < (A = Pi(i, M)).length && (M = new _n(M, e1, null, n, r), s.push({
                            event: M,
                            listeners: A
                        }), (v || null !== (v = Vn(n))) && (M.data = v))), (v = kn ? function(e1, t) {
                            switch(e1){
                                case "compositionend":
                                    return Vn(t);
                                case "keypress":
                                    return 32 !== t.which ? null : (Fn = !0, Bn);
                                case "textInput":
                                    return (e1 = t.data) === Bn && Fn ? null : e1;
                                default:
                                    return null;
                            }
                        }(e1, n) : function(e1, t) {
                            if (Gn) return "compositionend" === e1 || !Pn && Hn(e1, t) ? (e1 = nn(), tn = en = $t = null, Gn = !1, e1) : null;
                            switch(e1){
                                case "paste":
                                default:
                                    return null;
                                case "keypress":
                                    if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                                        if (t.char && 1 < t.char.length) return t.char;
                                        if (t.which) return String.fromCharCode(t.which);
                                    }
                                    return null;
                                case "compositionend":
                                    return jn && "ko" !== t.locale ? null : t.data;
                            }
                        }(e1, n)) && 0 < (i = Pi(i, "onBeforeInput")).length && (r = new _n("onBeforeInput", "beforeinput", null, n, r), s.push({
                            event: r,
                            listeners: i
                        }), r.data = v);
                    }
                    Ii(s, t);
                });
            }
            function Oi(e1, t, n) {
                return {
                    instance: e1,
                    listener: t,
                    currentTarget: n
                };
            }
            function Pi(e1, t) {
                for(var n = t + "Capture", i = []; null !== e1;){
                    var r = e1, a = r.stateNode;
                    5 === r.tag && null !== a && (r = a, null != (a = je(e1, n)) && i.unshift(Oi(e1, a, r)), null != (a = je(e1, t)) && i.push(Oi(e1, a, r))), e1 = e1.return;
                }
                return i;
            }
            function Ui(e1) {
                if (null === e1) return null;
                do e1 = e1.return;
                while (e1 && 5 !== e1.tag);
                return e1 || null;
            }
            function ki(e1, t, n, i, r) {
                for(var a = t._reactName, s = []; null !== n && n !== i;){
                    var o = n, l = o.alternate, c = o.stateNode;
                    if (null !== l && l === i) break;
                    5 === o.tag && null !== c && (o = c, r ? null != (l = je(n, a)) && s.unshift(Oi(n, l, o)) : r || null != (l = je(n, a)) && s.push(Oi(n, l, o))), n = n.return;
                }
                0 !== s.length && e1.push({
                    event: t,
                    listeners: s
                });
            }
            function ji() {}
            var Bi = null, Fi = null;
            function Hi(e1, t) {
                switch(e1){
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                        return !!t.autoFocus;
                }
                return !1;
            }
            function Vi(e1, t) {
                return "textarea" === e1 || "option" === e1 || "noscript" === e1 || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
            }
            var Gi = "function" == typeof setTimeout ? setTimeout : void 0, Qi = "function" == typeof clearTimeout ? clearTimeout : void 0;
            function Wi(e1) {
                (1 === e1.nodeType || 9 === e1.nodeType && null != (e1 = e1.body)) && (e1.textContent = "");
            }
            function Yi(e1) {
                for(; null != e1; e1 = e1.nextSibling){
                    var t = e1.nodeType;
                    if (1 === t || 3 === t) break;
                }
                return e1;
            }
            function Xi(e1) {
                e1 = e1.previousSibling;
                for(var t = 0; e1;){
                    if (8 === e1.nodeType) {
                        var n = e1.data;
                        if ("$" === n || "$!" === n || "$?" === n) {
                            if (0 === t) return e1;
                            t--;
                        } else "/$" === n && t++;
                    }
                    e1 = e1.previousSibling;
                }
                return null;
            }
            var Zi = 0, qi = Math.random().toString(36).slice(2), Ki = "__reactFiber$" + qi, Ji = "__reactProps$" + qi, $i = "__reactContainer$" + qi, er = "__reactEvents$" + qi;
            function tr(e1) {
                var t = e1[Ki];
                if (t) return t;
                for(var n = e1.parentNode; n;){
                    if (t = n[$i] || n[Ki]) {
                        if (n = t.alternate, null !== t.child || null !== n && null !== n.child) for(e1 = Xi(e1); null !== e1;){
                            if (n = e1[Ki]) return n;
                            e1 = Xi(e1);
                        }
                        return t;
                    }
                    n = (e1 = n).parentNode;
                }
                return null;
            }
            function nr(e1) {
                return !(e1 = e1[Ki] || e1[$i]) || 5 !== e1.tag && 6 !== e1.tag && 13 !== e1.tag && 3 !== e1.tag ? null : e1;
            }
            function ir(e1) {
                if (5 === e1.tag || 6 === e1.tag) return e1.stateNode;
                throw Error(s(33));
            }
            function rr(e1) {
                return e1[Ji] || null;
            }
            function ar(e1) {
                var t = e1[er];
                return void 0 === t && (t = e1[er] = new Set), t;
            }
            var sr = [], or = -1;
            function lr(e1) {
                return {
                    current: e1
                };
            }
            function cr(e1) {
                0 > or || (e1.current = sr[or], sr[or] = null, or--);
            }
            function ur(e1, t) {
                or++, sr[or] = e1.current, e1.current = t;
            }
            var hr = {}, dr = lr(hr), pr = lr(!1), fr = hr;
            function mr(e1, t) {
                var n = e1.type.contextTypes;
                if (!n) return hr;
                var i = e1.stateNode;
                if (i && i.__reactInternalMemoizedUnmaskedChildContext === t) return i.__reactInternalMemoizedMaskedChildContext;
                var r, a = {};
                for(r in n)a[r] = t[r];
                return i && ((e1 = e1.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e1.__reactInternalMemoizedMaskedChildContext = a), a;
            }
            function gr(e1) {
                return null != e1.childContextTypes;
            }
            function Ar() {
                cr(pr), cr(dr);
            }
            function vr(e1, t, n) {
                if (dr.current !== hr) throw Error(s(168));
                ur(dr, t), ur(pr, n);
            }
            function Mr(e1, t, n) {
                var i = e1.stateNode;
                if (e1 = t.childContextTypes, "function" != typeof i.getChildContext) return n;
                for(var a in i = i.getChildContext())if (!(a in e1)) throw Error(s(108, Y(t) || "Unknown", a));
                return r({}, n, i);
            }
            function yr(e1) {
                return e1 = (e1 = e1.stateNode) && e1.__reactInternalMemoizedMergedChildContext || hr, fr = dr.current, ur(dr, e1), ur(pr, pr.current), !0;
            }
            function xr(e1, t, n) {
                var i = e1.stateNode;
                if (!i) throw Error(s(169));
                n ? (e1 = Mr(e1, t, fr), i.__reactInternalMemoizedMergedChildContext = e1, cr(pr), cr(dr), ur(dr, e1)) : cr(pr), ur(pr, n);
            }
            var _r = null, br = null, wr = a.unstable_runWithPriority, Er = a.unstable_scheduleCallback, Tr = a.unstable_cancelCallback, Sr = a.unstable_shouldYield, Ir = a.unstable_requestPaint, Nr = a.unstable_now, Dr = a.unstable_getCurrentPriorityLevel, Cr = a.unstable_ImmediatePriority, Lr = a.unstable_UserBlockingPriority, Rr = a.unstable_NormalPriority, zr = a.unstable_LowPriority, Or = a.unstable_IdlePriority, Pr = {}, Ur = void 0 !== Ir ? Ir : function() {}, kr = null, jr = null, Br = !1, Fr = Nr(), Hr = 1e4 > Fr ? Nr : function() {
                return Nr() - Fr;
            };
            function Vr() {
                switch(Dr()){
                    case Cr:
                        return 99;
                    case Lr:
                        return 98;
                    case Rr:
                        return 97;
                    case zr:
                        return 96;
                    case Or:
                        return 95;
                    default:
                        throw Error(s(332));
                }
            }
            function Gr(e1) {
                switch(e1){
                    case 99:
                        return Cr;
                    case 98:
                        return Lr;
                    case 97:
                        return Rr;
                    case 96:
                        return zr;
                    case 95:
                        return Or;
                    default:
                        throw Error(s(332));
                }
            }
            function Qr(e1, t) {
                return e1 = Gr(e1), wr(e1, t);
            }
            function Wr(e1, t, n) {
                return e1 = Gr(e1), Er(e1, t, n);
            }
            function Yr() {
                if (null !== jr) {
                    var e1 = jr;
                    jr = null, Tr(e1);
                }
                Xr();
            }
            function Xr() {
                if (!Br && null !== kr) {
                    Br = !0;
                    var e1 = 0;
                    try {
                        var t = kr;
                        Qr(99, function() {
                            for(; e1 < t.length; e1++){
                                var n = t[e1];
                                do n = n(!0);
                                while (null !== n);
                            }
                        }), kr = null;
                    } catch (t) {
                        throw null !== kr && (kr = kr.slice(e1 + 1)), Er(Cr, Yr), t;
                    } finally{
                        Br = !1;
                    }
                }
            }
            var Zr = x.ReactCurrentBatchConfig;
            function qr(e1, t) {
                if (e1 && e1.defaultProps) {
                    for(var n in t = r({}, t), e1 = e1.defaultProps)void 0 === t[n] && (t[n] = e1[n]);
                    return t;
                }
                return t;
            }
            var Kr = lr(null), Jr = null, $r = null, ea = null;
            function ta() {
                ea = $r = Jr = null;
            }
            function na(e1) {
                var t = Kr.current;
                cr(Kr), e1.type._context._currentValue = t;
            }
            function ia(e1, t) {
                for(; null !== e1;){
                    var n = e1.alternate;
                    if ((e1.childLanes & t) === t) {
                        if (null === n || (n.childLanes & t) === t) break;
                        n.childLanes |= t;
                    } else e1.childLanes |= t, null !== n && (n.childLanes |= t);
                    e1 = e1.return;
                }
            }
            function ra(e1, t) {
                Jr = e1, ea = $r = null, null !== (e1 = e1.dependencies) && null !== e1.firstContext && (!!(e1.lanes & t) && (Os = !0), e1.firstContext = null);
            }
            function aa(e1, t) {
                if (ea !== e1 && !1 !== t && 0 !== t) {
                    if ("number" == typeof t && 1073741823 !== t || (ea = e1, t = 1073741823), t = {
                        context: e1,
                        observedBits: t,
                        next: null
                    }, null === $r) {
                        if (null === Jr) throw Error(s(308));
                        $r = t, Jr.dependencies = {
                            lanes: 0,
                            firstContext: t,
                            responders: null
                        };
                    } else $r = $r.next = t;
                }
                return e1._currentValue;
            }
            var sa = !1;
            function oa(e1) {
                e1.updateQueue = {
                    baseState: e1.memoizedState,
                    firstBaseUpdate: null,
                    lastBaseUpdate: null,
                    shared: {
                        pending: null
                    },
                    effects: null
                };
            }
            function la(e1, t) {
                e1 = e1.updateQueue, t.updateQueue === e1 && (t.updateQueue = {
                    baseState: e1.baseState,
                    firstBaseUpdate: e1.firstBaseUpdate,
                    lastBaseUpdate: e1.lastBaseUpdate,
                    shared: e1.shared,
                    effects: e1.effects
                });
            }
            function ca(e1, t) {
                return {
                    eventTime: e1,
                    lane: t,
                    tag: 0,
                    payload: null,
                    callback: null,
                    next: null
                };
            }
            function ua(e1, t) {
                if (null !== (e1 = e1.updateQueue)) {
                    var n = (e1 = e1.shared).pending;
                    null === n ? t.next = t : (t.next = n.next, n.next = t), e1.pending = t;
                }
            }
            function ha(e1, t) {
                var n = e1.updateQueue, i = e1.alternate;
                if (null !== i && n === (i = i.updateQueue)) {
                    var r = null, a = null;
                    if (null !== (n = n.firstBaseUpdate)) {
                        do {
                            var s = {
                                eventTime: n.eventTime,
                                lane: n.lane,
                                tag: n.tag,
                                payload: n.payload,
                                callback: n.callback,
                                next: null
                            };
                            null === a ? r = a = s : a = a.next = s, n = n.next;
                        }while (null !== n);
                        null === a ? r = a = t : a = a.next = t;
                    } else r = a = t;
                    return n = {
                        baseState: i.baseState,
                        firstBaseUpdate: r,
                        lastBaseUpdate: a,
                        shared: i.shared,
                        effects: i.effects
                    }, void (e1.updateQueue = n);
                }
                null === (e1 = n.lastBaseUpdate) ? n.firstBaseUpdate = t : e1.next = t, n.lastBaseUpdate = t;
            }
            function da(e1, t, n, i) {
                var a = e1.updateQueue;
                sa = !1;
                var s = a.firstBaseUpdate, o = a.lastBaseUpdate, l = a.shared.pending;
                if (null !== l) {
                    a.shared.pending = null;
                    var c = l, u = c.next;
                    c.next = null, null === o ? s = u : o.next = u, o = c;
                    var h = e1.alternate;
                    if (null !== h) {
                        var d = (h = h.updateQueue).lastBaseUpdate;
                        d !== o && (null === d ? h.firstBaseUpdate = u : d.next = u, h.lastBaseUpdate = c);
                    }
                }
                if (null !== s) {
                    for(d = a.baseState, o = 0, h = u = c = null;;){
                        l = s.lane;
                        var p = s.eventTime;
                        if ((i & l) === l) {
                            null !== h && (h = h.next = {
                                eventTime: p,
                                lane: 0,
                                tag: s.tag,
                                payload: s.payload,
                                callback: s.callback,
                                next: null
                            });
                            e: {
                                var f = e1, m = s;
                                switch(l = t, p = n, m.tag){
                                    case 1:
                                        if ("function" == typeof (f = m.payload)) {
                                            d = f.call(p, d, l);
                                            break e;
                                        }
                                        d = f;
                                        break e;
                                    case 3:
                                        f.flags = -4097 & f.flags | 64;
                                    case 0:
                                        if (null == (l = "function" == typeof (f = m.payload) ? f.call(p, d, l) : f)) break e;
                                        d = r({}, d, l);
                                        break e;
                                    case 2:
                                        sa = !0;
                                }
                            }
                            null !== s.callback && (e1.flags |= 32, null === (l = a.effects) ? a.effects = [
                                s
                            ] : l.push(s));
                        } else p = {
                            eventTime: p,
                            lane: l,
                            tag: s.tag,
                            payload: s.payload,
                            callback: s.callback,
                            next: null
                        }, null === h ? (u = h = p, c = d) : h = h.next = p, o |= l;
                        if (null === (s = s.next)) {
                            if (null === (l = a.shared.pending)) break;
                            s = l.next, l.next = null, a.lastBaseUpdate = l, a.shared.pending = null;
                        }
                    }
                    null === h && (c = d), a.baseState = c, a.firstBaseUpdate = u, a.lastBaseUpdate = h, jo |= o, e1.lanes = o, e1.memoizedState = d;
                }
            }
            function pa(e1, t, n) {
                if (e1 = t.effects, t.effects = null, null !== e1) for(t = 0; t < e1.length; t++){
                    var i = e1[t], r = i.callback;
                    if (null !== r) {
                        if (i.callback = null, i = n, "function" != typeof r) throw Error(s(191, r));
                        r.call(i);
                    }
                }
            }
            var fa = (new i.Component).refs;
            function ma(e1, t, n, i) {
                n = null == (n = n(i, t = e1.memoizedState)) ? t : r({}, t, n), e1.memoizedState = n, 0 === e1.lanes && (e1.updateQueue.baseState = n);
            }
            var ga = {
                isMounted: function(e1) {
                    return !!(e1 = e1._reactInternals) && Ze(e1) === e1;
                },
                enqueueSetState: function(e1, t, n) {
                    e1 = e1._reactInternals;
                    var i = ul(), r = hl(e1), a = ca(i, r);
                    a.payload = t, null != n && (a.callback = n), ua(e1, a), dl(e1, r, i);
                },
                enqueueReplaceState: function(e1, t, n) {
                    e1 = e1._reactInternals;
                    var i = ul(), r = hl(e1), a = ca(i, r);
                    a.tag = 1, a.payload = t, null != n && (a.callback = n), ua(e1, a), dl(e1, r, i);
                },
                enqueueForceUpdate: function(e1, t) {
                    e1 = e1._reactInternals;
                    var n = ul(), i = hl(e1), r = ca(n, i);
                    r.tag = 2, null != t && (r.callback = t), ua(e1, r), dl(e1, i, n);
                }
            };
            function Aa(e1, t, n, i, r, a, s) {
                return "function" == typeof (e1 = e1.stateNode).shouldComponentUpdate ? e1.shouldComponentUpdate(i, a, s) : !(t.prototype && t.prototype.isPureReactComponent && hi(n, i) && hi(r, a));
            }
            function va(e1, t, n) {
                var i = !1, r = hr, a = t.contextType;
                return "object" == typeof a && null !== a ? a = aa(a) : (r = gr(t) ? fr : dr.current, a = (i = null != (i = t.contextTypes)) ? mr(e1, r) : hr), t = new t(n, a), e1.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = ga, e1.stateNode = t, t._reactInternals = e1, i && ((e1 = e1.stateNode).__reactInternalMemoizedUnmaskedChildContext = r, e1.__reactInternalMemoizedMaskedChildContext = a), t;
            }
            function Ma(e1, t, n, i) {
                e1 = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, i), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, i), t.state !== e1 && ga.enqueueReplaceState(t, t.state, null);
            }
            function ya(e1, t, n, i) {
                var r = e1.stateNode;
                r.props = n, r.state = e1.memoizedState, r.refs = fa, oa(e1);
                var a = t.contextType;
                "object" == typeof a && null !== a ? r.context = aa(a) : (a = gr(t) ? fr : dr.current, r.context = mr(e1, a)), da(e1, n, r, i), r.state = e1.memoizedState, "function" == typeof (a = t.getDerivedStateFromProps) && (ma(e1, t, a, n), r.state = e1.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof r.getSnapshotBeforeUpdate || "function" != typeof r.UNSAFE_componentWillMount && "function" != typeof r.componentWillMount || (t = r.state, "function" == typeof r.componentWillMount && r.componentWillMount(), "function" == typeof r.UNSAFE_componentWillMount && r.UNSAFE_componentWillMount(), t !== r.state && ga.enqueueReplaceState(r, r.state, null), da(e1, n, r, i), r.state = e1.memoizedState), "function" == typeof r.componentDidMount && (e1.flags |= 4);
            }
            var xa = Array.isArray;
            function _a(e1, t, n) {
                if (null !== (e1 = n.ref) && "function" != typeof e1 && "object" != typeof e1) {
                    if (n._owner) {
                        if (n = n._owner) {
                            if (1 !== n.tag) throw Error(s(309));
                            var i = n.stateNode;
                        }
                        if (!i) throw Error(s(147, e1));
                        var r = "" + e1;
                        return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === r ? t.ref : (t = function(e1) {
                            var t = i.refs;
                            t === fa && (t = i.refs = {}), null === e1 ? delete t[r] : t[r] = e1;
                        }, t._stringRef = r, t);
                    }
                    if ("string" != typeof e1) throw Error(s(284));
                    if (!n._owner) throw Error(s(290, e1));
                }
                return e1;
            }
            function ba(e1, t) {
                if ("textarea" !== e1.type) throw Error(s(31, "[object Object]" === Object.prototype.toString.call(t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : t));
            }
            function wa(e1) {
                function t(t, n) {
                    if (e1) {
                        var i = t.lastEffect;
                        null !== i ? (i.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n, n.nextEffect = null, n.flags = 8;
                    }
                }
                function n(n, i) {
                    if (!e1) return null;
                    for(; null !== i;)t(n, i), i = i.sibling;
                    return null;
                }
                function i(e1, t) {
                    for(e1 = new Map; null !== t;)null !== t.key ? e1.set(t.key, t) : e1.set(t.index, t), t = t.sibling;
                    return e1;
                }
                function r(e1, t) {
                    return (e1 = Gl(e1, t)).index = 0, e1.sibling = null, e1;
                }
                function a(t, n, i) {
                    return t.index = i, e1 ? null !== (i = t.alternate) ? (i = i.index) < n ? (t.flags = 2, n) : i : (t.flags = 2, n) : n;
                }
                function o(t) {
                    return e1 && null === t.alternate && (t.flags = 2), t;
                }
                function l(e1, t, n, i) {
                    return null === t || 6 !== t.tag ? ((t = Xl(n, e1.mode, i)).return = e1, t) : ((t = r(t, n)).return = e1, t);
                }
                function c(e1, t, n, i) {
                    return null !== t && t.elementType === n.type ? ((i = r(t, n.props)).ref = _a(e1, t, n), i.return = e1, i) : ((i = Ql(n.type, n.key, n.props, null, e1.mode, i)).ref = _a(e1, t, n), i.return = e1, i);
                }
                function u(e1, t, n, i) {
                    return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = Zl(n, e1.mode, i)).return = e1, t) : ((t = r(t, n.children || [])).return = e1, t);
                }
                function h(e1, t, n, i, a) {
                    return null === t || 7 !== t.tag ? ((t = Wl(n, e1.mode, i, a)).return = e1, t) : ((t = r(t, n)).return = e1, t);
                }
                function d(e1, t, n) {
                    if ("string" == typeof t || "number" == typeof t) return (t = Xl("" + t, e1.mode, n)).return = e1, t;
                    if ("object" == typeof t && null !== t) {
                        switch(t.$$typeof){
                            case _:
                                return (n = Ql(t.type, t.key, t.props, null, e1.mode, n)).ref = _a(e1, null, t), n.return = e1, n;
                            case b:
                                return (t = Zl(t, e1.mode, n)).return = e1, t;
                        }
                        if (xa(t) || H(t)) return (t = Wl(t, e1.mode, n, null)).return = e1, t;
                        ba(e1, t);
                    }
                    return null;
                }
                function p(e1, t, n, i) {
                    var r = null !== t ? t.key : null;
                    if ("string" == typeof n || "number" == typeof n) return null !== r ? null : l(e1, t, "" + n, i);
                    if ("object" == typeof n && null !== n) {
                        switch(n.$$typeof){
                            case _:
                                return n.key === r ? n.type === w ? h(e1, t, n.props.children, i, r) : c(e1, t, n, i) : null;
                            case b:
                                return n.key === r ? u(e1, t, n, i) : null;
                        }
                        if (xa(n) || H(n)) return null !== r ? null : h(e1, t, n, i, null);
                        ba(e1, n);
                    }
                    return null;
                }
                function f(e1, t, n, i, r) {
                    if ("string" == typeof i || "number" == typeof i) return l(t, e1 = e1.get(n) || null, "" + i, r);
                    if ("object" == typeof i && null !== i) {
                        switch(i.$$typeof){
                            case _:
                                return e1 = e1.get(null === i.key ? n : i.key) || null, i.type === w ? h(t, e1, i.props.children, r, i.key) : c(t, e1, i, r);
                            case b:
                                return u(t, e1 = e1.get(null === i.key ? n : i.key) || null, i, r);
                        }
                        if (xa(i) || H(i)) return h(t, e1 = e1.get(n) || null, i, r, null);
                        ba(t, i);
                    }
                    return null;
                }
                function m(r, s, o, l) {
                    for(var c = null, u = null, h = s, m = s = 0, g = null; null !== h && m < o.length; m++){
                        h.index > m ? (g = h, h = null) : g = h.sibling;
                        var A = p(r, h, o[m], l);
                        if (null === A) {
                            null === h && (h = g);
                            break;
                        }
                        e1 && h && null === A.alternate && t(r, h), s = a(A, s, m), null === u ? c = A : u.sibling = A, u = A, h = g;
                    }
                    if (m === o.length) return n(r, h), c;
                    if (null === h) {
                        for(; m < o.length; m++)null !== (h = d(r, o[m], l)) && (s = a(h, s, m), null === u ? c = h : u.sibling = h, u = h);
                        return c;
                    }
                    for(h = i(r, h); m < o.length; m++)null !== (g = f(h, r, m, o[m], l)) && (e1 && null !== g.alternate && h.delete(null === g.key ? m : g.key), s = a(g, s, m), null === u ? c = g : u.sibling = g, u = g);
                    return e1 && h.forEach(function(e1) {
                        return t(r, e1);
                    }), c;
                }
                function g(r, o, l, c) {
                    var u = H(l);
                    if ("function" != typeof u) throw Error(s(150));
                    if (null == (l = u.call(l))) throw Error(s(151));
                    for(var h = u = null, m = o, g = o = 0, A = null, v = l.next(); null !== m && !v.done; g++, v = l.next()){
                        m.index > g ? (A = m, m = null) : A = m.sibling;
                        var M = p(r, m, v.value, c);
                        if (null === M) {
                            null === m && (m = A);
                            break;
                        }
                        e1 && m && null === M.alternate && t(r, m), o = a(M, o, g), null === h ? u = M : h.sibling = M, h = M, m = A;
                    }
                    if (v.done) return n(r, m), u;
                    if (null === m) {
                        for(; !v.done; g++, v = l.next())null !== (v = d(r, v.value, c)) && (o = a(v, o, g), null === h ? u = v : h.sibling = v, h = v);
                        return u;
                    }
                    for(m = i(r, m); !v.done; g++, v = l.next())null !== (v = f(m, r, g, v.value, c)) && (e1 && null !== v.alternate && m.delete(null === v.key ? g : v.key), o = a(v, o, g), null === h ? u = v : h.sibling = v, h = v);
                    return e1 && m.forEach(function(e1) {
                        return t(r, e1);
                    }), u;
                }
                return function(e1, i, a, l) {
                    var c = "object" == typeof a && null !== a && a.type === w && null === a.key;
                    c && (a = a.props.children);
                    var u = "object" == typeof a && null !== a;
                    if (u) switch(a.$$typeof){
                        case _:
                            e: {
                                for(u = a.key, c = i; null !== c;){
                                    if (c.key === u) {
                                        if (7 === c.tag) {
                                            if (a.type === w) {
                                                n(e1, c.sibling), (i = r(c, a.props.children)).return = e1, e1 = i;
                                                break e;
                                            }
                                        } else if (c.elementType === a.type) {
                                            n(e1, c.sibling), (i = r(c, a.props)).ref = _a(e1, c, a), i.return = e1, e1 = i;
                                            break e;
                                        }
                                        n(e1, c);
                                        break;
                                    }
                                    t(e1, c), c = c.sibling;
                                }
                                a.type === w ? ((i = Wl(a.props.children, e1.mode, l, a.key)).return = e1, e1 = i) : ((l = Ql(a.type, a.key, a.props, null, e1.mode, l)).ref = _a(e1, i, a), l.return = e1, e1 = l);
                            }
                            return o(e1);
                        case b:
                            e: {
                                for(c = a.key; null !== i;){
                                    if (i.key === c) {
                                        if (4 === i.tag && i.stateNode.containerInfo === a.containerInfo && i.stateNode.implementation === a.implementation) {
                                            n(e1, i.sibling), (i = r(i, a.children || [])).return = e1, e1 = i;
                                            break e;
                                        }
                                        n(e1, i);
                                        break;
                                    }
                                    t(e1, i), i = i.sibling;
                                }
                                (i = Zl(a, e1.mode, l)).return = e1, e1 = i;
                            }
                            return o(e1);
                    }
                    if ("string" == typeof a || "number" == typeof a) return a = "" + a, null !== i && 6 === i.tag ? (n(e1, i.sibling), (i = r(i, a)).return = e1, e1 = i) : (n(e1, i), (i = Xl(a, e1.mode, l)).return = e1, e1 = i), o(e1);
                    if (xa(a)) return m(e1, i, a, l);
                    if (H(a)) return g(e1, i, a, l);
                    if (u && ba(e1, a), void 0 === a && !c) switch(e1.tag){
                        case 1:
                        case 22:
                        case 0:
                        case 11:
                        case 15:
                            throw Error(s(152, Y(e1.type) || "Component"));
                    }
                    return n(e1, i);
                };
            }
            var Ea = wa(!0), Ta = wa(!1), Sa = {}, Ia = lr(Sa), Na = lr(Sa), Da = lr(Sa);
            function Ca(e1) {
                if (e1 === Sa) throw Error(s(174));
                return e1;
            }
            function La(e1, t) {
                switch(ur(Da, t), ur(Na, e1), ur(Ia, Sa), e1 = t.nodeType){
                    case 9:
                    case 11:
                        t = (t = t.documentElement) ? t.namespaceURI : pe(null, "");
                        break;
                    default:
                        t = pe(t = (e1 = 8 === e1 ? t.parentNode : t).namespaceURI || null, e1 = e1.tagName);
                }
                cr(Ia), ur(Ia, t);
            }
            function Ra() {
                cr(Ia), cr(Na), cr(Da);
            }
            function za(e1) {
                Ca(Da.current);
                var t = Ca(Ia.current), n = pe(t, e1.type);
                t !== n && (ur(Na, e1), ur(Ia, n));
            }
            function Oa(e1) {
                Na.current === e1 && (cr(Ia), cr(Na));
            }
            var Pa = lr(0);
            function Ua(e1) {
                for(var t = e1; null !== t;){
                    if (13 === t.tag) {
                        var n = t.memoizedState;
                        if (null !== n && (null === (n = n.dehydrated) || "$?" === n.data || "$!" === n.data)) return t;
                    } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
                        if (64 & t.flags) return t;
                    } else if (null !== t.child) {
                        t.child.return = t, t = t.child;
                        continue;
                    }
                    if (t === e1) break;
                    for(; null === t.sibling;){
                        if (null === t.return || t.return === e1) return null;
                        t = t.return;
                    }
                    t.sibling.return = t.return, t = t.sibling;
                }
                return null;
            }
            var ka = null, ja = null, Ba = !1;
            function Fa(e1, t) {
                var n = Hl(5, null, null, 0);
                n.elementType = "DELETED", n.type = "DELETED", n.stateNode = t, n.return = e1, n.flags = 8, null !== e1.lastEffect ? (e1.lastEffect.nextEffect = n, e1.lastEffect = n) : e1.firstEffect = e1.lastEffect = n;
            }
            function Ha(e1, t) {
                switch(e1.tag){
                    case 5:
                        var n = e1.type;
                        return null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e1.stateNode = t, !0);
                    case 6:
                        return null !== (t = "" === e1.pendingProps || 3 !== t.nodeType ? null : t) && (e1.stateNode = t, !0);
                    default:
                        return !1;
                }
            }
            function Va(e1) {
                if (Ba) {
                    var t = ja;
                    if (t) {
                        var n = t;
                        if (!Ha(e1, t)) {
                            if (!(t = Yi(n.nextSibling)) || !Ha(e1, t)) return e1.flags = -1025 & e1.flags | 2, Ba = !1, void (ka = e1);
                            Fa(ka, n);
                        }
                        ka = e1, ja = Yi(t.firstChild);
                    } else e1.flags = -1025 & e1.flags | 2, Ba = !1, ka = e1;
                }
            }
            function Ga(e1) {
                for(e1 = e1.return; null !== e1 && 5 !== e1.tag && 3 !== e1.tag && 13 !== e1.tag;)e1 = e1.return;
                ka = e1;
            }
            function Qa(e1) {
                if (e1 !== ka) return !1;
                if (!Ba) return Ga(e1), Ba = !0, !1;
                var t = e1.type;
                if (5 !== e1.tag || "head" !== t && "body" !== t && !Vi(t, e1.memoizedProps)) for(t = ja; t;)Fa(e1, t), t = Yi(t.nextSibling);
                if (Ga(e1), 13 === e1.tag) {
                    if (!(e1 = null !== (e1 = e1.memoizedState) ? e1.dehydrated : null)) throw Error(s(317));
                    e: {
                        for(e1 = e1.nextSibling, t = 0; e1;){
                            if (8 === e1.nodeType) {
                                var n = e1.data;
                                if ("/$" === n) {
                                    if (0 === t) {
                                        ja = Yi(e1.nextSibling);
                                        break e;
                                    }
                                    t--;
                                } else "$" !== n && "$!" !== n && "$?" !== n || t++;
                            }
                            e1 = e1.nextSibling;
                        }
                        ja = null;
                    }
                } else ja = ka ? Yi(e1.stateNode.nextSibling) : null;
                return !0;
            }
            function Wa() {
                ja = ka = null, Ba = !1;
            }
            var Ya = [];
            function Xa() {
                for(var e1 = 0; e1 < Ya.length; e1++)Ya[e1]._workInProgressVersionPrimary = null;
                Ya.length = 0;
            }
            var Za = x.ReactCurrentDispatcher, qa = x.ReactCurrentBatchConfig, Ka = 0, Ja = null, $a = null, es = null, ts = !1, ns = !1;
            function is() {
                throw Error(s(321));
            }
            function rs(e1, t) {
                if (null === t) return !1;
                for(var n = 0; n < t.length && n < e1.length; n++)if (!ci(e1[n], t[n])) return !1;
                return !0;
            }
            function as(e1, t, n, i, r, a) {
                if (Ka = a, Ja = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, Za.current = null === e1 || null === e1.memoizedState ? Cs : Ls, e1 = n(i, r), ns) {
                    a = 0;
                    do {
                        if (ns = !1, !(25 > a)) throw Error(s(301));
                        a += 1, es = $a = null, t.updateQueue = null, Za.current = Rs, e1 = n(i, r);
                    }while (ns);
                }
                if (Za.current = Ds, t = null !== $a && null !== $a.next, Ka = 0, es = $a = Ja = null, ts = !1, t) throw Error(s(300));
                return e1;
            }
            function ss() {
                var e1 = {
                    memoizedState: null,
                    baseState: null,
                    baseQueue: null,
                    queue: null,
                    next: null
                };
                return null === es ? Ja.memoizedState = es = e1 : es = es.next = e1, es;
            }
            function os() {
                if (null === $a) {
                    var e1 = Ja.alternate;
                    e1 = null !== e1 ? e1.memoizedState : null;
                } else e1 = $a.next;
                var t = null === es ? Ja.memoizedState : es.next;
                if (null !== t) es = t, $a = e1;
                else {
                    if (null === e1) throw Error(s(310));
                    e1 = {
                        memoizedState: ($a = e1).memoizedState,
                        baseState: $a.baseState,
                        baseQueue: $a.baseQueue,
                        queue: $a.queue,
                        next: null
                    }, null === es ? Ja.memoizedState = es = e1 : es = es.next = e1;
                }
                return es;
            }
            function ls(e1, t) {
                return "function" == typeof t ? t(e1) : t;
            }
            function cs(e1) {
                var t = os(), n = t.queue;
                if (null === n) throw Error(s(311));
                n.lastRenderedReducer = e1;
                var i = $a, r = i.baseQueue, a = n.pending;
                if (null !== a) {
                    if (null !== r) {
                        var o = r.next;
                        r.next = a.next, a.next = o;
                    }
                    i.baseQueue = r = a, n.pending = null;
                }
                if (null !== r) {
                    r = r.next, i = i.baseState;
                    var l = o = a = null, c = r;
                    do {
                        var u = c.lane;
                        if ((Ka & u) === u) null !== l && (l = l.next = {
                            lane: 0,
                            action: c.action,
                            eagerReducer: c.eagerReducer,
                            eagerState: c.eagerState,
                            next: null
                        }), i = c.eagerReducer === e1 ? c.eagerState : e1(i, c.action);
                        else {
                            var h = {
                                lane: u,
                                action: c.action,
                                eagerReducer: c.eagerReducer,
                                eagerState: c.eagerState,
                                next: null
                            };
                            null === l ? (o = l = h, a = i) : l = l.next = h, Ja.lanes |= u, jo |= u;
                        }
                        c = c.next;
                    }while (null !== c && c !== r);
                    null === l ? a = i : l.next = o, ci(i, t.memoizedState) || (Os = !0), t.memoizedState = i, t.baseState = a, t.baseQueue = l, n.lastRenderedState = i;
                }
                return [
                    t.memoizedState,
                    n.dispatch
                ];
            }
            function us(e1) {
                var t = os(), n = t.queue;
                if (null === n) throw Error(s(311));
                n.lastRenderedReducer = e1;
                var i = n.dispatch, r = n.pending, a = t.memoizedState;
                if (null !== r) {
                    n.pending = null;
                    var o = r = r.next;
                    do a = e1(a, o.action), o = o.next;
                    while (o !== r);
                    ci(a, t.memoizedState) || (Os = !0), t.memoizedState = a, null === t.baseQueue && (t.baseState = a), n.lastRenderedState = a;
                }
                return [
                    a,
                    i
                ];
            }
            function hs(e1, t, n) {
                var i = t._getVersion;
                i = i(t._source);
                var r = t._workInProgressVersionPrimary;
                if (null !== r ? e1 = r === i : (e1 = e1.mutableReadLanes, (e1 = (Ka & e1) === e1) && (t._workInProgressVersionPrimary = i, Ya.push(t))), e1) return n(t._source);
                throw Ya.push(t), Error(s(350));
            }
            function ds(e1, t, n, i) {
                var r = Co;
                if (null === r) throw Error(s(349));
                var a = t._getVersion, o = a(t._source), l = Za.current, c = l.useState(function() {
                    return hs(r, t, n);
                }), u = c[1], h = c[0];
                c = es;
                var d = e1.memoizedState, p = d.refs, f = p.getSnapshot, m = d.source;
                d = d.subscribe;
                var g = Ja;
                return e1.memoizedState = {
                    refs: p,
                    source: t,
                    subscribe: i
                }, l.useEffect(function() {
                    p.getSnapshot = n, p.setSnapshot = u;
                    var e1 = a(t._source);
                    if (!ci(o, e1)) {
                        e1 = n(t._source), ci(h, e1) || (u(e1), e1 = hl(g), r.mutableReadLanes |= e1 & r.pendingLanes), e1 = r.mutableReadLanes, r.entangledLanes |= e1;
                        for(var i = r.entanglements, s = e1; 0 < s;){
                            var l = 31 - Vt(s), c = 1 << l;
                            i[l] |= e1, s &= ~c;
                        }
                    }
                }, [
                    n,
                    t,
                    i
                ]), l.useEffect(function() {
                    return i(t._source, function() {
                        var e1 = p.getSnapshot, n = p.setSnapshot;
                        try {
                            n(e1(t._source));
                            var i = hl(g);
                            r.mutableReadLanes |= i & r.pendingLanes;
                        } catch (e1) {
                            n(function() {
                                throw e1;
                            });
                        }
                    });
                }, [
                    t,
                    i
                ]), ci(f, n) && ci(m, t) && ci(d, i) || ((e1 = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: ls,
                    lastRenderedState: h
                }).dispatch = u = Ns.bind(null, Ja, e1), c.queue = e1, c.baseQueue = null, h = hs(r, t, n), c.memoizedState = c.baseState = h), h;
            }
            function ps(e1, t, n) {
                return ds(os(), e1, t, n);
            }
            function fs(e1) {
                var t = ss();
                return "function" == typeof e1 && (e1 = e1()), t.memoizedState = t.baseState = e1, e1 = (e1 = t.queue = {
                    pending: null,
                    dispatch: null,
                    lastRenderedReducer: ls,
                    lastRenderedState: e1
                }).dispatch = Ns.bind(null, Ja, e1), [
                    t.memoizedState,
                    e1
                ];
            }
            function ms(e1, t, n, i) {
                return e1 = {
                    tag: e1,
                    create: t,
                    destroy: n,
                    deps: i,
                    next: null
                }, null === (t = Ja.updateQueue) ? (t = {
                    lastEffect: null
                }, Ja.updateQueue = t, t.lastEffect = e1.next = e1) : null === (n = t.lastEffect) ? t.lastEffect = e1.next = e1 : (i = n.next, n.next = e1, e1.next = i, t.lastEffect = e1), e1;
            }
            function gs(e1) {
                return e1 = {
                    current: e1
                }, ss().memoizedState = e1;
            }
            function As() {
                return os().memoizedState;
            }
            function vs(e1, t, n, i) {
                var r = ss();
                Ja.flags |= e1, r.memoizedState = ms(1 | t, n, void 0, void 0 === i ? null : i);
            }
            function Ms(e1, t, n, i) {
                var r = os();
                i = void 0 === i ? null : i;
                var a = void 0;
                if (null !== $a) {
                    var s = $a.memoizedState;
                    if (a = s.destroy, null !== i && rs(i, s.deps)) return void ms(t, n, a, i);
                }
                Ja.flags |= e1, r.memoizedState = ms(1 | t, n, a, i);
            }
            function ys(e1, t) {
                return vs(516, 4, e1, t);
            }
            function xs(e1, t) {
                return Ms(516, 4, e1, t);
            }
            function _s(e1, t) {
                return Ms(4, 2, e1, t);
            }
            function bs(e1, t) {
                return "function" == typeof t ? (e1 = e1(), t(e1), function() {
                    t(null);
                }) : null != t ? (e1 = e1(), t.current = e1, function() {
                    t.current = null;
                }) : void 0;
            }
            function ws(e1, t, n) {
                return n = null != n ? n.concat([
                    e1
                ]) : null, Ms(4, 2, bs.bind(null, t, e1), n);
            }
            function Es() {}
            function Ts(e1, t) {
                var n = os();
                t = void 0 === t ? null : t;
                var i = n.memoizedState;
                return null !== i && null !== t && rs(t, i[1]) ? i[0] : (n.memoizedState = [
                    e1,
                    t
                ], e1);
            }
            function Ss(e1, t) {
                var n = os();
                t = void 0 === t ? null : t;
                var i = n.memoizedState;
                return null !== i && null !== t && rs(t, i[1]) ? i[0] : (e1 = e1(), n.memoizedState = [
                    e1,
                    t
                ], e1);
            }
            function Is(e1, t) {
                var n = Vr();
                Qr(98 > n ? 98 : n, function() {
                    e1(!0);
                }), Qr(97 < n ? 97 : n, function() {
                    var n = qa.transition;
                    qa.transition = 1;
                    try {
                        e1(!1), t();
                    } finally{
                        qa.transition = n;
                    }
                });
            }
            function Ns(e1, t, n) {
                var i = ul(), r = hl(e1), a = {
                    lane: r,
                    action: n,
                    eagerReducer: null,
                    eagerState: null,
                    next: null
                }, s = t.pending;
                if (null === s ? a.next = a : (a.next = s.next, s.next = a), t.pending = a, s = e1.alternate, e1 === Ja || null !== s && s === Ja) ns = ts = !0;
                else {
                    if (0 === e1.lanes && (null === s || 0 === s.lanes) && null !== (s = t.lastRenderedReducer)) try {
                        var o = t.lastRenderedState, l = s(o, n);
                        if (a.eagerReducer = s, a.eagerState = l, ci(l, o)) return;
                    } catch (e1) {}
                    dl(e1, r, i);
                }
            }
            var Ds = {
                readContext: aa,
                useCallback: is,
                useContext: is,
                useEffect: is,
                useImperativeHandle: is,
                useLayoutEffect: is,
                useMemo: is,
                useReducer: is,
                useRef: is,
                useState: is,
                useDebugValue: is,
                useDeferredValue: is,
                useTransition: is,
                useMutableSource: is,
                useOpaqueIdentifier: is,
                unstable_isNewReconciler: !1
            }, Cs = {
                readContext: aa,
                useCallback: function(e1, t) {
                    return ss().memoizedState = [
                        e1,
                        void 0 === t ? null : t
                    ], e1;
                },
                useContext: aa,
                useEffect: ys,
                useImperativeHandle: function(e1, t, n) {
                    return n = null != n ? n.concat([
                        e1
                    ]) : null, vs(4, 2, bs.bind(null, t, e1), n);
                },
                useLayoutEffect: function(e1, t) {
                    return vs(4, 2, e1, t);
                },
                useMemo: function(e1, t) {
                    var n = ss();
                    return t = void 0 === t ? null : t, e1 = e1(), n.memoizedState = [
                        e1,
                        t
                    ], e1;
                },
                useReducer: function(e1, t, n) {
                    var i = ss();
                    return t = void 0 !== n ? n(t) : t, i.memoizedState = i.baseState = t, e1 = (e1 = i.queue = {
                        pending: null,
                        dispatch: null,
                        lastRenderedReducer: e1,
                        lastRenderedState: t
                    }).dispatch = Ns.bind(null, Ja, e1), [
                        i.memoizedState,
                        e1
                    ];
                },
                useRef: gs,
                useState: fs,
                useDebugValue: Es,
                useDeferredValue: function(e1) {
                    var t = fs(e1), n = t[0], i = t[1];
                    return ys(function() {
                        var t = qa.transition;
                        qa.transition = 1;
                        try {
                            i(e1);
                        } finally{
                            qa.transition = t;
                        }
                    }, [
                        e1
                    ]), n;
                },
                useTransition: function() {
                    var e1 = fs(!1), t = e1[0];
                    return gs(e1 = Is.bind(null, e1[1])), [
                        e1,
                        t
                    ];
                },
                useMutableSource: function(e1, t, n) {
                    var i = ss();
                    return i.memoizedState = {
                        refs: {
                            getSnapshot: t,
                            setSnapshot: null
                        },
                        source: e1,
                        subscribe: n
                    }, ds(i, e1, t, n);
                },
                useOpaqueIdentifier: function() {
                    if (Ba) {
                        var e1 = !1, t = function(e1) {
                            return {
                                $$typeof: O,
                                toString: e1,
                                valueOf: e1
                            };
                        }(function() {
                            throw e1 || (e1 = !0, n("r:" + (Zi++).toString(36))), Error(s(355));
                        }), n = fs(t)[1];
                        return !(2 & Ja.mode) && (Ja.flags |= 516, ms(5, function() {
                            n("r:" + (Zi++).toString(36));
                        }, void 0, null)), t;
                    }
                    return fs(t = "r:" + (Zi++).toString(36)), t;
                },
                unstable_isNewReconciler: !1
            }, Ls = {
                readContext: aa,
                useCallback: Ts,
                useContext: aa,
                useEffect: xs,
                useImperativeHandle: ws,
                useLayoutEffect: _s,
                useMemo: Ss,
                useReducer: cs,
                useRef: As,
                useState: function() {
                    return cs(ls);
                },
                useDebugValue: Es,
                useDeferredValue: function(e1) {
                    var t = cs(ls), n = t[0], i = t[1];
                    return xs(function() {
                        var t = qa.transition;
                        qa.transition = 1;
                        try {
                            i(e1);
                        } finally{
                            qa.transition = t;
                        }
                    }, [
                        e1
                    ]), n;
                },
                useTransition: function() {
                    var e1 = cs(ls)[0];
                    return [
                        As().current,
                        e1
                    ];
                },
                useMutableSource: ps,
                useOpaqueIdentifier: function() {
                    return cs(ls)[0];
                },
                unstable_isNewReconciler: !1
            }, Rs = {
                readContext: aa,
                useCallback: Ts,
                useContext: aa,
                useEffect: xs,
                useImperativeHandle: ws,
                useLayoutEffect: _s,
                useMemo: Ss,
                useReducer: us,
                useRef: As,
                useState: function() {
                    return us(ls);
                },
                useDebugValue: Es,
                useDeferredValue: function(e1) {
                    var t = us(ls), n = t[0], i = t[1];
                    return xs(function() {
                        var t = qa.transition;
                        qa.transition = 1;
                        try {
                            i(e1);
                        } finally{
                            qa.transition = t;
                        }
                    }, [
                        e1
                    ]), n;
                },
                useTransition: function() {
                    var e1 = us(ls)[0];
                    return [
                        As().current,
                        e1
                    ];
                },
                useMutableSource: ps,
                useOpaqueIdentifier: function() {
                    return us(ls)[0];
                },
                unstable_isNewReconciler: !1
            }, zs = x.ReactCurrentOwner, Os = !1;
            function Ps(e1, t, n, i) {
                t.child = null === e1 ? Ta(t, null, n, i) : Ea(t, e1.child, n, i);
            }
            function Us(e1, t, n, i, r) {
                n = n.render;
                var a = t.ref;
                return ra(t, r), i = as(e1, t, n, i, a, r), null === e1 || Os ? (t.flags |= 1, Ps(e1, t, i, r), t.child) : (t.updateQueue = e1.updateQueue, t.flags &= -517, e1.lanes &= ~r, no(e1, t, r));
            }
            function ks(e1, t, n, i, r, a) {
                if (null === e1) {
                    var s = n.type;
                    return "function" != typeof s || Vl(s) || void 0 !== s.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e1 = Ql(n.type, null, i, t, t.mode, a)).ref = t.ref, e1.return = t, t.child = e1) : (t.tag = 15, t.type = s, js(e1, t, s, i, r, a));
                }
                return s = e1.child, r & a || (r = s.memoizedProps, !(n = null !== (n = n.compare) ? n : hi)(r, i) || e1.ref !== t.ref) ? (t.flags |= 1, (e1 = Gl(s, i)).ref = t.ref, e1.return = t, t.child = e1) : no(e1, t, a);
            }
            function js(e1, t, n, i, r, a) {
                if (null !== e1 && hi(e1.memoizedProps, i) && e1.ref === t.ref) {
                    if (Os = !1, !(a & r)) return t.lanes = e1.lanes, no(e1, t, a);
                    16384 & e1.flags && (Os = !0);
                }
                return Hs(e1, t, n, i, a);
            }
            function Bs(e1, t, n) {
                var i = t.pendingProps, r = i.children, a = null !== e1 ? e1.memoizedState : null;
                if ("hidden" === i.mode || "unstable-defer-without-hiding" === i.mode) {
                    if (4 & t.mode) {
                        if (!(1073741824 & n)) return e1 = null !== a ? a.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = {
                            baseLanes: e1
                        }, yl(0, e1), null;
                        t.memoizedState = {
                            baseLanes: 0
                        }, yl(0, null !== a ? a.baseLanes : n);
                    } else t.memoizedState = {
                        baseLanes: 0
                    }, yl(0, n);
                } else null !== a ? (i = a.baseLanes | n, t.memoizedState = null) : i = n, yl(0, i);
                return Ps(e1, t, r, n), t.child;
            }
            function Fs(e1, t) {
                var n = t.ref;
                (null === e1 && null !== n || null !== e1 && e1.ref !== n) && (t.flags |= 128);
            }
            function Hs(e1, t, n, i, r) {
                var a = gr(n) ? fr : dr.current;
                return a = mr(t, a), ra(t, r), n = as(e1, t, n, i, a, r), null === e1 || Os ? (t.flags |= 1, Ps(e1, t, n, r), t.child) : (t.updateQueue = e1.updateQueue, t.flags &= -517, e1.lanes &= ~r, no(e1, t, r));
            }
            function Vs(e1, t, n, i, r) {
                if (gr(n)) {
                    var a = !0;
                    yr(t);
                } else a = !1;
                if (ra(t, r), null === t.stateNode) null !== e1 && (e1.alternate = null, t.alternate = null, t.flags |= 2), va(t, n, i), ya(t, n, i, r), i = !0;
                else if (null === e1) {
                    var s = t.stateNode, o = t.memoizedProps;
                    s.props = o;
                    var l = s.context, c = n.contextType;
                    c = "object" == typeof c && null !== c ? aa(c) : mr(t, c = gr(n) ? fr : dr.current);
                    var u = n.getDerivedStateFromProps, h = "function" == typeof u || "function" == typeof s.getSnapshotBeforeUpdate;
                    h || "function" != typeof s.UNSAFE_componentWillReceiveProps && "function" != typeof s.componentWillReceiveProps || (o !== i || l !== c) && Ma(t, s, i, c), sa = !1;
                    var d = t.memoizedState;
                    s.state = d, da(t, i, s, r), l = t.memoizedState, o !== i || d !== l || pr.current || sa ? ("function" == typeof u && (ma(t, n, u, i), l = t.memoizedState), (o = sa || Aa(t, n, o, i, d, l, c)) ? (h || "function" != typeof s.UNSAFE_componentWillMount && "function" != typeof s.componentWillMount || ("function" == typeof s.componentWillMount && s.componentWillMount(), "function" == typeof s.UNSAFE_componentWillMount && s.UNSAFE_componentWillMount()), "function" == typeof s.componentDidMount && (t.flags |= 4)) : ("function" == typeof s.componentDidMount && (t.flags |= 4), t.memoizedProps = i, t.memoizedState = l), s.props = i, s.state = l, s.context = c, i = o) : ("function" == typeof s.componentDidMount && (t.flags |= 4), i = !1);
                } else {
                    s = t.stateNode, la(e1, t), o = t.memoizedProps, c = t.type === t.elementType ? o : qr(t.type, o), s.props = c, h = t.pendingProps, d = s.context, l = "object" == typeof (l = n.contextType) && null !== l ? aa(l) : mr(t, l = gr(n) ? fr : dr.current);
                    var p = n.getDerivedStateFromProps;
                    (u = "function" == typeof p || "function" == typeof s.getSnapshotBeforeUpdate) || "function" != typeof s.UNSAFE_componentWillReceiveProps && "function" != typeof s.componentWillReceiveProps || (o !== h || d !== l) && Ma(t, s, i, l), sa = !1, d = t.memoizedState, s.state = d, da(t, i, s, r);
                    var f = t.memoizedState;
                    o !== h || d !== f || pr.current || sa ? ("function" == typeof p && (ma(t, n, p, i), f = t.memoizedState), (c = sa || Aa(t, n, c, i, d, f, l)) ? (u || "function" != typeof s.UNSAFE_componentWillUpdate && "function" != typeof s.componentWillUpdate || ("function" == typeof s.componentWillUpdate && s.componentWillUpdate(i, f, l), "function" == typeof s.UNSAFE_componentWillUpdate && s.UNSAFE_componentWillUpdate(i, f, l)), "function" == typeof s.componentDidUpdate && (t.flags |= 4), "function" == typeof s.getSnapshotBeforeUpdate && (t.flags |= 256)) : ("function" != typeof s.componentDidUpdate || o === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 4), "function" != typeof s.getSnapshotBeforeUpdate || o === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 256), t.memoizedProps = i, t.memoizedState = f), s.props = i, s.state = f, s.context = l, i = c) : ("function" != typeof s.componentDidUpdate || o === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 4), "function" != typeof s.getSnapshotBeforeUpdate || o === e1.memoizedProps && d === e1.memoizedState || (t.flags |= 256), i = !1);
                }
                return Gs(e1, t, n, i, a, r);
            }
            function Gs(e1, t, n, i, r, a) {
                Fs(e1, t);
                var s = !!(64 & t.flags);
                if (!i && !s) return r && xr(t, n, !1), no(e1, t, a);
                i = t.stateNode, zs.current = t;
                var o = s && "function" != typeof n.getDerivedStateFromError ? null : i.render();
                return t.flags |= 1, null !== e1 && s ? (t.child = Ea(t, e1.child, null, a), t.child = Ea(t, null, o, a)) : Ps(e1, t, o, a), t.memoizedState = i.state, r && xr(t, n, !0), t.child;
            }
            function Qs(e1) {
                var t = e1.stateNode;
                t.pendingContext ? vr(0, t.pendingContext, t.pendingContext !== t.context) : t.context && vr(0, t.context, !1), La(e1, t.containerInfo);
            }
            var Ws, Ys, Xs, Zs, qs = {
                dehydrated: null,
                retryLane: 0
            };
            function Ks(e1, t, n) {
                var i, r = t.pendingProps, a = Pa.current, s = !1;
                return (i = !!(64 & t.flags)) || (i = (null === e1 || null !== e1.memoizedState) && !!(2 & a)), i ? (s = !0, t.flags &= -65) : null !== e1 && null === e1.memoizedState || void 0 === r.fallback || !0 === r.unstable_avoidThisFallback || (a |= 1), ur(Pa, 1 & a), null === e1 ? (void 0 !== r.fallback && Va(t), e1 = r.children, a = r.fallback, s ? (e1 = Js(t, e1, a, n), t.child.memoizedState = {
                    baseLanes: n
                }, t.memoizedState = qs, e1) : "number" == typeof r.unstable_expectedLoadTime ? (e1 = Js(t, e1, a, n), t.child.memoizedState = {
                    baseLanes: n
                }, t.memoizedState = qs, t.lanes = 33554432, e1) : ((n = Yl({
                    mode: "visible",
                    children: e1
                }, t.mode, n, null)).return = t, t.child = n)) : (e1.memoizedState, s ? (r = function(e1, t, n, i, r) {
                    var a = t.mode, s = e1.child;
                    e1 = s.sibling;
                    var o = {
                        mode: "hidden",
                        children: n
                    };
                    return 2 & a || t.child === s ? n = Gl(s, o) : ((n = t.child).childLanes = 0, n.pendingProps = o, null !== (s = n.lastEffect) ? (t.firstEffect = n.firstEffect, t.lastEffect = s, s.nextEffect = null) : t.firstEffect = t.lastEffect = null), null !== e1 ? i = Gl(e1, i) : (i = Wl(i, a, r, null)).flags |= 2, i.return = t, n.return = t, n.sibling = i, t.child = n, i;
                }(e1, t, r.children, r.fallback, n), s = t.child, a = e1.child.memoizedState, s.memoizedState = null === a ? {
                    baseLanes: n
                } : {
                    baseLanes: a.baseLanes | n
                }, s.childLanes = e1.childLanes & ~n, t.memoizedState = qs, r) : (n = function(e1, t, n, i) {
                    var r = e1.child;
                    return e1 = r.sibling, n = Gl(r, {
                        mode: "visible",
                        children: n
                    }), !(2 & t.mode) && (n.lanes = i), n.return = t, n.sibling = null, null !== e1 && (e1.nextEffect = null, e1.flags = 8, t.firstEffect = t.lastEffect = e1), t.child = n;
                }(e1, t, r.children, n), t.memoizedState = null, n));
            }
            function Js(e1, t, n, i) {
                var r = e1.mode, a = e1.child;
                return t = {
                    mode: "hidden",
                    children: t
                }, 2 & r || null === a ? a = Yl(t, r, 0, null) : (a.childLanes = 0, a.pendingProps = t), n = Wl(n, r, i, null), a.return = e1, n.return = e1, a.sibling = n, e1.child = a, n;
            }
            function $s(e1, t) {
                e1.lanes |= t;
                var n = e1.alternate;
                null !== n && (n.lanes |= t), ia(e1.return, t);
            }
            function eo(e1, t, n, i, r, a) {
                var s = e1.memoizedState;
                null === s ? e1.memoizedState = {
                    isBackwards: t,
                    rendering: null,
                    renderingStartTime: 0,
                    last: i,
                    tail: n,
                    tailMode: r,
                    lastEffect: a
                } : (s.isBackwards = t, s.rendering = null, s.renderingStartTime = 0, s.last = i, s.tail = n, s.tailMode = r, s.lastEffect = a);
            }
            function to(e1, t, n) {
                var i = t.pendingProps, r = i.revealOrder, a = i.tail;
                if (Ps(e1, t, i.children, n), 2 & (i = Pa.current)) i = 1 & i | 2, t.flags |= 64;
                else {
                    if (null !== e1 && 64 & e1.flags) e: for(e1 = t.child; null !== e1;){
                        if (13 === e1.tag) null !== e1.memoizedState && $s(e1, n);
                        else if (19 === e1.tag) $s(e1, n);
                        else if (null !== e1.child) {
                            e1.child.return = e1, e1 = e1.child;
                            continue;
                        }
                        if (e1 === t) break e;
                        for(; null === e1.sibling;){
                            if (null === e1.return || e1.return === t) break e;
                            e1 = e1.return;
                        }
                        e1.sibling.return = e1.return, e1 = e1.sibling;
                    }
                    i &= 1;
                }
                if (ur(Pa, i), 2 & t.mode) switch(r){
                    case "forwards":
                        for(n = t.child, r = null; null !== n;)null !== (e1 = n.alternate) && null === Ua(e1) && (r = n), n = n.sibling;
                        null === (n = r) ? (r = t.child, t.child = null) : (r = n.sibling, n.sibling = null), eo(t, !1, r, n, a, t.lastEffect);
                        break;
                    case "backwards":
                        for(n = null, r = t.child, t.child = null; null !== r;){
                            if (null !== (e1 = r.alternate) && null === Ua(e1)) {
                                t.child = r;
                                break;
                            }
                            e1 = r.sibling, r.sibling = n, n = r, r = e1;
                        }
                        eo(t, !0, n, null, a, t.lastEffect);
                        break;
                    case "together":
                        eo(t, !1, null, null, void 0, t.lastEffect);
                        break;
                    default:
                        t.memoizedState = null;
                }
                else t.memoizedState = null;
                return t.child;
            }
            function no(e1, t, n) {
                if (null !== e1 && (t.dependencies = e1.dependencies), jo |= t.lanes, n & t.childLanes) {
                    if (null !== e1 && t.child !== e1.child) throw Error(s(153));
                    if (null !== t.child) {
                        for(n = Gl(e1 = t.child, e1.pendingProps), t.child = n, n.return = t; null !== e1.sibling;)e1 = e1.sibling, (n = n.sibling = Gl(e1, e1.pendingProps)).return = t;
                        n.sibling = null;
                    }
                    return t.child;
                }
                return null;
            }
            function io(e1, t) {
                if (!Ba) switch(e1.tailMode){
                    case "hidden":
                        t = e1.tail;
                        for(var n = null; null !== t;)null !== t.alternate && (n = t), t = t.sibling;
                        null === n ? e1.tail = null : n.sibling = null;
                        break;
                    case "collapsed":
                        n = e1.tail;
                        for(var i = null; null !== n;)null !== n.alternate && (i = n), n = n.sibling;
                        null === i ? t || null === e1.tail ? e1.tail = null : e1.tail.sibling = null : i.sibling = null;
                }
            }
            function ro(e1, t, n) {
                var i = t.pendingProps;
                switch(t.tag){
                    case 2:
                    case 16:
                    case 15:
                    case 0:
                    case 11:
                    case 7:
                    case 8:
                    case 12:
                    case 9:
                    case 14:
                        return null;
                    case 1:
                    case 17:
                        return gr(t.type) && Ar(), null;
                    case 3:
                        return Ra(), cr(pr), cr(dr), Xa(), (i = t.stateNode).pendingContext && (i.context = i.pendingContext, i.pendingContext = null), null !== e1 && null !== e1.child || (Qa(t) ? t.flags |= 4 : i.hydrate || (t.flags |= 256)), Ys(t), null;
                    case 5:
                        Oa(t);
                        var a = Ca(Da.current);
                        if (n = t.type, null !== e1 && null != t.stateNode) Xs(e1, t, n, i, a), e1.ref !== t.ref && (t.flags |= 128);
                        else {
                            if (!i) {
                                if (null === t.stateNode) throw Error(s(166));
                                return null;
                            }
                            if (e1 = Ca(Ia.current), Qa(t)) {
                                i = t.stateNode, n = t.type;
                                var o = t.memoizedProps;
                                switch(i[Ki] = t, i[Ji] = o, n){
                                    case "dialog":
                                        Ni("cancel", i), Ni("close", i);
                                        break;
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Ni("load", i);
                                        break;
                                    case "video":
                                    case "audio":
                                        for(e1 = 0; e1 < Ei.length; e1++)Ni(Ei[e1], i);
                                        break;
                                    case "source":
                                        Ni("error", i);
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Ni("error", i), Ni("load", i);
                                        break;
                                    case "details":
                                        Ni("toggle", i);
                                        break;
                                    case "input":
                                        ee(i, o), Ni("invalid", i);
                                        break;
                                    case "select":
                                        i._wrapperState = {
                                            wasMultiple: !!o.multiple
                                        }, Ni("invalid", i);
                                        break;
                                    case "textarea":
                                        le(i, o), Ni("invalid", i);
                                }
                                for(var c in be(n, o), e1 = null, o)o.hasOwnProperty(c) && (a = o[c], "children" === c ? "string" == typeof a ? i.textContent !== a && (e1 = [
                                    "children",
                                    a
                                ]) : "number" == typeof a && i.textContent !== "" + a && (e1 = [
                                    "children",
                                    "" + a
                                ]) : l.hasOwnProperty(c) && null != a && "onScroll" === c && Ni("scroll", i));
                                switch(n){
                                    case "input":
                                        q(i), ie(i, o, !0);
                                        break;
                                    case "textarea":
                                        q(i), ue(i);
                                        break;
                                    case "select":
                                    case "option":
                                        break;
                                    default:
                                        "function" == typeof o.onClick && (i.onclick = ji);
                                }
                                i = e1, t.updateQueue = i, null !== i && (t.flags |= 4);
                            } else {
                                switch(c = 9 === a.nodeType ? a : a.ownerDocument, e1 === he.html && (e1 = de(n)), e1 === he.html ? "script" === n ? ((e1 = c.createElement("div")).innerHTML = "<script></script>", e1 = e1.removeChild(e1.firstChild)) : "string" == typeof i.is ? e1 = c.createElement(n, {
                                    is: i.is
                                }) : (e1 = c.createElement(n), "select" === n && (c = e1, i.multiple ? c.multiple = !0 : i.size && (c.size = i.size))) : e1 = c.createElementNS(e1, n), e1[Ki] = t, e1[Ji] = i, Ws(e1, t, !1, !1), t.stateNode = e1, c = we(n, i), n){
                                    case "dialog":
                                        Ni("cancel", e1), Ni("close", e1), a = i;
                                        break;
                                    case "iframe":
                                    case "object":
                                    case "embed":
                                        Ni("load", e1), a = i;
                                        break;
                                    case "video":
                                    case "audio":
                                        for(a = 0; a < Ei.length; a++)Ni(Ei[a], e1);
                                        a = i;
                                        break;
                                    case "source":
                                        Ni("error", e1), a = i;
                                        break;
                                    case "img":
                                    case "image":
                                    case "link":
                                        Ni("error", e1), Ni("load", e1), a = i;
                                        break;
                                    case "details":
                                        Ni("toggle", e1), a = i;
                                        break;
                                    case "input":
                                        ee(e1, i), a = $(e1, i), Ni("invalid", e1);
                                        break;
                                    case "option":
                                        a = ae(e1, i);
                                        break;
                                    case "select":
                                        e1._wrapperState = {
                                            wasMultiple: !!i.multiple
                                        }, a = r({}, i, {
                                            value: void 0
                                        }), Ni("invalid", e1);
                                        break;
                                    case "textarea":
                                        le(e1, i), a = oe(e1, i), Ni("invalid", e1);
                                        break;
                                    default:
                                        a = i;
                                }
                                be(n, a);
                                var u = a;
                                for(o in u)if (u.hasOwnProperty(o)) {
                                    var h = u[o];
                                    "style" === o ? xe(e1, h) : "dangerouslySetInnerHTML" === o ? null != (h = h ? h.__html : void 0) && ge(e1, h) : "children" === o ? "string" == typeof h ? ("textarea" !== n || "" !== h) && Ae(e1, h) : "number" == typeof h && Ae(e1, "" + h) : "suppressContentEditableWarning" !== o && "suppressHydrationWarning" !== o && "autoFocus" !== o && (l.hasOwnProperty(o) ? null != h && "onScroll" === o && Ni("scroll", e1) : null != h && y(e1, o, h, c));
                                }
                                switch(n){
                                    case "input":
                                        q(e1), ie(e1, i, !1);
                                        break;
                                    case "textarea":
                                        q(e1), ue(e1);
                                        break;
                                    case "option":
                                        null != i.value && e1.setAttribute("value", "" + X(i.value));
                                        break;
                                    case "select":
                                        e1.multiple = !!i.multiple, null != (o = i.value) ? se(e1, !!i.multiple, o, !1) : null != i.defaultValue && se(e1, !!i.multiple, i.defaultValue, !0);
                                        break;
                                    default:
                                        "function" == typeof a.onClick && (e1.onclick = ji);
                                }
                                Hi(n, i) && (t.flags |= 4);
                            }
                            null !== t.ref && (t.flags |= 128);
                        }
                        return null;
                    case 6:
                        if (e1 && null != t.stateNode) Zs(e1, t, e1.memoizedProps, i);
                        else {
                            if ("string" != typeof i && null === t.stateNode) throw Error(s(166));
                            n = Ca(Da.current), Ca(Ia.current), Qa(t) ? (i = t.stateNode, n = t.memoizedProps, i[Ki] = t, i.nodeValue !== n && (t.flags |= 4)) : ((i = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(i))[Ki] = t, t.stateNode = i);
                        }
                        return null;
                    case 13:
                        return cr(Pa), i = t.memoizedState, 64 & t.flags ? (t.lanes = n, t) : (i = null !== i, n = !1, null === e1 ? void 0 !== t.memoizedProps.fallback && Qa(t) : n = null !== e1.memoizedState, i && !n && 2 & t.mode && (null === e1 && !0 !== t.memoizedProps.unstable_avoidThisFallback || 1 & Pa.current ? 0 === Po && (Po = 3) : (0 !== Po && 3 !== Po || (Po = 4), null === Co || !(134217727 & jo) && !(134217727 & Bo) || gl(Co, Ro))), (i || n) && (t.flags |= 4), null);
                    case 4:
                        return Ra(), Ys(t), null === e1 && Ci(t.stateNode.containerInfo), null;
                    case 10:
                        return na(t), null;
                    case 19:
                        if (cr(Pa), null === (i = t.memoizedState)) return null;
                        if (o = !!(64 & t.flags), null === (c = i.rendering)) {
                            if (o) io(i, !1);
                            else {
                                if (0 !== Po || null !== e1 && 64 & e1.flags) for(e1 = t.child; null !== e1;){
                                    if (null !== (c = Ua(e1))) {
                                        for(t.flags |= 64, io(i, !1), null !== (o = c.updateQueue) && (t.updateQueue = o, t.flags |= 4), null === i.lastEffect && (t.firstEffect = null), t.lastEffect = i.lastEffect, i = n, n = t.child; null !== n;)e1 = i, (o = n).flags &= 2, o.nextEffect = null, o.firstEffect = null, o.lastEffect = null, null === (c = o.alternate) ? (o.childLanes = 0, o.lanes = e1, o.child = null, o.memoizedProps = null, o.memoizedState = null, o.updateQueue = null, o.dependencies = null, o.stateNode = null) : (o.childLanes = c.childLanes, o.lanes = c.lanes, o.child = c.child, o.memoizedProps = c.memoizedProps, o.memoizedState = c.memoizedState, o.updateQueue = c.updateQueue, o.type = c.type, e1 = c.dependencies, o.dependencies = null === e1 ? null : {
                                            lanes: e1.lanes,
                                            firstContext: e1.firstContext
                                        }), n = n.sibling;
                                        return ur(Pa, 1 & Pa.current | 2), t.child;
                                    }
                                    e1 = e1.sibling;
                                }
                                null !== i.tail && Hr() > Go && (t.flags |= 64, o = !0, io(i, !1), t.lanes = 33554432);
                            }
                        } else {
                            if (!o) {
                                if (null !== (e1 = Ua(c))) {
                                    if (t.flags |= 64, o = !0, null !== (n = e1.updateQueue) && (t.updateQueue = n, t.flags |= 4), io(i, !0), null === i.tail && "hidden" === i.tailMode && !c.alternate && !Ba) return null !== (t = t.lastEffect = i.lastEffect) && (t.nextEffect = null), null;
                                } else 2 * Hr() - i.renderingStartTime > Go && 1073741824 !== n && (t.flags |= 64, o = !0, io(i, !1), t.lanes = 33554432);
                            }
                            i.isBackwards ? (c.sibling = t.child, t.child = c) : (null !== (n = i.last) ? n.sibling = c : t.child = c, i.last = c);
                        }
                        return null !== i.tail ? (n = i.tail, i.rendering = n, i.tail = n.sibling, i.lastEffect = t.lastEffect, i.renderingStartTime = Hr(), n.sibling = null, t = Pa.current, ur(Pa, o ? 1 & t | 2 : 1 & t), n) : null;
                    case 23:
                    case 24:
                        return xl(), null !== e1 && null !== e1.memoizedState != (null !== t.memoizedState) && "unstable-defer-without-hiding" !== i.mode && (t.flags |= 4), null;
                }
                throw Error(s(156, t.tag));
            }
            function ao(e1) {
                switch(e1.tag){
                    case 1:
                        gr(e1.type) && Ar();
                        var t = e1.flags;
                        return 4096 & t ? (e1.flags = -4097 & t | 64, e1) : null;
                    case 3:
                        if (Ra(), cr(pr), cr(dr), Xa(), 64 & (t = e1.flags)) throw Error(s(285));
                        return e1.flags = -4097 & t | 64, e1;
                    case 5:
                        return Oa(e1), null;
                    case 13:
                        return cr(Pa), 4096 & (t = e1.flags) ? (e1.flags = -4097 & t | 64, e1) : null;
                    case 19:
                        return cr(Pa), null;
                    case 4:
                        return Ra(), null;
                    case 10:
                        return na(e1), null;
                    case 23:
                    case 24:
                        return xl(), null;
                    default:
                        return null;
                }
            }
            function so(e1, t) {
                try {
                    var n = "", i = t;
                    do n += W(i), i = i.return;
                    while (i);
                    var r = n;
                } catch (e1) {
                    r = "\nError generating stack: " + e1.message + "\n" + e1.stack;
                }
                return {
                    value: e1,
                    source: t,
                    stack: r
                };
            }
            function oo(e1, t) {
                try {
                    console.error(t.value);
                } catch (e1) {
                    setTimeout(function() {
                        throw e1;
                    });
                }
            }
            Ws = function(e1, t) {
                for(var n = t.child; null !== n;){
                    if (5 === n.tag || 6 === n.tag) e1.appendChild(n.stateNode);
                    else if (4 !== n.tag && null !== n.child) {
                        n.child.return = n, n = n.child;
                        continue;
                    }
                    if (n === t) break;
                    for(; null === n.sibling;){
                        if (null === n.return || n.return === t) return;
                        n = n.return;
                    }
                    n.sibling.return = n.return, n = n.sibling;
                }
            }, Ys = function() {}, Xs = function(e1, t, n, i) {
                var a = e1.memoizedProps;
                if (a !== i) {
                    e1 = t.stateNode, Ca(Ia.current);
                    var s, o = null;
                    switch(n){
                        case "input":
                            a = $(e1, a), i = $(e1, i), o = [];
                            break;
                        case "option":
                            a = ae(e1, a), i = ae(e1, i), o = [];
                            break;
                        case "select":
                            a = r({}, a, {
                                value: void 0
                            }), i = r({}, i, {
                                value: void 0
                            }), o = [];
                            break;
                        case "textarea":
                            a = oe(e1, a), i = oe(e1, i), o = [];
                            break;
                        default:
                            "function" != typeof a.onClick && "function" == typeof i.onClick && (e1.onclick = ji);
                    }
                    for(h in be(n, i), n = null, a)if (!i.hasOwnProperty(h) && a.hasOwnProperty(h) && null != a[h]) {
                        if ("style" === h) {
                            var c = a[h];
                            for(s in c)c.hasOwnProperty(s) && (n || (n = {}), n[s] = "");
                        } else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (l.hasOwnProperty(h) ? o || (o = []) : (o = o || []).push(h, null));
                    }
                    for(h in i){
                        var u = i[h];
                        if (c = null != a ? a[h] : void 0, i.hasOwnProperty(h) && u !== c && (null != u || null != c)) {
                            if ("style" === h) {
                                if (c) {
                                    for(s in c)!c.hasOwnProperty(s) || u && u.hasOwnProperty(s) || (n || (n = {}), n[s] = "");
                                    for(s in u)u.hasOwnProperty(s) && c[s] !== u[s] && (n || (n = {}), n[s] = u[s]);
                                } else n || (o || (o = []), o.push(h, n)), n = u;
                            } else "dangerouslySetInnerHTML" === h ? (u = u ? u.__html : void 0, c = c ? c.__html : void 0, null != u && c !== u && (o = o || []).push(h, u)) : "children" === h ? "string" != typeof u && "number" != typeof u || (o = o || []).push(h, "" + u) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (l.hasOwnProperty(h) ? (null != u && "onScroll" === h && Ni("scroll", e1), o || c === u || (o = [])) : "object" == typeof u && null !== u && u.$$typeof === O ? u.toString() : (o = o || []).push(h, u));
                        }
                    }
                    n && (o = o || []).push("style", n);
                    var h = o;
                    (t.updateQueue = h) && (t.flags |= 4);
                }
            }, Zs = function(e1, t, n, i) {
                n !== i && (t.flags |= 4);
            };
            var lo = "function" == typeof WeakMap ? WeakMap : Map;
            function co(e1, t, n) {
                (n = ca(-1, n)).tag = 3, n.payload = {
                    element: null
                };
                var i = t.value;
                return n.callback = function() {
                    Xo || (Xo = !0, Zo = i), oo(0, t);
                }, n;
            }
            function uo(e1, t, n) {
                (n = ca(-1, n)).tag = 3;
                var i = e1.type.getDerivedStateFromError;
                if ("function" == typeof i) {
                    var r = t.value;
                    n.payload = function() {
                        return oo(0, t), i(r);
                    };
                }
                var a = e1.stateNode;
                return null !== a && "function" == typeof a.componentDidCatch && (n.callback = function() {
                    "function" != typeof i && (null === qo ? qo = new Set([
                        this
                    ]) : qo.add(this), oo(0, t));
                    var e1 = t.stack;
                    this.componentDidCatch(t.value, {
                        componentStack: null !== e1 ? e1 : ""
                    });
                }), n;
            }
            var ho = "function" == typeof WeakSet ? WeakSet : Set;
            function po(e1) {
                var t = e1.ref;
                if (null !== t) {
                    if ("function" == typeof t) try {
                        t(null);
                    } catch (t) {
                        kl(e1, t);
                    }
                    else t.current = null;
                }
            }
            function fo(e1, t) {
                switch(t.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                    case 5:
                    case 6:
                    case 4:
                    case 17:
                        return;
                    case 1:
                        if (256 & t.flags && null !== e1) {
                            var n = e1.memoizedProps, i = e1.memoizedState;
                            t = (e1 = t.stateNode).getSnapshotBeforeUpdate(t.elementType === t.type ? n : qr(t.type, n), i), e1.__reactInternalSnapshotBeforeUpdate = t;
                        }
                        return;
                    case 3:
                        return void (256 & t.flags && Wi(t.stateNode.containerInfo));
                }
                throw Error(s(163));
            }
            function mo(e1, t, n) {
                switch(n.tag){
                    case 0:
                    case 11:
                    case 15:
                    case 22:
                        if (null !== (t = null !== (t = n.updateQueue) ? t.lastEffect : null)) {
                            e1 = t = t.next;
                            do {
                                if (!(3 & ~e1.tag)) {
                                    var i = e1.create;
                                    e1.destroy = i();
                                }
                                e1 = e1.next;
                            }while (e1 !== t);
                        }
                        if (null !== (t = null !== (t = n.updateQueue) ? t.lastEffect : null)) {
                            e1 = t = t.next;
                            do {
                                var r = e1;
                                i = r.next, 4 & (r = r.tag) && 1 & r && (Ol(n, e1), zl(n, e1)), e1 = i;
                            }while (e1 !== t);
                        }
                        return;
                    case 1:
                        return e1 = n.stateNode, 4 & n.flags && (null === t ? e1.componentDidMount() : (i = n.elementType === n.type ? t.memoizedProps : qr(n.type, t.memoizedProps), e1.componentDidUpdate(i, t.memoizedState, e1.__reactInternalSnapshotBeforeUpdate))), void (null !== (t = n.updateQueue) && pa(n, t, e1));
                    case 3:
                        if (null !== (t = n.updateQueue)) {
                            if (e1 = null, null !== n.child) switch(n.child.tag){
                                case 5:
                                case 1:
                                    e1 = n.child.stateNode;
                            }
                            pa(n, t, e1);
                        }
                        return;
                    case 5:
                        return e1 = n.stateNode, void (null === t && 4 & n.flags && Hi(n.type, n.memoizedProps) && e1.focus());
                    case 6:
                    case 4:
                    case 12:
                    case 19:
                    case 17:
                    case 20:
                    case 21:
                    case 23:
                    case 24:
                        return;
                    case 13:
                        return void (null === n.memoizedState && (n = n.alternate, null !== n && (n = n.memoizedState, null !== n && (n = n.dehydrated, null !== n && xt(n)))));
                }
                throw Error(s(163));
            }
            function go(e1, t) {
                for(var n = e1;;){
                    if (5 === n.tag) {
                        var i = n.stateNode;
                        if (t) "function" == typeof (i = i.style).setProperty ? i.setProperty("display", "none", "important") : i.display = "none";
                        else {
                            i = n.stateNode;
                            var r = n.memoizedProps.style;
                            r = null != r && r.hasOwnProperty("display") ? r.display : null, i.style.display = ye("display", r);
                        }
                    } else if (6 === n.tag) n.stateNode.nodeValue = t ? "" : n.memoizedProps;
                    else if ((23 !== n.tag && 24 !== n.tag || null === n.memoizedState || n === e1) && null !== n.child) {
                        n.child.return = n, n = n.child;
                        continue;
                    }
                    if (n === e1) break;
                    for(; null === n.sibling;){
                        if (null === n.return || n.return === e1) return;
                        n = n.return;
                    }
                    n.sibling.return = n.return, n = n.sibling;
                }
            }
            function Ao(e1, t) {
                if (br && "function" == typeof br.onCommitFiberUnmount) try {
                    br.onCommitFiberUnmount(_r, t);
                } catch (e1) {}
                switch(t.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        if (null !== (e1 = t.updateQueue) && null !== (e1 = e1.lastEffect)) {
                            var n = e1 = e1.next;
                            do {
                                var i = n, r = i.destroy;
                                if (i = i.tag, void 0 !== r) {
                                    if (4 & i) Ol(t, n);
                                    else {
                                        i = t;
                                        try {
                                            r();
                                        } catch (e1) {
                                            kl(i, e1);
                                        }
                                    }
                                }
                                n = n.next;
                            }while (n !== e1);
                        }
                        break;
                    case 1:
                        if (po(t), "function" == typeof (e1 = t.stateNode).componentWillUnmount) try {
                            e1.props = t.memoizedProps, e1.state = t.memoizedState, e1.componentWillUnmount();
                        } catch (e1) {
                            kl(t, e1);
                        }
                        break;
                    case 5:
                        po(t);
                        break;
                    case 4:
                        bo(e1, t);
                }
            }
            function vo(e1) {
                e1.alternate = null, e1.child = null, e1.dependencies = null, e1.firstEffect = null, e1.lastEffect = null, e1.memoizedProps = null, e1.memoizedState = null, e1.pendingProps = null, e1.return = null, e1.updateQueue = null;
            }
            function Mo(e1) {
                return 5 === e1.tag || 3 === e1.tag || 4 === e1.tag;
            }
            function yo(e1) {
                e: {
                    for(var t = e1.return; null !== t;){
                        if (Mo(t)) break e;
                        t = t.return;
                    }
                    throw Error(s(160));
                }
                var n = t;
                switch(t = n.stateNode, n.tag){
                    case 5:
                        var i = !1;
                        break;
                    case 3:
                    case 4:
                        t = t.containerInfo, i = !0;
                        break;
                    default:
                        throw Error(s(161));
                }
                16 & n.flags && (Ae(t, ""), n.flags &= -17);
                e: t: for(n = e1;;){
                    for(; null === n.sibling;){
                        if (null === n.return || Mo(n.return)) {
                            n = null;
                            break e;
                        }
                        n = n.return;
                    }
                    for(n.sibling.return = n.return, n = n.sibling; 5 !== n.tag && 6 !== n.tag && 18 !== n.tag;){
                        if (2 & n.flags) continue t;
                        if (null === n.child || 4 === n.tag) continue t;
                        n.child.return = n, n = n.child;
                    }
                    if (!(2 & n.flags)) {
                        n = n.stateNode;
                        break e;
                    }
                }
                i ? xo(e1, n, t) : _o(e1, n, t);
            }
            function xo(e1, t, n) {
                var i = e1.tag, r = 5 === i || 6 === i;
                if (r) e1 = r ? e1.stateNode : e1.stateNode.instance, t ? 8 === n.nodeType ? n.parentNode.insertBefore(e1, t) : n.insertBefore(e1, t) : (8 === n.nodeType ? (t = n.parentNode).insertBefore(e1, n) : (t = n).appendChild(e1), null != (n = n._reactRootContainer) || null !== t.onclick || (t.onclick = ji));
                else if (4 !== i && null !== (e1 = e1.child)) for(xo(e1, t, n), e1 = e1.sibling; null !== e1;)xo(e1, t, n), e1 = e1.sibling;
            }
            function _o(e1, t, n) {
                var i = e1.tag, r = 5 === i || 6 === i;
                if (r) e1 = r ? e1.stateNode : e1.stateNode.instance, t ? n.insertBefore(e1, t) : n.appendChild(e1);
                else if (4 !== i && null !== (e1 = e1.child)) for(_o(e1, t, n), e1 = e1.sibling; null !== e1;)_o(e1, t, n), e1 = e1.sibling;
            }
            function bo(e1, t) {
                for(var n, i, r = t, a = !1;;){
                    if (!a) {
                        a = r.return;
                        e: for(;;){
                            if (null === a) throw Error(s(160));
                            switch(n = a.stateNode, a.tag){
                                case 5:
                                    i = !1;
                                    break e;
                                case 3:
                                case 4:
                                    n = n.containerInfo, i = !0;
                                    break e;
                            }
                            a = a.return;
                        }
                        a = !0;
                    }
                    if (5 === r.tag || 6 === r.tag) {
                        e: for(var o = e1, l = r, c = l;;)if (Ao(o, c), null !== c.child && 4 !== c.tag) c.child.return = c, c = c.child;
                        else {
                            if (c === l) break e;
                            for(; null === c.sibling;){
                                if (null === c.return || c.return === l) break e;
                                c = c.return;
                            }
                            c.sibling.return = c.return, c = c.sibling;
                        }
                        i ? (o = n, l = r.stateNode, 8 === o.nodeType ? o.parentNode.removeChild(l) : o.removeChild(l)) : n.removeChild(r.stateNode);
                    } else if (4 === r.tag) {
                        if (null !== r.child) {
                            n = r.stateNode.containerInfo, i = !0, r.child.return = r, r = r.child;
                            continue;
                        }
                    } else if (Ao(e1, r), null !== r.child) {
                        r.child.return = r, r = r.child;
                        continue;
                    }
                    if (r === t) break;
                    for(; null === r.sibling;){
                        if (null === r.return || r.return === t) return;
                        4 === (r = r.return).tag && (a = !1);
                    }
                    r.sibling.return = r.return, r = r.sibling;
                }
            }
            function wo(e1, t) {
                switch(t.tag){
                    case 0:
                    case 11:
                    case 14:
                    case 15:
                    case 22:
                        var n = t.updateQueue;
                        if (null !== (n = null !== n ? n.lastEffect : null)) {
                            var i = n = n.next;
                            do !(3 & ~i.tag) && (e1 = i.destroy, i.destroy = void 0, void 0 !== e1 && e1()), i = i.next;
                            while (i !== n);
                        }
                        return;
                    case 1:
                    case 12:
                    case 17:
                        return;
                    case 5:
                        if (null != (n = t.stateNode)) {
                            i = t.memoizedProps;
                            var r = null !== e1 ? e1.memoizedProps : i;
                            e1 = t.type;
                            var a = t.updateQueue;
                            if (t.updateQueue = null, null !== a) {
                                for(n[Ji] = i, "input" === e1 && "radio" === i.type && null != i.name && te(n, i), we(e1, r), t = we(e1, i), r = 0; r < a.length; r += 2){
                                    var o = a[r], l = a[r + 1];
                                    "style" === o ? xe(n, l) : "dangerouslySetInnerHTML" === o ? ge(n, l) : "children" === o ? Ae(n, l) : y(n, o, l, t);
                                }
                                switch(e1){
                                    case "input":
                                        ne(n, i);
                                        break;
                                    case "textarea":
                                        ce(n, i);
                                        break;
                                    case "select":
                                        e1 = n._wrapperState.wasMultiple, n._wrapperState.wasMultiple = !!i.multiple, null != (a = i.value) ? se(n, !!i.multiple, a, !1) : e1 !== !!i.multiple && (null != i.defaultValue ? se(n, !!i.multiple, i.defaultValue, !0) : se(n, !!i.multiple, i.multiple ? [] : "", !1));
                                }
                            }
                        }
                        return;
                    case 6:
                        if (null === t.stateNode) throw Error(s(162));
                        return void (t.stateNode.nodeValue = t.memoizedProps);
                    case 3:
                        return void ((n = t.stateNode).hydrate && (n.hydrate = !1, xt(n.containerInfo)));
                    case 13:
                        return null !== t.memoizedState && (Vo = Hr(), go(t.child, !0)), void Eo(t);
                    case 19:
                        return void Eo(t);
                    case 23:
                    case 24:
                        return void go(t, null !== t.memoizedState);
                }
                throw Error(s(163));
            }
            function Eo(e1) {
                var t = e1.updateQueue;
                if (null !== t) {
                    e1.updateQueue = null;
                    var n = e1.stateNode;
                    null === n && (n = e1.stateNode = new ho), t.forEach(function(t) {
                        var i = Bl.bind(null, e1, t);
                        n.has(t) || (n.add(t), t.then(i, i));
                    });
                }
            }
            function To(e1, t) {
                return null !== e1 && (null === (e1 = e1.memoizedState) || null !== e1.dehydrated) && null !== (t = t.memoizedState) && null === t.dehydrated;
            }
            var So = Math.ceil, Io = x.ReactCurrentDispatcher, No = x.ReactCurrentOwner, Do = 0, Co = null, Lo = null, Ro = 0, zo = 0, Oo = lr(0), Po = 0, Uo = null, ko = 0, jo = 0, Bo = 0, Fo = 0, Ho = null, Vo = 0, Go = 1 / 0;
            function Qo() {
                Go = Hr() + 500;
            }
            var Wo, Yo = null, Xo = !1, Zo = null, qo = null, Ko = !1, Jo = null, $o = 90, el = [], tl = [], nl = null, il = 0, rl = null, al = -1, sl = 0, ol = 0, ll = null, cl = !1;
            function ul() {
                return 48 & Do ? Hr() : -1 !== al ? al : al = Hr();
            }
            function hl(e1) {
                if (!(2 & (e1 = e1.mode))) return 1;
                if (!(4 & e1)) return 99 === Vr() ? 1 : 2;
                if (0 === sl && (sl = ko), 0 !== Zr.transition) {
                    0 !== ol && (ol = null !== Ho ? Ho.pendingLanes : 0), e1 = sl;
                    var t = 4186112 & ~ol;
                    return 0 == (t &= -t) && 0 == (t = (e1 = 4186112 & ~e1) & -e1) && (t = 8192), t;
                }
                return e1 = Vr(), e1 = jt(4 & Do && 98 === e1 ? 12 : e1 = function(e1) {
                    switch(e1){
                        case 99:
                            return 15;
                        case 98:
                            return 10;
                        case 97:
                        case 96:
                            return 8;
                        case 95:
                            return 2;
                        default:
                            return 0;
                    }
                }(e1), sl);
            }
            function dl(e1, t, n) {
                if (50 < il) throw il = 0, rl = null, Error(s(185));
                if (null === (e1 = pl(e1, t))) return null;
                Ht(e1, t, n), e1 === Co && (Bo |= t, 4 === Po && gl(e1, Ro));
                var i = Vr();
                1 === t ? 8 & Do && !(48 & Do) ? Al(e1) : (fl(e1, n), 0 === Do && (Qo(), Yr())) : (!(4 & Do) || 98 !== i && 99 !== i || (null === nl ? nl = new Set([
                    e1
                ]) : nl.add(e1)), fl(e1, n)), Ho = e1;
            }
            function pl(e1, t) {
                e1.lanes |= t;
                var n = e1.alternate;
                for(null !== n && (n.lanes |= t), n = e1, e1 = e1.return; null !== e1;)e1.childLanes |= t, null !== (n = e1.alternate) && (n.childLanes |= t), n = e1, e1 = e1.return;
                return 3 === n.tag ? n.stateNode : null;
            }
            function fl(e1, t) {
                for(var n = e1.callbackNode, i = e1.suspendedLanes, r = e1.pingedLanes, a = e1.expirationTimes, o = e1.pendingLanes; 0 < o;){
                    var l = 31 - Vt(o), c = 1 << l, u = a[l];
                    if (-1 === u) {
                        if (!(c & i) || c & r) {
                            u = t, Pt(c);
                            var h = Ot;
                            a[l] = 10 <= h ? u + 250 : 6 <= h ? u + 5e3 : -1;
                        }
                    } else u <= t && (e1.expiredLanes |= c);
                    o &= ~c;
                }
                if (i = Ut(e1, e1 === Co ? Ro : 0), t = Ot, 0 === i) null !== n && (n !== Pr && Tr(n), e1.callbackNode = null, e1.callbackPriority = 0);
                else {
                    if (null !== n) {
                        if (e1.callbackPriority === t) return;
                        n !== Pr && Tr(n);
                    }
                    15 === t ? (n = Al.bind(null, e1), null === kr ? (kr = [
                        n
                    ], jr = Er(Cr, Xr)) : kr.push(n), n = Pr) : 14 === t ? n = Wr(99, Al.bind(null, e1)) : (n = function(e1) {
                        switch(e1){
                            case 15:
                            case 14:
                                return 99;
                            case 13:
                            case 12:
                            case 11:
                            case 10:
                                return 98;
                            case 9:
                            case 8:
                            case 7:
                            case 6:
                            case 4:
                            case 5:
                                return 97;
                            case 3:
                            case 2:
                            case 1:
                                return 95;
                            case 0:
                                return 90;
                            default:
                                throw Error(s(358, e1));
                        }
                    }(t), n = Wr(n, ml.bind(null, e1))), e1.callbackPriority = t, e1.callbackNode = n;
                }
            }
            function ml(e1) {
                if (al = -1, ol = sl = 0, 48 & Do) throw Error(s(327));
                var t = e1.callbackNode;
                if (Rl() && e1.callbackNode !== t) return null;
                var n = Ut(e1, e1 === Co ? Ro : 0);
                if (0 === n) return null;
                var i = n, r = Do;
                Do |= 16;
                var a = wl();
                for(Co === e1 && Ro === i || (Qo(), _l(e1, i));;)try {
                    Sl();
                    break;
                } catch (t) {
                    bl(e1, t);
                }
                if (ta(), Io.current = a, Do = r, null !== Lo ? i = 0 : (Co = null, Ro = 0, i = Po), ko & Bo) _l(e1, 0);
                else if (0 !== i) {
                    if (2 === i && (Do |= 64, e1.hydrate && (e1.hydrate = !1, Wi(e1.containerInfo)), 0 !== (n = kt(e1)) && (i = El(e1, n))), 1 === i) throw t = Uo, _l(e1, 0), gl(e1, n), fl(e1, Hr()), t;
                    switch(e1.finishedWork = e1.current.alternate, e1.finishedLanes = n, i){
                        case 0:
                        case 1:
                            throw Error(s(345));
                        case 2:
                        case 5:
                            Dl(e1);
                            break;
                        case 3:
                            if (gl(e1, n), (62914560 & n) === n && 10 < (i = Vo + 500 - Hr())) {
                                if (0 !== Ut(e1, 0)) break;
                                if (((r = e1.suspendedLanes) & n) !== n) {
                                    ul(), e1.pingedLanes |= e1.suspendedLanes & r;
                                    break;
                                }
                                e1.timeoutHandle = Gi(Dl.bind(null, e1), i);
                                break;
                            }
                            Dl(e1);
                            break;
                        case 4:
                            if (gl(e1, n), (4186112 & n) === n) break;
                            for(i = e1.eventTimes, r = -1; 0 < n;){
                                var o = 31 - Vt(n);
                                a = 1 << o, (o = i[o]) > r && (r = o), n &= ~a;
                            }
                            if (n = r, 10 < (n = (120 > (n = Hr() - n) ? 120 : 480 > n ? 480 : 1080 > n ? 1080 : 1920 > n ? 1920 : 3e3 > n ? 3e3 : 4320 > n ? 4320 : 1960 * So(n / 1960)) - n)) {
                                e1.timeoutHandle = Gi(Dl.bind(null, e1), n);
                                break;
                            }
                            Dl(e1);
                            break;
                        default:
                            throw Error(s(329));
                    }
                }
                return fl(e1, Hr()), e1.callbackNode === t ? ml.bind(null, e1) : null;
            }
            function gl(e1, t) {
                for(t &= ~Fo, t &= ~Bo, e1.suspendedLanes |= t, e1.pingedLanes &= ~t, e1 = e1.expirationTimes; 0 < t;){
                    var n = 31 - Vt(t), i = 1 << n;
                    e1[n] = -1, t &= ~i;
                }
            }
            function Al(e1) {
                if (48 & Do) throw Error(s(327));
                if (Rl(), e1 === Co && e1.expiredLanes & Ro) {
                    var t = Ro, n = El(e1, t);
                    ko & Bo && (n = El(e1, t = Ut(e1, t)));
                } else n = El(e1, t = Ut(e1, 0));
                if (0 !== e1.tag && 2 === n && (Do |= 64, e1.hydrate && (e1.hydrate = !1, Wi(e1.containerInfo)), 0 !== (t = kt(e1)) && (n = El(e1, t))), 1 === n) throw n = Uo, _l(e1, 0), gl(e1, t), fl(e1, Hr()), n;
                return e1.finishedWork = e1.current.alternate, e1.finishedLanes = t, Dl(e1), fl(e1, Hr()), null;
            }
            function vl(e1, t) {
                var n = Do;
                Do |= 1;
                try {
                    return e1(t);
                } finally{
                    0 === (Do = n) && (Qo(), Yr());
                }
            }
            function Ml(e1, t) {
                var n = Do;
                Do &= -2, Do |= 8;
                try {
                    return e1(t);
                } finally{
                    0 === (Do = n) && (Qo(), Yr());
                }
            }
            function yl(e1, t) {
                ur(Oo, zo), zo |= t, ko |= t;
            }
            function xl() {
                zo = Oo.current, cr(Oo);
            }
            function _l(e1, t) {
                e1.finishedWork = null, e1.finishedLanes = 0;
                var n = e1.timeoutHandle;
                if (-1 !== n && (e1.timeoutHandle = -1, Qi(n)), null !== Lo) for(n = Lo.return; null !== n;){
                    var i = n;
                    switch(i.tag){
                        case 1:
                            null != (i = i.type.childContextTypes) && Ar();
                            break;
                        case 3:
                            Ra(), cr(pr), cr(dr), Xa();
                            break;
                        case 5:
                            Oa(i);
                            break;
                        case 4:
                            Ra();
                            break;
                        case 13:
                        case 19:
                            cr(Pa);
                            break;
                        case 10:
                            na(i);
                            break;
                        case 23:
                        case 24:
                            xl();
                    }
                    n = n.return;
                }
                Co = e1, Lo = Gl(e1.current, null), Ro = zo = ko = t, Po = 0, Uo = null, Fo = Bo = jo = 0;
            }
            function bl(e1, t) {
                for(;;){
                    var n = Lo;
                    try {
                        if (ta(), Za.current = Ds, ts) {
                            for(var i = Ja.memoizedState; null !== i;){
                                var r = i.queue;
                                null !== r && (r.pending = null), i = i.next;
                            }
                            ts = !1;
                        }
                        if (Ka = 0, es = $a = Ja = null, ns = !1, No.current = null, null === n || null === n.return) {
                            Po = 1, Uo = t, Lo = null;
                            break;
                        }
                        e: {
                            var a = e1, s = n.return, o = n, l = t;
                            if (t = Ro, o.flags |= 2048, o.firstEffect = o.lastEffect = null, null !== l && "object" == typeof l && "function" == typeof l.then) {
                                var c = l;
                                if (!(2 & o.mode)) {
                                    var u = o.alternate;
                                    u ? (o.updateQueue = u.updateQueue, o.memoizedState = u.memoizedState, o.lanes = u.lanes) : (o.updateQueue = null, o.memoizedState = null);
                                }
                                var h = !!(1 & Pa.current), d = s;
                                do {
                                    var p;
                                    if (p = 13 === d.tag) {
                                        var f = d.memoizedState;
                                        if (null !== f) p = null !== f.dehydrated;
                                        else {
                                            var m = d.memoizedProps;
                                            p = void 0 !== m.fallback && (!0 !== m.unstable_avoidThisFallback || !h);
                                        }
                                    }
                                    if (p) {
                                        var g = d.updateQueue;
                                        if (null === g) {
                                            var A = new Set;
                                            A.add(c), d.updateQueue = A;
                                        } else g.add(c);
                                        if (!(2 & d.mode)) {
                                            if (d.flags |= 64, o.flags |= 16384, o.flags &= -2981, 1 === o.tag) {
                                                if (null === o.alternate) o.tag = 17;
                                                else {
                                                    var v = ca(-1, 1);
                                                    v.tag = 2, ua(o, v);
                                                }
                                            }
                                            o.lanes |= 1;
                                            break e;
                                        }
                                        l = void 0, o = t;
                                        var M = a.pingCache;
                                        if (null === M ? (M = a.pingCache = new lo, l = new Set, M.set(c, l)) : void 0 === (l = M.get(c)) && (l = new Set, M.set(c, l)), !l.has(o)) {
                                            l.add(o);
                                            var y = jl.bind(null, a, c, o);
                                            c.then(y, y);
                                        }
                                        d.flags |= 4096, d.lanes = t;
                                        break e;
                                    }
                                    d = d.return;
                                }while (null !== d);
                                l = Error((Y(o.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                            }
                            5 !== Po && (Po = 2), l = so(l, o), d = s;
                            do {
                                switch(d.tag){
                                    case 3:
                                        a = l, d.flags |= 4096, t &= -t, d.lanes |= t, ha(d, co(0, a, t));
                                        break e;
                                    case 1:
                                        a = l;
                                        var x = d.type, _ = d.stateNode;
                                        if (!(64 & d.flags || "function" != typeof x.getDerivedStateFromError && (null === _ || "function" != typeof _.componentDidCatch || null !== qo && qo.has(_)))) {
                                            d.flags |= 4096, t &= -t, d.lanes |= t, ha(d, uo(d, a, t));
                                            break e;
                                        }
                                }
                                d = d.return;
                            }while (null !== d);
                        }
                        Nl(n);
                    } catch (e1) {
                        t = e1, Lo === n && null !== n && (Lo = n = n.return);
                        continue;
                    }
                    break;
                }
            }
            function wl() {
                var e1 = Io.current;
                return Io.current = Ds, null === e1 ? Ds : e1;
            }
            function El(e1, t) {
                var n = Do;
                Do |= 16;
                var i = wl();
                for(Co === e1 && Ro === t || _l(e1, t);;)try {
                    Tl();
                    break;
                } catch (t) {
                    bl(e1, t);
                }
                if (ta(), Do = n, Io.current = i, null !== Lo) throw Error(s(261));
                return Co = null, Ro = 0, Po;
            }
            function Tl() {
                for(; null !== Lo;)Il(Lo);
            }
            function Sl() {
                for(; null !== Lo && !Sr();)Il(Lo);
            }
            function Il(e1) {
                var t = Wo(e1.alternate, e1, zo);
                e1.memoizedProps = e1.pendingProps, null === t ? Nl(e1) : Lo = t, No.current = null;
            }
            function Nl(e1) {
                var t = e1;
                do {
                    var n = t.alternate;
                    if (e1 = t.return, 2048 & t.flags) {
                        if (null !== (n = ao(t))) return n.flags &= 2047, void (Lo = n);
                        null !== e1 && (e1.firstEffect = e1.lastEffect = null, e1.flags |= 2048);
                    } else {
                        if (null !== (n = ro(n, t, zo))) return void (Lo = n);
                        if (24 !== (n = t).tag && 23 !== n.tag || null === n.memoizedState || 1073741824 & zo || !(4 & n.mode)) {
                            for(var i = 0, r = n.child; null !== r;)i |= r.lanes | r.childLanes, r = r.sibling;
                            n.childLanes = i;
                        }
                        null !== e1 && !(2048 & e1.flags) && (null === e1.firstEffect && (e1.firstEffect = t.firstEffect), null !== t.lastEffect && (null !== e1.lastEffect && (e1.lastEffect.nextEffect = t.firstEffect), e1.lastEffect = t.lastEffect), 1 < t.flags && (null !== e1.lastEffect ? e1.lastEffect.nextEffect = t : e1.firstEffect = t, e1.lastEffect = t));
                    }
                    if (null !== (t = t.sibling)) return void (Lo = t);
                    Lo = t = e1;
                }while (null !== t);
                0 === Po && (Po = 5);
            }
            function Dl(e1) {
                var t = Vr();
                return Qr(99, Cl.bind(null, e1, t)), null;
            }
            function Cl(e1, t) {
                do Rl();
                while (null !== Jo);
                if (48 & Do) throw Error(s(327));
                var n = e1.finishedWork;
                if (null === n) return null;
                if (e1.finishedWork = null, e1.finishedLanes = 0, n === e1.current) throw Error(s(177));
                e1.callbackNode = null;
                var i = n.lanes | n.childLanes, r = i, a = e1.pendingLanes & ~r;
                e1.pendingLanes = r, e1.suspendedLanes = 0, e1.pingedLanes = 0, e1.expiredLanes &= r, e1.mutableReadLanes &= r, e1.entangledLanes &= r, r = e1.entanglements;
                for(var o = e1.eventTimes, l = e1.expirationTimes; 0 < a;){
                    var c = 31 - Vt(a), u = 1 << c;
                    r[c] = 0, o[c] = -1, l[c] = -1, a &= ~u;
                }
                if (null !== nl && !(24 & i) && nl.has(e1) && nl.delete(e1), e1 === Co && (Lo = Co = null, Ro = 0), 1 < n.flags ? null !== n.lastEffect ? (n.lastEffect.nextEffect = n, i = n.firstEffect) : i = n : i = n.firstEffect, null !== i) {
                    if (r = Do, Do |= 32, No.current = null, Bi = Xt, gi(o = mi())) {
                        if ("selectionStart" in o) l = {
                            start: o.selectionStart,
                            end: o.selectionEnd
                        };
                        else e: if (l = (l = o.ownerDocument) && l.defaultView || window, (u = l.getSelection && l.getSelection()) && 0 !== u.rangeCount) {
                            l = u.anchorNode, a = u.anchorOffset, c = u.focusNode, u = u.focusOffset;
                            try {
                                l.nodeType, c.nodeType;
                            } catch (e1) {
                                l = null;
                                break e;
                            }
                            var h = 0, d = -1, p = -1, f = 0, m = 0, g = o, A = null;
                            t: for(;;){
                                for(var v; g !== l || 0 !== a && 3 !== g.nodeType || (d = h + a), g !== c || 0 !== u && 3 !== g.nodeType || (p = h + u), 3 === g.nodeType && (h += g.nodeValue.length), null !== (v = g.firstChild);)A = g, g = v;
                                for(;;){
                                    if (g === o) break t;
                                    if (A === l && ++f === a && (d = h), A === c && ++m === u && (p = h), null !== (v = g.nextSibling)) break;
                                    A = (g = A).parentNode;
                                }
                                g = v;
                            }
                            l = -1 === d || -1 === p ? null : {
                                start: d,
                                end: p
                            };
                        } else l = null;
                        l = l || {
                            start: 0,
                            end: 0
                        };
                    } else l = null;
                    Fi = {
                        focusedElem: o,
                        selectionRange: l
                    }, Xt = !1, ll = null, cl = !1, Yo = i;
                    do try {
                        Ll();
                    } catch (e1) {
                        if (null === Yo) throw Error(s(330));
                        kl(Yo, e1), Yo = Yo.nextEffect;
                    }
                    while (null !== Yo);
                    ll = null, Yo = i;
                    do try {
                        for(o = e1; null !== Yo;){
                            var M = Yo.flags;
                            if (16 & M && Ae(Yo.stateNode, ""), 128 & M) {
                                var y = Yo.alternate;
                                if (null !== y) {
                                    var x = y.ref;
                                    null !== x && ("function" == typeof x ? x(null) : x.current = null);
                                }
                            }
                            switch(1038 & M){
                                case 2:
                                    yo(Yo), Yo.flags &= -3;
                                    break;
                                case 6:
                                    yo(Yo), Yo.flags &= -3, wo(Yo.alternate, Yo);
                                    break;
                                case 1024:
                                    Yo.flags &= -1025;
                                    break;
                                case 1028:
                                    Yo.flags &= -1025, wo(Yo.alternate, Yo);
                                    break;
                                case 4:
                                    wo(Yo.alternate, Yo);
                                    break;
                                case 8:
                                    bo(o, l = Yo);
                                    var _ = l.alternate;
                                    vo(l), null !== _ && vo(_);
                            }
                            Yo = Yo.nextEffect;
                        }
                    } catch (e1) {
                        if (null === Yo) throw Error(s(330));
                        kl(Yo, e1), Yo = Yo.nextEffect;
                    }
                    while (null !== Yo);
                    if (x = Fi, y = mi(), M = x.focusedElem, o = x.selectionRange, y !== M && M && M.ownerDocument && fi(M.ownerDocument.documentElement, M)) {
                        null !== o && gi(M) && (y = o.start, void 0 === (x = o.end) && (x = y), "selectionStart" in M ? (M.selectionStart = y, M.selectionEnd = Math.min(x, M.value.length)) : (x = (y = M.ownerDocument || document) && y.defaultView || window).getSelection && (x = x.getSelection(), l = M.textContent.length, _ = Math.min(o.start, l), o = void 0 === o.end ? _ : Math.min(o.end, l), !x.extend && _ > o && (l = o, o = _, _ = l), l = pi(M, _), a = pi(M, o), l && a && (1 !== x.rangeCount || x.anchorNode !== l.node || x.anchorOffset !== l.offset || x.focusNode !== a.node || x.focusOffset !== a.offset) && ((y = y.createRange()).setStart(l.node, l.offset), x.removeAllRanges(), _ > o ? (x.addRange(y), x.extend(a.node, a.offset)) : (y.setEnd(a.node, a.offset), x.addRange(y))))), y = [];
                        for(x = M; x = x.parentNode;)1 === x.nodeType && y.push({
                            element: x,
                            left: x.scrollLeft,
                            top: x.scrollTop
                        });
                        for("function" == typeof M.focus && M.focus(), M = 0; M < y.length; M++)(x = y[M]).element.scrollLeft = x.left, x.element.scrollTop = x.top;
                    }
                    Xt = !!Bi, Fi = Bi = null, e1.current = n, Yo = i;
                    do try {
                        for(M = e1; null !== Yo;){
                            var b = Yo.flags;
                            if (36 & b && mo(M, Yo.alternate, Yo), 128 & b) {
                                y = void 0;
                                var w = Yo.ref;
                                if (null !== w) {
                                    var E = Yo.stateNode;
                                    Yo.tag, y = E, "function" == typeof w ? w(y) : w.current = y;
                                }
                            }
                            Yo = Yo.nextEffect;
                        }
                    } catch (e1) {
                        if (null === Yo) throw Error(s(330));
                        kl(Yo, e1), Yo = Yo.nextEffect;
                    }
                    while (null !== Yo);
                    Yo = null, Ur(), Do = r;
                } else e1.current = n;
                if (Ko) Ko = !1, Jo = e1, $o = t;
                else for(Yo = i; null !== Yo;)t = Yo.nextEffect, Yo.nextEffect = null, 8 & Yo.flags && ((b = Yo).sibling = null, b.stateNode = null), Yo = t;
                if (0 === (i = e1.pendingLanes) && (qo = null), 1 === i ? e1 === rl ? il++ : (il = 0, rl = e1) : il = 0, n = n.stateNode, br && "function" == typeof br.onCommitFiberRoot) try {
                    br.onCommitFiberRoot(_r, n, void 0, !(64 & ~n.current.flags));
                } catch (e1) {}
                if (fl(e1, Hr()), Xo) throw Xo = !1, e1 = Zo, Zo = null, e1;
                return 8 & Do || Yr(), null;
            }
            function Ll() {
                for(; null !== Yo;){
                    var e1 = Yo.alternate;
                    cl || null === ll || (8 & Yo.flags ? $e(Yo, ll) && (cl = !0) : 13 === Yo.tag && To(e1, Yo) && $e(Yo, ll) && (cl = !0));
                    var t = Yo.flags;
                    256 & t && fo(e1, Yo), !(512 & t) || Ko || (Ko = !0, Wr(97, function() {
                        return Rl(), null;
                    })), Yo = Yo.nextEffect;
                }
            }
            function Rl() {
                if (90 !== $o) {
                    var e1 = 97 < $o ? 97 : $o;
                    return $o = 90, Qr(e1, Pl);
                }
                return !1;
            }
            function zl(e1, t) {
                el.push(t, e1), Ko || (Ko = !0, Wr(97, function() {
                    return Rl(), null;
                }));
            }
            function Ol(e1, t) {
                tl.push(t, e1), Ko || (Ko = !0, Wr(97, function() {
                    return Rl(), null;
                }));
            }
            function Pl() {
                if (null === Jo) return !1;
                var e1 = Jo;
                if (Jo = null, 48 & Do) throw Error(s(331));
                var t = Do;
                Do |= 32;
                var n = tl;
                tl = [];
                for(var i = 0; i < n.length; i += 2){
                    var r = n[i], a = n[i + 1], o = r.destroy;
                    if (r.destroy = void 0, "function" == typeof o) try {
                        o();
                    } catch (e1) {
                        if (null === a) throw Error(s(330));
                        kl(a, e1);
                    }
                }
                for(n = el, el = [], i = 0; i < n.length; i += 2){
                    r = n[i], a = n[i + 1];
                    try {
                        var l = r.create;
                        r.destroy = l();
                    } catch (e1) {
                        if (null === a) throw Error(s(330));
                        kl(a, e1);
                    }
                }
                for(l = e1.current.firstEffect; null !== l;)e1 = l.nextEffect, l.nextEffect = null, 8 & l.flags && (l.sibling = null, l.stateNode = null), l = e1;
                return Do = t, Yr(), !0;
            }
            function Ul(e1, t, n) {
                ua(e1, t = co(0, t = so(n, t), 1)), t = ul(), null !== (e1 = pl(e1, 1)) && (Ht(e1, 1, t), fl(e1, t));
            }
            function kl(e1, t) {
                if (3 === e1.tag) Ul(e1, e1, t);
                else for(var n = e1.return; null !== n;){
                    if (3 === n.tag) {
                        Ul(n, e1, t);
                        break;
                    }
                    if (1 === n.tag) {
                        var i = n.stateNode;
                        if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof i.componentDidCatch && (null === qo || !qo.has(i))) {
                            var r = uo(n, e1 = so(t, e1), 1);
                            if (ua(n, r), r = ul(), null !== (n = pl(n, 1))) Ht(n, 1, r), fl(n, r);
                            else if ("function" == typeof i.componentDidCatch && (null === qo || !qo.has(i))) try {
                                i.componentDidCatch(t, e1);
                            } catch (e1) {}
                            break;
                        }
                    }
                    n = n.return;
                }
            }
            function jl(e1, t, n) {
                var i = e1.pingCache;
                null !== i && i.delete(t), t = ul(), e1.pingedLanes |= e1.suspendedLanes & n, Co === e1 && (Ro & n) === n && (4 === Po || 3 === Po && (62914560 & Ro) === Ro && 500 > Hr() - Vo ? _l(e1, 0) : Fo |= n), fl(e1, t);
            }
            function Bl(e1, t) {
                var n = e1.stateNode;
                null !== n && n.delete(t), 0 == (t = 0) && (2 & (t = e1.mode) ? 4 & t ? (0 === sl && (sl = ko), 0 === (t = Bt(62914560 & ~sl)) && (t = 4194304)) : t = 99 === Vr() ? 1 : 2 : t = 1), n = ul(), null !== (e1 = pl(e1, t)) && (Ht(e1, t, n), fl(e1, n));
            }
            function Fl(e1, t, n, i) {
                this.tag = e1, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = i, this.flags = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childLanes = this.lanes = 0, this.alternate = null;
            }
            function Hl(e1, t, n, i) {
                return new Fl(e1, t, n, i);
            }
            function Vl(e1) {
                return !(!(e1 = e1.prototype) || !e1.isReactComponent);
            }
            function Gl(e1, t) {
                var n = e1.alternate;
                return null === n ? ((n = Hl(e1.tag, t, e1.key, e1.mode)).elementType = e1.elementType, n.type = e1.type, n.stateNode = e1.stateNode, n.alternate = e1, e1.alternate = n) : (n.pendingProps = t, n.type = e1.type, n.flags = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childLanes = e1.childLanes, n.lanes = e1.lanes, n.child = e1.child, n.memoizedProps = e1.memoizedProps, n.memoizedState = e1.memoizedState, n.updateQueue = e1.updateQueue, t = e1.dependencies, n.dependencies = null === t ? null : {
                    lanes: t.lanes,
                    firstContext: t.firstContext
                }, n.sibling = e1.sibling, n.index = e1.index, n.ref = e1.ref, n;
            }
            function Ql(e1, t, n, i, r, a) {
                var o = 2;
                if (i = e1, "function" == typeof e1) Vl(e1) && (o = 1);
                else if ("string" == typeof e1) o = 5;
                else e: switch(e1){
                    case w:
                        return Wl(n.children, r, a, t);
                    case P:
                        o = 8, r |= 16;
                        break;
                    case E:
                        o = 8, r |= 1;
                        break;
                    case T:
                        return (e1 = Hl(12, n, t, 8 | r)).elementType = T, e1.type = T, e1.lanes = a, e1;
                    case D:
                        return (e1 = Hl(13, n, t, r)).type = D, e1.elementType = D, e1.lanes = a, e1;
                    case C:
                        return (e1 = Hl(19, n, t, r)).elementType = C, e1.lanes = a, e1;
                    case U:
                        return Yl(n, r, a, t);
                    case k:
                        return (e1 = Hl(24, n, t, r)).elementType = k, e1.lanes = a, e1;
                    default:
                        if ("object" == typeof e1 && null !== e1) switch(e1.$$typeof){
                            case S:
                                o = 10;
                                break e;
                            case I:
                                o = 9;
                                break e;
                            case N:
                                o = 11;
                                break e;
                            case L:
                                o = 14;
                                break e;
                            case R:
                                o = 16, i = null;
                                break e;
                            case z:
                                o = 22;
                                break e;
                        }
                        throw Error(s(130, null == e1 ? e1 : typeof e1, ""));
                }
                return (t = Hl(o, n, t, r)).elementType = e1, t.type = i, t.lanes = a, t;
            }
            function Wl(e1, t, n, i) {
                return (e1 = Hl(7, e1, i, t)).lanes = n, e1;
            }
            function Yl(e1, t, n, i) {
                return (e1 = Hl(23, e1, i, t)).elementType = U, e1.lanes = n, e1;
            }
            function Xl(e1, t, n) {
                return (e1 = Hl(6, e1, null, t)).lanes = n, e1;
            }
            function Zl(e1, t, n) {
                return (t = Hl(4, null !== e1.children ? e1.children : [], e1.key, t)).lanes = n, t.stateNode = {
                    containerInfo: e1.containerInfo,
                    pendingChildren: null,
                    implementation: e1.implementation
                }, t;
            }
            function ql(e1, t, n) {
                this.tag = t, this.containerInfo = e1, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 0, this.eventTimes = Ft(0), this.expirationTimes = Ft(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Ft(0), this.mutableSourceEagerHydrationData = null;
            }
            function Kl(e1, t, n, i) {
                var r = t.current, a = ul(), o = hl(r);
                e: if (n) {
                    t: {
                        if (Ze(n = n._reactInternals) !== n || 1 !== n.tag) throw Error(s(170));
                        var l = n;
                        do {
                            switch(l.tag){
                                case 3:
                                    l = l.stateNode.context;
                                    break t;
                                case 1:
                                    if (gr(l.type)) {
                                        l = l.stateNode.__reactInternalMemoizedMergedChildContext;
                                        break t;
                                    }
                            }
                            l = l.return;
                        }while (null !== l);
                        throw Error(s(171));
                    }
                    if (1 === n.tag) {
                        var c = n.type;
                        if (gr(c)) {
                            n = Mr(n, c, l);
                            break e;
                        }
                    }
                    n = l;
                } else n = hr;
                return null === t.context ? t.context = n : t.pendingContext = n, (t = ca(a, o)).payload = {
                    element: e1
                }, null !== (i = void 0 === i ? null : i) && (t.callback = i), ua(r, t), dl(r, o, a), o;
            }
            function Jl(e1) {
                return (e1 = e1.current).child ? (e1.child.tag, e1.child.stateNode) : null;
            }
            function $l(e1, t) {
                if (null !== (e1 = e1.memoizedState) && null !== e1.dehydrated) {
                    var n = e1.retryLane;
                    e1.retryLane = 0 !== n && n < t ? n : t;
                }
            }
            function ec(e1, t) {
                $l(e1, t), (e1 = e1.alternate) && $l(e1, t);
            }
            function tc(e1, t, n) {
                var i = null != n && null != n.hydrationOptions && n.hydrationOptions.mutableSources || null;
                if (n = new ql(e1, t, null != n && !0 === n.hydrate), t = Hl(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0), n.current = t, t.stateNode = n, oa(t), e1[$i] = n.current, Ci(8 === e1.nodeType ? e1.parentNode : e1), i) for(e1 = 0; e1 < i.length; e1++){
                    var r = (t = i[e1])._getVersion;
                    r = r(t._source), null == n.mutableSourceEagerHydrationData ? n.mutableSourceEagerHydrationData = [
                        t,
                        r
                    ] : n.mutableSourceEagerHydrationData.push(t, r);
                }
                this._internalRoot = n;
            }
            function nc(e1) {
                return !(!e1 || 1 !== e1.nodeType && 9 !== e1.nodeType && 11 !== e1.nodeType && (8 !== e1.nodeType || " react-mount-point-unstable " !== e1.nodeValue));
            }
            function ic(e1, t, n, i, r) {
                var a = n._reactRootContainer;
                if (a) {
                    var s = a._internalRoot;
                    if ("function" == typeof r) {
                        var o = r;
                        r = function() {
                            var e1 = Jl(s);
                            o.call(e1);
                        };
                    }
                    Kl(t, s, e1, r);
                } else {
                    if (a = n._reactRootContainer = function(e1, t) {
                        if (t || (t = !(!(t = e1 ? 9 === e1.nodeType ? e1.documentElement : e1.firstChild : null) || 1 !== t.nodeType || !t.hasAttribute("data-reactroot"))), !t) for(var n; n = e1.lastChild;)e1.removeChild(n);
                        return new tc(e1, 0, t ? {
                            hydrate: !0
                        } : void 0);
                    }(n, i), s = a._internalRoot, "function" == typeof r) {
                        var l = r;
                        r = function() {
                            var e1 = Jl(s);
                            l.call(e1);
                        };
                    }
                    Ml(function() {
                        Kl(t, s, e1, r);
                    });
                }
                return Jl(s);
            }
            function rc(e1, t) {
                var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
                if (!nc(t)) throw Error(s(200));
                return function(e1, t, n) {
                    var i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
                    return {
                        $$typeof: b,
                        key: null == i ? null : "" + i,
                        children: e1,
                        containerInfo: t,
                        implementation: n
                    };
                }(e1, t, null, n);
            }
            Wo = function(e1, t, n) {
                var i = t.lanes;
                if (null !== e1) {
                    if (e1.memoizedProps !== t.pendingProps || pr.current) Os = !0;
                    else {
                        if (!(n & i)) {
                            switch(Os = !1, t.tag){
                                case 3:
                                    Qs(t), Wa();
                                    break;
                                case 5:
                                    za(t);
                                    break;
                                case 1:
                                    gr(t.type) && yr(t);
                                    break;
                                case 4:
                                    La(t, t.stateNode.containerInfo);
                                    break;
                                case 10:
                                    i = t.memoizedProps.value;
                                    var r = t.type._context;
                                    ur(Kr, r._currentValue), r._currentValue = i;
                                    break;
                                case 13:
                                    if (null !== t.memoizedState) return n & t.child.childLanes ? Ks(e1, t, n) : (ur(Pa, 1 & Pa.current), null !== (t = no(e1, t, n)) ? t.sibling : null);
                                    ur(Pa, 1 & Pa.current);
                                    break;
                                case 19:
                                    if (i = !!(n & t.childLanes), 64 & e1.flags) {
                                        if (i) return to(e1, t, n);
                                        t.flags |= 64;
                                    }
                                    if (null !== (r = t.memoizedState) && (r.rendering = null, r.tail = null, r.lastEffect = null), ur(Pa, Pa.current), i) break;
                                    return null;
                                case 23:
                                case 24:
                                    return t.lanes = 0, Bs(e1, t, n);
                            }
                            return no(e1, t, n);
                        }
                        Os = !!(16384 & e1.flags);
                    }
                } else Os = !1;
                switch(t.lanes = 0, t.tag){
                    case 2:
                        if (i = t.type, null !== e1 && (e1.alternate = null, t.alternate = null, t.flags |= 2), e1 = t.pendingProps, r = mr(t, dr.current), ra(t, n), r = as(null, t, i, e1, r, n), t.flags |= 1, "object" == typeof r && null !== r && "function" == typeof r.render && void 0 === r.$$typeof) {
                            if (t.tag = 1, t.memoizedState = null, t.updateQueue = null, gr(i)) {
                                var a = !0;
                                yr(t);
                            } else a = !1;
                            t.memoizedState = null !== r.state && void 0 !== r.state ? r.state : null, oa(t);
                            var o = i.getDerivedStateFromProps;
                            "function" == typeof o && ma(t, i, o, e1), r.updater = ga, t.stateNode = r, r._reactInternals = t, ya(t, i, e1, n), t = Gs(null, t, i, !0, a, n);
                        } else t.tag = 0, Ps(null, t, r, n), t = t.child;
                        return t;
                    case 16:
                        r = t.elementType;
                        e: {
                            switch(null !== e1 && (e1.alternate = null, t.alternate = null, t.flags |= 2), e1 = t.pendingProps, r = (a = r._init)(r._payload), t.type = r, a = t.tag = function(e1) {
                                if ("function" == typeof e1) return Vl(e1) ? 1 : 0;
                                if (null != e1) {
                                    if ((e1 = e1.$$typeof) === N) return 11;
                                    if (e1 === L) return 14;
                                }
                                return 2;
                            }(r), e1 = qr(r, e1), a){
                                case 0:
                                    t = Hs(null, t, r, e1, n);
                                    break e;
                                case 1:
                                    t = Vs(null, t, r, e1, n);
                                    break e;
                                case 11:
                                    t = Us(null, t, r, e1, n);
                                    break e;
                                case 14:
                                    t = ks(null, t, r, qr(r.type, e1), i, n);
                                    break e;
                            }
                            throw Error(s(306, r, ""));
                        }
                        return t;
                    case 0:
                        return i = t.type, r = t.pendingProps, Hs(e1, t, i, r = t.elementType === i ? r : qr(i, r), n);
                    case 1:
                        return i = t.type, r = t.pendingProps, Vs(e1, t, i, r = t.elementType === i ? r : qr(i, r), n);
                    case 3:
                        if (Qs(t), i = t.updateQueue, null === e1 || null === i) throw Error(s(282));
                        if (i = t.pendingProps, r = null !== (r = t.memoizedState) ? r.element : null, la(e1, t), da(t, i, null, n), (i = t.memoizedState.element) === r) Wa(), t = no(e1, t, n);
                        else {
                            if ((a = (r = t.stateNode).hydrate) && (ja = Yi(t.stateNode.containerInfo.firstChild), ka = t, a = Ba = !0), a) {
                                if (null != (e1 = r.mutableSourceEagerHydrationData)) for(r = 0; r < e1.length; r += 2)(a = e1[r])._workInProgressVersionPrimary = e1[r + 1], Ya.push(a);
                                for(n = Ta(t, null, i, n), t.child = n; n;)n.flags = -3 & n.flags | 1024, n = n.sibling;
                            } else Ps(e1, t, i, n), Wa();
                            t = t.child;
                        }
                        return t;
                    case 5:
                        return za(t), null === e1 && Va(t), i = t.type, r = t.pendingProps, a = null !== e1 ? e1.memoizedProps : null, o = r.children, Vi(i, r) ? o = null : null !== a && Vi(i, a) && (t.flags |= 16), Fs(e1, t), Ps(e1, t, o, n), t.child;
                    case 6:
                        return null === e1 && Va(t), null;
                    case 13:
                        return Ks(e1, t, n);
                    case 4:
                        return La(t, t.stateNode.containerInfo), i = t.pendingProps, null === e1 ? t.child = Ea(t, null, i, n) : Ps(e1, t, i, n), t.child;
                    case 11:
                        return i = t.type, r = t.pendingProps, Us(e1, t, i, r = t.elementType === i ? r : qr(i, r), n);
                    case 7:
                        return Ps(e1, t, t.pendingProps, n), t.child;
                    case 8:
                    case 12:
                        return Ps(e1, t, t.pendingProps.children, n), t.child;
                    case 10:
                        e: {
                            i = t.type._context, r = t.pendingProps, o = t.memoizedProps, a = r.value;
                            var l = t.type._context;
                            if (ur(Kr, l._currentValue), l._currentValue = a, null !== o) {
                                if (l = o.value, 0 == (a = ci(l, a) ? 0 : 0 | ("function" == typeof i._calculateChangedBits ? i._calculateChangedBits(l, a) : 1073741823))) {
                                    if (o.children === r.children && !pr.current) {
                                        t = no(e1, t, n);
                                        break e;
                                    }
                                } else for(null !== (l = t.child) && (l.return = t); null !== l;){
                                    var c = l.dependencies;
                                    if (null !== c) {
                                        o = l.child;
                                        for(var u = c.firstContext; null !== u;){
                                            if (u.context === i && u.observedBits & a) {
                                                1 === l.tag && ((u = ca(-1, n & -n)).tag = 2, ua(l, u)), l.lanes |= n, null !== (u = l.alternate) && (u.lanes |= n), ia(l.return, n), c.lanes |= n;
                                                break;
                                            }
                                            u = u.next;
                                        }
                                    } else o = 10 === l.tag && l.type === t.type ? null : l.child;
                                    if (null !== o) o.return = l;
                                    else for(o = l; null !== o;){
                                        if (o === t) {
                                            o = null;
                                            break;
                                        }
                                        if (null !== (l = o.sibling)) {
                                            l.return = o.return, o = l;
                                            break;
                                        }
                                        o = o.return;
                                    }
                                    l = o;
                                }
                            }
                            Ps(e1, t, r.children, n), t = t.child;
                        }
                        return t;
                    case 9:
                        return r = t.type, i = (a = t.pendingProps).children, ra(t, n), i = i(r = aa(r, a.unstable_observedBits)), t.flags |= 1, Ps(e1, t, i, n), t.child;
                    case 14:
                        return a = qr(r = t.type, t.pendingProps), ks(e1, t, r, a = qr(r.type, a), i, n);
                    case 15:
                        return js(e1, t, t.type, t.pendingProps, i, n);
                    case 17:
                        return i = t.type, r = t.pendingProps, r = t.elementType === i ? r : qr(i, r), null !== e1 && (e1.alternate = null, t.alternate = null, t.flags |= 2), t.tag = 1, gr(i) ? (e1 = !0, yr(t)) : e1 = !1, ra(t, n), va(t, i, r), ya(t, i, r, n), Gs(null, t, i, !0, e1, n);
                    case 19:
                        return to(e1, t, n);
                    case 23:
                    case 24:
                        return Bs(e1, t, n);
                }
                throw Error(s(156, t.tag));
            }, tc.prototype.render = function(e1) {
                Kl(e1, this._internalRoot, null, null);
            }, tc.prototype.unmount = function() {
                var e1 = this._internalRoot, t = e1.containerInfo;
                Kl(null, e1, null, function() {
                    t[$i] = null;
                });
            }, et = function(e1) {
                13 === e1.tag && (dl(e1, 4, ul()), ec(e1, 4));
            }, tt = function(e1) {
                13 === e1.tag && (dl(e1, 67108864, ul()), ec(e1, 67108864));
            }, nt = function(e1) {
                if (13 === e1.tag) {
                    var t = ul(), n = hl(e1);
                    dl(e1, n, t), ec(e1, n);
                }
            }, it = function(e1, t) {
                return t();
            }, Te = function(e1, t, n) {
                switch(t){
                    case "input":
                        if (ne(e1, n), t = n.name, "radio" === n.type && null != t) {
                            for(n = e1; n.parentNode;)n = n.parentNode;
                            for(n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++){
                                var i = n[t];
                                if (i !== e1 && i.form === e1.form) {
                                    var r = rr(i);
                                    if (!r) throw Error(s(90));
                                    K(i), ne(i, r);
                                }
                            }
                        }
                        break;
                    case "textarea":
                        ce(e1, n);
                        break;
                    case "select":
                        null != (t = n.value) && se(e1, !!n.multiple, t, !1);
                }
            }, Le = vl, Re = function(e1, t, n, i, r) {
                var a = Do;
                Do |= 4;
                try {
                    return Qr(98, e1.bind(null, t, n, i, r));
                } finally{
                    0 === (Do = a) && (Qo(), Yr());
                }
            }, ze = function() {
                !(49 & Do) && (function() {
                    if (null !== nl) {
                        var e1 = nl;
                        nl = null, e1.forEach(function(e1) {
                            e1.expiredLanes |= 24 & e1.pendingLanes, fl(e1, Hr());
                        });
                    }
                    Yr();
                }(), Rl());
            }, Oe = function(e1, t) {
                var n = Do;
                Do |= 2;
                try {
                    return e1(t);
                } finally{
                    0 === (Do = n) && (Qo(), Yr());
                }
            };
            var ac = {
                Events: [
                    nr,
                    ir,
                    rr,
                    De,
                    Ce,
                    Rl,
                    {
                        current: !1
                    }
                ]
            }, sc = {
                findFiberByHostInstance: tr,
                bundleType: 0,
                version: "17.0.2",
                rendererPackageName: "react-dom"
            }, oc = {
                bundleType: sc.bundleType,
                version: sc.version,
                rendererPackageName: sc.rendererPackageName,
                rendererConfig: sc.rendererConfig,
                overrideHookState: null,
                overrideHookStateDeletePath: null,
                overrideHookStateRenamePath: null,
                overrideProps: null,
                overridePropsDeletePath: null,
                overridePropsRenamePath: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: x.ReactCurrentDispatcher,
                findHostInstanceByFiber: function(e1) {
                    return null === (e1 = Je(e1)) ? null : e1.stateNode;
                },
                findFiberByHostInstance: sc.findFiberByHostInstance || function() {
                    return null;
                },
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null
            };
            if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
                var lc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
                if (!lc.isDisabled && lc.supportsFiber) try {
                    _r = lc.inject(oc), br = lc;
                } catch (me) {}
            }
            t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ac, t.createPortal = rc, t.findDOMNode = function(e1) {
                if (null == e1) return null;
                if (1 === e1.nodeType) return e1;
                var t = e1._reactInternals;
                if (void 0 === t) {
                    if ("function" == typeof e1.render) throw Error(s(188));
                    throw Error(s(268, Object.keys(e1)));
                }
                return null === (e1 = Je(t)) ? null : e1.stateNode;
            }, t.flushSync = function(e1, t) {
                var n = Do;
                if (48 & n) return e1(t);
                Do |= 1;
                try {
                    if (e1) return Qr(99, e1.bind(null, t));
                } finally{
                    Do = n, Yr();
                }
            }, t.hydrate = function(e1, t, n) {
                if (!nc(t)) throw Error(s(200));
                return ic(null, e1, t, !0, n);
            }, t.render = function(e1, t, n) {
                if (!nc(t)) throw Error(s(200));
                return ic(null, e1, t, !1, n);
            }, t.unmountComponentAtNode = function(e1) {
                if (!nc(e1)) throw Error(s(40));
                return !!e1._reactRootContainer && (Ml(function() {
                    ic(null, null, e1, !1, function() {
                        e1._reactRootContainer = null, e1[$i] = null;
                    });
                }), !0);
            }, t.unstable_batchedUpdates = vl, t.unstable_createPortal = function(e1, t) {
                return rc(e1, t, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
            }, t.unstable_renderSubtreeIntoContainer = function(e1, t, n, i) {
                if (!nc(n)) throw Error(s(200));
                if (null == e1 || void 0 === e1._reactInternals) throw Error(s(38));
                return ic(e1, t, n, !1, i);
            }, t.version = "17.0.2";
        },
        834: (e1, t, n)=>{
            "use strict";
            !function e1() {
                if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE) try {
                    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e1);
                } catch (e1) {
                    console.error(e1);
                }
            }(), e1.exports = n(230);
        },
        534: (e1, t, n)=>{
            "use strict";
            var i = n(383), r = 60103, a = 60106;
            t.Fragment = 60107, t.StrictMode = 60108, t.Profiler = 60114;
            var s = 60109, o = 60110, l = 60112;
            t.Suspense = 60113;
            var c = 60115, u = 60116;
            if ("function" == typeof Symbol && Symbol.for) {
                var h = Symbol.for;
                r = h("react.element"), a = h("react.portal"), t.Fragment = h("react.fragment"), t.StrictMode = h("react.strict_mode"), t.Profiler = h("react.profiler"), s = h("react.provider"), o = h("react.context"), l = h("react.forward_ref"), t.Suspense = h("react.suspense"), c = h("react.memo"), u = h("react.lazy");
            }
            var d = "function" == typeof Symbol && Symbol.iterator;
            function p(e1) {
                for(var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e1, n = 1; n < arguments.length; n++)t += "&args[]=" + encodeURIComponent(arguments[n]);
                return "Minified React error #" + e1 + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
            }
            var f = {
                isMounted: function() {
                    return !1;
                },
                enqueueForceUpdate: function() {},
                enqueueReplaceState: function() {},
                enqueueSetState: function() {}
            }, m = {};
            function g(e1, t, n) {
                this.props = e1, this.context = t, this.refs = m, this.updater = n || f;
            }
            function A() {}
            function v(e1, t, n) {
                this.props = e1, this.context = t, this.refs = m, this.updater = n || f;
            }
            g.prototype.isReactComponent = {}, g.prototype.setState = function(e1, t) {
                if ("object" != typeof e1 && "function" != typeof e1 && null != e1) throw Error(p(85));
                this.updater.enqueueSetState(this, e1, t, "setState");
            }, g.prototype.forceUpdate = function(e1) {
                this.updater.enqueueForceUpdate(this, e1, "forceUpdate");
            }, A.prototype = g.prototype;
            var M = v.prototype = new A;
            M.constructor = v, i(M, g.prototype), M.isPureReactComponent = !0;
            var y = {
                current: null
            }, x = Object.prototype.hasOwnProperty, _ = {
                key: !0,
                ref: !0,
                __self: !0,
                __source: !0
            };
            function b(e1, t, n) {
                var i, a = {}, s = null, o = null;
                if (null != t) for(i in void 0 !== t.ref && (o = t.ref), void 0 !== t.key && (s = "" + t.key), t)x.call(t, i) && !_.hasOwnProperty(i) && (a[i] = t[i]);
                var l = arguments.length - 2;
                if (1 === l) a.children = n;
                else if (1 < l) {
                    for(var c = Array(l), u = 0; u < l; u++)c[u] = arguments[u + 2];
                    a.children = c;
                }
                if (e1 && e1.defaultProps) for(i in l = e1.defaultProps)void 0 === a[i] && (a[i] = l[i]);
                return {
                    $$typeof: r,
                    type: e1,
                    key: s,
                    ref: o,
                    props: a,
                    _owner: y.current
                };
            }
            function w(e1) {
                return "object" == typeof e1 && null !== e1 && e1.$$typeof === r;
            }
            var E = /\/+/g;
            function T(e1, t) {
                return "object" == typeof e1 && null !== e1 && null != e1.key ? function(e1) {
                    var t = {
                        "=": "=0",
                        ":": "=2"
                    };
                    return "$" + e1.replace(/[=:]/g, function(e1) {
                        return t[e1];
                    });
                }("" + e1.key) : t.toString(36);
            }
            function S(e1, t, n, i, s) {
                var o = typeof e1;
                "undefined" !== o && "boolean" !== o || (e1 = null);
                var l = !1;
                if (null === e1) l = !0;
                else switch(o){
                    case "string":
                    case "number":
                        l = !0;
                        break;
                    case "object":
                        switch(e1.$$typeof){
                            case r:
                            case a:
                                l = !0;
                        }
                }
                if (l) return s = s(l = e1), e1 = "" === i ? "." + T(l, 0) : i, Array.isArray(s) ? (n = "", null != e1 && (n = e1.replace(E, "$&/") + "/"), S(s, t, n, "", function(e1) {
                    return e1;
                })) : null != s && (w(s) && (s = function(e1, t) {
                    return {
                        $$typeof: r,
                        type: e1.type,
                        key: t,
                        ref: e1.ref,
                        props: e1.props,
                        _owner: e1._owner
                    };
                }(s, n + (!s.key || l && l.key === s.key ? "" : ("" + s.key).replace(E, "$&/") + "/") + e1)), t.push(s)), 1;
                if (l = 0, i = "" === i ? "." : i + ":", Array.isArray(e1)) for(var c = 0; c < e1.length; c++){
                    var u = i + T(o = e1[c], c);
                    l += S(o, t, n, u, s);
                }
                else if (u = function(e1) {
                    return null === e1 || "object" != typeof e1 ? null : "function" == typeof (e1 = d && e1[d] || e1["@@iterator"]) ? e1 : null;
                }(e1), "function" == typeof u) for(e1 = u.call(e1), c = 0; !(o = e1.next()).done;)l += S(o = o.value, t, n, u = i + T(o, c++), s);
                else if ("object" === o) throw t = "" + e1, Error(p(31, "[object Object]" === t ? "object with keys {" + Object.keys(e1).join(", ") + "}" : t));
                return l;
            }
            function I(e1, t, n) {
                if (null == e1) return e1;
                var i = [], r = 0;
                return S(e1, i, "", "", function(e1) {
                    return t.call(n, e1, r++);
                }), i;
            }
            function N(e1) {
                if (-1 === e1._status) {
                    var t = e1._result;
                    t = t(), e1._status = 0, e1._result = t, t.then(function(t) {
                        0 === e1._status && (t = t.default, e1._status = 1, e1._result = t);
                    }, function(t) {
                        0 === e1._status && (e1._status = 2, e1._result = t);
                    });
                }
                if (1 === e1._status) return e1._result;
                throw e1._result;
            }
            var D = {
                current: null
            };
            function C() {
                var e1 = D.current;
                if (null === e1) throw Error(p(321));
                return e1;
            }
            var L = {
                ReactCurrentDispatcher: D,
                ReactCurrentBatchConfig: {
                    transition: 0
                },
                ReactCurrentOwner: y,
                IsSomeRendererActing: {
                    current: !1
                },
                assign: i
            };
            t.Children = {
                map: I,
                forEach: function(e1, t, n) {
                    I(e1, function() {
                        t.apply(this, arguments);
                    }, n);
                },
                count: function(e1) {
                    var t = 0;
                    return I(e1, function() {
                        t++;
                    }), t;
                },
                toArray: function(e1) {
                    return I(e1, function(e1) {
                        return e1;
                    }) || [];
                },
                only: function(e1) {
                    if (!w(e1)) throw Error(p(143));
                    return e1;
                }
            }, t.Component = g, t.PureComponent = v, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = L, t.cloneElement = function(e1, t, n) {
                if (null == e1) throw Error(p(267, e1));
                var a = i({}, e1.props), s = e1.key, o = e1.ref, l = e1._owner;
                if (null != t) {
                    if (void 0 !== t.ref && (o = t.ref, l = y.current), void 0 !== t.key && (s = "" + t.key), e1.type && e1.type.defaultProps) var c = e1.type.defaultProps;
                    for(u in t)x.call(t, u) && !_.hasOwnProperty(u) && (a[u] = void 0 === t[u] && void 0 !== c ? c[u] : t[u]);
                }
                var u = arguments.length - 2;
                if (1 === u) a.children = n;
                else if (1 < u) {
                    c = Array(u);
                    for(var h = 0; h < u; h++)c[h] = arguments[h + 2];
                    a.children = c;
                }
                return {
                    $$typeof: r,
                    type: e1.type,
                    key: s,
                    ref: o,
                    props: a,
                    _owner: l
                };
            }, t.createContext = function(e1, t) {
                return void 0 === t && (t = null), (e1 = {
                    $$typeof: o,
                    _calculateChangedBits: t,
                    _currentValue: e1,
                    _currentValue2: e1,
                    _threadCount: 0,
                    Provider: null,
                    Consumer: null
                }).Provider = {
                    $$typeof: s,
                    _context: e1
                }, e1.Consumer = e1;
            }, t.createElement = b, t.createFactory = function(e1) {
                var t = b.bind(null, e1);
                return t.type = e1, t;
            }, t.createRef = function() {
                return {
                    current: null
                };
            }, t.forwardRef = function(e1) {
                return {
                    $$typeof: l,
                    render: e1
                };
            }, t.isValidElement = w, t.lazy = function(e1) {
                return {
                    $$typeof: u,
                    _payload: {
                        _status: -1,
                        _result: e1
                    },
                    _init: N
                };
            }, t.memo = function(e1, t) {
                return {
                    $$typeof: c,
                    type: e1,
                    compare: void 0 === t ? null : t
                };
            }, t.useCallback = function(e1, t) {
                return C().useCallback(e1, t);
            }, t.useContext = function(e1, t) {
                return C().useContext(e1, t);
            }, t.useDebugValue = function() {}, t.useEffect = function(e1, t) {
                return C().useEffect(e1, t);
            }, t.useImperativeHandle = function(e1, t, n) {
                return C().useImperativeHandle(e1, t, n);
            }, t.useLayoutEffect = function(e1, t) {
                return C().useLayoutEffect(e1, t);
            }, t.useMemo = function(e1, t) {
                return C().useMemo(e1, t);
            }, t.useReducer = function(e1, t, n) {
                return C().useReducer(e1, t, n);
            }, t.useRef = function(e1) {
                return C().useRef(e1);
            }, t.useState = function(e1) {
                return C().useState(e1);
            }, t.version = "17.0.2";
        },
        471: (e1, t, n)=>{
            "use strict";
            e1.exports = n(534);
        },
        582: (e1, t)=>{
            "use strict";
            var n, i, r, a;
            if ("object" == typeof performance && "function" == typeof performance.now) {
                var s = performance;
                t.unstable_now = function() {
                    return s.now();
                };
            } else {
                var o = Date, l = o.now();
                t.unstable_now = function() {
                    return o.now() - l;
                };
            }
            if ("undefined" == typeof window || "function" != typeof MessageChannel) {
                var c = null, u = null, h = function() {
                    if (null !== c) try {
                        var e1 = t.unstable_now();
                        c(!0, e1), c = null;
                    } catch (e1) {
                        throw setTimeout(h, 0), e1;
                    }
                };
                n = function(e1) {
                    null !== c ? setTimeout(n, 0, e1) : (c = e1, setTimeout(h, 0));
                }, i = function(e1, t) {
                    u = setTimeout(e1, t);
                }, r = function() {
                    clearTimeout(u);
                }, t.unstable_shouldYield = function() {
                    return !1;
                }, a = t.unstable_forceFrameRate = function() {};
            } else {
                var d = window.setTimeout, p = window.clearTimeout;
                if ("undefined" != typeof console) {
                    var f = window.cancelAnimationFrame;
                    "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), "function" != typeof f && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
                }
                var m = !1, g = null, A = -1, v = 5, M = 0;
                t.unstable_shouldYield = function() {
                    return t.unstable_now() >= M;
                }, a = function() {}, t.unstable_forceFrameRate = function(e1) {
                    0 > e1 || 125 < e1 ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : v = 0 < e1 ? Math.floor(1e3 / e1) : 5;
                };
                var y = new MessageChannel, x = y.port2;
                y.port1.onmessage = function() {
                    if (null !== g) {
                        var e1 = t.unstable_now();
                        M = e1 + v;
                        try {
                            g(!0, e1) ? x.postMessage(null) : (m = !1, g = null);
                        } catch (e1) {
                            throw x.postMessage(null), e1;
                        }
                    } else m = !1;
                }, n = function(e1) {
                    g = e1, m || (m = !0, x.postMessage(null));
                }, i = function(e1, n) {
                    A = d(function() {
                        e1(t.unstable_now());
                    }, n);
                }, r = function() {
                    p(A), A = -1;
                };
            }
            function _(e1, t) {
                var n = e1.length;
                e1.push(t);
                e: for(;;){
                    var i = n - 1 >>> 1, r = e1[i];
                    if (!(void 0 !== r && 0 < E(r, t))) break e;
                    e1[i] = t, e1[n] = r, n = i;
                }
            }
            function b(e1) {
                return void 0 === (e1 = e1[0]) ? null : e1;
            }
            function w(e1) {
                var t = e1[0];
                if (void 0 !== t) {
                    var n = e1.pop();
                    if (n !== t) {
                        e1[0] = n;
                        e: for(var i = 0, r = e1.length; i < r;){
                            var a = 2 * (i + 1) - 1, s = e1[a], o = a + 1, l = e1[o];
                            if (void 0 !== s && 0 > E(s, n)) void 0 !== l && 0 > E(l, s) ? (e1[i] = l, e1[o] = n, i = o) : (e1[i] = s, e1[a] = n, i = a);
                            else {
                                if (!(void 0 !== l && 0 > E(l, n))) break e;
                                e1[i] = l, e1[o] = n, i = o;
                            }
                        }
                    }
                    return t;
                }
                return null;
            }
            function E(e1, t) {
                var n = e1.sortIndex - t.sortIndex;
                return 0 !== n ? n : e1.id - t.id;
            }
            var T = [], S = [], I = 1, N = null, D = 3, C = !1, L = !1, R = !1;
            function z(e1) {
                for(var t = b(S); null !== t;){
                    if (null === t.callback) w(S);
                    else {
                        if (!(t.startTime <= e1)) break;
                        w(S), t.sortIndex = t.expirationTime, _(T, t);
                    }
                    t = b(S);
                }
            }
            function O(e1) {
                if (R = !1, z(e1), !L) {
                    if (null !== b(T)) L = !0, n(P);
                    else {
                        var t = b(S);
                        null !== t && i(O, t.startTime - e1);
                    }
                }
            }
            function P(e1, n) {
                L = !1, R && (R = !1, r()), C = !0;
                var a = D;
                try {
                    for(z(n), N = b(T); null !== N && (!(N.expirationTime > n) || e1 && !t.unstable_shouldYield());){
                        var s = N.callback;
                        if ("function" == typeof s) {
                            N.callback = null, D = N.priorityLevel;
                            var o = s(N.expirationTime <= n);
                            n = t.unstable_now(), "function" == typeof o ? N.callback = o : N === b(T) && w(T), z(n);
                        } else w(T);
                        N = b(T);
                    }
                    if (null !== N) var l = !0;
                    else {
                        var c = b(S);
                        null !== c && i(O, c.startTime - n), l = !1;
                    }
                    return l;
                } finally{
                    N = null, D = a, C = !1;
                }
            }
            var U = a;
            t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function(e1) {
                e1.callback = null;
            }, t.unstable_continueExecution = function() {
                L || C || (L = !0, n(P));
            }, t.unstable_getCurrentPriorityLevel = function() {
                return D;
            }, t.unstable_getFirstCallbackNode = function() {
                return b(T);
            }, t.unstable_next = function(e1) {
                switch(D){
                    case 1:
                    case 2:
                    case 3:
                        var t = 3;
                        break;
                    default:
                        t = D;
                }
                var n = D;
                D = t;
                try {
                    return e1();
                } finally{
                    D = n;
                }
            }, t.unstable_pauseExecution = function() {}, t.unstable_requestPaint = U, t.unstable_runWithPriority = function(e1, t) {
                switch(e1){
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        break;
                    default:
                        e1 = 3;
                }
                var n = D;
                D = e1;
                try {
                    return t();
                } finally{
                    D = n;
                }
            }, t.unstable_scheduleCallback = function(e1, a, s) {
                var o = t.unstable_now();
                switch(s = "object" == typeof s && null !== s && "number" == typeof (s = s.delay) && 0 < s ? o + s : o, e1){
                    case 1:
                        var l = -1;
                        break;
                    case 2:
                        l = 250;
                        break;
                    case 5:
                        l = 1073741823;
                        break;
                    case 4:
                        l = 1e4;
                        break;
                    default:
                        l = 5e3;
                }
                return e1 = {
                    id: I++,
                    callback: a,
                    priorityLevel: e1,
                    startTime: s,
                    expirationTime: l = s + l,
                    sortIndex: -1
                }, s > o ? (e1.sortIndex = s, _(S, e1), null === b(T) && e1 === b(S) && (R ? r() : R = !0, i(O, s - o))) : (e1.sortIndex = l, _(T, e1), L || C || (L = !0, n(P))), e1;
            }, t.unstable_wrapCallback = function(e1) {
                var t = D;
                return function() {
                    var n = D;
                    D = t;
                    try {
                        return e1.apply(this, arguments);
                    } finally{
                        D = n;
                    }
                };
            };
        },
        817: (e1, t, n)=>{
            "use strict";
            e1.exports = n(582);
        },
        229: function(e1, t, n) {
            var i;
            !function(r, a) {
                "use strict";
                var s = "function", o = "undefined", l = "object", c = "string", u = "major", h = "model", d = "name", p = "type", f = "vendor", m = "version", g = "architecture", A = "console", v = "mobile", M = "tablet", y = "smarttv", x = "wearable", _ = "embedded", b = "Amazon", w = "Apple", E = "ASUS", T = "BlackBerry", S = "Browser", I = "Chrome", N = "Firefox", D = "Google", C = "Huawei", L = "LG", R = "Microsoft", z = "Motorola", O = "Opera", P = "Samsung", U = "Sharp", k = "Sony", j = "Xiaomi", B = "Zebra", F = "Facebook", H = "Chromium OS", V = "Mac OS", G = function(e1) {
                    for(var t = {}, n = 0; n < e1.length; n++)t[e1[n].toUpperCase()] = e1[n];
                    return t;
                }, Q = function(e1, t) {
                    return typeof e1 === c && -1 !== W(t).indexOf(W(e1));
                }, W = function(e1) {
                    return e1.toLowerCase();
                }, Y = function(e1, t) {
                    if (typeof e1 === c) return e1 = e1.replace(/^\s\s*/, ""), typeof t === o ? e1 : e1.substring(0, 500);
                }, X = function(e1, t) {
                    for(var n, i, r, o, c, u, h = 0; h < t.length && !c;){
                        var d = t[h], p = t[h + 1];
                        for(n = i = 0; n < d.length && !c && d[n];)if (c = d[n++].exec(e1)) for(r = 0; r < p.length; r++)u = c[++i], typeof (o = p[r]) === l && o.length > 0 ? 2 === o.length ? typeof o[1] == s ? this[o[0]] = o[1].call(this, u) : this[o[0]] = o[1] : 3 === o.length ? typeof o[1] !== s || o[1].exec && o[1].test ? this[o[0]] = u ? u.replace(o[1], o[2]) : a : this[o[0]] = u ? o[1].call(this, u, o[2]) : a : 4 === o.length && (this[o[0]] = u ? o[3].call(this, u.replace(o[1], o[2])) : a) : this[o] = u || a;
                        h += 2;
                    }
                }, Z = function(e1, t) {
                    for(var n in t)if (typeof t[n] === l && t[n].length > 0) {
                        for(var i = 0; i < t[n].length; i++)if (Q(t[n][i], e1)) return "?" === n ? a : n;
                    } else if (Q(t[n], e1)) return "?" === n ? a : n;
                    return e1;
                }, q = {
                    ME: "4.90",
                    "NT 3.11": "NT3.51",
                    "NT 4.0": "NT4.0",
                    2e3: "NT 5.0",
                    XP: [
                        "NT 5.1",
                        "NT 5.2"
                    ],
                    Vista: "NT 6.0",
                    7: "NT 6.1",
                    8: "NT 6.2",
                    8.1: "NT 6.3",
                    10: [
                        "NT 6.4",
                        "NT 10.0"
                    ],
                    RT: "ARM"
                }, K = {
                    browser: [
                        [
                            /\b(?:crmo|crios)\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Chrome"
                            ]
                        ],
                        [
                            /edg(?:e|ios|a)?\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Edge"
                            ]
                        ],
                        [
                            /(opera mini)\/([-\w\.]+)/i,
                            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /opios[\/ ]+([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                O + " Mini"
                            ]
                        ],
                        [
                            /\bop(?:rg)?x\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                O + " GX"
                            ]
                        ],
                        [
                            /\bopr\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                O
                            ]
                        ],
                        [
                            /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Baidu"
                            ]
                        ],
                        [
                            /(kindle)\/([\w\.]+)/i,
                            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                            /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                            /(?:ms|\()(ie) ([\w\.]+)/i,
                            /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                            /(heytap|ovi)browser\/([\d\.]+)/i,
                            /(weibo)__([\d\.]+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /\bddg\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "DuckDuckGo"
                            ]
                        ],
                        [
                            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "UC" + S
                            ]
                        ],
                        [
                            /microm.+\bqbcore\/([\w\.]+)/i,
                            /\bqbcore\/([\w\.]+).+microm/i,
                            /micromessenger\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "WeChat"
                            ]
                        ],
                        [
                            /konqueror\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Konqueror"
                            ]
                        ],
                        [
                            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
                        ],
                        [
                            m,
                            [
                                d,
                                "IE"
                            ]
                        ],
                        [
                            /ya(?:search)?browser\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Yandex"
                            ]
                        ],
                        [
                            /slbrowser\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Smart Lenovo " + S
                            ]
                        ],
                        [
                            /(avast|avg)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 Secure " + S
                            ],
                            m
                        ],
                        [
                            /\bfocus\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                N + " Focus"
                            ]
                        ],
                        [
                            /\bopt\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                O + " Touch"
                            ]
                        ],
                        [
                            /coc_coc\w+\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Coc Coc"
                            ]
                        ],
                        [
                            /dolfin\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Dolphin"
                            ]
                        ],
                        [
                            /coast\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                O + " Coast"
                            ]
                        ],
                        [
                            /miuibrowser\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "MIUI " + S
                            ]
                        ],
                        [
                            /fxios\/([-\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                N
                            ]
                        ],
                        [
                            /\bqihu|(qi?ho?o?|360)browser/i
                        ],
                        [
                            [
                                d,
                                "360 " + S
                            ]
                        ],
                        [
                            /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /(.+)/,
                                "$1 " + S
                            ],
                            m
                        ],
                        [
                            /samsungbrowser\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                P + " Internet"
                            ]
                        ],
                        [
                            /(comodo_dragon)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                /_/g,
                                " "
                            ],
                            m
                        ],
                        [
                            /metasr[\/ ]?([\d\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Sogou Explorer"
                            ]
                        ],
                        [
                            /(sogou)mo\w+\/([\d\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Sogou Mobile"
                            ],
                            m
                        ],
                        [
                            /(electron)\/([\w\.]+) safari/i,
                            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                            /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /(lbbrowser)/i,
                            /\[(linkedin)app\]/i
                        ],
                        [
                            d
                        ],
                        [
                            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
                        ],
                        [
                            [
                                d,
                                F
                            ],
                            m
                        ],
                        [
                            /(Klarna)\/([\w\.]+)/i,
                            /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                            /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                            /safari (line)\/([\w\.]+)/i,
                            /\b(line)\/([\w\.]+)\/iab/i,
                            /(alipay)client\/([\w\.]+)/i,
                            /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                            /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /\bgsa\/([\w\.]+) .*safari\//i
                        ],
                        [
                            m,
                            [
                                d,
                                "GSA"
                            ]
                        ],
                        [
                            /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "TikTok"
                            ]
                        ],
                        [
                            /headlesschrome(?:\/([\w\.]+)| )/i
                        ],
                        [
                            m,
                            [
                                d,
                                I + " Headless"
                            ]
                        ],
                        [
                            / wv\).+(chrome)\/([\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                I + " WebView"
                            ],
                            m
                        ],
                        [
                            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Android " + S
                            ]
                        ],
                        [
                            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Mobile Safari"
                            ]
                        ],
                        [
                            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
                        ],
                        [
                            m,
                            d
                        ],
                        [
                            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
                        ],
                        [
                            d,
                            [
                                m,
                                Z,
                                {
                                    "1.0": "/8",
                                    1.2: "/1",
                                    1.3: "/3",
                                    "2.0": "/412",
                                    "2.0.2": "/416",
                                    "2.0.3": "/417",
                                    "2.0.4": "/419",
                                    "?": "/"
                                }
                            ]
                        ],
                        [
                            /(webkit|khtml)\/([\w\.]+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /(navigator|netscape\d?)\/([-\w\.]+)/i
                        ],
                        [
                            [
                                d,
                                "Netscape"
                            ],
                            m
                        ],
                        [
                            /mobile vr; rv:([\w\.]+)\).+firefox/i
                        ],
                        [
                            m,
                            [
                                d,
                                N + " Reality"
                            ]
                        ],
                        [
                            /ekiohf.+(flow)\/([\w\.]+)/i,
                            /(swiftfox)/i,
                            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                            /(firefox)\/([\w\.]+)/i,
                            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                            /(links) \(([\w\.]+)/i,
                            /panasonic;(viera)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /(cobalt)\/([\w\.]+)/i
                        ],
                        [
                            d,
                            [
                                m,
                                /master.|lts./,
                                ""
                            ]
                        ]
                    ],
                    cpu: [
                        [
                            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "amd64"
                            ]
                        ],
                        [
                            /(ia32(?=;))/i
                        ],
                        [
                            [
                                g,
                                W
                            ]
                        ],
                        [
                            /((?:i[346]|x)86)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "ia32"
                            ]
                        ],
                        [
                            /\b(aarch64|arm(v?8e?l?|_?64))\b/i
                        ],
                        [
                            [
                                g,
                                "arm64"
                            ]
                        ],
                        [
                            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
                        ],
                        [
                            [
                                g,
                                "armhf"
                            ]
                        ],
                        [
                            /windows (ce|mobile); ppc;/i
                        ],
                        [
                            [
                                g,
                                "arm"
                            ]
                        ],
                        [
                            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
                        ],
                        [
                            [
                                g,
                                /ower/,
                                "",
                                W
                            ]
                        ],
                        [
                            /(sun4\w)[;\)]/i
                        ],
                        [
                            [
                                g,
                                "sparc"
                            ]
                        ],
                        [
                            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                        ],
                        [
                            [
                                g,
                                W
                            ]
                        ]
                    ],
                    device: [
                        [
                            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
                        ],
                        [
                            h,
                            [
                                f,
                                P
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                            /samsung[- ]([-\w]+)/i,
                            /sec-(sgh\w+)/i
                        ],
                        [
                            h,
                            [
                                f,
                                P
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
                        ],
                        [
                            h,
                            [
                                f,
                                w
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\((ipad);[-\w\),; ]+apple/i,
                            /applecoremedia\/[\w\.]+ \((ipad)/i,
                            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
                        ],
                        [
                            h,
                            [
                                f,
                                w
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(macintosh);/i
                        ],
                        [
                            h,
                            [
                                f,
                                w
                            ]
                        ],
                        [
                            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
                        ],
                        [
                            h,
                            [
                                f,
                                U
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
                        ],
                        [
                            h,
                            [
                                f,
                                C
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(?:huawei|honor)([-\w ]+)[;\)]/i,
                            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
                        ],
                        [
                            h,
                            [
                                f,
                                C
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                            /\b; (\w+) build\/hm\1/i,
                            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                            /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                f,
                                j
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                f,
                                j
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /; (\w+) bui.+ oppo/i,
                            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "OPPO"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(opd2\d{3}a?) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                "OPPO"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /vivo (\w+)(?: bui|\))/i,
                            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Vivo"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Realme"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                            /\bmot(?:orola)?[- ](\w*)/i,
                            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
                        ],
                        [
                            h,
                            [
                                f,
                                z
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
                        ],
                        [
                            h,
                            [
                                f,
                                z
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
                        ],
                        [
                            h,
                            [
                                f,
                                L
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                            /\blg-?([\d\w]+) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                L
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(ideatab[-\w ]+)/i,
                            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Lenovo"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(?:maemo|nokia).*(n900|lumia \d+)/i,
                            /nokia[-_ ]?([-\w\.]*)/i
                        ],
                        [
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                f,
                                "Nokia"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(pixel c)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                D
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                D
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
                        ],
                        [
                            h,
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /sony tablet [ps]/i,
                            /\b(?:sony)?sgp\w+(?: bui|\))/i
                        ],
                        [
                            [
                                h,
                                "Xperia Tablet"
                            ],
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            / (kb2005|in20[12]5|be20[12][59])\b/i,
                            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "OnePlus"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(alexa)webm/i,
                            /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                            /(kf[a-z]+)( bui|\)).+silk\//i
                        ],
                        [
                            h,
                            [
                                f,
                                b
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
                        ],
                        [
                            [
                                h,
                                /(.+)/g,
                                "Fire Phone $1"
                            ],
                            [
                                f,
                                b
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(playbook);[-\w\),; ]+(rim)/i
                        ],
                        [
                            h,
                            f,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b((?:bb[a-f]|st[hv])100-\d)/i,
                            /\(bb10; (\w+)/i
                        ],
                        [
                            h,
                            [
                                f,
                                T
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
                        ],
                        [
                            h,
                            [
                                f,
                                E
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                E
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(nexus 9)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "HTC"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                            /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
                        ],
                        [
                            f,
                            [
                                h,
                                /_/g,
                                " "
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Acer"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+; (m[1-5] note) bui/i,
                            /\bmz-([-\w]{2,})/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Meizu"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Ulefone"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                            /(hp) ([\w ]+\w)/i,
                            /(asus)-?(\w+)/i,
                            /(microsoft); (lumia[\w ]+)/i,
                            /(lenovo)[-_ ]?([-\w]+)/i,
                            /(jolla)/i,
                            /(oppo) ?([\w ]+) bui/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(kobo)\s(ereader|touch)/i,
                            /(archos) (gamepad2?)/i,
                            /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                            /(kindle)\/([\w\.]+)/i,
                            /(nook)[\w ]+build\/(\w+)/i,
                            /(dell) (strea[kpr\d ]*[\dko])/i,
                            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                            /(trinity)[- ]*(t\d{3}) bui/i,
                            /(gigaset)[- ]+(q\w{1,9}) bui/i,
                            /(vodafone) ([\w ]+)(?:\)| bui)/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(surface duo)/i
                        ],
                        [
                            h,
                            [
                                f,
                                R
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid [\d\.]+; (fp\du?)(?: b|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Fairphone"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(u304aa)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "AT&T"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\bsie-(\w*)/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Siemens"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(rct\w+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "RCA"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(venue[\d ]{2,7}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Dell"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(q(?:mv|ta)\w+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Verizon"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Barnes & Noble"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(tm\d{3}\w+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "NuVision"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(k88) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "ZTE"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(nx\d{3}j) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "ZTE"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(gen\d{3}) b.+49h/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Swiss"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(zur\d{3}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Swiss"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b((zeki)?tb.*\b) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Zeki"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b([yr]\d{2}) b/i,
                            /\b(dragon[- ]+touch |dt)(\w{5}) b/i
                        ],
                        [
                            [
                                f,
                                "Dragon Touch"
                            ],
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(ns-?\w{0,9}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Insignia"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b((nxa|next)-?\w{0,9}) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "NextBook"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
                        ],
                        [
                            [
                                f,
                                "Voice"
                            ],
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(lvtel\-)?(v1[12]) b/i
                        ],
                        [
                            [
                                f,
                                "LvTel"
                            ],
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(ph-1) /i
                        ],
                        [
                            h,
                            [
                                f,
                                "Essential"
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /\b(v(100md|700na|7011|917g).*\b) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Envizen"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b(trio[-\w\. ]+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "MachSpeed"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\btu_(1491) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Rotor"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(shield[\w ]+) b/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Nvidia"
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(sprint) (\w+)/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(kin\.[onetw]{3})/i
                        ],
                        [
                            [
                                h,
                                /\./g,
                                " "
                            ],
                            [
                                f,
                                R
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                B
                            ],
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                B
                            ],
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /smart-tv.+(samsung)/i
                        ],
                        [
                            f,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /hbbtv.+maple;(\d+)/i
                        ],
                        [
                            [
                                h,
                                /^/,
                                "SmartTV"
                            ],
                            [
                                f,
                                P
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
                        ],
                        [
                            [
                                f,
                                L
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(apple) ?tv/i
                        ],
                        [
                            f,
                            [
                                h,
                                w + " TV"
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /crkey/i
                        ],
                        [
                            [
                                h,
                                I + "cast"
                            ],
                            [
                                f,
                                D
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /droid.+aft(\w+)( bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                b
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\(dtv[\);].+(aquos)/i,
                            /(aquos-tv[\w ]+)\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                U
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(bravia[\w ]+)( bui|\))/i
                        ],
                        [
                            h,
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(mitv-\w{5}) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                j
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /Hbbtv.*(technisat) (.*);/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                            /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
                        ],
                        [
                            [
                                f,
                                Y
                            ],
                            [
                                h,
                                Y
                            ],
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
                        ],
                        [
                            [
                                p,
                                y
                            ]
                        ],
                        [
                            /(ouya)/i,
                            /(nintendo) ([wids3utch]+)/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                A
                            ]
                        ],
                        [
                            /droid.+; (shield) bui/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Nvidia"
                            ],
                            [
                                p,
                                A
                            ]
                        ],
                        [
                            /(playstation [345portablevi]+)/i
                        ],
                        [
                            h,
                            [
                                f,
                                k
                            ],
                            [
                                p,
                                A
                            ]
                        ],
                        [
                            /\b(xbox(?: one)?(?!; xbox))[\); ]/i
                        ],
                        [
                            h,
                            [
                                f,
                                R
                            ],
                            [
                                p,
                                A
                            ]
                        ],
                        [
                            /((pebble))app/i
                        ],
                        [
                            f,
                            h,
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
                        ],
                        [
                            h,
                            [
                                f,
                                w
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /droid.+; (glass) \d/i
                        ],
                        [
                            h,
                            [
                                f,
                                D
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /droid.+; (wt63?0{2,3})\)/i
                        ],
                        [
                            h,
                            [
                                f,
                                B
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(quest( \d| pro)?)/i
                        ],
                        [
                            h,
                            [
                                f,
                                F
                            ],
                            [
                                p,
                                x
                            ]
                        ],
                        [
                            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
                        ],
                        [
                            f,
                            [
                                p,
                                _
                            ]
                        ],
                        [
                            /(aeobc)\b/i
                        ],
                        [
                            h,
                            [
                                f,
                                b
                            ],
                            [
                                p,
                                _
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
                        ],
                        [
                            h,
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
                        ],
                        [
                            h,
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
                        ],
                        [
                            [
                                p,
                                M
                            ]
                        ],
                        [
                            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
                        ],
                        [
                            [
                                p,
                                v
                            ]
                        ],
                        [
                            /(android[-\w\. ]{0,9});.+buil/i
                        ],
                        [
                            h,
                            [
                                f,
                                "Generic"
                            ]
                        ]
                    ],
                    engine: [
                        [
                            /windows.+ edge\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "EdgeHTML"
                            ]
                        ],
                        [
                            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Blink"
                            ]
                        ],
                        [
                            /(presto)\/([\w\.]+)/i,
                            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                            /ekioh(flow)\/([\w\.]+)/i,
                            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                            /(icab)[\/ ]([23]\.[\d\.]+)/i,
                            /\b(libweb)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /rv\:([\w\.]{1,9})\b.+(gecko)/i
                        ],
                        [
                            m,
                            d
                        ]
                    ],
                    os: [
                        [
                            /microsoft (windows) (vista|xp)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
                        ],
                        [
                            d,
                            [
                                m,
                                Z,
                                q
                            ]
                        ],
                        [
                            /windows nt 6\.2; (arm)/i,
                            /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                            /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
                        ],
                        [
                            [
                                m,
                                Z,
                                q
                            ],
                            [
                                d,
                                "Windows"
                            ]
                        ],
                        [
                            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                            /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                            /cfnetwork\/.+darwin/i
                        ],
                        [
                            [
                                m,
                                /_/g,
                                "."
                            ],
                            [
                                d,
                                "iOS"
                            ]
                        ],
                        [
                            /(mac os x) ?([\w\. ]*)/i,
                            /(macintosh|mac_powerpc\b)(?!.+haiku)/i
                        ],
                        [
                            [
                                d,
                                V
                            ],
                            [
                                m,
                                /_/g,
                                "."
                            ]
                        ],
                        [
                            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
                        ],
                        [
                            m,
                            d
                        ],
                        [
                            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                            /(blackberry)\w*\/([\w\.]*)/i,
                            /(tizen|kaios)[\/ ]([\w\.]+)/i,
                            /\((series40);/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /\(bb(10);/i
                        ],
                        [
                            m,
                            [
                                d,
                                T
                            ]
                        ],
                        [
                            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "Symbian"
                            ]
                        ],
                        [
                            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                N + " OS"
                            ]
                        ],
                        [
                            /web0s;.+rt(tv)/i,
                            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "webOS"
                            ]
                        ],
                        [
                            /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                "watchOS"
                            ]
                        ],
                        [
                            /crkey\/([\d\.]+)/i
                        ],
                        [
                            m,
                            [
                                d,
                                I + "cast"
                            ]
                        ],
                        [
                            /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
                        ],
                        [
                            [
                                d,
                                H
                            ],
                            m
                        ],
                        [
                            /panasonic;(viera)/i,
                            /(netrange)mmh/i,
                            /(nettv)\/(\d+\.[\w\.]+)/i,
                            /(nintendo|playstation) ([wids345portablevuch]+)/i,
                            /(xbox); +xbox ([^\);]+)/i,
                            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                            /(mint)[\/\(\) ]?(\w*)/i,
                            /(mageia|vectorlinux)[; ]/i,
                            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                            /(hurd|linux) ?([\w\.]*)/i,
                            /(gnu) ?([\w\.]*)/i,
                            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                            /(haiku) (\w+)/i
                        ],
                        [
                            d,
                            m
                        ],
                        [
                            /(sunos) ?([\w\.\d]*)/i
                        ],
                        [
                            [
                                d,
                                "Solaris"
                            ],
                            m
                        ],
                        [
                            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                            /(unix) ?([\w\.]*)/i
                        ],
                        [
                            d,
                            m
                        ]
                    ]
                }, J = function(e1, t) {
                    if (typeof e1 === l && (t = e1, e1 = a), !(this instanceof J)) return new J(e1, t).getResult();
                    var n = typeof r !== o && r.navigator ? r.navigator : a, i = e1 || (n && n.userAgent ? n.userAgent : ""), A = n && n.userAgentData ? n.userAgentData : a, y = t ? function(e1, t) {
                        var n = {};
                        for(var i in e1)t[i] && t[i].length % 2 == 0 ? n[i] = t[i].concat(e1[i]) : n[i] = e1[i];
                        return n;
                    }(K, t) : K, x = n && n.userAgent == i;
                    return this.getBrowser = function() {
                        var e1, t = {};
                        return t[d] = a, t[m] = a, X.call(t, i, y.browser), t[u] = typeof (e1 = t[m]) === c ? e1.replace(/[^\d\.]/g, "").split(".")[0] : a, x && n && n.brave && typeof n.brave.isBrave == s && (t[d] = "Brave"), t;
                    }, this.getCPU = function() {
                        var e1 = {};
                        return e1[g] = a, X.call(e1, i, y.cpu), e1;
                    }, this.getDevice = function() {
                        var e1 = {};
                        return e1[f] = a, e1[h] = a, e1[p] = a, X.call(e1, i, y.device), x && !e1[p] && A && A.mobile && (e1[p] = v), x && "Macintosh" == e1[h] && n && typeof n.standalone !== o && n.maxTouchPoints && n.maxTouchPoints > 2 && (e1[h] = "iPad", e1[p] = M), e1;
                    }, this.getEngine = function() {
                        var e1 = {};
                        return e1[d] = a, e1[m] = a, X.call(e1, i, y.engine), e1;
                    }, this.getOS = function() {
                        var e1 = {};
                        return e1[d] = a, e1[m] = a, X.call(e1, i, y.os), x && !e1[d] && A && A.platform && "Unknown" != A.platform && (e1[d] = A.platform.replace(/chrome os/i, H).replace(/macos/i, V)), e1;
                    }, this.getResult = function() {
                        return {
                            ua: this.getUA(),
                            browser: this.getBrowser(),
                            engine: this.getEngine(),
                            os: this.getOS(),
                            device: this.getDevice(),
                            cpu: this.getCPU()
                        };
                    }, this.getUA = function() {
                        return i;
                    }, this.setUA = function(e1) {
                        return i = typeof e1 === c && e1.length > 500 ? Y(e1, 500) : e1, this;
                    }, this.setUA(i), this;
                };
                J.VERSION = "1.0.38", J.BROWSER = G([
                    d,
                    m,
                    u
                ]), J.CPU = G([
                    g
                ]), J.DEVICE = G([
                    h,
                    f,
                    p,
                    A,
                    v,
                    y,
                    M,
                    x,
                    _
                ]), J.ENGINE = J.OS = G([
                    d,
                    m
                ]), typeof t !== o ? (e1.exports && (t = e1.exports = J), t.UAParser = J) : n.amdO ? (i = (function() {
                    return J;
                }).call(t, n, t, e1)) === a || (e1.exports = i) : typeof r !== o && (r.UAParser = J);
                var $ = typeof r !== o && (r.jQuery || r.Zepto);
                if ($ && !$.ua) {
                    var ee = new J;
                    $.ua = ee.getResult(), $.ua.get = function() {
                        return ee.getUA();
                    }, $.ua.set = function(e1) {
                        ee.setUA(e1);
                        var t = ee.getResult();
                        for(var n in t)$.ua[n] = t[n];
                    };
                }
            }("object" == typeof window ? window : this);
        },
        447: (e1)=>{
            function t(e1, t, n) {
                e1.addEventListener("wheel", t, n);
            }
            e1.exports = t, e1.exports.addWheelListener = t, e1.exports.removeWheelListener = function(e1, t, n) {
                e1.removeEventListener("wheel", t, n);
            };
        },
        234: (e1, t, n)=>{
            "use strict";
            n.d(t, {
                A: ()=>f
            });
            var i = n(248), r = n.n(i), a = n(89), s = n.n(a), o = n(492), l = n.n(o), c = new URL(n(877), n.b), u = new URL(n(709), n.b), h = s()(r()), d = l()(c), p = l()(u);
            h.push([
                e1.id,
                `@font-face{font-family:"Roboto Mono";font-style:normal;font-display:swap;font-weight:100;src:url(${d}) format("woff2"),url(${p}) format("woff")}`,
                ""
            ]);
            const f = h;
        },
        744: (e1, t, n)=>{
            "use strict";
            n.d(t, {
                A: ()=>f
            });
            var i = n(248), r = n.n(i), a = n(89), s = n.n(a), o = n(492), l = n.n(o), c = new URL(n(67), n.b), u = new URL(n(907), n.b), h = s()(r()), d = l()(c), p = l()(u);
            h.push([
                e1.id,
                `@font-face{font-family:"Roboto Mono";font-style:normal;font-display:swap;font-weight:700;src:url(${d}) format("woff2"),url(${p}) format("woff")}`,
                ""
            ]);
            const f = h;
        },
        19: (e1, t, n)=>{
            "use strict";
            n.d(t, {
                A: ()=>f
            });
            var i = n(248), r = n.n(i), a = n(89), s = n.n(a), o = n(492), l = n.n(o), c = new URL(n(702), n.b), u = new URL(n(356), n.b), h = s()(r()), d = l()(c), p = l()(u);
            h.push([
                e1.id,
                `@font-face{font-family:"Roboto Mono";font-style:normal;font-display:swap;font-weight:100;src:url(${d}) format("woff2"),url(${p}) format("woff")}`,
                ""
            ]);
            const f = h;
        },
        465: (e1, t, n)=>{
            "use strict";
            n.d(t, {
                A: ()=>f
            });
            var i = n(248), r = n.n(i), a = n(89), s = n.n(a), o = n(492), l = n.n(o), c = new URL(n(756), n.b), u = new URL(n(314), n.b), h = s()(r()), d = l()(c), p = l()(u);
            h.push([
                e1.id,
                `@font-face{font-family:"Roboto Mono";font-style:normal;font-display:swap;font-weight:700;src:url(${d}) format("woff2"),url(${p}) format("woff")}`,
                ""
            ]);
            const f = h;
        },
        132: (e1, t, n)=>{
            "use strict";
            n.d(t, {
                A: ()=>o
            });
            var i = n(248), r = n.n(i), a = n(89), s = n.n(a)()(r());
            s.push([
                e1.id,
                '.widget-application{--main-color: #FAC62D;--main-text: #413E3E;width:100%;height:100%;flex:none;overflow:hidden;position:relative;z-index:1;background-color:#fff;font-size:20px}.widget-application *,.widget-application *:before,.widget-application *:after{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:"Roboto Mono",monospace;text-decoration:none;font-weight:700;color:#413e3e;outline:none;padding:0;margin:0;box-sizing:border-box;-webkit-box-sizing:border-box}.widget-application .widget-logo{position:absolute;left:45px;top:30px;z-index:3}.widget-application--tablet.widget-application .widget-logo{left:36px;top:39px}.widget-application--mobile.widget-application .widget-logo{left:23px;top:24px}.widget-application--smallMobile.widget-application .widget-logo{left:23px;top:21px}.widget-application .widget-logo img{display:block;width:82px;height:82px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-logo img{width:58px;height:58px}.widget-application--mobile.widget-application .widget-logo img{width:36px;height:36px}.widget-application--smallMobile.widget-application .widget-logo img{width:28px;height:28px}.widget-application .widget-tab__panorama-close-map{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-tab__panorama-close-map{right:30px;top:35px}.widget-application--mobile.widget-application .widget-tab__panorama-close-map{padding:5px;right:22px;top:20px}.widget-application .widget-tab__panorama-close-map img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-tab__panorama-close-map img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-tab__panorama-close-map img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-tab__panorama-close-map img{width:26px;height:26px}.widget-application .widget-enter-fullscreen{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-enter-fullscreen{right:30px;top:35px}.widget-application--mobile.widget-application .widget-enter-fullscreen{padding:5px;right:22px;top:20px}.widget-application .widget-enter-fullscreen img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-enter-fullscreen img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-enter-fullscreen img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-enter-fullscreen img{width:26px;height:26px}.widget-application .widget-exit-fullscreen{position:absolute;right:45px;top:36px;z-index:3;padding:10px;touch-action:none;ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer}.widget-application--tablet.widget-application .widget-exit-fullscreen{right:30px;top:35px}.widget-application--mobile.widget-application .widget-exit-fullscreen{padding:5px;right:22px;top:20px}.widget-application .widget-exit-fullscreen img{display:block;width:50px;height:50px;object-fit:contain;object-position:center}.widget-application--tablet.widget-application .widget-exit-fullscreen img{width:40px;height:40px}.widget-application--mobile.widget-application .widget-exit-fullscreen img{width:32px;height:32px}.widget-application--smallMobile.widget-application .widget-exit-fullscreen img{width:26px;height:26px}.widget-application .widget-tab-buttons{position:absolute;z-index:3;right:44px;bottom:35px;display:flex;align-items:center;justify-content:flex-end}.widget-application--tablet.widget-application .widget-tab-buttons{right:35px;bottom:35px}.widget-application--mobile.widget-application .widget-tab-buttons{right:22px;bottom:22px}.widget-application--smallMobile.widget-application .widget-tab-buttons{right:20px;bottom:30px}.widget-application .widget-tab-buttons-vertical{flex-direction:column;row-gap:28px;bottom:120px;right:30px}.widget-application--tablet.widget-application .widget-tab-buttons-vertical{bottom:120px;right:30px}.widget-application--mobile.widget-application .widget-tab-buttons-vertical{row-gap:10px;bottom:90px;right:21px}.widget-application .widget-tab-buttons-vertical .widget-tab-button{font-size:19px;font-weight:700;line-height:26px;width:50px;height:50px}.widget-application--tablet.widget-application .widget-tab-buttons-vertical .widget-tab-button{font-size:19px;font-weight:700;line-height:26px;width:50px;height:50px}.widget-application--mobile.widget-application .widget-tab-buttons-vertical .widget-tab-button{font-size:17px;line-height:23px;width:44px;height:44px}.widget-application .widget-tab-button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:72px;height:72px;border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:#eaeaea;color:#413e3e;font-size:28px;line-height:120%;font-weight:700;margin-left:40px}.widget-application--tablet.widget-application .widget-tab-button{margin-left:20px;width:60px;height:60px;font-size:22px}.widget-application--mobile.widget-application .widget-tab-button{margin-left:10px;font-size:17px;width:44px;height:44px}.widget-application--smallMobile.widget-application .widget-tab-button{width:36px;height:36px;font-size:14px}.widget-application .widget-tab-button--active{background-color:var(--main-color);color:var(--main-text)}.widget-application .widget-tab-button--active img{filter:invert(100%) sepia(99%) saturate(0%) hue-rotate(97deg) brightness(105%) contrast(100%)}.widget-application .widget-tab-button img{width:38px;height:28px}.widget-application--mobile.widget-application .widget-tab-button img{width:33px;height:25px}.widget-application .widget-tab{width:100%;height:100%;display:flex;align-items:center;justify-content:center;padding:60px 30px}.widget-application--smallMobile.widget-application .widget-tab{padding:60px 20px}.widget-application .widget-tab--rotation{padding:0 !important}.widget-application .widget-tab-menu{position:absolute;z-index:3;left:15px;top:15px;max-height:100%;overflow-y:auto;padding-bottom:30px}.widget-application .widget-tab-menu__wallpapers{display:flex;flex-wrap:wrap;align-items:flex-start;margin-top:10px;width:100%}.widget-application .widget-tab-menu__wallpapers img{width:30px;height:30px;display:block;object-fit:cover;cursor:pointer;margin-right:10px;margin-block-end:10px}.widget-application .widget-tab-menu ul{list-style-type:none}.widget-application .widget-tab-menu ul li{color:#413e3e;background-color:var(--main-color);padding:5px 15px;border-radius:10px;font-size:.7rem;border:none;cursor:pointer;margin-bottom:15px;width:200px;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none}.widget-application .widget-tab-menu ul li label{display:flex;cursor:inherit;width:100%}.widget-application .widget-tab-menu ul li input[type=color]{cursor:pointer;margin-left:auto;width:50px;height:20px;border:0;border-radius:5px}.widget-application .widget-tab-menu ul li input[type=color]::-webkit-color-swatch-wrapper{display:none !important}.widget-application .widget-tab-menu ul li input[type=file]{display:none}.widget-application .widget-tab-menu ul li:nth-child(1){position:relative}.widget-application .widget-tab-menu ul li:nth-child(1)::after{--bar-width: 2px;content:"";width:20px;height:15px;display:block;background:repeating-linear-gradient(180deg, #000000, #000000 var(--bar-width), rgba(0, 0, 0, 0) var(--bar-width), rgba(0, 0, 0, 0) calc(var(--bar-width) * 3));position:absolute;right:10px;top:50%;transform:translateY(-50%)}.widget-application--mobile.widget-application .widget-tab--area~.widget-tab-buttons-vertical{bottom:23px;right:22px;flex-direction:row}.widget-application .widget-tab--area .widget-tab__isometry-arrows{bottom:119px;height:42px}.widget-application--tablet.widget-application .widget-tab--area .widget-tab__isometry-arrows{bottom:119px;height:42px}.widget-application--mobile.widget-application .widget-tab--area .widget-tab__isometry-arrows{bottom:180px}.widget-application .widget-tab--area .widget-tab__isometry-arrows span{font-size:14px;font-weight:700;line-height:18px;margin:0 2px}.widget-application--tablet.widget-application .widget-tab--area .widget-tab__isometry-arrows span{font-size:14px;font-weight:700;line-height:18px;margin:0 2px}.widget-application .widget-tab--area .widget-tab__isometry-arrow img{width:16px;height:16px}.widget-application--tablet.widget-application .widget-tab--area .widget-tab__isometry-arrow img{width:16px;height:16px}.widget-application .widget-instructions{position:absolute;z-index:2;left:0;top:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;background-position:center;background-repeat:no-repeat;background-size:cover}.widget-application .widget-instructions__content{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;background-color:rgba(234,234,234,.85);border-radius:20px;overflow:hidden;width:400px;max-width:calc(100% - 60px);padding:36px 30px 30px 30px;backdrop-filter:blur(5px);-moz-backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px)}.widget-application--mobile.widget-application .widget-instructions__content{width:280px;padding:26px 20px 20px 20px}.widget-application .widget-instructions__steps{display:flex;align-items:flex-start;justify-content:center}.widget-application .widget-instructions__step{display:flex;flex-direction:column;align-items:center;justify-content:flex-start;margin:0 15px}.widget-application--tablet.widget-application .widget-instructions__step{margin:0 10px}.widget-application .widget-instructions__step img{display:block;width:52px;height:80px;object-fit:contain;object-position:center}.widget-application--mobile.widget-application .widget-instructions__step img{width:40px;height:60px}.widget-application--smallMobile.widget-application .widget-instructions__step img{width:35px}.widget-application .widget-instructions__step p{color:#413e3e;font-size:20px;font-weight:700;text-align:center;margin-top:10px;max-width:130px}.widget-application--tablet.widget-application .widget-instructions__step p{font-size:18px;max-width:115px}.widget-application--mobile.widget-application .widget-instructions__step p{font-size:16px}.widget-application--smallMobile.widget-application .widget-instructions__step p{font-size:14px}.widget-application .widget-instructions__hint p{color:#413e3e;font-weight:700;text-align:center;margin-top:1.5em;font-size:14px}.widget-application--tablet.widget-application .widget-instructions__hint p{font-size:12px}.widget-application--mobile.widget-application .widget-instructions__hint p{font-size:10px}.widget-application--smallMobile.widget-application .widget-instructions__hint p{font-size:8px}.widget-application .widget-instructions button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;display:flex;align-items:center;justify-content:center;height:44px;padding:0 33px;border-radius:52px;background-color:var(--main-color);color:var(--main-text);font-size:24px;font-weight:700;text-transform:uppercase;margin:25px auto 0 auto}.widget-application .widget-instructions button:disabled{opacity:.75;cursor:not-allowed}.widget-application--tablet.widget-application .widget-instructions button{font-size:18px;height:40px}.widget-application--mobile.widget-application .widget-instructions button{font-size:16px;height:35px}.widget-application--smallMobile.widget-application .widget-instructions button{font-size:14px;height:26px;padding:0 25px}.widget-application .widget-tab__panorama{width:100%;height:100%;position:absolute;left:0;top:0;z-index:2}.widget-application .widget-tab__panorama-overlay{width:100%;height:100%;overflow:hidden;background:#fff !important}.widget-application .widget-tab__panorama-overlay *{display:none !important}.widget-application .widget-tab__panorama-overlay canvas{display:block !important}.widget-application .widget-tab__panorama-enter-vr{position:absolute;left:50%;bottom:50px;transform:translateX(-50%);z-index:3;padding:10px 15px;border-radius:10px;border:2px solid #000;background-color:#fff;font-size:16px;font-weight:600;cursor:pointer}.widget-application .widget-tab__panorama-enter-vr:disabled{opacity:.5}.widget-application .widget-tab__panorama-controls{position:absolute;z-index:2;left:50%;bottom:35px;display:flex;align-items:center;justify-content:center;padding:8px;border-radius:38px;background-color:rgba(0,0,0,.2);transform:translateX(-50%);backdrop-filter:blur(5px);-moz-backdrop-filter:blur(5px);-webkit-backdrop-filter:blur(5px)}.widget-application--mobile.widget-application .widget-tab__panorama-controls{padding:5px;bottom:22px}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls{bottom:30px}.widget-application .widget-tab__panorama-controls-container{position:absolute;left:50%;bottom:35px;display:flex;column-gap:5px;transform:translateX(-50%)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container{bottom:25px}.widget-application .widget-tab__panorama-controls-container>div{position:unset;left:unset;bottom:unset;padding:5px;transform:translateX(0)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container>div{padding:4px}.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button{width:40px;height:40px;margin-right:11px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button{width:34px;height:34px;margin-right:9px}.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:22px}.widget-application--tablet.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:32px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-container .widget-tab__panorama-controls-button img{width:37px}.widget-application .widget-tab__panorama-controls-button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:55px;height:55px;border-radius:50%;background-color:#fff;display:flex;align-items:center;justify-content:center;margin-right:18px}.widget-application--tablet.widget-application .widget-tab__panorama-controls-button{width:44px;height:44px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button{margin-right:10px;width:33px;height:33px}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls-button{width:26px;height:26px}.widget-application .widget-tab__panorama-controls-button:disabled{background-color:#e6e6e6;cursor:not-allowed}.widget-application .widget-tab__panorama-controls-button:disabled img{filter:invert(100%) saturate(0)}.widget-application .widget-tab__panorama-controls-button img{display:block}.widget-application--tablet.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.7)}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.52)}.widget-application--smallMobile.widget-application .widget-tab__panorama-controls-button img{transform:scale(0.45)}.widget-application .widget-tab__panorama-controls-button:nth-last-child(1){margin-right:0}.widget-application .widget-tab__panorama-controls-button--bareshell{display:flex;align-items:center;column-gap:10px;padding:11px 9px 9px 8px;background:none;border:none;cursor:pointer}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell{column-gap:7px;padding:8px 8px 8px 6px}.widget-application .widget-tab__panorama-controls-button--bareshell .checked{right:calc(100% - 2px);transform:translateX(-100%)}.widget-application .widget-tab__panorama-controls-button--bareshell-text{font-size:15px;font-weight:700;line-height:20px;color:#fff}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-text{font-size:13px;line-height:17px}.widget-application .widget-tab__panorama-controls-button--bareshell-switch{position:relative;width:34px;height:19px}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-switch{width:28px;height:16px}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-checkbox{height:0;width:0;visibility:hidden}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-checkbox:checked+.widget-tab__panorama-controls-button--bareshell-switch-label .widget-tab__panorama-controls-button--bareshell-switch-button{right:calc(100% - 2px);transform:translateX(100%)}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label{position:absolute;top:0;display:flex;align-items:center;justify-content:space-between;width:34px;height:19px;background-color:#fff;border-radius:20px;border:1px solid #fff;transition:background-color .2s}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label{width:28px;height:16px}.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label .widget-tab__panorama-controls-button--bareshell-switch-button{content:"";position:absolute;top:1px;right:1px;width:14px;height:14px;border-radius:45px;transition:.2s;background:#413e3e}.widget-application--mobile.widget-application .widget-tab__panorama-controls-button--bareshell-switch-label .widget-tab__panorama-controls-button--bareshell-switch-button{width:12px;height:12px}.widget-application .widget-tab__panorama-controls-button span{font-size:23px;font-weight:700;line-height:120%;letter-spacing:-0.12em}.widget-application .widget-tab__panorama-close-map{z-index:4}.widget-application .widget-tab__panorama-map{position:absolute;left:45px;bottom:35px;z-index:3;border-radius:10px;opacity:1;transition:opacity .5s;padding:8px;background-color:#fff;touch-action:none;-webkit-touch-action:none}.widget-application .widget-tab__panorama-map::before{content:"";position:absolute;z-index:-1;left:50%;top:50%;transform:translate(-50%, -50%);width:100%;height:100%;border-radius:inherit;background-color:#fff}.widget-application--tablet.widget-application .widget-tab__panorama-map{left:35px;transform:scale(0.6);transform-origin:0% 100%}.widget-application--mobile.widget-application .widget-tab__panorama-map{left:22px;bottom:22px;transform:scale(0.4)}.widget-application--smallMobile.widget-application .widget-tab__panorama-map{left:20px;bottom:30px;transform:scale(0.35)}.widget-application--mobile.widget-application .widget-tab__panorama-map--bottom{bottom:91px}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled{transform:scale(1.4) translate(-50%, 50%);left:50%;bottom:50%}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled::after{content:"";position:absolute;z-index:-2;left:50%;top:50%;transform:translate(-50%, -50%);width:100vw;height:100vh;background-color:rgba(196,196,196,.8)}.widget-application--tablet.widget-application .widget-tab__panorama-map--scaled svg path:active{opacity:.3 !important}.widget-application--mobile.widget-application .widget-tab__panorama-map--scaled{transform:scale(1) translate(-50%, 50%)}.widget-application .widget-tab__panorama-map--hidden{opacity:0;pointer-events:none}.widget-application .widget-tab__panorama-map canvas{width:200px;border-radius:unset;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;-webkit-backface-visibility:hidden;-ms-transform:translateZ(0);-webkit-transform:translateZ(0);transform:translateZ(0)}.widget-application .widget-tab__panorama-map-image{position:absolute;left:0;top:0;z-index:-1;display:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;-webkit-backface-visibility:hidden;-ms-transform:translateZ(0);-webkit-transform:translateZ(0);transform:translateZ(0)}.widget-application .widget-tab__panorama-map svg{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);width:200px;height:calc(100% - 16px);z-index:3;display:block;border-radius:inherit}.widget-application .widget-tab__panorama-map svg path{opacity:0;fill:var(--main-color);cursor:pointer}.widget-application .widget-tab__panorama-map svg path:hover{opacity:.3}.widget-application .widget-tab__panorama-map__fov{--x: 0;--y: 0;--rotate: 0;position:absolute;left:calc(var(--x) + 8px);top:calc(var(--y) + 8px);width:16px;height:16px;transform:translate(-50%, -50%) rotate(calc(var(--rotate) * 1rad));transform-origin:50% 50%;z-index:4;pointer-events:none}.widget-application .widget-tab__panorama-map__fov-direction{border-radius:50%;border-left:30px solid rgba(0,0,0,0);border-right:30px solid rgba(0,0,0,0);border-bottom:30px solid rgba(0,0,0,0);border-top:40px solid var(--main-color);opacity:.4;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);z-index:1}.widget-application .widget-tab__panorama-map__fov-dot{position:relative;z-index:5;width:100%;height:100%;background-color:var(--main-color);border-radius:50%;border:2px solid var(--main-color);box-shadow:inset 0 0 0 2px #fff}.widget-application .widget-tab__panorama-top-view-map{cursor:pointer;position:absolute;left:45px;bottom:35px;z-index:3;border-radius:10px;opacity:1;transition:opacity .5s;padding:8px;background-color:#fff;touch-action:none;-webkit-touch-action:none}.widget-application--tablet.widget-application .widget-tab__panorama-top-view-map{left:35px;transform:scale(0.6);transform-origin:0% 100%}.widget-application--mobile.widget-application .widget-tab__panorama-top-view-map{left:22px;bottom:22px;transform:scale(0.4)}.widget-application--smallMobile.widget-application .widget-tab__panorama-top-view-map{left:20px;bottom:30px;transform:scale(0.35)}.widget-application--tablet.widget-application .widget-tab__panorama-top-view-map--scaled{transform:scale(1.4) translate(-50%, 50%);left:50%;bottom:50%}.widget-application--mobile.widget-application .widget-tab__panorama-top-view-map--bottom{bottom:91px}.widget-application .widget-tab__panorama-top-view-map--hidden{opacity:0;pointer-events:none}.widget-application .widget-tab__panorama-top-view-map .display-wrapper{position:relative}.widget-application .widget-tab__panorama-top-view-map .display-wrapper canvas,.widget-application .widget-tab__panorama-top-view-map .display-wrapper img{position:relative}.widget-application .widget-tab__panorama-top-view-map .display-wrapper canvas.hidden,.widget-application .widget-tab__panorama-top-view-map .display-wrapper img.hidden{display:none}.widget-application .widget-tab__panorama-top-view-map .camera{opacity:.8;display:block;position:absolute;width:8px;height:8px;background:radial-gradient(orange 0%, orange 30%, transparent 45%, transparent 50%, orange 70%);border-radius:50%;transform:translate(-50%, -50%);pointer-events:none;transition:background 200ms,opacity 200ms,width 200ms,height 200ms}.widget-application .widget-tab__panorama-top-view-map .camera--current{--rotate: 0;width:16px;height:16px;opacity:1;transform:translate(-50%, -50%) rotate(calc(var(--rotate) * 1rad))}.widget-application .widget-tab__panorama-top-view-map .camera--current::before{content:"";border-radius:50%;border-left:30px solid rgba(0,0,0,0);border-right:30px solid rgba(0,0,0,0);border-bottom:30px solid rgba(0,0,0,0);border-top:40px solid var(--main-color);opacity:.4;position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);z-index:1}.map-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0);z-index:3;display:none}.map-overlay--visible{display:block}.widget-application .widget-tab__rotation{width:100%;height:100%}.widget-application .widget-tab__rotation-start{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;position:absolute;left:50%;bottom:35px;transform:translateX(-50%);display:flex;align-items:center;justify-content:center;padding:0 25px 0 10px;background-color:#eaeaea;border-radius:38px;height:72px;width:202px}.widget-application--tablet.widget-application .widget-tab__rotation-start{height:60px;width:166px;padding:0 20px 0 8px;bottom:35px}.widget-application--mobile.widget-application .widget-tab__rotation-start{height:44px;width:115px;padding:0 10px 0 6px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start{height:36px;width:85px;padding:0 8px 0 6px;bottom:30px}.widget-application .widget-tab__rotation-start-icon{display:flex;align-items:center;justify-content:center;border-radius:50%;background-color:#fff;margin-right:18px;padding:10px}.widget-application--tablet.widget-application .widget-tab__rotation-start-icon{padding:7px;margin-right:15px}.widget-application--mobile.widget-application .widget-tab__rotation-start-icon{margin-right:7px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start-icon{padding:6px;margin-right:5px}.widget-application .widget-tab__rotation-start-icon img{display:block;position:relative;top:2px;width:34px}.widget-application--tablet.widget-application .widget-tab__rotation-start-icon img{width:30px;top:1px}.widget-application--mobile.widget-application .widget-tab__rotation-start-icon img{width:19px;top:0}.widget-application--smallMobile.widget-application .widget-tab__rotation-start-icon img{width:15px}.widget-application .widget-tab__rotation-start span{font-size:24px;font-weight:700;color:#413e3e;text-transform:uppercase;width:100%;display:block;text-align:center;position:relative;top:1px}.widget-application--tablet.widget-application .widget-tab__rotation-start span{font-size:20px}.widget-application--mobile.widget-application .widget-tab__rotation-start span{font-size:14px}.widget-application--smallMobile.widget-application .widget-tab__rotation-start span{font-size:10px;top:0}.widget-application .widget-tab__threesixty,.widget-application .widget-tab__isometry{width:100%;height:100%;touch-action:none;-webkit-touch-action:none}.widget-application .widget-tab__threesixty-container,.widget-application .widget-tab__isometry-container{width:100% !important;height:100% !important;position:relative;background-image:none !important}.widget-application .widget-tab__threesixty-container img,.widget-application .widget-tab__isometry-container img{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%);max-width:calc(100% - 60px);max-height:calc(100% - 120px);width:600px;height:600px;object-fit:contain;opacity:0;pointer-events:none;user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none}.widget-application .widget-tab__threesixty-container img.active,.widget-application .widget-tab__isometry-container img.active{opacity:1}.widget-application .widget-tab__threesixty--active{cursor:move}.widget-application--smallMobile.widget-application .widget-tab__threesixty-container img{max-width:calc(100% - 40px)}.widget-application--smallMobile.widget-application .widget-tab__isometry-container img{max-width:calc(100% - 40px)}.widget-application .widget-tab__isometry-shader{position:absolute;left:50%;width:470px !important;height:470px !important;margin:37px auto;transform:translateX(-50%);cursor:pointer}.widget-application--mobile.widget-application .widget-tab__isometry-shader{width:calc(100vw - 120px) !important;height:calc(100vw - 120px) !important;max-height:calc(100vh - 330px) !important;max-width:calc(100vh - 330px) !important}.widget-application .widget-tab__isometry-shader canvas{position:absolute;width:100% !important;height:100% !important}.widget-application .widget-tab__isometry .hidden{display:none}.widget-application .widget-tab__isometry-arrows{position:absolute;z-index:3;left:50%;bottom:35px;transform:translateX(-50%);height:72px;display:flex;align-items:center;justify-content:center}.widget-application--tablet.widget-application .widget-tab__isometry-arrows{bottom:35px;height:60px}.widget-application--mobile.widget-application .widget-tab__isometry-arrows{bottom:22px;height:44px}.widget-application--smallMobile.widget-application .widget-tab__isometry-arrows{bottom:100px;height:36px}.widget-application .widget-tab__isometry-arrows::before{content:"";position:absolute;left:50%;top:50%;width:calc(100% + 30px);height:100%;transform:translate(-50%, -50%);background-color:#eaeaea;z-index:-1;border-radius:60px}.widget-application--tablet.widget-application .widget-tab__isometry-arrows::before{border-radius:32px}.widget-application--mobile.widget-application .widget-tab__isometry-arrows::before{width:calc(100% + 15px);border-radius:30px}.widget-application .widget-tab__isometry-arrows span{font-size:28px;font-weight:700;display:block;margin:0 9px}.widget-application--tablet.widget-application .widget-tab__isometry-arrows span{font-size:22px}.widget-application--mobile.widget-application .widget-tab__isometry-arrows span{font-size:17px;margin:0 3px}.widget-application--smallMobile.widget-application .widget-tab__isometry-arrows span{font-size:14px;margin:0}.widget-application .widget-tab__isometry-arrow{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;display:flex;align-items:center;justify-content:center;padding:5px}.widget-application .widget-tab__isometry-arrow img{width:32px}.widget-application--tablet.widget-application .widget-tab__isometry-arrow img{width:24px}.widget-application--mobile.widget-application .widget-tab__isometry-arrow img{width:18px}.widget-application--smallMobile.widget-application .widget-tab__isometry-arrow img{width:14px}.widget-application .widget-tab__isometry-buttons{position:absolute;z-index:3;left:44px;bottom:35px;display:flex;align-items:center;justify-content:flex-end}.widget-application--tablet.widget-application .widget-tab__isometry-buttons{left:35px;bottom:35px}.widget-application--mobile.widget-application .widget-tab__isometry-buttons{left:22px;bottom:22px}.widget-application--smallMobile.widget-application .widget-tab__isometry-buttons{left:20px;bottom:30px}.widget-application .widget-tab__isometry-button{ouline:none;border:none;box-shadow:none;background:rgba(0,0,0,0);cursor:pointer;width:72px;height:72px;border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:#eaeaea;margin-top:40px}.widget-application--tablet.widget-application .widget-tab__isometry-button{margin-top:20px;width:60px;height:60px}.widget-application--mobile.widget-application .widget-tab__isometry-button{margin-top:10px;width:44px;height:44px}.widget-application--smallMobile.widget-application .widget-tab__isometry-button{width:36px;height:36px}.widget-application .widget-tab__isometry-button img{display:block;width:50px}.widget-application--tablet.widget-application .widget-tab__isometry-button img{width:40px}.widget-application--mobile.widget-application .widget-tab__isometry-button img{width:30px}.widget-application--smallMobile.widget-application .widget-tab__isometry-button img{width:25px}.widget-application .widget-loader{display:block;position:relative;width:80px;height:80px}.widget-application .widget-loader--absolute{position:absolute;left:50%;top:50%;transform:translate(-50%, -50%)}.widget-application .widget-loader--sm{transform:translate(-50%, -50%) scale(0.75)}.widget-application .widget-loader div{position:absolute;top:33px;width:13px;height:13px;border-radius:50%;background:var(--main-color);animation-timing-function:cubic-bezier(0, 1, 1, 0)}.widget-application .widget-loader div:nth-child(1){left:8px;animation:widget-loader-1 .6s infinite}.widget-application .widget-loader div:nth-child(2){left:8px;animation:widget-loader-2 .6s infinite}.widget-application .widget-loader div:nth-child(3){left:32px;animation:widget-loader-2 .6s infinite}.widget-application .widget-loader div:nth-child(4){left:56px;animation:widget-loader-3 .6s infinite}@keyframes widget-loader-1{0%{transform:scale(0)}100%{transform:scale(1)}}@keyframes widget-loader-3{0%{transform:scale(1)}100%{transform:scale(0)}}@keyframes widget-loader-2{0%{transform:translate(0, 0)}100%{transform:translate(24px, 0)}}.widget-application .widget-watermark-button{position:absolute;right:4px;bottom:4px;z-index:1000}.widget-application--tablet.widget-application .widget-watermark-button{right:3px;bottom:2px}.widget-application--mobile.widget-application .widget-watermark-button{right:2px}.widget-application--smallMobile.widget-application .widget-watermark-button{right:13px;bottom:8px}.widget-application .widget-watermark-button a{font-size:18px;line-height:90%;color:#000;opacity:.5}.widget-application--tablet.widget-application .widget-watermark-button a{font-size:15px}.widget-application--mobile.widget-application .widget-watermark-button a{font-size:10px}.widget-application--smallMobile.widget-application .widget-watermark-button a{font-size:9px}.widget-application .widget-watermark-button a span{font-weight:100;font-size:inherit;line-height:90%;color:inherit}.widget-application .floors-select{position:absolute;top:47px;left:50%;background:none;height:37px;border:none;transform:translateX(-50%);cursor:pointer;white-space:nowrap;overflow-x:visible;z-index:3}.widget-application .floors-select--text{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:28px;line-height:36px;font-weight:700;word-spacing:-12px;border-bottom:1px #413e3e solid;padding:0 2px}.widget-application--tablet.widget-application .floors-select--text{font-size:24px;line-height:32px;word-spacing:-9px}.widget-application--mobile.widget-application .floors-select--text{font-size:20px;line-height:28px;word-spacing:-6px}.widget-application .floors-select--text:hover{border-bottom:1px #000 solid}.widget-application .floors-select--block{display:flex;flex-direction:column;background:#fff;margin-top:7px;border-radius:6px;-moz-box-shadow:0 0 2px 2px rgba(0,0,0,.2);-webkit-box-shadow:0 0 2px 2px rgba(0,0,0,.2);box-shadow:0 0 2px 2px rgba(0,0,0,.2);overflow:hidden}.widget-application .floors-select--block-item{font-size:20px;text-align:center;line-height:40px;word-spacing:-9px}.widget-application--tablet.widget-application .floors-select--block-item{font-size:18px;word-spacing:-5px}.widget-application--mobile.widget-application .floors-select--block-item{font-size:16px;word-spacing:-4px}.widget-application .floors-select--block-item:active{background:linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 100%)}.widget-application .floors-select--block-item--active{background:var(--main-color)}.widget-application .widget-tab-rooms{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;position:absolute;bottom:20px;width:100%;max-width:100%;height:69px;overflow-x:scroll;-ms-overflow-style:none;overflow:-moz-scrollbars-none}.widget-application--mobile.widget-application .widget-tab-rooms{bottom:90px}.widget-application .widget-tab-rooms::-webkit-scrollbar{width:0;display:none}.widget-application .widget-tab-rooms-container{display:flex;column-gap:22px}.widget-application--mobile.widget-application .widget-tab-rooms-container{column-gap:10px}.widget-application .widget-tab-rooms-item{position:relative;flex-shrink:0;display:flex;flex-direction:column;align-items:center;background:#fff;width:93px;height:69px;padding:4px 3px;border:2px solid var(--main-color);border-radius:12px;cursor:pointer}.widget-application--mobile.widget-application .widget-tab-rooms-item{width:68px;height:50px;padding:2px 0;border-radius:9px}.widget-application .widget-tab-rooms-item:first-child{margin-left:30px}.widget-application--mobile.widget-application .widget-tab-rooms-item:first-child{margin-left:20px}.widget-application .widget-tab-rooms-item:last-child::after{content:"";position:absolute;right:-30px;top:0;width:30px;height:1px}.widget-application--mobile.widget-application .widget-tab-rooms-item:last-child::after{right:-20px;width:20px}.widget-application .widget-tab-rooms-item-img{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;height:26px !important;width:46px !important}.widget-application--mobile.widget-application .widget-tab-rooms-item-img{height:19px !important;width:34px !important}.widget-application .widget-tab-rooms-item-type{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:12px;font-weight:700;line-height:11px;letter-spacing:-0.03em;text-align:center;color:rgba(65,62,62,.5);margin-top:3px}.widget-application--mobile.widget-application .widget-tab-rooms-item-type{font-size:9px;line-height:8px;letter-spacing:-0.03em;margin-top:2px}.widget-application .widget-tab-rooms-item-area{user-select:none;-webkit-user-select:none;user-drag:none;-webkit-user-drag:none;font-size:10px;font-weight:700;line-height:12px;letter-spacing:-0.08em;word-spacing:-1px;text-align:center;color:#413e3e;margin-top:4px}.widget-application--mobile.widget-application .widget-tab-rooms-item-area{font-size:7px;line-height:8px;margin-top:2px}.widget-application .widget-tab-rooms-item-active{background:var(--main-color)}.widget-application .widget-tab-rooms-item-active .widget-tab-rooms-item-img{filter:invert(100%) sepia(99%) saturate(0%) hue-rotate(97deg) brightness(105%) contrast(100%)}.widget-application .widget-tab-rooms-item-active .widget-tab-rooms-item-type{color:#fff}.widget-application .widget-tab-rooms-item-active .widget-tab-rooms-item-area{color:#fff}.widget-application .widget-tab-rooms-switch{position:fixed;bottom:119px;left:30px;width:109px;height:29px}.widget-application--mobile.widget-application .widget-tab-rooms-switch{bottom:30px;left:26px}.widget-application .widget-tab-rooms-switch-checkbox{height:0;width:0;visibility:hidden}.widget-application .widget-tab-rooms-switch-checkbox:checked+.widget-tab-rooms-switch-label .widget-tab-rooms-switch-button{left:calc(100% - 1px);transform:translateX(-100%)}.widget-application .widget-tab-rooms-switch-label{position:absolute;top:0;display:flex;align-items:center;justify-content:space-between;cursor:pointer;width:109px;height:29px;border-radius:20px;border:1px solid var(--main-color);transition:background-color .2s}.widget-application .widget-tab-rooms-switch-label .widget-tab-rooms-switch-button{content:"";position:absolute;top:1px;left:1px;width:56px;height:25px;border-radius:45px;transition:.2s;background:var(--main-color)}.widget-application .widget-tab-rooms-switch-text{position:absolute;display:flex;align-items:center;justify-content:space-between;width:100%;padding:0 10px 0 15px}.widget-application .widget-tab-rooms-switch-text-item{font-size:12px;font-weight:700;line-height:11px;color:var(--main-color);letter-spacing:-0.03em}.widget-application .widget-tab-rooms-switch-text .active{color:#fff}',
                ""
            ]);
            const o = s;
        },
        72: (e1)=>{
            "use strict";
            var t = [];
            function n(e1) {
                for(var n = -1, i = 0; i < t.length; i++)if (t[i].identifier === e1) {
                    n = i;
                    break;
                }
                return n;
            }
            function i(e1, i) {
                for(var a = {}, s = [], o = 0; o < e1.length; o++){
                    var l = e1[o], c = i.base ? l[0] + i.base : l[0], u = a[c] || 0, h = "".concat(c, " ").concat(u);
                    a[c] = u + 1;
                    var d = n(h), p = {
                        css: l[1],
                        media: l[2],
                        sourceMap: l[3],
                        supports: l[4],
                        layer: l[5]
                    };
                    if (-1 !== d) t[d].references++, t[d].updater(p);
                    else {
                        var f = r(p, i);
                        i.byIndex = o, t.splice(o, 0, {
                            identifier: h,
                            updater: f,
                            references: 1
                        });
                    }
                    s.push(h);
                }
                return s;
            }
            function r(e1, t) {
                var n = t.domAPI(t);
                return n.update(e1), function(t) {
                    if (t) {
                        if (t.css === e1.css && t.media === e1.media && t.sourceMap === e1.sourceMap && t.supports === e1.supports && t.layer === e1.layer) return;
                        n.update(e1 = t);
                    } else n.remove();
                };
            }
            e1.exports = function(e1, r) {
                var a = i(e1 = e1 || [], r = r || {});
                return function(e1) {
                    e1 = e1 || [];
                    for(var s = 0; s < a.length; s++){
                        var o = n(a[s]);
                        t[o].references--;
                    }
                    for(var l = i(e1, r), c = 0; c < a.length; c++){
                        var u = n(a[c]);
                        0 === t[u].references && (t[u].updater(), t.splice(u, 1));
                    }
                    a = l;
                };
            };
        },
        659: (e1)=>{
            "use strict";
            var t = {};
            e1.exports = function(e1, n) {
                var i = function(e1) {
                    if (void 0 === t[e1]) {
                        var n = document.querySelector(e1);
                        if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                            n = n.contentDocument.head;
                        } catch (e1) {
                            n = null;
                        }
                        t[e1] = n;
                    }
                    return t[e1];
                }(e1);
                if (!i) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                i.appendChild(n);
            };
        },
        540: (e1)=>{
            "use strict";
            e1.exports = function(e1) {
                var t = document.createElement("style");
                return e1.setAttributes(t, e1.attributes), e1.insert(t, e1.options), t;
            };
        },
        56: (e1, t, n)=>{
            "use strict";
            e1.exports = function(e1) {
                var t = n.nc;
                t && e1.setAttribute("nonce", t);
            };
        },
        825: (e1)=>{
            "use strict";
            e1.exports = function(e1) {
                if ("undefined" == typeof document) return {
                    update: function() {},
                    remove: function() {}
                };
                var t = e1.insertStyleElement(e1);
                return {
                    update: function(n) {
                        !function(e1, t, n) {
                            var i = "";
                            n.supports && (i += "@supports (".concat(n.supports, ") {")), n.media && (i += "@media ".concat(n.media, " {"));
                            var r = void 0 !== n.layer;
                            r && (i += "@layer".concat(n.layer.length > 0 ? " ".concat(n.layer) : "", " {")), i += n.css, r && (i += "}"), n.media && (i += "}"), n.supports && (i += "}");
                            var a = n.sourceMap;
                            a && "undefined" != typeof btoa && (i += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(a)))), " */")), t.styleTagTransform(i, e1, t.options);
                        }(t, e1, n);
                    },
                    remove: function() {
                        !function(e1) {
                            if (null === e1.parentNode) return !1;
                            e1.parentNode.removeChild(e1);
                        }(t);
                    }
                };
            };
        },
        113: (e1)=>{
            "use strict";
            e1.exports = function(e1, t) {
                if (t.styleSheet) t.styleSheet.cssText = e1;
                else {
                    for(; t.firstChild;)t.removeChild(t.firstChild);
                    t.appendChild(document.createTextNode(e1));
                }
            };
        },
        512: (e1)=>{
            "use strict";
            e1.exports = function(e1, t, n, i) {
                var r = self || window;
                try {
                    try {
                        var a;
                        try {
                            a = new r.Blob([
                                e1
                            ]);
                        } catch (t) {
                            (a = new (r.BlobBuilder || r.WebKitBlobBuilder || r.MozBlobBuilder || r.MSBlobBuilder)).append(e1), a = a.getBlob();
                        }
                        var s = r.URL || r.webkitURL, o = s.createObjectURL(a), l = new r[t](o, n);
                        return s.revokeObjectURL(o), l;
                    } catch (i) {
                        return new r[t]("data:application/javascript,".concat(encodeURIComponent(e1)), n);
                    }
                } catch (e1) {
                    if (!i) throw Error("Inline worker is not supported");
                    return new r[t](i, n);
                }
            };
        },
        709: (e1)=>{
            "use strict";
            e1.exports = "data:font/woff;base64,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";
        },
        877: (e1)=>{
            "use strict";
            e1.exports = "data:font/woff2;base64,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";
        },
        907: (e1)=>{
            "use strict";
            e1.exports = "data:font/woff;base64,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";
        },
        67: (e1)=>{
            "use strict";
            e1.exports = "data:font/woff2;base64,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";
        },
        356: (e1)=>{
            "use strict";
            e1.exports = "data:font/woff;base64,d09GRgABAAAAADwYAA4AAAAAV+wAAQABAAAAAAAAAAAAAAAAAAAAAAAAAABHU1VCAAABRAAAADYAAAA2kw2CBE9TLzIAAAF8AAAAVQAAAGB0OVF0U1RBVAAAAdQAAAA3AAAAROOEzChjbWFwAAACDAAAAXkAAAI2OPA88mdhc3AAAAOIAAAACAAAAAgAAAAQZ2x5ZgAAA5AAADPLAABNJINPyMNoZWFkAAA3XAAAADYAAAA2ATWcDmhoZWEAADeUAAAAHwAAACQKsQEqaG10eAAAN7QAAAEyAAABwmVfW9psb2NhAAA46AAAAbcAAAHCMiIgPG1heHAAADqgAAAAHAAAACAA/wE6bmFtZQAAOrwAAAE8AAACkkJUZWJwb3N0AAA7+AAAABYAAAAg/20AZXByZXAAADwQAAAABwAAAAdoBoyFAAEAAAAKACQAJgAEREZMVAAeY3lybAAiZ3JlawAibGF0bgAiAAAAAAAIAAAAAAAAAAD//wAAAAB42mNgYTnL8IuBlYGBdRarMQMDozyEZr7IkMbEAAacEKqBgUEdSHkDsQKI7+7v787gwMD7/y9H0t+rDAwcSUzaCgyM8/0ZGRhYrFg3gNUxAgCVBA5mAAAAeNodxAEGgEAUBcB5vxCFoiN0sYiKAEvXjwYjYlBY/zf1nlcL7rY/GUVvFsjkQCcqCwgfrdoEWgB42pXMA6xYWQBF0fU5tn2H4di1bdu2bdu2bdu2gvrFTu32M6zbw3AjFnH4MHVj0j8+9jvkkk2CeG/51f+yqaCaDrpIjvk9pmTsptg9sWdiz4XY8Fp4I3wYPg9fh+/CT+HPkCHkCq3Com+/++797z5KSk5+kJyMtwS/ySC7iqrraFoqpcQjlA/Cp+HLdMof4f8nUHYhkeTtJG+E5FlJt5O+T0p4cOPB5ehUdCQ6HBWNikSFo8zRv1GGKGPq145+uVj7Qu0LDWLOuSgGOVAF9dBMGy+vGKXVNkAxPQxUSxNN9ddGedVV0FVFlXTSUWdlDdJMN80NVc1+LfTU0jDnlVFcCaWU1MtgR/SW0wldXNDHYf20k10OB5w0RBXHZJPLKXnkllc5oww3whgjjZbPWBONM94E00w2xVSTTDfbDDPNNUt7cyw0z3wLLFJYUcsstsQKSy2X30prrbLaGhuts94GhWyyzWZb7LBVB9vtsdMuu+1VxL4UZjaQ2QAAAAABAAH//wAPeNqtfAV8G0f28M7syg6aZEm2Bba0YpZWuyuwLEtmZo4dO9g4jA22aThNkzQpc69w0Os11PZSZm7TY+j1eoXj4mHbxFp/byVFkS/N9/tTslJWb97MvHk0M+/NhMDEZoKg1kiOE9nEDIJAUgbRiJHyCJHfP+wX6AqB9h/KRwakR6eEFsnxs+3oFEdum9hJkMSvoWYt1FQSViJAEIyW43iOM/mMJqPRZEr8YJM/tFKtXK6Qy2XyrOysrGxtfn7qd2Hi96/R8323h4JVyG2xrqpE/JC2jG6ORO7tE25k0Y21OxhvBSpnmH1NwlrENh72+6sjPnZfAw74fEfnVK93OityJLKA2bQoOnqN0+FA8VJsN1s2NLVfabd7EH4br0d6g/Hy7s71RpMBEYg4PPkxFZS8RERgxHSWSINJB4QmHhYITz0iiQomAQaU1CMDWOJh5CIWFWRzKrzMoZHmjU5XTCYvRKhQLqtyOjc1DR9kmEgOO7MuFLpvUfcen6+5uLgIoaLi4ibWt6d78b2hUB16uucmvz+KfHb7umjlvsp3I/uilevsNgahqN9/Y/foA5FIA0K8y3VFbd1Nde/U31BXd4XL5UeNlZEHQHqvggx6QQYywpaWgMh31nh+PFpFktfiI0uPQvsqWtFzXXn5cFkZjXRlZcPl5df1CEd9KBha6mhYpleXIaRRqbs5bler8DL2OeybamtvbzvZdntt7SaH3Yc5rC42X9UcPdzwSP3ByuhKi8WNgbPvAj0yoGcmcJbV5mtTH/LR+BBJTbxCBiYm8E84vIY7287h2wGJ+CPU0EKN6RdqMPnki/FeMnviJR9+0483ADJ+U8TdO/kJxUteJKoIwkBqZdr8pOyMF8mO8WbIjtZdJDuFNyE7HgkxdLVuyOdb4WvZ5vHWFxWJAlIoat2uTY3dexhvdT47qzlUfsdw516Way9RKhFSqZSdPH+gJ7w1GFx8O/qKF/ptgfz8HIS8NuvaaOWBqi8qd0cqVgBHOLd7V+vgTX6+wudwbKyuua7+s6ab6+q2Op0cKpDJqsQxnYTxq5Ic0+bT+eKHgW9KxUxMMAxJSY7H+/F3gQM/iTtF/J8RBHk2iS8FDmhlSR7/DK0UjpBGYSfaJjnuP/s0x0lifhF/2+Qn5F8TVgrWnZJ/gll0UosTnODzyVMI+73ea3p7Dni8AYrPigYCd4zNuzsQqMSS4xMzuq7nQU2Rz+3e1z33Nt5f3hiJfGcu+W/o4Q8wgpugh1nQA2IQolF2YhDoM7yoKr4N9zTGf/prnw9PxClShw/F7/ojWQfjsYjU/R3q2qCuBCQqjp5FFp4McJLNoB9i+eOp8hz4IbZJQgck/EsjNL2NQ2jYizZhrls4LLom/CK+ZWITeSQ+HC8HmpdD/YehvjKpXcBZqdgGiSilSIyXwSJ3zx6TdJxtl3SffZAAezoEGlYBGmYgmqBH0YoupUJJxsFDpq2K1l1CEeGhKlBRUXGTj93TDa6AbSoSXQH4g2bWt7era6/P1wS650NSmSwGvqO5eZPoTWSiN5HJoi7nRoC4nCIEL32n7kZwAm4Xz7vcV9TBjyTA5eZ5t0sEIPrdyn3R6Dq7nWFEvxJN+hUA2BjGZl9XGd0HY03wfgHwJo8ohbFqpzhsYPFUH43MaM+cu0Oh6qpQ6O5hoZpDezoO+phQ2Oe7pg0vRiGOu3l09DY/H8YgiDvwbzHn9uzr7trldDFI7O1y4WtqDDhrJlr/C5xFPPnfYe4YUilVnbz/mp6ea3h/p1K0UyXYqZ8/2OPoNCCJ8cv6JXqaZpFCUVTv8V7R2nqFx9ugSJh7kaLe69kGEK+noUhRBAxuvAWM1OVkWadra13dLY3vJK3WxeblCJ+Deluuamv9AXK/W3UgGl1rtXk8ouFHD1S9W3V1NLrGZvV4rLY1ldED4rg/Ai4PAZcLCTphHyz6T0azUzmNX0BjvHBbbKXZ7KgJld89KKz3od62gz5fmHE4tjXilfEjOXh1SaPHs6V55BY+yfGVHP459rnce7oarnJ7gqIvvh10uQk43gD9FqZZmGn4aTISD+u7hOuE3+mHKqzx+w839N4UDDVNZ6n6cPVjC3vuqYy0dlRU3dVadW0w2FDn919d3bEPJr9pLAWT311D7XdEIu0IDdaEbqitORIKNaPhrsuNRoPD4dg9MHyUCZc7nc4DI3OvdrtjRYWcxbymq2W1waD3uVw724ZvZtmQw+7Y0794t8sclMkCVusm0TesAs7OF1cuiZlDpiWZfGr+xGz0Pgb/wXFn90g2A9Zx4IIGsNSiByEzVYmkyUxOUBofwj6P59DQ0GGPl024srDff89li+8J+EV/Yui+ozzcUB8uv6OH/M2EYexEVXV7e3XViTHoZTwl5WngZxjRA5oQjasq0DsBoVcuF3r94Gjea22V6AB3DHBvBNwCEVfKK6SMlCazTWTyCzV6P5UWfuz9i+cRjfp33g80qke91NPj4+dikuPnbn38cWrRuVtPn6YWiRzYDi2tTc220CliEg+NNwkDUfSKYK5AT6AnIoIZvRIl8/FdcT5ejJ+KV+E/4deg9iDU7kzSLNaWMvlQtUeor0IfIB/6MIIHyd6JTfFfYgu5V+ztMODnJ30pj0zAcKSAeQconngSCxO/Q+RVnKTbyJ49YedA708D31VUK8ESDeI4RYbnZ1q8ItOEZdqEYGSFGZ5VLpck5MQaEz9Tkz352wiaUYBwhOMOt9cdDoZaKI6sZpht5dVbXE4/Fv41eLqxaSTodm+NVm0PBMZoNE2oYBZbrD7UXFF7sgNN08wJBHdP5xbwWNNzlc1qM5vMG9pw9XwtrIVoelnDnUhjMF45VrfCYDDBZN/NMwsKSjWagUDbYq2xCE8SlfO0Wq1o2+/DGNVZBFh21cU+LTEJslPnCtN/urP8/3BkapgB5FUu17Y2dqHD0azkOFWby7nA07rF7aoC78+j3PyCgNmyopZb5nI1SQtqnI4V5XXLrRZ/QX4elsoqd4bDy8wmp7pE2ezEV5wl7rZVgc9zmc3LwuGd3TL/Op6fZzDY1Gp1D49nBcdo2mjTG+bx/HpRxqdgRLkgNQbm4ySF7CUXVLLMsSWX0XjDZTe4PU6EnB739YsbtrldwSwuO8ZxR3rWfJf38wjxfv/31rQd5rnaady0cpd7i66ruvqhYevQsZrqLqfVdnlDzwGvh5vT1PzCIuvi55ua57gdjqs6QBhGI4FFayY/BY4rxPWu9IK+yBjgdtpfXfBk+ec5fdzpYe5dP/ZCgOO4J8a33O91OPx6i+3Q8vXPGa2vjy+7xm42YLNs5IW29sXDA/dkEfHtI6uWdDc/u0bW8YP6prkH18f/smTdaEPDD4CK+4BLFuCSjnAThAS6N6VXoayWvZhH0gT3ZLLkHIuPrnquxhT93sL53woEKxHZhsp5/53zVjwUDscQqo9WPjLYdbXHw098MiPK+q4t7BlUttYj1FFddWw4FBn+bmWkcbi5+fmF9iXPNzUNUPaY33+0fXbHTcFgDUjwJ2Cl/Vkyoky0OhIWhxeYwWdSli0a8D8jFHpKqIp4fdvaHH32aSW+kkKLrPXGUKgRI+E3yECR/NzhPQZ9SdZ0HywCMCq1WK/fMJcXtf+k0Ex+nrDwtimygEHKMnU8O9PL5tOyzJllypyTn1HrpJv33b7Ws8DpbFMh8P67+8svs6vZIqMyovOuq5x/k8/H88pmh2Ohb9u3PS4LrzNbjqwqX+F0VBdIG1zuZdz8Q2anBUQ69mZb0yis6atsR7qOcFwFrSlk1Ho6KC+j6yrC9w1TtseczUqlemVnx2OrZO0P1DYuMtH0WCj+Jd+jVmt6quqeEC3j58DX6VlEYq2UWN5mbhLhZ8ao0Cyez23k2F0NneuMBhrxyGa37xuu28r42kkWv3GWwE/XJnZxyOd0XdUcr8ZP9l3PseU2g3GxyNnPoS+v5DR4WmXmKp8sFLnI+i709Dk6KKwlq4TtC9QWc2n2tOnKQply2rQsKshNeDmOopBPabcrc5QzZ8yaNWOmEto+JTSRdsljMB+KC3Bou/CSokr3B50hF7rP73Jvq85jlCpeSqk8RUVeNczdDLtUbTWXlpnMpWKveNn1TpcFYSQh3ZIsjHFlMHjffMqHWJEQjd0GnSIE46vIIi7eMXyEpfXxt3Fee/yf+3keN8YfxSvQm0JgM5V9lkDPAHqSN1B3eiZnPkdHhJXAh11ZBHd2GcdJXgfMXsDcBPoZBExoXZopMJhzfUY2AyITIRnmkRQnvOz1ePAMtUo1UBttkRXOQtiD0UytWj0Qq2otLJwJP/NKFAs7fL062ps3XadStXGLtgArzr1MFtrnGA1ujBw6uoOeeJP0UdkSurG01IwxYzT10xPvk2WOyxyusEqhKNdqwwqFEg/WJvd4VBZQDrrG/Keikb4pU8zPQNPYhKYZzmva3oSmtZXwl9Qyw+JyRIEuHAQ/Vgn9FIv+XjrFn7OZVjplDsi07YOoMlx+fPXqY+XlEYQqy8PHEu+VLApw7G3z59/OsQGE/Cx364IFt7NcAHutS15oahocamp64bILr0fB/VdXd3dXVx8bss55qLqmqwteRUt4VxilioFCNcEDhUx+pn5OcbQsjWSXmljf5VTtTphE193j8XgxF2ZvWuqD2bVFyZFZ2OSyXb2QFSfTQmmN07k8NHe3nXUJo7jCFpMriha0tL46Khv/RUd1h6qkpNH5cPwzWf/p+lgfqEQXh+XBuTqdoSnU/JxI7QlhlPwsTe0Uj5jP/Fc93wm3z3fnOjd4vnY1TP8JF7f+fhfn8NNe+9WXBZY7nbWFsiaXayk7fsBqN4KLG329tWVekUIes8ZfkLzzsLOxpEQ10j705AZZz/HW6gGjTjcSiP+Z7VKp1CNVDacIhPaAhvmoNkJGEMgI3DOJG2MuY6Igv3P8bHkWW0HK50Yr7+ii69RZ2nqqFR3ZXfPkuZfxqfn7bVbDdAmTPZ1AxJugR1qq9X+/00iyLPmQH7ss5Ydqwjs4vmUan9UeqbitsfHbMXsE4jEHK9m9PBepYZj13tCVHFuL/VnNwdDR5ooDXLi5NRDbWu8/xLsiaDrTogYyVMrhuvZVtE5ndJYurO5YRtPWnJk6jbK/ItJVXCxTaUrHarrXGww6jUa3pLFjiVqry51l06n7RY/zEqw5/ikZSezfaNHhZGohb5qideCMcDgoPI8qsNdu31iv4pQ5qpyZs1WzS3zK4Jheb8Foj7BZMiK8y8eJ1nGtVo1IRJEMfGNcpCzpiZAEL/b6K+h1ggoSKnEeh9DFlG7oCySQL/r9KCfq8e5o7VhnMOoRh+wO+/6RA8/5qGBcWrvSaLL4PZ4dTfhEvKP/Zt5fuXqB2P460IBuKjh1x1LPo5+HhSUqtTAepoITvdEq8ruA2wK4RwD3EjuWWs9PjPTPPV8Hjtt8z3mfY63HA6TjwQcnfgpNTP785yRKfou93ggtdVDBi3Ys64Tt9eh+oaYO3YhurhVq0P31eBC9H/9b/OdoQqCwDedC7W6hiVoPtcVZMcn9FOHowqIa2PJ5bJHZFC7GgajQq9QIsQiaaJJxNN3PyayFWOEQmky0bthPfTbRWhEhT5x79UFXm0pdmkUykizoZT/Q2EcFk/scXlwmZWvZX5MBNHErKZ94BZFnOPJnbn7CYucIkngQdN8EseRiwkqExLWBEV9Q5/zCgrSmSEDv8zMVf4pIEQAoE+6c69rXveW7LOvuWuje1XXFAwzjnPjp7JkWB3NwdfN6u628QIf0DustqxvX2mzlUvyzGdMR7kSzDiLNgJ1f1t//wbjwz0PCn+c6mTV9g79azC71oRlzf9HQNeqxWldF4l8Pv9LRNQ7bgaXl+B3PfHcyAotfgX1dViJGJpEZ8vErUsGLHpAc/3H5K2dvTO21yXMQS7ACDqvNDGGk/C+Tch6ZISMZeW7iffRt9xK7PRTm+RsH5tzE8xGSIzm3a1dHyw63i/UaTXOsAs2hT/it1dVHW4eOwIKiJhi6o79lv48pd9rs29pqYEuzwhN/hwM6FoBVfAJ0NItrFyYjbHJpj/Nfo/XOle23lIcaQgxzoL3ren+gBshsqYx8d+7gXaFgtddmWxsNLjYZnRW8/8b+gVuDwWpAKPd697Y273S7uVq//2Atif2INpmumNN9ld3h9Hnc+3vG7oBQaYD13TjSstFuD+YWhKzW5VWDR32MP8iy1w+2bXc6vC4YZWv7epPJlIiUDYs2AvKYkYh65tNIJkaJGGA7hGl7ovEG/Dw3MTGKS7rRC+Sn585pIC1ykCN1V090A4f+DProhdpuqKvgOIX3v8AjkS9SUa7Flpp75vRd7XH7zDbb3pFOGFpoOj+j2s/fNGf8NsbrDvsDd85rvycSwjfEg/hsXgWPIrC76+67LRiq8Tid29sHr4dwTWtV7Ni8ufeHw7VuD65nxVHdCXRJQXImojKRdaGys3DmFnKqiJJrHobMlFFWxn6UXCR9WPiqu68Foapw+NjyBbf6fKyf5e5YGNnEcv2a7L72tj/fIp0cvMbt8jgdsH2YdxvHBVFuO8/vlLyI963bJPzhzu8ufry2rnOgru7U4MgPYrHWUrWm23fw7MjIShT/uiYYvKWn9a7Kyg6Emioj35mzKTZuNCai1leDhOyixaQiT4ih7BMj5IL4Hl5ySAeRJ/ALJ2C87TBeF1FHzAU830Wz3EUhj0yFJTMkljldXgpOGauDwdt6+24JBKKwwJsfqFxjs3mbo5XfHRr8brSy2SfGfQMLjQb77NpA4LqWluuCwdq6YOBoczO81VkijG93bd0uhqkIMd5dDXV7fEyEqhg8ApRxXubIYGy5zR4uyI86nRvr59/g9TIM471hXv1GpzOaX1Bhs62Ib+rebrVBOMW6vafrKrvN4bDbt+PNzRssFpvVYtnQ0rLFZnW6bLYtojbcI0aHEtHgKEEY6KRJFpxf0mVyJnNDKb0wbHgyVqNobxnWff+rjo52DAw5sXXx3RzvD3Dc7fPrYXXQpUSNTc0fGfr2O10et8N5ZGTlLW63DRW08f69Og5dvmgRkt1178ofd7TMRXMaGh8bHjpeU9Nj1NPzQnlHvh6aM47+1FIRvr299e7q2l6MBhsanxgL1W6w2kQjQw/gW/CvUtog+k8+H/9quvCbr/AtpGKM7Yg7AWcQ30YeljxBWBMaw/9X/edhQX9OVaEs0Vt09KCHG9Ub7CRYulrV4jDVKZWlGoWCLRLew7d5vlJF9fo2G9uhVKq0mtIB3lkL+QaZTBaxGqo0pXyR8Gs70DEXHyavkTz+f+4/sbrO0qOnHQZNaavZ1l6mtVAcxZhMCzjvmNHo0hQVx/RlQYVcadXrhz3MHL3eSbGUQa1qsBgb1CqdrUzbaqCqPSi3QFrpdcRkCelXOQO9KrVKCUttv62ySKGZNqNULg/quU6VEoCqDtZaKQPUQhilvVwqzRP9J4rgU8DrFwkfUQ+jZMRp13gJ6hWyKbrGpQKPhkw9Y5IqRnaHZudgvVY3WuG/zGrlKJ6063S9Tqa5pESJT/Lr3e4KOwzObe+mSxwFeKbwlbFRpaY5i2XMfmIGp9e34+ccAy4ULF9o0FtVanVfubdGJivQqjUd7hokVyr7q7i2kpIiVKzId5SUhWfmSwvCNr5aWjAbPWgIFcoU4ug4fJK8CUaX2LOh/8GeDXHIajKtrq9faTJZkPi+qr5+ldFkZZG2rHROOAw5YS1C2tKyOeGK4dIyLbV+ffUmp5PlIDFVtb5qs9PJwevm0+v9i2BCdBhNiwLrwbOYHHajcRF4vhrwjjskp8AePASbton/htobkAmhnmnCV++Tw0L3h8X+oqIyQ2lph93Tq9WaSDdZWlxSY6Eri4pUEO9wy4Rzws1YwcT/ij/Gr/a5G+Ib4jL770qCZdo6k6uhuKhYo1S1eywRuUwhlUr9Rl25UuWRC1+aD1BrSs8dAnKJMHxtkPwQaM4nZERxmmr4Bym0MoZNTr8SkbIWkTL8c07Yj9BW9y4hBylM8f1JAj4/T8C/0IdCjur0aTsarxR6B5Idif0g6pDkdGJuHxLnBcPUDv5PjVIK1FIzptKZU2loKSsza1XKWr2pXq02UB7KSYNzcfTpdDalXF5epvYVFhYbtWXddmentsxKuihtSUnUoIuVFJea1Opa3arEWP8wZYTkDjuanZ8XdJjBDgvAIsstTEtJSXFRSXGT1xSQyZXZ01XSQp/W3VgMEikuqXcbA1JAlRYEDGYuPz8XTaiSXMJihpDaCh41N7HjYLVk6oMYqVaKkJTaKnTmo8XCTXno+0JR/H32TrRupnADqldw+NscvgwODKDvCX3oPXLVxLWgkT6YbW6B/WkfrGN3EITk4p0bPKyooBkMzTQmxpjBXAX9TckKxX+6DeABYCRQkVYEZhokuc3Zpi31KVSFbuCoOdijKTXNnDkD2zFS6rRr+rg+rdaTl63VaIZiFeKyA/uwWqPuD9R2yeWz0StN601mq1ZbNhb19hsNwcI8hqaH4/9mW4qLi3Va7Vjk5ZmU3KvVduFJQTJ95kyjWt3JN84pKSkkgawCpsxa7CookOvV6maLuUN34nDFHr+/UatSNVlNTWoVbaLphWFHm0atAyfXrn8a8U7XtvryFVart1SlbLRbGlUqrc9C6wbd5eNmsxu56zSdtYXl9SqVDvfP0g84HN3aMnOl273GK873DZP/or4H85+a8CQkmp/6nD9ZI8tPczMljfwUx7wQHNFR3xNU6B5hBP1eUPhXBjbe5nSa9Q7HvRsDy/3vrThgtChVdsP+ZU7odoDDt4sHTLIphNb29Z4ZEn7U8Vbf4FZJlg2tae15rBZ565/tqV+GkARS/wRoxzTQjpdBO6qI+QQkQaQXC1aRqTAmY4bCZE4sl4zugM6IFpnpgxMF2dkX9GKawabfNhRbYNC7c3Pdenq0wtas0wZLlDKPWlNn87Wr1aZZs2ZiA4lUWu3K7sgoTbtyct0Gw4KqgV0GcxmnLNMuafN3l2osgAfhXrOmtNvftkhLq8lFtXNVSjlGwsykKnTgFfc0PdoQHnCKMzQ732RyIWl+vqPYKjXn5ckQsmi1PQ5Hn3794drDkNF1m0wLOW4RoA3VNT/453tCt0dinVZYkrhcw8Z7jMMu16COtrYGK76Nr27i+S3ujtn0EAD1tA1kPx/2bH/PshA2WAkTiDdlpwLN2QqRu+dZlsn15GSG0UWrXFk6f4b/+jPNB11vbS5c9VTru+qPF2xTlL+1Qow9VlSHgt8a7tjt87WUFBcjtE94pBNy5+Ucy966YPyPboyQTCaPOZ0bJLJV7o2N6x0Qk4ytd28b+/dtvUNNsdjJxQuPx2LNYsasIry7sv0d1H3uSCwYuH1w8I5gsGrpeF5ZfmdgPe+HaI5N1O1fgLeKJvK52tQplalnKWRT0vtaNIvj0Nqh+yrC9fXhivuGhINorZgQi8Z4/nCLcDBxyK4VcQxz49jYjT6GQxxyORw7erq3w64SpaOiWUQyzohY39Sk45QoqemSUVGqmOXdt8znl7rdHSqO03R73OO+JTd6fR4e653mHaOBNV5vq6ywweNeG+nZYXG7sVS25Mcddd2p3OJXozhqF5OLw41tZzbKBh6vjfWq1apuDhcERyHU1hiqfh3II96B03YWySTRAZaftOrzMb4phwtkl0pEZEQOEyOaMlyUW6rTLm/39Ou0ZoR0hTItQi5a10HrXCDB8YChRa+NKIs0jWZzpzG2CcLhTh3dCbaDkF4m0yOfzbY6MrjNZNIj6vLoFpcrAAUaTbsjsITxLQmGR0zmOpNpTnl4TEcbZs+aUSr1FGnBUzss5tU1NeM2W4PB0OkLjjPMZeLCzmCr4vmDjef2w7ifm3RTjqwrxewYSgoh8+CVAuZ87j8Do99wes3E0rKsi2KjX6IIw2yv7L6O56MkT9WEgneN+Bv3+XyR+mDw2oboLpaNIRT2eq6oat/hdPowT3Juz4F+f9PVLBupA5zGyE6OrUb9TevMZgvyuF2H5iy6k+OD5BNPSRinc2fv8C6XK1Ki4Czmdd0tEJww+73eq7uGb/X7o5InnqAAZ3fv3J1OEcdvsayFQULOfyZVKDESgYzs8aUHlC3LYERGDnnLN+SQs8rd7h0t/hX3Ar8QAvx7V/gbtns8kexLZJHbdnk8oex3fk2ONDU9s9C68JmmphHyw4+yfA77luZkNhkRt4HlzpW8mFhJi0uMS4alpbSMkSYPr9IyrSl10hXdi1YJh6brTcYNHc3rLGYbyWHxgFzfnKsdTsf0H/1kBqKmTzfTG8lnUXyGQjUN5iR8G4cqGq7m2KjH7thS33XIx4Qay8N3dgvPc8Ij2m6zpTqP49TVBn2TAShsAAp3g28pTkSBtWzirxjvpE3wrZUl/uImDr0ghOEzgP4cEyqKJAohHEV/EIbRs0IlehbV8l/w5Kw4bNrxmYl/wo+EV/4DdQP1N4IWo5YGBW9KaiK45+SoTdkKUedSbhosEWVwJ9NWyV/cbLojXBGL3m+6J/K98fHvRe4y3hOrilTcaryh8qEVKx+Kl9XEAncsWnCnv7qmojxw/9Il9/nLYzefMj829Isly3879KL5mfr+vvqnTM8Nfrhs/NeDj5pOtIyMYPniX/fXjcyp631v0fwfd7UtWdja+XMC49LJs/gIcIQkchOr9ClZSryUl+nkcj0tV+jQEar03AfC3YqyMoVCqyOgrl24Bd9JtZ2vy+RLE7VkiRZwJy8D06TFuvj0uQ+oUjR6oS7x9eRZ8g+gKx5xr4CYBDP+axuaxDOFygCfn5/P6j09ZaV61u3e3d6xn2HCEp702W2X19asgZNfpSpVs80SLpTJVTQMSA+EoWtdnXpDTGMeZLxrY+17PB7O53Lv6qgFfJvDYl1TU7HYbm83GRotljnCeJJ2LdCOJMJO8jWqJUU7nUHWlFmXzpgq2IwBTqH9Ni575kxTqW+OjjZ7wU+0d1zldDAkR9mMxuU1tStgI0mXlna59K7cnFm9IAwtTH86/ENLlUbDqZwL/YHt9a1Auz9xODa22mJxOsF9VNes9XqHHLqITteKrpXrEhWBWHT3JMIu4i4xGm9Ieg4Fx2EXh5xWA+dV7tpTf3mgrPwggXALaMYLsMKfCZiZFLfo5QqDQSHX+4p0uqJimp6cxHsBN06+SxiJwSBBZBODRJBcBvAg9CYA3ASQELkMSgaIWwlichKes9R0aB1KBDizK9YkEjVRLfyLMIsP4PvwWbF3lNk7q5UnR4OfT7JCJ47qGawlZ5PbiOL/3x4ePYNKYEOm15fL5cUYJ99DcnkJ/q2GDspkCoVMFqQ1+hC8FslkIQIRz0y+Ts0GekiCkEBkkpo9cZLjOLFHAl9JnsGPiCUISsgzcS++EooQ0YF/TB0is8+XUIfOvYB/nCgZhJKbMkpuOl+CS6h5eCgLOhFLaEU2g4f8aIZX0ve97/9D1LjnoTyeKBf5wdMKkkl+Y4zL8TQWUTiEp7OS1YePCv9EueI3tOqlrsXPZBUkzgXArJBecmMvh+xWQ4lp9uxZ1FeXjYsi18Rouhnq5FBX4ttTZwnS+sFziV0A1Ck2zs7JkdyyeIlYR1Wh1XcQCPJRjfgA8XuxjmFKnQMJtSoyzM7NW7B9h1hFGSo1doHw0bXUtWQt0GYiFk2OJCS/iNhLiCXHqCvJkSxRIxZ/S4QvJp4nRB7sgF5+l+il+D/64ad0mpsYnIKelZ/3Y/FVL77mp/ov8WtMvY7UO68290KP57mPs4gFCQpS3IbfC0VdRDcKVrIuqw9oJdCFZQOfPiefMu40f+FBNxYUSiNO55Y2af0qqzVYUJCH8gsKgpA0qpe2QswnUlgoxY2F/c+NzXu6t/cIa/Me7Oo6PTL8aEdJx6Mjw6e7uq7x2nxHe3ufmTfvOaBhOdCgSdHApnvO/oa7CIq0n9EgiBwAEZtbLxCB8s5T0bZFpEJagLnCvufmzXumt/eoz+a9BqgYHklQMTwCVBz02tgjvb1PzxsTqXhPeBXOfG4nss/fLoD5Ikv4FTL/LauR+6qey24W+fWK8Cr+LIUlExP12nz0yuefI1PWdu6rh7ns04DTJdSR72WFExHcFCfFYYnnEHyZrJSlFjZJqyZfL2xYb7E4EN6zevU+o8G8sTWvZ7fdBoDrduw8ihFkuHYJdc7iFh+zo/1fO+4oUty288vm7Yy/q8Sh6gsFjvZ/uftqSUxyYM+/Bo74gz1ASSdQ8i5QIpp1gndpEtg0XRm8Tq2y0tSJwu6Uwt0Yj0+roVfU1SzTl+oQioSsa+tyI4uNPh4hm6ms28v0lhqtCDkslnXCemdJKxu8eeRf4bm02U7GSItJN1bx5ZL7w7ZqhUMWsfA3DH3ZsNpUapsx015mXlX/r7YdsAMDao8Tj5Bq8kEiK5nxlSEGfYmMtcKvkakWu9FW4ZBUOARFJ4jvp/ESiWEWfVmLDMJvapGRfFDYLOxGa6QEIi4njlLD1KMJv5KfTMeLCyO8lRe86AyPPsBPo6+EaawwHX3JAv738I/JTy74MPKTiacSPgzD+ehJyk39A1rKndoWCXj4ICfUoCc4dG/xxFOkAZ0RvJzYATfxDscl72F8TOkou0iHVIEQMM2EUDb6mQltR9tNwpVooUm4TbjdhBaiPAPaK2wyoP1omUm4PvEleui1xL+pAWplYjWiTFKXOXPkZ7xTAxMl6NXzM0l6RnnI50P7U78n3k+9wMiOoYcpK3kVQZ4/Gy1+KOvEbnILfJo4TliS8O/3oCyKohzENBELmXj4klFUvNjjxn+euBNlhVC1TIaqg8IeL2A/iaZTasotYksBU4EU2ehJcmziLoRfr62Js2g62uJFm0PCy6Ua4WWRR2+ja8g/478lZokEd8k/T/wJf4SuQQtZ4UcARN7JneRbidUcIRHFvhyPhuJ3b8tyfP1TKC2B0oeTpQgx8BuPBuN3S45//dMshwgKEzvJPZJCsTwRM16ZCEzuTEV1JYQddp53JnLzDNECfnnp/+yUE/of1BEjxXYEx4YHy0MDcIwQIY1aM1BePqCBZRCSKeSQGa1RyGVIbLzG7amFFvCgWAGQ+gEJZbxzqBCQvN5ahbwwWcEjVpAJtXiFLX6UurmFXWq1cbzNNu5r8S2123h4XXZVi6UP8ixOWt9nhVeadtr1dF+8upUdt9lF5KW+VhE58bqj1dpP0w4HTffZWq19NETXAHk8yUqEm4W/4x0pSYCl4B2c8Pesp7+OiavqSijbAGVJbQP3yYsYlRz8gZIvfoX/HZ8h6ns3SGM/1QmyaCLmi1aeGU6beiSIy9h7ZS5RDZfYg5gKvzmPTLa4yTyptJpnamWlBShPLmsM8dWQKKLcSKFUDlQ2jhWr5JpSzUi4ckCplMfDXDB0+qpVD4Qaq2vr/Q+t3PlIBRvgKyoiPz687alYa3trW/VTW695K1pVgV5VRpRKPUKWMueo3lPaDWtmbXFJudLYri2zxBy2xRa3Y4PL4bPTuq7dbT9oah5rCzW/NDD8Zktl2/zO2tOdI6909K7qre15f+midzrqO5d0dD1HUEQHcGkPVU8oCBcRFvd/0kuMTXEJXhgYafIol9EkxoJYBgKNyRV/R11N9JW9B9+KRirb2yPPbN3yZLSzg4s1BH+wdtX3yhtq/KHQo1duORGKlaPBB24I3hWrB4Nc8Dp7Q0srgg0Lb8TKBW93tI4sbYMzcePvtVd1dkQ731s69FxruK25vOnl4e6TjY1zh6JNj7uEs0ie21beMRfH70TBv5ERf5E1L1+aiF4tIW+i2MR9scLkLowmSZFSKSO6KQbeSIGvOX68hr/PBy503QN+SbPQhIsFFr0R/1Nip/t+ICCUofehNbSV/BMJefYEvwj03+QV2mrQlvW63eJGzFBa1u1295ZpDbyqqChmMkHCsUSpKKo0GmNFxSrqZ+6+sjKjUcR3QXTebNJq+9zGqpJitaa4uNpgjBYXq1TFRTECET/CN1D+1K01lJgcDCaJlCYN2XiO8JULYVTgFf6E9smFq6aFsLBeSn4tPFmGaoSntSi8nz2MDggbdnMwukRe6hZoSZk4d0wy4ikN+NDQmFb8yLTiB+C8VEviL5r8TcgofDSKpgnN/mbhumZ/k/A6ss+FznIb/Y0zRtDyUXSrsAjd6sOzOHS3MCp+uPg/fSlY/J9gqYnz7TeB3+SIRmL+VA3kFYy45hFtF03d/mbEqFJLyqRpJpcmPErCLhJEdjJufl+ln7++O7TM6+k3H4meiIQ5imOExoNllSXFWqOOHvXHxg0GM2S0/aUuR69WZ0U31W13uwPIWFraanKiZ0vhpORi4eMyjbqXszcplZoSmYxVXafySqVyNNoPd4u8mpKSOuuxXw3/ZPXcZzuxfJMqajB0OSCQC1tZq3V1hBlzOHvNZtMQw6wVdtoscIfYf5nL2UWb4+9baoqKS6iVzByatmhV6ma7qa60zF+0Td9qtQ6ApLyTfweePU2MiDkExKUPgeHsrIJvPi3IcwVpXmRnwqUXrsVlZiIy3GB61iEzK1LXk7Tf9+SNN/yus29YImGaIu9+m+6wmBtVcmWVwdCgveHVUI1LkjXa0vWTFRu/wzBWCVZa5WGrwz1jJkUydD/TvQX249kkWZjbVWOqVqkcBWShVFpu97WoOPPEVyArzYIGc1DpQHmQc2lw+7hZOSQ+uwdNXzB3zZoFS4W37t8j/H1hz8LZs2aVFTrz1DNnzp7bNufc5SdRztC8+aO9vV8cDv2oyejmjMYOJfra6Ouoqnqgz7anq2JEr1E3QfBCozEy1s6/ZsfujfrqtEph0XTrEoezotXpu1W0iK1CPtUK9j5OHEidqoHnv360NBn1SPA1/QDk/xt5TnAbTcXOnhqyBelQrVa9YYxlV3jtc+z2NrVGW+UL3FDfcy3HhkmOhHuT9y9svzsa7RBdjodfaDK5kd1gmMdxK5nK/YFAI0L1gcA11QO3BoI1UAHO7hxb2HF3tLLdpteP+vwrbDZOmG5byHiH9bQVoVqfbzM3vMHrFTUSId5hX+EvYdCxSrjewxYWanJmqaQFbkjjco1LjXqa83gP9Cy828+HzFbrriFgt4ErnA5ObDQaXWA0+WXy0tn5Nlq/tK1thY4uc7vdh4bxkm9xvN9kte6cE51vAPxsfVnpXHR0llIq9eh0fYGq/hLIKynLCgo8Wu1AMDqoUqmoaeJympgER3KHeLs0eX41M4TNkIu5U5edgiQLpFsevgwuLKNYefjBZcseLA/HEIEQha8jX0/dTGMQr4AvGlEhJKG1SBIWfujD1+Eru7vi20k19FSHnqB2k+JpAwJNzele6tRHhoip3X4M2eg2vxFOyfiVZdV6Q4cT7oJptZjHkLxuC5iqSjUBpbYKDnA4Ywu0Whp/gbzDtN4mLyhwFqk5maxYTCKEGRCLTZYBs66CvXny/1fItmEjgRNRg9eJy1AkDben4W9MxjPgVBp+hpgO8IvbeW3ymQx4Vxr+NpGbAc9Jw98k7kKtAD8sVIv/9wHAKYBnET+SfgnQxL39ROtZKSqNKJKG21NwkcrJDDiVhp8hJAC/qB2g8tcoQuDJFwG+ECQqFeMBjHbKf1KQuMSRyAd7MyMD2vxfohWbXqhr6sSDjS2PrxWOCp8iKfILEyi44hRT34xxQ3XoxErhZXJB79AnW05eda6jZ5CMt3Ec3rIgMvDLtY+s/UVP4wiJrwM5JO/NJyibkRrhUhRJw+0puDjCP2TAqTT8DDEL4Be1AyN8XoQnb5on+J2b4ve3RH4nb5RnVwI8L9XvXNSdhkdTcLHff2bAi9PwMwQB8IvagX4fRd0ESeyYfIRaLvklYSACRF0q1iKlsy++hAZBOj49gUxxkyiBnHF/AoE382KH+9bKzeo6q21RcPvDPM8iVFBQwBm3Vy7irh3aeoov903sdXqcd6/jR2CxVBy/vcyRk5tLVmOPl7l1Zc92Nx426uA29fy3B1HWj6w1sD7aMjz04fg74SsrKta6f3OMj24cmvOHpe+OnOnpXqOERZT53MeOy/z8alTw7oKf9bWPh33U9LaTRHr0dHr0bxI3ovkAT9zuTUhDnuJuH4qk4fYUXOTuJxlwKg0/M/k1wC9qB7j7kAhP3pHNLgN4Sar9auQDeOJ2q+QTgKsSVvT6BiIN/TQNfWPGBehLaegZBfENLbz2VhqaVZiGvi2/gHsmBRVH/wMiB+CnhGrxtibANUlbpsGWk7cTJR8DtCxJ25LJNPSTNPQN4QL0xTT0zIzJb2jhtWcBmrp5JQXoz1O82EuY0vDCFBxaVqahYn8p6Bmz6aI2oOX3AJq87yR5E6CW1Pj2E7MAnrifJPkrwK3JkQwJaejHaegbX1yAvpCGnokL39DCaycFggToSqqSeiFxfzMqxgQyrCPDMfF09sUHOkRrMUwxFTChg3iwf3Vk1Le1IXH9CZVpSgeD/ZEmy5A3AWCD4nUoexst9DW0kDXJG1GxVU70ENMKJxmx13rlH5r/8jJtTF6MajgYqVhMP3yrtCDjdlR+3sQNta/dlLwfpdeS67XDfv+29BhF7llT3Dsqci95gyQhAXeSewEiDf00DX3jswvQl9LQM78hvqGF164FaPIWRgLqS7a7+AL0pTT0TOJa+SfUh/gDySeJuAFJS/EHD0efoD5EM4R/i6V/hdLfny9lpPie06FnJJ8I/0YzxNId1BfkZsmniVWAic6WMbD3IDf/1fzHyseeqKbO/uPznBdfhCLidkkWOUPyLGGAH5kprItn/pR8yRkcmZuTY1VboqVl1VZzhQzSKxyZJ4LMfpMuZjeH5fIiybMl4hkpY5HCpCoqjhpKHPn5hVplkaW0pLgK6HNItpAQjEpHFu+OH5RsYVkCo1ZJL1D+EsQGFVOzQZKMd9R6Po6Hnjr/Jjko106J8iVzKU+S07MK/4c73OeL5bJymhZTSMVyefKtiIOxWoqKzbk5eXk5uZaiInNObp5kka5CoVCpFIoKnS5SVKRWFxVFdEW2/LzCwrx8W5HCmpcHoZM8qyhXoYUUPbGSILR0dua6WJF5qAGPs8XqKrXKgJBXr+/QZtsX2Kx+2F5H9ZuoGbNnO0xWLjdvNvIgqUxW7zeHZIVFEjGjISWOkm+T+wkTsW5y/uRvQavXESfhX0S8n7hjFyQ0qbM2GRtTCDtNuVJT6PM57x2vW+OwR+Ukw2XZbfZ9Y33raL0GU8GzRlzffZm+rKyPfZcKxjd2HeW4SC0ciG8StflriEY/TT4I/a+frE9Y1XriW0T6/ikVnHr/NH0PN33xFuRG4zuomZKTmfc40uc8yYGYMAsJ/pPx+WhDmLwVF8V/Wfbmmx50XaeghF42QBTIC7scPqFbib9pNWYvTOy0jEl80gtaNj16lgwLIfQSfKLh8hOrAys4fnlg64vV1Y3oTfiDGmtqXtzqX85xy/2rj0P6HuF6/hm/ccUPY7EGaV4wJ7+rsfGNjXr/M7x345uNjV15uYH8/Kaq2OnlXkJC5MZ/Th2bNo8gQScZoDJEENNJCT01Ky5SSV8iHy6T0awU2EHCB8+L/wB34Rah5PVpM2fQ6hnKWbPyywxFFvwGshn0Y/7KRbTOoCgocMhngoSzXh+hsqiszgnPhId8+5wbNvhm/WxTkYIp8VW6+dqF2jKNSW9YXGmpVKn50jx1bp5p3QMPTDxIUTP2UxRIN/UHZxEokT9L5Ubh95j4O5VTFMsXE8T/A/8VTO4AAAEAAAADAABIn0ckXw889QALCAAAAAAAxPARLgAAAADa2D+r/AX91QZHCGIAAAAJAAIAAAAAAAB42mNgZGDgSPp7lYGB5ewf1n9tbO5AEVTACACWDQXjAHjaRdADjBhAAAXR+VsGdVQrrm3btm3bNoPatu2ebdv2RWcrL5o4U90FgL0EcAl7gonlFB/x5gAxZPKTz1wkk11EcZvNvGctSzjMXC7xnXA+8Z7HePIRH9L4JJHGTLy5QDAfdBJnbPBnOxO4ynTO8JpYNrOcBcRzl7N84KFeaq4WaZB6MoIBxSbSnTHUZhm+BBOIBd+5xRiWmZamPdmqoftmgjll+lJoeugf/wRTmGuayNJ0NXWVp8t6p6MlravaoFDZaZqm6r0+sIsX3MabbbzjIb9xU1c10QDam/FmMNOZwhrtx50BPKYr+ylUdUaxtwqXCC5TaI13ueJH5Y5ykffl5vK9Cp94XC6tXMmlKv7lpjNdyUrUUW6rgybKUsmgRoSTTRoAqC07gXogTN0ir+Z9fgAAeNoswQMQ40AAAMA2dlKkUXF627Zt27Zt27Ztc/S2bds2dn3/xHw9fTf9yfz5/VX9+/2X/K8oSOWjylHtqGHUdzozvZ5+ztRh2jOLmB3MDeY7a7Kp2bkcz1XjZnKP+Bg/mT/CfxJyCtWFNsIR4YdYTlwqfpWQNEE6Jn2Tg3I2uao8Qp6v+JWQUk05rDxSM6sz1dVaLm2Btkn7qLfQLxkpjEHGtkDJQMdgpuCAUIbQgtCVcIbwGjOp2dc8aX6LVI90jUyOvLHKW02sXtYwa7K12NplPbTe2X5bsz07lV3Urm/3tCfbC+w19hX7jv3ESe20cwY6k53Lbnq3sFvdbe/2cWe7e9wn7g/P9NJ6+byyXl2vbTQUhdEs0UOxHLH6sZWxk3EpvjhRHaQGJUEDsB7sBofAOXALPAOfIA116MFkMBPsDPvD0XA6XAzXw93wEDwHb6FKqB5qhbqhQWgcmoWWog1oNzqIzqAb6DF6h35iCZsY4tQ4Gy6Iy+IauDFuh3vi2/g5/kRoohGHEJKO5CVlSAMyh6wkp5N4SUr9Xj3JqCTTk6z5/9dOq0kDYZVak1qX2iQAb5yDOAB42mNgZGBgeMCwkUGMoZ2BFcxDAGYGRgA2rwI6eNp9kTVSBEAQRd8q7u5kuDskuLum2Cru7HU4AAkacgAyNOYk/JoaXGrsTcvvESCRU1w43DHAOVh2UMy5Zadi7i27aOTFsvtTjIdcR6ZlL4WOWsuJzDrGLSeT6TixnEK04xrDDoh33FiOE99ajv8UkyL7Mz1ssU2EXUIECLJPMfXUUkeTaFYWn9ZptljW2NcoZkzzpqFJdrWG8bFiMrs40BpkS/Y97UuRotq2du3UqAUImYgD6VUra4sNY91SC7COD79R32dP9t1PdTds1bK/TmNOGxJP4yPAgdSWpNBANbWmdTDAhNqA6LOGVaDqXWEen7lByHiKP2n8n2dva+96ZFo1S2xrrJi3rDZvE5B3nZBsPmXt4TO3HWWIHvoYZ0ZzFfWm6u+3tRVZwPf+c0MaS1Z33NTZQPtX485i/HjaY2BmAIP/WQwpQIqRAQ0AACowAdIAALgB/4WwBI0A";
        },
        702: (e1)=>{
            "use strict";
            e1.exports = "data:font/woff2;base64,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";
        },
        314: (e1)=>{
            "use strict";
            e1.exports = "data:font/woff;base64,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";
        },
        756: (e1)=>{
            "use strict";
            e1.exports = "data:font/woff2;base64,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";
        }
    }, t = {};
    function n(i) {
        var r = t[i];
        if (void 0 !== r) return r.exports;
        var a = t[i] = {
            id: i,
            exports: {}
        };
        return e1[i].call(a.exports, a, a.exports, n), a.exports;
    }
    n.m = e1, n.amdO = {}, n.n = (e1)=>{
        var t = e1 && e1.__esModule ? ()=>e1.default : ()=>e1;
        return n.d(t, {
            a: t
        }), t;
    }, n.d = (e1, t)=>{
        for(var i in t)n.o(t, i) && !n.o(e1, i) && Object.defineProperty(e1, i, {
            enumerable: !0,
            get: t[i]
        });
    }, n.g = function() {
        if ("object" == typeof globalThis) return globalThis;
        try {
            return this || new Function("return this")();
        } catch (e1) {
            if ("object" == typeof window) return window;
        }
    }(), n.o = (e1, t)=>Object.prototype.hasOwnProperty.call(e1, t), n.r = (e1)=>{
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e1, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e1, "__esModule", {
            value: !0
        });
    }, n.b = document.baseURI || self.location.href, n.nc = void 0;
    var i = {};
    (()=>{
        "use strict";
        n.r(i), n.d(i, {
            ApiStore: ()=>Di,
            Widget: ()=>vC,
            rotationModes: ()=>Zi
        });
        var e1 = {};
        n.r(e1), n.d(e1, {
            ACESFilmicToneMapping: ()=>ea,
            AddEquation: ()=>Mr,
            AddOperation: ()=>Zr,
            AdditiveAnimationBlendMode: ()=>Rs,
            AdditiveBlending: ()=>mr,
            AlphaFormat: ()=>za,
            AlwaysCompare: ()=>_o,
            AlwaysDepth: ()=>Br,
            AlwaysStencilFunc: ()=>fo,
            AmbientLight: ()=>jA,
            AnimationAction: ()=>Iv,
            AnimationClip: ()=>cA,
            AnimationLoader: ()=>vA,
            AnimationMixer: ()=>Dv,
            AnimationObjectGroup: ()=>Sv,
            AnimationUtils: ()=>qg,
            ArcCurve: ()=>mm,
            ArrayCamera: ()=>Up,
            ArrowHelper: ()=>xM,
            AttachedBindMode: ()=>na,
            Audio: ()=>dv,
            AudioAnalyser: ()=>vv,
            AudioContext: ()=>$A,
            AudioListener: ()=>hv,
            AudioLoader: ()=>ev,
            AxesHelper: ()=>_M,
            BackSide: ()=>ur,
            BasicDepthPacking: ()=>js,
            BasicShadowMap: ()=>ar,
            Bone: ()=>Nf,
            BooleanKeyframeTrack: ()=>nA,
            Box2: ()=>Hv,
            Box3: ()=>zl,
            Box3Helper: ()=>gM,
            BoxGeometry: ()=>Qu,
            BoxHelper: ()=>mM,
            BufferAttribute: ()=>ou,
            BufferGeometry: ()=>Eu,
            BufferGeometryLoader: ()=>WA,
            ByteType: ()=>wa,
            Cache: ()=>hA,
            Camera: ()=>Ku,
            CameraHelper: ()=>dM,
            CanvasTexture: ()=>dm,
            CapsuleGeometry: ()=>Pm,
            CatmullRomCurve3: ()=>xm,
            CineonToneMapping: ()=>$r,
            CircleGeometry: ()=>Um,
            ClampToEdgeWrapping: ()=>ha,
            Clock: ()=>av,
            Color: ()=>Zc,
            ColorKeyframeTrack: ()=>iA,
            ColorManagement: ()=>dl,
            CompressedArrayTexture: ()=>um,
            CompressedCubeTexture: ()=>hm,
            CompressedTexture: ()=>cm,
            CompressedTextureLoader: ()=>MA,
            ConeGeometry: ()=>jm,
            ConstantAlphaFactor: ()=>Ur,
            ConstantColorFactor: ()=>Or,
            CubeCamera: ()=>eh,
            CubeReflectionMapping: ()=>aa,
            CubeRefractionMapping: ()=>sa,
            CubeTexture: ()=>th,
            CubeTextureLoader: ()=>xA,
            CubeUVReflectionMapping: ()=>ca,
            CubicBezierCurve: ()=>Em,
            CubicBezierCurve3: ()=>Tm,
            CubicInterpolant: ()=>Jg,
            CullFaceBack: ()=>nr,
            CullFaceFront: ()=>ir,
            CullFaceFrontBack: ()=>rr,
            CullFaceNone: ()=>tr,
            Curve: ()=>pm,
            CurvePath: ()=>Rm,
            CustomBlending: ()=>vr,
            CustomToneMapping: ()=>ta,
            CylinderGeometry: ()=>km,
            Cylindrical: ()=>Bv,
            Data3DTexture: ()=>Sl,
            DataArrayTexture: ()=>El,
            DataTexture: ()=>Df,
            DataTextureLoader: ()=>_A,
            DataUtils: ()=>ru,
            DecrementStencilOp: ()=>no,
            DecrementWrapStencilOp: ()=>ro,
            DefaultLoadingManager: ()=>pA,
            DepthFormat: ()=>ka,
            DepthStencilFormat: ()=>ja,
            DepthTexture: ()=>Fp,
            DetachedBindMode: ()=>ia,
            DirectionalLight: ()=>kA,
            DirectionalLightHelper: ()=>cM,
            DiscreteInterpolant: ()=>eA,
            DisplayP3ColorSpace: ()=>Ws,
            DodecahedronGeometry: ()=>Fm,
            DoubleSide: ()=>hr,
            DstAlphaFactor: ()=>Dr,
            DstColorFactor: ()=>Lr,
            DynamicCopyUsage: ()=>Do,
            DynamicDrawUsage: ()=>wo,
            DynamicReadUsage: ()=>So,
            EdgesGeometry: ()=>Wm,
            EllipseCurve: ()=>fm,
            EqualCompare: ()=>Ao,
            EqualDepth: ()=>Vr,
            EqualStencilFunc: ()=>lo,
            EquirectangularReflectionMapping: ()=>oa,
            EquirectangularRefractionMapping: ()=>la,
            Euler: ()=>Ac,
            EventDispatcher: ()=>Uo,
            ExtrudeGeometry: ()=>xg,
            FileLoader: ()=>AA,
            Float16BufferAttribute: ()=>mu,
            Float32BufferAttribute: ()=>gu,
            Float64BufferAttribute: ()=>Au,
            FloatType: ()=>Na,
            Fog: ()=>Xp,
            FogExp2: ()=>Yp,
            FramebufferTexture: ()=>lm,
            FrontSide: ()=>cr,
            Frustum: ()=>ch,
            GLBufferAttribute: ()=>Ov,
            GLSL1: ()=>Lo,
            GLSL3: ()=>Ro,
            GreaterCompare: ()=>Mo,
            GreaterDepth: ()=>Qr,
            GreaterEqualCompare: ()=>xo,
            GreaterEqualDepth: ()=>Gr,
            GreaterEqualStencilFunc: ()=>po,
            GreaterStencilFunc: ()=>uo,
            GridHelper: ()=>rM,
            Group: ()=>kp,
            HalfFloatType: ()=>Da,
            HemisphereLight: ()=>EA,
            HemisphereLightHelper: ()=>iM,
            IcosahedronGeometry: ()=>bg,
            ImageBitmapLoader: ()=>KA,
            ImageLoader: ()=>yA,
            ImageUtils: ()=>gl,
            IncrementStencilOp: ()=>to,
            IncrementWrapStencilOp: ()=>io,
            InstancedBufferAttribute: ()=>zf,
            InstancedBufferGeometry: ()=>QA,
            InstancedInterleavedBuffer: ()=>zv,
            InstancedMesh: ()=>Hf,
            Int16BufferAttribute: ()=>hu,
            Int32BufferAttribute: ()=>pu,
            Int8BufferAttribute: ()=>lu,
            IntType: ()=>Sa,
            InterleavedBuffer: ()=>qp,
            InterleavedBufferAttribute: ()=>Jp,
            Interpolant: ()=>Kg,
            InterpolateDiscrete: ()=>Ts,
            InterpolateLinear: ()=>Ss,
            InterpolateSmooth: ()=>Is,
            InvertStencilOp: ()=>ao,
            KeepStencilOp: ()=>$s,
            KeyframeTrack: ()=>tA,
            LOD: ()=>vf,
            LatheGeometry: ()=>Om,
            Layers: ()=>vc,
            LessCompare: ()=>go,
            LessDepth: ()=>Fr,
            LessEqualCompare: ()=>vo,
            LessEqualDepth: ()=>Hr,
            LessEqualStencilFunc: ()=>co,
            LessStencilFunc: ()=>oo,
            Light: ()=>wA,
            LightProbe: ()=>HA,
            Line: ()=>Zf,
            Line3: ()=>Qv,
            LineBasicMaterial: ()=>Vf,
            LineCurve: ()=>Sm,
            LineCurve3: ()=>Im,
            LineDashedMaterial: ()=>Gg,
            LineLoop: ()=>$f,
            LineSegments: ()=>Jf,
            LinearDisplayP3ColorSpace: ()=>Ys,
            LinearEncoding: ()=>Us,
            LinearFilter: ()=>va,
            LinearInterpolant: ()=>$g,
            LinearMipMapLinearFilter: ()=>_a,
            LinearMipMapNearestFilter: ()=>ya,
            LinearMipmapLinearFilter: ()=>xa,
            LinearMipmapNearestFilter: ()=>Ma,
            LinearSRGBColorSpace: ()=>Qs,
            LinearToneMapping: ()=>Kr,
            LinearTransfer: ()=>Xs,
            Loader: ()=>fA,
            LoaderUtils: ()=>GA,
            LoadingManager: ()=>dA,
            LoopOnce: ()=>bs,
            LoopPingPong: ()=>Es,
            LoopRepeat: ()=>ws,
            LuminanceAlphaFormat: ()=>Ua,
            LuminanceFormat: ()=>Pa,
            MOUSE: ()=>$i,
            Material: ()=>Jc,
            MaterialLoader: ()=>VA,
            MathUtils: ()=>Ko,
            Matrix3: ()=>$o,
            Matrix4: ()=>oc,
            MaxEquation: ()=>br,
            Mesh: ()=>Vu,
            MeshBasicMaterial: ()=>$c,
            MeshDepthMaterial: ()=>Cp,
            MeshDistanceMaterial: ()=>Lp,
            MeshLambertMaterial: ()=>Hg,
            MeshMatcapMaterial: ()=>Vg,
            MeshNormalMaterial: ()=>Fg,
            MeshPhongMaterial: ()=>jg,
            MeshPhysicalMaterial: ()=>kg,
            MeshStandardMaterial: ()=>Ug,
            MeshToonMaterial: ()=>Bg,
            MinEquation: ()=>_r,
            MirroredRepeatWrapping: ()=>da,
            MixOperation: ()=>Xr,
            MultiplyBlending: ()=>Ar,
            MultiplyOperation: ()=>Yr,
            NearestFilter: ()=>pa,
            NearestMipMapLinearFilter: ()=>Aa,
            NearestMipMapNearestFilter: ()=>ma,
            NearestMipmapLinearFilter: ()=>ga,
            NearestMipmapNearestFilter: ()=>fa,
            NeverCompare: ()=>mo,
            NeverDepth: ()=>jr,
            NeverStencilFunc: ()=>so,
            NoBlending: ()=>pr,
            NoColorSpace: ()=>Vs,
            NoToneMapping: ()=>qr,
            NormalAnimationBlendMode: ()=>Ls,
            NormalBlending: ()=>fr,
            NotEqualCompare: ()=>yo,
            NotEqualDepth: ()=>Wr,
            NotEqualStencilFunc: ()=>ho,
            NumberKeyframeTrack: ()=>rA,
            Object3D: ()=>Lc,
            ObjectLoader: ()=>YA,
            ObjectSpaceNormalMap: ()=>Hs,
            OctahedronGeometry: ()=>wg,
            OneFactor: ()=>Er,
            OneMinusConstantAlphaFactor: ()=>kr,
            OneMinusConstantColorFactor: ()=>Pr,
            OneMinusDstAlphaFactor: ()=>Cr,
            OneMinusDstColorFactor: ()=>Rr,
            OneMinusSrcAlphaFactor: ()=>Nr,
            OneMinusSrcColorFactor: ()=>Sr,
            OrthographicCamera: ()=>bh,
            P3Primaries: ()=>Ks,
            PCFShadowMap: ()=>sr,
            PCFSoftShadowMap: ()=>or,
            PMREMGenerator: ()=>zh,
            Path: ()=>zm,
            PerspectiveCamera: ()=>Ju,
            Plane: ()=>sh,
            PlaneGeometry: ()=>dh,
            PlaneHelper: ()=>AM,
            PointLight: ()=>PA,
            PointLightHelper: ()=>$v,
            Points: ()=>am,
            PointsMaterial: ()=>em,
            PolarGridHelper: ()=>aM,
            PolyhedronGeometry: ()=>Bm,
            PositionalAudio: ()=>Av,
            PropertyBinding: ()=>Tv,
            PropertyMixer: ()=>Mv,
            QuadraticBezierCurve: ()=>Nm,
            QuadraticBezierCurve3: ()=>Dm,
            Quaternion: ()=>Dl,
            QuaternionKeyframeTrack: ()=>sA,
            QuaternionLinearInterpolant: ()=>aA,
            RED_GREEN_RGTC2_Format: ()=>xs,
            RED_RGTC1_Format: ()=>Ms,
            REVISION: ()=>Ji,
            RGBADepthPacking: ()=>Bs,
            RGBAFormat: ()=>Oa,
            RGBAIntegerFormat: ()=>Ga,
            RGBA_ASTC_10x10_Format: ()=>ps,
            RGBA_ASTC_10x5_Format: ()=>us,
            RGBA_ASTC_10x6_Format: ()=>hs,
            RGBA_ASTC_10x8_Format: ()=>ds,
            RGBA_ASTC_12x10_Format: ()=>fs,
            RGBA_ASTC_12x12_Format: ()=>ms,
            RGBA_ASTC_4x4_Format: ()=>ns,
            RGBA_ASTC_5x4_Format: ()=>is,
            RGBA_ASTC_5x5_Format: ()=>rs,
            RGBA_ASTC_6x5_Format: ()=>as,
            RGBA_ASTC_6x6_Format: ()=>ss,
            RGBA_ASTC_8x5_Format: ()=>os,
            RGBA_ASTC_8x6_Format: ()=>ls,
            RGBA_ASTC_8x8_Format: ()=>cs,
            RGBA_BPTC_Format: ()=>gs,
            RGBA_ETC2_EAC_Format: ()=>ts,
            RGBA_PVRTC_2BPPV1_Format: ()=>Ja,
            RGBA_PVRTC_4BPPV1_Format: ()=>Ka,
            RGBA_S3TC_DXT1_Format: ()=>Wa,
            RGBA_S3TC_DXT3_Format: ()=>Ya,
            RGBA_S3TC_DXT5_Format: ()=>Xa,
            RGB_BPTC_SIGNED_Format: ()=>As,
            RGB_BPTC_UNSIGNED_Format: ()=>vs,
            RGB_ETC1_Format: ()=>$a,
            RGB_ETC2_Format: ()=>es,
            RGB_PVRTC_2BPPV1_Format: ()=>qa,
            RGB_PVRTC_4BPPV1_Format: ()=>Za,
            RGB_S3TC_DXT1_Format: ()=>Qa,
            RGFormat: ()=>Ha,
            RGIntegerFormat: ()=>Va,
            RawShaderMaterial: ()=>Pg,
            Ray: ()=>sc,
            Raycaster: ()=>Pv,
            Rec709Primaries: ()=>qs,
            RectAreaLight: ()=>BA,
            RedFormat: ()=>Ba,
            RedIntegerFormat: ()=>Fa,
            ReinhardToneMapping: ()=>Jr,
            RenderTarget: ()=>bl,
            RepeatWrapping: ()=>ua,
            ReplaceStencilOp: ()=>eo,
            ReverseSubtractEquation: ()=>xr,
            RingGeometry: ()=>Eg,
            SIGNED_RED_GREEN_RGTC2_Format: ()=>_s,
            SIGNED_RED_RGTC1_Format: ()=>ys,
            SRGBColorSpace: ()=>Gs,
            SRGBTransfer: ()=>Zs,
            Scene: ()=>Zp,
            ShaderChunk: ()=>ph,
            ShaderLib: ()=>mh,
            ShaderMaterial: ()=>qu,
            ShadowMaterial: ()=>Og,
            Shape: ()=>Ym,
            ShapeGeometry: ()=>Tg,
            ShapePath: ()=>bM,
            ShapeUtils: ()=>vg,
            ShortType: ()=>Ea,
            Skeleton: ()=>Rf,
            SkeletonHelper: ()=>Kv,
            SkinnedMesh: ()=>If,
            Source: ()=>vl,
            Sphere: ()=>Jl,
            SphereGeometry: ()=>Sg,
            Spherical: ()=>jv,
            SphericalHarmonics3: ()=>FA,
            SplineCurve: ()=>Cm,
            SpotLight: ()=>CA,
            SpotLightHelper: ()=>Yv,
            Sprite: ()=>ff,
            SpriteMaterial: ()=>$p,
            SrcAlphaFactor: ()=>Ir,
            SrcAlphaSaturateFactor: ()=>zr,
            SrcColorFactor: ()=>Tr,
            StaticCopyUsage: ()=>No,
            StaticDrawUsage: ()=>bo,
            StaticReadUsage: ()=>To,
            StereoCamera: ()=>rv,
            StreamCopyUsage: ()=>Co,
            StreamDrawUsage: ()=>Eo,
            StreamReadUsage: ()=>Io,
            StringKeyframeTrack: ()=>oA,
            SubtractEquation: ()=>yr,
            SubtractiveBlending: ()=>gr,
            TOUCH: ()=>er,
            TangentSpaceNormalMap: ()=>Fs,
            TetrahedronGeometry: ()=>Ig,
            Texture: ()=>xl,
            TextureLoader: ()=>bA,
            TorusGeometry: ()=>Ng,
            TorusKnotGeometry: ()=>Dg,
            Triangle: ()=>Gc,
            TriangleFanDrawMode: ()=>Ps,
            TriangleStripDrawMode: ()=>Os,
            TrianglesDrawMode: ()=>zs,
            TubeGeometry: ()=>Cg,
            TwoPassDoubleSide: ()=>dr,
            UVMapping: ()=>ra,
            Uint16BufferAttribute: ()=>du,
            Uint32BufferAttribute: ()=>fu,
            Uint8BufferAttribute: ()=>cu,
            Uint8ClampedBufferAttribute: ()=>uu,
            Uniform: ()=>Cv,
            UniformsGroup: ()=>Rv,
            UniformsLib: ()=>fh,
            UniformsUtils: ()=>Zu,
            UnsignedByteType: ()=>ba,
            UnsignedInt248Type: ()=>Ra,
            UnsignedIntType: ()=>Ia,
            UnsignedShort4444Type: ()=>Ca,
            UnsignedShort5551Type: ()=>La,
            UnsignedShortType: ()=>Ta,
            VSMShadowMap: ()=>lr,
            Vector2: ()=>Jo,
            Vector3: ()=>Cl,
            Vector4: ()=>_l,
            VectorKeyframeTrack: ()=>lA,
            VideoTexture: ()=>om,
            WebGL1Renderer: ()=>Wp,
            WebGL3DRenderTarget: ()=>Il,
            WebGLArrayRenderTarget: ()=>Tl,
            WebGLCoordinateSystem: ()=>Oo,
            WebGLCubeRenderTarget: ()=>nh,
            WebGLMultipleRenderTargets: ()=>Nl,
            WebGLRenderTarget: ()=>wl,
            WebGLRenderer: ()=>Qp,
            WebGLUtils: ()=>Pp,
            WebGPUCoordinateSystem: ()=>Po,
            WireframeGeometry: ()=>Lg,
            WrapAroundEnding: ()=>Cs,
            ZeroCurvatureEnding: ()=>Ns,
            ZeroFactor: ()=>wr,
            ZeroSlopeEnding: ()=>Ds,
            ZeroStencilOp: ()=>Js,
            _SRGBAFormat: ()=>zo,
            createCanvasElement: ()=>al,
            sRGBEncoding: ()=>ks
        });
        var t = n(471), r = n(72), a = n.n(r), s = n(825), o = n.n(s), l = n(659), c = n.n(l), u = n(56), h = n.n(u), d = n(540), p = n.n(d), f = n(113), m = n.n(f), g = n(234), A = {};
        A.styleTagTransform = m(), A.setAttributes = h(), A.insert = c().bind(null, "head"), A.domAPI = o(), A.insertStyleElement = p(), a()(g.A, A), g.A && g.A.locals && g.A.locals;
        var v = n(744), M = {};
        M.styleTagTransform = m(), M.setAttributes = h(), M.insert = c().bind(null, "head"), M.domAPI = o(), M.insertStyleElement = p(), a()(v.A, M), v.A && v.A.locals && v.A.locals;
        var y = n(19), x = {};
        x.styleTagTransform = m(), x.setAttributes = h(), x.insert = c().bind(null, "head"), x.domAPI = o(), x.insertStyleElement = p(), a()(y.A, x), y.A && y.A.locals && y.A.locals;
        var _ = n(465), b = {};
        b.styleTagTransform = m(), b.setAttributes = h(), b.insert = c().bind(null, "head"), b.domAPI = o(), b.insertStyleElement = p(), a()(_.A, b), _.A && _.A.locals && _.A.locals;
        var w = n(132), E = {};
        function T(e1) {
            for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
            throw new Error("number" == typeof e1 ? "[MobX] minified error nr: " + e1 + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e1);
        }
        E.styleTagTransform = m(), E.setAttributes = h(), E.insert = c().bind(null, "head"), E.domAPI = o(), E.insertStyleElement = p(), a()(w.A, E), w.A && w.A.locals && w.A.locals;
        var S = {};
        function I() {
            return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : void 0 !== n.g ? n.g : "undefined" != typeof self ? self : S;
        }
        var N = Object.assign, D = Object.getOwnPropertyDescriptor, C = Object.defineProperty, L = Object.prototype, R = [];
        Object.freeze(R);
        var z = {};
        Object.freeze(z);
        var O = "undefined" != typeof Proxy, P = Object.toString();
        function U() {
            O || T("Proxy not available");
        }
        function k(e1) {
            var t = !1;
            return function() {
                if (!t) return t = !0, e1.apply(this, arguments);
            };
        }
        var j = function() {};
        function B(e1) {
            return "function" == typeof e1;
        }
        function F(e1) {
            switch(typeof e1){
                case "string":
                case "symbol":
                case "number":
                    return !0;
            }
            return !1;
        }
        function H(e1) {
            return null !== e1 && "object" == typeof e1;
        }
        function V(e1) {
            if (!H(e1)) return !1;
            var t = Object.getPrototypeOf(e1);
            if (null == t) return !0;
            var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
            return "function" == typeof n && n.toString() === P;
        }
        function G(e1) {
            var t = null == e1 ? void 0 : e1.constructor;
            return !!t && ("GeneratorFunction" === t.name || "GeneratorFunction" === t.displayName);
        }
        function Q(e1, t, n) {
            C(e1, t, {
                enumerable: !1,
                writable: !0,
                configurable: !0,
                value: n
            });
        }
        function W(e1, t, n) {
            C(e1, t, {
                enumerable: !1,
                writable: !1,
                configurable: !0,
                value: n
            });
        }
        function Y(e1, t) {
            var n = "isMobX" + e1;
            return t.prototype[n] = !0, function(e1) {
                return H(e1) && !0 === e1[n];
            };
        }
        function X(e1) {
            return null != e1 && "[object Map]" === Object.prototype.toString.call(e1);
        }
        function Z(e1) {
            return null != e1 && "[object Set]" === Object.prototype.toString.call(e1);
        }
        var q = void 0 !== Object.getOwnPropertySymbols, K = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : q ? function(e1) {
            return Object.getOwnPropertyNames(e1).concat(Object.getOwnPropertySymbols(e1));
        } : Object.getOwnPropertyNames;
        function J(e1) {
            return null === e1 ? null : "object" == typeof e1 ? "" + e1 : e1;
        }
        function $(e1, t) {
            return L.hasOwnProperty.call(e1, t);
        }
        var ee = Object.getOwnPropertyDescriptors || function(e1) {
            var t = {};
            return K(e1).forEach(function(n) {
                t[n] = D(e1, n);
            }), t;
        };
        function te(e1, t) {
            return !!(e1 & t);
        }
        function ne(e1, t, n) {
            return n ? e1 |= t : e1 &= ~t, e1;
        }
        function ie(e1, t) {
            (null == t || t > e1.length) && (t = e1.length);
            for(var n = 0, i = Array(t); n < t; n++)i[n] = e1[n];
            return i;
        }
        function re(e1, t) {
            for(var n = 0; n < t.length; n++){
                var i = t[n];
                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e1, ue(i.key), i);
            }
        }
        function ae(e1, t, n) {
            return t && re(e1.prototype, t), n && re(e1, n), Object.defineProperty(e1, "prototype", {
                writable: !1
            }), e1;
        }
        function se(e1, t) {
            var n = "undefined" != typeof Symbol && e1[Symbol.iterator] || e1["@@iterator"];
            if (n) return (n = n.call(e1)).next.bind(n);
            if (Array.isArray(e1) || (n = function(e1, t) {
                if (e1) {
                    if ("string" == typeof e1) return ie(e1, t);
                    var n = ({}).toString.call(e1).slice(8, -1);
                    return "Object" === n && e1.constructor && (n = e1.constructor.name), "Map" === n || "Set" === n ? Array.from(e1) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ie(e1, t) : void 0;
                }
            }(e1)) || t && e1 && "number" == typeof e1.length) {
                n && (e1 = n);
                var i = 0;
                return function() {
                    return i >= e1.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: e1[i++]
                    };
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function oe() {
            return oe = Object.assign ? Object.assign.bind() : function(e1) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var i in n)({}).hasOwnProperty.call(n, i) && (e1[i] = n[i]);
                }
                return e1;
            }, oe.apply(null, arguments);
        }
        function le(e1, t) {
            e1.prototype = Object.create(t.prototype), e1.prototype.constructor = e1, ce(e1, t);
        }
        function ce(e1, t) {
            return ce = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e1, t) {
                return e1.__proto__ = t, e1;
            }, ce(e1, t);
        }
        function ue(e1) {
            var t = function(e1) {
                if ("object" != typeof e1 || !e1) return e1;
                var t = e1[Symbol.toPrimitive];
                if (void 0 !== t) {
                    var n = t.call(e1, "string");
                    if ("object" != typeof n) return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return String(e1);
            }(e1);
            return "symbol" == typeof t ? t : t + "";
        }
        var he = Symbol("mobx-stored-annotations");
        function de(e1) {
            return Object.assign(function(t, n) {
                if (fe(n)) return e1.decorate_20223_(t, n);
                pe(t, n, e1);
            }, e1);
        }
        function pe(e1, t, n) {
            $(e1, he) || Q(e1, he, oe({}, e1[he])), function(e1) {
                return e1.annotationType_ === _e;
            }(n) || (e1[he][t] = n);
        }
        function fe(e1) {
            return "object" == typeof e1 && "string" == typeof e1.kind;
        }
        var me = Symbol("mobx administration"), ge = function() {
            function e1(e1) {
                void 0 === e1 && (e1 = "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = new Set, this.lastAccessedBy_ = 0, this.lowestObserverState_ = Mt.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = e1;
            }
            var t = e1.prototype;
            return t.onBO = function() {
                this.onBOL && this.onBOL.forEach(function(e1) {
                    return e1();
                });
            }, t.onBUO = function() {
                this.onBUOL && this.onBUOL.forEach(function(e1) {
                    return e1();
                });
            }, t.reportObserved = function() {
                return Ft(this);
            }, t.reportChanged = function() {
                jt(), Ht(this), Bt();
            }, t.toString = function() {
                return this.name_;
            }, ae(e1, [
                {
                    key: "isBeingObserved",
                    get: function() {
                        return te(this.flags_, e1.isBeingObservedMask_);
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.isBeingObservedMask_, t);
                    }
                },
                {
                    key: "isPendingUnobservation",
                    get: function() {
                        return te(this.flags_, e1.isPendingUnobservationMask_);
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.isPendingUnobservationMask_, t);
                    }
                },
                {
                    key: "diffValue",
                    get: function() {
                        return te(this.flags_, e1.diffValueMask_) ? 1 : 0;
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.diffValueMask_, 1 === t);
                    }
                }
            ]);
        }();
        ge.isBeingObservedMask_ = 1, ge.isPendingUnobservationMask_ = 2, ge.diffValueMask_ = 4;
        var Ae = Y("Atom", ge);
        function ve(e1, t, n) {
            void 0 === t && (t = j), void 0 === n && (n = j);
            var i = new ge(e1);
            return t !== j && un(on, i, t, undefined), n !== j && cn(i, n), i;
        }
        var Me = {
            identity: function(e1, t) {
                return e1 === t;
            },
            structural: function(e1, t) {
                return wi(e1, t);
            },
            default: function(e1, t) {
                return Object.is ? Object.is(e1, t) : e1 === t ? 0 !== e1 || 1 / e1 == 1 / t : e1 != e1 && t != t;
            },
            shallow: function(e1, t) {
                return wi(e1, t, 1);
            }
        };
        function ye(e1, t, n) {
            return _n(e1) ? e1 : Array.isArray(e1) ? at.array(e1, {
                name: n
            }) : V(e1) ? at.object(e1, void 0, {
                name: n
            }) : X(e1) ? at.map(e1, {
                name: n
            }) : Z(e1) ? at.set(e1, {
                name: n
            }) : "function" != typeof e1 || an(e1) || xn(e1) ? e1 : G(e1) ? Mn(e1) : rn(n, e1);
        }
        function xe(e1) {
            return e1;
        }
        var _e = "override";
        function be(e1, t) {
            return {
                annotationType_: e1,
                options_: t,
                make_: we,
                extend_: Ee,
                decorate_20223_: Te
            };
        }
        function we(e1, t, n, i) {
            var r;
            if (null != (r = this.options_) && r.bound) return null === this.extend_(e1, t, n, !1) ? 0 : 1;
            if (i === e1.target_) return null === this.extend_(e1, t, n, !1) ? 0 : 2;
            if (an(n.value)) return 1;
            var a = Se(e1, this, t, n, !1);
            return C(i, t, a), 2;
        }
        function Ee(e1, t, n, i) {
            var r = Se(e1, this, t, n);
            return e1.defineProperty_(t, r, i);
        }
        function Te(e1, t) {
            var n = t.kind, i = t.name, r = t.addInitializer, a = this;
            if ("field" != n) {
                var s, o, l, c, u, h;
                if ("method" == n) return an(e1) || (o = e1, e1 = ft(null != (l = null == (c = a.options_) ? void 0 : c.name) ? l : i.toString(), o, null != (u = null == (h = a.options_) ? void 0 : h.autoAction) && u)), null != (s = this.options_) && s.bound && r(function() {
                    var e1 = this, t = e1[i].bind(e1);
                    t.isMobxAction = !0, e1[i] = t;
                }), e1;
                T("Cannot apply '" + a.annotationType_ + "' to '" + String(i) + "' (kind: " + n + "):\n'" + a.annotationType_ + "' can only be used on properties with a function value.");
            } else r(function() {
                pe(this, i, a);
            });
        }
        function Se(e1, t, n, i, r) {
            var a, s, o, l, c, u, h, d;
            void 0 === r && (r = Pt.safeDescriptors), d = i, t.annotationType_, d.value;
            var p, f = i.value;
            return null != (a = t.options_) && a.bound && (f = f.bind(null != (p = e1.proxy_) ? p : e1.target_)), {
                value: ft(null != (s = null == (o = t.options_) ? void 0 : o.name) ? s : n.toString(), f, null != (l = null == (c = t.options_) ? void 0 : c.autoAction) && l, null != (u = t.options_) && u.bound ? null != (h = e1.proxy_) ? h : e1.target_ : void 0),
                configurable: !r || e1.isPlainObject_,
                enumerable: !1,
                writable: !r
            };
        }
        function Ie(e1, t) {
            return {
                annotationType_: e1,
                options_: t,
                make_: Ne,
                extend_: De,
                decorate_20223_: Ce
            };
        }
        function Ne(e1, t, n, i) {
            var r;
            if (i === e1.target_) return null === this.extend_(e1, t, n, !1) ? 0 : 2;
            if (null != (r = this.options_) && r.bound && (!$(e1.target_, t) || !xn(e1.target_[t])) && null === this.extend_(e1, t, n, !1)) return 0;
            if (xn(n.value)) return 1;
            var a = Le(e1, this, 0, n, !1, !1);
            return C(i, t, a), 2;
        }
        function De(e1, t, n, i) {
            var r, a = Le(e1, this, 0, n, null == (r = this.options_) ? void 0 : r.bound);
            return e1.defineProperty_(t, a, i);
        }
        function Ce(e1, t) {
            var n, i = t.name, r = t.addInitializer;
            return xn(e1) || (e1 = Mn(e1)), null != (n = this.options_) && n.bound && r(function() {
                var e1 = this, t = e1[i].bind(e1);
                t.isMobXFlow = !0, e1[i] = t;
            }), e1;
        }
        function Le(e1, t, n, i, r, a) {
            var s;
            void 0 === a && (a = Pt.safeDescriptors), s = i, t.annotationType_, s.value;
            var o, l = i.value;
            return xn(l) || (l = Mn(l)), r && ((l = l.bind(null != (o = e1.proxy_) ? o : e1.target_)).isMobXFlow = !0), {
                value: l,
                configurable: !a || e1.isPlainObject_,
                enumerable: !1,
                writable: !a
            };
        }
        function Re(e1, t) {
            return {
                annotationType_: e1,
                options_: t,
                make_: ze,
                extend_: Oe,
                decorate_20223_: Pe
            };
        }
        function ze(e1, t, n) {
            return null === this.extend_(e1, t, n, !1) ? 0 : 1;
        }
        function Oe(e1, t, n, i) {
            var r;
            return r = n, this.annotationType_, r.get, e1.defineComputedProperty_(t, oe({}, this.options_, {
                get: n.get,
                set: n.set
            }), i);
        }
        function Pe(e1, t) {
            var n = this, i = t.name;
            return (0, t.addInitializer)(function() {
                var t = ii(this)[me], r = oe({}, n.options_, {
                    get: e1,
                    context: this
                });
                r.name || (r.name = "ObservableObject." + i.toString()), t.values_.set(i, new vt(r));
            }), function() {
                return this[me].getObservablePropValue_(i);
            };
        }
        function Ue(e1, t) {
            return {
                annotationType_: e1,
                options_: t,
                make_: ke,
                extend_: je,
                decorate_20223_: Be
            };
        }
        function ke(e1, t, n) {
            return null === this.extend_(e1, t, n, !1) ? 0 : 1;
        }
        function je(e1, t, n, i) {
            var r, a;
            return this.annotationType_, e1.defineObservableProperty_(t, n.value, null != (r = null == (a = this.options_) ? void 0 : a.enhancer) ? r : ye, i);
        }
        function Be(e1, t) {
            var n = this, i = t.kind, r = t.name, a = new WeakSet;
            function s(e1, t) {
                var i, s, o = ii(e1)[me], l = new At(t, null != (i = null == (s = n.options_) ? void 0 : s.enhancer) ? i : ye, "ObservableObject." + r.toString(), !1);
                o.values_.set(r, l), a.add(e1);
            }
            if ("accessor" == i) return {
                get: function() {
                    return a.has(this) || s(this, e1.get.call(this)), this[me].getObservablePropValue_(r);
                },
                set: function(e1) {
                    return a.has(this) || s(this, e1), this[me].setObservablePropValue_(r, e1);
                },
                init: function(e1) {
                    return a.has(this) || s(this, e1), e1;
                }
            };
        }
        var Fe = "true", He = Ve();
        function Ve(e1) {
            return {
                annotationType_: Fe,
                options_: e1,
                make_: Ge,
                extend_: Qe,
                decorate_20223_: We
            };
        }
        function Ge(e1, t, n, i) {
            var r, a, s, o;
            if (n.get) return ct.make_(e1, t, n, i);
            if (n.set) {
                var l = ft(t.toString(), n.set);
                return i === e1.target_ ? null === e1.defineProperty_(t, {
                    configurable: !Pt.safeDescriptors || e1.isPlainObject_,
                    set: l
                }) ? 0 : 2 : (C(i, t, {
                    configurable: !0,
                    set: l
                }), 2);
            }
            if (i !== e1.target_ && "function" == typeof n.value) return G(n.value) ? (null != (o = this.options_) && o.autoBind ? Mn.bound : Mn).make_(e1, t, n, i) : (null != (s = this.options_) && s.autoBind ? rn.bound : rn).make_(e1, t, n, i);
            var c, u = !1 === (null == (r = this.options_) ? void 0 : r.deep) ? at.ref : at;
            return "function" == typeof n.value && null != (a = this.options_) && a.autoBind && (n.value = n.value.bind(null != (c = e1.proxy_) ? c : e1.target_)), u.make_(e1, t, n, i);
        }
        function Qe(e1, t, n, i) {
            var r, a, s;
            return n.get ? ct.extend_(e1, t, n, i) : n.set ? e1.defineProperty_(t, {
                configurable: !Pt.safeDescriptors || e1.isPlainObject_,
                set: ft(t.toString(), n.set)
            }, i) : ("function" == typeof n.value && null != (r = this.options_) && r.autoBind && (n.value = n.value.bind(null != (s = e1.proxy_) ? s : e1.target_)), (!1 === (null == (a = this.options_) ? void 0 : a.deep) ? at.ref : at).extend_(e1, t, n, i));
        }
        function We(e1, t) {
            T("'" + this.annotationType_ + "' cannot be used as a decorator");
        }
        var Ye = {
            deep: !0,
            name: void 0,
            defaultDecorator: void 0,
            proxy: !0
        };
        function Xe(e1) {
            return e1 || Ye;
        }
        Object.freeze(Ye);
        var Ze = Ue("observable"), qe = Ue("observable.ref", {
            enhancer: xe
        }), Ke = Ue("observable.shallow", {
            enhancer: function(e1, t, n) {
                return null == e1 || si(e1) || Qn(e1) || qn(e1) || $n(e1) ? e1 : Array.isArray(e1) ? at.array(e1, {
                    name: n,
                    deep: !1
                }) : V(e1) ? at.object(e1, void 0, {
                    name: n,
                    deep: !1
                }) : X(e1) ? at.map(e1, {
                    name: n,
                    deep: !1
                }) : Z(e1) ? at.set(e1, {
                    name: n,
                    deep: !1
                }) : void 0;
            }
        }), Je = Ue("observable.struct", {
            enhancer: function(e1, t) {
                return wi(e1, t) ? t : e1;
            }
        }), $e = de(Ze);
        function et(e1) {
            var t, n, i;
            return !0 === e1.deep ? ye : !1 === e1.deep ? xe : (t = e1.defaultDecorator) && null != (n = null == (i = t.options_) ? void 0 : i.enhancer) ? n : ye;
        }
        function tt(e1, t, n) {
            return fe(t) ? Ze.decorate_20223_(e1, t) : F(t) ? void pe(e1, t, Ze) : _n(e1) ? e1 : V(e1) ? at.object(e1, t, n) : Array.isArray(e1) ? at.array(e1, t) : X(e1) ? at.map(e1, t) : Z(e1) ? at.set(e1, t) : "object" == typeof e1 && null !== e1 ? e1 : at.box(e1, t);
        }
        N(tt, $e);
        var nt, it, rt = {
            box: function(e1, t) {
                var n = Xe(t);
                return new At(e1, et(n), n.name, !0, n.equals);
            },
            array: function(e1, t) {
                var n = Xe(t);
                return (!1 === Pt.useProxies || !1 === n.proxy ? vi : kn)(e1, et(n), n.name);
            },
            map: function(e1, t) {
                var n = Xe(t);
                return new Zn(e1, et(n), n.name);
            },
            set: function(e1, t) {
                var n = Xe(t);
                return new Jn(e1, et(n), n.name);
            },
            object: function(e1, t, n) {
                return _i(function() {
                    return pn(!1 === Pt.useProxies || !1 === (null == n ? void 0 : n.proxy) ? ii({}, n) : function(e1, t) {
                        var n, i;
                        return U(), null != (i = (n = (e1 = ii(e1, t))[me]).proxy_) ? i : n.proxy_ = new Proxy(e1, En);
                    }({}, n), e1, t);
                });
            },
            ref: de(qe),
            shallow: de(Ke),
            deep: $e,
            struct: de(Je)
        }, at = N(tt, rt), st = "computed", ot = Re(st), lt = Re("computed.struct", {
            equals: Me.structural
        }), ct = function(e1, t) {
            if (fe(t)) return ot.decorate_20223_(e1, t);
            if (F(t)) return pe(e1, t, ot);
            if (V(e1)) return de(Re(st, e1));
            var n = V(t) ? t : {};
            return n.get = e1, n.name || (n.name = e1.name || ""), new vt(n);
        };
        Object.assign(ct, ot), ct.struct = de(lt);
        var ut = 0, ht = 1, dt = null != (nt = null == (it = D(function() {}, "name")) ? void 0 : it.configurable) && nt, pt = {
            value: "action",
            configurable: !0,
            writable: !1,
            enumerable: !1
        };
        function ft(e1, t, n, i) {
            function r() {
                return function(e1, t, n, i, r) {
                    var a = function(e1, t) {
                        var n = !1, i = 0, r = Pt.trackingDerivation, a = !t || !r;
                        jt();
                        var s = Pt.allowStateChanges;
                        a && (It(), s = mt(!0));
                        var o = {
                            runAsAction_: a,
                            prevDerivation_: r,
                            prevAllowStateChanges_: s,
                            prevAllowStateReads_: Dt(!0),
                            notifySpy_: n,
                            startTime_: i,
                            actionId_: ht++,
                            parentActionId_: ut
                        };
                        return ut = o.actionId_, o;
                    }(0, t);
                    try {
                        return n.apply(i, r);
                    } catch (e1) {
                        throw a.error_ = e1, e1;
                    } finally{
                        !function(e1) {
                            ut !== e1.actionId_ && T(30), ut = e1.parentActionId_, void 0 !== e1.error_ && (Pt.suppressReactionErrors = !0), gt(e1.prevAllowStateChanges_), Ct(e1.prevAllowStateReads_), Bt(), e1.runAsAction_ && Nt(e1.prevDerivation_), Pt.suppressReactionErrors = !1;
                        }(a);
                    }
                }(0, n, t, i || this, arguments);
            }
            return void 0 === n && (n = !1), r.isMobxAction = !0, r.toString = function() {
                return t.toString();
            }, dt && (pt.value = e1, C(r, "name", pt)), r;
        }
        function mt(e1) {
            var t = Pt.allowStateChanges;
            return Pt.allowStateChanges = e1, t;
        }
        function gt(e1) {
            Pt.allowStateChanges = e1;
        }
        var At = function(e1) {
            function t(t, n, i, r, a) {
                var s;
                return void 0 === i && (i = "ObservableValue"), void 0 === r && (r = !0), void 0 === a && (a = Me.default), (s = e1.call(this, i) || this).enhancer = void 0, s.name_ = void 0, s.equals = void 0, s.hasUnreportedChange_ = !1, s.interceptors_ = void 0, s.changeListeners_ = void 0, s.value_ = void 0, s.dehancer = void 0, s.enhancer = n, s.name_ = i, s.equals = a, s.value_ = n(t, void 0, i), s;
            }
            le(t, e1);
            var n = t.prototype;
            return n.dehanceValue = function(e1) {
                return void 0 !== this.dehancer ? this.dehancer(e1) : e1;
            }, n.set = function(e1) {
                this.value_, (e1 = this.prepareNewValue_(e1)) !== Pt.UNCHANGED && this.setNewValue_(e1);
            }, n.prepareNewValue_ = function(e1) {
                if (Tn(this)) {
                    var t = In(this, {
                        object: this,
                        type: On,
                        newValue: e1
                    });
                    if (!t) return Pt.UNCHANGED;
                    e1 = t.newValue;
                }
                return e1 = this.enhancer(e1, this.value_, this.name_), this.equals(this.value_, e1) ? Pt.UNCHANGED : e1;
            }, n.setNewValue_ = function(e1) {
                var t = this.value_;
                this.value_ = e1, this.reportChanged(), Nn(this) && Cn(this, {
                    type: On,
                    object: this,
                    newValue: e1,
                    oldValue: t
                });
            }, n.get = function() {
                return this.reportObserved(), this.dehanceValue(this.value_);
            }, n.intercept_ = function(e1) {
                return Sn(this, e1);
            }, n.observe_ = function(e1, t) {
                return t && e1({
                    observableKind: "value",
                    debugObjectName: this.name_,
                    object: this,
                    type: On,
                    newValue: this.value_,
                    oldValue: void 0
                }), Dn(this, e1);
            }, n.raw = function() {
                return this.value_;
            }, n.toJSON = function() {
                return this.get();
            }, n.toString = function() {
                return this.name_ + "[" + this.value_ + "]";
            }, n.valueOf = function() {
                return J(this.get());
            }, n[Symbol.toPrimitive] = function() {
                return this.valueOf();
            }, t;
        }(ge), vt = function() {
            function e1(e1) {
                this.dependenciesState_ = Mt.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = new Set, this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = Mt.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new _t(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = yt.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, e1.get || T(31), this.derivation = e1.get, this.name_ = e1.name || "ComputedValue", e1.set && (this.setter_ = ft("ComputedValue-setter", e1.set)), this.equals_ = e1.equals || (e1.compareStructural || e1.struct ? Me.structural : Me.default), this.scope_ = e1.context, this.requiresReaction_ = e1.requiresReaction, this.keepAlive_ = !!e1.keepAlive;
            }
            var t = e1.prototype;
            return t.onBecomeStale_ = function() {
                var e1;
                (e1 = this).lowestObserverState_ === Mt.UP_TO_DATE_ && (e1.lowestObserverState_ = Mt.POSSIBLY_STALE_, e1.observers_.forEach(function(e1) {
                    e1.dependenciesState_ === Mt.UP_TO_DATE_ && (e1.dependenciesState_ = Mt.POSSIBLY_STALE_, e1.onBecomeStale_());
                }));
            }, t.onBO = function() {
                this.onBOL && this.onBOL.forEach(function(e1) {
                    return e1();
                });
            }, t.onBUO = function() {
                this.onBUOL && this.onBUOL.forEach(function(e1) {
                    return e1();
                });
            }, t.get = function() {
                if (this.isComputing && T(32, this.name_, this.derivation), 0 !== Pt.inBatch || 0 !== this.observers_.size || this.keepAlive_) {
                    if (Ft(this), wt(this)) {
                        var e1 = Pt.trackingContext;
                        this.keepAlive_ && !e1 && (Pt.trackingContext = this), this.trackAndCompute() && (t = this).lowestObserverState_ !== Mt.STALE_ && (t.lowestObserverState_ = Mt.STALE_, t.observers_.forEach(function(e1) {
                            e1.dependenciesState_ === Mt.POSSIBLY_STALE_ ? e1.dependenciesState_ = Mt.STALE_ : e1.dependenciesState_ === Mt.UP_TO_DATE_ && (t.lowestObserverState_ = Mt.UP_TO_DATE_);
                        })), Pt.trackingContext = e1;
                    }
                } else wt(this) && (this.warnAboutUntrackedRead_(), jt(), this.value_ = this.computeValue_(!1), Bt());
                var t, n = this.value_;
                if (bt(n)) throw n.cause;
                return n;
            }, t.set = function(e1) {
                if (this.setter_) {
                    this.isRunningSetter && T(33, this.name_), this.isRunningSetter = !0;
                    try {
                        this.setter_.call(this.scope_, e1);
                    } finally{
                        this.isRunningSetter = !1;
                    }
                } else T(34, this.name_);
            }, t.trackAndCompute = function() {
                var e1 = this.value_, t = this.dependenciesState_ === Mt.NOT_TRACKING_, n = this.computeValue_(!0), i = t || bt(e1) || bt(n) || !this.equals_(e1, n);
                return i && (this.value_ = n), i;
            }, t.computeValue_ = function(e1) {
                this.isComputing = !0;
                var t, n = mt(!1);
                if (e1) t = Et(this, this.derivation, this.scope_);
                else if (!0 === Pt.disableErrorBoundaries) t = this.derivation.call(this.scope_);
                else try {
                    t = this.derivation.call(this.scope_);
                } catch (e1) {
                    t = new _t(e1);
                }
                return gt(n), this.isComputing = !1, t;
            }, t.suspend_ = function() {
                this.keepAlive_ || (Tt(this), this.value_ = void 0);
            }, t.observe_ = function(e1, t) {
                var n = this, i = !0, r = void 0;
                return function(e1, t) {
                    var n, i, r, a;
                    void 0 === t && (t = z);
                    var s, o = null != (n = null == (i = t) ? void 0 : i.name) ? n : "Autorun";
                    if (t.scheduler || t.delay) {
                        var l = function(e1) {
                            return e1.scheduler ? e1.scheduler : e1.delay ? function(t) {
                                return setTimeout(t, e1.delay);
                            } : sn;
                        }(t), c = !1;
                        s = new Vt(o, function() {
                            c || (c = !0, l(function() {
                                c = !1, s.isDisposed || s.track(u);
                            }));
                        }, t.onError, t.requiresObservable);
                    } else s = new Vt(o, function() {
                        this.track(u);
                    }, t.onError, t.requiresObservable);
                    function u() {
                        e1(s);
                    }
                    return null != (r = t) && null != (r = r.signal) && r.aborted || s.schedule_(), s.getDisposer_(null == (a = t) ? void 0 : a.signal);
                }(function() {
                    var a = n.get();
                    if (!i || t) {
                        var s = It();
                        e1({
                            observableKind: "computed",
                            debugObjectName: n.name_,
                            type: On,
                            object: n,
                            newValue: a,
                            oldValue: r
                        }), Nt(s);
                    }
                    i = !1, r = a;
                });
            }, t.warnAboutUntrackedRead_ = function() {}, t.toString = function() {
                return this.name_ + "[" + this.derivation.toString() + "]";
            }, t.valueOf = function() {
                return J(this.get());
            }, t[Symbol.toPrimitive] = function() {
                return this.valueOf();
            }, ae(e1, [
                {
                    key: "isComputing",
                    get: function() {
                        return te(this.flags_, e1.isComputingMask_);
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.isComputingMask_, t);
                    }
                },
                {
                    key: "isRunningSetter",
                    get: function() {
                        return te(this.flags_, e1.isRunningSetterMask_);
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.isRunningSetterMask_, t);
                    }
                },
                {
                    key: "isBeingObserved",
                    get: function() {
                        return te(this.flags_, e1.isBeingObservedMask_);
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.isBeingObservedMask_, t);
                    }
                },
                {
                    key: "isPendingUnobservation",
                    get: function() {
                        return te(this.flags_, e1.isPendingUnobservationMask_);
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.isPendingUnobservationMask_, t);
                    }
                },
                {
                    key: "diffValue",
                    get: function() {
                        return te(this.flags_, e1.diffValueMask_) ? 1 : 0;
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.diffValueMask_, 1 === t);
                    }
                }
            ]);
        }();
        vt.isComputingMask_ = 1, vt.isRunningSetterMask_ = 2, vt.isBeingObservedMask_ = 4, vt.isPendingUnobservationMask_ = 8, vt.diffValueMask_ = 16;
        var Mt, yt, xt = Y("ComputedValue", vt);
        !function(e1) {
            e1[e1.NOT_TRACKING_ = -1] = "NOT_TRACKING_", e1[e1.UP_TO_DATE_ = 0] = "UP_TO_DATE_", e1[e1.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", e1[e1.STALE_ = 2] = "STALE_";
        }(Mt || (Mt = {})), function(e1) {
            e1[e1.NONE = 0] = "NONE", e1[e1.LOG = 1] = "LOG", e1[e1.BREAK = 2] = "BREAK";
        }(yt || (yt = {}));
        var _t = function(e1) {
            this.cause = void 0, this.cause = e1;
        };
        function bt(e1) {
            return e1 instanceof _t;
        }
        function wt(e1) {
            switch(e1.dependenciesState_){
                case Mt.UP_TO_DATE_:
                    return !1;
                case Mt.NOT_TRACKING_:
                case Mt.STALE_:
                    return !0;
                case Mt.POSSIBLY_STALE_:
                    for(var t = Dt(!0), n = It(), i = e1.observing_, r = i.length, a = 0; a < r; a++){
                        var s = i[a];
                        if (xt(s)) {
                            if (Pt.disableErrorBoundaries) s.get();
                            else try {
                                s.get();
                            } catch (e1) {
                                return Nt(n), Ct(t), !0;
                            }
                            if (e1.dependenciesState_ === Mt.STALE_) return Nt(n), Ct(t), !0;
                        }
                    }
                    return Lt(e1), Nt(n), Ct(t), !1;
            }
        }
        function Et(e1, t, n) {
            var i = Dt(!0);
            Lt(e1), e1.newObserving_ = new Array(0 === e1.runId_ ? 100 : e1.observing_.length), e1.unboundDepsCount_ = 0, e1.runId_ = ++Pt.runId;
            var r, a = Pt.trackingDerivation;
            if (Pt.trackingDerivation = e1, Pt.inBatch++, !0 === Pt.disableErrorBoundaries) r = t.call(n);
            else try {
                r = t.call(n);
            } catch (e1) {
                r = new _t(e1);
            }
            return Pt.inBatch--, Pt.trackingDerivation = a, function(e1) {
                for(var t = e1.observing_, n = e1.observing_ = e1.newObserving_, i = Mt.UP_TO_DATE_, r = 0, a = e1.unboundDepsCount_, s = 0; s < a; s++){
                    var o = n[s];
                    0 === o.diffValue && (o.diffValue = 1, r !== s && (n[r] = o), r++), o.dependenciesState_ > i && (i = o.dependenciesState_);
                }
                for(n.length = r, e1.newObserving_ = null, a = t.length; a--;){
                    var l = t[a];
                    0 === l.diffValue && Ut(l, e1), l.diffValue = 0;
                }
                for(; r--;){
                    var c = n[r];
                    1 === c.diffValue && (c.diffValue = 0, h = e1, (u = c).observers_.add(h), u.lowestObserverState_ > h.dependenciesState_ && (u.lowestObserverState_ = h.dependenciesState_));
                }
                var u, h;
                i !== Mt.UP_TO_DATE_ && (e1.dependenciesState_ = i, e1.onBecomeStale_());
            }(e1), Ct(i), r;
        }
        function Tt(e1) {
            var t = e1.observing_;
            e1.observing_ = [];
            for(var n = t.length; n--;)Ut(t[n], e1);
            e1.dependenciesState_ = Mt.NOT_TRACKING_;
        }
        function St(e1) {
            var t = It();
            try {
                return e1();
            } finally{
                Nt(t);
            }
        }
        function It() {
            var e1 = Pt.trackingDerivation;
            return Pt.trackingDerivation = null, e1;
        }
        function Nt(e1) {
            Pt.trackingDerivation = e1;
        }
        function Dt(e1) {
            var t = Pt.allowStateReads;
            return Pt.allowStateReads = e1, t;
        }
        function Ct(e1) {
            Pt.allowStateReads = e1;
        }
        function Lt(e1) {
            if (e1.dependenciesState_ !== Mt.UP_TO_DATE_) {
                e1.dependenciesState_ = Mt.UP_TO_DATE_;
                for(var t = e1.observing_, n = t.length; n--;)t[n].lowestObserverState_ = Mt.UP_TO_DATE_;
            }
        }
        var Rt = function() {
            this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
        }, zt = !0, Ot = !1, Pt = function() {
            var e1 = I();
            return e1.__mobxInstanceCount > 0 && !e1.__mobxGlobals && (zt = !1), e1.__mobxGlobals && e1.__mobxGlobals.version !== (new Rt).version && (zt = !1), zt ? e1.__mobxGlobals ? (e1.__mobxInstanceCount += 1, e1.__mobxGlobals.UNCHANGED || (e1.__mobxGlobals.UNCHANGED = {}), e1.__mobxGlobals) : (e1.__mobxInstanceCount = 1, e1.__mobxGlobals = new Rt) : (setTimeout(function() {
                Ot || T(35);
            }, 1), new Rt);
        }();
        function Ut(e1, t) {
            e1.observers_.delete(t), 0 === e1.observers_.size && kt(e1);
        }
        function kt(e1) {
            !1 === e1.isPendingUnobservation && (e1.isPendingUnobservation = !0, Pt.pendingUnobservations.push(e1));
        }
        function jt() {
            Pt.inBatch++;
        }
        function Bt() {
            if (0 == --Pt.inBatch) {
                Wt();
                for(var e1 = Pt.pendingUnobservations, t = 0; t < e1.length; t++){
                    var n = e1[t];
                    n.isPendingUnobservation = !1, 0 === n.observers_.size && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof vt && n.suspend_());
                }
                Pt.pendingUnobservations = [];
            }
        }
        function Ft(e1) {
            var t = Pt.trackingDerivation;
            return null !== t ? (t.runId_ !== e1.lastAccessedBy_ && (e1.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e1, !e1.isBeingObserved && Pt.trackingContext && (e1.isBeingObserved = !0, e1.onBO())), e1.isBeingObserved) : (0 === e1.observers_.size && Pt.inBatch > 0 && kt(e1), !1);
        }
        function Ht(e1) {
            e1.lowestObserverState_ !== Mt.STALE_ && (e1.lowestObserverState_ = Mt.STALE_, e1.observers_.forEach(function(e1) {
                e1.dependenciesState_ === Mt.UP_TO_DATE_ && e1.onBecomeStale_(), e1.dependenciesState_ = Mt.STALE_;
            }));
        }
        var Vt = function() {
            function e1(e1, t, n, i) {
                void 0 === e1 && (e1 = "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = Mt.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = yt.NONE, this.name_ = e1, this.onInvalidate_ = t, this.errorHandler_ = n, this.requiresObservable_ = i;
            }
            var t = e1.prototype;
            return t.onBecomeStale_ = function() {
                this.schedule_();
            }, t.schedule_ = function() {
                this.isScheduled || (this.isScheduled = !0, Pt.pendingReactions.push(this), Wt());
            }, t.runReaction_ = function() {
                if (!this.isDisposed) {
                    jt(), this.isScheduled = !1;
                    var e1 = Pt.trackingContext;
                    if (Pt.trackingContext = this, wt(this)) {
                        this.isTrackPending = !0;
                        try {
                            this.onInvalidate_();
                        } catch (e1) {
                            this.reportExceptionInDerivation_(e1);
                        }
                    }
                    Pt.trackingContext = e1, Bt();
                }
            }, t.track = function(e1) {
                if (!this.isDisposed) {
                    jt(), this.isRunning = !0;
                    var t = Pt.trackingContext;
                    Pt.trackingContext = this;
                    var n = Et(this, e1, void 0);
                    Pt.trackingContext = t, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && Tt(this), bt(n) && this.reportExceptionInDerivation_(n.cause), Bt();
                }
            }, t.reportExceptionInDerivation_ = function(e1) {
                var t = this;
                if (this.errorHandler_) this.errorHandler_(e1, this);
                else {
                    if (Pt.disableErrorBoundaries) throw e1;
                    var n = "[mobx] uncaught error in '" + this + "'";
                    Pt.suppressReactionErrors || console.error(n, e1), Pt.globalReactionErrorHandlers.forEach(function(n) {
                        return n(e1, t);
                    });
                }
            }, t.dispose = function() {
                this.isDisposed || (this.isDisposed = !0, this.isRunning || (jt(), Tt(this), Bt()));
            }, t.getDisposer_ = function(e1) {
                var t = this, n = function n() {
                    t.dispose(), null == e1 || null == e1.removeEventListener || e1.removeEventListener("abort", n);
                };
                return null == e1 || null == e1.addEventListener || e1.addEventListener("abort", n), n[me] = this, n;
            }, t.toString = function() {
                return "Reaction[" + this.name_ + "]";
            }, t.trace = function(e1) {
                void 0 === e1 && (e1 = !1);
            }, ae(e1, [
                {
                    key: "isDisposed",
                    get: function() {
                        return te(this.flags_, e1.isDisposedMask_);
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.isDisposedMask_, t);
                    }
                },
                {
                    key: "isScheduled",
                    get: function() {
                        return te(this.flags_, e1.isScheduledMask_);
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.isScheduledMask_, t);
                    }
                },
                {
                    key: "isTrackPending",
                    get: function() {
                        return te(this.flags_, e1.isTrackPendingMask_);
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.isTrackPendingMask_, t);
                    }
                },
                {
                    key: "isRunning",
                    get: function() {
                        return te(this.flags_, e1.isRunningMask_);
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.isRunningMask_, t);
                    }
                },
                {
                    key: "diffValue",
                    get: function() {
                        return te(this.flags_, e1.diffValueMask_) ? 1 : 0;
                    },
                    set: function(t) {
                        this.flags_ = ne(this.flags_, e1.diffValueMask_, 1 === t);
                    }
                }
            ]);
        }();
        Vt.isDisposedMask_ = 1, Vt.isScheduledMask_ = 2, Vt.isTrackPendingMask_ = 4, Vt.isRunningMask_ = 8, Vt.diffValueMask_ = 16;
        var Gt = 100, Qt = function(e1) {
            return e1();
        };
        function Wt() {
            Pt.inBatch > 0 || Pt.isRunningReactions || Qt(Yt);
        }
        function Yt() {
            Pt.isRunningReactions = !0;
            for(var e1 = Pt.pendingReactions, t = 0; e1.length > 0;){
                ++t === Gt && (console.error("[mobx] cycle in reaction: " + e1[0]), e1.splice(0));
                for(var n = e1.splice(0), i = 0, r = n.length; i < r; i++)n[i].runReaction_();
            }
            Pt.isRunningReactions = !1;
        }
        var Xt = Y("Reaction", Vt), Zt = "action", qt = "autoAction", Kt = be(Zt), Jt = be("action.bound", {
            bound: !0
        }), $t = be(qt, {
            autoAction: !0
        }), en = be("autoAction.bound", {
            autoAction: !0,
            bound: !0
        });
        function tn(e1) {
            return function(t, n) {
                return B(t) ? ft(t.name || "<unnamed action>", t, e1) : B(n) ? ft(t, n, e1) : fe(n) ? (e1 ? $t : Kt).decorate_20223_(t, n) : F(n) ? pe(t, n, e1 ? $t : Kt) : F(t) ? de(be(e1 ? qt : Zt, {
                    name: t,
                    autoAction: e1
                })) : void 0;
            };
        }
        var nn = tn(!1);
        Object.assign(nn, Kt);
        var rn = tn(!0);
        function an(e1) {
            return B(e1) && !0 === e1.isMobxAction;
        }
        Object.assign(rn, $t), nn.bound = de(Jt), rn.bound = de(en);
        var sn = function(e1) {
            return e1();
        };
        var on = "onBO", ln = "onBUO";
        function cn(e1, t, n) {
            return un(ln, e1, t, n);
        }
        function un(e1, t, n, i) {
            var r = "function" == typeof i ? Mi(t, n) : Mi(t), a = B(i) ? i : n, s = e1 + "L";
            return r[s] ? r[s].add(a) : r[s] = new Set([
                a
            ]), function() {
                var e1 = r[s];
                e1 && (e1.delete(a), 0 === e1.size && delete r[s]);
            };
        }
        var hn = "always";
        function dn(e1) {
            !0 === e1.isolateGlobalState && function() {
                if ((Pt.pendingReactions.length || Pt.inBatch || Pt.isRunningReactions) && T(36), Ot = !0, zt) {
                    var e1 = I();
                    0 == --e1.__mobxInstanceCount && (e1.__mobxGlobals = void 0), Pt = new Rt;
                }
            }();
            var t, n, i = e1.useProxies, r = e1.enforceActions;
            if (void 0 !== i && (Pt.useProxies = i === hn || "never" !== i && "undefined" != typeof Proxy), "ifavailable" === i && (Pt.verifyProxies = !0), void 0 !== r) {
                var a = r === hn ? hn : "observed" === r;
                Pt.enforceActions = a, Pt.allowStateChanges = !0 !== a && a !== hn;
            }
            [
                "computedRequiresReaction",
                "reactionRequiresObservable",
                "observableRequiresReaction",
                "disableErrorBoundaries",
                "safeDescriptors"
            ].forEach(function(t) {
                t in e1 && (Pt[t] = !!e1[t]);
            }), Pt.allowStateReads = !Pt.observableRequiresReaction, e1.reactionScheduler && (t = e1.reactionScheduler, n = Qt, Qt = function(e1) {
                return t(function() {
                    return n(e1);
                });
            });
        }
        function pn(e1, t, n, i) {
            var r = ee(t);
            return _i(function() {
                var t = ii(e1, i)[me];
                K(r).forEach(function(e1) {
                    t.extend_(e1, r[e1], !n || !(e1 in n) || n[e1]);
                });
            }), e1;
        }
        function fn(e1) {
            var t, n = {
                name: e1.name_
            };
            return e1.observing_ && e1.observing_.length > 0 && (n.dependencies = (t = e1.observing_, Array.from(new Set(t))).map(fn)), n;
        }
        var mn = 0;
        function gn() {
            this.message = "FLOW_CANCELLED";
        }
        gn.prototype = Object.create(Error.prototype);
        var An = Ie("flow"), vn = Ie("flow.bound", {
            bound: !0
        }), Mn = Object.assign(function(e1, t) {
            if (fe(t)) return An.decorate_20223_(e1, t);
            if (F(t)) return pe(e1, t, An);
            var n = e1, i = n.name || "<unnamed flow>", r = function() {
                var e1, t = arguments, r = ++mn, a = nn(i + " - runid: " + r + " - init", n).apply(this, t), s = void 0, o = new Promise(function(t, n) {
                    var o = 0;
                    function l(e1) {
                        var t;
                        s = void 0;
                        try {
                            t = nn(i + " - runid: " + r + " - yield " + o++, a.next).call(a, e1);
                        } catch (e1) {
                            return n(e1);
                        }
                        u(t);
                    }
                    function c(e1) {
                        var t;
                        s = void 0;
                        try {
                            t = nn(i + " - runid: " + r + " - yield " + o++, a.throw).call(a, e1);
                        } catch (e1) {
                            return n(e1);
                        }
                        u(t);
                    }
                    function u(e1) {
                        if (!B(null == e1 ? void 0 : e1.then)) return e1.done ? t(e1.value) : (s = Promise.resolve(e1.value)).then(l, c);
                        e1.then(u, n);
                    }
                    e1 = n, l(void 0);
                });
                return o.cancel = nn(i + " - runid: " + r + " - cancel", function() {
                    try {
                        s && yn(s);
                        var t = a.return(void 0), n = Promise.resolve(t.value);
                        n.then(j, j), yn(n), e1(new gn);
                    } catch (t) {
                        e1(t);
                    }
                }), o;
            };
            return r.isMobXFlow = !0, r;
        }, An);
        function yn(e1) {
            B(e1.cancel) && e1.cancel();
        }
        function xn(e1) {
            return !0 === (null == e1 ? void 0 : e1.isMobXFlow);
        }
        function _n(e1) {
            return function(e1, t) {
                return !!e1 && (void 0 !== t ? !!si(e1) && e1[me].values_.has(t) : si(e1) || !!e1[me] || Ae(e1) || Xt(e1) || xt(e1));
            }(e1);
        }
        function bn(e1, t) {
            void 0 === t && (t = void 0), jt();
            try {
                return e1.apply(t);
            } finally{
                Bt();
            }
        }
        function wn(e1) {
            return e1[me];
        }
        Mn.bound = de(vn);
        var En = {
            has: function(e1, t) {
                return wn(e1).has_(t);
            },
            get: function(e1, t) {
                return wn(e1).get_(t);
            },
            set: function(e1, t, n) {
                var i;
                return !!F(t) && (null == (i = wn(e1).set_(t, n, !0)) || i);
            },
            deleteProperty: function(e1, t) {
                var n;
                return !!F(t) && (null == (n = wn(e1).delete_(t, !0)) || n);
            },
            defineProperty: function(e1, t, n) {
                var i;
                return null == (i = wn(e1).defineProperty_(t, n)) || i;
            },
            ownKeys: function(e1) {
                return wn(e1).ownKeys_();
            },
            preventExtensions: function(e1) {
                T(13);
            }
        };
        function Tn(e1) {
            return void 0 !== e1.interceptors_ && e1.interceptors_.length > 0;
        }
        function Sn(e1, t) {
            var n = e1.interceptors_ || (e1.interceptors_ = []);
            return n.push(t), k(function() {
                var e1 = n.indexOf(t);
                -1 !== e1 && n.splice(e1, 1);
            });
        }
        function In(e1, t) {
            var n = It();
            try {
                for(var i = [].concat(e1.interceptors_ || []), r = 0, a = i.length; r < a && ((t = i[r](t)) && !t.type && T(14), t); r++);
                return t;
            } finally{
                Nt(n);
            }
        }
        function Nn(e1) {
            return void 0 !== e1.changeListeners_ && e1.changeListeners_.length > 0;
        }
        function Dn(e1, t) {
            var n = e1.changeListeners_ || (e1.changeListeners_ = []);
            return n.push(t), k(function() {
                var e1 = n.indexOf(t);
                -1 !== e1 && n.splice(e1, 1);
            });
        }
        function Cn(e1, t) {
            var n = It(), i = e1.changeListeners_;
            if (i) {
                for(var r = 0, a = (i = i.slice()).length; r < a; r++)i[r](t);
                Nt(n);
            }
        }
        var Ln = Symbol("mobx-keys");
        function Rn(e1, t, n) {
            return V(e1) ? pn(e1, e1, t, n) : (_i(function() {
                var i = ii(e1, n)[me];
                if (!e1[Ln]) {
                    var r = Object.getPrototypeOf(e1), a = new Set([].concat(K(e1), K(r)));
                    a.delete("constructor"), a.delete(me), Q(r, Ln, a);
                }
                e1[Ln].forEach(function(e1) {
                    return i.make_(e1, !t || !(e1 in t) || t[e1]);
                });
            }), e1);
        }
        var zn = "splice", On = "update", Pn = {
            get: function(e1, t) {
                var n = e1[me];
                return t === me ? n : "length" === t ? n.getArrayLength_() : "string" != typeof t || isNaN(t) ? $(jn, t) ? jn[t] : e1[t] : n.get_(parseInt(t));
            },
            set: function(e1, t, n) {
                var i = e1[me];
                return "length" === t && i.setArrayLength_(n), "symbol" == typeof t || isNaN(t) ? e1[t] = n : i.set_(parseInt(t), n), !0;
            },
            preventExtensions: function() {
                T(15);
            }
        }, Un = function() {
            function e1(e1, t, n, i) {
                void 0 === e1 && (e1 = "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = n, this.legacyMode_ = i, this.atom_ = new ge(e1), this.enhancer_ = function(e1, n) {
                    return t(e1, n, "ObservableArray[..]");
                };
            }
            var t = e1.prototype;
            return t.dehanceValue_ = function(e1) {
                return void 0 !== this.dehancer ? this.dehancer(e1) : e1;
            }, t.dehanceValues_ = function(e1) {
                return void 0 !== this.dehancer && e1.length > 0 ? e1.map(this.dehancer) : e1;
            }, t.intercept_ = function(e1) {
                return Sn(this, e1);
            }, t.observe_ = function(e1, t) {
                return void 0 === t && (t = !1), t && e1({
                    observableKind: "array",
                    object: this.proxy_,
                    debugObjectName: this.atom_.name_,
                    type: "splice",
                    index: 0,
                    added: this.values_.slice(),
                    addedCount: this.values_.length,
                    removed: [],
                    removedCount: 0
                }), Dn(this, e1);
            }, t.getArrayLength_ = function() {
                return this.atom_.reportObserved(), this.values_.length;
            }, t.setArrayLength_ = function(e1) {
                ("number" != typeof e1 || isNaN(e1) || e1 < 0) && T("Out of range: " + e1);
                var t = this.values_.length;
                if (e1 !== t) {
                    if (e1 > t) {
                        for(var n = new Array(e1 - t), i = 0; i < e1 - t; i++)n[i] = void 0;
                        this.spliceWithArray_(t, 0, n);
                    } else this.spliceWithArray_(e1, t - e1);
                }
            }, t.updateArrayLength_ = function(e1, t) {
                e1 !== this.lastKnownLength_ && T(16), this.lastKnownLength_ += t, this.legacyMode_ && t > 0 && Ai(e1 + t + 1);
            }, t.spliceWithArray_ = function(e1, t, n) {
                var i = this;
                this.atom_;
                var r = this.values_.length;
                if (void 0 === e1 ? e1 = 0 : e1 > r ? e1 = r : e1 < 0 && (e1 = Math.max(0, r + e1)), t = 1 === arguments.length ? r - e1 : null == t ? 0 : Math.max(0, Math.min(t, r - e1)), void 0 === n && (n = R), Tn(this)) {
                    var a = In(this, {
                        object: this.proxy_,
                        type: zn,
                        index: e1,
                        removedCount: t,
                        added: n
                    });
                    if (!a) return R;
                    t = a.removedCount, n = a.added;
                }
                if (n = 0 === n.length ? n : n.map(function(e1) {
                    return i.enhancer_(e1, void 0);
                }), this.legacyMode_) {
                    var s = n.length - t;
                    this.updateArrayLength_(r, s);
                }
                var o = this.spliceItemsIntoValues_(e1, t, n);
                return 0 === t && 0 === n.length || this.notifyArraySplice_(e1, n, o), this.dehanceValues_(o);
            }, t.spliceItemsIntoValues_ = function(e1, t, n) {
                var i;
                if (n.length < 1e4) return (i = this.values_).splice.apply(i, [
                    e1,
                    t
                ].concat(n));
                var r = this.values_.slice(e1, e1 + t), a = this.values_.slice(e1 + t);
                this.values_.length += n.length - t;
                for(var s = 0; s < n.length; s++)this.values_[e1 + s] = n[s];
                for(var o = 0; o < a.length; o++)this.values_[e1 + n.length + o] = a[o];
                return r;
            }, t.notifyArrayChildUpdate_ = function(e1, t, n) {
                var i = !this.owned_ && !1, r = Nn(this), a = r || i ? {
                    observableKind: "array",
                    object: this.proxy_,
                    type: On,
                    debugObjectName: this.atom_.name_,
                    index: e1,
                    newValue: t,
                    oldValue: n
                } : null;
                this.atom_.reportChanged(), r && Cn(this, a);
            }, t.notifyArraySplice_ = function(e1, t, n) {
                var i = !this.owned_ && !1, r = Nn(this), a = r || i ? {
                    observableKind: "array",
                    object: this.proxy_,
                    debugObjectName: this.atom_.name_,
                    type: zn,
                    index: e1,
                    removed: n,
                    added: t,
                    removedCount: n.length,
                    addedCount: t.length
                } : null;
                this.atom_.reportChanged(), r && Cn(this, a);
            }, t.get_ = function(e1) {
                if (!(this.legacyMode_ && e1 >= this.values_.length)) return this.atom_.reportObserved(), this.dehanceValue_(this.values_[e1]);
                console.warn("[mobx] Out of bounds read: " + e1);
            }, t.set_ = function(e1, t) {
                var n = this.values_;
                if (this.legacyMode_ && e1 > n.length && T(17, e1, n.length), e1 < n.length) {
                    this.atom_;
                    var i = n[e1];
                    if (Tn(this)) {
                        var r = In(this, {
                            type: On,
                            object: this.proxy_,
                            index: e1,
                            newValue: t
                        });
                        if (!r) return;
                        t = r.newValue;
                    }
                    (t = this.enhancer_(t, i)) !== i && (n[e1] = t, this.notifyArrayChildUpdate_(e1, t, i));
                } else {
                    for(var a = new Array(e1 + 1 - n.length), s = 0; s < a.length - 1; s++)a[s] = void 0;
                    a[a.length - 1] = t, this.spliceWithArray_(n.length, 0, a);
                }
            }, e1;
        }();
        function kn(e1, t, n, i) {
            return void 0 === n && (n = "ObservableArray"), void 0 === i && (i = !1), U(), _i(function() {
                var r = new Un(n, t, i, !1);
                W(r.values_, me, r);
                var a = new Proxy(r.values_, Pn);
                return r.proxy_ = a, e1 && e1.length && r.spliceWithArray_(0, 0, e1), a;
            });
        }
        var jn = {
            clear: function() {
                return this.splice(0);
            },
            replace: function(e1) {
                var t = this[me];
                return t.spliceWithArray_(0, t.values_.length, e1);
            },
            toJSON: function() {
                return this.slice();
            },
            splice: function(e1, t) {
                for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)i[r - 2] = arguments[r];
                var a = this[me];
                switch(arguments.length){
                    case 0:
                        return [];
                    case 1:
                        return a.spliceWithArray_(e1);
                    case 2:
                        return a.spliceWithArray_(e1, t);
                }
                return a.spliceWithArray_(e1, t, i);
            },
            spliceWithArray: function(e1, t, n) {
                return this[me].spliceWithArray_(e1, t, n);
            },
            push: function() {
                for(var e1 = this[me], t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
                return e1.spliceWithArray_(e1.values_.length, 0, n), e1.values_.length;
            },
            pop: function() {
                return this.splice(Math.max(this[me].values_.length - 1, 0), 1)[0];
            },
            shift: function() {
                return this.splice(0, 1)[0];
            },
            unshift: function() {
                for(var e1 = this[me], t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
                return e1.spliceWithArray_(0, 0, n), e1.values_.length;
            },
            reverse: function() {
                return Pt.trackingDerivation && T(37, "reverse"), this.replace(this.slice().reverse()), this;
            },
            sort: function() {
                Pt.trackingDerivation && T(37, "sort");
                var e1 = this.slice();
                return e1.sort.apply(e1, arguments), this.replace(e1), this;
            },
            remove: function(e1) {
                var t = this[me], n = t.dehanceValues_(t.values_).indexOf(e1);
                return n > -1 && (this.splice(n, 1), !0);
            }
        };
        function Bn(e1, t) {
            "function" == typeof Array.prototype[e1] && (jn[e1] = t(e1));
        }
        function Fn(e1) {
            return function() {
                var t = this[me];
                t.atom_.reportObserved();
                var n = t.dehanceValues_(t.values_);
                return n[e1].apply(n, arguments);
            };
        }
        function Hn(e1) {
            return function(t, n) {
                var i = this, r = this[me];
                return r.atom_.reportObserved(), r.dehanceValues_(r.values_)[e1](function(e1, r) {
                    return t.call(n, e1, r, i);
                });
            };
        }
        function Vn(e1) {
            return function() {
                var t = this, n = this[me];
                n.atom_.reportObserved();
                var i = n.dehanceValues_(n.values_), r = arguments[0];
                return arguments[0] = function(e1, n, i) {
                    return r(e1, n, i, t);
                }, i[e1].apply(i, arguments);
            };
        }
        Bn("at", Fn), Bn("concat", Fn), Bn("flat", Fn), Bn("includes", Fn), Bn("indexOf", Fn), Bn("join", Fn), Bn("lastIndexOf", Fn), Bn("slice", Fn), Bn("toString", Fn), Bn("toLocaleString", Fn), Bn("toSorted", Fn), Bn("toSpliced", Fn), Bn("with", Fn), Bn("every", Hn), Bn("filter", Hn), Bn("find", Hn), Bn("findIndex", Hn), Bn("findLast", Hn), Bn("findLastIndex", Hn), Bn("flatMap", Hn), Bn("forEach", Hn), Bn("map", Hn), Bn("some", Hn), Bn("toReversed", Hn), Bn("reduce", Vn), Bn("reduceRight", Vn);
        var Gn = Y("ObservableArrayAdministration", Un);
        function Qn(e1) {
            return H(e1) && Gn(e1[me]);
        }
        var Wn = {}, Yn = "add", Xn = "delete", Zn = function() {
            function e1(e1, t, n) {
                var i = this;
                void 0 === t && (t = ye), void 0 === n && (n = "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[me] = Wn, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = t, this.name_ = n, B(Map) || T(18), _i(function() {
                    i.keysAtom_ = ve("ObservableMap.keys()"), i.data_ = new Map, i.hasMap_ = new Map, e1 && i.merge(e1);
                });
            }
            var t = e1.prototype;
            return t.has_ = function(e1) {
                return this.data_.has(e1);
            }, t.has = function(e1) {
                var t = this;
                if (!Pt.trackingDerivation) return this.has_(e1);
                var n = this.hasMap_.get(e1);
                if (!n) {
                    var i = n = new At(this.has_(e1), xe, "ObservableMap.key?", !1);
                    this.hasMap_.set(e1, i), cn(i, function() {
                        return t.hasMap_.delete(e1);
                    });
                }
                return n.get();
            }, t.set = function(e1, t) {
                var n = this.has_(e1);
                if (Tn(this)) {
                    var i = In(this, {
                        type: n ? On : Yn,
                        object: this,
                        newValue: t,
                        name: e1
                    });
                    if (!i) return this;
                    t = i.newValue;
                }
                return n ? this.updateValue_(e1, t) : this.addValue_(e1, t), this;
            }, t.delete = function(e1) {
                var t = this;
                if (this.keysAtom_, Tn(this) && !In(this, {
                    type: Xn,
                    object: this,
                    name: e1
                })) return !1;
                if (this.has_(e1)) {
                    var n = Nn(this), i = n ? {
                        observableKind: "map",
                        debugObjectName: this.name_,
                        type: Xn,
                        object: this,
                        oldValue: this.data_.get(e1).value_,
                        name: e1
                    } : null;
                    return bn(function() {
                        var n;
                        t.keysAtom_.reportChanged(), null == (n = t.hasMap_.get(e1)) || n.setNewValue_(!1), t.data_.get(e1).setNewValue_(void 0), t.data_.delete(e1);
                    }), n && Cn(this, i), !0;
                }
                return !1;
            }, t.updateValue_ = function(e1, t) {
                var n = this.data_.get(e1);
                if ((t = n.prepareNewValue_(t)) !== Pt.UNCHANGED) {
                    var i = Nn(this), r = i ? {
                        observableKind: "map",
                        debugObjectName: this.name_,
                        type: On,
                        object: this,
                        oldValue: n.value_,
                        name: e1,
                        newValue: t
                    } : null;
                    n.setNewValue_(t), i && Cn(this, r);
                }
            }, t.addValue_ = function(e1, t) {
                var n = this;
                this.keysAtom_, bn(function() {
                    var i, r = new At(t, n.enhancer_, "ObservableMap.key", !1);
                    n.data_.set(e1, r), t = r.value_, null == (i = n.hasMap_.get(e1)) || i.setNewValue_(!0), n.keysAtom_.reportChanged();
                });
                var i = Nn(this), r = i ? {
                    observableKind: "map",
                    debugObjectName: this.name_,
                    type: Yn,
                    object: this,
                    name: e1,
                    newValue: t
                } : null;
                i && Cn(this, r);
            }, t.get = function(e1) {
                return this.has(e1) ? this.dehanceValue_(this.data_.get(e1).get()) : this.dehanceValue_(void 0);
            }, t.dehanceValue_ = function(e1) {
                return void 0 !== this.dehancer ? this.dehancer(e1) : e1;
            }, t.keys = function() {
                return this.keysAtom_.reportObserved(), this.data_.keys();
            }, t.values = function() {
                var e1 = this, t = this.keys();
                return Si({
                    next: function() {
                        var n = t.next(), i = n.done, r = n.value;
                        return {
                            done: i,
                            value: i ? void 0 : e1.get(r)
                        };
                    }
                });
            }, t.entries = function() {
                var e1 = this, t = this.keys();
                return Si({
                    next: function() {
                        var n = t.next(), i = n.done, r = n.value;
                        return {
                            done: i,
                            value: i ? void 0 : [
                                r,
                                e1.get(r)
                            ]
                        };
                    }
                });
            }, t[Symbol.iterator] = function() {
                return this.entries();
            }, t.forEach = function(e1, t) {
                for(var n, i = se(this); !(n = i()).done;){
                    var r = n.value, a = r[0], s = r[1];
                    e1.call(t, s, a, this);
                }
            }, t.merge = function(e1) {
                var t = this;
                return qn(e1) && (e1 = new Map(e1)), bn(function() {
                    var n, i, r;
                    V(e1) ? (function(e1) {
                        var t = Object.keys(e1);
                        if (!q) return t;
                        var n = Object.getOwnPropertySymbols(e1);
                        return n.length ? [].concat(t, n.filter(function(t) {
                            return L.propertyIsEnumerable.call(e1, t);
                        })) : t;
                    })(e1).forEach(function(n) {
                        return t.set(n, e1[n]);
                    }) : Array.isArray(e1) ? e1.forEach(function(e1) {
                        var n = e1[0], i = e1[1];
                        return t.set(n, i);
                    }) : X(e1) ? (n = e1, i = Object.getPrototypeOf(n), r = Object.getPrototypeOf(i), null !== Object.getPrototypeOf(r) && T(19, e1), e1.forEach(function(e1, n) {
                        return t.set(n, e1);
                    })) : null != e1 && T(20, e1);
                }), this;
            }, t.clear = function() {
                var e1 = this;
                bn(function() {
                    St(function() {
                        for(var t, n = se(e1.keys()); !(t = n()).done;){
                            var i = t.value;
                            e1.delete(i);
                        }
                    });
                });
            }, t.replace = function(e1) {
                var t = this;
                return bn(function() {
                    for(var n, i = function(e1) {
                        if (X(e1) || qn(e1)) return e1;
                        if (Array.isArray(e1)) return new Map(e1);
                        if (V(e1)) {
                            var t = new Map;
                            for(var n in e1)t.set(n, e1[n]);
                            return t;
                        }
                        return T(21, e1);
                    }(e1), r = new Map, a = !1, s = se(t.data_.keys()); !(n = s()).done;){
                        var o = n.value;
                        if (!i.has(o)) {
                            if (t.delete(o)) a = !0;
                            else {
                                var l = t.data_.get(o);
                                r.set(o, l);
                            }
                        }
                    }
                    for(var c, u = se(i.entries()); !(c = u()).done;){
                        var h = c.value, d = h[0], p = h[1], f = t.data_.has(d);
                        if (t.set(d, p), t.data_.has(d)) {
                            var m = t.data_.get(d);
                            r.set(d, m), f || (a = !0);
                        }
                    }
                    if (!a) {
                        if (t.data_.size !== r.size) t.keysAtom_.reportChanged();
                        else for(var g = t.data_.keys(), A = r.keys(), v = g.next(), M = A.next(); !v.done;){
                            if (v.value !== M.value) {
                                t.keysAtom_.reportChanged();
                                break;
                            }
                            v = g.next(), M = A.next();
                        }
                    }
                    t.data_ = r;
                }), this;
            }, t.toString = function() {
                return "[object ObservableMap]";
            }, t.toJSON = function() {
                return Array.from(this);
            }, t.observe_ = function(e1, t) {
                return Dn(this, e1);
            }, t.intercept_ = function(e1) {
                return Sn(this, e1);
            }, ae(e1, [
                {
                    key: "size",
                    get: function() {
                        return this.keysAtom_.reportObserved(), this.data_.size;
                    }
                },
                {
                    key: Symbol.toStringTag,
                    get: function() {
                        return "Map";
                    }
                }
            ]);
        }(), qn = Y("ObservableMap", Zn), Kn = {}, Jn = function() {
            function e1(e1, t, n) {
                var i = this;
                void 0 === t && (t = ye), void 0 === n && (n = "ObservableSet"), this.name_ = void 0, this[me] = Kn, this.data_ = new Set, this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = n, B(Set) || T(22), this.enhancer_ = function(e1, i) {
                    return t(e1, i, n);
                }, _i(function() {
                    i.atom_ = ve(i.name_), e1 && i.replace(e1);
                });
            }
            var t = e1.prototype;
            return t.dehanceValue_ = function(e1) {
                return void 0 !== this.dehancer ? this.dehancer(e1) : e1;
            }, t.clear = function() {
                var e1 = this;
                bn(function() {
                    St(function() {
                        for(var t, n = se(e1.data_.values()); !(t = n()).done;){
                            var i = t.value;
                            e1.delete(i);
                        }
                    });
                });
            }, t.forEach = function(e1, t) {
                for(var n, i = se(this); !(n = i()).done;){
                    var r = n.value;
                    e1.call(t, r, r, this);
                }
            }, t.add = function(e1) {
                var t = this;
                if (this.atom_, Tn(this) && !In(this, {
                    type: Yn,
                    object: this,
                    newValue: e1
                })) return this;
                if (!this.has(e1)) {
                    bn(function() {
                        t.data_.add(t.enhancer_(e1, void 0)), t.atom_.reportChanged();
                    });
                    var n = Nn(this), i = n ? {
                        observableKind: "set",
                        debugObjectName: this.name_,
                        type: Yn,
                        object: this,
                        newValue: e1
                    } : null;
                    n && Cn(this, i);
                }
                return this;
            }, t.delete = function(e1) {
                var t = this;
                if (Tn(this) && !In(this, {
                    type: Xn,
                    object: this,
                    oldValue: e1
                })) return !1;
                if (this.has(e1)) {
                    var n = Nn(this), i = n ? {
                        observableKind: "set",
                        debugObjectName: this.name_,
                        type: Xn,
                        object: this,
                        oldValue: e1
                    } : null;
                    return bn(function() {
                        t.atom_.reportChanged(), t.data_.delete(e1);
                    }), n && Cn(this, i), !0;
                }
                return !1;
            }, t.has = function(e1) {
                return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(e1));
            }, t.entries = function() {
                var e1 = 0, t = Array.from(this.keys()), n = Array.from(this.values());
                return Si({
                    next: function() {
                        var i = e1;
                        return e1 += 1, i < n.length ? {
                            value: [
                                t[i],
                                n[i]
                            ],
                            done: !1
                        } : {
                            done: !0
                        };
                    }
                });
            }, t.keys = function() {
                return this.values();
            }, t.values = function() {
                this.atom_.reportObserved();
                var e1 = this, t = 0, n = Array.from(this.data_.values());
                return Si({
                    next: function() {
                        return t < n.length ? {
                            value: e1.dehanceValue_(n[t++]),
                            done: !1
                        } : {
                            done: !0
                        };
                    }
                });
            }, t.intersection = function(e1) {
                return Z(e1) ? e1.intersection(this) : new Set(this).intersection(e1);
            }, t.union = function(e1) {
                return Z(e1) ? e1.union(this) : new Set(this).union(e1);
            }, t.difference = function(e1) {
                return new Set(this).difference(e1);
            }, t.symmetricDifference = function(e1) {
                return Z(e1) ? e1.symmetricDifference(this) : new Set(this).symmetricDifference(e1);
            }, t.isSubsetOf = function(e1) {
                return new Set(this).isSubsetOf(e1);
            }, t.isSupersetOf = function(e1) {
                return new Set(this).isSupersetOf(e1);
            }, t.isDisjointFrom = function(e1) {
                return Z(e1) ? e1.isDisjointFrom(this) : new Set(this).isDisjointFrom(e1);
            }, t.replace = function(e1) {
                var t = this;
                return $n(e1) && (e1 = new Set(e1)), bn(function() {
                    Array.isArray(e1) || Z(e1) ? (t.clear(), e1.forEach(function(e1) {
                        return t.add(e1);
                    })) : null != e1 && T("Cannot initialize set from " + e1);
                }), this;
            }, t.observe_ = function(e1, t) {
                return Dn(this, e1);
            }, t.intercept_ = function(e1) {
                return Sn(this, e1);
            }, t.toJSON = function() {
                return Array.from(this);
            }, t.toString = function() {
                return "[object ObservableSet]";
            }, t[Symbol.iterator] = function() {
                return this.values();
            }, ae(e1, [
                {
                    key: "size",
                    get: function() {
                        return this.atom_.reportObserved(), this.data_.size;
                    }
                },
                {
                    key: Symbol.toStringTag,
                    get: function() {
                        return "Set";
                    }
                }
            ]);
        }(), $n = Y("ObservableSet", Jn), ei = Object.create(null), ti = "remove", ni = function() {
            function e1(e1, t, n, i) {
                void 0 === t && (t = new Map), void 0 === i && (i = He), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = e1, this.values_ = t, this.name_ = n, this.defaultAnnotation_ = i, this.keysAtom_ = new ge("ObservableObject.keys"), this.isPlainObject_ = V(this.target_);
            }
            var t = e1.prototype;
            return t.getObservablePropValue_ = function(e1) {
                return this.values_.get(e1).get();
            }, t.setObservablePropValue_ = function(e1, t) {
                var n = this.values_.get(e1);
                if (n instanceof vt) return n.set(t), !0;
                if (Tn(this)) {
                    var i = In(this, {
                        type: On,
                        object: this.proxy_ || this.target_,
                        name: e1,
                        newValue: t
                    });
                    if (!i) return null;
                    t = i.newValue;
                }
                if ((t = n.prepareNewValue_(t)) !== Pt.UNCHANGED) {
                    var r = Nn(this), a = r ? {
                        type: On,
                        observableKind: "object",
                        debugObjectName: this.name_,
                        object: this.proxy_ || this.target_,
                        oldValue: n.value_,
                        name: e1,
                        newValue: t
                    } : null;
                    n.setNewValue_(t), r && Cn(this, a);
                }
                return !0;
            }, t.get_ = function(e1) {
                return Pt.trackingDerivation && !$(this.target_, e1) && this.has_(e1), this.target_[e1];
            }, t.set_ = function(e1, t, n) {
                return void 0 === n && (n = !1), $(this.target_, e1) ? this.values_.has(e1) ? this.setObservablePropValue_(e1, t) : n ? Reflect.set(this.target_, e1, t) : (this.target_[e1] = t, !0) : this.extend_(e1, {
                    value: t,
                    enumerable: !0,
                    writable: !0,
                    configurable: !0
                }, this.defaultAnnotation_, n);
            }, t.has_ = function(e1) {
                if (!Pt.trackingDerivation) return e1 in this.target_;
                this.pendingKeys_ || (this.pendingKeys_ = new Map);
                var t = this.pendingKeys_.get(e1);
                return t || (t = new At(e1 in this.target_, xe, "ObservableObject.key?", !1), this.pendingKeys_.set(e1, t)), t.get();
            }, t.make_ = function(e1, t) {
                if (!0 === t && (t = this.defaultAnnotation_), !1 !== t) {
                    if (!(e1 in this.target_)) {
                        var n;
                        if (null != (n = this.target_[he]) && n[e1]) return;
                        T(1, t.annotationType_, this.name_ + "." + e1.toString());
                    }
                    for(var i = this.target_; i && i !== L;){
                        var r = D(i, e1);
                        if (r) {
                            var a = t.make_(this, e1, r, i);
                            if (0 === a) return;
                            if (1 === a) break;
                        }
                        i = Object.getPrototypeOf(i);
                    }
                    oi(this, 0, e1);
                }
            }, t.extend_ = function(e1, t, n, i) {
                if (void 0 === i && (i = !1), !0 === n && (n = this.defaultAnnotation_), !1 === n) return this.defineProperty_(e1, t, i);
                var r = n.extend_(this, e1, t, i);
                return r && oi(this, 0, e1), r;
            }, t.defineProperty_ = function(e1, t, n) {
                void 0 === n && (n = !1), this.keysAtom_;
                try {
                    jt();
                    var i = this.delete_(e1);
                    if (!i) return i;
                    if (Tn(this)) {
                        var r = In(this, {
                            object: this.proxy_ || this.target_,
                            name: e1,
                            type: Yn,
                            newValue: t.value
                        });
                        if (!r) return null;
                        var a = r.newValue;
                        t.value !== a && (t = oe({}, t, {
                            value: a
                        }));
                    }
                    if (n) {
                        if (!Reflect.defineProperty(this.target_, e1, t)) return !1;
                    } else C(this.target_, e1, t);
                    this.notifyPropertyAddition_(e1, t.value);
                } finally{
                    Bt();
                }
                return !0;
            }, t.defineObservableProperty_ = function(e1, t, n, i) {
                void 0 === i && (i = !1), this.keysAtom_;
                try {
                    jt();
                    var r = this.delete_(e1);
                    if (!r) return r;
                    if (Tn(this)) {
                        var a = In(this, {
                            object: this.proxy_ || this.target_,
                            name: e1,
                            type: Yn,
                            newValue: t
                        });
                        if (!a) return null;
                        t = a.newValue;
                    }
                    var s = ai(e1), o = {
                        configurable: !Pt.safeDescriptors || this.isPlainObject_,
                        enumerable: !0,
                        get: s.get,
                        set: s.set
                    };
                    if (i) {
                        if (!Reflect.defineProperty(this.target_, e1, o)) return !1;
                    } else C(this.target_, e1, o);
                    var l = new At(t, n, "ObservableObject.key", !1);
                    this.values_.set(e1, l), this.notifyPropertyAddition_(e1, l.value_);
                } finally{
                    Bt();
                }
                return !0;
            }, t.defineComputedProperty_ = function(e1, t, n) {
                void 0 === n && (n = !1), this.keysAtom_;
                try {
                    jt();
                    var i = this.delete_(e1);
                    if (!i) return i;
                    if (Tn(this) && !In(this, {
                        object: this.proxy_ || this.target_,
                        name: e1,
                        type: Yn,
                        newValue: void 0
                    })) return null;
                    t.name || (t.name = "ObservableObject.key"), t.context = this.proxy_ || this.target_;
                    var r = ai(e1), a = {
                        configurable: !Pt.safeDescriptors || this.isPlainObject_,
                        enumerable: !1,
                        get: r.get,
                        set: r.set
                    };
                    if (n) {
                        if (!Reflect.defineProperty(this.target_, e1, a)) return !1;
                    } else C(this.target_, e1, a);
                    this.values_.set(e1, new vt(t)), this.notifyPropertyAddition_(e1, void 0);
                } finally{
                    Bt();
                }
                return !0;
            }, t.delete_ = function(e1, t) {
                if (void 0 === t && (t = !1), this.keysAtom_, !$(this.target_, e1)) return !0;
                if (Tn(this) && !In(this, {
                    object: this.proxy_ || this.target_,
                    name: e1,
                    type: ti
                })) return null;
                try {
                    var n;
                    jt();
                    var i, r = Nn(this), a = this.values_.get(e1), s = void 0;
                    if (!a && r && (s = null == (i = D(this.target_, e1)) ? void 0 : i.value), t) {
                        if (!Reflect.deleteProperty(this.target_, e1)) return !1;
                    } else delete this.target_[e1];
                    if (a && (this.values_.delete(e1), a instanceof At && (s = a.value_), Ht(a)), this.keysAtom_.reportChanged(), null == (n = this.pendingKeys_) || null == (n = n.get(e1)) || n.set(e1 in this.target_), r) {
                        var o = {
                            type: ti,
                            observableKind: "object",
                            object: this.proxy_ || this.target_,
                            debugObjectName: this.name_,
                            oldValue: s,
                            name: e1
                        };
                        r && Cn(this, o);
                    }
                } finally{
                    Bt();
                }
                return !0;
            }, t.observe_ = function(e1, t) {
                return Dn(this, e1);
            }, t.intercept_ = function(e1) {
                return Sn(this, e1);
            }, t.notifyPropertyAddition_ = function(e1, t) {
                var n, i = Nn(this);
                if (i) {
                    var r = i ? {
                        type: Yn,
                        observableKind: "object",
                        debugObjectName: this.name_,
                        object: this.proxy_ || this.target_,
                        name: e1,
                        newValue: t
                    } : null;
                    i && Cn(this, r);
                }
                null == (n = this.pendingKeys_) || null == (n = n.get(e1)) || n.set(!0), this.keysAtom_.reportChanged();
            }, t.ownKeys_ = function() {
                return this.keysAtom_.reportObserved(), K(this.target_);
            }, t.keys_ = function() {
                return this.keysAtom_.reportObserved(), Object.keys(this.target_);
            }, e1;
        }();
        function ii(e1, t) {
            var n;
            if ($(e1, me)) return e1;
            var i = null != (n = null == t ? void 0 : t.name) ? n : "ObservableObject", r = new ni(e1, new Map, String(i), function(e1) {
                var t;
                return e1 ? null != (t = e1.defaultDecorator) ? t : Ve(e1) : void 0;
            }(t));
            return Q(e1, me, r), e1;
        }
        var ri = Y("ObservableObjectAdministration", ni);
        function ai(e1) {
            return ei[e1] || (ei[e1] = {
                get: function() {
                    return this[me].getObservablePropValue_(e1);
                },
                set: function(t) {
                    return this[me].setObservablePropValue_(e1, t);
                }
            });
        }
        function si(e1) {
            return !!H(e1) && ri(e1[me]);
        }
        function oi(e1, t, n) {
            var i;
            null == (i = e1.target_[he]) || delete i[n];
        }
        var li, ci, ui = mi(0), hi = function() {
            var e1 = !1, t = {};
            return Object.defineProperty(t, "0", {
                set: function() {
                    e1 = !0;
                }
            }), Object.create(t)[0] = 1, !1 === e1;
        }(), di = 0, pi = function() {};
        li = pi, ci = Array.prototype, Object.setPrototypeOf ? Object.setPrototypeOf(li.prototype, ci) : void 0 !== li.prototype.__proto__ ? li.prototype.__proto__ = ci : li.prototype = ci;
        var fi = function(e1) {
            function t(t, n, i, r) {
                var a;
                return void 0 === i && (i = "ObservableArray"), void 0 === r && (r = !1), a = e1.call(this) || this, _i(function() {
                    var e1 = new Un(i, n, r, !0);
                    e1.proxy_ = a, W(a, me, e1), t && t.length && a.spliceWithArray(0, 0, t), hi && Object.defineProperty(a, "0", ui);
                }), a;
            }
            le(t, e1);
            var n = t.prototype;
            return n.concat = function() {
                this[me].atom_.reportObserved();
                for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
                return Array.prototype.concat.apply(this.slice(), t.map(function(e1) {
                    return Qn(e1) ? e1.slice() : e1;
                }));
            }, n[Symbol.iterator] = function() {
                var e1 = this, t = 0;
                return Si({
                    next: function() {
                        return t < e1.length ? {
                            value: e1[t++],
                            done: !1
                        } : {
                            done: !0,
                            value: void 0
                        };
                    }
                });
            }, ae(t, [
                {
                    key: "length",
                    get: function() {
                        return this[me].getArrayLength_();
                    },
                    set: function(e1) {
                        this[me].setArrayLength_(e1);
                    }
                },
                {
                    key: Symbol.toStringTag,
                    get: function() {
                        return "Array";
                    }
                }
            ]);
        }(pi);
        function mi(e1) {
            return {
                enumerable: !1,
                configurable: !0,
                get: function() {
                    return this[me].get_(e1);
                },
                set: function(t) {
                    this[me].set_(e1, t);
                }
            };
        }
        function gi(e1) {
            C(fi.prototype, "" + e1, mi(e1));
        }
        function Ai(e1) {
            if (e1 > di) {
                for(var t = di; t < e1 + 100; t++)gi(t);
                di = e1;
            }
        }
        function vi(e1, t, n) {
            return new fi(e1, t, n);
        }
        function Mi(e1, t) {
            if ("object" == typeof e1 && null !== e1) {
                if (Qn(e1)) return void 0 !== t && T(23), e1[me].atom_;
                if ($n(e1)) return e1.atom_;
                if (qn(e1)) {
                    if (void 0 === t) return e1.keysAtom_;
                    var n = e1.data_.get(t) || e1.hasMap_.get(t);
                    return n || T(25, t, xi(e1)), n;
                }
                if (si(e1)) {
                    if (!t) return T(26);
                    var i = e1[me].values_.get(t);
                    return i || T(27, t, xi(e1)), i;
                }
                if (Ae(e1) || xt(e1) || Xt(e1)) return e1;
            } else if (B(e1) && Xt(e1[me])) return e1[me];
            T(28);
        }
        function yi(e1, t) {
            return e1 || T(29), void 0 !== t ? yi(Mi(e1, t)) : Ae(e1) || xt(e1) || Xt(e1) || qn(e1) || $n(e1) ? e1 : e1[me] ? e1[me] : void T(24, e1);
        }
        function xi(e1, t) {
            var n;
            if (void 0 !== t) n = Mi(e1, t);
            else {
                if (an(e1)) return e1.name;
                n = si(e1) || qn(e1) || $n(e1) ? yi(e1) : Mi(e1);
            }
            return n.name_;
        }
        function _i(e1) {
            var t = It(), n = mt(!0);
            jt();
            try {
                return e1();
            } finally{
                Bt(), gt(n), Nt(t);
            }
        }
        Object.entries(jn).forEach(function(e1) {
            var t = e1[0], n = e1[1];
            "concat" !== t && Q(fi.prototype, t, n);
        }), Ai(1e3);
        var bi = L.toString;
        function wi(e1, t, n) {
            return void 0 === n && (n = -1), Ei(e1, t, n);
        }
        function Ei(e1, t, n, i, r) {
            if (e1 === t) return 0 !== e1 || 1 / e1 == 1 / t;
            if (null == e1 || null == t) return !1;
            if (e1 != e1) return t != t;
            var a = typeof e1;
            if ("function" !== a && "object" !== a && "object" != typeof t) return !1;
            var s = bi.call(e1);
            if (s !== bi.call(t)) return !1;
            switch(s){
                case "[object RegExp]":
                case "[object String]":
                    return "" + e1 == "" + t;
                case "[object Number]":
                    return +e1 != +e1 ? +t != +t : 0 == +e1 ? 1 / +e1 == 1 / t : +e1 == +t;
                case "[object Date]":
                case "[object Boolean]":
                    return +e1 == +t;
                case "[object Symbol]":
                    return "undefined" != typeof Symbol && Symbol.valueOf.call(e1) === Symbol.valueOf.call(t);
                case "[object Map]":
                case "[object Set]":
                    n >= 0 && n++;
            }
            e1 = Ti(e1), t = Ti(t);
            var o = "[object Array]" === s;
            if (!o) {
                if ("object" != typeof e1 || "object" != typeof t) return !1;
                var l = e1.constructor, c = t.constructor;
                if (l !== c && !(B(l) && l instanceof l && B(c) && c instanceof c) && "constructor" in e1 && "constructor" in t) return !1;
            }
            if (0 === n) return !1;
            n < 0 && (n = -1), r = r || [];
            for(var u = (i = i || []).length; u--;)if (i[u] === e1) return r[u] === t;
            if (i.push(e1), r.push(t), o) {
                if ((u = e1.length) !== t.length) return !1;
                for(; u--;)if (!Ei(e1[u], t[u], n - 1, i, r)) return !1;
            } else {
                var h, d = Object.keys(e1);
                if (u = d.length, Object.keys(t).length !== u) return !1;
                for(; u--;)if (!$(t, h = d[u]) || !Ei(e1[h], t[h], n - 1, i, r)) return !1;
            }
            return i.pop(), r.pop(), !0;
        }
        function Ti(e1) {
            return Qn(e1) ? e1.slice() : X(e1) || qn(e1) || Z(e1) || $n(e1) ? Array.from(e1.entries()) : e1;
        }
        function Si(e1) {
            return e1[Symbol.iterator] = Ii, e1;
        }
        function Ii() {
            return this;
        }
        function Ni(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        [
            "Symbol",
            "Map",
            "Set"
        ].forEach(function(e1) {
            void 0 === I()[e1] && T("MobX requires global '" + e1 + "' to be available or polyfilled");
        }), "object" == typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
            spy: function(e1) {
                return console.warn("[mobx.spy] Is a no-op in production builds"), function() {};
            },
            extras: {
                getDebugName: xi
            },
            $mobx: me
        }), dn({
            useProxies: "never"
        });
        const Di = class {
            constructor(e1){
                Ni(this, "API_URL", null), Ni(this, "getBrandingData", (e1)=>e1 ? {
                        name: e1.company_name,
                        url: e1.company_url
                    } : null), Ni(this, "getParsedData", async (e1)=>{
                    var t, n, i, r, a, s;
                    const o = await this.loadJson(e1.json.value), l = this.getBrandingData(e1.widget_branding), c = e1.original_plans_img || [], u = e1.styled_plan_img || [], h = e1.floors.map((e1, t)=>{
                        var n, i;
                        return {
                            ...e1,
                            original_plan_img: null !== (n = null !== (i = u[t]) && void 0 !== i ? i : c[t]) && void 0 !== n ? n : null
                        };
                    });
                    return {
                        raw: e1,
                        parsed: {
                            locale: (null === (t = e1.widget_branding) || void 0 === t ? void 0 : t.widget_language) || "en",
                            logo: (null === (n = e1.widget_branding) || void 0 === n ? void 0 : n.logo_path) || null,
                            floors: h,
                            branding: l,
                            json: o,
                            bareshell: null !== (i = null === (r = e1.hidden_furniture) || void 0 === r ? void 0 : r.enabled) && void 0 !== i && i,
                            hasTopViewMask: null !== (a = e1.has_top_view_room_ids) && void 0 !== a && a,
                            hasMiddleCutMasks: null !== (s = e1.has_middle_cut_room_ids) && void 0 !== s && s
                        }
                    };
                }), Ni(this, "loadFurnitureData", async ()=>{
                    const e1 = "".concat(this.API_URL, "/api/furniture"), t = await fetch(e1);
                    return await t.json();
                }), Ni(this, "loadCrmWidgetData", async (e1)=>{
                    const t = "".concat(this.API_URL, "/api/crm/plans/").concat(e1, "/widget"), n = await fetch(t, {
                        headers: {
                            "Widget-Version": "2.9.2"
                        }
                    }), i = await n.json();
                    return this.getParsedData(i);
                }), Ni(this, "loadWidgetData", async (e1)=>{
                    const t = "".concat(this.API_URL, "/api/plans/").concat(e1, "/v2/widget"), n = await fetch(t, {
                        headers: {
                            "Widget-Version": "2.9.2"
                        }
                    }), i = await n.json();
                    return this.getParsedData(i);
                }), Ni(this, "loadEditorData", async (e1, t)=>{
                    const n = "".concat(this.API_URL, "/api/plans/").concat(e1, "/editor?token=").concat(t), i = await fetch(n);
                    return await i.json();
                }), Ni(this, "loadPanoramaData", async (e1)=>{
                    const t = "".concat(this.API_URL, "/api/plans/").concat(e1, "/panorama"), n = await fetch(t);
                    return await n.json();
                }), Ni(this, "loadJson", async (e1)=>{
                    const t = await fetch(e1);
                    return await t.json();
                }), Rn(this), this.API_URL = e1;
            }
        }, Ci = JSON.parse('{"create-points":"\u0421\u043E\u0437\u0434\u0430\u0432\u0430\u0439\u0442\u0435 \u0442\u043E\u0447\u043A\u0438","delete-points":"\u0423\u0434\u0430\u043B\u044F\u0439\u0442\u0435 \u0442\u043E\u0447\u043A\u0438","research-plan":"\u0418\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u044C \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0443","rotate-plan":"\u0412\u0440\u0430\u0449\u0430\u0442\u044C \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0443","ok":"\u041E\u043A","made-by-link":"https://hart-estate.ru/","made-by-text":"hart-estate.ru","instructions-hint-text":"","floor":"$0 \u044D\u0442\u0430\u0436"}'), Li = JSON.parse('{"create-points":"Create a point","delete-points":"Remove point","research-plan":"Research plan","rotate-plan":"Rotate plan","ok":"Ok","made-by-link":"https://getfloorplan.com/","made-by-text":"getfloorplan.com","instructions-hint-text":"","floor":"$0 floor","floorNumberEndings":{"1":"1st","2":"2nd","3":"3d","rest":"th"}}'), Ri = JSON.parse('{"research-plan":"klicken","rotate-plan":"drehen","ok":"Ok","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 boden"}'), zi = JSON.parse('{"research-plan":"Explora el dise\xf1o","rotate-plan":"Girar dise\xf1o","rotate":"Comenzar","stop":"Detener","plan":"Disposici\xf3n","off":"Apagar","on":"Encender","ok":"Ok","menu":"Men\xfa","wasd":"WASD","view-from-above":"Vista desde arriba","free-camera":"Revisi\xf3n gratuita","shadows":"Oscuridad","hide-walls":"Ocultar paredes","show-walls":"Mostrar paredes","hide-doors":"Ocultar puertas","show-doors":"Mostrar puertas","material":"Material","texture":"Textura","color":"Color","wall-color":"Color de la pared","wall-texture":"Textura de la pared","upload-wall-texture":"Textura de la pared de carga","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 piso"}'), Oi = JSON.parse('{"create-points":"\u8A08\u6E2C\u958B\u59CB","delete-points":"\u78BA\u5B9A","research-plan":"\u30BF\u30C3\u30D7\u3057\u3066\u79FB\u52D5","rotate-plan":"\u30C9\u30E9\u30C3\u30B0\u3067\u79FB\u52D5","ok":"Ok","made-by-link":"","made-by-text":"","instructions-hint-text":"","floor":"$0 \u968E"}');
        function Pi(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        dn({
            useProxies: "never"
        });
        const Ui = new class {
            constructor(){
                Pi(this, "availableLocales", [
                    "ru",
                    "en",
                    "de",
                    "es",
                    "ja"
                ]), Pi(this, "locales", {
                    ru: Ci,
                    en: Li,
                    de: Ri,
                    es: zi,
                    ja: Oi
                }), Pi(this, "currentLocale", "en"), Pi(this, "getLocaleText", (e1)=>this.localeData[e1]), Pi(this, "setCurrentLocale", (e1)=>{
                    this.availableLocales.some((t)=>t === e1) && (this.currentLocale = e1);
                }), Rn(this);
            }
            get localeData() {
                return this.locales[this.currentLocale];
            }
        }, ki = Ui;
        function ji(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        dn({
            useProxies: "never"
        });
        const Bi = new class {
            constructor(){
                ji(this, "controlsVisible", !0), ji(this, "currentFloorIndex", 0), ji(this, "configParams", null), ji(this, "listeners", {
                    resize: []
                }), Rn(this);
            }
            get primaryCameraPointId() {
                var e1;
                if (!this.config.json) return null;
                const t = this.config.json.Floors[this.currentFloorIndex];
                if (this.config.primaryCameraPointId && t.CameraPoints.some((e1)=>{
                    let { ID: t } = e1;
                    return t === this.config.primaryCameraPointId;
                })) return this.config.primaryCameraPointId;
                const n = t.PrimaryCameraPointId || null, i = (null === (e1 = this.config.json.Meta) || void 0 === e1 ? void 0 : e1.PrimaryCameraPointId) || null;
                return n || i;
            }
            get initialPanoramaRoomId() {
                if (!this.config.json) return null;
                const { Rooms: e1 } = this.config.json.Floors[this.currentFloorIndex].Units[0], t = [
                    ...e1
                ].sort((e1, t)=>t.Area - e1.Area), n = t.find((e1)=>{
                    let { Type: t } = e1;
                    return "Living" === t;
                }), i = t[0];
                return (null == n ? void 0 : n.ID) || (null == i ? void 0 : i.ID) || null;
            }
            get config() {
                return this.getFloorConfig(this.currentFloorIndex);
            }
            get prevFloorIndex() {
                const e1 = this.currentFloorIndex - 1;
                return e1 < 0 ? this.configParams.floors.length - 1 : e1;
            }
            get nextFloorIndex() {
                return (this.currentFloorIndex + 1) % this.configParams.floors.length;
            }
            get dictionaryOverrides() {
                return this.configParams.dictionaryOverrides;
            }
            get autoRotatePanarama() {
                return this.configParams.autoRotate;
            }
            get instructionVisible() {
                return this.configParams.instructionVisible;
            }
            get scales() {
                return this.config.scales;
            }
            isCapable(e1) {
                var t;
                return Boolean(null === (t = this.configParams) || void 0 === t || null === (t = t.capabilities) || void 0 === t || null === (t = t[e1]) || void 0 === t ? void 0 : t.enabled);
            }
            getFloorConfig(e1) {
                const t = this.getFloorParamByKey("original_plan_img", e1), n = this.getFloorParamByKey("styled_plan_img", e1), i = this.getFloorParamByKey("original_plans_img", e1), r = this.getFloorParamByKey("top_view_img", e1), a = this.getFloorParamByKey("panorama", e1), s = this.getFloorParamByKey("rotate", e1);
                return {
                    ...this.configParams,
                    originalPlans: i,
                    planImage: n || t,
                    rotationData: s,
                    panoramaData: a,
                    topViewImage: r
                };
            }
            setCurrentFloorIndex(e1) {
                this.currentFloorIndex = e1;
            }
            setPrevFloorIndex() {
                this.setCurrentFloorIndex(this.prevFloorIndex);
            }
            setNextFloorIndex() {
                this.setCurrentFloorIndex(this.nextFloorIndex);
            }
            getFloorParamByKey(e1, t) {
                return this.configParams.floors[t][e1];
            }
            isTabIncluded(e1) {
                return this.config.tabs.find((t)=>t === e1);
            }
            setConfig(e1) {
                this.configParams = e1, ki.setCurrentLocale(e1.locale), this.dispatchEvent("resize", {
                    width: e1.width,
                    height: e1.height
                });
            }
            hideControls() {
                this.controlsVisible = !1;
            }
            showControls() {
                this.controlsVisible = !0;
            }
            addEventListener(e1, t) {
                this.listeners[e1] && this.listeners[e1].push(t);
            }
            dispatchEvent(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                this.listeners[e1] && this.listeners[e1].forEach((e1)=>e1(t));
            }
        }, Fi = [
            [
                "requestFullscreen",
                "exitFullscreen",
                "fullscreenElement",
                "fullscreenEnabled",
                "fullscreenchange",
                "fullscreenerror"
            ],
            [
                "webkitRequestFullscreen",
                "webkitExitFullscreen",
                "webkitFullscreenElement",
                "webkitFullscreenEnabled",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "webkitRequestFullScreen",
                "webkitCancelFullScreen",
                "webkitCurrentFullScreenElement",
                "webkitCancelFullScreen",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "mozRequestFullScreen",
                "mozCancelFullScreen",
                "mozFullScreenElement",
                "mozFullScreenEnabled",
                "mozfullscreenchange",
                "mozfullscreenerror"
            ],
            [
                "msRequestFullscreen",
                "msExitFullscreen",
                "msFullscreenElement",
                "msFullscreenEnabled",
                "MSFullscreenChange",
                "MSFullscreenError"
            ]
        ], Hi = (()=>{
            if ("undefined" == typeof document) return !1;
            const e1 = Fi[0], t = {};
            for (const n of Fi)if ((null == n ? void 0 : n[1]) in document) {
                for (const [i, r] of n.entries())t[e1[i]] = r;
                return t;
            }
            return !1;
        })(), Vi = {
            change: Hi.fullscreenchange,
            error: Hi.fullscreenerror
        };
        let Gi = {
            request () {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : document.documentElement, t = arguments.length > 1 ? arguments[1] : void 0;
                return new Promise((n, i)=>{
                    const r = ()=>{
                        Gi.off("change", r), n();
                    };
                    Gi.on("change", r);
                    const a = e1[Hi.requestFullscreen](t);
                    a instanceof Promise && a.then(r).catch(i);
                });
            },
            exit: ()=>new Promise((e1, t)=>{
                    if (!Gi.isFullscreen) return void e1();
                    const n = ()=>{
                        Gi.off("change", n), e1();
                    };
                    Gi.on("change", n);
                    const i = document[Hi.exitFullscreen]();
                    i instanceof Promise && i.then(n).catch(t);
                }),
            toggle: (e1, t)=>Gi.isFullscreen ? Gi.exit() : Gi.request(e1, t),
            onchange (e1) {
                Gi.on("change", e1);
            },
            onerror (e1) {
                Gi.on("error", e1);
            },
            on (e1, t) {
                const n = Vi[e1];
                n && document.addEventListener(n, t, !1);
            },
            off (e1, t) {
                const n = Vi[e1];
                n && document.removeEventListener(n, t, !1);
            },
            raw: Hi
        };
        Object.defineProperties(Gi, {
            isFullscreen: {
                get: ()=>Boolean(document[Hi.fullscreenElement])
            },
            element: {
                enumerable: !0,
                get: ()=>{
                    var e1;
                    return null !== (e1 = document[Hi.fullscreenElement]) && void 0 !== e1 ? e1 : void 0;
                }
            },
            isEnabled: {
                enumerable: !0,
                get: ()=>Boolean(document[Hi.fullscreenEnabled])
            }
        }), Hi || (Gi = {
            isEnabled: !1
        });
        const Qi = Gi;
        function Wi(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        dn({
            useProxies: "never"
        });
        const Yi = new class {
            constructor(){
                Wi(this, "enabled", Qi.isEnabled), Wi(this, "active", !1), Wi(this, "element", null), Wi(this, "width", null), Wi(this, "height", null), Rn(this);
            }
            init() {
                this.element = document.querySelector("#widget-application"), this.enabled && (this.resize(Bi.config), Qi.on("change", ()=>{
                    setTimeout(()=>{
                        this.active = Qi.isFullscreen, this.active ? Bi.setConfig({
                            ...Bi.config,
                            width: window.innerWidth,
                            height: window.innerHeight
                        }) : Bi.setConfig({
                            ...Bi.config,
                            width: this.width,
                            height: this.height
                        });
                    }, 100);
                }));
            }
            async enter() {
                return await Qi.request(this.element);
            }
            async exit() {
                return await Qi.exit();
            }
            resize(e1) {
                let { width: t, height: n } = e1;
                this.width = t, this.height = n;
            }
        }, Xi = Yi, Zi = {
            DEFAULT: 0,
            THREESIXTY: 1
        }, qi = {
            tabs: [
                "rotation",
                "area",
                "panorama"
            ],
            logo: null,
            logoUrl: null,
            width: 1920,
            height: 1080,
            resizable: !0,
            rotationMode: Zi.DEFAULT,
            floors: [],
            panoramaFov: 75,
            preloadPerPanoramaCount: 3,
            forcePreloadNonCached: !0,
            forceTopViewOnMap: !1,
            topViewResolutionUpscale: 2,
            enableCameraTransitionBetweenPanoramas: !1,
            enableCameraRotationBetweenPanoramas: !0,
            primaryCameraPointId: null,
            json: null,
            locale: "en",
            API_URL: "https://backend.estate.hart-digital.com",
            branding: null,
            colors: {
                main: "#FAC62D",
                mainText: "#413E3E"
            },
            panoramaIcons: {
                spot: "data:image/png;base64,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",
                interactiveSpot: "data:image/png;base64,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",
                door: "data:image/png;base64,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"
            },
            dictionaryOverrides: null,
            instructionVisible: !0,
            autoRotate: !1,
            scales: [
                "x1",
                "x2",
                "x05"
            ],
            enableGyroscope: !0,
            scaleButtonType: "img",
            floorNumberEndingsVisible: !1,
            interactiveDoors: !1,
            interactiveCameraPoints: !1,
            defaultButtonsStyle: !0,
            availableRotationSteps: [
                "carousel",
                "plan",
                "topView",
                "renders"
            ],
            defaultLinkOptions: {},
            ruler_options: {}
        }, Ki = qi, Ji = "158", $i = {
            LEFT: 0,
            MIDDLE: 1,
            RIGHT: 2,
            ROTATE: 0,
            DOLLY: 1,
            PAN: 2
        }, er = {
            ROTATE: 0,
            PAN: 1,
            DOLLY_PAN: 2,
            DOLLY_ROTATE: 3
        }, tr = 0, nr = 1, ir = 2, rr = 3, ar = 0, sr = 1, or = 2, lr = 3, cr = 0, ur = 1, hr = 2, dr = 2, pr = 0, fr = 1, mr = 2, gr = 3, Ar = 4, vr = 5, Mr = 100, yr = 101, xr = 102, _r = 103, br = 104, wr = 200, Er = 201, Tr = 202, Sr = 203, Ir = 204, Nr = 205, Dr = 206, Cr = 207, Lr = 208, Rr = 209, zr = 210, Or = 211, Pr = 212, Ur = 213, kr = 214, jr = 0, Br = 1, Fr = 2, Hr = 3, Vr = 4, Gr = 5, Qr = 6, Wr = 7, Yr = 0, Xr = 1, Zr = 2, qr = 0, Kr = 1, Jr = 2, $r = 3, ea = 4, ta = 5, na = "attached", ia = "detached", ra = 300, aa = 301, sa = 302, oa = 303, la = 304, ca = 306, ua = 1e3, ha = 1001, da = 1002, pa = 1003, fa = 1004, ma = 1004, ga = 1005, Aa = 1005, va = 1006, Ma = 1007, ya = 1007, xa = 1008, _a = 1008, ba = 1009, wa = 1010, Ea = 1011, Ta = 1012, Sa = 1013, Ia = 1014, Na = 1015, Da = 1016, Ca = 1017, La = 1018, Ra = 1020, za = 1021, Oa = 1023, Pa = 1024, Ua = 1025, ka = 1026, ja = 1027, Ba = 1028, Fa = 1029, Ha = 1030, Va = 1031, Ga = 1033, Qa = 33776, Wa = 33777, Ya = 33778, Xa = 33779, Za = 35840, qa = 35841, Ka = 35842, Ja = 35843, $a = 36196, es = 37492, ts = 37496, ns = 37808, is = 37809, rs = 37810, as = 37811, ss = 37812, os = 37813, ls = 37814, cs = 37815, us = 37816, hs = 37817, ds = 37818, ps = 37819, fs = 37820, ms = 37821, gs = 36492, As = 36494, vs = 36495, Ms = 36283, ys = 36284, xs = 36285, _s = 36286, bs = 2200, ws = 2201, Es = 2202, Ts = 2300, Ss = 2301, Is = 2302, Ns = 2400, Ds = 2401, Cs = 2402, Ls = 2500, Rs = 2501, zs = 0, Os = 1, Ps = 2, Us = 3e3, ks = 3001, js = 3200, Bs = 3201, Fs = 0, Hs = 1, Vs = "", Gs = "srgb", Qs = "srgb-linear", Ws = "display-p3", Ys = "display-p3-linear", Xs = "linear", Zs = "srgb", qs = "rec709", Ks = "p3", Js = 0, $s = 7680, eo = 7681, to = 7682, no = 7683, io = 34055, ro = 34056, ao = 5386, so = 512, oo = 513, lo = 514, co = 515, uo = 516, ho = 517, po = 518, fo = 519, mo = 512, go = 513, Ao = 514, vo = 515, Mo = 516, yo = 517, xo = 518, _o = 519, bo = 35044, wo = 35048, Eo = 35040, To = 35045, So = 35049, Io = 35041, No = 35046, Do = 35050, Co = 35042, Lo = "100", Ro = "300 es", zo = 1035, Oo = 2e3, Po = 2001;
        class Uo {
            addEventListener(e1, t) {
                void 0 === this._listeners && (this._listeners = {});
                const n = this._listeners;
                void 0 === n[e1] && (n[e1] = []), -1 === n[e1].indexOf(t) && n[e1].push(t);
            }
            hasEventListener(e1, t) {
                if (void 0 === this._listeners) return !1;
                const n = this._listeners;
                return void 0 !== n[e1] && -1 !== n[e1].indexOf(t);
            }
            removeEventListener(e1, t) {
                if (void 0 === this._listeners) return;
                const n = this._listeners[e1];
                if (void 0 !== n) {
                    const e1 = n.indexOf(t);
                    -1 !== e1 && n.splice(e1, 1);
                }
            }
            dispatchEvent(e1) {
                if (void 0 === this._listeners) return;
                const t = this._listeners[e1.type];
                if (void 0 !== t) {
                    e1.target = this;
                    const n = t.slice(0);
                    for(let t = 0, i = n.length; t < i; t++)n[t].call(this, e1);
                    e1.target = null;
                }
            }
        }
        const ko = [
            "00",
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "0a",
            "0b",
            "0c",
            "0d",
            "0e",
            "0f",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "1a",
            "1b",
            "1c",
            "1d",
            "1e",
            "1f",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "2a",
            "2b",
            "2c",
            "2d",
            "2e",
            "2f",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "3a",
            "3b",
            "3c",
            "3d",
            "3e",
            "3f",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "4a",
            "4b",
            "4c",
            "4d",
            "4e",
            "4f",
            "50",
            "51",
            "52",
            "53",
            "54",
            "55",
            "56",
            "57",
            "58",
            "59",
            "5a",
            "5b",
            "5c",
            "5d",
            "5e",
            "5f",
            "60",
            "61",
            "62",
            "63",
            "64",
            "65",
            "66",
            "67",
            "68",
            "69",
            "6a",
            "6b",
            "6c",
            "6d",
            "6e",
            "6f",
            "70",
            "71",
            "72",
            "73",
            "74",
            "75",
            "76",
            "77",
            "78",
            "79",
            "7a",
            "7b",
            "7c",
            "7d",
            "7e",
            "7f",
            "80",
            "81",
            "82",
            "83",
            "84",
            "85",
            "86",
            "87",
            "88",
            "89",
            "8a",
            "8b",
            "8c",
            "8d",
            "8e",
            "8f",
            "90",
            "91",
            "92",
            "93",
            "94",
            "95",
            "96",
            "97",
            "98",
            "99",
            "9a",
            "9b",
            "9c",
            "9d",
            "9e",
            "9f",
            "a0",
            "a1",
            "a2",
            "a3",
            "a4",
            "a5",
            "a6",
            "a7",
            "a8",
            "a9",
            "aa",
            "ab",
            "ac",
            "ad",
            "ae",
            "af",
            "b0",
            "b1",
            "b2",
            "b3",
            "b4",
            "b5",
            "b6",
            "b7",
            "b8",
            "b9",
            "ba",
            "bb",
            "bc",
            "bd",
            "be",
            "bf",
            "c0",
            "c1",
            "c2",
            "c3",
            "c4",
            "c5",
            "c6",
            "c7",
            "c8",
            "c9",
            "ca",
            "cb",
            "cc",
            "cd",
            "ce",
            "cf",
            "d0",
            "d1",
            "d2",
            "d3",
            "d4",
            "d5",
            "d6",
            "d7",
            "d8",
            "d9",
            "da",
            "db",
            "dc",
            "dd",
            "de",
            "df",
            "e0",
            "e1",
            "e2",
            "e3",
            "e4",
            "e5",
            "e6",
            "e7",
            "e8",
            "e9",
            "ea",
            "eb",
            "ec",
            "ed",
            "ee",
            "ef",
            "f0",
            "f1",
            "f2",
            "f3",
            "f4",
            "f5",
            "f6",
            "f7",
            "f8",
            "f9",
            "fa",
            "fb",
            "fc",
            "fd",
            "fe",
            "ff"
        ];
        let jo = 1234567;
        const Bo = Math.PI / 180, Fo = 180 / Math.PI;
        function Ho() {
            const e1 = 4294967295 * Math.random() | 0, t = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0;
            return (ko[255 & e1] + ko[e1 >> 8 & 255] + ko[e1 >> 16 & 255] + ko[e1 >> 24 & 255] + "-" + ko[255 & t] + ko[t >> 8 & 255] + "-" + ko[t >> 16 & 15 | 64] + ko[t >> 24 & 255] + "-" + ko[63 & n | 128] + ko[n >> 8 & 255] + "-" + ko[n >> 16 & 255] + ko[n >> 24 & 255] + ko[255 & i] + ko[i >> 8 & 255] + ko[i >> 16 & 255] + ko[i >> 24 & 255]).toLowerCase();
        }
        function Vo(e1, t, n) {
            return Math.max(t, Math.min(n, e1));
        }
        function Go(e1, t) {
            return (e1 % t + t) % t;
        }
        function Qo(e1, t, n) {
            return (1 - n) * e1 + n * t;
        }
        function Wo(e1) {
            return !(e1 & e1 - 1) && 0 !== e1;
        }
        function Yo(e1) {
            return Math.pow(2, Math.ceil(Math.log(e1) / Math.LN2));
        }
        function Xo(e1) {
            return Math.pow(2, Math.floor(Math.log(e1) / Math.LN2));
        }
        function Zo(e1, t) {
            switch(t.constructor){
                case Float32Array:
                    return e1;
                case Uint32Array:
                    return e1 / 4294967295;
                case Uint16Array:
                    return e1 / 65535;
                case Uint8Array:
                    return e1 / 255;
                case Int32Array:
                    return Math.max(e1 / 2147483647, -1);
                case Int16Array:
                    return Math.max(e1 / 32767, -1);
                case Int8Array:
                    return Math.max(e1 / 127, -1);
                default:
                    throw new Error("Invalid component type.");
            }
        }
        function qo(e1, t) {
            switch(t.constructor){
                case Float32Array:
                    return e1;
                case Uint32Array:
                    return Math.round(4294967295 * e1);
                case Uint16Array:
                    return Math.round(65535 * e1);
                case Uint8Array:
                    return Math.round(255 * e1);
                case Int32Array:
                    return Math.round(2147483647 * e1);
                case Int16Array:
                    return Math.round(32767 * e1);
                case Int8Array:
                    return Math.round(127 * e1);
                default:
                    throw new Error("Invalid component type.");
            }
        }
        const Ko = {
            DEG2RAD: Bo,
            RAD2DEG: Fo,
            generateUUID: Ho,
            clamp: Vo,
            euclideanModulo: Go,
            mapLinear: function(e1, t, n, i, r) {
                return i + (e1 - t) * (r - i) / (n - t);
            },
            inverseLerp: function(e1, t, n) {
                return e1 !== t ? (n - e1) / (t - e1) : 0;
            },
            lerp: Qo,
            damp: function(e1, t, n, i) {
                return Qo(e1, t, 1 - Math.exp(-n * i));
            },
            pingpong: function(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                return t - Math.abs(Go(e1, 2 * t) - t);
            },
            smoothstep: function(e1, t, n) {
                return e1 <= t ? 0 : e1 >= n ? 1 : (e1 = (e1 - t) / (n - t)) * e1 * (3 - 2 * e1);
            },
            smootherstep: function(e1, t, n) {
                return e1 <= t ? 0 : e1 >= n ? 1 : (e1 = (e1 - t) / (n - t)) * e1 * e1 * (e1 * (6 * e1 - 15) + 10);
            },
            randInt: function(e1, t) {
                return e1 + Math.floor(Math.random() * (t - e1 + 1));
            },
            randFloat: function(e1, t) {
                return e1 + Math.random() * (t - e1);
            },
            randFloatSpread: function(e1) {
                return e1 * (.5 - Math.random());
            },
            seededRandom: function(e1) {
                void 0 !== e1 && (jo = e1);
                let t = jo += 1831565813;
                return t = Math.imul(t ^ t >>> 15, 1 | t), t ^= t + Math.imul(t ^ t >>> 7, 61 | t), ((t ^ t >>> 14) >>> 0) / 4294967296;
            },
            degToRad: function(e1) {
                return e1 * Bo;
            },
            radToDeg: function(e1) {
                return e1 * Fo;
            },
            isPowerOfTwo: Wo,
            ceilPowerOfTwo: Yo,
            floorPowerOfTwo: Xo,
            setQuaternionFromProperEuler: function(e1, t, n, i, r) {
                const a = Math.cos, s = Math.sin, o = a(n / 2), l = s(n / 2), c = a((t + i) / 2), u = s((t + i) / 2), h = a((t - i) / 2), d = s((t - i) / 2), p = a((i - t) / 2), f = s((i - t) / 2);
                switch(r){
                    case "XYX":
                        e1.set(o * u, l * h, l * d, o * c);
                        break;
                    case "YZY":
                        e1.set(l * d, o * u, l * h, o * c);
                        break;
                    case "ZXZ":
                        e1.set(l * h, l * d, o * u, o * c);
                        break;
                    case "XZX":
                        e1.set(o * u, l * f, l * p, o * c);
                        break;
                    case "YXY":
                        e1.set(l * p, o * u, l * f, o * c);
                        break;
                    case "ZYZ":
                        e1.set(l * f, l * p, o * u, o * c);
                        break;
                    default:
                        console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + r);
                }
            },
            normalize: qo,
            denormalize: Zo
        };
        class Jo {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                Jo.prototype.isVector2 = !0, this.x = e1, this.y = t;
            }
            get width() {
                return this.x;
            }
            set width(e1) {
                this.x = e1;
            }
            get height() {
                return this.y;
            }
            set height(e1) {
                this.y = e1;
            }
            set(e1, t) {
                return this.x = e1, this.y = t, this;
            }
            setScalar(e1) {
                return this.x = e1, this.y = e1, this;
            }
            setX(e1) {
                return this.x = e1, this;
            }
            setY(e1) {
                return this.y = e1, this;
            }
            setComponent(e1, t) {
                switch(e1){
                    case 0:
                        this.x = t;
                        break;
                    case 1:
                        this.y = t;
                        break;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
                return this;
            }
            getComponent(e1) {
                switch(e1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y);
            }
            copy(e1) {
                return this.x = e1.x, this.y = e1.y, this;
            }
            add(e1) {
                return this.x += e1.x, this.y += e1.y, this;
            }
            addScalar(e1) {
                return this.x += e1, this.y += e1, this;
            }
            addVectors(e1, t) {
                return this.x = e1.x + t.x, this.y = e1.y + t.y, this;
            }
            addScaledVector(e1, t) {
                return this.x += e1.x * t, this.y += e1.y * t, this;
            }
            sub(e1) {
                return this.x -= e1.x, this.y -= e1.y, this;
            }
            subScalar(e1) {
                return this.x -= e1, this.y -= e1, this;
            }
            subVectors(e1, t) {
                return this.x = e1.x - t.x, this.y = e1.y - t.y, this;
            }
            multiply(e1) {
                return this.x *= e1.x, this.y *= e1.y, this;
            }
            multiplyScalar(e1) {
                return this.x *= e1, this.y *= e1, this;
            }
            divide(e1) {
                return this.x /= e1.x, this.y /= e1.y, this;
            }
            divideScalar(e1) {
                return this.multiplyScalar(1 / e1);
            }
            applyMatrix3(e1) {
                const t = this.x, n = this.y, i = e1.elements;
                return this.x = i[0] * t + i[3] * n + i[6], this.y = i[1] * t + i[4] * n + i[7], this;
            }
            min(e1) {
                return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this;
            }
            max(e1) {
                return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this;
            }
            clamp(e1, t) {
                return this.x = Math.max(e1.x, Math.min(t.x, this.x)), this.y = Math.max(e1.y, Math.min(t.y, this.y)), this;
            }
            clampScalar(e1, t) {
                return this.x = Math.max(e1, Math.min(t, this.x)), this.y = Math.max(e1, Math.min(t, this.y)), this;
            }
            clampLength(e1, t) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(e1, Math.min(t, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this;
            }
            dot(e1) {
                return this.x * e1.x + this.y * e1.y;
            }
            cross(e1) {
                return this.x * e1.y - this.y * e1.x;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            angle() {
                return Math.atan2(-this.y, -this.x) + Math.PI;
            }
            angleTo(e1) {
                const t = Math.sqrt(this.lengthSq() * e1.lengthSq());
                if (0 === t) return Math.PI / 2;
                const n = this.dot(e1) / t;
                return Math.acos(Vo(n, -1, 1));
            }
            distanceTo(e1) {
                return Math.sqrt(this.distanceToSquared(e1));
            }
            distanceToSquared(e1) {
                const t = this.x - e1.x, n = this.y - e1.y;
                return t * t + n * n;
            }
            manhattanDistanceTo(e1) {
                return Math.abs(this.x - e1.x) + Math.abs(this.y - e1.y);
            }
            setLength(e1) {
                return this.normalize().multiplyScalar(e1);
            }
            lerp(e1, t) {
                return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this;
            }
            lerpVectors(e1, t, n) {
                return this.x = e1.x + (t.x - e1.x) * n, this.y = e1.y + (t.y - e1.y) * n, this;
            }
            equals(e1) {
                return e1.x === this.x && e1.y === this.y;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.x = e1[t], this.y = e1[t + 1], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.x, e1[t + 1] = this.y, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.x = e1.getX(t), this.y = e1.getY(t), this;
            }
            rotateAround(e1, t) {
                const n = Math.cos(t), i = Math.sin(t), r = this.x - e1.x, a = this.y - e1.y;
                return this.x = r * n - a * i + e1.x, this.y = r * i + a * n + e1.y, this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y;
            }
        }
        class $o {
            constructor(e1, t, n, i, r, a, s, o, l){
                $o.prototype.isMatrix3 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== e1 && this.set(e1, t, n, i, r, a, s, o, l);
            }
            set(e1, t, n, i, r, a, s, o, l) {
                const c = this.elements;
                return c[0] = e1, c[1] = i, c[2] = s, c[3] = t, c[4] = r, c[5] = o, c[6] = n, c[7] = a, c[8] = l, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
            }
            copy(e1) {
                const t = this.elements, n = e1.elements;
                return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], this;
            }
            extractBasis(e1, t, n) {
                return e1.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
            }
            setFromMatrix4(e1) {
                const t = e1.elements;
                return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
            }
            multiply(e1) {
                return this.multiplyMatrices(this, e1);
            }
            premultiply(e1) {
                return this.multiplyMatrices(e1, this);
            }
            multiplyMatrices(e1, t) {
                const n = e1.elements, i = t.elements, r = this.elements, a = n[0], s = n[3], o = n[6], l = n[1], c = n[4], u = n[7], h = n[2], d = n[5], p = n[8], f = i[0], m = i[3], g = i[6], A = i[1], v = i[4], M = i[7], y = i[2], x = i[5], _ = i[8];
                return r[0] = a * f + s * A + o * y, r[3] = a * m + s * v + o * x, r[6] = a * g + s * M + o * _, r[1] = l * f + c * A + u * y, r[4] = l * m + c * v + u * x, r[7] = l * g + c * M + u * _, r[2] = h * f + d * A + p * y, r[5] = h * m + d * v + p * x, r[8] = h * g + d * M + p * _, this;
            }
            multiplyScalar(e1) {
                const t = this.elements;
                return t[0] *= e1, t[3] *= e1, t[6] *= e1, t[1] *= e1, t[4] *= e1, t[7] *= e1, t[2] *= e1, t[5] *= e1, t[8] *= e1, this;
            }
            determinant() {
                const e1 = this.elements, t = e1[0], n = e1[1], i = e1[2], r = e1[3], a = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8];
                return t * a * c - t * s * l - n * r * c + n * s * o + i * r * l - i * a * o;
            }
            invert() {
                const e1 = this.elements, t = e1[0], n = e1[1], i = e1[2], r = e1[3], a = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8], u = c * a - s * l, h = s * o - c * r, d = l * r - a * o, p = t * u + n * h + i * d;
                if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                const f = 1 / p;
                return e1[0] = u * f, e1[1] = (i * l - c * n) * f, e1[2] = (s * n - i * a) * f, e1[3] = h * f, e1[4] = (c * t - i * o) * f, e1[5] = (i * r - s * t) * f, e1[6] = d * f, e1[7] = (n * o - l * t) * f, e1[8] = (a * t - n * r) * f, this;
            }
            transpose() {
                let e1;
                const t = this.elements;
                return e1 = t[1], t[1] = t[3], t[3] = e1, e1 = t[2], t[2] = t[6], t[6] = e1, e1 = t[5], t[5] = t[7], t[7] = e1, this;
            }
            getNormalMatrix(e1) {
                return this.setFromMatrix4(e1).invert().transpose();
            }
            transposeIntoArray(e1) {
                const t = this.elements;
                return e1[0] = t[0], e1[1] = t[3], e1[2] = t[6], e1[3] = t[1], e1[4] = t[4], e1[5] = t[7], e1[6] = t[2], e1[7] = t[5], e1[8] = t[8], this;
            }
            setUvTransform(e1, t, n, i, r, a, s) {
                const o = Math.cos(r), l = Math.sin(r);
                return this.set(n * o, n * l, -n * (o * a + l * s) + a + e1, -i * l, i * o, -i * (-l * a + o * s) + s + t, 0, 0, 1), this;
            }
            scale(e1, t) {
                return this.premultiply(el.makeScale(e1, t)), this;
            }
            rotate(e1) {
                return this.premultiply(el.makeRotation(-e1)), this;
            }
            translate(e1, t) {
                return this.premultiply(el.makeTranslation(e1, t)), this;
            }
            makeTranslation(e1, t) {
                return e1.isVector2 ? this.set(1, 0, e1.x, 0, 1, e1.y, 0, 0, 1) : this.set(1, 0, e1, 0, 1, t, 0, 0, 1), this;
            }
            makeRotation(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(t, -n, 0, n, t, 0, 0, 0, 1), this;
            }
            makeScale(e1, t) {
                return this.set(e1, 0, 0, 0, t, 0, 0, 0, 1), this;
            }
            equals(e1) {
                const t = this.elements, n = e1.elements;
                for(let e1 = 0; e1 < 9; e1++)if (t[e1] !== n[e1]) return !1;
                return !0;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                for(let n = 0; n < 9; n++)this.elements[n] = e1[n + t];
                return this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.elements;
                return e1[t] = n[0], e1[t + 1] = n[1], e1[t + 2] = n[2], e1[t + 3] = n[3], e1[t + 4] = n[4], e1[t + 5] = n[5], e1[t + 6] = n[6], e1[t + 7] = n[7], e1[t + 8] = n[8], e1;
            }
            clone() {
                return (new this.constructor).fromArray(this.elements);
            }
        }
        const el = new $o;
        function tl(e1) {
            for(let t = e1.length - 1; t >= 0; --t)if (e1[t] >= 65535) return !0;
            return !1;
        }
        const nl = {
            Int8Array: Int8Array,
            Uint8Array: Uint8Array,
            Uint8ClampedArray: Uint8ClampedArray,
            Int16Array: Int16Array,
            Uint16Array: Uint16Array,
            Int32Array: Int32Array,
            Uint32Array: Uint32Array,
            Float32Array: Float32Array,
            Float64Array: Float64Array
        };
        function il(e1, t) {
            return new nl[e1](t);
        }
        function rl(e1) {
            return document.createElementNS("http://www.w3.org/1999/xhtml", e1);
        }
        function al() {
            const e1 = rl("canvas");
            return e1.style.display = "block", e1;
        }
        const sl = {};
        function ol(e1) {
            e1 in sl || (sl[e1] = !0, console.warn(e1));
        }
        const ll = (new $o).set(.8224621, .177538, 0, .0331941, .9668058, 0, .0170827, .0723974, .9105199), cl = (new $o).set(1.2249401, -0.2249404, 0, -0.0420569, 1.0420571, 0, -0.0196376, -0.0786361, 1.0982735), ul = {
            [Qs]: {
                transfer: Xs,
                primaries: qs,
                toReference: (e1)=>e1,
                fromReference: (e1)=>e1
            },
            [Gs]: {
                transfer: Zs,
                primaries: qs,
                toReference: (e1)=>e1.convertSRGBToLinear(),
                fromReference: (e1)=>e1.convertLinearToSRGB()
            },
            [Ys]: {
                transfer: Xs,
                primaries: Ks,
                toReference: (e1)=>e1.applyMatrix3(cl),
                fromReference: (e1)=>e1.applyMatrix3(ll)
            },
            [Ws]: {
                transfer: Zs,
                primaries: Ks,
                toReference: (e1)=>e1.convertSRGBToLinear().applyMatrix3(cl),
                fromReference: (e1)=>e1.applyMatrix3(ll).convertLinearToSRGB()
            }
        }, hl = new Set([
            Qs,
            Ys
        ]), dl = {
            enabled: !0,
            _workingColorSpace: Qs,
            get legacyMode () {
                return console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), !this.enabled;
            },
            set legacyMode (e){
                console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."), this.enabled = !e;
            },
            get workingColorSpace () {
                return this._workingColorSpace;
            },
            set workingColorSpace (e){
                if (!hl.has(e)) throw new Error('Unsupported working color space, "'.concat(e, '".'));
                this._workingColorSpace = e;
            },
            convert: function(e1, t, n) {
                if (!1 === this.enabled || t === n || !t || !n) return e1;
                const i = ul[t].toReference;
                return (0, ul[n].fromReference)(i(e1));
            },
            fromWorkingColorSpace: function(e1, t) {
                return this.convert(e1, this._workingColorSpace, t);
            },
            toWorkingColorSpace: function(e1, t) {
                return this.convert(e1, t, this._workingColorSpace);
            },
            getPrimaries: function(e1) {
                return ul[e1].primaries;
            },
            getTransfer: function(e1) {
                return e1 === Vs ? Xs : ul[e1].transfer;
            }
        };
        function pl(e1) {
            return e1 < .04045 ? .0773993808 * e1 : Math.pow(.9478672986 * e1 + .0521327014, 2.4);
        }
        function fl(e1) {
            return e1 < .0031308 ? 12.92 * e1 : 1.055 * Math.pow(e1, .41666) - .055;
        }
        let ml;
        class gl {
            static getDataURL(e1) {
                if (/^data:/i.test(e1.src)) return e1.src;
                if ("undefined" == typeof HTMLCanvasElement) return e1.src;
                let t;
                if (e1 instanceof HTMLCanvasElement) t = e1;
                else {
                    void 0 === ml && (ml = rl("canvas")), ml.width = e1.width, ml.height = e1.height;
                    const n = ml.getContext("2d");
                    e1 instanceof ImageData ? n.putImageData(e1, 0, 0) : n.drawImage(e1, 0, 0, e1.width, e1.height), t = ml;
                }
                return t.width > 2048 || t.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", e1), t.toDataURL("image/jpeg", .6)) : t.toDataURL("image/png");
            }
            static sRGBToLinear(e1) {
                if ("undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap) {
                    const t = rl("canvas");
                    t.width = e1.width, t.height = e1.height;
                    const n = t.getContext("2d");
                    n.drawImage(e1, 0, 0, e1.width, e1.height);
                    const i = n.getImageData(0, 0, e1.width, e1.height), r = i.data;
                    for(let e1 = 0; e1 < r.length; e1++)r[e1] = 255 * pl(r[e1] / 255);
                    return n.putImageData(i, 0, 0), t;
                }
                if (e1.data) {
                    const t = e1.data.slice(0);
                    for(let e1 = 0; e1 < t.length; e1++)t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[e1] = Math.floor(255 * pl(t[e1] / 255)) : t[e1] = pl(t[e1]);
                    return {
                        data: t,
                        width: e1.width,
                        height: e1.height
                    };
                }
                return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e1;
            }
        }
        let Al = 0;
        class vl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                this.isSource = !0, Object.defineProperty(this, "id", {
                    value: Al++
                }), this.uuid = Ho(), this.data = e1, this.version = 0;
            }
            set needsUpdate(e1) {
                !0 === e1 && this.version++;
            }
            toJSON(e1) {
                const t = void 0 === e1 || "string" == typeof e1;
                if (!t && void 0 !== e1.images[this.uuid]) return e1.images[this.uuid];
                const n = {
                    uuid: this.uuid,
                    url: ""
                }, i = this.data;
                if (null !== i) {
                    let e1;
                    if (Array.isArray(i)) {
                        e1 = [];
                        for(let t = 0, n = i.length; t < n; t++)i[t].isDataTexture ? e1.push(Ml(i[t].image)) : e1.push(Ml(i[t]));
                    } else e1 = Ml(i);
                    n.url = e1;
                }
                return t || (e1.images[this.uuid] = n), n;
            }
        }
        function Ml(e1) {
            return "undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap ? gl.getDataURL(e1) : e1.data ? {
                data: Array.from(e1.data),
                width: e1.width,
                height: e1.height,
                type: e1.data.constructor.name
            } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
        }
        let yl = 0;
        class xl extends Uo {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : xl.DEFAULT_IMAGE, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : xl.DEFAULT_MAPPING, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ha, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : ha, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : va, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : xa, s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : Oa, o = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : ba, l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : xl.DEFAULT_ANISOTROPY, c = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : Vs;
                super(), this.isTexture = !0, Object.defineProperty(this, "id", {
                    value: yl++
                }), this.uuid = Ho(), this.name = "", this.source = new vl(e1), this.mipmaps = [], this.mapping = t, this.channel = 0, this.wrapS = n, this.wrapT = i, this.magFilter = r, this.minFilter = a, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = o, this.offset = new Jo(0, 0), this.repeat = new Jo(1, 1), this.center = new Jo(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new $o, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, "string" == typeof c ? this.colorSpace = c : (ol("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = c === ks ? Gs : Vs), this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
            }
            get image() {
                return this.source.data;
            }
            set image(e1) {
                void 0 === e1 && (e1 = null), this.source.data = e1;
            }
            updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                return this.name = e1.name, this.source = e1.source, this.mipmaps = e1.mipmaps.slice(0), this.mapping = e1.mapping, this.channel = e1.channel, this.wrapS = e1.wrapS, this.wrapT = e1.wrapT, this.magFilter = e1.magFilter, this.minFilter = e1.minFilter, this.anisotropy = e1.anisotropy, this.format = e1.format, this.internalFormat = e1.internalFormat, this.type = e1.type, this.offset.copy(e1.offset), this.repeat.copy(e1.repeat), this.center.copy(e1.center), this.rotation = e1.rotation, this.matrixAutoUpdate = e1.matrixAutoUpdate, this.matrix.copy(e1.matrix), this.generateMipmaps = e1.generateMipmaps, this.premultiplyAlpha = e1.premultiplyAlpha, this.flipY = e1.flipY, this.unpackAlignment = e1.unpackAlignment, this.colorSpace = e1.colorSpace, this.userData = JSON.parse(JSON.stringify(e1.userData)), this.needsUpdate = !0, this;
            }
            toJSON(e1) {
                const t = void 0 === e1 || "string" == typeof e1;
                if (!t && void 0 !== e1.textures[this.uuid]) return e1.textures[this.uuid];
                const n = {
                    metadata: {
                        version: 4.6,
                        type: "Texture",
                        generator: "Texture.toJSON"
                    },
                    uuid: this.uuid,
                    name: this.name,
                    image: this.source.toJSON(e1).uuid,
                    mapping: this.mapping,
                    channel: this.channel,
                    repeat: [
                        this.repeat.x,
                        this.repeat.y
                    ],
                    offset: [
                        this.offset.x,
                        this.offset.y
                    ],
                    center: [
                        this.center.x,
                        this.center.y
                    ],
                    rotation: this.rotation,
                    wrap: [
                        this.wrapS,
                        this.wrapT
                    ],
                    format: this.format,
                    internalFormat: this.internalFormat,
                    type: this.type,
                    colorSpace: this.colorSpace,
                    minFilter: this.minFilter,
                    magFilter: this.magFilter,
                    anisotropy: this.anisotropy,
                    flipY: this.flipY,
                    generateMipmaps: this.generateMipmaps,
                    premultiplyAlpha: this.premultiplyAlpha,
                    unpackAlignment: this.unpackAlignment
                };
                return Object.keys(this.userData).length > 0 && (n.userData = this.userData), t || (e1.textures[this.uuid] = n), n;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            transformUv(e1) {
                if (this.mapping !== ra) return e1;
                if (e1.applyMatrix3(this.matrix), e1.x < 0 || e1.x > 1) switch(this.wrapS){
                    case ua:
                        e1.x = e1.x - Math.floor(e1.x);
                        break;
                    case ha:
                        e1.x = e1.x < 0 ? 0 : 1;
                        break;
                    case da:
                        1 === Math.abs(Math.floor(e1.x) % 2) ? e1.x = Math.ceil(e1.x) - e1.x : e1.x = e1.x - Math.floor(e1.x);
                }
                if (e1.y < 0 || e1.y > 1) switch(this.wrapT){
                    case ua:
                        e1.y = e1.y - Math.floor(e1.y);
                        break;
                    case ha:
                        e1.y = e1.y < 0 ? 0 : 1;
                        break;
                    case da:
                        1 === Math.abs(Math.floor(e1.y) % 2) ? e1.y = Math.ceil(e1.y) - e1.y : e1.y = e1.y - Math.floor(e1.y);
                }
                return this.flipY && (e1.y = 1 - e1.y), e1;
            }
            set needsUpdate(e1) {
                !0 === e1 && (this.version++, this.source.needsUpdate = !0);
            }
            get encoding() {
                return ol("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace === Gs ? ks : Us;
            }
            set encoding(e1) {
                ol("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = e1 === ks ? Gs : Vs;
            }
        }
        xl.DEFAULT_IMAGE = null, xl.DEFAULT_MAPPING = ra, xl.DEFAULT_ANISOTROPY = 1;
        class _l {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                _l.prototype.isVector4 = !0, this.x = e1, this.y = t, this.z = n, this.w = i;
            }
            get width() {
                return this.z;
            }
            set width(e1) {
                this.z = e1;
            }
            get height() {
                return this.w;
            }
            set height(e1) {
                this.w = e1;
            }
            set(e1, t, n, i) {
                return this.x = e1, this.y = t, this.z = n, this.w = i, this;
            }
            setScalar(e1) {
                return this.x = e1, this.y = e1, this.z = e1, this.w = e1, this;
            }
            setX(e1) {
                return this.x = e1, this;
            }
            setY(e1) {
                return this.y = e1, this;
            }
            setZ(e1) {
                return this.z = e1, this;
            }
            setW(e1) {
                return this.w = e1, this;
            }
            setComponent(e1, t) {
                switch(e1){
                    case 0:
                        this.x = t;
                        break;
                    case 1:
                        this.y = t;
                        break;
                    case 2:
                        this.z = t;
                        break;
                    case 3:
                        this.w = t;
                        break;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
                return this;
            }
            getComponent(e1) {
                switch(e1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    case 3:
                        return this.w;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
            }
            copy(e1) {
                return this.x = e1.x, this.y = e1.y, this.z = e1.z, this.w = void 0 !== e1.w ? e1.w : 1, this;
            }
            add(e1) {
                return this.x += e1.x, this.y += e1.y, this.z += e1.z, this.w += e1.w, this;
            }
            addScalar(e1) {
                return this.x += e1, this.y += e1, this.z += e1, this.w += e1, this;
            }
            addVectors(e1, t) {
                return this.x = e1.x + t.x, this.y = e1.y + t.y, this.z = e1.z + t.z, this.w = e1.w + t.w, this;
            }
            addScaledVector(e1, t) {
                return this.x += e1.x * t, this.y += e1.y * t, this.z += e1.z * t, this.w += e1.w * t, this;
            }
            sub(e1) {
                return this.x -= e1.x, this.y -= e1.y, this.z -= e1.z, this.w -= e1.w, this;
            }
            subScalar(e1) {
                return this.x -= e1, this.y -= e1, this.z -= e1, this.w -= e1, this;
            }
            subVectors(e1, t) {
                return this.x = e1.x - t.x, this.y = e1.y - t.y, this.z = e1.z - t.z, this.w = e1.w - t.w, this;
            }
            multiply(e1) {
                return this.x *= e1.x, this.y *= e1.y, this.z *= e1.z, this.w *= e1.w, this;
            }
            multiplyScalar(e1) {
                return this.x *= e1, this.y *= e1, this.z *= e1, this.w *= e1, this;
            }
            applyMatrix4(e1) {
                const t = this.x, n = this.y, i = this.z, r = this.w, a = e1.elements;
                return this.x = a[0] * t + a[4] * n + a[8] * i + a[12] * r, this.y = a[1] * t + a[5] * n + a[9] * i + a[13] * r, this.z = a[2] * t + a[6] * n + a[10] * i + a[14] * r, this.w = a[3] * t + a[7] * n + a[11] * i + a[15] * r, this;
            }
            divideScalar(e1) {
                return this.multiplyScalar(1 / e1);
            }
            setAxisAngleFromQuaternion(e1) {
                this.w = 2 * Math.acos(e1.w);
                const t = Math.sqrt(1 - e1.w * e1.w);
                return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e1.x / t, this.y = e1.y / t, this.z = e1.z / t), this;
            }
            setAxisAngleFromRotationMatrix(e1) {
                let t, n, i, r;
                const a = .01, s = .1, o = e1.elements, l = o[0], c = o[4], u = o[8], h = o[1], d = o[5], p = o[9], f = o[2], m = o[6], g = o[10];
                if (Math.abs(c - h) < a && Math.abs(u - f) < a && Math.abs(p - m) < a) {
                    if (Math.abs(c + h) < s && Math.abs(u + f) < s && Math.abs(p + m) < s && Math.abs(l + d + g - 3) < s) return this.set(1, 0, 0, 0), this;
                    t = Math.PI;
                    const e1 = (l + 1) / 2, o = (d + 1) / 2, A = (g + 1) / 2, v = (c + h) / 4, M = (u + f) / 4, y = (p + m) / 4;
                    return e1 > o && e1 > A ? e1 < a ? (n = 0, i = .707106781, r = .707106781) : (n = Math.sqrt(e1), i = v / n, r = M / n) : o > A ? o < a ? (n = .707106781, i = 0, r = .707106781) : (i = Math.sqrt(o), n = v / i, r = y / i) : A < a ? (n = .707106781, i = .707106781, r = 0) : (r = Math.sqrt(A), n = M / r, i = y / r), this.set(n, i, r, t), this;
                }
                let A = Math.sqrt((m - p) * (m - p) + (u - f) * (u - f) + (h - c) * (h - c));
                return Math.abs(A) < .001 && (A = 1), this.x = (m - p) / A, this.y = (u - f) / A, this.z = (h - c) / A, this.w = Math.acos((l + d + g - 1) / 2), this;
            }
            min(e1) {
                return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this.z = Math.min(this.z, e1.z), this.w = Math.min(this.w, e1.w), this;
            }
            max(e1) {
                return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this.z = Math.max(this.z, e1.z), this.w = Math.max(this.w, e1.w), this;
            }
            clamp(e1, t) {
                return this.x = Math.max(e1.x, Math.min(t.x, this.x)), this.y = Math.max(e1.y, Math.min(t.y, this.y)), this.z = Math.max(e1.z, Math.min(t.z, this.z)), this.w = Math.max(e1.w, Math.min(t.w, this.w)), this;
            }
            clampScalar(e1, t) {
                return this.x = Math.max(e1, Math.min(t, this.x)), this.y = Math.max(e1, Math.min(t, this.y)), this.z = Math.max(e1, Math.min(t, this.z)), this.w = Math.max(e1, Math.min(t, this.w)), this;
            }
            clampLength(e1, t) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(e1, Math.min(t, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
            }
            dot(e1) {
                return this.x * e1.x + this.y * e1.y + this.z * e1.z + this.w * e1.w;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(e1) {
                return this.normalize().multiplyScalar(e1);
            }
            lerp(e1, t) {
                return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this.z += (e1.z - this.z) * t, this.w += (e1.w - this.w) * t, this;
            }
            lerpVectors(e1, t, n) {
                return this.x = e1.x + (t.x - e1.x) * n, this.y = e1.y + (t.y - e1.y) * n, this.z = e1.z + (t.z - e1.z) * n, this.w = e1.w + (t.w - e1.w) * n, this;
            }
            equals(e1) {
                return e1.x === this.x && e1.y === this.y && e1.z === this.z && e1.w === this.w;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.x = e1[t], this.y = e1[t + 1], this.z = e1[t + 2], this.w = e1[t + 3], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.x, e1[t + 1] = this.y, e1[t + 2] = this.z, e1[t + 3] = this.w, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.x = e1.getX(t), this.y = e1.getY(t), this.z = e1.getZ(t), this.w = e1.getW(t), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z, yield this.w;
            }
        }
        class bl extends Uo {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                super(), this.isRenderTarget = !0, this.width = e1, this.height = t, this.depth = 1, this.scissor = new _l(0, 0, e1, t), this.scissorTest = !1, this.viewport = new _l(0, 0, e1, t);
                const i = {
                    width: e1,
                    height: t,
                    depth: 1
                };
                void 0 !== n.encoding && (ol("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace."), n.colorSpace = n.encoding === ks ? Gs : Vs), n = Object.assign({
                    generateMipmaps: !1,
                    internalFormat: null,
                    minFilter: va,
                    depthBuffer: !0,
                    stencilBuffer: !1,
                    depthTexture: null,
                    samples: 0
                }, n), this.texture = new xl(i, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = n.generateMipmaps, this.texture.internalFormat = n.internalFormat, this.depthBuffer = n.depthBuffer, this.stencilBuffer = n.stencilBuffer, this.depthTexture = n.depthTexture, this.samples = n.samples;
            }
            setSize(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                this.width === e1 && this.height === t && this.depth === n || (this.width = e1, this.height = t, this.depth = n, this.texture.image.width = e1, this.texture.image.height = t, this.texture.image.depth = n, this.dispose()), this.viewport.set(0, 0, e1, t), this.scissor.set(0, 0, e1, t);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                this.width = e1.width, this.height = e1.height, this.depth = e1.depth, this.scissor.copy(e1.scissor), this.scissorTest = e1.scissorTest, this.viewport.copy(e1.viewport), this.texture = e1.texture.clone(), this.texture.isRenderTargetTexture = !0;
                const t = Object.assign({}, e1.texture.image);
                return this.texture.source = new vl(t), this.depthBuffer = e1.depthBuffer, this.stencilBuffer = e1.stencilBuffer, null !== e1.depthTexture && (this.depthTexture = e1.depthTexture.clone()), this.samples = e1.samples, this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        class wl extends bl {
            constructor(){
                super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}), this.isWebGLRenderTarget = !0;
            }
        }
        class El extends xl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                super(null), this.isDataArrayTexture = !0, this.image = {
                    data: e1,
                    width: t,
                    height: n,
                    depth: i
                }, this.magFilter = pa, this.minFilter = pa, this.wrapR = ha, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        class Tl extends wl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                super(e1, t), this.isWebGLArrayRenderTarget = !0, this.depth = n, this.texture = new El(null, e1, t, n), this.texture.isRenderTargetTexture = !0;
            }
        }
        class Sl extends xl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                super(null), this.isData3DTexture = !0, this.image = {
                    data: e1,
                    width: t,
                    height: n,
                    depth: i
                }, this.magFilter = pa, this.minFilter = pa, this.wrapR = ha, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        class Il extends wl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                super(e1, t), this.isWebGL3DRenderTarget = !0, this.depth = n, this.texture = new Sl(null, e1, t, n), this.texture.isRenderTargetTexture = !0;
            }
        }
        class Nl extends wl {
            constructor(){
                let e1 = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}), this.isWebGLMultipleRenderTargets = !0;
                const t = this.texture;
                this.texture = [];
                for(let n = 0; n < e1; n++)this.texture[n] = t.clone(), this.texture[n].isRenderTargetTexture = !0;
            }
            setSize(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                if (this.width !== e1 || this.height !== t || this.depth !== n) {
                    this.width = e1, this.height = t, this.depth = n;
                    for(let i = 0, r = this.texture.length; i < r; i++)this.texture[i].image.width = e1, this.texture[i].image.height = t, this.texture[i].image.depth = n;
                    this.dispose();
                }
                this.viewport.set(0, 0, e1, t), this.scissor.set(0, 0, e1, t);
            }
            copy(e1) {
                this.dispose(), this.width = e1.width, this.height = e1.height, this.depth = e1.depth, this.scissor.copy(e1.scissor), this.scissorTest = e1.scissorTest, this.viewport.copy(e1.viewport), this.depthBuffer = e1.depthBuffer, this.stencilBuffer = e1.stencilBuffer, null !== e1.depthTexture && (this.depthTexture = e1.depthTexture.clone()), this.texture.length = 0;
                for(let t = 0, n = e1.texture.length; t < n; t++)this.texture[t] = e1.texture[t].clone(), this.texture[t].isRenderTargetTexture = !0;
                return this;
            }
        }
        class Dl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                this.isQuaternion = !0, this._x = e1, this._y = t, this._z = n, this._w = i;
            }
            static slerpFlat(e1, t, n, i, r, a, s) {
                let o = n[i + 0], l = n[i + 1], c = n[i + 2], u = n[i + 3];
                const h = r[a + 0], d = r[a + 1], p = r[a + 2], f = r[a + 3];
                if (0 === s) return e1[t + 0] = o, e1[t + 1] = l, e1[t + 2] = c, void (e1[t + 3] = u);
                if (1 === s) return e1[t + 0] = h, e1[t + 1] = d, e1[t + 2] = p, void (e1[t + 3] = f);
                if (u !== f || o !== h || l !== d || c !== p) {
                    let e1 = 1 - s;
                    const t = o * h + l * d + c * p + u * f, n = t >= 0 ? 1 : -1, i = 1 - t * t;
                    if (i > Number.EPSILON) {
                        const r = Math.sqrt(i), a = Math.atan2(r, t * n);
                        e1 = Math.sin(e1 * a) / r, s = Math.sin(s * a) / r;
                    }
                    const r = s * n;
                    if (o = o * e1 + h * r, l = l * e1 + d * r, c = c * e1 + p * r, u = u * e1 + f * r, e1 === 1 - s) {
                        const e1 = 1 / Math.sqrt(o * o + l * l + c * c + u * u);
                        o *= e1, l *= e1, c *= e1, u *= e1;
                    }
                }
                e1[t] = o, e1[t + 1] = l, e1[t + 2] = c, e1[t + 3] = u;
            }
            static multiplyQuaternionsFlat(e1, t, n, i, r, a) {
                const s = n[i], o = n[i + 1], l = n[i + 2], c = n[i + 3], u = r[a], h = r[a + 1], d = r[a + 2], p = r[a + 3];
                return e1[t] = s * p + c * u + o * d - l * h, e1[t + 1] = o * p + c * h + l * u - s * d, e1[t + 2] = l * p + c * d + s * h - o * u, e1[t + 3] = c * p - s * u - o * h - l * d, e1;
            }
            get x() {
                return this._x;
            }
            set x(e1) {
                this._x = e1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(e1) {
                this._y = e1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(e1) {
                this._z = e1, this._onChangeCallback();
            }
            get w() {
                return this._w;
            }
            set w(e1) {
                this._w = e1, this._onChangeCallback();
            }
            set(e1, t, n, i) {
                return this._x = e1, this._y = t, this._z = n, this._w = i, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
            }
            copy(e1) {
                return this._x = e1.x, this._y = e1.y, this._z = e1.z, this._w = e1.w, this._onChangeCallback(), this;
            }
            setFromEuler(e1, t) {
                const n = e1._x, i = e1._y, r = e1._z, a = e1._order, s = Math.cos, o = Math.sin, l = s(n / 2), c = s(i / 2), u = s(r / 2), h = o(n / 2), d = o(i / 2), p = o(r / 2);
                switch(a){
                    case "XYZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "YXZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "ZXY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "ZYX":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "YZX":
                        this._x = h * c * u + l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "XZY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    default:
                        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
                }
                return !1 !== t && this._onChangeCallback(), this;
            }
            setFromAxisAngle(e1, t) {
                const n = t / 2, i = Math.sin(n);
                return this._x = e1.x * i, this._y = e1.y * i, this._z = e1.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
            }
            setFromRotationMatrix(e1) {
                const t = e1.elements, n = t[0], i = t[4], r = t[8], a = t[1], s = t[5], o = t[9], l = t[2], c = t[6], u = t[10], h = n + s + u;
                if (h > 0) {
                    const e1 = .5 / Math.sqrt(h + 1);
                    this._w = .25 / e1, this._x = (c - o) * e1, this._y = (r - l) * e1, this._z = (a - i) * e1;
                } else if (n > s && n > u) {
                    const e1 = 2 * Math.sqrt(1 + n - s - u);
                    this._w = (c - o) / e1, this._x = .25 * e1, this._y = (i + a) / e1, this._z = (r + l) / e1;
                } else if (s > u) {
                    const e1 = 2 * Math.sqrt(1 + s - n - u);
                    this._w = (r - l) / e1, this._x = (i + a) / e1, this._y = .25 * e1, this._z = (o + c) / e1;
                } else {
                    const e1 = 2 * Math.sqrt(1 + u - n - s);
                    this._w = (a - i) / e1, this._x = (r + l) / e1, this._y = (o + c) / e1, this._z = .25 * e1;
                }
                return this._onChangeCallback(), this;
            }
            setFromUnitVectors(e1, t) {
                let n = e1.dot(t) + 1;
                return n < Number.EPSILON ? (n = 0, Math.abs(e1.x) > Math.abs(e1.z) ? (this._x = -e1.y, this._y = e1.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -e1.z, this._z = e1.y, this._w = n)) : (this._x = e1.y * t.z - e1.z * t.y, this._y = e1.z * t.x - e1.x * t.z, this._z = e1.x * t.y - e1.y * t.x, this._w = n), this.normalize();
            }
            angleTo(e1) {
                return 2 * Math.acos(Math.abs(Vo(this.dot(e1), -1, 1)));
            }
            rotateTowards(e1, t) {
                const n = this.angleTo(e1);
                if (0 === n) return this;
                const i = Math.min(1, t / n);
                return this.slerp(e1, i), this;
            }
            identity() {
                return this.set(0, 0, 0, 1);
            }
            invert() {
                return this.conjugate();
            }
            conjugate() {
                return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
            }
            dot(e1) {
                return this._x * e1._x + this._y * e1._y + this._z * e1._z + this._w * e1._w;
            }
            lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            }
            length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            }
            normalize() {
                let e1 = this.length();
                return 0 === e1 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e1 = 1 / e1, this._x = this._x * e1, this._y = this._y * e1, this._z = this._z * e1, this._w = this._w * e1), this._onChangeCallback(), this;
            }
            multiply(e1) {
                return this.multiplyQuaternions(this, e1);
            }
            premultiply(e1) {
                return this.multiplyQuaternions(e1, this);
            }
            multiplyQuaternions(e1, t) {
                const n = e1._x, i = e1._y, r = e1._z, a = e1._w, s = t._x, o = t._y, l = t._z, c = t._w;
                return this._x = n * c + a * s + i * l - r * o, this._y = i * c + a * o + r * s - n * l, this._z = r * c + a * l + n * o - i * s, this._w = a * c - n * s - i * o - r * l, this._onChangeCallback(), this;
            }
            slerp(e1, t) {
                if (0 === t) return this;
                if (1 === t) return this.copy(e1);
                const n = this._x, i = this._y, r = this._z, a = this._w;
                let s = a * e1._w + n * e1._x + i * e1._y + r * e1._z;
                if (s < 0 ? (this._w = -e1._w, this._x = -e1._x, this._y = -e1._y, this._z = -e1._z, s = -s) : this.copy(e1), s >= 1) return this._w = a, this._x = n, this._y = i, this._z = r, this;
                const o = 1 - s * s;
                if (o <= Number.EPSILON) {
                    const e1 = 1 - t;
                    return this._w = e1 * a + t * this._w, this._x = e1 * n + t * this._x, this._y = e1 * i + t * this._y, this._z = e1 * r + t * this._z, this.normalize(), this._onChangeCallback(), this;
                }
                const l = Math.sqrt(o), c = Math.atan2(l, s), u = Math.sin((1 - t) * c) / l, h = Math.sin(t * c) / l;
                return this._w = a * u + this._w * h, this._x = n * u + this._x * h, this._y = i * u + this._y * h, this._z = r * u + this._z * h, this._onChangeCallback(), this;
            }
            slerpQuaternions(e1, t, n) {
                return this.copy(e1).slerp(t, n);
            }
            random() {
                const e1 = Math.random(), t = Math.sqrt(1 - e1), n = Math.sqrt(e1), i = 2 * Math.PI * Math.random(), r = 2 * Math.PI * Math.random();
                return this.set(t * Math.cos(i), n * Math.sin(r), n * Math.cos(r), t * Math.sin(i));
            }
            equals(e1) {
                return e1._x === this._x && e1._y === this._y && e1._z === this._z && e1._w === this._w;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this._x = e1[t], this._y = e1[t + 1], this._z = e1[t + 2], this._w = e1[t + 3], this._onChangeCallback(), this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this._x, e1[t + 1] = this._y, e1[t + 2] = this._z, e1[t + 3] = this._w, e1;
            }
            fromBufferAttribute(e1, t) {
                return this._x = e1.getX(t), this._y = e1.getY(t), this._z = e1.getZ(t), this._w = e1.getW(t), this;
            }
            toJSON() {
                return this.toArray();
            }
            _onChange(e1) {
                return this._onChangeCallback = e1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._w;
            }
        }
        class Cl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                Cl.prototype.isVector3 = !0, this.x = e1, this.y = t, this.z = n;
            }
            set(e1, t, n) {
                return void 0 === n && (n = this.z), this.x = e1, this.y = t, this.z = n, this;
            }
            setScalar(e1) {
                return this.x = e1, this.y = e1, this.z = e1, this;
            }
            setX(e1) {
                return this.x = e1, this;
            }
            setY(e1) {
                return this.y = e1, this;
            }
            setZ(e1) {
                return this.z = e1, this;
            }
            setComponent(e1, t) {
                switch(e1){
                    case 0:
                        this.x = t;
                        break;
                    case 1:
                        this.y = t;
                        break;
                    case 2:
                        this.z = t;
                        break;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
                return this;
            }
            getComponent(e1) {
                switch(e1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z);
            }
            copy(e1) {
                return this.x = e1.x, this.y = e1.y, this.z = e1.z, this;
            }
            add(e1) {
                return this.x += e1.x, this.y += e1.y, this.z += e1.z, this;
            }
            addScalar(e1) {
                return this.x += e1, this.y += e1, this.z += e1, this;
            }
            addVectors(e1, t) {
                return this.x = e1.x + t.x, this.y = e1.y + t.y, this.z = e1.z + t.z, this;
            }
            addScaledVector(e1, t) {
                return this.x += e1.x * t, this.y += e1.y * t, this.z += e1.z * t, this;
            }
            sub(e1) {
                return this.x -= e1.x, this.y -= e1.y, this.z -= e1.z, this;
            }
            subScalar(e1) {
                return this.x -= e1, this.y -= e1, this.z -= e1, this;
            }
            subVectors(e1, t) {
                return this.x = e1.x - t.x, this.y = e1.y - t.y, this.z = e1.z - t.z, this;
            }
            multiply(e1) {
                return this.x *= e1.x, this.y *= e1.y, this.z *= e1.z, this;
            }
            multiplyScalar(e1) {
                return this.x *= e1, this.y *= e1, this.z *= e1, this;
            }
            multiplyVectors(e1, t) {
                return this.x = e1.x * t.x, this.y = e1.y * t.y, this.z = e1.z * t.z, this;
            }
            applyEuler(e1) {
                return this.applyQuaternion(Rl.setFromEuler(e1));
            }
            applyAxisAngle(e1, t) {
                return this.applyQuaternion(Rl.setFromAxisAngle(e1, t));
            }
            applyMatrix3(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.elements;
                return this.x = r[0] * t + r[3] * n + r[6] * i, this.y = r[1] * t + r[4] * n + r[7] * i, this.z = r[2] * t + r[5] * n + r[8] * i, this;
            }
            applyNormalMatrix(e1) {
                return this.applyMatrix3(e1).normalize();
            }
            applyMatrix4(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.elements, a = 1 / (r[3] * t + r[7] * n + r[11] * i + r[15]);
                return this.x = (r[0] * t + r[4] * n + r[8] * i + r[12]) * a, this.y = (r[1] * t + r[5] * n + r[9] * i + r[13]) * a, this.z = (r[2] * t + r[6] * n + r[10] * i + r[14]) * a, this;
            }
            applyQuaternion(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.x, a = e1.y, s = e1.z, o = e1.w, l = 2 * (a * i - s * n), c = 2 * (s * t - r * i), u = 2 * (r * n - a * t);
                return this.x = t + o * l + a * u - s * c, this.y = n + o * c + s * l - r * u, this.z = i + o * u + r * c - a * l, this;
            }
            project(e1) {
                return this.applyMatrix4(e1.matrixWorldInverse).applyMatrix4(e1.projectionMatrix);
            }
            unproject(e1) {
                return this.applyMatrix4(e1.projectionMatrixInverse).applyMatrix4(e1.matrixWorld);
            }
            transformDirection(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.elements;
                return this.x = r[0] * t + r[4] * n + r[8] * i, this.y = r[1] * t + r[5] * n + r[9] * i, this.z = r[2] * t + r[6] * n + r[10] * i, this.normalize();
            }
            divide(e1) {
                return this.x /= e1.x, this.y /= e1.y, this.z /= e1.z, this;
            }
            divideScalar(e1) {
                return this.multiplyScalar(1 / e1);
            }
            min(e1) {
                return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this.z = Math.min(this.z, e1.z), this;
            }
            max(e1) {
                return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this.z = Math.max(this.z, e1.z), this;
            }
            clamp(e1, t) {
                return this.x = Math.max(e1.x, Math.min(t.x, this.x)), this.y = Math.max(e1.y, Math.min(t.y, this.y)), this.z = Math.max(e1.z, Math.min(t.z, this.z)), this;
            }
            clampScalar(e1, t) {
                return this.x = Math.max(e1, Math.min(t, this.x)), this.y = Math.max(e1, Math.min(t, this.y)), this.z = Math.max(e1, Math.min(t, this.z)), this;
            }
            clampLength(e1, t) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(e1, Math.min(t, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
            }
            dot(e1) {
                return this.x * e1.x + this.y * e1.y + this.z * e1.z;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(e1) {
                return this.normalize().multiplyScalar(e1);
            }
            lerp(e1, t) {
                return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this.z += (e1.z - this.z) * t, this;
            }
            lerpVectors(e1, t, n) {
                return this.x = e1.x + (t.x - e1.x) * n, this.y = e1.y + (t.y - e1.y) * n, this.z = e1.z + (t.z - e1.z) * n, this;
            }
            cross(e1) {
                return this.crossVectors(this, e1);
            }
            crossVectors(e1, t) {
                const n = e1.x, i = e1.y, r = e1.z, a = t.x, s = t.y, o = t.z;
                return this.x = i * o - r * s, this.y = r * a - n * o, this.z = n * s - i * a, this;
            }
            projectOnVector(e1) {
                const t = e1.lengthSq();
                if (0 === t) return this.set(0, 0, 0);
                const n = e1.dot(this) / t;
                return this.copy(e1).multiplyScalar(n);
            }
            projectOnPlane(e1) {
                return Ll.copy(this).projectOnVector(e1), this.sub(Ll);
            }
            reflect(e1) {
                return this.sub(Ll.copy(e1).multiplyScalar(2 * this.dot(e1)));
            }
            angleTo(e1) {
                const t = Math.sqrt(this.lengthSq() * e1.lengthSq());
                if (0 === t) return Math.PI / 2;
                const n = this.dot(e1) / t;
                return Math.acos(Vo(n, -1, 1));
            }
            distanceTo(e1) {
                return Math.sqrt(this.distanceToSquared(e1));
            }
            distanceToSquared(e1) {
                const t = this.x - e1.x, n = this.y - e1.y, i = this.z - e1.z;
                return t * t + n * n + i * i;
            }
            manhattanDistanceTo(e1) {
                return Math.abs(this.x - e1.x) + Math.abs(this.y - e1.y) + Math.abs(this.z - e1.z);
            }
            setFromSpherical(e1) {
                return this.setFromSphericalCoords(e1.radius, e1.phi, e1.theta);
            }
            setFromSphericalCoords(e1, t, n) {
                const i = Math.sin(t) * e1;
                return this.x = i * Math.sin(n), this.y = Math.cos(t) * e1, this.z = i * Math.cos(n), this;
            }
            setFromCylindrical(e1) {
                return this.setFromCylindricalCoords(e1.radius, e1.theta, e1.y);
            }
            setFromCylindricalCoords(e1, t, n) {
                return this.x = e1 * Math.sin(t), this.y = n, this.z = e1 * Math.cos(t), this;
            }
            setFromMatrixPosition(e1) {
                const t = e1.elements;
                return this.x = t[12], this.y = t[13], this.z = t[14], this;
            }
            setFromMatrixScale(e1) {
                const t = this.setFromMatrixColumn(e1, 0).length(), n = this.setFromMatrixColumn(e1, 1).length(), i = this.setFromMatrixColumn(e1, 2).length();
                return this.x = t, this.y = n, this.z = i, this;
            }
            setFromMatrixColumn(e1, t) {
                return this.fromArray(e1.elements, 4 * t);
            }
            setFromMatrix3Column(e1, t) {
                return this.fromArray(e1.elements, 3 * t);
            }
            setFromEuler(e1) {
                return this.x = e1._x, this.y = e1._y, this.z = e1._z, this;
            }
            setFromColor(e1) {
                return this.x = e1.r, this.y = e1.g, this.z = e1.b, this;
            }
            equals(e1) {
                return e1.x === this.x && e1.y === this.y && e1.z === this.z;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.x = e1[t], this.y = e1[t + 1], this.z = e1[t + 2], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.x, e1[t + 1] = this.y, e1[t + 2] = this.z, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.x = e1.getX(t), this.y = e1.getY(t), this.z = e1.getZ(t), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
            }
            randomDirection() {
                const e1 = 2 * (Math.random() - .5), t = Math.random() * Math.PI * 2, n = Math.sqrt(1 - e1 ** 2);
                return this.x = n * Math.cos(t), this.y = n * Math.sin(t), this.z = e1, this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z;
            }
        }
        const Ll = new Cl, Rl = new Dl;
        class zl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Cl(1 / 0, 1 / 0, 1 / 0), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl(-1 / 0, -1 / 0, -1 / 0);
                this.isBox3 = !0, this.min = e1, this.max = t;
            }
            set(e1, t) {
                return this.min.copy(e1), this.max.copy(t), this;
            }
            setFromArray(e1) {
                this.makeEmpty();
                for(let t = 0, n = e1.length; t < n; t += 3)this.expandByPoint(Pl.fromArray(e1, t));
                return this;
            }
            setFromBufferAttribute(e1) {
                this.makeEmpty();
                for(let t = 0, n = e1.count; t < n; t++)this.expandByPoint(Pl.fromBufferAttribute(e1, t));
                return this;
            }
            setFromPoints(e1) {
                this.makeEmpty();
                for(let t = 0, n = e1.length; t < n; t++)this.expandByPoint(e1[t]);
                return this;
            }
            setFromCenterAndSize(e1, t) {
                const n = Pl.copy(t).multiplyScalar(.5);
                return this.min.copy(e1).sub(n), this.max.copy(e1).add(n), this;
            }
            setFromObject(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.makeEmpty(), this.expandByObject(e1, t);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                return this.min.copy(e1.min), this.max.copy(e1.max), this;
            }
            makeEmpty() {
                return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
            }
            isEmpty() {
                return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
            }
            getCenter(e1) {
                return this.isEmpty() ? e1.set(0, 0, 0) : e1.addVectors(this.min, this.max).multiplyScalar(.5);
            }
            getSize(e1) {
                return this.isEmpty() ? e1.set(0, 0, 0) : e1.subVectors(this.max, this.min);
            }
            expandByPoint(e1) {
                return this.min.min(e1), this.max.max(e1), this;
            }
            expandByVector(e1) {
                return this.min.sub(e1), this.max.add(e1), this;
            }
            expandByScalar(e1) {
                return this.min.addScalar(-e1), this.max.addScalar(e1), this;
            }
            expandByObject(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                e1.updateWorldMatrix(!1, !1);
                const n = e1.geometry;
                if (void 0 !== n) {
                    const i = n.getAttribute("position");
                    if (!0 === t && void 0 !== i && !0 !== e1.isInstancedMesh) for(let t = 0, n = i.count; t < n; t++)!0 === e1.isMesh ? e1.getVertexPosition(t, Pl) : Pl.fromBufferAttribute(i, t), Pl.applyMatrix4(e1.matrixWorld), this.expandByPoint(Pl);
                    else void 0 !== e1.boundingBox ? (null === e1.boundingBox && e1.computeBoundingBox(), Ul.copy(e1.boundingBox)) : (null === n.boundingBox && n.computeBoundingBox(), Ul.copy(n.boundingBox)), Ul.applyMatrix4(e1.matrixWorld), this.union(Ul);
                }
                const i = e1.children;
                for(let e1 = 0, n = i.length; e1 < n; e1++)this.expandByObject(i[e1], t);
                return this;
            }
            containsPoint(e1) {
                return !(e1.x < this.min.x || e1.x > this.max.x || e1.y < this.min.y || e1.y > this.max.y || e1.z < this.min.z || e1.z > this.max.z);
            }
            containsBox(e1) {
                return this.min.x <= e1.min.x && e1.max.x <= this.max.x && this.min.y <= e1.min.y && e1.max.y <= this.max.y && this.min.z <= e1.min.z && e1.max.z <= this.max.z;
            }
            getParameter(e1, t) {
                return t.set((e1.x - this.min.x) / (this.max.x - this.min.x), (e1.y - this.min.y) / (this.max.y - this.min.y), (e1.z - this.min.z) / (this.max.z - this.min.z));
            }
            intersectsBox(e1) {
                return !(e1.max.x < this.min.x || e1.min.x > this.max.x || e1.max.y < this.min.y || e1.min.y > this.max.y || e1.max.z < this.min.z || e1.min.z > this.max.z);
            }
            intersectsSphere(e1) {
                return this.clampPoint(e1.center, Pl), Pl.distanceToSquared(e1.center) <= e1.radius * e1.radius;
            }
            intersectsPlane(e1) {
                let t, n;
                return e1.normal.x > 0 ? (t = e1.normal.x * this.min.x, n = e1.normal.x * this.max.x) : (t = e1.normal.x * this.max.x, n = e1.normal.x * this.min.x), e1.normal.y > 0 ? (t += e1.normal.y * this.min.y, n += e1.normal.y * this.max.y) : (t += e1.normal.y * this.max.y, n += e1.normal.y * this.min.y), e1.normal.z > 0 ? (t += e1.normal.z * this.min.z, n += e1.normal.z * this.max.z) : (t += e1.normal.z * this.max.z, n += e1.normal.z * this.min.z), t <= -e1.constant && n >= -e1.constant;
            }
            intersectsTriangle(e1) {
                if (this.isEmpty()) return !1;
                this.getCenter(Gl), Ql.subVectors(this.max, Gl), kl.subVectors(e1.a, Gl), jl.subVectors(e1.b, Gl), Bl.subVectors(e1.c, Gl), Fl.subVectors(jl, kl), Hl.subVectors(Bl, jl), Vl.subVectors(kl, Bl);
                let t = [
                    0,
                    -Fl.z,
                    Fl.y,
                    0,
                    -Hl.z,
                    Hl.y,
                    0,
                    -Vl.z,
                    Vl.y,
                    Fl.z,
                    0,
                    -Fl.x,
                    Hl.z,
                    0,
                    -Hl.x,
                    Vl.z,
                    0,
                    -Vl.x,
                    -Fl.y,
                    Fl.x,
                    0,
                    -Hl.y,
                    Hl.x,
                    0,
                    -Vl.y,
                    Vl.x,
                    0
                ];
                return !!Xl(t, kl, jl, Bl, Ql) && (t = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], !!Xl(t, kl, jl, Bl, Ql) && (Wl.crossVectors(Fl, Hl), t = [
                    Wl.x,
                    Wl.y,
                    Wl.z
                ], Xl(t, kl, jl, Bl, Ql)));
            }
            clampPoint(e1, t) {
                return t.copy(e1).clamp(this.min, this.max);
            }
            distanceToPoint(e1) {
                return this.clampPoint(e1, Pl).distanceTo(e1);
            }
            getBoundingSphere(e1) {
                return this.isEmpty() ? e1.makeEmpty() : (this.getCenter(e1.center), e1.radius = .5 * this.getSize(Pl).length()), e1;
            }
            intersect(e1) {
                return this.min.max(e1.min), this.max.min(e1.max), this.isEmpty() && this.makeEmpty(), this;
            }
            union(e1) {
                return this.min.min(e1.min), this.max.max(e1.max), this;
            }
            applyMatrix4(e1) {
                return this.isEmpty() || (Ol[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e1), Ol[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e1), Ol[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e1), Ol[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e1), Ol[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e1), Ol[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e1), Ol[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e1), Ol[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e1), this.setFromPoints(Ol)), this;
            }
            translate(e1) {
                return this.min.add(e1), this.max.add(e1), this;
            }
            equals(e1) {
                return e1.min.equals(this.min) && e1.max.equals(this.max);
            }
        }
        const Ol = [
            new Cl,
            new Cl,
            new Cl,
            new Cl,
            new Cl,
            new Cl,
            new Cl,
            new Cl
        ], Pl = new Cl, Ul = new zl, kl = new Cl, jl = new Cl, Bl = new Cl, Fl = new Cl, Hl = new Cl, Vl = new Cl, Gl = new Cl, Ql = new Cl, Wl = new Cl, Yl = new Cl;
        function Xl(e1, t, n, i, r) {
            for(let a = 0, s = e1.length - 3; a <= s; a += 3){
                Yl.fromArray(e1, a);
                const s = r.x * Math.abs(Yl.x) + r.y * Math.abs(Yl.y) + r.z * Math.abs(Yl.z), o = t.dot(Yl), l = n.dot(Yl), c = i.dot(Yl);
                if (Math.max(-Math.max(o, l, c), Math.min(o, l, c)) > s) return !1;
            }
            return !0;
        }
        const Zl = new zl, ql = new Cl, Kl = new Cl;
        class Jl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Cl, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
                this.center = e1, this.radius = t;
            }
            set(e1, t) {
                return this.center.copy(e1), this.radius = t, this;
            }
            setFromPoints(e1, t) {
                const n = this.center;
                void 0 !== t ? n.copy(t) : Zl.setFromPoints(e1).getCenter(n);
                let i = 0;
                for(let t = 0, r = e1.length; t < r; t++)i = Math.max(i, n.distanceToSquared(e1[t]));
                return this.radius = Math.sqrt(i), this;
            }
            copy(e1) {
                return this.center.copy(e1.center), this.radius = e1.radius, this;
            }
            isEmpty() {
                return this.radius < 0;
            }
            makeEmpty() {
                return this.center.set(0, 0, 0), this.radius = -1, this;
            }
            containsPoint(e1) {
                return e1.distanceToSquared(this.center) <= this.radius * this.radius;
            }
            distanceToPoint(e1) {
                return e1.distanceTo(this.center) - this.radius;
            }
            intersectsSphere(e1) {
                const t = this.radius + e1.radius;
                return e1.center.distanceToSquared(this.center) <= t * t;
            }
            intersectsBox(e1) {
                return e1.intersectsSphere(this);
            }
            intersectsPlane(e1) {
                return Math.abs(e1.distanceToPoint(this.center)) <= this.radius;
            }
            clampPoint(e1, t) {
                const n = this.center.distanceToSquared(e1);
                return t.copy(e1), n > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
            }
            getBoundingBox(e1) {
                return this.isEmpty() ? (e1.makeEmpty(), e1) : (e1.set(this.center, this.center), e1.expandByScalar(this.radius), e1);
            }
            applyMatrix4(e1) {
                return this.center.applyMatrix4(e1), this.radius = this.radius * e1.getMaxScaleOnAxis(), this;
            }
            translate(e1) {
                return this.center.add(e1), this;
            }
            expandByPoint(e1) {
                if (this.isEmpty()) return this.center.copy(e1), this.radius = 0, this;
                ql.subVectors(e1, this.center);
                const t = ql.lengthSq();
                if (t > this.radius * this.radius) {
                    const e1 = Math.sqrt(t), n = .5 * (e1 - this.radius);
                    this.center.addScaledVector(ql, n / e1), this.radius += n;
                }
                return this;
            }
            union(e1) {
                return e1.isEmpty() ? this : this.isEmpty() ? (this.copy(e1), this) : (!0 === this.center.equals(e1.center) ? this.radius = Math.max(this.radius, e1.radius) : (Kl.subVectors(e1.center, this.center).setLength(e1.radius), this.expandByPoint(ql.copy(e1.center).add(Kl)), this.expandByPoint(ql.copy(e1.center).sub(Kl))), this);
            }
            equals(e1) {
                return e1.center.equals(this.center) && e1.radius === this.radius;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const $l = new Cl, ec = new Cl, tc = new Cl, nc = new Cl, ic = new Cl, rc = new Cl, ac = new Cl;
        class sc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Cl, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl(0, 0, -1);
                this.origin = e1, this.direction = t;
            }
            set(e1, t) {
                return this.origin.copy(e1), this.direction.copy(t), this;
            }
            copy(e1) {
                return this.origin.copy(e1.origin), this.direction.copy(e1.direction), this;
            }
            at(e1, t) {
                return t.copy(this.origin).addScaledVector(this.direction, e1);
            }
            lookAt(e1) {
                return this.direction.copy(e1).sub(this.origin).normalize(), this;
            }
            recast(e1) {
                return this.origin.copy(this.at(e1, $l)), this;
            }
            closestPointToPoint(e1, t) {
                t.subVectors(e1, this.origin);
                const n = t.dot(this.direction);
                return n < 0 ? t.copy(this.origin) : t.copy(this.origin).addScaledVector(this.direction, n);
            }
            distanceToPoint(e1) {
                return Math.sqrt(this.distanceSqToPoint(e1));
            }
            distanceSqToPoint(e1) {
                const t = $l.subVectors(e1, this.origin).dot(this.direction);
                return t < 0 ? this.origin.distanceToSquared(e1) : ($l.copy(this.origin).addScaledVector(this.direction, t), $l.distanceToSquared(e1));
            }
            distanceSqToSegment(e1, t, n, i) {
                ec.copy(e1).add(t).multiplyScalar(.5), tc.copy(t).sub(e1).normalize(), nc.copy(this.origin).sub(ec);
                const r = .5 * e1.distanceTo(t), a = -this.direction.dot(tc), s = nc.dot(this.direction), o = -nc.dot(tc), l = nc.lengthSq(), c = Math.abs(1 - a * a);
                let u, h, d, p;
                if (c > 0) {
                    if (u = a * o - s, h = a * s - o, p = r * c, u >= 0) {
                        if (h >= -p) {
                            if (h <= p) {
                                const e1 = 1 / c;
                                u *= e1, h *= e1, d = u * (u + a * h + 2 * s) + h * (a * u + h + 2 * o) + l;
                            } else h = r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                        } else h = -r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                    } else h <= -p ? (u = Math.max(0, -(-a * r + s)), h = u > 0 ? -r : Math.min(Math.max(-r, -o), r), d = -u * u + h * (h + 2 * o) + l) : h <= p ? (u = 0, h = Math.min(Math.max(-r, -o), r), d = h * (h + 2 * o) + l) : (u = Math.max(0, -(a * r + s)), h = u > 0 ? r : Math.min(Math.max(-r, -o), r), d = -u * u + h * (h + 2 * o) + l);
                } else h = a > 0 ? -r : r, u = Math.max(0, -(a * h + s)), d = -u * u + h * (h + 2 * o) + l;
                return n && n.copy(this.origin).addScaledVector(this.direction, u), i && i.copy(ec).addScaledVector(tc, h), d;
            }
            intersectSphere(e1, t) {
                $l.subVectors(e1.center, this.origin);
                const n = $l.dot(this.direction), i = $l.dot($l) - n * n, r = e1.radius * e1.radius;
                if (i > r) return null;
                const a = Math.sqrt(r - i), s = n - a, o = n + a;
                return o < 0 ? null : s < 0 ? this.at(o, t) : this.at(s, t);
            }
            intersectsSphere(e1) {
                return this.distanceSqToPoint(e1.center) <= e1.radius * e1.radius;
            }
            distanceToPlane(e1) {
                const t = e1.normal.dot(this.direction);
                if (0 === t) return 0 === e1.distanceToPoint(this.origin) ? 0 : null;
                const n = -(this.origin.dot(e1.normal) + e1.constant) / t;
                return n >= 0 ? n : null;
            }
            intersectPlane(e1, t) {
                const n = this.distanceToPlane(e1);
                return null === n ? null : this.at(n, t);
            }
            intersectsPlane(e1) {
                const t = e1.distanceToPoint(this.origin);
                return 0 === t || e1.normal.dot(this.direction) * t < 0;
            }
            intersectBox(e1, t) {
                let n, i, r, a, s, o;
                const l = 1 / this.direction.x, c = 1 / this.direction.y, u = 1 / this.direction.z, h = this.origin;
                return l >= 0 ? (n = (e1.min.x - h.x) * l, i = (e1.max.x - h.x) * l) : (n = (e1.max.x - h.x) * l, i = (e1.min.x - h.x) * l), c >= 0 ? (r = (e1.min.y - h.y) * c, a = (e1.max.y - h.y) * c) : (r = (e1.max.y - h.y) * c, a = (e1.min.y - h.y) * c), n > a || r > i ? null : ((r > n || isNaN(n)) && (n = r), (a < i || isNaN(i)) && (i = a), u >= 0 ? (s = (e1.min.z - h.z) * u, o = (e1.max.z - h.z) * u) : (s = (e1.max.z - h.z) * u, o = (e1.min.z - h.z) * u), n > o || s > i ? null : ((s > n || n != n) && (n = s), (o < i || i != i) && (i = o), i < 0 ? null : this.at(n >= 0 ? n : i, t)));
            }
            intersectsBox(e1) {
                return null !== this.intersectBox(e1, $l);
            }
            intersectTriangle(e1, t, n, i, r) {
                ic.subVectors(t, e1), rc.subVectors(n, e1), ac.crossVectors(ic, rc);
                let a, s = this.direction.dot(ac);
                if (s > 0) {
                    if (i) return null;
                    a = 1;
                } else {
                    if (!(s < 0)) return null;
                    a = -1, s = -s;
                }
                nc.subVectors(this.origin, e1);
                const o = a * this.direction.dot(rc.crossVectors(nc, rc));
                if (o < 0) return null;
                const l = a * this.direction.dot(ic.cross(nc));
                if (l < 0) return null;
                if (o + l > s) return null;
                const c = -a * nc.dot(ac);
                return c < 0 ? null : this.at(c / s, r);
            }
            applyMatrix4(e1) {
                return this.origin.applyMatrix4(e1), this.direction.transformDirection(e1), this;
            }
            equals(e1) {
                return e1.origin.equals(this.origin) && e1.direction.equals(this.direction);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class oc {
            constructor(e1, t, n, i, r, a, s, o, l, c, u, h, d, p, f, m){
                oc.prototype.isMatrix4 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== e1 && this.set(e1, t, n, i, r, a, s, o, l, c, u, h, d, p, f, m);
            }
            set(e1, t, n, i, r, a, s, o, l, c, u, h, d, p, f, m) {
                const g = this.elements;
                return g[0] = e1, g[4] = t, g[8] = n, g[12] = i, g[1] = r, g[5] = a, g[9] = s, g[13] = o, g[2] = l, g[6] = c, g[10] = u, g[14] = h, g[3] = d, g[7] = p, g[11] = f, g[15] = m, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            clone() {
                return (new oc).fromArray(this.elements);
            }
            copy(e1) {
                const t = this.elements, n = e1.elements;
                return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], t[9] = n[9], t[10] = n[10], t[11] = n[11], t[12] = n[12], t[13] = n[13], t[14] = n[14], t[15] = n[15], this;
            }
            copyPosition(e1) {
                const t = this.elements, n = e1.elements;
                return t[12] = n[12], t[13] = n[13], t[14] = n[14], this;
            }
            setFromMatrix3(e1) {
                const t = e1.elements;
                return this.set(t[0], t[3], t[6], 0, t[1], t[4], t[7], 0, t[2], t[5], t[8], 0, 0, 0, 0, 1), this;
            }
            extractBasis(e1, t, n) {
                return e1.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
            }
            makeBasis(e1, t, n) {
                return this.set(e1.x, t.x, n.x, 0, e1.y, t.y, n.y, 0, e1.z, t.z, n.z, 0, 0, 0, 0, 1), this;
            }
            extractRotation(e1) {
                const t = this.elements, n = e1.elements, i = 1 / lc.setFromMatrixColumn(e1, 0).length(), r = 1 / lc.setFromMatrixColumn(e1, 1).length(), a = 1 / lc.setFromMatrixColumn(e1, 2).length();
                return t[0] = n[0] * i, t[1] = n[1] * i, t[2] = n[2] * i, t[3] = 0, t[4] = n[4] * r, t[5] = n[5] * r, t[6] = n[6] * r, t[7] = 0, t[8] = n[8] * a, t[9] = n[9] * a, t[10] = n[10] * a, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
            }
            makeRotationFromEuler(e1) {
                const t = this.elements, n = e1.x, i = e1.y, r = e1.z, a = Math.cos(n), s = Math.sin(n), o = Math.cos(i), l = Math.sin(i), c = Math.cos(r), u = Math.sin(r);
                if ("XYZ" === e1.order) {
                    const e1 = a * c, n = a * u, i = s * c, r = s * u;
                    t[0] = o * c, t[4] = -o * u, t[8] = l, t[1] = n + i * l, t[5] = e1 - r * l, t[9] = -s * o, t[2] = r - e1 * l, t[6] = i + n * l, t[10] = a * o;
                } else if ("YXZ" === e1.order) {
                    const e1 = o * c, n = o * u, i = l * c, r = l * u;
                    t[0] = e1 + r * s, t[4] = i * s - n, t[8] = a * l, t[1] = a * u, t[5] = a * c, t[9] = -s, t[2] = n * s - i, t[6] = r + e1 * s, t[10] = a * o;
                } else if ("ZXY" === e1.order) {
                    const e1 = o * c, n = o * u, i = l * c, r = l * u;
                    t[0] = e1 - r * s, t[4] = -a * u, t[8] = i + n * s, t[1] = n + i * s, t[5] = a * c, t[9] = r - e1 * s, t[2] = -a * l, t[6] = s, t[10] = a * o;
                } else if ("ZYX" === e1.order) {
                    const e1 = a * c, n = a * u, i = s * c, r = s * u;
                    t[0] = o * c, t[4] = i * l - n, t[8] = e1 * l + r, t[1] = o * u, t[5] = r * l + e1, t[9] = n * l - i, t[2] = -l, t[6] = s * o, t[10] = a * o;
                } else if ("YZX" === e1.order) {
                    const e1 = a * o, n = a * l, i = s * o, r = s * l;
                    t[0] = o * c, t[4] = r - e1 * u, t[8] = i * u + n, t[1] = u, t[5] = a * c, t[9] = -s * c, t[2] = -l * c, t[6] = n * u + i, t[10] = e1 - r * u;
                } else if ("XZY" === e1.order) {
                    const e1 = a * o, n = a * l, i = s * o, r = s * l;
                    t[0] = o * c, t[4] = -u, t[8] = l * c, t[1] = e1 * u + r, t[5] = a * c, t[9] = n * u - i, t[2] = i * u - n, t[6] = s * c, t[10] = r * u + e1;
                }
                return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
            }
            makeRotationFromQuaternion(e1) {
                return this.compose(uc, e1, hc);
            }
            lookAt(e1, t, n) {
                const i = this.elements;
                return fc.subVectors(e1, t), 0 === fc.lengthSq() && (fc.z = 1), fc.normalize(), dc.crossVectors(n, fc), 0 === dc.lengthSq() && (1 === Math.abs(n.z) ? fc.x += 1e-4 : fc.z += 1e-4, fc.normalize(), dc.crossVectors(n, fc)), dc.normalize(), pc.crossVectors(fc, dc), i[0] = dc.x, i[4] = pc.x, i[8] = fc.x, i[1] = dc.y, i[5] = pc.y, i[9] = fc.y, i[2] = dc.z, i[6] = pc.z, i[10] = fc.z, this;
            }
            multiply(e1) {
                return this.multiplyMatrices(this, e1);
            }
            premultiply(e1) {
                return this.multiplyMatrices(e1, this);
            }
            multiplyMatrices(e1, t) {
                const n = e1.elements, i = t.elements, r = this.elements, a = n[0], s = n[4], o = n[8], l = n[12], c = n[1], u = n[5], h = n[9], d = n[13], p = n[2], f = n[6], m = n[10], g = n[14], A = n[3], v = n[7], M = n[11], y = n[15], x = i[0], _ = i[4], b = i[8], w = i[12], E = i[1], T = i[5], S = i[9], I = i[13], N = i[2], D = i[6], C = i[10], L = i[14], R = i[3], z = i[7], O = i[11], P = i[15];
                return r[0] = a * x + s * E + o * N + l * R, r[4] = a * _ + s * T + o * D + l * z, r[8] = a * b + s * S + o * C + l * O, r[12] = a * w + s * I + o * L + l * P, r[1] = c * x + u * E + h * N + d * R, r[5] = c * _ + u * T + h * D + d * z, r[9] = c * b + u * S + h * C + d * O, r[13] = c * w + u * I + h * L + d * P, r[2] = p * x + f * E + m * N + g * R, r[6] = p * _ + f * T + m * D + g * z, r[10] = p * b + f * S + m * C + g * O, r[14] = p * w + f * I + m * L + g * P, r[3] = A * x + v * E + M * N + y * R, r[7] = A * _ + v * T + M * D + y * z, r[11] = A * b + v * S + M * C + y * O, r[15] = A * w + v * I + M * L + y * P, this;
            }
            multiplyScalar(e1) {
                const t = this.elements;
                return t[0] *= e1, t[4] *= e1, t[8] *= e1, t[12] *= e1, t[1] *= e1, t[5] *= e1, t[9] *= e1, t[13] *= e1, t[2] *= e1, t[6] *= e1, t[10] *= e1, t[14] *= e1, t[3] *= e1, t[7] *= e1, t[11] *= e1, t[15] *= e1, this;
            }
            determinant() {
                const e1 = this.elements, t = e1[0], n = e1[4], i = e1[8], r = e1[12], a = e1[1], s = e1[5], o = e1[9], l = e1[13], c = e1[2], u = e1[6], h = e1[10], d = e1[14];
                return e1[3] * (+r * o * u - i * l * u - r * s * h + n * l * h + i * s * d - n * o * d) + e1[7] * (+t * o * d - t * l * h + r * a * h - i * a * d + i * l * c - r * o * c) + e1[11] * (+t * l * u - t * s * d - r * a * u + n * a * d + r * s * c - n * l * c) + e1[15] * (-i * s * c - t * o * u + t * s * h + i * a * u - n * a * h + n * o * c);
            }
            transpose() {
                const e1 = this.elements;
                let t;
                return t = e1[1], e1[1] = e1[4], e1[4] = t, t = e1[2], e1[2] = e1[8], e1[8] = t, t = e1[6], e1[6] = e1[9], e1[9] = t, t = e1[3], e1[3] = e1[12], e1[12] = t, t = e1[7], e1[7] = e1[13], e1[13] = t, t = e1[11], e1[11] = e1[14], e1[14] = t, this;
            }
            setPosition(e1, t, n) {
                const i = this.elements;
                return e1.isVector3 ? (i[12] = e1.x, i[13] = e1.y, i[14] = e1.z) : (i[12] = e1, i[13] = t, i[14] = n), this;
            }
            invert() {
                const e1 = this.elements, t = e1[0], n = e1[1], i = e1[2], r = e1[3], a = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8], u = e1[9], h = e1[10], d = e1[11], p = e1[12], f = e1[13], m = e1[14], g = e1[15], A = u * m * l - f * h * l + f * o * d - s * m * d - u * o * g + s * h * g, v = p * h * l - c * m * l - p * o * d + a * m * d + c * o * g - a * h * g, M = c * f * l - p * u * l + p * s * d - a * f * d - c * s * g + a * u * g, y = p * u * o - c * f * o - p * s * h + a * f * h + c * s * m - a * u * m, x = t * A + n * v + i * M + r * y;
                if (0 === x) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                const _ = 1 / x;
                return e1[0] = A * _, e1[1] = (f * h * r - u * m * r - f * i * d + n * m * d + u * i * g - n * h * g) * _, e1[2] = (s * m * r - f * o * r + f * i * l - n * m * l - s * i * g + n * o * g) * _, e1[3] = (u * o * r - s * h * r - u * i * l + n * h * l + s * i * d - n * o * d) * _, e1[4] = v * _, e1[5] = (c * m * r - p * h * r + p * i * d - t * m * d - c * i * g + t * h * g) * _, e1[6] = (p * o * r - a * m * r - p * i * l + t * m * l + a * i * g - t * o * g) * _, e1[7] = (a * h * r - c * o * r + c * i * l - t * h * l - a * i * d + t * o * d) * _, e1[8] = M * _, e1[9] = (p * u * r - c * f * r - p * n * d + t * f * d + c * n * g - t * u * g) * _, e1[10] = (a * f * r - p * s * r + p * n * l - t * f * l - a * n * g + t * s * g) * _, e1[11] = (c * s * r - a * u * r - c * n * l + t * u * l + a * n * d - t * s * d) * _, e1[12] = y * _, e1[13] = (c * f * i - p * u * i + p * n * h - t * f * h - c * n * m + t * u * m) * _, e1[14] = (p * s * i - a * f * i - p * n * o + t * f * o + a * n * m - t * s * m) * _, e1[15] = (a * u * i - c * s * i + c * n * o - t * u * o - a * n * h + t * s * h) * _, this;
            }
            scale(e1) {
                const t = this.elements, n = e1.x, i = e1.y, r = e1.z;
                return t[0] *= n, t[4] *= i, t[8] *= r, t[1] *= n, t[5] *= i, t[9] *= r, t[2] *= n, t[6] *= i, t[10] *= r, t[3] *= n, t[7] *= i, t[11] *= r, this;
            }
            getMaxScaleOnAxis() {
                const e1 = this.elements, t = e1[0] * e1[0] + e1[1] * e1[1] + e1[2] * e1[2], n = e1[4] * e1[4] + e1[5] * e1[5] + e1[6] * e1[6], i = e1[8] * e1[8] + e1[9] * e1[9] + e1[10] * e1[10];
                return Math.sqrt(Math.max(t, n, i));
            }
            makeTranslation(e1, t, n) {
                return e1.isVector3 ? this.set(1, 0, 0, e1.x, 0, 1, 0, e1.y, 0, 0, 1, e1.z, 0, 0, 0, 1) : this.set(1, 0, 0, e1, 0, 1, 0, t, 0, 0, 1, n, 0, 0, 0, 1), this;
            }
            makeRotationX(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1), this;
            }
            makeRotationY(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1), this;
            }
            makeRotationZ(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            makeRotationAxis(e1, t) {
                const n = Math.cos(t), i = Math.sin(t), r = 1 - n, a = e1.x, s = e1.y, o = e1.z, l = r * a, c = r * s;
                return this.set(l * a + n, l * s - i * o, l * o + i * s, 0, l * s + i * o, c * s + n, c * o - i * a, 0, l * o - i * s, c * o + i * a, r * o * o + n, 0, 0, 0, 0, 1), this;
            }
            makeScale(e1, t, n) {
                return this.set(e1, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
            }
            makeShear(e1, t, n, i, r, a) {
                return this.set(1, n, r, 0, e1, 1, a, 0, t, i, 1, 0, 0, 0, 0, 1), this;
            }
            compose(e1, t, n) {
                const i = this.elements, r = t._x, a = t._y, s = t._z, o = t._w, l = r + r, c = a + a, u = s + s, h = r * l, d = r * c, p = r * u, f = a * c, m = a * u, g = s * u, A = o * l, v = o * c, M = o * u, y = n.x, x = n.y, _ = n.z;
                return i[0] = (1 - (f + g)) * y, i[1] = (d + M) * y, i[2] = (p - v) * y, i[3] = 0, i[4] = (d - M) * x, i[5] = (1 - (h + g)) * x, i[6] = (m + A) * x, i[7] = 0, i[8] = (p + v) * _, i[9] = (m - A) * _, i[10] = (1 - (h + f)) * _, i[11] = 0, i[12] = e1.x, i[13] = e1.y, i[14] = e1.z, i[15] = 1, this;
            }
            decompose(e1, t, n) {
                const i = this.elements;
                let r = lc.set(i[0], i[1], i[2]).length();
                const a = lc.set(i[4], i[5], i[6]).length(), s = lc.set(i[8], i[9], i[10]).length();
                this.determinant() < 0 && (r = -r), e1.x = i[12], e1.y = i[13], e1.z = i[14], cc.copy(this);
                const o = 1 / r, l = 1 / a, c = 1 / s;
                return cc.elements[0] *= o, cc.elements[1] *= o, cc.elements[2] *= o, cc.elements[4] *= l, cc.elements[5] *= l, cc.elements[6] *= l, cc.elements[8] *= c, cc.elements[9] *= c, cc.elements[10] *= c, t.setFromRotationMatrix(cc), n.x = r, n.y = a, n.z = s, this;
            }
            makePerspective(e1, t, n, i, r, a) {
                let s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : Oo;
                const o = this.elements, l = 2 * r / (t - e1), c = 2 * r / (n - i), u = (t + e1) / (t - e1), h = (n + i) / (n - i);
                let d, p;
                if (s === Oo) d = -(a + r) / (a - r), p = -2 * a * r / (a - r);
                else {
                    if (s !== Po) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
                    d = -a / (a - r), p = -a * r / (a - r);
                }
                return o[0] = l, o[4] = 0, o[8] = u, o[12] = 0, o[1] = 0, o[5] = c, o[9] = h, o[13] = 0, o[2] = 0, o[6] = 0, o[10] = d, o[14] = p, o[3] = 0, o[7] = 0, o[11] = -1, o[15] = 0, this;
            }
            makeOrthographic(e1, t, n, i, r, a) {
                let s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : Oo;
                const o = this.elements, l = 1 / (t - e1), c = 1 / (n - i), u = 1 / (a - r), h = (t + e1) * l, d = (n + i) * c;
                let p, f;
                if (s === Oo) p = (a + r) * u, f = -2 * u;
                else {
                    if (s !== Po) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
                    p = r * u, f = -1 * u;
                }
                return o[0] = 2 * l, o[4] = 0, o[8] = 0, o[12] = -h, o[1] = 0, o[5] = 2 * c, o[9] = 0, o[13] = -d, o[2] = 0, o[6] = 0, o[10] = f, o[14] = -p, o[3] = 0, o[7] = 0, o[11] = 0, o[15] = 1, this;
            }
            equals(e1) {
                const t = this.elements, n = e1.elements;
                for(let e1 = 0; e1 < 16; e1++)if (t[e1] !== n[e1]) return !1;
                return !0;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                for(let n = 0; n < 16; n++)this.elements[n] = e1[n + t];
                return this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.elements;
                return e1[t] = n[0], e1[t + 1] = n[1], e1[t + 2] = n[2], e1[t + 3] = n[3], e1[t + 4] = n[4], e1[t + 5] = n[5], e1[t + 6] = n[6], e1[t + 7] = n[7], e1[t + 8] = n[8], e1[t + 9] = n[9], e1[t + 10] = n[10], e1[t + 11] = n[11], e1[t + 12] = n[12], e1[t + 13] = n[13], e1[t + 14] = n[14], e1[t + 15] = n[15], e1;
            }
        }
        const lc = new Cl, cc = new oc, uc = new Cl(0, 0, 0), hc = new Cl(1, 1, 1), dc = new Cl, pc = new Cl, fc = new Cl, mc = new oc, gc = new Dl;
        class Ac {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : Ac.DEFAULT_ORDER;
                this.isEuler = !0, this._x = e1, this._y = t, this._z = n, this._order = i;
            }
            get x() {
                return this._x;
            }
            set x(e1) {
                this._x = e1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(e1) {
                this._y = e1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(e1) {
                this._z = e1, this._onChangeCallback();
            }
            get order() {
                return this._order;
            }
            set order(e1) {
                this._order = e1, this._onChangeCallback();
            }
            set(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : this._order;
                return this._x = e1, this._y = t, this._z = n, this._order = i, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._order);
            }
            copy(e1) {
                return this._x = e1._x, this._y = e1._y, this._z = e1._z, this._order = e1._order, this._onChangeCallback(), this;
            }
            setFromRotationMatrix(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._order, n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                const i = e1.elements, r = i[0], a = i[4], s = i[8], o = i[1], l = i[5], c = i[9], u = i[2], h = i[6], d = i[10];
                switch(t){
                    case "XYZ":
                        this._y = Math.asin(Vo(s, -1, 1)), Math.abs(s) < .9999999 ? (this._x = Math.atan2(-c, d), this._z = Math.atan2(-a, r)) : (this._x = Math.atan2(h, l), this._z = 0);
                        break;
                    case "YXZ":
                        this._x = Math.asin(-Vo(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(s, d), this._z = Math.atan2(o, l)) : (this._y = Math.atan2(-u, r), this._z = 0);
                        break;
                    case "ZXY":
                        this._x = Math.asin(Vo(h, -1, 1)), Math.abs(h) < .9999999 ? (this._y = Math.atan2(-u, d), this._z = Math.atan2(-a, l)) : (this._y = 0, this._z = Math.atan2(o, r));
                        break;
                    case "ZYX":
                        this._y = Math.asin(-Vo(u, -1, 1)), Math.abs(u) < .9999999 ? (this._x = Math.atan2(h, d), this._z = Math.atan2(o, r)) : (this._x = 0, this._z = Math.atan2(-a, l));
                        break;
                    case "YZX":
                        this._z = Math.asin(Vo(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(-c, l), this._y = Math.atan2(-u, r)) : (this._x = 0, this._y = Math.atan2(s, d));
                        break;
                    case "XZY":
                        this._z = Math.asin(-Vo(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(h, l), this._y = Math.atan2(s, r)) : (this._x = Math.atan2(-c, d), this._y = 0);
                        break;
                    default:
                        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
                }
                return this._order = t, !0 === n && this._onChangeCallback(), this;
            }
            setFromQuaternion(e1, t, n) {
                return mc.makeRotationFromQuaternion(e1), this.setFromRotationMatrix(mc, t, n);
            }
            setFromVector3(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._order;
                return this.set(e1.x, e1.y, e1.z, t);
            }
            reorder(e1) {
                return gc.setFromEuler(this), this.setFromQuaternion(gc, e1);
            }
            equals(e1) {
                return e1._x === this._x && e1._y === this._y && e1._z === this._z && e1._order === this._order;
            }
            fromArray(e1) {
                return this._x = e1[0], this._y = e1[1], this._z = e1[2], void 0 !== e1[3] && (this._order = e1[3]), this._onChangeCallback(), this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this._x, e1[t + 1] = this._y, e1[t + 2] = this._z, e1[t + 3] = this._order, e1;
            }
            _onChange(e1) {
                return this._onChangeCallback = e1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._order;
            }
        }
        Ac.DEFAULT_ORDER = "XYZ";
        class vc {
            constructor(){
                this.mask = 1;
            }
            set(e1) {
                this.mask = 1 << e1 >>> 0;
            }
            enable(e1) {
                this.mask |= 1 << e1;
            }
            enableAll() {
                this.mask = -1;
            }
            toggle(e1) {
                this.mask ^= 1 << e1;
            }
            disable(e1) {
                this.mask &= ~(1 << e1);
            }
            disableAll() {
                this.mask = 0;
            }
            test(e1) {
                return !!(this.mask & e1.mask);
            }
            isEnabled(e1) {
                return !!(this.mask & 1 << e1);
            }
        }
        let Mc = 0;
        const yc = new Cl, xc = new Dl, _c = new oc, bc = new Cl, wc = new Cl, Ec = new Cl, Tc = new Dl, Sc = new Cl(1, 0, 0), Ic = new Cl(0, 1, 0), Nc = new Cl(0, 0, 1), Dc = {
            type: "added"
        }, Cc = {
            type: "removed"
        };
        class Lc extends Uo {
            constructor(){
                super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
                    value: Mc++
                }), this.uuid = Ho(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = Lc.DEFAULT_UP.clone();
                const e1 = new Cl, t = new Ac, n = new Dl, i = new Cl(1, 1, 1);
                t._onChange(function() {
                    n.setFromEuler(t, !1);
                }), n._onChange(function() {
                    t.setFromQuaternion(n, void 0, !1);
                }), Object.defineProperties(this, {
                    position: {
                        configurable: !0,
                        enumerable: !0,
                        value: e1
                    },
                    rotation: {
                        configurable: !0,
                        enumerable: !0,
                        value: t
                    },
                    quaternion: {
                        configurable: !0,
                        enumerable: !0,
                        value: n
                    },
                    scale: {
                        configurable: !0,
                        enumerable: !0,
                        value: i
                    },
                    modelViewMatrix: {
                        value: new oc
                    },
                    normalMatrix: {
                        value: new $o
                    }
                }), this.matrix = new oc, this.matrixWorld = new oc, this.matrixAutoUpdate = Lc.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = Lc.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.layers = new vc, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
            }
            onBeforeRender() {}
            onAfterRender() {}
            applyMatrix4(e1) {
                this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e1), this.matrix.decompose(this.position, this.quaternion, this.scale);
            }
            applyQuaternion(e1) {
                return this.quaternion.premultiply(e1), this;
            }
            setRotationFromAxisAngle(e1, t) {
                this.quaternion.setFromAxisAngle(e1, t);
            }
            setRotationFromEuler(e1) {
                this.quaternion.setFromEuler(e1, !0);
            }
            setRotationFromMatrix(e1) {
                this.quaternion.setFromRotationMatrix(e1);
            }
            setRotationFromQuaternion(e1) {
                this.quaternion.copy(e1);
            }
            rotateOnAxis(e1, t) {
                return xc.setFromAxisAngle(e1, t), this.quaternion.multiply(xc), this;
            }
            rotateOnWorldAxis(e1, t) {
                return xc.setFromAxisAngle(e1, t), this.quaternion.premultiply(xc), this;
            }
            rotateX(e1) {
                return this.rotateOnAxis(Sc, e1);
            }
            rotateY(e1) {
                return this.rotateOnAxis(Ic, e1);
            }
            rotateZ(e1) {
                return this.rotateOnAxis(Nc, e1);
            }
            translateOnAxis(e1, t) {
                return yc.copy(e1).applyQuaternion(this.quaternion), this.position.add(yc.multiplyScalar(t)), this;
            }
            translateX(e1) {
                return this.translateOnAxis(Sc, e1);
            }
            translateY(e1) {
                return this.translateOnAxis(Ic, e1);
            }
            translateZ(e1) {
                return this.translateOnAxis(Nc, e1);
            }
            localToWorld(e1) {
                return this.updateWorldMatrix(!0, !1), e1.applyMatrix4(this.matrixWorld);
            }
            worldToLocal(e1) {
                return this.updateWorldMatrix(!0, !1), e1.applyMatrix4(_c.copy(this.matrixWorld).invert());
            }
            lookAt(e1, t, n) {
                e1.isVector3 ? bc.copy(e1) : bc.set(e1, t, n);
                const i = this.parent;
                this.updateWorldMatrix(!0, !1), wc.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? _c.lookAt(wc, bc, this.up) : _c.lookAt(bc, wc, this.up), this.quaternion.setFromRotationMatrix(_c), i && (_c.extractRotation(i.matrixWorld), xc.setFromRotationMatrix(_c), this.quaternion.premultiply(xc.invert()));
            }
            add(e1) {
                if (arguments.length > 1) {
                    for(let e1 = 0; e1 < arguments.length; e1++)this.add(arguments[e1]);
                    return this;
                }
                return e1 === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", e1), this) : (e1 && e1.isObject3D ? (null !== e1.parent && e1.parent.remove(e1), e1.parent = this, this.children.push(e1), e1.dispatchEvent(Dc)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", e1), this);
            }
            remove(e1) {
                if (arguments.length > 1) {
                    for(let e1 = 0; e1 < arguments.length; e1++)this.remove(arguments[e1]);
                    return this;
                }
                const t = this.children.indexOf(e1);
                return -1 !== t && (e1.parent = null, this.children.splice(t, 1), e1.dispatchEvent(Cc)), this;
            }
            removeFromParent() {
                const e1 = this.parent;
                return null !== e1 && e1.remove(this), this;
            }
            clear() {
                return this.remove(...this.children);
            }
            attach(e1) {
                return this.updateWorldMatrix(!0, !1), _c.copy(this.matrixWorld).invert(), null !== e1.parent && (e1.parent.updateWorldMatrix(!0, !1), _c.multiply(e1.parent.matrixWorld)), e1.applyMatrix4(_c), this.add(e1), e1.updateWorldMatrix(!1, !0), this;
            }
            getObjectById(e1) {
                return this.getObjectByProperty("id", e1);
            }
            getObjectByName(e1) {
                return this.getObjectByProperty("name", e1);
            }
            getObjectByProperty(e1, t) {
                if (this[e1] === t) return this;
                for(let n = 0, i = this.children.length; n < i; n++){
                    const i = this.children[n].getObjectByProperty(e1, t);
                    if (void 0 !== i) return i;
                }
            }
            getObjectsByProperty(e1, t) {
                let n = [];
                this[e1] === t && n.push(this);
                for(let i = 0, r = this.children.length; i < r; i++){
                    const r = this.children[i].getObjectsByProperty(e1, t);
                    r.length > 0 && (n = n.concat(r));
                }
                return n;
            }
            getWorldPosition(e1) {
                return this.updateWorldMatrix(!0, !1), e1.setFromMatrixPosition(this.matrixWorld);
            }
            getWorldQuaternion(e1) {
                return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(wc, e1, Ec), e1;
            }
            getWorldScale(e1) {
                return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(wc, Tc, e1), e1;
            }
            getWorldDirection(e1) {
                this.updateWorldMatrix(!0, !1);
                const t = this.matrixWorld.elements;
                return e1.set(t[8], t[9], t[10]).normalize();
            }
            raycast() {}
            traverse(e1) {
                e1(this);
                const t = this.children;
                for(let n = 0, i = t.length; n < i; n++)t[n].traverse(e1);
            }
            traverseVisible(e1) {
                if (!1 === this.visible) return;
                e1(this);
                const t = this.children;
                for(let n = 0, i = t.length; n < i; n++)t[n].traverseVisible(e1);
            }
            traverseAncestors(e1) {
                const t = this.parent;
                null !== t && (e1(t), t.traverseAncestors(e1));
            }
            updateMatrix() {
                this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
            }
            updateMatrixWorld(e1) {
                this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e1) && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, e1 = !0);
                const t = this.children;
                for(let n = 0, i = t.length; n < i; n++){
                    const i = t[n];
                    !0 !== i.matrixWorldAutoUpdate && !0 !== e1 || i.updateMatrixWorld(e1);
                }
            }
            updateWorldMatrix(e1, t) {
                const n = this.parent;
                if (!0 === e1 && null !== n && !0 === n.matrixWorldAutoUpdate && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), !0 === t) {
                    const e1 = this.children;
                    for(let t = 0, n = e1.length; t < n; t++){
                        const n = e1[t];
                        !0 === n.matrixWorldAutoUpdate && n.updateWorldMatrix(!1, !0);
                    }
                }
            }
            toJSON(e1) {
                const t = void 0 === e1 || "string" == typeof e1, n = {};
                t && (e1 = {
                    geometries: {},
                    materials: {},
                    textures: {},
                    images: {},
                    shapes: {},
                    skeletons: {},
                    animations: {},
                    nodes: {}
                }, n.metadata = {
                    version: 4.6,
                    type: "Object",
                    generator: "Object3D.toJSON"
                });
                const i = {};
                function r(t, n) {
                    return void 0 === t[n.uuid] && (t[n.uuid] = n.toJSON(e1)), n.uuid;
                }
                if (i.uuid = this.uuid, i.type = this.type, "" !== this.name && (i.name = this.name), !0 === this.castShadow && (i.castShadow = !0), !0 === this.receiveShadow && (i.receiveShadow = !0), !1 === this.visible && (i.visible = !1), !1 === this.frustumCulled && (i.frustumCulled = !1), 0 !== this.renderOrder && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), i.up = this.up.toArray(), !1 === this.matrixAutoUpdate && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (i.instanceColor = this.instanceColor.toJSON())), this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(e1).uuid)), this.environment && this.environment.isTexture && !0 !== this.environment.isRenderTargetTexture && (i.environment = this.environment.toJSON(e1).uuid);
                else if (this.isMesh || this.isLine || this.isPoints) {
                    i.geometry = r(e1.geometries, this.geometry);
                    const t = this.geometry.parameters;
                    if (void 0 !== t && void 0 !== t.shapes) {
                        const n = t.shapes;
                        if (Array.isArray(n)) for(let t = 0, i = n.length; t < i; t++){
                            const i = n[t];
                            r(e1.shapes, i);
                        }
                        else r(e1.shapes, n);
                    }
                }
                if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (r(e1.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), void 0 !== this.material) {
                    if (Array.isArray(this.material)) {
                        const t = [];
                        for(let n = 0, i = this.material.length; n < i; n++)t.push(r(e1.materials, this.material[n]));
                        i.material = t;
                    } else i.material = r(e1.materials, this.material);
                }
                if (this.children.length > 0) {
                    i.children = [];
                    for(let t = 0; t < this.children.length; t++)i.children.push(this.children[t].toJSON(e1).object);
                }
                if (this.animations.length > 0) {
                    i.animations = [];
                    for(let t = 0; t < this.animations.length; t++){
                        const n = this.animations[t];
                        i.animations.push(r(e1.animations, n));
                    }
                }
                if (t) {
                    const t = a(e1.geometries), i = a(e1.materials), r = a(e1.textures), s = a(e1.images), o = a(e1.shapes), l = a(e1.skeletons), c = a(e1.animations), u = a(e1.nodes);
                    t.length > 0 && (n.geometries = t), i.length > 0 && (n.materials = i), r.length > 0 && (n.textures = r), s.length > 0 && (n.images = s), o.length > 0 && (n.shapes = o), l.length > 0 && (n.skeletons = l), c.length > 0 && (n.animations = c), u.length > 0 && (n.nodes = u);
                }
                return n.object = i, n;
                function a(e1) {
                    const t = [];
                    for(const n in e1){
                        const i = e1[n];
                        delete i.metadata, t.push(i);
                    }
                    return t;
                }
            }
            clone(e1) {
                return (new this.constructor).copy(this, e1);
            }
            copy(e1) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                if (this.name = e1.name, this.up.copy(e1.up), this.position.copy(e1.position), this.rotation.order = e1.rotation.order, this.quaternion.copy(e1.quaternion), this.scale.copy(e1.scale), this.matrix.copy(e1.matrix), this.matrixWorld.copy(e1.matrixWorld), this.matrixAutoUpdate = e1.matrixAutoUpdate, this.matrixWorldNeedsUpdate = e1.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = e1.matrixWorldAutoUpdate, this.layers.mask = e1.layers.mask, this.visible = e1.visible, this.castShadow = e1.castShadow, this.receiveShadow = e1.receiveShadow, this.frustumCulled = e1.frustumCulled, this.renderOrder = e1.renderOrder, this.animations = e1.animations.slice(), this.userData = JSON.parse(JSON.stringify(e1.userData)), !0 === t) for(let t = 0; t < e1.children.length; t++){
                    const n = e1.children[t];
                    this.add(n.clone());
                }
                return this;
            }
        }
        Lc.DEFAULT_UP = new Cl(0, 1, 0), Lc.DEFAULT_MATRIX_AUTO_UPDATE = !0, Lc.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
        const Rc = new Cl, zc = new Cl, Oc = new Cl, Pc = new Cl, Uc = new Cl, kc = new Cl, jc = new Cl, Bc = new Cl, Fc = new Cl, Hc = new Cl;
        let Vc = !1;
        class Gc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Cl, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Cl;
                this.a = e1, this.b = t, this.c = n;
            }
            static getNormal(e1, t, n, i) {
                i.subVectors(n, t), Rc.subVectors(e1, t), i.cross(Rc);
                const r = i.lengthSq();
                return r > 0 ? i.multiplyScalar(1 / Math.sqrt(r)) : i.set(0, 0, 0);
            }
            static getBarycoord(e1, t, n, i, r) {
                Rc.subVectors(i, t), zc.subVectors(n, t), Oc.subVectors(e1, t);
                const a = Rc.dot(Rc), s = Rc.dot(zc), o = Rc.dot(Oc), l = zc.dot(zc), c = zc.dot(Oc), u = a * l - s * s;
                if (0 === u) return r.set(-2, -1, -1);
                const h = 1 / u, d = (l * o - s * c) * h, p = (a * c - s * o) * h;
                return r.set(1 - d - p, p, d);
            }
            static containsPoint(e1, t, n, i) {
                return this.getBarycoord(e1, t, n, i, Pc), Pc.x >= 0 && Pc.y >= 0 && Pc.x + Pc.y <= 1;
            }
            static getUV(e1, t, n, i, r, a, s, o) {
                return !1 === Vc && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), Vc = !0), this.getInterpolation(e1, t, n, i, r, a, s, o);
            }
            static getInterpolation(e1, t, n, i, r, a, s, o) {
                return this.getBarycoord(e1, t, n, i, Pc), o.setScalar(0), o.addScaledVector(r, Pc.x), o.addScaledVector(a, Pc.y), o.addScaledVector(s, Pc.z), o;
            }
            static isFrontFacing(e1, t, n, i) {
                return Rc.subVectors(n, t), zc.subVectors(e1, t), Rc.cross(zc).dot(i) < 0;
            }
            set(e1, t, n) {
                return this.a.copy(e1), this.b.copy(t), this.c.copy(n), this;
            }
            setFromPointsAndIndices(e1, t, n, i) {
                return this.a.copy(e1[t]), this.b.copy(e1[n]), this.c.copy(e1[i]), this;
            }
            setFromAttributeAndIndices(e1, t, n, i) {
                return this.a.fromBufferAttribute(e1, t), this.b.fromBufferAttribute(e1, n), this.c.fromBufferAttribute(e1, i), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                return this.a.copy(e1.a), this.b.copy(e1.b), this.c.copy(e1.c), this;
            }
            getArea() {
                return Rc.subVectors(this.c, this.b), zc.subVectors(this.a, this.b), .5 * Rc.cross(zc).length();
            }
            getMidpoint(e1) {
                return e1.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
            }
            getNormal(e1) {
                return Gc.getNormal(this.a, this.b, this.c, e1);
            }
            getPlane(e1) {
                return e1.setFromCoplanarPoints(this.a, this.b, this.c);
            }
            getBarycoord(e1, t) {
                return Gc.getBarycoord(e1, this.a, this.b, this.c, t);
            }
            getUV(e1, t, n, i, r) {
                return !1 === Vc && (console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."), Vc = !0), Gc.getInterpolation(e1, this.a, this.b, this.c, t, n, i, r);
            }
            getInterpolation(e1, t, n, i, r) {
                return Gc.getInterpolation(e1, this.a, this.b, this.c, t, n, i, r);
            }
            containsPoint(e1) {
                return Gc.containsPoint(e1, this.a, this.b, this.c);
            }
            isFrontFacing(e1) {
                return Gc.isFrontFacing(this.a, this.b, this.c, e1);
            }
            intersectsBox(e1) {
                return e1.intersectsTriangle(this);
            }
            closestPointToPoint(e1, t) {
                const n = this.a, i = this.b, r = this.c;
                let a, s;
                Uc.subVectors(i, n), kc.subVectors(r, n), Bc.subVectors(e1, n);
                const o = Uc.dot(Bc), l = kc.dot(Bc);
                if (o <= 0 && l <= 0) return t.copy(n);
                Fc.subVectors(e1, i);
                const c = Uc.dot(Fc), u = kc.dot(Fc);
                if (c >= 0 && u <= c) return t.copy(i);
                const h = o * u - c * l;
                if (h <= 0 && o >= 0 && c <= 0) return a = o / (o - c), t.copy(n).addScaledVector(Uc, a);
                Hc.subVectors(e1, r);
                const d = Uc.dot(Hc), p = kc.dot(Hc);
                if (p >= 0 && d <= p) return t.copy(r);
                const f = d * l - o * p;
                if (f <= 0 && l >= 0 && p <= 0) return s = l / (l - p), t.copy(n).addScaledVector(kc, s);
                const m = c * p - d * u;
                if (m <= 0 && u - c >= 0 && d - p >= 0) return jc.subVectors(r, i), s = (u - c) / (u - c + (d - p)), t.copy(i).addScaledVector(jc, s);
                const g = 1 / (m + f + h);
                return a = f * g, s = h * g, t.copy(n).addScaledVector(Uc, a).addScaledVector(kc, s);
            }
            equals(e1) {
                return e1.a.equals(this.a) && e1.b.equals(this.b) && e1.c.equals(this.c);
            }
        }
        const Qc = {
            aliceblue: 15792383,
            antiquewhite: 16444375,
            aqua: 65535,
            aquamarine: 8388564,
            azure: 15794175,
            beige: 16119260,
            bisque: 16770244,
            black: 0,
            blanchedalmond: 16772045,
            blue: 255,
            blueviolet: 9055202,
            brown: 10824234,
            burlywood: 14596231,
            cadetblue: 6266528,
            chartreuse: 8388352,
            chocolate: 13789470,
            coral: 16744272,
            cornflowerblue: 6591981,
            cornsilk: 16775388,
            crimson: 14423100,
            cyan: 65535,
            darkblue: 139,
            darkcyan: 35723,
            darkgoldenrod: 12092939,
            darkgray: 11119017,
            darkgreen: 25600,
            darkgrey: 11119017,
            darkkhaki: 12433259,
            darkmagenta: 9109643,
            darkolivegreen: 5597999,
            darkorange: 16747520,
            darkorchid: 10040012,
            darkred: 9109504,
            darksalmon: 15308410,
            darkseagreen: 9419919,
            darkslateblue: 4734347,
            darkslategray: 3100495,
            darkslategrey: 3100495,
            darkturquoise: 52945,
            darkviolet: 9699539,
            deeppink: 16716947,
            deepskyblue: 49151,
            dimgray: 6908265,
            dimgrey: 6908265,
            dodgerblue: 2003199,
            firebrick: 11674146,
            floralwhite: 16775920,
            forestgreen: 2263842,
            fuchsia: 16711935,
            gainsboro: 14474460,
            ghostwhite: 16316671,
            gold: 16766720,
            goldenrod: 14329120,
            gray: 8421504,
            green: 32768,
            greenyellow: 11403055,
            grey: 8421504,
            honeydew: 15794160,
            hotpink: 16738740,
            indianred: 13458524,
            indigo: 4915330,
            ivory: 16777200,
            khaki: 15787660,
            lavender: 15132410,
            lavenderblush: 16773365,
            lawngreen: 8190976,
            lemonchiffon: 16775885,
            lightblue: 11393254,
            lightcoral: 15761536,
            lightcyan: 14745599,
            lightgoldenrodyellow: 16448210,
            lightgray: 13882323,
            lightgreen: 9498256,
            lightgrey: 13882323,
            lightpink: 16758465,
            lightsalmon: 16752762,
            lightseagreen: 2142890,
            lightskyblue: 8900346,
            lightslategray: 7833753,
            lightslategrey: 7833753,
            lightsteelblue: 11584734,
            lightyellow: 16777184,
            lime: 65280,
            limegreen: 3329330,
            linen: 16445670,
            magenta: 16711935,
            maroon: 8388608,
            mediumaquamarine: 6737322,
            mediumblue: 205,
            mediumorchid: 12211667,
            mediumpurple: 9662683,
            mediumseagreen: 3978097,
            mediumslateblue: 8087790,
            mediumspringgreen: 64154,
            mediumturquoise: 4772300,
            mediumvioletred: 13047173,
            midnightblue: 1644912,
            mintcream: 16121850,
            mistyrose: 16770273,
            moccasin: 16770229,
            navajowhite: 16768685,
            navy: 128,
            oldlace: 16643558,
            olive: 8421376,
            olivedrab: 7048739,
            orange: 16753920,
            orangered: 16729344,
            orchid: 14315734,
            palegoldenrod: 15657130,
            palegreen: 10025880,
            paleturquoise: 11529966,
            palevioletred: 14381203,
            papayawhip: 16773077,
            peachpuff: 16767673,
            peru: 13468991,
            pink: 16761035,
            plum: 14524637,
            powderblue: 11591910,
            purple: 8388736,
            rebeccapurple: 6697881,
            red: 16711680,
            rosybrown: 12357519,
            royalblue: 4286945,
            saddlebrown: 9127187,
            salmon: 16416882,
            sandybrown: 16032864,
            seagreen: 3050327,
            seashell: 16774638,
            sienna: 10506797,
            silver: 12632256,
            skyblue: 8900331,
            slateblue: 6970061,
            slategray: 7372944,
            slategrey: 7372944,
            snow: 16775930,
            springgreen: 65407,
            steelblue: 4620980,
            tan: 13808780,
            teal: 32896,
            thistle: 14204888,
            tomato: 16737095,
            turquoise: 4251856,
            violet: 15631086,
            wheat: 16113331,
            white: 16777215,
            whitesmoke: 16119285,
            yellow: 16776960,
            yellowgreen: 10145074
        }, Wc = {
            h: 0,
            s: 0,
            l: 0
        }, Yc = {
            h: 0,
            s: 0,
            l: 0
        };
        function Xc(e1, t, n) {
            return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e1 + 6 * (t - e1) * n : n < .5 ? t : n < 2 / 3 ? e1 + 6 * (t - e1) * (2 / 3 - n) : e1;
        }
        class Zc {
            constructor(e1, t, n){
                return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(e1, t, n);
            }
            set(e1, t, n) {
                if (void 0 === t && void 0 === n) {
                    const t = e1;
                    t && t.isColor ? this.copy(t) : "number" == typeof t ? this.setHex(t) : "string" == typeof t && this.setStyle(t);
                } else this.setRGB(e1, t, n);
                return this;
            }
            setScalar(e1) {
                return this.r = e1, this.g = e1, this.b = e1, this;
            }
            setHex(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Gs;
                return e1 = Math.floor(e1), this.r = (e1 >> 16 & 255) / 255, this.g = (e1 >> 8 & 255) / 255, this.b = (255 & e1) / 255, dl.toWorkingColorSpace(this, t), this;
            }
            setRGB(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : dl.workingColorSpace;
                return this.r = e1, this.g = t, this.b = n, dl.toWorkingColorSpace(this, i), this;
            }
            setHSL(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : dl.workingColorSpace;
                if (e1 = Go(e1, 1), t = Vo(t, 0, 1), n = Vo(n, 0, 1), 0 === t) this.r = this.g = this.b = n;
                else {
                    const i = n <= .5 ? n * (1 + t) : n + t - n * t, r = 2 * n - i;
                    this.r = Xc(r, i, e1 + 1 / 3), this.g = Xc(r, i, e1), this.b = Xc(r, i, e1 - 1 / 3);
                }
                return dl.toWorkingColorSpace(this, i), this;
            }
            setStyle(e1) {
                let t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Gs;
                function i(t) {
                    void 0 !== t && parseFloat(t) < 1 && console.warn("THREE.Color: Alpha component of " + e1 + " will be ignored.");
                }
                if (t = /^(\w+)\(([^\)]*)\)/.exec(e1)) {
                    let r;
                    const a = t[1], s = t[2];
                    switch(a){
                        case "rgb":
                        case "rgba":
                            if (r = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(r[4]), this.setRGB(Math.min(255, parseInt(r[1], 10)) / 255, Math.min(255, parseInt(r[2], 10)) / 255, Math.min(255, parseInt(r[3], 10)) / 255, n);
                            if (r = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(r[4]), this.setRGB(Math.min(100, parseInt(r[1], 10)) / 100, Math.min(100, parseInt(r[2], 10)) / 100, Math.min(100, parseInt(r[3], 10)) / 100, n);
                            break;
                        case "hsl":
                        case "hsla":
                            if (r = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) return i(r[4]), this.setHSL(parseFloat(r[1]) / 360, parseFloat(r[2]) / 100, parseFloat(r[3]) / 100, n);
                            break;
                        default:
                            console.warn("THREE.Color: Unknown color model " + e1);
                    }
                } else if (t = /^\#([A-Fa-f\d]+)$/.exec(e1)) {
                    const i = t[1], r = i.length;
                    if (3 === r) return this.setRGB(parseInt(i.charAt(0), 16) / 15, parseInt(i.charAt(1), 16) / 15, parseInt(i.charAt(2), 16) / 15, n);
                    if (6 === r) return this.setHex(parseInt(i, 16), n);
                    console.warn("THREE.Color: Invalid hex color " + e1);
                } else if (e1 && e1.length > 0) return this.setColorName(e1, n);
                return this;
            }
            setColorName(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Gs;
                const n = Qc[e1.toLowerCase()];
                return void 0 !== n ? this.setHex(n, t) : console.warn("THREE.Color: Unknown color " + e1), this;
            }
            clone() {
                return new this.constructor(this.r, this.g, this.b);
            }
            copy(e1) {
                return this.r = e1.r, this.g = e1.g, this.b = e1.b, this;
            }
            copySRGBToLinear(e1) {
                return this.r = pl(e1.r), this.g = pl(e1.g), this.b = pl(e1.b), this;
            }
            copyLinearToSRGB(e1) {
                return this.r = fl(e1.r), this.g = fl(e1.g), this.b = fl(e1.b), this;
            }
            convertSRGBToLinear() {
                return this.copySRGBToLinear(this), this;
            }
            convertLinearToSRGB() {
                return this.copyLinearToSRGB(this), this;
            }
            getHex() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Gs;
                return dl.fromWorkingColorSpace(qc.copy(this), e1), 65536 * Math.round(Vo(255 * qc.r, 0, 255)) + 256 * Math.round(Vo(255 * qc.g, 0, 255)) + Math.round(Vo(255 * qc.b, 0, 255));
            }
            getHexString() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Gs;
                return ("000000" + this.getHex(e1).toString(16)).slice(-6);
            }
            getHSL(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : dl.workingColorSpace;
                dl.fromWorkingColorSpace(qc.copy(this), t);
                const n = qc.r, i = qc.g, r = qc.b, a = Math.max(n, i, r), s = Math.min(n, i, r);
                let o, l;
                const c = (s + a) / 2;
                if (s === a) o = 0, l = 0;
                else {
                    const e1 = a - s;
                    switch(l = c <= .5 ? e1 / (a + s) : e1 / (2 - a - s), a){
                        case n:
                            o = (i - r) / e1 + (i < r ? 6 : 0);
                            break;
                        case i:
                            o = (r - n) / e1 + 2;
                            break;
                        case r:
                            o = (n - i) / e1 + 4;
                    }
                    o /= 6;
                }
                return e1.h = o, e1.s = l, e1.l = c, e1;
            }
            getRGB(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : dl.workingColorSpace;
                return dl.fromWorkingColorSpace(qc.copy(this), t), e1.r = qc.r, e1.g = qc.g, e1.b = qc.b, e1;
            }
            getStyle() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Gs;
                dl.fromWorkingColorSpace(qc.copy(this), e1);
                const t = qc.r, n = qc.g, i = qc.b;
                return e1 !== Gs ? "color(".concat(e1, " ").concat(t.toFixed(3), " ").concat(n.toFixed(3), " ").concat(i.toFixed(3), ")") : "rgb(".concat(Math.round(255 * t), ",").concat(Math.round(255 * n), ",").concat(Math.round(255 * i), ")");
            }
            offsetHSL(e1, t, n) {
                return this.getHSL(Wc), this.setHSL(Wc.h + e1, Wc.s + t, Wc.l + n);
            }
            add(e1) {
                return this.r += e1.r, this.g += e1.g, this.b += e1.b, this;
            }
            addColors(e1, t) {
                return this.r = e1.r + t.r, this.g = e1.g + t.g, this.b = e1.b + t.b, this;
            }
            addScalar(e1) {
                return this.r += e1, this.g += e1, this.b += e1, this;
            }
            sub(e1) {
                return this.r = Math.max(0, this.r - e1.r), this.g = Math.max(0, this.g - e1.g), this.b = Math.max(0, this.b - e1.b), this;
            }
            multiply(e1) {
                return this.r *= e1.r, this.g *= e1.g, this.b *= e1.b, this;
            }
            multiplyScalar(e1) {
                return this.r *= e1, this.g *= e1, this.b *= e1, this;
            }
            lerp(e1, t) {
                return this.r += (e1.r - this.r) * t, this.g += (e1.g - this.g) * t, this.b += (e1.b - this.b) * t, this;
            }
            lerpColors(e1, t, n) {
                return this.r = e1.r + (t.r - e1.r) * n, this.g = e1.g + (t.g - e1.g) * n, this.b = e1.b + (t.b - e1.b) * n, this;
            }
            lerpHSL(e1, t) {
                this.getHSL(Wc), e1.getHSL(Yc);
                const n = Qo(Wc.h, Yc.h, t), i = Qo(Wc.s, Yc.s, t), r = Qo(Wc.l, Yc.l, t);
                return this.setHSL(n, i, r), this;
            }
            setFromVector3(e1) {
                return this.r = e1.x, this.g = e1.y, this.b = e1.z, this;
            }
            applyMatrix3(e1) {
                const t = this.r, n = this.g, i = this.b, r = e1.elements;
                return this.r = r[0] * t + r[3] * n + r[6] * i, this.g = r[1] * t + r[4] * n + r[7] * i, this.b = r[2] * t + r[5] * n + r[8] * i, this;
            }
            equals(e1) {
                return e1.r === this.r && e1.g === this.g && e1.b === this.b;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.r = e1[t], this.g = e1[t + 1], this.b = e1[t + 2], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.r, e1[t + 1] = this.g, e1[t + 2] = this.b, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.r = e1.getX(t), this.g = e1.getY(t), this.b = e1.getZ(t), this;
            }
            toJSON() {
                return this.getHex();
            }
            *[Symbol.iterator]() {
                yield this.r, yield this.g, yield this.b;
            }
        }
        const qc = new Zc;
        Zc.NAMES = Qc;
        let Kc = 0;
        class Jc extends Uo {
            constructor(){
                super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
                    value: Kc++
                }), this.uuid = Ho(), this.name = "", this.type = "Material", this.blending = fr, this.side = cr, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = Ir, this.blendDst = Nr, this.blendEquation = Mr, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new Zc(0, 0, 0), this.blendAlpha = 0, this.depthFunc = Hr, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = fo, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = $s, this.stencilZFail = $s, this.stencilZPass = $s, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
            }
            get alphaTest() {
                return this._alphaTest;
            }
            set alphaTest(e1) {
                this._alphaTest > 0 != e1 > 0 && this.version++, this._alphaTest = e1;
            }
            onBuild() {}
            onBeforeRender() {}
            onBeforeCompile() {}
            customProgramCacheKey() {
                return this.onBeforeCompile.toString();
            }
            setValues(e1) {
                if (void 0 !== e1) for(const t in e1){
                    const n = e1[t];
                    if (void 0 === n) {
                        console.warn("THREE.Material: parameter '".concat(t, "' has value of undefined."));
                        continue;
                    }
                    const i = this[t];
                    void 0 !== i ? i && i.isColor ? i.set(n) : i && i.isVector3 && n && n.isVector3 ? i.copy(n) : this[t] = n : console.warn("THREE.Material: '".concat(t, "' is not a property of THREE.").concat(this.type, "."));
                }
            }
            toJSON(e1) {
                const t = void 0 === e1 || "string" == typeof e1;
                t && (e1 = {
                    textures: {},
                    images: {}
                });
                const n = {
                    metadata: {
                        version: 4.6,
                        type: "Material",
                        generator: "Material.toJSON"
                    }
                };
                function i(e1) {
                    const t = [];
                    for(const n in e1){
                        const i = e1[n];
                        delete i.metadata, t.push(i);
                    }
                    return t;
                }
                if (n.uuid = this.uuid, n.type = this.type, "" !== this.name && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), void 0 !== this.roughness && (n.roughness = this.roughness), void 0 !== this.metalness && (n.metalness = this.metalness), void 0 !== this.sheen && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity && 1 !== this.emissiveIntensity && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (n.shininess = this.shininess), void 0 !== this.clearcoat && (n.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(e1).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e1).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e1).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), void 0 !== this.iridescence && (n.iridescence = this.iridescence), void 0 !== this.iridescenceIOR && (n.iridescenceIOR = this.iridescenceIOR), void 0 !== this.iridescenceThicknessRange && (n.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(e1).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e1).uuid), void 0 !== this.anisotropy && (n.anisotropy = this.anisotropy), void 0 !== this.anisotropyRotation && (n.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (n.anisotropyMap = this.anisotropyMap.toJSON(e1).uuid), this.map && this.map.isTexture && (n.map = this.map.toJSON(e1).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(e1).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(e1).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(e1).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(e1).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(e1).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(e1).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(e1).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(e1).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(e1).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(e1).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(e1).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(e1).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(e1).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(e1).uuid, void 0 !== this.combine && (n.combine = this.combine)), void 0 !== this.envMapIntensity && (n.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (n.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(e1).uuid), void 0 !== this.transmission && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(e1).uuid), void 0 !== this.thickness && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(e1).uuid), void 0 !== this.attenuationDistance && this.attenuationDistance !== 1 / 0 && (n.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (n.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (n.size = this.size), null !== this.shadowSide && (n.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== fr && (n.blending = this.blending), this.side !== cr && (n.side = this.side), !0 === this.vertexColors && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), !0 === this.transparent && (n.transparent = !0), this.blendSrc !== Ir && (n.blendSrc = this.blendSrc), this.blendDst !== Nr && (n.blendDst = this.blendDst), this.blendEquation !== Mr && (n.blendEquation = this.blendEquation), null !== this.blendSrcAlpha && (n.blendSrcAlpha = this.blendSrcAlpha), null !== this.blendDstAlpha && (n.blendDstAlpha = this.blendDstAlpha), null !== this.blendEquationAlpha && (n.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (n.blendColor = this.blendColor.getHex()), 0 !== this.blendAlpha && (n.blendAlpha = this.blendAlpha), this.depthFunc !== Hr && (n.depthFunc = this.depthFunc), !1 === this.depthTest && (n.depthTest = this.depthTest), !1 === this.depthWrite && (n.depthWrite = this.depthWrite), !1 === this.colorWrite && (n.colorWrite = this.colorWrite), 255 !== this.stencilWriteMask && (n.stencilWriteMask = this.stencilWriteMask), this.stencilFunc !== fo && (n.stencilFunc = this.stencilFunc), 0 !== this.stencilRef && (n.stencilRef = this.stencilRef), 255 !== this.stencilFuncMask && (n.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== $s && (n.stencilFail = this.stencilFail), this.stencilZFail !== $s && (n.stencilZFail = this.stencilZFail), this.stencilZPass !== $s && (n.stencilZPass = this.stencilZPass), !0 === this.stencilWrite && (n.stencilWrite = this.stencilWrite), void 0 !== this.rotation && 0 !== this.rotation && (n.rotation = this.rotation), !0 === this.polygonOffset && (n.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (n.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (n.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (n.linewidth = this.linewidth), void 0 !== this.dashSize && (n.dashSize = this.dashSize), void 0 !== this.gapSize && (n.gapSize = this.gapSize), void 0 !== this.scale && (n.scale = this.scale), !0 === this.dithering && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), !0 === this.alphaHash && (n.alphaHash = !0), !0 === this.alphaToCoverage && (n.alphaToCoverage = !0), !0 === this.premultipliedAlpha && (n.premultipliedAlpha = !0), !0 === this.forceSinglePass && (n.forceSinglePass = !0), !0 === this.wireframe && (n.wireframe = !0), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (n.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (n.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (n.flatShading = !0), !1 === this.visible && (n.visible = !1), !1 === this.toneMapped && (n.toneMapped = !1), !1 === this.fog && (n.fog = !1), Object.keys(this.userData).length > 0 && (n.userData = this.userData), t) {
                    const t = i(e1.textures), r = i(e1.images);
                    t.length > 0 && (n.textures = t), r.length > 0 && (n.images = r);
                }
                return n;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                this.name = e1.name, this.blending = e1.blending, this.side = e1.side, this.vertexColors = e1.vertexColors, this.opacity = e1.opacity, this.transparent = e1.transparent, this.blendSrc = e1.blendSrc, this.blendDst = e1.blendDst, this.blendEquation = e1.blendEquation, this.blendSrcAlpha = e1.blendSrcAlpha, this.blendDstAlpha = e1.blendDstAlpha, this.blendEquationAlpha = e1.blendEquationAlpha, this.blendColor.copy(e1.blendColor), this.blendAlpha = e1.blendAlpha, this.depthFunc = e1.depthFunc, this.depthTest = e1.depthTest, this.depthWrite = e1.depthWrite, this.stencilWriteMask = e1.stencilWriteMask, this.stencilFunc = e1.stencilFunc, this.stencilRef = e1.stencilRef, this.stencilFuncMask = e1.stencilFuncMask, this.stencilFail = e1.stencilFail, this.stencilZFail = e1.stencilZFail, this.stencilZPass = e1.stencilZPass, this.stencilWrite = e1.stencilWrite;
                const t = e1.clippingPlanes;
                let n = null;
                if (null !== t) {
                    const e1 = t.length;
                    n = new Array(e1);
                    for(let i = 0; i !== e1; ++i)n[i] = t[i].clone();
                }
                return this.clippingPlanes = n, this.clipIntersection = e1.clipIntersection, this.clipShadows = e1.clipShadows, this.shadowSide = e1.shadowSide, this.colorWrite = e1.colorWrite, this.precision = e1.precision, this.polygonOffset = e1.polygonOffset, this.polygonOffsetFactor = e1.polygonOffsetFactor, this.polygonOffsetUnits = e1.polygonOffsetUnits, this.dithering = e1.dithering, this.alphaTest = e1.alphaTest, this.alphaHash = e1.alphaHash, this.alphaToCoverage = e1.alphaToCoverage, this.premultipliedAlpha = e1.premultipliedAlpha, this.forceSinglePass = e1.forceSinglePass, this.visible = e1.visible, this.toneMapped = e1.toneMapped, this.userData = JSON.parse(JSON.stringify(e1.userData)), this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            set needsUpdate(e1) {
                !0 === e1 && this.version++;
            }
        }
        class $c extends Jc {
            constructor(e1){
                super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Zc(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Yr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.lightMap = e1.lightMap, this.lightMapIntensity = e1.lightMapIntensity, this.aoMap = e1.aoMap, this.aoMapIntensity = e1.aoMapIntensity, this.specularMap = e1.specularMap, this.alphaMap = e1.alphaMap, this.envMap = e1.envMap, this.combine = e1.combine, this.reflectivity = e1.reflectivity, this.refractionRatio = e1.refractionRatio, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.wireframeLinecap = e1.wireframeLinecap, this.wireframeLinejoin = e1.wireframeLinejoin, this.fog = e1.fog, this;
            }
        }
        const eu = tu();
        function tu() {
            const e1 = new ArrayBuffer(4), t = new Float32Array(e1), n = new Uint32Array(e1), i = new Uint32Array(512), r = new Uint32Array(512);
            for(let e1 = 0; e1 < 256; ++e1){
                const t = e1 - 127;
                t < -27 ? (i[e1] = 0, i[256 | e1] = 32768, r[e1] = 24, r[256 | e1] = 24) : t < -14 ? (i[e1] = 1024 >> -t - 14, i[256 | e1] = 1024 >> -t - 14 | 32768, r[e1] = -t - 1, r[256 | e1] = -t - 1) : t <= 15 ? (i[e1] = t + 15 << 10, i[256 | e1] = t + 15 << 10 | 32768, r[e1] = 13, r[256 | e1] = 13) : t < 128 ? (i[e1] = 31744, i[256 | e1] = 64512, r[e1] = 24, r[256 | e1] = 24) : (i[e1] = 31744, i[256 | e1] = 64512, r[e1] = 13, r[256 | e1] = 13);
            }
            const a = new Uint32Array(2048), s = new Uint32Array(64), o = new Uint32Array(64);
            for(let e1 = 1; e1 < 1024; ++e1){
                let t = e1 << 13, n = 0;
                for(; !(8388608 & t);)t <<= 1, n -= 8388608;
                t &= -8388609, n += 947912704, a[e1] = t | n;
            }
            for(let e1 = 1024; e1 < 2048; ++e1)a[e1] = 939524096 + (e1 - 1024 << 13);
            for(let e1 = 1; e1 < 31; ++e1)s[e1] = e1 << 23;
            s[31] = 1199570944, s[32] = 2147483648;
            for(let e1 = 33; e1 < 63; ++e1)s[e1] = 2147483648 + (e1 - 32 << 23);
            s[63] = 3347054592;
            for(let e1 = 1; e1 < 64; ++e1)32 !== e1 && (o[e1] = 1024);
            return {
                floatView: t,
                uint32View: n,
                baseTable: i,
                shiftTable: r,
                mantissaTable: a,
                exponentTable: s,
                offsetTable: o
            };
        }
        function nu(e1) {
            Math.abs(e1) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), e1 = Vo(e1, -65504, 65504), eu.floatView[0] = e1;
            const t = eu.uint32View[0], n = t >> 23 & 511;
            return eu.baseTable[n] + ((8388607 & t) >> eu.shiftTable[n]);
        }
        function iu(e1) {
            const t = e1 >> 10;
            return eu.uint32View[0] = eu.mantissaTable[eu.offsetTable[t] + (1023 & e1)] + eu.exponentTable[t], eu.floatView[0];
        }
        const ru = {
            toHalfFloat: nu,
            fromHalfFloat: iu
        }, au = new Cl, su = new Jo;
        class ou {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                if (Array.isArray(e1)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
                this.isBufferAttribute = !0, this.name = "", this.array = e1, this.itemSize = t, this.count = void 0 !== e1 ? e1.length / t : 0, this.normalized = n, this.usage = bo, this.updateRange = {
                    offset: 0,
                    count: -1
                }, this.gpuType = Na, this.version = 0;
            }
            onUploadCallback() {}
            set needsUpdate(e1) {
                !0 === e1 && this.version++;
            }
            setUsage(e1) {
                return this.usage = e1, this;
            }
            copy(e1) {
                return this.name = e1.name, this.array = new e1.array.constructor(e1.array), this.itemSize = e1.itemSize, this.count = e1.count, this.normalized = e1.normalized, this.usage = e1.usage, this.gpuType = e1.gpuType, this;
            }
            copyAt(e1, t, n) {
                e1 *= this.itemSize, n *= t.itemSize;
                for(let i = 0, r = this.itemSize; i < r; i++)this.array[e1 + i] = t.array[n + i];
                return this;
            }
            copyArray(e1) {
                return this.array.set(e1), this;
            }
            applyMatrix3(e1) {
                if (2 === this.itemSize) for(let t = 0, n = this.count; t < n; t++)su.fromBufferAttribute(this, t), su.applyMatrix3(e1), this.setXY(t, su.x, su.y);
                else if (3 === this.itemSize) for(let t = 0, n = this.count; t < n; t++)au.fromBufferAttribute(this, t), au.applyMatrix3(e1), this.setXYZ(t, au.x, au.y, au.z);
                return this;
            }
            applyMatrix4(e1) {
                for(let t = 0, n = this.count; t < n; t++)au.fromBufferAttribute(this, t), au.applyMatrix4(e1), this.setXYZ(t, au.x, au.y, au.z);
                return this;
            }
            applyNormalMatrix(e1) {
                for(let t = 0, n = this.count; t < n; t++)au.fromBufferAttribute(this, t), au.applyNormalMatrix(e1), this.setXYZ(t, au.x, au.y, au.z);
                return this;
            }
            transformDirection(e1) {
                for(let t = 0, n = this.count; t < n; t++)au.fromBufferAttribute(this, t), au.transformDirection(e1), this.setXYZ(t, au.x, au.y, au.z);
                return this;
            }
            set(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.array.set(e1, t), this;
            }
            getComponent(e1, t) {
                let n = this.array[e1 * this.itemSize + t];
                return this.normalized && (n = Zo(n, this.array)), n;
            }
            setComponent(e1, t, n) {
                return this.normalized && (n = qo(n, this.array)), this.array[e1 * this.itemSize + t] = n, this;
            }
            getX(e1) {
                let t = this.array[e1 * this.itemSize];
                return this.normalized && (t = Zo(t, this.array)), t;
            }
            setX(e1, t) {
                return this.normalized && (t = qo(t, this.array)), this.array[e1 * this.itemSize] = t, this;
            }
            getY(e1) {
                let t = this.array[e1 * this.itemSize + 1];
                return this.normalized && (t = Zo(t, this.array)), t;
            }
            setY(e1, t) {
                return this.normalized && (t = qo(t, this.array)), this.array[e1 * this.itemSize + 1] = t, this;
            }
            getZ(e1) {
                let t = this.array[e1 * this.itemSize + 2];
                return this.normalized && (t = Zo(t, this.array)), t;
            }
            setZ(e1, t) {
                return this.normalized && (t = qo(t, this.array)), this.array[e1 * this.itemSize + 2] = t, this;
            }
            getW(e1) {
                let t = this.array[e1 * this.itemSize + 3];
                return this.normalized && (t = Zo(t, this.array)), t;
            }
            setW(e1, t) {
                return this.normalized && (t = qo(t, this.array)), this.array[e1 * this.itemSize + 3] = t, this;
            }
            setXY(e1, t, n) {
                return e1 *= this.itemSize, this.normalized && (t = qo(t, this.array), n = qo(n, this.array)), this.array[e1 + 0] = t, this.array[e1 + 1] = n, this;
            }
            setXYZ(e1, t, n, i) {
                return e1 *= this.itemSize, this.normalized && (t = qo(t, this.array), n = qo(n, this.array), i = qo(i, this.array)), this.array[e1 + 0] = t, this.array[e1 + 1] = n, this.array[e1 + 2] = i, this;
            }
            setXYZW(e1, t, n, i, r) {
                return e1 *= this.itemSize, this.normalized && (t = qo(t, this.array), n = qo(n, this.array), i = qo(i, this.array), r = qo(r, this.array)), this.array[e1 + 0] = t, this.array[e1 + 1] = n, this.array[e1 + 2] = i, this.array[e1 + 3] = r, this;
            }
            onUpload(e1) {
                return this.onUploadCallback = e1, this;
            }
            clone() {
                return new this.constructor(this.array, this.itemSize).copy(this);
            }
            toJSON() {
                const e1 = {
                    itemSize: this.itemSize,
                    type: this.array.constructor.name,
                    array: Array.from(this.array),
                    normalized: this.normalized
                };
                return "" !== this.name && (e1.name = this.name), this.usage !== bo && (e1.usage = this.usage), 0 === this.updateRange.offset && -1 === this.updateRange.count || (e1.updateRange = this.updateRange), e1;
            }
        }
        class lu extends ou {
            constructor(e1, t, n){
                super(new Int8Array(e1), t, n);
            }
        }
        class cu extends ou {
            constructor(e1, t, n){
                super(new Uint8Array(e1), t, n);
            }
        }
        class uu extends ou {
            constructor(e1, t, n){
                super(new Uint8ClampedArray(e1), t, n);
            }
        }
        class hu extends ou {
            constructor(e1, t, n){
                super(new Int16Array(e1), t, n);
            }
        }
        class du extends ou {
            constructor(e1, t, n){
                super(new Uint16Array(e1), t, n);
            }
        }
        class pu extends ou {
            constructor(e1, t, n){
                super(new Int32Array(e1), t, n);
            }
        }
        class fu extends ou {
            constructor(e1, t, n){
                super(new Uint32Array(e1), t, n);
            }
        }
        class mu extends ou {
            constructor(e1, t, n){
                super(new Uint16Array(e1), t, n), this.isFloat16BufferAttribute = !0;
            }
            getX(e1) {
                let t = iu(this.array[e1 * this.itemSize]);
                return this.normalized && (t = Zo(t, this.array)), t;
            }
            setX(e1, t) {
                return this.normalized && (t = qo(t, this.array)), this.array[e1 * this.itemSize] = nu(t), this;
            }
            getY(e1) {
                let t = iu(this.array[e1 * this.itemSize + 1]);
                return this.normalized && (t = Zo(t, this.array)), t;
            }
            setY(e1, t) {
                return this.normalized && (t = qo(t, this.array)), this.array[e1 * this.itemSize + 1] = nu(t), this;
            }
            getZ(e1) {
                let t = iu(this.array[e1 * this.itemSize + 2]);
                return this.normalized && (t = Zo(t, this.array)), t;
            }
            setZ(e1, t) {
                return this.normalized && (t = qo(t, this.array)), this.array[e1 * this.itemSize + 2] = nu(t), this;
            }
            getW(e1) {
                let t = iu(this.array[e1 * this.itemSize + 3]);
                return this.normalized && (t = Zo(t, this.array)), t;
            }
            setW(e1, t) {
                return this.normalized && (t = qo(t, this.array)), this.array[e1 * this.itemSize + 3] = nu(t), this;
            }
            setXY(e1, t, n) {
                return e1 *= this.itemSize, this.normalized && (t = qo(t, this.array), n = qo(n, this.array)), this.array[e1 + 0] = nu(t), this.array[e1 + 1] = nu(n), this;
            }
            setXYZ(e1, t, n, i) {
                return e1 *= this.itemSize, this.normalized && (t = qo(t, this.array), n = qo(n, this.array), i = qo(i, this.array)), this.array[e1 + 0] = nu(t), this.array[e1 + 1] = nu(n), this.array[e1 + 2] = nu(i), this;
            }
            setXYZW(e1, t, n, i, r) {
                return e1 *= this.itemSize, this.normalized && (t = qo(t, this.array), n = qo(n, this.array), i = qo(i, this.array), r = qo(r, this.array)), this.array[e1 + 0] = nu(t), this.array[e1 + 1] = nu(n), this.array[e1 + 2] = nu(i), this.array[e1 + 3] = nu(r), this;
            }
        }
        class gu extends ou {
            constructor(e1, t, n){
                super(new Float32Array(e1), t, n);
            }
        }
        class Au extends ou {
            constructor(e1, t, n){
                super(new Float64Array(e1), t, n);
            }
        }
        let vu = 0;
        const Mu = new oc, yu = new Lc, xu = new Cl, _u = new zl, bu = new zl, wu = new Cl;
        class Eu extends Uo {
            constructor(){
                super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
                    value: vu++
                }), this.uuid = Ho(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
                    start: 0,
                    count: 1 / 0
                }, this.userData = {};
            }
            getIndex() {
                return this.index;
            }
            setIndex(e1) {
                return Array.isArray(e1) ? this.index = new (tl(e1) ? fu : du)(e1, 1) : this.index = e1, this;
            }
            getAttribute(e1) {
                return this.attributes[e1];
            }
            setAttribute(e1, t) {
                return this.attributes[e1] = t, this;
            }
            deleteAttribute(e1) {
                return delete this.attributes[e1], this;
            }
            hasAttribute(e1) {
                return void 0 !== this.attributes[e1];
            }
            addGroup(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                this.groups.push({
                    start: e1,
                    count: t,
                    materialIndex: n
                });
            }
            clearGroups() {
                this.groups = [];
            }
            setDrawRange(e1, t) {
                this.drawRange.start = e1, this.drawRange.count = t;
            }
            applyMatrix4(e1) {
                const t = this.attributes.position;
                void 0 !== t && (t.applyMatrix4(e1), t.needsUpdate = !0);
                const n = this.attributes.normal;
                if (void 0 !== n) {
                    const t = (new $o).getNormalMatrix(e1);
                    n.applyNormalMatrix(t), n.needsUpdate = !0;
                }
                const i = this.attributes.tangent;
                return void 0 !== i && (i.transformDirection(e1), i.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
            }
            applyQuaternion(e1) {
                return Mu.makeRotationFromQuaternion(e1), this.applyMatrix4(Mu), this;
            }
            rotateX(e1) {
                return Mu.makeRotationX(e1), this.applyMatrix4(Mu), this;
            }
            rotateY(e1) {
                return Mu.makeRotationY(e1), this.applyMatrix4(Mu), this;
            }
            rotateZ(e1) {
                return Mu.makeRotationZ(e1), this.applyMatrix4(Mu), this;
            }
            translate(e1, t, n) {
                return Mu.makeTranslation(e1, t, n), this.applyMatrix4(Mu), this;
            }
            scale(e1, t, n) {
                return Mu.makeScale(e1, t, n), this.applyMatrix4(Mu), this;
            }
            lookAt(e1) {
                return yu.lookAt(e1), yu.updateMatrix(), this.applyMatrix4(yu.matrix), this;
            }
            center() {
                return this.computeBoundingBox(), this.boundingBox.getCenter(xu).negate(), this.translate(xu.x, xu.y, xu.z), this;
            }
            setFromPoints(e1) {
                const t = [];
                for(let n = 0, i = e1.length; n < i; n++){
                    const i = e1[n];
                    t.push(i.x, i.y, i.z || 0);
                }
                return this.setAttribute("position", new gu(t, 3)), this;
            }
            computeBoundingBox() {
                null === this.boundingBox && (this.boundingBox = new zl);
                const e1 = this.attributes.position, t = this.morphAttributes.position;
                if (e1 && e1.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingBox.set(new Cl(-1 / 0, -1 / 0, -1 / 0), new Cl(1 / 0, 1 / 0, 1 / 0));
                if (void 0 !== e1) {
                    if (this.boundingBox.setFromBufferAttribute(e1), t) for(let e1 = 0, n = t.length; e1 < n; e1++){
                        const n = t[e1];
                        _u.setFromBufferAttribute(n), this.morphTargetsRelative ? (wu.addVectors(this.boundingBox.min, _u.min), this.boundingBox.expandByPoint(wu), wu.addVectors(this.boundingBox.max, _u.max), this.boundingBox.expandByPoint(wu)) : (this.boundingBox.expandByPoint(_u.min), this.boundingBox.expandByPoint(_u.max));
                    }
                } else this.boundingBox.makeEmpty();
                (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
            }
            computeBoundingSphere() {
                null === this.boundingSphere && (this.boundingSphere = new Jl);
                const e1 = this.attributes.position, t = this.morphAttributes.position;
                if (e1 && e1.isGLBufferAttribute) return console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), void this.boundingSphere.set(new Cl, 1 / 0);
                if (e1) {
                    const n = this.boundingSphere.center;
                    if (_u.setFromBufferAttribute(e1), t) for(let e1 = 0, n = t.length; e1 < n; e1++){
                        const n = t[e1];
                        bu.setFromBufferAttribute(n), this.morphTargetsRelative ? (wu.addVectors(_u.min, bu.min), _u.expandByPoint(wu), wu.addVectors(_u.max, bu.max), _u.expandByPoint(wu)) : (_u.expandByPoint(bu.min), _u.expandByPoint(bu.max));
                    }
                    _u.getCenter(n);
                    let i = 0;
                    for(let t = 0, r = e1.count; t < r; t++)wu.fromBufferAttribute(e1, t), i = Math.max(i, n.distanceToSquared(wu));
                    if (t) for(let r = 0, a = t.length; r < a; r++){
                        const a = t[r], s = this.morphTargetsRelative;
                        for(let t = 0, r = a.count; t < r; t++)wu.fromBufferAttribute(a, t), s && (xu.fromBufferAttribute(e1, t), wu.add(xu)), i = Math.max(i, n.distanceToSquared(wu));
                    }
                    this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
                }
            }
            computeTangents() {
                const e1 = this.index, t = this.attributes;
                if (null === e1 || void 0 === t.position || void 0 === t.normal || void 0 === t.uv) return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
                const n = e1.array, i = t.position.array, r = t.normal.array, a = t.uv.array, s = i.length / 3;
                !1 === this.hasAttribute("tangent") && this.setAttribute("tangent", new ou(new Float32Array(4 * s), 4));
                const o = this.getAttribute("tangent").array, l = [], c = [];
                for(let e1 = 0; e1 < s; e1++)l[e1] = new Cl, c[e1] = new Cl;
                const u = new Cl, h = new Cl, d = new Cl, p = new Jo, f = new Jo, m = new Jo, g = new Cl, A = new Cl;
                function v(e1, t, n) {
                    u.fromArray(i, 3 * e1), h.fromArray(i, 3 * t), d.fromArray(i, 3 * n), p.fromArray(a, 2 * e1), f.fromArray(a, 2 * t), m.fromArray(a, 2 * n), h.sub(u), d.sub(u), f.sub(p), m.sub(p);
                    const r = 1 / (f.x * m.y - m.x * f.y);
                    isFinite(r) && (g.copy(h).multiplyScalar(m.y).addScaledVector(d, -f.y).multiplyScalar(r), A.copy(d).multiplyScalar(f.x).addScaledVector(h, -m.x).multiplyScalar(r), l[e1].add(g), l[t].add(g), l[n].add(g), c[e1].add(A), c[t].add(A), c[n].add(A));
                }
                let M = this.groups;
                0 === M.length && (M = [
                    {
                        start: 0,
                        count: n.length
                    }
                ]);
                for(let e1 = 0, t = M.length; e1 < t; ++e1){
                    const t = M[e1], i = t.start;
                    for(let e1 = i, r = i + t.count; e1 < r; e1 += 3)v(n[e1 + 0], n[e1 + 1], n[e1 + 2]);
                }
                const y = new Cl, x = new Cl, _ = new Cl, b = new Cl;
                function w(e1) {
                    _.fromArray(r, 3 * e1), b.copy(_);
                    const t = l[e1];
                    y.copy(t), y.sub(_.multiplyScalar(_.dot(t))).normalize(), x.crossVectors(b, t);
                    const n = x.dot(c[e1]) < 0 ? -1 : 1;
                    o[4 * e1] = y.x, o[4 * e1 + 1] = y.y, o[4 * e1 + 2] = y.z, o[4 * e1 + 3] = n;
                }
                for(let e1 = 0, t = M.length; e1 < t; ++e1){
                    const t = M[e1], i = t.start;
                    for(let e1 = i, r = i + t.count; e1 < r; e1 += 3)w(n[e1 + 0]), w(n[e1 + 1]), w(n[e1 + 2]);
                }
            }
            computeVertexNormals() {
                const e1 = this.index, t = this.getAttribute("position");
                if (void 0 !== t) {
                    let n = this.getAttribute("normal");
                    if (void 0 === n) n = new ou(new Float32Array(3 * t.count), 3), this.setAttribute("normal", n);
                    else for(let e1 = 0, t = n.count; e1 < t; e1++)n.setXYZ(e1, 0, 0, 0);
                    const i = new Cl, r = new Cl, a = new Cl, s = new Cl, o = new Cl, l = new Cl, c = new Cl, u = new Cl;
                    if (e1) for(let h = 0, d = e1.count; h < d; h += 3){
                        const d = e1.getX(h + 0), p = e1.getX(h + 1), f = e1.getX(h + 2);
                        i.fromBufferAttribute(t, d), r.fromBufferAttribute(t, p), a.fromBufferAttribute(t, f), c.subVectors(a, r), u.subVectors(i, r), c.cross(u), s.fromBufferAttribute(n, d), o.fromBufferAttribute(n, p), l.fromBufferAttribute(n, f), s.add(c), o.add(c), l.add(c), n.setXYZ(d, s.x, s.y, s.z), n.setXYZ(p, o.x, o.y, o.z), n.setXYZ(f, l.x, l.y, l.z);
                    }
                    else for(let e1 = 0, s = t.count; e1 < s; e1 += 3)i.fromBufferAttribute(t, e1 + 0), r.fromBufferAttribute(t, e1 + 1), a.fromBufferAttribute(t, e1 + 2), c.subVectors(a, r), u.subVectors(i, r), c.cross(u), n.setXYZ(e1 + 0, c.x, c.y, c.z), n.setXYZ(e1 + 1, c.x, c.y, c.z), n.setXYZ(e1 + 2, c.x, c.y, c.z);
                    this.normalizeNormals(), n.needsUpdate = !0;
                }
            }
            normalizeNormals() {
                const e1 = this.attributes.normal;
                for(let t = 0, n = e1.count; t < n; t++)wu.fromBufferAttribute(e1, t), wu.normalize(), e1.setXYZ(t, wu.x, wu.y, wu.z);
            }
            toNonIndexed() {
                function e1(e1, t) {
                    const n = e1.array, i = e1.itemSize, r = e1.normalized, a = new n.constructor(t.length * i);
                    let s = 0, o = 0;
                    for(let r = 0, l = t.length; r < l; r++){
                        s = e1.isInterleavedBufferAttribute ? t[r] * e1.data.stride + e1.offset : t[r] * i;
                        for(let e1 = 0; e1 < i; e1++)a[o++] = n[s++];
                    }
                    return new ou(a, i, r);
                }
                if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
                const t = new Eu, n = this.index.array, i = this.attributes;
                for(const r in i){
                    const a = e1(i[r], n);
                    t.setAttribute(r, a);
                }
                const r = this.morphAttributes;
                for(const i in r){
                    const a = [], s = r[i];
                    for(let t = 0, i = s.length; t < i; t++){
                        const i = e1(s[t], n);
                        a.push(i);
                    }
                    t.morphAttributes[i] = a;
                }
                t.morphTargetsRelative = this.morphTargetsRelative;
                const a = this.groups;
                for(let e1 = 0, n = a.length; e1 < n; e1++){
                    const n = a[e1];
                    t.addGroup(n.start, n.count, n.materialIndex);
                }
                return t;
            }
            toJSON() {
                const e1 = {
                    metadata: {
                        version: 4.6,
                        type: "BufferGeometry",
                        generator: "BufferGeometry.toJSON"
                    }
                };
                if (e1.uuid = this.uuid, e1.type = this.type, "" !== this.name && (e1.name = this.name), Object.keys(this.userData).length > 0 && (e1.userData = this.userData), void 0 !== this.parameters) {
                    const t = this.parameters;
                    for(const n in t)void 0 !== t[n] && (e1[n] = t[n]);
                    return e1;
                }
                e1.data = {
                    attributes: {}
                };
                const t = this.index;
                null !== t && (e1.data.index = {
                    type: t.array.constructor.name,
                    array: Array.prototype.slice.call(t.array)
                });
                const n = this.attributes;
                for(const t in n){
                    const i = n[t];
                    e1.data.attributes[t] = i.toJSON(e1.data);
                }
                const i = {};
                let r = !1;
                for(const t in this.morphAttributes){
                    const n = this.morphAttributes[t], a = [];
                    for(let t = 0, i = n.length; t < i; t++){
                        const i = n[t];
                        a.push(i.toJSON(e1.data));
                    }
                    a.length > 0 && (i[t] = a, r = !0);
                }
                r && (e1.data.morphAttributes = i, e1.data.morphTargetsRelative = this.morphTargetsRelative);
                const a = this.groups;
                a.length > 0 && (e1.data.groups = JSON.parse(JSON.stringify(a)));
                const s = this.boundingSphere;
                return null !== s && (e1.data.boundingSphere = {
                    center: s.center.toArray(),
                    radius: s.radius
                }), e1;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
                const t = {};
                this.name = e1.name;
                const n = e1.index;
                null !== n && this.setIndex(n.clone(t));
                const i = e1.attributes;
                for(const e1 in i){
                    const n = i[e1];
                    this.setAttribute(e1, n.clone(t));
                }
                const r = e1.morphAttributes;
                for(const e1 in r){
                    const n = [], i = r[e1];
                    for(let e1 = 0, r = i.length; e1 < r; e1++)n.push(i[e1].clone(t));
                    this.morphAttributes[e1] = n;
                }
                this.morphTargetsRelative = e1.morphTargetsRelative;
                const a = e1.groups;
                for(let e1 = 0, t = a.length; e1 < t; e1++){
                    const t = a[e1];
                    this.addGroup(t.start, t.count, t.materialIndex);
                }
                const s = e1.boundingBox;
                null !== s && (this.boundingBox = s.clone());
                const o = e1.boundingSphere;
                return null !== o && (this.boundingSphere = o.clone()), this.drawRange.start = e1.drawRange.start, this.drawRange.count = e1.drawRange.count, this.userData = e1.userData, this;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        const Tu = new oc, Su = new sc, Iu = new Jl, Nu = new Cl, Du = new Cl, Cu = new Cl, Lu = new Cl, Ru = new Cl, zu = new Cl, Ou = new Jo, Pu = new Jo, Uu = new Jo, ku = new Cl, ju = new Cl, Bu = new Cl, Fu = new Cl, Hu = new Cl;
        class Vu extends Lc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Eu, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new $c;
                super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e1, this.material = t, this.updateMorphTargets();
            }
            copy(e1, t) {
                return super.copy(e1, t), void 0 !== e1.morphTargetInfluences && (this.morphTargetInfluences = e1.morphTargetInfluences.slice()), void 0 !== e1.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, e1.morphTargetDictionary)), this.material = Array.isArray(e1.material) ? e1.material.slice() : e1.material, this.geometry = e1.geometry, this;
            }
            updateMorphTargets() {
                const e1 = this.geometry.morphAttributes, t = Object.keys(e1);
                if (t.length > 0) {
                    const n = e1[t[0]];
                    if (void 0 !== n) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let e1 = 0, t = n.length; e1 < t; e1++){
                            const t = n[e1].name || String(e1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e1;
                        }
                    }
                }
            }
            getVertexPosition(e1, t) {
                const n = this.geometry, i = n.attributes.position, r = n.morphAttributes.position, a = n.morphTargetsRelative;
                t.fromBufferAttribute(i, e1);
                const s = this.morphTargetInfluences;
                if (r && s) {
                    zu.set(0, 0, 0);
                    for(let n = 0, i = r.length; n < i; n++){
                        const i = s[n], o = r[n];
                        0 !== i && (Ru.fromBufferAttribute(o, e1), a ? zu.addScaledVector(Ru, i) : zu.addScaledVector(Ru.sub(t), i));
                    }
                    t.add(zu);
                }
                return t;
            }
            raycast(e1, t) {
                const n = this.geometry, i = this.material, r = this.matrixWorld;
                if (void 0 !== i) {
                    if (null === n.boundingSphere && n.computeBoundingSphere(), Iu.copy(n.boundingSphere), Iu.applyMatrix4(r), Su.copy(e1.ray).recast(e1.near), !1 === Iu.containsPoint(Su.origin)) {
                        if (null === Su.intersectSphere(Iu, Nu)) return;
                        if (Su.origin.distanceToSquared(Nu) > (e1.far - e1.near) ** 2) return;
                    }
                    Tu.copy(r).invert(), Su.copy(e1.ray).applyMatrix4(Tu), null !== n.boundingBox && !1 === Su.intersectsBox(n.boundingBox) || this._computeIntersections(e1, t, Su);
                }
            }
            _computeIntersections(e1, t, n) {
                let i;
                const r = this.geometry, a = this.material, s = r.index, o = r.attributes.position, l = r.attributes.uv, c = r.attributes.uv1, u = r.attributes.normal, h = r.groups, d = r.drawRange;
                if (null !== s) {
                    if (Array.isArray(a)) for(let r = 0, o = h.length; r < o; r++){
                        const o = h[r], p = a[o.materialIndex];
                        for(let r = Math.max(o.start, d.start), a = Math.min(s.count, Math.min(o.start + o.count, d.start + d.count)); r < a; r += 3)i = Gu(this, p, e1, n, l, c, u, s.getX(r), s.getX(r + 1), s.getX(r + 2)), i && (i.faceIndex = Math.floor(r / 3), i.face.materialIndex = o.materialIndex, t.push(i));
                    }
                    else for(let r = Math.max(0, d.start), o = Math.min(s.count, d.start + d.count); r < o; r += 3)i = Gu(this, a, e1, n, l, c, u, s.getX(r), s.getX(r + 1), s.getX(r + 2)), i && (i.faceIndex = Math.floor(r / 3), t.push(i));
                } else if (void 0 !== o) {
                    if (Array.isArray(a)) for(let r = 0, s = h.length; r < s; r++){
                        const s = h[r], p = a[s.materialIndex];
                        for(let r = Math.max(s.start, d.start), a = Math.min(o.count, Math.min(s.start + s.count, d.start + d.count)); r < a; r += 3)i = Gu(this, p, e1, n, l, c, u, r, r + 1, r + 2), i && (i.faceIndex = Math.floor(r / 3), i.face.materialIndex = s.materialIndex, t.push(i));
                    }
                    else for(let r = Math.max(0, d.start), s = Math.min(o.count, d.start + d.count); r < s; r += 3)i = Gu(this, a, e1, n, l, c, u, r, r + 1, r + 2), i && (i.faceIndex = Math.floor(r / 3), t.push(i));
                }
            }
        }
        function Gu(e1, t, n, i, r, a, s, o, l, c) {
            e1.getVertexPosition(o, Du), e1.getVertexPosition(l, Cu), e1.getVertexPosition(c, Lu);
            const u = function(e1, t, n, i, r, a, s, o) {
                let l;
                if (l = t.side === ur ? i.intersectTriangle(s, a, r, !0, o) : i.intersectTriangle(r, a, s, t.side === cr, o), null === l) return null;
                Hu.copy(o), Hu.applyMatrix4(e1.matrixWorld);
                const c = n.ray.origin.distanceTo(Hu);
                return c < n.near || c > n.far ? null : {
                    distance: c,
                    point: Hu.clone(),
                    object: e1
                };
            }(e1, t, n, i, Du, Cu, Lu, Fu);
            if (u) {
                r && (Ou.fromBufferAttribute(r, o), Pu.fromBufferAttribute(r, l), Uu.fromBufferAttribute(r, c), u.uv = Gc.getInterpolation(Fu, Du, Cu, Lu, Ou, Pu, Uu, new Jo)), a && (Ou.fromBufferAttribute(a, o), Pu.fromBufferAttribute(a, l), Uu.fromBufferAttribute(a, c), u.uv1 = Gc.getInterpolation(Fu, Du, Cu, Lu, Ou, Pu, Uu, new Jo), u.uv2 = u.uv1), s && (ku.fromBufferAttribute(s, o), ju.fromBufferAttribute(s, l), Bu.fromBufferAttribute(s, c), u.normal = Gc.getInterpolation(Fu, Du, Cu, Lu, ku, ju, Bu, new Cl), u.normal.dot(i.direction) > 0 && u.normal.multiplyScalar(-1));
                const e1 = {
                    a: o,
                    b: l,
                    c: c,
                    normal: new Cl,
                    materialIndex: 0
                };
                Gc.getNormal(Du, Cu, Lu, e1.normal), u.face = e1;
            }
            return u;
        }
        class Qu extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 1;
                super(), this.type = "BoxGeometry", this.parameters = {
                    width: e1,
                    height: t,
                    depth: n,
                    widthSegments: i,
                    heightSegments: r,
                    depthSegments: a
                };
                const s = this;
                i = Math.floor(i), r = Math.floor(r), a = Math.floor(a);
                const o = [], l = [], c = [], u = [];
                let h = 0, d = 0;
                function p(e1, t, n, i, r, a, p, f, m, g, A) {
                    const v = a / m, M = p / g, y = a / 2, x = p / 2, _ = f / 2, b = m + 1, w = g + 1;
                    let E = 0, T = 0;
                    const S = new Cl;
                    for(let a = 0; a < w; a++){
                        const s = a * M - x;
                        for(let o = 0; o < b; o++){
                            const h = o * v - y;
                            S[e1] = h * i, S[t] = s * r, S[n] = _, l.push(S.x, S.y, S.z), S[e1] = 0, S[t] = 0, S[n] = f > 0 ? 1 : -1, c.push(S.x, S.y, S.z), u.push(o / m), u.push(1 - a / g), E += 1;
                        }
                    }
                    for(let e1 = 0; e1 < g; e1++)for(let t = 0; t < m; t++){
                        const n = h + t + b * e1, i = h + t + b * (e1 + 1), r = h + (t + 1) + b * (e1 + 1), a = h + (t + 1) + b * e1;
                        o.push(n, i, a), o.push(i, r, a), T += 6;
                    }
                    s.addGroup(d, T, A), d += T, h += E;
                }
                p("z", "y", "x", -1, -1, n, t, e1, a, r, 0), p("z", "y", "x", 1, -1, n, t, -e1, a, r, 1), p("x", "z", "y", 1, 1, e1, n, t, i, a, 2), p("x", "z", "y", 1, -1, e1, n, -t, i, a, 3), p("x", "y", "z", 1, -1, e1, t, n, i, r, 4), p("x", "y", "z", -1, -1, e1, t, -n, i, r, 5), this.setIndex(o), this.setAttribute("position", new gu(l, 3)), this.setAttribute("normal", new gu(c, 3)), this.setAttribute("uv", new gu(u, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Qu(e1.width, e1.height, e1.depth, e1.widthSegments, e1.heightSegments, e1.depthSegments);
            }
        }
        function Wu(e1) {
            const t = {};
            for(const n in e1){
                t[n] = {};
                for(const i in e1[n]){
                    const r = e1[n][i];
                    r && (r.isColor || r.isMatrix3 || r.isMatrix4 || r.isVector2 || r.isVector3 || r.isVector4 || r.isTexture || r.isQuaternion) ? r.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), t[n][i] = null) : t[n][i] = r.clone() : Array.isArray(r) ? t[n][i] = r.slice() : t[n][i] = r;
                }
            }
            return t;
        }
        function Yu(e1) {
            const t = {};
            for(let n = 0; n < e1.length; n++){
                const i = Wu(e1[n]);
                for(const e1 in i)t[e1] = i[e1];
            }
            return t;
        }
        function Xu(e1) {
            return null === e1.getRenderTarget() ? e1.outputColorSpace : dl.workingColorSpace;
        }
        const Zu = {
            clone: Wu,
            merge: Yu
        };
        class qu extends Jc {
            constructor(e1){
                super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = "void main() {\n	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
                    derivatives: !1,
                    fragDepth: !1,
                    drawBuffers: !1,
                    shaderTextureLOD: !1
                }, this.defaultAttributeValues = {
                    color: [
                        1,
                        1,
                        1
                    ],
                    uv: [
                        0,
                        0
                    ],
                    uv1: [
                        0,
                        0
                    ]
                }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, void 0 !== e1 && this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.fragmentShader = e1.fragmentShader, this.vertexShader = e1.vertexShader, this.uniforms = Wu(e1.uniforms), this.uniformsGroups = function(e1) {
                    const t = [];
                    for(let n = 0; n < e1.length; n++)t.push(e1[n].clone());
                    return t;
                }(e1.uniformsGroups), this.defines = Object.assign({}, e1.defines), this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.fog = e1.fog, this.lights = e1.lights, this.clipping = e1.clipping, this.extensions = Object.assign({}, e1.extensions), this.glslVersion = e1.glslVersion, this;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                t.glslVersion = this.glslVersion, t.uniforms = {};
                for(const n in this.uniforms){
                    const i = this.uniforms[n].value;
                    i && i.isTexture ? t.uniforms[n] = {
                        type: "t",
                        value: i.toJSON(e1).uuid
                    } : i && i.isColor ? t.uniforms[n] = {
                        type: "c",
                        value: i.getHex()
                    } : i && i.isVector2 ? t.uniforms[n] = {
                        type: "v2",
                        value: i.toArray()
                    } : i && i.isVector3 ? t.uniforms[n] = {
                        type: "v3",
                        value: i.toArray()
                    } : i && i.isVector4 ? t.uniforms[n] = {
                        type: "v4",
                        value: i.toArray()
                    } : i && i.isMatrix3 ? t.uniforms[n] = {
                        type: "m3",
                        value: i.toArray()
                    } : i && i.isMatrix4 ? t.uniforms[n] = {
                        type: "m4",
                        value: i.toArray()
                    } : t.uniforms[n] = {
                        value: i
                    };
                }
                Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader, t.lights = this.lights, t.clipping = this.clipping;
                const n = {};
                for(const e1 in this.extensions)!0 === this.extensions[e1] && (n[e1] = !0);
                return Object.keys(n).length > 0 && (t.extensions = n), t;
            }
        }
        class Ku extends Lc {
            constructor(){
                super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new oc, this.projectionMatrix = new oc, this.projectionMatrixInverse = new oc, this.coordinateSystem = Oo;
            }
            copy(e1, t) {
                return super.copy(e1, t), this.matrixWorldInverse.copy(e1.matrixWorldInverse), this.projectionMatrix.copy(e1.projectionMatrix), this.projectionMatrixInverse.copy(e1.projectionMatrixInverse), this.coordinateSystem = e1.coordinateSystem, this;
            }
            getWorldDirection(e1) {
                return super.getWorldDirection(e1).negate();
            }
            updateMatrixWorld(e1) {
                super.updateMatrixWorld(e1), this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
            updateWorldMatrix(e1, t) {
                super.updateWorldMatrix(e1, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class Ju extends Ku {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 50, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : .1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 2e3;
                super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e1, this.zoom = 1, this.near = n, this.far = i, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
            }
            copy(e1, t) {
                return super.copy(e1, t), this.fov = e1.fov, this.zoom = e1.zoom, this.near = e1.near, this.far = e1.far, this.focus = e1.focus, this.aspect = e1.aspect, this.view = null === e1.view ? null : Object.assign({}, e1.view), this.filmGauge = e1.filmGauge, this.filmOffset = e1.filmOffset, this;
            }
            setFocalLength(e1) {
                const t = .5 * this.getFilmHeight() / e1;
                this.fov = 2 * Fo * Math.atan(t), this.updateProjectionMatrix();
            }
            getFocalLength() {
                const e1 = Math.tan(.5 * Bo * this.fov);
                return .5 * this.getFilmHeight() / e1;
            }
            getEffectiveFOV() {
                return 2 * Fo * Math.atan(Math.tan(.5 * Bo * this.fov) / this.zoom);
            }
            getFilmWidth() {
                return this.filmGauge * Math.min(this.aspect, 1);
            }
            getFilmHeight() {
                return this.filmGauge / Math.max(this.aspect, 1);
            }
            setViewOffset(e1, t, n, i, r, a) {
                this.aspect = e1 / t, null === this.view && (this.view = {
                    enabled: !0,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                }), this.view.enabled = !0, this.view.fullWidth = e1, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
            }
            clearViewOffset() {
                null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
            }
            updateProjectionMatrix() {
                const e1 = this.near;
                let t = e1 * Math.tan(.5 * Bo * this.fov) / this.zoom, n = 2 * t, i = this.aspect * n, r = -0.5 * i;
                const a = this.view;
                if (null !== this.view && this.view.enabled) {
                    const e1 = a.fullWidth, s = a.fullHeight;
                    r += a.offsetX * i / e1, t -= a.offsetY * n / s, i *= a.width / e1, n *= a.height / s;
                }
                const s = this.filmOffset;
                0 !== s && (r += e1 * s / this.getFilmWidth()), this.projectionMatrix.makePerspective(r, r + i, t, t - n, e1, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, null !== this.view && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
            }
        }
        const $u = -90;
        class eh extends Lc {
            constructor(e1, t, n){
                super(), this.type = "CubeCamera", this.renderTarget = n, this.coordinateSystem = null, this.activeMipmapLevel = 0;
                const i = new Ju($u, 1, e1, t);
                i.layers = this.layers, this.add(i);
                const r = new Ju($u, 1, e1, t);
                r.layers = this.layers, this.add(r);
                const a = new Ju($u, 1, e1, t);
                a.layers = this.layers, this.add(a);
                const s = new Ju($u, 1, e1, t);
                s.layers = this.layers, this.add(s);
                const o = new Ju($u, 1, e1, t);
                o.layers = this.layers, this.add(o);
                const l = new Ju($u, 1, e1, t);
                l.layers = this.layers, this.add(l);
            }
            updateCoordinateSystem() {
                const e1 = this.coordinateSystem, t = this.children.concat(), [n, i, r, a, s, o] = t;
                for (const e1 of t)this.remove(e1);
                if (e1 === Oo) n.up.set(0, 1, 0), n.lookAt(1, 0, 0), i.up.set(0, 1, 0), i.lookAt(-1, 0, 0), r.up.set(0, 0, -1), r.lookAt(0, 1, 0), a.up.set(0, 0, 1), a.lookAt(0, -1, 0), s.up.set(0, 1, 0), s.lookAt(0, 0, 1), o.up.set(0, 1, 0), o.lookAt(0, 0, -1);
                else {
                    if (e1 !== Po) throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e1);
                    n.up.set(0, -1, 0), n.lookAt(-1, 0, 0), i.up.set(0, -1, 0), i.lookAt(1, 0, 0), r.up.set(0, 0, 1), r.lookAt(0, 1, 0), a.up.set(0, 0, -1), a.lookAt(0, -1, 0), s.up.set(0, -1, 0), s.lookAt(0, 0, 1), o.up.set(0, -1, 0), o.lookAt(0, 0, -1);
                }
                for (const e1 of t)this.add(e1), e1.updateMatrixWorld();
            }
            update(e1, t) {
                null === this.parent && this.updateMatrixWorld();
                const { renderTarget: n, activeMipmapLevel: i } = this;
                this.coordinateSystem !== e1.coordinateSystem && (this.coordinateSystem = e1.coordinateSystem, this.updateCoordinateSystem());
                const [r, a, s, o, l, c] = this.children, u = e1.getRenderTarget(), h = e1.getActiveCubeFace(), d = e1.getActiveMipmapLevel(), p = e1.xr.enabled;
                e1.xr.enabled = !1;
                const f = n.texture.generateMipmaps;
                n.texture.generateMipmaps = !1, e1.setRenderTarget(n, 0, i), e1.render(t, r), e1.setRenderTarget(n, 1, i), e1.render(t, a), e1.setRenderTarget(n, 2, i), e1.render(t, s), e1.setRenderTarget(n, 3, i), e1.render(t, o), e1.setRenderTarget(n, 4, i), e1.render(t, l), n.texture.generateMipmaps = f, e1.setRenderTarget(n, 5, i), e1.render(t, c), e1.setRenderTarget(u, h, d), e1.xr.enabled = p, n.texture.needsPMREMUpdate = !0;
            }
        }
        class th extends xl {
            constructor(e1, t, n, i, r, a, s, o, l, c){
                super(e1 = void 0 !== e1 ? e1 : [], t = void 0 !== t ? t : aa, n, i, r, a, s, o, l, c), this.isCubeTexture = !0, this.flipY = !1;
            }
            get images() {
                return this.image;
            }
            set images(e1) {
                this.image = e1;
            }
        }
        class nh extends wl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                super(e1, e1, t), this.isWebGLCubeRenderTarget = !0;
                const n = {
                    width: e1,
                    height: e1,
                    depth: 1
                }, i = [
                    n,
                    n,
                    n,
                    n,
                    n,
                    n
                ];
                void 0 !== t.encoding && (ol("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace."), t.colorSpace = t.encoding === ks ? Gs : Vs), this.texture = new th(i, t.mapping, t.wrapS, t.wrapT, t.magFilter, t.minFilter, t.format, t.type, t.anisotropy, t.colorSpace), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = void 0 !== t.generateMipmaps && t.generateMipmaps, this.texture.minFilter = void 0 !== t.minFilter ? t.minFilter : va;
            }
            fromEquirectangularTexture(e1, t) {
                this.texture.type = t.type, this.texture.colorSpace = t.colorSpace, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
                const n = new Qu(5, 5, 5), i = new qu({
                    name: "CubemapFromEquirect",
                    uniforms: Wu({
                        tEquirect: {
                            value: null
                        }
                    }),
                    vertexShader: "\n\n				varying vec3 vWorldDirection;\n\n				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n				}\n\n				void main() {\n\n					vWorldDirection = transformDirection( position, modelMatrix );\n\n					#include <begin_vertex>\n					#include <project_vertex>\n\n				}\n			",
                    fragmentShader: "\n\n				uniform sampler2D tEquirect;\n\n				varying vec3 vWorldDirection;\n\n				#include <common>\n\n				void main() {\n\n					vec3 direction = normalize( vWorldDirection );\n\n					vec2 sampleUV = equirectUv( direction );\n\n					gl_FragColor = texture2D( tEquirect, sampleUV );\n\n				}\n			",
                    side: ur,
                    blending: pr
                });
                i.uniforms.tEquirect.value = t;
                const r = new Vu(n, i), a = t.minFilter;
                return t.minFilter === xa && (t.minFilter = va), new eh(1, 10, this).update(e1, r), t.minFilter = a, r.geometry.dispose(), r.material.dispose(), this;
            }
            clear(e1, t, n, i) {
                const r = e1.getRenderTarget();
                for(let r = 0; r < 6; r++)e1.setRenderTarget(this, r), e1.clear(t, n, i);
                e1.setRenderTarget(r);
            }
        }
        const ih = new Cl, rh = new Cl, ah = new $o;
        class sh {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Cl(1, 0, 0), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                this.isPlane = !0, this.normal = e1, this.constant = t;
            }
            set(e1, t) {
                return this.normal.copy(e1), this.constant = t, this;
            }
            setComponents(e1, t, n, i) {
                return this.normal.set(e1, t, n), this.constant = i, this;
            }
            setFromNormalAndCoplanarPoint(e1, t) {
                return this.normal.copy(e1), this.constant = -t.dot(this.normal), this;
            }
            setFromCoplanarPoints(e1, t, n) {
                const i = ih.subVectors(n, t).cross(rh.subVectors(e1, t)).normalize();
                return this.setFromNormalAndCoplanarPoint(i, e1), this;
            }
            copy(e1) {
                return this.normal.copy(e1.normal), this.constant = e1.constant, this;
            }
            normalize() {
                const e1 = 1 / this.normal.length();
                return this.normal.multiplyScalar(e1), this.constant *= e1, this;
            }
            negate() {
                return this.constant *= -1, this.normal.negate(), this;
            }
            distanceToPoint(e1) {
                return this.normal.dot(e1) + this.constant;
            }
            distanceToSphere(e1) {
                return this.distanceToPoint(e1.center) - e1.radius;
            }
            projectPoint(e1, t) {
                return t.copy(e1).addScaledVector(this.normal, -this.distanceToPoint(e1));
            }
            intersectLine(e1, t) {
                const n = e1.delta(ih), i = this.normal.dot(n);
                if (0 === i) return 0 === this.distanceToPoint(e1.start) ? t.copy(e1.start) : null;
                const r = -(e1.start.dot(this.normal) + this.constant) / i;
                return r < 0 || r > 1 ? null : t.copy(e1.start).addScaledVector(n, r);
            }
            intersectsLine(e1) {
                const t = this.distanceToPoint(e1.start), n = this.distanceToPoint(e1.end);
                return t < 0 && n > 0 || n < 0 && t > 0;
            }
            intersectsBox(e1) {
                return e1.intersectsPlane(this);
            }
            intersectsSphere(e1) {
                return e1.intersectsPlane(this);
            }
            coplanarPoint(e1) {
                return e1.copy(this.normal).multiplyScalar(-this.constant);
            }
            applyMatrix4(e1, t) {
                const n = t || ah.getNormalMatrix(e1), i = this.coplanarPoint(ih).applyMatrix4(e1), r = this.normal.applyMatrix3(n).normalize();
                return this.constant = -i.dot(r), this;
            }
            translate(e1) {
                return this.constant -= e1.dot(this.normal), this;
            }
            equals(e1) {
                return e1.normal.equals(this.normal) && e1.constant === this.constant;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const oh = new Jl, lh = new Cl;
        class ch {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new sh, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new sh, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new sh, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : new sh, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : new sh, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : new sh;
                this.planes = [
                    e1,
                    t,
                    n,
                    i,
                    r,
                    a
                ];
            }
            set(e1, t, n, i, r, a) {
                const s = this.planes;
                return s[0].copy(e1), s[1].copy(t), s[2].copy(n), s[3].copy(i), s[4].copy(r), s[5].copy(a), this;
            }
            copy(e1) {
                const t = this.planes;
                for(let n = 0; n < 6; n++)t[n].copy(e1.planes[n]);
                return this;
            }
            setFromProjectionMatrix(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Oo;
                const n = this.planes, i = e1.elements, r = i[0], a = i[1], s = i[2], o = i[3], l = i[4], c = i[5], u = i[6], h = i[7], d = i[8], p = i[9], f = i[10], m = i[11], g = i[12], A = i[13], v = i[14], M = i[15];
                if (n[0].setComponents(o - r, h - l, m - d, M - g).normalize(), n[1].setComponents(o + r, h + l, m + d, M + g).normalize(), n[2].setComponents(o + a, h + c, m + p, M + A).normalize(), n[3].setComponents(o - a, h - c, m - p, M - A).normalize(), n[4].setComponents(o - s, h - u, m - f, M - v).normalize(), t === Oo) n[5].setComponents(o + s, h + u, m + f, M + v).normalize();
                else {
                    if (t !== Po) throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t);
                    n[5].setComponents(s, u, f, v).normalize();
                }
                return this;
            }
            intersectsObject(e1) {
                if (void 0 !== e1.boundingSphere) null === e1.boundingSphere && e1.computeBoundingSphere(), oh.copy(e1.boundingSphere).applyMatrix4(e1.matrixWorld);
                else {
                    const t = e1.geometry;
                    null === t.boundingSphere && t.computeBoundingSphere(), oh.copy(t.boundingSphere).applyMatrix4(e1.matrixWorld);
                }
                return this.intersectsSphere(oh);
            }
            intersectsSprite(e1) {
                return oh.center.set(0, 0, 0), oh.radius = .7071067811865476, oh.applyMatrix4(e1.matrixWorld), this.intersectsSphere(oh);
            }
            intersectsSphere(e1) {
                const t = this.planes, n = e1.center, i = -e1.radius;
                for(let e1 = 0; e1 < 6; e1++)if (t[e1].distanceToPoint(n) < i) return !1;
                return !0;
            }
            intersectsBox(e1) {
                const t = this.planes;
                for(let n = 0; n < 6; n++){
                    const i = t[n];
                    if (lh.x = i.normal.x > 0 ? e1.max.x : e1.min.x, lh.y = i.normal.y > 0 ? e1.max.y : e1.min.y, lh.z = i.normal.z > 0 ? e1.max.z : e1.min.z, i.distanceToPoint(lh) < 0) return !1;
                }
                return !0;
            }
            containsPoint(e1) {
                const t = this.planes;
                for(let n = 0; n < 6; n++)if (t[n].distanceToPoint(e1) < 0) return !1;
                return !0;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        function uh() {
            let e1 = null, t = !1, n = null, i = null;
            function r(t, a) {
                n(t, a), i = e1.requestAnimationFrame(r);
            }
            return {
                start: function() {
                    !0 !== t && null !== n && (i = e1.requestAnimationFrame(r), t = !0);
                },
                stop: function() {
                    e1.cancelAnimationFrame(i), t = !1;
                },
                setAnimationLoop: function(e1) {
                    n = e1;
                },
                setContext: function(t) {
                    e1 = t;
                }
            };
        }
        function hh(e1, t) {
            const n = t.isWebGL2, i = new WeakMap;
            return {
                get: function(e1) {
                    return e1.isInterleavedBufferAttribute && (e1 = e1.data), i.get(e1);
                },
                remove: function(t) {
                    t.isInterleavedBufferAttribute && (t = t.data);
                    const n = i.get(t);
                    n && (e1.deleteBuffer(n.buffer), i.delete(t));
                },
                update: function(t, r) {
                    if (t.isGLBufferAttribute) {
                        const e1 = i.get(t);
                        return void ((!e1 || e1.version < t.version) && i.set(t, {
                            buffer: t.buffer,
                            type: t.type,
                            bytesPerElement: t.elementSize,
                            version: t.version
                        }));
                    }
                    t.isInterleavedBufferAttribute && (t = t.data);
                    const a = i.get(t);
                    void 0 === a ? i.set(t, function(t, i) {
                        const r = t.array, a = t.usage, s = e1.createBuffer();
                        let o;
                        if (e1.bindBuffer(i, s), e1.bufferData(i, r, a), t.onUploadCallback(), r instanceof Float32Array) o = e1.FLOAT;
                        else if (r instanceof Uint16Array) {
                            if (t.isFloat16BufferAttribute) {
                                if (!n) throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
                                o = e1.HALF_FLOAT;
                            } else o = e1.UNSIGNED_SHORT;
                        } else if (r instanceof Int16Array) o = e1.SHORT;
                        else if (r instanceof Uint32Array) o = e1.UNSIGNED_INT;
                        else if (r instanceof Int32Array) o = e1.INT;
                        else if (r instanceof Int8Array) o = e1.BYTE;
                        else if (r instanceof Uint8Array) o = e1.UNSIGNED_BYTE;
                        else {
                            if (!(r instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + r);
                            o = e1.UNSIGNED_BYTE;
                        }
                        return {
                            buffer: s,
                            type: o,
                            bytesPerElement: r.BYTES_PER_ELEMENT,
                            version: t.version
                        };
                    }(t, r)) : a.version < t.version && (function(t, i, r) {
                        const a = i.array, s = i.updateRange;
                        e1.bindBuffer(r, t), -1 === s.count ? e1.bufferSubData(r, 0, a) : (n ? e1.bufferSubData(r, s.offset * a.BYTES_PER_ELEMENT, a, s.offset, s.count) : e1.bufferSubData(r, s.offset * a.BYTES_PER_ELEMENT, a.subarray(s.offset, s.offset + s.count)), s.count = -1), i.onUploadCallback();
                    }(a.buffer, t, r), a.version = t.version);
                }
            };
        }
        class dh extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                super(), this.type = "PlaneGeometry", this.parameters = {
                    width: e1,
                    height: t,
                    widthSegments: n,
                    heightSegments: i
                };
                const r = e1 / 2, a = t / 2, s = Math.floor(n), o = Math.floor(i), l = s + 1, c = o + 1, u = e1 / s, h = t / o, d = [], p = [], f = [], m = [];
                for(let e1 = 0; e1 < c; e1++){
                    const t = e1 * h - a;
                    for(let n = 0; n < l; n++){
                        const i = n * u - r;
                        p.push(i, -t, 0), f.push(0, 0, 1), m.push(n / s), m.push(1 - e1 / o);
                    }
                }
                for(let e1 = 0; e1 < o; e1++)for(let t = 0; t < s; t++){
                    const n = t + l * e1, i = t + l * (e1 + 1), r = t + 1 + l * (e1 + 1), a = t + 1 + l * e1;
                    d.push(n, i, a), d.push(i, r, a);
                }
                this.setIndex(d), this.setAttribute("position", new gu(p, 3)), this.setAttribute("normal", new gu(f, 3)), this.setAttribute("uv", new gu(m, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new dh(e1.width, e1.height, e1.widthSegments, e1.heightSegments);
            }
        }
        const ph = {
            alphahash_fragment: "#ifdef USE_ALPHAHASH\n	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif",
            alphahash_pars_fragment: "#ifdef USE_ALPHAHASH\n	const float ALPHA_HASH_SCALE = 0.05;\n	float hash2D( vec2 value ) {\n		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n	}\n	float hash3D( vec3 value ) {\n		return hash2D( vec2( hash2D( value.xy ), value.z ) );\n	}\n	float getAlphaHashThreshold( vec3 position ) {\n		float maxDeriv = max(\n			length( dFdx( position.xyz ) ),\n			length( dFdy( position.xyz ) )\n		);\n		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n		vec2 pixScales = vec2(\n			exp2( floor( log2( pixScale ) ) ),\n			exp2( ceil( log2( pixScale ) ) )\n		);\n		vec2 alpha = vec2(\n			hash3D( floor( pixScales.x * position.xyz ) ),\n			hash3D( floor( pixScales.y * position.xyz ) )\n		);\n		float lerpFactor = fract( log2( pixScale ) );\n		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n		float a = min( lerpFactor, 1.0 - lerpFactor );\n		vec3 cases = vec3(\n			x * x / ( 2.0 * a * ( 1.0 - a ) ),\n			( x - 0.5 * a ) / ( 1.0 - a ),\n			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n		);\n		float threshold = ( x < ( 1.0 - a ) )\n			? ( ( x < a ) ? cases.x : cases.y )\n			: cases.z;\n		return clamp( threshold , 1.0e-6, 1.0 );\n	}\n#endif",
            alphamap_fragment: "#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
            alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
            alphatest_fragment: "#ifdef USE_ALPHATEST\n	if ( diffuseColor.a < alphaTest ) discard;\n#endif",
            alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n	uniform float alphaTest;\n#endif",
            aomap_fragment: "#ifdef USE_AOMAP\n	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n	reflectedLight.indirectDiffuse *= ambientOcclusion;\n	#if defined( USE_CLEARCOAT ) \n		clearcoatSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_SHEEN ) \n		sheenSpecularIndirect *= ambientOcclusion;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD )\n		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n	#endif\n#endif",
            aomap_pars_fragment: "#ifdef USE_AOMAP\n	uniform sampler2D aoMap;\n	uniform float aoMapIntensity;\n#endif",
            begin_vertex: "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n	vPosition = vec3( position );\n#endif",
            beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n	vec3 objectTangent = vec3( tangent.xyz );\n#endif",
            bsdfs: "float G_BlinnPhong_Implicit( ) {\n	return 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( specularColor, 1.0, dotVH );\n	float G = G_BlinnPhong_Implicit( );\n	float D = D_BlinnPhong( shininess, dotNH );\n	return F * ( G * D );\n} // validated",
            iridescence_fragment: "#ifdef USE_IRIDESCENCE\n	const mat3 XYZ_TO_REC709 = mat3(\n		 3.2404542, -0.9692660,  0.0556434,\n		-1.5371385,  1.8760108, -0.2040259,\n		-0.4985314,  0.0415560,  1.0572252\n	);\n	vec3 Fresnel0ToIor( vec3 fresnel0 ) {\n		vec3 sqrtF0 = sqrt( fresnel0 );\n		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n	}\n	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n	}\n	float IorToFresnel0( float transmittedIor, float incidentIor ) {\n		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n	}\n	vec3 evalSensitivity( float OPD, vec3 shift ) {\n		float phase = 2.0 * PI * OPD * 1.0e-9;\n		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n		xyz /= 1.0685e-7;\n		vec3 rgb = XYZ_TO_REC709 * xyz;\n		return rgb;\n	}\n	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n		vec3 I;\n		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n		float cosTheta2Sq = 1.0 - sinTheta2Sq;\n		if ( cosTheta2Sq < 0.0 ) {\n			return vec3( 1.0 );\n		}\n		float cosTheta2 = sqrt( cosTheta2Sq );\n		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n		float R12 = F_Schlick( R0, 1.0, cosTheta1 );\n		float T121 = 1.0 - R12;\n		float phi12 = 0.0;\n		if ( iridescenceIOR < outsideIOR ) phi12 = PI;\n		float phi21 = PI - phi12;\n		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n		vec3 phi23 = vec3( 0.0 );\n		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n		vec3 phi = vec3( phi21 ) + phi23;\n		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n		vec3 r123 = sqrt( R123 );\n		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n		vec3 C0 = R12 + Rs;\n		I = C0;\n		vec3 Cm = Rs - T121;\n		for ( int m = 1; m <= 2; ++ m ) {\n			Cm *= r123;\n			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n			I += Cm * Sm;\n		}\n		return max( I, vec3( 0.0 ) );\n	}\n#endif",
            bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n	uniform sampler2D bumpMap;\n	uniform float bumpScale;\n	vec2 dHdxy_fwd() {\n		vec2 dSTdx = dFdx( vBumpMapUv );\n		vec2 dSTdy = dFdy( vBumpMapUv );\n		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n		return vec2( dBx, dBy );\n	}\n	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n		vec3 vN = surf_norm;\n		vec3 R1 = cross( vSigmaY, vN );\n		vec3 R2 = cross( vN, vSigmaX );\n		float fDet = dot( vSigmaX, R1 ) * faceDirection;\n		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n		return normalize( abs( fDet ) * surf_norm - vGrad );\n	}\n#endif",
            clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n	vec4 plane;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n		plane = clippingPlanes[ i ];\n		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n	}\n	#pragma unroll_loop_end\n	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n		bool clipped = true;\n		#pragma unroll_loop_start\n		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n			plane = clippingPlanes[ i ];\n			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n		}\n		#pragma unroll_loop_end\n		if ( clipped ) discard;\n	#endif\n#endif",
            clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
            clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n	varying vec3 vClipPosition;\n#endif",
            clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n	vClipPosition = - mvPosition.xyz;\n#endif",
            color_fragment: "#if defined( USE_COLOR_ALPHA )\n	diffuseColor *= vColor;\n#elif defined( USE_COLOR )\n	diffuseColor.rgb *= vColor;\n#endif",
            color_pars_fragment: "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR )\n	varying vec3 vColor;\n#endif",
            color_pars_vertex: "#if defined( USE_COLOR_ALPHA )\n	varying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	varying vec3 vColor;\n#endif",
            color_vertex: "#if defined( USE_COLOR_ALPHA )\n	vColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n	vColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n	vColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n	vColor.xyz *= instanceColor.xyz;\n#endif",
            common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n	const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n	return fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n	float precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n	float precisionSafeLength( vec3 v ) {\n		float maxComponent = max3( abs( v ) );\n		return length( v / maxComponent ) * maxComponent;\n	}\n#endif\nstruct IncidentLight {\n	vec3 color;\n	vec3 direction;\n	bool visible;\n};\nstruct ReflectedLight {\n	vec3 directDiffuse;\n	vec3 directSpecular;\n	vec3 indirectDiffuse;\n	vec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n	varying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n	mat3 tmp;\n	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n	return tmp;\n}\nfloat luminance( const in vec3 rgb ) {\n	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\n	return dot( weights, rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n	return m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n	return vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n	return RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
            cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n	#define cubeUV_minMipLevel 4.0\n	#define cubeUV_minTileSize 16.0\n	float getFace( vec3 direction ) {\n		vec3 absDirection = abs( direction );\n		float face = - 1.0;\n		if ( absDirection.x > absDirection.z ) {\n			if ( absDirection.x > absDirection.y )\n				face = direction.x > 0.0 ? 0.0 : 3.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		} else {\n			if ( absDirection.z > absDirection.y )\n				face = direction.z > 0.0 ? 2.0 : 5.0;\n			else\n				face = direction.y > 0.0 ? 1.0 : 4.0;\n		}\n		return face;\n	}\n	vec2 getUV( vec3 direction, float face ) {\n		vec2 uv;\n		if ( face == 0.0 ) {\n			uv = vec2( direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 1.0 ) {\n			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n		} else if ( face == 2.0 ) {\n			uv = vec2( - direction.x, direction.y ) / abs( direction.z );\n		} else if ( face == 3.0 ) {\n			uv = vec2( - direction.z, direction.y ) / abs( direction.x );\n		} else if ( face == 4.0 ) {\n			uv = vec2( - direction.x, direction.z ) / abs( direction.y );\n		} else {\n			uv = vec2( direction.x, direction.y ) / abs( direction.z );\n		}\n		return 0.5 * ( uv + 1.0 );\n	}\n	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n		float face = getFace( direction );\n		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n		mipInt = max( mipInt, cubeUV_minMipLevel );\n		float faceSize = exp2( mipInt );\n		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n		if ( face > 2.0 ) {\n			uv.y += faceSize;\n			face -= 3.0;\n		}\n		uv.x += face * faceSize;\n		uv.x += filterInt * 3.0 * cubeUV_minTileSize;\n		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n		uv.x *= CUBEUV_TEXEL_WIDTH;\n		uv.y *= CUBEUV_TEXEL_HEIGHT;\n		#ifdef texture2DGradEXT\n			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n		#else\n			return texture2D( envMap, uv ).rgb;\n		#endif\n	}\n	#define cubeUV_r0 1.0\n	#define cubeUV_v0 0.339\n	#define cubeUV_m0 - 2.0\n	#define cubeUV_r1 0.8\n	#define cubeUV_v1 0.276\n	#define cubeUV_m1 - 1.0\n	#define cubeUV_r4 0.4\n	#define cubeUV_v4 0.046\n	#define cubeUV_m4 2.0\n	#define cubeUV_r5 0.305\n	#define cubeUV_v5 0.016\n	#define cubeUV_m5 3.0\n	#define cubeUV_r6 0.21\n	#define cubeUV_v6 0.0038\n	#define cubeUV_m6 4.0\n	float roughnessToMip( float roughness ) {\n		float mip = 0.0;\n		if ( roughness >= cubeUV_r1 ) {\n			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n		} else if ( roughness >= cubeUV_r4 ) {\n			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n		} else if ( roughness >= cubeUV_r5 ) {\n			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n		} else if ( roughness >= cubeUV_r6 ) {\n			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n		} else {\n			mip = - 2.0 * log2( 1.16 * roughness );		}\n		return mip;\n	}\n	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n		float mipF = fract( mip );\n		float mipInt = floor( mip );\n		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n		if ( mipF == 0.0 ) {\n			return vec4( color0, 1.0 );\n		} else {\n			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n			return vec4( mix( color0, color1, mipF ), 1.0 );\n		}\n	}\n#endif",
            defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n	mat3 m = mat3( instanceMatrix );\n	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n	transformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n	transformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#ifdef FLIP_SIDED\n		transformedTangent = - transformedTangent;\n	#endif\n#endif",
            displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n	uniform sampler2D displacementMap;\n	uniform float displacementScale;\n	uniform float displacementBias;\n#endif",
            displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
            emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n	totalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
            emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n	uniform sampler2D emissiveMap;\n#endif",
            colorspace_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
            colorspace_pars_fragment: "\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\n	vec3( 0.8224621, 0.177538, 0.0 ),\n	vec3( 0.0331941, 0.9668058, 0.0 ),\n	vec3( 0.0170827, 0.0723974, 0.9105199 )\n);\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\n	vec3( 1.2249401, - 0.2249404, 0.0 ),\n	vec3( - 0.0420569, 1.0420571, 0.0 ),\n	vec3( - 0.0196376, - 0.0786361, 1.0982735 )\n);\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\n	return vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\n}\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\n	return vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\n}\nvec4 LinearTransferOETF( in vec4 value ) {\n	return value;\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 LinearToLinear( in vec4 value ) {\n	return value;\n}\nvec4 LinearTosRGB( in vec4 value ) {\n	return sRGBTransferOETF( value );\n}",
            envmap_fragment: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vec3 cameraToFrag;\n		if ( isOrthographic ) {\n			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToFrag = normalize( vWorldPosition - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vec3 reflectVec = reflect( cameraToFrag, worldNormal );\n		#else\n			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n		#endif\n	#else\n		vec3 reflectVec = vReflect;\n	#endif\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n	#else\n		vec4 envColor = vec4( 0.0 );\n	#endif\n	#ifdef ENVMAP_BLENDING_MULTIPLY\n		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_MIX )\n		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n	#elif defined( ENVMAP_BLENDING_ADD )\n		outgoingLight += envColor.xyz * specularStrength * reflectivity;\n	#endif\n#endif",
            envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float envMapIntensity;\n	uniform float flipEnvMap;\n	#ifdef ENVMAP_TYPE_CUBE\n		uniform samplerCube envMap;\n	#else\n		uniform sampler2D envMap;\n	#endif\n	\n#endif",
            envmap_pars_fragment: "#ifdef USE_ENVMAP\n	uniform float reflectivity;\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		varying vec3 vWorldPosition;\n		uniform float refractionRatio;\n	#else\n		varying vec3 vReflect;\n	#endif\n#endif",
            envmap_pars_vertex: "#ifdef USE_ENVMAP\n	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n		#define ENV_WORLDPOS\n	#endif\n	#ifdef ENV_WORLDPOS\n		\n		varying vec3 vWorldPosition;\n	#else\n		varying vec3 vReflect;\n		uniform float refractionRatio;\n	#endif\n#endif",
            envmap_physical_pars_fragment: "#ifdef USE_ENVMAP\n	vec3 getIBLIrradiance( const in vec3 normal ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n			return PI * envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n		#ifdef ENVMAP_TYPE_CUBE_UV\n			vec3 reflectVec = reflect( - viewDir, normal );\n			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n			return envMapColor.rgb * envMapIntensity;\n		#else\n			return vec3( 0.0 );\n		#endif\n	}\n	#ifdef USE_ANISOTROPY\n		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n			#ifdef ENVMAP_TYPE_CUBE_UV\n				vec3 bentNormal = cross( bitangent, viewDir );\n				bentNormal = normalize( cross( bentNormal, bitangent ) );\n				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n				return getIBLRadiance( viewDir, bentNormal, roughness );\n			#else\n				return vec3( 0.0 );\n			#endif\n		}\n	#endif\n#endif",
            envmap_vertex: "#ifdef USE_ENVMAP\n	#ifdef ENV_WORLDPOS\n		vWorldPosition = worldPosition.xyz;\n	#else\n		vec3 cameraToVertex;\n		if ( isOrthographic ) {\n			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n		} else {\n			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n		}\n		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n		#ifdef ENVMAP_MODE_REFLECTION\n			vReflect = reflect( cameraToVertex, worldNormal );\n		#else\n			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n		#endif\n	#endif\n#endif",
            fog_vertex: "#ifdef USE_FOG\n	vFogDepth = - mvPosition.z;\n#endif",
            fog_pars_vertex: "#ifdef USE_FOG\n	varying float vFogDepth;\n#endif",
            fog_fragment: "#ifdef USE_FOG\n	#ifdef FOG_EXP2\n		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n	#else\n		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n	#endif\n	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
            fog_pars_fragment: "#ifdef USE_FOG\n	uniform vec3 fogColor;\n	varying float vFogDepth;\n	#ifdef FOG_EXP2\n		uniform float fogDensity;\n	#else\n		uniform float fogNear;\n		uniform float fogFar;\n	#endif\n#endif",
            gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n	uniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n	float dotNL = dot( normal, lightDirection );\n	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n	#ifdef USE_GRADIENTMAP\n		return vec3( texture2D( gradientMap, coord ).r );\n	#else\n		vec2 fw = fwidth( coord ) * 0.5;\n		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n	#endif\n}",
            lightmap_fragment: "#ifdef USE_LIGHTMAP\n	vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n	reflectedLight.indirectDiffuse += lightMapIrradiance;\n#endif",
            lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n	uniform sampler2D lightMap;\n	uniform float lightMapIntensity;\n#endif",
            lights_lambert_fragment: "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
            lights_lambert_pars_fragment: "varying vec3 vViewPosition;\nstruct LambertMaterial {\n	vec3 diffuseColor;\n	float specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Lambert\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert",
            lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n	uniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n	float x = normal.x, y = normal.y, z = normal.z;\n	vec3 result = shCoefficients[ 0 ] * 0.886227;\n	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n	return result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n	return irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n	vec3 irradiance = ambientLightColor;\n	return irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n	#if defined ( LEGACY_LIGHTS )\n		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\n		}\n		return 1.0;\n	#else\n		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n		if ( cutoffDistance > 0.0 ) {\n			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n		}\n		return distanceFalloff;\n	#endif\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n	return smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n	struct DirectionalLight {\n		vec3 direction;\n		vec3 color;\n	};\n	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n		light.color = directionalLight.color;\n		light.direction = directionalLight.direction;\n		light.visible = true;\n	}\n#endif\n#if NUM_POINT_LIGHTS > 0\n	struct PointLight {\n		vec3 position;\n		vec3 color;\n		float distance;\n		float decay;\n	};\n	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = pointLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float lightDistance = length( lVector );\n		light.color = pointLight.color;\n		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n		light.visible = ( light.color != vec3( 0.0 ) );\n	}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n	struct SpotLight {\n		vec3 position;\n		vec3 direction;\n		vec3 color;\n		float distance;\n		float decay;\n		float coneCos;\n		float penumbraCos;\n	};\n	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n		vec3 lVector = spotLight.position - geometryPosition;\n		light.direction = normalize( lVector );\n		float angleCos = dot( light.direction, spotLight.direction );\n		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n		if ( spotAttenuation > 0.0 ) {\n			float lightDistance = length( lVector );\n			light.color = spotLight.color * spotAttenuation;\n			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n			light.visible = ( light.color != vec3( 0.0 ) );\n		} else {\n			light.color = vec3( 0.0 );\n			light.visible = false;\n		}\n	}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n	struct RectAreaLight {\n		vec3 color;\n		vec3 position;\n		vec3 halfWidth;\n		vec3 halfHeight;\n	};\n	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;\n	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n	struct HemisphereLight {\n		vec3 direction;\n		vec3 skyColor;\n		vec3 groundColor;\n	};\n	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n		float dotNL = dot( normal, hemiLight.direction );\n		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n		return irradiance;\n	}\n#endif",
            lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
            lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n	vec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_Toon\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon",
            lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
            lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n	vec3 diffuseColor;\n	vec3 specularColor;\n	float specularShininess;\n	float specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct				RE_Direct_BlinnPhong\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong",
            lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n	material.ior = ior;\n	#ifdef USE_SPECULAR\n		float specularIntensityFactor = specularIntensity;\n		vec3 specularColorFactor = specularColor;\n		#ifdef USE_SPECULAR_COLORMAP\n			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n		#endif\n		#ifdef USE_SPECULAR_INTENSITYMAP\n			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n		#endif\n		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n	#else\n		float specularIntensityFactor = 1.0;\n		vec3 specularColorFactor = vec3( 1.0 );\n		material.specularF90 = 1.0;\n	#endif\n	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n	material.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n	material.clearcoat = clearcoat;\n	material.clearcoatRoughness = clearcoatRoughness;\n	material.clearcoatF0 = vec3( 0.04 );\n	material.clearcoatF90 = 1.0;\n	#ifdef USE_CLEARCOATMAP\n		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n	#endif\n	#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n	#endif\n	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n	material.clearcoatRoughness += geometryRoughness;\n	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_IRIDESCENCE\n	material.iridescence = iridescence;\n	material.iridescenceIOR = iridescenceIOR;\n	#ifdef USE_IRIDESCENCEMAP\n		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n	#endif\n	#ifdef USE_IRIDESCENCE_THICKNESSMAP\n		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n	#else\n		material.iridescenceThickness = iridescenceThicknessMaximum;\n	#endif\n#endif\n#ifdef USE_SHEEN\n	material.sheenColor = sheenColor;\n	#ifdef USE_SHEEN_COLORMAP\n		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n	#endif\n	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	#ifdef USE_ANISOTROPYMAP\n		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n	#else\n		vec2 anisotropyV = anisotropyVector;\n	#endif\n	material.anisotropy = length( anisotropyV );\n	anisotropyV /= material.anisotropy;\n	material.anisotropy = saturate( material.anisotropy );\n	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n	material.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\n	material.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\n#endif",
            lights_physical_pars_fragment: "struct PhysicalMaterial {\n	vec3 diffuseColor;\n	float roughness;\n	vec3 specularColor;\n	float specularF90;\n	#ifdef USE_CLEARCOAT\n		float clearcoat;\n		float clearcoatRoughness;\n		vec3 clearcoatF0;\n		float clearcoatF90;\n	#endif\n	#ifdef USE_IRIDESCENCE\n		float iridescence;\n		float iridescenceIOR;\n		float iridescenceThickness;\n		vec3 iridescenceFresnel;\n		vec3 iridescenceF0;\n	#endif\n	#ifdef USE_SHEEN\n		vec3 sheenColor;\n		float sheenRoughness;\n	#endif\n	#ifdef IOR\n		float ior;\n	#endif\n	#ifdef USE_TRANSMISSION\n		float transmission;\n		float transmissionAlpha;\n		float thickness;\n		float attenuationDistance;\n		vec3 attenuationColor;\n	#endif\n	#ifdef USE_ANISOTROPY\n		float anisotropy;\n		float alphaT;\n		vec3 anisotropyT;\n		vec3 anisotropyB;\n	#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n	float a2 = pow2( alpha );\n	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n	return 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n	float a2 = pow2( alpha );\n	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n	return RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n		float v = 0.5 / ( gv + gl );\n		return saturate(v);\n	}\n	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n		float a2 = alphaT * alphaB;\n		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n		highp float v2 = dot( v, v );\n		float w2 = a2 / v2;\n		return RECIPROCAL_PI * a2 * pow2 ( w2 );\n	}\n#endif\n#ifdef USE_CLEARCOAT\n	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n		vec3 f0 = material.clearcoatF0;\n		float f90 = material.clearcoatF90;\n		float roughness = material.clearcoatRoughness;\n		float alpha = pow2( roughness );\n		vec3 halfDir = normalize( lightDir + viewDir );\n		float dotNL = saturate( dot( normal, lightDir ) );\n		float dotNV = saturate( dot( normal, viewDir ) );\n		float dotNH = saturate( dot( normal, halfDir ) );\n		float dotVH = saturate( dot( viewDir, halfDir ) );\n		vec3 F = F_Schlick( f0, f90, dotVH );\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n		return F * ( V * D );\n	}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n	vec3 f0 = material.specularColor;\n	float f90 = material.specularF90;\n	float roughness = material.roughness;\n	float alpha = pow2( roughness );\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float dotVH = saturate( dot( viewDir, halfDir ) );\n	vec3 F = F_Schlick( f0, f90, dotVH );\n	#ifdef USE_IRIDESCENCE\n		F = mix( F, material.iridescenceFresnel, material.iridescence );\n	#endif\n	#ifdef USE_ANISOTROPY\n		float dotTL = dot( material.anisotropyT, lightDir );\n		float dotTV = dot( material.anisotropyT, viewDir );\n		float dotTH = dot( material.anisotropyT, halfDir );\n		float dotBL = dot( material.anisotropyB, lightDir );\n		float dotBV = dot( material.anisotropyB, viewDir );\n		float dotBH = dot( material.anisotropyB, halfDir );\n		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n	#else\n		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n		float D = D_GGX( alpha, dotNH );\n	#endif\n	return F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n	const float LUT_SIZE = 64.0;\n	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n	const float LUT_BIAS = 0.5 / LUT_SIZE;\n	float dotNV = saturate( dot( N, V ) );\n	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n	uv = uv * LUT_SCALE + LUT_BIAS;\n	return uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n	float l = length( f );\n	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n	float x = dot( v1, v2 );\n	float y = abs( x );\n	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n	float b = 3.4175940 + ( 4.1616724 + y ) * y;\n	float v = a / b;\n	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n	return cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n	vec3 lightNormal = cross( v1, v2 );\n	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n	vec3 T1, T2;\n	T1 = normalize( V - N * dot( V, N ) );\n	T2 = - cross( N, T1 );\n	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n	vec3 coords[ 4 ];\n	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n	coords[ 0 ] = normalize( coords[ 0 ] );\n	coords[ 1 ] = normalize( coords[ 1 ] );\n	coords[ 2 ] = normalize( coords[ 2 ] );\n	coords[ 3 ] = normalize( coords[ 3 ] );\n	vec3 vectorFormFactor = vec3( 0.0 );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n	return vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n	float alpha = pow2( roughness );\n	float invAlpha = 1.0 / alpha;\n	float cos2h = dotNH * dotNH;\n	float sin2h = max( 1.0 - cos2h, 0.0078125 );\n	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n	vec3 halfDir = normalize( lightDir + viewDir );\n	float dotNL = saturate( dot( normal, lightDir ) );\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float dotNH = saturate( dot( normal, halfDir ) );\n	float D = D_Charlie( sheenRoughness, dotNH );\n	float V = V_Neubelt( dotNV, dotNL );\n	return sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	float r2 = roughness * roughness;\n	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n	return saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n	float dotNV = saturate( dot( normal, viewDir ) );\n	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n	vec4 r = roughness * c0 + c1;\n	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n	return fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	return specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n	vec2 fab = DFGApprox( normal, viewDir, roughness );\n	#ifdef USE_IRIDESCENCE\n		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n	#else\n		vec3 Fr = specularColor;\n	#endif\n	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n	float Ess = fab.x + fab.y;\n	float Ems = 1.0 - Ess;\n	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n	singleScatter += FssEss;\n	multiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n		vec3 normal = geometryNormal;\n		vec3 viewDir = geometryViewDir;\n		vec3 position = geometryPosition;\n		vec3 lightPos = rectAreaLight.position;\n		vec3 halfWidth = rectAreaLight.halfWidth;\n		vec3 halfHeight = rectAreaLight.halfHeight;\n		vec3 lightColor = rectAreaLight.color;\n		float roughness = material.roughness;\n		vec3 rectCoords[ 4 ];\n		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n		vec2 uv = LTC_Uv( normal, viewDir, roughness );\n		vec4 t1 = texture2D( ltc_1, uv );\n		vec4 t2 = texture2D( ltc_2, uv );\n		mat3 mInv = mat3(\n			vec3( t1.x, 0, t1.y ),\n			vec3(    0, 1,    0 ),\n			vec3( t1.z, 0, t1.w )\n		);\n		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n	}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n	vec3 irradiance = dotNL * directLight.color;\n	#ifdef USE_CLEARCOAT\n		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n		vec3 ccIrradiance = dotNLcc * directLight.color;\n		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n	#endif\n	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n	#ifdef USE_CLEARCOAT\n		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n	#endif\n	#ifdef USE_SHEEN\n		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n	#endif\n	vec3 singleScattering = vec3( 0.0 );\n	vec3 multiScattering = vec3( 0.0 );\n	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n	#ifdef USE_IRIDESCENCE\n		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n	#else\n		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n	#endif\n	vec3 totalScattering = singleScattering + multiScattering;\n	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n	reflectedLight.indirectSpecular += radiance * singleScattering;\n	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct				RE_Direct_Physical\n#define RE_Direct_RectArea		RE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular		RE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
            lights_fragment_begin: "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n	geometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n	float dotNVi = saturate( dot( normal, geometryViewDir ) );\n	if ( material.iridescenceThickness == 0.0 ) {\n		material.iridescence = 0.0;\n	} else {\n		material.iridescence = saturate( material.iridescence );\n	}\n	if ( material.iridescence > 0.0 ) {\n		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n	}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n	PointLight pointLight;\n	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n		pointLight = pointLights[ i ];\n		getPointLightInfo( pointLight, geometryPosition, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n		pointLightShadow = pointLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n	SpotLight spotLight;\n	vec4 spotColor;\n	vec3 spotLightCoord;\n	bool inSpotLightMap;\n	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n		spotLight = spotLights[ i ];\n		getSpotLightInfo( spotLight, geometryPosition, directLight );\n		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n		#else\n		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n		#endif\n		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n		#endif\n		#undef SPOT_LIGHT_MAP_INDEX\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n		spotLightShadow = spotLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n	DirectionalLight directionalLight;\n	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLightShadow;\n	#endif\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n		directionalLight = directionalLights[ i ];\n		getDirectionalLightInfo( directionalLight, directLight );\n		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n		directionalLightShadow = directionalLightShadows[ i ];\n		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n		#endif\n		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n	RectAreaLight rectAreaLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n		rectAreaLight = rectAreaLights[ i ];\n		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n	}\n	#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n	vec3 iblIrradiance = vec3( 0.0 );\n	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n	#if defined( USE_LIGHT_PROBES )\n		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n	#endif\n	#if ( NUM_HEMI_LIGHTS > 0 )\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if defined( RE_IndirectSpecular )\n	vec3 radiance = vec3( 0.0 );\n	vec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
            lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n		irradiance += lightMapIrradiance;\n	#endif\n	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n		iblIrradiance += getIBLIrradiance( geometryNormal );\n	#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n	#ifdef USE_ANISOTROPY\n		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n	#else\n		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n	#endif\n	#ifdef USE_CLEARCOAT\n		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n	#endif\n#endif",
            lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif",
            logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
            logdepthbuf_pars_fragment: "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n	uniform float logDepthBufFC;\n	varying float vFragDepth;\n	varying float vIsPerspective;\n#endif",
            logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		varying float vFragDepth;\n		varying float vIsPerspective;\n	#else\n		uniform float logDepthBufFC;\n	#endif\n#endif",
            logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n	#ifdef USE_LOGDEPTHBUF_EXT\n		vFragDepth = 1.0 + gl_Position.w;\n		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n	#else\n		if ( isPerspectiveMatrix( projectionMatrix ) ) {\n			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n			gl_Position.z *= gl_Position.w;\n		}\n	#endif\n#endif",
            map_fragment: "#ifdef USE_MAP\n	vec4 sampledDiffuseColor = texture2D( map, vMapUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\n	\n	#endif\n	diffuseColor *= sampledDiffuseColor;\n#endif",
            map_pars_fragment: "#ifdef USE_MAP\n	uniform sampler2D map;\n#endif",
            map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n	#if defined( USE_POINTS_UV )\n		vec2 uv = vUv;\n	#else\n		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n	#endif\n#endif\n#ifdef USE_MAP\n	diffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n	diffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
            map_particle_pars_fragment: "#if defined( USE_POINTS_UV )\n	varying vec2 vUv;\n#else\n	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n		uniform mat3 uvTransform;\n	#endif\n#endif\n#ifdef USE_MAP\n	uniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform sampler2D alphaMap;\n#endif",
            metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n	metalnessFactor *= texelMetalness.b;\n#endif",
            metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n	uniform sampler2D metalnessMap;\n#endif",
            morphcolor_vertex: "#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\n	vColor *= morphTargetBaseInfluence;\n	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n		#if defined( USE_COLOR_ALPHA )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n		#elif defined( USE_COLOR )\n			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n		#endif\n	}\n#endif",
            morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n	objectNormal *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n	#endif\n#endif",
            morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n	uniform float morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n		uniform sampler2DArray morphTargetsTexture;\n		uniform ivec2 morphTargetsTextureSize;\n		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n			int y = texelIndex / morphTargetsTextureSize.x;\n			int x = texelIndex - y * morphTargetsTextureSize.x;\n			ivec3 morphUV = ivec3( x, y, morphTargetIndex );\n			return texelFetch( morphTargetsTexture, morphUV, 0 );\n		}\n	#else\n		#ifndef USE_MORPHNORMALS\n			uniform float morphTargetInfluences[ 8 ];\n		#else\n			uniform float morphTargetInfluences[ 4 ];\n		#endif\n	#endif\n#endif",
            morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n	transformed *= morphTargetBaseInfluence;\n	#ifdef MORPHTARGETS_TEXTURE\n		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n		}\n	#else\n		transformed += morphTarget0 * morphTargetInfluences[ 0 ];\n		transformed += morphTarget1 * morphTargetInfluences[ 1 ];\n		transformed += morphTarget2 * morphTargetInfluences[ 2 ];\n		transformed += morphTarget3 * morphTargetInfluences[ 3 ];\n		#ifndef USE_MORPHNORMALS\n			transformed += morphTarget4 * morphTargetInfluences[ 4 ];\n			transformed += morphTarget5 * morphTargetInfluences[ 5 ];\n			transformed += morphTarget6 * morphTargetInfluences[ 6 ];\n			transformed += morphTarget7 * morphTargetInfluences[ 7 ];\n		#endif\n	#endif\n#endif",
            normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n	vec3 fdx = dFdx( vViewPosition );\n	vec3 fdy = dFdy( vViewPosition );\n	vec3 normal = normalize( cross( fdx, fdy ) );\n#else\n	vec3 normal = normalize( vNormal );\n	#ifdef DOUBLE_SIDED\n		normal *= faceDirection;\n	#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n	#ifdef USE_TANGENT\n		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn = getTangentFrame( - vViewPosition, normal,\n		#if defined( USE_NORMALMAP )\n			vNormalMapUv\n		#elif defined( USE_CLEARCOAT_NORMALMAP )\n			vClearcoatNormalMapUv\n		#else\n			vUv\n		#endif\n		);\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn[0] *= faceDirection;\n		tbn[1] *= faceDirection;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	#ifdef USE_TANGENT\n		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n	#else\n		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n	#endif\n	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n		tbn2[0] *= faceDirection;\n		tbn2[1] *= faceDirection;\n	#endif\n#endif\nvec3 nonPerturbedNormal = normal;",
            normal_fragment_maps: "#ifdef USE_NORMALMAP_OBJECTSPACE\n	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	#ifdef FLIP_SIDED\n		normal = - normal;\n	#endif\n	#ifdef DOUBLE_SIDED\n		normal = normal * faceDirection;\n	#endif\n	normal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n	mapN.xy *= normalScale;\n	normal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
            normal_pars_fragment: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
            normal_pars_vertex: "#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n	#ifdef USE_TANGENT\n		varying vec3 vTangent;\n		varying vec3 vBitangent;\n	#endif\n#endif",
            normal_vertex: "#ifndef FLAT_SHADED\n	vNormal = normalize( transformedNormal );\n	#ifdef USE_TANGENT\n		vTangent = normalize( transformedTangent );\n		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n	#endif\n#endif",
            normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n	uniform sampler2D normalMap;\n	uniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n	uniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n		vec3 q0 = dFdx( eye_pos.xyz );\n		vec3 q1 = dFdy( eye_pos.xyz );\n		vec2 st0 = dFdx( uv.st );\n		vec2 st1 = dFdy( uv.st );\n		vec3 N = surf_norm;\n		vec3 q1perp = cross( q1, N );\n		vec3 q0perp = cross( N, q0 );\n		vec3 T = q1perp * st0.x + q0perp * st1.x;\n		vec3 B = q1perp * st0.y + q0perp * st1.y;\n		float det = max( dot( T, T ), dot( B, B ) );\n		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n		return mat3( T * scale, B * scale, N );\n	}\n#endif",
            clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n	vec3 clearcoatNormal = nonPerturbedNormal;\n#endif",
            clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n	clearcoatMapN.xy *= clearcoatNormalScale;\n	clearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
            clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n	uniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform sampler2D clearcoatNormalMap;\n	uniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform sampler2D clearcoatRoughnessMap;\n#endif",
            iridescence_pars_fragment: "#ifdef USE_IRIDESCENCEMAP\n	uniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform sampler2D iridescenceThicknessMap;\n#endif",
            opaque_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
            packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n	return normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n	return 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n	vec4 r = vec4( fract( v * PackFactors ), v );\n	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n	return dot( v, UnpackFactors );\n}\nvec2 packDepthToRG( in highp float v ) {\n	return packDepthToRGBA( v ).yx;\n}\nfloat unpackRGToDepth( const in highp vec2 v ) {\n	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n	return ( near * far ) / ( ( far - near ) * depth - far );\n}",
            premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n	gl_FragColor.rgb *= gl_FragColor.a;\n#endif",
            project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n	mvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
            dithering_fragment: "#ifdef DITHERING\n	gl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
            dithering_pars_fragment: "#ifdef DITHERING\n	vec3 dithering( vec3 color ) {\n		float grid_position = rand( gl_FragCoord.xy );\n		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n		return color + dither_shift_RGB;\n	}\n#endif",
            roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n	roughnessFactor *= texelRoughness.g;\n#endif",
            roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n	uniform sampler2D roughnessMap;\n#endif",
            shadowmap_pars_fragment: "#if NUM_SPOT_LIGHT_COORDS > 0\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n	}\n	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n		return unpackRGBATo2Half( texture2D( shadow, uv ) );\n	}\n	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n		float occlusion = 1.0;\n		vec2 distribution = texture2DDistribution( shadow, uv );\n		float hard_shadow = step( compare , distribution.x );\n		if (hard_shadow != 1.0 ) {\n			float distance = compare - distribution.x ;\n			float variance = max( 0.00000, distribution.y * distribution.y );\n			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n		}\n		return occlusion;\n	}\n	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n		float shadow = 1.0;\n		shadowCoord.xyz /= shadowCoord.w;\n		shadowCoord.z += shadowBias;\n		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n		if ( frustumTest ) {\n		#if defined( SHADOWMAP_TYPE_PCF )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx0 = - texelSize.x * shadowRadius;\n			float dy0 = - texelSize.y * shadowRadius;\n			float dx1 = + texelSize.x * shadowRadius;\n			float dy1 = + texelSize.y * shadowRadius;\n			float dx2 = dx0 / 2.0;\n			float dy2 = dy0 / 2.0;\n			float dx3 = dx1 / 2.0;\n			float dy3 = dy1 / 2.0;\n			shadow = (\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n			) * ( 1.0 / 17.0 );\n		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n			float dx = texelSize.x;\n			float dy = texelSize.y;\n			vec2 uv = shadowCoord.xy;\n			vec2 f = fract( uv * shadowMapSize + 0.5 );\n			uv -= f * texelSize;\n			shadow = (\n				texture2DCompare( shadowMap, uv, shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n					 f.x ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n					 f.y ) +\n				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n						  f.x ),\n					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n						  f.x ),\n					 f.y )\n			) * ( 1.0 / 9.0 );\n		#elif defined( SHADOWMAP_TYPE_VSM )\n			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#else\n			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n		#endif\n		}\n		return shadow;\n	}\n	vec2 cubeToUV( vec3 v, float texelSizeY ) {\n		vec3 absV = abs( v );\n		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n		absV *= scaleToCube;\n		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n		vec2 planar = v.xy;\n		float almostATexel = 1.5 * texelSizeY;\n		float almostOne = 1.0 - almostATexel;\n		if ( absV.z >= almostOne ) {\n			if ( v.z > 0.0 )\n				planar.x = 4.0 - v.x;\n		} else if ( absV.x >= almostOne ) {\n			float signX = sign( v.x );\n			planar.x = v.z * signX + 2.0 * signX;\n		} else if ( absV.y >= almostOne ) {\n			float signY = sign( v.y );\n			planar.x = v.x + 2.0 * signY + 2.0;\n			planar.y = v.z * signY - 2.0;\n		}\n		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n	}\n	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n		vec3 lightToPosition = shadowCoord.xyz;\n		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;\n		vec3 bd3D = normalize( lightToPosition );\n		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n			return (\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n			) * ( 1.0 / 9.0 );\n		#else\n			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n		#endif\n	}\n#endif",
            shadowmap_pars_vertex: "#if NUM_SPOT_LIGHT_COORDS > 0\n	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n		struct DirectionalLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n		struct SpotLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n		};\n		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n		struct PointLightShadow {\n			float shadowBias;\n			float shadowNormalBias;\n			float shadowRadius;\n			vec2 shadowMapSize;\n			float shadowCameraNear;\n			float shadowCameraFar;\n		};\n		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n	#endif\n#endif",
            shadowmap_vertex: "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n	vec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n		#pragma unroll_loop_start\n		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n		}\n		#pragma unroll_loop_end\n	#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n		shadowWorldPosition = worldPosition;\n		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n		#endif\n		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n	}\n	#pragma unroll_loop_end\n#endif",
            shadowmask_pars_fragment: "float getShadowMask() {\n	float shadow = 1.0;\n	#ifdef USE_SHADOWMAP\n	#if NUM_DIR_LIGHT_SHADOWS > 0\n	DirectionalLightShadow directionalLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n		directionalLight = directionalLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_SPOT_LIGHT_SHADOWS > 0\n	SpotLightShadow spotLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n		spotLight = spotLightShadows[ i ];\n		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#if NUM_POINT_LIGHT_SHADOWS > 0\n	PointLightShadow pointLight;\n	#pragma unroll_loop_start\n	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n		pointLight = pointLightShadows[ i ];\n		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n	}\n	#pragma unroll_loop_end\n	#endif\n	#endif\n	return shadow;\n}",
            skinbase_vertex: "#ifdef USE_SKINNING\n	mat4 boneMatX = getBoneMatrix( skinIndex.x );\n	mat4 boneMatY = getBoneMatrix( skinIndex.y );\n	mat4 boneMatZ = getBoneMatrix( skinIndex.z );\n	mat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
            skinning_pars_vertex: "#ifdef USE_SKINNING\n	uniform mat4 bindMatrix;\n	uniform mat4 bindMatrixInverse;\n	uniform highp sampler2D boneTexture;\n	uniform int boneTextureSize;\n	mat4 getBoneMatrix( const in float i ) {\n		float j = i * 4.0;\n		float x = mod( j, float( boneTextureSize ) );\n		float y = floor( j / float( boneTextureSize ) );\n		float dx = 1.0 / float( boneTextureSize );\n		float dy = 1.0 / float( boneTextureSize );\n		y = dy * ( y + 0.5 );\n		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n		mat4 bone = mat4( v1, v2, v3, v4 );\n		return bone;\n	}\n#endif",
            skinning_vertex: "#ifdef USE_SKINNING\n	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n	vec4 skinned = vec4( 0.0 );\n	skinned += boneMatX * skinVertex * skinWeight.x;\n	skinned += boneMatY * skinVertex * skinWeight.y;\n	skinned += boneMatZ * skinVertex * skinWeight.z;\n	skinned += boneMatW * skinVertex * skinWeight.w;\n	transformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
            skinnormal_vertex: "#ifdef USE_SKINNING\n	mat4 skinMatrix = mat4( 0.0 );\n	skinMatrix += skinWeight.x * boneMatX;\n	skinMatrix += skinWeight.y * boneMatY;\n	skinMatrix += skinWeight.z * boneMatZ;\n	skinMatrix += skinWeight.w * boneMatW;\n	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n	#ifdef USE_TANGENT\n		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n	#endif\n#endif",
            specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n	specularStrength = texelSpecular.r;\n#else\n	specularStrength = 1.0;\n#endif",
            specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n	uniform sampler2D specularMap;\n#endif",
            tonemapping_fragment: "#if defined( TONE_MAPPING )\n	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
            tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n	return saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	return saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n	color *= toneMappingExposure;\n	color = max( vec3( 0.0 ), color - 0.004 );\n	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n	return a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n	const mat3 ACESInputMat = mat3(\n		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),\n		vec3( 0.04823, 0.01566, 0.83777 )\n	);\n	const mat3 ACESOutputMat = mat3(\n		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),\n		vec3( -0.07367, -0.00605,  1.07602 )\n	);\n	color *= toneMappingExposure / 0.6;\n	color = ACESInputMat * color;\n	color = RRTAndODTFit( color );\n	color = ACESOutputMat * color;\n	return saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
            transmission_fragment: "#ifdef USE_TRANSMISSION\n	material.transmission = transmission;\n	material.transmissionAlpha = 1.0;\n	material.thickness = thickness;\n	material.attenuationDistance = attenuationDistance;\n	material.attenuationColor = attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n	#endif\n	vec3 pos = vWorldPosition;\n	vec3 v = normalize( cameraPosition - pos );\n	vec3 n = inverseTransformDirection( normal, viewMatrix );\n	vec4 transmitted = getIBLVolumeRefraction(\n		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\n		material.attenuationColor, material.attenuationDistance );\n	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
            transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n	uniform float transmission;\n	uniform float thickness;\n	uniform float attenuationDistance;\n	uniform vec3 attenuationColor;\n	#ifdef USE_TRANSMISSIONMAP\n		uniform sampler2D transmissionMap;\n	#endif\n	#ifdef USE_THICKNESSMAP\n		uniform sampler2D thicknessMap;\n	#endif\n	uniform vec2 transmissionSamplerSize;\n	uniform sampler2D transmissionSamplerMap;\n	uniform mat4 modelMatrix;\n	uniform mat4 projectionMatrix;\n	varying vec3 vWorldPosition;\n	float w0( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n	}\n	float w1( float a ) {\n		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n	}\n	float w2( float a ){\n		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n	}\n	float w3( float a ) {\n		return ( 1.0 / 6.0 ) * ( a * a * a );\n	}\n	float g0( float a ) {\n		return w0( a ) + w1( a );\n	}\n	float g1( float a ) {\n		return w2( a ) + w3( a );\n	}\n	float h0( float a ) {\n		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n	}\n	float h1( float a ) {\n		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n	}\n	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n		uv = uv * texelSize.zw + 0.5;\n		vec2 iuv = floor( uv );\n		vec2 fuv = fract( uv );\n		float g0x = g0( fuv.x );\n		float g1x = g1( fuv.x );\n		float h0x = h0( fuv.x );\n		float h1x = h1( fuv.x );\n		float h0y = h0( fuv.y );\n		float h1y = h1( fuv.y );\n		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n	}\n	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n		vec2 fLodSizeInv = 1.0 / fLodSize;\n		vec2 cLodSizeInv = 1.0 / cLodSize;\n		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n		return mix( fSample, cSample, fract( lod ) );\n	}\n	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n		vec3 modelScale;\n		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n		return normalize( refractionVector ) * thickness * modelScale;\n	}\n	float applyIorToRoughness( const in float roughness, const in float ior ) {\n		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n	}\n	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n	}\n	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n		if ( isinf( attenuationDistance ) ) {\n			return vec3( 1.0 );\n		} else {\n			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;\n		}\n	}\n	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\n		const in vec3 attenuationColor, const in float attenuationDistance ) {\n		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n		vec3 refractedRayExit = position + transmissionRay;\n		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n		vec2 refractionCoords = ndcPos.xy / ndcPos.w;\n		refractionCoords += 1.0;\n		refractionCoords /= 2.0;\n		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n		vec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n		vec3 attenuatedColor = transmittance * transmittedLight.rgb;\n		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n	}\n#endif",
            uv_pars_fragment: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
            uv_pars_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	varying vec2 vUv;\n#endif\n#ifdef USE_MAP\n	uniform mat3 mapTransform;\n	varying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n	uniform mat3 alphaMapTransform;\n	varying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n	uniform mat3 lightMapTransform;\n	varying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n	uniform mat3 aoMapTransform;\n	varying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n	uniform mat3 bumpMapTransform;\n	varying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n	uniform mat3 normalMapTransform;\n	varying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	uniform mat3 displacementMapTransform;\n	varying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n	uniform mat3 emissiveMapTransform;\n	varying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n	uniform mat3 metalnessMapTransform;\n	varying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	uniform mat3 roughnessMapTransform;\n	varying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	uniform mat3 anisotropyMapTransform;\n	varying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n	uniform mat3 clearcoatMapTransform;\n	varying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	uniform mat3 clearcoatNormalMapTransform;\n	varying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	uniform mat3 clearcoatRoughnessMapTransform;\n	varying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	uniform mat3 sheenColorMapTransform;\n	varying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	uniform mat3 sheenRoughnessMapTransform;\n	varying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	uniform mat3 iridescenceMapTransform;\n	varying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	uniform mat3 iridescenceThicknessMapTransform;\n	varying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n	uniform mat3 specularMapTransform;\n	varying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	uniform mat3 specularColorMapTransform;\n	varying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	uniform mat3 specularIntensityMapTransform;\n	varying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	uniform mat3 transmissionMapTransform;\n	varying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n	uniform mat3 thicknessMapTransform;\n	varying vec2 vThicknessMapUv;\n#endif",
            uv_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n	vUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
            worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n	vec4 worldPosition = vec4( transformed, 1.0 );\n	#ifdef USE_INSTANCING\n		worldPosition = instanceMatrix * worldPosition;\n	#endif\n	worldPosition = modelMatrix * worldPosition;\n#endif",
            background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	gl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
            background_frag: "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n	vec4 texColor = texture2D( t2D, vUv );\n	#ifdef DECODE_VIDEO_TEXTURE\n		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            backgroundCube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
            backgroundCube_frag: "#ifdef ENVMAP_TYPE_CUBE\n	uniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n	uniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n	#ifdef ENVMAP_TYPE_CUBE\n		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n	#elif defined( ENVMAP_TYPE_CUBE_UV )\n		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\n	#else\n		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n	#endif\n	texColor.rgb *= backgroundIntensity;\n	gl_FragColor = texColor;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n	gl_Position.z = gl_Position.w;\n}",
            cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n	gl_FragColor = texColor;\n	gl_FragColor.a *= opacity;\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            depth_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vHighPrecisionZW = gl_Position.zw;\n}",
            depth_frag: "#if DEPTH_PACKING == 3200\n	uniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#if DEPTH_PACKING == 3200\n		diffuseColor.a = opacity;\n	#endif\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <logdepthbuf_fragment>\n	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n	#if DEPTH_PACKING == 3200\n		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n	#elif DEPTH_PACKING == 3201\n		gl_FragColor = packDepthToRGBA( fragCoordZ );\n	#endif\n}",
            distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <skinbase_vertex>\n	#ifdef USE_DISPLACEMENTMAP\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <worldpos_vertex>\n	#include <clipping_planes_vertex>\n	vWorldPosition = worldPosition.xyz;\n}",
            distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( 1.0 );\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	float dist = length( vWorldPosition - referencePosition );\n	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n	dist = saturate( dist );\n	gl_FragColor = packDepthToRGBA( dist );\n}",
            equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vWorldDirection = transformDirection( position, modelMatrix );\n	#include <begin_vertex>\n	#include <project_vertex>\n}",
            equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n	vec3 direction = normalize( vWorldDirection );\n	vec2 sampleUV = equirectUv( direction );\n	gl_FragColor = texture2D( tEquirect, sampleUV );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n}",
            linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	vLineDistance = scale * lineDistance;\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
            linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	if ( mod( vLineDistance, totalSize ) > dashSize ) {\n		discard;\n	}\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
            meshbasic_vert: "#include <common>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n		#include <beginnormal_vertex>\n		#include <morphnormal_vertex>\n		#include <skinbase_vertex>\n		#include <skinnormal_vertex>\n		#include <defaultnormal_vertex>\n	#endif\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <fog_vertex>\n}",
            meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n	varying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	#ifdef USE_LIGHTMAP\n		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n	#else\n		reflectedLight.indirectDiffuse += vec3( 1.0 );\n	#endif\n	#include <aomap_fragment>\n	reflectedLight.indirectDiffuse *= diffuseColor.rgb;\n	vec3 outgoingLight = reflectedLight.indirectDiffuse;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshlambert_vert: "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            meshlambert_frag: "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_lambert_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n	vViewPosition = - mvPosition.xyz;\n}",
            meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	vec3 viewDir = normalize( vViewPosition );\n	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n	vec3 y = cross( viewDir, x );\n	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n	#ifdef USE_MATCAP\n		vec4 matcapColor = texture2D( matcap, uv );\n	#else\n		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n	#endif\n	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	vViewPosition = - mvPosition.xyz;\n#endif\n}",
            meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n	varying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	#include <logdepthbuf_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n	#ifdef OPAQUE\n		gl_FragColor.a = 1.0;\n	#endif\n}",
            meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <envmap_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <specularmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_phong_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n	#include <envmap_fragment>\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n	varying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n	vWorldPosition = worldPosition.xyz;\n#endif\n}",
            meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n	#define IOR\n	#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n	uniform float ior;\n#endif\n#ifdef USE_SPECULAR\n	uniform float specularIntensity;\n	uniform vec3 specularColor;\n	#ifdef USE_SPECULAR_COLORMAP\n		uniform sampler2D specularColorMap;\n	#endif\n	#ifdef USE_SPECULAR_INTENSITYMAP\n		uniform sampler2D specularIntensityMap;\n	#endif\n#endif\n#ifdef USE_CLEARCOAT\n	uniform float clearcoat;\n	uniform float clearcoatRoughness;\n#endif\n#ifdef USE_IRIDESCENCE\n	uniform float iridescence;\n	uniform float iridescenceIOR;\n	uniform float iridescenceThicknessMinimum;\n	uniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n	uniform vec3 sheenColor;\n	uniform float sheenRoughness;\n	#ifdef USE_SHEEN_COLORMAP\n		uniform sampler2D sheenColorMap;\n	#endif\n	#ifdef USE_SHEEN_ROUGHNESSMAP\n		uniform sampler2D sheenRoughnessMap;\n	#endif\n#endif\n#ifdef USE_ANISOTROPY\n	uniform vec2 anisotropyVector;\n	#ifdef USE_ANISOTROPYMAP\n		uniform sampler2D anisotropyMap;\n	#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <roughnessmap_fragment>\n	#include <metalnessmap_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <clearcoat_normal_fragment_begin>\n	#include <clearcoat_normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_physical_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n	#include <transmission_fragment>\n	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n	#ifdef USE_SHEEN\n		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n	#endif\n	#ifdef USE_CLEARCOAT\n		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n	#endif\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <normal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <displacementmap_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	vViewPosition = - mvPosition.xyz;\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n	vec3 totalEmissiveRadiance = emissive;\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <color_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	#include <normal_fragment_begin>\n	#include <normal_fragment_maps>\n	#include <emissivemap_fragment>\n	#include <lights_toon_fragment>\n	#include <lights_fragment_begin>\n	#include <lights_fragment_maps>\n	#include <lights_fragment_end>\n	#include <aomap_fragment>\n	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n	#include <dithering_fragment>\n}",
            points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n	varying vec2 vUv;\n	uniform mat3 uvTransform;\n#endif\nvoid main() {\n	#ifdef USE_POINTS_UV\n		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n	#endif\n	#include <color_vertex>\n	#include <morphcolor_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <project_vertex>\n	gl_PointSize = size;\n	#ifdef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n	#endif\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <worldpos_vertex>\n	#include <fog_vertex>\n}",
            points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_particle_fragment>\n	#include <color_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n	#include <premultiplied_alpha_fragment>\n}",
            shadow_vert: "#include <common>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n	#include <beginnormal_vertex>\n	#include <morphnormal_vertex>\n	#include <skinbase_vertex>\n	#include <skinnormal_vertex>\n	#include <defaultnormal_vertex>\n	#include <begin_vertex>\n	#include <morphtarget_vertex>\n	#include <skinning_vertex>\n	#include <project_vertex>\n	#include <logdepthbuf_vertex>\n	#include <worldpos_vertex>\n	#include <shadowmap_vertex>\n	#include <fog_vertex>\n}",
            shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n	#include <logdepthbuf_fragment>\n	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}",
            sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n	#include <uv_vertex>\n	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n	vec2 scale;\n	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n	#ifndef USE_SIZEATTENUATION\n		bool isPerspective = isPerspectiveMatrix( projectionMatrix );\n		if ( isPerspective ) scale *= - mvPosition.z;\n	#endif\n	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n	vec2 rotatedPosition;\n	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n	mvPosition.xy += rotatedPosition;\n	gl_Position = projectionMatrix * mvPosition;\n	#include <logdepthbuf_vertex>\n	#include <clipping_planes_vertex>\n	#include <fog_vertex>\n}",
            sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n	#include <clipping_planes_fragment>\n	vec3 outgoingLight = vec3( 0.0 );\n	vec4 diffuseColor = vec4( diffuse, opacity );\n	#include <logdepthbuf_fragment>\n	#include <map_fragment>\n	#include <alphamap_fragment>\n	#include <alphatest_fragment>\n	#include <alphahash_fragment>\n	outgoingLight = diffuseColor.rgb;\n	#include <opaque_fragment>\n	#include <tonemapping_fragment>\n	#include <colorspace_fragment>\n	#include <fog_fragment>\n}"
        }, fh = {
            common: {
                diffuse: {
                    value: new Zc(16777215)
                },
                opacity: {
                    value: 1
                },
                map: {
                    value: null
                },
                mapTransform: {
                    value: new $o
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new $o
                },
                alphaTest: {
                    value: 0
                }
            },
            specularmap: {
                specularMap: {
                    value: null
                },
                specularMapTransform: {
                    value: new $o
                }
            },
            envmap: {
                envMap: {
                    value: null
                },
                flipEnvMap: {
                    value: -1
                },
                reflectivity: {
                    value: 1
                },
                ior: {
                    value: 1.5
                },
                refractionRatio: {
                    value: .98
                }
            },
            aomap: {
                aoMap: {
                    value: null
                },
                aoMapIntensity: {
                    value: 1
                },
                aoMapTransform: {
                    value: new $o
                }
            },
            lightmap: {
                lightMap: {
                    value: null
                },
                lightMapIntensity: {
                    value: 1
                },
                lightMapTransform: {
                    value: new $o
                }
            },
            bumpmap: {
                bumpMap: {
                    value: null
                },
                bumpMapTransform: {
                    value: new $o
                },
                bumpScale: {
                    value: 1
                }
            },
            normalmap: {
                normalMap: {
                    value: null
                },
                normalMapTransform: {
                    value: new $o
                },
                normalScale: {
                    value: new Jo(1, 1)
                }
            },
            displacementmap: {
                displacementMap: {
                    value: null
                },
                displacementMapTransform: {
                    value: new $o
                },
                displacementScale: {
                    value: 1
                },
                displacementBias: {
                    value: 0
                }
            },
            emissivemap: {
                emissiveMap: {
                    value: null
                },
                emissiveMapTransform: {
                    value: new $o
                }
            },
            metalnessmap: {
                metalnessMap: {
                    value: null
                },
                metalnessMapTransform: {
                    value: new $o
                }
            },
            roughnessmap: {
                roughnessMap: {
                    value: null
                },
                roughnessMapTransform: {
                    value: new $o
                }
            },
            gradientmap: {
                gradientMap: {
                    value: null
                }
            },
            fog: {
                fogDensity: {
                    value: 25e-5
                },
                fogNear: {
                    value: 1
                },
                fogFar: {
                    value: 2e3
                },
                fogColor: {
                    value: new Zc(16777215)
                }
            },
            lights: {
                ambientLightColor: {
                    value: []
                },
                lightProbe: {
                    value: []
                },
                directionalLights: {
                    value: [],
                    properties: {
                        direction: {},
                        color: {}
                    }
                },
                directionalLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {}
                    }
                },
                directionalShadowMap: {
                    value: []
                },
                directionalShadowMatrix: {
                    value: []
                },
                spotLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        direction: {},
                        distance: {},
                        coneCos: {},
                        penumbraCos: {},
                        decay: {}
                    }
                },
                spotLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {}
                    }
                },
                spotLightMap: {
                    value: []
                },
                spotShadowMap: {
                    value: []
                },
                spotLightMatrix: {
                    value: []
                },
                pointLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        decay: {},
                        distance: {}
                    }
                },
                pointLightShadows: {
                    value: [],
                    properties: {
                        shadowBias: {},
                        shadowNormalBias: {},
                        shadowRadius: {},
                        shadowMapSize: {},
                        shadowCameraNear: {},
                        shadowCameraFar: {}
                    }
                },
                pointShadowMap: {
                    value: []
                },
                pointShadowMatrix: {
                    value: []
                },
                hemisphereLights: {
                    value: [],
                    properties: {
                        direction: {},
                        skyColor: {},
                        groundColor: {}
                    }
                },
                rectAreaLights: {
                    value: [],
                    properties: {
                        color: {},
                        position: {},
                        width: {},
                        height: {}
                    }
                },
                ltc_1: {
                    value: null
                },
                ltc_2: {
                    value: null
                }
            },
            points: {
                diffuse: {
                    value: new Zc(16777215)
                },
                opacity: {
                    value: 1
                },
                size: {
                    value: 1
                },
                scale: {
                    value: 1
                },
                map: {
                    value: null
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new $o
                },
                alphaTest: {
                    value: 0
                },
                uvTransform: {
                    value: new $o
                }
            },
            sprite: {
                diffuse: {
                    value: new Zc(16777215)
                },
                opacity: {
                    value: 1
                },
                center: {
                    value: new Jo(.5, .5)
                },
                rotation: {
                    value: 0
                },
                map: {
                    value: null
                },
                mapTransform: {
                    value: new $o
                },
                alphaMap: {
                    value: null
                },
                alphaMapTransform: {
                    value: new $o
                },
                alphaTest: {
                    value: 0
                }
            }
        }, mh = {
            basic: {
                uniforms: Yu([
                    fh.common,
                    fh.specularmap,
                    fh.envmap,
                    fh.aomap,
                    fh.lightmap,
                    fh.fog
                ]),
                vertexShader: ph.meshbasic_vert,
                fragmentShader: ph.meshbasic_frag
            },
            lambert: {
                uniforms: Yu([
                    fh.common,
                    fh.specularmap,
                    fh.envmap,
                    fh.aomap,
                    fh.lightmap,
                    fh.emissivemap,
                    fh.bumpmap,
                    fh.normalmap,
                    fh.displacementmap,
                    fh.fog,
                    fh.lights,
                    {
                        emissive: {
                            value: new Zc(0)
                        }
                    }
                ]),
                vertexShader: ph.meshlambert_vert,
                fragmentShader: ph.meshlambert_frag
            },
            phong: {
                uniforms: Yu([
                    fh.common,
                    fh.specularmap,
                    fh.envmap,
                    fh.aomap,
                    fh.lightmap,
                    fh.emissivemap,
                    fh.bumpmap,
                    fh.normalmap,
                    fh.displacementmap,
                    fh.fog,
                    fh.lights,
                    {
                        emissive: {
                            value: new Zc(0)
                        },
                        specular: {
                            value: new Zc(1118481)
                        },
                        shininess: {
                            value: 30
                        }
                    }
                ]),
                vertexShader: ph.meshphong_vert,
                fragmentShader: ph.meshphong_frag
            },
            standard: {
                uniforms: Yu([
                    fh.common,
                    fh.envmap,
                    fh.aomap,
                    fh.lightmap,
                    fh.emissivemap,
                    fh.bumpmap,
                    fh.normalmap,
                    fh.displacementmap,
                    fh.roughnessmap,
                    fh.metalnessmap,
                    fh.fog,
                    fh.lights,
                    {
                        emissive: {
                            value: new Zc(0)
                        },
                        roughness: {
                            value: 1
                        },
                        metalness: {
                            value: 0
                        },
                        envMapIntensity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: ph.meshphysical_vert,
                fragmentShader: ph.meshphysical_frag
            },
            toon: {
                uniforms: Yu([
                    fh.common,
                    fh.aomap,
                    fh.lightmap,
                    fh.emissivemap,
                    fh.bumpmap,
                    fh.normalmap,
                    fh.displacementmap,
                    fh.gradientmap,
                    fh.fog,
                    fh.lights,
                    {
                        emissive: {
                            value: new Zc(0)
                        }
                    }
                ]),
                vertexShader: ph.meshtoon_vert,
                fragmentShader: ph.meshtoon_frag
            },
            matcap: {
                uniforms: Yu([
                    fh.common,
                    fh.bumpmap,
                    fh.normalmap,
                    fh.displacementmap,
                    fh.fog,
                    {
                        matcap: {
                            value: null
                        }
                    }
                ]),
                vertexShader: ph.meshmatcap_vert,
                fragmentShader: ph.meshmatcap_frag
            },
            points: {
                uniforms: Yu([
                    fh.points,
                    fh.fog
                ]),
                vertexShader: ph.points_vert,
                fragmentShader: ph.points_frag
            },
            dashed: {
                uniforms: Yu([
                    fh.common,
                    fh.fog,
                    {
                        scale: {
                            value: 1
                        },
                        dashSize: {
                            value: 1
                        },
                        totalSize: {
                            value: 2
                        }
                    }
                ]),
                vertexShader: ph.linedashed_vert,
                fragmentShader: ph.linedashed_frag
            },
            depth: {
                uniforms: Yu([
                    fh.common,
                    fh.displacementmap
                ]),
                vertexShader: ph.depth_vert,
                fragmentShader: ph.depth_frag
            },
            normal: {
                uniforms: Yu([
                    fh.common,
                    fh.bumpmap,
                    fh.normalmap,
                    fh.displacementmap,
                    {
                        opacity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: ph.meshnormal_vert,
                fragmentShader: ph.meshnormal_frag
            },
            sprite: {
                uniforms: Yu([
                    fh.sprite,
                    fh.fog
                ]),
                vertexShader: ph.sprite_vert,
                fragmentShader: ph.sprite_frag
            },
            background: {
                uniforms: {
                    uvTransform: {
                        value: new $o
                    },
                    t2D: {
                        value: null
                    },
                    backgroundIntensity: {
                        value: 1
                    }
                },
                vertexShader: ph.background_vert,
                fragmentShader: ph.background_frag
            },
            backgroundCube: {
                uniforms: {
                    envMap: {
                        value: null
                    },
                    flipEnvMap: {
                        value: -1
                    },
                    backgroundBlurriness: {
                        value: 0
                    },
                    backgroundIntensity: {
                        value: 1
                    }
                },
                vertexShader: ph.backgroundCube_vert,
                fragmentShader: ph.backgroundCube_frag
            },
            cube: {
                uniforms: {
                    tCube: {
                        value: null
                    },
                    tFlip: {
                        value: -1
                    },
                    opacity: {
                        value: 1
                    }
                },
                vertexShader: ph.cube_vert,
                fragmentShader: ph.cube_frag
            },
            equirect: {
                uniforms: {
                    tEquirect: {
                        value: null
                    }
                },
                vertexShader: ph.equirect_vert,
                fragmentShader: ph.equirect_frag
            },
            distanceRGBA: {
                uniforms: Yu([
                    fh.common,
                    fh.displacementmap,
                    {
                        referencePosition: {
                            value: new Cl
                        },
                        nearDistance: {
                            value: 1
                        },
                        farDistance: {
                            value: 1e3
                        }
                    }
                ]),
                vertexShader: ph.distanceRGBA_vert,
                fragmentShader: ph.distanceRGBA_frag
            },
            shadow: {
                uniforms: Yu([
                    fh.lights,
                    fh.fog,
                    {
                        color: {
                            value: new Zc(0)
                        },
                        opacity: {
                            value: 1
                        }
                    }
                ]),
                vertexShader: ph.shadow_vert,
                fragmentShader: ph.shadow_frag
            }
        };
        mh.physical = {
            uniforms: Yu([
                mh.standard.uniforms,
                {
                    clearcoat: {
                        value: 0
                    },
                    clearcoatMap: {
                        value: null
                    },
                    clearcoatMapTransform: {
                        value: new $o
                    },
                    clearcoatNormalMap: {
                        value: null
                    },
                    clearcoatNormalMapTransform: {
                        value: new $o
                    },
                    clearcoatNormalScale: {
                        value: new Jo(1, 1)
                    },
                    clearcoatRoughness: {
                        value: 0
                    },
                    clearcoatRoughnessMap: {
                        value: null
                    },
                    clearcoatRoughnessMapTransform: {
                        value: new $o
                    },
                    iridescence: {
                        value: 0
                    },
                    iridescenceMap: {
                        value: null
                    },
                    iridescenceMapTransform: {
                        value: new $o
                    },
                    iridescenceIOR: {
                        value: 1.3
                    },
                    iridescenceThicknessMinimum: {
                        value: 100
                    },
                    iridescenceThicknessMaximum: {
                        value: 400
                    },
                    iridescenceThicknessMap: {
                        value: null
                    },
                    iridescenceThicknessMapTransform: {
                        value: new $o
                    },
                    sheen: {
                        value: 0
                    },
                    sheenColor: {
                        value: new Zc(0)
                    },
                    sheenColorMap: {
                        value: null
                    },
                    sheenColorMapTransform: {
                        value: new $o
                    },
                    sheenRoughness: {
                        value: 1
                    },
                    sheenRoughnessMap: {
                        value: null
                    },
                    sheenRoughnessMapTransform: {
                        value: new $o
                    },
                    transmission: {
                        value: 0
                    },
                    transmissionMap: {
                        value: null
                    },
                    transmissionMapTransform: {
                        value: new $o
                    },
                    transmissionSamplerSize: {
                        value: new Jo
                    },
                    transmissionSamplerMap: {
                        value: null
                    },
                    thickness: {
                        value: 0
                    },
                    thicknessMap: {
                        value: null
                    },
                    thicknessMapTransform: {
                        value: new $o
                    },
                    attenuationDistance: {
                        value: 0
                    },
                    attenuationColor: {
                        value: new Zc(0)
                    },
                    specularColor: {
                        value: new Zc(1, 1, 1)
                    },
                    specularColorMap: {
                        value: null
                    },
                    specularColorMapTransform: {
                        value: new $o
                    },
                    specularIntensity: {
                        value: 1
                    },
                    specularIntensityMap: {
                        value: null
                    },
                    specularIntensityMapTransform: {
                        value: new $o
                    },
                    anisotropyVector: {
                        value: new Jo
                    },
                    anisotropyMap: {
                        value: null
                    },
                    anisotropyMapTransform: {
                        value: new $o
                    }
                }
            ]),
            vertexShader: ph.meshphysical_vert,
            fragmentShader: ph.meshphysical_frag
        };
        const gh = {
            r: 0,
            b: 0,
            g: 0
        };
        function Ah(e1, t, n, i, r, a, s) {
            const o = new Zc(0);
            let l, c, u = !0 === a ? 0 : 1, h = null, d = 0, p = null;
            function f(t, n) {
                t.getRGB(gh, Xu(e1)), i.buffers.color.setClear(gh.r, gh.g, gh.b, n, s);
            }
            return {
                getClearColor: function() {
                    return o;
                },
                setClearColor: function(e1) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                    o.set(e1), u = t, f(o, u);
                },
                getClearAlpha: function() {
                    return u;
                },
                setClearAlpha: function(e1) {
                    u = e1, f(o, u);
                },
                render: function(a, m) {
                    let g = !1, A = !0 === m.isScene ? m.background : null;
                    A && A.isTexture && (A = (m.backgroundBlurriness > 0 ? n : t).get(A)), null === A ? f(o, u) : A && A.isColor && (f(A, 1), g = !0);
                    const v = e1.xr.getEnvironmentBlendMode();
                    "additive" === v ? i.buffers.color.setClear(0, 0, 0, 1, s) : "alpha-blend" === v && i.buffers.color.setClear(0, 0, 0, 0, s), (e1.autoClear || g) && e1.clear(e1.autoClearColor, e1.autoClearDepth, e1.autoClearStencil), A && (A.isCubeTexture || A.mapping === ca) ? (void 0 === c && (c = new Vu(new Qu(1, 1, 1), new qu({
                        name: "BackgroundCubeMaterial",
                        uniforms: Wu(mh.backgroundCube.uniforms),
                        vertexShader: mh.backgroundCube.vertexShader,
                        fragmentShader: mh.backgroundCube.fragmentShader,
                        side: ur,
                        depthTest: !1,
                        depthWrite: !1,
                        fog: !1
                    })), c.geometry.deleteAttribute("normal"), c.geometry.deleteAttribute("uv"), c.onBeforeRender = function(e1, t, n) {
                        this.matrixWorld.copyPosition(n.matrixWorld);
                    }, Object.defineProperty(c.material, "envMap", {
                        get: function() {
                            return this.uniforms.envMap.value;
                        }
                    }), r.update(c)), c.material.uniforms.envMap.value = A, c.material.uniforms.flipEnvMap.value = A.isCubeTexture && !1 === A.isRenderTargetTexture ? -1 : 1, c.material.uniforms.backgroundBlurriness.value = m.backgroundBlurriness, c.material.uniforms.backgroundIntensity.value = m.backgroundIntensity, c.material.toneMapped = dl.getTransfer(A.colorSpace) !== Zs, h === A && d === A.version && p === e1.toneMapping || (c.material.needsUpdate = !0, h = A, d = A.version, p = e1.toneMapping), c.layers.enableAll(), a.unshift(c, c.geometry, c.material, 0, 0, null)) : A && A.isTexture && (void 0 === l && (l = new Vu(new dh(2, 2), new qu({
                        name: "BackgroundMaterial",
                        uniforms: Wu(mh.background.uniforms),
                        vertexShader: mh.background.vertexShader,
                        fragmentShader: mh.background.fragmentShader,
                        side: cr,
                        depthTest: !1,
                        depthWrite: !1,
                        fog: !1
                    })), l.geometry.deleteAttribute("normal"), Object.defineProperty(l.material, "map", {
                        get: function() {
                            return this.uniforms.t2D.value;
                        }
                    }), r.update(l)), l.material.uniforms.t2D.value = A, l.material.uniforms.backgroundIntensity.value = m.backgroundIntensity, l.material.toneMapped = dl.getTransfer(A.colorSpace) !== Zs, !0 === A.matrixAutoUpdate && A.updateMatrix(), l.material.uniforms.uvTransform.value.copy(A.matrix), h === A && d === A.version && p === e1.toneMapping || (l.material.needsUpdate = !0, h = A, d = A.version, p = e1.toneMapping), l.layers.enableAll(), a.unshift(l, l.geometry, l.material, 0, 0, null));
                }
            };
        }
        function vh(e1, t, n, i) {
            const r = e1.getParameter(e1.MAX_VERTEX_ATTRIBS), a = i.isWebGL2 ? null : t.get("OES_vertex_array_object"), s = i.isWebGL2 || null !== a, o = {}, l = p(null);
            let c = l, u = !1;
            function h(t) {
                return i.isWebGL2 ? e1.bindVertexArray(t) : a.bindVertexArrayOES(t);
            }
            function d(t) {
                return i.isWebGL2 ? e1.deleteVertexArray(t) : a.deleteVertexArrayOES(t);
            }
            function p(e1) {
                const t = [], n = [], i = [];
                for(let e1 = 0; e1 < r; e1++)t[e1] = 0, n[e1] = 0, i[e1] = 0;
                return {
                    geometry: null,
                    program: null,
                    wireframe: !1,
                    newAttributes: t,
                    enabledAttributes: n,
                    attributeDivisors: i,
                    object: e1,
                    attributes: {},
                    index: null
                };
            }
            function f() {
                const e1 = c.newAttributes;
                for(let t = 0, n = e1.length; t < n; t++)e1[t] = 0;
            }
            function m(e1) {
                g(e1, 0);
            }
            function g(n, r) {
                const a = c.newAttributes, s = c.enabledAttributes, o = c.attributeDivisors;
                a[n] = 1, 0 === s[n] && (e1.enableVertexAttribArray(n), s[n] = 1), o[n] !== r && ((i.isWebGL2 ? e1 : t.get("ANGLE_instanced_arrays"))[i.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](n, r), o[n] = r);
            }
            function A() {
                const t = c.newAttributes, n = c.enabledAttributes;
                for(let i = 0, r = n.length; i < r; i++)n[i] !== t[i] && (e1.disableVertexAttribArray(i), n[i] = 0);
            }
            function v(t, n, i, r, a, s, o) {
                !0 === o ? e1.vertexAttribIPointer(t, n, i, a, s) : e1.vertexAttribPointer(t, n, i, r, a, s);
            }
            function M() {
                y(), u = !0, c !== l && (c = l, h(c.object));
            }
            function y() {
                l.geometry = null, l.program = null, l.wireframe = !1;
            }
            return {
                setup: function(r, l, d, M, y) {
                    let x = !1;
                    if (s) {
                        const t = function(t, n, r) {
                            const s = !0 === r.wireframe;
                            let l = o[t.id];
                            void 0 === l && (l = {}, o[t.id] = l);
                            let c = l[n.id];
                            void 0 === c && (c = {}, l[n.id] = c);
                            let u = c[s];
                            return void 0 === u && (u = p(i.isWebGL2 ? e1.createVertexArray() : a.createVertexArrayOES()), c[s] = u), u;
                        }(M, d, l);
                        c !== t && (c = t, h(c.object)), x = function(e1, t, n, i) {
                            const r = c.attributes, a = t.attributes;
                            let s = 0;
                            const o = n.getAttributes();
                            for(const t in o)if (o[t].location >= 0) {
                                const n = r[t];
                                let i = a[t];
                                if (void 0 === i && ("instanceMatrix" === t && e1.instanceMatrix && (i = e1.instanceMatrix), "instanceColor" === t && e1.instanceColor && (i = e1.instanceColor)), void 0 === n) return !0;
                                if (n.attribute !== i) return !0;
                                if (i && n.data !== i.data) return !0;
                                s++;
                            }
                            return c.attributesNum !== s || c.index !== i;
                        }(r, M, d, y), x && function(e1, t, n, i) {
                            const r = {}, a = t.attributes;
                            let s = 0;
                            const o = n.getAttributes();
                            for(const t in o)if (o[t].location >= 0) {
                                let n = a[t];
                                void 0 === n && ("instanceMatrix" === t && e1.instanceMatrix && (n = e1.instanceMatrix), "instanceColor" === t && e1.instanceColor && (n = e1.instanceColor));
                                const i = {};
                                i.attribute = n, n && n.data && (i.data = n.data), r[t] = i, s++;
                            }
                            c.attributes = r, c.attributesNum = s, c.index = i;
                        }(r, M, d, y);
                    } else {
                        const e1 = !0 === l.wireframe;
                        c.geometry === M.id && c.program === d.id && c.wireframe === e1 || (c.geometry = M.id, c.program = d.id, c.wireframe = e1, x = !0);
                    }
                    null !== y && n.update(y, e1.ELEMENT_ARRAY_BUFFER), (x || u) && (u = !1, function(r, a, s, o) {
                        if (!1 === i.isWebGL2 && (r.isInstancedMesh || o.isInstancedBufferGeometry) && null === t.get("ANGLE_instanced_arrays")) return;
                        f();
                        const l = o.attributes, c = s.getAttributes(), u = a.defaultAttributeValues;
                        for(const t in c){
                            const a = c[t];
                            if (a.location >= 0) {
                                let s = l[t];
                                if (void 0 === s && ("instanceMatrix" === t && r.instanceMatrix && (s = r.instanceMatrix), "instanceColor" === t && r.instanceColor && (s = r.instanceColor)), void 0 !== s) {
                                    const t = s.normalized, l = s.itemSize, c = n.get(s);
                                    if (void 0 === c) continue;
                                    const u = c.buffer, h = c.type, d = c.bytesPerElement, p = !0 === i.isWebGL2 && (h === e1.INT || h === e1.UNSIGNED_INT || s.gpuType === Sa);
                                    if (s.isInterleavedBufferAttribute) {
                                        const n = s.data, i = n.stride, c = s.offset;
                                        if (n.isInstancedInterleavedBuffer) {
                                            for(let e1 = 0; e1 < a.locationSize; e1++)g(a.location + e1, n.meshPerAttribute);
                                            !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = n.meshPerAttribute * n.count);
                                        } else for(let e1 = 0; e1 < a.locationSize; e1++)m(a.location + e1);
                                        e1.bindBuffer(e1.ARRAY_BUFFER, u);
                                        for(let e1 = 0; e1 < a.locationSize; e1++)v(a.location + e1, l / a.locationSize, h, t, i * d, (c + l / a.locationSize * e1) * d, p);
                                    } else {
                                        if (s.isInstancedBufferAttribute) {
                                            for(let e1 = 0; e1 < a.locationSize; e1++)g(a.location + e1, s.meshPerAttribute);
                                            !0 !== r.isInstancedMesh && void 0 === o._maxInstanceCount && (o._maxInstanceCount = s.meshPerAttribute * s.count);
                                        } else for(let e1 = 0; e1 < a.locationSize; e1++)m(a.location + e1);
                                        e1.bindBuffer(e1.ARRAY_BUFFER, u);
                                        for(let e1 = 0; e1 < a.locationSize; e1++)v(a.location + e1, l / a.locationSize, h, t, l * d, l / a.locationSize * e1 * d, p);
                                    }
                                } else if (void 0 !== u) {
                                    const n = u[t];
                                    if (void 0 !== n) switch(n.length){
                                        case 2:
                                            e1.vertexAttrib2fv(a.location, n);
                                            break;
                                        case 3:
                                            e1.vertexAttrib3fv(a.location, n);
                                            break;
                                        case 4:
                                            e1.vertexAttrib4fv(a.location, n);
                                            break;
                                        default:
                                            e1.vertexAttrib1fv(a.location, n);
                                    }
                                }
                            }
                        }
                        A();
                    }(r, l, d, M), null !== y && e1.bindBuffer(e1.ELEMENT_ARRAY_BUFFER, n.get(y).buffer));
                },
                reset: M,
                resetDefaultState: y,
                dispose: function() {
                    M();
                    for(const e1 in o){
                        const t = o[e1];
                        for(const e1 in t){
                            const n = t[e1];
                            for(const e1 in n)d(n[e1].object), delete n[e1];
                            delete t[e1];
                        }
                        delete o[e1];
                    }
                },
                releaseStatesOfGeometry: function(e1) {
                    if (void 0 === o[e1.id]) return;
                    const t = o[e1.id];
                    for(const e1 in t){
                        const n = t[e1];
                        for(const e1 in n)d(n[e1].object), delete n[e1];
                        delete t[e1];
                    }
                    delete o[e1.id];
                },
                releaseStatesOfProgram: function(e1) {
                    for(const t in o){
                        const n = o[t];
                        if (void 0 === n[e1.id]) continue;
                        const i = n[e1.id];
                        for(const e1 in i)d(i[e1].object), delete i[e1];
                        delete n[e1.id];
                    }
                },
                initAttributes: f,
                enableAttribute: m,
                disableUnusedAttributes: A
            };
        }
        function Mh(e1, t, n, i) {
            const r = i.isWebGL2;
            let a;
            this.setMode = function(e1) {
                a = e1;
            }, this.render = function(t, i) {
                e1.drawArrays(a, t, i), n.update(i, a, 1);
            }, this.renderInstances = function(i, s, o) {
                if (0 === o) return;
                let l, c;
                if (r) l = e1, c = "drawArraysInstanced";
                else if (l = t.get("ANGLE_instanced_arrays"), c = "drawArraysInstancedANGLE", null === l) return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                l[c](a, i, s, o), n.update(s, a, o);
            };
        }
        function yh(e1, t, n) {
            let i;
            function r(t) {
                if ("highp" === t) {
                    if (e1.getShaderPrecisionFormat(e1.VERTEX_SHADER, e1.HIGH_FLOAT).precision > 0 && e1.getShaderPrecisionFormat(e1.FRAGMENT_SHADER, e1.HIGH_FLOAT).precision > 0) return "highp";
                    t = "mediump";
                }
                return "mediump" === t && e1.getShaderPrecisionFormat(e1.VERTEX_SHADER, e1.MEDIUM_FLOAT).precision > 0 && e1.getShaderPrecisionFormat(e1.FRAGMENT_SHADER, e1.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
            }
            const a = "undefined" != typeof WebGL2RenderingContext && "WebGL2RenderingContext" === e1.constructor.name;
            let s = void 0 !== n.precision ? n.precision : "highp";
            const o = r(s);
            o !== s && (console.warn("THREE.WebGLRenderer:", s, "not supported, using", o, "instead."), s = o);
            const l = a || t.has("WEBGL_draw_buffers"), c = !0 === n.logarithmicDepthBuffer, u = e1.getParameter(e1.MAX_TEXTURE_IMAGE_UNITS), h = e1.getParameter(e1.MAX_VERTEX_TEXTURE_IMAGE_UNITS), d = e1.getParameter(e1.MAX_TEXTURE_SIZE), p = e1.getParameter(e1.MAX_CUBE_MAP_TEXTURE_SIZE), f = e1.getParameter(e1.MAX_VERTEX_ATTRIBS), m = e1.getParameter(e1.MAX_VERTEX_UNIFORM_VECTORS), g = e1.getParameter(e1.MAX_VARYING_VECTORS), A = e1.getParameter(e1.MAX_FRAGMENT_UNIFORM_VECTORS), v = h > 0, M = a || t.has("OES_texture_float");
            return {
                isWebGL2: a,
                drawBuffers: l,
                getMaxAnisotropy: function() {
                    if (void 0 !== i) return i;
                    if (!0 === t.has("EXT_texture_filter_anisotropic")) {
                        const n = t.get("EXT_texture_filter_anisotropic");
                        i = e1.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
                    } else i = 0;
                    return i;
                },
                getMaxPrecision: r,
                precision: s,
                logarithmicDepthBuffer: c,
                maxTextures: u,
                maxVertexTextures: h,
                maxTextureSize: d,
                maxCubemapSize: p,
                maxAttributes: f,
                maxVertexUniforms: m,
                maxVaryings: g,
                maxFragmentUniforms: A,
                vertexTextures: v,
                floatFragmentTextures: M,
                floatVertexTextures: v && M,
                maxSamples: a ? e1.getParameter(e1.MAX_SAMPLES) : 0
            };
        }
        function xh(e1) {
            const t = this;
            let n = null, i = 0, r = !1, a = !1;
            const s = new sh, o = new $o, l = {
                value: null,
                needsUpdate: !1
            };
            function c(e1, n, i, r) {
                const a = null !== e1 ? e1.length : 0;
                let c = null;
                if (0 !== a) {
                    if (c = l.value, !0 !== r || null === c) {
                        const t = i + 4 * a, r = n.matrixWorldInverse;
                        o.getNormalMatrix(r), (null === c || c.length < t) && (c = new Float32Array(t));
                        for(let t = 0, n = i; t !== a; ++t, n += 4)s.copy(e1[t]).applyMatrix4(r, o), s.normal.toArray(c, n), c[n + 3] = s.constant;
                    }
                    l.value = c, l.needsUpdate = !0;
                }
                return t.numPlanes = a, t.numIntersection = 0, c;
            }
            this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(e1, t) {
                const n = 0 !== e1.length || t || 0 !== i || r;
                return r = t, i = e1.length, n;
            }, this.beginShadows = function() {
                a = !0, c(null);
            }, this.endShadows = function() {
                a = !1;
            }, this.setGlobalState = function(e1, t) {
                n = c(e1, t, 0);
            }, this.setState = function(s, o, u) {
                const h = s.clippingPlanes, d = s.clipIntersection, p = s.clipShadows, f = e1.get(s);
                if (!r || null === h || 0 === h.length || a && !p) a ? c(null) : (l.value !== n && (l.value = n, l.needsUpdate = i > 0), t.numPlanes = i, t.numIntersection = 0);
                else {
                    const e1 = a ? 0 : i, t = 4 * e1;
                    let r = f.clippingState || null;
                    l.value = r, r = c(h, o, t, u);
                    for(let e1 = 0; e1 !== t; ++e1)r[e1] = n[e1];
                    f.clippingState = r, this.numIntersection = d ? this.numPlanes : 0, this.numPlanes += e1;
                }
            };
        }
        function _h(e1) {
            let t = new WeakMap;
            function n(e1, t) {
                return t === oa ? e1.mapping = aa : t === la && (e1.mapping = sa), e1;
            }
            function i(e1) {
                const n = e1.target;
                n.removeEventListener("dispose", i);
                const r = t.get(n);
                void 0 !== r && (t.delete(n), r.dispose());
            }
            return {
                get: function(r) {
                    if (r && r.isTexture && !1 === r.isRenderTargetTexture) {
                        const a = r.mapping;
                        if (a === oa || a === la) {
                            if (t.has(r)) return n(t.get(r).texture, r.mapping);
                            {
                                const a = r.image;
                                if (a && a.height > 0) {
                                    const s = new nh(a.height / 2);
                                    return s.fromEquirectangularTexture(e1, r), t.set(r, s), r.addEventListener("dispose", i), n(s.texture, r.mapping);
                                }
                                return null;
                            }
                        }
                    }
                    return r;
                },
                dispose: function() {
                    t = new WeakMap;
                }
            };
        }
        class bh extends Ku {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : -1, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : .1, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 2e3;
                super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e1, this.right = t, this.top = n, this.bottom = i, this.near = r, this.far = a, this.updateProjectionMatrix();
            }
            copy(e1, t) {
                return super.copy(e1, t), this.left = e1.left, this.right = e1.right, this.top = e1.top, this.bottom = e1.bottom, this.near = e1.near, this.far = e1.far, this.zoom = e1.zoom, this.view = null === e1.view ? null : Object.assign({}, e1.view), this;
            }
            setViewOffset(e1, t, n, i, r, a) {
                null === this.view && (this.view = {
                    enabled: !0,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                }), this.view.enabled = !0, this.view.fullWidth = e1, this.view.fullHeight = t, this.view.offsetX = n, this.view.offsetY = i, this.view.width = r, this.view.height = a, this.updateProjectionMatrix();
            }
            clearViewOffset() {
                null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
            }
            updateProjectionMatrix() {
                const e1 = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), n = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2;
                let r = n - e1, a = n + e1, s = i + t, o = i - t;
                if (null !== this.view && this.view.enabled) {
                    const e1 = (this.right - this.left) / this.view.fullWidth / this.zoom, t = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
                    r += e1 * this.view.offsetX, a = r + e1 * this.view.width, s -= t * this.view.offsetY, o = s - t * this.view.height;
                }
                this.projectionMatrix.makeOrthographic(r, a, s, o, this.near, this.far, this.coordinateSystem), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, null !== this.view && (t.object.view = Object.assign({}, this.view)), t;
            }
        }
        const wh = [
            .125,
            .215,
            .35,
            .446,
            .526,
            .582
        ], Eh = 20, Th = new bh, Sh = new Zc;
        let Ih = null, Nh = 0, Dh = 0;
        const Ch = (1 + Math.sqrt(5)) / 2, Lh = 1 / Ch, Rh = [
            new Cl(1, 1, 1),
            new Cl(-1, 1, 1),
            new Cl(1, 1, -1),
            new Cl(-1, 1, -1),
            new Cl(0, Ch, Lh),
            new Cl(0, Ch, -Lh),
            new Cl(Lh, 0, Ch),
            new Cl(-Lh, 0, Ch),
            new Cl(Ch, Lh, 0),
            new Cl(-Ch, Lh, 0)
        ];
        class zh {
            constructor(e1){
                this._renderer = e1, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
            }
            fromScene(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : .1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 100;
                Ih = this._renderer.getRenderTarget(), Nh = this._renderer.getActiveCubeFace(), Dh = this._renderer.getActiveMipmapLevel(), this._setSize(256);
                const r = this._allocateTargets();
                return r.depthBuffer = !0, this._sceneToCubeUV(e1, n, i, r), t > 0 && this._blur(r, 0, 0, t), this._applyPMREM(r), this._cleanup(r), r;
            }
            fromEquirectangular(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                return this._fromTexture(e1, t);
            }
            fromCubemap(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                return this._fromTexture(e1, t);
            }
            compileCubemapShader() {
                null === this._cubemapMaterial && (this._cubemapMaterial = kh(), this._compileMaterial(this._cubemapMaterial));
            }
            compileEquirectangularShader() {
                null === this._equirectMaterial && (this._equirectMaterial = Uh(), this._compileMaterial(this._equirectMaterial));
            }
            dispose() {
                this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose();
            }
            _setSize(e1) {
                this._lodMax = Math.floor(Math.log2(e1)), this._cubeSize = Math.pow(2, this._lodMax);
            }
            _dispose() {
                null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();
                for(let e1 = 0; e1 < this._lodPlanes.length; e1++)this._lodPlanes[e1].dispose();
            }
            _cleanup(e1) {
                this._renderer.setRenderTarget(Ih, Nh, Dh), e1.scissorTest = !1, Ph(e1, 0, 0, e1.width, e1.height);
            }
            _fromTexture(e1, t) {
                e1.mapping === aa || e1.mapping === sa ? this._setSize(0 === e1.image.length ? 16 : e1.image[0].width || e1.image[0].image.width) : this._setSize(e1.image.width / 4), Ih = this._renderer.getRenderTarget(), Nh = this._renderer.getActiveCubeFace(), Dh = this._renderer.getActiveMipmapLevel();
                const n = t || this._allocateTargets();
                return this._textureToCubeUV(e1, n), this._applyPMREM(n), this._cleanup(n), n;
            }
            _allocateTargets() {
                const e1 = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, n = {
                    magFilter: va,
                    minFilter: va,
                    generateMipmaps: !1,
                    type: Da,
                    format: Oa,
                    colorSpace: Qs,
                    depthBuffer: !1
                }, i = Oh(e1, t, n);
                if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== e1 || this._pingPongRenderTarget.height !== t) {
                    null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = Oh(e1, t, n);
                    const { _lodMax: i } = this;
                    ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = function(e1) {
                        const t = [], n = [], i = [];
                        let r = e1;
                        const a = e1 - 4 + 1 + wh.length;
                        for(let s = 0; s < a; s++){
                            const a = Math.pow(2, r);
                            n.push(a);
                            let o = 1 / a;
                            s > e1 - 4 ? o = wh[s - e1 + 4 - 1] : 0 === s && (o = 0), i.push(o);
                            const l = 1 / (a - 2), c = -l, u = 1 + l, h = [
                                c,
                                c,
                                u,
                                c,
                                u,
                                u,
                                c,
                                c,
                                u,
                                u,
                                c,
                                u
                            ], d = 6, p = 6, f = 3, m = 2, g = 1, A = new Float32Array(f * p * d), v = new Float32Array(m * p * d), M = new Float32Array(g * p * d);
                            for(let e1 = 0; e1 < d; e1++){
                                const t = e1 % 3 * 2 / 3 - 1, n = e1 > 2 ? 0 : -1, i = [
                                    t,
                                    n,
                                    0,
                                    t + 2 / 3,
                                    n,
                                    0,
                                    t + 2 / 3,
                                    n + 1,
                                    0,
                                    t,
                                    n,
                                    0,
                                    t + 2 / 3,
                                    n + 1,
                                    0,
                                    t,
                                    n + 1,
                                    0
                                ];
                                A.set(i, f * p * e1), v.set(h, m * p * e1);
                                const r = [
                                    e1,
                                    e1,
                                    e1,
                                    e1,
                                    e1,
                                    e1
                                ];
                                M.set(r, g * p * e1);
                            }
                            const y = new Eu;
                            y.setAttribute("position", new ou(A, f)), y.setAttribute("uv", new ou(v, m)), y.setAttribute("faceIndex", new ou(M, g)), t.push(y), r > 4 && r--;
                        }
                        return {
                            lodPlanes: t,
                            sizeLods: n,
                            sigmas: i
                        };
                    }(i)), this._blurMaterial = function(e1, t, n) {
                        const i = new Float32Array(Eh), r = new Cl(0, 1, 0);
                        return new qu({
                            name: "SphericalGaussianBlur",
                            defines: {
                                n: Eh,
                                CUBEUV_TEXEL_WIDTH: 1 / t,
                                CUBEUV_TEXEL_HEIGHT: 1 / n,
                                CUBEUV_MAX_MIP: "".concat(e1, ".0")
                            },
                            uniforms: {
                                envMap: {
                                    value: null
                                },
                                samples: {
                                    value: 1
                                },
                                weights: {
                                    value: i
                                },
                                latitudinal: {
                                    value: !1
                                },
                                dTheta: {
                                    value: 0
                                },
                                mipInt: {
                                    value: 0
                                },
                                poleAxis: {
                                    value: r
                                }
                            },
                            vertexShader: "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	",
                            fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n			uniform int samples;\n			uniform float weights[ n ];\n			uniform bool latitudinal;\n			uniform float dTheta;\n			uniform float mipInt;\n			uniform vec3 poleAxis;\n\n			#define ENVMAP_TYPE_CUBE_UV\n			#include <cube_uv_reflection_fragment>\n\n			vec3 getSample( float theta, vec3 axis ) {\n\n				float cosTheta = cos( theta );\n				// Rodrigues' axis-angle rotation\n				vec3 sampleDirection = vOutputDirection * cosTheta\n					+ cross( axis, vOutputDirection ) * sin( theta )\n					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n				return bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n			}\n\n			void main() {\n\n				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n				}\n\n				axis = normalize( axis );\n\n				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n				for ( int i = 1; i < n; i++ ) {\n\n					if ( i >= samples ) {\n\n						break;\n\n					}\n\n					float theta = dTheta * float( i );\n					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n				}\n\n			}\n		",
                            blending: pr,
                            depthTest: !1,
                            depthWrite: !1
                        });
                    }(i, e1, t);
                }
                return i;
            }
            _compileMaterial(e1) {
                const t = new Vu(this._lodPlanes[0], e1);
                this._renderer.compile(t, Th);
            }
            _sceneToCubeUV(e1, t, n, i) {
                const r = new Ju(90, 1, t, n), a = [
                    1,
                    -1,
                    1,
                    1,
                    1,
                    1
                ], s = [
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    -1
                ], o = this._renderer, l = o.autoClear, c = o.toneMapping;
                o.getClearColor(Sh), o.toneMapping = qr, o.autoClear = !1;
                const u = new $c({
                    name: "PMREM.Background",
                    side: ur,
                    depthWrite: !1,
                    depthTest: !1
                }), h = new Vu(new Qu, u);
                let d = !1;
                const p = e1.background;
                p ? p.isColor && (u.color.copy(p), e1.background = null, d = !0) : (u.color.copy(Sh), d = !0);
                for(let t = 0; t < 6; t++){
                    const n = t % 3;
                    0 === n ? (r.up.set(0, a[t], 0), r.lookAt(s[t], 0, 0)) : 1 === n ? (r.up.set(0, 0, a[t]), r.lookAt(0, s[t], 0)) : (r.up.set(0, a[t], 0), r.lookAt(0, 0, s[t]));
                    const l = this._cubeSize;
                    Ph(i, n * l, t > 2 ? l : 0, l, l), o.setRenderTarget(i), d && o.render(h, r), o.render(e1, r);
                }
                h.geometry.dispose(), h.material.dispose(), o.toneMapping = c, o.autoClear = l, e1.background = p;
            }
            _textureToCubeUV(e1, t) {
                const n = this._renderer, i = e1.mapping === aa || e1.mapping === sa;
                i ? (null === this._cubemapMaterial && (this._cubemapMaterial = kh()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === e1.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = Uh());
                const r = i ? this._cubemapMaterial : this._equirectMaterial, a = new Vu(this._lodPlanes[0], r);
                r.uniforms.envMap.value = e1;
                const s = this._cubeSize;
                Ph(t, 0, 0, 3 * s, 2 * s), n.setRenderTarget(t), n.render(a, Th);
            }
            _applyPMREM(e1) {
                const t = this._renderer, n = t.autoClear;
                t.autoClear = !1;
                for(let t = 1; t < this._lodPlanes.length; t++){
                    const n = Math.sqrt(this._sigmas[t] * this._sigmas[t] - this._sigmas[t - 1] * this._sigmas[t - 1]), i = Rh[(t - 1) % Rh.length];
                    this._blur(e1, t - 1, t, n, i);
                }
                t.autoClear = n;
            }
            _blur(e1, t, n, i, r) {
                const a = this._pingPongRenderTarget;
                this._halfBlur(e1, a, t, n, i, "latitudinal", r), this._halfBlur(a, e1, n, n, i, "longitudinal", r);
            }
            _halfBlur(e1, t, n, i, r, a, s) {
                const o = this._renderer, l = this._blurMaterial;
                "latitudinal" !== a && "longitudinal" !== a && console.error("blur direction must be either latitudinal or longitudinal!");
                const c = new Vu(this._lodPlanes[i], l), u = l.uniforms, h = this._sizeLods[n] - 1, d = isFinite(r) ? Math.PI / (2 * h) : 2 * Math.PI / 39, p = r / d, f = isFinite(r) ? 1 + Math.floor(3 * p) : Eh;
                f > Eh && console.warn("sigmaRadians, ".concat(r, ", is too large and will clip, as it requested ").concat(f, " samples when the maximum is set to ").concat(Eh));
                const m = [];
                let g = 0;
                for(let e1 = 0; e1 < Eh; ++e1){
                    const t = e1 / p, n = Math.exp(-t * t / 2);
                    m.push(n), 0 === e1 ? g += n : e1 < f && (g += 2 * n);
                }
                for(let e1 = 0; e1 < m.length; e1++)m[e1] = m[e1] / g;
                u.envMap.value = e1.texture, u.samples.value = f, u.weights.value = m, u.latitudinal.value = "latitudinal" === a, s && (u.poleAxis.value = s);
                const { _lodMax: A } = this;
                u.dTheta.value = d, u.mipInt.value = A - n;
                const v = this._sizeLods[i];
                Ph(t, 3 * v * (i > A - 4 ? i - A + 4 : 0), 4 * (this._cubeSize - v), 3 * v, 2 * v), o.setRenderTarget(t), o.render(c, Th);
            }
        }
        function Oh(e1, t, n) {
            const i = new wl(e1, t, n);
            return i.texture.mapping = ca, i.texture.name = "PMREM.cubeUv", i.scissorTest = !0, i;
        }
        function Ph(e1, t, n, i, r) {
            e1.viewport.set(t, n, i, r), e1.scissor.set(t, n, i, r);
        }
        function Uh() {
            return new qu({
                name: "EquirectangularToCubeUV",
                uniforms: {
                    envMap: {
                        value: null
                    }
                },
                vertexShader: "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	",
                fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			varying vec3 vOutputDirection;\n\n			uniform sampler2D envMap;\n\n			#include <common>\n\n			void main() {\n\n				vec3 outputDirection = normalize( vOutputDirection );\n				vec2 uv = equirectUv( outputDirection );\n\n				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n			}\n		",
                blending: pr,
                depthTest: !1,
                depthWrite: !1
            });
        }
        function kh() {
            return new qu({
                name: "CubemapToCubeUV",
                uniforms: {
                    envMap: {
                        value: null
                    },
                    flipEnvMap: {
                        value: -1
                    }
                },
                vertexShader: "\n\n		precision mediump float;\n		precision mediump int;\n\n		attribute float faceIndex;\n\n		varying vec3 vOutputDirection;\n\n		// RH coordinate system; PMREM face-indexing convention\n		vec3 getDirection( vec2 uv, float face ) {\n\n			uv = 2.0 * uv - 1.0;\n\n			vec3 direction = vec3( uv, 1.0 );\n\n			if ( face == 0.0 ) {\n\n				direction = direction.zyx; // ( 1, v, u ) pos x\n\n			} else if ( face == 1.0 ) {\n\n				direction = direction.xzy;\n				direction.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n			} else if ( face == 2.0 ) {\n\n				direction.x *= -1.0; // ( -u, v, 1 ) pos z\n\n			} else if ( face == 3.0 ) {\n\n				direction = direction.zyx;\n				direction.xz *= -1.0; // ( -1, v, -u ) neg x\n\n			} else if ( face == 4.0 ) {\n\n				direction = direction.xzy;\n				direction.xy *= -1.0; // ( -u, -1, v ) neg y\n\n			} else if ( face == 5.0 ) {\n\n				direction.z *= -1.0; // ( u, v, -1 ) neg z\n\n			}\n\n			return direction;\n\n		}\n\n		void main() {\n\n			vOutputDirection = getDirection( uv, faceIndex );\n			gl_Position = vec4( position, 1.0 );\n\n		}\n	",
                fragmentShader: "\n\n			precision mediump float;\n			precision mediump int;\n\n			uniform float flipEnvMap;\n\n			varying vec3 vOutputDirection;\n\n			uniform samplerCube envMap;\n\n			void main() {\n\n				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n			}\n		",
                blending: pr,
                depthTest: !1,
                depthWrite: !1
            });
        }
        function jh(e1) {
            let t = new WeakMap, n = null;
            function i(e1) {
                const n = e1.target;
                n.removeEventListener("dispose", i);
                const r = t.get(n);
                void 0 !== r && (t.delete(n), r.dispose());
            }
            return {
                get: function(r) {
                    if (r && r.isTexture) {
                        const a = r.mapping, s = a === oa || a === la, o = a === aa || a === sa;
                        if (s || o) {
                            if (r.isRenderTargetTexture && !0 === r.needsPMREMUpdate) {
                                r.needsPMREMUpdate = !1;
                                let i = t.get(r);
                                return null === n && (n = new zh(e1)), i = s ? n.fromEquirectangular(r, i) : n.fromCubemap(r, i), t.set(r, i), i.texture;
                            }
                            if (t.has(r)) return t.get(r).texture;
                            {
                                const a = r.image;
                                if (s && a && a.height > 0 || o && a && function(e1) {
                                    let t = 0;
                                    for(let n = 0; n < 6; n++)void 0 !== e1[n] && t++;
                                    return 6 === t;
                                }(a)) {
                                    null === n && (n = new zh(e1));
                                    const a = s ? n.fromEquirectangular(r) : n.fromCubemap(r);
                                    return t.set(r, a), r.addEventListener("dispose", i), a.texture;
                                }
                                return null;
                            }
                        }
                    }
                    return r;
                },
                dispose: function() {
                    t = new WeakMap, null !== n && (n.dispose(), n = null);
                }
            };
        }
        function Bh(e1) {
            const t = {};
            function n(n) {
                if (void 0 !== t[n]) return t[n];
                let i;
                switch(n){
                    case "WEBGL_depth_texture":
                        i = e1.getExtension("WEBGL_depth_texture") || e1.getExtension("MOZ_WEBGL_depth_texture") || e1.getExtension("WEBKIT_WEBGL_depth_texture");
                        break;
                    case "EXT_texture_filter_anisotropic":
                        i = e1.getExtension("EXT_texture_filter_anisotropic") || e1.getExtension("MOZ_EXT_texture_filter_anisotropic") || e1.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                        break;
                    case "WEBGL_compressed_texture_s3tc":
                        i = e1.getExtension("WEBGL_compressed_texture_s3tc") || e1.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || e1.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                        break;
                    case "WEBGL_compressed_texture_pvrtc":
                        i = e1.getExtension("WEBGL_compressed_texture_pvrtc") || e1.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                        break;
                    default:
                        i = e1.getExtension(n);
                }
                return t[n] = i, i;
            }
            return {
                has: function(e1) {
                    return null !== n(e1);
                },
                init: function(e1) {
                    e1.isWebGL2 ? n("EXT_color_buffer_float") : (n("WEBGL_depth_texture"), n("OES_texture_float"), n("OES_texture_half_float"), n("OES_texture_half_float_linear"), n("OES_standard_derivatives"), n("OES_element_index_uint"), n("OES_vertex_array_object"), n("ANGLE_instanced_arrays")), n("OES_texture_float_linear"), n("EXT_color_buffer_half_float"), n("WEBGL_multisampled_render_to_texture");
                },
                get: function(e1) {
                    const t = n(e1);
                    return null === t && console.warn("THREE.WebGLRenderer: " + e1 + " extension not supported."), t;
                }
            };
        }
        function Fh(e1, t, n, i) {
            const r = {}, a = new WeakMap;
            function s(e1) {
                const o = e1.target;
                null !== o.index && t.remove(o.index);
                for(const e1 in o.attributes)t.remove(o.attributes[e1]);
                for(const e1 in o.morphAttributes){
                    const n = o.morphAttributes[e1];
                    for(let e1 = 0, i = n.length; e1 < i; e1++)t.remove(n[e1]);
                }
                o.removeEventListener("dispose", s), delete r[o.id];
                const l = a.get(o);
                l && (t.remove(l), a.delete(o)), i.releaseStatesOfGeometry(o), !0 === o.isInstancedBufferGeometry && delete o._maxInstanceCount, n.memory.geometries--;
            }
            function o(e1) {
                const n = [], i = e1.index, r = e1.attributes.position;
                let s = 0;
                if (null !== i) {
                    const e1 = i.array;
                    s = i.version;
                    for(let t = 0, i = e1.length; t < i; t += 3){
                        const i = e1[t + 0], r = e1[t + 1], a = e1[t + 2];
                        n.push(i, r, r, a, a, i);
                    }
                } else {
                    if (void 0 === r) return;
                    {
                        const e1 = r.array;
                        s = r.version;
                        for(let t = 0, i = e1.length / 3 - 1; t < i; t += 3){
                            const e1 = t + 0, i = t + 1, r = t + 2;
                            n.push(e1, i, i, r, r, e1);
                        }
                    }
                }
                const o = new (tl(n) ? fu : du)(n, 1);
                o.version = s;
                const l = a.get(e1);
                l && t.remove(l), a.set(e1, o);
            }
            return {
                get: function(e1, t) {
                    return !0 === r[t.id] || (t.addEventListener("dispose", s), r[t.id] = !0, n.memory.geometries++), t;
                },
                update: function(n) {
                    const i = n.attributes;
                    for(const n in i)t.update(i[n], e1.ARRAY_BUFFER);
                    const r = n.morphAttributes;
                    for(const n in r){
                        const i = r[n];
                        for(let n = 0, r = i.length; n < r; n++)t.update(i[n], e1.ARRAY_BUFFER);
                    }
                },
                getWireframeAttribute: function(e1) {
                    const t = a.get(e1);
                    if (t) {
                        const n = e1.index;
                        null !== n && t.version < n.version && o(e1);
                    } else o(e1);
                    return a.get(e1);
                }
            };
        }
        function Hh(e1, t, n, i) {
            const r = i.isWebGL2;
            let a, s, o;
            this.setMode = function(e1) {
                a = e1;
            }, this.setIndex = function(e1) {
                s = e1.type, o = e1.bytesPerElement;
            }, this.render = function(t, i) {
                e1.drawElements(a, i, s, t * o), n.update(i, a, 1);
            }, this.renderInstances = function(i, l, c) {
                if (0 === c) return;
                let u, h;
                if (r) u = e1, h = "drawElementsInstanced";
                else if (u = t.get("ANGLE_instanced_arrays"), h = "drawElementsInstancedANGLE", null === u) return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
                u[h](a, l, s, i * o, c), n.update(l, a, c);
            };
        }
        function Vh(e1) {
            const t = {
                frame: 0,
                calls: 0,
                triangles: 0,
                points: 0,
                lines: 0
            };
            return {
                memory: {
                    geometries: 0,
                    textures: 0
                },
                render: t,
                programs: null,
                autoReset: !0,
                reset: function() {
                    t.calls = 0, t.triangles = 0, t.points = 0, t.lines = 0;
                },
                update: function(n, i, r) {
                    switch(t.calls++, i){
                        case e1.TRIANGLES:
                            t.triangles += r * (n / 3);
                            break;
                        case e1.LINES:
                            t.lines += r * (n / 2);
                            break;
                        case e1.LINE_STRIP:
                            t.lines += r * (n - 1);
                            break;
                        case e1.LINE_LOOP:
                            t.lines += r * n;
                            break;
                        case e1.POINTS:
                            t.points += r * n;
                            break;
                        default:
                            console.error("THREE.WebGLInfo: Unknown draw mode:", i);
                    }
                }
            };
        }
        function Gh(e1, t) {
            return e1[0] - t[0];
        }
        function Qh(e1, t) {
            return Math.abs(t[1]) - Math.abs(e1[1]);
        }
        function Wh(e1, t, n) {
            const i = {}, r = new Float32Array(8), a = new WeakMap, s = new _l, o = [];
            for(let e1 = 0; e1 < 8; e1++)o[e1] = [
                e1,
                0
            ];
            return {
                update: function(l, c, u) {
                    const h = l.morphTargetInfluences;
                    if (!0 === t.isWebGL2) {
                        const d = c.morphAttributes.position || c.morphAttributes.normal || c.morphAttributes.color, p = void 0 !== d ? d.length : 0;
                        let f = a.get(c);
                        if (void 0 === f || f.count !== p) {
                            void 0 !== f && f.texture.dispose();
                            const A = void 0 !== c.morphAttributes.position, v = void 0 !== c.morphAttributes.normal, M = void 0 !== c.morphAttributes.color, y = c.morphAttributes.position || [], x = c.morphAttributes.normal || [], _ = c.morphAttributes.color || [];
                            let b = 0;
                            !0 === A && (b = 1), !0 === v && (b = 2), !0 === M && (b = 3);
                            let w = c.attributes.position.count * b, E = 1;
                            w > t.maxTextureSize && (E = Math.ceil(w / t.maxTextureSize), w = t.maxTextureSize);
                            const T = new Float32Array(w * E * 4 * p), S = new El(T, w, E, p);
                            S.type = Na, S.needsUpdate = !0;
                            const I = 4 * b;
                            for(let D = 0; D < p; D++){
                                const C = y[D], L = x[D], R = _[D], z = w * E * 4 * D;
                                for(let O = 0; O < C.count; O++){
                                    const P = O * I;
                                    !0 === A && (s.fromBufferAttribute(C, O), T[z + P + 0] = s.x, T[z + P + 1] = s.y, T[z + P + 2] = s.z, T[z + P + 3] = 0), !0 === v && (s.fromBufferAttribute(L, O), T[z + P + 4] = s.x, T[z + P + 5] = s.y, T[z + P + 6] = s.z, T[z + P + 7] = 0), !0 === M && (s.fromBufferAttribute(R, O), T[z + P + 8] = s.x, T[z + P + 9] = s.y, T[z + P + 10] = s.z, T[z + P + 11] = 4 === R.itemSize ? s.w : 1);
                                }
                            }
                            function N() {
                                S.dispose(), a.delete(c), c.removeEventListener("dispose", N);
                            }
                            f = {
                                count: p,
                                texture: S,
                                size: new Jo(w, E)
                            }, a.set(c, f), c.addEventListener("dispose", N);
                        }
                        let m = 0;
                        for(let U = 0; U < h.length; U++)m += h[U];
                        const g = c.morphTargetsRelative ? 1 : 1 - m;
                        u.getUniforms().setValue(e1, "morphTargetBaseInfluence", g), u.getUniforms().setValue(e1, "morphTargetInfluences", h), u.getUniforms().setValue(e1, "morphTargetsTexture", f.texture, n), u.getUniforms().setValue(e1, "morphTargetsTextureSize", f.size);
                    } else {
                        const k = void 0 === h ? 0 : h.length;
                        let j = i[c.id];
                        if (void 0 === j || j.length !== k) {
                            j = [];
                            for(let G = 0; G < k; G++)j[G] = [
                                G,
                                0
                            ];
                            i[c.id] = j;
                        }
                        for(let Q = 0; Q < k; Q++){
                            const W = j[Q];
                            W[0] = Q, W[1] = h[Q];
                        }
                        j.sort(Qh);
                        for(let Y = 0; Y < 8; Y++)Y < k && j[Y][1] ? (o[Y][0] = j[Y][0], o[Y][1] = j[Y][1]) : (o[Y][0] = Number.MAX_SAFE_INTEGER, o[Y][1] = 0);
                        o.sort(Gh);
                        const B = c.morphAttributes.position, F = c.morphAttributes.normal;
                        let H = 0;
                        for(let X = 0; X < 8; X++){
                            const Z = o[X], q = Z[0], K = Z[1];
                            q !== Number.MAX_SAFE_INTEGER && K ? (B && c.getAttribute("morphTarget" + X) !== B[q] && c.setAttribute("morphTarget" + X, B[q]), F && c.getAttribute("morphNormal" + X) !== F[q] && c.setAttribute("morphNormal" + X, F[q]), r[X] = K, H += K) : (B && !0 === c.hasAttribute("morphTarget" + X) && c.deleteAttribute("morphTarget" + X), F && !0 === c.hasAttribute("morphNormal" + X) && c.deleteAttribute("morphNormal" + X), r[X] = 0);
                        }
                        const V = c.morphTargetsRelative ? 1 : 1 - H;
                        u.getUniforms().setValue(e1, "morphTargetBaseInfluence", V), u.getUniforms().setValue(e1, "morphTargetInfluences", r);
                    }
                }
            };
        }
        function Yh(e1, t, n, i) {
            let r = new WeakMap;
            function a(e1) {
                const t = e1.target;
                t.removeEventListener("dispose", a), n.remove(t.instanceMatrix), null !== t.instanceColor && n.remove(t.instanceColor);
            }
            return {
                update: function(s) {
                    const o = i.render.frame, l = s.geometry, c = t.get(s, l);
                    if (r.get(c) !== o && (t.update(c), r.set(c, o)), s.isInstancedMesh && (!1 === s.hasEventListener("dispose", a) && s.addEventListener("dispose", a), r.get(s) !== o && (n.update(s.instanceMatrix, e1.ARRAY_BUFFER), null !== s.instanceColor && n.update(s.instanceColor, e1.ARRAY_BUFFER), r.set(s, o))), s.isSkinnedMesh) {
                        const e1 = s.skeleton;
                        r.get(e1) !== o && (e1.update(), r.set(e1, o));
                    }
                    return c;
                },
                dispose: function() {
                    r = new WeakMap;
                }
            };
        }
        const Xh = new xl, Zh = new El, qh = new Sl, Kh = new th, Jh = [], $h = [], ed = new Float32Array(16), td = new Float32Array(9), nd = new Float32Array(4);
        function id(e1, t, n) {
            const i = e1[0];
            if (i <= 0 || i > 0) return e1;
            const r = t * n;
            let a = Jh[r];
            if (void 0 === a && (a = new Float32Array(r), Jh[r] = a), 0 !== t) {
                i.toArray(a, 0);
                for(let i = 1, r = 0; i !== t; ++i)r += n, e1[i].toArray(a, r);
            }
            return a;
        }
        function rd(e1, t) {
            if (e1.length !== t.length) return !1;
            for(let n = 0, i = e1.length; n < i; n++)if (e1[n] !== t[n]) return !1;
            return !0;
        }
        function ad(e1, t) {
            for(let n = 0, i = t.length; n < i; n++)e1[n] = t[n];
        }
        function sd(e1, t) {
            let n = $h[t];
            void 0 === n && (n = new Int32Array(t), $h[t] = n);
            for(let i = 0; i !== t; ++i)n[i] = e1.allocateTextureUnit();
            return n;
        }
        function od(e1, t) {
            const n = this.cache;
            n[0] !== t && (e1.uniform1f(this.addr, t), n[0] = t);
        }
        function ld(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y || (e1.uniform2f(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
            else {
                if (rd(n, t)) return;
                e1.uniform2fv(this.addr, t), ad(n, t);
            }
        }
        function cd(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z || (e1.uniform3f(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
            else if (void 0 !== t.r) n[0] === t.r && n[1] === t.g && n[2] === t.b || (e1.uniform3f(this.addr, t.r, t.g, t.b), n[0] = t.r, n[1] = t.g, n[2] = t.b);
            else {
                if (rd(n, t)) return;
                e1.uniform3fv(this.addr, t), ad(n, t);
            }
        }
        function ud(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z && n[3] === t.w || (e1.uniform4f(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
            else {
                if (rd(n, t)) return;
                e1.uniform4fv(this.addr, t), ad(n, t);
            }
        }
        function hd(e1, t) {
            const n = this.cache, i = t.elements;
            if (void 0 === i) {
                if (rd(n, t)) return;
                e1.uniformMatrix2fv(this.addr, !1, t), ad(n, t);
            } else {
                if (rd(n, i)) return;
                nd.set(i), e1.uniformMatrix2fv(this.addr, !1, nd), ad(n, i);
            }
        }
        function dd(e1, t) {
            const n = this.cache, i = t.elements;
            if (void 0 === i) {
                if (rd(n, t)) return;
                e1.uniformMatrix3fv(this.addr, !1, t), ad(n, t);
            } else {
                if (rd(n, i)) return;
                td.set(i), e1.uniformMatrix3fv(this.addr, !1, td), ad(n, i);
            }
        }
        function pd(e1, t) {
            const n = this.cache, i = t.elements;
            if (void 0 === i) {
                if (rd(n, t)) return;
                e1.uniformMatrix4fv(this.addr, !1, t), ad(n, t);
            } else {
                if (rd(n, i)) return;
                ed.set(i), e1.uniformMatrix4fv(this.addr, !1, ed), ad(n, i);
            }
        }
        function fd(e1, t) {
            const n = this.cache;
            n[0] !== t && (e1.uniform1i(this.addr, t), n[0] = t);
        }
        function md(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y || (e1.uniform2i(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
            else {
                if (rd(n, t)) return;
                e1.uniform2iv(this.addr, t), ad(n, t);
            }
        }
        function gd(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z || (e1.uniform3i(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
            else {
                if (rd(n, t)) return;
                e1.uniform3iv(this.addr, t), ad(n, t);
            }
        }
        function Ad(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z && n[3] === t.w || (e1.uniform4i(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
            else {
                if (rd(n, t)) return;
                e1.uniform4iv(this.addr, t), ad(n, t);
            }
        }
        function vd(e1, t) {
            const n = this.cache;
            n[0] !== t && (e1.uniform1ui(this.addr, t), n[0] = t);
        }
        function Md(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y || (e1.uniform2ui(this.addr, t.x, t.y), n[0] = t.x, n[1] = t.y);
            else {
                if (rd(n, t)) return;
                e1.uniform2uiv(this.addr, t), ad(n, t);
            }
        }
        function yd(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z || (e1.uniform3ui(this.addr, t.x, t.y, t.z), n[0] = t.x, n[1] = t.y, n[2] = t.z);
            else {
                if (rd(n, t)) return;
                e1.uniform3uiv(this.addr, t), ad(n, t);
            }
        }
        function xd(e1, t) {
            const n = this.cache;
            if (void 0 !== t.x) n[0] === t.x && n[1] === t.y && n[2] === t.z && n[3] === t.w || (e1.uniform4ui(this.addr, t.x, t.y, t.z, t.w), n[0] = t.x, n[1] = t.y, n[2] = t.z, n[3] = t.w);
            else {
                if (rd(n, t)) return;
                e1.uniform4uiv(this.addr, t), ad(n, t);
            }
        }
        function _d(e1, t, n) {
            const i = this.cache, r = n.allocateTextureUnit();
            i[0] !== r && (e1.uniform1i(this.addr, r), i[0] = r), n.setTexture2D(t || Xh, r);
        }
        function bd(e1, t, n) {
            const i = this.cache, r = n.allocateTextureUnit();
            i[0] !== r && (e1.uniform1i(this.addr, r), i[0] = r), n.setTexture3D(t || qh, r);
        }
        function wd(e1, t, n) {
            const i = this.cache, r = n.allocateTextureUnit();
            i[0] !== r && (e1.uniform1i(this.addr, r), i[0] = r), n.setTextureCube(t || Kh, r);
        }
        function Ed(e1, t, n) {
            const i = this.cache, r = n.allocateTextureUnit();
            i[0] !== r && (e1.uniform1i(this.addr, r), i[0] = r), n.setTexture2DArray(t || Zh, r);
        }
        function Td(e1, t) {
            e1.uniform1fv(this.addr, t);
        }
        function Sd(e1, t) {
            const n = id(t, this.size, 2);
            e1.uniform2fv(this.addr, n);
        }
        function Id(e1, t) {
            const n = id(t, this.size, 3);
            e1.uniform3fv(this.addr, n);
        }
        function Nd(e1, t) {
            const n = id(t, this.size, 4);
            e1.uniform4fv(this.addr, n);
        }
        function Dd(e1, t) {
            const n = id(t, this.size, 4);
            e1.uniformMatrix2fv(this.addr, !1, n);
        }
        function Cd(e1, t) {
            const n = id(t, this.size, 9);
            e1.uniformMatrix3fv(this.addr, !1, n);
        }
        function Ld(e1, t) {
            const n = id(t, this.size, 16);
            e1.uniformMatrix4fv(this.addr, !1, n);
        }
        function Rd(e1, t) {
            e1.uniform1iv(this.addr, t);
        }
        function zd(e1, t) {
            e1.uniform2iv(this.addr, t);
        }
        function Od(e1, t) {
            e1.uniform3iv(this.addr, t);
        }
        function Pd(e1, t) {
            e1.uniform4iv(this.addr, t);
        }
        function Ud(e1, t) {
            e1.uniform1uiv(this.addr, t);
        }
        function kd(e1, t) {
            e1.uniform2uiv(this.addr, t);
        }
        function jd(e1, t) {
            e1.uniform3uiv(this.addr, t);
        }
        function Bd(e1, t) {
            e1.uniform4uiv(this.addr, t);
        }
        function Fd(e1, t, n) {
            const i = this.cache, r = t.length, a = sd(n, r);
            rd(i, a) || (e1.uniform1iv(this.addr, a), ad(i, a));
            for(let e1 = 0; e1 !== r; ++e1)n.setTexture2D(t[e1] || Xh, a[e1]);
        }
        function Hd(e1, t, n) {
            const i = this.cache, r = t.length, a = sd(n, r);
            rd(i, a) || (e1.uniform1iv(this.addr, a), ad(i, a));
            for(let e1 = 0; e1 !== r; ++e1)n.setTexture3D(t[e1] || qh, a[e1]);
        }
        function Vd(e1, t, n) {
            const i = this.cache, r = t.length, a = sd(n, r);
            rd(i, a) || (e1.uniform1iv(this.addr, a), ad(i, a));
            for(let e1 = 0; e1 !== r; ++e1)n.setTextureCube(t[e1] || Kh, a[e1]);
        }
        function Gd(e1, t, n) {
            const i = this.cache, r = t.length, a = sd(n, r);
            rd(i, a) || (e1.uniform1iv(this.addr, a), ad(i, a));
            for(let e1 = 0; e1 !== r; ++e1)n.setTexture2DArray(t[e1] || Zh, a[e1]);
        }
        class Qd {
            constructor(e1, t, n){
                this.id = e1, this.addr = n, this.cache = [], this.setValue = function(e1) {
                    switch(e1){
                        case 5126:
                            return od;
                        case 35664:
                            return ld;
                        case 35665:
                            return cd;
                        case 35666:
                            return ud;
                        case 35674:
                            return hd;
                        case 35675:
                            return dd;
                        case 35676:
                            return pd;
                        case 5124:
                        case 35670:
                            return fd;
                        case 35667:
                        case 35671:
                            return md;
                        case 35668:
                        case 35672:
                            return gd;
                        case 35669:
                        case 35673:
                            return Ad;
                        case 5125:
                            return vd;
                        case 36294:
                            return Md;
                        case 36295:
                            return yd;
                        case 36296:
                            return xd;
                        case 35678:
                        case 36198:
                        case 36298:
                        case 36306:
                        case 35682:
                            return _d;
                        case 35679:
                        case 36299:
                        case 36307:
                            return bd;
                        case 35680:
                        case 36300:
                        case 36308:
                        case 36293:
                            return wd;
                        case 36289:
                        case 36303:
                        case 36311:
                        case 36292:
                            return Ed;
                    }
                }(t.type);
            }
        }
        class Wd {
            constructor(e1, t, n){
                this.id = e1, this.addr = n, this.cache = [], this.size = t.size, this.setValue = function(e1) {
                    switch(e1){
                        case 5126:
                            return Td;
                        case 35664:
                            return Sd;
                        case 35665:
                            return Id;
                        case 35666:
                            return Nd;
                        case 35674:
                            return Dd;
                        case 35675:
                            return Cd;
                        case 35676:
                            return Ld;
                        case 5124:
                        case 35670:
                            return Rd;
                        case 35667:
                        case 35671:
                            return zd;
                        case 35668:
                        case 35672:
                            return Od;
                        case 35669:
                        case 35673:
                            return Pd;
                        case 5125:
                            return Ud;
                        case 36294:
                            return kd;
                        case 36295:
                            return jd;
                        case 36296:
                            return Bd;
                        case 35678:
                        case 36198:
                        case 36298:
                        case 36306:
                        case 35682:
                            return Fd;
                        case 35679:
                        case 36299:
                        case 36307:
                            return Hd;
                        case 35680:
                        case 36300:
                        case 36308:
                        case 36293:
                            return Vd;
                        case 36289:
                        case 36303:
                        case 36311:
                        case 36292:
                            return Gd;
                    }
                }(t.type);
            }
        }
        class Yd {
            constructor(e1){
                this.id = e1, this.seq = [], this.map = {};
            }
            setValue(e1, t, n) {
                const i = this.seq;
                for(let r = 0, a = i.length; r !== a; ++r){
                    const a = i[r];
                    a.setValue(e1, t[a.id], n);
                }
            }
        }
        const Xd = /(\w+)(\])?(\[|\.)?/g;
        function Zd(e1, t) {
            e1.seq.push(t), e1.map[t.id] = t;
        }
        function qd(e1, t, n) {
            const i = e1.name, r = i.length;
            for(Xd.lastIndex = 0;;){
                const a = Xd.exec(i), s = Xd.lastIndex;
                let o = a[1];
                const l = "]" === a[2], c = a[3];
                if (l && (o |= 0), void 0 === c || "[" === c && s + 2 === r) {
                    Zd(n, void 0 === c ? new Qd(o, e1, t) : new Wd(o, e1, t));
                    break;
                }
                {
                    let e1 = n.map[o];
                    void 0 === e1 && (e1 = new Yd(o), Zd(n, e1)), n = e1;
                }
            }
        }
        class Kd {
            constructor(e1, t){
                this.seq = [], this.map = {};
                const n = e1.getProgramParameter(t, e1.ACTIVE_UNIFORMS);
                for(let i = 0; i < n; ++i){
                    const n = e1.getActiveUniform(t, i);
                    qd(n, e1.getUniformLocation(t, n.name), this);
                }
            }
            setValue(e1, t, n, i) {
                const r = this.map[t];
                void 0 !== r && r.setValue(e1, n, i);
            }
            setOptional(e1, t, n) {
                const i = t[n];
                void 0 !== i && this.setValue(e1, n, i);
            }
            static upload(e1, t, n, i) {
                for(let r = 0, a = t.length; r !== a; ++r){
                    const a = t[r], s = n[a.id];
                    !1 !== s.needsUpdate && a.setValue(e1, s.value, i);
                }
            }
            static seqWithValue(e1, t) {
                const n = [];
                for(let i = 0, r = e1.length; i !== r; ++i){
                    const r = e1[i];
                    r.id in t && n.push(r);
                }
                return n;
            }
        }
        function Jd(e1, t, n) {
            const i = e1.createShader(t);
            return e1.shaderSource(i, n), e1.compileShader(i), i;
        }
        const $d = 37297;
        let ep = 0;
        function tp(e1, t, n) {
            const i = e1.getShaderParameter(t, e1.COMPILE_STATUS), r = e1.getShaderInfoLog(t).trim();
            if (i && "" === r) return "";
            const a = /ERROR: 0:(\d+)/.exec(r);
            if (a) {
                const i = parseInt(a[1]);
                return n.toUpperCase() + "\n\n" + r + "\n\n" + function(e1, t) {
                    const n = e1.split("\n"), i = [], r = Math.max(t - 6, 0), a = Math.min(t + 6, n.length);
                    for(let e1 = r; e1 < a; e1++){
                        const r = e1 + 1;
                        i.push("".concat(r === t ? ">" : " ", " ").concat(r, ": ").concat(n[e1]));
                    }
                    return i.join("\n");
                }(e1.getShaderSource(t), i);
            }
            return r;
        }
        function np(e1, t) {
            const n = function(e1) {
                const t = dl.getPrimaries(dl.workingColorSpace), n = dl.getPrimaries(e1);
                let i;
                switch(t === n ? i = "" : t === Ks && n === qs ? i = "LinearDisplayP3ToLinearSRGB" : t === qs && n === Ks && (i = "LinearSRGBToLinearDisplayP3"), e1){
                    case Qs:
                    case Ys:
                        return [
                            i,
                            "LinearTransferOETF"
                        ];
                    case Gs:
                    case Ws:
                        return [
                            i,
                            "sRGBTransferOETF"
                        ];
                    default:
                        return console.warn("THREE.WebGLProgram: Unsupported color space:", e1), [
                            i,
                            "LinearTransferOETF"
                        ];
                }
            }(t);
            return "vec4 ".concat(e1, "( vec4 value ) { return ").concat(n[0], "( ").concat(n[1], "( value ) ); }");
        }
        function ip(e1, t) {
            let n;
            switch(t){
                case Kr:
                    n = "Linear";
                    break;
                case Jr:
                    n = "Reinhard";
                    break;
                case $r:
                    n = "OptimizedCineon";
                    break;
                case ea:
                    n = "ACESFilmic";
                    break;
                case ta:
                    n = "Custom";
                    break;
                default:
                    console.warn("THREE.WebGLProgram: Unsupported toneMapping:", t), n = "Linear";
            }
            return "vec3 " + e1 + "( vec3 color ) { return " + n + "ToneMapping( color ); }";
        }
        function rp(e1) {
            return "" !== e1;
        }
        function ap(e1, t) {
            const n = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
            return e1.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, n).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
        }
        function sp(e1, t) {
            return e1.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
        }
        const op = /^[ \t]*#include +<([\w\d./]+)>/gm;
        function lp(e1) {
            return e1.replace(op, up);
        }
        const cp = new Map([
            [
                "encodings_fragment",
                "colorspace_fragment"
            ],
            [
                "encodings_pars_fragment",
                "colorspace_pars_fragment"
            ],
            [
                "output_fragment",
                "opaque_fragment"
            ]
        ]);
        function up(e1, t) {
            let n = ph[t];
            if (void 0 === n) {
                const e1 = cp.get(t);
                if (void 0 === e1) throw new Error("Can not resolve #include <" + t + ">");
                n = ph[e1], console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', t, e1);
            }
            return lp(n);
        }
        const hp = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
        function dp(e1) {
            return e1.replace(hp, pp);
        }
        function pp(e1, t, n, i) {
            let r = "";
            for(let e1 = parseInt(t); e1 < parseInt(n); e1++)r += i.replace(/\[\s*i\s*\]/g, "[ " + e1 + " ]").replace(/UNROLLED_LOOP_INDEX/g, e1);
            return r;
        }
        function fp(e1) {
            let t = "precision " + e1.precision + " float;\nprecision " + e1.precision + " int;";
            return "highp" === e1.precision ? t += "\n#define HIGH_PRECISION" : "mediump" === e1.precision ? t += "\n#define MEDIUM_PRECISION" : "lowp" === e1.precision && (t += "\n#define LOW_PRECISION"), t;
        }
        function mp(e1, t, n, i) {
            const r = e1.getContext(), a = n.defines;
            let s = n.vertexShader, o = n.fragmentShader;
            const l = function(e1) {
                let t = "SHADOWMAP_TYPE_BASIC";
                return e1.shadowMapType === sr ? t = "SHADOWMAP_TYPE_PCF" : e1.shadowMapType === or ? t = "SHADOWMAP_TYPE_PCF_SOFT" : e1.shadowMapType === lr && (t = "SHADOWMAP_TYPE_VSM"), t;
            }(n), c = function(e1) {
                let t = "ENVMAP_TYPE_CUBE";
                if (e1.envMap) switch(e1.envMapMode){
                    case aa:
                    case sa:
                        t = "ENVMAP_TYPE_CUBE";
                        break;
                    case ca:
                        t = "ENVMAP_TYPE_CUBE_UV";
                }
                return t;
            }(n), u = function(e1) {
                let t = "ENVMAP_MODE_REFLECTION";
                return e1.envMap && e1.envMapMode === sa && (t = "ENVMAP_MODE_REFRACTION"), t;
            }(n), h = function(e1) {
                let t = "ENVMAP_BLENDING_NONE";
                if (e1.envMap) switch(e1.combine){
                    case Yr:
                        t = "ENVMAP_BLENDING_MULTIPLY";
                        break;
                    case Xr:
                        t = "ENVMAP_BLENDING_MIX";
                        break;
                    case Zr:
                        t = "ENVMAP_BLENDING_ADD";
                }
                return t;
            }(n), d = function(e1) {
                const t = e1.envMapCubeUVHeight;
                if (null === t) return null;
                const n = Math.log2(t) - 2, i = 1 / t;
                return {
                    texelWidth: 1 / (3 * Math.max(Math.pow(2, n), 112)),
                    texelHeight: i,
                    maxMip: n
                };
            }(n), p = n.isWebGL2 ? "" : function(e1) {
                return [
                    e1.extensionDerivatives || e1.envMapCubeUVHeight || e1.bumpMap || e1.normalMapTangentSpace || e1.clearcoatNormalMap || e1.flatShading || "physical" === e1.shaderID ? "#extension GL_OES_standard_derivatives : enable" : "",
                    (e1.extensionFragDepth || e1.logarithmicDepthBuffer) && e1.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
                    e1.extensionDrawBuffers && e1.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
                    (e1.extensionShaderTextureLOD || e1.envMap || e1.transmission) && e1.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
                ].filter(rp).join("\n");
            }(n), f = function(e1) {
                const t = [];
                for(const n in e1){
                    const i = e1[n];
                    !1 !== i && t.push("#define " + n + " " + i);
                }
                return t.join("\n");
            }(a), m = r.createProgram();
            let g, A, v = n.glslVersion ? "#version " + n.glslVersion + "\n" : "";
            n.isRawShaderMaterial ? (g = [
                "#define SHADER_TYPE " + n.shaderType,
                "#define SHADER_NAME " + n.shaderName,
                f
            ].filter(rp).join("\n"), g.length > 0 && (g += "\n"), A = [
                p,
                "#define SHADER_TYPE " + n.shaderType,
                "#define SHADER_NAME " + n.shaderName,
                f
            ].filter(rp).join("\n"), A.length > 0 && (A += "\n")) : (g = [
                fp(n),
                "#define SHADER_TYPE " + n.shaderType,
                "#define SHADER_NAME " + n.shaderName,
                f,
                n.instancing ? "#define USE_INSTANCING" : "",
                n.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
                n.useFog && n.fog ? "#define USE_FOG" : "",
                n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
                n.map ? "#define USE_MAP" : "",
                n.envMap ? "#define USE_ENVMAP" : "",
                n.envMap ? "#define " + u : "",
                n.lightMap ? "#define USE_LIGHTMAP" : "",
                n.aoMap ? "#define USE_AOMAP" : "",
                n.bumpMap ? "#define USE_BUMPMAP" : "",
                n.normalMap ? "#define USE_NORMALMAP" : "",
                n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                n.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
                n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                n.anisotropy ? "#define USE_ANISOTROPY" : "",
                n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                n.specularMap ? "#define USE_SPECULARMAP" : "",
                n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                n.metalnessMap ? "#define USE_METALNESSMAP" : "",
                n.alphaMap ? "#define USE_ALPHAMAP" : "",
                n.alphaHash ? "#define USE_ALPHAHASH" : "",
                n.transmission ? "#define USE_TRANSMISSION" : "",
                n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                n.mapUv ? "#define MAP_UV " + n.mapUv : "",
                n.alphaMapUv ? "#define ALPHAMAP_UV " + n.alphaMapUv : "",
                n.lightMapUv ? "#define LIGHTMAP_UV " + n.lightMapUv : "",
                n.aoMapUv ? "#define AOMAP_UV " + n.aoMapUv : "",
                n.emissiveMapUv ? "#define EMISSIVEMAP_UV " + n.emissiveMapUv : "",
                n.bumpMapUv ? "#define BUMPMAP_UV " + n.bumpMapUv : "",
                n.normalMapUv ? "#define NORMALMAP_UV " + n.normalMapUv : "",
                n.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + n.displacementMapUv : "",
                n.metalnessMapUv ? "#define METALNESSMAP_UV " + n.metalnessMapUv : "",
                n.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + n.roughnessMapUv : "",
                n.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + n.anisotropyMapUv : "",
                n.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + n.clearcoatMapUv : "",
                n.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + n.clearcoatNormalMapUv : "",
                n.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + n.clearcoatRoughnessMapUv : "",
                n.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + n.iridescenceMapUv : "",
                n.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + n.iridescenceThicknessMapUv : "",
                n.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + n.sheenColorMapUv : "",
                n.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + n.sheenRoughnessMapUv : "",
                n.specularMapUv ? "#define SPECULARMAP_UV " + n.specularMapUv : "",
                n.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + n.specularColorMapUv : "",
                n.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + n.specularIntensityMapUv : "",
                n.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + n.transmissionMapUv : "",
                n.thicknessMapUv ? "#define THICKNESSMAP_UV " + n.thicknessMapUv : "",
                n.vertexTangents && !1 === n.flatShading ? "#define USE_TANGENT" : "",
                n.vertexColors ? "#define USE_COLOR" : "",
                n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                n.vertexUv1s ? "#define USE_UV1" : "",
                n.vertexUv2s ? "#define USE_UV2" : "",
                n.vertexUv3s ? "#define USE_UV3" : "",
                n.pointsUvs ? "#define USE_POINTS_UV" : "",
                n.flatShading ? "#define FLAT_SHADED" : "",
                n.skinning ? "#define USE_SKINNING" : "",
                n.morphTargets ? "#define USE_MORPHTARGETS" : "",
                n.morphNormals && !1 === n.flatShading ? "#define USE_MORPHNORMALS" : "",
                n.morphColors && n.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
                n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
                n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + n.morphTextureStride : "",
                n.morphTargetsCount > 0 && n.isWebGL2 ? "#define MORPHTARGETS_COUNT " + n.morphTargetsCount : "",
                n.doubleSided ? "#define DOUBLE_SIDED" : "",
                n.flipSided ? "#define FLIP_SIDED" : "",
                n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                n.shadowMapEnabled ? "#define " + l : "",
                n.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
                n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                n.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
                n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
                "uniform mat4 modelMatrix;",
                "uniform mat4 modelViewMatrix;",
                "uniform mat4 projectionMatrix;",
                "uniform mat4 viewMatrix;",
                "uniform mat3 normalMatrix;",
                "uniform vec3 cameraPosition;",
                "uniform bool isOrthographic;",
                "#ifdef USE_INSTANCING",
                "	attribute mat4 instanceMatrix;",
                "#endif",
                "#ifdef USE_INSTANCING_COLOR",
                "	attribute vec3 instanceColor;",
                "#endif",
                "attribute vec3 position;",
                "attribute vec3 normal;",
                "attribute vec2 uv;",
                "#ifdef USE_UV1",
                "	attribute vec2 uv1;",
                "#endif",
                "#ifdef USE_UV2",
                "	attribute vec2 uv2;",
                "#endif",
                "#ifdef USE_UV3",
                "	attribute vec2 uv3;",
                "#endif",
                "#ifdef USE_TANGENT",
                "	attribute vec4 tangent;",
                "#endif",
                "#if defined( USE_COLOR_ALPHA )",
                "	attribute vec4 color;",
                "#elif defined( USE_COLOR )",
                "	attribute vec3 color;",
                "#endif",
                "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
                "	attribute vec3 morphTarget0;",
                "	attribute vec3 morphTarget1;",
                "	attribute vec3 morphTarget2;",
                "	attribute vec3 morphTarget3;",
                "	#ifdef USE_MORPHNORMALS",
                "		attribute vec3 morphNormal0;",
                "		attribute vec3 morphNormal1;",
                "		attribute vec3 morphNormal2;",
                "		attribute vec3 morphNormal3;",
                "	#else",
                "		attribute vec3 morphTarget4;",
                "		attribute vec3 morphTarget5;",
                "		attribute vec3 morphTarget6;",
                "		attribute vec3 morphTarget7;",
                "	#endif",
                "#endif",
                "#ifdef USE_SKINNING",
                "	attribute vec4 skinIndex;",
                "	attribute vec4 skinWeight;",
                "#endif",
                "\n"
            ].filter(rp).join("\n"), A = [
                p,
                fp(n),
                "#define SHADER_TYPE " + n.shaderType,
                "#define SHADER_NAME " + n.shaderName,
                f,
                n.useFog && n.fog ? "#define USE_FOG" : "",
                n.useFog && n.fogExp2 ? "#define FOG_EXP2" : "",
                n.map ? "#define USE_MAP" : "",
                n.matcap ? "#define USE_MATCAP" : "",
                n.envMap ? "#define USE_ENVMAP" : "",
                n.envMap ? "#define " + c : "",
                n.envMap ? "#define " + u : "",
                n.envMap ? "#define " + h : "",
                d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
                d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
                d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
                n.lightMap ? "#define USE_LIGHTMAP" : "",
                n.aoMap ? "#define USE_AOMAP" : "",
                n.bumpMap ? "#define USE_BUMPMAP" : "",
                n.normalMap ? "#define USE_NORMALMAP" : "",
                n.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                n.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                n.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                n.anisotropy ? "#define USE_ANISOTROPY" : "",
                n.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                n.clearcoat ? "#define USE_CLEARCOAT" : "",
                n.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                n.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                n.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                n.iridescence ? "#define USE_IRIDESCENCE" : "",
                n.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                n.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                n.specularMap ? "#define USE_SPECULARMAP" : "",
                n.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                n.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                n.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                n.metalnessMap ? "#define USE_METALNESSMAP" : "",
                n.alphaMap ? "#define USE_ALPHAMAP" : "",
                n.alphaTest ? "#define USE_ALPHATEST" : "",
                n.alphaHash ? "#define USE_ALPHAHASH" : "",
                n.sheen ? "#define USE_SHEEN" : "",
                n.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                n.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                n.transmission ? "#define USE_TRANSMISSION" : "",
                n.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                n.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                n.vertexTangents && !1 === n.flatShading ? "#define USE_TANGENT" : "",
                n.vertexColors || n.instancingColor ? "#define USE_COLOR" : "",
                n.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                n.vertexUv1s ? "#define USE_UV1" : "",
                n.vertexUv2s ? "#define USE_UV2" : "",
                n.vertexUv3s ? "#define USE_UV3" : "",
                n.pointsUvs ? "#define USE_POINTS_UV" : "",
                n.gradientMap ? "#define USE_GRADIENTMAP" : "",
                n.flatShading ? "#define FLAT_SHADED" : "",
                n.doubleSided ? "#define DOUBLE_SIDED" : "",
                n.flipSided ? "#define FLIP_SIDED" : "",
                n.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                n.shadowMapEnabled ? "#define " + l : "",
                n.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
                n.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                n.useLegacyLights ? "#define LEGACY_LIGHTS" : "",
                n.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
                n.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                n.logarithmicDepthBuffer && n.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
                "uniform mat4 viewMatrix;",
                "uniform vec3 cameraPosition;",
                "uniform bool isOrthographic;",
                n.toneMapping !== qr ? "#define TONE_MAPPING" : "",
                n.toneMapping !== qr ? ph.tonemapping_pars_fragment : "",
                n.toneMapping !== qr ? ip("toneMapping", n.toneMapping) : "",
                n.dithering ? "#define DITHERING" : "",
                n.opaque ? "#define OPAQUE" : "",
                ph.colorspace_pars_fragment,
                np("linearToOutputTexel", n.outputColorSpace),
                n.useDepthPacking ? "#define DEPTH_PACKING " + n.depthPacking : "",
                "\n"
            ].filter(rp).join("\n")), s = lp(s), s = ap(s, n), s = sp(s, n), o = lp(o), o = ap(o, n), o = sp(o, n), s = dp(s), o = dp(o), n.isWebGL2 && !0 !== n.isRawShaderMaterial && (v = "#version 300 es\n", g = [
                "precision mediump sampler2DArray;",
                "#define attribute in",
                "#define varying out",
                "#define texture2D texture"
            ].join("\n") + "\n" + g, A = [
                "precision mediump sampler2DArray;",
                "#define varying in",
                n.glslVersion === Ro ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
                n.glslVersion === Ro ? "" : "#define gl_FragColor pc_fragColor",
                "#define gl_FragDepthEXT gl_FragDepth",
                "#define texture2D texture",
                "#define textureCube texture",
                "#define texture2DProj textureProj",
                "#define texture2DLodEXT textureLod",
                "#define texture2DProjLodEXT textureProjLod",
                "#define textureCubeLodEXT textureLod",
                "#define texture2DGradEXT textureGrad",
                "#define texture2DProjGradEXT textureProjGrad",
                "#define textureCubeGradEXT textureGrad"
            ].join("\n") + "\n" + A);
            const M = v + g + s, y = v + A + o, x = Jd(r, r.VERTEX_SHADER, M), _ = Jd(r, r.FRAGMENT_SHADER, y);
            function b(t) {
                if (e1.debug.checkShaderErrors) {
                    const n = r.getProgramInfoLog(m).trim(), i = r.getShaderInfoLog(x).trim(), a = r.getShaderInfoLog(_).trim();
                    let s = !0, o = !0;
                    if (!1 === r.getProgramParameter(m, r.LINK_STATUS)) {
                        if (s = !1, "function" == typeof e1.debug.onShaderError) e1.debug.onShaderError(r, m, x, _);
                        else {
                            const e1 = tp(r, x, "vertex"), t = tp(r, _, "fragment");
                            console.error("THREE.WebGLProgram: Shader Error " + r.getError() + " - VALIDATE_STATUS " + r.getProgramParameter(m, r.VALIDATE_STATUS) + "\n\nProgram Info Log: " + n + "\n" + e1 + "\n" + t);
                        }
                    } else "" !== n ? console.warn("THREE.WebGLProgram: Program Info Log:", n) : "" !== i && "" !== a || (o = !1);
                    o && (t.diagnostics = {
                        runnable: s,
                        programLog: n,
                        vertexShader: {
                            log: i,
                            prefix: g
                        },
                        fragmentShader: {
                            log: a,
                            prefix: A
                        }
                    });
                }
                r.deleteShader(x), r.deleteShader(_), w = new Kd(r, m), E = function(e1, t) {
                    const n = {}, i = e1.getProgramParameter(t, e1.ACTIVE_ATTRIBUTES);
                    for(let r = 0; r < i; r++){
                        const i = e1.getActiveAttrib(t, r), a = i.name;
                        let s = 1;
                        i.type === e1.FLOAT_MAT2 && (s = 2), i.type === e1.FLOAT_MAT3 && (s = 3), i.type === e1.FLOAT_MAT4 && (s = 4), n[a] = {
                            type: i.type,
                            location: e1.getAttribLocation(t, a),
                            locationSize: s
                        };
                    }
                    return n;
                }(r, m);
            }
            let w, E;
            r.attachShader(m, x), r.attachShader(m, _), void 0 !== n.index0AttributeName ? r.bindAttribLocation(m, 0, n.index0AttributeName) : !0 === n.morphTargets && r.bindAttribLocation(m, 0, "position"), r.linkProgram(m), this.getUniforms = function() {
                return void 0 === w && b(this), w;
            }, this.getAttributes = function() {
                return void 0 === E && b(this), E;
            };
            let T = !1 === n.rendererExtensionParallelShaderCompile;
            return this.isReady = function() {
                return !1 === T && (T = r.getProgramParameter(m, $d)), T;
            }, this.destroy = function() {
                i.releaseStatesOfProgram(this), r.deleteProgram(m), this.program = void 0;
            }, this.type = n.shaderType, this.name = n.shaderName, this.id = ep++, this.cacheKey = t, this.usedTimes = 1, this.program = m, this.vertexShader = x, this.fragmentShader = _, this;
        }
        let gp = 0;
        class Ap {
            constructor(){
                this.shaderCache = new Map, this.materialCache = new Map;
            }
            update(e1) {
                const t = e1.vertexShader, n = e1.fragmentShader, i = this._getShaderStage(t), r = this._getShaderStage(n), a = this._getShaderCacheForMaterial(e1);
                return !1 === a.has(i) && (a.add(i), i.usedTimes++), !1 === a.has(r) && (a.add(r), r.usedTimes++), this;
            }
            remove(e1) {
                const t = this.materialCache.get(e1);
                for (const e1 of t)e1.usedTimes--, 0 === e1.usedTimes && this.shaderCache.delete(e1.code);
                return this.materialCache.delete(e1), this;
            }
            getVertexShaderID(e1) {
                return this._getShaderStage(e1.vertexShader).id;
            }
            getFragmentShaderID(e1) {
                return this._getShaderStage(e1.fragmentShader).id;
            }
            dispose() {
                this.shaderCache.clear(), this.materialCache.clear();
            }
            _getShaderCacheForMaterial(e1) {
                const t = this.materialCache;
                let n = t.get(e1);
                return void 0 === n && (n = new Set, t.set(e1, n)), n;
            }
            _getShaderStage(e1) {
                const t = this.shaderCache;
                let n = t.get(e1);
                return void 0 === n && (n = new vp(e1), t.set(e1, n)), n;
            }
        }
        class vp {
            constructor(e1){
                this.id = gp++, this.code = e1, this.usedTimes = 0;
            }
        }
        function Mp(e1, t, n, i, r, a, s) {
            const o = new vc, l = new Ap, c = [], u = r.isWebGL2, h = r.logarithmicDepthBuffer, d = r.vertexTextures;
            let p = r.precision;
            const f = {
                MeshDepthMaterial: "depth",
                MeshDistanceMaterial: "distanceRGBA",
                MeshNormalMaterial: "normal",
                MeshBasicMaterial: "basic",
                MeshLambertMaterial: "lambert",
                MeshPhongMaterial: "phong",
                MeshToonMaterial: "toon",
                MeshStandardMaterial: "physical",
                MeshPhysicalMaterial: "physical",
                MeshMatcapMaterial: "matcap",
                LineBasicMaterial: "basic",
                LineDashedMaterial: "dashed",
                PointsMaterial: "points",
                ShadowMaterial: "shadow",
                SpriteMaterial: "sprite"
            };
            function m(e1) {
                return 0 === e1 ? "uv" : "uv".concat(e1);
            }
            return {
                getParameters: function(a, o, c, g, A) {
                    const v = g.fog, M = A.geometry, y = a.isMeshStandardMaterial ? g.environment : null, x = (a.isMeshStandardMaterial ? n : t).get(a.envMap || y), _ = x && x.mapping === ca ? x.image.height : null, b = f[a.type];
                    null !== a.precision && (p = r.getMaxPrecision(a.precision), p !== a.precision && console.warn("THREE.WebGLProgram.getParameters:", a.precision, "not supported, using", p, "instead."));
                    const w = M.morphAttributes.position || M.morphAttributes.normal || M.morphAttributes.color, E = void 0 !== w ? w.length : 0;
                    let T, S, I, N, D = 0;
                    if (void 0 !== M.morphAttributes.position && (D = 1), void 0 !== M.morphAttributes.normal && (D = 2), void 0 !== M.morphAttributes.color && (D = 3), b) {
                        const e1 = mh[b];
                        T = e1.vertexShader, S = e1.fragmentShader;
                    } else T = a.vertexShader, S = a.fragmentShader, l.update(a), I = l.getVertexShaderID(a), N = l.getFragmentShaderID(a);
                    const C = e1.getRenderTarget(), L = !0 === A.isInstancedMesh, R = !!a.map, z = !!a.matcap, O = !!x, P = !!a.aoMap, U = !!a.lightMap, k = !!a.bumpMap, j = !!a.normalMap, B = !!a.displacementMap, F = !!a.emissiveMap, H = !!a.metalnessMap, V = !!a.roughnessMap, G = a.anisotropy > 0, Q = a.clearcoat > 0, W = a.iridescence > 0, Y = a.sheen > 0, X = a.transmission > 0, Z = G && !!a.anisotropyMap, q = Q && !!a.clearcoatMap, K = Q && !!a.clearcoatNormalMap, J = Q && !!a.clearcoatRoughnessMap, $ = W && !!a.iridescenceMap, ee = W && !!a.iridescenceThicknessMap, te = Y && !!a.sheenColorMap, ne = Y && !!a.sheenRoughnessMap, ie = !!a.specularMap, re = !!a.specularColorMap, ae = !!a.specularIntensityMap, se = X && !!a.transmissionMap, oe = X && !!a.thicknessMap, le = !!a.gradientMap, ce = !!a.alphaMap, ue = a.alphaTest > 0, he = !!a.alphaHash, de = !!a.extensions, pe = !!M.attributes.uv1, fe = !!M.attributes.uv2, me = !!M.attributes.uv3;
                    let ge = qr;
                    return a.toneMapped && (null !== C && !0 !== C.isXRRenderTarget || (ge = e1.toneMapping)), {
                        isWebGL2: u,
                        shaderID: b,
                        shaderType: a.type,
                        shaderName: a.name,
                        vertexShader: T,
                        fragmentShader: S,
                        defines: a.defines,
                        customVertexShaderID: I,
                        customFragmentShaderID: N,
                        isRawShaderMaterial: !0 === a.isRawShaderMaterial,
                        glslVersion: a.glslVersion,
                        precision: p,
                        instancing: L,
                        instancingColor: L && null !== A.instanceColor,
                        supportsVertexTextures: d,
                        outputColorSpace: null === C ? e1.outputColorSpace : !0 === C.isXRRenderTarget ? C.texture.colorSpace : Qs,
                        map: R,
                        matcap: z,
                        envMap: O,
                        envMapMode: O && x.mapping,
                        envMapCubeUVHeight: _,
                        aoMap: P,
                        lightMap: U,
                        bumpMap: k,
                        normalMap: j,
                        displacementMap: d && B,
                        emissiveMap: F,
                        normalMapObjectSpace: j && a.normalMapType === Hs,
                        normalMapTangentSpace: j && a.normalMapType === Fs,
                        metalnessMap: H,
                        roughnessMap: V,
                        anisotropy: G,
                        anisotropyMap: Z,
                        clearcoat: Q,
                        clearcoatMap: q,
                        clearcoatNormalMap: K,
                        clearcoatRoughnessMap: J,
                        iridescence: W,
                        iridescenceMap: $,
                        iridescenceThicknessMap: ee,
                        sheen: Y,
                        sheenColorMap: te,
                        sheenRoughnessMap: ne,
                        specularMap: ie,
                        specularColorMap: re,
                        specularIntensityMap: ae,
                        transmission: X,
                        transmissionMap: se,
                        thicknessMap: oe,
                        gradientMap: le,
                        opaque: !1 === a.transparent && a.blending === fr,
                        alphaMap: ce,
                        alphaTest: ue,
                        alphaHash: he,
                        combine: a.combine,
                        mapUv: R && m(a.map.channel),
                        aoMapUv: P && m(a.aoMap.channel),
                        lightMapUv: U && m(a.lightMap.channel),
                        bumpMapUv: k && m(a.bumpMap.channel),
                        normalMapUv: j && m(a.normalMap.channel),
                        displacementMapUv: B && m(a.displacementMap.channel),
                        emissiveMapUv: F && m(a.emissiveMap.channel),
                        metalnessMapUv: H && m(a.metalnessMap.channel),
                        roughnessMapUv: V && m(a.roughnessMap.channel),
                        anisotropyMapUv: Z && m(a.anisotropyMap.channel),
                        clearcoatMapUv: q && m(a.clearcoatMap.channel),
                        clearcoatNormalMapUv: K && m(a.clearcoatNormalMap.channel),
                        clearcoatRoughnessMapUv: J && m(a.clearcoatRoughnessMap.channel),
                        iridescenceMapUv: $ && m(a.iridescenceMap.channel),
                        iridescenceThicknessMapUv: ee && m(a.iridescenceThicknessMap.channel),
                        sheenColorMapUv: te && m(a.sheenColorMap.channel),
                        sheenRoughnessMapUv: ne && m(a.sheenRoughnessMap.channel),
                        specularMapUv: ie && m(a.specularMap.channel),
                        specularColorMapUv: re && m(a.specularColorMap.channel),
                        specularIntensityMapUv: ae && m(a.specularIntensityMap.channel),
                        transmissionMapUv: se && m(a.transmissionMap.channel),
                        thicknessMapUv: oe && m(a.thicknessMap.channel),
                        alphaMapUv: ce && m(a.alphaMap.channel),
                        vertexTangents: !!M.attributes.tangent && (j || G),
                        vertexColors: a.vertexColors,
                        vertexAlphas: !0 === a.vertexColors && !!M.attributes.color && 4 === M.attributes.color.itemSize,
                        vertexUv1s: pe,
                        vertexUv2s: fe,
                        vertexUv3s: me,
                        pointsUvs: !0 === A.isPoints && !!M.attributes.uv && (R || ce),
                        fog: !!v,
                        useFog: !0 === a.fog,
                        fogExp2: v && v.isFogExp2,
                        flatShading: !0 === a.flatShading,
                        sizeAttenuation: !0 === a.sizeAttenuation,
                        logarithmicDepthBuffer: h,
                        skinning: !0 === A.isSkinnedMesh,
                        morphTargets: void 0 !== M.morphAttributes.position,
                        morphNormals: void 0 !== M.morphAttributes.normal,
                        morphColors: void 0 !== M.morphAttributes.color,
                        morphTargetsCount: E,
                        morphTextureStride: D,
                        numDirLights: o.directional.length,
                        numPointLights: o.point.length,
                        numSpotLights: o.spot.length,
                        numSpotLightMaps: o.spotLightMap.length,
                        numRectAreaLights: o.rectArea.length,
                        numHemiLights: o.hemi.length,
                        numDirLightShadows: o.directionalShadowMap.length,
                        numPointLightShadows: o.pointShadowMap.length,
                        numSpotLightShadows: o.spotShadowMap.length,
                        numSpotLightShadowsWithMaps: o.numSpotLightShadowsWithMaps,
                        numLightProbes: o.numLightProbes,
                        numClippingPlanes: s.numPlanes,
                        numClipIntersection: s.numIntersection,
                        dithering: a.dithering,
                        shadowMapEnabled: e1.shadowMap.enabled && c.length > 0,
                        shadowMapType: e1.shadowMap.type,
                        toneMapping: ge,
                        useLegacyLights: e1._useLegacyLights,
                        decodeVideoTexture: R && !0 === a.map.isVideoTexture && dl.getTransfer(a.map.colorSpace) === Zs,
                        premultipliedAlpha: a.premultipliedAlpha,
                        doubleSided: a.side === hr,
                        flipSided: a.side === ur,
                        useDepthPacking: a.depthPacking >= 0,
                        depthPacking: a.depthPacking || 0,
                        index0AttributeName: a.index0AttributeName,
                        extensionDerivatives: de && !0 === a.extensions.derivatives,
                        extensionFragDepth: de && !0 === a.extensions.fragDepth,
                        extensionDrawBuffers: de && !0 === a.extensions.drawBuffers,
                        extensionShaderTextureLOD: de && !0 === a.extensions.shaderTextureLOD,
                        rendererExtensionFragDepth: u || i.has("EXT_frag_depth"),
                        rendererExtensionDrawBuffers: u || i.has("WEBGL_draw_buffers"),
                        rendererExtensionShaderTextureLod: u || i.has("EXT_shader_texture_lod"),
                        rendererExtensionParallelShaderCompile: i.has("KHR_parallel_shader_compile"),
                        customProgramCacheKey: a.customProgramCacheKey()
                    };
                },
                getProgramCacheKey: function(t) {
                    const n = [];
                    if (t.shaderID ? n.push(t.shaderID) : (n.push(t.customVertexShaderID), n.push(t.customFragmentShaderID)), void 0 !== t.defines) for(const e1 in t.defines)n.push(e1), n.push(t.defines[e1]);
                    return !1 === t.isRawShaderMaterial && (function(e1, t) {
                        e1.push(t.precision), e1.push(t.outputColorSpace), e1.push(t.envMapMode), e1.push(t.envMapCubeUVHeight), e1.push(t.mapUv), e1.push(t.alphaMapUv), e1.push(t.lightMapUv), e1.push(t.aoMapUv), e1.push(t.bumpMapUv), e1.push(t.normalMapUv), e1.push(t.displacementMapUv), e1.push(t.emissiveMapUv), e1.push(t.metalnessMapUv), e1.push(t.roughnessMapUv), e1.push(t.anisotropyMapUv), e1.push(t.clearcoatMapUv), e1.push(t.clearcoatNormalMapUv), e1.push(t.clearcoatRoughnessMapUv), e1.push(t.iridescenceMapUv), e1.push(t.iridescenceThicknessMapUv), e1.push(t.sheenColorMapUv), e1.push(t.sheenRoughnessMapUv), e1.push(t.specularMapUv), e1.push(t.specularColorMapUv), e1.push(t.specularIntensityMapUv), e1.push(t.transmissionMapUv), e1.push(t.thicknessMapUv), e1.push(t.combine), e1.push(t.fogExp2), e1.push(t.sizeAttenuation), e1.push(t.morphTargetsCount), e1.push(t.morphAttributeCount), e1.push(t.numDirLights), e1.push(t.numPointLights), e1.push(t.numSpotLights), e1.push(t.numSpotLightMaps), e1.push(t.numHemiLights), e1.push(t.numRectAreaLights), e1.push(t.numDirLightShadows), e1.push(t.numPointLightShadows), e1.push(t.numSpotLightShadows), e1.push(t.numSpotLightShadowsWithMaps), e1.push(t.numLightProbes), e1.push(t.shadowMapType), e1.push(t.toneMapping), e1.push(t.numClippingPlanes), e1.push(t.numClipIntersection), e1.push(t.depthPacking);
                    }(n, t), function(e1, t) {
                        o.disableAll(), t.isWebGL2 && o.enable(0), t.supportsVertexTextures && o.enable(1), t.instancing && o.enable(2), t.instancingColor && o.enable(3), t.matcap && o.enable(4), t.envMap && o.enable(5), t.normalMapObjectSpace && o.enable(6), t.normalMapTangentSpace && o.enable(7), t.clearcoat && o.enable(8), t.iridescence && o.enable(9), t.alphaTest && o.enable(10), t.vertexColors && o.enable(11), t.vertexAlphas && o.enable(12), t.vertexUv1s && o.enable(13), t.vertexUv2s && o.enable(14), t.vertexUv3s && o.enable(15), t.vertexTangents && o.enable(16), t.anisotropy && o.enable(17), t.alphaHash && o.enable(18), e1.push(o.mask), o.disableAll(), t.fog && o.enable(0), t.useFog && o.enable(1), t.flatShading && o.enable(2), t.logarithmicDepthBuffer && o.enable(3), t.skinning && o.enable(4), t.morphTargets && o.enable(5), t.morphNormals && o.enable(6), t.morphColors && o.enable(7), t.premultipliedAlpha && o.enable(8), t.shadowMapEnabled && o.enable(9), t.useLegacyLights && o.enable(10), t.doubleSided && o.enable(11), t.flipSided && o.enable(12), t.useDepthPacking && o.enable(13), t.dithering && o.enable(14), t.transmission && o.enable(15), t.sheen && o.enable(16), t.opaque && o.enable(17), t.pointsUvs && o.enable(18), t.decodeVideoTexture && o.enable(19), e1.push(o.mask);
                    }(n, t), n.push(e1.outputColorSpace)), n.push(t.customProgramCacheKey), n.join();
                },
                getUniforms: function(e1) {
                    const t = f[e1.type];
                    let n;
                    if (t) {
                        const e1 = mh[t];
                        n = Zu.clone(e1.uniforms);
                    } else n = e1.uniforms;
                    return n;
                },
                acquireProgram: function(t, n) {
                    let i;
                    for(let e1 = 0, t = c.length; e1 < t; e1++){
                        const t = c[e1];
                        if (t.cacheKey === n) {
                            i = t, ++i.usedTimes;
                            break;
                        }
                    }
                    return void 0 === i && (i = new mp(e1, n, t, a), c.push(i)), i;
                },
                releaseProgram: function(e1) {
                    if (0 == --e1.usedTimes) {
                        const t = c.indexOf(e1);
                        c[t] = c[c.length - 1], c.pop(), e1.destroy();
                    }
                },
                releaseShaderCache: function(e1) {
                    l.remove(e1);
                },
                programs: c,
                dispose: function() {
                    l.dispose();
                }
            };
        }
        function yp() {
            let e1 = new WeakMap;
            return {
                get: function(t) {
                    let n = e1.get(t);
                    return void 0 === n && (n = {}, e1.set(t, n)), n;
                },
                remove: function(t) {
                    e1.delete(t);
                },
                update: function(t, n, i) {
                    e1.get(t)[n] = i;
                },
                dispose: function() {
                    e1 = new WeakMap;
                }
            };
        }
        function xp(e1, t) {
            return e1.groupOrder !== t.groupOrder ? e1.groupOrder - t.groupOrder : e1.renderOrder !== t.renderOrder ? e1.renderOrder - t.renderOrder : e1.material.id !== t.material.id ? e1.material.id - t.material.id : e1.z !== t.z ? e1.z - t.z : e1.id - t.id;
        }
        function _p(e1, t) {
            return e1.groupOrder !== t.groupOrder ? e1.groupOrder - t.groupOrder : e1.renderOrder !== t.renderOrder ? e1.renderOrder - t.renderOrder : e1.z !== t.z ? t.z - e1.z : e1.id - t.id;
        }
        function bp() {
            const e1 = [];
            let t = 0;
            const n = [], i = [], r = [];
            function a(n, i, r, a, s, o) {
                let l = e1[t];
                return void 0 === l ? (l = {
                    id: n.id,
                    object: n,
                    geometry: i,
                    material: r,
                    groupOrder: a,
                    renderOrder: n.renderOrder,
                    z: s,
                    group: o
                }, e1[t] = l) : (l.id = n.id, l.object = n, l.geometry = i, l.material = r, l.groupOrder = a, l.renderOrder = n.renderOrder, l.z = s, l.group = o), t++, l;
            }
            return {
                opaque: n,
                transmissive: i,
                transparent: r,
                init: function() {
                    t = 0, n.length = 0, i.length = 0, r.length = 0;
                },
                push: function(e1, t, s, o, l, c) {
                    const u = a(e1, t, s, o, l, c);
                    s.transmission > 0 ? i.push(u) : !0 === s.transparent ? r.push(u) : n.push(u);
                },
                unshift: function(e1, t, s, o, l, c) {
                    const u = a(e1, t, s, o, l, c);
                    s.transmission > 0 ? i.unshift(u) : !0 === s.transparent ? r.unshift(u) : n.unshift(u);
                },
                finish: function() {
                    for(let n = t, i = e1.length; n < i; n++){
                        const t = e1[n];
                        if (null === t.id) break;
                        t.id = null, t.object = null, t.geometry = null, t.material = null, t.group = null;
                    }
                },
                sort: function(e1, t) {
                    n.length > 1 && n.sort(e1 || xp), i.length > 1 && i.sort(t || _p), r.length > 1 && r.sort(t || _p);
                }
            };
        }
        function wp() {
            let e1 = new WeakMap;
            return {
                get: function(t, n) {
                    const i = e1.get(t);
                    let r;
                    return void 0 === i ? (r = new bp, e1.set(t, [
                        r
                    ])) : n >= i.length ? (r = new bp, i.push(r)) : r = i[n], r;
                },
                dispose: function() {
                    e1 = new WeakMap;
                }
            };
        }
        function Ep() {
            const e1 = {};
            return {
                get: function(t) {
                    if (void 0 !== e1[t.id]) return e1[t.id];
                    let n;
                    switch(t.type){
                        case "DirectionalLight":
                            n = {
                                direction: new Cl,
                                color: new Zc
                            };
                            break;
                        case "SpotLight":
                            n = {
                                position: new Cl,
                                direction: new Cl,
                                color: new Zc,
                                distance: 0,
                                coneCos: 0,
                                penumbraCos: 0,
                                decay: 0
                            };
                            break;
                        case "PointLight":
                            n = {
                                position: new Cl,
                                color: new Zc,
                                distance: 0,
                                decay: 0
                            };
                            break;
                        case "HemisphereLight":
                            n = {
                                direction: new Cl,
                                skyColor: new Zc,
                                groundColor: new Zc
                            };
                            break;
                        case "RectAreaLight":
                            n = {
                                color: new Zc,
                                position: new Cl,
                                halfWidth: new Cl,
                                halfHeight: new Cl
                            };
                    }
                    return e1[t.id] = n, n;
                }
            };
        }
        let Tp = 0;
        function Sp(e1, t) {
            return (t.castShadow ? 2 : 0) - (e1.castShadow ? 2 : 0) + (t.map ? 1 : 0) - (e1.map ? 1 : 0);
        }
        function Ip(e1, t) {
            const n = new Ep, i = function() {
                const e1 = {};
                return {
                    get: function(t) {
                        if (void 0 !== e1[t.id]) return e1[t.id];
                        let n;
                        switch(t.type){
                            case "DirectionalLight":
                            case "SpotLight":
                                n = {
                                    shadowBias: 0,
                                    shadowNormalBias: 0,
                                    shadowRadius: 1,
                                    shadowMapSize: new Jo
                                };
                                break;
                            case "PointLight":
                                n = {
                                    shadowBias: 0,
                                    shadowNormalBias: 0,
                                    shadowRadius: 1,
                                    shadowMapSize: new Jo,
                                    shadowCameraNear: 1,
                                    shadowCameraFar: 1e3
                                };
                        }
                        return e1[t.id] = n, n;
                    }
                };
            }(), r = {
                version: 0,
                hash: {
                    directionalLength: -1,
                    pointLength: -1,
                    spotLength: -1,
                    rectAreaLength: -1,
                    hemiLength: -1,
                    numDirectionalShadows: -1,
                    numPointShadows: -1,
                    numSpotShadows: -1,
                    numSpotMaps: -1,
                    numLightProbes: -1
                },
                ambient: [
                    0,
                    0,
                    0
                ],
                probe: [],
                directional: [],
                directionalShadow: [],
                directionalShadowMap: [],
                directionalShadowMatrix: [],
                spot: [],
                spotLightMap: [],
                spotShadow: [],
                spotShadowMap: [],
                spotLightMatrix: [],
                rectArea: [],
                rectAreaLTC1: null,
                rectAreaLTC2: null,
                point: [],
                pointShadow: [],
                pointShadowMap: [],
                pointShadowMatrix: [],
                hemi: [],
                numSpotLightShadowsWithMaps: 0,
                numLightProbes: 0
            };
            for(let e1 = 0; e1 < 9; e1++)r.probe.push(new Cl);
            const a = new Cl, s = new oc, o = new oc;
            return {
                setup: function(a, s) {
                    let o = 0, l = 0, c = 0;
                    for(let e1 = 0; e1 < 9; e1++)r.probe[e1].set(0, 0, 0);
                    let u = 0, h = 0, d = 0, p = 0, f = 0, m = 0, g = 0, A = 0, v = 0, M = 0, y = 0;
                    a.sort(Sp);
                    const x = !0 === s ? Math.PI : 1;
                    for(let e1 = 0, t = a.length; e1 < t; e1++){
                        const t = a[e1], s = t.color, _ = t.intensity, b = t.distance, w = t.shadow && t.shadow.map ? t.shadow.map.texture : null;
                        if (t.isAmbientLight) o += s.r * _ * x, l += s.g * _ * x, c += s.b * _ * x;
                        else if (t.isLightProbe) {
                            for(let e1 = 0; e1 < 9; e1++)r.probe[e1].addScaledVector(t.sh.coefficients[e1], _);
                            y++;
                        } else if (t.isDirectionalLight) {
                            const e1 = n.get(t);
                            if (e1.color.copy(t.color).multiplyScalar(t.intensity * x), t.castShadow) {
                                const e1 = t.shadow, n = i.get(t);
                                n.shadowBias = e1.bias, n.shadowNormalBias = e1.normalBias, n.shadowRadius = e1.radius, n.shadowMapSize = e1.mapSize, r.directionalShadow[u] = n, r.directionalShadowMap[u] = w, r.directionalShadowMatrix[u] = t.shadow.matrix, m++;
                            }
                            r.directional[u] = e1, u++;
                        } else if (t.isSpotLight) {
                            const e1 = n.get(t);
                            e1.position.setFromMatrixPosition(t.matrixWorld), e1.color.copy(s).multiplyScalar(_ * x), e1.distance = b, e1.coneCos = Math.cos(t.angle), e1.penumbraCos = Math.cos(t.angle * (1 - t.penumbra)), e1.decay = t.decay, r.spot[d] = e1;
                            const a = t.shadow;
                            if (t.map && (r.spotLightMap[v] = t.map, v++, a.updateMatrices(t), t.castShadow && M++), r.spotLightMatrix[d] = a.matrix, t.castShadow) {
                                const e1 = i.get(t);
                                e1.shadowBias = a.bias, e1.shadowNormalBias = a.normalBias, e1.shadowRadius = a.radius, e1.shadowMapSize = a.mapSize, r.spotShadow[d] = e1, r.spotShadowMap[d] = w, A++;
                            }
                            d++;
                        } else if (t.isRectAreaLight) {
                            const e1 = n.get(t);
                            e1.color.copy(s).multiplyScalar(_), e1.halfWidth.set(.5 * t.width, 0, 0), e1.halfHeight.set(0, .5 * t.height, 0), r.rectArea[p] = e1, p++;
                        } else if (t.isPointLight) {
                            const e1 = n.get(t);
                            if (e1.color.copy(t.color).multiplyScalar(t.intensity * x), e1.distance = t.distance, e1.decay = t.decay, t.castShadow) {
                                const e1 = t.shadow, n = i.get(t);
                                n.shadowBias = e1.bias, n.shadowNormalBias = e1.normalBias, n.shadowRadius = e1.radius, n.shadowMapSize = e1.mapSize, n.shadowCameraNear = e1.camera.near, n.shadowCameraFar = e1.camera.far, r.pointShadow[h] = n, r.pointShadowMap[h] = w, r.pointShadowMatrix[h] = t.shadow.matrix, g++;
                            }
                            r.point[h] = e1, h++;
                        } else if (t.isHemisphereLight) {
                            const e1 = n.get(t);
                            e1.skyColor.copy(t.color).multiplyScalar(_ * x), e1.groundColor.copy(t.groundColor).multiplyScalar(_ * x), r.hemi[f] = e1, f++;
                        }
                    }
                    p > 0 && (t.isWebGL2 || !0 === e1.has("OES_texture_float_linear") ? (r.rectAreaLTC1 = fh.LTC_FLOAT_1, r.rectAreaLTC2 = fh.LTC_FLOAT_2) : !0 === e1.has("OES_texture_half_float_linear") ? (r.rectAreaLTC1 = fh.LTC_HALF_1, r.rectAreaLTC2 = fh.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), r.ambient[0] = o, r.ambient[1] = l, r.ambient[2] = c;
                    const _ = r.hash;
                    _.directionalLength === u && _.pointLength === h && _.spotLength === d && _.rectAreaLength === p && _.hemiLength === f && _.numDirectionalShadows === m && _.numPointShadows === g && _.numSpotShadows === A && _.numSpotMaps === v && _.numLightProbes === y || (r.directional.length = u, r.spot.length = d, r.rectArea.length = p, r.point.length = h, r.hemi.length = f, r.directionalShadow.length = m, r.directionalShadowMap.length = m, r.pointShadow.length = g, r.pointShadowMap.length = g, r.spotShadow.length = A, r.spotShadowMap.length = A, r.directionalShadowMatrix.length = m, r.pointShadowMatrix.length = g, r.spotLightMatrix.length = A + v - M, r.spotLightMap.length = v, r.numSpotLightShadowsWithMaps = M, r.numLightProbes = y, _.directionalLength = u, _.pointLength = h, _.spotLength = d, _.rectAreaLength = p, _.hemiLength = f, _.numDirectionalShadows = m, _.numPointShadows = g, _.numSpotShadows = A, _.numSpotMaps = v, _.numLightProbes = y, r.version = Tp++);
                },
                setupView: function(e1, t) {
                    let n = 0, i = 0, l = 0, c = 0, u = 0;
                    const h = t.matrixWorldInverse;
                    for(let t = 0, d = e1.length; t < d; t++){
                        const d = e1[t];
                        if (d.isDirectionalLight) {
                            const e1 = r.directional[n];
                            e1.direction.setFromMatrixPosition(d.matrixWorld), a.setFromMatrixPosition(d.target.matrixWorld), e1.direction.sub(a), e1.direction.transformDirection(h), n++;
                        } else if (d.isSpotLight) {
                            const e1 = r.spot[l];
                            e1.position.setFromMatrixPosition(d.matrixWorld), e1.position.applyMatrix4(h), e1.direction.setFromMatrixPosition(d.matrixWorld), a.setFromMatrixPosition(d.target.matrixWorld), e1.direction.sub(a), e1.direction.transformDirection(h), l++;
                        } else if (d.isRectAreaLight) {
                            const e1 = r.rectArea[c];
                            e1.position.setFromMatrixPosition(d.matrixWorld), e1.position.applyMatrix4(h), o.identity(), s.copy(d.matrixWorld), s.premultiply(h), o.extractRotation(s), e1.halfWidth.set(.5 * d.width, 0, 0), e1.halfHeight.set(0, .5 * d.height, 0), e1.halfWidth.applyMatrix4(o), e1.halfHeight.applyMatrix4(o), c++;
                        } else if (d.isPointLight) {
                            const e1 = r.point[i];
                            e1.position.setFromMatrixPosition(d.matrixWorld), e1.position.applyMatrix4(h), i++;
                        } else if (d.isHemisphereLight) {
                            const e1 = r.hemi[u];
                            e1.direction.setFromMatrixPosition(d.matrixWorld), e1.direction.transformDirection(h), u++;
                        }
                    }
                },
                state: r
            };
        }
        function Np(e1, t) {
            const n = new Ip(e1, t), i = [], r = [];
            return {
                init: function() {
                    i.length = 0, r.length = 0;
                },
                state: {
                    lightsArray: i,
                    shadowsArray: r,
                    lights: n
                },
                setupLights: function(e1) {
                    n.setup(i, e1);
                },
                setupLightsView: function(e1) {
                    n.setupView(i, e1);
                },
                pushLight: function(e1) {
                    i.push(e1);
                },
                pushShadow: function(e1) {
                    r.push(e1);
                }
            };
        }
        function Dp(e1, t) {
            let n = new WeakMap;
            return {
                get: function(i) {
                    let r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                    const a = n.get(i);
                    let s;
                    return void 0 === a ? (s = new Np(e1, t), n.set(i, [
                        s
                    ])) : r >= a.length ? (s = new Np(e1, t), a.push(s)) : s = a[r], s;
                },
                dispose: function() {
                    n = new WeakMap;
                }
            };
        }
        class Cp extends Jc {
            constructor(e1){
                super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = js, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.depthPacking = e1.depthPacking, this.map = e1.map, this.alphaMap = e1.alphaMap, this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this;
            }
        }
        class Lp extends Jc {
            constructor(e1){
                super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.map = e1.map, this.alphaMap = e1.alphaMap, this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this;
            }
        }
        function Rp(e1, t, n) {
            let i = new ch;
            const r = new Jo, a = new Jo, s = new _l, o = new Cp({
                depthPacking: Bs
            }), l = new Lp, c = {}, u = n.maxTextureSize, h = {
                [cr]: ur,
                [ur]: cr,
                [hr]: hr
            }, d = new qu({
                defines: {
                    VSM_SAMPLES: 8
                },
                uniforms: {
                    shadow_pass: {
                        value: null
                    },
                    resolution: {
                        value: new Jo
                    },
                    radius: {
                        value: 4
                    }
                },
                vertexShader: "void main() {\n	gl_Position = vec4( position, 1.0 );\n}",
                fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n	const float samples = float( VSM_SAMPLES );\n	float mean = 0.0;\n	float squared_mean = 0.0;\n	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n	for ( float i = 0.0; i < samples; i ++ ) {\n		float uvOffset = uvStart + i * uvStride;\n		#ifdef HORIZONTAL_PASS\n			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n			mean += distribution.x;\n			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n		#else\n			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n			mean += depth;\n			squared_mean += depth * depth;\n		#endif\n	}\n	mean = mean / samples;\n	squared_mean = squared_mean / samples;\n	float std_dev = sqrt( squared_mean - mean * mean );\n	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}"
            }), p = d.clone();
            p.defines.HORIZONTAL_PASS = 1;
            const f = new Eu;
            f.setAttribute("position", new ou(new Float32Array([
                -1,
                -1,
                .5,
                3,
                -1,
                .5,
                -1,
                3,
                .5
            ]), 3));
            const m = new Vu(f, d), g = this;
            this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = sr;
            let A = this.type;
            function v(n, i) {
                const a = t.update(m);
                d.defines.VSM_SAMPLES !== n.blurSamples && (d.defines.VSM_SAMPLES = n.blurSamples, p.defines.VSM_SAMPLES = n.blurSamples, d.needsUpdate = !0, p.needsUpdate = !0), null === n.mapPass && (n.mapPass = new wl(r.x, r.y)), d.uniforms.shadow_pass.value = n.map.texture, d.uniforms.resolution.value = n.mapSize, d.uniforms.radius.value = n.radius, e1.setRenderTarget(n.mapPass), e1.clear(), e1.renderBufferDirect(i, null, a, d, m, null), p.uniforms.shadow_pass.value = n.mapPass.texture, p.uniforms.resolution.value = n.mapSize, p.uniforms.radius.value = n.radius, e1.setRenderTarget(n.map), e1.clear(), e1.renderBufferDirect(i, null, a, p, m, null);
            }
            function M(t, n, i, r) {
                let a = null;
                const s = !0 === i.isPointLight ? t.customDistanceMaterial : t.customDepthMaterial;
                if (void 0 !== s) a = s;
                else if (a = !0 === i.isPointLight ? l : o, e1.localClippingEnabled && !0 === n.clipShadows && Array.isArray(n.clippingPlanes) && 0 !== n.clippingPlanes.length || n.displacementMap && 0 !== n.displacementScale || n.alphaMap && n.alphaTest > 0 || n.map && n.alphaTest > 0) {
                    const e1 = a.uuid, t = n.uuid;
                    let i = c[e1];
                    void 0 === i && (i = {}, c[e1] = i);
                    let r = i[t];
                    void 0 === r && (r = a.clone(), i[t] = r), a = r;
                }
                return a.visible = n.visible, a.wireframe = n.wireframe, a.side = r === lr ? null !== n.shadowSide ? n.shadowSide : n.side : null !== n.shadowSide ? n.shadowSide : h[n.side], a.alphaMap = n.alphaMap, a.alphaTest = n.alphaTest, a.map = n.map, a.clipShadows = n.clipShadows, a.clippingPlanes = n.clippingPlanes, a.clipIntersection = n.clipIntersection, a.displacementMap = n.displacementMap, a.displacementScale = n.displacementScale, a.displacementBias = n.displacementBias, a.wireframeLinewidth = n.wireframeLinewidth, a.linewidth = n.linewidth, !0 === i.isPointLight && !0 === a.isMeshDistanceMaterial && (e1.properties.get(a).light = i), a;
            }
            function y(n, r, a, s, o) {
                if (!1 === n.visible) return;
                if (n.layers.test(r.layers) && (n.isMesh || n.isLine || n.isPoints) && (n.castShadow || n.receiveShadow && o === lr) && (!n.frustumCulled || i.intersectsObject(n))) {
                    n.modelViewMatrix.multiplyMatrices(a.matrixWorldInverse, n.matrixWorld);
                    const i = t.update(n), r = n.material;
                    if (Array.isArray(r)) {
                        const t = i.groups;
                        for(let l = 0, c = t.length; l < c; l++){
                            const c = t[l], u = r[c.materialIndex];
                            if (u && u.visible) {
                                const t = M(n, u, s, o);
                                e1.renderBufferDirect(a, null, i, t, n, c);
                            }
                        }
                    } else if (r.visible) {
                        const t = M(n, r, s, o);
                        e1.renderBufferDirect(a, null, i, t, n, null);
                    }
                }
                const l = n.children;
                for(let e1 = 0, t = l.length; e1 < t; e1++)y(l[e1], r, a, s, o);
            }
            this.render = function(t, n, o) {
                if (!1 === g.enabled) return;
                if (!1 === g.autoUpdate && !1 === g.needsUpdate) return;
                if (0 === t.length) return;
                const l = e1.getRenderTarget(), c = e1.getActiveCubeFace(), h = e1.getActiveMipmapLevel(), d = e1.state;
                d.setBlending(pr), d.buffers.color.setClear(1, 1, 1, 1), d.buffers.depth.setTest(!0), d.setScissorTest(!1);
                const p = A !== lr && this.type === lr, f = A === lr && this.type !== lr;
                for(let l = 0, c = t.length; l < c; l++){
                    const c = t[l], h = c.shadow;
                    if (void 0 === h) {
                        console.warn("THREE.WebGLShadowMap:", c, "has no shadow.");
                        continue;
                    }
                    if (!1 === h.autoUpdate && !1 === h.needsUpdate) continue;
                    r.copy(h.mapSize);
                    const m = h.getFrameExtents();
                    if (r.multiply(m), a.copy(h.mapSize), (r.x > u || r.y > u) && (r.x > u && (a.x = Math.floor(u / m.x), r.x = a.x * m.x, h.mapSize.x = a.x), r.y > u && (a.y = Math.floor(u / m.y), r.y = a.y * m.y, h.mapSize.y = a.y)), null === h.map || !0 === p || !0 === f) {
                        const e1 = this.type !== lr ? {
                            minFilter: pa,
                            magFilter: pa
                        } : {};
                        null !== h.map && h.map.dispose(), h.map = new wl(r.x, r.y, e1), h.map.texture.name = c.name + ".shadowMap", h.camera.updateProjectionMatrix();
                    }
                    e1.setRenderTarget(h.map), e1.clear();
                    const g = h.getViewportCount();
                    for(let e1 = 0; e1 < g; e1++){
                        const t = h.getViewport(e1);
                        s.set(a.x * t.x, a.y * t.y, a.x * t.z, a.y * t.w), d.viewport(s), h.updateMatrices(c, e1), i = h.getFrustum(), y(n, o, h.camera, c, this.type);
                    }
                    !0 !== h.isPointLightShadow && this.type === lr && v(h, o), h.needsUpdate = !1;
                }
                A = this.type, g.needsUpdate = !1, e1.setRenderTarget(l, c, h);
            };
        }
        function zp(e1, t, n) {
            const i = n.isWebGL2, r = new function() {
                let t = !1;
                const n = new _l;
                let i = null;
                const r = new _l(0, 0, 0, 0);
                return {
                    setMask: function(n) {
                        i === n || t || (e1.colorMask(n, n, n, n), i = n);
                    },
                    setLocked: function(e1) {
                        t = e1;
                    },
                    setClear: function(t, i, a, s, o) {
                        !0 === o && (t *= s, i *= s, a *= s), n.set(t, i, a, s), !1 === r.equals(n) && (e1.clearColor(t, i, a, s), r.copy(n));
                    },
                    reset: function() {
                        t = !1, i = null, r.set(-1, 0, 0, 0);
                    }
                };
            }, a = new function() {
                let t = !1, n = null, i = null, r = null;
                return {
                    setTest: function(t) {
                        t ? H(e1.DEPTH_TEST) : V(e1.DEPTH_TEST);
                    },
                    setMask: function(i) {
                        n === i || t || (e1.depthMask(i), n = i);
                    },
                    setFunc: function(t) {
                        if (i !== t) {
                            switch(t){
                                case jr:
                                    e1.depthFunc(e1.NEVER);
                                    break;
                                case Br:
                                    e1.depthFunc(e1.ALWAYS);
                                    break;
                                case Fr:
                                    e1.depthFunc(e1.LESS);
                                    break;
                                case Hr:
                                    e1.depthFunc(e1.LEQUAL);
                                    break;
                                case Vr:
                                    e1.depthFunc(e1.EQUAL);
                                    break;
                                case Gr:
                                    e1.depthFunc(e1.GEQUAL);
                                    break;
                                case Qr:
                                    e1.depthFunc(e1.GREATER);
                                    break;
                                case Wr:
                                    e1.depthFunc(e1.NOTEQUAL);
                                    break;
                                default:
                                    e1.depthFunc(e1.LEQUAL);
                            }
                            i = t;
                        }
                    },
                    setLocked: function(e1) {
                        t = e1;
                    },
                    setClear: function(t) {
                        r !== t && (e1.clearDepth(t), r = t);
                    },
                    reset: function() {
                        t = !1, n = null, i = null, r = null;
                    }
                };
            }, s = new function() {
                let t = !1, n = null, i = null, r = null, a = null, s = null, o = null, l = null, c = null;
                return {
                    setTest: function(n) {
                        t || (n ? H(e1.STENCIL_TEST) : V(e1.STENCIL_TEST));
                    },
                    setMask: function(i) {
                        n === i || t || (e1.stencilMask(i), n = i);
                    },
                    setFunc: function(t, n, s) {
                        i === t && r === n && a === s || (e1.stencilFunc(t, n, s), i = t, r = n, a = s);
                    },
                    setOp: function(t, n, i) {
                        s === t && o === n && l === i || (e1.stencilOp(t, n, i), s = t, o = n, l = i);
                    },
                    setLocked: function(e1) {
                        t = e1;
                    },
                    setClear: function(t) {
                        c !== t && (e1.clearStencil(t), c = t);
                    },
                    reset: function() {
                        t = !1, n = null, i = null, r = null, a = null, s = null, o = null, l = null, c = null;
                    }
                };
            }, o = new WeakMap, l = new WeakMap;
            let c = {}, u = {}, h = new WeakMap, d = [], p = null, f = !1, m = null, g = null, A = null, v = null, M = null, y = null, x = null, _ = new Zc(0, 0, 0), b = 0, w = !1, E = null, T = null, S = null, I = null, N = null;
            const D = e1.getParameter(e1.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
            let C = !1, L = 0;
            const R = e1.getParameter(e1.VERSION);
            -1 !== R.indexOf("WebGL") ? (L = parseFloat(/^WebGL (\d)/.exec(R)[1]), C = L >= 1) : -1 !== R.indexOf("OpenGL ES") && (L = parseFloat(/^OpenGL ES (\d)/.exec(R)[1]), C = L >= 2);
            let z = null, O = {};
            const P = e1.getParameter(e1.SCISSOR_BOX), U = e1.getParameter(e1.VIEWPORT), k = (new _l).fromArray(P), j = (new _l).fromArray(U);
            function B(t, n, r, a) {
                const s = new Uint8Array(4), o = e1.createTexture();
                e1.bindTexture(t, o), e1.texParameteri(t, e1.TEXTURE_MIN_FILTER, e1.NEAREST), e1.texParameteri(t, e1.TEXTURE_MAG_FILTER, e1.NEAREST);
                for(let o = 0; o < r; o++)!i || t !== e1.TEXTURE_3D && t !== e1.TEXTURE_2D_ARRAY ? e1.texImage2D(n + o, 0, e1.RGBA, 1, 1, 0, e1.RGBA, e1.UNSIGNED_BYTE, s) : e1.texImage3D(n, 0, e1.RGBA, 1, 1, a, 0, e1.RGBA, e1.UNSIGNED_BYTE, s);
                return o;
            }
            const F = {};
            function H(t) {
                !0 !== c[t] && (e1.enable(t), c[t] = !0);
            }
            function V(t) {
                !1 !== c[t] && (e1.disable(t), c[t] = !1);
            }
            F[e1.TEXTURE_2D] = B(e1.TEXTURE_2D, e1.TEXTURE_2D, 1), F[e1.TEXTURE_CUBE_MAP] = B(e1.TEXTURE_CUBE_MAP, e1.TEXTURE_CUBE_MAP_POSITIVE_X, 6), i && (F[e1.TEXTURE_2D_ARRAY] = B(e1.TEXTURE_2D_ARRAY, e1.TEXTURE_2D_ARRAY, 1, 1), F[e1.TEXTURE_3D] = B(e1.TEXTURE_3D, e1.TEXTURE_3D, 1, 1)), r.setClear(0, 0, 0, 1), a.setClear(1), s.setClear(0), H(e1.DEPTH_TEST), a.setFunc(Hr), Y(!1), X(nr), H(e1.CULL_FACE), W(pr);
            const G = {
                [Mr]: e1.FUNC_ADD,
                [yr]: e1.FUNC_SUBTRACT,
                [xr]: e1.FUNC_REVERSE_SUBTRACT
            };
            if (i) G[_r] = e1.MIN, G[br] = e1.MAX;
            else {
                const e1 = t.get("EXT_blend_minmax");
                null !== e1 && (G[_r] = e1.MIN_EXT, G[br] = e1.MAX_EXT);
            }
            const Q = {
                [wr]: e1.ZERO,
                [Er]: e1.ONE,
                [Tr]: e1.SRC_COLOR,
                [Ir]: e1.SRC_ALPHA,
                [zr]: e1.SRC_ALPHA_SATURATE,
                [Lr]: e1.DST_COLOR,
                [Dr]: e1.DST_ALPHA,
                [Sr]: e1.ONE_MINUS_SRC_COLOR,
                [Nr]: e1.ONE_MINUS_SRC_ALPHA,
                [Rr]: e1.ONE_MINUS_DST_COLOR,
                [Cr]: e1.ONE_MINUS_DST_ALPHA,
                [Or]: e1.CONSTANT_COLOR,
                [Pr]: e1.ONE_MINUS_CONSTANT_COLOR,
                [Ur]: e1.CONSTANT_ALPHA,
                [kr]: e1.ONE_MINUS_CONSTANT_ALPHA
            };
            function W(t, n, i, r, a, s, o, l, c, u) {
                if (t !== pr) {
                    if (!1 === f && (H(e1.BLEND), f = !0), t === vr) a = a || n, s = s || i, o = o || r, n === g && a === M || (e1.blendEquationSeparate(G[n], G[a]), g = n, M = a), i === A && r === v && s === y && o === x || (e1.blendFuncSeparate(Q[i], Q[r], Q[s], Q[o]), A = i, v = r, y = s, x = o), !1 !== l.equals(_) && c === b || (e1.blendColor(l.r, l.g, l.b, c), _.copy(l), b = c), m = t, w = !1;
                    else if (t !== m || u !== w) {
                        if (g === Mr && M === Mr || (e1.blendEquation(e1.FUNC_ADD), g = Mr, M = Mr), u) switch(t){
                            case fr:
                                e1.blendFuncSeparate(e1.ONE, e1.ONE_MINUS_SRC_ALPHA, e1.ONE, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case mr:
                                e1.blendFunc(e1.ONE, e1.ONE);
                                break;
                            case gr:
                                e1.blendFuncSeparate(e1.ZERO, e1.ONE_MINUS_SRC_COLOR, e1.ZERO, e1.ONE);
                                break;
                            case Ar:
                                e1.blendFuncSeparate(e1.ZERO, e1.SRC_COLOR, e1.ZERO, e1.SRC_ALPHA);
                                break;
                            default:
                                console.error("THREE.WebGLState: Invalid blending: ", t);
                        }
                        else switch(t){
                            case fr:
                                e1.blendFuncSeparate(e1.SRC_ALPHA, e1.ONE_MINUS_SRC_ALPHA, e1.ONE, e1.ONE_MINUS_SRC_ALPHA);
                                break;
                            case mr:
                                e1.blendFunc(e1.SRC_ALPHA, e1.ONE);
                                break;
                            case gr:
                                e1.blendFuncSeparate(e1.ZERO, e1.ONE_MINUS_SRC_COLOR, e1.ZERO, e1.ONE);
                                break;
                            case Ar:
                                e1.blendFunc(e1.ZERO, e1.SRC_COLOR);
                                break;
                            default:
                                console.error("THREE.WebGLState: Invalid blending: ", t);
                        }
                        A = null, v = null, y = null, x = null, _.set(0, 0, 0), b = 0, m = t, w = u;
                    }
                } else !0 === f && (V(e1.BLEND), f = !1);
            }
            function Y(t) {
                E !== t && (t ? e1.frontFace(e1.CW) : e1.frontFace(e1.CCW), E = t);
            }
            function X(t) {
                t !== tr ? (H(e1.CULL_FACE), t !== T && (t === nr ? e1.cullFace(e1.BACK) : t === ir ? e1.cullFace(e1.FRONT) : e1.cullFace(e1.FRONT_AND_BACK))) : V(e1.CULL_FACE), T = t;
            }
            function Z(t, n, i) {
                t ? (H(e1.POLYGON_OFFSET_FILL), I === n && N === i || (e1.polygonOffset(n, i), I = n, N = i)) : V(e1.POLYGON_OFFSET_FILL);
            }
            return {
                buffers: {
                    color: r,
                    depth: a,
                    stencil: s
                },
                enable: H,
                disable: V,
                bindFramebuffer: function(t, n) {
                    return u[t] !== n && (e1.bindFramebuffer(t, n), u[t] = n, i && (t === e1.DRAW_FRAMEBUFFER && (u[e1.FRAMEBUFFER] = n), t === e1.FRAMEBUFFER && (u[e1.DRAW_FRAMEBUFFER] = n)), !0);
                },
                drawBuffers: function(i, r) {
                    let a = d, s = !1;
                    if (i) {
                        if (a = h.get(r), void 0 === a && (a = [], h.set(r, a)), i.isWebGLMultipleRenderTargets) {
                            const t = i.texture;
                            if (a.length !== t.length || a[0] !== e1.COLOR_ATTACHMENT0) {
                                for(let n = 0, i = t.length; n < i; n++)a[n] = e1.COLOR_ATTACHMENT0 + n;
                                a.length = t.length, s = !0;
                            }
                        } else a[0] !== e1.COLOR_ATTACHMENT0 && (a[0] = e1.COLOR_ATTACHMENT0, s = !0);
                    } else a[0] !== e1.BACK && (a[0] = e1.BACK, s = !0);
                    s && (n.isWebGL2 ? e1.drawBuffers(a) : t.get("WEBGL_draw_buffers").drawBuffersWEBGL(a));
                },
                useProgram: function(t) {
                    return p !== t && (e1.useProgram(t), p = t, !0);
                },
                setBlending: W,
                setMaterial: function(t, n) {
                    t.side === hr ? V(e1.CULL_FACE) : H(e1.CULL_FACE);
                    let i = t.side === ur;
                    n && (i = !i), Y(i), t.blending === fr && !1 === t.transparent ? W(pr) : W(t.blending, t.blendEquation, t.blendSrc, t.blendDst, t.blendEquationAlpha, t.blendSrcAlpha, t.blendDstAlpha, t.blendColor, t.blendAlpha, t.premultipliedAlpha), a.setFunc(t.depthFunc), a.setTest(t.depthTest), a.setMask(t.depthWrite), r.setMask(t.colorWrite);
                    const o = t.stencilWrite;
                    s.setTest(o), o && (s.setMask(t.stencilWriteMask), s.setFunc(t.stencilFunc, t.stencilRef, t.stencilFuncMask), s.setOp(t.stencilFail, t.stencilZFail, t.stencilZPass)), Z(t.polygonOffset, t.polygonOffsetFactor, t.polygonOffsetUnits), !0 === t.alphaToCoverage ? H(e1.SAMPLE_ALPHA_TO_COVERAGE) : V(e1.SAMPLE_ALPHA_TO_COVERAGE);
                },
                setFlipSided: Y,
                setCullFace: X,
                setLineWidth: function(t) {
                    t !== S && (C && e1.lineWidth(t), S = t);
                },
                setPolygonOffset: Z,
                setScissorTest: function(t) {
                    t ? H(e1.SCISSOR_TEST) : V(e1.SCISSOR_TEST);
                },
                activeTexture: function(t) {
                    void 0 === t && (t = e1.TEXTURE0 + D - 1), z !== t && (e1.activeTexture(t), z = t);
                },
                bindTexture: function(t, n, i) {
                    void 0 === i && (i = null === z ? e1.TEXTURE0 + D - 1 : z);
                    let r = O[i];
                    void 0 === r && (r = {
                        type: void 0,
                        texture: void 0
                    }, O[i] = r), r.type === t && r.texture === n || (z !== i && (e1.activeTexture(i), z = i), e1.bindTexture(t, n || F[t]), r.type = t, r.texture = n);
                },
                unbindTexture: function() {
                    const t = O[z];
                    void 0 !== t && void 0 !== t.type && (e1.bindTexture(t.type, null), t.type = void 0, t.texture = void 0);
                },
                compressedTexImage2D: function() {
                    try {
                        e1.compressedTexImage2D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                compressedTexImage3D: function() {
                    try {
                        e1.compressedTexImage3D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                texImage2D: function() {
                    try {
                        e1.texImage2D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                texImage3D: function() {
                    try {
                        e1.texImage3D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                updateUBOMapping: function(t, n) {
                    let i = l.get(n);
                    void 0 === i && (i = new WeakMap, l.set(n, i));
                    let r = i.get(t);
                    void 0 === r && (r = e1.getUniformBlockIndex(n, t.name), i.set(t, r));
                },
                uniformBlockBinding: function(t, n) {
                    const i = l.get(n).get(t);
                    o.get(n) !== i && (e1.uniformBlockBinding(n, i, t.__bindingPointIndex), o.set(n, i));
                },
                texStorage2D: function() {
                    try {
                        e1.texStorage2D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                texStorage3D: function() {
                    try {
                        e1.texStorage3D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                texSubImage2D: function() {
                    try {
                        e1.texSubImage2D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                texSubImage3D: function() {
                    try {
                        e1.texSubImage3D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                compressedTexSubImage2D: function() {
                    try {
                        e1.compressedTexSubImage2D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                compressedTexSubImage3D: function() {
                    try {
                        e1.compressedTexSubImage3D.apply(e1, arguments);
                    } catch (e1) {
                        console.error("THREE.WebGLState:", e1);
                    }
                },
                scissor: function(t) {
                    !1 === k.equals(t) && (e1.scissor(t.x, t.y, t.z, t.w), k.copy(t));
                },
                viewport: function(t) {
                    !1 === j.equals(t) && (e1.viewport(t.x, t.y, t.z, t.w), j.copy(t));
                },
                reset: function() {
                    e1.disable(e1.BLEND), e1.disable(e1.CULL_FACE), e1.disable(e1.DEPTH_TEST), e1.disable(e1.POLYGON_OFFSET_FILL), e1.disable(e1.SCISSOR_TEST), e1.disable(e1.STENCIL_TEST), e1.disable(e1.SAMPLE_ALPHA_TO_COVERAGE), e1.blendEquation(e1.FUNC_ADD), e1.blendFunc(e1.ONE, e1.ZERO), e1.blendFuncSeparate(e1.ONE, e1.ZERO, e1.ONE, e1.ZERO), e1.blendColor(0, 0, 0, 0), e1.colorMask(!0, !0, !0, !0), e1.clearColor(0, 0, 0, 0), e1.depthMask(!0), e1.depthFunc(e1.LESS), e1.clearDepth(1), e1.stencilMask(4294967295), e1.stencilFunc(e1.ALWAYS, 0, 4294967295), e1.stencilOp(e1.KEEP, e1.KEEP, e1.KEEP), e1.clearStencil(0), e1.cullFace(e1.BACK), e1.frontFace(e1.CCW), e1.polygonOffset(0, 0), e1.activeTexture(e1.TEXTURE0), e1.bindFramebuffer(e1.FRAMEBUFFER, null), !0 === i && (e1.bindFramebuffer(e1.DRAW_FRAMEBUFFER, null), e1.bindFramebuffer(e1.READ_FRAMEBUFFER, null)), e1.useProgram(null), e1.lineWidth(1), e1.scissor(0, 0, e1.canvas.width, e1.canvas.height), e1.viewport(0, 0, e1.canvas.width, e1.canvas.height), c = {}, z = null, O = {}, u = {}, h = new WeakMap, d = [], p = null, f = !1, m = null, g = null, A = null, v = null, M = null, y = null, x = null, _ = new Zc(0, 0, 0), b = 0, w = !1, E = null, T = null, S = null, I = null, N = null, k.set(0, 0, e1.canvas.width, e1.canvas.height), j.set(0, 0, e1.canvas.width, e1.canvas.height), r.reset(), a.reset(), s.reset();
                }
            };
        }
        function Op(e1, t, n, i, r, a, s) {
            const o = r.isWebGL2, l = r.maxTextures, c = r.maxCubemapSize, u = r.maxTextureSize, h = r.maxSamples, d = t.has("WEBGL_multisampled_render_to_texture") ? t.get("WEBGL_multisampled_render_to_texture") : null, p = "undefined" != typeof navigator && /OculusBrowser/g.test(navigator.userAgent), f = new WeakMap;
            let m;
            const g = new WeakMap;
            let A = !1;
            try {
                A = "undefined" != typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
            } catch (e1) {}
            function v(e1, t) {
                return A ? new OffscreenCanvas(e1, t) : rl("canvas");
            }
            function M(e1, t, n, i) {
                let r = 1;
                if ((e1.width > i || e1.height > i) && (r = i / Math.max(e1.width, e1.height)), r < 1 || !0 === t) {
                    if ("undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap) {
                        const i = t ? Xo : Math.floor, a = i(r * e1.width), s = i(r * e1.height);
                        void 0 === m && (m = v(a, s));
                        const o = n ? v(a, s) : m;
                        return o.width = a, o.height = s, o.getContext("2d").drawImage(e1, 0, 0, a, s), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + e1.width + "x" + e1.height + ") to (" + a + "x" + s + ")."), o;
                    }
                    return "data" in e1 && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + e1.width + "x" + e1.height + ")."), e1;
                }
                return e1;
            }
            function y(e1) {
                return Wo(e1.width) && Wo(e1.height);
            }
            function x(e1, t) {
                return e1.generateMipmaps && t && e1.minFilter !== pa && e1.minFilter !== va;
            }
            function _(t) {
                e1.generateMipmap(t);
            }
            function b(n, i, r, a) {
                let s = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                if (!1 === o) return i;
                if (null !== n) {
                    if (void 0 !== e1[n]) return e1[n];
                    console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + n + "'");
                }
                let l = i;
                if (i === e1.RED && (r === e1.FLOAT && (l = e1.R32F), r === e1.HALF_FLOAT && (l = e1.R16F), r === e1.UNSIGNED_BYTE && (l = e1.R8)), i === e1.RED_INTEGER && (r === e1.UNSIGNED_BYTE && (l = e1.R8UI), r === e1.UNSIGNED_SHORT && (l = e1.R16UI), r === e1.UNSIGNED_INT && (l = e1.R32UI), r === e1.BYTE && (l = e1.R8I), r === e1.SHORT && (l = e1.R16I), r === e1.INT && (l = e1.R32I)), i === e1.RG && (r === e1.FLOAT && (l = e1.RG32F), r === e1.HALF_FLOAT && (l = e1.RG16F), r === e1.UNSIGNED_BYTE && (l = e1.RG8)), i === e1.RGBA) {
                    const t = s ? Xs : dl.getTransfer(a);
                    r === e1.FLOAT && (l = e1.RGBA32F), r === e1.HALF_FLOAT && (l = e1.RGBA16F), r === e1.UNSIGNED_BYTE && (l = t === Zs ? e1.SRGB8_ALPHA8 : e1.RGBA8), r === e1.UNSIGNED_SHORT_4_4_4_4 && (l = e1.RGBA4), r === e1.UNSIGNED_SHORT_5_5_5_1 && (l = e1.RGB5_A1);
                }
                return l !== e1.R16F && l !== e1.R32F && l !== e1.RG16F && l !== e1.RG32F && l !== e1.RGBA16F && l !== e1.RGBA32F || t.get("EXT_color_buffer_float"), l;
            }
            function w(e1, t, n) {
                return !0 === x(e1, n) || e1.isFramebufferTexture && e1.minFilter !== pa && e1.minFilter !== va ? Math.log2(Math.max(t.width, t.height)) + 1 : void 0 !== e1.mipmaps && e1.mipmaps.length > 0 ? e1.mipmaps.length : e1.isCompressedTexture && Array.isArray(e1.image) ? t.mipmaps.length : 1;
            }
            function E(t) {
                return t === pa || t === fa || t === ga ? e1.NEAREST : e1.LINEAR;
            }
            function T(e1) {
                const t = e1.target;
                t.removeEventListener("dispose", T), function(e1) {
                    const t = i.get(e1);
                    if (void 0 === t.__webglInit) return;
                    const n = e1.source, r = g.get(n);
                    if (r) {
                        const i = r[t.__cacheKey];
                        i.usedTimes--, 0 === i.usedTimes && I(e1), 0 === Object.keys(r).length && g.delete(n);
                    }
                    i.remove(e1);
                }(t), t.isVideoTexture && f.delete(t);
            }
            function S(t) {
                const n = t.target;
                n.removeEventListener("dispose", S), function(t) {
                    const n = t.texture, r = i.get(t), a = i.get(n);
                    if (void 0 !== a.__webglTexture && (e1.deleteTexture(a.__webglTexture), s.memory.textures--), t.depthTexture && t.depthTexture.dispose(), t.isWebGLCubeRenderTarget) for(let t = 0; t < 6; t++){
                        if (Array.isArray(r.__webglFramebuffer[t])) for(let n = 0; n < r.__webglFramebuffer[t].length; n++)e1.deleteFramebuffer(r.__webglFramebuffer[t][n]);
                        else e1.deleteFramebuffer(r.__webglFramebuffer[t]);
                        r.__webglDepthbuffer && e1.deleteRenderbuffer(r.__webglDepthbuffer[t]);
                    }
                    else {
                        if (Array.isArray(r.__webglFramebuffer)) for(let t = 0; t < r.__webglFramebuffer.length; t++)e1.deleteFramebuffer(r.__webglFramebuffer[t]);
                        else e1.deleteFramebuffer(r.__webglFramebuffer);
                        if (r.__webglDepthbuffer && e1.deleteRenderbuffer(r.__webglDepthbuffer), r.__webglMultisampledFramebuffer && e1.deleteFramebuffer(r.__webglMultisampledFramebuffer), r.__webglColorRenderbuffer) for(let t = 0; t < r.__webglColorRenderbuffer.length; t++)r.__webglColorRenderbuffer[t] && e1.deleteRenderbuffer(r.__webglColorRenderbuffer[t]);
                        r.__webglDepthRenderbuffer && e1.deleteRenderbuffer(r.__webglDepthRenderbuffer);
                    }
                    if (t.isWebGLMultipleRenderTargets) for(let t = 0, r = n.length; t < r; t++){
                        const r = i.get(n[t]);
                        r.__webglTexture && (e1.deleteTexture(r.__webglTexture), s.memory.textures--), i.remove(n[t]);
                    }
                    i.remove(n), i.remove(t);
                }(n);
            }
            function I(t) {
                const n = i.get(t);
                e1.deleteTexture(n.__webglTexture);
                const r = t.source;
                delete g.get(r)[n.__cacheKey], s.memory.textures--;
            }
            let N = 0;
            function D(t, r) {
                const a = i.get(t);
                if (t.isVideoTexture && function(e1) {
                    const t = s.render.frame;
                    f.get(e1) !== t && (f.set(e1, t), e1.update());
                }(t), !1 === t.isRenderTargetTexture && t.version > 0 && a.__version !== t.version) {
                    const e1 = t.image;
                    if (null === e1) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
                    else {
                        if (!1 !== e1.complete) return void P(a, t, r);
                        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
                    }
                }
                n.bindTexture(e1.TEXTURE_2D, a.__webglTexture, e1.TEXTURE0 + r);
            }
            const C = {
                [ua]: e1.REPEAT,
                [ha]: e1.CLAMP_TO_EDGE,
                [da]: e1.MIRRORED_REPEAT
            }, L = {
                [pa]: e1.NEAREST,
                [fa]: e1.NEAREST_MIPMAP_NEAREST,
                [ga]: e1.NEAREST_MIPMAP_LINEAR,
                [va]: e1.LINEAR,
                [Ma]: e1.LINEAR_MIPMAP_NEAREST,
                [xa]: e1.LINEAR_MIPMAP_LINEAR
            }, R = {
                [mo]: e1.NEVER,
                [_o]: e1.ALWAYS,
                [go]: e1.LESS,
                [vo]: e1.LEQUAL,
                [Ao]: e1.EQUAL,
                [xo]: e1.GEQUAL,
                [Mo]: e1.GREATER,
                [yo]: e1.NOTEQUAL
            };
            function z(n, a, s) {
                if (s ? (e1.texParameteri(n, e1.TEXTURE_WRAP_S, C[a.wrapS]), e1.texParameteri(n, e1.TEXTURE_WRAP_T, C[a.wrapT]), n !== e1.TEXTURE_3D && n !== e1.TEXTURE_2D_ARRAY || e1.texParameteri(n, e1.TEXTURE_WRAP_R, C[a.wrapR]), e1.texParameteri(n, e1.TEXTURE_MAG_FILTER, L[a.magFilter]), e1.texParameteri(n, e1.TEXTURE_MIN_FILTER, L[a.minFilter])) : (e1.texParameteri(n, e1.TEXTURE_WRAP_S, e1.CLAMP_TO_EDGE), e1.texParameteri(n, e1.TEXTURE_WRAP_T, e1.CLAMP_TO_EDGE), n !== e1.TEXTURE_3D && n !== e1.TEXTURE_2D_ARRAY || e1.texParameteri(n, e1.TEXTURE_WRAP_R, e1.CLAMP_TO_EDGE), a.wrapS === ha && a.wrapT === ha || console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), e1.texParameteri(n, e1.TEXTURE_MAG_FILTER, E(a.magFilter)), e1.texParameteri(n, e1.TEXTURE_MIN_FILTER, E(a.minFilter)), a.minFilter !== pa && a.minFilter !== va && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), a.compareFunction && (e1.texParameteri(n, e1.TEXTURE_COMPARE_MODE, e1.COMPARE_REF_TO_TEXTURE), e1.texParameteri(n, e1.TEXTURE_COMPARE_FUNC, R[a.compareFunction])), !0 === t.has("EXT_texture_filter_anisotropic")) {
                    const s = t.get("EXT_texture_filter_anisotropic");
                    if (a.magFilter === pa) return;
                    if (a.minFilter !== ga && a.minFilter !== xa) return;
                    if (a.type === Na && !1 === t.has("OES_texture_float_linear")) return;
                    if (!1 === o && a.type === Da && !1 === t.has("OES_texture_half_float_linear")) return;
                    (a.anisotropy > 1 || i.get(a).__currentAnisotropy) && (e1.texParameterf(n, s.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(a.anisotropy, r.getMaxAnisotropy())), i.get(a).__currentAnisotropy = a.anisotropy);
                }
            }
            function O(t, n) {
                let i = !1;
                void 0 === t.__webglInit && (t.__webglInit = !0, n.addEventListener("dispose", T));
                const r = n.source;
                let a = g.get(r);
                void 0 === a && (a = {}, g.set(r, a));
                const o = function(e1) {
                    const t = [];
                    return t.push(e1.wrapS), t.push(e1.wrapT), t.push(e1.wrapR || 0), t.push(e1.magFilter), t.push(e1.minFilter), t.push(e1.anisotropy), t.push(e1.internalFormat), t.push(e1.format), t.push(e1.type), t.push(e1.generateMipmaps), t.push(e1.premultiplyAlpha), t.push(e1.flipY), t.push(e1.unpackAlignment), t.push(e1.colorSpace), t.join();
                }(n);
                if (o !== t.__cacheKey) {
                    void 0 === a[o] && (a[o] = {
                        texture: e1.createTexture(),
                        usedTimes: 0
                    }, s.memory.textures++, i = !0), a[o].usedTimes++;
                    const r = a[t.__cacheKey];
                    void 0 !== r && (a[t.__cacheKey].usedTimes--, 0 === r.usedTimes && I(n)), t.__cacheKey = o, t.__webglTexture = a[o].texture;
                }
                return i;
            }
            function P(t, r, s) {
                let l = e1.TEXTURE_2D;
                (r.isDataArrayTexture || r.isCompressedArrayTexture) && (l = e1.TEXTURE_2D_ARRAY), r.isData3DTexture && (l = e1.TEXTURE_3D);
                const c = O(t, r), h = r.source;
                n.bindTexture(l, t.__webglTexture, e1.TEXTURE0 + s);
                const d = i.get(h);
                if (h.version !== d.__version || !0 === c) {
                    n.activeTexture(e1.TEXTURE0 + s);
                    const t = dl.getPrimaries(dl.workingColorSpace), i = r.colorSpace === Vs ? null : dl.getPrimaries(r.colorSpace), p = r.colorSpace === Vs || t === i ? e1.NONE : e1.BROWSER_DEFAULT_WEBGL;
                    e1.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, r.flipY), e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), e1.pixelStorei(e1.UNPACK_ALIGNMENT, r.unpackAlignment), e1.pixelStorei(e1.UNPACK_COLORSPACE_CONVERSION_WEBGL, p);
                    const f = function(e1) {
                        return !o && (e1.wrapS !== ha || e1.wrapT !== ha || e1.minFilter !== pa && e1.minFilter !== va);
                    }(r) && !1 === y(r.image);
                    let m = M(r.image, f, !1, u);
                    m = H(r, m);
                    const g = y(m) || o, A = a.convert(r.format, r.colorSpace);
                    let v, E = a.convert(r.type), T = b(r.internalFormat, A, E, r.colorSpace, r.isVideoTexture);
                    z(l, r, g);
                    const S = r.mipmaps, I = o && !0 !== r.isVideoTexture, N = void 0 === d.__version || !0 === c, D = w(r, m, g);
                    if (r.isDepthTexture) T = e1.DEPTH_COMPONENT, o ? T = r.type === Na ? e1.DEPTH_COMPONENT32F : r.type === Ia ? e1.DEPTH_COMPONENT24 : r.type === Ra ? e1.DEPTH24_STENCIL8 : e1.DEPTH_COMPONENT16 : r.type === Na && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), r.format === ka && T === e1.DEPTH_COMPONENT && r.type !== Ta && r.type !== Ia && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), r.type = Ia, E = a.convert(r.type)), r.format === ja && T === e1.DEPTH_COMPONENT && (T = e1.DEPTH_STENCIL, r.type !== Ra && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), r.type = Ra, E = a.convert(r.type))), N && (I ? n.texStorage2D(e1.TEXTURE_2D, 1, T, m.width, m.height) : n.texImage2D(e1.TEXTURE_2D, 0, T, m.width, m.height, 0, A, E, null));
                    else if (r.isDataTexture) {
                        if (S.length > 0 && g) {
                            I && N && n.texStorage2D(e1.TEXTURE_2D, D, T, S[0].width, S[0].height);
                            for(let t = 0, i = S.length; t < i; t++)v = S[t], I ? n.texSubImage2D(e1.TEXTURE_2D, t, 0, 0, v.width, v.height, A, E, v.data) : n.texImage2D(e1.TEXTURE_2D, t, T, v.width, v.height, 0, A, E, v.data);
                            r.generateMipmaps = !1;
                        } else I ? (N && n.texStorage2D(e1.TEXTURE_2D, D, T, m.width, m.height), n.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, m.width, m.height, A, E, m.data)) : n.texImage2D(e1.TEXTURE_2D, 0, T, m.width, m.height, 0, A, E, m.data);
                    } else if (r.isCompressedTexture) {
                        if (r.isCompressedArrayTexture) {
                            I && N && n.texStorage3D(e1.TEXTURE_2D_ARRAY, D, T, S[0].width, S[0].height, m.depth);
                            for(let t = 0, i = S.length; t < i; t++)v = S[t], r.format !== Oa ? null !== A ? I ? n.compressedTexSubImage3D(e1.TEXTURE_2D_ARRAY, t, 0, 0, 0, v.width, v.height, m.depth, A, v.data, 0, 0) : n.compressedTexImage3D(e1.TEXTURE_2D_ARRAY, t, T, v.width, v.height, m.depth, 0, v.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : I ? n.texSubImage3D(e1.TEXTURE_2D_ARRAY, t, 0, 0, 0, v.width, v.height, m.depth, A, E, v.data) : n.texImage3D(e1.TEXTURE_2D_ARRAY, t, T, v.width, v.height, m.depth, 0, A, E, v.data);
                        } else {
                            I && N && n.texStorage2D(e1.TEXTURE_2D, D, T, S[0].width, S[0].height);
                            for(let t = 0, i = S.length; t < i; t++)v = S[t], r.format !== Oa ? null !== A ? I ? n.compressedTexSubImage2D(e1.TEXTURE_2D, t, 0, 0, v.width, v.height, A, v.data) : n.compressedTexImage2D(e1.TEXTURE_2D, t, T, v.width, v.height, 0, v.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : I ? n.texSubImage2D(e1.TEXTURE_2D, t, 0, 0, v.width, v.height, A, E, v.data) : n.texImage2D(e1.TEXTURE_2D, t, T, v.width, v.height, 0, A, E, v.data);
                        }
                    } else if (r.isDataArrayTexture) I ? (N && n.texStorage3D(e1.TEXTURE_2D_ARRAY, D, T, m.width, m.height, m.depth), n.texSubImage3D(e1.TEXTURE_2D_ARRAY, 0, 0, 0, 0, m.width, m.height, m.depth, A, E, m.data)) : n.texImage3D(e1.TEXTURE_2D_ARRAY, 0, T, m.width, m.height, m.depth, 0, A, E, m.data);
                    else if (r.isData3DTexture) I ? (N && n.texStorage3D(e1.TEXTURE_3D, D, T, m.width, m.height, m.depth), n.texSubImage3D(e1.TEXTURE_3D, 0, 0, 0, 0, m.width, m.height, m.depth, A, E, m.data)) : n.texImage3D(e1.TEXTURE_3D, 0, T, m.width, m.height, m.depth, 0, A, E, m.data);
                    else if (r.isFramebufferTexture) {
                        if (N) {
                            if (I) n.texStorage2D(e1.TEXTURE_2D, D, T, m.width, m.height);
                            else {
                                let t = m.width, i = m.height;
                                for(let r = 0; r < D; r++)n.texImage2D(e1.TEXTURE_2D, r, T, t, i, 0, A, E, null), t >>= 1, i >>= 1;
                            }
                        }
                    } else if (S.length > 0 && g) {
                        I && N && n.texStorage2D(e1.TEXTURE_2D, D, T, S[0].width, S[0].height);
                        for(let t = 0, i = S.length; t < i; t++)v = S[t], I ? n.texSubImage2D(e1.TEXTURE_2D, t, 0, 0, A, E, v) : n.texImage2D(e1.TEXTURE_2D, t, T, A, E, v);
                        r.generateMipmaps = !1;
                    } else I ? (N && n.texStorage2D(e1.TEXTURE_2D, D, T, m.width, m.height), n.texSubImage2D(e1.TEXTURE_2D, 0, 0, 0, A, E, m)) : n.texImage2D(e1.TEXTURE_2D, 0, T, A, E, m);
                    x(r, g) && _(l), d.__version = h.version, r.onUpdate && r.onUpdate(r);
                }
                t.__version = r.version;
            }
            function U(t, r, s, o, l, c) {
                const u = a.convert(s.format, s.colorSpace), h = a.convert(s.type), p = b(s.internalFormat, u, h, s.colorSpace);
                if (!i.get(r).__hasExternalTextures) {
                    const t = Math.max(1, r.width >> c), i = Math.max(1, r.height >> c);
                    l === e1.TEXTURE_3D || l === e1.TEXTURE_2D_ARRAY ? n.texImage3D(l, c, p, t, i, r.depth, 0, u, h, null) : n.texImage2D(l, c, p, t, i, 0, u, h, null);
                }
                n.bindFramebuffer(e1.FRAMEBUFFER, t), F(r) ? d.framebufferTexture2DMultisampleEXT(e1.FRAMEBUFFER, o, l, i.get(s).__webglTexture, 0, B(r)) : (l === e1.TEXTURE_2D || l >= e1.TEXTURE_CUBE_MAP_POSITIVE_X && l <= e1.TEXTURE_CUBE_MAP_NEGATIVE_Z) && e1.framebufferTexture2D(e1.FRAMEBUFFER, o, l, i.get(s).__webglTexture, c), n.bindFramebuffer(e1.FRAMEBUFFER, null);
            }
            function k(t, n, i) {
                if (e1.bindRenderbuffer(e1.RENDERBUFFER, t), n.depthBuffer && !n.stencilBuffer) {
                    let r = !0 === o ? e1.DEPTH_COMPONENT24 : e1.DEPTH_COMPONENT16;
                    if (i || F(n)) {
                        const t = n.depthTexture;
                        t && t.isDepthTexture && (t.type === Na ? r = e1.DEPTH_COMPONENT32F : t.type === Ia && (r = e1.DEPTH_COMPONENT24));
                        const i = B(n);
                        F(n) ? d.renderbufferStorageMultisampleEXT(e1.RENDERBUFFER, i, r, n.width, n.height) : e1.renderbufferStorageMultisample(e1.RENDERBUFFER, i, r, n.width, n.height);
                    } else e1.renderbufferStorage(e1.RENDERBUFFER, r, n.width, n.height);
                    e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.RENDERBUFFER, t);
                } else if (n.depthBuffer && n.stencilBuffer) {
                    const r = B(n);
                    i && !1 === F(n) ? e1.renderbufferStorageMultisample(e1.RENDERBUFFER, r, e1.DEPTH24_STENCIL8, n.width, n.height) : F(n) ? d.renderbufferStorageMultisampleEXT(e1.RENDERBUFFER, r, e1.DEPTH24_STENCIL8, n.width, n.height) : e1.renderbufferStorage(e1.RENDERBUFFER, e1.DEPTH_STENCIL, n.width, n.height), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.DEPTH_STENCIL_ATTACHMENT, e1.RENDERBUFFER, t);
                } else {
                    const t = !0 === n.isWebGLMultipleRenderTargets ? n.texture : [
                        n.texture
                    ];
                    for(let r = 0; r < t.length; r++){
                        const s = t[r], o = a.convert(s.format, s.colorSpace), l = a.convert(s.type), c = b(s.internalFormat, o, l, s.colorSpace), u = B(n);
                        i && !1 === F(n) ? e1.renderbufferStorageMultisample(e1.RENDERBUFFER, u, c, n.width, n.height) : F(n) ? d.renderbufferStorageMultisampleEXT(e1.RENDERBUFFER, u, c, n.width, n.height) : e1.renderbufferStorage(e1.RENDERBUFFER, c, n.width, n.height);
                    }
                }
                e1.bindRenderbuffer(e1.RENDERBUFFER, null);
            }
            function j(t) {
                const r = i.get(t), a = !0 === t.isWebGLCubeRenderTarget;
                if (t.depthTexture && !r.__autoAllocateDepthBuffer) {
                    if (a) throw new Error("target.depthTexture not supported in Cube render targets");
                    !function(t, r) {
                        if (r && r.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
                        if (n.bindFramebuffer(e1.FRAMEBUFFER, t), !r.depthTexture || !r.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
                        i.get(r.depthTexture).__webglTexture && r.depthTexture.image.width === r.width && r.depthTexture.image.height === r.height || (r.depthTexture.image.width = r.width, r.depthTexture.image.height = r.height, r.depthTexture.needsUpdate = !0), D(r.depthTexture, 0);
                        const a = i.get(r.depthTexture).__webglTexture, s = B(r);
                        if (r.depthTexture.format === ka) F(r) ? d.framebufferTexture2DMultisampleEXT(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.TEXTURE_2D, a, 0, s) : e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.DEPTH_ATTACHMENT, e1.TEXTURE_2D, a, 0);
                        else {
                            if (r.depthTexture.format !== ja) throw new Error("Unknown depthTexture format");
                            F(r) ? d.framebufferTexture2DMultisampleEXT(e1.FRAMEBUFFER, e1.DEPTH_STENCIL_ATTACHMENT, e1.TEXTURE_2D, a, 0, s) : e1.framebufferTexture2D(e1.FRAMEBUFFER, e1.DEPTH_STENCIL_ATTACHMENT, e1.TEXTURE_2D, a, 0);
                        }
                    }(r.__webglFramebuffer, t);
                } else if (a) {
                    r.__webglDepthbuffer = [];
                    for(let i = 0; i < 6; i++)n.bindFramebuffer(e1.FRAMEBUFFER, r.__webglFramebuffer[i]), r.__webglDepthbuffer[i] = e1.createRenderbuffer(), k(r.__webglDepthbuffer[i], t, !1);
                } else n.bindFramebuffer(e1.FRAMEBUFFER, r.__webglFramebuffer), r.__webglDepthbuffer = e1.createRenderbuffer(), k(r.__webglDepthbuffer, t, !1);
                n.bindFramebuffer(e1.FRAMEBUFFER, null);
            }
            function B(e1) {
                return Math.min(h, e1.samples);
            }
            function F(e1) {
                const n = i.get(e1);
                return o && e1.samples > 0 && !0 === t.has("WEBGL_multisampled_render_to_texture") && !1 !== n.__useRenderToTexture;
            }
            function H(e1, n) {
                const i = e1.colorSpace, r = e1.format, a = e1.type;
                return !0 === e1.isCompressedTexture || !0 === e1.isVideoTexture || e1.format === zo || i !== Qs && i !== Vs && (dl.getTransfer(i) === Zs ? !1 === o ? !0 === t.has("EXT_sRGB") && r === Oa ? (e1.format = zo, e1.minFilter = va, e1.generateMipmaps = !1) : n = gl.sRGBToLinear(n) : r === Oa && a === ba || console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", i)), n;
            }
            this.allocateTextureUnit = function() {
                const e1 = N;
                return e1 >= l && console.warn("THREE.WebGLTextures: Trying to use " + e1 + " texture units while this GPU supports only " + l), N += 1, e1;
            }, this.resetTextureUnits = function() {
                N = 0;
            }, this.setTexture2D = D, this.setTexture2DArray = function(t, r) {
                const a = i.get(t);
                t.version > 0 && a.__version !== t.version ? P(a, t, r) : n.bindTexture(e1.TEXTURE_2D_ARRAY, a.__webglTexture, e1.TEXTURE0 + r);
            }, this.setTexture3D = function(t, r) {
                const a = i.get(t);
                t.version > 0 && a.__version !== t.version ? P(a, t, r) : n.bindTexture(e1.TEXTURE_3D, a.__webglTexture, e1.TEXTURE0 + r);
            }, this.setTextureCube = function(t, r) {
                const s = i.get(t);
                t.version > 0 && s.__version !== t.version ? function(t, r, s) {
                    if (6 !== r.image.length) return;
                    const l = O(t, r), u = r.source;
                    n.bindTexture(e1.TEXTURE_CUBE_MAP, t.__webglTexture, e1.TEXTURE0 + s);
                    const h = i.get(u);
                    if (u.version !== h.__version || !0 === l) {
                        n.activeTexture(e1.TEXTURE0 + s);
                        const t = dl.getPrimaries(dl.workingColorSpace), i = r.colorSpace === Vs ? null : dl.getPrimaries(r.colorSpace), d = r.colorSpace === Vs || t === i ? e1.NONE : e1.BROWSER_DEFAULT_WEBGL;
                        e1.pixelStorei(e1.UNPACK_FLIP_Y_WEBGL, r.flipY), e1.pixelStorei(e1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, r.premultiplyAlpha), e1.pixelStorei(e1.UNPACK_ALIGNMENT, r.unpackAlignment), e1.pixelStorei(e1.UNPACK_COLORSPACE_CONVERSION_WEBGL, d);
                        const p = r.isCompressedTexture || r.image[0].isCompressedTexture, f = r.image[0] && r.image[0].isDataTexture, m = [];
                        for(let e1 = 0; e1 < 6; e1++)m[e1] = p || f ? f ? r.image[e1].image : r.image[e1] : M(r.image[e1], !1, !0, c), m[e1] = H(r, m[e1]);
                        const g = m[0], A = y(g) || o, v = a.convert(r.format, r.colorSpace), E = a.convert(r.type), T = b(r.internalFormat, v, E, r.colorSpace), S = o && !0 !== r.isVideoTexture, I = void 0 === h.__version || !0 === l;
                        let N, D = w(r, g, A);
                        if (z(e1.TEXTURE_CUBE_MAP, r, A), p) {
                            S && I && n.texStorage2D(e1.TEXTURE_CUBE_MAP, D, T, g.width, g.height);
                            for(let t = 0; t < 6; t++){
                                N = m[t].mipmaps;
                                for(let i = 0; i < N.length; i++){
                                    const a = N[i];
                                    r.format !== Oa ? null !== v ? S ? n.compressedTexSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i, 0, 0, a.width, a.height, v, a.data) : n.compressedTexImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i, T, a.width, a.height, 0, a.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : S ? n.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i, 0, 0, a.width, a.height, v, E, a.data) : n.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i, T, a.width, a.height, 0, v, E, a.data);
                                }
                            }
                        } else {
                            N = r.mipmaps, S && I && (N.length > 0 && D++, n.texStorage2D(e1.TEXTURE_CUBE_MAP, D, T, m[0].width, m[0].height));
                            for(let t = 0; t < 6; t++)if (f) {
                                S ? n.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, m[t].width, m[t].height, v, E, m[t].data) : n.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, T, m[t].width, m[t].height, 0, v, E, m[t].data);
                                for(let i = 0; i < N.length; i++){
                                    const r = N[i].image[t].image;
                                    S ? n.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i + 1, 0, 0, r.width, r.height, v, E, r.data) : n.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i + 1, T, r.width, r.height, 0, v, E, r.data);
                                }
                            } else {
                                S ? n.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, 0, 0, v, E, m[t]) : n.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, 0, T, v, E, m[t]);
                                for(let i = 0; i < N.length; i++){
                                    const r = N[i];
                                    S ? n.texSubImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i + 1, 0, 0, v, E, r.image[t]) : n.texImage2D(e1.TEXTURE_CUBE_MAP_POSITIVE_X + t, i + 1, T, v, E, r.image[t]);
                                }
                            }
                        }
                        x(r, A) && _(e1.TEXTURE_CUBE_MAP), h.__version = u.version, r.onUpdate && r.onUpdate(r);
                    }
                    t.__version = r.version;
                }(s, t, r) : n.bindTexture(e1.TEXTURE_CUBE_MAP, s.__webglTexture, e1.TEXTURE0 + r);
            }, this.rebindTextures = function(t, n, r) {
                const a = i.get(t);
                void 0 !== n && U(a.__webglFramebuffer, t, t.texture, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, 0), void 0 !== r && j(t);
            }, this.setupRenderTarget = function(t) {
                const l = t.texture, c = i.get(t), u = i.get(l);
                t.addEventListener("dispose", S), !0 !== t.isWebGLMultipleRenderTargets && (void 0 === u.__webglTexture && (u.__webglTexture = e1.createTexture()), u.__version = l.version, s.memory.textures++);
                const h = !0 === t.isWebGLCubeRenderTarget, d = !0 === t.isWebGLMultipleRenderTargets, p = y(t) || o;
                if (h) {
                    c.__webglFramebuffer = [];
                    for(let t = 0; t < 6; t++)if (o && l.mipmaps && l.mipmaps.length > 0) {
                        c.__webglFramebuffer[t] = [];
                        for(let n = 0; n < l.mipmaps.length; n++)c.__webglFramebuffer[t][n] = e1.createFramebuffer();
                    } else c.__webglFramebuffer[t] = e1.createFramebuffer();
                } else {
                    if (o && l.mipmaps && l.mipmaps.length > 0) {
                        c.__webglFramebuffer = [];
                        for(let t = 0; t < l.mipmaps.length; t++)c.__webglFramebuffer[t] = e1.createFramebuffer();
                    } else c.__webglFramebuffer = e1.createFramebuffer();
                    if (d) {
                        if (r.drawBuffers) {
                            const n = t.texture;
                            for(let t = 0, r = n.length; t < r; t++){
                                const r = i.get(n[t]);
                                void 0 === r.__webglTexture && (r.__webglTexture = e1.createTexture(), s.memory.textures++);
                            }
                        } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
                    }
                    if (o && t.samples > 0 && !1 === F(t)) {
                        const i = d ? l : [
                            l
                        ];
                        c.__webglMultisampledFramebuffer = e1.createFramebuffer(), c.__webglColorRenderbuffer = [], n.bindFramebuffer(e1.FRAMEBUFFER, c.__webglMultisampledFramebuffer);
                        for(let n = 0; n < i.length; n++){
                            const r = i[n];
                            c.__webglColorRenderbuffer[n] = e1.createRenderbuffer(), e1.bindRenderbuffer(e1.RENDERBUFFER, c.__webglColorRenderbuffer[n]);
                            const s = a.convert(r.format, r.colorSpace), o = a.convert(r.type), l = b(r.internalFormat, s, o, r.colorSpace, !0 === t.isXRRenderTarget), u = B(t);
                            e1.renderbufferStorageMultisample(e1.RENDERBUFFER, u, l, t.width, t.height), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + n, e1.RENDERBUFFER, c.__webglColorRenderbuffer[n]);
                        }
                        e1.bindRenderbuffer(e1.RENDERBUFFER, null), t.depthBuffer && (c.__webglDepthRenderbuffer = e1.createRenderbuffer(), k(c.__webglDepthRenderbuffer, t, !0)), n.bindFramebuffer(e1.FRAMEBUFFER, null);
                    }
                }
                if (h) {
                    n.bindTexture(e1.TEXTURE_CUBE_MAP, u.__webglTexture), z(e1.TEXTURE_CUBE_MAP, l, p);
                    for(let n = 0; n < 6; n++)if (o && l.mipmaps && l.mipmaps.length > 0) for(let i = 0; i < l.mipmaps.length; i++)U(c.__webglFramebuffer[n][i], t, l, e1.COLOR_ATTACHMENT0, e1.TEXTURE_CUBE_MAP_POSITIVE_X + n, i);
                    else U(c.__webglFramebuffer[n], t, l, e1.COLOR_ATTACHMENT0, e1.TEXTURE_CUBE_MAP_POSITIVE_X + n, 0);
                    x(l, p) && _(e1.TEXTURE_CUBE_MAP), n.unbindTexture();
                } else if (d) {
                    const r = t.texture;
                    for(let a = 0, s = r.length; a < s; a++){
                        const s = r[a], o = i.get(s);
                        n.bindTexture(e1.TEXTURE_2D, o.__webglTexture), z(e1.TEXTURE_2D, s, p), U(c.__webglFramebuffer, t, s, e1.COLOR_ATTACHMENT0 + a, e1.TEXTURE_2D, 0), x(s, p) && _(e1.TEXTURE_2D);
                    }
                    n.unbindTexture();
                } else {
                    let i = e1.TEXTURE_2D;
                    if ((t.isWebGL3DRenderTarget || t.isWebGLArrayRenderTarget) && (o ? i = t.isWebGL3DRenderTarget ? e1.TEXTURE_3D : e1.TEXTURE_2D_ARRAY : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), n.bindTexture(i, u.__webglTexture), z(i, l, p), o && l.mipmaps && l.mipmaps.length > 0) for(let n = 0; n < l.mipmaps.length; n++)U(c.__webglFramebuffer[n], t, l, e1.COLOR_ATTACHMENT0, i, n);
                    else U(c.__webglFramebuffer, t, l, e1.COLOR_ATTACHMENT0, i, 0);
                    x(l, p) && _(i), n.unbindTexture();
                }
                t.depthBuffer && j(t);
            }, this.updateRenderTargetMipmap = function(t) {
                const r = y(t) || o, a = !0 === t.isWebGLMultipleRenderTargets ? t.texture : [
                    t.texture
                ];
                for(let s = 0, o = a.length; s < o; s++){
                    const o = a[s];
                    if (x(o, r)) {
                        const r = t.isWebGLCubeRenderTarget ? e1.TEXTURE_CUBE_MAP : e1.TEXTURE_2D, a = i.get(o).__webglTexture;
                        n.bindTexture(r, a), _(r), n.unbindTexture();
                    }
                }
            }, this.updateMultisampleRenderTarget = function(t) {
                if (o && t.samples > 0 && !1 === F(t)) {
                    const r = t.isWebGLMultipleRenderTargets ? t.texture : [
                        t.texture
                    ], a = t.width, s = t.height;
                    let o = e1.COLOR_BUFFER_BIT;
                    const l = [], c = t.stencilBuffer ? e1.DEPTH_STENCIL_ATTACHMENT : e1.DEPTH_ATTACHMENT, u = i.get(t), h = !0 === t.isWebGLMultipleRenderTargets;
                    if (h) for(let t = 0; t < r.length; t++)n.bindFramebuffer(e1.FRAMEBUFFER, u.__webglMultisampledFramebuffer), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + t, e1.RENDERBUFFER, null), n.bindFramebuffer(e1.FRAMEBUFFER, u.__webglFramebuffer), e1.framebufferTexture2D(e1.DRAW_FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + t, e1.TEXTURE_2D, null, 0);
                    n.bindFramebuffer(e1.READ_FRAMEBUFFER, u.__webglMultisampledFramebuffer), n.bindFramebuffer(e1.DRAW_FRAMEBUFFER, u.__webglFramebuffer);
                    for(let n = 0; n < r.length; n++){
                        l.push(e1.COLOR_ATTACHMENT0 + n), t.depthBuffer && l.push(c);
                        const d = void 0 !== u.__ignoreDepthValues && u.__ignoreDepthValues;
                        if (!1 === d && (t.depthBuffer && (o |= e1.DEPTH_BUFFER_BIT), t.stencilBuffer && (o |= e1.STENCIL_BUFFER_BIT)), h && e1.framebufferRenderbuffer(e1.READ_FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.RENDERBUFFER, u.__webglColorRenderbuffer[n]), !0 === d && (e1.invalidateFramebuffer(e1.READ_FRAMEBUFFER, [
                            c
                        ]), e1.invalidateFramebuffer(e1.DRAW_FRAMEBUFFER, [
                            c
                        ])), h) {
                            const t = i.get(r[n]).__webglTexture;
                            e1.framebufferTexture2D(e1.DRAW_FRAMEBUFFER, e1.COLOR_ATTACHMENT0, e1.TEXTURE_2D, t, 0);
                        }
                        e1.blitFramebuffer(0, 0, a, s, 0, 0, a, s, o, e1.NEAREST), p && e1.invalidateFramebuffer(e1.READ_FRAMEBUFFER, l);
                    }
                    if (n.bindFramebuffer(e1.READ_FRAMEBUFFER, null), n.bindFramebuffer(e1.DRAW_FRAMEBUFFER, null), h) for(let t = 0; t < r.length; t++){
                        n.bindFramebuffer(e1.FRAMEBUFFER, u.__webglMultisampledFramebuffer), e1.framebufferRenderbuffer(e1.FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + t, e1.RENDERBUFFER, u.__webglColorRenderbuffer[t]);
                        const a = i.get(r[t]).__webglTexture;
                        n.bindFramebuffer(e1.FRAMEBUFFER, u.__webglFramebuffer), e1.framebufferTexture2D(e1.DRAW_FRAMEBUFFER, e1.COLOR_ATTACHMENT0 + t, e1.TEXTURE_2D, a, 0);
                    }
                    n.bindFramebuffer(e1.DRAW_FRAMEBUFFER, u.__webglMultisampledFramebuffer);
                }
            }, this.setupDepthRenderbuffer = j, this.setupFrameBufferTexture = U, this.useMultisampledRTT = F;
        }
        function Pp(e1, t, n) {
            const i = n.isWebGL2;
            return {
                convert: function(n) {
                    let r, a = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Vs;
                    const s = dl.getTransfer(a);
                    if (n === ba) return e1.UNSIGNED_BYTE;
                    if (n === Ca) return e1.UNSIGNED_SHORT_4_4_4_4;
                    if (n === La) return e1.UNSIGNED_SHORT_5_5_5_1;
                    if (n === wa) return e1.BYTE;
                    if (n === Ea) return e1.SHORT;
                    if (n === Ta) return e1.UNSIGNED_SHORT;
                    if (n === Sa) return e1.INT;
                    if (n === Ia) return e1.UNSIGNED_INT;
                    if (n === Na) return e1.FLOAT;
                    if (n === Da) return i ? e1.HALF_FLOAT : (r = t.get("OES_texture_half_float"), null !== r ? r.HALF_FLOAT_OES : null);
                    if (n === za) return e1.ALPHA;
                    if (n === Oa) return e1.RGBA;
                    if (n === Pa) return e1.LUMINANCE;
                    if (n === Ua) return e1.LUMINANCE_ALPHA;
                    if (n === ka) return e1.DEPTH_COMPONENT;
                    if (n === ja) return e1.DEPTH_STENCIL;
                    if (n === zo) return r = t.get("EXT_sRGB"), null !== r ? r.SRGB_ALPHA_EXT : null;
                    if (n === Ba) return e1.RED;
                    if (n === Fa) return e1.RED_INTEGER;
                    if (n === Ha) return e1.RG;
                    if (n === Va) return e1.RG_INTEGER;
                    if (n === Ga) return e1.RGBA_INTEGER;
                    if (n === Qa || n === Wa || n === Ya || n === Xa) {
                        if (s === Zs) {
                            if (r = t.get("WEBGL_compressed_texture_s3tc_srgb"), null === r) return null;
                            if (n === Qa) return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                            if (n === Wa) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                            if (n === Ya) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                            if (n === Xa) return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                        } else {
                            if (r = t.get("WEBGL_compressed_texture_s3tc"), null === r) return null;
                            if (n === Qa) return r.COMPRESSED_RGB_S3TC_DXT1_EXT;
                            if (n === Wa) return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                            if (n === Ya) return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                            if (n === Xa) return r.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                        }
                    }
                    if (n === Za || n === qa || n === Ka || n === Ja) {
                        if (r = t.get("WEBGL_compressed_texture_pvrtc"), null === r) return null;
                        if (n === Za) return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                        if (n === qa) return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                        if (n === Ka) return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                        if (n === Ja) return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
                    }
                    if (n === $a) return r = t.get("WEBGL_compressed_texture_etc1"), null !== r ? r.COMPRESSED_RGB_ETC1_WEBGL : null;
                    if (n === es || n === ts) {
                        if (r = t.get("WEBGL_compressed_texture_etc"), null === r) return null;
                        if (n === es) return s === Zs ? r.COMPRESSED_SRGB8_ETC2 : r.COMPRESSED_RGB8_ETC2;
                        if (n === ts) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : r.COMPRESSED_RGBA8_ETC2_EAC;
                    }
                    if (n === ns || n === is || n === rs || n === as || n === ss || n === os || n === ls || n === cs || n === us || n === hs || n === ds || n === ps || n === fs || n === ms) {
                        if (r = t.get("WEBGL_compressed_texture_astc"), null === r) return null;
                        if (n === ns) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : r.COMPRESSED_RGBA_ASTC_4x4_KHR;
                        if (n === is) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : r.COMPRESSED_RGBA_ASTC_5x4_KHR;
                        if (n === rs) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : r.COMPRESSED_RGBA_ASTC_5x5_KHR;
                        if (n === as) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : r.COMPRESSED_RGBA_ASTC_6x5_KHR;
                        if (n === ss) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : r.COMPRESSED_RGBA_ASTC_6x6_KHR;
                        if (n === os) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : r.COMPRESSED_RGBA_ASTC_8x5_KHR;
                        if (n === ls) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : r.COMPRESSED_RGBA_ASTC_8x6_KHR;
                        if (n === cs) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : r.COMPRESSED_RGBA_ASTC_8x8_KHR;
                        if (n === us) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : r.COMPRESSED_RGBA_ASTC_10x5_KHR;
                        if (n === hs) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : r.COMPRESSED_RGBA_ASTC_10x6_KHR;
                        if (n === ds) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : r.COMPRESSED_RGBA_ASTC_10x8_KHR;
                        if (n === ps) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : r.COMPRESSED_RGBA_ASTC_10x10_KHR;
                        if (n === fs) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : r.COMPRESSED_RGBA_ASTC_12x10_KHR;
                        if (n === ms) return s === Zs ? r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : r.COMPRESSED_RGBA_ASTC_12x12_KHR;
                    }
                    if (n === gs || n === As || n === vs) {
                        if (r = t.get("EXT_texture_compression_bptc"), null === r) return null;
                        if (n === gs) return s === Zs ? r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : r.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                        if (n === As) return r.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                        if (n === vs) return r.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
                    }
                    if (n === Ms || n === ys || n === xs || n === _s) {
                        if (r = t.get("EXT_texture_compression_rgtc"), null === r) return null;
                        if (n === gs) return r.COMPRESSED_RED_RGTC1_EXT;
                        if (n === ys) return r.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                        if (n === xs) return r.COMPRESSED_RED_GREEN_RGTC2_EXT;
                        if (n === _s) return r.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
                    }
                    return n === Ra ? i ? e1.UNSIGNED_INT_24_8 : (r = t.get("WEBGL_depth_texture"), null !== r ? r.UNSIGNED_INT_24_8_WEBGL : null) : void 0 !== e1[n] ? e1[n] : null;
                }
            };
        }
        class Up extends Ju {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                super(), this.isArrayCamera = !0, this.cameras = e1;
            }
        }
        class kp extends Lc {
            constructor(){
                super(), this.isGroup = !0, this.type = "Group";
            }
        }
        const jp = {
            type: "move"
        };
        class Bp {
            constructor(){
                this._targetRay = null, this._grip = null, this._hand = null;
            }
            getHandSpace() {
                return null === this._hand && (this._hand = new kp, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
                    pinching: !1
                }), this._hand;
            }
            getTargetRaySpace() {
                return null === this._targetRay && (this._targetRay = new kp, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new Cl, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new Cl), this._targetRay;
            }
            getGripSpace() {
                return null === this._grip && (this._grip = new kp, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new Cl, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new Cl), this._grip;
            }
            dispatchEvent(e1) {
                return null !== this._targetRay && this._targetRay.dispatchEvent(e1), null !== this._grip && this._grip.dispatchEvent(e1), null !== this._hand && this._hand.dispatchEvent(e1), this;
            }
            connect(e1) {
                if (e1 && e1.hand) {
                    const t = this._hand;
                    if (t) for (const n of e1.hand.values())this._getHandJoint(t, n);
                }
                return this.dispatchEvent({
                    type: "connected",
                    data: e1
                }), this;
            }
            disconnect(e1) {
                return this.dispatchEvent({
                    type: "disconnected",
                    data: e1
                }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
            }
            update(e1, t, n) {
                let i = null, r = null, a = null;
                const s = this._targetRay, o = this._grip, l = this._hand;
                if (e1 && "visible-blurred" !== t.session.visibilityState) {
                    if (l && e1.hand) {
                        a = !0;
                        for (const i of e1.hand.values()){
                            const e1 = t.getJointPose(i, n), r = this._getHandJoint(l, i);
                            null !== e1 && (r.matrix.fromArray(e1.transform.matrix), r.matrix.decompose(r.position, r.rotation, r.scale), r.matrixWorldNeedsUpdate = !0, r.jointRadius = e1.radius), r.visible = null !== e1;
                        }
                        const i = l.joints["index-finger-tip"], r = l.joints["thumb-tip"], s = i.position.distanceTo(r.position), o = .02, c = .005;
                        l.inputState.pinching && s > o + c ? (l.inputState.pinching = !1, this.dispatchEvent({
                            type: "pinchend",
                            handedness: e1.handedness,
                            target: this
                        })) : !l.inputState.pinching && s <= o - c && (l.inputState.pinching = !0, this.dispatchEvent({
                            type: "pinchstart",
                            handedness: e1.handedness,
                            target: this
                        }));
                    } else null !== o && e1.gripSpace && (r = t.getPose(e1.gripSpace, n), null !== r && (o.matrix.fromArray(r.transform.matrix), o.matrix.decompose(o.position, o.rotation, o.scale), o.matrixWorldNeedsUpdate = !0, r.linearVelocity ? (o.hasLinearVelocity = !0, o.linearVelocity.copy(r.linearVelocity)) : o.hasLinearVelocity = !1, r.angularVelocity ? (o.hasAngularVelocity = !0, o.angularVelocity.copy(r.angularVelocity)) : o.hasAngularVelocity = !1));
                    null !== s && (i = t.getPose(e1.targetRaySpace, n), null === i && null !== r && (i = r), null !== i && (s.matrix.fromArray(i.transform.matrix), s.matrix.decompose(s.position, s.rotation, s.scale), s.matrixWorldNeedsUpdate = !0, i.linearVelocity ? (s.hasLinearVelocity = !0, s.linearVelocity.copy(i.linearVelocity)) : s.hasLinearVelocity = !1, i.angularVelocity ? (s.hasAngularVelocity = !0, s.angularVelocity.copy(i.angularVelocity)) : s.hasAngularVelocity = !1, this.dispatchEvent(jp)));
                }
                return null !== s && (s.visible = null !== i), null !== o && (o.visible = null !== r), null !== l && (l.visible = null !== a), this;
            }
            _getHandJoint(e1, t) {
                if (void 0 === e1.joints[t.jointName]) {
                    const n = new kp;
                    n.matrixAutoUpdate = !1, n.visible = !1, e1.joints[t.jointName] = n, e1.add(n);
                }
                return e1.joints[t.jointName];
            }
        }
        class Fp extends xl {
            constructor(e1, t, n, i, r, a, s, o, l, c){
                if ((c = void 0 !== c ? c : ka) !== ka && c !== ja) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
                void 0 === n && c === ka && (n = Ia), void 0 === n && c === ja && (n = Ra), super(null, i, r, a, s, o, c, n, l), this.isDepthTexture = !0, this.image = {
                    width: e1,
                    height: t
                }, this.magFilter = void 0 !== s ? s : pa, this.minFilter = void 0 !== o ? o : pa, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
            }
            copy(e1) {
                return super.copy(e1), this.compareFunction = e1.compareFunction, this;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return null !== this.compareFunction && (t.compareFunction = this.compareFunction), t;
            }
        }
        class Hp extends Uo {
            constructor(e1, t){
                super();
                const n = this;
                let i = null, r = 1, a = null, s = "local-floor", o = 1, l = null, c = null, u = null, h = null, d = null, p = null;
                const f = t.getContextAttributes();
                let m = null, g = null;
                const A = [], v = [], M = new Ju;
                M.layers.enable(1), M.viewport = new _l;
                const y = new Ju;
                y.layers.enable(2), y.viewport = new _l;
                const x = [
                    M,
                    y
                ], _ = new Up;
                _.layers.enable(1), _.layers.enable(2);
                let b = null, w = null;
                function E(e1) {
                    const t = v.indexOf(e1.inputSource);
                    if (-1 === t) return;
                    const n = A[t];
                    void 0 !== n && (n.update(e1.inputSource, e1.frame, l || a), n.dispatchEvent({
                        type: e1.type,
                        data: e1.inputSource
                    }));
                }
                function T() {
                    i.removeEventListener("select", E), i.removeEventListener("selectstart", E), i.removeEventListener("selectend", E), i.removeEventListener("squeeze", E), i.removeEventListener("squeezestart", E), i.removeEventListener("squeezeend", E), i.removeEventListener("end", T), i.removeEventListener("inputsourceschange", S);
                    for(let e1 = 0; e1 < A.length; e1++){
                        const t = v[e1];
                        null !== t && (v[e1] = null, A[e1].disconnect(t));
                    }
                    b = null, w = null, e1.setRenderTarget(m), d = null, h = null, u = null, i = null, g = null, L.stop(), n.isPresenting = !1, n.dispatchEvent({
                        type: "sessionend"
                    });
                }
                function S(e1) {
                    for(let t = 0; t < e1.removed.length; t++){
                        const n = e1.removed[t], i = v.indexOf(n);
                        i >= 0 && (v[i] = null, A[i].disconnect(n));
                    }
                    for(let t = 0; t < e1.added.length; t++){
                        const n = e1.added[t];
                        let i = v.indexOf(n);
                        if (-1 === i) {
                            for(let e1 = 0; e1 < A.length; e1++){
                                if (e1 >= v.length) {
                                    v.push(n), i = e1;
                                    break;
                                }
                                if (null === v[e1]) {
                                    v[e1] = n, i = e1;
                                    break;
                                }
                            }
                            if (-1 === i) break;
                        }
                        const r = A[i];
                        r && r.connect(n);
                    }
                }
                this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(e1) {
                    let t = A[e1];
                    return void 0 === t && (t = new Bp, A[e1] = t), t.getTargetRaySpace();
                }, this.getControllerGrip = function(e1) {
                    let t = A[e1];
                    return void 0 === t && (t = new Bp, A[e1] = t), t.getGripSpace();
                }, this.getHand = function(e1) {
                    let t = A[e1];
                    return void 0 === t && (t = new Bp, A[e1] = t), t.getHandSpace();
                }, this.setFramebufferScaleFactor = function(e1) {
                    r = e1, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
                }, this.setReferenceSpaceType = function(e1) {
                    s = e1, !0 === n.isPresenting && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
                }, this.getReferenceSpace = function() {
                    return l || a;
                }, this.setReferenceSpace = function(e1) {
                    l = e1;
                }, this.getBaseLayer = function() {
                    return null !== h ? h : d;
                }, this.getBinding = function() {
                    return u;
                }, this.getFrame = function() {
                    return p;
                }, this.getSession = function() {
                    return i;
                }, this.setSession = async function(c) {
                    if (i = c, null !== i) {
                        if (m = e1.getRenderTarget(), i.addEventListener("select", E), i.addEventListener("selectstart", E), i.addEventListener("selectend", E), i.addEventListener("squeeze", E), i.addEventListener("squeezestart", E), i.addEventListener("squeezeend", E), i.addEventListener("end", T), i.addEventListener("inputsourceschange", S), !0 !== f.xrCompatible && await t.makeXRCompatible(), void 0 === i.renderState.layers || !1 === e1.capabilities.isWebGL2) {
                            const n = {
                                antialias: void 0 !== i.renderState.layers || f.antialias,
                                alpha: !0,
                                depth: f.depth,
                                stencil: f.stencil,
                                framebufferScaleFactor: r
                            };
                            d = new XRWebGLLayer(i, t, n), i.updateRenderState({
                                baseLayer: d
                            }), g = new wl(d.framebufferWidth, d.framebufferHeight, {
                                format: Oa,
                                type: ba,
                                colorSpace: e1.outputColorSpace,
                                stencilBuffer: f.stencil
                            });
                        } else {
                            let n = null, a = null, s = null;
                            f.depth && (s = f.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24, n = f.stencil ? ja : ka, a = f.stencil ? Ra : Ia);
                            const o = {
                                colorFormat: t.RGBA8,
                                depthFormat: s,
                                scaleFactor: r
                            };
                            u = new XRWebGLBinding(i, t), h = u.createProjectionLayer(o), i.updateRenderState({
                                layers: [
                                    h
                                ]
                            }), g = new wl(h.textureWidth, h.textureHeight, {
                                format: Oa,
                                type: ba,
                                depthTexture: new Fp(h.textureWidth, h.textureHeight, a, void 0, void 0, void 0, void 0, void 0, void 0, n),
                                stencilBuffer: f.stencil,
                                colorSpace: e1.outputColorSpace,
                                samples: f.antialias ? 4 : 0
                            }), e1.properties.get(g).__ignoreDepthValues = h.ignoreDepthValues;
                        }
                        g.isXRRenderTarget = !0, this.setFoveation(o), l = null, a = await i.requestReferenceSpace(s), L.setContext(i), L.start(), n.isPresenting = !0, n.dispatchEvent({
                            type: "sessionstart"
                        });
                    }
                }, this.getEnvironmentBlendMode = function() {
                    if (null !== i) return i.environmentBlendMode;
                };
                const I = new Cl, N = new Cl;
                function D(e1, t) {
                    null === t ? e1.matrixWorld.copy(e1.matrix) : e1.matrixWorld.multiplyMatrices(t.matrixWorld, e1.matrix), e1.matrixWorldInverse.copy(e1.matrixWorld).invert();
                }
                this.updateCamera = function(e1) {
                    if (null === i) return;
                    _.near = y.near = M.near = e1.near, _.far = y.far = M.far = e1.far, b === _.near && w === _.far || (i.updateRenderState({
                        depthNear: _.near,
                        depthFar: _.far
                    }), b = _.near, w = _.far);
                    const t = e1.parent, n = _.cameras;
                    D(_, t);
                    for(let e1 = 0; e1 < n.length; e1++)D(n[e1], t);
                    2 === n.length ? function(e1, t, n) {
                        I.setFromMatrixPosition(t.matrixWorld), N.setFromMatrixPosition(n.matrixWorld);
                        const i = I.distanceTo(N), r = t.projectionMatrix.elements, a = n.projectionMatrix.elements, s = r[14] / (r[10] - 1), o = r[14] / (r[10] + 1), l = (r[9] + 1) / r[5], c = (r[9] - 1) / r[5], u = (r[8] - 1) / r[0], h = (a[8] + 1) / a[0], d = s * u, p = s * h, f = i / (-u + h), m = f * -u;
                        t.matrixWorld.decompose(e1.position, e1.quaternion, e1.scale), e1.translateX(m), e1.translateZ(f), e1.matrixWorld.compose(e1.position, e1.quaternion, e1.scale), e1.matrixWorldInverse.copy(e1.matrixWorld).invert();
                        const g = s + f, A = o + f, v = d - m, M = p + (i - m), y = l * o / A * g, x = c * o / A * g;
                        e1.projectionMatrix.makePerspective(v, M, y, x, g, A), e1.projectionMatrixInverse.copy(e1.projectionMatrix).invert();
                    }(_, M, y) : _.projectionMatrix.copy(M.projectionMatrix), function(e1, t, n) {
                        null === n ? e1.matrix.copy(t.matrixWorld) : (e1.matrix.copy(n.matrixWorld), e1.matrix.invert(), e1.matrix.multiply(t.matrixWorld)), e1.matrix.decompose(e1.position, e1.quaternion, e1.scale), e1.updateMatrixWorld(!0), e1.projectionMatrix.copy(t.projectionMatrix), e1.projectionMatrixInverse.copy(t.projectionMatrixInverse), e1.isPerspectiveCamera && (e1.fov = 2 * Fo * Math.atan(1 / e1.projectionMatrix.elements[5]), e1.zoom = 1);
                    }(e1, _, t);
                }, this.getCamera = function() {
                    return _;
                }, this.getFoveation = function() {
                    if (null !== h || null !== d) return o;
                }, this.setFoveation = function(e1) {
                    o = e1, null !== h && (h.fixedFoveation = e1), null !== d && void 0 !== d.fixedFoveation && (d.fixedFoveation = e1);
                };
                let C = null;
                const L = new uh;
                L.setAnimationLoop(function(t, i) {
                    if (c = i.getViewerPose(l || a), p = i, null !== c) {
                        const t = c.views;
                        null !== d && (e1.setRenderTargetFramebuffer(g, d.framebuffer), e1.setRenderTarget(g));
                        let n = !1;
                        t.length !== _.cameras.length && (_.cameras.length = 0, n = !0);
                        for(let i = 0; i < t.length; i++){
                            const r = t[i];
                            let a = null;
                            if (null !== d) a = d.getViewport(r);
                            else {
                                const t = u.getViewSubImage(h, r);
                                a = t.viewport, 0 === i && (e1.setRenderTargetTextures(g, t.colorTexture, h.ignoreDepthValues ? void 0 : t.depthStencilTexture), e1.setRenderTarget(g));
                            }
                            let s = x[i];
                            void 0 === s && (s = new Ju, s.layers.enable(i), s.viewport = new _l, x[i] = s), s.matrix.fromArray(r.transform.matrix), s.matrix.decompose(s.position, s.quaternion, s.scale), s.projectionMatrix.fromArray(r.projectionMatrix), s.projectionMatrixInverse.copy(s.projectionMatrix).invert(), s.viewport.set(a.x, a.y, a.width, a.height), 0 === i && (_.matrix.copy(s.matrix), _.matrix.decompose(_.position, _.quaternion, _.scale)), !0 === n && _.cameras.push(s);
                        }
                    }
                    for(let e1 = 0; e1 < A.length; e1++){
                        const t = v[e1], n = A[e1];
                        null !== t && void 0 !== n && n.update(t, i, l || a);
                    }
                    C && C(t, i), i.detectedPlanes && n.dispatchEvent({
                        type: "planesdetected",
                        data: i
                    }), p = null;
                }), this.setAnimationLoop = function(e1) {
                    C = e1;
                }, this.dispose = function() {};
            }
        }
        function Vp(e1, t) {
            function n(e1, t) {
                !0 === e1.matrixAutoUpdate && e1.updateMatrix(), t.value.copy(e1.matrix);
            }
            function i(i, r) {
                i.opacity.value = r.opacity, r.color && i.diffuse.value.copy(r.color), r.emissive && i.emissive.value.copy(r.emissive).multiplyScalar(r.emissiveIntensity), r.map && (i.map.value = r.map, n(r.map, i.mapTransform)), r.alphaMap && (i.alphaMap.value = r.alphaMap, n(r.alphaMap, i.alphaMapTransform)), r.bumpMap && (i.bumpMap.value = r.bumpMap, n(r.bumpMap, i.bumpMapTransform), i.bumpScale.value = r.bumpScale, r.side === ur && (i.bumpScale.value *= -1)), r.normalMap && (i.normalMap.value = r.normalMap, n(r.normalMap, i.normalMapTransform), i.normalScale.value.copy(r.normalScale), r.side === ur && i.normalScale.value.negate()), r.displacementMap && (i.displacementMap.value = r.displacementMap, n(r.displacementMap, i.displacementMapTransform), i.displacementScale.value = r.displacementScale, i.displacementBias.value = r.displacementBias), r.emissiveMap && (i.emissiveMap.value = r.emissiveMap, n(r.emissiveMap, i.emissiveMapTransform)), r.specularMap && (i.specularMap.value = r.specularMap, n(r.specularMap, i.specularMapTransform)), r.alphaTest > 0 && (i.alphaTest.value = r.alphaTest);
                const a = t.get(r).envMap;
                if (a && (i.envMap.value = a, i.flipEnvMap.value = a.isCubeTexture && !1 === a.isRenderTargetTexture ? -1 : 1, i.reflectivity.value = r.reflectivity, i.ior.value = r.ior, i.refractionRatio.value = r.refractionRatio), r.lightMap) {
                    i.lightMap.value = r.lightMap;
                    const t = !0 === e1._useLegacyLights ? Math.PI : 1;
                    i.lightMapIntensity.value = r.lightMapIntensity * t, n(r.lightMap, i.lightMapTransform);
                }
                r.aoMap && (i.aoMap.value = r.aoMap, i.aoMapIntensity.value = r.aoMapIntensity, n(r.aoMap, i.aoMapTransform));
            }
            return {
                refreshFogUniforms: function(t, n) {
                    n.color.getRGB(t.fogColor.value, Xu(e1)), n.isFog ? (t.fogNear.value = n.near, t.fogFar.value = n.far) : n.isFogExp2 && (t.fogDensity.value = n.density);
                },
                refreshMaterialUniforms: function(e1, r, a, s, o) {
                    r.isMeshBasicMaterial || r.isMeshLambertMaterial ? i(e1, r) : r.isMeshToonMaterial ? (i(e1, r), function(e1, t) {
                        t.gradientMap && (e1.gradientMap.value = t.gradientMap);
                    }(e1, r)) : r.isMeshPhongMaterial ? (i(e1, r), function(e1, t) {
                        e1.specular.value.copy(t.specular), e1.shininess.value = Math.max(t.shininess, 1e-4);
                    }(e1, r)) : r.isMeshStandardMaterial ? (i(e1, r), function(e1, i) {
                        e1.metalness.value = i.metalness, i.metalnessMap && (e1.metalnessMap.value = i.metalnessMap, n(i.metalnessMap, e1.metalnessMapTransform)), e1.roughness.value = i.roughness, i.roughnessMap && (e1.roughnessMap.value = i.roughnessMap, n(i.roughnessMap, e1.roughnessMapTransform));
                        t.get(i).envMap && (e1.envMapIntensity.value = i.envMapIntensity);
                    }(e1, r), r.isMeshPhysicalMaterial && function(e1, t, i) {
                        e1.ior.value = t.ior, t.sheen > 0 && (e1.sheenColor.value.copy(t.sheenColor).multiplyScalar(t.sheen), e1.sheenRoughness.value = t.sheenRoughness, t.sheenColorMap && (e1.sheenColorMap.value = t.sheenColorMap, n(t.sheenColorMap, e1.sheenColorMapTransform)), t.sheenRoughnessMap && (e1.sheenRoughnessMap.value = t.sheenRoughnessMap, n(t.sheenRoughnessMap, e1.sheenRoughnessMapTransform))), t.clearcoat > 0 && (e1.clearcoat.value = t.clearcoat, e1.clearcoatRoughness.value = t.clearcoatRoughness, t.clearcoatMap && (e1.clearcoatMap.value = t.clearcoatMap, n(t.clearcoatMap, e1.clearcoatMapTransform)), t.clearcoatRoughnessMap && (e1.clearcoatRoughnessMap.value = t.clearcoatRoughnessMap, n(t.clearcoatRoughnessMap, e1.clearcoatRoughnessMapTransform)), t.clearcoatNormalMap && (e1.clearcoatNormalMap.value = t.clearcoatNormalMap, n(t.clearcoatNormalMap, e1.clearcoatNormalMapTransform), e1.clearcoatNormalScale.value.copy(t.clearcoatNormalScale), t.side === ur && e1.clearcoatNormalScale.value.negate())), t.iridescence > 0 && (e1.iridescence.value = t.iridescence, e1.iridescenceIOR.value = t.iridescenceIOR, e1.iridescenceThicknessMinimum.value = t.iridescenceThicknessRange[0], e1.iridescenceThicknessMaximum.value = t.iridescenceThicknessRange[1], t.iridescenceMap && (e1.iridescenceMap.value = t.iridescenceMap, n(t.iridescenceMap, e1.iridescenceMapTransform)), t.iridescenceThicknessMap && (e1.iridescenceThicknessMap.value = t.iridescenceThicknessMap, n(t.iridescenceThicknessMap, e1.iridescenceThicknessMapTransform))), t.transmission > 0 && (e1.transmission.value = t.transmission, e1.transmissionSamplerMap.value = i.texture, e1.transmissionSamplerSize.value.set(i.width, i.height), t.transmissionMap && (e1.transmissionMap.value = t.transmissionMap, n(t.transmissionMap, e1.transmissionMapTransform)), e1.thickness.value = t.thickness, t.thicknessMap && (e1.thicknessMap.value = t.thicknessMap, n(t.thicknessMap, e1.thicknessMapTransform)), e1.attenuationDistance.value = t.attenuationDistance, e1.attenuationColor.value.copy(t.attenuationColor)), t.anisotropy > 0 && (e1.anisotropyVector.value.set(t.anisotropy * Math.cos(t.anisotropyRotation), t.anisotropy * Math.sin(t.anisotropyRotation)), t.anisotropyMap && (e1.anisotropyMap.value = t.anisotropyMap, n(t.anisotropyMap, e1.anisotropyMapTransform))), e1.specularIntensity.value = t.specularIntensity, e1.specularColor.value.copy(t.specularColor), t.specularColorMap && (e1.specularColorMap.value = t.specularColorMap, n(t.specularColorMap, e1.specularColorMapTransform)), t.specularIntensityMap && (e1.specularIntensityMap.value = t.specularIntensityMap, n(t.specularIntensityMap, e1.specularIntensityMapTransform));
                    }(e1, r, o)) : r.isMeshMatcapMaterial ? (i(e1, r), function(e1, t) {
                        t.matcap && (e1.matcap.value = t.matcap);
                    }(e1, r)) : r.isMeshDepthMaterial ? i(e1, r) : r.isMeshDistanceMaterial ? (i(e1, r), function(e1, n) {
                        const i = t.get(n).light;
                        e1.referencePosition.value.setFromMatrixPosition(i.matrixWorld), e1.nearDistance.value = i.shadow.camera.near, e1.farDistance.value = i.shadow.camera.far;
                    }(e1, r)) : r.isMeshNormalMaterial ? i(e1, r) : r.isLineBasicMaterial ? (function(e1, t) {
                        e1.diffuse.value.copy(t.color), e1.opacity.value = t.opacity, t.map && (e1.map.value = t.map, n(t.map, e1.mapTransform));
                    }(e1, r), r.isLineDashedMaterial && function(e1, t) {
                        e1.dashSize.value = t.dashSize, e1.totalSize.value = t.dashSize + t.gapSize, e1.scale.value = t.scale;
                    }(e1, r)) : r.isPointsMaterial ? function(e1, t, i, r) {
                        e1.diffuse.value.copy(t.color), e1.opacity.value = t.opacity, e1.size.value = t.size * i, e1.scale.value = .5 * r, t.map && (e1.map.value = t.map, n(t.map, e1.uvTransform)), t.alphaMap && (e1.alphaMap.value = t.alphaMap, n(t.alphaMap, e1.alphaMapTransform)), t.alphaTest > 0 && (e1.alphaTest.value = t.alphaTest);
                    }(e1, r, a, s) : r.isSpriteMaterial ? function(e1, t) {
                        e1.diffuse.value.copy(t.color), e1.opacity.value = t.opacity, e1.rotation.value = t.rotation, t.map && (e1.map.value = t.map, n(t.map, e1.mapTransform)), t.alphaMap && (e1.alphaMap.value = t.alphaMap, n(t.alphaMap, e1.alphaMapTransform)), t.alphaTest > 0 && (e1.alphaTest.value = t.alphaTest);
                    }(e1, r) : r.isShadowMaterial ? (e1.color.value.copy(r.color), e1.opacity.value = r.opacity) : r.isShaderMaterial && (r.uniformsNeedUpdate = !1);
                }
            };
        }
        function Gp(e1, t, n, i) {
            let r = {}, a = {}, s = [];
            const o = n.isWebGL2 ? e1.getParameter(e1.MAX_UNIFORM_BUFFER_BINDINGS) : 0;
            function l(e1, t, n) {
                const i = e1.value;
                if (void 0 === n[t]) {
                    if ("number" == typeof i) n[t] = i;
                    else {
                        const e1 = Array.isArray(i) ? i : [
                            i
                        ], r = [];
                        for(let t = 0; t < e1.length; t++)r.push(e1[t].clone());
                        n[t] = r;
                    }
                    return !0;
                }
                if ("number" == typeof i) {
                    if (n[t] !== i) return n[t] = i, !0;
                } else {
                    const e1 = Array.isArray(n[t]) ? n[t] : [
                        n[t]
                    ], r = Array.isArray(i) ? i : [
                        i
                    ];
                    for(let t = 0; t < e1.length; t++){
                        const n = e1[t];
                        if (!1 === n.equals(r[t])) return n.copy(r[t]), !0;
                    }
                }
                return !1;
            }
            function c(e1) {
                const t = {
                    boundary: 0,
                    storage: 0
                };
                return "number" == typeof e1 ? (t.boundary = 4, t.storage = 4) : e1.isVector2 ? (t.boundary = 8, t.storage = 8) : e1.isVector3 || e1.isColor ? (t.boundary = 16, t.storage = 12) : e1.isVector4 ? (t.boundary = 16, t.storage = 16) : e1.isMatrix3 ? (t.boundary = 48, t.storage = 48) : e1.isMatrix4 ? (t.boundary = 64, t.storage = 64) : e1.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", e1), t;
            }
            function u(t) {
                const n = t.target;
                n.removeEventListener("dispose", u);
                const i = s.indexOf(n.__bindingPointIndex);
                s.splice(i, 1), e1.deleteBuffer(r[n.id]), delete r[n.id], delete a[n.id];
            }
            return {
                bind: function(e1, t) {
                    const n = t.program;
                    i.uniformBlockBinding(e1, n);
                },
                update: function(n, h) {
                    let d = r[n.id];
                    void 0 === d && (function(e1) {
                        const t = e1.uniforms;
                        let n = 0;
                        let i = 0;
                        for(let e1 = 0, r = t.length; e1 < r; e1++){
                            const r = t[e1], a = {
                                boundary: 0,
                                storage: 0
                            }, s = Array.isArray(r.value) ? r.value : [
                                r.value
                            ];
                            for(let e1 = 0, t = s.length; e1 < t; e1++){
                                const t = c(s[e1]);
                                a.boundary += t.boundary, a.storage += t.storage;
                            }
                            r.__data = new Float32Array(a.storage / Float32Array.BYTES_PER_ELEMENT), r.__offset = n, e1 > 0 && (i = n % 16, 0 !== i && 16 - i - a.boundary < 0 && (n += 16 - i, r.__offset = n)), n += a.storage;
                        }
                        i = n % 16, i > 0 && (n += 16 - i), e1.__size = n, e1.__cache = {};
                    }(n), d = function(t) {
                        const n = function() {
                            for(let e1 = 0; e1 < o; e1++)if (-1 === s.indexOf(e1)) return s.push(e1), e1;
                            return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
                        }();
                        t.__bindingPointIndex = n;
                        const i = e1.createBuffer(), r = t.__size, a = t.usage;
                        return e1.bindBuffer(e1.UNIFORM_BUFFER, i), e1.bufferData(e1.UNIFORM_BUFFER, r, a), e1.bindBuffer(e1.UNIFORM_BUFFER, null), e1.bindBufferBase(e1.UNIFORM_BUFFER, n, i), i;
                    }(n), r[n.id] = d, n.addEventListener("dispose", u));
                    const p = h.program;
                    i.updateUBOMapping(n, p);
                    const f = t.render.frame;
                    a[n.id] !== f && (function(t) {
                        const n = r[t.id], i = t.uniforms, a = t.__cache;
                        e1.bindBuffer(e1.UNIFORM_BUFFER, n);
                        for(let t = 0, n = i.length; t < n; t++){
                            const n = i[t];
                            if (!0 === l(n, t, a)) {
                                const t = n.__offset, i = Array.isArray(n.value) ? n.value : [
                                    n.value
                                ];
                                let r = 0;
                                for(let a = 0; a < i.length; a++){
                                    const s = i[a], o = c(s);
                                    "number" == typeof s ? (n.__data[0] = s, e1.bufferSubData(e1.UNIFORM_BUFFER, t + r, n.__data)) : s.isMatrix3 ? (n.__data[0] = s.elements[0], n.__data[1] = s.elements[1], n.__data[2] = s.elements[2], n.__data[3] = s.elements[0], n.__data[4] = s.elements[3], n.__data[5] = s.elements[4], n.__data[6] = s.elements[5], n.__data[7] = s.elements[0], n.__data[8] = s.elements[6], n.__data[9] = s.elements[7], n.__data[10] = s.elements[8], n.__data[11] = s.elements[0]) : (s.toArray(n.__data, r), r += o.storage / Float32Array.BYTES_PER_ELEMENT);
                                }
                                e1.bufferSubData(e1.UNIFORM_BUFFER, t, n.__data);
                            }
                        }
                        e1.bindBuffer(e1.UNIFORM_BUFFER, null);
                    }(n), a[n.id] = f);
                },
                dispose: function() {
                    for(const t in r)e1.deleteBuffer(r[t]);
                    s = [], r = {}, a = {};
                }
            };
        }
        class Qp {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                const { canvas: t = al(), context: n = null, depth: i = !0, stencil: r = !0, alpha: a = !1, antialias: s = !1, premultipliedAlpha: o = !0, preserveDrawingBuffer: l = !1, powerPreference: c = "default", failIfMajorPerformanceCaveat: u = !1 } = e1;
                let h;
                this.isWebGLRenderer = !0, h = null !== n ? n.getContextAttributes().alpha : a;
                const d = new Uint32Array(4), p = new Int32Array(4);
                let f = null, m = null;
                const g = [], A = [];
                this.domElement = t, this.debug = {
                    checkShaderErrors: !0,
                    onShaderError: null
                }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this._outputColorSpace = Gs, this._useLegacyLights = !1, this.toneMapping = qr, this.toneMappingExposure = 1;
                const v = this;
                let M = !1, y = 0, x = 0, _ = null, b = -1, w = null;
                const E = new _l, T = new _l;
                let S = null;
                const I = new Zc(0);
                let N = 0, D = t.width, C = t.height, L = 1, R = null, z = null;
                const O = new _l(0, 0, D, C), P = new _l(0, 0, D, C);
                let U = !1;
                const k = new ch;
                let j = !1, B = !1, F = null;
                const H = new oc, V = new Jo, G = new Cl, Q = {
                    background: null,
                    fog: null,
                    environment: null,
                    overrideMaterial: null,
                    isScene: !0
                };
                function W() {
                    return null === _ ? L : 1;
                }
                let Y, X, Z, q, K, J, $, ee, te, ne, ie, re, ae, se, oe, le, ce, ue, he, de, pe, fe, me, ge, Ae = n;
                function ve(e1, n) {
                    for(let i = 0; i < e1.length; i++){
                        const r = e1[i], a = t.getContext(r, n);
                        if (null !== a) return a;
                    }
                    return null;
                }
                try {
                    const e1 = {
                        alpha: !0,
                        depth: i,
                        stencil: r,
                        antialias: s,
                        premultipliedAlpha: o,
                        preserveDrawingBuffer: l,
                        powerPreference: c,
                        failIfMajorPerformanceCaveat: u
                    };
                    if ("setAttribute" in t && t.setAttribute("data-engine", "three.js r".concat(Ji)), t.addEventListener("webglcontextlost", xe, !1), t.addEventListener("webglcontextrestored", _e, !1), t.addEventListener("webglcontextcreationerror", be, !1), null === Ae) {
                        const t = [
                            "webgl2",
                            "webgl",
                            "experimental-webgl"
                        ];
                        if (!0 === v.isWebGL1Renderer && t.shift(), Ae = ve(t, e1), null === Ae) throw ve(t) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
                    }
                    "undefined" != typeof WebGLRenderingContext && Ae instanceof WebGLRenderingContext && console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163."), void 0 === Ae.getShaderPrecisionFormat && (Ae.getShaderPrecisionFormat = function() {
                        return {
                            rangeMin: 1,
                            rangeMax: 1,
                            precision: 1
                        };
                    });
                } catch (e1) {
                    throw console.error("THREE.WebGLRenderer: " + e1.message), e1;
                }
                function Me() {
                    Y = new Bh(Ae), X = new yh(Ae, Y, e1), Y.init(X), fe = new Pp(Ae, Y, X), Z = new zp(Ae, Y, X), q = new Vh(Ae), K = new yp, J = new Op(Ae, Y, Z, K, X, fe, q), $ = new _h(v), ee = new jh(v), te = new hh(Ae, X), me = new vh(Ae, Y, te, X), ne = new Fh(Ae, te, q, me), ie = new Yh(Ae, ne, te, q), he = new Wh(Ae, X, J), le = new xh(K), re = new Mp(v, $, ee, Y, X, me, le), ae = new Vp(v, K), se = new wp, oe = new Dp(Y, X), ue = new Ah(v, $, ee, Z, ie, h, o), ce = new Rp(v, ie, X), ge = new Gp(Ae, q, X, Z), de = new Mh(Ae, Y, q, X), pe = new Hh(Ae, Y, q, X), q.programs = re.programs, v.capabilities = X, v.extensions = Y, v.properties = K, v.renderLists = se, v.shadowMap = ce, v.state = Z, v.info = q;
                }
                Me();
                const ye = new Hp(v, Ae);
                function xe(e1) {
                    e1.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), M = !0;
                }
                function _e() {
                    console.log("THREE.WebGLRenderer: Context Restored."), M = !1;
                    const e1 = q.autoReset, t = ce.enabled, n = ce.autoUpdate, i = ce.needsUpdate, r = ce.type;
                    Me(), q.autoReset = e1, ce.enabled = t, ce.autoUpdate = n, ce.needsUpdate = i, ce.type = r;
                }
                function be(e1) {
                    console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", e1.statusMessage);
                }
                function we(e1) {
                    const t = e1.target;
                    t.removeEventListener("dispose", we), function(e1) {
                        (function(e1) {
                            const t = K.get(e1).programs;
                            void 0 !== t && (t.forEach(function(e1) {
                                re.releaseProgram(e1);
                            }), e1.isShaderMaterial && re.releaseShaderCache(e1));
                        })(e1), K.remove(e1);
                    }(t);
                }
                function Ee(e1, t, n) {
                    !0 === e1.transparent && e1.side === hr && !1 === e1.forceSinglePass ? (e1.side = ur, e1.needsUpdate = !0, ze(e1, t, n), e1.side = cr, e1.needsUpdate = !0, ze(e1, t, n), e1.side = hr) : ze(e1, t, n);
                }
                this.xr = ye, this.getContext = function() {
                    return Ae;
                }, this.getContextAttributes = function() {
                    return Ae.getContextAttributes();
                }, this.forceContextLoss = function() {
                    const e1 = Y.get("WEBGL_lose_context");
                    e1 && e1.loseContext();
                }, this.forceContextRestore = function() {
                    const e1 = Y.get("WEBGL_lose_context");
                    e1 && e1.restoreContext();
                }, this.getPixelRatio = function() {
                    return L;
                }, this.setPixelRatio = function(e1) {
                    void 0 !== e1 && (L = e1, this.setSize(D, C, !1));
                }, this.getSize = function(e1) {
                    return e1.set(D, C);
                }, this.setSize = function(e1, n) {
                    let i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                    ye.isPresenting ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (D = e1, C = n, t.width = Math.floor(e1 * L), t.height = Math.floor(n * L), !0 === i && (t.style.width = e1 + "px", t.style.height = n + "px"), this.setViewport(0, 0, e1, n));
                }, this.getDrawingBufferSize = function(e1) {
                    return e1.set(D * L, C * L).floor();
                }, this.setDrawingBufferSize = function(e1, n, i) {
                    D = e1, C = n, L = i, t.width = Math.floor(e1 * i), t.height = Math.floor(n * i), this.setViewport(0, 0, e1, n);
                }, this.getCurrentViewport = function(e1) {
                    return e1.copy(E);
                }, this.getViewport = function(e1) {
                    return e1.copy(O);
                }, this.setViewport = function(e1, t, n, i) {
                    e1.isVector4 ? O.set(e1.x, e1.y, e1.z, e1.w) : O.set(e1, t, n, i), Z.viewport(E.copy(O).multiplyScalar(L).floor());
                }, this.getScissor = function(e1) {
                    return e1.copy(P);
                }, this.setScissor = function(e1, t, n, i) {
                    e1.isVector4 ? P.set(e1.x, e1.y, e1.z, e1.w) : P.set(e1, t, n, i), Z.scissor(T.copy(P).multiplyScalar(L).floor());
                }, this.getScissorTest = function() {
                    return U;
                }, this.setScissorTest = function(e1) {
                    Z.setScissorTest(U = e1);
                }, this.setOpaqueSort = function(e1) {
                    R = e1;
                }, this.setTransparentSort = function(e1) {
                    z = e1;
                }, this.getClearColor = function(e1) {
                    return e1.copy(ue.getClearColor());
                }, this.setClearColor = function() {
                    ue.setClearColor.apply(ue, arguments);
                }, this.getClearAlpha = function() {
                    return ue.getClearAlpha();
                }, this.setClearAlpha = function() {
                    ue.setClearAlpha.apply(ue, arguments);
                }, this.clear = function() {
                    let e1 = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], t = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], n = 0;
                    if (!(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0]) {
                        let e1 = !1;
                        if (null !== _) {
                            const t = _.texture.format;
                            e1 = t === Ga || t === Va || t === Fa;
                        }
                        if (e1) {
                            const e1 = _.texture.type, t = e1 === ba || e1 === Ia || e1 === Ta || e1 === Ra || e1 === Ca || e1 === La, n = ue.getClearColor(), i = ue.getClearAlpha(), r = n.r, a = n.g, s = n.b;
                            t ? (d[0] = r, d[1] = a, d[2] = s, d[3] = i, Ae.clearBufferuiv(Ae.COLOR, 0, d)) : (p[0] = r, p[1] = a, p[2] = s, p[3] = i, Ae.clearBufferiv(Ae.COLOR, 0, p));
                        } else n |= Ae.COLOR_BUFFER_BIT;
                    }
                    e1 && (n |= Ae.DEPTH_BUFFER_BIT), t && (n |= Ae.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), Ae.clear(n);
                }, this.clearColor = function() {
                    this.clear(!0, !1, !1);
                }, this.clearDepth = function() {
                    this.clear(!1, !0, !1);
                }, this.clearStencil = function() {
                    this.clear(!1, !1, !0);
                }, this.dispose = function() {
                    t.removeEventListener("webglcontextlost", xe, !1), t.removeEventListener("webglcontextrestored", _e, !1), t.removeEventListener("webglcontextcreationerror", be, !1), se.dispose(), oe.dispose(), K.dispose(), $.dispose(), ee.dispose(), ie.dispose(), me.dispose(), ge.dispose(), re.dispose(), ye.dispose(), ye.removeEventListener("sessionstart", Se), ye.removeEventListener("sessionend", Ie), F && (F.dispose(), F = null), Ne.stop();
                }, this.renderBufferDirect = function(e1, t, n, i, r, a) {
                    null === t && (t = Q);
                    const s = r.isMesh && r.matrixWorld.determinant() < 0, o = function(e1, t, n, i, r) {
                        !0 !== t.isScene && (t = Q), J.resetTextureUnits();
                        const a = t.fog, s = i.isMeshStandardMaterial ? t.environment : null, o = null === _ ? v.outputColorSpace : !0 === _.isXRRenderTarget ? _.texture.colorSpace : Qs, l = (i.isMeshStandardMaterial ? ee : $).get(i.envMap || s), c = !0 === i.vertexColors && !!n.attributes.color && 4 === n.attributes.color.itemSize, u = !!n.attributes.tangent && (!!i.normalMap || i.anisotropy > 0), h = !!n.morphAttributes.position, d = !!n.morphAttributes.normal, p = !!n.morphAttributes.color;
                        let f = qr;
                        i.toneMapped && (null !== _ && !0 !== _.isXRRenderTarget || (f = v.toneMapping));
                        const g = n.morphAttributes.position || n.morphAttributes.normal || n.morphAttributes.color, A = void 0 !== g ? g.length : 0, M = K.get(i), y = m.state.lights;
                        if (!0 === j && (!0 === B || e1 !== w)) {
                            const t = e1 === w && i.id === b;
                            le.setState(i, e1, t);
                        }
                        let x = !1;
                        i.version === M.__version ? M.needsLights && M.lightsStateVersion !== y.state.version || M.outputColorSpace !== o || r.isInstancedMesh && !1 === M.instancing ? x = !0 : r.isInstancedMesh || !0 !== M.instancing ? r.isSkinnedMesh && !1 === M.skinning ? x = !0 : r.isSkinnedMesh || !0 !== M.skinning ? r.isInstancedMesh && !0 === M.instancingColor && null === r.instanceColor || r.isInstancedMesh && !1 === M.instancingColor && null !== r.instanceColor || M.envMap !== l || !0 === i.fog && M.fog !== a ? x = !0 : void 0 === M.numClippingPlanes || M.numClippingPlanes === le.numPlanes && M.numIntersection === le.numIntersection ? (M.vertexAlphas !== c || M.vertexTangents !== u || M.morphTargets !== h || M.morphNormals !== d || M.morphColors !== p || M.toneMapping !== f || !0 === X.isWebGL2 && M.morphTargetsCount !== A) && (x = !0) : x = !0 : x = !0 : x = !0 : (x = !0, M.__version = i.version);
                        let E = M.currentProgram;
                        !0 === x && (E = ze(i, t, r));
                        let T = !1, S = !1, I = !1;
                        const N = E.getUniforms(), D = M.uniforms;
                        if (Z.useProgram(E.program) && (T = !0, S = !0, I = !0), i.id !== b && (b = i.id, S = !0), T || w !== e1) {
                            N.setValue(Ae, "projectionMatrix", e1.projectionMatrix), N.setValue(Ae, "viewMatrix", e1.matrixWorldInverse);
                            const t = N.map.cameraPosition;
                            void 0 !== t && t.setValue(Ae, G.setFromMatrixPosition(e1.matrixWorld)), X.logarithmicDepthBuffer && N.setValue(Ae, "logDepthBufFC", 2 / (Math.log(e1.far + 1) / Math.LN2)), (i.isMeshPhongMaterial || i.isMeshToonMaterial || i.isMeshLambertMaterial || i.isMeshBasicMaterial || i.isMeshStandardMaterial || i.isShaderMaterial) && N.setValue(Ae, "isOrthographic", !0 === e1.isOrthographicCamera), w !== e1 && (w = e1, S = !0, I = !0);
                        }
                        if (r.isSkinnedMesh) {
                            N.setOptional(Ae, r, "bindMatrix"), N.setOptional(Ae, r, "bindMatrixInverse");
                            const e1 = r.skeleton;
                            e1 && (X.floatVertexTextures ? (null === e1.boneTexture && e1.computeBoneTexture(), N.setValue(Ae, "boneTexture", e1.boneTexture, J), N.setValue(Ae, "boneTextureSize", e1.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
                        }
                        const R = n.morphAttributes;
                        var z, O;
                        if ((void 0 !== R.position || void 0 !== R.normal || void 0 !== R.color && !0 === X.isWebGL2) && he.update(r, n, E), (S || M.receiveShadow !== r.receiveShadow) && (M.receiveShadow = r.receiveShadow, N.setValue(Ae, "receiveShadow", r.receiveShadow)), i.isMeshGouraudMaterial && null !== i.envMap && (D.envMap.value = l, D.flipEnvMap.value = l.isCubeTexture && !1 === l.isRenderTargetTexture ? -1 : 1), S && (N.setValue(Ae, "toneMappingExposure", v.toneMappingExposure), M.needsLights && (O = I, (z = D).ambientLightColor.needsUpdate = O, z.lightProbe.needsUpdate = O, z.directionalLights.needsUpdate = O, z.directionalLightShadows.needsUpdate = O, z.pointLights.needsUpdate = O, z.pointLightShadows.needsUpdate = O, z.spotLights.needsUpdate = O, z.spotLightShadows.needsUpdate = O, z.rectAreaLights.needsUpdate = O, z.hemisphereLights.needsUpdate = O), a && !0 === i.fog && ae.refreshFogUniforms(D, a), ae.refreshMaterialUniforms(D, i, L, C, F), Kd.upload(Ae, Oe(M), D, J)), i.isShaderMaterial && !0 === i.uniformsNeedUpdate && (Kd.upload(Ae, Oe(M), D, J), i.uniformsNeedUpdate = !1), i.isSpriteMaterial && N.setValue(Ae, "center", r.center), N.setValue(Ae, "modelViewMatrix", r.modelViewMatrix), N.setValue(Ae, "normalMatrix", r.normalMatrix), N.setValue(Ae, "modelMatrix", r.matrixWorld), i.isShaderMaterial || i.isRawShaderMaterial) {
                            const e1 = i.uniformsGroups;
                            for(let t = 0, n = e1.length; t < n; t++)if (X.isWebGL2) {
                                const n = e1[t];
                                ge.update(n, E), ge.bind(n, E);
                            } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
                        }
                        return E;
                    }(e1, t, n, i, r);
                    Z.setMaterial(i, s);
                    let l = n.index, c = 1;
                    if (!0 === i.wireframe) {
                        if (l = ne.getWireframeAttribute(n), void 0 === l) return;
                        c = 2;
                    }
                    const u = n.drawRange, h = n.attributes.position;
                    let d = u.start * c, p = (u.start + u.count) * c;
                    null !== a && (d = Math.max(d, a.start * c), p = Math.min(p, (a.start + a.count) * c)), null !== l ? (d = Math.max(d, 0), p = Math.min(p, l.count)) : null != h && (d = Math.max(d, 0), p = Math.min(p, h.count));
                    const f = p - d;
                    if (f < 0 || f === 1 / 0) return;
                    let g;
                    me.setup(r, i, o, n, l);
                    let A = de;
                    if (null !== l && (g = te.get(l), A = pe, A.setIndex(g)), r.isMesh) !0 === i.wireframe ? (Z.setLineWidth(i.wireframeLinewidth * W()), A.setMode(Ae.LINES)) : A.setMode(Ae.TRIANGLES);
                    else if (r.isLine) {
                        let e1 = i.linewidth;
                        void 0 === e1 && (e1 = 1), Z.setLineWidth(e1 * W()), r.isLineSegments ? A.setMode(Ae.LINES) : r.isLineLoop ? A.setMode(Ae.LINE_LOOP) : A.setMode(Ae.LINE_STRIP);
                    } else r.isPoints ? A.setMode(Ae.POINTS) : r.isSprite && A.setMode(Ae.TRIANGLES);
                    if (r.isInstancedMesh) A.renderInstances(d, f, r.count);
                    else if (n.isInstancedBufferGeometry) {
                        const e1 = void 0 !== n._maxInstanceCount ? n._maxInstanceCount : 1 / 0, t = Math.min(n.instanceCount, e1);
                        A.renderInstances(d, f, t);
                    } else A.render(d, f);
                }, this.compile = function(e1, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    null === n && (n = e1), m = oe.get(n), m.init(), A.push(m), n.traverseVisible(function(e1) {
                        e1.isLight && e1.layers.test(t.layers) && (m.pushLight(e1), e1.castShadow && m.pushShadow(e1));
                    }), e1 !== n && e1.traverseVisible(function(e1) {
                        e1.isLight && e1.layers.test(t.layers) && (m.pushLight(e1), e1.castShadow && m.pushShadow(e1));
                    }), m.setupLights(v._useLegacyLights);
                    const i = new Set;
                    return e1.traverse(function(e1) {
                        const t = e1.material;
                        if (t) {
                            if (Array.isArray(t)) for(let r = 0; r < t.length; r++){
                                const a = t[r];
                                Ee(a, n, e1), i.add(a);
                            }
                            else Ee(t, n, e1), i.add(t);
                        }
                    }), A.pop(), m = null, i;
                }, this.compileAsync = function(e1, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                    const i = this.compile(e1, t, n);
                    return new Promise((t)=>{
                        function n() {
                            i.forEach(function(e1) {
                                K.get(e1).currentProgram.isReady() && i.delete(e1);
                            }), 0 !== i.size ? setTimeout(n, 10) : t(e1);
                        }
                        null !== Y.get("KHR_parallel_shader_compile") ? n() : setTimeout(n, 10);
                    });
                };
                let Te = null;
                function Se() {
                    Ne.stop();
                }
                function Ie() {
                    Ne.start();
                }
                const Ne = new uh;
                function De(e1, t, n, i) {
                    if (!1 === e1.visible) return;
                    if (e1.layers.test(t.layers)) {
                        if (e1.isGroup) n = e1.renderOrder;
                        else if (e1.isLOD) !0 === e1.autoUpdate && e1.update(t);
                        else if (e1.isLight) m.pushLight(e1), e1.castShadow && m.pushShadow(e1);
                        else if (e1.isSprite) {
                            if (!e1.frustumCulled || k.intersectsSprite(e1)) {
                                i && G.setFromMatrixPosition(e1.matrixWorld).applyMatrix4(H);
                                const t = ie.update(e1), r = e1.material;
                                r.visible && f.push(e1, t, r, n, G.z, null);
                            }
                        } else if ((e1.isMesh || e1.isLine || e1.isPoints) && (!e1.frustumCulled || k.intersectsObject(e1))) {
                            const t = ie.update(e1), r = e1.material;
                            if (i && (void 0 !== e1.boundingSphere ? (null === e1.boundingSphere && e1.computeBoundingSphere(), G.copy(e1.boundingSphere.center)) : (null === t.boundingSphere && t.computeBoundingSphere(), G.copy(t.boundingSphere.center)), G.applyMatrix4(e1.matrixWorld).applyMatrix4(H)), Array.isArray(r)) {
                                const i = t.groups;
                                for(let a = 0, s = i.length; a < s; a++){
                                    const s = i[a], o = r[s.materialIndex];
                                    o && o.visible && f.push(e1, t, o, n, G.z, s);
                                }
                            } else r.visible && f.push(e1, t, r, n, G.z, null);
                        }
                    }
                    const r = e1.children;
                    for(let e1 = 0, a = r.length; e1 < a; e1++)De(r[e1], t, n, i);
                }
                function Ce(e1, t, n, i) {
                    const r = e1.opaque, a = e1.transmissive, s = e1.transparent;
                    m.setupLightsView(n), !0 === j && le.setGlobalState(v.clippingPlanes, n), a.length > 0 && function(e1, t, n, i) {
                        if (null !== (!0 === n.isScene ? n.overrideMaterial : null)) return;
                        const r = X.isWebGL2;
                        null === F && (F = new wl(1, 1, {
                            generateMipmaps: !0,
                            type: Y.has("EXT_color_buffer_half_float") ? Da : ba,
                            minFilter: xa,
                            samples: r ? 4 : 0
                        })), v.getDrawingBufferSize(V), r ? F.setSize(V.x, V.y) : F.setSize(Xo(V.x), Xo(V.y));
                        const a = v.getRenderTarget();
                        v.setRenderTarget(F), v.getClearColor(I), N = v.getClearAlpha(), N < 1 && v.setClearColor(16777215, .5), v.clear();
                        const s = v.toneMapping;
                        v.toneMapping = qr, Le(e1, n, i), J.updateMultisampleRenderTarget(F), J.updateRenderTargetMipmap(F);
                        let o = !1;
                        for(let e1 = 0, r = t.length; e1 < r; e1++){
                            const r = t[e1], a = r.object, s = r.geometry, l = r.material, c = r.group;
                            if (l.side === hr && a.layers.test(i.layers)) {
                                const e1 = l.side;
                                l.side = ur, l.needsUpdate = !0, Re(a, n, i, s, l, c), l.side = e1, l.needsUpdate = !0, o = !0;
                            }
                        }
                        !0 === o && (J.updateMultisampleRenderTarget(F), J.updateRenderTargetMipmap(F)), v.setRenderTarget(a), v.setClearColor(I, N), v.toneMapping = s;
                    }(r, a, t, n), i && Z.viewport(E.copy(i)), r.length > 0 && Le(r, t, n), a.length > 0 && Le(a, t, n), s.length > 0 && Le(s, t, n), Z.buffers.depth.setTest(!0), Z.buffers.depth.setMask(!0), Z.buffers.color.setMask(!0), Z.setPolygonOffset(!1);
                }
                function Le(e1, t, n) {
                    const i = !0 === t.isScene ? t.overrideMaterial : null;
                    for(let r = 0, a = e1.length; r < a; r++){
                        const a = e1[r], s = a.object, o = a.geometry, l = null === i ? a.material : i, c = a.group;
                        s.layers.test(n.layers) && Re(s, t, n, o, l, c);
                    }
                }
                function Re(e1, t, n, i, r, a) {
                    e1.onBeforeRender(v, t, n, i, r, a), e1.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse, e1.matrixWorld), e1.normalMatrix.getNormalMatrix(e1.modelViewMatrix), r.onBeforeRender(v, t, n, i, e1, a), !0 === r.transparent && r.side === hr && !1 === r.forceSinglePass ? (r.side = ur, r.needsUpdate = !0, v.renderBufferDirect(n, t, i, r, e1, a), r.side = cr, r.needsUpdate = !0, v.renderBufferDirect(n, t, i, r, e1, a), r.side = hr) : v.renderBufferDirect(n, t, i, r, e1, a), e1.onAfterRender(v, t, n, i, r, a);
                }
                function ze(e1, t, n) {
                    !0 !== t.isScene && (t = Q);
                    const i = K.get(e1), r = m.state.lights, a = m.state.shadowsArray, s = r.state.version, o = re.getParameters(e1, r.state, a, t, n), l = re.getProgramCacheKey(o);
                    let c = i.programs;
                    i.environment = e1.isMeshStandardMaterial ? t.environment : null, i.fog = t.fog, i.envMap = (e1.isMeshStandardMaterial ? ee : $).get(e1.envMap || i.environment), void 0 === c && (e1.addEventListener("dispose", we), c = new Map, i.programs = c);
                    let u = c.get(l);
                    if (void 0 !== u) {
                        if (i.currentProgram === u && i.lightsStateVersion === s) return Pe(e1, o), u;
                    } else o.uniforms = re.getUniforms(e1), e1.onBuild(n, o, v), e1.onBeforeCompile(o, v), u = re.acquireProgram(o, l), c.set(l, u), i.uniforms = o.uniforms;
                    const h = i.uniforms;
                    return (e1.isShaderMaterial || e1.isRawShaderMaterial) && !0 !== e1.clipping || (h.clippingPlanes = le.uniform), Pe(e1, o), i.needsLights = function(e1) {
                        return e1.isMeshLambertMaterial || e1.isMeshToonMaterial || e1.isMeshPhongMaterial || e1.isMeshStandardMaterial || e1.isShadowMaterial || e1.isShaderMaterial && !0 === e1.lights;
                    }(e1), i.lightsStateVersion = s, i.needsLights && (h.ambientLightColor.value = r.state.ambient, h.lightProbe.value = r.state.probe, h.directionalLights.value = r.state.directional, h.directionalLightShadows.value = r.state.directionalShadow, h.spotLights.value = r.state.spot, h.spotLightShadows.value = r.state.spotShadow, h.rectAreaLights.value = r.state.rectArea, h.ltc_1.value = r.state.rectAreaLTC1, h.ltc_2.value = r.state.rectAreaLTC2, h.pointLights.value = r.state.point, h.pointLightShadows.value = r.state.pointShadow, h.hemisphereLights.value = r.state.hemi, h.directionalShadowMap.value = r.state.directionalShadowMap, h.directionalShadowMatrix.value = r.state.directionalShadowMatrix, h.spotShadowMap.value = r.state.spotShadowMap, h.spotLightMatrix.value = r.state.spotLightMatrix, h.spotLightMap.value = r.state.spotLightMap, h.pointShadowMap.value = r.state.pointShadowMap, h.pointShadowMatrix.value = r.state.pointShadowMatrix), i.currentProgram = u, i.uniformsList = null, u;
                }
                function Oe(e1) {
                    if (null === e1.uniformsList) {
                        const t = e1.currentProgram.getUniforms();
                        e1.uniformsList = Kd.seqWithValue(t.seq, e1.uniforms);
                    }
                    return e1.uniformsList;
                }
                function Pe(e1, t) {
                    const n = K.get(e1);
                    n.outputColorSpace = t.outputColorSpace, n.instancing = t.instancing, n.instancingColor = t.instancingColor, n.skinning = t.skinning, n.morphTargets = t.morphTargets, n.morphNormals = t.morphNormals, n.morphColors = t.morphColors, n.morphTargetsCount = t.morphTargetsCount, n.numClippingPlanes = t.numClippingPlanes, n.numIntersection = t.numClipIntersection, n.vertexAlphas = t.vertexAlphas, n.vertexTangents = t.vertexTangents, n.toneMapping = t.toneMapping;
                }
                Ne.setAnimationLoop(function(e1) {
                    Te && Te(e1);
                }), "undefined" != typeof self && Ne.setContext(self), this.setAnimationLoop = function(e1) {
                    Te = e1, ye.setAnimationLoop(e1), null === e1 ? Ne.stop() : Ne.start();
                }, ye.addEventListener("sessionstart", Se), ye.addEventListener("sessionend", Ie), this.render = function(e1, t) {
                    if (void 0 !== t && !0 !== t.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                    if (!0 === M) return;
                    !0 === e1.matrixWorldAutoUpdate && e1.updateMatrixWorld(), null === t.parent && !0 === t.matrixWorldAutoUpdate && t.updateMatrixWorld(), !0 === ye.enabled && !0 === ye.isPresenting && (!0 === ye.cameraAutoUpdate && ye.updateCamera(t), t = ye.getCamera()), !0 === e1.isScene && e1.onBeforeRender(v, e1, t, _), m = oe.get(e1, A.length), m.init(), A.push(m), H.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), k.setFromProjectionMatrix(H), B = this.localClippingEnabled, j = le.init(this.clippingPlanes, B), f = se.get(e1, g.length), f.init(), g.push(f), De(e1, t, 0, v.sortObjects), f.finish(), !0 === v.sortObjects && f.sort(R, z), this.info.render.frame++, !0 === j && le.beginShadows();
                    const n = m.state.shadowsArray;
                    if (ce.render(n, e1, t), !0 === j && le.endShadows(), !0 === this.info.autoReset && this.info.reset(), ue.render(f, e1), m.setupLights(v._useLegacyLights), t.isArrayCamera) {
                        const n = t.cameras;
                        for(let t = 0, i = n.length; t < i; t++){
                            const i = n[t];
                            Ce(f, e1, i, i.viewport);
                        }
                    } else Ce(f, e1, t);
                    null !== _ && (J.updateMultisampleRenderTarget(_), J.updateRenderTargetMipmap(_)), !0 === e1.isScene && e1.onAfterRender(v, e1, t), me.resetDefaultState(), b = -1, w = null, A.pop(), m = A.length > 0 ? A[A.length - 1] : null, g.pop(), f = g.length > 0 ? g[g.length - 1] : null;
                }, this.getActiveCubeFace = function() {
                    return y;
                }, this.getActiveMipmapLevel = function() {
                    return x;
                }, this.getRenderTarget = function() {
                    return _;
                }, this.setRenderTargetTextures = function(e1, t, n) {
                    K.get(e1.texture).__webglTexture = t, K.get(e1.depthTexture).__webglTexture = n;
                    const i = K.get(e1);
                    i.__hasExternalTextures = !0, i.__hasExternalTextures && (i.__autoAllocateDepthBuffer = void 0 === n, i.__autoAllocateDepthBuffer || !0 === Y.has("WEBGL_multisampled_render_to_texture") && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), i.__useRenderToTexture = !1));
                }, this.setRenderTargetFramebuffer = function(e1, t) {
                    const n = K.get(e1);
                    n.__webglFramebuffer = t, n.__useDefaultFramebuffer = void 0 === t;
                }, this.setRenderTarget = function(e1) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                    _ = e1, y = t, x = n;
                    let i = !0, r = null, a = !1, s = !1;
                    if (e1) {
                        const o = K.get(e1);
                        void 0 !== o.__useDefaultFramebuffer ? (Z.bindFramebuffer(Ae.FRAMEBUFFER, null), i = !1) : void 0 === o.__webglFramebuffer ? J.setupRenderTarget(e1) : o.__hasExternalTextures && J.rebindTextures(e1, K.get(e1.texture).__webglTexture, K.get(e1.depthTexture).__webglTexture);
                        const l = e1.texture;
                        (l.isData3DTexture || l.isDataArrayTexture || l.isCompressedArrayTexture) && (s = !0);
                        const c = K.get(e1).__webglFramebuffer;
                        e1.isWebGLCubeRenderTarget ? (r = Array.isArray(c[t]) ? c[t][n] : c[t], a = !0) : r = X.isWebGL2 && e1.samples > 0 && !1 === J.useMultisampledRTT(e1) ? K.get(e1).__webglMultisampledFramebuffer : Array.isArray(c) ? c[n] : c, E.copy(e1.viewport), T.copy(e1.scissor), S = e1.scissorTest;
                    } else E.copy(O).multiplyScalar(L).floor(), T.copy(P).multiplyScalar(L).floor(), S = U;
                    if (Z.bindFramebuffer(Ae.FRAMEBUFFER, r) && X.drawBuffers && i && Z.drawBuffers(e1, r), Z.viewport(E), Z.scissor(T), Z.setScissorTest(S), a) {
                        const i = K.get(e1.texture);
                        Ae.framebufferTexture2D(Ae.FRAMEBUFFER, Ae.COLOR_ATTACHMENT0, Ae.TEXTURE_CUBE_MAP_POSITIVE_X + t, i.__webglTexture, n);
                    } else if (s) {
                        const i = K.get(e1.texture), r = t || 0;
                        Ae.framebufferTextureLayer(Ae.FRAMEBUFFER, Ae.COLOR_ATTACHMENT0, i.__webglTexture, n || 0, r);
                    }
                    b = -1;
                }, this.readRenderTargetPixels = function(e1, t, n, i, r, a, s) {
                    if (!e1 || !e1.isWebGLRenderTarget) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                    let o = K.get(e1).__webglFramebuffer;
                    if (e1.isWebGLCubeRenderTarget && void 0 !== s && (o = o[s]), o) {
                        Z.bindFramebuffer(Ae.FRAMEBUFFER, o);
                        try {
                            const s = e1.texture, o = s.format, l = s.type;
                            if (o !== Oa && fe.convert(o) !== Ae.getParameter(Ae.IMPLEMENTATION_COLOR_READ_FORMAT)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                            const c = l === Da && (Y.has("EXT_color_buffer_half_float") || X.isWebGL2 && Y.has("EXT_color_buffer_float"));
                            if (!(l === ba || fe.convert(l) === Ae.getParameter(Ae.IMPLEMENTATION_COLOR_READ_TYPE) || l === Na && (X.isWebGL2 || Y.has("OES_texture_float") || Y.has("WEBGL_color_buffer_float")) || c)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                            t >= 0 && t <= e1.width - i && n >= 0 && n <= e1.height - r && Ae.readPixels(t, n, i, r, fe.convert(o), fe.convert(l), a);
                        } finally{
                            const e1 = null !== _ ? K.get(_).__webglFramebuffer : null;
                            Z.bindFramebuffer(Ae.FRAMEBUFFER, e1);
                        }
                    }
                }, this.copyFramebufferToTexture = function(e1, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                    const i = Math.pow(2, -n), r = Math.floor(t.image.width * i), a = Math.floor(t.image.height * i);
                    J.setTexture2D(t, 0), Ae.copyTexSubImage2D(Ae.TEXTURE_2D, n, 0, 0, e1.x, e1.y, r, a), Z.unbindTexture();
                }, this.copyTextureToTexture = function(e1, t, n) {
                    let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
                    const r = t.image.width, a = t.image.height, s = fe.convert(n.format), o = fe.convert(n.type);
                    J.setTexture2D(n, 0), Ae.pixelStorei(Ae.UNPACK_FLIP_Y_WEBGL, n.flipY), Ae.pixelStorei(Ae.UNPACK_PREMULTIPLY_ALPHA_WEBGL, n.premultiplyAlpha), Ae.pixelStorei(Ae.UNPACK_ALIGNMENT, n.unpackAlignment), t.isDataTexture ? Ae.texSubImage2D(Ae.TEXTURE_2D, i, e1.x, e1.y, r, a, s, o, t.image.data) : t.isCompressedTexture ? Ae.compressedTexSubImage2D(Ae.TEXTURE_2D, i, e1.x, e1.y, t.mipmaps[0].width, t.mipmaps[0].height, s, t.mipmaps[0].data) : Ae.texSubImage2D(Ae.TEXTURE_2D, i, e1.x, e1.y, s, o, t.image), 0 === i && n.generateMipmaps && Ae.generateMipmap(Ae.TEXTURE_2D), Z.unbindTexture();
                }, this.copyTextureToTexture3D = function(e1, t, n, i) {
                    let r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0;
                    if (v.isWebGL1Renderer) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
                    const a = e1.max.x - e1.min.x + 1, s = e1.max.y - e1.min.y + 1, o = e1.max.z - e1.min.z + 1, l = fe.convert(i.format), c = fe.convert(i.type);
                    let u;
                    if (i.isData3DTexture) J.setTexture3D(i, 0), u = Ae.TEXTURE_3D;
                    else {
                        if (!i.isDataArrayTexture) return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
                        J.setTexture2DArray(i, 0), u = Ae.TEXTURE_2D_ARRAY;
                    }
                    Ae.pixelStorei(Ae.UNPACK_FLIP_Y_WEBGL, i.flipY), Ae.pixelStorei(Ae.UNPACK_PREMULTIPLY_ALPHA_WEBGL, i.premultiplyAlpha), Ae.pixelStorei(Ae.UNPACK_ALIGNMENT, i.unpackAlignment);
                    const h = Ae.getParameter(Ae.UNPACK_ROW_LENGTH), d = Ae.getParameter(Ae.UNPACK_IMAGE_HEIGHT), p = Ae.getParameter(Ae.UNPACK_SKIP_PIXELS), f = Ae.getParameter(Ae.UNPACK_SKIP_ROWS), m = Ae.getParameter(Ae.UNPACK_SKIP_IMAGES), g = n.isCompressedTexture ? n.mipmaps[0] : n.image;
                    Ae.pixelStorei(Ae.UNPACK_ROW_LENGTH, g.width), Ae.pixelStorei(Ae.UNPACK_IMAGE_HEIGHT, g.height), Ae.pixelStorei(Ae.UNPACK_SKIP_PIXELS, e1.min.x), Ae.pixelStorei(Ae.UNPACK_SKIP_ROWS, e1.min.y), Ae.pixelStorei(Ae.UNPACK_SKIP_IMAGES, e1.min.z), n.isDataTexture || n.isData3DTexture ? Ae.texSubImage3D(u, r, t.x, t.y, t.z, a, s, o, l, c, g.data) : n.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), Ae.compressedTexSubImage3D(u, r, t.x, t.y, t.z, a, s, o, l, g.data)) : Ae.texSubImage3D(u, r, t.x, t.y, t.z, a, s, o, l, c, g), Ae.pixelStorei(Ae.UNPACK_ROW_LENGTH, h), Ae.pixelStorei(Ae.UNPACK_IMAGE_HEIGHT, d), Ae.pixelStorei(Ae.UNPACK_SKIP_PIXELS, p), Ae.pixelStorei(Ae.UNPACK_SKIP_ROWS, f), Ae.pixelStorei(Ae.UNPACK_SKIP_IMAGES, m), 0 === r && i.generateMipmaps && Ae.generateMipmap(u), Z.unbindTexture();
                }, this.initTexture = function(e1) {
                    e1.isCubeTexture ? J.setTextureCube(e1, 0) : e1.isData3DTexture ? J.setTexture3D(e1, 0) : e1.isDataArrayTexture || e1.isCompressedArrayTexture ? J.setTexture2DArray(e1, 0) : J.setTexture2D(e1, 0), Z.unbindTexture();
                }, this.resetState = function() {
                    y = 0, x = 0, _ = null, Z.reset(), me.reset();
                }, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                    detail: this
                }));
            }
            get coordinateSystem() {
                return Oo;
            }
            get outputColorSpace() {
                return this._outputColorSpace;
            }
            set outputColorSpace(e1) {
                this._outputColorSpace = e1;
                const t = this.getContext();
                t.drawingBufferColorSpace = e1 === Ws ? "display-p3" : "srgb", t.unpackColorSpace = dl.workingColorSpace === Ys ? "display-p3" : "srgb";
            }
            get physicallyCorrectLights() {
                return console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), !this.useLegacyLights;
            }
            set physicallyCorrectLights(e1) {
                console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."), this.useLegacyLights = !e1;
            }
            get outputEncoding() {
                return console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace === Gs ? ks : Us;
            }
            set outputEncoding(e1) {
                console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."), this.outputColorSpace = e1 === ks ? Gs : Qs;
            }
            get useLegacyLights() {
                return console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."), this._useLegacyLights;
            }
            set useLegacyLights(e1) {
                console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."), this._useLegacyLights = e1;
            }
        }
        class Wp extends Qp {
        }
        Wp.prototype.isWebGL1Renderer = !0;
        class Yp {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 25e-5;
                this.isFogExp2 = !0, this.name = "", this.color = new Zc(e1), this.density = t;
            }
            clone() {
                return new Yp(this.color, this.density);
            }
            toJSON() {
                return {
                    type: "FogExp2",
                    name: this.name,
                    color: this.color.getHex(),
                    density: this.density
                };
            }
        }
        class Xp {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1e3;
                this.isFog = !0, this.name = "", this.color = new Zc(e1), this.near = t, this.far = n;
            }
            clone() {
                return new Xp(this.color, this.near, this.far);
            }
            toJSON() {
                return {
                    type: "Fog",
                    name: this.name,
                    color: this.color.getHex(),
                    near: this.near,
                    far: this.far
                };
            }
        }
        class Zp extends Lc {
            constructor(){
                super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                    detail: this
                }));
            }
            copy(e1, t) {
                return super.copy(e1, t), null !== e1.background && (this.background = e1.background.clone()), null !== e1.environment && (this.environment = e1.environment.clone()), null !== e1.fog && (this.fog = e1.fog.clone()), this.backgroundBlurriness = e1.backgroundBlurriness, this.backgroundIntensity = e1.backgroundIntensity, null !== e1.overrideMaterial && (this.overrideMaterial = e1.overrideMaterial.clone()), this.matrixAutoUpdate = e1.matrixAutoUpdate, this;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return null !== this.fog && (t.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (t.object.backgroundBlurriness = this.backgroundBlurriness), 1 !== this.backgroundIntensity && (t.object.backgroundIntensity = this.backgroundIntensity), t;
            }
        }
        class qp {
            constructor(e1, t){
                this.isInterleavedBuffer = !0, this.array = e1, this.stride = t, this.count = void 0 !== e1 ? e1.length / t : 0, this.usage = bo, this.updateRange = {
                    offset: 0,
                    count: -1
                }, this.version = 0, this.uuid = Ho();
            }
            onUploadCallback() {}
            set needsUpdate(e1) {
                !0 === e1 && this.version++;
            }
            setUsage(e1) {
                return this.usage = e1, this;
            }
            copy(e1) {
                return this.array = new e1.array.constructor(e1.array), this.count = e1.count, this.stride = e1.stride, this.usage = e1.usage, this;
            }
            copyAt(e1, t, n) {
                e1 *= this.stride, n *= t.stride;
                for(let i = 0, r = this.stride; i < r; i++)this.array[e1 + i] = t.array[n + i];
                return this;
            }
            set(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.array.set(e1, t), this;
            }
            clone(e1) {
                void 0 === e1.arrayBuffers && (e1.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = Ho()), void 0 === e1.arrayBuffers[this.array.buffer._uuid] && (e1.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
                const t = new this.array.constructor(e1.arrayBuffers[this.array.buffer._uuid]), n = new this.constructor(t, this.stride);
                return n.setUsage(this.usage), n;
            }
            onUpload(e1) {
                return this.onUploadCallback = e1, this;
            }
            toJSON(e1) {
                return void 0 === e1.arrayBuffers && (e1.arrayBuffers = {}), void 0 === this.array.buffer._uuid && (this.array.buffer._uuid = Ho()), void 0 === e1.arrayBuffers[this.array.buffer._uuid] && (e1.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
                    uuid: this.uuid,
                    buffer: this.array.buffer._uuid,
                    type: this.array.constructor.name,
                    stride: this.stride
                };
            }
        }
        const Kp = new Cl;
        class Jp {
            constructor(e1, t, n){
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                this.isInterleavedBufferAttribute = !0, this.name = "", this.data = e1, this.itemSize = t, this.offset = n, this.normalized = i;
            }
            get count() {
                return this.data.count;
            }
            get array() {
                return this.data.array;
            }
            set needsUpdate(e1) {
                this.data.needsUpdate = e1;
            }
            applyMatrix4(e1) {
                for(let t = 0, n = this.data.count; t < n; t++)Kp.fromBufferAttribute(this, t), Kp.applyMatrix4(e1), this.setXYZ(t, Kp.x, Kp.y, Kp.z);
                return this;
            }
            applyNormalMatrix(e1) {
                for(let t = 0, n = this.count; t < n; t++)Kp.fromBufferAttribute(this, t), Kp.applyNormalMatrix(e1), this.setXYZ(t, Kp.x, Kp.y, Kp.z);
                return this;
            }
            transformDirection(e1) {
                for(let t = 0, n = this.count; t < n; t++)Kp.fromBufferAttribute(this, t), Kp.transformDirection(e1), this.setXYZ(t, Kp.x, Kp.y, Kp.z);
                return this;
            }
            setX(e1, t) {
                return this.normalized && (t = qo(t, this.array)), this.data.array[e1 * this.data.stride + this.offset] = t, this;
            }
            setY(e1, t) {
                return this.normalized && (t = qo(t, this.array)), this.data.array[e1 * this.data.stride + this.offset + 1] = t, this;
            }
            setZ(e1, t) {
                return this.normalized && (t = qo(t, this.array)), this.data.array[e1 * this.data.stride + this.offset + 2] = t, this;
            }
            setW(e1, t) {
                return this.normalized && (t = qo(t, this.array)), this.data.array[e1 * this.data.stride + this.offset + 3] = t, this;
            }
            getX(e1) {
                let t = this.data.array[e1 * this.data.stride + this.offset];
                return this.normalized && (t = Zo(t, this.array)), t;
            }
            getY(e1) {
                let t = this.data.array[e1 * this.data.stride + this.offset + 1];
                return this.normalized && (t = Zo(t, this.array)), t;
            }
            getZ(e1) {
                let t = this.data.array[e1 * this.data.stride + this.offset + 2];
                return this.normalized && (t = Zo(t, this.array)), t;
            }
            getW(e1) {
                let t = this.data.array[e1 * this.data.stride + this.offset + 3];
                return this.normalized && (t = Zo(t, this.array)), t;
            }
            setXY(e1, t, n) {
                return e1 = e1 * this.data.stride + this.offset, this.normalized && (t = qo(t, this.array), n = qo(n, this.array)), this.data.array[e1 + 0] = t, this.data.array[e1 + 1] = n, this;
            }
            setXYZ(e1, t, n, i) {
                return e1 = e1 * this.data.stride + this.offset, this.normalized && (t = qo(t, this.array), n = qo(n, this.array), i = qo(i, this.array)), this.data.array[e1 + 0] = t, this.data.array[e1 + 1] = n, this.data.array[e1 + 2] = i, this;
            }
            setXYZW(e1, t, n, i, r) {
                return e1 = e1 * this.data.stride + this.offset, this.normalized && (t = qo(t, this.array), n = qo(n, this.array), i = qo(i, this.array), r = qo(r, this.array)), this.data.array[e1 + 0] = t, this.data.array[e1 + 1] = n, this.data.array[e1 + 2] = i, this.data.array[e1 + 3] = r, this;
            }
            clone(e1) {
                if (void 0 === e1) {
                    console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
                    const e1 = [];
                    for(let t = 0; t < this.count; t++){
                        const n = t * this.data.stride + this.offset;
                        for(let t = 0; t < this.itemSize; t++)e1.push(this.data.array[n + t]);
                    }
                    return new ou(new this.array.constructor(e1), this.itemSize, this.normalized);
                }
                return void 0 === e1.interleavedBuffers && (e1.interleavedBuffers = {}), void 0 === e1.interleavedBuffers[this.data.uuid] && (e1.interleavedBuffers[this.data.uuid] = this.data.clone(e1)), new Jp(e1.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
            }
            toJSON(e1) {
                if (void 0 === e1) {
                    console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
                    const e1 = [];
                    for(let t = 0; t < this.count; t++){
                        const n = t * this.data.stride + this.offset;
                        for(let t = 0; t < this.itemSize; t++)e1.push(this.data.array[n + t]);
                    }
                    return {
                        itemSize: this.itemSize,
                        type: this.array.constructor.name,
                        array: e1,
                        normalized: this.normalized
                    };
                }
                return void 0 === e1.interleavedBuffers && (e1.interleavedBuffers = {}), void 0 === e1.interleavedBuffers[this.data.uuid] && (e1.interleavedBuffers[this.data.uuid] = this.data.toJSON(e1)), {
                    isInterleavedBufferAttribute: !0,
                    itemSize: this.itemSize,
                    data: this.data.uuid,
                    offset: this.offset,
                    normalized: this.normalized
                };
            }
        }
        class $p extends Jc {
            constructor(e1){
                super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new Zc(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.alphaMap = e1.alphaMap, this.rotation = e1.rotation, this.sizeAttenuation = e1.sizeAttenuation, this.fog = e1.fog, this;
            }
        }
        let ef;
        const tf = new Cl, nf = new Cl, rf = new Cl, af = new Jo, sf = new Jo, of = new oc, lf = new Cl, cf = new Cl, uf = new Cl, hf = new Jo, df = new Jo, pf = new Jo;
        class ff extends Lc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new $p;
                if (super(), this.isSprite = !0, this.type = "Sprite", void 0 === ef) {
                    ef = new Eu;
                    const e1 = new Float32Array([
                        -0.5,
                        -0.5,
                        0,
                        0,
                        0,
                        .5,
                        -0.5,
                        0,
                        1,
                        0,
                        .5,
                        .5,
                        0,
                        1,
                        1,
                        -0.5,
                        .5,
                        0,
                        0,
                        1
                    ]), t = new qp(e1, 5);
                    ef.setIndex([
                        0,
                        1,
                        2,
                        0,
                        2,
                        3
                    ]), ef.setAttribute("position", new Jp(t, 3, 0, !1)), ef.setAttribute("uv", new Jp(t, 2, 3, !1));
                }
                this.geometry = ef, this.material = e1, this.center = new Jo(.5, .5);
            }
            raycast(e1, t) {
                null === e1.camera && console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.'), nf.setFromMatrixScale(this.matrixWorld), of.copy(e1.camera.matrixWorld), this.modelViewMatrix.multiplyMatrices(e1.camera.matrixWorldInverse, this.matrixWorld), rf.setFromMatrixPosition(this.modelViewMatrix), e1.camera.isPerspectiveCamera && !1 === this.material.sizeAttenuation && nf.multiplyScalar(-rf.z);
                const n = this.material.rotation;
                let i, r;
                0 !== n && (r = Math.cos(n), i = Math.sin(n));
                const a = this.center;
                mf(lf.set(-0.5, -0.5, 0), rf, a, nf, i, r), mf(cf.set(.5, -0.5, 0), rf, a, nf, i, r), mf(uf.set(.5, .5, 0), rf, a, nf, i, r), hf.set(0, 0), df.set(1, 0), pf.set(1, 1);
                let s = e1.ray.intersectTriangle(lf, cf, uf, !1, tf);
                if (null === s && (mf(cf.set(-0.5, .5, 0), rf, a, nf, i, r), df.set(0, 1), s = e1.ray.intersectTriangle(lf, uf, cf, !1, tf), null === s)) return;
                const o = e1.ray.origin.distanceTo(tf);
                o < e1.near || o > e1.far || t.push({
                    distance: o,
                    point: tf.clone(),
                    uv: Gc.getInterpolation(tf, lf, cf, uf, hf, df, pf, new Jo),
                    face: null,
                    object: this
                });
            }
            copy(e1, t) {
                return super.copy(e1, t), void 0 !== e1.center && this.center.copy(e1.center), this.material = e1.material, this;
            }
        }
        function mf(e1, t, n, i, r, a) {
            af.subVectors(e1, n).addScalar(.5).multiply(i), void 0 !== r ? (sf.x = a * af.x - r * af.y, sf.y = r * af.x + a * af.y) : sf.copy(af), e1.copy(t), e1.x += sf.x, e1.y += sf.y, e1.applyMatrix4(of);
        }
        const gf = new Cl, Af = new Cl;
        class vf extends Lc {
            constructor(){
                super(), this._currentLevel = 0, this.type = "LOD", Object.defineProperties(this, {
                    levels: {
                        enumerable: !0,
                        value: []
                    },
                    isLOD: {
                        value: !0
                    }
                }), this.autoUpdate = !0;
            }
            copy(e1) {
                super.copy(e1, !1);
                const t = e1.levels;
                for(let e1 = 0, n = t.length; e1 < n; e1++){
                    const n = t[e1];
                    this.addLevel(n.object.clone(), n.distance, n.hysteresis);
                }
                return this.autoUpdate = e1.autoUpdate, this;
            }
            addLevel(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                t = Math.abs(t);
                const i = this.levels;
                let r;
                for(r = 0; r < i.length && !(t < i[r].distance); r++);
                return i.splice(r, 0, {
                    distance: t,
                    hysteresis: n,
                    object: e1
                }), this.add(e1), this;
            }
            getCurrentLevel() {
                return this._currentLevel;
            }
            getObjectForDistance(e1) {
                const t = this.levels;
                if (t.length > 0) {
                    let n, i;
                    for(n = 1, i = t.length; n < i; n++){
                        let i = t[n].distance;
                        if (t[n].object.visible && (i -= i * t[n].hysteresis), e1 < i) break;
                    }
                    return t[n - 1].object;
                }
                return null;
            }
            raycast(e1, t) {
                if (this.levels.length > 0) {
                    gf.setFromMatrixPosition(this.matrixWorld);
                    const n = e1.ray.origin.distanceTo(gf);
                    this.getObjectForDistance(n).raycast(e1, t);
                }
            }
            update(e1) {
                const t = this.levels;
                if (t.length > 1) {
                    gf.setFromMatrixPosition(e1.matrixWorld), Af.setFromMatrixPosition(this.matrixWorld);
                    const n = gf.distanceTo(Af) / e1.zoom;
                    let i, r;
                    for(t[0].object.visible = !0, i = 1, r = t.length; i < r; i++){
                        let e1 = t[i].distance;
                        if (t[i].object.visible && (e1 -= e1 * t[i].hysteresis), !(n >= e1)) break;
                        t[i - 1].object.visible = !1, t[i].object.visible = !0;
                    }
                    for(this._currentLevel = i - 1; i < r; i++)t[i].object.visible = !1;
                }
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                !1 === this.autoUpdate && (t.object.autoUpdate = !1), t.object.levels = [];
                const n = this.levels;
                for(let e1 = 0, i = n.length; e1 < i; e1++){
                    const i = n[e1];
                    t.object.levels.push({
                        object: i.object.uuid,
                        distance: i.distance,
                        hysteresis: i.hysteresis
                    });
                }
                return t;
            }
        }
        const Mf = new Cl, yf = new _l, xf = new _l, _f = new Cl, bf = new oc, wf = new Cl, Ef = new Jl, Tf = new oc, Sf = new sc;
        class If extends Vu {
            constructor(e1, t){
                super(e1, t), this.isSkinnedMesh = !0, this.type = "SkinnedMesh", this.bindMode = na, this.bindMatrix = new oc, this.bindMatrixInverse = new oc, this.boundingBox = null, this.boundingSphere = null;
            }
            computeBoundingBox() {
                const e1 = this.geometry;
                null === this.boundingBox && (this.boundingBox = new zl), this.boundingBox.makeEmpty();
                const t = e1.getAttribute("position");
                for(let e1 = 0; e1 < t.count; e1++)this.getVertexPosition(e1, wf), this.boundingBox.expandByPoint(wf);
            }
            computeBoundingSphere() {
                const e1 = this.geometry;
                null === this.boundingSphere && (this.boundingSphere = new Jl), this.boundingSphere.makeEmpty();
                const t = e1.getAttribute("position");
                for(let e1 = 0; e1 < t.count; e1++)this.getVertexPosition(e1, wf), this.boundingSphere.expandByPoint(wf);
            }
            copy(e1, t) {
                return super.copy(e1, t), this.bindMode = e1.bindMode, this.bindMatrix.copy(e1.bindMatrix), this.bindMatrixInverse.copy(e1.bindMatrixInverse), this.skeleton = e1.skeleton, null !== e1.boundingBox && (this.boundingBox = e1.boundingBox.clone()), null !== e1.boundingSphere && (this.boundingSphere = e1.boundingSphere.clone()), this;
            }
            raycast(e1, t) {
                const n = this.material, i = this.matrixWorld;
                void 0 !== n && (null === this.boundingSphere && this.computeBoundingSphere(), Ef.copy(this.boundingSphere), Ef.applyMatrix4(i), !1 !== e1.ray.intersectsSphere(Ef) && (Tf.copy(i).invert(), Sf.copy(e1.ray).applyMatrix4(Tf), null !== this.boundingBox && !1 === Sf.intersectsBox(this.boundingBox) || this._computeIntersections(e1, t, Sf)));
            }
            getVertexPosition(e1, t) {
                return super.getVertexPosition(e1, t), this.applyBoneTransform(e1, t), t;
            }
            bind(e1, t) {
                this.skeleton = e1, void 0 === t && (this.updateMatrixWorld(!0), this.skeleton.calculateInverses(), t = this.matrixWorld), this.bindMatrix.copy(t), this.bindMatrixInverse.copy(t).invert();
            }
            pose() {
                this.skeleton.pose();
            }
            normalizeSkinWeights() {
                const e1 = new _l, t = this.geometry.attributes.skinWeight;
                for(let n = 0, i = t.count; n < i; n++){
                    e1.fromBufferAttribute(t, n);
                    const i = 1 / e1.manhattanLength();
                    i !== 1 / 0 ? e1.multiplyScalar(i) : e1.set(1, 0, 0, 0), t.setXYZW(n, e1.x, e1.y, e1.z, e1.w);
                }
            }
            updateMatrixWorld(e1) {
                super.updateMatrixWorld(e1), this.bindMode === na ? this.bindMatrixInverse.copy(this.matrixWorld).invert() : this.bindMode === ia ? this.bindMatrixInverse.copy(this.bindMatrix).invert() : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode);
            }
            applyBoneTransform(e1, t) {
                const n = this.skeleton, i = this.geometry;
                yf.fromBufferAttribute(i.attributes.skinIndex, e1), xf.fromBufferAttribute(i.attributes.skinWeight, e1), Mf.copy(t).applyMatrix4(this.bindMatrix), t.set(0, 0, 0);
                for(let e1 = 0; e1 < 4; e1++){
                    const i = xf.getComponent(e1);
                    if (0 !== i) {
                        const r = yf.getComponent(e1);
                        bf.multiplyMatrices(n.bones[r].matrixWorld, n.boneInverses[r]), t.addScaledVector(_f.copy(Mf).applyMatrix4(bf), i);
                    }
                }
                return t.applyMatrix4(this.bindMatrixInverse);
            }
            boneTransform(e1, t) {
                return console.warn("THREE.SkinnedMesh: .boneTransform() was renamed to .applyBoneTransform() in r151."), this.applyBoneTransform(e1, t);
            }
        }
        class Nf extends Lc {
            constructor(){
                super(), this.isBone = !0, this.type = "Bone";
            }
        }
        class Df extends xl {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                super(null, arguments.length > 5 ? arguments[5] : void 0, arguments.length > 6 ? arguments[6] : void 0, arguments.length > 7 ? arguments[7] : void 0, arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : pa, arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : pa, arguments.length > 3 ? arguments[3] : void 0, arguments.length > 4 ? arguments[4] : void 0, arguments.length > 10 ? arguments[10] : void 0, arguments.length > 11 ? arguments[11] : void 0), this.isDataTexture = !0, this.image = {
                    data: e1,
                    width: t,
                    height: n
                }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        const Cf = new oc, Lf = new oc;
        class Rf {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                this.uuid = Ho(), this.bones = e1.slice(0), this.boneInverses = t, this.boneMatrices = null, this.boneTexture = null, this.boneTextureSize = 0, this.init();
            }
            init() {
                const e1 = this.bones, t = this.boneInverses;
                if (this.boneMatrices = new Float32Array(16 * e1.length), 0 === t.length) this.calculateInverses();
                else if (e1.length !== t.length) {
                    console.warn("THREE.Skeleton: Number of inverse bone matrices does not match amount of bones."), this.boneInverses = [];
                    for(let e1 = 0, t = this.bones.length; e1 < t; e1++)this.boneInverses.push(new oc);
                }
            }
            calculateInverses() {
                this.boneInverses.length = 0;
                for(let e1 = 0, t = this.bones.length; e1 < t; e1++){
                    const t = new oc;
                    this.bones[e1] && t.copy(this.bones[e1].matrixWorld).invert(), this.boneInverses.push(t);
                }
            }
            pose() {
                for(let e1 = 0, t = this.bones.length; e1 < t; e1++){
                    const t = this.bones[e1];
                    t && t.matrixWorld.copy(this.boneInverses[e1]).invert();
                }
                for(let e1 = 0, t = this.bones.length; e1 < t; e1++){
                    const t = this.bones[e1];
                    t && (t.parent && t.parent.isBone ? (t.matrix.copy(t.parent.matrixWorld).invert(), t.matrix.multiply(t.matrixWorld)) : t.matrix.copy(t.matrixWorld), t.matrix.decompose(t.position, t.quaternion, t.scale));
                }
            }
            update() {
                const e1 = this.bones, t = this.boneInverses, n = this.boneMatrices, i = this.boneTexture;
                for(let i = 0, r = e1.length; i < r; i++){
                    const r = e1[i] ? e1[i].matrixWorld : Lf;
                    Cf.multiplyMatrices(r, t[i]), Cf.toArray(n, 16 * i);
                }
                null !== i && (i.needsUpdate = !0);
            }
            clone() {
                return new Rf(this.bones, this.boneInverses);
            }
            computeBoneTexture() {
                let e1 = Math.sqrt(4 * this.bones.length);
                e1 = Yo(e1), e1 = Math.max(e1, 4);
                const t = new Float32Array(e1 * e1 * 4);
                t.set(this.boneMatrices);
                const n = new Df(t, e1, e1, Oa, Na);
                return n.needsUpdate = !0, this.boneMatrices = t, this.boneTexture = n, this.boneTextureSize = e1, this;
            }
            getBoneByName(e1) {
                for(let t = 0, n = this.bones.length; t < n; t++){
                    const n = this.bones[t];
                    if (n.name === e1) return n;
                }
            }
            dispose() {
                null !== this.boneTexture && (this.boneTexture.dispose(), this.boneTexture = null);
            }
            fromJSON(e1, t) {
                this.uuid = e1.uuid;
                for(let n = 0, i = e1.bones.length; n < i; n++){
                    const i = e1.bones[n];
                    let r = t[i];
                    void 0 === r && (console.warn("THREE.Skeleton: No bone found with UUID:", i), r = new Nf), this.bones.push(r), this.boneInverses.push((new oc).fromArray(e1.boneInverses[n]));
                }
                return this.init(), this;
            }
            toJSON() {
                const e1 = {
                    metadata: {
                        version: 4.6,
                        type: "Skeleton",
                        generator: "Skeleton.toJSON"
                    },
                    bones: [],
                    boneInverses: []
                };
                e1.uuid = this.uuid;
                const t = this.bones, n = this.boneInverses;
                for(let i = 0, r = t.length; i < r; i++){
                    const r = t[i];
                    e1.bones.push(r.uuid);
                    const a = n[i];
                    e1.boneInverses.push(a.toArray());
                }
                return e1;
            }
        }
        class zf extends ou {
            constructor(e1, t, n){
                let i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                super(e1, t, n), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = i;
            }
            copy(e1) {
                return super.copy(e1), this.meshPerAttribute = e1.meshPerAttribute, this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.meshPerAttribute = this.meshPerAttribute, e1.isInstancedBufferAttribute = !0, e1;
            }
        }
        const Of = new oc, Pf = new oc, Uf = [], kf = new zl, jf = new oc, Bf = new Vu, Ff = new Jl;
        class Hf extends Vu {
            constructor(e1, t, n){
                super(e1, t), this.isInstancedMesh = !0, this.instanceMatrix = new zf(new Float32Array(16 * n), 16), this.instanceColor = null, this.count = n, this.boundingBox = null, this.boundingSphere = null;
                for(let e1 = 0; e1 < n; e1++)this.setMatrixAt(e1, jf);
            }
            computeBoundingBox() {
                const e1 = this.geometry, t = this.count;
                null === this.boundingBox && (this.boundingBox = new zl), null === e1.boundingBox && e1.computeBoundingBox(), this.boundingBox.makeEmpty();
                for(let n = 0; n < t; n++)this.getMatrixAt(n, Of), kf.copy(e1.boundingBox).applyMatrix4(Of), this.boundingBox.union(kf);
            }
            computeBoundingSphere() {
                const e1 = this.geometry, t = this.count;
                null === this.boundingSphere && (this.boundingSphere = new Jl), null === e1.boundingSphere && e1.computeBoundingSphere(), this.boundingSphere.makeEmpty();
                for(let n = 0; n < t; n++)this.getMatrixAt(n, Of), Ff.copy(e1.boundingSphere).applyMatrix4(Of), this.boundingSphere.union(Ff);
            }
            copy(e1, t) {
                return super.copy(e1, t), this.instanceMatrix.copy(e1.instanceMatrix), null !== e1.instanceColor && (this.instanceColor = e1.instanceColor.clone()), this.count = e1.count, null !== e1.boundingBox && (this.boundingBox = e1.boundingBox.clone()), null !== e1.boundingSphere && (this.boundingSphere = e1.boundingSphere.clone()), this;
            }
            getColorAt(e1, t) {
                t.fromArray(this.instanceColor.array, 3 * e1);
            }
            getMatrixAt(e1, t) {
                t.fromArray(this.instanceMatrix.array, 16 * e1);
            }
            raycast(e1, t) {
                const n = this.matrixWorld, i = this.count;
                if (Bf.geometry = this.geometry, Bf.material = this.material, void 0 !== Bf.material && (null === this.boundingSphere && this.computeBoundingSphere(), Ff.copy(this.boundingSphere), Ff.applyMatrix4(n), !1 !== e1.ray.intersectsSphere(Ff))) for(let r = 0; r < i; r++){
                    this.getMatrixAt(r, Of), Pf.multiplyMatrices(n, Of), Bf.matrixWorld = Pf, Bf.raycast(e1, Uf);
                    for(let e1 = 0, n = Uf.length; e1 < n; e1++){
                        const n = Uf[e1];
                        n.instanceId = r, n.object = this, t.push(n);
                    }
                    Uf.length = 0;
                }
            }
            setColorAt(e1, t) {
                null === this.instanceColor && (this.instanceColor = new zf(new Float32Array(3 * this.instanceMatrix.count), 3)), t.toArray(this.instanceColor.array, 3 * e1);
            }
            setMatrixAt(e1, t) {
                t.toArray(this.instanceMatrix.array, 16 * e1);
            }
            updateMorphTargets() {}
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
        }
        class Vf extends Jc {
            constructor(e1){
                super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Zc(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.linewidth = e1.linewidth, this.linecap = e1.linecap, this.linejoin = e1.linejoin, this.fog = e1.fog, this;
            }
        }
        const Gf = new Cl, Qf = new Cl, Wf = new oc, Yf = new sc, Xf = new Jl;
        class Zf extends Lc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Eu, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Vf;
                super(), this.isLine = !0, this.type = "Line", this.geometry = e1, this.material = t, this.updateMorphTargets();
            }
            copy(e1, t) {
                return super.copy(e1, t), this.material = Array.isArray(e1.material) ? e1.material.slice() : e1.material, this.geometry = e1.geometry, this;
            }
            computeLineDistances() {
                const e1 = this.geometry;
                if (null === e1.index) {
                    const t = e1.attributes.position, n = [
                        0
                    ];
                    for(let e1 = 1, i = t.count; e1 < i; e1++)Gf.fromBufferAttribute(t, e1 - 1), Qf.fromBufferAttribute(t, e1), n[e1] = n[e1 - 1], n[e1] += Gf.distanceTo(Qf);
                    e1.setAttribute("lineDistance", new gu(n, 1));
                } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                return this;
            }
            raycast(e1, t) {
                const n = this.geometry, i = this.matrixWorld, r = e1.params.Line.threshold, a = n.drawRange;
                if (null === n.boundingSphere && n.computeBoundingSphere(), Xf.copy(n.boundingSphere), Xf.applyMatrix4(i), Xf.radius += r, !1 === e1.ray.intersectsSphere(Xf)) return;
                Wf.copy(i).invert(), Yf.copy(e1.ray).applyMatrix4(Wf);
                const s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = s * s, l = new Cl, c = new Cl, u = new Cl, h = new Cl, d = this.isLineSegments ? 2 : 1, p = n.index, f = n.attributes.position;
                if (null !== p) for(let n = Math.max(0, a.start), i = Math.min(p.count, a.start + a.count) - 1; n < i; n += d){
                    const i = p.getX(n), r = p.getX(n + 1);
                    if (l.fromBufferAttribute(f, i), c.fromBufferAttribute(f, r), Yf.distanceSqToSegment(l, c, h, u) > o) continue;
                    h.applyMatrix4(this.matrixWorld);
                    const a = e1.ray.origin.distanceTo(h);
                    a < e1.near || a > e1.far || t.push({
                        distance: a,
                        point: u.clone().applyMatrix4(this.matrixWorld),
                        index: n,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
                else for(let n = Math.max(0, a.start), i = Math.min(f.count, a.start + a.count) - 1; n < i; n += d){
                    if (l.fromBufferAttribute(f, n), c.fromBufferAttribute(f, n + 1), Yf.distanceSqToSegment(l, c, h, u) > o) continue;
                    h.applyMatrix4(this.matrixWorld);
                    const i = e1.ray.origin.distanceTo(h);
                    i < e1.near || i > e1.far || t.push({
                        distance: i,
                        point: u.clone().applyMatrix4(this.matrixWorld),
                        index: n,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            }
            updateMorphTargets() {
                const e1 = this.geometry.morphAttributes, t = Object.keys(e1);
                if (t.length > 0) {
                    const n = e1[t[0]];
                    if (void 0 !== n) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let e1 = 0, t = n.length; e1 < t; e1++){
                            const t = n[e1].name || String(e1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e1;
                        }
                    }
                }
            }
        }
        const qf = new Cl, Kf = new Cl;
        class Jf extends Zf {
            constructor(e1, t){
                super(e1, t), this.isLineSegments = !0, this.type = "LineSegments";
            }
            computeLineDistances() {
                const e1 = this.geometry;
                if (null === e1.index) {
                    const t = e1.attributes.position, n = [];
                    for(let e1 = 0, i = t.count; e1 < i; e1 += 2)qf.fromBufferAttribute(t, e1), Kf.fromBufferAttribute(t, e1 + 1), n[e1] = 0 === e1 ? 0 : n[e1 - 1], n[e1 + 1] = n[e1] + qf.distanceTo(Kf);
                    e1.setAttribute("lineDistance", new gu(n, 1));
                } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                return this;
            }
        }
        class $f extends Zf {
            constructor(e1, t){
                super(e1, t), this.isLineLoop = !0, this.type = "LineLoop";
            }
        }
        class em extends Jc {
            constructor(e1){
                super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new Zc(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.alphaMap = e1.alphaMap, this.size = e1.size, this.sizeAttenuation = e1.sizeAttenuation, this.fog = e1.fog, this;
            }
        }
        const tm = new oc, nm = new sc, im = new Jl, rm = new Cl;
        class am extends Lc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Eu, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new em;
                super(), this.isPoints = !0, this.type = "Points", this.geometry = e1, this.material = t, this.updateMorphTargets();
            }
            copy(e1, t) {
                return super.copy(e1, t), this.material = Array.isArray(e1.material) ? e1.material.slice() : e1.material, this.geometry = e1.geometry, this;
            }
            raycast(e1, t) {
                const n = this.geometry, i = this.matrixWorld, r = e1.params.Points.threshold, a = n.drawRange;
                if (null === n.boundingSphere && n.computeBoundingSphere(), im.copy(n.boundingSphere), im.applyMatrix4(i), im.radius += r, !1 === e1.ray.intersectsSphere(im)) return;
                tm.copy(i).invert(), nm.copy(e1.ray).applyMatrix4(tm);
                const s = r / ((this.scale.x + this.scale.y + this.scale.z) / 3), o = s * s, l = n.index, c = n.attributes.position;
                if (null !== l) for(let n = Math.max(0, a.start), r = Math.min(l.count, a.start + a.count); n < r; n++){
                    const r = l.getX(n);
                    rm.fromBufferAttribute(c, r), sm(rm, r, o, i, e1, t, this);
                }
                else for(let n = Math.max(0, a.start), r = Math.min(c.count, a.start + a.count); n < r; n++)rm.fromBufferAttribute(c, n), sm(rm, n, o, i, e1, t, this);
            }
            updateMorphTargets() {
                const e1 = this.geometry.morphAttributes, t = Object.keys(e1);
                if (t.length > 0) {
                    const n = e1[t[0]];
                    if (void 0 !== n) {
                        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                        for(let e1 = 0, t = n.length; e1 < t; e1++){
                            const t = n[e1].name || String(e1);
                            this.morphTargetInfluences.push(0), this.morphTargetDictionary[t] = e1;
                        }
                    }
                }
            }
        }
        function sm(e1, t, n, i, r, a, s) {
            const o = nm.distanceSqToPoint(e1);
            if (o < n) {
                const n = new Cl;
                nm.closestPointToPoint(e1, n), n.applyMatrix4(i);
                const l = r.ray.origin.distanceTo(n);
                if (l < r.near || l > r.far) return;
                a.push({
                    distance: l,
                    distanceToRay: Math.sqrt(o),
                    point: n,
                    index: t,
                    face: null,
                    object: s
                });
            }
        }
        class om extends xl {
            constructor(e1, t, n, i, r, a, s, o, l){
                super(e1, t, n, i, r, a, s, o, l), this.isVideoTexture = !0, this.minFilter = void 0 !== a ? a : va, this.magFilter = void 0 !== r ? r : va, this.generateMipmaps = !1;
                const c = this;
                "requestVideoFrameCallback" in e1 && e1.requestVideoFrameCallback(function t() {
                    c.needsUpdate = !0, e1.requestVideoFrameCallback(t);
                });
            }
            clone() {
                return new this.constructor(this.image).copy(this);
            }
            update() {
                const e1 = this.image;
                !1 == "requestVideoFrameCallback" in e1 && e1.readyState >= e1.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
            }
        }
        class lm extends xl {
            constructor(e1, t){
                super({
                    width: e1,
                    height: t
                }), this.isFramebufferTexture = !0, this.magFilter = pa, this.minFilter = pa, this.generateMipmaps = !1, this.needsUpdate = !0;
            }
        }
        class cm extends xl {
            constructor(e1, t, n, i, r, a, s, o, l, c, u, h){
                super(null, a, s, o, l, c, i, r, u, h), this.isCompressedTexture = !0, this.image = {
                    width: t,
                    height: n
                }, this.mipmaps = e1, this.flipY = !1, this.generateMipmaps = !1;
            }
        }
        class um extends cm {
            constructor(e1, t, n, i, r, a){
                super(e1, t, n, r, a), this.isCompressedArrayTexture = !0, this.image.depth = i, this.wrapR = ha;
            }
        }
        class hm extends cm {
            constructor(e1, t, n){
                super(void 0, e1[0].width, e1[0].height, t, n, aa), this.isCompressedCubeTexture = !0, this.isCubeTexture = !0, this.image = e1;
            }
        }
        class dm extends xl {
            constructor(e1, t, n, i, r, a, s, o, l){
                super(e1, t, n, i, r, a, s, o, l), this.isCanvasTexture = !0, this.needsUpdate = !0;
            }
        }
        class pm {
            constructor(){
                this.type = "Curve", this.arcLengthDivisions = 200;
            }
            getPoint() {
                return console.warn("THREE.Curve: .getPoint() not implemented."), null;
            }
            getPointAt(e1, t) {
                const n = this.getUtoTmapping(e1);
                return this.getPoint(n, t);
            }
            getPoints() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 5;
                const t = [];
                for(let n = 0; n <= e1; n++)t.push(this.getPoint(n / e1));
                return t;
            }
            getSpacedPoints() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 5;
                const t = [];
                for(let n = 0; n <= e1; n++)t.push(this.getPointAt(n / e1));
                return t;
            }
            getLength() {
                const e1 = this.getLengths();
                return e1[e1.length - 1];
            }
            getLengths() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.arcLengthDivisions;
                if (this.cacheArcLengths && this.cacheArcLengths.length === e1 + 1 && !this.needsUpdate) return this.cacheArcLengths;
                this.needsUpdate = !1;
                const t = [];
                let n, i = this.getPoint(0), r = 0;
                t.push(0);
                for(let a = 1; a <= e1; a++)n = this.getPoint(a / e1), r += n.distanceTo(i), t.push(r), i = n;
                return this.cacheArcLengths = t, t;
            }
            updateArcLengths() {
                this.needsUpdate = !0, this.getLengths();
            }
            getUtoTmapping(e1, t) {
                const n = this.getLengths();
                let i = 0;
                const r = n.length;
                let a;
                a = t || e1 * n[r - 1];
                let s, o = 0, l = r - 1;
                for(; o <= l;)if (i = Math.floor(o + (l - o) / 2), s = n[i] - a, s < 0) o = i + 1;
                else {
                    if (!(s > 0)) {
                        l = i;
                        break;
                    }
                    l = i - 1;
                }
                if (i = l, n[i] === a) return i / (r - 1);
                const c = n[i];
                return (i + (a - c) / (n[i + 1] - c)) / (r - 1);
            }
            getTangent(e1, t) {
                const n = 1e-4;
                let i = e1 - n, r = e1 + n;
                i < 0 && (i = 0), r > 1 && (r = 1);
                const a = this.getPoint(i), s = this.getPoint(r), o = t || (a.isVector2 ? new Jo : new Cl);
                return o.copy(s).sub(a).normalize(), o;
            }
            getTangentAt(e1, t) {
                const n = this.getUtoTmapping(e1);
                return this.getTangent(n, t);
            }
            computeFrenetFrames(e1, t) {
                const n = new Cl, i = [], r = [], a = [], s = new Cl, o = new oc;
                for(let t = 0; t <= e1; t++){
                    const n = t / e1;
                    i[t] = this.getTangentAt(n, new Cl);
                }
                r[0] = new Cl, a[0] = new Cl;
                let l = Number.MAX_VALUE;
                const c = Math.abs(i[0].x), u = Math.abs(i[0].y), h = Math.abs(i[0].z);
                c <= l && (l = c, n.set(1, 0, 0)), u <= l && (l = u, n.set(0, 1, 0)), h <= l && n.set(0, 0, 1), s.crossVectors(i[0], n).normalize(), r[0].crossVectors(i[0], s), a[0].crossVectors(i[0], r[0]);
                for(let t = 1; t <= e1; t++){
                    if (r[t] = r[t - 1].clone(), a[t] = a[t - 1].clone(), s.crossVectors(i[t - 1], i[t]), s.length() > Number.EPSILON) {
                        s.normalize();
                        const e1 = Math.acos(Vo(i[t - 1].dot(i[t]), -1, 1));
                        r[t].applyMatrix4(o.makeRotationAxis(s, e1));
                    }
                    a[t].crossVectors(i[t], r[t]);
                }
                if (!0 === t) {
                    let t = Math.acos(Vo(r[0].dot(r[e1]), -1, 1));
                    t /= e1, i[0].dot(s.crossVectors(r[0], r[e1])) > 0 && (t = -t);
                    for(let n = 1; n <= e1; n++)r[n].applyMatrix4(o.makeRotationAxis(i[n], t * n)), a[n].crossVectors(i[n], r[n]);
                }
                return {
                    tangents: i,
                    normals: r,
                    binormals: a
                };
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                return this.arcLengthDivisions = e1.arcLengthDivisions, this;
            }
            toJSON() {
                const e1 = {
                    metadata: {
                        version: 4.6,
                        type: "Curve",
                        generator: "Curve.toJSON"
                    }
                };
                return e1.arcLengthDivisions = this.arcLengthDivisions, e1.type = this.type, e1;
            }
            fromJSON(e1) {
                return this.arcLengthDivisions = e1.arcLengthDivisions, this;
            }
        }
        class fm extends pm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 2 * Math.PI, s = arguments.length > 6 && void 0 !== arguments[6] && arguments[6], o = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 0;
                super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = e1, this.aY = t, this.xRadius = n, this.yRadius = i, this.aStartAngle = r, this.aEndAngle = a, this.aClockwise = s, this.aRotation = o;
            }
            getPoint(e1, t) {
                const n = t || new Jo, i = 2 * Math.PI;
                let r = this.aEndAngle - this.aStartAngle;
                const a = Math.abs(r) < Number.EPSILON;
                for(; r < 0;)r += i;
                for(; r > i;)r -= i;
                r < Number.EPSILON && (r = a ? 0 : i), !0 !== this.aClockwise || a || (r === i ? r = -i : r -= i);
                const s = this.aStartAngle + e1 * r;
                let o = this.aX + this.xRadius * Math.cos(s), l = this.aY + this.yRadius * Math.sin(s);
                if (0 !== this.aRotation) {
                    const e1 = Math.cos(this.aRotation), t = Math.sin(this.aRotation), n = o - this.aX, i = l - this.aY;
                    o = n * e1 - i * t + this.aX, l = n * t + i * e1 + this.aY;
                }
                return n.set(o, l);
            }
            copy(e1) {
                return super.copy(e1), this.aX = e1.aX, this.aY = e1.aY, this.xRadius = e1.xRadius, this.yRadius = e1.yRadius, this.aStartAngle = e1.aStartAngle, this.aEndAngle = e1.aEndAngle, this.aClockwise = e1.aClockwise, this.aRotation = e1.aRotation, this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.aX = this.aX, e1.aY = this.aY, e1.xRadius = this.xRadius, e1.yRadius = this.yRadius, e1.aStartAngle = this.aStartAngle, e1.aEndAngle = this.aEndAngle, e1.aClockwise = this.aClockwise, e1.aRotation = this.aRotation, e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.aX = e1.aX, this.aY = e1.aY, this.xRadius = e1.xRadius, this.yRadius = e1.yRadius, this.aStartAngle = e1.aStartAngle, this.aEndAngle = e1.aEndAngle, this.aClockwise = e1.aClockwise, this.aRotation = e1.aRotation, this;
            }
        }
        class mm extends fm {
            constructor(e1, t, n, i, r, a){
                super(e1, t, n, n, i, r, a), this.isArcCurve = !0, this.type = "ArcCurve";
            }
        }
        function gm() {
            let e1 = 0, t = 0, n = 0, i = 0;
            function r(r, a, s, o) {
                e1 = r, t = s, n = -3 * r + 3 * a - 2 * s - o, i = 2 * r - 2 * a + s + o;
            }
            return {
                initCatmullRom: function(e1, t, n, i, a) {
                    r(t, n, a * (n - e1), a * (i - t));
                },
                initNonuniformCatmullRom: function(e1, t, n, i, a, s, o) {
                    let l = (t - e1) / a - (n - e1) / (a + s) + (n - t) / s, c = (n - t) / s - (i - t) / (s + o) + (i - n) / o;
                    l *= s, c *= s, r(t, n, l, c);
                },
                calc: function(r) {
                    const a = r * r;
                    return e1 + t * r + n * a + i * (a * r);
                }
            };
        }
        const Am = new Cl, vm = new gm, Mm = new gm, ym = new gm;
        class xm extends pm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "centripetal", i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : .5;
                super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = e1, this.closed = t, this.curveType = n, this.tension = i;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl, n = this.points, i = n.length, r = (i - (this.closed ? 0 : 1)) * e1;
                let a, s, o = Math.floor(r), l = r - o;
                this.closed ? o += o > 0 ? 0 : (Math.floor(Math.abs(o) / i) + 1) * i : 0 === l && o === i - 1 && (o = i - 2, l = 1), this.closed || o > 0 ? a = n[(o - 1) % i] : (Am.subVectors(n[0], n[1]).add(n[0]), a = Am);
                const c = n[o % i], u = n[(o + 1) % i];
                if (this.closed || o + 2 < i ? s = n[(o + 2) % i] : (Am.subVectors(n[i - 1], n[i - 2]).add(n[i - 1]), s = Am), "centripetal" === this.curveType || "chordal" === this.curveType) {
                    const e1 = "chordal" === this.curveType ? .5 : .25;
                    let t = Math.pow(a.distanceToSquared(c), e1), n = Math.pow(c.distanceToSquared(u), e1), i = Math.pow(u.distanceToSquared(s), e1);
                    n < 1e-4 && (n = 1), t < 1e-4 && (t = n), i < 1e-4 && (i = n), vm.initNonuniformCatmullRom(a.x, c.x, u.x, s.x, t, n, i), Mm.initNonuniformCatmullRom(a.y, c.y, u.y, s.y, t, n, i), ym.initNonuniformCatmullRom(a.z, c.z, u.z, s.z, t, n, i);
                } else "catmullrom" === this.curveType && (vm.initCatmullRom(a.x, c.x, u.x, s.x, this.tension), Mm.initCatmullRom(a.y, c.y, u.y, s.y, this.tension), ym.initCatmullRom(a.z, c.z, u.z, s.z, this.tension));
                return t.set(vm.calc(l), Mm.calc(l), ym.calc(l)), t;
            }
            copy(e1) {
                super.copy(e1), this.points = [];
                for(let t = 0, n = e1.points.length; t < n; t++){
                    const n = e1.points[t];
                    this.points.push(n.clone());
                }
                return this.closed = e1.closed, this.curveType = e1.curveType, this.tension = e1.tension, this;
            }
            toJSON() {
                const e1 = super.toJSON();
                e1.points = [];
                for(let t = 0, n = this.points.length; t < n; t++){
                    const n = this.points[t];
                    e1.points.push(n.toArray());
                }
                return e1.closed = this.closed, e1.curveType = this.curveType, e1.tension = this.tension, e1;
            }
            fromJSON(e1) {
                super.fromJSON(e1), this.points = [];
                for(let t = 0, n = e1.points.length; t < n; t++){
                    const n = e1.points[t];
                    this.points.push((new Cl).fromArray(n));
                }
                return this.closed = e1.closed, this.curveType = e1.curveType, this.tension = e1.tension, this;
            }
        }
        function _m(e1, t, n, i, r) {
            const a = .5 * (i - t), s = .5 * (r - n), o = e1 * e1;
            return (2 * n - 2 * i + a + s) * (e1 * o) + (-3 * n + 3 * i - 2 * a - s) * o + a * e1 + n;
        }
        function bm(e1, t, n, i) {
            return function(e1, t) {
                const n = 1 - e1;
                return n * n * t;
            }(e1, t) + function(e1, t) {
                return 2 * (1 - e1) * e1 * t;
            }(e1, n) + function(e1, t) {
                return e1 * e1 * t;
            }(e1, i);
        }
        function wm(e1, t, n, i, r) {
            return function(e1, t) {
                const n = 1 - e1;
                return n * n * n * t;
            }(e1, t) + function(e1, t) {
                const n = 1 - e1;
                return 3 * n * n * e1 * t;
            }(e1, n) + function(e1, t) {
                return 3 * (1 - e1) * e1 * e1 * t;
            }(e1, i) + function(e1, t) {
                return e1 * e1 * e1 * t;
            }(e1, r);
        }
        class Em extends pm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Jo, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Jo, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Jo, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : new Jo;
                super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = e1, this.v1 = t, this.v2 = n, this.v3 = i;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Jo, n = this.v0, i = this.v1, r = this.v2, a = this.v3;
                return t.set(wm(e1, n.x, i.x, r.x, a.x), wm(e1, n.y, i.y, r.y, a.y)), t;
            }
            copy(e1) {
                return super.copy(e1), this.v0.copy(e1.v0), this.v1.copy(e1.v1), this.v2.copy(e1.v2), this.v3.copy(e1.v3), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.v0 = this.v0.toArray(), e1.v1 = this.v1.toArray(), e1.v2 = this.v2.toArray(), e1.v3 = this.v3.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.v0.fromArray(e1.v0), this.v1.fromArray(e1.v1), this.v2.fromArray(e1.v2), this.v3.fromArray(e1.v3), this;
            }
        }
        class Tm extends pm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Cl, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Cl, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : new Cl;
                super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = e1, this.v1 = t, this.v2 = n, this.v3 = i;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl, n = this.v0, i = this.v1, r = this.v2, a = this.v3;
                return t.set(wm(e1, n.x, i.x, r.x, a.x), wm(e1, n.y, i.y, r.y, a.y), wm(e1, n.z, i.z, r.z, a.z)), t;
            }
            copy(e1) {
                return super.copy(e1), this.v0.copy(e1.v0), this.v1.copy(e1.v1), this.v2.copy(e1.v2), this.v3.copy(e1.v3), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.v0 = this.v0.toArray(), e1.v1 = this.v1.toArray(), e1.v2 = this.v2.toArray(), e1.v3 = this.v3.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.v0.fromArray(e1.v0), this.v1.fromArray(e1.v1), this.v2.fromArray(e1.v2), this.v3.fromArray(e1.v3), this;
            }
        }
        class Sm extends pm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Jo, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Jo;
                super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = e1, this.v2 = t;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Jo;
                return 1 === e1 ? t.copy(this.v2) : (t.copy(this.v2).sub(this.v1), t.multiplyScalar(e1).add(this.v1)), t;
            }
            getPointAt(e1, t) {
                return this.getPoint(e1, t);
            }
            getTangent(e1) {
                return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Jo).subVectors(this.v2, this.v1).normalize();
            }
            getTangentAt(e1, t) {
                return this.getTangent(e1, t);
            }
            copy(e1) {
                return super.copy(e1), this.v1.copy(e1.v1), this.v2.copy(e1.v2), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.v1 = this.v1.toArray(), e1.v2 = this.v2.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.v1.fromArray(e1.v1), this.v2.fromArray(e1.v2), this;
            }
        }
        class Im extends pm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Cl, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl;
                super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = e1, this.v2 = t;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl;
                return 1 === e1 ? t.copy(this.v2) : (t.copy(this.v2).sub(this.v1), t.multiplyScalar(e1).add(this.v1)), t;
            }
            getPointAt(e1, t) {
                return this.getPoint(e1, t);
            }
            getTangent(e1) {
                return (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl).subVectors(this.v2, this.v1).normalize();
            }
            getTangentAt(e1, t) {
                return this.getTangent(e1, t);
            }
            copy(e1) {
                return super.copy(e1), this.v1.copy(e1.v1), this.v2.copy(e1.v2), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.v1 = this.v1.toArray(), e1.v2 = this.v2.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.v1.fromArray(e1.v1), this.v2.fromArray(e1.v2), this;
            }
        }
        class Nm extends pm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Jo, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Jo, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Jo;
                super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = e1, this.v1 = t, this.v2 = n;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Jo, n = this.v0, i = this.v1, r = this.v2;
                return t.set(bm(e1, n.x, i.x, r.x), bm(e1, n.y, i.y, r.y)), t;
            }
            copy(e1) {
                return super.copy(e1), this.v0.copy(e1.v0), this.v1.copy(e1.v1), this.v2.copy(e1.v2), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.v0 = this.v0.toArray(), e1.v1 = this.v1.toArray(), e1.v2 = this.v2.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.v0.fromArray(e1.v0), this.v1.fromArray(e1.v1), this.v2.fromArray(e1.v2), this;
            }
        }
        class Dm extends pm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Cl, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : new Cl;
                super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = e1, this.v1 = t, this.v2 = n;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl, n = this.v0, i = this.v1, r = this.v2;
                return t.set(bm(e1, n.x, i.x, r.x), bm(e1, n.y, i.y, r.y), bm(e1, n.z, i.z, r.z)), t;
            }
            copy(e1) {
                return super.copy(e1), this.v0.copy(e1.v0), this.v1.copy(e1.v1), this.v2.copy(e1.v2), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.v0 = this.v0.toArray(), e1.v1 = this.v1.toArray(), e1.v2 = this.v2.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.v0.fromArray(e1.v0), this.v1.fromArray(e1.v1), this.v2.fromArray(e1.v2), this;
            }
        }
        class Cm extends pm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = e1;
            }
            getPoint(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Jo, n = this.points, i = (n.length - 1) * e1, r = Math.floor(i), a = i - r, s = n[0 === r ? r : r - 1], o = n[r], l = n[r > n.length - 2 ? n.length - 1 : r + 1], c = n[r > n.length - 3 ? n.length - 1 : r + 2];
                return t.set(_m(a, s.x, o.x, l.x, c.x), _m(a, s.y, o.y, l.y, c.y)), t;
            }
            copy(e1) {
                super.copy(e1), this.points = [];
                for(let t = 0, n = e1.points.length; t < n; t++){
                    const n = e1.points[t];
                    this.points.push(n.clone());
                }
                return this;
            }
            toJSON() {
                const e1 = super.toJSON();
                e1.points = [];
                for(let t = 0, n = this.points.length; t < n; t++){
                    const n = this.points[t];
                    e1.points.push(n.toArray());
                }
                return e1;
            }
            fromJSON(e1) {
                super.fromJSON(e1), this.points = [];
                for(let t = 0, n = e1.points.length; t < n; t++){
                    const n = e1.points[t];
                    this.points.push((new Jo).fromArray(n));
                }
                return this;
            }
        }
        var Lm = Object.freeze({
            __proto__: null,
            ArcCurve: mm,
            CatmullRomCurve3: xm,
            CubicBezierCurve: Em,
            CubicBezierCurve3: Tm,
            EllipseCurve: fm,
            LineCurve: Sm,
            LineCurve3: Im,
            QuadraticBezierCurve: Nm,
            QuadraticBezierCurve3: Dm,
            SplineCurve: Cm
        });
        class Rm extends pm {
            constructor(){
                super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
            }
            add(e1) {
                this.curves.push(e1);
            }
            closePath() {
                const e1 = this.curves[0].getPoint(0), t = this.curves[this.curves.length - 1].getPoint(1);
                if (!e1.equals(t)) {
                    const n = !0 === e1.isVector2 ? "LineCurve" : "LineCurve3";
                    this.curves.push(new Lm[n](t, e1));
                }
                return this;
            }
            getPoint(e1, t) {
                const n = e1 * this.getLength(), i = this.getCurveLengths();
                let r = 0;
                for(; r < i.length;){
                    if (i[r] >= n) {
                        const e1 = i[r] - n, a = this.curves[r], s = a.getLength(), o = 0 === s ? 0 : 1 - e1 / s;
                        return a.getPointAt(o, t);
                    }
                    r++;
                }
                return null;
            }
            getLength() {
                const e1 = this.getCurveLengths();
                return e1[e1.length - 1];
            }
            updateArcLengths() {
                this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
            }
            getCurveLengths() {
                if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
                const e1 = [];
                let t = 0;
                for(let n = 0, i = this.curves.length; n < i; n++)t += this.curves[n].getLength(), e1.push(t);
                return this.cacheLengths = e1, e1;
            }
            getSpacedPoints() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 40;
                const t = [];
                for(let n = 0; n <= e1; n++)t.push(this.getPoint(n / e1));
                return this.autoClose && t.push(t[0]), t;
            }
            getPoints() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 12;
                const t = [];
                let n;
                for(let i = 0, r = this.curves; i < r.length; i++){
                    const a = r[i], s = a.isEllipseCurve ? 2 * e1 : a.isLineCurve || a.isLineCurve3 ? 1 : a.isSplineCurve ? e1 * a.points.length : e1, o = a.getPoints(s);
                    for(let e1 = 0; e1 < o.length; e1++){
                        const i = o[e1];
                        n && n.equals(i) || (t.push(i), n = i);
                    }
                }
                return this.autoClose && t.length > 1 && !t[t.length - 1].equals(t[0]) && t.push(t[0]), t;
            }
            copy(e1) {
                super.copy(e1), this.curves = [];
                for(let t = 0, n = e1.curves.length; t < n; t++){
                    const n = e1.curves[t];
                    this.curves.push(n.clone());
                }
                return this.autoClose = e1.autoClose, this;
            }
            toJSON() {
                const e1 = super.toJSON();
                e1.autoClose = this.autoClose, e1.curves = [];
                for(let t = 0, n = this.curves.length; t < n; t++){
                    const n = this.curves[t];
                    e1.curves.push(n.toJSON());
                }
                return e1;
            }
            fromJSON(e1) {
                super.fromJSON(e1), this.autoClose = e1.autoClose, this.curves = [];
                for(let t = 0, n = e1.curves.length; t < n; t++){
                    const n = e1.curves[t];
                    this.curves.push((new Lm[n.type]).fromJSON(n));
                }
                return this;
            }
        }
        class zm extends Rm {
            constructor(e1){
                super(), this.type = "Path", this.currentPoint = new Jo, e1 && this.setFromPoints(e1);
            }
            setFromPoints(e1) {
                this.moveTo(e1[0].x, e1[0].y);
                for(let t = 1, n = e1.length; t < n; t++)this.lineTo(e1[t].x, e1[t].y);
                return this;
            }
            moveTo(e1, t) {
                return this.currentPoint.set(e1, t), this;
            }
            lineTo(e1, t) {
                const n = new Sm(this.currentPoint.clone(), new Jo(e1, t));
                return this.curves.push(n), this.currentPoint.set(e1, t), this;
            }
            quadraticCurveTo(e1, t, n, i) {
                const r = new Nm(this.currentPoint.clone(), new Jo(e1, t), new Jo(n, i));
                return this.curves.push(r), this.currentPoint.set(n, i), this;
            }
            bezierCurveTo(e1, t, n, i, r, a) {
                const s = new Em(this.currentPoint.clone(), new Jo(e1, t), new Jo(n, i), new Jo(r, a));
                return this.curves.push(s), this.currentPoint.set(r, a), this;
            }
            splineThru(e1) {
                const t = [
                    this.currentPoint.clone()
                ].concat(e1), n = new Cm(t);
                return this.curves.push(n), this.currentPoint.copy(e1[e1.length - 1]), this;
            }
            arc(e1, t, n, i, r, a) {
                const s = this.currentPoint.x, o = this.currentPoint.y;
                return this.absarc(e1 + s, t + o, n, i, r, a), this;
            }
            absarc(e1, t, n, i, r, a) {
                return this.absellipse(e1, t, n, n, i, r, a), this;
            }
            ellipse(e1, t, n, i, r, a, s, o) {
                const l = this.currentPoint.x, c = this.currentPoint.y;
                return this.absellipse(e1 + l, t + c, n, i, r, a, s, o), this;
            }
            absellipse(e1, t, n, i, r, a, s, o) {
                const l = new fm(e1, t, n, i, r, a, s, o);
                if (this.curves.length > 0) {
                    const e1 = l.getPoint(0);
                    e1.equals(this.currentPoint) || this.lineTo(e1.x, e1.y);
                }
                this.curves.push(l);
                const c = l.getPoint(1);
                return this.currentPoint.copy(c), this;
            }
            copy(e1) {
                return super.copy(e1), this.currentPoint.copy(e1.currentPoint), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.currentPoint = this.currentPoint.toArray(), e1;
            }
            fromJSON(e1) {
                return super.fromJSON(e1), this.currentPoint.fromArray(e1.currentPoint), this;
            }
        }
        class Om extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [
                    new Jo(0, -0.5),
                    new Jo(.5, 0),
                    new Jo(0, .5)
                ], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 12, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 2 * Math.PI;
                super(), this.type = "LatheGeometry", this.parameters = {
                    points: e1,
                    segments: t,
                    phiStart: n,
                    phiLength: i
                }, t = Math.floor(t), i = Vo(i, 0, 2 * Math.PI);
                const r = [], a = [], s = [], o = [], l = [], c = 1 / t, u = new Cl, h = new Jo, d = new Cl, p = new Cl, f = new Cl;
                let m = 0, g = 0;
                for(let t = 0; t <= e1.length - 1; t++)switch(t){
                    case 0:
                        m = e1[t + 1].x - e1[t].x, g = e1[t + 1].y - e1[t].y, d.x = 1 * g, d.y = -m, d.z = 0 * g, f.copy(d), d.normalize(), o.push(d.x, d.y, d.z);
                        break;
                    case e1.length - 1:
                        o.push(f.x, f.y, f.z);
                        break;
                    default:
                        m = e1[t + 1].x - e1[t].x, g = e1[t + 1].y - e1[t].y, d.x = 1 * g, d.y = -m, d.z = 0 * g, p.copy(d), d.x += f.x, d.y += f.y, d.z += f.z, d.normalize(), o.push(d.x, d.y, d.z), f.copy(p);
                }
                for(let r = 0; r <= t; r++){
                    const d = n + r * c * i, p = Math.sin(d), f = Math.cos(d);
                    for(let n = 0; n <= e1.length - 1; n++){
                        u.x = e1[n].x * p, u.y = e1[n].y, u.z = e1[n].x * f, a.push(u.x, u.y, u.z), h.x = r / t, h.y = n / (e1.length - 1), s.push(h.x, h.y);
                        const i = o[3 * n + 0] * p, c = o[3 * n + 1], d = o[3 * n + 0] * f;
                        l.push(i, c, d);
                    }
                }
                for(let n = 0; n < t; n++)for(let t = 0; t < e1.length - 1; t++){
                    const i = t + n * e1.length, a = i, s = i + e1.length, o = i + e1.length + 1, l = i + 1;
                    r.push(a, s, l), r.push(o, l, s);
                }
                this.setIndex(r), this.setAttribute("position", new gu(a, 3)), this.setAttribute("uv", new gu(s, 2)), this.setAttribute("normal", new gu(l, 3));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Om(e1.points, e1.segments, e1.phiStart, e1.phiLength);
            }
        }
        class Pm extends Om {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 4, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 8;
                const r = new zm;
                r.absarc(0, -t / 2, e1, 1.5 * Math.PI, 0), r.absarc(0, t / 2, e1, 0, .5 * Math.PI), super(r.getPoints(n), i), this.type = "CapsuleGeometry", this.parameters = {
                    radius: e1,
                    length: t,
                    capSegments: n,
                    radialSegments: i
                };
            }
            static fromJSON(e1) {
                return new Pm(e1.radius, e1.length, e1.capSegments, e1.radialSegments);
            }
        }
        class Um extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 32, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 2 * Math.PI;
                super(), this.type = "CircleGeometry", this.parameters = {
                    radius: e1,
                    segments: t,
                    thetaStart: n,
                    thetaLength: i
                }, t = Math.max(3, t);
                const r = [], a = [], s = [], o = [], l = new Cl, c = new Jo;
                a.push(0, 0, 0), s.push(0, 0, 1), o.push(.5, .5);
                for(let r = 0, u = 3; r <= t; r++, u += 3){
                    const h = n + r / t * i;
                    l.x = e1 * Math.cos(h), l.y = e1 * Math.sin(h), a.push(l.x, l.y, l.z), s.push(0, 0, 1), c.x = (a[u] / e1 + 1) / 2, c.y = (a[u + 1] / e1 + 1) / 2, o.push(c.x, c.y);
                }
                for(let e1 = 1; e1 <= t; e1++)r.push(e1, e1 + 1, 0);
                this.setIndex(r), this.setAttribute("position", new gu(a, 3)), this.setAttribute("normal", new gu(s, 3)), this.setAttribute("uv", new gu(o, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Um(e1.radius, e1.segments, e1.thetaStart, e1.thetaLength);
            }
        }
        class km extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 32, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1, a = arguments.length > 5 && void 0 !== arguments[5] && arguments[5], s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 0, o = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 2 * Math.PI;
                super(), this.type = "CylinderGeometry", this.parameters = {
                    radiusTop: e1,
                    radiusBottom: t,
                    height: n,
                    radialSegments: i,
                    heightSegments: r,
                    openEnded: a,
                    thetaStart: s,
                    thetaLength: o
                };
                const l = this;
                i = Math.floor(i), r = Math.floor(r);
                const c = [], u = [], h = [], d = [];
                let p = 0;
                const f = [], m = n / 2;
                let g = 0;
                function A(n) {
                    const r = p, a = new Jo, f = new Cl;
                    let A = 0;
                    const v = !0 === n ? e1 : t, M = !0 === n ? 1 : -1;
                    for(let e1 = 1; e1 <= i; e1++)u.push(0, m * M, 0), h.push(0, M, 0), d.push(.5, .5), p++;
                    const y = p;
                    for(let e1 = 0; e1 <= i; e1++){
                        const t = e1 / i * o + s, n = Math.cos(t), r = Math.sin(t);
                        f.x = v * r, f.y = m * M, f.z = v * n, u.push(f.x, f.y, f.z), h.push(0, M, 0), a.x = .5 * n + .5, a.y = .5 * r * M + .5, d.push(a.x, a.y), p++;
                    }
                    for(let e1 = 0; e1 < i; e1++){
                        const t = r + e1, i = y + e1;
                        !0 === n ? c.push(i, i + 1, t) : c.push(i + 1, i, t), A += 3;
                    }
                    l.addGroup(g, A, !0 === n ? 1 : 2), g += A;
                }
                !function() {
                    const a = new Cl, A = new Cl;
                    let v = 0;
                    const M = (t - e1) / n;
                    for(let l = 0; l <= r; l++){
                        const c = [], g = l / r, v = g * (t - e1) + e1;
                        for(let e1 = 0; e1 <= i; e1++){
                            const t = e1 / i, r = t * o + s, l = Math.sin(r), f = Math.cos(r);
                            A.x = v * l, A.y = -g * n + m, A.z = v * f, u.push(A.x, A.y, A.z), a.set(l, M, f).normalize(), h.push(a.x, a.y, a.z), d.push(t, 1 - g), c.push(p++);
                        }
                        f.push(c);
                    }
                    for(let e1 = 0; e1 < i; e1++)for(let t = 0; t < r; t++){
                        const n = f[t][e1], i = f[t + 1][e1], r = f[t + 1][e1 + 1], a = f[t][e1 + 1];
                        c.push(n, i, a), c.push(i, r, a), v += 6;
                    }
                    l.addGroup(g, v, 0), g += v;
                }(), !1 === a && (e1 > 0 && A(!0), t > 0 && A(!1)), this.setIndex(c), this.setAttribute("position", new gu(u, 3)), this.setAttribute("normal", new gu(h, 3)), this.setAttribute("uv", new gu(d, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new km(e1.radiusTop, e1.radiusBottom, e1.height, e1.radialSegments, e1.heightSegments, e1.openEnded, e1.thetaStart, e1.thetaLength);
            }
        }
        class jm extends km {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 32, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0, s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 2 * Math.PI;
                super(0, e1, t, n, i, r, a, s), this.type = "ConeGeometry", this.parameters = {
                    radius: e1,
                    height: t,
                    radialSegments: n,
                    heightSegments: i,
                    openEnded: r,
                    thetaStart: a,
                    thetaLength: s
                };
            }
            static fromJSON(e1) {
                return new jm(e1.radius, e1.height, e1.radialSegments, e1.heightSegments, e1.openEnded, e1.thetaStart, e1.thetaLength);
            }
        }
        class Bm extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0;
                super(), this.type = "PolyhedronGeometry", this.parameters = {
                    vertices: e1,
                    indices: t,
                    radius: n,
                    detail: i
                };
                const r = [], a = [];
                function s(e1, t, n, i) {
                    const r = i + 1, a = [];
                    for(let i = 0; i <= r; i++){
                        a[i] = [];
                        const s = e1.clone().lerp(n, i / r), o = t.clone().lerp(n, i / r), l = r - i;
                        for(let e1 = 0; e1 <= l; e1++)a[i][e1] = 0 === e1 && i === r ? s : s.clone().lerp(o, e1 / l);
                    }
                    for(let e1 = 0; e1 < r; e1++)for(let t = 0; t < 2 * (r - e1) - 1; t++){
                        const n = Math.floor(t / 2);
                        t % 2 == 0 ? (o(a[e1][n + 1]), o(a[e1 + 1][n]), o(a[e1][n])) : (o(a[e1][n + 1]), o(a[e1 + 1][n + 1]), o(a[e1 + 1][n]));
                    }
                }
                function o(e1) {
                    r.push(e1.x, e1.y, e1.z);
                }
                function l(t, n) {
                    const i = 3 * t;
                    n.x = e1[i + 0], n.y = e1[i + 1], n.z = e1[i + 2];
                }
                function c(e1, t, n, i) {
                    i < 0 && 1 === e1.x && (a[t] = e1.x - 1), 0 === n.x && 0 === n.z && (a[t] = i / 2 / Math.PI + .5);
                }
                function u(e1) {
                    return Math.atan2(e1.z, -e1.x);
                }
                !function(e1) {
                    const n = new Cl, i = new Cl, r = new Cl;
                    for(let a = 0; a < t.length; a += 3)l(t[a + 0], n), l(t[a + 1], i), l(t[a + 2], r), s(n, i, r, e1);
                }(i), function(e1) {
                    const t = new Cl;
                    for(let n = 0; n < r.length; n += 3)t.x = r[n + 0], t.y = r[n + 1], t.z = r[n + 2], t.normalize().multiplyScalar(e1), r[n + 0] = t.x, r[n + 1] = t.y, r[n + 2] = t.z;
                }(n), function() {
                    const e1 = new Cl;
                    for(let n = 0; n < r.length; n += 3){
                        e1.x = r[n + 0], e1.y = r[n + 1], e1.z = r[n + 2];
                        const i = u(e1) / 2 / Math.PI + .5, s = (t = e1, Math.atan2(-t.y, Math.sqrt(t.x * t.x + t.z * t.z)) / Math.PI + .5);
                        a.push(i, 1 - s);
                    }
                    var t;
                    (function() {
                        const e1 = new Cl, t = new Cl, n = new Cl, i = new Cl, s = new Jo, o = new Jo, l = new Jo;
                        for(let h = 0, d = 0; h < r.length; h += 9, d += 6){
                            e1.set(r[h + 0], r[h + 1], r[h + 2]), t.set(r[h + 3], r[h + 4], r[h + 5]), n.set(r[h + 6], r[h + 7], r[h + 8]), s.set(a[d + 0], a[d + 1]), o.set(a[d + 2], a[d + 3]), l.set(a[d + 4], a[d + 5]), i.copy(e1).add(t).add(n).divideScalar(3);
                            const p = u(i);
                            c(s, d + 0, e1, p), c(o, d + 2, t, p), c(l, d + 4, n, p);
                        }
                    })(), function() {
                        for(let e1 = 0; e1 < a.length; e1 += 6){
                            const t = a[e1 + 0], n = a[e1 + 2], i = a[e1 + 4], r = Math.max(t, n, i), s = Math.min(t, n, i);
                            r > .9 && s < .1 && (t < .2 && (a[e1 + 0] += 1), n < .2 && (a[e1 + 2] += 1), i < .2 && (a[e1 + 4] += 1));
                        }
                    }();
                }(), this.setAttribute("position", new gu(r, 3)), this.setAttribute("normal", new gu(r.slice(), 3)), this.setAttribute("uv", new gu(a, 2)), 0 === i ? this.computeVertexNormals() : this.normalizeNormals();
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Bm(e1.vertices, e1.indices, e1.radius, e1.details);
            }
        }
        class Fm extends Bm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = (1 + Math.sqrt(5)) / 2, i = 1 / n;
                super([
                    -1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    0,
                    -i,
                    -n,
                    0,
                    -i,
                    n,
                    0,
                    i,
                    -n,
                    0,
                    i,
                    n,
                    -i,
                    -n,
                    0,
                    -i,
                    n,
                    0,
                    i,
                    -n,
                    0,
                    i,
                    n,
                    0,
                    -n,
                    0,
                    -i,
                    n,
                    0,
                    -i,
                    -n,
                    0,
                    i,
                    n,
                    0,
                    i
                ], [
                    3,
                    11,
                    7,
                    3,
                    7,
                    15,
                    3,
                    15,
                    13,
                    7,
                    19,
                    17,
                    7,
                    17,
                    6,
                    7,
                    6,
                    15,
                    17,
                    4,
                    8,
                    17,
                    8,
                    10,
                    17,
                    10,
                    6,
                    8,
                    0,
                    16,
                    8,
                    16,
                    2,
                    8,
                    2,
                    10,
                    0,
                    12,
                    1,
                    0,
                    1,
                    18,
                    0,
                    18,
                    16,
                    6,
                    10,
                    2,
                    6,
                    2,
                    13,
                    6,
                    13,
                    15,
                    2,
                    16,
                    18,
                    2,
                    18,
                    3,
                    2,
                    3,
                    13,
                    18,
                    1,
                    9,
                    18,
                    9,
                    11,
                    18,
                    11,
                    3,
                    4,
                    14,
                    12,
                    4,
                    12,
                    0,
                    4,
                    0,
                    8,
                    11,
                    9,
                    5,
                    11,
                    5,
                    19,
                    11,
                    19,
                    7,
                    19,
                    5,
                    14,
                    19,
                    14,
                    4,
                    19,
                    4,
                    17,
                    1,
                    12,
                    14,
                    1,
                    14,
                    5,
                    1,
                    5,
                    9
                ], e1, t), this.type = "DodecahedronGeometry", this.parameters = {
                    radius: e1,
                    detail: t
                };
            }
            static fromJSON(e1) {
                return new Fm(e1.radius, e1.detail);
            }
        }
        const Hm = new Cl, Vm = new Cl, Gm = new Cl, Qm = new Gc;
        class Wm extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                if (super(), this.type = "EdgesGeometry", this.parameters = {
                    geometry: e1,
                    thresholdAngle: t
                }, null !== e1) {
                    const n = 4, i = Math.pow(10, n), r = Math.cos(Bo * t), a = e1.getIndex(), s = e1.getAttribute("position"), o = a ? a.count : s.count, l = [
                        0,
                        0,
                        0
                    ], c = [
                        "a",
                        "b",
                        "c"
                    ], u = new Array(3), h = {}, d = [];
                    for(let e1 = 0; e1 < o; e1 += 3){
                        a ? (l[0] = a.getX(e1), l[1] = a.getX(e1 + 1), l[2] = a.getX(e1 + 2)) : (l[0] = e1, l[1] = e1 + 1, l[2] = e1 + 2);
                        const { a: t, b: n, c: o } = Qm;
                        if (t.fromBufferAttribute(s, l[0]), n.fromBufferAttribute(s, l[1]), o.fromBufferAttribute(s, l[2]), Qm.getNormal(Gm), u[0] = "".concat(Math.round(t.x * i), ",").concat(Math.round(t.y * i), ",").concat(Math.round(t.z * i)), u[1] = "".concat(Math.round(n.x * i), ",").concat(Math.round(n.y * i), ",").concat(Math.round(n.z * i)), u[2] = "".concat(Math.round(o.x * i), ",").concat(Math.round(o.y * i), ",").concat(Math.round(o.z * i)), u[0] !== u[1] && u[1] !== u[2] && u[2] !== u[0]) for(let e1 = 0; e1 < 3; e1++){
                            const t = (e1 + 1) % 3, n = u[e1], i = u[t], a = Qm[c[e1]], s = Qm[c[t]], o = "".concat(n, "_").concat(i), p = "".concat(i, "_").concat(n);
                            p in h && h[p] ? (Gm.dot(h[p].normal) <= r && (d.push(a.x, a.y, a.z), d.push(s.x, s.y, s.z)), h[p] = null) : o in h || (h[o] = {
                                index0: l[e1],
                                index1: l[t],
                                normal: Gm.clone()
                            });
                        }
                    }
                    for(const e1 in h)if (h[e1]) {
                        const { index0: t, index1: n } = h[e1];
                        Hm.fromBufferAttribute(s, t), Vm.fromBufferAttribute(s, n), d.push(Hm.x, Hm.y, Hm.z), d.push(Vm.x, Vm.y, Vm.z);
                    }
                    this.setAttribute("position", new gu(d, 3));
                }
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
        }
        class Ym extends zm {
            constructor(e1){
                super(e1), this.uuid = Ho(), this.type = "Shape", this.holes = [];
            }
            getPointsHoles(e1) {
                const t = [];
                for(let n = 0, i = this.holes.length; n < i; n++)t[n] = this.holes[n].getPoints(e1);
                return t;
            }
            extractPoints(e1) {
                return {
                    shape: this.getPoints(e1),
                    holes: this.getPointsHoles(e1)
                };
            }
            copy(e1) {
                super.copy(e1), this.holes = [];
                for(let t = 0, n = e1.holes.length; t < n; t++){
                    const n = e1.holes[t];
                    this.holes.push(n.clone());
                }
                return this;
            }
            toJSON() {
                const e1 = super.toJSON();
                e1.uuid = this.uuid, e1.holes = [];
                for(let t = 0, n = this.holes.length; t < n; t++){
                    const n = this.holes[t];
                    e1.holes.push(n.toJSON());
                }
                return e1;
            }
            fromJSON(e1) {
                super.fromJSON(e1), this.uuid = e1.uuid, this.holes = [];
                for(let t = 0, n = e1.holes.length; t < n; t++){
                    const n = e1.holes[t];
                    this.holes.push((new zm).fromJSON(n));
                }
                return this;
            }
        }
        function Xm(e1, t, n, i, r) {
            let a, s;
            if (r === function(e1, t, n, i) {
                let r = 0;
                for(let a = t, s = n - i; a < n; a += i)r += (e1[s] - e1[a]) * (e1[a + 1] + e1[s + 1]), s = a;
                return r;
            }(e1, t, n, i) > 0) for(a = t; a < n; a += i)s = mg(a, e1[a], e1[a + 1], s);
            else for(a = n - i; a >= t; a -= i)s = mg(a, e1[a], e1[a + 1], s);
            return s && cg(s, s.next) && (gg(s), s = s.next), s;
        }
        function Zm(e1, t) {
            if (!e1) return e1;
            t || (t = e1);
            let n, i = e1;
            do if (n = !1, i.steiner || !cg(i, i.next) && 0 !== lg(i.prev, i, i.next)) i = i.next;
            else {
                if (gg(i), i = t = i.prev, i === i.next) break;
                n = !0;
            }
            while (n || i !== t);
            return t;
        }
        function qm(e1, t, n, i, r, a, s) {
            if (!e1) return;
            !s && a && function(e1, t, n, i) {
                let r = e1;
                do 0 === r.z && (r.z = rg(r.x, r.y, t, n, i)), r.prevZ = r.prev, r.nextZ = r.next, r = r.next;
                while (r !== e1);
                r.prevZ.nextZ = null, r.prevZ = null, function(e1) {
                    let t, n, i, r, a, s, o, l, c = 1;
                    do {
                        for(n = e1, e1 = null, a = null, s = 0; n;){
                            for(s++, i = n, o = 0, t = 0; t < c && (o++, i = i.nextZ, i); t++);
                            for(l = c; o > 0 || l > 0 && i;)0 !== o && (0 === l || !i || n.z <= i.z) ? (r = n, n = n.nextZ, o--) : (r = i, i = i.nextZ, l--), a ? a.nextZ = r : e1 = r, r.prevZ = a, a = r;
                            n = i;
                        }
                        a.nextZ = null, c *= 2;
                    }while (s > 1);
                }(r);
            }(e1, i, r, a);
            let o, l, c = e1;
            for(; e1.prev !== e1.next;)if (o = e1.prev, l = e1.next, a ? Jm(e1, i, r, a) : Km(e1)) t.push(o.i / n | 0), t.push(e1.i / n | 0), t.push(l.i / n | 0), gg(e1), e1 = l.next, c = l.next;
            else if ((e1 = l) === c) {
                s ? 1 === s ? qm(e1 = $m(Zm(e1), t, n), t, n, i, r, a, 2) : 2 === s && eg(e1, t, n, i, r, a) : qm(Zm(e1), t, n, i, r, a, 1);
                break;
            }
        }
        function Km(e1) {
            const t = e1.prev, n = e1, i = e1.next;
            if (lg(t, n, i) >= 0) return !1;
            const r = t.x, a = n.x, s = i.x, o = t.y, l = n.y, c = i.y, u = r < a ? r < s ? r : s : a < s ? a : s, h = o < l ? o < c ? o : c : l < c ? l : c, d = r > a ? r > s ? r : s : a > s ? a : s, p = o > l ? o > c ? o : c : l > c ? l : c;
            let f = i.next;
            for(; f !== t;){
                if (f.x >= u && f.x <= d && f.y >= h && f.y <= p && sg(r, o, a, l, s, c, f.x, f.y) && lg(f.prev, f, f.next) >= 0) return !1;
                f = f.next;
            }
            return !0;
        }
        function Jm(e1, t, n, i) {
            const r = e1.prev, a = e1, s = e1.next;
            if (lg(r, a, s) >= 0) return !1;
            const o = r.x, l = a.x, c = s.x, u = r.y, h = a.y, d = s.y, p = o < l ? o < c ? o : c : l < c ? l : c, f = u < h ? u < d ? u : d : h < d ? h : d, m = o > l ? o > c ? o : c : l > c ? l : c, g = u > h ? u > d ? u : d : h > d ? h : d, A = rg(p, f, t, n, i), v = rg(m, g, t, n, i);
            let M = e1.prevZ, y = e1.nextZ;
            for(; M && M.z >= A && y && y.z <= v;){
                if (M.x >= p && M.x <= m && M.y >= f && M.y <= g && M !== r && M !== s && sg(o, u, l, h, c, d, M.x, M.y) && lg(M.prev, M, M.next) >= 0) return !1;
                if (M = M.prevZ, y.x >= p && y.x <= m && y.y >= f && y.y <= g && y !== r && y !== s && sg(o, u, l, h, c, d, y.x, y.y) && lg(y.prev, y, y.next) >= 0) return !1;
                y = y.nextZ;
            }
            for(; M && M.z >= A;){
                if (M.x >= p && M.x <= m && M.y >= f && M.y <= g && M !== r && M !== s && sg(o, u, l, h, c, d, M.x, M.y) && lg(M.prev, M, M.next) >= 0) return !1;
                M = M.prevZ;
            }
            for(; y && y.z <= v;){
                if (y.x >= p && y.x <= m && y.y >= f && y.y <= g && y !== r && y !== s && sg(o, u, l, h, c, d, y.x, y.y) && lg(y.prev, y, y.next) >= 0) return !1;
                y = y.nextZ;
            }
            return !0;
        }
        function $m(e1, t, n) {
            let i = e1;
            do {
                const r = i.prev, a = i.next.next;
                !cg(r, a) && ug(r, i, i.next, a) && pg(r, a) && pg(a, r) && (t.push(r.i / n | 0), t.push(i.i / n | 0), t.push(a.i / n | 0), gg(i), gg(i.next), i = e1 = a), i = i.next;
            }while (i !== e1);
            return Zm(i);
        }
        function eg(e1, t, n, i, r, a) {
            let s = e1;
            do {
                let e1 = s.next.next;
                for(; e1 !== s.prev;){
                    if (s.i !== e1.i && og(s, e1)) {
                        let o = fg(s, e1);
                        return s = Zm(s, s.next), o = Zm(o, o.next), qm(s, t, n, i, r, a, 0), void qm(o, t, n, i, r, a, 0);
                    }
                    e1 = e1.next;
                }
                s = s.next;
            }while (s !== e1);
        }
        function tg(e1, t) {
            return e1.x - t.x;
        }
        function ng(e1, t) {
            const n = function(e1, t) {
                let n, i = t, r = -1 / 0;
                const a = e1.x, s = e1.y;
                do {
                    if (s <= i.y && s >= i.next.y && i.next.y !== i.y) {
                        const e1 = i.x + (s - i.y) * (i.next.x - i.x) / (i.next.y - i.y);
                        if (e1 <= a && e1 > r && (r = e1, n = i.x < i.next.x ? i : i.next, e1 === a)) return n;
                    }
                    i = i.next;
                }while (i !== t);
                if (!n) return null;
                const o = n, l = n.x, c = n.y;
                let u, h = 1 / 0;
                i = n;
                do a >= i.x && i.x >= l && a !== i.x && sg(s < c ? a : r, s, l, c, s < c ? r : a, s, i.x, i.y) && (u = Math.abs(s - i.y) / (a - i.x), pg(i, e1) && (u < h || u === h && (i.x > n.x || i.x === n.x && ig(n, i))) && (n = i, h = u)), i = i.next;
                while (i !== o);
                return n;
            }(e1, t);
            if (!n) return t;
            const i = fg(n, e1);
            return Zm(i, i.next), Zm(n, n.next);
        }
        function ig(e1, t) {
            return lg(e1.prev, e1, t.prev) < 0 && lg(t.next, e1, e1.next) < 0;
        }
        function rg(e1, t, n, i, r) {
            return (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - n) * r | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - i) * r | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
        }
        function ag(e1) {
            let t = e1, n = e1;
            do (t.x < n.x || t.x === n.x && t.y < n.y) && (n = t), t = t.next;
            while (t !== e1);
            return n;
        }
        function sg(e1, t, n, i, r, a, s, o) {
            return (r - s) * (t - o) >= (e1 - s) * (a - o) && (e1 - s) * (i - o) >= (n - s) * (t - o) && (n - s) * (a - o) >= (r - s) * (i - o);
        }
        function og(e1, t) {
            return e1.next.i !== t.i && e1.prev.i !== t.i && !function(e1, t) {
                let n = e1;
                do {
                    if (n.i !== e1.i && n.next.i !== e1.i && n.i !== t.i && n.next.i !== t.i && ug(n, n.next, e1, t)) return !0;
                    n = n.next;
                }while (n !== e1);
                return !1;
            }(e1, t) && (pg(e1, t) && pg(t, e1) && function(e1, t) {
                let n = e1, i = !1;
                const r = (e1.x + t.x) / 2, a = (e1.y + t.y) / 2;
                do n.y > a != n.next.y > a && n.next.y !== n.y && r < (n.next.x - n.x) * (a - n.y) / (n.next.y - n.y) + n.x && (i = !i), n = n.next;
                while (n !== e1);
                return i;
            }(e1, t) && (lg(e1.prev, e1, t.prev) || lg(e1, t.prev, t)) || cg(e1, t) && lg(e1.prev, e1, e1.next) > 0 && lg(t.prev, t, t.next) > 0);
        }
        function lg(e1, t, n) {
            return (t.y - e1.y) * (n.x - t.x) - (t.x - e1.x) * (n.y - t.y);
        }
        function cg(e1, t) {
            return e1.x === t.x && e1.y === t.y;
        }
        function ug(e1, t, n, i) {
            const r = dg(lg(e1, t, n)), a = dg(lg(e1, t, i)), s = dg(lg(n, i, e1)), o = dg(lg(n, i, t));
            return r !== a && s !== o || !(0 !== r || !hg(e1, n, t)) || !(0 !== a || !hg(e1, i, t)) || !(0 !== s || !hg(n, e1, i)) || !(0 !== o || !hg(n, t, i));
        }
        function hg(e1, t, n) {
            return t.x <= Math.max(e1.x, n.x) && t.x >= Math.min(e1.x, n.x) && t.y <= Math.max(e1.y, n.y) && t.y >= Math.min(e1.y, n.y);
        }
        function dg(e1) {
            return e1 > 0 ? 1 : e1 < 0 ? -1 : 0;
        }
        function pg(e1, t) {
            return lg(e1.prev, e1, e1.next) < 0 ? lg(e1, t, e1.next) >= 0 && lg(e1, e1.prev, t) >= 0 : lg(e1, t, e1.prev) < 0 || lg(e1, e1.next, t) < 0;
        }
        function fg(e1, t) {
            const n = new Ag(e1.i, e1.x, e1.y), i = new Ag(t.i, t.x, t.y), r = e1.next, a = t.prev;
            return e1.next = t, t.prev = e1, n.next = r, r.prev = n, i.next = n, n.prev = i, a.next = i, i.prev = a, i;
        }
        function mg(e1, t, n, i) {
            const r = new Ag(e1, t, n);
            return i ? (r.next = i.next, r.prev = i, i.next.prev = r, i.next = r) : (r.prev = r, r.next = r), r;
        }
        function gg(e1) {
            e1.next.prev = e1.prev, e1.prev.next = e1.next, e1.prevZ && (e1.prevZ.nextZ = e1.nextZ), e1.nextZ && (e1.nextZ.prevZ = e1.prevZ);
        }
        function Ag(e1, t, n) {
            this.i = e1, this.x = t, this.y = n, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
        }
        class vg {
            static area(e1) {
                const t = e1.length;
                let n = 0;
                for(let i = t - 1, r = 0; r < t; i = r++)n += e1[i].x * e1[r].y - e1[r].x * e1[i].y;
                return .5 * n;
            }
            static isClockWise(e1) {
                return vg.area(e1) < 0;
            }
            static triangulateShape(e1, t) {
                const n = [], i = [], r = [];
                Mg(e1), yg(n, e1);
                let a = e1.length;
                t.forEach(Mg);
                for(let e1 = 0; e1 < t.length; e1++)i.push(a), a += t[e1].length, yg(n, t[e1]);
                const s = function(e1, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2;
                    const i = t && t.length, r = i ? t[0] * n : e1.length;
                    let a = Xm(e1, 0, r, n, !0);
                    const s = [];
                    if (!a || a.next === a.prev) return s;
                    let o, l, c, u, h, d, p;
                    if (i && (a = function(e1, t, n, i) {
                        const r = [];
                        let a, s, o, l, c;
                        for(a = 0, s = t.length; a < s; a++)o = t[a] * i, l = a < s - 1 ? t[a + 1] * i : e1.length, c = Xm(e1, o, l, i, !1), c === c.next && (c.steiner = !0), r.push(ag(c));
                        for(r.sort(tg), a = 0; a < r.length; a++)n = ng(r[a], n);
                        return n;
                    }(e1, t, a, n)), e1.length > 80 * n) {
                        o = c = e1[0], l = u = e1[1];
                        for(let t = n; t < r; t += n)h = e1[t], d = e1[t + 1], h < o && (o = h), d < l && (l = d), h > c && (c = h), d > u && (u = d);
                        p = Math.max(c - o, u - l), p = 0 !== p ? 32767 / p : 0;
                    }
                    return qm(a, s, n, o, l, p, 0), s;
                }(n, i);
                for(let e1 = 0; e1 < s.length; e1 += 3)r.push(s.slice(e1, e1 + 3));
                return r;
            }
        }
        function Mg(e1) {
            const t = e1.length;
            t > 2 && e1[t - 1].equals(e1[0]) && e1.pop();
        }
        function yg(e1, t) {
            for(let n = 0; n < t.length; n++)e1.push(t[n].x), e1.push(t[n].y);
        }
        class xg extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Ym([
                    new Jo(.5, .5),
                    new Jo(-0.5, .5),
                    new Jo(-0.5, -0.5),
                    new Jo(.5, -0.5)
                ]), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                super(), this.type = "ExtrudeGeometry", this.parameters = {
                    shapes: e1,
                    options: t
                }, e1 = Array.isArray(e1) ? e1 : [
                    e1
                ];
                const n = this, i = [], r = [];
                for(let t = 0, n = e1.length; t < n; t++)a(e1[t]);
                function a(e1) {
                    const a = [], s = void 0 !== t.curveSegments ? t.curveSegments : 12, o = void 0 !== t.steps ? t.steps : 1, l = void 0 !== t.depth ? t.depth : 1;
                    let c = void 0 === t.bevelEnabled || t.bevelEnabled, u = void 0 !== t.bevelThickness ? t.bevelThickness : .2, h = void 0 !== t.bevelSize ? t.bevelSize : u - .1, d = void 0 !== t.bevelOffset ? t.bevelOffset : 0, p = void 0 !== t.bevelSegments ? t.bevelSegments : 3;
                    const f = t.extrudePath, m = void 0 !== t.UVGenerator ? t.UVGenerator : _g;
                    let g, A, v, M, y, x = !1;
                    f && (g = f.getSpacedPoints(o), x = !0, c = !1, A = f.computeFrenetFrames(o, !1), v = new Cl, M = new Cl, y = new Cl), c || (p = 0, u = 0, h = 0, d = 0);
                    const _ = e1.extractPoints(s);
                    let b = _.shape;
                    const w = _.holes;
                    if (!vg.isClockWise(b)) {
                        b = b.reverse();
                        for(let e1 = 0, t = w.length; e1 < t; e1++){
                            const t = w[e1];
                            vg.isClockWise(t) && (w[e1] = t.reverse());
                        }
                    }
                    const E = vg.triangulateShape(b, w), T = b;
                    for(let e1 = 0, t = w.length; e1 < t; e1++){
                        const t = w[e1];
                        b = b.concat(t);
                    }
                    function S(e1, t, n) {
                        return t || console.error("THREE.ExtrudeGeometry: vec does not exist"), e1.clone().addScaledVector(t, n);
                    }
                    const I = b.length, N = E.length;
                    function D(e1, t, n) {
                        let i, r, a;
                        const s = e1.x - t.x, o = e1.y - t.y, l = n.x - e1.x, c = n.y - e1.y, u = s * s + o * o, h = s * c - o * l;
                        if (Math.abs(h) > Number.EPSILON) {
                            const h = Math.sqrt(u), d = Math.sqrt(l * l + c * c), p = t.x - o / h, f = t.y + s / h, m = ((n.x - c / d - p) * c - (n.y + l / d - f) * l) / (s * c - o * l);
                            i = p + s * m - e1.x, r = f + o * m - e1.y;
                            const g = i * i + r * r;
                            if (g <= 2) return new Jo(i, r);
                            a = Math.sqrt(g / 2);
                        } else {
                            let e1 = !1;
                            s > Number.EPSILON ? l > Number.EPSILON && (e1 = !0) : s < -Number.EPSILON ? l < -Number.EPSILON && (e1 = !0) : Math.sign(o) === Math.sign(c) && (e1 = !0), e1 ? (i = -o, r = s, a = Math.sqrt(u)) : (i = s, r = o, a = Math.sqrt(u / 2));
                        }
                        return new Jo(i / a, r / a);
                    }
                    const C = [];
                    for(let e1 = 0, t = T.length, n = t - 1, i = e1 + 1; e1 < t; e1++, n++, i++)n === t && (n = 0), i === t && (i = 0), C[e1] = D(T[e1], T[n], T[i]);
                    const L = [];
                    let R, z = C.concat();
                    for(let e1 = 0, t = w.length; e1 < t; e1++){
                        const t = w[e1];
                        R = [];
                        for(let e1 = 0, n = t.length, i = n - 1, r = e1 + 1; e1 < n; e1++, i++, r++)i === n && (i = 0), r === n && (r = 0), R[e1] = D(t[e1], t[i], t[r]);
                        L.push(R), z = z.concat(R);
                    }
                    for(let e1 = 0; e1 < p; e1++){
                        const t = e1 / p, n = u * Math.cos(t * Math.PI / 2), i = h * Math.sin(t * Math.PI / 2) + d;
                        for(let e1 = 0, t = T.length; e1 < t; e1++){
                            const t = S(T[e1], C[e1], i);
                            U(t.x, t.y, -n);
                        }
                        for(let e1 = 0, t = w.length; e1 < t; e1++){
                            const t = w[e1];
                            R = L[e1];
                            for(let e1 = 0, r = t.length; e1 < r; e1++){
                                const r = S(t[e1], R[e1], i);
                                U(r.x, r.y, -n);
                            }
                        }
                    }
                    const O = h + d;
                    for(let e1 = 0; e1 < I; e1++){
                        const t = c ? S(b[e1], z[e1], O) : b[e1];
                        x ? (M.copy(A.normals[0]).multiplyScalar(t.x), v.copy(A.binormals[0]).multiplyScalar(t.y), y.copy(g[0]).add(M).add(v), U(y.x, y.y, y.z)) : U(t.x, t.y, 0);
                    }
                    for(let e1 = 1; e1 <= o; e1++)for(let t = 0; t < I; t++){
                        const n = c ? S(b[t], z[t], O) : b[t];
                        x ? (M.copy(A.normals[e1]).multiplyScalar(n.x), v.copy(A.binormals[e1]).multiplyScalar(n.y), y.copy(g[e1]).add(M).add(v), U(y.x, y.y, y.z)) : U(n.x, n.y, l / o * e1);
                    }
                    for(let e1 = p - 1; e1 >= 0; e1--){
                        const t = e1 / p, n = u * Math.cos(t * Math.PI / 2), i = h * Math.sin(t * Math.PI / 2) + d;
                        for(let e1 = 0, t = T.length; e1 < t; e1++){
                            const t = S(T[e1], C[e1], i);
                            U(t.x, t.y, l + n);
                        }
                        for(let e1 = 0, t = w.length; e1 < t; e1++){
                            const t = w[e1];
                            R = L[e1];
                            for(let e1 = 0, r = t.length; e1 < r; e1++){
                                const r = S(t[e1], R[e1], i);
                                x ? U(r.x, r.y + g[o - 1].y, g[o - 1].x + n) : U(r.x, r.y, l + n);
                            }
                        }
                    }
                    function P(e1, t) {
                        let n = e1.length;
                        for(; --n >= 0;){
                            const i = n;
                            let r = n - 1;
                            r < 0 && (r = e1.length - 1);
                            for(let e1 = 0, n = o + 2 * p; e1 < n; e1++){
                                const n = I * e1, a = I * (e1 + 1);
                                j(t + i + n, t + r + n, t + r + a, t + i + a);
                            }
                        }
                    }
                    function U(e1, t, n) {
                        a.push(e1), a.push(t), a.push(n);
                    }
                    function k(e1, t, r) {
                        B(e1), B(t), B(r);
                        const a = i.length / 3, s = m.generateTopUV(n, i, a - 3, a - 2, a - 1);
                        F(s[0]), F(s[1]), F(s[2]);
                    }
                    function j(e1, t, r, a) {
                        B(e1), B(t), B(a), B(t), B(r), B(a);
                        const s = i.length / 3, o = m.generateSideWallUV(n, i, s - 6, s - 3, s - 2, s - 1);
                        F(o[0]), F(o[1]), F(o[3]), F(o[1]), F(o[2]), F(o[3]);
                    }
                    function B(e1) {
                        i.push(a[3 * e1 + 0]), i.push(a[3 * e1 + 1]), i.push(a[3 * e1 + 2]);
                    }
                    function F(e1) {
                        r.push(e1.x), r.push(e1.y);
                    }
                    !function() {
                        const e1 = i.length / 3;
                        if (c) {
                            let e1 = 0, t = I * e1;
                            for(let e1 = 0; e1 < N; e1++){
                                const n = E[e1];
                                k(n[2] + t, n[1] + t, n[0] + t);
                            }
                            e1 = o + 2 * p, t = I * e1;
                            for(let e1 = 0; e1 < N; e1++){
                                const n = E[e1];
                                k(n[0] + t, n[1] + t, n[2] + t);
                            }
                        } else {
                            for(let e1 = 0; e1 < N; e1++){
                                const t = E[e1];
                                k(t[2], t[1], t[0]);
                            }
                            for(let e1 = 0; e1 < N; e1++){
                                const t = E[e1];
                                k(t[0] + I * o, t[1] + I * o, t[2] + I * o);
                            }
                        }
                        n.addGroup(e1, i.length / 3 - e1, 0);
                    }(), function() {
                        const e1 = i.length / 3;
                        let t = 0;
                        P(T, t), t += T.length;
                        for(let e1 = 0, n = w.length; e1 < n; e1++){
                            const n = w[e1];
                            P(n, t), t += n.length;
                        }
                        n.addGroup(e1, i.length / 3 - e1, 1);
                    }();
                }
                this.setAttribute("position", new gu(i, 3)), this.setAttribute("uv", new gu(r, 2)), this.computeVertexNormals();
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return function(e1, t, n) {
                    if (n.shapes = [], Array.isArray(e1)) for(let t = 0, i = e1.length; t < i; t++){
                        const i = e1[t];
                        n.shapes.push(i.uuid);
                    }
                    else n.shapes.push(e1.uuid);
                    return n.options = Object.assign({}, t), void 0 !== t.extrudePath && (n.options.extrudePath = t.extrudePath.toJSON()), n;
                }(this.parameters.shapes, this.parameters.options, e1);
            }
            static fromJSON(e1, t) {
                const n = [];
                for(let i = 0, r = e1.shapes.length; i < r; i++){
                    const r = t[e1.shapes[i]];
                    n.push(r);
                }
                const i = e1.options.extrudePath;
                return void 0 !== i && (e1.options.extrudePath = (new Lm[i.type]).fromJSON(i)), new xg(n, e1.options);
            }
        }
        const _g = {
            generateTopUV: function(e1, t, n, i, r) {
                const a = t[3 * n], s = t[3 * n + 1], o = t[3 * i], l = t[3 * i + 1], c = t[3 * r], u = t[3 * r + 1];
                return [
                    new Jo(a, s),
                    new Jo(o, l),
                    new Jo(c, u)
                ];
            },
            generateSideWallUV: function(e1, t, n, i, r, a) {
                const s = t[3 * n], o = t[3 * n + 1], l = t[3 * n + 2], c = t[3 * i], u = t[3 * i + 1], h = t[3 * i + 2], d = t[3 * r], p = t[3 * r + 1], f = t[3 * r + 2], m = t[3 * a], g = t[3 * a + 1], A = t[3 * a + 2];
                return Math.abs(o - u) < Math.abs(s - c) ? [
                    new Jo(s, 1 - l),
                    new Jo(c, 1 - h),
                    new Jo(d, 1 - f),
                    new Jo(m, 1 - A)
                ] : [
                    new Jo(o, 1 - l),
                    new Jo(u, 1 - h),
                    new Jo(p, 1 - f),
                    new Jo(g, 1 - A)
                ];
            }
        };
        class bg extends Bm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = (1 + Math.sqrt(5)) / 2;
                super([
                    -1,
                    n,
                    0,
                    1,
                    n,
                    0,
                    -1,
                    -n,
                    0,
                    1,
                    -n,
                    0,
                    0,
                    -1,
                    n,
                    0,
                    1,
                    n,
                    0,
                    -1,
                    -n,
                    0,
                    1,
                    -n,
                    n,
                    0,
                    -1,
                    n,
                    0,
                    1,
                    -n,
                    0,
                    -1,
                    -n,
                    0,
                    1
                ], [
                    0,
                    11,
                    5,
                    0,
                    5,
                    1,
                    0,
                    1,
                    7,
                    0,
                    7,
                    10,
                    0,
                    10,
                    11,
                    1,
                    5,
                    9,
                    5,
                    11,
                    4,
                    11,
                    10,
                    2,
                    10,
                    7,
                    6,
                    7,
                    1,
                    8,
                    3,
                    9,
                    4,
                    3,
                    4,
                    2,
                    3,
                    2,
                    6,
                    3,
                    6,
                    8,
                    3,
                    8,
                    9,
                    4,
                    9,
                    5,
                    2,
                    4,
                    11,
                    6,
                    2,
                    10,
                    8,
                    6,
                    7,
                    9,
                    8,
                    1
                ], e1, t), this.type = "IcosahedronGeometry", this.parameters = {
                    radius: e1,
                    detail: t
                };
            }
            static fromJSON(e1) {
                return new bg(e1.radius, e1.detail);
            }
        }
        class wg extends Bm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                super([
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    -1
                ], [
                    0,
                    2,
                    4,
                    0,
                    4,
                    3,
                    0,
                    3,
                    5,
                    0,
                    5,
                    2,
                    1,
                    2,
                    5,
                    1,
                    5,
                    3,
                    1,
                    3,
                    4,
                    1,
                    4,
                    2
                ], e1, t), this.type = "OctahedronGeometry", this.parameters = {
                    radius: e1,
                    detail: t
                };
            }
            static fromJSON(e1) {
                return new wg(e1.radius, e1.detail);
            }
        }
        class Eg extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : .5, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 32, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 2 * Math.PI;
                super(), this.type = "RingGeometry", this.parameters = {
                    innerRadius: e1,
                    outerRadius: t,
                    thetaSegments: n,
                    phiSegments: i,
                    thetaStart: r,
                    thetaLength: a
                }, n = Math.max(3, n), i = Math.max(1, i);
                const s = [], o = [], l = [], c = [];
                let u = e1;
                const h = (t - e1) / i, d = new Cl, p = new Jo;
                for(let e1 = 0; e1 <= i; e1++){
                    for(let e1 = 0; e1 <= n; e1++){
                        const i = r + e1 / n * a;
                        d.x = u * Math.cos(i), d.y = u * Math.sin(i), o.push(d.x, d.y, d.z), l.push(0, 0, 1), p.x = (d.x / t + 1) / 2, p.y = (d.y / t + 1) / 2, c.push(p.x, p.y);
                    }
                    u += h;
                }
                for(let e1 = 0; e1 < i; e1++){
                    const t = e1 * (n + 1);
                    for(let e1 = 0; e1 < n; e1++){
                        const i = e1 + t, r = i, a = i + n + 1, o = i + n + 2, l = i + 1;
                        s.push(r, a, l), s.push(a, o, l);
                    }
                }
                this.setIndex(s), this.setAttribute("position", new gu(o, 3)), this.setAttribute("normal", new gu(l, 3)), this.setAttribute("uv", new gu(c, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Eg(e1.innerRadius, e1.outerRadius, e1.thetaSegments, e1.phiSegments, e1.thetaStart, e1.thetaLength);
            }
        }
        class Tg extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Ym([
                    new Jo(0, .5),
                    new Jo(-0.5, -0.5),
                    new Jo(.5, -0.5)
                ]), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 12;
                super(), this.type = "ShapeGeometry", this.parameters = {
                    shapes: e1,
                    curveSegments: t
                };
                const n = [], i = [], r = [], a = [];
                let s = 0, o = 0;
                if (!1 === Array.isArray(e1)) l(e1);
                else for(let t = 0; t < e1.length; t++)l(e1[t]), this.addGroup(s, o, t), s += o, o = 0;
                function l(e1) {
                    const s = i.length / 3, l = e1.extractPoints(t);
                    let c = l.shape;
                    const u = l.holes;
                    !1 === vg.isClockWise(c) && (c = c.reverse());
                    for(let e1 = 0, t = u.length; e1 < t; e1++){
                        const t = u[e1];
                        !0 === vg.isClockWise(t) && (u[e1] = t.reverse());
                    }
                    const h = vg.triangulateShape(c, u);
                    for(let e1 = 0, t = u.length; e1 < t; e1++){
                        const t = u[e1];
                        c = c.concat(t);
                    }
                    for(let e1 = 0, t = c.length; e1 < t; e1++){
                        const t = c[e1];
                        i.push(t.x, t.y, 0), r.push(0, 0, 1), a.push(t.x, t.y);
                    }
                    for(let e1 = 0, t = h.length; e1 < t; e1++){
                        const t = h[e1], i = t[0] + s, r = t[1] + s, a = t[2] + s;
                        n.push(i, r, a), o += 3;
                    }
                }
                this.setIndex(n), this.setAttribute("position", new gu(i, 3)), this.setAttribute("normal", new gu(r, 3)), this.setAttribute("uv", new gu(a, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return function(e1, t) {
                    if (t.shapes = [], Array.isArray(e1)) for(let n = 0, i = e1.length; n < i; n++){
                        const i = e1[n];
                        t.shapes.push(i.uuid);
                    }
                    else t.shapes.push(e1.uuid);
                    return t;
                }(this.parameters.shapes, e1);
            }
            static fromJSON(e1, t) {
                const n = [];
                for(let i = 0, r = e1.shapes.length; i < r; i++){
                    const r = t[e1.shapes[i]];
                    n.push(r);
                }
                return new Tg(n, e1.curveSegments);
            }
        }
        class Sg extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 32, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 16, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 2 * Math.PI, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0, s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : Math.PI;
                super(), this.type = "SphereGeometry", this.parameters = {
                    radius: e1,
                    widthSegments: t,
                    heightSegments: n,
                    phiStart: i,
                    phiLength: r,
                    thetaStart: a,
                    thetaLength: s
                }, t = Math.max(3, Math.floor(t)), n = Math.max(2, Math.floor(n));
                const o = Math.min(a + s, Math.PI);
                let l = 0;
                const c = [], u = new Cl, h = new Cl, d = [], p = [], f = [], m = [];
                for(let d = 0; d <= n; d++){
                    const g = [], A = d / n;
                    let v = 0;
                    0 === d && 0 === a ? v = .5 / t : d === n && o === Math.PI && (v = -0.5 / t);
                    for(let n = 0; n <= t; n++){
                        const o = n / t;
                        u.x = -e1 * Math.cos(i + o * r) * Math.sin(a + A * s), u.y = e1 * Math.cos(a + A * s), u.z = e1 * Math.sin(i + o * r) * Math.sin(a + A * s), p.push(u.x, u.y, u.z), h.copy(u).normalize(), f.push(h.x, h.y, h.z), m.push(o + v, 1 - A), g.push(l++);
                    }
                    c.push(g);
                }
                for(let e1 = 0; e1 < n; e1++)for(let i = 0; i < t; i++){
                    const t = c[e1][i + 1], r = c[e1][i], s = c[e1 + 1][i], l = c[e1 + 1][i + 1];
                    (0 !== e1 || a > 0) && d.push(t, r, l), (e1 !== n - 1 || o < Math.PI) && d.push(r, s, l);
                }
                this.setIndex(d), this.setAttribute("position", new gu(p, 3)), this.setAttribute("normal", new gu(f, 3)), this.setAttribute("uv", new gu(m, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Sg(e1.radius, e1.widthSegments, e1.heightSegments, e1.phiStart, e1.phiLength, e1.thetaStart, e1.thetaLength);
            }
        }
        class Ig extends Bm {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                super([
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    1,
                    -1,
                    -1
                ], [
                    2,
                    1,
                    0,
                    0,
                    3,
                    2,
                    1,
                    3,
                    0,
                    2,
                    3,
                    1
                ], e1, t), this.type = "TetrahedronGeometry", this.parameters = {
                    radius: e1,
                    detail: t
                };
            }
            static fromJSON(e1) {
                return new Ig(e1.radius, e1.detail);
            }
        }
        class Ng extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .4, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 12, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 48, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 2 * Math.PI;
                super(), this.type = "TorusGeometry", this.parameters = {
                    radius: e1,
                    tube: t,
                    radialSegments: n,
                    tubularSegments: i,
                    arc: r
                }, n = Math.floor(n), i = Math.floor(i);
                const a = [], s = [], o = [], l = [], c = new Cl, u = new Cl, h = new Cl;
                for(let a = 0; a <= n; a++)for(let d = 0; d <= i; d++){
                    const p = d / i * r, f = a / n * Math.PI * 2;
                    u.x = (e1 + t * Math.cos(f)) * Math.cos(p), u.y = (e1 + t * Math.cos(f)) * Math.sin(p), u.z = t * Math.sin(f), s.push(u.x, u.y, u.z), c.x = e1 * Math.cos(p), c.y = e1 * Math.sin(p), h.subVectors(u, c).normalize(), o.push(h.x, h.y, h.z), l.push(d / i), l.push(a / n);
                }
                for(let e1 = 1; e1 <= n; e1++)for(let t = 1; t <= i; t++){
                    const n = (i + 1) * e1 + t - 1, r = (i + 1) * (e1 - 1) + t - 1, s = (i + 1) * (e1 - 1) + t, o = (i + 1) * e1 + t;
                    a.push(n, r, o), a.push(r, s, o);
                }
                this.setIndex(a), this.setAttribute("position", new gu(s, 3)), this.setAttribute("normal", new gu(o, 3)), this.setAttribute("uv", new gu(l, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Ng(e1.radius, e1.tube, e1.radialSegments, e1.tubularSegments, e1.arc);
            }
        }
        class Dg extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .4, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 64, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 8, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 2, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 3;
                super(), this.type = "TorusKnotGeometry", this.parameters = {
                    radius: e1,
                    tube: t,
                    tubularSegments: n,
                    radialSegments: i,
                    p: r,
                    q: a
                }, n = Math.floor(n), i = Math.floor(i);
                const s = [], o = [], l = [], c = [], u = new Cl, h = new Cl, d = new Cl, p = new Cl, f = new Cl, m = new Cl, g = new Cl;
                for(let s = 0; s <= n; ++s){
                    const v = s / n * r * Math.PI * 2;
                    A(v, r, a, e1, d), A(v + .01, r, a, e1, p), m.subVectors(p, d), g.addVectors(p, d), f.crossVectors(m, g), g.crossVectors(f, m), f.normalize(), g.normalize();
                    for(let e1 = 0; e1 <= i; ++e1){
                        const r = e1 / i * Math.PI * 2, a = -t * Math.cos(r), p = t * Math.sin(r);
                        u.x = d.x + (a * g.x + p * f.x), u.y = d.y + (a * g.y + p * f.y), u.z = d.z + (a * g.z + p * f.z), o.push(u.x, u.y, u.z), h.subVectors(u, d).normalize(), l.push(h.x, h.y, h.z), c.push(s / n), c.push(e1 / i);
                    }
                }
                for(let e1 = 1; e1 <= n; e1++)for(let t = 1; t <= i; t++){
                    const n = (i + 1) * (e1 - 1) + (t - 1), r = (i + 1) * e1 + (t - 1), a = (i + 1) * e1 + t, o = (i + 1) * (e1 - 1) + t;
                    s.push(n, r, o), s.push(r, a, o);
                }
                function A(e1, t, n, i, r) {
                    const a = Math.cos(e1), s = Math.sin(e1), o = n / t * e1, l = Math.cos(o);
                    r.x = i * (2 + l) * .5 * a, r.y = i * (2 + l) * s * .5, r.z = i * Math.sin(o) * .5;
                }
                this.setIndex(s), this.setAttribute("position", new gu(o, 3)), this.setAttribute("normal", new gu(l, 3)), this.setAttribute("uv", new gu(c, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            static fromJSON(e1) {
                return new Dg(e1.radius, e1.tube, e1.tubularSegments, e1.radialSegments, e1.p, e1.q);
            }
        }
        class Cg extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Dm(new Cl(-1, -1, 0), new Cl(-1, 1, 0), new Cl(1, 1, 0)), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 64, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 8, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                super(), this.type = "TubeGeometry", this.parameters = {
                    path: e1,
                    tubularSegments: t,
                    radius: n,
                    radialSegments: i,
                    closed: r
                };
                const a = e1.computeFrenetFrames(t, r);
                this.tangents = a.tangents, this.normals = a.normals, this.binormals = a.binormals;
                const s = new Cl, o = new Cl, l = new Jo;
                let c = new Cl;
                const u = [], h = [], d = [], p = [];
                function f(r) {
                    c = e1.getPointAt(r / t, c);
                    const l = a.normals[r], d = a.binormals[r];
                    for(let e1 = 0; e1 <= i; e1++){
                        const t = e1 / i * Math.PI * 2, r = Math.sin(t), a = -Math.cos(t);
                        o.x = a * l.x + r * d.x, o.y = a * l.y + r * d.y, o.z = a * l.z + r * d.z, o.normalize(), h.push(o.x, o.y, o.z), s.x = c.x + n * o.x, s.y = c.y + n * o.y, s.z = c.z + n * o.z, u.push(s.x, s.y, s.z);
                    }
                }
                !function() {
                    for(let e1 = 0; e1 < t; e1++)f(e1);
                    f(!1 === r ? t : 0), function() {
                        for(let e1 = 0; e1 <= t; e1++)for(let n = 0; n <= i; n++)l.x = e1 / t, l.y = n / i, d.push(l.x, l.y);
                    }(), function() {
                        for(let e1 = 1; e1 <= t; e1++)for(let t = 1; t <= i; t++){
                            const n = (i + 1) * (e1 - 1) + (t - 1), r = (i + 1) * e1 + (t - 1), a = (i + 1) * e1 + t, s = (i + 1) * (e1 - 1) + t;
                            p.push(n, r, s), p.push(r, a, s);
                        }
                    }();
                }(), this.setIndex(p), this.setAttribute("position", new gu(u, 3)), this.setAttribute("normal", new gu(h, 3)), this.setAttribute("uv", new gu(d, 2));
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.path = this.parameters.path.toJSON(), e1;
            }
            static fromJSON(e1) {
                return new Cg((new Lm[e1.path.type]).fromJSON(e1.path), e1.tubularSegments, e1.radius, e1.radialSegments, e1.closed);
            }
        }
        class Lg extends Eu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if (super(), this.type = "WireframeGeometry", this.parameters = {
                    geometry: e1
                }, null !== e1) {
                    const t = [], n = new Set, i = new Cl, r = new Cl;
                    if (null !== e1.index) {
                        const a = e1.attributes.position, s = e1.index;
                        let o = e1.groups;
                        0 === o.length && (o = [
                            {
                                start: 0,
                                count: s.count,
                                materialIndex: 0
                            }
                        ]);
                        for(let e1 = 0, l = o.length; e1 < l; ++e1){
                            const l = o[e1], c = l.start;
                            for(let e1 = c, o = c + l.count; e1 < o; e1 += 3)for(let o = 0; o < 3; o++){
                                const l = s.getX(e1 + o), c = s.getX(e1 + (o + 1) % 3);
                                i.fromBufferAttribute(a, l), r.fromBufferAttribute(a, c), !0 === Rg(i, r, n) && (t.push(i.x, i.y, i.z), t.push(r.x, r.y, r.z));
                            }
                        }
                    } else {
                        const a = e1.attributes.position;
                        for(let e1 = 0, s = a.count / 3; e1 < s; e1++)for(let s = 0; s < 3; s++){
                            const o = 3 * e1 + s, l = 3 * e1 + (s + 1) % 3;
                            i.fromBufferAttribute(a, o), r.fromBufferAttribute(a, l), !0 === Rg(i, r, n) && (t.push(i.x, i.y, i.z), t.push(r.x, r.y, r.z));
                        }
                    }
                    this.setAttribute("position", new gu(t, 3));
                }
            }
            copy(e1) {
                return super.copy(e1), this.parameters = Object.assign({}, e1.parameters), this;
            }
        }
        function Rg(e1, t, n) {
            const i = "".concat(e1.x, ",").concat(e1.y, ",").concat(e1.z, "-").concat(t.x, ",").concat(t.y, ",").concat(t.z), r = "".concat(t.x, ",").concat(t.y, ",").concat(t.z, "-").concat(e1.x, ",").concat(e1.y, ",").concat(e1.z);
            return !0 !== n.has(i) && !0 !== n.has(r) && (n.add(i), n.add(r), !0);
        }
        var zg = Object.freeze({
            __proto__: null,
            BoxGeometry: Qu,
            CapsuleGeometry: Pm,
            CircleGeometry: Um,
            ConeGeometry: jm,
            CylinderGeometry: km,
            DodecahedronGeometry: Fm,
            EdgesGeometry: Wm,
            ExtrudeGeometry: xg,
            IcosahedronGeometry: bg,
            LatheGeometry: Om,
            OctahedronGeometry: wg,
            PlaneGeometry: dh,
            PolyhedronGeometry: Bm,
            RingGeometry: Eg,
            ShapeGeometry: Tg,
            SphereGeometry: Sg,
            TetrahedronGeometry: Ig,
            TorusGeometry: Ng,
            TorusKnotGeometry: Dg,
            TubeGeometry: Cg,
            WireframeGeometry: Lg
        });
        class Og extends Jc {
            constructor(e1){
                super(), this.isShadowMaterial = !0, this.type = "ShadowMaterial", this.color = new Zc(0), this.transparent = !0, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.fog = e1.fog, this;
            }
        }
        class Pg extends qu {
            constructor(e1){
                super(e1), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
            }
        }
        class Ug extends Jc {
            constructor(e1){
                super(), this.isMeshStandardMaterial = !0, this.defines = {
                    STANDARD: ""
                }, this.type = "MeshStandardMaterial", this.color = new Zc(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Zc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Fs, this.normalScale = new Jo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.defines = {
                    STANDARD: ""
                }, this.color.copy(e1.color), this.roughness = e1.roughness, this.metalness = e1.metalness, this.map = e1.map, this.lightMap = e1.lightMap, this.lightMapIntensity = e1.lightMapIntensity, this.aoMap = e1.aoMap, this.aoMapIntensity = e1.aoMapIntensity, this.emissive.copy(e1.emissive), this.emissiveMap = e1.emissiveMap, this.emissiveIntensity = e1.emissiveIntensity, this.bumpMap = e1.bumpMap, this.bumpScale = e1.bumpScale, this.normalMap = e1.normalMap, this.normalMapType = e1.normalMapType, this.normalScale.copy(e1.normalScale), this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.roughnessMap = e1.roughnessMap, this.metalnessMap = e1.metalnessMap, this.alphaMap = e1.alphaMap, this.envMap = e1.envMap, this.envMapIntensity = e1.envMapIntensity, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.wireframeLinecap = e1.wireframeLinecap, this.wireframeLinejoin = e1.wireframeLinejoin, this.flatShading = e1.flatShading, this.fog = e1.fog, this;
            }
        }
        class kg extends Ug {
            constructor(e1){
                super(), this.isMeshPhysicalMaterial = !0, this.defines = {
                    STANDARD: "",
                    PHYSICAL: ""
                }, this.type = "MeshPhysicalMaterial", this.anisotropyRotation = 0, this.anisotropyMap = null, this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new Jo(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
                    get: function() {
                        return Vo(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
                    },
                    set: function(e1) {
                        this.ior = (1 + .4 * e1) / (1 - .4 * e1);
                    }
                }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [
                    100,
                    400
                ], this.iridescenceThicknessMap = null, this.sheenColor = new Zc(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 1 / 0, this.attenuationColor = new Zc(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new Zc(1, 1, 1), this.specularColorMap = null, this._anisotropy = 0, this._clearcoat = 0, this._iridescence = 0, this._sheen = 0, this._transmission = 0, this.setValues(e1);
            }
            get anisotropy() {
                return this._anisotropy;
            }
            set anisotropy(e1) {
                this._anisotropy > 0 != e1 > 0 && this.version++, this._anisotropy = e1;
            }
            get clearcoat() {
                return this._clearcoat;
            }
            set clearcoat(e1) {
                this._clearcoat > 0 != e1 > 0 && this.version++, this._clearcoat = e1;
            }
            get iridescence() {
                return this._iridescence;
            }
            set iridescence(e1) {
                this._iridescence > 0 != e1 > 0 && this.version++, this._iridescence = e1;
            }
            get sheen() {
                return this._sheen;
            }
            set sheen(e1) {
                this._sheen > 0 != e1 > 0 && this.version++, this._sheen = e1;
            }
            get transmission() {
                return this._transmission;
            }
            set transmission(e1) {
                this._transmission > 0 != e1 > 0 && this.version++, this._transmission = e1;
            }
            copy(e1) {
                return super.copy(e1), this.defines = {
                    STANDARD: "",
                    PHYSICAL: ""
                }, this.anisotropy = e1.anisotropy, this.anisotropyRotation = e1.anisotropyRotation, this.anisotropyMap = e1.anisotropyMap, this.clearcoat = e1.clearcoat, this.clearcoatMap = e1.clearcoatMap, this.clearcoatRoughness = e1.clearcoatRoughness, this.clearcoatRoughnessMap = e1.clearcoatRoughnessMap, this.clearcoatNormalMap = e1.clearcoatNormalMap, this.clearcoatNormalScale.copy(e1.clearcoatNormalScale), this.ior = e1.ior, this.iridescence = e1.iridescence, this.iridescenceMap = e1.iridescenceMap, this.iridescenceIOR = e1.iridescenceIOR, this.iridescenceThicknessRange = [
                    ...e1.iridescenceThicknessRange
                ], this.iridescenceThicknessMap = e1.iridescenceThicknessMap, this.sheen = e1.sheen, this.sheenColor.copy(e1.sheenColor), this.sheenColorMap = e1.sheenColorMap, this.sheenRoughness = e1.sheenRoughness, this.sheenRoughnessMap = e1.sheenRoughnessMap, this.transmission = e1.transmission, this.transmissionMap = e1.transmissionMap, this.thickness = e1.thickness, this.thicknessMap = e1.thicknessMap, this.attenuationDistance = e1.attenuationDistance, this.attenuationColor.copy(e1.attenuationColor), this.specularIntensity = e1.specularIntensity, this.specularIntensityMap = e1.specularIntensityMap, this.specularColor.copy(e1.specularColor), this.specularColorMap = e1.specularColorMap, this;
            }
        }
        class jg extends Jc {
            constructor(e1){
                super(), this.isMeshPhongMaterial = !0, this.type = "MeshPhongMaterial", this.color = new Zc(16777215), this.specular = new Zc(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Zc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Fs, this.normalScale = new Jo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Yr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.specular.copy(e1.specular), this.shininess = e1.shininess, this.map = e1.map, this.lightMap = e1.lightMap, this.lightMapIntensity = e1.lightMapIntensity, this.aoMap = e1.aoMap, this.aoMapIntensity = e1.aoMapIntensity, this.emissive.copy(e1.emissive), this.emissiveMap = e1.emissiveMap, this.emissiveIntensity = e1.emissiveIntensity, this.bumpMap = e1.bumpMap, this.bumpScale = e1.bumpScale, this.normalMap = e1.normalMap, this.normalMapType = e1.normalMapType, this.normalScale.copy(e1.normalScale), this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.specularMap = e1.specularMap, this.alphaMap = e1.alphaMap, this.envMap = e1.envMap, this.combine = e1.combine, this.reflectivity = e1.reflectivity, this.refractionRatio = e1.refractionRatio, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.wireframeLinecap = e1.wireframeLinecap, this.wireframeLinejoin = e1.wireframeLinejoin, this.flatShading = e1.flatShading, this.fog = e1.fog, this;
            }
        }
        class Bg extends Jc {
            constructor(e1){
                super(), this.isMeshToonMaterial = !0, this.defines = {
                    TOON: ""
                }, this.type = "MeshToonMaterial", this.color = new Zc(16777215), this.map = null, this.gradientMap = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Zc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Fs, this.normalScale = new Jo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.gradientMap = e1.gradientMap, this.lightMap = e1.lightMap, this.lightMapIntensity = e1.lightMapIntensity, this.aoMap = e1.aoMap, this.aoMapIntensity = e1.aoMapIntensity, this.emissive.copy(e1.emissive), this.emissiveMap = e1.emissiveMap, this.emissiveIntensity = e1.emissiveIntensity, this.bumpMap = e1.bumpMap, this.bumpScale = e1.bumpScale, this.normalMap = e1.normalMap, this.normalMapType = e1.normalMapType, this.normalScale.copy(e1.normalScale), this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.alphaMap = e1.alphaMap, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.wireframeLinecap = e1.wireframeLinecap, this.wireframeLinejoin = e1.wireframeLinejoin, this.fog = e1.fog, this;
            }
        }
        class Fg extends Jc {
            constructor(e1){
                super(), this.isMeshNormalMaterial = !0, this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Fs, this.normalScale = new Jo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.bumpMap = e1.bumpMap, this.bumpScale = e1.bumpScale, this.normalMap = e1.normalMap, this.normalMapType = e1.normalMapType, this.normalScale.copy(e1.normalScale), this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.flatShading = e1.flatShading, this;
            }
        }
        class Hg extends Jc {
            constructor(e1){
                super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new Zc(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Zc(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Fs, this.normalScale = new Jo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Yr, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.color.copy(e1.color), this.map = e1.map, this.lightMap = e1.lightMap, this.lightMapIntensity = e1.lightMapIntensity, this.aoMap = e1.aoMap, this.aoMapIntensity = e1.aoMapIntensity, this.emissive.copy(e1.emissive), this.emissiveMap = e1.emissiveMap, this.emissiveIntensity = e1.emissiveIntensity, this.bumpMap = e1.bumpMap, this.bumpScale = e1.bumpScale, this.normalMap = e1.normalMap, this.normalMapType = e1.normalMapType, this.normalScale.copy(e1.normalScale), this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.specularMap = e1.specularMap, this.alphaMap = e1.alphaMap, this.envMap = e1.envMap, this.combine = e1.combine, this.reflectivity = e1.reflectivity, this.refractionRatio = e1.refractionRatio, this.wireframe = e1.wireframe, this.wireframeLinewidth = e1.wireframeLinewidth, this.wireframeLinecap = e1.wireframeLinecap, this.wireframeLinejoin = e1.wireframeLinejoin, this.flatShading = e1.flatShading, this.fog = e1.fog, this;
            }
        }
        class Vg extends Jc {
            constructor(e1){
                super(), this.isMeshMatcapMaterial = !0, this.defines = {
                    MATCAP: ""
                }, this.type = "MeshMatcapMaterial", this.color = new Zc(16777215), this.matcap = null, this.map = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Fs, this.normalScale = new Jo(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.flatShading = !1, this.fog = !0, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.defines = {
                    MATCAP: ""
                }, this.color.copy(e1.color), this.matcap = e1.matcap, this.map = e1.map, this.bumpMap = e1.bumpMap, this.bumpScale = e1.bumpScale, this.normalMap = e1.normalMap, this.normalMapType = e1.normalMapType, this.normalScale.copy(e1.normalScale), this.displacementMap = e1.displacementMap, this.displacementScale = e1.displacementScale, this.displacementBias = e1.displacementBias, this.alphaMap = e1.alphaMap, this.flatShading = e1.flatShading, this.fog = e1.fog, this;
            }
        }
        class Gg extends Vf {
            constructor(e1){
                super(), this.isLineDashedMaterial = !0, this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(e1);
            }
            copy(e1) {
                return super.copy(e1), this.scale = e1.scale, this.dashSize = e1.dashSize, this.gapSize = e1.gapSize, this;
            }
        }
        function Qg(e1, t, n) {
            return !e1 || !n && e1.constructor === t ? e1 : "number" == typeof t.BYTES_PER_ELEMENT ? new t(e1) : Array.prototype.slice.call(e1);
        }
        function Wg(e1) {
            return ArrayBuffer.isView(e1) && !(e1 instanceof DataView);
        }
        function Yg(e1) {
            const t = e1.length, n = new Array(t);
            for(let e1 = 0; e1 !== t; ++e1)n[e1] = e1;
            return n.sort(function(t, n) {
                return e1[t] - e1[n];
            }), n;
        }
        function Xg(e1, t, n) {
            const i = e1.length, r = new e1.constructor(i);
            for(let a = 0, s = 0; s !== i; ++a){
                const i = n[a] * t;
                for(let n = 0; n !== t; ++n)r[s++] = e1[i + n];
            }
            return r;
        }
        function Zg(e1, t, n, i) {
            let r = 1, a = e1[0];
            for(; void 0 !== a && void 0 === a[i];)a = e1[r++];
            if (void 0 === a) return;
            let s = a[i];
            if (void 0 !== s) {
                if (Array.isArray(s)) do s = a[i], void 0 !== s && (t.push(a.time), n.push.apply(n, s)), a = e1[r++];
                while (void 0 !== a);
                else if (void 0 !== s.toArray) do s = a[i], void 0 !== s && (t.push(a.time), s.toArray(n, n.length)), a = e1[r++];
                while (void 0 !== a);
                else do s = a[i], void 0 !== s && (t.push(a.time), n.push(s)), a = e1[r++];
                while (void 0 !== a);
            }
        }
        const qg = {
            convertArray: Qg,
            isTypedArray: Wg,
            getKeyframeOrder: Yg,
            sortedArray: Xg,
            flattenJSON: Zg,
            subclip: function(e1, t, n, i) {
                let r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 30;
                const a = e1.clone();
                a.name = t;
                const s = [];
                for(let e1 = 0; e1 < a.tracks.length; ++e1){
                    const t = a.tracks[e1], o = t.getValueSize(), l = [], c = [];
                    for(let e1 = 0; e1 < t.times.length; ++e1){
                        const a = t.times[e1] * r;
                        if (!(a < n || a >= i)) {
                            l.push(t.times[e1]);
                            for(let n = 0; n < o; ++n)c.push(t.values[e1 * o + n]);
                        }
                    }
                    0 !== l.length && (t.times = Qg(l, t.times.constructor), t.values = Qg(c, t.values.constructor), s.push(t));
                }
                a.tracks = s;
                let o = 1 / 0;
                for(let e1 = 0; e1 < a.tracks.length; ++e1)o > a.tracks[e1].times[0] && (o = a.tracks[e1].times[0]);
                for(let e1 = 0; e1 < a.tracks.length; ++e1)a.tracks[e1].shift(-1 * o);
                return a.resetDuration(), a;
            },
            makeClipAdditive: function(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 30;
                i <= 0 && (i = 30);
                const r = n.tracks.length, a = t / i;
                for(let t = 0; t < r; ++t){
                    const i = n.tracks[t], r = i.ValueTypeName;
                    if ("bool" === r || "string" === r) continue;
                    const s = e1.tracks.find(function(e1) {
                        return e1.name === i.name && e1.ValueTypeName === r;
                    });
                    if (void 0 === s) continue;
                    let o = 0;
                    const l = i.getValueSize();
                    i.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (o = l / 3);
                    let c = 0;
                    const u = s.getValueSize();
                    s.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (c = u / 3);
                    const h = i.times.length - 1;
                    let d;
                    if (a <= i.times[0]) {
                        const e1 = o, t = l - o;
                        d = i.values.slice(e1, t);
                    } else if (a >= i.times[h]) {
                        const e1 = h * l + o, t = e1 + l - o;
                        d = i.values.slice(e1, t);
                    } else {
                        const e1 = i.createInterpolant(), t = o, n = l - o;
                        e1.evaluate(a), d = e1.resultBuffer.slice(t, n);
                    }
                    "quaternion" === r && (new Dl).fromArray(d).normalize().conjugate().toArray(d);
                    const p = s.times.length;
                    for(let e1 = 0; e1 < p; ++e1){
                        const t = e1 * u + c;
                        if ("quaternion" === r) Dl.multiplyQuaternionsFlat(s.values, t, d, 0, s.values, t);
                        else {
                            const e1 = u - 2 * c;
                            for(let n = 0; n < e1; ++n)s.values[t + n] -= d[n];
                        }
                    }
                }
                return e1.blendMode = Rs, e1;
            }
        };
        class Kg {
            constructor(e1, t, n, i){
                this.parameterPositions = e1, this._cachedIndex = 0, this.resultBuffer = void 0 !== i ? i : new t.constructor(n), this.sampleValues = t, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
            }
            evaluate(e1) {
                const t = this.parameterPositions;
                let n = this._cachedIndex, i = t[n], r = t[n - 1];
                e: {
                    t: {
                        let a;
                        n: {
                            i: if (!(e1 < i)) {
                                for(let a = n + 2;;){
                                    if (void 0 === i) {
                                        if (e1 < r) break i;
                                        return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
                                    }
                                    if (n === a) break;
                                    if (r = i, i = t[++n], e1 < i) break t;
                                }
                                a = t.length;
                                break n;
                            }
                            if (e1 >= r) break e;
                            {
                                const s = t[1];
                                e1 < s && (n = 2, r = s);
                                for(let a = n - 2;;){
                                    if (void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
                                    if (n === a) break;
                                    if (i = r, r = t[--n - 1], e1 >= r) break t;
                                }
                                a = n, n = 0;
                            }
                        }
                        for(; n < a;){
                            const i = n + a >>> 1;
                            e1 < t[i] ? a = i : n = i + 1;
                        }
                        if (i = t[n], r = t[n - 1], void 0 === r) return this._cachedIndex = 0, this.copySampleValue_(0);
                        if (void 0 === i) return n = t.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
                    }
                    this._cachedIndex = n, this.intervalChanged_(n, r, i);
                }
                return this.interpolate_(n, r, e1, i);
            }
            getSettings_() {
                return this.settings || this.DefaultSettings_;
            }
            copySampleValue_(e1) {
                const t = this.resultBuffer, n = this.sampleValues, i = this.valueSize, r = e1 * i;
                for(let e1 = 0; e1 !== i; ++e1)t[e1] = n[r + e1];
                return t;
            }
            interpolate_() {
                throw new Error("call to abstract method");
            }
            intervalChanged_() {}
        }
        class Jg extends Kg {
            constructor(e1, t, n, i){
                super(e1, t, n, i), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
                    endingStart: Ns,
                    endingEnd: Ns
                };
            }
            intervalChanged_(e1, t, n) {
                const i = this.parameterPositions;
                let r = e1 - 2, a = e1 + 1, s = i[r], o = i[a];
                if (void 0 === s) switch(this.getSettings_().endingStart){
                    case Ds:
                        r = e1, s = 2 * t - n;
                        break;
                    case Cs:
                        r = i.length - 2, s = t + i[r] - i[r + 1];
                        break;
                    default:
                        r = e1, s = n;
                }
                if (void 0 === o) switch(this.getSettings_().endingEnd){
                    case Ds:
                        a = e1, o = 2 * n - t;
                        break;
                    case Cs:
                        a = 1, o = n + i[1] - i[0];
                        break;
                    default:
                        a = e1 - 1, o = t;
                }
                const l = .5 * (n - t), c = this.valueSize;
                this._weightPrev = l / (t - s), this._weightNext = l / (o - n), this._offsetPrev = r * c, this._offsetNext = a * c;
            }
            interpolate_(e1, t, n, i) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = e1 * s, l = o - s, c = this._offsetPrev, u = this._offsetNext, h = this._weightPrev, d = this._weightNext, p = (n - t) / (i - t), f = p * p, m = f * p, g = -h * m + 2 * h * f - h * p, A = (1 + h) * m + (-1.5 - 2 * h) * f + (-0.5 + h) * p + 1, v = (-1 - d) * m + (1.5 + d) * f + .5 * p, M = d * m - d * f;
                for(let e1 = 0; e1 !== s; ++e1)r[e1] = g * a[c + e1] + A * a[l + e1] + v * a[o + e1] + M * a[u + e1];
                return r;
            }
        }
        class $g extends Kg {
            constructor(e1, t, n, i){
                super(e1, t, n, i);
            }
            interpolate_(e1, t, n, i) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = e1 * s, l = o - s, c = (n - t) / (i - t), u = 1 - c;
                for(let e1 = 0; e1 !== s; ++e1)r[e1] = a[l + e1] * u + a[o + e1] * c;
                return r;
            }
        }
        class eA extends Kg {
            constructor(e1, t, n, i){
                super(e1, t, n, i);
            }
            interpolate_(e1) {
                return this.copySampleValue_(e1 - 1);
            }
        }
        class tA {
            constructor(e1, t, n, i){
                if (void 0 === e1) throw new Error("THREE.KeyframeTrack: track name is undefined");
                if (void 0 === t || 0 === t.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + e1);
                this.name = e1, this.times = Qg(t, this.TimeBufferType), this.values = Qg(n, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
            }
            static toJSON(e1) {
                const t = e1.constructor;
                let n;
                if (t.toJSON !== this.toJSON) n = t.toJSON(e1);
                else {
                    n = {
                        name: e1.name,
                        times: Qg(e1.times, Array),
                        values: Qg(e1.values, Array)
                    };
                    const t = e1.getInterpolation();
                    t !== e1.DefaultInterpolation && (n.interpolation = t);
                }
                return n.type = e1.ValueTypeName, n;
            }
            InterpolantFactoryMethodDiscrete(e1) {
                return new eA(this.times, this.values, this.getValueSize(), e1);
            }
            InterpolantFactoryMethodLinear(e1) {
                return new $g(this.times, this.values, this.getValueSize(), e1);
            }
            InterpolantFactoryMethodSmooth(e1) {
                return new Jg(this.times, this.values, this.getValueSize(), e1);
            }
            setInterpolation(e1) {
                let t;
                switch(e1){
                    case Ts:
                        t = this.InterpolantFactoryMethodDiscrete;
                        break;
                    case Ss:
                        t = this.InterpolantFactoryMethodLinear;
                        break;
                    case Is:
                        t = this.InterpolantFactoryMethodSmooth;
                }
                if (void 0 === t) {
                    const t = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
                    if (void 0 === this.createInterpolant) {
                        if (e1 === this.DefaultInterpolation) throw new Error(t);
                        this.setInterpolation(this.DefaultInterpolation);
                    }
                    return console.warn("THREE.KeyframeTrack:", t), this;
                }
                return this.createInterpolant = t, this;
            }
            getInterpolation() {
                switch(this.createInterpolant){
                    case this.InterpolantFactoryMethodDiscrete:
                        return Ts;
                    case this.InterpolantFactoryMethodLinear:
                        return Ss;
                    case this.InterpolantFactoryMethodSmooth:
                        return Is;
                }
            }
            getValueSize() {
                return this.values.length / this.times.length;
            }
            shift(e1) {
                if (0 !== e1) {
                    const t = this.times;
                    for(let n = 0, i = t.length; n !== i; ++n)t[n] += e1;
                }
                return this;
            }
            scale(e1) {
                if (1 !== e1) {
                    const t = this.times;
                    for(let n = 0, i = t.length; n !== i; ++n)t[n] *= e1;
                }
                return this;
            }
            trim(e1, t) {
                const n = this.times, i = n.length;
                let r = 0, a = i - 1;
                for(; r !== i && n[r] < e1;)++r;
                for(; -1 !== a && n[a] > t;)--a;
                if (++a, 0 !== r || a !== i) {
                    r >= a && (a = Math.max(a, 1), r = a - 1);
                    const e1 = this.getValueSize();
                    this.times = n.slice(r, a), this.values = this.values.slice(r * e1, a * e1);
                }
                return this;
            }
            validate() {
                let e1 = !0;
                const t = this.getValueSize();
                t - Math.floor(t) != 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), e1 = !1);
                const n = this.times, i = this.values, r = n.length;
                0 === r && (console.error("THREE.KeyframeTrack: Track is empty.", this), e1 = !1);
                let a = null;
                for(let t = 0; t !== r; t++){
                    const i = n[t];
                    if ("number" == typeof i && isNaN(i)) {
                        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, t, i), e1 = !1;
                        break;
                    }
                    if (null !== a && a > i) {
                        console.error("THREE.KeyframeTrack: Out of order keys.", this, t, i, a), e1 = !1;
                        break;
                    }
                    a = i;
                }
                if (void 0 !== i && Wg(i)) for(let t = 0, n = i.length; t !== n; ++t){
                    const n = i[t];
                    if (isNaN(n)) {
                        console.error("THREE.KeyframeTrack: Value is not a valid number.", this, t, n), e1 = !1;
                        break;
                    }
                }
                return e1;
            }
            optimize() {
                const e1 = this.times.slice(), t = this.values.slice(), n = this.getValueSize(), i = this.getInterpolation() === Is, r = e1.length - 1;
                let a = 1;
                for(let s = 1; s < r; ++s){
                    let r = !1;
                    const o = e1[s];
                    if (o !== e1[s + 1] && (1 !== s || o !== e1[0])) {
                        if (i) r = !0;
                        else {
                            const e1 = s * n, i = e1 - n, a = e1 + n;
                            for(let s = 0; s !== n; ++s){
                                const n = t[e1 + s];
                                if (n !== t[i + s] || n !== t[a + s]) {
                                    r = !0;
                                    break;
                                }
                            }
                        }
                    }
                    if (r) {
                        if (s !== a) {
                            e1[a] = e1[s];
                            const i = s * n, r = a * n;
                            for(let e1 = 0; e1 !== n; ++e1)t[r + e1] = t[i + e1];
                        }
                        ++a;
                    }
                }
                if (r > 0) {
                    e1[a] = e1[r];
                    for(let e1 = r * n, i = a * n, s = 0; s !== n; ++s)t[i + s] = t[e1 + s];
                    ++a;
                }
                return a !== e1.length ? (this.times = e1.slice(0, a), this.values = t.slice(0, a * n)) : (this.times = e1, this.values = t), this;
            }
            clone() {
                const e1 = this.times.slice(), t = this.values.slice(), n = new this.constructor(this.name, e1, t);
                return n.createInterpolant = this.createInterpolant, n;
            }
        }
        tA.prototype.TimeBufferType = Float32Array, tA.prototype.ValueBufferType = Float32Array, tA.prototype.DefaultInterpolation = Ss;
        class nA extends tA {
        }
        nA.prototype.ValueTypeName = "bool", nA.prototype.ValueBufferType = Array, nA.prototype.DefaultInterpolation = Ts, nA.prototype.InterpolantFactoryMethodLinear = void 0, nA.prototype.InterpolantFactoryMethodSmooth = void 0;
        class iA extends tA {
        }
        iA.prototype.ValueTypeName = "color";
        class rA extends tA {
        }
        rA.prototype.ValueTypeName = "number";
        class aA extends Kg {
            constructor(e1, t, n, i){
                super(e1, t, n, i);
            }
            interpolate_(e1, t, n, i) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = (n - t) / (i - t);
                let l = e1 * s;
                for(let e1 = l + s; l !== e1; l += 4)Dl.slerpFlat(r, 0, a, l - s, a, l, o);
                return r;
            }
        }
        class sA extends tA {
            InterpolantFactoryMethodLinear(e1) {
                return new aA(this.times, this.values, this.getValueSize(), e1);
            }
        }
        sA.prototype.ValueTypeName = "quaternion", sA.prototype.DefaultInterpolation = Ss, sA.prototype.InterpolantFactoryMethodSmooth = void 0;
        class oA extends tA {
        }
        oA.prototype.ValueTypeName = "string", oA.prototype.ValueBufferType = Array, oA.prototype.DefaultInterpolation = Ts, oA.prototype.InterpolantFactoryMethodLinear = void 0, oA.prototype.InterpolantFactoryMethodSmooth = void 0;
        class lA extends tA {
        }
        lA.prototype.ValueTypeName = "vector";
        class cA {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1, n = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : Ls;
                this.name = e1, this.tracks = n, this.duration = t, this.blendMode = i, this.uuid = Ho(), this.duration < 0 && this.resetDuration();
            }
            static parse(e1) {
                const t = [], n = e1.tracks, i = 1 / (e1.fps || 1);
                for(let e1 = 0, r = n.length; e1 !== r; ++e1)t.push(uA(n[e1]).scale(i));
                const r = new this(e1.name, e1.duration, t, e1.blendMode);
                return r.uuid = e1.uuid, r;
            }
            static toJSON(e1) {
                const t = [], n = e1.tracks, i = {
                    name: e1.name,
                    duration: e1.duration,
                    tracks: t,
                    uuid: e1.uuid,
                    blendMode: e1.blendMode
                };
                for(let e1 = 0, i = n.length; e1 !== i; ++e1)t.push(tA.toJSON(n[e1]));
                return i;
            }
            static CreateFromMorphTargetSequence(e1, t, n, i) {
                const r = t.length, a = [];
                for(let e1 = 0; e1 < r; e1++){
                    let s = [], o = [];
                    s.push((e1 + r - 1) % r, e1, (e1 + 1) % r), o.push(0, 1, 0);
                    const l = Yg(s);
                    s = Xg(s, 1, l), o = Xg(o, 1, l), i || 0 !== s[0] || (s.push(r), o.push(o[0])), a.push(new rA(".morphTargetInfluences[" + t[e1].name + "]", s, o).scale(1 / n));
                }
                return new this(e1, -1, a);
            }
            static findByName(e1, t) {
                let n = e1;
                if (!Array.isArray(e1)) {
                    const t = e1;
                    n = t.geometry && t.geometry.animations || t.animations;
                }
                for(let e1 = 0; e1 < n.length; e1++)if (n[e1].name === t) return n[e1];
                return null;
            }
            static CreateClipsFromMorphTargetSequences(e1, t, n) {
                const i = {}, r = /^([\w-]*?)([\d]+)$/;
                for(let t = 0, n = e1.length; t < n; t++){
                    const n = e1[t], a = n.name.match(r);
                    if (a && a.length > 1) {
                        const e1 = a[1];
                        let t = i[e1];
                        t || (i[e1] = t = []), t.push(n);
                    }
                }
                const a = [];
                for(const e1 in i)a.push(this.CreateFromMorphTargetSequence(e1, i[e1], t, n));
                return a;
            }
            static parseAnimation(e1, t) {
                if (!e1) return console.error("THREE.AnimationClip: No animation in JSONLoader data."), null;
                const n = function(e1, t, n, i, r) {
                    if (0 !== n.length) {
                        const a = [], s = [];
                        Zg(n, a, s, i), 0 !== a.length && r.push(new e1(t, a, s));
                    }
                }, i = [], r = e1.name || "default", a = e1.fps || 30, s = e1.blendMode;
                let o = e1.length || -1;
                const l = e1.hierarchy || [];
                for(let e1 = 0; e1 < l.length; e1++){
                    const r = l[e1].keys;
                    if (r && 0 !== r.length) {
                        if (r[0].morphTargets) {
                            const e1 = {};
                            let t;
                            for(t = 0; t < r.length; t++)if (r[t].morphTargets) for(let n = 0; n < r[t].morphTargets.length; n++)e1[r[t].morphTargets[n]] = -1;
                            for(const n in e1){
                                const e1 = [], a = [];
                                for(let i = 0; i !== r[t].morphTargets.length; ++i){
                                    const i = r[t];
                                    e1.push(i.time), a.push(i.morphTarget === n ? 1 : 0);
                                }
                                i.push(new rA(".morphTargetInfluence[" + n + "]", e1, a));
                            }
                            o = e1.length * a;
                        } else {
                            const a = ".bones[" + t[e1].name + "]";
                            n(lA, a + ".position", r, "pos", i), n(sA, a + ".quaternion", r, "rot", i), n(lA, a + ".scale", r, "scl", i);
                        }
                    }
                }
                return 0 === i.length ? null : new this(r, o, i, s);
            }
            resetDuration() {
                let e1 = 0;
                for(let t = 0, n = this.tracks.length; t !== n; ++t){
                    const n = this.tracks[t];
                    e1 = Math.max(e1, n.times[n.times.length - 1]);
                }
                return this.duration = e1, this;
            }
            trim() {
                for(let e1 = 0; e1 < this.tracks.length; e1++)this.tracks[e1].trim(0, this.duration);
                return this;
            }
            validate() {
                let e1 = !0;
                for(let t = 0; t < this.tracks.length; t++)e1 = e1 && this.tracks[t].validate();
                return e1;
            }
            optimize() {
                for(let e1 = 0; e1 < this.tracks.length; e1++)this.tracks[e1].optimize();
                return this;
            }
            clone() {
                const e1 = [];
                for(let t = 0; t < this.tracks.length; t++)e1.push(this.tracks[t].clone());
                return new this.constructor(this.name, this.duration, e1, this.blendMode);
            }
            toJSON() {
                return this.constructor.toJSON(this);
            }
        }
        function uA(e1) {
            if (void 0 === e1.type) throw new Error("THREE.KeyframeTrack: track type undefined, can not parse");
            const t = function(e1) {
                switch(e1.toLowerCase()){
                    case "scalar":
                    case "double":
                    case "float":
                    case "number":
                    case "integer":
                        return rA;
                    case "vector":
                    case "vector2":
                    case "vector3":
                    case "vector4":
                        return lA;
                    case "color":
                        return iA;
                    case "quaternion":
                        return sA;
                    case "bool":
                    case "boolean":
                        return nA;
                    case "string":
                        return oA;
                }
                throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + e1);
            }(e1.type);
            if (void 0 === e1.times) {
                const t = [], n = [];
                Zg(e1.keys, t, n, "value"), e1.times = t, e1.values = n;
            }
            return void 0 !== t.parse ? t.parse(e1) : new t(e1.name, e1.times, e1.values, e1.interpolation);
        }
        const hA = {
            enabled: !1,
            files: {},
            add: function(e1, t) {
                !1 !== this.enabled && (this.files[e1] = t);
            },
            get: function(e1) {
                if (!1 !== this.enabled) return this.files[e1];
            },
            remove: function(e1) {
                delete this.files[e1];
            },
            clear: function() {
                this.files = {};
            }
        };
        class dA {
            constructor(e1, t, n){
                const i = this;
                let r, a = !1, s = 0, o = 0;
                const l = [];
                this.onStart = void 0, this.onLoad = e1, this.onProgress = t, this.onError = n, this.itemStart = function(e1) {
                    o++, !1 === a && void 0 !== i.onStart && i.onStart(e1, s, o), a = !0;
                }, this.itemEnd = function(e1) {
                    s++, void 0 !== i.onProgress && i.onProgress(e1, s, o), s === o && (a = !1, void 0 !== i.onLoad && i.onLoad());
                }, this.itemError = function(e1) {
                    void 0 !== i.onError && i.onError(e1);
                }, this.resolveURL = function(e1) {
                    return r ? r(e1) : e1;
                }, this.setURLModifier = function(e1) {
                    return r = e1, this;
                }, this.addHandler = function(e1, t) {
                    return l.push(e1, t), this;
                }, this.removeHandler = function(e1) {
                    const t = l.indexOf(e1);
                    return -1 !== t && l.splice(t, 2), this;
                }, this.getHandler = function(e1) {
                    for(let t = 0, n = l.length; t < n; t += 2){
                        const n = l[t], i = l[t + 1];
                        if (n.global && (n.lastIndex = 0), n.test(e1)) return i;
                    }
                    return null;
                };
            }
        }
        const pA = new dA;
        class fA {
            constructor(e1){
                this.manager = void 0 !== e1 ? e1 : pA, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
            }
            load() {}
            loadAsync(e1, t) {
                const n = this;
                return new Promise(function(i, r) {
                    n.load(e1, i, t, r);
                });
            }
            parse() {}
            setCrossOrigin(e1) {
                return this.crossOrigin = e1, this;
            }
            setWithCredentials(e1) {
                return this.withCredentials = e1, this;
            }
            setPath(e1) {
                return this.path = e1, this;
            }
            setResourcePath(e1) {
                return this.resourcePath = e1, this;
            }
            setRequestHeader(e1) {
                return this.requestHeader = e1, this;
            }
        }
        fA.DEFAULT_MATERIAL_NAME = "__DEFAULT";
        const mA = {};
        class gA extends Error {
            constructor(e1, t){
                super(e1), this.response = t;
            }
        }
        class AA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                void 0 === e1 && (e1 = ""), void 0 !== this.path && (e1 = this.path + e1), e1 = this.manager.resolveURL(e1);
                const r = hA.get(e1);
                if (void 0 !== r) return this.manager.itemStart(e1), setTimeout(()=>{
                    t && t(r), this.manager.itemEnd(e1);
                }, 0), r;
                if (void 0 !== mA[e1]) return void mA[e1].push({
                    onLoad: t,
                    onProgress: n,
                    onError: i
                });
                mA[e1] = [], mA[e1].push({
                    onLoad: t,
                    onProgress: n,
                    onError: i
                });
                const a = new Request(e1, {
                    headers: new Headers(this.requestHeader),
                    credentials: this.withCredentials ? "include" : "same-origin"
                }), s = this.mimeType, o = this.responseType;
                fetch(a).then((t)=>{
                    if (200 === t.status || 0 === t.status) {
                        if (0 === t.status && console.warn("THREE.FileLoader: HTTP Status 0 received."), "undefined" == typeof ReadableStream || void 0 === t.body || void 0 === t.body.getReader) return t;
                        const n = mA[e1], i = t.body.getReader(), r = t.headers.get("Content-Length") || t.headers.get("X-File-Size"), a = r ? parseInt(r) : 0, s = 0 !== a;
                        let o = 0;
                        const l = new ReadableStream({
                            start (e1) {
                                !function t() {
                                    i.read().then((i)=>{
                                        let { done: r, value: l } = i;
                                        if (r) e1.close();
                                        else {
                                            o += l.byteLength;
                                            const i = new ProgressEvent("progress", {
                                                lengthComputable: s,
                                                loaded: o,
                                                total: a
                                            });
                                            for(let e1 = 0, t = n.length; e1 < t; e1++){
                                                const t = n[e1];
                                                t.onProgress && t.onProgress(i);
                                            }
                                            e1.enqueue(l), t();
                                        }
                                    });
                                }();
                            }
                        });
                        return new Response(l);
                    }
                    throw new gA('fetch for "'.concat(t.url, '" responded with ').concat(t.status, ": ").concat(t.statusText), t);
                }).then((e1)=>{
                    switch(o){
                        case "arraybuffer":
                            return e1.arrayBuffer();
                        case "blob":
                            return e1.blob();
                        case "document":
                            return e1.text().then((e1)=>(new DOMParser).parseFromString(e1, s));
                        case "json":
                            return e1.json();
                        default:
                            if (void 0 === s) return e1.text();
                            {
                                const t = /charset="?([^;"\s]*)"?/i.exec(s), n = t && t[1] ? t[1].toLowerCase() : void 0, i = new TextDecoder(n);
                                return e1.arrayBuffer().then((e1)=>i.decode(e1));
                            }
                    }
                }).then((t)=>{
                    hA.add(e1, t);
                    const n = mA[e1];
                    delete mA[e1];
                    for(let e1 = 0, i = n.length; e1 < i; e1++){
                        const i = n[e1];
                        i.onLoad && i.onLoad(t);
                    }
                }).catch((t)=>{
                    const n = mA[e1];
                    if (void 0 === n) throw this.manager.itemError(e1), t;
                    delete mA[e1];
                    for(let e1 = 0, i = n.length; e1 < i; e1++){
                        const i = n[e1];
                        i.onError && i.onError(t);
                    }
                    this.manager.itemError(e1);
                }).finally(()=>{
                    this.manager.itemEnd(e1);
                }), this.manager.itemStart(e1);
            }
            setResponseType(e1) {
                return this.responseType = e1, this;
            }
            setMimeType(e1) {
                return this.mimeType = e1, this;
            }
        }
        class vA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = this, a = new AA(this.manager);
                a.setPath(this.path), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(e1, function(n) {
                    try {
                        t(r.parse(JSON.parse(n)));
                    } catch (t) {
                        i ? i(t) : console.error(t), r.manager.itemError(e1);
                    }
                }, n, i);
            }
            parse(e1) {
                const t = [];
                for(let n = 0; n < e1.length; n++){
                    const i = cA.parse(e1[n]);
                    t.push(i);
                }
                return t;
            }
        }
        class MA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = this, a = [], s = new cm, o = new AA(this.manager);
                o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(r.withCredentials);
                let l = 0;
                function c(c) {
                    o.load(e1[c], function(e1) {
                        const n = r.parse(e1, !0);
                        a[c] = {
                            width: n.width,
                            height: n.height,
                            format: n.format,
                            mipmaps: n.mipmaps
                        }, l += 1, 6 === l && (1 === n.mipmapCount && (s.minFilter = va), s.image = a, s.format = n.format, s.needsUpdate = !0, t && t(s));
                    }, n, i);
                }
                if (Array.isArray(e1)) for(let t = 0, n = e1.length; t < n; ++t)c(t);
                else o.load(e1, function(e1) {
                    const n = r.parse(e1, !0);
                    if (n.isCubemap) {
                        const e1 = n.mipmaps.length / n.mipmapCount;
                        for(let t = 0; t < e1; t++){
                            a[t] = {
                                mipmaps: []
                            };
                            for(let e1 = 0; e1 < n.mipmapCount; e1++)a[t].mipmaps.push(n.mipmaps[t * n.mipmapCount + e1]), a[t].format = n.format, a[t].width = n.width, a[t].height = n.height;
                        }
                        s.image = a;
                    } else s.image.width = n.width, s.image.height = n.height, s.mipmaps = n.mipmaps;
                    1 === n.mipmapCount && (s.minFilter = va), s.format = n.format, s.needsUpdate = !0, t && t(s);
                }, n, i);
                return s;
            }
        }
        class yA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                void 0 !== this.path && (e1 = this.path + e1), e1 = this.manager.resolveURL(e1);
                const r = this, a = hA.get(e1);
                if (void 0 !== a) return r.manager.itemStart(e1), setTimeout(function() {
                    t && t(a), r.manager.itemEnd(e1);
                }, 0), a;
                const s = rl("img");
                function o() {
                    c(), hA.add(e1, this), t && t(this), r.manager.itemEnd(e1);
                }
                function l(t) {
                    c(), i && i(t), r.manager.itemError(e1), r.manager.itemEnd(e1);
                }
                function c() {
                    s.removeEventListener("load", o, !1), s.removeEventListener("error", l, !1);
                }
                return s.addEventListener("load", o, !1), s.addEventListener("error", l, !1), "data:" !== e1.slice(0, 5) && void 0 !== this.crossOrigin && (s.crossOrigin = this.crossOrigin), r.manager.itemStart(e1), s.src = e1, s;
            }
        }
        class xA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = new th;
                r.colorSpace = Gs;
                const a = new yA(this.manager);
                a.setCrossOrigin(this.crossOrigin), a.setPath(this.path);
                let s = 0;
                function o(n) {
                    a.load(e1[n], function(e1) {
                        r.images[n] = e1, s++, 6 === s && (r.needsUpdate = !0, t && t(r));
                    }, void 0, i);
                }
                for(let t = 0; t < e1.length; ++t)o(t);
                return r;
            }
        }
        class _A extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = this, a = new Df, s = new AA(this.manager);
                return s.setResponseType("arraybuffer"), s.setRequestHeader(this.requestHeader), s.setPath(this.path), s.setWithCredentials(r.withCredentials), s.load(e1, function(e1) {
                    let n;
                    try {
                        n = r.parse(e1);
                    } catch (e1) {
                        if (void 0 === i) return void console.error(e1);
                        i(e1);
                    }
                    void 0 !== n.image ? a.image = n.image : void 0 !== n.data && (a.image.width = n.width, a.image.height = n.height, a.image.data = n.data), a.wrapS = void 0 !== n.wrapS ? n.wrapS : ha, a.wrapT = void 0 !== n.wrapT ? n.wrapT : ha, a.magFilter = void 0 !== n.magFilter ? n.magFilter : va, a.minFilter = void 0 !== n.minFilter ? n.minFilter : va, a.anisotropy = void 0 !== n.anisotropy ? n.anisotropy : 1, void 0 !== n.colorSpace ? a.colorSpace = n.colorSpace : void 0 !== n.encoding && (a.encoding = n.encoding), void 0 !== n.flipY && (a.flipY = n.flipY), void 0 !== n.format && (a.format = n.format), void 0 !== n.type && (a.type = n.type), void 0 !== n.mipmaps && (a.mipmaps = n.mipmaps, a.minFilter = xa), 1 === n.mipmapCount && (a.minFilter = va), void 0 !== n.generateMipmaps && (a.generateMipmaps = n.generateMipmaps), a.needsUpdate = !0, t && t(a, n);
                }, n, i), a;
            }
        }
        class bA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = new xl, a = new yA(this.manager);
                return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(e1, function(e1) {
                    r.image = e1, r.needsUpdate = !0, void 0 !== t && t(r);
                }, n, i), r;
            }
        }
        class wA extends Lc {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                super(), this.isLight = !0, this.type = "Light", this.color = new Zc(e1), this.intensity = t;
            }
            dispose() {}
            copy(e1, t) {
                return super.copy(e1, t), this.color.copy(e1.color), this.intensity = e1.intensity, this;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return t.object.color = this.color.getHex(), t.object.intensity = this.intensity, void 0 !== this.groundColor && (t.object.groundColor = this.groundColor.getHex()), void 0 !== this.distance && (t.object.distance = this.distance), void 0 !== this.angle && (t.object.angle = this.angle), void 0 !== this.decay && (t.object.decay = this.decay), void 0 !== this.penumbra && (t.object.penumbra = this.penumbra), void 0 !== this.shadow && (t.object.shadow = this.shadow.toJSON()), t;
            }
        }
        class EA extends wA {
            constructor(e1, t, n){
                super(e1, n), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(Lc.DEFAULT_UP), this.updateMatrix(), this.groundColor = new Zc(t);
            }
            copy(e1, t) {
                return super.copy(e1, t), this.groundColor.copy(e1.groundColor), this;
            }
        }
        const TA = new oc, SA = new Cl, IA = new Cl;
        class NA {
            constructor(e1){
                this.camera = e1, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new Jo(512, 512), this.map = null, this.mapPass = null, this.matrix = new oc, this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new ch, this._frameExtents = new Jo(1, 1), this._viewportCount = 1, this._viewports = [
                    new _l(0, 0, 1, 1)
                ];
            }
            getViewportCount() {
                return this._viewportCount;
            }
            getFrustum() {
                return this._frustum;
            }
            updateMatrices(e1) {
                const t = this.camera, n = this.matrix;
                SA.setFromMatrixPosition(e1.matrixWorld), t.position.copy(SA), IA.setFromMatrixPosition(e1.target.matrixWorld), t.lookAt(IA), t.updateMatrixWorld(), TA.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse), this._frustum.setFromProjectionMatrix(TA), n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), n.multiply(TA);
            }
            getViewport(e1) {
                return this._viewports[e1];
            }
            getFrameExtents() {
                return this._frameExtents;
            }
            dispose() {
                this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
            }
            copy(e1) {
                return this.camera = e1.camera.clone(), this.bias = e1.bias, this.radius = e1.radius, this.mapSize.copy(e1.mapSize), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            toJSON() {
                const e1 = {};
                return 0 !== this.bias && (e1.bias = this.bias), 0 !== this.normalBias && (e1.normalBias = this.normalBias), 1 !== this.radius && (e1.radius = this.radius), 512 === this.mapSize.x && 512 === this.mapSize.y || (e1.mapSize = this.mapSize.toArray()), e1.camera = this.camera.toJSON(!1).object, delete e1.camera.matrix, e1;
            }
        }
        class DA extends NA {
            constructor(){
                super(new Ju(50, 1, .5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
            }
            updateMatrices(e1) {
                const t = this.camera, n = 2 * Fo * e1.angle * this.focus, i = this.mapSize.width / this.mapSize.height, r = e1.distance || t.far;
                n === t.fov && i === t.aspect && r === t.far || (t.fov = n, t.aspect = i, t.far = r, t.updateProjectionMatrix()), super.updateMatrices(e1);
            }
            copy(e1) {
                return super.copy(e1), this.focus = e1.focus, this;
            }
        }
        class CA extends wA {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : Math.PI / 3, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 2;
                super(e1, t), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(Lc.DEFAULT_UP), this.updateMatrix(), this.target = new Lc, this.distance = n, this.angle = i, this.penumbra = r, this.decay = a, this.map = null, this.shadow = new DA;
            }
            get power() {
                return this.intensity * Math.PI;
            }
            set power(e1) {
                this.intensity = e1 / Math.PI;
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(e1, t) {
                return super.copy(e1, t), this.distance = e1.distance, this.angle = e1.angle, this.penumbra = e1.penumbra, this.decay = e1.decay, this.target = e1.target.clone(), this.shadow = e1.shadow.clone(), this;
            }
        }
        const LA = new oc, RA = new Cl, zA = new Cl;
        class OA extends NA {
            constructor(){
                super(new Ju(90, 1, .5, 500)), this.isPointLightShadow = !0, this._frameExtents = new Jo(4, 2), this._viewportCount = 6, this._viewports = [
                    new _l(2, 1, 1, 1),
                    new _l(0, 1, 1, 1),
                    new _l(3, 1, 1, 1),
                    new _l(1, 1, 1, 1),
                    new _l(3, 0, 1, 1),
                    new _l(1, 0, 1, 1)
                ], this._cubeDirections = [
                    new Cl(1, 0, 0),
                    new Cl(-1, 0, 0),
                    new Cl(0, 0, 1),
                    new Cl(0, 0, -1),
                    new Cl(0, 1, 0),
                    new Cl(0, -1, 0)
                ], this._cubeUps = [
                    new Cl(0, 1, 0),
                    new Cl(0, 1, 0),
                    new Cl(0, 1, 0),
                    new Cl(0, 1, 0),
                    new Cl(0, 0, 1),
                    new Cl(0, 0, -1)
                ];
            }
            updateMatrices(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.camera, i = this.matrix, r = e1.distance || n.far;
                r !== n.far && (n.far = r, n.updateProjectionMatrix()), RA.setFromMatrixPosition(e1.matrixWorld), n.position.copy(RA), zA.copy(n.position), zA.add(this._cubeDirections[t]), n.up.copy(this._cubeUps[t]), n.lookAt(zA), n.updateMatrixWorld(), i.makeTranslation(-RA.x, -RA.y, -RA.z), LA.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), this._frustum.setFromProjectionMatrix(LA);
            }
        }
        class PA extends wA {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 2;
                super(e1, t), this.isPointLight = !0, this.type = "PointLight", this.distance = n, this.decay = i, this.shadow = new OA;
            }
            get power() {
                return 4 * this.intensity * Math.PI;
            }
            set power(e1) {
                this.intensity = e1 / (4 * Math.PI);
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(e1, t) {
                return super.copy(e1, t), this.distance = e1.distance, this.decay = e1.decay, this.shadow = e1.shadow.clone(), this;
            }
        }
        class UA extends NA {
            constructor(){
                super(new bh(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
            }
        }
        class kA extends wA {
            constructor(e1, t){
                super(e1, t), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(Lc.DEFAULT_UP), this.updateMatrix(), this.target = new Lc, this.shadow = new UA;
            }
            dispose() {
                this.shadow.dispose();
            }
            copy(e1) {
                return super.copy(e1), this.target = e1.target.clone(), this.shadow = e1.shadow.clone(), this;
            }
        }
        class jA extends wA {
            constructor(e1, t){
                super(e1, t), this.isAmbientLight = !0, this.type = "AmbientLight";
            }
        }
        class BA extends wA {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 10;
                super(e1, t), this.isRectAreaLight = !0, this.type = "RectAreaLight", this.width = n, this.height = i;
            }
            get power() {
                return this.intensity * this.width * this.height * Math.PI;
            }
            set power(e1) {
                this.intensity = e1 / (this.width * this.height * Math.PI);
            }
            copy(e1) {
                return super.copy(e1), this.width = e1.width, this.height = e1.height, this;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return t.object.width = this.width, t.object.height = this.height, t;
            }
        }
        class FA {
            constructor(){
                this.isSphericalHarmonics3 = !0, this.coefficients = [];
                for(let e1 = 0; e1 < 9; e1++)this.coefficients.push(new Cl);
            }
            set(e1) {
                for(let t = 0; t < 9; t++)this.coefficients[t].copy(e1[t]);
                return this;
            }
            zero() {
                for(let e1 = 0; e1 < 9; e1++)this.coefficients[e1].set(0, 0, 0);
                return this;
            }
            getAt(e1, t) {
                const n = e1.x, i = e1.y, r = e1.z, a = this.coefficients;
                return t.copy(a[0]).multiplyScalar(.282095), t.addScaledVector(a[1], .488603 * i), t.addScaledVector(a[2], .488603 * r), t.addScaledVector(a[3], .488603 * n), t.addScaledVector(a[4], n * i * 1.092548), t.addScaledVector(a[5], i * r * 1.092548), t.addScaledVector(a[6], .315392 * (3 * r * r - 1)), t.addScaledVector(a[7], n * r * 1.092548), t.addScaledVector(a[8], .546274 * (n * n - i * i)), t;
            }
            getIrradianceAt(e1, t) {
                const n = e1.x, i = e1.y, r = e1.z, a = this.coefficients;
                return t.copy(a[0]).multiplyScalar(.886227), t.addScaledVector(a[1], 1.023328 * i), t.addScaledVector(a[2], 1.023328 * r), t.addScaledVector(a[3], 1.023328 * n), t.addScaledVector(a[4], .858086 * n * i), t.addScaledVector(a[5], .858086 * i * r), t.addScaledVector(a[6], .743125 * r * r - .247708), t.addScaledVector(a[7], .858086 * n * r), t.addScaledVector(a[8], .429043 * (n * n - i * i)), t;
            }
            add(e1) {
                for(let t = 0; t < 9; t++)this.coefficients[t].add(e1.coefficients[t]);
                return this;
            }
            addScaledSH(e1, t) {
                for(let n = 0; n < 9; n++)this.coefficients[n].addScaledVector(e1.coefficients[n], t);
                return this;
            }
            scale(e1) {
                for(let t = 0; t < 9; t++)this.coefficients[t].multiplyScalar(e1);
                return this;
            }
            lerp(e1, t) {
                for(let n = 0; n < 9; n++)this.coefficients[n].lerp(e1.coefficients[n], t);
                return this;
            }
            equals(e1) {
                for(let t = 0; t < 9; t++)if (!this.coefficients[t].equals(e1.coefficients[t])) return !1;
                return !0;
            }
            copy(e1) {
                return this.set(e1.coefficients);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.coefficients;
                for(let i = 0; i < 9; i++)n[i].fromArray(e1, t + 3 * i);
                return this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.coefficients;
                for(let i = 0; i < 9; i++)n[i].toArray(e1, t + 3 * i);
                return e1;
            }
            static getBasisAt(e1, t) {
                const n = e1.x, i = e1.y, r = e1.z;
                t[0] = .282095, t[1] = .488603 * i, t[2] = .488603 * r, t[3] = .488603 * n, t[4] = 1.092548 * n * i, t[5] = 1.092548 * i * r, t[6] = .315392 * (3 * r * r - 1), t[7] = 1.092548 * n * r, t[8] = .546274 * (n * n - i * i);
            }
        }
        class HA extends wA {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new FA;
                super(void 0, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1), this.isLightProbe = !0, this.sh = e1;
            }
            copy(e1) {
                return super.copy(e1), this.sh.copy(e1.sh), this;
            }
            fromJSON(e1) {
                return this.intensity = e1.intensity, this.sh.fromArray(e1.sh), this;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return t.object.sh = this.sh.toArray(), t;
            }
        }
        class VA extends fA {
            constructor(e1){
                super(e1), this.textures = {};
            }
            load(e1, t, n, i) {
                const r = this, a = new AA(r.manager);
                a.setPath(r.path), a.setRequestHeader(r.requestHeader), a.setWithCredentials(r.withCredentials), a.load(e1, function(n) {
                    try {
                        t(r.parse(JSON.parse(n)));
                    } catch (t) {
                        i ? i(t) : console.error(t), r.manager.itemError(e1);
                    }
                }, n, i);
            }
            parse(e1) {
                const t = this.textures;
                function n(e1) {
                    return void 0 === t[e1] && console.warn("THREE.MaterialLoader: Undefined texture", e1), t[e1];
                }
                const i = VA.createMaterialFromType(e1.type);
                if (void 0 !== e1.uuid && (i.uuid = e1.uuid), void 0 !== e1.name && (i.name = e1.name), void 0 !== e1.color && void 0 !== i.color && i.color.setHex(e1.color), void 0 !== e1.roughness && (i.roughness = e1.roughness), void 0 !== e1.metalness && (i.metalness = e1.metalness), void 0 !== e1.sheen && (i.sheen = e1.sheen), void 0 !== e1.sheenColor && (i.sheenColor = (new Zc).setHex(e1.sheenColor)), void 0 !== e1.sheenRoughness && (i.sheenRoughness = e1.sheenRoughness), void 0 !== e1.emissive && void 0 !== i.emissive && i.emissive.setHex(e1.emissive), void 0 !== e1.specular && void 0 !== i.specular && i.specular.setHex(e1.specular), void 0 !== e1.specularIntensity && (i.specularIntensity = e1.specularIntensity), void 0 !== e1.specularColor && void 0 !== i.specularColor && i.specularColor.setHex(e1.specularColor), void 0 !== e1.shininess && (i.shininess = e1.shininess), void 0 !== e1.clearcoat && (i.clearcoat = e1.clearcoat), void 0 !== e1.clearcoatRoughness && (i.clearcoatRoughness = e1.clearcoatRoughness), void 0 !== e1.iridescence && (i.iridescence = e1.iridescence), void 0 !== e1.iridescenceIOR && (i.iridescenceIOR = e1.iridescenceIOR), void 0 !== e1.iridescenceThicknessRange && (i.iridescenceThicknessRange = e1.iridescenceThicknessRange), void 0 !== e1.transmission && (i.transmission = e1.transmission), void 0 !== e1.thickness && (i.thickness = e1.thickness), void 0 !== e1.attenuationDistance && (i.attenuationDistance = e1.attenuationDistance), void 0 !== e1.attenuationColor && void 0 !== i.attenuationColor && i.attenuationColor.setHex(e1.attenuationColor), void 0 !== e1.anisotropy && (i.anisotropy = e1.anisotropy), void 0 !== e1.anisotropyRotation && (i.anisotropyRotation = e1.anisotropyRotation), void 0 !== e1.fog && (i.fog = e1.fog), void 0 !== e1.flatShading && (i.flatShading = e1.flatShading), void 0 !== e1.blending && (i.blending = e1.blending), void 0 !== e1.combine && (i.combine = e1.combine), void 0 !== e1.side && (i.side = e1.side), void 0 !== e1.shadowSide && (i.shadowSide = e1.shadowSide), void 0 !== e1.opacity && (i.opacity = e1.opacity), void 0 !== e1.transparent && (i.transparent = e1.transparent), void 0 !== e1.alphaTest && (i.alphaTest = e1.alphaTest), void 0 !== e1.alphaHash && (i.alphaHash = e1.alphaHash), void 0 !== e1.depthFunc && (i.depthFunc = e1.depthFunc), void 0 !== e1.depthTest && (i.depthTest = e1.depthTest), void 0 !== e1.depthWrite && (i.depthWrite = e1.depthWrite), void 0 !== e1.colorWrite && (i.colorWrite = e1.colorWrite), void 0 !== e1.blendSrc && (i.blendSrc = e1.blendSrc), void 0 !== e1.blendDst && (i.blendDst = e1.blendDst), void 0 !== e1.blendEquation && (i.blendEquation = e1.blendEquation), void 0 !== e1.blendSrcAlpha && (i.blendSrcAlpha = e1.blendSrcAlpha), void 0 !== e1.blendDstAlpha && (i.blendDstAlpha = e1.blendDstAlpha), void 0 !== e1.blendEquationAlpha && (i.blendEquationAlpha = e1.blendEquationAlpha), void 0 !== e1.blendColor && void 0 !== i.blendColor && i.blendColor.setHex(e1.blendColor), void 0 !== e1.blendAlpha && (i.blendAlpha = e1.blendAlpha), void 0 !== e1.stencilWriteMask && (i.stencilWriteMask = e1.stencilWriteMask), void 0 !== e1.stencilFunc && (i.stencilFunc = e1.stencilFunc), void 0 !== e1.stencilRef && (i.stencilRef = e1.stencilRef), void 0 !== e1.stencilFuncMask && (i.stencilFuncMask = e1.stencilFuncMask), void 0 !== e1.stencilFail && (i.stencilFail = e1.stencilFail), void 0 !== e1.stencilZFail && (i.stencilZFail = e1.stencilZFail), void 0 !== e1.stencilZPass && (i.stencilZPass = e1.stencilZPass), void 0 !== e1.stencilWrite && (i.stencilWrite = e1.stencilWrite), void 0 !== e1.wireframe && (i.wireframe = e1.wireframe), void 0 !== e1.wireframeLinewidth && (i.wireframeLinewidth = e1.wireframeLinewidth), void 0 !== e1.wireframeLinecap && (i.wireframeLinecap = e1.wireframeLinecap), void 0 !== e1.wireframeLinejoin && (i.wireframeLinejoin = e1.wireframeLinejoin), void 0 !== e1.rotation && (i.rotation = e1.rotation), void 0 !== e1.linewidth && (i.linewidth = e1.linewidth), void 0 !== e1.dashSize && (i.dashSize = e1.dashSize), void 0 !== e1.gapSize && (i.gapSize = e1.gapSize), void 0 !== e1.scale && (i.scale = e1.scale), void 0 !== e1.polygonOffset && (i.polygonOffset = e1.polygonOffset), void 0 !== e1.polygonOffsetFactor && (i.polygonOffsetFactor = e1.polygonOffsetFactor), void 0 !== e1.polygonOffsetUnits && (i.polygonOffsetUnits = e1.polygonOffsetUnits), void 0 !== e1.dithering && (i.dithering = e1.dithering), void 0 !== e1.alphaToCoverage && (i.alphaToCoverage = e1.alphaToCoverage), void 0 !== e1.premultipliedAlpha && (i.premultipliedAlpha = e1.premultipliedAlpha), void 0 !== e1.forceSinglePass && (i.forceSinglePass = e1.forceSinglePass), void 0 !== e1.visible && (i.visible = e1.visible), void 0 !== e1.toneMapped && (i.toneMapped = e1.toneMapped), void 0 !== e1.userData && (i.userData = e1.userData), void 0 !== e1.vertexColors && ("number" == typeof e1.vertexColors ? i.vertexColors = e1.vertexColors > 0 : i.vertexColors = e1.vertexColors), void 0 !== e1.uniforms) for(const t in e1.uniforms){
                    const r = e1.uniforms[t];
                    switch(i.uniforms[t] = {}, r.type){
                        case "t":
                            i.uniforms[t].value = n(r.value);
                            break;
                        case "c":
                            i.uniforms[t].value = (new Zc).setHex(r.value);
                            break;
                        case "v2":
                            i.uniforms[t].value = (new Jo).fromArray(r.value);
                            break;
                        case "v3":
                            i.uniforms[t].value = (new Cl).fromArray(r.value);
                            break;
                        case "v4":
                            i.uniforms[t].value = (new _l).fromArray(r.value);
                            break;
                        case "m3":
                            i.uniforms[t].value = (new $o).fromArray(r.value);
                            break;
                        case "m4":
                            i.uniforms[t].value = (new oc).fromArray(r.value);
                            break;
                        default:
                            i.uniforms[t].value = r.value;
                    }
                }
                if (void 0 !== e1.defines && (i.defines = e1.defines), void 0 !== e1.vertexShader && (i.vertexShader = e1.vertexShader), void 0 !== e1.fragmentShader && (i.fragmentShader = e1.fragmentShader), void 0 !== e1.glslVersion && (i.glslVersion = e1.glslVersion), void 0 !== e1.extensions) for(const t in e1.extensions)i.extensions[t] = e1.extensions[t];
                if (void 0 !== e1.lights && (i.lights = e1.lights), void 0 !== e1.clipping && (i.clipping = e1.clipping), void 0 !== e1.size && (i.size = e1.size), void 0 !== e1.sizeAttenuation && (i.sizeAttenuation = e1.sizeAttenuation), void 0 !== e1.map && (i.map = n(e1.map)), void 0 !== e1.matcap && (i.matcap = n(e1.matcap)), void 0 !== e1.alphaMap && (i.alphaMap = n(e1.alphaMap)), void 0 !== e1.bumpMap && (i.bumpMap = n(e1.bumpMap)), void 0 !== e1.bumpScale && (i.bumpScale = e1.bumpScale), void 0 !== e1.normalMap && (i.normalMap = n(e1.normalMap)), void 0 !== e1.normalMapType && (i.normalMapType = e1.normalMapType), void 0 !== e1.normalScale) {
                    let t = e1.normalScale;
                    !1 === Array.isArray(t) && (t = [
                        t,
                        t
                    ]), i.normalScale = (new Jo).fromArray(t);
                }
                return void 0 !== e1.displacementMap && (i.displacementMap = n(e1.displacementMap)), void 0 !== e1.displacementScale && (i.displacementScale = e1.displacementScale), void 0 !== e1.displacementBias && (i.displacementBias = e1.displacementBias), void 0 !== e1.roughnessMap && (i.roughnessMap = n(e1.roughnessMap)), void 0 !== e1.metalnessMap && (i.metalnessMap = n(e1.metalnessMap)), void 0 !== e1.emissiveMap && (i.emissiveMap = n(e1.emissiveMap)), void 0 !== e1.emissiveIntensity && (i.emissiveIntensity = e1.emissiveIntensity), void 0 !== e1.specularMap && (i.specularMap = n(e1.specularMap)), void 0 !== e1.specularIntensityMap && (i.specularIntensityMap = n(e1.specularIntensityMap)), void 0 !== e1.specularColorMap && (i.specularColorMap = n(e1.specularColorMap)), void 0 !== e1.envMap && (i.envMap = n(e1.envMap)), void 0 !== e1.envMapIntensity && (i.envMapIntensity = e1.envMapIntensity), void 0 !== e1.reflectivity && (i.reflectivity = e1.reflectivity), void 0 !== e1.refractionRatio && (i.refractionRatio = e1.refractionRatio), void 0 !== e1.lightMap && (i.lightMap = n(e1.lightMap)), void 0 !== e1.lightMapIntensity && (i.lightMapIntensity = e1.lightMapIntensity), void 0 !== e1.aoMap && (i.aoMap = n(e1.aoMap)), void 0 !== e1.aoMapIntensity && (i.aoMapIntensity = e1.aoMapIntensity), void 0 !== e1.gradientMap && (i.gradientMap = n(e1.gradientMap)), void 0 !== e1.clearcoatMap && (i.clearcoatMap = n(e1.clearcoatMap)), void 0 !== e1.clearcoatRoughnessMap && (i.clearcoatRoughnessMap = n(e1.clearcoatRoughnessMap)), void 0 !== e1.clearcoatNormalMap && (i.clearcoatNormalMap = n(e1.clearcoatNormalMap)), void 0 !== e1.clearcoatNormalScale && (i.clearcoatNormalScale = (new Jo).fromArray(e1.clearcoatNormalScale)), void 0 !== e1.iridescenceMap && (i.iridescenceMap = n(e1.iridescenceMap)), void 0 !== e1.iridescenceThicknessMap && (i.iridescenceThicknessMap = n(e1.iridescenceThicknessMap)), void 0 !== e1.transmissionMap && (i.transmissionMap = n(e1.transmissionMap)), void 0 !== e1.thicknessMap && (i.thicknessMap = n(e1.thicknessMap)), void 0 !== e1.anisotropyMap && (i.anisotropyMap = n(e1.anisotropyMap)), void 0 !== e1.sheenColorMap && (i.sheenColorMap = n(e1.sheenColorMap)), void 0 !== e1.sheenRoughnessMap && (i.sheenRoughnessMap = n(e1.sheenRoughnessMap)), i;
            }
            setTextures(e1) {
                return this.textures = e1, this;
            }
            static createMaterialFromType(e1) {
                return new ({
                    ShadowMaterial: Og,
                    SpriteMaterial: $p,
                    RawShaderMaterial: Pg,
                    ShaderMaterial: qu,
                    PointsMaterial: em,
                    MeshPhysicalMaterial: kg,
                    MeshStandardMaterial: Ug,
                    MeshPhongMaterial: jg,
                    MeshToonMaterial: Bg,
                    MeshNormalMaterial: Fg,
                    MeshLambertMaterial: Hg,
                    MeshDepthMaterial: Cp,
                    MeshDistanceMaterial: Lp,
                    MeshBasicMaterial: $c,
                    MeshMatcapMaterial: Vg,
                    LineDashedMaterial: Gg,
                    LineBasicMaterial: Vf,
                    Material: Jc
                })[e1];
            }
        }
        class GA {
            static decodeText(e1) {
                if ("undefined" != typeof TextDecoder) return (new TextDecoder).decode(e1);
                let t = "";
                for(let n = 0, i = e1.length; n < i; n++)t += String.fromCharCode(e1[n]);
                try {
                    return decodeURIComponent(escape(t));
                } catch (e1) {
                    return t;
                }
            }
            static extractUrlBase(e1) {
                const t = e1.lastIndexOf("/");
                return -1 === t ? "./" : e1.slice(0, t + 1);
            }
            static resolveURL(e1, t) {
                return "string" != typeof e1 || "" === e1 ? "" : (/^https?:\/\//i.test(t) && /^\//.test(e1) && (t = t.replace(/(^https?:\/\/[^\/]+).*/i, "$1")), /^(https?:)?\/\//i.test(e1) || /^data:.*,.*$/i.test(e1) || /^blob:.*$/i.test(e1) ? e1 : t + e1);
            }
        }
        class QA extends Eu {
            constructor(){
                super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
            }
            copy(e1) {
                return super.copy(e1), this.instanceCount = e1.instanceCount, this;
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.instanceCount = this.instanceCount, e1.isInstancedBufferGeometry = !0, e1;
            }
        }
        class WA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = this, a = new AA(r.manager);
                a.setPath(r.path), a.setRequestHeader(r.requestHeader), a.setWithCredentials(r.withCredentials), a.load(e1, function(n) {
                    try {
                        t(r.parse(JSON.parse(n)));
                    } catch (t) {
                        i ? i(t) : console.error(t), r.manager.itemError(e1);
                    }
                }, n, i);
            }
            parse(e1) {
                const t = {}, n = {};
                function i(e1, i) {
                    if (void 0 !== t[i]) return t[i];
                    const r = e1.interleavedBuffers[i], a = function(e1, t) {
                        if (void 0 !== n[t]) return n[t];
                        const i = e1.arrayBuffers[t], r = new Uint32Array(i).buffer;
                        return n[t] = r, r;
                    }(e1, r.buffer), s = il(r.type, a), o = new qp(s, r.stride);
                    return o.uuid = r.uuid, t[i] = o, o;
                }
                const r = e1.isInstancedBufferGeometry ? new QA : new Eu, a = e1.data.index;
                if (void 0 !== a) {
                    const e1 = il(a.type, a.array);
                    r.setIndex(new ou(e1, 1));
                }
                const s = e1.data.attributes;
                for(const t in s){
                    const n = s[t];
                    let a;
                    if (n.isInterleavedBufferAttribute) {
                        const t = i(e1.data, n.data);
                        a = new Jp(t, n.itemSize, n.offset, n.normalized);
                    } else {
                        const e1 = il(n.type, n.array);
                        a = new (n.isInstancedBufferAttribute ? zf : ou)(e1, n.itemSize, n.normalized);
                    }
                    void 0 !== n.name && (a.name = n.name), void 0 !== n.usage && a.setUsage(n.usage), void 0 !== n.updateRange && (a.updateRange.offset = n.updateRange.offset, a.updateRange.count = n.updateRange.count), r.setAttribute(t, a);
                }
                const o = e1.data.morphAttributes;
                if (o) for(const t in o){
                    const n = o[t], a = [];
                    for(let t = 0, r = n.length; t < r; t++){
                        const r = n[t];
                        let s;
                        if (r.isInterleavedBufferAttribute) {
                            const t = i(e1.data, r.data);
                            s = new Jp(t, r.itemSize, r.offset, r.normalized);
                        } else {
                            const e1 = il(r.type, r.array);
                            s = new ou(e1, r.itemSize, r.normalized);
                        }
                        void 0 !== r.name && (s.name = r.name), a.push(s);
                    }
                    r.morphAttributes[t] = a;
                }
                e1.data.morphTargetsRelative && (r.morphTargetsRelative = !0);
                const l = e1.data.groups || e1.data.drawcalls || e1.data.offsets;
                if (void 0 !== l) for(let e1 = 0, t = l.length; e1 !== t; ++e1){
                    const t = l[e1];
                    r.addGroup(t.start, t.count, t.materialIndex);
                }
                const c = e1.data.boundingSphere;
                if (void 0 !== c) {
                    const e1 = new Cl;
                    void 0 !== c.center && e1.fromArray(c.center), r.boundingSphere = new Jl(e1, c.radius);
                }
                return e1.name && (r.name = e1.name), e1.userData && (r.userData = e1.userData), r;
            }
        }
        class YA extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = this, a = "" === this.path ? GA.extractUrlBase(e1) : this.path;
                this.resourcePath = this.resourcePath || a;
                const s = new AA(this.manager);
                s.setPath(this.path), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(e1, function(n) {
                    let a = null;
                    try {
                        a = JSON.parse(n);
                    } catch (t) {
                        return void 0 !== i && i(t), void console.error("THREE:ObjectLoader: Can't parse " + e1 + ".", t.message);
                    }
                    const s = a.metadata;
                    if (void 0 === s || void 0 === s.type || "geometry" === s.type.toLowerCase()) return void 0 !== i && i(new Error("THREE.ObjectLoader: Can't load " + e1)), void console.error("THREE.ObjectLoader: Can't load " + e1);
                    r.parse(a, t);
                }, n, i);
            }
            async loadAsync(e1, t) {
                const n = "" === this.path ? GA.extractUrlBase(e1) : this.path;
                this.resourcePath = this.resourcePath || n;
                const i = new AA(this.manager);
                i.setPath(this.path), i.setRequestHeader(this.requestHeader), i.setWithCredentials(this.withCredentials);
                const r = await i.loadAsync(e1, t), a = JSON.parse(r), s = a.metadata;
                if (void 0 === s || void 0 === s.type || "geometry" === s.type.toLowerCase()) throw new Error("THREE.ObjectLoader: Can't load " + e1);
                return await this.parseAsync(a);
            }
            parse(e1, t) {
                const n = this.parseAnimations(e1.animations), i = this.parseShapes(e1.shapes), r = this.parseGeometries(e1.geometries, i), a = this.parseImages(e1.images, function() {
                    void 0 !== t && t(l);
                }), s = this.parseTextures(e1.textures, a), o = this.parseMaterials(e1.materials, s), l = this.parseObject(e1.object, r, o, s, n), c = this.parseSkeletons(e1.skeletons, l);
                if (this.bindSkeletons(l, c), void 0 !== t) {
                    let e1 = !1;
                    for(const t in a)if (a[t].data instanceof HTMLImageElement) {
                        e1 = !0;
                        break;
                    }
                    !1 === e1 && t(l);
                }
                return l;
            }
            async parseAsync(e1) {
                const t = this.parseAnimations(e1.animations), n = this.parseShapes(e1.shapes), i = this.parseGeometries(e1.geometries, n), r = await this.parseImagesAsync(e1.images), a = this.parseTextures(e1.textures, r), s = this.parseMaterials(e1.materials, a), o = this.parseObject(e1.object, i, s, a, t), l = this.parseSkeletons(e1.skeletons, o);
                return this.bindSkeletons(o, l), o;
            }
            parseShapes(e1) {
                const t = {};
                if (void 0 !== e1) for(let n = 0, i = e1.length; n < i; n++){
                    const i = (new Ym).fromJSON(e1[n]);
                    t[i.uuid] = i;
                }
                return t;
            }
            parseSkeletons(e1, t) {
                const n = {}, i = {};
                if (t.traverse(function(e1) {
                    e1.isBone && (i[e1.uuid] = e1);
                }), void 0 !== e1) for(let t = 0, r = e1.length; t < r; t++){
                    const r = (new Rf).fromJSON(e1[t], i);
                    n[r.uuid] = r;
                }
                return n;
            }
            parseGeometries(e1, t) {
                const n = {};
                if (void 0 !== e1) {
                    const i = new WA;
                    for(let r = 0, a = e1.length; r < a; r++){
                        let a;
                        const s = e1[r];
                        switch(s.type){
                            case "BufferGeometry":
                            case "InstancedBufferGeometry":
                                a = i.parse(s);
                                break;
                            default:
                                s.type in zg ? a = zg[s.type].fromJSON(s, t) : console.warn('THREE.ObjectLoader: Unsupported geometry type "'.concat(s.type, '"'));
                        }
                        a.uuid = s.uuid, void 0 !== s.name && (a.name = s.name), void 0 !== s.userData && (a.userData = s.userData), n[s.uuid] = a;
                    }
                }
                return n;
            }
            parseMaterials(e1, t) {
                const n = {}, i = {};
                if (void 0 !== e1) {
                    const r = new VA;
                    r.setTextures(t);
                    for(let t = 0, a = e1.length; t < a; t++){
                        const a = e1[t];
                        void 0 === n[a.uuid] && (n[a.uuid] = r.parse(a)), i[a.uuid] = n[a.uuid];
                    }
                }
                return i;
            }
            parseAnimations(e1) {
                const t = {};
                if (void 0 !== e1) for(let n = 0; n < e1.length; n++){
                    const i = e1[n], r = cA.parse(i);
                    t[r.uuid] = r;
                }
                return t;
            }
            parseImages(e1, t) {
                const n = this, i = {};
                let r;
                function a(e1) {
                    if ("string" == typeof e1) {
                        const t = e1;
                        return function(e1) {
                            return n.manager.itemStart(e1), r.load(e1, function() {
                                n.manager.itemEnd(e1);
                            }, void 0, function() {
                                n.manager.itemError(e1), n.manager.itemEnd(e1);
                            });
                        }(/^(\/\/)|([a-z]+:(\/\/)?)/i.test(t) ? t : n.resourcePath + t);
                    }
                    return e1.data ? {
                        data: il(e1.type, e1.data),
                        width: e1.width,
                        height: e1.height
                    } : null;
                }
                if (void 0 !== e1 && e1.length > 0) {
                    const n = new dA(t);
                    r = new yA(n), r.setCrossOrigin(this.crossOrigin);
                    for(let t = 0, n = e1.length; t < n; t++){
                        const n = e1[t], r = n.url;
                        if (Array.isArray(r)) {
                            const e1 = [];
                            for(let t = 0, n = r.length; t < n; t++){
                                const n = a(r[t]);
                                null !== n && (n instanceof HTMLImageElement ? e1.push(n) : e1.push(new Df(n.data, n.width, n.height)));
                            }
                            i[n.uuid] = new vl(e1);
                        } else {
                            const e1 = a(n.url);
                            i[n.uuid] = new vl(e1);
                        }
                    }
                }
                return i;
            }
            async parseImagesAsync(e1) {
                const t = this, n = {};
                let i;
                async function r(e1) {
                    if ("string" == typeof e1) {
                        const n = e1, r = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(n) ? n : t.resourcePath + n;
                        return await i.loadAsync(r);
                    }
                    return e1.data ? {
                        data: il(e1.type, e1.data),
                        width: e1.width,
                        height: e1.height
                    } : null;
                }
                if (void 0 !== e1 && e1.length > 0) {
                    i = new yA(this.manager), i.setCrossOrigin(this.crossOrigin);
                    for(let t = 0, i = e1.length; t < i; t++){
                        const i = e1[t], a = i.url;
                        if (Array.isArray(a)) {
                            const e1 = [];
                            for(let t = 0, n = a.length; t < n; t++){
                                const n = a[t], i = await r(n);
                                null !== i && (i instanceof HTMLImageElement ? e1.push(i) : e1.push(new Df(i.data, i.width, i.height)));
                            }
                            n[i.uuid] = new vl(e1);
                        } else {
                            const e1 = await r(i.url);
                            n[i.uuid] = new vl(e1);
                        }
                    }
                }
                return n;
            }
            parseTextures(e1, t) {
                function n(e1, t) {
                    return "number" == typeof e1 ? e1 : (console.warn("THREE.ObjectLoader.parseTexture: Constant should be in numeric form.", e1), t[e1]);
                }
                const i = {};
                if (void 0 !== e1) for(let r = 0, a = e1.length; r < a; r++){
                    const a = e1[r];
                    void 0 === a.image && console.warn('THREE.ObjectLoader: No "image" specified for', a.uuid), void 0 === t[a.image] && console.warn("THREE.ObjectLoader: Undefined image", a.image);
                    const s = t[a.image], o = s.data;
                    let l;
                    Array.isArray(o) ? (l = new th, 6 === o.length && (l.needsUpdate = !0)) : (l = o && o.data ? new Df : new xl, o && (l.needsUpdate = !0)), l.source = s, l.uuid = a.uuid, void 0 !== a.name && (l.name = a.name), void 0 !== a.mapping && (l.mapping = n(a.mapping, XA)), void 0 !== a.channel && (l.channel = a.channel), void 0 !== a.offset && l.offset.fromArray(a.offset), void 0 !== a.repeat && l.repeat.fromArray(a.repeat), void 0 !== a.center && l.center.fromArray(a.center), void 0 !== a.rotation && (l.rotation = a.rotation), void 0 !== a.wrap && (l.wrapS = n(a.wrap[0], ZA), l.wrapT = n(a.wrap[1], ZA)), void 0 !== a.format && (l.format = a.format), void 0 !== a.internalFormat && (l.internalFormat = a.internalFormat), void 0 !== a.type && (l.type = a.type), void 0 !== a.colorSpace && (l.colorSpace = a.colorSpace), void 0 !== a.encoding && (l.encoding = a.encoding), void 0 !== a.minFilter && (l.minFilter = n(a.minFilter, qA)), void 0 !== a.magFilter && (l.magFilter = n(a.magFilter, qA)), void 0 !== a.anisotropy && (l.anisotropy = a.anisotropy), void 0 !== a.flipY && (l.flipY = a.flipY), void 0 !== a.generateMipmaps && (l.generateMipmaps = a.generateMipmaps), void 0 !== a.premultiplyAlpha && (l.premultiplyAlpha = a.premultiplyAlpha), void 0 !== a.unpackAlignment && (l.unpackAlignment = a.unpackAlignment), void 0 !== a.compareFunction && (l.compareFunction = a.compareFunction), void 0 !== a.userData && (l.userData = a.userData), i[a.uuid] = l;
                }
                return i;
            }
            parseObject(e1, t, n, i, r) {
                let a, s, o;
                function l(e1) {
                    return void 0 === t[e1] && console.warn("THREE.ObjectLoader: Undefined geometry", e1), t[e1];
                }
                function c(e1) {
                    if (void 0 !== e1) {
                        if (Array.isArray(e1)) {
                            const t = [];
                            for(let i = 0, r = e1.length; i < r; i++){
                                const r = e1[i];
                                void 0 === n[r] && console.warn("THREE.ObjectLoader: Undefined material", r), t.push(n[r]);
                            }
                            return t;
                        }
                        return void 0 === n[e1] && console.warn("THREE.ObjectLoader: Undefined material", e1), n[e1];
                    }
                }
                function u(e1) {
                    return void 0 === i[e1] && console.warn("THREE.ObjectLoader: Undefined texture", e1), i[e1];
                }
                switch(e1.type){
                    case "Scene":
                        a = new Zp, void 0 !== e1.background && (Number.isInteger(e1.background) ? a.background = new Zc(e1.background) : a.background = u(e1.background)), void 0 !== e1.environment && (a.environment = u(e1.environment)), void 0 !== e1.fog && ("Fog" === e1.fog.type ? a.fog = new Xp(e1.fog.color, e1.fog.near, e1.fog.far) : "FogExp2" === e1.fog.type && (a.fog = new Yp(e1.fog.color, e1.fog.density)), "" !== e1.fog.name && (a.fog.name = e1.fog.name)), void 0 !== e1.backgroundBlurriness && (a.backgroundBlurriness = e1.backgroundBlurriness), void 0 !== e1.backgroundIntensity && (a.backgroundIntensity = e1.backgroundIntensity);
                        break;
                    case "PerspectiveCamera":
                        a = new Ju(e1.fov, e1.aspect, e1.near, e1.far), void 0 !== e1.focus && (a.focus = e1.focus), void 0 !== e1.zoom && (a.zoom = e1.zoom), void 0 !== e1.filmGauge && (a.filmGauge = e1.filmGauge), void 0 !== e1.filmOffset && (a.filmOffset = e1.filmOffset), void 0 !== e1.view && (a.view = Object.assign({}, e1.view));
                        break;
                    case "OrthographicCamera":
                        a = new bh(e1.left, e1.right, e1.top, e1.bottom, e1.near, e1.far), void 0 !== e1.zoom && (a.zoom = e1.zoom), void 0 !== e1.view && (a.view = Object.assign({}, e1.view));
                        break;
                    case "AmbientLight":
                        a = new jA(e1.color, e1.intensity);
                        break;
                    case "DirectionalLight":
                        a = new kA(e1.color, e1.intensity);
                        break;
                    case "PointLight":
                        a = new PA(e1.color, e1.intensity, e1.distance, e1.decay);
                        break;
                    case "RectAreaLight":
                        a = new BA(e1.color, e1.intensity, e1.width, e1.height);
                        break;
                    case "SpotLight":
                        a = new CA(e1.color, e1.intensity, e1.distance, e1.angle, e1.penumbra, e1.decay);
                        break;
                    case "HemisphereLight":
                        a = new EA(e1.color, e1.groundColor, e1.intensity);
                        break;
                    case "LightProbe":
                        a = (new HA).fromJSON(e1);
                        break;
                    case "SkinnedMesh":
                        s = l(e1.geometry), o = c(e1.material), a = new If(s, o), void 0 !== e1.bindMode && (a.bindMode = e1.bindMode), void 0 !== e1.bindMatrix && a.bindMatrix.fromArray(e1.bindMatrix), void 0 !== e1.skeleton && (a.skeleton = e1.skeleton);
                        break;
                    case "Mesh":
                        s = l(e1.geometry), o = c(e1.material), a = new Vu(s, o);
                        break;
                    case "InstancedMesh":
                        s = l(e1.geometry), o = c(e1.material);
                        const t1 = e1.count, n1 = e1.instanceMatrix, i1 = e1.instanceColor;
                        a = new Hf(s, o, t1), a.instanceMatrix = new zf(new Float32Array(n1.array), 16), void 0 !== i1 && (a.instanceColor = new zf(new Float32Array(i1.array), i1.itemSize));
                        break;
                    case "LOD":
                        a = new vf;
                        break;
                    case "Line":
                        a = new Zf(l(e1.geometry), c(e1.material));
                        break;
                    case "LineLoop":
                        a = new $f(l(e1.geometry), c(e1.material));
                        break;
                    case "LineSegments":
                        a = new Jf(l(e1.geometry), c(e1.material));
                        break;
                    case "PointCloud":
                    case "Points":
                        a = new am(l(e1.geometry), c(e1.material));
                        break;
                    case "Sprite":
                        a = new ff(c(e1.material));
                        break;
                    case "Group":
                        a = new kp;
                        break;
                    case "Bone":
                        a = new Nf;
                        break;
                    default:
                        a = new Lc;
                }
                if (a.uuid = e1.uuid, void 0 !== e1.name && (a.name = e1.name), void 0 !== e1.matrix ? (a.matrix.fromArray(e1.matrix), void 0 !== e1.matrixAutoUpdate && (a.matrixAutoUpdate = e1.matrixAutoUpdate), a.matrixAutoUpdate && a.matrix.decompose(a.position, a.quaternion, a.scale)) : (void 0 !== e1.position && a.position.fromArray(e1.position), void 0 !== e1.rotation && a.rotation.fromArray(e1.rotation), void 0 !== e1.quaternion && a.quaternion.fromArray(e1.quaternion), void 0 !== e1.scale && a.scale.fromArray(e1.scale)), void 0 !== e1.up && a.up.fromArray(e1.up), void 0 !== e1.castShadow && (a.castShadow = e1.castShadow), void 0 !== e1.receiveShadow && (a.receiveShadow = e1.receiveShadow), e1.shadow && (void 0 !== e1.shadow.bias && (a.shadow.bias = e1.shadow.bias), void 0 !== e1.shadow.normalBias && (a.shadow.normalBias = e1.shadow.normalBias), void 0 !== e1.shadow.radius && (a.shadow.radius = e1.shadow.radius), void 0 !== e1.shadow.mapSize && a.shadow.mapSize.fromArray(e1.shadow.mapSize), void 0 !== e1.shadow.camera && (a.shadow.camera = this.parseObject(e1.shadow.camera))), void 0 !== e1.visible && (a.visible = e1.visible), void 0 !== e1.frustumCulled && (a.frustumCulled = e1.frustumCulled), void 0 !== e1.renderOrder && (a.renderOrder = e1.renderOrder), void 0 !== e1.userData && (a.userData = e1.userData), void 0 !== e1.layers && (a.layers.mask = e1.layers), void 0 !== e1.children) {
                    const s = e1.children;
                    for(let e1 = 0; e1 < s.length; e1++)a.add(this.parseObject(s[e1], t, n, i, r));
                }
                if (void 0 !== e1.animations) {
                    const t = e1.animations;
                    for(let e1 = 0; e1 < t.length; e1++){
                        const n = t[e1];
                        a.animations.push(r[n]);
                    }
                }
                if ("LOD" === e1.type) {
                    void 0 !== e1.autoUpdate && (a.autoUpdate = e1.autoUpdate);
                    const t = e1.levels;
                    for(let e1 = 0; e1 < t.length; e1++){
                        const n = t[e1], i = a.getObjectByProperty("uuid", n.object);
                        void 0 !== i && a.addLevel(i, n.distance, n.hysteresis);
                    }
                }
                return a;
            }
            bindSkeletons(e1, t) {
                0 !== Object.keys(t).length && e1.traverse(function(e1) {
                    if (!0 === e1.isSkinnedMesh && void 0 !== e1.skeleton) {
                        const n = t[e1.skeleton];
                        void 0 === n ? console.warn("THREE.ObjectLoader: No skeleton found with UUID:", e1.skeleton) : e1.bind(n, e1.bindMatrix);
                    }
                });
            }
        }
        const XA = {
            UVMapping: ra,
            CubeReflectionMapping: aa,
            CubeRefractionMapping: sa,
            EquirectangularReflectionMapping: oa,
            EquirectangularRefractionMapping: la,
            CubeUVReflectionMapping: ca
        }, ZA = {
            RepeatWrapping: ua,
            ClampToEdgeWrapping: ha,
            MirroredRepeatWrapping: da
        }, qA = {
            NearestFilter: pa,
            NearestMipmapNearestFilter: fa,
            NearestMipmapLinearFilter: ga,
            LinearFilter: va,
            LinearMipmapNearestFilter: Ma,
            LinearMipmapLinearFilter: xa
        };
        class KA extends fA {
            constructor(e1){
                super(e1), this.isImageBitmapLoader = !0, "undefined" == typeof createImageBitmap && console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."), "undefined" == typeof fetch && console.warn("THREE.ImageBitmapLoader: fetch() not supported."), this.options = {
                    premultiplyAlpha: "none"
                };
            }
            setOptions(e1) {
                return this.options = e1, this;
            }
            load(e1, t, n, i) {
                void 0 === e1 && (e1 = ""), void 0 !== this.path && (e1 = this.path + e1), e1 = this.manager.resolveURL(e1);
                const r = this, a = hA.get(e1);
                if (void 0 !== a) return r.manager.itemStart(e1), setTimeout(function() {
                    t && t(a), r.manager.itemEnd(e1);
                }, 0), a;
                const s = {};
                s.credentials = "anonymous" === this.crossOrigin ? "same-origin" : "include", s.headers = this.requestHeader, fetch(e1, s).then(function(e1) {
                    return e1.blob();
                }).then(function(e1) {
                    return createImageBitmap(e1, Object.assign(r.options, {
                        colorSpaceConversion: "none"
                    }));
                }).then(function(n) {
                    hA.add(e1, n), t && t(n), r.manager.itemEnd(e1);
                }).catch(function(t) {
                    i && i(t), r.manager.itemError(e1), r.manager.itemEnd(e1);
                }), r.manager.itemStart(e1);
            }
        }
        let JA;
        class $A {
            static getContext() {
                return void 0 === JA && (JA = new (window.AudioContext || window.webkitAudioContext)), JA;
            }
            static setContext(e1) {
                JA = e1;
            }
        }
        class ev extends fA {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = this, a = new AA(this.manager);
                function s(t) {
                    i ? i(t) : console.error(t), r.manager.itemError(e1);
                }
                a.setResponseType("arraybuffer"), a.setPath(this.path), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(e1, function(e1) {
                    try {
                        const n = e1.slice(0);
                        $A.getContext().decodeAudioData(n, function(e1) {
                            t(e1);
                        }, s);
                    } catch (e1) {
                        s(e1);
                    }
                }, n, i);
            }
        }
        const tv = new oc, nv = new oc, iv = new oc;
        class rv {
            constructor(){
                this.type = "StereoCamera", this.aspect = 1, this.eyeSep = .064, this.cameraL = new Ju, this.cameraL.layers.enable(1), this.cameraL.matrixAutoUpdate = !1, this.cameraR = new Ju, this.cameraR.layers.enable(2), this.cameraR.matrixAutoUpdate = !1, this._cache = {
                    focus: null,
                    fov: null,
                    aspect: null,
                    near: null,
                    far: null,
                    zoom: null,
                    eyeSep: null
                };
            }
            update(e1) {
                const t = this._cache;
                if (t.focus !== e1.focus || t.fov !== e1.fov || t.aspect !== e1.aspect * this.aspect || t.near !== e1.near || t.far !== e1.far || t.zoom !== e1.zoom || t.eyeSep !== this.eyeSep) {
                    t.focus = e1.focus, t.fov = e1.fov, t.aspect = e1.aspect * this.aspect, t.near = e1.near, t.far = e1.far, t.zoom = e1.zoom, t.eyeSep = this.eyeSep, iv.copy(e1.projectionMatrix);
                    const n = t.eyeSep / 2, i = n * t.near / t.focus, r = t.near * Math.tan(Bo * t.fov * .5) / t.zoom;
                    let a, s;
                    nv.elements[12] = -n, tv.elements[12] = n, a = -r * t.aspect + i, s = r * t.aspect + i, iv.elements[0] = 2 * t.near / (s - a), iv.elements[8] = (s + a) / (s - a), this.cameraL.projectionMatrix.copy(iv), a = -r * t.aspect - i, s = r * t.aspect - i, iv.elements[0] = 2 * t.near / (s - a), iv.elements[8] = (s + a) / (s - a), this.cameraR.projectionMatrix.copy(iv);
                }
                this.cameraL.matrixWorld.copy(e1.matrixWorld).multiply(nv), this.cameraR.matrixWorld.copy(e1.matrixWorld).multiply(tv);
            }
        }
        class av {
            constructor(){
                let e1 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                this.autoStart = e1, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
            }
            start() {
                this.startTime = sv(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
            }
            stop() {
                this.getElapsedTime(), this.running = !1, this.autoStart = !1;
            }
            getElapsedTime() {
                return this.getDelta(), this.elapsedTime;
            }
            getDelta() {
                let e1 = 0;
                if (this.autoStart && !this.running) return this.start(), 0;
                if (this.running) {
                    const t = sv();
                    e1 = (t - this.oldTime) / 1e3, this.oldTime = t, this.elapsedTime += e1;
                }
                return e1;
            }
        }
        function sv() {
            return ("undefined" == typeof performance ? Date : performance).now();
        }
        const ov = new Cl, lv = new Dl, cv = new Cl, uv = new Cl;
        class hv extends Lc {
            constructor(){
                super(), this.type = "AudioListener", this.context = $A.getContext(), this.gain = this.context.createGain(), this.gain.connect(this.context.destination), this.filter = null, this.timeDelta = 0, this._clock = new av;
            }
            getInput() {
                return this.gain;
            }
            removeFilter() {
                return null !== this.filter && (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination), this.gain.connect(this.context.destination), this.filter = null), this;
            }
            getFilter() {
                return this.filter;
            }
            setFilter(e1) {
                return null !== this.filter ? (this.gain.disconnect(this.filter), this.filter.disconnect(this.context.destination)) : this.gain.disconnect(this.context.destination), this.filter = e1, this.gain.connect(this.filter), this.filter.connect(this.context.destination), this;
            }
            getMasterVolume() {
                return this.gain.gain.value;
            }
            setMasterVolume(e1) {
                return this.gain.gain.setTargetAtTime(e1, this.context.currentTime, .01), this;
            }
            updateMatrixWorld(e1) {
                super.updateMatrixWorld(e1);
                const t = this.context.listener, n = this.up;
                if (this.timeDelta = this._clock.getDelta(), this.matrixWorld.decompose(ov, lv, cv), uv.set(0, 0, -1).applyQuaternion(lv), t.positionX) {
                    const e1 = this.context.currentTime + this.timeDelta;
                    t.positionX.linearRampToValueAtTime(ov.x, e1), t.positionY.linearRampToValueAtTime(ov.y, e1), t.positionZ.linearRampToValueAtTime(ov.z, e1), t.forwardX.linearRampToValueAtTime(uv.x, e1), t.forwardY.linearRampToValueAtTime(uv.y, e1), t.forwardZ.linearRampToValueAtTime(uv.z, e1), t.upX.linearRampToValueAtTime(n.x, e1), t.upY.linearRampToValueAtTime(n.y, e1), t.upZ.linearRampToValueAtTime(n.z, e1);
                } else t.setPosition(ov.x, ov.y, ov.z), t.setOrientation(uv.x, uv.y, uv.z, n.x, n.y, n.z);
            }
        }
        class dv extends Lc {
            constructor(e1){
                super(), this.type = "Audio", this.listener = e1, this.context = e1.context, this.gain = this.context.createGain(), this.gain.connect(e1.getInput()), this.autoplay = !1, this.buffer = null, this.detune = 0, this.loop = !1, this.loopStart = 0, this.loopEnd = 0, this.offset = 0, this.duration = void 0, this.playbackRate = 1, this.isPlaying = !1, this.hasPlaybackControl = !0, this.source = null, this.sourceType = "empty", this._startedAt = 0, this._progress = 0, this._connected = !1, this.filters = [];
            }
            getOutput() {
                return this.gain;
            }
            setNodeSource(e1) {
                return this.hasPlaybackControl = !1, this.sourceType = "audioNode", this.source = e1, this.connect(), this;
            }
            setMediaElementSource(e1) {
                return this.hasPlaybackControl = !1, this.sourceType = "mediaNode", this.source = this.context.createMediaElementSource(e1), this.connect(), this;
            }
            setMediaStreamSource(e1) {
                return this.hasPlaybackControl = !1, this.sourceType = "mediaStreamNode", this.source = this.context.createMediaStreamSource(e1), this.connect(), this;
            }
            setBuffer(e1) {
                return this.buffer = e1, this.sourceType = "buffer", this.autoplay && this.play(), this;
            }
            play() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                if (!0 === this.isPlaying) return void console.warn("THREE.Audio: Audio is already playing.");
                if (!1 === this.hasPlaybackControl) return void console.warn("THREE.Audio: this Audio has no playback control.");
                this._startedAt = this.context.currentTime + e1;
                const t = this.context.createBufferSource();
                return t.buffer = this.buffer, t.loop = this.loop, t.loopStart = this.loopStart, t.loopEnd = this.loopEnd, t.onended = this.onEnded.bind(this), t.start(this._startedAt, this._progress + this.offset, this.duration), this.isPlaying = !0, this.source = t, this.setDetune(this.detune), this.setPlaybackRate(this.playbackRate), this.connect();
            }
            pause() {
                if (!1 !== this.hasPlaybackControl) return !0 === this.isPlaying && (this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate, !0 === this.loop && (this._progress = this._progress % (this.duration || this.buffer.duration)), this.source.stop(), this.source.onended = null, this.isPlaying = !1), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            stop() {
                if (!1 !== this.hasPlaybackControl) return this._progress = 0, null !== this.source && (this.source.stop(), this.source.onended = null), this.isPlaying = !1, this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            connect() {
                if (this.filters.length > 0) {
                    this.source.connect(this.filters[0]);
                    for(let e1 = 1, t = this.filters.length; e1 < t; e1++)this.filters[e1 - 1].connect(this.filters[e1]);
                    this.filters[this.filters.length - 1].connect(this.getOutput());
                } else this.source.connect(this.getOutput());
                return this._connected = !0, this;
            }
            disconnect() {
                if (!1 !== this._connected) {
                    if (this.filters.length > 0) {
                        this.source.disconnect(this.filters[0]);
                        for(let e1 = 1, t = this.filters.length; e1 < t; e1++)this.filters[e1 - 1].disconnect(this.filters[e1]);
                        this.filters[this.filters.length - 1].disconnect(this.getOutput());
                    } else this.source.disconnect(this.getOutput());
                    return this._connected = !1, this;
                }
            }
            getFilters() {
                return this.filters;
            }
            setFilters(e1) {
                return e1 || (e1 = []), !0 === this._connected ? (this.disconnect(), this.filters = e1.slice(), this.connect()) : this.filters = e1.slice(), this;
            }
            setDetune(e1) {
                if (this.detune = e1, void 0 !== this.source.detune) return !0 === this.isPlaying && this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, .01), this;
            }
            getDetune() {
                return this.detune;
            }
            getFilter() {
                return this.getFilters()[0];
            }
            setFilter(e1) {
                return this.setFilters(e1 ? [
                    e1
                ] : []);
            }
            setPlaybackRate(e1) {
                if (!1 !== this.hasPlaybackControl) return this.playbackRate = e1, !0 === this.isPlaying && this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, .01), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            getPlaybackRate() {
                return this.playbackRate;
            }
            onEnded() {
                this.isPlaying = !1;
            }
            getLoop() {
                return !1 === this.hasPlaybackControl ? (console.warn("THREE.Audio: this Audio has no playback control."), !1) : this.loop;
            }
            setLoop(e1) {
                if (!1 !== this.hasPlaybackControl) return this.loop = e1, !0 === this.isPlaying && (this.source.loop = this.loop), this;
                console.warn("THREE.Audio: this Audio has no playback control.");
            }
            setLoopStart(e1) {
                return this.loopStart = e1, this;
            }
            setLoopEnd(e1) {
                return this.loopEnd = e1, this;
            }
            getVolume() {
                return this.gain.gain.value;
            }
            setVolume(e1) {
                return this.gain.gain.setTargetAtTime(e1, this.context.currentTime, .01), this;
            }
        }
        const pv = new Cl, fv = new Dl, mv = new Cl, gv = new Cl;
        class Av extends dv {
            constructor(e1){
                super(e1), this.panner = this.context.createPanner(), this.panner.panningModel = "HRTF", this.panner.connect(this.gain);
            }
            connect() {
                super.connect(), this.panner.connect(this.gain);
            }
            disconnect() {
                super.disconnect(), this.panner.disconnect(this.gain);
            }
            getOutput() {
                return this.panner;
            }
            getRefDistance() {
                return this.panner.refDistance;
            }
            setRefDistance(e1) {
                return this.panner.refDistance = e1, this;
            }
            getRolloffFactor() {
                return this.panner.rolloffFactor;
            }
            setRolloffFactor(e1) {
                return this.panner.rolloffFactor = e1, this;
            }
            getDistanceModel() {
                return this.panner.distanceModel;
            }
            setDistanceModel(e1) {
                return this.panner.distanceModel = e1, this;
            }
            getMaxDistance() {
                return this.panner.maxDistance;
            }
            setMaxDistance(e1) {
                return this.panner.maxDistance = e1, this;
            }
            setDirectionalCone(e1, t, n) {
                return this.panner.coneInnerAngle = e1, this.panner.coneOuterAngle = t, this.panner.coneOuterGain = n, this;
            }
            updateMatrixWorld(e1) {
                if (super.updateMatrixWorld(e1), !0 === this.hasPlaybackControl && !1 === this.isPlaying) return;
                this.matrixWorld.decompose(pv, fv, mv), gv.set(0, 0, 1).applyQuaternion(fv);
                const t = this.panner;
                if (t.positionX) {
                    const e1 = this.context.currentTime + this.listener.timeDelta;
                    t.positionX.linearRampToValueAtTime(pv.x, e1), t.positionY.linearRampToValueAtTime(pv.y, e1), t.positionZ.linearRampToValueAtTime(pv.z, e1), t.orientationX.linearRampToValueAtTime(gv.x, e1), t.orientationY.linearRampToValueAtTime(gv.y, e1), t.orientationZ.linearRampToValueAtTime(gv.z, e1);
                } else t.setPosition(pv.x, pv.y, pv.z), t.setOrientation(gv.x, gv.y, gv.z);
            }
        }
        class vv {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2048;
                this.analyser = e1.context.createAnalyser(), this.analyser.fftSize = t, this.data = new Uint8Array(this.analyser.frequencyBinCount), e1.getOutput().connect(this.analyser);
            }
            getFrequencyData() {
                return this.analyser.getByteFrequencyData(this.data), this.data;
            }
            getAverageFrequency() {
                let e1 = 0;
                const t = this.getFrequencyData();
                for(let n = 0; n < t.length; n++)e1 += t[n];
                return e1 / t.length;
            }
        }
        class Mv {
            constructor(e1, t, n){
                let i, r, a;
                switch(this.binding = e1, this.valueSize = n, t){
                    case "quaternion":
                        i = this._slerp, r = this._slerpAdditive, a = this._setAdditiveIdentityQuaternion, this.buffer = new Float64Array(6 * n), this._workIndex = 5;
                        break;
                    case "string":
                    case "bool":
                        i = this._select, r = this._select, a = this._setAdditiveIdentityOther, this.buffer = new Array(5 * n);
                        break;
                    default:
                        i = this._lerp, r = this._lerpAdditive, a = this._setAdditiveIdentityNumeric, this.buffer = new Float64Array(5 * n);
                }
                this._mixBufferRegion = i, this._mixBufferRegionAdditive = r, this._setIdentity = a, this._origIndex = 3, this._addIndex = 4, this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, this.useCount = 0, this.referenceCount = 0;
            }
            accumulate(e1, t) {
                const n = this.buffer, i = this.valueSize, r = e1 * i + i;
                let a = this.cumulativeWeight;
                if (0 === a) {
                    for(let e1 = 0; e1 !== i; ++e1)n[r + e1] = n[e1];
                    a = t;
                } else {
                    a += t;
                    const e1 = t / a;
                    this._mixBufferRegion(n, r, 0, e1, i);
                }
                this.cumulativeWeight = a;
            }
            accumulateAdditive(e1) {
                const t = this.buffer, n = this.valueSize, i = n * this._addIndex;
                0 === this.cumulativeWeightAdditive && this._setIdentity(), this._mixBufferRegionAdditive(t, i, 0, e1, n), this.cumulativeWeightAdditive += e1;
            }
            apply(e1) {
                const t = this.valueSize, n = this.buffer, i = e1 * t + t, r = this.cumulativeWeight, a = this.cumulativeWeightAdditive, s = this.binding;
                if (this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0, r < 1) {
                    const e1 = t * this._origIndex;
                    this._mixBufferRegion(n, i, e1, 1 - r, t);
                }
                a > 0 && this._mixBufferRegionAdditive(n, i, this._addIndex * t, 1, t);
                for(let e1 = t, r = t + t; e1 !== r; ++e1)if (n[e1] !== n[e1 + t]) {
                    s.setValue(n, i);
                    break;
                }
            }
            saveOriginalState() {
                const e1 = this.binding, t = this.buffer, n = this.valueSize, i = n * this._origIndex;
                e1.getValue(t, i);
                for(let e1 = n, r = i; e1 !== r; ++e1)t[e1] = t[i + e1 % n];
                this._setIdentity(), this.cumulativeWeight = 0, this.cumulativeWeightAdditive = 0;
            }
            restoreOriginalState() {
                const e1 = 3 * this.valueSize;
                this.binding.setValue(this.buffer, e1);
            }
            _setAdditiveIdentityNumeric() {
                const e1 = this._addIndex * this.valueSize, t = e1 + this.valueSize;
                for(let n = e1; n < t; n++)this.buffer[n] = 0;
            }
            _setAdditiveIdentityQuaternion() {
                this._setAdditiveIdentityNumeric(), this.buffer[this._addIndex * this.valueSize + 3] = 1;
            }
            _setAdditiveIdentityOther() {
                const e1 = this._origIndex * this.valueSize, t = this._addIndex * this.valueSize;
                for(let n = 0; n < this.valueSize; n++)this.buffer[t + n] = this.buffer[e1 + n];
            }
            _select(e1, t, n, i, r) {
                if (i >= .5) for(let i = 0; i !== r; ++i)e1[t + i] = e1[n + i];
            }
            _slerp(e1, t, n, i) {
                Dl.slerpFlat(e1, t, e1, t, e1, n, i);
            }
            _slerpAdditive(e1, t, n, i, r) {
                const a = this._workIndex * r;
                Dl.multiplyQuaternionsFlat(e1, a, e1, t, e1, n), Dl.slerpFlat(e1, t, e1, t, e1, a, i);
            }
            _lerp(e1, t, n, i, r) {
                const a = 1 - i;
                for(let s = 0; s !== r; ++s){
                    const r = t + s;
                    e1[r] = e1[r] * a + e1[n + s] * i;
                }
            }
            _lerpAdditive(e1, t, n, i, r) {
                for(let a = 0; a !== r; ++a){
                    const r = t + a;
                    e1[r] = e1[r] + e1[n + a] * i;
                }
            }
        }
        const yv = "\\[\\]\\.:\\/", xv = new RegExp("[" + yv + "]", "g"), _v = "[^" + yv + "]", bv = "[^" + yv.replace("\\.", "") + "]", wv = new RegExp("^" + /((?:WC+[\/:])*)/.source.replace("WC", _v) + /(WCOD+)?/.source.replace("WCOD", bv) + /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", _v) + /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", _v) + "$"), Ev = [
            "material",
            "materials",
            "bones",
            "map"
        ];
        class Tv {
            constructor(e1, t, n){
                this.path = t, this.parsedPath = n || Tv.parseTrackName(t), this.node = Tv.findNode(e1, this.parsedPath.nodeName), this.rootNode = e1, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
            }
            static create(e1, t, n) {
                return e1 && e1.isAnimationObjectGroup ? new Tv.Composite(e1, t, n) : new Tv(e1, t, n);
            }
            static sanitizeNodeName(e1) {
                return e1.replace(/\s/g, "_").replace(xv, "");
            }
            static parseTrackName(e1) {
                const t = wv.exec(e1);
                if (null === t) throw new Error("PropertyBinding: Cannot parse trackName: " + e1);
                const n = {
                    nodeName: t[2],
                    objectName: t[3],
                    objectIndex: t[4],
                    propertyName: t[5],
                    propertyIndex: t[6]
                }, i = n.nodeName && n.nodeName.lastIndexOf(".");
                if (void 0 !== i && -1 !== i) {
                    const e1 = n.nodeName.substring(i + 1);
                    -1 !== Ev.indexOf(e1) && (n.nodeName = n.nodeName.substring(0, i), n.objectName = e1);
                }
                if (null === n.propertyName || 0 === n.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + e1);
                return n;
            }
            static findNode(e1, t) {
                if (void 0 === t || "" === t || "." === t || -1 === t || t === e1.name || t === e1.uuid) return e1;
                if (e1.skeleton) {
                    const n = e1.skeleton.getBoneByName(t);
                    if (void 0 !== n) return n;
                }
                if (e1.children) {
                    const n = function(e1) {
                        for(let i = 0; i < e1.length; i++){
                            const r = e1[i];
                            if (r.name === t || r.uuid === t) return r;
                            const a = n(r.children);
                            if (a) return a;
                        }
                        return null;
                    }, i = n(e1.children);
                    if (i) return i;
                }
                return null;
            }
            _getValue_unavailable() {}
            _setValue_unavailable() {}
            _getValue_direct(e1, t) {
                e1[t] = this.targetObject[this.propertyName];
            }
            _getValue_array(e1, t) {
                const n = this.resolvedProperty;
                for(let i = 0, r = n.length; i !== r; ++i)e1[t++] = n[i];
            }
            _getValue_arrayElement(e1, t) {
                e1[t] = this.resolvedProperty[this.propertyIndex];
            }
            _getValue_toArray(e1, t) {
                this.resolvedProperty.toArray(e1, t);
            }
            _setValue_direct(e1, t) {
                this.targetObject[this.propertyName] = e1[t];
            }
            _setValue_direct_setNeedsUpdate(e1, t) {
                this.targetObject[this.propertyName] = e1[t], this.targetObject.needsUpdate = !0;
            }
            _setValue_direct_setMatrixWorldNeedsUpdate(e1, t) {
                this.targetObject[this.propertyName] = e1[t], this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_array(e1, t) {
                const n = this.resolvedProperty;
                for(let i = 0, r = n.length; i !== r; ++i)n[i] = e1[t++];
            }
            _setValue_array_setNeedsUpdate(e1, t) {
                const n = this.resolvedProperty;
                for(let i = 0, r = n.length; i !== r; ++i)n[i] = e1[t++];
                this.targetObject.needsUpdate = !0;
            }
            _setValue_array_setMatrixWorldNeedsUpdate(e1, t) {
                const n = this.resolvedProperty;
                for(let i = 0, r = n.length; i !== r; ++i)n[i] = e1[t++];
                this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_arrayElement(e1, t) {
                this.resolvedProperty[this.propertyIndex] = e1[t];
            }
            _setValue_arrayElement_setNeedsUpdate(e1, t) {
                this.resolvedProperty[this.propertyIndex] = e1[t], this.targetObject.needsUpdate = !0;
            }
            _setValue_arrayElement_setMatrixWorldNeedsUpdate(e1, t) {
                this.resolvedProperty[this.propertyIndex] = e1[t], this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _setValue_fromArray(e1, t) {
                this.resolvedProperty.fromArray(e1, t);
            }
            _setValue_fromArray_setNeedsUpdate(e1, t) {
                this.resolvedProperty.fromArray(e1, t), this.targetObject.needsUpdate = !0;
            }
            _setValue_fromArray_setMatrixWorldNeedsUpdate(e1, t) {
                this.resolvedProperty.fromArray(e1, t), this.targetObject.matrixWorldNeedsUpdate = !0;
            }
            _getValue_unbound(e1, t) {
                this.bind(), this.getValue(e1, t);
            }
            _setValue_unbound(e1, t) {
                this.bind(), this.setValue(e1, t);
            }
            bind() {
                let e1 = this.node;
                const t = this.parsedPath, n = t.objectName, i = t.propertyName;
                let r = t.propertyIndex;
                if (e1 || (e1 = Tv.findNode(this.rootNode, t.nodeName), this.node = e1), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !e1) return void console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
                if (n) {
                    let i = t.objectIndex;
                    switch(n){
                        case "materials":
                            if (!e1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                            if (!e1.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                            e1 = e1.material.materials;
                            break;
                        case "bones":
                            if (!e1.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                            e1 = e1.skeleton.bones;
                            for(let t = 0; t < e1.length; t++)if (e1[t].name === i) {
                                i = t;
                                break;
                            }
                            break;
                        case "map":
                            if ("map" in e1) {
                                e1 = e1.map;
                                break;
                            }
                            if (!e1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                            if (!e1.material.map) return void console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                            e1 = e1.material.map;
                            break;
                        default:
                            if (void 0 === e1[n]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                            e1 = e1[n];
                    }
                    if (void 0 !== i) {
                        if (void 0 === e1[i]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, e1);
                        e1 = e1[i];
                    }
                }
                const a = e1[i];
                if (void 0 === a) {
                    const n = t.nodeName;
                    return void console.error("THREE.PropertyBinding: Trying to update property for track: " + n + "." + i + " but it wasn't found.", e1);
                }
                let s = this.Versioning.None;
                this.targetObject = e1, void 0 !== e1.needsUpdate ? s = this.Versioning.NeedsUpdate : void 0 !== e1.matrixWorldNeedsUpdate && (s = this.Versioning.MatrixWorldNeedsUpdate);
                let o = this.BindingType.Direct;
                if (void 0 !== r) {
                    if ("morphTargetInfluences" === i) {
                        if (!e1.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                        if (!e1.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                        void 0 !== e1.morphTargetDictionary[r] && (r = e1.morphTargetDictionary[r]);
                    }
                    o = this.BindingType.ArrayElement, this.resolvedProperty = a, this.propertyIndex = r;
                } else void 0 !== a.fromArray && void 0 !== a.toArray ? (o = this.BindingType.HasFromToArray, this.resolvedProperty = a) : Array.isArray(a) ? (o = this.BindingType.EntireArray, this.resolvedProperty = a) : this.propertyName = i;
                this.getValue = this.GetterByBindingType[o], this.setValue = this.SetterByBindingTypeAndVersioning[o][s];
            }
            unbind() {
                this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
            }
        }
        Tv.Composite = class {
            constructor(e1, t, n){
                const i = n || Tv.parseTrackName(t);
                this._targetGroup = e1, this._bindings = e1.subscribe_(t, i);
            }
            getValue(e1, t) {
                this.bind();
                const n = this._targetGroup.nCachedObjects_, i = this._bindings[n];
                void 0 !== i && i.getValue(e1, t);
            }
            setValue(e1, t) {
                const n = this._bindings;
                for(let i = this._targetGroup.nCachedObjects_, r = n.length; i !== r; ++i)n[i].setValue(e1, t);
            }
            bind() {
                const e1 = this._bindings;
                for(let t = this._targetGroup.nCachedObjects_, n = e1.length; t !== n; ++t)e1[t].bind();
            }
            unbind() {
                const e1 = this._bindings;
                for(let t = this._targetGroup.nCachedObjects_, n = e1.length; t !== n; ++t)e1[t].unbind();
            }
        }, Tv.prototype.BindingType = {
            Direct: 0,
            EntireArray: 1,
            ArrayElement: 2,
            HasFromToArray: 3
        }, Tv.prototype.Versioning = {
            None: 0,
            NeedsUpdate: 1,
            MatrixWorldNeedsUpdate: 2
        }, Tv.prototype.GetterByBindingType = [
            Tv.prototype._getValue_direct,
            Tv.prototype._getValue_array,
            Tv.prototype._getValue_arrayElement,
            Tv.prototype._getValue_toArray
        ], Tv.prototype.SetterByBindingTypeAndVersioning = [
            [
                Tv.prototype._setValue_direct,
                Tv.prototype._setValue_direct_setNeedsUpdate,
                Tv.prototype._setValue_direct_setMatrixWorldNeedsUpdate
            ],
            [
                Tv.prototype._setValue_array,
                Tv.prototype._setValue_array_setNeedsUpdate,
                Tv.prototype._setValue_array_setMatrixWorldNeedsUpdate
            ],
            [
                Tv.prototype._setValue_arrayElement,
                Tv.prototype._setValue_arrayElement_setNeedsUpdate,
                Tv.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
            ],
            [
                Tv.prototype._setValue_fromArray,
                Tv.prototype._setValue_fromArray_setNeedsUpdate,
                Tv.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
            ]
        ];
        class Sv {
            constructor(){
                this.isAnimationObjectGroup = !0, this.uuid = Ho(), this._objects = Array.prototype.slice.call(arguments), this.nCachedObjects_ = 0;
                const e1 = {};
                this._indicesByUUID = e1;
                for(let t = 0, n = arguments.length; t !== n; ++t)e1[arguments[t].uuid] = t;
                this._paths = [], this._parsedPaths = [], this._bindings = [], this._bindingsIndicesByPath = {};
                const t = this;
                this.stats = {
                    objects: {
                        get total () {
                            return t._objects.length;
                        },
                        get inUse () {
                            return this.total - t.nCachedObjects_;
                        }
                    },
                    get bindingsPerObject () {
                        return t._bindings.length;
                    }
                };
            }
            add() {
                const e1 = this._objects, t = this._indicesByUUID, n = this._paths, i = this._parsedPaths, r = this._bindings, a = r.length;
                let s, o = e1.length, l = this.nCachedObjects_;
                for(let c = 0, u = arguments.length; c !== u; ++c){
                    const u = arguments[c], h = u.uuid;
                    let d = t[h];
                    if (void 0 === d) {
                        d = o++, t[h] = d, e1.push(u);
                        for(let e1 = 0, t = a; e1 !== t; ++e1)r[e1].push(new Tv(u, n[e1], i[e1]));
                    } else if (d < l) {
                        s = e1[d];
                        const o = --l, c = e1[o];
                        t[c.uuid] = d, e1[d] = c, t[h] = o, e1[o] = u;
                        for(let e1 = 0, t = a; e1 !== t; ++e1){
                            const t = r[e1], a = t[o];
                            let s = t[d];
                            t[d] = a, void 0 === s && (s = new Tv(u, n[e1], i[e1])), t[o] = s;
                        }
                    } else e1[d] !== s && console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
                }
                this.nCachedObjects_ = l;
            }
            remove() {
                const e1 = this._objects, t = this._indicesByUUID, n = this._bindings, i = n.length;
                let r = this.nCachedObjects_;
                for(let a = 0, s = arguments.length; a !== s; ++a){
                    const s = arguments[a], o = s.uuid, l = t[o];
                    if (void 0 !== l && l >= r) {
                        const a = r++, c = e1[a];
                        t[c.uuid] = l, e1[l] = c, t[o] = a, e1[a] = s;
                        for(let e1 = 0, t = i; e1 !== t; ++e1){
                            const t = n[e1], i = t[a], r = t[l];
                            t[l] = i, t[a] = r;
                        }
                    }
                }
                this.nCachedObjects_ = r;
            }
            uncache() {
                const e1 = this._objects, t = this._indicesByUUID, n = this._bindings, i = n.length;
                let r = this.nCachedObjects_, a = e1.length;
                for(let s = 0, o = arguments.length; s !== o; ++s){
                    const o = arguments[s].uuid, l = t[o];
                    if (void 0 !== l) {
                        if (delete t[o], l < r) {
                            const s = --r, o = e1[s], c = --a, u = e1[c];
                            t[o.uuid] = l, e1[l] = o, t[u.uuid] = s, e1[s] = u, e1.pop();
                            for(let e1 = 0, t = i; e1 !== t; ++e1){
                                const t = n[e1], i = t[s], r = t[c];
                                t[l] = i, t[s] = r, t.pop();
                            }
                        } else {
                            const r = --a, s = e1[r];
                            r > 0 && (t[s.uuid] = l), e1[l] = s, e1.pop();
                            for(let e1 = 0, t = i; e1 !== t; ++e1){
                                const t = n[e1];
                                t[l] = t[r], t.pop();
                            }
                        }
                    }
                }
                this.nCachedObjects_ = r;
            }
            subscribe_(e1, t) {
                const n = this._bindingsIndicesByPath;
                let i = n[e1];
                const r = this._bindings;
                if (void 0 !== i) return r[i];
                const a = this._paths, s = this._parsedPaths, o = this._objects, l = o.length, c = this.nCachedObjects_, u = new Array(l);
                i = r.length, n[e1] = i, a.push(e1), s.push(t), r.push(u);
                for(let n = c, i = o.length; n !== i; ++n){
                    const i = o[n];
                    u[n] = new Tv(i, e1, t);
                }
                return u;
            }
            unsubscribe_(e1) {
                const t = this._bindingsIndicesByPath, n = t[e1];
                if (void 0 !== n) {
                    const i = this._paths, r = this._parsedPaths, a = this._bindings, s = a.length - 1, o = a[s];
                    t[e1[s]] = n, a[n] = o, a.pop(), r[n] = r[s], r.pop(), i[n] = i[s], i.pop();
                }
            }
        }
        class Iv {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : t.blendMode;
                this._mixer = e1, this._clip = t, this._localRoot = n, this.blendMode = i;
                const r = t.tracks, a = r.length, s = new Array(a), o = {
                    endingStart: Ns,
                    endingEnd: Ns
                };
                for(let e1 = 0; e1 !== a; ++e1){
                    const t = r[e1].createInterpolant(null);
                    s[e1] = t, t.settings = o;
                }
                this._interpolantSettings = o, this._interpolants = s, this._propertyBindings = new Array(a), this._cacheIndex = null, this._byClipCacheIndex = null, this._timeScaleInterpolant = null, this._weightInterpolant = null, this.loop = ws, this._loopCount = -1, this._startTime = null, this.time = 0, this.timeScale = 1, this._effectiveTimeScale = 1, this.weight = 1, this._effectiveWeight = 1, this.repetitions = 1 / 0, this.paused = !1, this.enabled = !0, this.clampWhenFinished = !1, this.zeroSlopeAtStart = !0, this.zeroSlopeAtEnd = !0;
            }
            play() {
                return this._mixer._activateAction(this), this;
            }
            stop() {
                return this._mixer._deactivateAction(this), this.reset();
            }
            reset() {
                return this.paused = !1, this.enabled = !0, this.time = 0, this._loopCount = -1, this._startTime = null, this.stopFading().stopWarping();
            }
            isRunning() {
                return this.enabled && !this.paused && 0 !== this.timeScale && null === this._startTime && this._mixer._isActiveAction(this);
            }
            isScheduled() {
                return this._mixer._isActiveAction(this);
            }
            startAt(e1) {
                return this._startTime = e1, this;
            }
            setLoop(e1, t) {
                return this.loop = e1, this.repetitions = t, this;
            }
            setEffectiveWeight(e1) {
                return this.weight = e1, this._effectiveWeight = this.enabled ? e1 : 0, this.stopFading();
            }
            getEffectiveWeight() {
                return this._effectiveWeight;
            }
            fadeIn(e1) {
                return this._scheduleFading(e1, 0, 1);
            }
            fadeOut(e1) {
                return this._scheduleFading(e1, 1, 0);
            }
            crossFadeFrom(e1, t, n) {
                if (e1.fadeOut(t), this.fadeIn(t), n) {
                    const n = this._clip.duration, i = e1._clip.duration, r = i / n, a = n / i;
                    e1.warp(1, r, t), this.warp(a, 1, t);
                }
                return this;
            }
            crossFadeTo(e1, t, n) {
                return e1.crossFadeFrom(this, t, n);
            }
            stopFading() {
                const e1 = this._weightInterpolant;
                return null !== e1 && (this._weightInterpolant = null, this._mixer._takeBackControlInterpolant(e1)), this;
            }
            setEffectiveTimeScale(e1) {
                return this.timeScale = e1, this._effectiveTimeScale = this.paused ? 0 : e1, this.stopWarping();
            }
            getEffectiveTimeScale() {
                return this._effectiveTimeScale;
            }
            setDuration(e1) {
                return this.timeScale = this._clip.duration / e1, this.stopWarping();
            }
            syncWith(e1) {
                return this.time = e1.time, this.timeScale = e1.timeScale, this.stopWarping();
            }
            halt(e1) {
                return this.warp(this._effectiveTimeScale, 0, e1);
            }
            warp(e1, t, n) {
                const i = this._mixer, r = i.time, a = this.timeScale;
                let s = this._timeScaleInterpolant;
                null === s && (s = i._lendControlInterpolant(), this._timeScaleInterpolant = s);
                const o = s.parameterPositions, l = s.sampleValues;
                return o[0] = r, o[1] = r + n, l[0] = e1 / a, l[1] = t / a, this;
            }
            stopWarping() {
                const e1 = this._timeScaleInterpolant;
                return null !== e1 && (this._timeScaleInterpolant = null, this._mixer._takeBackControlInterpolant(e1)), this;
            }
            getMixer() {
                return this._mixer;
            }
            getClip() {
                return this._clip;
            }
            getRoot() {
                return this._localRoot || this._mixer._root;
            }
            _update(e1, t, n, i) {
                if (!this.enabled) return void this._updateWeight(e1);
                const r = this._startTime;
                if (null !== r) {
                    const i = (e1 - r) * n;
                    i < 0 || 0 === n ? t = 0 : (this._startTime = null, t = n * i);
                }
                t *= this._updateTimeScale(e1);
                const a = this._updateTime(t), s = this._updateWeight(e1);
                if (s > 0) {
                    const e1 = this._interpolants, t = this._propertyBindings;
                    if (this.blendMode === Rs) for(let n = 0, i = e1.length; n !== i; ++n)e1[n].evaluate(a), t[n].accumulateAdditive(s);
                    else for(let n = 0, r = e1.length; n !== r; ++n)e1[n].evaluate(a), t[n].accumulate(i, s);
                }
            }
            _updateWeight(e1) {
                let t = 0;
                if (this.enabled) {
                    t = this.weight;
                    const n = this._weightInterpolant;
                    if (null !== n) {
                        const i = n.evaluate(e1)[0];
                        t *= i, e1 > n.parameterPositions[1] && (this.stopFading(), 0 === i && (this.enabled = !1));
                    }
                }
                return this._effectiveWeight = t, t;
            }
            _updateTimeScale(e1) {
                let t = 0;
                if (!this.paused) {
                    t = this.timeScale;
                    const n = this._timeScaleInterpolant;
                    null !== n && (t *= n.evaluate(e1)[0], e1 > n.parameterPositions[1] && (this.stopWarping(), 0 === t ? this.paused = !0 : this.timeScale = t));
                }
                return this._effectiveTimeScale = t, t;
            }
            _updateTime(e1) {
                const t = this._clip.duration, n = this.loop;
                let i = this.time + e1, r = this._loopCount;
                const a = n === Es;
                if (0 === e1) return -1 === r || !a || 1 & ~r ? i : t - i;
                if (n === bs) {
                    -1 === r && (this._loopCount = 0, this._setEndings(!0, !0, !1));
                    e: {
                        if (i >= t) i = t;
                        else {
                            if (!(i < 0)) {
                                this.time = i;
                                break e;
                            }
                            i = 0;
                        }
                        this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, this.time = i, this._mixer.dispatchEvent({
                            type: "finished",
                            action: this,
                            direction: e1 < 0 ? -1 : 1
                        });
                    }
                } else {
                    if (-1 === r && (e1 >= 0 ? (r = 0, this._setEndings(!0, 0 === this.repetitions, a)) : this._setEndings(0 === this.repetitions, !0, a)), i >= t || i < 0) {
                        const n = Math.floor(i / t);
                        i -= t * n, r += Math.abs(n);
                        const s = this.repetitions - r;
                        if (s <= 0) this.clampWhenFinished ? this.paused = !0 : this.enabled = !1, i = e1 > 0 ? t : 0, this.time = i, this._mixer.dispatchEvent({
                            type: "finished",
                            action: this,
                            direction: e1 > 0 ? 1 : -1
                        });
                        else {
                            if (1 === s) {
                                const t = e1 < 0;
                                this._setEndings(t, !t, a);
                            } else this._setEndings(!1, !1, a);
                            this._loopCount = r, this.time = i, this._mixer.dispatchEvent({
                                type: "loop",
                                action: this,
                                loopDelta: n
                            });
                        }
                    } else this.time = i;
                    if (a && !(1 & ~r)) return t - i;
                }
                return i;
            }
            _setEndings(e1, t, n) {
                const i = this._interpolantSettings;
                n ? (i.endingStart = Ds, i.endingEnd = Ds) : (i.endingStart = e1 ? this.zeroSlopeAtStart ? Ds : Ns : Cs, i.endingEnd = t ? this.zeroSlopeAtEnd ? Ds : Ns : Cs);
            }
            _scheduleFading(e1, t, n) {
                const i = this._mixer, r = i.time;
                let a = this._weightInterpolant;
                null === a && (a = i._lendControlInterpolant(), this._weightInterpolant = a);
                const s = a.parameterPositions, o = a.sampleValues;
                return s[0] = r, o[0] = t, s[1] = r + e1, o[1] = n, this;
            }
        }
        const Nv = new Float32Array(1);
        class Dv extends Uo {
            constructor(e1){
                super(), this._root = e1, this._initMemoryManager(), this._accuIndex = 0, this.time = 0, this.timeScale = 1;
            }
            _bindAction(e1, t) {
                const n = e1._localRoot || this._root, i = e1._clip.tracks, r = i.length, a = e1._propertyBindings, s = e1._interpolants, o = n.uuid, l = this._bindingsByRootAndName;
                let c = l[o];
                void 0 === c && (c = {}, l[o] = c);
                for(let e1 = 0; e1 !== r; ++e1){
                    const r = i[e1], l = r.name;
                    let u = c[l];
                    if (void 0 !== u) ++u.referenceCount, a[e1] = u;
                    else {
                        if (u = a[e1], void 0 !== u) {
                            null === u._cacheIndex && (++u.referenceCount, this._addInactiveBinding(u, o, l));
                            continue;
                        }
                        const i = t && t._propertyBindings[e1].binding.parsedPath;
                        u = new Mv(Tv.create(n, l, i), r.ValueTypeName, r.getValueSize()), ++u.referenceCount, this._addInactiveBinding(u, o, l), a[e1] = u;
                    }
                    s[e1].resultBuffer = u.buffer;
                }
            }
            _activateAction(e1) {
                if (!this._isActiveAction(e1)) {
                    if (null === e1._cacheIndex) {
                        const t = (e1._localRoot || this._root).uuid, n = e1._clip.uuid, i = this._actionsByClip[n];
                        this._bindAction(e1, i && i.knownActions[0]), this._addInactiveAction(e1, n, t);
                    }
                    const t = e1._propertyBindings;
                    for(let e1 = 0, n = t.length; e1 !== n; ++e1){
                        const n = t[e1];
                        0 == n.useCount++ && (this._lendBinding(n), n.saveOriginalState());
                    }
                    this._lendAction(e1);
                }
            }
            _deactivateAction(e1) {
                if (this._isActiveAction(e1)) {
                    const t = e1._propertyBindings;
                    for(let e1 = 0, n = t.length; e1 !== n; ++e1){
                        const n = t[e1];
                        0 == --n.useCount && (n.restoreOriginalState(), this._takeBackBinding(n));
                    }
                    this._takeBackAction(e1);
                }
            }
            _initMemoryManager() {
                this._actions = [], this._nActiveActions = 0, this._actionsByClip = {}, this._bindings = [], this._nActiveBindings = 0, this._bindingsByRootAndName = {}, this._controlInterpolants = [], this._nActiveControlInterpolants = 0;
                const e1 = this;
                this.stats = {
                    actions: {
                        get total () {
                            return e1._actions.length;
                        },
                        get inUse () {
                            return e1._nActiveActions;
                        }
                    },
                    bindings: {
                        get total () {
                            return e1._bindings.length;
                        },
                        get inUse () {
                            return e1._nActiveBindings;
                        }
                    },
                    controlInterpolants: {
                        get total () {
                            return e1._controlInterpolants.length;
                        },
                        get inUse () {
                            return e1._nActiveControlInterpolants;
                        }
                    }
                };
            }
            _isActiveAction(e1) {
                const t = e1._cacheIndex;
                return null !== t && t < this._nActiveActions;
            }
            _addInactiveAction(e1, t, n) {
                const i = this._actions, r = this._actionsByClip;
                let a = r[t];
                if (void 0 === a) a = {
                    knownActions: [
                        e1
                    ],
                    actionByRoot: {}
                }, e1._byClipCacheIndex = 0, r[t] = a;
                else {
                    const t = a.knownActions;
                    e1._byClipCacheIndex = t.length, t.push(e1);
                }
                e1._cacheIndex = i.length, i.push(e1), a.actionByRoot[n] = e1;
            }
            _removeInactiveAction(e1) {
                const t = this._actions, n = t[t.length - 1], i = e1._cacheIndex;
                n._cacheIndex = i, t[i] = n, t.pop(), e1._cacheIndex = null;
                const r = e1._clip.uuid, a = this._actionsByClip, s = a[r], o = s.knownActions, l = o[o.length - 1], c = e1._byClipCacheIndex;
                l._byClipCacheIndex = c, o[c] = l, o.pop(), e1._byClipCacheIndex = null, delete s.actionByRoot[(e1._localRoot || this._root).uuid], 0 === o.length && delete a[r], this._removeInactiveBindingsForAction(e1);
            }
            _removeInactiveBindingsForAction(e1) {
                const t = e1._propertyBindings;
                for(let e1 = 0, n = t.length; e1 !== n; ++e1){
                    const n = t[e1];
                    0 == --n.referenceCount && this._removeInactiveBinding(n);
                }
            }
            _lendAction(e1) {
                const t = this._actions, n = e1._cacheIndex, i = this._nActiveActions++, r = t[i];
                e1._cacheIndex = i, t[i] = e1, r._cacheIndex = n, t[n] = r;
            }
            _takeBackAction(e1) {
                const t = this._actions, n = e1._cacheIndex, i = --this._nActiveActions, r = t[i];
                e1._cacheIndex = i, t[i] = e1, r._cacheIndex = n, t[n] = r;
            }
            _addInactiveBinding(e1, t, n) {
                const i = this._bindingsByRootAndName, r = this._bindings;
                let a = i[t];
                void 0 === a && (a = {}, i[t] = a), a[n] = e1, e1._cacheIndex = r.length, r.push(e1);
            }
            _removeInactiveBinding(e1) {
                const t = this._bindings, n = e1.binding, i = n.rootNode.uuid, r = n.path, a = this._bindingsByRootAndName, s = a[i], o = t[t.length - 1], l = e1._cacheIndex;
                o._cacheIndex = l, t[l] = o, t.pop(), delete s[r], 0 === Object.keys(s).length && delete a[i];
            }
            _lendBinding(e1) {
                const t = this._bindings, n = e1._cacheIndex, i = this._nActiveBindings++, r = t[i];
                e1._cacheIndex = i, t[i] = e1, r._cacheIndex = n, t[n] = r;
            }
            _takeBackBinding(e1) {
                const t = this._bindings, n = e1._cacheIndex, i = --this._nActiveBindings, r = t[i];
                e1._cacheIndex = i, t[i] = e1, r._cacheIndex = n, t[n] = r;
            }
            _lendControlInterpolant() {
                const e1 = this._controlInterpolants, t = this._nActiveControlInterpolants++;
                let n = e1[t];
                return void 0 === n && (n = new $g(new Float32Array(2), new Float32Array(2), 1, Nv), n.__cacheIndex = t, e1[t] = n), n;
            }
            _takeBackControlInterpolant(e1) {
                const t = this._controlInterpolants, n = e1.__cacheIndex, i = --this._nActiveControlInterpolants, r = t[i];
                e1.__cacheIndex = i, t[i] = e1, r.__cacheIndex = n, t[n] = r;
            }
            clipAction(e1, t, n) {
                const i = t || this._root, r = i.uuid;
                let a = "string" == typeof e1 ? cA.findByName(i, e1) : e1;
                const s = null !== a ? a.uuid : e1, o = this._actionsByClip[s];
                let l = null;
                if (void 0 === n && (n = null !== a ? a.blendMode : Ls), void 0 !== o) {
                    const e1 = o.actionByRoot[r];
                    if (void 0 !== e1 && e1.blendMode === n) return e1;
                    l = o.knownActions[0], null === a && (a = l._clip);
                }
                if (null === a) return null;
                const c = new Iv(this, a, t, n);
                return this._bindAction(c, l), this._addInactiveAction(c, s, r), c;
            }
            existingAction(e1, t) {
                const n = t || this._root, i = n.uuid, r = "string" == typeof e1 ? cA.findByName(n, e1) : e1, a = r ? r.uuid : e1, s = this._actionsByClip[a];
                return void 0 !== s && s.actionByRoot[i] || null;
            }
            stopAllAction() {
                const e1 = this._actions;
                for(let t = this._nActiveActions - 1; t >= 0; --t)e1[t].stop();
                return this;
            }
            update(e1) {
                e1 *= this.timeScale;
                const t = this._actions, n = this._nActiveActions, i = this.time += e1, r = Math.sign(e1), a = this._accuIndex ^= 1;
                for(let s = 0; s !== n; ++s)t[s]._update(i, e1, r, a);
                const s = this._bindings, o = this._nActiveBindings;
                for(let e1 = 0; e1 !== o; ++e1)s[e1].apply(a);
                return this;
            }
            setTime(e1) {
                this.time = 0;
                for(let e1 = 0; e1 < this._actions.length; e1++)this._actions[e1].time = 0;
                return this.update(e1);
            }
            getRoot() {
                return this._root;
            }
            uncacheClip(e1) {
                const t = this._actions, n = e1.uuid, i = this._actionsByClip, r = i[n];
                if (void 0 !== r) {
                    const e1 = r.knownActions;
                    for(let n = 0, i = e1.length; n !== i; ++n){
                        const i = e1[n];
                        this._deactivateAction(i);
                        const r = i._cacheIndex, a = t[t.length - 1];
                        i._cacheIndex = null, i._byClipCacheIndex = null, a._cacheIndex = r, t[r] = a, t.pop(), this._removeInactiveBindingsForAction(i);
                    }
                    delete i[n];
                }
            }
            uncacheRoot(e1) {
                const t = e1.uuid, n = this._actionsByClip;
                for(const e1 in n){
                    const i = n[e1].actionByRoot[t];
                    void 0 !== i && (this._deactivateAction(i), this._removeInactiveAction(i));
                }
                const i = this._bindingsByRootAndName[t];
                if (void 0 !== i) for(const e1 in i){
                    const t = i[e1];
                    t.restoreOriginalState(), this._removeInactiveBinding(t);
                }
            }
            uncacheAction(e1, t) {
                const n = this.existingAction(e1, t);
                null !== n && (this._deactivateAction(n), this._removeInactiveAction(n));
            }
        }
        class Cv {
            constructor(e1){
                this.value = e1;
            }
            clone() {
                return new Cv(void 0 === this.value.clone ? this.value : this.value.clone());
            }
        }
        let Lv = 0;
        class Rv extends Uo {
            constructor(){
                super(), this.isUniformsGroup = !0, Object.defineProperty(this, "id", {
                    value: Lv++
                }), this.name = "", this.usage = bo, this.uniforms = [];
            }
            add(e1) {
                return this.uniforms.push(e1), this;
            }
            remove(e1) {
                const t = this.uniforms.indexOf(e1);
                return -1 !== t && this.uniforms.splice(t, 1), this;
            }
            setName(e1) {
                return this.name = e1, this;
            }
            setUsage(e1) {
                return this.usage = e1, this;
            }
            dispose() {
                return this.dispatchEvent({
                    type: "dispose"
                }), this;
            }
            copy(e1) {
                this.name = e1.name, this.usage = e1.usage;
                const t = e1.uniforms;
                this.uniforms.length = 0;
                for(let e1 = 0, n = t.length; e1 < n; e1++)this.uniforms.push(t[e1].clone());
                return this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class zv extends qp {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                super(e1, t), this.isInstancedInterleavedBuffer = !0, this.meshPerAttribute = n;
            }
            copy(e1) {
                return super.copy(e1), this.meshPerAttribute = e1.meshPerAttribute, this;
            }
            clone(e1) {
                const t = super.clone(e1);
                return t.meshPerAttribute = this.meshPerAttribute, t;
            }
            toJSON(e1) {
                const t = super.toJSON(e1);
                return t.isInstancedInterleavedBuffer = !0, t.meshPerAttribute = this.meshPerAttribute, t;
            }
        }
        class Ov {
            constructor(e1, t, n, i, r){
                this.isGLBufferAttribute = !0, this.name = "", this.buffer = e1, this.type = t, this.itemSize = n, this.elementSize = i, this.count = r, this.version = 0;
            }
            set needsUpdate(e1) {
                !0 === e1 && this.version++;
            }
            setBuffer(e1) {
                return this.buffer = e1, this;
            }
            setType(e1, t) {
                return this.type = e1, this.elementSize = t, this;
            }
            setItemSize(e1) {
                return this.itemSize = e1, this;
            }
            setCount(e1) {
                return this.count = e1, this;
            }
        }
        class Pv {
            constructor(e1, t){
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1 / 0;
                this.ray = new sc(e1, t), this.near = n, this.far = i, this.camera = null, this.layers = new vc, this.params = {
                    Mesh: {},
                    Line: {
                        threshold: 1
                    },
                    LOD: {},
                    Points: {
                        threshold: 1
                    },
                    Sprite: {}
                };
            }
            set(e1, t) {
                this.ray.set(e1, t);
            }
            setFromCamera(e1, t) {
                t.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(t.matrixWorld), this.ray.direction.set(e1.x, e1.y, .5).unproject(t).sub(this.ray.origin).normalize(), this.camera = t) : t.isOrthographicCamera ? (this.ray.origin.set(e1.x, e1.y, (t.near + t.far) / (t.near - t.far)).unproject(t), this.ray.direction.set(0, 0, -1).transformDirection(t.matrixWorld), this.camera = t) : console.error("THREE.Raycaster: Unsupported camera type: " + t.type);
            }
            intersectObject(e1) {
                let t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
                return kv(e1, this, t, !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1]), t.sort(Uv), t;
            }
            intersectObjects(e1) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [];
                for(let i = 0, r = e1.length; i < r; i++)kv(e1[i], this, n, t);
                return n.sort(Uv), n;
            }
        }
        function Uv(e1, t) {
            return e1.distance - t.distance;
        }
        function kv(e1, t, n, i) {
            if (e1.layers.test(t.layers) && e1.raycast(t, n), !0 === i) {
                const i = e1.children;
                for(let e1 = 0, r = i.length; e1 < r; e1++)kv(i[e1], t, n, !0);
            }
        }
        class jv {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                return this.radius = e1, this.phi = t, this.theta = n, this;
            }
            set(e1, t, n) {
                return this.radius = e1, this.phi = t, this.theta = n, this;
            }
            copy(e1) {
                return this.radius = e1.radius, this.phi = e1.phi, this.theta = e1.theta, this;
            }
            makeSafe() {
                const e1 = 1e-6;
                return this.phi = Math.max(e1, Math.min(Math.PI - e1, this.phi)), this;
            }
            setFromVector3(e1) {
                return this.setFromCartesianCoords(e1.x, e1.y, e1.z);
            }
            setFromCartesianCoords(e1, t, n) {
                return this.radius = Math.sqrt(e1 * e1 + t * t + n * n), 0 === this.radius ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(e1, n), this.phi = Math.acos(Vo(t / this.radius, -1, 1))), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        class Bv {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                return this.radius = e1, this.theta = t, this.y = n, this;
            }
            set(e1, t, n) {
                return this.radius = e1, this.theta = t, this.y = n, this;
            }
            copy(e1) {
                return this.radius = e1.radius, this.theta = e1.theta, this.y = e1.y, this;
            }
            setFromVector3(e1) {
                return this.setFromCartesianCoords(e1.x, e1.y, e1.z);
            }
            setFromCartesianCoords(e1, t, n) {
                return this.radius = Math.sqrt(e1 * e1 + n * n), this.theta = Math.atan2(e1, n), this.y = t, this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const Fv = new Jo;
        class Hv {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Jo(1 / 0, 1 / 0), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Jo(-1 / 0, -1 / 0);
                this.isBox2 = !0, this.min = e1, this.max = t;
            }
            set(e1, t) {
                return this.min.copy(e1), this.max.copy(t), this;
            }
            setFromPoints(e1) {
                this.makeEmpty();
                for(let t = 0, n = e1.length; t < n; t++)this.expandByPoint(e1[t]);
                return this;
            }
            setFromCenterAndSize(e1, t) {
                const n = Fv.copy(t).multiplyScalar(.5);
                return this.min.copy(e1).sub(n), this.max.copy(e1).add(n), this;
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                return this.min.copy(e1.min), this.max.copy(e1.max), this;
            }
            makeEmpty() {
                return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
            }
            isEmpty() {
                return this.max.x < this.min.x || this.max.y < this.min.y;
            }
            getCenter(e1) {
                return this.isEmpty() ? e1.set(0, 0) : e1.addVectors(this.min, this.max).multiplyScalar(.5);
            }
            getSize(e1) {
                return this.isEmpty() ? e1.set(0, 0) : e1.subVectors(this.max, this.min);
            }
            expandByPoint(e1) {
                return this.min.min(e1), this.max.max(e1), this;
            }
            expandByVector(e1) {
                return this.min.sub(e1), this.max.add(e1), this;
            }
            expandByScalar(e1) {
                return this.min.addScalar(-e1), this.max.addScalar(e1), this;
            }
            containsPoint(e1) {
                return !(e1.x < this.min.x || e1.x > this.max.x || e1.y < this.min.y || e1.y > this.max.y);
            }
            containsBox(e1) {
                return this.min.x <= e1.min.x && e1.max.x <= this.max.x && this.min.y <= e1.min.y && e1.max.y <= this.max.y;
            }
            getParameter(e1, t) {
                return t.set((e1.x - this.min.x) / (this.max.x - this.min.x), (e1.y - this.min.y) / (this.max.y - this.min.y));
            }
            intersectsBox(e1) {
                return !(e1.max.x < this.min.x || e1.min.x > this.max.x || e1.max.y < this.min.y || e1.min.y > this.max.y);
            }
            clampPoint(e1, t) {
                return t.copy(e1).clamp(this.min, this.max);
            }
            distanceToPoint(e1) {
                return this.clampPoint(e1, Fv).distanceTo(e1);
            }
            intersect(e1) {
                return this.min.max(e1.min), this.max.min(e1.max), this.isEmpty() && this.makeEmpty(), this;
            }
            union(e1) {
                return this.min.min(e1.min), this.max.max(e1.max), this;
            }
            translate(e1) {
                return this.min.add(e1), this.max.add(e1), this;
            }
            equals(e1) {
                return e1.min.equals(this.min) && e1.max.equals(this.max);
            }
        }
        const Vv = new Cl, Gv = new Cl;
        class Qv {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Cl, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl;
                this.start = e1, this.end = t;
            }
            set(e1, t) {
                return this.start.copy(e1), this.end.copy(t), this;
            }
            copy(e1) {
                return this.start.copy(e1.start), this.end.copy(e1.end), this;
            }
            getCenter(e1) {
                return e1.addVectors(this.start, this.end).multiplyScalar(.5);
            }
            delta(e1) {
                return e1.subVectors(this.end, this.start);
            }
            distanceSq() {
                return this.start.distanceToSquared(this.end);
            }
            distance() {
                return this.start.distanceTo(this.end);
            }
            at(e1, t) {
                return this.delta(t).multiplyScalar(e1).add(this.start);
            }
            closestPointToPointParameter(e1, t) {
                Vv.subVectors(e1, this.start), Gv.subVectors(this.end, this.start);
                const n = Gv.dot(Gv);
                let i = Gv.dot(Vv) / n;
                return t && (i = Vo(i, 0, 1)), i;
            }
            closestPointToPoint(e1, t, n) {
                const i = this.closestPointToPointParameter(e1, t);
                return this.delta(n).multiplyScalar(i).add(this.start);
            }
            applyMatrix4(e1) {
                return this.start.applyMatrix4(e1), this.end.applyMatrix4(e1), this;
            }
            equals(e1) {
                return e1.start.equals(this.start) && e1.end.equals(this.end);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
        }
        const Wv = new Cl;
        class Yv extends Lc {
            constructor(e1, t){
                super(), this.light = e1, this.matrix = e1.matrixWorld, this.matrixAutoUpdate = !1, this.color = t, this.type = "SpotLightHelper";
                const n = new Eu, i = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    1,
                    0,
                    0,
                    0,
                    -1,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    0,
                    0,
                    0,
                    0,
                    -1,
                    1
                ];
                for(let e1 = 0, t = 1, n = 32; e1 < n; e1++, t++){
                    const r = e1 / n * Math.PI * 2, a = t / n * Math.PI * 2;
                    i.push(Math.cos(r), Math.sin(r), 1, Math.cos(a), Math.sin(a), 1);
                }
                n.setAttribute("position", new gu(i, 3));
                const r = new Vf({
                    fog: !1,
                    toneMapped: !1
                });
                this.cone = new Jf(n, r), this.add(this.cone), this.update();
            }
            dispose() {
                this.cone.geometry.dispose(), this.cone.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1);
                const e1 = this.light.distance ? this.light.distance : 1e3, t = e1 * Math.tan(this.light.angle);
                this.cone.scale.set(t, t, e1), Wv.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt(Wv), void 0 !== this.color ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
            }
        }
        const Xv = new Cl, Zv = new oc, qv = new oc;
        class Kv extends Jf {
            constructor(e1){
                const t = Jv(e1), n = new Eu, i = [], r = [], a = new Zc(0, 0, 1), s = new Zc(0, 1, 0);
                for(let e1 = 0; e1 < t.length; e1++){
                    const n = t[e1];
                    n.parent && n.parent.isBone && (i.push(0, 0, 0), i.push(0, 0, 0), r.push(a.r, a.g, a.b), r.push(s.r, s.g, s.b));
                }
                n.setAttribute("position", new gu(i, 3)), n.setAttribute("color", new gu(r, 3)), super(n, new Vf({
                    vertexColors: !0,
                    depthTest: !1,
                    depthWrite: !1,
                    toneMapped: !1,
                    transparent: !0
                })), this.isSkeletonHelper = !0, this.type = "SkeletonHelper", this.root = e1, this.bones = t, this.matrix = e1.matrixWorld, this.matrixAutoUpdate = !1;
            }
            updateMatrixWorld(e1) {
                const t = this.bones, n = this.geometry, i = n.getAttribute("position");
                qv.copy(this.root.matrixWorld).invert();
                for(let e1 = 0, n = 0; e1 < t.length; e1++){
                    const r = t[e1];
                    r.parent && r.parent.isBone && (Zv.multiplyMatrices(qv, r.matrixWorld), Xv.setFromMatrixPosition(Zv), i.setXYZ(n, Xv.x, Xv.y, Xv.z), Zv.multiplyMatrices(qv, r.parent.matrixWorld), Xv.setFromMatrixPosition(Zv), i.setXYZ(n + 1, Xv.x, Xv.y, Xv.z), n += 2);
                }
                n.getAttribute("position").needsUpdate = !0, super.updateMatrixWorld(e1);
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        function Jv(e1) {
            const t = [];
            !0 === e1.isBone && t.push(e1);
            for(let n = 0; n < e1.children.length; n++)t.push.apply(t, Jv(e1.children[n]));
            return t;
        }
        class $v extends Vu {
            constructor(e1, t, n){
                super(new Sg(t, 4, 2), new $c({
                    wireframe: !0,
                    fog: !1,
                    toneMapped: !1
                })), this.light = e1, this.color = n, this.type = "PointLightHelper", this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1, this.update();
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), void 0 !== this.color ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
            }
        }
        const eM = new Cl, tM = new Zc, nM = new Zc;
        class iM extends Lc {
            constructor(e1, t, n){
                super(), this.light = e1, this.matrix = e1.matrixWorld, this.matrixAutoUpdate = !1, this.color = n, this.type = "HemisphereLightHelper";
                const i = new wg(t);
                i.rotateY(.5 * Math.PI), this.material = new $c({
                    wireframe: !0,
                    fog: !1,
                    toneMapped: !1
                }), void 0 === this.color && (this.material.vertexColors = !0);
                const r = i.getAttribute("position"), a = new Float32Array(3 * r.count);
                i.setAttribute("color", new ou(a, 3)), this.add(new Vu(i, this.material)), this.update();
            }
            dispose() {
                this.children[0].geometry.dispose(), this.children[0].material.dispose();
            }
            update() {
                const e1 = this.children[0];
                if (void 0 !== this.color) this.material.color.set(this.color);
                else {
                    const t = e1.geometry.getAttribute("color");
                    tM.copy(this.light.color), nM.copy(this.light.groundColor);
                    for(let e1 = 0, n = t.count; e1 < n; e1++){
                        const i = e1 < n / 2 ? tM : nM;
                        t.setXYZ(e1, i.r, i.g, i.b);
                    }
                    t.needsUpdate = !0;
                }
                this.light.updateWorldMatrix(!0, !1), e1.lookAt(eM.setFromMatrixPosition(this.light.matrixWorld).negate());
            }
        }
        class rM extends Jf {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 10, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 4473924, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 8947848;
                n = new Zc(n), i = new Zc(i);
                const r = t / 2, a = e1 / t, s = e1 / 2, o = [], l = [];
                for(let e1 = 0, c = 0, u = -s; e1 <= t; e1++, u += a){
                    o.push(-s, 0, u, s, 0, u), o.push(u, 0, -s, u, 0, s);
                    const t = e1 === r ? n : i;
                    t.toArray(l, c), c += 3, t.toArray(l, c), c += 3, t.toArray(l, c), c += 3, t.toArray(l, c), c += 3;
                }
                const c = new Eu;
                c.setAttribute("position", new gu(o, 3)), c.setAttribute("color", new gu(l, 3)), super(c, new Vf({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "GridHelper";
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class aM extends Jf {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 10, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 16, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 8, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 64, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 4473924, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 8947848;
                r = new Zc(r), a = new Zc(a);
                const s = [], o = [];
                if (t > 1) for(let n = 0; n < t; n++){
                    const i = n / t * (2 * Math.PI), l = Math.sin(i) * e1, c = Math.cos(i) * e1;
                    s.push(0, 0, 0), s.push(l, 0, c);
                    const u = 1 & n ? r : a;
                    o.push(u.r, u.g, u.b), o.push(u.r, u.g, u.b);
                }
                for(let t = 0; t < n; t++){
                    const l = 1 & t ? r : a, c = e1 - e1 / n * t;
                    for(let e1 = 0; e1 < i; e1++){
                        let t = e1 / i * (2 * Math.PI), n = Math.sin(t) * c, r = Math.cos(t) * c;
                        s.push(n, 0, r), o.push(l.r, l.g, l.b), t = (e1 + 1) / i * (2 * Math.PI), n = Math.sin(t) * c, r = Math.cos(t) * c, s.push(n, 0, r), o.push(l.r, l.g, l.b);
                    }
                }
                const l = new Eu;
                l.setAttribute("position", new gu(s, 3)), l.setAttribute("color", new gu(o, 3)), super(l, new Vf({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "PolarGridHelper";
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        const sM = new Cl, oM = new Cl, lM = new Cl;
        class cM extends Lc {
            constructor(e1, t, n){
                super(), this.light = e1, this.matrix = e1.matrixWorld, this.matrixAutoUpdate = !1, this.color = n, this.type = "DirectionalLightHelper", void 0 === t && (t = 1);
                let i = new Eu;
                i.setAttribute("position", new gu([
                    -t,
                    t,
                    0,
                    t,
                    t,
                    0,
                    t,
                    -t,
                    0,
                    -t,
                    -t,
                    0,
                    -t,
                    t,
                    0
                ], 3));
                const r = new Vf({
                    fog: !1,
                    toneMapped: !1
                });
                this.lightPlane = new Zf(i, r), this.add(this.lightPlane), i = new Eu, i.setAttribute("position", new gu([
                    0,
                    0,
                    0,
                    0,
                    0,
                    1
                ], 3)), this.targetLine = new Zf(i, r), this.add(this.targetLine), this.update();
            }
            dispose() {
                this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
            }
            update() {
                this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), sM.setFromMatrixPosition(this.light.matrixWorld), oM.setFromMatrixPosition(this.light.target.matrixWorld), lM.subVectors(oM, sM), this.lightPlane.lookAt(oM), void 0 !== this.color ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt(oM), this.targetLine.scale.z = lM.length();
            }
        }
        const uM = new Cl, hM = new Ku;
        class dM extends Jf {
            constructor(e1){
                const t = new Eu, n = new Vf({
                    color: 16777215,
                    vertexColors: !0,
                    toneMapped: !1
                }), i = [], r = [], a = {};
                function s(e1, t) {
                    o(e1), o(t);
                }
                function o(e1) {
                    i.push(0, 0, 0), r.push(0, 0, 0), void 0 === a[e1] && (a[e1] = []), a[e1].push(i.length / 3 - 1);
                }
                s("n1", "n2"), s("n2", "n4"), s("n4", "n3"), s("n3", "n1"), s("f1", "f2"), s("f2", "f4"), s("f4", "f3"), s("f3", "f1"), s("n1", "f1"), s("n2", "f2"), s("n3", "f3"), s("n4", "f4"), s("p", "n1"), s("p", "n2"), s("p", "n3"), s("p", "n4"), s("u1", "u2"), s("u2", "u3"), s("u3", "u1"), s("c", "t"), s("p", "c"), s("cn1", "cn2"), s("cn3", "cn4"), s("cf1", "cf2"), s("cf3", "cf4"), t.setAttribute("position", new gu(i, 3)), t.setAttribute("color", new gu(r, 3)), super(t, n), this.type = "CameraHelper", this.camera = e1, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = e1.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = a, this.update();
                const l = new Zc(16755200), c = new Zc(16711680), u = new Zc(43775), h = new Zc(16777215), d = new Zc(3355443);
                this.setColors(l, c, u, h, d);
            }
            setColors(e1, t, n, i, r) {
                const a = this.geometry.getAttribute("color");
                a.setXYZ(0, e1.r, e1.g, e1.b), a.setXYZ(1, e1.r, e1.g, e1.b), a.setXYZ(2, e1.r, e1.g, e1.b), a.setXYZ(3, e1.r, e1.g, e1.b), a.setXYZ(4, e1.r, e1.g, e1.b), a.setXYZ(5, e1.r, e1.g, e1.b), a.setXYZ(6, e1.r, e1.g, e1.b), a.setXYZ(7, e1.r, e1.g, e1.b), a.setXYZ(8, e1.r, e1.g, e1.b), a.setXYZ(9, e1.r, e1.g, e1.b), a.setXYZ(10, e1.r, e1.g, e1.b), a.setXYZ(11, e1.r, e1.g, e1.b), a.setXYZ(12, e1.r, e1.g, e1.b), a.setXYZ(13, e1.r, e1.g, e1.b), a.setXYZ(14, e1.r, e1.g, e1.b), a.setXYZ(15, e1.r, e1.g, e1.b), a.setXYZ(16, e1.r, e1.g, e1.b), a.setXYZ(17, e1.r, e1.g, e1.b), a.setXYZ(18, e1.r, e1.g, e1.b), a.setXYZ(19, e1.r, e1.g, e1.b), a.setXYZ(20, e1.r, e1.g, e1.b), a.setXYZ(21, e1.r, e1.g, e1.b), a.setXYZ(22, e1.r, e1.g, e1.b), a.setXYZ(23, e1.r, e1.g, e1.b), a.setXYZ(24, t.r, t.g, t.b), a.setXYZ(25, t.r, t.g, t.b), a.setXYZ(26, t.r, t.g, t.b), a.setXYZ(27, t.r, t.g, t.b), a.setXYZ(28, t.r, t.g, t.b), a.setXYZ(29, t.r, t.g, t.b), a.setXYZ(30, t.r, t.g, t.b), a.setXYZ(31, t.r, t.g, t.b), a.setXYZ(32, n.r, n.g, n.b), a.setXYZ(33, n.r, n.g, n.b), a.setXYZ(34, n.r, n.g, n.b), a.setXYZ(35, n.r, n.g, n.b), a.setXYZ(36, n.r, n.g, n.b), a.setXYZ(37, n.r, n.g, n.b), a.setXYZ(38, i.r, i.g, i.b), a.setXYZ(39, i.r, i.g, i.b), a.setXYZ(40, r.r, r.g, r.b), a.setXYZ(41, r.r, r.g, r.b), a.setXYZ(42, r.r, r.g, r.b), a.setXYZ(43, r.r, r.g, r.b), a.setXYZ(44, r.r, r.g, r.b), a.setXYZ(45, r.r, r.g, r.b), a.setXYZ(46, r.r, r.g, r.b), a.setXYZ(47, r.r, r.g, r.b), a.setXYZ(48, r.r, r.g, r.b), a.setXYZ(49, r.r, r.g, r.b), a.needsUpdate = !0;
            }
            update() {
                const e1 = this.geometry, t = this.pointMap;
                hM.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse), pM("c", t, e1, hM, 0, 0, -1), pM("t", t, e1, hM, 0, 0, 1), pM("n1", t, e1, hM, -1, -1, -1), pM("n2", t, e1, hM, 1, -1, -1), pM("n3", t, e1, hM, -1, 1, -1), pM("n4", t, e1, hM, 1, 1, -1), pM("f1", t, e1, hM, -1, -1, 1), pM("f2", t, e1, hM, 1, -1, 1), pM("f3", t, e1, hM, -1, 1, 1), pM("f4", t, e1, hM, 1, 1, 1), pM("u1", t, e1, hM, .7, 1.1, -1), pM("u2", t, e1, hM, -0.7, 1.1, -1), pM("u3", t, e1, hM, 0, 2, -1), pM("cf1", t, e1, hM, -1, 0, 1), pM("cf2", t, e1, hM, 1, 0, 1), pM("cf3", t, e1, hM, 0, -1, 1), pM("cf4", t, e1, hM, 0, 1, 1), pM("cn1", t, e1, hM, -1, 0, -1), pM("cn2", t, e1, hM, 1, 0, -1), pM("cn3", t, e1, hM, 0, -1, -1), pM("cn4", t, e1, hM, 0, 1, -1), e1.getAttribute("position").needsUpdate = !0;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        function pM(e1, t, n, i, r, a, s) {
            uM.set(r, a, s).unproject(i);
            const o = t[e1];
            if (void 0 !== o) {
                const e1 = n.getAttribute("position");
                for(let t = 0, n = o.length; t < n; t++)e1.setXYZ(o[t], uM.x, uM.y, uM.z);
            }
        }
        const fM = new zl;
        class mM extends Jf {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 16776960;
                const n = new Uint16Array([
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    0,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    4,
                    0,
                    4,
                    1,
                    5,
                    2,
                    6,
                    3,
                    7
                ]), i = new Float32Array(24), r = new Eu;
                r.setIndex(new ou(n, 1)), r.setAttribute("position", new ou(i, 3)), super(r, new Vf({
                    color: t,
                    toneMapped: !1
                })), this.object = e1, this.type = "BoxHelper", this.matrixAutoUpdate = !1, this.update();
            }
            update(e1) {
                if (void 0 !== e1 && console.warn("THREE.BoxHelper: .update() has no longer arguments."), void 0 !== this.object && fM.setFromObject(this.object), fM.isEmpty()) return;
                const t = fM.min, n = fM.max, i = this.geometry.attributes.position, r = i.array;
                r[0] = n.x, r[1] = n.y, r[2] = n.z, r[3] = t.x, r[4] = n.y, r[5] = n.z, r[6] = t.x, r[7] = t.y, r[8] = n.z, r[9] = n.x, r[10] = t.y, r[11] = n.z, r[12] = n.x, r[13] = n.y, r[14] = t.z, r[15] = t.x, r[16] = n.y, r[17] = t.z, r[18] = t.x, r[19] = t.y, r[20] = t.z, r[21] = n.x, r[22] = t.y, r[23] = t.z, i.needsUpdate = !0, this.geometry.computeBoundingSphere();
            }
            setFromObject(e1) {
                return this.object = e1, this.update(), this;
            }
            copy(e1, t) {
                return super.copy(e1, t), this.object = e1.object, this;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class gM extends Jf {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 16776960;
                const n = new Uint16Array([
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    0,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    4,
                    0,
                    4,
                    1,
                    5,
                    2,
                    6,
                    3,
                    7
                ]), i = new Eu;
                i.setIndex(new ou(n, 1)), i.setAttribute("position", new gu([
                    1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    1,
                    -1,
                    1,
                    1,
                    1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1,
                    -1,
                    -1,
                    1,
                    -1,
                    -1
                ], 3)), super(i, new Vf({
                    color: t,
                    toneMapped: !1
                })), this.box = e1, this.type = "Box3Helper", this.geometry.computeBoundingSphere();
            }
            updateMatrixWorld(e1) {
                const t = this.box;
                t.isEmpty() || (t.getCenter(this.position), t.getSize(this.scale), this.scale.multiplyScalar(.5), super.updateMatrixWorld(e1));
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class AM extends Zf {
            constructor(e1){
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
                const n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 16776960, i = new Eu;
                i.setAttribute("position", new gu([
                    1,
                    -1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    -1,
                    0,
                    1,
                    1,
                    0
                ], 3)), i.computeBoundingSphere(), super(i, new Vf({
                    color: n,
                    toneMapped: !1
                })), this.type = "PlaneHelper", this.plane = e1, this.size = t;
                const r = new Eu;
                r.setAttribute("position", new gu([
                    1,
                    1,
                    0,
                    -1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    1,
                    0,
                    -1,
                    -1,
                    0,
                    1,
                    -1,
                    0
                ], 3)), r.computeBoundingSphere(), this.add(new Vu(r, new $c({
                    color: n,
                    opacity: .2,
                    transparent: !0,
                    depthWrite: !1,
                    toneMapped: !1
                })));
            }
            updateMatrixWorld(e1) {
                this.position.set(0, 0, 0), this.scale.set(.5 * this.size, .5 * this.size, 1), this.lookAt(this.plane.normal), this.translateZ(-this.plane.constant), super.updateMatrixWorld(e1);
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose(), this.children[0].geometry.dispose(), this.children[0].material.dispose();
            }
        }
        const vM = new Cl;
        let MM, yM;
        class xM extends Lc {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : new Cl(0, 0, 1), t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Cl(0, 0, 0), n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 16776960, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : .2 * n, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : .2 * r;
                super(), this.type = "ArrowHelper", void 0 === MM && (MM = new Eu, MM.setAttribute("position", new gu([
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ], 3)), yM = new km(0, .5, 1, 5, 1), yM.translate(0, -0.5, 0)), this.position.copy(t), this.line = new Zf(MM, new Vf({
                    color: i,
                    toneMapped: !1
                })), this.line.matrixAutoUpdate = !1, this.add(this.line), this.cone = new Vu(yM, new $c({
                    color: i,
                    toneMapped: !1
                })), this.cone.matrixAutoUpdate = !1, this.add(this.cone), this.setDirection(e1), this.setLength(n, r, a);
            }
            setDirection(e1) {
                if (e1.y > .99999) this.quaternion.set(0, 0, 0, 1);
                else if (e1.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
                else {
                    vM.set(e1.z, 0, -e1.x).normalize();
                    const t = Math.acos(e1.y);
                    this.quaternion.setFromAxisAngle(vM, t);
                }
            }
            setLength(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .2 * e1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : .2 * t;
                this.line.scale.set(1, Math.max(1e-4, e1 - t), 1), this.line.updateMatrix(), this.cone.scale.set(n, t, n), this.cone.position.y = e1, this.cone.updateMatrix();
            }
            setColor(e1) {
                this.line.material.color.set(e1), this.cone.material.color.set(e1);
            }
            copy(e1) {
                return super.copy(e1, !1), this.line.copy(e1.line), this.cone.copy(e1.cone), this;
            }
            dispose() {
                this.line.geometry.dispose(), this.line.material.dispose(), this.cone.geometry.dispose(), this.cone.material.dispose();
            }
        }
        class _M extends Jf {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
                const t = [
                    0,
                    0,
                    0,
                    e1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    e1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    e1
                ], n = new Eu;
                n.setAttribute("position", new gu(t, 3)), n.setAttribute("color", new gu([
                    1,
                    0,
                    0,
                    1,
                    .6,
                    0,
                    0,
                    1,
                    0,
                    .6,
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    .6,
                    1
                ], 3)), super(n, new Vf({
                    vertexColors: !0,
                    toneMapped: !1
                })), this.type = "AxesHelper";
            }
            setColors(e1, t, n) {
                const i = new Zc, r = this.geometry.attributes.color.array;
                return i.set(e1), i.toArray(r, 0), i.toArray(r, 3), i.set(t), i.toArray(r, 6), i.toArray(r, 9), i.set(n), i.toArray(r, 12), i.toArray(r, 15), this.geometry.attributes.color.needsUpdate = !0, this;
            }
            dispose() {
                this.geometry.dispose(), this.material.dispose();
            }
        }
        class bM {
            constructor(){
                this.type = "ShapePath", this.color = new Zc, this.subPaths = [], this.currentPath = null;
            }
            moveTo(e1, t) {
                return this.currentPath = new zm, this.subPaths.push(this.currentPath), this.currentPath.moveTo(e1, t), this;
            }
            lineTo(e1, t) {
                return this.currentPath.lineTo(e1, t), this;
            }
            quadraticCurveTo(e1, t, n, i) {
                return this.currentPath.quadraticCurveTo(e1, t, n, i), this;
            }
            bezierCurveTo(e1, t, n, i, r, a) {
                return this.currentPath.bezierCurveTo(e1, t, n, i, r, a), this;
            }
            splineThru(e1) {
                return this.currentPath.splineThru(e1), this;
            }
            toShapes(e1) {
                function t(e1, t) {
                    const n = t.length;
                    let i = !1;
                    for(let r = n - 1, a = 0; a < n; r = a++){
                        let n = t[r], s = t[a], o = s.x - n.x, l = s.y - n.y;
                        if (Math.abs(l) > Number.EPSILON) {
                            if (l < 0 && (n = t[a], o = -o, s = t[r], l = -l), e1.y < n.y || e1.y > s.y) continue;
                            if (e1.y === n.y) {
                                if (e1.x === n.x) return !0;
                            } else {
                                const t = l * (e1.x - n.x) - o * (e1.y - n.y);
                                if (0 === t) return !0;
                                if (t < 0) continue;
                                i = !i;
                            }
                        } else {
                            if (e1.y !== n.y) continue;
                            if (s.x <= e1.x && e1.x <= n.x || n.x <= e1.x && e1.x <= s.x) return !0;
                        }
                    }
                    return i;
                }
                const n = vg.isClockWise, i = this.subPaths;
                if (0 === i.length) return [];
                let r, a, s;
                const o = [];
                if (1 === i.length) return a = i[0], s = new Ym, s.curves = a.curves, o.push(s), o;
                let l = !n(i[0].getPoints());
                l = e1 ? !l : l;
                const c = [], u = [];
                let h, d, p = [], f = 0;
                u[f] = void 0, p[f] = [];
                for(let t = 0, s = i.length; t < s; t++)a = i[t], h = a.getPoints(), r = n(h), r = e1 ? !r : r, r ? (!l && u[f] && f++, u[f] = {
                    s: new Ym,
                    p: h
                }, u[f].s.curves = a.curves, l && f++, p[f] = []) : p[f].push({
                    h: a,
                    p: h[0]
                });
                if (!u[0]) return function(e1) {
                    const t = [];
                    for(let n = 0, i = e1.length; n < i; n++){
                        const i = e1[n], r = new Ym;
                        r.curves = i.curves, t.push(r);
                    }
                    return t;
                }(i);
                if (u.length > 1) {
                    let e1 = !1, n = 0;
                    for(let e1 = 0, t = u.length; e1 < t; e1++)c[e1] = [];
                    for(let i = 0, r = u.length; i < r; i++){
                        const r = p[i];
                        for(let a = 0; a < r.length; a++){
                            const s = r[a];
                            let o = !0;
                            for(let r = 0; r < u.length; r++)t(s.p, u[r].p) && (i !== r && n++, o ? (o = !1, c[r].push(s)) : e1 = !0);
                            o && c[i].push(s);
                        }
                    }
                    n > 0 && !1 === e1 && (p = c);
                }
                for(let e1 = 0, t = u.length; e1 < t; e1++){
                    s = u[e1].s, o.push(s), d = p[e1];
                    for(let e1 = 0, t = d.length; e1 < t; e1++)s.holes.push(d[e1].h);
                }
                return o;
            }
        }
        function wM(e1, t) {
            if (t === zs) return console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles."), e1;
            if (t === Ps || t === Os) {
                let n = e1.getIndex();
                if (null === n) {
                    const t = [], i = e1.getAttribute("position");
                    if (void 0 === i) return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), e1;
                    for(let e1 = 0; e1 < i.count; e1++)t.push(e1);
                    e1.setIndex(t), n = e1.getIndex();
                }
                const i = n.count - 2, r = [];
                if (t === Ps) for(let e1 = 1; e1 <= i; e1++)r.push(n.getX(0)), r.push(n.getX(e1)), r.push(n.getX(e1 + 1));
                else for(let e1 = 0; e1 < i; e1++)e1 % 2 == 0 ? (r.push(n.getX(e1)), r.push(n.getX(e1 + 1)), r.push(n.getX(e1 + 2))) : (r.push(n.getX(e1 + 2)), r.push(n.getX(e1 + 1)), r.push(n.getX(e1)));
                r.length / 3 !== i && console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
                const a = e1.clone();
                return a.setIndex(r), a.clearGroups(), a;
            }
            return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", t), e1;
        }
        "undefined" != typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
            detail: {
                revision: Ji
            }
        })), "undefined" != typeof window && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = Ji);
        class EM extends fA {
            constructor(e1){
                super(e1), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(e1) {
                    return new CM(e1);
                }), this.register(function(e1) {
                    return new jM(e1);
                }), this.register(function(e1) {
                    return new BM(e1);
                }), this.register(function(e1) {
                    return new FM(e1);
                }), this.register(function(e1) {
                    return new RM(e1);
                }), this.register(function(e1) {
                    return new zM(e1);
                }), this.register(function(e1) {
                    return new OM(e1);
                }), this.register(function(e1) {
                    return new PM(e1);
                }), this.register(function(e1) {
                    return new DM(e1);
                }), this.register(function(e1) {
                    return new UM(e1);
                }), this.register(function(e1) {
                    return new LM(e1);
                }), this.register(function(e1) {
                    return new kM(e1);
                }), this.register(function(e1) {
                    return new IM(e1);
                }), this.register(function(e1) {
                    return new HM(e1);
                }), this.register(function(e1) {
                    return new VM(e1);
                });
            }
            load(e1, t, n, i) {
                const r = this;
                let a;
                a = "" !== this.resourcePath ? this.resourcePath : "" !== this.path ? this.path : GA.extractUrlBase(e1), this.manager.itemStart(e1);
                const s = function(t) {
                    i ? i(t) : console.error(t), r.manager.itemError(e1), r.manager.itemEnd(e1);
                }, o = new AA(this.manager);
                o.setPath(this.path), o.setResponseType("arraybuffer"), o.setRequestHeader(this.requestHeader), o.setWithCredentials(this.withCredentials), o.load(e1, function(n) {
                    try {
                        r.parse(n, a, function(n) {
                            t(n), r.manager.itemEnd(e1);
                        }, s);
                    } catch (e1) {
                        s(e1);
                    }
                }, n, s);
            }
            setDRACOLoader(e1) {
                return this.dracoLoader = e1, this;
            }
            setDDSLoader() {
                throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
            }
            setKTX2Loader(e1) {
                return this.ktx2Loader = e1, this;
            }
            setMeshoptDecoder(e1) {
                return this.meshoptDecoder = e1, this;
            }
            register(e1) {
                return -1 === this.pluginCallbacks.indexOf(e1) && this.pluginCallbacks.push(e1), this;
            }
            unregister(e1) {
                return -1 !== this.pluginCallbacks.indexOf(e1) && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(e1), 1), this;
            }
            parse(e1, t, n, i) {
                let r;
                const a = {}, s = {}, o = new TextDecoder;
                if ("string" == typeof e1) r = JSON.parse(e1);
                else if (e1 instanceof ArrayBuffer) {
                    if (o.decode(new Uint8Array(e1, 0, 4)) === GM) {
                        try {
                            a[SM.KHR_BINARY_GLTF] = new QM(e1);
                        } catch (e1) {
                            return void (i && i(e1));
                        }
                        r = JSON.parse(a[SM.KHR_BINARY_GLTF].content);
                    } else r = JSON.parse(o.decode(e1));
                } else r = e1;
                if (void 0 === r.asset || r.asset.version[0] < 2) return void (i && i(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported.")));
                const l = new py(r, {
                    path: t || this.resourcePath || "",
                    crossOrigin: this.crossOrigin,
                    requestHeader: this.requestHeader,
                    manager: this.manager,
                    ktx2Loader: this.ktx2Loader,
                    meshoptDecoder: this.meshoptDecoder
                });
                l.fileLoader.setRequestHeader(this.requestHeader);
                for(let e1 = 0; e1 < this.pluginCallbacks.length; e1++){
                    const t = this.pluginCallbacks[e1](l);
                    t.name || console.error("THREE.GLTFLoader: Invalid plugin found: missing name"), s[t.name] = t, a[t.name] = !0;
                }
                if (r.extensionsUsed) for(let e1 = 0; e1 < r.extensionsUsed.length; ++e1){
                    const t = r.extensionsUsed[e1], n = r.extensionsRequired || [];
                    switch(t){
                        case SM.KHR_MATERIALS_UNLIT:
                            a[t] = new NM;
                            break;
                        case SM.KHR_DRACO_MESH_COMPRESSION:
                            a[t] = new WM(r, this.dracoLoader);
                            break;
                        case SM.KHR_TEXTURE_TRANSFORM:
                            a[t] = new YM;
                            break;
                        case SM.KHR_MESH_QUANTIZATION:
                            a[t] = new XM;
                            break;
                        default:
                            n.indexOf(t) >= 0 && void 0 === s[t] && console.warn('THREE.GLTFLoader: Unknown extension "' + t + '".');
                    }
                }
                l.setExtensions(a), l.setPlugins(s), l.parse(n, i);
            }
            parseAsync(e1, t) {
                const n = this;
                return new Promise(function(i, r) {
                    n.parse(e1, t, i, r);
                });
            }
        }
        function TM() {
            let e1 = {};
            return {
                get: function(t) {
                    return e1[t];
                },
                add: function(t, n) {
                    e1[t] = n;
                },
                remove: function(t) {
                    delete e1[t];
                },
                removeAll: function() {
                    e1 = {};
                }
            };
        }
        const SM = {
            KHR_BINARY_GLTF: "KHR_binary_glTF",
            KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
            KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
            KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
            KHR_MATERIALS_IOR: "KHR_materials_ior",
            KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
            KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
            KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
            KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
            KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
            KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
            KHR_MATERIALS_VOLUME: "KHR_materials_volume",
            KHR_TEXTURE_BASISU: "KHR_texture_basisu",
            KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
            KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
            KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
            EXT_TEXTURE_WEBP: "EXT_texture_webp",
            EXT_TEXTURE_AVIF: "EXT_texture_avif",
            EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
            EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
        };
        class IM {
            constructor(e1){
                this.parser = e1, this.name = SM.KHR_LIGHTS_PUNCTUAL, this.cache = {
                    refs: {},
                    uses: {}
                };
            }
            _markDefs() {
                const e1 = this.parser, t = this.parser.json.nodes || [];
                for(let n = 0, i = t.length; n < i; n++){
                    const i = t[n];
                    i.extensions && i.extensions[this.name] && void 0 !== i.extensions[this.name].light && e1._addNodeRef(this.cache, i.extensions[this.name].light);
                }
            }
            _loadLight(e1) {
                const t = this.parser, n = "light:" + e1;
                let i = t.cache.get(n);
                if (i) return i;
                const r = t.json, a = ((r.extensions && r.extensions[this.name] || {}).lights || [])[e1];
                let s;
                const o = new Zc(16777215);
                void 0 !== a.color && o.setRGB(a.color[0], a.color[1], a.color[2], Qs);
                const l = void 0 !== a.range ? a.range : 0;
                switch(a.type){
                    case "directional":
                        s = new kA(o), s.target.position.set(0, 0, -1), s.add(s.target);
                        break;
                    case "point":
                        s = new PA(o), s.distance = l;
                        break;
                    case "spot":
                        s = new CA(o), s.distance = l, a.spot = a.spot || {}, a.spot.innerConeAngle = void 0 !== a.spot.innerConeAngle ? a.spot.innerConeAngle : 0, a.spot.outerConeAngle = void 0 !== a.spot.outerConeAngle ? a.spot.outerConeAngle : Math.PI / 4, s.angle = a.spot.outerConeAngle, s.penumbra = 1 - a.spot.innerConeAngle / a.spot.outerConeAngle, s.target.position.set(0, 0, -1), s.add(s.target);
                        break;
                    default:
                        throw new Error("THREE.GLTFLoader: Unexpected light type: " + a.type);
                }
                return s.position.set(0, 0, 0), s.decay = 2, oy(s, a), void 0 !== a.intensity && (s.intensity = a.intensity), s.name = t.createUniqueName(a.name || "light_" + e1), i = Promise.resolve(s), t.cache.add(n, i), i;
            }
            getDependency(e1, t) {
                if ("light" === e1) return this._loadLight(t);
            }
            createNodeAttachment(e1) {
                const t = this, n = this.parser, i = n.json.nodes[e1], r = (i.extensions && i.extensions[this.name] || {}).light;
                return void 0 === r ? null : this._loadLight(r).then(function(e1) {
                    return n._getNodeRef(t.cache, r, e1);
                });
            }
        }
        class NM {
            constructor(){
                this.name = SM.KHR_MATERIALS_UNLIT;
            }
            getMaterialType() {
                return $c;
            }
            extendParams(e1, t, n) {
                const i = [];
                e1.color = new Zc(1, 1, 1), e1.opacity = 1;
                const r = t.pbrMetallicRoughness;
                if (r) {
                    if (Array.isArray(r.baseColorFactor)) {
                        const t = r.baseColorFactor;
                        e1.color.setRGB(t[0], t[1], t[2], Qs), e1.opacity = t[3];
                    }
                    void 0 !== r.baseColorTexture && i.push(n.assignTexture(e1, "map", r.baseColorTexture, Gs));
                }
                return Promise.all(i);
            }
        }
        class DM {
            constructor(e1){
                this.parser = e1, this.name = SM.KHR_MATERIALS_EMISSIVE_STRENGTH;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser.json.materials[e1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const i = n.extensions[this.name].emissiveStrength;
                return void 0 !== i && (t.emissiveIntensity = i), Promise.resolve();
            }
        }
        class CM {
            constructor(e1){
                this.parser = e1, this.name = SM.KHR_MATERIALS_CLEARCOAT;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? kg : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                if (void 0 !== a.clearcoatFactor && (t.clearcoat = a.clearcoatFactor), void 0 !== a.clearcoatTexture && r.push(n.assignTexture(t, "clearcoatMap", a.clearcoatTexture)), void 0 !== a.clearcoatRoughnessFactor && (t.clearcoatRoughness = a.clearcoatRoughnessFactor), void 0 !== a.clearcoatRoughnessTexture && r.push(n.assignTexture(t, "clearcoatRoughnessMap", a.clearcoatRoughnessTexture)), void 0 !== a.clearcoatNormalTexture && (r.push(n.assignTexture(t, "clearcoatNormalMap", a.clearcoatNormalTexture)), void 0 !== a.clearcoatNormalTexture.scale)) {
                    const e1 = a.clearcoatNormalTexture.scale;
                    t.clearcoatNormalScale = new Jo(e1, e1);
                }
                return Promise.all(r);
            }
        }
        class LM {
            constructor(e1){
                this.parser = e1, this.name = SM.KHR_MATERIALS_IRIDESCENCE;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? kg : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                return void 0 !== a.iridescenceFactor && (t.iridescence = a.iridescenceFactor), void 0 !== a.iridescenceTexture && r.push(n.assignTexture(t, "iridescenceMap", a.iridescenceTexture)), void 0 !== a.iridescenceIor && (t.iridescenceIOR = a.iridescenceIor), void 0 === t.iridescenceThicknessRange && (t.iridescenceThicknessRange = [
                    100,
                    400
                ]), void 0 !== a.iridescenceThicknessMinimum && (t.iridescenceThicknessRange[0] = a.iridescenceThicknessMinimum), void 0 !== a.iridescenceThicknessMaximum && (t.iridescenceThicknessRange[1] = a.iridescenceThicknessMaximum), void 0 !== a.iridescenceThicknessTexture && r.push(n.assignTexture(t, "iridescenceThicknessMap", a.iridescenceThicknessTexture)), Promise.all(r);
            }
        }
        class RM {
            constructor(e1){
                this.parser = e1, this.name = SM.KHR_MATERIALS_SHEEN;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? kg : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [];
                t.sheenColor = new Zc(0, 0, 0), t.sheenRoughness = 0, t.sheen = 1;
                const a = i.extensions[this.name];
                if (void 0 !== a.sheenColorFactor) {
                    const e1 = a.sheenColorFactor;
                    t.sheenColor.setRGB(e1[0], e1[1], e1[2], Qs);
                }
                return void 0 !== a.sheenRoughnessFactor && (t.sheenRoughness = a.sheenRoughnessFactor), void 0 !== a.sheenColorTexture && r.push(n.assignTexture(t, "sheenColorMap", a.sheenColorTexture, Gs)), void 0 !== a.sheenRoughnessTexture && r.push(n.assignTexture(t, "sheenRoughnessMap", a.sheenRoughnessTexture)), Promise.all(r);
            }
        }
        class zM {
            constructor(e1){
                this.parser = e1, this.name = SM.KHR_MATERIALS_TRANSMISSION;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? kg : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                return void 0 !== a.transmissionFactor && (t.transmission = a.transmissionFactor), void 0 !== a.transmissionTexture && r.push(n.assignTexture(t, "transmissionMap", a.transmissionTexture)), Promise.all(r);
            }
        }
        class OM {
            constructor(e1){
                this.parser = e1, this.name = SM.KHR_MATERIALS_VOLUME;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? kg : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                t.thickness = void 0 !== a.thicknessFactor ? a.thicknessFactor : 0, void 0 !== a.thicknessTexture && r.push(n.assignTexture(t, "thicknessMap", a.thicknessTexture)), t.attenuationDistance = a.attenuationDistance || 1 / 0;
                const s = a.attenuationColor || [
                    1,
                    1,
                    1
                ];
                return t.attenuationColor = (new Zc).setRGB(s[0], s[1], s[2], Qs), Promise.all(r);
            }
        }
        class PM {
            constructor(e1){
                this.parser = e1, this.name = SM.KHR_MATERIALS_IOR;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? kg : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser.json.materials[e1];
                if (!n.extensions || !n.extensions[this.name]) return Promise.resolve();
                const i = n.extensions[this.name];
                return t.ior = void 0 !== i.ior ? i.ior : 1.5, Promise.resolve();
            }
        }
        class UM {
            constructor(e1){
                this.parser = e1, this.name = SM.KHR_MATERIALS_SPECULAR;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? kg : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                t.specularIntensity = void 0 !== a.specularFactor ? a.specularFactor : 1, void 0 !== a.specularTexture && r.push(n.assignTexture(t, "specularIntensityMap", a.specularTexture));
                const s = a.specularColorFactor || [
                    1,
                    1,
                    1
                ];
                return t.specularColor = (new Zc).setRGB(s[0], s[1], s[2], Qs), void 0 !== a.specularColorTexture && r.push(n.assignTexture(t, "specularColorMap", a.specularColorTexture, Gs)), Promise.all(r);
            }
        }
        class kM {
            constructor(e1){
                this.parser = e1, this.name = SM.KHR_MATERIALS_ANISOTROPY;
            }
            getMaterialType(e1) {
                const t = this.parser.json.materials[e1];
                return t.extensions && t.extensions[this.name] ? kg : null;
            }
            extendMaterialParams(e1, t) {
                const n = this.parser, i = n.json.materials[e1];
                if (!i.extensions || !i.extensions[this.name]) return Promise.resolve();
                const r = [], a = i.extensions[this.name];
                return void 0 !== a.anisotropyStrength && (t.anisotropy = a.anisotropyStrength), void 0 !== a.anisotropyRotation && (t.anisotropyRotation = a.anisotropyRotation), void 0 !== a.anisotropyTexture && r.push(n.assignTexture(t, "anisotropyMap", a.anisotropyTexture)), Promise.all(r);
            }
        }
        class jM {
            constructor(e1){
                this.parser = e1, this.name = SM.KHR_TEXTURE_BASISU;
            }
            loadTexture(e1) {
                const t = this.parser, n = t.json, i = n.textures[e1];
                if (!i.extensions || !i.extensions[this.name]) return null;
                const r = i.extensions[this.name], a = t.options.ktx2Loader;
                if (!a) {
                    if (n.extensionsRequired && n.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
                    return null;
                }
                return t.loadTextureImage(e1, r.source, a);
            }
        }
        class BM {
            constructor(e1){
                this.parser = e1, this.name = SM.EXT_TEXTURE_WEBP, this.isSupported = null;
            }
            loadTexture(e1) {
                const t = this.name, n = this.parser, i = n.json, r = i.textures[e1];
                if (!r.extensions || !r.extensions[t]) return null;
                const a = r.extensions[t], s = i.images[a.source];
                let o = n.textureLoader;
                if (s.uri) {
                    const e1 = n.options.manager.getHandler(s.uri);
                    null !== e1 && (o = e1);
                }
                return this.detectSupport().then(function(r) {
                    if (r) return n.loadTextureImage(e1, a.source, o);
                    if (i.extensionsRequired && i.extensionsRequired.indexOf(t) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
                    return n.loadTexture(e1);
                });
            }
            detectSupport() {
                return this.isSupported || (this.isSupported = new Promise(function(e1) {
                    const t = new Image;
                    t.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA", t.onload = t.onerror = function() {
                        e1(1 === t.height);
                    };
                })), this.isSupported;
            }
        }
        class FM {
            constructor(e1){
                this.parser = e1, this.name = SM.EXT_TEXTURE_AVIF, this.isSupported = null;
            }
            loadTexture(e1) {
                const t = this.name, n = this.parser, i = n.json, r = i.textures[e1];
                if (!r.extensions || !r.extensions[t]) return null;
                const a = r.extensions[t], s = i.images[a.source];
                let o = n.textureLoader;
                if (s.uri) {
                    const e1 = n.options.manager.getHandler(s.uri);
                    null !== e1 && (o = e1);
                }
                return this.detectSupport().then(function(r) {
                    if (r) return n.loadTextureImage(e1, a.source, o);
                    if (i.extensionsRequired && i.extensionsRequired.indexOf(t) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
                    return n.loadTexture(e1);
                });
            }
            detectSupport() {
                return this.isSupported || (this.isSupported = new Promise(function(e1) {
                    const t = new Image;
                    t.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=", t.onload = t.onerror = function() {
                        e1(1 === t.height);
                    };
                })), this.isSupported;
            }
        }
        class HM {
            constructor(e1){
                this.name = SM.EXT_MESHOPT_COMPRESSION, this.parser = e1;
            }
            loadBufferView(e1) {
                const t = this.parser.json, n = t.bufferViews[e1];
                if (n.extensions && n.extensions[this.name]) {
                    const e1 = n.extensions[this.name], i = this.parser.getDependency("buffer", e1.buffer), r = this.parser.options.meshoptDecoder;
                    if (!r || !r.supported) {
                        if (t.extensionsRequired && t.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                        return null;
                    }
                    return i.then(function(t) {
                        const n = e1.byteOffset || 0, i = e1.byteLength || 0, a = e1.count, s = e1.byteStride, o = new Uint8Array(t, n, i);
                        return r.decodeGltfBufferAsync ? r.decodeGltfBufferAsync(a, s, o, e1.mode, e1.filter).then(function(e1) {
                            return e1.buffer;
                        }) : r.ready.then(function() {
                            const t = new ArrayBuffer(a * s);
                            return r.decodeGltfBuffer(new Uint8Array(t), a, s, o, e1.mode, e1.filter), t;
                        });
                    });
                }
                return null;
            }
        }
        class VM {
            constructor(e1){
                this.name = SM.EXT_MESH_GPU_INSTANCING, this.parser = e1;
            }
            createNodeMesh(e1) {
                const t = this.parser.json, n = t.nodes[e1];
                if (!n.extensions || !n.extensions[this.name] || void 0 === n.mesh) return null;
                const i = t.meshes[n.mesh];
                for (const e1 of i.primitives)if (e1.mode !== JM.TRIANGLES && e1.mode !== JM.TRIANGLE_STRIP && e1.mode !== JM.TRIANGLE_FAN && void 0 !== e1.mode) return null;
                const r = n.extensions[this.name].attributes, a = [], s = {};
                for(const e1 in r)a.push(this.parser.getDependency("accessor", r[e1]).then((t)=>(s[e1] = t, s[e1])));
                return a.length < 1 ? null : (a.push(this.parser.createNodeMesh(e1)), Promise.all(a).then((e1)=>{
                    const t = e1.pop(), n = t.isGroup ? t.children : [
                        t
                    ], i = e1[0].count, r = [];
                    for (const e1 of n){
                        const t = new oc, n = new Cl, a = new Dl, o = new Cl(1, 1, 1), l = new Hf(e1.geometry, e1.material, i);
                        for(let e1 = 0; e1 < i; e1++)s.TRANSLATION && n.fromBufferAttribute(s.TRANSLATION, e1), s.ROTATION && a.fromBufferAttribute(s.ROTATION, e1), s.SCALE && o.fromBufferAttribute(s.SCALE, e1), l.setMatrixAt(e1, t.compose(n, a, o));
                        for(const t in s)if ("_COLOR_0" === t) {
                            const e1 = s[t];
                            l.instanceColor = new zf(e1.array, e1.itemSize, e1.normalized);
                        } else "TRANSLATION" !== t && "ROTATION" !== t && "SCALE" !== t && e1.geometry.setAttribute(t, s[t]);
                        Lc.prototype.copy.call(l, e1), this.parser.assignFinalMaterial(l), r.push(l);
                    }
                    return t.isGroup ? (t.clear(), t.add(...r), t) : r[0];
                }));
            }
        }
        const GM = "glTF";
        class QM {
            constructor(e1){
                this.name = SM.KHR_BINARY_GLTF, this.content = null, this.body = null;
                const t = new DataView(e1, 0, 12), n = new TextDecoder;
                if (this.header = {
                    magic: n.decode(new Uint8Array(e1.slice(0, 4))),
                    version: t.getUint32(4, !0),
                    length: t.getUint32(8, !0)
                }, this.header.magic !== GM) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
                if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
                const i = this.header.length - 12, r = new DataView(e1, 12);
                let a = 0;
                for(; a < i;){
                    const t = r.getUint32(a, !0);
                    a += 4;
                    const i = r.getUint32(a, !0);
                    if (a += 4, 1313821514 === i) {
                        const i = new Uint8Array(e1, 12 + a, t);
                        this.content = n.decode(i);
                    } else if (5130562 === i) {
                        const n = 12 + a;
                        this.body = e1.slice(n, n + t);
                    }
                    a += t;
                }
                if (null === this.content) throw new Error("THREE.GLTFLoader: JSON content not found.");
            }
        }
        class WM {
            constructor(e1, t){
                if (!t) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
                this.name = SM.KHR_DRACO_MESH_COMPRESSION, this.json = e1, this.dracoLoader = t, this.dracoLoader.preload();
            }
            decodePrimitive(e1, t) {
                const n = this.json, i = this.dracoLoader, r = e1.extensions[this.name].bufferView, a = e1.extensions[this.name].attributes, s = {}, o = {}, l = {};
                for(const e1 in a){
                    const t = iy[e1] || e1.toLowerCase();
                    s[t] = a[e1];
                }
                for(const t in e1.attributes){
                    const i = iy[t] || t.toLowerCase();
                    if (void 0 !== a[t]) {
                        const r = n.accessors[e1.attributes[t]], a = $M[r.componentType];
                        l[i] = a.name, o[i] = !0 === r.normalized;
                    }
                }
                return t.getDependency("bufferView", r).then(function(e1) {
                    return new Promise(function(t) {
                        i.decodeDracoFile(e1, function(e1) {
                            for(const t in e1.attributes){
                                const n = e1.attributes[t], i = o[t];
                                void 0 !== i && (n.normalized = i);
                            }
                            t(e1);
                        }, s, l);
                    });
                });
            }
        }
        class YM {
            constructor(){
                this.name = SM.KHR_TEXTURE_TRANSFORM;
            }
            extendTexture(e1, t) {
                return void 0 !== t.texCoord && t.texCoord !== e1.channel || void 0 !== t.offset || void 0 !== t.rotation || void 0 !== t.scale ? (e1 = e1.clone(), void 0 !== t.texCoord && (e1.channel = t.texCoord), void 0 !== t.offset && e1.offset.fromArray(t.offset), void 0 !== t.rotation && (e1.rotation = t.rotation), void 0 !== t.scale && e1.repeat.fromArray(t.scale), e1.needsUpdate = !0, e1) : e1;
            }
        }
        class XM {
            constructor(){
                this.name = SM.KHR_MESH_QUANTIZATION;
            }
        }
        class ZM extends Kg {
            constructor(e1, t, n, i){
                super(e1, t, n, i);
            }
            copySampleValue_(e1) {
                const t = this.resultBuffer, n = this.sampleValues, i = this.valueSize, r = e1 * i * 3 + i;
                for(let e1 = 0; e1 !== i; e1++)t[e1] = n[r + e1];
                return t;
            }
            interpolate_(e1, t, n, i) {
                const r = this.resultBuffer, a = this.sampleValues, s = this.valueSize, o = 2 * s, l = 3 * s, c = i - t, u = (n - t) / c, h = u * u, d = h * u, p = e1 * l, f = p - l, m = -2 * d + 3 * h, g = d - h, A = 1 - m, v = g - h + u;
                for(let e1 = 0; e1 !== s; e1++){
                    const t = a[f + e1 + s], n = a[f + e1 + o] * c, i = a[p + e1 + s], l = a[p + e1] * c;
                    r[e1] = A * t + v * n + m * i + g * l;
                }
                return r;
            }
        }
        const qM = new Dl;
        class KM extends ZM {
            interpolate_(e1, t, n, i) {
                const r = super.interpolate_(e1, t, n, i);
                return qM.fromArray(r).normalize().toArray(r), r;
            }
        }
        const JM = {
            FLOAT: 5126,
            FLOAT_MAT3: 35675,
            FLOAT_MAT4: 35676,
            FLOAT_VEC2: 35664,
            FLOAT_VEC3: 35665,
            FLOAT_VEC4: 35666,
            LINEAR: 9729,
            REPEAT: 10497,
            SAMPLER_2D: 35678,
            POINTS: 0,
            LINES: 1,
            LINE_LOOP: 2,
            LINE_STRIP: 3,
            TRIANGLES: 4,
            TRIANGLE_STRIP: 5,
            TRIANGLE_FAN: 6,
            UNSIGNED_BYTE: 5121,
            UNSIGNED_SHORT: 5123
        }, $M = {
            5120: Int8Array,
            5121: Uint8Array,
            5122: Int16Array,
            5123: Uint16Array,
            5125: Uint32Array,
            5126: Float32Array
        }, ey = {
            9728: pa,
            9729: va,
            9984: fa,
            9985: Ma,
            9986: ga,
            9987: xa
        }, ty = {
            33071: ha,
            33648: da,
            10497: ua
        }, ny = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        }, iy = {
            POSITION: "position",
            NORMAL: "normal",
            TANGENT: "tangent",
            TEXCOORD_0: "uv",
            TEXCOORD_1: "uv1",
            TEXCOORD_2: "uv2",
            TEXCOORD_3: "uv3",
            COLOR_0: "color",
            WEIGHTS_0: "skinWeight",
            JOINTS_0: "skinIndex"
        }, ry = {
            scale: "scale",
            translation: "position",
            rotation: "quaternion",
            weights: "morphTargetInfluences"
        }, ay = {
            CUBICSPLINE: void 0,
            LINEAR: Ss,
            STEP: Ts
        };
        function sy(e1, t, n) {
            for(const i in n.extensions)void 0 === e1[i] && (t.userData.gltfExtensions = t.userData.gltfExtensions || {}, t.userData.gltfExtensions[i] = n.extensions[i]);
        }
        function oy(e1, t) {
            void 0 !== t.extras && ("object" == typeof t.extras ? Object.assign(e1.userData, t.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + t.extras));
        }
        function ly(e1, t) {
            if (e1.updateMorphTargets(), void 0 !== t.weights) for(let n = 0, i = t.weights.length; n < i; n++)e1.morphTargetInfluences[n] = t.weights[n];
            if (t.extras && Array.isArray(t.extras.targetNames)) {
                const n = t.extras.targetNames;
                if (e1.morphTargetInfluences.length === n.length) {
                    e1.morphTargetDictionary = {};
                    for(let t = 0, i = n.length; t < i; t++)e1.morphTargetDictionary[n[t]] = t;
                } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
            }
        }
        function cy(e1) {
            let t;
            const n = e1.extensions && e1.extensions[SM.KHR_DRACO_MESH_COMPRESSION];
            if (t = n ? "draco:" + n.bufferView + ":" + n.indices + ":" + uy(n.attributes) : e1.indices + ":" + uy(e1.attributes) + ":" + e1.mode, void 0 !== e1.targets) for(let n = 0, i = e1.targets.length; n < i; n++)t += ":" + uy(e1.targets[n]);
            return t;
        }
        function uy(e1) {
            let t = "";
            const n = Object.keys(e1).sort();
            for(let i = 0, r = n.length; i < r; i++)t += n[i] + ":" + e1[n[i]] + ";";
            return t;
        }
        function hy(e1) {
            switch(e1){
                case Int8Array:
                    return 1 / 127;
                case Uint8Array:
                    return 1 / 255;
                case Int16Array:
                    return 1 / 32767;
                case Uint16Array:
                    return 1 / 65535;
                default:
                    throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
            }
        }
        const dy = new oc;
        class py {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                this.json = e1, this.extensions = {}, this.plugins = {}, this.options = t, this.cache = new TM, this.associations = new Map, this.primitiveCache = {}, this.nodeCache = {}, this.meshCache = {
                    refs: {},
                    uses: {}
                }, this.cameraCache = {
                    refs: {},
                    uses: {}
                }, this.lightCache = {
                    refs: {},
                    uses: {}
                }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {};
                let n = !1, i = !1, r = -1;
                "undefined" != typeof navigator && (n = !0 === /^((?!chrome|android).)*safari/i.test(navigator.userAgent), i = navigator.userAgent.indexOf("Firefox") > -1, r = i ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1), "undefined" == typeof createImageBitmap || n || i && r < 98 ? this.textureLoader = new bA(this.options.manager) : this.textureLoader = new KA(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new AA(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), "use-credentials" === this.options.crossOrigin && this.fileLoader.setWithCredentials(!0);
            }
            setExtensions(e1) {
                this.extensions = e1;
            }
            setPlugins(e1) {
                this.plugins = e1;
            }
            parse(e1, t) {
                const n = this, i = this.json, r = this.extensions;
                this.cache.removeAll(), this.nodeCache = {}, this._invokeAll(function(e1) {
                    return e1._markDefs && e1._markDefs();
                }), Promise.all(this._invokeAll(function(e1) {
                    return e1.beforeRoot && e1.beforeRoot();
                })).then(function() {
                    return Promise.all([
                        n.getDependencies("scene"),
                        n.getDependencies("animation"),
                        n.getDependencies("camera")
                    ]);
                }).then(function(t) {
                    const a = {
                        scene: t[0][i.scene || 0],
                        scenes: t[0],
                        animations: t[1],
                        cameras: t[2],
                        asset: i.asset,
                        parser: n,
                        userData: {}
                    };
                    return sy(r, a, i), oy(a, i), Promise.all(n._invokeAll(function(e1) {
                        return e1.afterRoot && e1.afterRoot(a);
                    })).then(function() {
                        e1(a);
                    });
                }).catch(t);
            }
            _markDefs() {
                const e1 = this.json.nodes || [], t = this.json.skins || [], n = this.json.meshes || [];
                for(let n = 0, i = t.length; n < i; n++){
                    const i = t[n].joints;
                    for(let t = 0, n = i.length; t < n; t++)e1[i[t]].isBone = !0;
                }
                for(let t = 0, i = e1.length; t < i; t++){
                    const i = e1[t];
                    void 0 !== i.mesh && (this._addNodeRef(this.meshCache, i.mesh), void 0 !== i.skin && (n[i.mesh].isSkinnedMesh = !0)), void 0 !== i.camera && this._addNodeRef(this.cameraCache, i.camera);
                }
            }
            _addNodeRef(e1, t) {
                void 0 !== t && (void 0 === e1.refs[t] && (e1.refs[t] = e1.uses[t] = 0), e1.refs[t]++);
            }
            _getNodeRef(e1, t, n) {
                if (e1.refs[t] <= 1) return n;
                const i = n.clone(), r = (e1, t)=>{
                    const n = this.associations.get(e1);
                    null != n && this.associations.set(t, n);
                    for (const [n, i] of e1.children.entries())r(i, t.children[n]);
                };
                return r(n, i), i.name += "_instance_" + e1.uses[t]++, i;
            }
            _invokeOne(e1) {
                const t = Object.values(this.plugins);
                t.push(this);
                for(let n = 0; n < t.length; n++){
                    const i = e1(t[n]);
                    if (i) return i;
                }
                return null;
            }
            _invokeAll(e1) {
                const t = Object.values(this.plugins);
                t.unshift(this);
                const n = [];
                for(let i = 0; i < t.length; i++){
                    const r = e1(t[i]);
                    r && n.push(r);
                }
                return n;
            }
            getDependency(e1, t) {
                const n = e1 + ":" + t;
                let i = this.cache.get(n);
                if (!i) {
                    switch(e1){
                        case "scene":
                            i = this.loadScene(t);
                            break;
                        case "node":
                            i = this._invokeOne(function(e1) {
                                return e1.loadNode && e1.loadNode(t);
                            });
                            break;
                        case "mesh":
                            i = this._invokeOne(function(e1) {
                                return e1.loadMesh && e1.loadMesh(t);
                            });
                            break;
                        case "accessor":
                            i = this.loadAccessor(t);
                            break;
                        case "bufferView":
                            i = this._invokeOne(function(e1) {
                                return e1.loadBufferView && e1.loadBufferView(t);
                            });
                            break;
                        case "buffer":
                            i = this.loadBuffer(t);
                            break;
                        case "material":
                            i = this._invokeOne(function(e1) {
                                return e1.loadMaterial && e1.loadMaterial(t);
                            });
                            break;
                        case "texture":
                            i = this._invokeOne(function(e1) {
                                return e1.loadTexture && e1.loadTexture(t);
                            });
                            break;
                        case "skin":
                            i = this.loadSkin(t);
                            break;
                        case "animation":
                            i = this._invokeOne(function(e1) {
                                return e1.loadAnimation && e1.loadAnimation(t);
                            });
                            break;
                        case "camera":
                            i = this.loadCamera(t);
                            break;
                        default:
                            if (i = this._invokeOne(function(n) {
                                return n != this && n.getDependency && n.getDependency(e1, t);
                            }), !i) throw new Error("Unknown type: " + e1);
                    }
                    this.cache.add(n, i);
                }
                return i;
            }
            getDependencies(e1) {
                let t = this.cache.get(e1);
                if (!t) {
                    const n = this, i = this.json[e1 + ("mesh" === e1 ? "es" : "s")] || [];
                    t = Promise.all(i.map(function(t, i) {
                        return n.getDependency(e1, i);
                    })), this.cache.add(e1, t);
                }
                return t;
            }
            loadBuffer(e1) {
                const t = this.json.buffers[e1], n = this.fileLoader;
                if (t.type && "arraybuffer" !== t.type) throw new Error("THREE.GLTFLoader: " + t.type + " buffer type is not supported.");
                if (void 0 === t.uri && 0 === e1) return Promise.resolve(this.extensions[SM.KHR_BINARY_GLTF].body);
                const i = this.options;
                return new Promise(function(e1, r) {
                    n.load(GA.resolveURL(t.uri, i.path), e1, void 0, function() {
                        r(new Error('THREE.GLTFLoader: Failed to load buffer "' + t.uri + '".'));
                    });
                });
            }
            loadBufferView(e1) {
                const t = this.json.bufferViews[e1];
                return this.getDependency("buffer", t.buffer).then(function(e1) {
                    const n = t.byteLength || 0, i = t.byteOffset || 0;
                    return e1.slice(i, i + n);
                });
            }
            loadAccessor(e1) {
                const t = this, n = this.json, i = this.json.accessors[e1];
                if (void 0 === i.bufferView && void 0 === i.sparse) {
                    const e1 = ny[i.type], t = $M[i.componentType], n = !0 === i.normalized, r = new t(i.count * e1);
                    return Promise.resolve(new ou(r, e1, n));
                }
                const r = [];
                return void 0 !== i.bufferView ? r.push(this.getDependency("bufferView", i.bufferView)) : r.push(null), void 0 !== i.sparse && (r.push(this.getDependency("bufferView", i.sparse.indices.bufferView)), r.push(this.getDependency("bufferView", i.sparse.values.bufferView))), Promise.all(r).then(function(e1) {
                    const r = e1[0], a = ny[i.type], s = $M[i.componentType], o = s.BYTES_PER_ELEMENT, l = o * a, c = i.byteOffset || 0, u = void 0 !== i.bufferView ? n.bufferViews[i.bufferView].byteStride : void 0, h = !0 === i.normalized;
                    let d, p;
                    if (u && u !== l) {
                        const e1 = Math.floor(c / u), n = "InterleavedBuffer:" + i.bufferView + ":" + i.componentType + ":" + e1 + ":" + i.count;
                        let l = t.cache.get(n);
                        l || (d = new s(r, e1 * u, i.count * u / o), l = new qp(d, u / o), t.cache.add(n, l)), p = new Jp(l, a, c % u / o, h);
                    } else d = null === r ? new s(i.count * a) : new s(r, c, i.count * a), p = new ou(d, a, h);
                    if (void 0 !== i.sparse) {
                        const t = ny.SCALAR, n = $M[i.sparse.indices.componentType], o = i.sparse.indices.byteOffset || 0, l = i.sparse.values.byteOffset || 0, c = new n(e1[1], o, i.sparse.count * t), u = new s(e1[2], l, i.sparse.count * a);
                        null !== r && (p = new ou(p.array.slice(), p.itemSize, p.normalized));
                        for(let e1 = 0, t = c.length; e1 < t; e1++){
                            const t = c[e1];
                            if (p.setX(t, u[e1 * a]), a >= 2 && p.setY(t, u[e1 * a + 1]), a >= 3 && p.setZ(t, u[e1 * a + 2]), a >= 4 && p.setW(t, u[e1 * a + 3]), a >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                        }
                    }
                    return p;
                });
            }
            loadTexture(e1) {
                const t = this.json, n = this.options, i = t.textures[e1].source, r = t.images[i];
                let a = this.textureLoader;
                if (r.uri) {
                    const e1 = n.manager.getHandler(r.uri);
                    null !== e1 && (a = e1);
                }
                return this.loadTextureImage(e1, i, a);
            }
            loadTextureImage(e1, t, n) {
                const i = this, r = this.json, a = r.textures[e1], s = r.images[t], o = (s.uri || s.bufferView) + ":" + a.sampler;
                if (this.textureCache[o]) return this.textureCache[o];
                const l = this.loadImageSource(t, n).then(function(t) {
                    t.flipY = !1, t.name = a.name || s.name || "", "" === t.name && "string" == typeof s.uri && !1 === s.uri.startsWith("data:image/") && (t.name = s.uri);
                    const n = (r.samplers || {})[a.sampler] || {};
                    return t.magFilter = ey[n.magFilter] || va, t.minFilter = ey[n.minFilter] || xa, t.wrapS = ty[n.wrapS] || ua, t.wrapT = ty[n.wrapT] || ua, i.associations.set(t, {
                        textures: e1
                    }), t;
                }).catch(function() {
                    return null;
                });
                return this.textureCache[o] = l, l;
            }
            loadImageSource(e1, t) {
                const n = this.json, i = this.options;
                if (void 0 !== this.sourceCache[e1]) return this.sourceCache[e1].then((e1)=>e1.clone());
                const r = n.images[e1], a = self.URL || self.webkitURL;
                let s = r.uri || "", o = !1;
                if (void 0 !== r.bufferView) s = this.getDependency("bufferView", r.bufferView).then(function(e1) {
                    o = !0;
                    const t = new Blob([
                        e1
                    ], {
                        type: r.mimeType
                    });
                    return s = a.createObjectURL(t), s;
                });
                else if (void 0 === r.uri) throw new Error("THREE.GLTFLoader: Image " + e1 + " is missing URI and bufferView");
                const l = Promise.resolve(s).then(function(e1) {
                    return new Promise(function(n, r) {
                        let a = n;
                        !0 === t.isImageBitmapLoader && (a = function(e1) {
                            const t = new xl(e1);
                            t.needsUpdate = !0, n(t);
                        }), t.load(GA.resolveURL(e1, i.path), a, void 0, r);
                    });
                }).then(function(e1) {
                    var t;
                    return !0 === o && a.revokeObjectURL(s), e1.userData.mimeType = r.mimeType || ((t = r.uri).search(/\.jpe?g($|\?)/i) > 0 || 0 === t.search(/^data\:image\/jpeg/) ? "image/jpeg" : t.search(/\.webp($|\?)/i) > 0 || 0 === t.search(/^data\:image\/webp/) ? "image/webp" : "image/png"), e1;
                }).catch(function(e1) {
                    throw console.error("THREE.GLTFLoader: Couldn't load texture", s), e1;
                });
                return this.sourceCache[e1] = l, l;
            }
            assignTexture(e1, t, n, i) {
                const r = this;
                return this.getDependency("texture", n.index).then(function(a) {
                    if (!a) return null;
                    if (void 0 !== n.texCoord && n.texCoord > 0 && ((a = a.clone()).channel = n.texCoord), r.extensions[SM.KHR_TEXTURE_TRANSFORM]) {
                        const e1 = void 0 !== n.extensions ? n.extensions[SM.KHR_TEXTURE_TRANSFORM] : void 0;
                        if (e1) {
                            const t = r.associations.get(a);
                            a = r.extensions[SM.KHR_TEXTURE_TRANSFORM].extendTexture(a, e1), r.associations.set(a, t);
                        }
                    }
                    return void 0 !== i && (a.colorSpace = i), e1[t] = a, a;
                });
            }
            assignFinalMaterial(e1) {
                const t = e1.geometry;
                let n = e1.material;
                const i = void 0 === t.attributes.tangent, r = void 0 !== t.attributes.color, a = void 0 === t.attributes.normal;
                if (e1.isPoints) {
                    const e1 = "PointsMaterial:" + n.uuid;
                    let t = this.cache.get(e1);
                    t || (t = new em, Jc.prototype.copy.call(t, n), t.color.copy(n.color), t.map = n.map, t.sizeAttenuation = !1, this.cache.add(e1, t)), n = t;
                } else if (e1.isLine) {
                    const e1 = "LineBasicMaterial:" + n.uuid;
                    let t = this.cache.get(e1);
                    t || (t = new Vf, Jc.prototype.copy.call(t, n), t.color.copy(n.color), t.map = n.map, this.cache.add(e1, t)), n = t;
                }
                if (i || r || a) {
                    let e1 = "ClonedMaterial:" + n.uuid + ":";
                    i && (e1 += "derivative-tangents:"), r && (e1 += "vertex-colors:"), a && (e1 += "flat-shading:");
                    let t = this.cache.get(e1);
                    t || (t = n.clone(), r && (t.vertexColors = !0), a && (t.flatShading = !0), i && (t.normalScale && (t.normalScale.y *= -1), t.clearcoatNormalScale && (t.clearcoatNormalScale.y *= -1)), this.cache.add(e1, t), this.associations.set(t, this.associations.get(n))), n = t;
                }
                e1.material = n;
            }
            getMaterialType() {
                return Ug;
            }
            loadMaterial(e1) {
                const t = this, n = this.json, i = this.extensions, r = n.materials[e1];
                let a;
                const s = {}, o = [];
                if ((r.extensions || {})[SM.KHR_MATERIALS_UNLIT]) {
                    const e1 = i[SM.KHR_MATERIALS_UNLIT];
                    a = e1.getMaterialType(), o.push(e1.extendParams(s, r, t));
                } else {
                    const n = r.pbrMetallicRoughness || {};
                    if (s.color = new Zc(1, 1, 1), s.opacity = 1, Array.isArray(n.baseColorFactor)) {
                        const e1 = n.baseColorFactor;
                        s.color.setRGB(e1[0], e1[1], e1[2], Qs), s.opacity = e1[3];
                    }
                    void 0 !== n.baseColorTexture && o.push(t.assignTexture(s, "map", n.baseColorTexture, Gs)), s.metalness = void 0 !== n.metallicFactor ? n.metallicFactor : 1, s.roughness = void 0 !== n.roughnessFactor ? n.roughnessFactor : 1, void 0 !== n.metallicRoughnessTexture && (o.push(t.assignTexture(s, "metalnessMap", n.metallicRoughnessTexture)), o.push(t.assignTexture(s, "roughnessMap", n.metallicRoughnessTexture))), a = this._invokeOne(function(t) {
                        return t.getMaterialType && t.getMaterialType(e1);
                    }), o.push(Promise.all(this._invokeAll(function(t) {
                        return t.extendMaterialParams && t.extendMaterialParams(e1, s);
                    })));
                }
                !0 === r.doubleSided && (s.side = hr);
                const l = r.alphaMode || "OPAQUE";
                if ("BLEND" === l ? (s.transparent = !0, s.depthWrite = !1) : (s.transparent = !1, "MASK" === l && (s.alphaTest = void 0 !== r.alphaCutoff ? r.alphaCutoff : .5)), void 0 !== r.normalTexture && a !== $c && (o.push(t.assignTexture(s, "normalMap", r.normalTexture)), s.normalScale = new Jo(1, 1), void 0 !== r.normalTexture.scale)) {
                    const e1 = r.normalTexture.scale;
                    s.normalScale.set(e1, e1);
                }
                if (void 0 !== r.occlusionTexture && a !== $c && (o.push(t.assignTexture(s, "aoMap", r.occlusionTexture)), void 0 !== r.occlusionTexture.strength && (s.aoMapIntensity = r.occlusionTexture.strength)), void 0 !== r.emissiveFactor && a !== $c) {
                    const e1 = r.emissiveFactor;
                    s.emissive = (new Zc).setRGB(e1[0], e1[1], e1[2], Qs);
                }
                return void 0 !== r.emissiveTexture && a !== $c && o.push(t.assignTexture(s, "emissiveMap", r.emissiveTexture, Gs)), Promise.all(o).then(function() {
                    const n = new a(s);
                    return r.name && (n.name = r.name), oy(n, r), t.associations.set(n, {
                        materials: e1
                    }), r.extensions && sy(i, n, r), n;
                });
            }
            createUniqueName(e1) {
                const t = Tv.sanitizeNodeName(e1 || "");
                return t in this.nodeNamesUsed ? t + "_" + ++this.nodeNamesUsed[t] : (this.nodeNamesUsed[t] = 0, t);
            }
            loadGeometries(e1) {
                const t = this, n = this.extensions, i = this.primitiveCache;
                function r(e1) {
                    return n[SM.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(e1, t).then(function(n) {
                        return fy(n, e1, t);
                    });
                }
                const a = [];
                for(let n = 0, s = e1.length; n < s; n++){
                    const s = e1[n], o = cy(s), l = i[o];
                    if (l) a.push(l.promise);
                    else {
                        let e1;
                        e1 = s.extensions && s.extensions[SM.KHR_DRACO_MESH_COMPRESSION] ? r(s) : fy(new Eu, s, t), i[o] = {
                            primitive: s,
                            promise: e1
                        }, a.push(e1);
                    }
                }
                return Promise.all(a);
            }
            loadMesh(e1) {
                const t = this, n = this.json, i = this.extensions, r = n.meshes[e1], a = r.primitives, s = [];
                for(let e1 = 0, t = a.length; e1 < t; e1++){
                    const t = void 0 === a[e1].material ? (void 0 === (o = this.cache).DefaultMaterial && (o.DefaultMaterial = new Ug({
                        color: 16777215,
                        emissive: 0,
                        metalness: 1,
                        roughness: 1,
                        transparent: !1,
                        depthTest: !0,
                        side: cr
                    })), o.DefaultMaterial) : this.getDependency("material", a[e1].material);
                    s.push(t);
                }
                var o;
                return s.push(t.loadGeometries(a)), Promise.all(s).then(function(n) {
                    const s = n.slice(0, n.length - 1), o = n[n.length - 1], l = [];
                    for(let n = 0, c = o.length; n < c; n++){
                        const c = o[n], u = a[n];
                        let h;
                        const d = s[n];
                        if (u.mode === JM.TRIANGLES || u.mode === JM.TRIANGLE_STRIP || u.mode === JM.TRIANGLE_FAN || void 0 === u.mode) h = !0 === r.isSkinnedMesh ? new If(c, d) : new Vu(c, d), !0 === h.isSkinnedMesh && h.normalizeSkinWeights(), u.mode === JM.TRIANGLE_STRIP ? h.geometry = wM(h.geometry, Os) : u.mode === JM.TRIANGLE_FAN && (h.geometry = wM(h.geometry, Ps));
                        else if (u.mode === JM.LINES) h = new Jf(c, d);
                        else if (u.mode === JM.LINE_STRIP) h = new Zf(c, d);
                        else if (u.mode === JM.LINE_LOOP) h = new $f(c, d);
                        else {
                            if (u.mode !== JM.POINTS) throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + u.mode);
                            h = new am(c, d);
                        }
                        Object.keys(h.geometry.morphAttributes).length > 0 && ly(h, r), h.name = t.createUniqueName(r.name || "mesh_" + e1), oy(h, r), u.extensions && sy(i, h, u), t.assignFinalMaterial(h), l.push(h);
                    }
                    for(let n = 0, i = l.length; n < i; n++)t.associations.set(l[n], {
                        meshes: e1,
                        primitives: n
                    });
                    if (1 === l.length) return r.extensions && sy(i, l[0], r), l[0];
                    const c = new kp;
                    r.extensions && sy(i, c, r), t.associations.set(c, {
                        meshes: e1
                    });
                    for(let e1 = 0, t = l.length; e1 < t; e1++)c.add(l[e1]);
                    return c;
                });
            }
            loadCamera(e1) {
                let t;
                const n = this.json.cameras[e1], i = n[n.type];
                if (i) return "perspective" === n.type ? t = new Ju(Ko.radToDeg(i.yfov), i.aspectRatio || 1, i.znear || 1, i.zfar || 2e6) : "orthographic" === n.type && (t = new bh(-i.xmag, i.xmag, i.ymag, -i.ymag, i.znear, i.zfar)), n.name && (t.name = this.createUniqueName(n.name)), oy(t, n), Promise.resolve(t);
                console.warn("THREE.GLTFLoader: Missing camera parameters.");
            }
            loadSkin(e1) {
                const t = this.json.skins[e1], n = [];
                for(let e1 = 0, i = t.joints.length; e1 < i; e1++)n.push(this._loadNodeShallow(t.joints[e1]));
                return void 0 !== t.inverseBindMatrices ? n.push(this.getDependency("accessor", t.inverseBindMatrices)) : n.push(null), Promise.all(n).then(function(e1) {
                    const n = e1.pop(), i = e1, r = [], a = [];
                    for(let e1 = 0, s = i.length; e1 < s; e1++){
                        const s = i[e1];
                        if (s) {
                            r.push(s);
                            const t = new oc;
                            null !== n && t.fromArray(n.array, 16 * e1), a.push(t);
                        } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', t.joints[e1]);
                    }
                    return new Rf(r, a);
                });
            }
            loadAnimation(e1) {
                const t = this.json, n = this, i = t.animations[e1], r = i.name ? i.name : "animation_" + e1, a = [], s = [], o = [], l = [], c = [];
                for(let e1 = 0, t = i.channels.length; e1 < t; e1++){
                    const t = i.channels[e1], n = i.samplers[t.sampler], r = t.target, u = r.node, h = void 0 !== i.parameters ? i.parameters[n.input] : n.input, d = void 0 !== i.parameters ? i.parameters[n.output] : n.output;
                    void 0 !== r.node && (a.push(this.getDependency("node", u)), s.push(this.getDependency("accessor", h)), o.push(this.getDependency("accessor", d)), l.push(n), c.push(r));
                }
                return Promise.all([
                    Promise.all(a),
                    Promise.all(s),
                    Promise.all(o),
                    Promise.all(l),
                    Promise.all(c)
                ]).then(function(e1) {
                    const t = e1[0], i = e1[1], a = e1[2], s = e1[3], o = e1[4], l = [];
                    for(let e1 = 0, r = t.length; e1 < r; e1++){
                        const r = t[e1], c = i[e1], u = a[e1], h = s[e1], d = o[e1];
                        if (void 0 === r) continue;
                        r.updateMatrix && r.updateMatrix();
                        const p = n._createAnimationTracks(r, c, u, h, d);
                        if (p) for(let e1 = 0; e1 < p.length; e1++)l.push(p[e1]);
                    }
                    return new cA(r, void 0, l);
                });
            }
            createNodeMesh(e1) {
                const t = this.json, n = this, i = t.nodes[e1];
                return void 0 === i.mesh ? null : n.getDependency("mesh", i.mesh).then(function(e1) {
                    const t = n._getNodeRef(n.meshCache, i.mesh, e1);
                    return void 0 !== i.weights && t.traverse(function(e1) {
                        if (e1.isMesh) for(let t = 0, n = i.weights.length; t < n; t++)e1.morphTargetInfluences[t] = i.weights[t];
                    }), t;
                });
            }
            loadNode(e1) {
                const t = this, n = this.json.nodes[e1], i = t._loadNodeShallow(e1), r = [], a = n.children || [];
                for(let e1 = 0, n = a.length; e1 < n; e1++)r.push(t.getDependency("node", a[e1]));
                const s = void 0 === n.skin ? Promise.resolve(null) : t.getDependency("skin", n.skin);
                return Promise.all([
                    i,
                    Promise.all(r),
                    s
                ]).then(function(e1) {
                    const t = e1[0], n = e1[1], i = e1[2];
                    null !== i && t.traverse(function(e1) {
                        e1.isSkinnedMesh && e1.bind(i, dy);
                    });
                    for(let e1 = 0, i = n.length; e1 < i; e1++)t.add(n[e1]);
                    return t;
                });
            }
            _loadNodeShallow(e1) {
                const t = this.json, n = this.extensions, i = this;
                if (void 0 !== this.nodeCache[e1]) return this.nodeCache[e1];
                const r = t.nodes[e1], a = r.name ? i.createUniqueName(r.name) : "", s = [], o = i._invokeOne(function(t) {
                    return t.createNodeMesh && t.createNodeMesh(e1);
                });
                return o && s.push(o), void 0 !== r.camera && s.push(i.getDependency("camera", r.camera).then(function(e1) {
                    return i._getNodeRef(i.cameraCache, r.camera, e1);
                })), i._invokeAll(function(t) {
                    return t.createNodeAttachment && t.createNodeAttachment(e1);
                }).forEach(function(e1) {
                    s.push(e1);
                }), this.nodeCache[e1] = Promise.all(s).then(function(t) {
                    let s;
                    if (s = !0 === r.isBone ? new Nf : t.length > 1 ? new kp : 1 === t.length ? t[0] : new Lc, s !== t[0]) for(let e1 = 0, n = t.length; e1 < n; e1++)s.add(t[e1]);
                    if (r.name && (s.userData.name = r.name, s.name = a), oy(s, r), r.extensions && sy(n, s, r), void 0 !== r.matrix) {
                        const e1 = new oc;
                        e1.fromArray(r.matrix), s.applyMatrix4(e1);
                    } else void 0 !== r.translation && s.position.fromArray(r.translation), void 0 !== r.rotation && s.quaternion.fromArray(r.rotation), void 0 !== r.scale && s.scale.fromArray(r.scale);
                    return i.associations.has(s) || i.associations.set(s, {}), i.associations.get(s).nodes = e1, s;
                }), this.nodeCache[e1];
            }
            loadScene(e1) {
                const t = this.extensions, n = this.json.scenes[e1], i = this, r = new kp;
                n.name && (r.name = i.createUniqueName(n.name)), oy(r, n), n.extensions && sy(t, r, n);
                const a = n.nodes || [], s = [];
                for(let e1 = 0, t = a.length; e1 < t; e1++)s.push(i.getDependency("node", a[e1]));
                return Promise.all(s).then(function(e1) {
                    for(let t = 0, n = e1.length; t < n; t++)r.add(e1[t]);
                    return i.associations = ((e1)=>{
                        const t = new Map;
                        for (const [e1, n] of i.associations)(e1 instanceof Jc || e1 instanceof xl) && t.set(e1, n);
                        return e1.traverse((e1)=>{
                            const n = i.associations.get(e1);
                            null != n && t.set(e1, n);
                        }), t;
                    })(r), r;
                });
            }
            _createAnimationTracks(e1, t, n, i, r) {
                const a = [], s = e1.name ? e1.name : e1.uuid, o = [];
                let l;
                switch(ry[r.path] === ry.weights ? e1.traverse(function(e1) {
                    e1.morphTargetInfluences && o.push(e1.name ? e1.name : e1.uuid);
                }) : o.push(s), ry[r.path]){
                    case ry.weights:
                        l = rA;
                        break;
                    case ry.rotation:
                        l = sA;
                        break;
                    case ry.position:
                    case ry.scale:
                        l = lA;
                        break;
                    default:
                        l = 1 === n.itemSize ? rA : lA;
                }
                const c = void 0 !== i.interpolation ? ay[i.interpolation] : Ss, u = this._getArrayFromAccessor(n);
                for(let e1 = 0, n = o.length; e1 < n; e1++){
                    const n = new l(o[e1] + "." + ry[r.path], t.array, u, c);
                    "CUBICSPLINE" === i.interpolation && this._createCubicSplineTrackInterpolant(n), a.push(n);
                }
                return a;
            }
            _getArrayFromAccessor(e1) {
                let t = e1.array;
                if (e1.normalized) {
                    const e1 = hy(t.constructor), n = new Float32Array(t.length);
                    for(let i = 0, r = t.length; i < r; i++)n[i] = t[i] * e1;
                    t = n;
                }
                return t;
            }
            _createCubicSplineTrackInterpolant(e1) {
                e1.createInterpolant = function(e1) {
                    return new (this instanceof sA ? KM : ZM)(this.times, this.values, this.getValueSize() / 3, e1);
                }, e1.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0;
            }
        }
        function fy(e1, t, n) {
            const i = t.attributes, r = [];
            function a(t, i) {
                return n.getDependency("accessor", t).then(function(t) {
                    e1.setAttribute(i, t);
                });
            }
            for(const t in i){
                const n = iy[t] || t.toLowerCase();
                n in e1.attributes || r.push(a(i[t], n));
            }
            if (void 0 !== t.indices && !e1.index) {
                const i = n.getDependency("accessor", t.indices).then(function(t) {
                    e1.setIndex(t);
                });
                r.push(i);
            }
            return dl.workingColorSpace !== Qs && "COLOR_0" in i && console.warn('THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "'.concat(dl.workingColorSpace, '" not supported.')), oy(e1, t), function(e1, t, n) {
                const i = t.attributes, r = new zl;
                if (void 0 === i.POSITION) return;
                {
                    const e1 = n.json.accessors[i.POSITION], t = e1.min, a = e1.max;
                    if (void 0 === t || void 0 === a) return void console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
                    if (r.set(new Cl(t[0], t[1], t[2]), new Cl(a[0], a[1], a[2])), e1.normalized) {
                        const t = hy($M[e1.componentType]);
                        r.min.multiplyScalar(t), r.max.multiplyScalar(t);
                    }
                }
                const a = t.targets;
                if (void 0 !== a) {
                    const e1 = new Cl, t = new Cl;
                    for(let i = 0, r = a.length; i < r; i++){
                        const r = a[i];
                        if (void 0 !== r.POSITION) {
                            const i = n.json.accessors[r.POSITION], a = i.min, s = i.max;
                            if (void 0 !== a && void 0 !== s) {
                                if (t.setX(Math.max(Math.abs(a[0]), Math.abs(s[0]))), t.setY(Math.max(Math.abs(a[1]), Math.abs(s[1]))), t.setZ(Math.max(Math.abs(a[2]), Math.abs(s[2]))), i.normalized) {
                                    const e1 = hy($M[i.componentType]);
                                    t.multiplyScalar(e1);
                                }
                                e1.max(t);
                            } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
                        }
                    }
                    r.expandByVector(e1);
                }
                e1.boundingBox = r;
                const s = new Jl;
                r.getCenter(s.center), s.radius = r.min.distanceTo(r.max) / 2, e1.boundingSphere = s;
            }(e1, t, n), Promise.all(r).then(function() {
                return void 0 !== t.targets ? function(e1, t, n) {
                    let i = !1, r = !1, a = !1;
                    for(let e1 = 0, n = t.length; e1 < n; e1++){
                        const n = t[e1];
                        if (void 0 !== n.POSITION && (i = !0), void 0 !== n.NORMAL && (r = !0), void 0 !== n.COLOR_0 && (a = !0), i && r && a) break;
                    }
                    if (!i && !r && !a) return Promise.resolve(e1);
                    const s = [], o = [], l = [];
                    for(let c = 0, u = t.length; c < u; c++){
                        const u = t[c];
                        if (i) {
                            const t = void 0 !== u.POSITION ? n.getDependency("accessor", u.POSITION) : e1.attributes.position;
                            s.push(t);
                        }
                        if (r) {
                            const t = void 0 !== u.NORMAL ? n.getDependency("accessor", u.NORMAL) : e1.attributes.normal;
                            o.push(t);
                        }
                        if (a) {
                            const t = void 0 !== u.COLOR_0 ? n.getDependency("accessor", u.COLOR_0) : e1.attributes.color;
                            l.push(t);
                        }
                    }
                    return Promise.all([
                        Promise.all(s),
                        Promise.all(o),
                        Promise.all(l)
                    ]).then(function(t) {
                        const n = t[0], s = t[1], o = t[2];
                        return i && (e1.morphAttributes.position = n), r && (e1.morphAttributes.normal = s), a && (e1.morphAttributes.color = o), e1.morphTargetsRelative = !0, e1;
                    });
                }(e1, t.targets, n) : e1;
            });
        }
        const my = {
            Handedness: Object.freeze({
                NONE: "none",
                LEFT: "left",
                RIGHT: "right"
            }),
            ComponentState: Object.freeze({
                DEFAULT: "default",
                TOUCHED: "touched",
                PRESSED: "pressed"
            }),
            ComponentProperty: Object.freeze({
                BUTTON: "button",
                X_AXIS: "xAxis",
                Y_AXIS: "yAxis",
                STATE: "state"
            }),
            ComponentType: Object.freeze({
                TRIGGER: "trigger",
                SQUEEZE: "squeeze",
                TOUCHPAD: "touchpad",
                THUMBSTICK: "thumbstick",
                BUTTON: "button"
            }),
            ButtonTouchThreshold: .05,
            AxisTouchThreshold: .1,
            VisualResponseProperty: Object.freeze({
                TRANSFORM: "transform",
                VISIBILITY: "visibility"
            })
        };
        async function gy(e1) {
            const t = await fetch(e1);
            if (t.ok) return t.json();
            throw new Error(t.statusText);
        }
        const Ay = {
            xAxis: 0,
            yAxis: 0,
            button: 0,
            state: my.ComponentState.DEFAULT
        };
        class vy {
            constructor(e1){
                this.componentProperty = e1.componentProperty, this.states = e1.states, this.valueNodeName = e1.valueNodeName, this.valueNodeProperty = e1.valueNodeProperty, this.valueNodeProperty === my.VisualResponseProperty.TRANSFORM && (this.minNodeName = e1.minNodeName, this.maxNodeName = e1.maxNodeName), this.value = 0, this.updateFromComponent(Ay);
            }
            updateFromComponent(e1) {
                let { xAxis: t, yAxis: n, button: i, state: r } = e1;
                const { normalizedXAxis: a, normalizedYAxis: s } = function() {
                    let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = e1, i = t;
                    if (Math.sqrt(e1 * e1 + t * t) > 1) {
                        const r = Math.atan2(t, e1);
                        n = Math.cos(r), i = Math.sin(r);
                    }
                    return {
                        normalizedXAxis: .5 * n + .5,
                        normalizedYAxis: .5 * i + .5
                    };
                }(t, n);
                switch(this.componentProperty){
                    case my.ComponentProperty.X_AXIS:
                        this.value = this.states.includes(r) ? a : .5;
                        break;
                    case my.ComponentProperty.Y_AXIS:
                        this.value = this.states.includes(r) ? s : .5;
                        break;
                    case my.ComponentProperty.BUTTON:
                        this.value = this.states.includes(r) ? i : 0;
                        break;
                    case my.ComponentProperty.STATE:
                        this.valueNodeProperty === my.VisualResponseProperty.VISIBILITY ? this.value = this.states.includes(r) : this.value = this.states.includes(r) ? 1 : 0;
                        break;
                    default:
                        throw new Error("Unexpected visualResponse componentProperty ".concat(this.componentProperty));
                }
            }
        }
        class My {
            constructor(e1, t){
                if (!(e1 && t && t.visualResponses && t.gamepadIndices && 0 !== Object.keys(t.gamepadIndices).length)) throw new Error("Invalid arguments supplied");
                this.id = e1, this.type = t.type, this.rootNodeName = t.rootNodeName, this.touchPointNodeName = t.touchPointNodeName, this.visualResponses = {}, Object.keys(t.visualResponses).forEach((e1)=>{
                    const n = new vy(t.visualResponses[e1]);
                    this.visualResponses[e1] = n;
                }), this.gamepadIndices = Object.assign({}, t.gamepadIndices), this.values = {
                    state: my.ComponentState.DEFAULT,
                    button: void 0 !== this.gamepadIndices.button ? 0 : void 0,
                    xAxis: void 0 !== this.gamepadIndices.xAxis ? 0 : void 0,
                    yAxis: void 0 !== this.gamepadIndices.yAxis ? 0 : void 0
                };
            }
            get data() {
                return {
                    id: this.id,
                    ...this.values
                };
            }
            updateFromGamepad(e1) {
                if (this.values.state = my.ComponentState.DEFAULT, void 0 !== this.gamepadIndices.button && e1.buttons.length > this.gamepadIndices.button) {
                    const t = e1.buttons[this.gamepadIndices.button];
                    this.values.button = t.value, this.values.button = this.values.button < 0 ? 0 : this.values.button, this.values.button = this.values.button > 1 ? 1 : this.values.button, t.pressed || 1 === this.values.button ? this.values.state = my.ComponentState.PRESSED : (t.touched || this.values.button > my.ButtonTouchThreshold) && (this.values.state = my.ComponentState.TOUCHED);
                }
                void 0 !== this.gamepadIndices.xAxis && e1.axes.length > this.gamepadIndices.xAxis && (this.values.xAxis = e1.axes[this.gamepadIndices.xAxis], this.values.xAxis = this.values.xAxis < -1 ? -1 : this.values.xAxis, this.values.xAxis = this.values.xAxis > 1 ? 1 : this.values.xAxis, this.values.state === my.ComponentState.DEFAULT && Math.abs(this.values.xAxis) > my.AxisTouchThreshold && (this.values.state = my.ComponentState.TOUCHED)), void 0 !== this.gamepadIndices.yAxis && e1.axes.length > this.gamepadIndices.yAxis && (this.values.yAxis = e1.axes[this.gamepadIndices.yAxis], this.values.yAxis = this.values.yAxis < -1 ? -1 : this.values.yAxis, this.values.yAxis = this.values.yAxis > 1 ? 1 : this.values.yAxis, this.values.state === my.ComponentState.DEFAULT && Math.abs(this.values.yAxis) > my.AxisTouchThreshold && (this.values.state = my.ComponentState.TOUCHED)), Object.values(this.visualResponses).forEach((e1)=>{
                    e1.updateFromComponent(this.values);
                });
            }
        }
        class yy {
            constructor(e1, t, n){
                if (!e1) throw new Error("No xrInputSource supplied");
                if (!t) throw new Error("No profile supplied");
                this.xrInputSource = e1, this.assetUrl = n, this.id = t.profileId, this.layoutDescription = t.layouts[e1.handedness], this.components = {}, Object.keys(this.layoutDescription.components).forEach((e1)=>{
                    const t = this.layoutDescription.components[e1];
                    this.components[e1] = new My(e1, t);
                }), this.updateFromGamepad();
            }
            get gripSpace() {
                return this.xrInputSource.gripSpace;
            }
            get targetRaySpace() {
                return this.xrInputSource.targetRaySpace;
            }
            get data() {
                const e1 = [];
                return Object.values(this.components).forEach((t)=>{
                    e1.push(t.data);
                }), e1;
            }
            updateFromGamepad() {
                Object.values(this.components).forEach((e1)=>{
                    e1.updateFromGamepad(this.xrInputSource.gamepad);
                });
            }
        }
        class xy extends Lc {
            constructor(){
                super(), this.motionController = null, this.envMap = null;
            }
            setEnvironmentMap(e1) {
                return this.envMap == e1 || (this.envMap = e1, this.traverse((e1)=>{
                    e1.isMesh && (e1.material.envMap = this.envMap, e1.material.needsUpdate = !0);
                })), this;
            }
            updateMatrixWorld(e1) {
                super.updateMatrixWorld(e1), this.motionController && (this.motionController.updateFromGamepad(), Object.values(this.motionController.components).forEach((e1)=>{
                    Object.values(e1.visualResponses).forEach((e1)=>{
                        const { valueNode: t, minNode: n, maxNode: i, value: r, valueNodeProperty: a } = e1;
                        t && (a === my.VisualResponseProperty.VISIBILITY ? t.visible = r : a === my.VisualResponseProperty.TRANSFORM && (t.quaternion.slerpQuaternions(n.quaternion, i.quaternion, r), t.position.lerpVectors(n.position, i.position, r)));
                    });
                }));
            }
        }
        function _y(e1, t) {
            !function(e1, t) {
                Object.values(e1.components).forEach((e1)=>{
                    const { type: n, touchPointNodeName: i, visualResponses: r } = e1;
                    if (n === my.ComponentType.TOUCHPAD) {
                        if (e1.touchPointNode = t.getObjectByName(i), e1.touchPointNode) {
                            const t = new Sg(.001), n = new $c({
                                color: 255
                            }), i = new Vu(t, n);
                            e1.touchPointNode.add(i);
                        } else console.warn("Could not find touch dot, ".concat(e1.touchPointNodeName, ", in touchpad component ").concat(e1.id));
                    }
                    Object.values(r).forEach((e1)=>{
                        const { valueNodeName: n, minNodeName: i, maxNodeName: r, valueNodeProperty: a } = e1;
                        if (a === my.VisualResponseProperty.TRANSFORM) {
                            if (e1.minNode = t.getObjectByName(i), e1.maxNode = t.getObjectByName(r), !e1.minNode) return void console.warn("Could not find ".concat(i, " in the model"));
                            if (!e1.maxNode) return void console.warn("Could not find ".concat(r, " in the model"));
                        }
                        e1.valueNode = t.getObjectByName(n), e1.valueNode || console.warn("Could not find ".concat(n, " in the model"));
                    });
                });
            }(e1.motionController, t), e1.envMap && t.traverse((t)=>{
                t.isMesh && (t.material.envMap = e1.envMap, t.material.needsUpdate = !0);
            }), e1.add(t);
        }
        class by {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                this.gltfLoader = e1, this.path = "https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles", this._assetCache = {}, this.gltfLoader || (this.gltfLoader = new EM);
            }
            createControllerModel(e1) {
                const t = new xy;
                let n = null;
                return e1.addEventListener("connected", (e1)=>{
                    const i = e1.data;
                    "tracked-pointer" === i.targetRayMode && i.gamepad && (async function(e1, t) {
                        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, i = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
                        if (!e1) throw new Error("No xrInputSource supplied");
                        if (!t) throw new Error("No basePath supplied");
                        const r = await async function(e1) {
                            if (!e1) throw new Error("No basePath supplied");
                            return await gy("".concat(e1, "/").concat("profilesList.json"));
                        }(t);
                        let a;
                        if (e1.profiles.some((e1)=>{
                            const n = r[e1];
                            return n && (a = {
                                profileId: e1,
                                profilePath: "".concat(t, "/").concat(n.path),
                                deprecated: !!n.deprecated
                            }), !!a;
                        }), !a) {
                            if (!n) throw new Error("No matching profile name found");
                            const e1 = r[n];
                            if (!e1) throw new Error('No matching profile name found and default profile "'.concat(n, '" missing.'));
                            a = {
                                profileId: n,
                                profilePath: "".concat(t, "/").concat(e1.path),
                                deprecated: !!e1.deprecated
                            };
                        }
                        const s = await gy(a.profilePath);
                        let o;
                        if (i) {
                            let t;
                            if (t = "any" === e1.handedness ? s.layouts[Object.keys(s.layouts)[0]] : s.layouts[e1.handedness], !t) throw new Error("No matching handedness, ".concat(e1.handedness, ", in profile ").concat(a.profileId));
                            t.assetPath && (o = a.profilePath.replace("profile.json", t.assetPath));
                        }
                        return {
                            profile: s,
                            assetPath: o
                        };
                    })(i, this.path, "generic-trigger").then((e1)=>{
                        let { profile: r, assetPath: a } = e1;
                        t.motionController = new yy(i, r, a);
                        const s = this._assetCache[t.motionController.assetUrl];
                        if (s) n = s.scene.clone(), _y(t, n);
                        else {
                            if (!this.gltfLoader) throw new Error("GLTFLoader not set.");
                            this.gltfLoader.setPath(""), this.gltfLoader.load(t.motionController.assetUrl, (e1)=>{
                                this._assetCache[t.motionController.assetUrl] = e1, n = e1.scene.clone(), _y(t, n);
                            }, null, ()=>{
                                throw new Error("Asset ".concat(t.motionController.assetUrl, " missing or malformed."));
                            });
                        }
                    }).catch((e1)=>{
                        console.warn(e1);
                    });
                }), e1.addEventListener("disconnected", ()=>{
                    t.motionController = null, t.remove(n), n = null;
                }), t;
            }
        }
        const wy = new oc, Ey = new Cl;
        class Ty {
            constructor(e1, t, n, i, r){
                let a;
                this.controller = t, this.handModel = e1, this.envMap = null, r && r.primitive && "sphere" !== r.primitive ? "box" === r.primitive && (a = new Qu(1, 1, 1)) : a = new Sg(1, 10, 10);
                const s = new Ug;
                this.handMesh = new Hf(a, s, 30), this.handMesh.frustumCulled = !1, this.handMesh.instanceMatrix.setUsage(wo), this.handMesh.castShadow = !0, this.handMesh.receiveShadow = !0, this.handModel.add(this.handMesh), this.joints = [
                    "wrist",
                    "thumb-metacarpal",
                    "thumb-phalanx-proximal",
                    "thumb-phalanx-distal",
                    "thumb-tip",
                    "index-finger-metacarpal",
                    "index-finger-phalanx-proximal",
                    "index-finger-phalanx-intermediate",
                    "index-finger-phalanx-distal",
                    "index-finger-tip",
                    "middle-finger-metacarpal",
                    "middle-finger-phalanx-proximal",
                    "middle-finger-phalanx-intermediate",
                    "middle-finger-phalanx-distal",
                    "middle-finger-tip",
                    "ring-finger-metacarpal",
                    "ring-finger-phalanx-proximal",
                    "ring-finger-phalanx-intermediate",
                    "ring-finger-phalanx-distal",
                    "ring-finger-tip",
                    "pinky-finger-metacarpal",
                    "pinky-finger-phalanx-proximal",
                    "pinky-finger-phalanx-intermediate",
                    "pinky-finger-phalanx-distal",
                    "pinky-finger-tip"
                ];
            }
            updateMesh() {
                const e1 = this.controller.joints;
                let t = 0;
                for(let n = 0; n < this.joints.length; n++){
                    const i = e1[this.joints[n]];
                    i.visible && (Ey.setScalar(i.jointRadius || .008), wy.compose(i.position, i.quaternion, Ey), this.handMesh.setMatrixAt(n, wy), t++);
                }
                this.handMesh.count = t, this.handMesh.instanceMatrix.needsUpdate = !0;
            }
        }
        class Sy {
            constructor(e1, t, n, i){
                let r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
                this.controller = t, this.handModel = e1, this.bones = [], null === r && (r = new EM, r.setPath(n || "https://cdn.jsdelivr.net/npm/@webxr-input-profiles/assets@1.0/dist/profiles/generic-hand/")), r.load("".concat(i, ".glb"), (e1)=>{
                    const t = e1.scene.children[0];
                    this.handModel.add(t);
                    const n = t.getObjectByProperty("type", "SkinnedMesh");
                    n.frustumCulled = !1, n.castShadow = !0, n.receiveShadow = !0, [
                        "wrist",
                        "thumb-metacarpal",
                        "thumb-phalanx-proximal",
                        "thumb-phalanx-distal",
                        "thumb-tip",
                        "index-finger-metacarpal",
                        "index-finger-phalanx-proximal",
                        "index-finger-phalanx-intermediate",
                        "index-finger-phalanx-distal",
                        "index-finger-tip",
                        "middle-finger-metacarpal",
                        "middle-finger-phalanx-proximal",
                        "middle-finger-phalanx-intermediate",
                        "middle-finger-phalanx-distal",
                        "middle-finger-tip",
                        "ring-finger-metacarpal",
                        "ring-finger-phalanx-proximal",
                        "ring-finger-phalanx-intermediate",
                        "ring-finger-phalanx-distal",
                        "ring-finger-tip",
                        "pinky-finger-metacarpal",
                        "pinky-finger-phalanx-proximal",
                        "pinky-finger-phalanx-intermediate",
                        "pinky-finger-phalanx-distal",
                        "pinky-finger-tip"
                    ].forEach((e1)=>{
                        const n = t.getObjectByName(e1);
                        void 0 !== n ? n.jointName = e1 : console.warn("Couldn't find ".concat(e1, " in ").concat(i, " hand mesh")), this.bones.push(n);
                    });
                });
            }
            updateMesh() {
                const e1 = this.controller.joints;
                for(let t = 0; t < this.bones.length; t++){
                    const n = this.bones[t];
                    if (n) {
                        const t = e1[n.jointName];
                        if (t.visible) {
                            const e1 = t.position;
                            n.position.copy(e1), n.quaternion.copy(t.quaternion);
                        }
                    }
                }
            }
        }
        class Iy extends Lc {
            constructor(e1){
                super(), this.controller = e1, this.motionController = null, this.envMap = null, this.mesh = null;
            }
            updateMatrixWorld(e1) {
                super.updateMatrixWorld(e1), this.motionController && this.motionController.updateMesh();
            }
        }
        class Ny {
            constructor(){
                this.path = null;
            }
            setPath(e1) {
                return this.path = e1, this;
            }
            createHandModel(e1, t) {
                const n = new Iy(e1);
                return e1.addEventListener("connected", (i)=>{
                    const r = i.data;
                    r.hand && !n.motionController && (n.xrInputSource = r, void 0 === t || "spheres" === t ? n.motionController = new Ty(n, e1, this.path, r.handedness, {
                        primitive: "sphere"
                    }) : "boxes" === t ? n.motionController = new Ty(n, e1, this.path, r.handedness, {
                        primitive: "box"
                    }) : "mesh" === t && (n.motionController = new Sy(n, e1, this.path, r.handedness))), e1.visible = !0;
                }), e1.addEventListener("disconnected", ()=>{
                    e1.visible = !1;
                }), n;
            }
        }
        function Dy(e1) {
            return Math.sqrt(Math.pow(e1[1][0] - e1[0][0], 2) + Math.pow(e1[1][1] - e1[0][1], 2));
        }
        const Cy = 3.280839895, Ly = (e1)=>{
            e1.preventDefault();
        }, Ry = async (e1)=>{
            const t = new Promise((t)=>{
                const n = new Image;
                n.onload = ()=>t(n), n.src = e1;
            });
            return await t;
        }, zy = (e1, t, n, i, r, a)=>{
            let s = a;
            i < 2 * s && (s = i / 2), r < 2 * a && (s = r / 2), e1.beginPath(), e1.moveTo(t + s, n), e1.arcTo(t + i, n, t + i, n + r, s), e1.arcTo(t + i, n + r, t, n + r, s), e1.arcTo(t, n + r, t, n, s), e1.arcTo(t, n, t + i, n, s), e1.closePath();
        }, Oy = function(e1) {
            var t, n;
            let i = null !== (t = null === (n = Bi.dictionaryOverrides) || void 0 === n ? void 0 : n[e1]) && void 0 !== t ? t : ki.getLocaleText(e1);
            for(var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), s = 1; s < r; s++)a[s - 1] = arguments[s];
            return Bi.config.floorNumberEndingsVisible && "floor" === e1 ? a.reduce((e1, t, n)=>e1.replaceAll("$".concat(n), ((e1)=>{
                    var t, n;
                    return null !== (t = Bi.dictionaryOverrides) && void 0 !== t && null !== (t = t.floorNumberEndings) && void 0 !== t && t[e1] ? Bi.dictionaryOverrides.floorNumberEndings[e1] : null !== (n = ki.getLocaleText("floorNumberEndings")[e1]) && void 0 !== n ? n : e1 + ki.getLocaleText("floorNumberEndings").rest;
                })(t)), i) : a.reduce((e1, t, n)=>e1.replaceAll("$".concat(n), t), i);
        }, Py = (e1)=>{
            const t = Math.floor(e1 * Cy), n = 12 * (e1 * Cy - t);
            return "".concat(t, "'").concat(Math.round(n), '"');
        }, Uy = function(e1, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 100;
            return new Promise((i)=>{
                const r = setInterval(()=>{
                    e1() || (clearInterval(r), i(t));
                }, n);
            });
        };
        var ky = function(e1) {
            return URL.createObjectURL(new Blob([
                e1
            ], {
                type: "text/javascript"
            }));
        };
        try {
            URL.revokeObjectURL(ky(""));
        } catch (e1) {
            ky = function(e1) {
                return "data:application/javascript;charset=UTF-8," + encodeURI(e1);
            };
        }
        var jy = Uint8Array, By = Uint16Array, Fy = Uint32Array, Hy = new jy([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), Vy = new jy([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), Gy = new jy([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), Qy = function(e1, t) {
            for(var n = new By(31), i = 0; i < 31; ++i)n[i] = t += 1 << e1[i - 1];
            var r = new Fy(n[30]);
            for(i = 1; i < 30; ++i)for(var a = n[i]; a < n[i + 1]; ++a)r[a] = a - n[i] << 5 | i;
            return [
                n,
                r
            ];
        }, Wy = Qy(Hy, 2), Yy = Wy[0], Xy = Wy[1];
        Yy[28] = 258, Xy[258] = 28;
        for(var Zy = Qy(Vy, 0), qy = Zy[0], Ky = (Zy[1], new By(32768)), Jy = 0; Jy < 32768; ++Jy){
            var $y = (43690 & Jy) >>> 1 | (21845 & Jy) << 1;
            $y = (61680 & ($y = (52428 & $y) >>> 2 | (13107 & $y) << 2)) >>> 4 | (3855 & $y) << 4, Ky[Jy] = ((65280 & $y) >>> 8 | (255 & $y) << 8) >>> 1;
        }
        var ex = function(e1, t, n) {
            for(var i = e1.length, r = 0, a = new By(t); r < i; ++r)++a[e1[r] - 1];
            var s, o = new By(t);
            for(r = 0; r < t; ++r)o[r] = o[r - 1] + a[r - 1] << 1;
            if (n) {
                s = new By(1 << t);
                var l = 15 - t;
                for(r = 0; r < i; ++r)if (e1[r]) for(var c = r << 4 | e1[r], u = t - e1[r], h = o[e1[r] - 1]++ << u, d = h | (1 << u) - 1; h <= d; ++h)s[Ky[h] >>> l] = c;
            } else for(s = new By(i), r = 0; r < i; ++r)e1[r] && (s[r] = Ky[o[e1[r] - 1]++] >>> 15 - e1[r]);
            return s;
        }, tx = new jy(288);
        for(Jy = 0; Jy < 144; ++Jy)tx[Jy] = 8;
        for(Jy = 144; Jy < 256; ++Jy)tx[Jy] = 9;
        for(Jy = 256; Jy < 280; ++Jy)tx[Jy] = 7;
        for(Jy = 280; Jy < 288; ++Jy)tx[Jy] = 8;
        var nx = new jy(32);
        for(Jy = 0; Jy < 32; ++Jy)nx[Jy] = 5;
        var ix = ex(tx, 9, 1), rx = ex(nx, 5, 1), ax = function(e1) {
            for(var t = e1[0], n = 1; n < e1.length; ++n)e1[n] > t && (t = e1[n]);
            return t;
        }, sx = function(e1, t, n) {
            var i = t / 8 | 0;
            return (e1[i] | e1[i + 1] << 8) >> (7 & t) & n;
        }, ox = function(e1, t) {
            var n = t / 8 | 0;
            return (e1[n] | e1[n + 1] << 8 | e1[n + 2] << 16) >> (7 & t);
        }, lx = function(e1, t, n) {
            var i = e1.length;
            if (!i || n && !n.l && i < 5) return t || new jy(0);
            var r = !t || n, a = !n || n.i;
            n || (n = {}), t || (t = new jy(3 * i));
            var s, o = function(e1) {
                var n = t.length;
                if (e1 > n) {
                    var i = new jy(Math.max(2 * n, e1));
                    i.set(t), t = i;
                }
            }, l = n.f || 0, c = n.p || 0, u = n.b || 0, h = n.l, d = n.d, p = n.m, f = n.n, m = 8 * i;
            do {
                if (!h) {
                    n.f = l = sx(e1, c, 1);
                    var g = sx(e1, c + 1, 3);
                    if (c += 3, !g) {
                        var A = e1[s = c, (I = (s / 8 | 0) + (7 & s && 1) + 4) - 4] | e1[I - 3] << 8, v = I + A;
                        if (v > i) {
                            if (a) throw "unexpected EOF";
                            break;
                        }
                        r && o(u + A), t.set(e1.subarray(I, v), u), n.b = u += A, n.p = c = 8 * v;
                        continue;
                    }
                    if (1 == g) h = ix, d = rx, p = 9, f = 5;
                    else {
                        if (2 != g) throw "invalid block type";
                        var M = sx(e1, c, 31) + 257, y = sx(e1, c + 10, 15) + 4, x = M + sx(e1, c + 5, 31) + 1;
                        c += 14;
                        for(var _ = new jy(x), b = new jy(19), w = 0; w < y; ++w)b[Gy[w]] = sx(e1, c + 3 * w, 7);
                        c += 3 * y;
                        var E = ax(b), T = (1 << E) - 1, S = ex(b, E, 1);
                        for(w = 0; w < x;){
                            var I, N = S[sx(e1, c, T)];
                            if (c += 15 & N, (I = N >>> 4) < 16) _[w++] = I;
                            else {
                                var D = 0, C = 0;
                                for(16 == I ? (C = 3 + sx(e1, c, 3), c += 2, D = _[w - 1]) : 17 == I ? (C = 3 + sx(e1, c, 7), c += 3) : 18 == I && (C = 11 + sx(e1, c, 127), c += 7); C--;)_[w++] = D;
                            }
                        }
                        var L = _.subarray(0, M), R = _.subarray(M);
                        p = ax(L), f = ax(R), h = ex(L, p, 1), d = ex(R, f, 1);
                    }
                    if (c > m) {
                        if (a) throw "unexpected EOF";
                        break;
                    }
                }
                r && o(u + 131072);
                for(var z = (1 << p) - 1, O = (1 << f) - 1, P = c;; P = c){
                    var U = (D = h[ox(e1, c) & z]) >>> 4;
                    if ((c += 15 & D) > m) {
                        if (a) throw "unexpected EOF";
                        break;
                    }
                    if (!D) throw "invalid length/literal";
                    if (U < 256) t[u++] = U;
                    else {
                        if (256 == U) {
                            P = c, h = null;
                            break;
                        }
                        var k = U - 254;
                        if (U > 264) {
                            var j = Hy[w = U - 257];
                            k = sx(e1, c, (1 << j) - 1) + Yy[w], c += j;
                        }
                        var B = d[ox(e1, c) & O], F = B >>> 4;
                        if (!B) throw "invalid distance";
                        if (c += 15 & B, R = qy[F], F > 3 && (j = Vy[F], R += ox(e1, c) & (1 << j) - 1, c += j), c > m) {
                            if (a) throw "unexpected EOF";
                            break;
                        }
                        r && o(u + 131072);
                        for(var H = u + k; u < H; u += 4)t[u] = t[u - R], t[u + 1] = t[u + 1 - R], t[u + 2] = t[u + 2 - R], t[u + 3] = t[u + 3 - R];
                        u = H;
                    }
                }
                n.l = h, n.p = P, n.b = u, h && (l = 1, n.m = p, n.d = d, n.n = f);
            }while (!l);
            return u == t.length ? t : function(e1, t, n) {
                (null == t || t < 0) && (t = 0), (null == n || n > e1.length) && (n = e1.length);
                var i = new (e1 instanceof By ? By : e1 instanceof Fy ? Fy : jy)(n - t);
                return i.set(e1.subarray(t, n)), i;
            }(t, 0, u);
        }, cx = new jy(0);
        function ux(e1, t) {
            return lx((function(e1) {
                if (8 != (15 & e1[0]) || e1[0] >>> 4 > 7 || (e1[0] << 8 | e1[1]) % 31) throw "invalid zlib data";
                if (32 & e1[1]) throw "invalid zlib data: preset dictionaries not supported";
            }(e1), e1.subarray(2, -4)), t);
        }
        var hx = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            hx.decode(cx, {
                stream: !0
            });
        } catch (e1) {}
        class dx extends _A {
            constructor(e1){
                super(e1), this.type = Da;
            }
            parse(e1) {
                const t = 65536, n = 14, i = 65537, r = Math.pow(2.7182818, 2.2), a = {
                    l: 0,
                    c: 0,
                    lc: 0
                };
                function s(e1, t, n, i, r) {
                    for(; n < e1;)t = t << 8 | U(i, r), n += 8;
                    n -= e1, a.l = t >> n & (1 << e1) - 1, a.c = t, a.lc = n;
                }
                const o = new Array(59);
                function l(e1) {
                    return 63 & e1;
                }
                function c(e1) {
                    return e1 >> 6;
                }
                const u = {
                    c: 0,
                    lc: 0
                };
                function h(e1, t, n, i) {
                    e1 = e1 << 8 | U(n, i), t += 8, u.c = e1, u.lc = t;
                }
                const d = {
                    c: 0,
                    lc: 0
                };
                function p(e1, t, n, i, r, a, s, o, l) {
                    if (e1 == t) {
                        i < 8 && (h(n, i, r, a), n = u.c, i = u.lc);
                        let e1 = n >> (i -= 8);
                        if (e1 = new Uint8Array([
                            e1
                        ])[0], o.value + e1 > l) return !1;
                        const t = s[o.value - 1];
                        for(; e1-- > 0;)s[o.value++] = t;
                    } else {
                        if (!(o.value < l)) return !1;
                        s[o.value++] = e1;
                    }
                    d.c = n, d.lc = i;
                }
                function f(e1) {
                    return 65535 & e1;
                }
                function m(e1) {
                    const t = f(e1);
                    return t > 32767 ? t - 65536 : t;
                }
                const g = {
                    a: 0,
                    b: 0
                };
                function A(e1, t) {
                    const n = m(e1), i = m(t), r = n + (1 & i) + (i >> 1), a = r, s = r - i;
                    g.a = a, g.b = s;
                }
                function v(e1, t) {
                    const n = f(e1), i = f(t), r = n - (i >> 1) & 65535, a = i + r - 32768 & 65535;
                    g.a = a, g.b = r;
                }
                function M(e1, t, n, i, r, a, s) {
                    const o = s < 16384, l = n > r ? r : n;
                    let c, u, h = 1;
                    for(; h <= l;)h <<= 1;
                    for(h >>= 1, c = h, h >>= 1; h >= 1;){
                        u = 0;
                        const s = u + a * (r - c), l = a * h, d = a * c, p = i * h, f = i * c;
                        let m, M, y, x;
                        for(; u <= s; u += d){
                            let r = u;
                            const a = u + i * (n - c);
                            for(; r <= a; r += f){
                                const n = r + p, i = r + l, a = i + p;
                                o ? (A(e1[r + t], e1[i + t]), m = g.a, y = g.b, A(e1[n + t], e1[a + t]), M = g.a, x = g.b, A(m, M), e1[r + t] = g.a, e1[n + t] = g.b, A(y, x), e1[i + t] = g.a, e1[a + t] = g.b) : (v(e1[r + t], e1[i + t]), m = g.a, y = g.b, v(e1[n + t], e1[a + t]), M = g.a, x = g.b, v(m, M), e1[r + t] = g.a, e1[n + t] = g.b, v(y, x), e1[i + t] = g.a, e1[a + t] = g.b);
                            }
                            if (n & h) {
                                const n = r + l;
                                o ? A(e1[r + t], e1[n + t]) : v(e1[r + t], e1[n + t]), m = g.a, e1[n + t] = g.b, e1[r + t] = m;
                            }
                        }
                        if (r & h) {
                            let r = u;
                            const a = u + i * (n - c);
                            for(; r <= a; r += f){
                                const n = r + p;
                                o ? A(e1[r + t], e1[n + t]) : v(e1[r + t], e1[n + t]), m = g.a, e1[n + t] = g.b, e1[r + t] = m;
                            }
                        }
                        c = h, h >>= 1;
                    }
                    return u;
                }
                function y(e1, t, r, f, m, g) {
                    const A = r.value, v = P(t, r), M = P(t, r);
                    r.value += 4;
                    const y = P(t, r);
                    if (r.value += 4, v < 0 || v >= i || M < 0 || M >= i) throw new Error("Something wrong with HUF_ENCSIZE");
                    const x = new Array(i), _ = new Array(16384);
                    if (function(e1) {
                        for(let t = 0; t < 16384; t++)e1[t] = {}, e1[t].len = 0, e1[t].lit = 0, e1[t].p = null;
                    }(_), function(e1, t, n, r, l, c) {
                        const u = t;
                        let h = 0, d = 0;
                        for(; r <= l; r++){
                            if (u.value - t.value > n) return !1;
                            s(6, h, d, e1, u);
                            const i = a.l;
                            if (h = a.c, d = a.lc, c[r] = i, 63 == i) {
                                if (u.value - t.value > n) throw new Error("Something wrong with hufUnpackEncTable");
                                s(8, h, d, e1, u);
                                let i = a.l + 6;
                                if (h = a.c, d = a.lc, r + i > l + 1) throw new Error("Something wrong with hufUnpackEncTable");
                                for(; i--;)c[r++] = 0;
                                r--;
                            } else if (i >= 59) {
                                let e1 = i - 59 + 2;
                                if (r + e1 > l + 1) throw new Error("Something wrong with hufUnpackEncTable");
                                for(; e1--;)c[r++] = 0;
                                r--;
                            }
                        }
                        !function(e1) {
                            for(let e1 = 0; e1 <= 58; ++e1)o[e1] = 0;
                            for(let t = 0; t < i; ++t)o[e1[t]] += 1;
                            let t = 0;
                            for(let e1 = 58; e1 > 0; --e1){
                                const n = t + o[e1] >> 1;
                                o[e1] = t, t = n;
                            }
                            for(let t = 0; t < i; ++t){
                                const n = e1[t];
                                n > 0 && (e1[t] = n | o[n]++ << 6);
                            }
                        }(c);
                    }(e1, r, f - (r.value - A), v, M, x), y > 8 * (f - (r.value - A))) throw new Error("Something wrong with hufUncompress");
                    !function(e1, t, i, r) {
                        for(; t <= i; t++){
                            const i = c(e1[t]), a = l(e1[t]);
                            if (i >> a) throw new Error("Invalid table entry");
                            if (a > n) {
                                const e1 = r[i >> a - n];
                                if (e1.len) throw new Error("Invalid table entry");
                                if (e1.lit++, e1.p) {
                                    const t = e1.p;
                                    e1.p = new Array(e1.lit);
                                    for(let n = 0; n < e1.lit - 1; ++n)e1.p[n] = t[n];
                                } else e1.p = new Array(1);
                                e1.p[e1.lit - 1] = t;
                            } else if (a) {
                                let e1 = 0;
                                for(let s = 1 << n - a; s > 0; s--){
                                    const s = r[(i << n - a) + e1];
                                    if (s.len || s.p) throw new Error("Invalid table entry");
                                    s.len = a, s.lit = t, e1++;
                                }
                            }
                        }
                    }(x, v, M, _), function(e1, t, i, r, a, s, o, f, m) {
                        let g = 0, A = 0;
                        const v = o, M = Math.trunc(r.value + (a + 7) / 8);
                        for(; r.value < M;)for(h(g, A, i, r), g = u.c, A = u.lc; A >= n;){
                            const a = t[g >> A - n & 16383];
                            if (a.len) A -= a.len, p(a.lit, s, g, A, i, r, f, m, v), g = d.c, A = d.lc;
                            else {
                                if (!a.p) throw new Error("hufDecode issues");
                                let t;
                                for(t = 0; t < a.lit; t++){
                                    const n = l(e1[a.p[t]]);
                                    for(; A < n && r.value < M;)h(g, A, i, r), g = u.c, A = u.lc;
                                    if (A >= n && c(e1[a.p[t]]) == (g >> A - n & (1 << n) - 1)) {
                                        A -= n, p(a.p[t], s, g, A, i, r, f, m, v), g = d.c, A = d.lc;
                                        break;
                                    }
                                }
                                if (t == a.lit) throw new Error("hufDecode issues");
                            }
                        }
                        const y = 8 - a & 7;
                        for(g >>= y, A -= y; A > 0;){
                            const e1 = t[g << n - A & 16383];
                            if (!e1.len) throw new Error("hufDecode issues");
                            A -= e1.len, p(e1.lit, s, g, A, i, r, f, m, v), g = d.c, A = d.lc;
                        }
                    }(x, _, e1, r, y, M, g, m, {
                        value: 0
                    });
                }
                function x(e1) {
                    for(let t = 1; t < e1.length; t++){
                        const n = e1[t - 1] + e1[t] - 128;
                        e1[t] = n;
                    }
                }
                function _(e1, t) {
                    let n = 0, i = Math.floor((e1.length + 1) / 2), r = 0;
                    const a = e1.length - 1;
                    for(; !(r > a || (t[r++] = e1[n++], r > a));)t[r++] = e1[i++];
                }
                function b(e1) {
                    let t = e1.byteLength;
                    const n = new Array;
                    let i = 0;
                    const r = new DataView(e1);
                    for(; t > 0;){
                        const e1 = r.getInt8(i++);
                        if (e1 < 0) {
                            const a = -e1;
                            t -= a + 1;
                            for(let e1 = 0; e1 < a; e1++)n.push(r.getUint8(i++));
                        } else {
                            const a = e1;
                            t -= 2;
                            const s = r.getUint8(i++);
                            for(let e1 = 0; e1 < a + 1; e1++)n.push(s);
                        }
                    }
                    return n;
                }
                function w(e1, t, n) {
                    let i, r = 1;
                    for(; r < 64;)i = t[e1.value], 65280 == i ? r = 64 : i >> 8 == 255 ? r += 255 & i : (n[r] = i, r++), e1.value++;
                }
                function E(e1) {
                    const t = .5 * Math.cos(.7853975), n = .5 * Math.cos(3.14159 / 16), i = .5 * Math.cos(3.14159 / 8), r = .5 * Math.cos(3 * 3.14159 / 16), a = .5 * Math.cos(.981746875), s = .5 * Math.cos(3 * 3.14159 / 8), o = .5 * Math.cos(1.374445625), l = new Array(4), c = new Array(4), u = new Array(4), h = new Array(4);
                    for(let d = 0; d < 8; ++d){
                        const p = 8 * d;
                        l[0] = i * e1[p + 2], l[1] = s * e1[p + 2], l[2] = i * e1[p + 6], l[3] = s * e1[p + 6], c[0] = n * e1[p + 1] + r * e1[p + 3] + a * e1[p + 5] + o * e1[p + 7], c[1] = r * e1[p + 1] - o * e1[p + 3] - n * e1[p + 5] - a * e1[p + 7], c[2] = a * e1[p + 1] - n * e1[p + 3] + o * e1[p + 5] + r * e1[p + 7], c[3] = o * e1[p + 1] - a * e1[p + 3] + r * e1[p + 5] - n * e1[p + 7], u[0] = t * (e1[p + 0] + e1[p + 4]), u[3] = t * (e1[p + 0] - e1[p + 4]), u[1] = l[0] + l[3], u[2] = l[1] - l[2], h[0] = u[0] + u[1], h[1] = u[3] + u[2], h[2] = u[3] - u[2], h[3] = u[0] - u[1], e1[p + 0] = h[0] + c[0], e1[p + 1] = h[1] + c[1], e1[p + 2] = h[2] + c[2], e1[p + 3] = h[3] + c[3], e1[p + 4] = h[3] - c[3], e1[p + 5] = h[2] - c[2], e1[p + 6] = h[1] - c[1], e1[p + 7] = h[0] - c[0];
                    }
                    for(let d = 0; d < 8; ++d)l[0] = i * e1[16 + d], l[1] = s * e1[16 + d], l[2] = i * e1[48 + d], l[3] = s * e1[48 + d], c[0] = n * e1[8 + d] + r * e1[24 + d] + a * e1[40 + d] + o * e1[56 + d], c[1] = r * e1[8 + d] - o * e1[24 + d] - n * e1[40 + d] - a * e1[56 + d], c[2] = a * e1[8 + d] - n * e1[24 + d] + o * e1[40 + d] + r * e1[56 + d], c[3] = o * e1[8 + d] - a * e1[24 + d] + r * e1[40 + d] - n * e1[56 + d], u[0] = t * (e1[d] + e1[32 + d]), u[3] = t * (e1[d] - e1[32 + d]), u[1] = l[0] + l[3], u[2] = l[1] - l[2], h[0] = u[0] + u[1], h[1] = u[3] + u[2], h[2] = u[3] - u[2], h[3] = u[0] - u[1], e1[0 + d] = h[0] + c[0], e1[8 + d] = h[1] + c[1], e1[16 + d] = h[2] + c[2], e1[24 + d] = h[3] + c[3], e1[32 + d] = h[3] - c[3], e1[40 + d] = h[2] - c[2], e1[48 + d] = h[1] - c[1], e1[56 + d] = h[0] - c[0];
                }
                function T(e1) {
                    for(let t = 0; t < 64; ++t){
                        const n = e1[0][t], i = e1[1][t], r = e1[2][t];
                        e1[0][t] = n + 1.5747 * r, e1[1][t] = n - .1873 * i - .4682 * r, e1[2][t] = n + 1.8556 * i;
                    }
                }
                function S(e1, t, n) {
                    for(let a = 0; a < 64; ++a)t[n + a] = ru.toHalfFloat((i = e1[a]) <= 1 ? Math.sign(i) * Math.pow(Math.abs(i), 2.2) : Math.sign(i) * Math.pow(r, Math.abs(i) - 1));
                    var i;
                }
                function I(e1) {
                    return new DataView(e1.array.buffer, e1.offset.value, e1.size);
                }
                function N(e1) {
                    const t = e1.viewer.buffer.slice(e1.offset.value, e1.offset.value + e1.size), n = new Uint8Array(b(t)), i = new Uint8Array(n.length);
                    return x(n), _(n, i), new DataView(i.buffer);
                }
                function D(e1) {
                    const t = ux(e1.array.slice(e1.offset.value, e1.offset.value + e1.size)), n = new Uint8Array(t.length);
                    return x(t), _(t, n), new DataView(n.buffer);
                }
                function C(e1) {
                    const n = e1.viewer, i = {
                        value: e1.offset.value
                    }, r = new Uint16Array(e1.width * e1.scanlineBlockSize * (e1.channels * e1.type)), a = new Uint8Array(8192);
                    let s = 0;
                    const o = new Array(e1.channels);
                    for(let t = 0; t < e1.channels; t++)o[t] = {}, o[t].start = s, o[t].end = o[t].start, o[t].nx = e1.width, o[t].ny = e1.lines, o[t].size = e1.type, s += o[t].nx * o[t].ny * o[t].size;
                    const l = V(n, i), c = V(n, i);
                    if (c >= 8192) throw new Error("Something is wrong with PIZ_COMPRESSION BITMAP_SIZE");
                    if (l <= c) for(let e1 = 0; e1 < c - l + 1; e1++)a[e1 + l] = k(n, i);
                    const u = new Uint16Array(t), h = function(e1, n) {
                        let i = 0;
                        for(let r = 0; r < t; ++r)(0 == r || e1[r >> 3] & 1 << (7 & r)) && (n[i++] = r);
                        const r = i - 1;
                        for(; i < t;)n[i++] = 0;
                        return r;
                    }(a, u), d = P(n, i);
                    y(e1.array, n, i, d, r, s);
                    for(let t = 0; t < e1.channels; ++t){
                        const e1 = o[t];
                        for(let n = 0; n < o[t].size; ++n)M(r, e1.start + n, e1.nx, e1.size, e1.ny, e1.nx * e1.size, h);
                    }
                    !function(e1, t, n) {
                        for(let i = 0; i < n; ++i)t[i] = e1[t[i]];
                    }(u, r, s);
                    let p = 0;
                    const f = new Uint8Array(r.buffer.byteLength);
                    for(let t = 0; t < e1.lines; t++)for(let t = 0; t < e1.channels; t++){
                        const e1 = o[t], n = e1.nx * e1.size, i = new Uint8Array(r.buffer, 2 * e1.end, 2 * n);
                        f.set(i, p), p += 2 * n, e1.end += n;
                    }
                    return new DataView(f.buffer);
                }
                function L(e1) {
                    const t = ux(e1.array.slice(e1.offset.value, e1.offset.value + e1.size)), n = e1.lines * e1.channels * e1.width, i = 1 == e1.type ? new Uint16Array(n) : new Uint32Array(n);
                    let r = 0, a = 0;
                    const s = new Array(4);
                    for(let n = 0; n < e1.lines; n++)for(let n = 0; n < e1.channels; n++){
                        let n = 0;
                        switch(e1.type){
                            case 1:
                                s[0] = r, s[1] = s[0] + e1.width, r = s[1] + e1.width;
                                for(let r = 0; r < e1.width; ++r)n += t[s[0]++] << 8 | t[s[1]++], i[a] = n, a++;
                                break;
                            case 2:
                                s[0] = r, s[1] = s[0] + e1.width, s[2] = s[1] + e1.width, r = s[2] + e1.width;
                                for(let r = 0; r < e1.width; ++r)n += t[s[0]++] << 24 | t[s[1]++] << 16 | t[s[2]++] << 8, i[a] = n, a++;
                        }
                    }
                    return new DataView(i.buffer);
                }
                function R(e1) {
                    const t = e1.viewer, n = {
                        value: e1.offset.value
                    }, i = new Uint8Array(e1.width * e1.lines * (e1.channels * e1.type * 2)), r = {
                        version: j(t, n),
                        unknownUncompressedSize: j(t, n),
                        unknownCompressedSize: j(t, n),
                        acCompressedSize: j(t, n),
                        dcCompressedSize: j(t, n),
                        rleCompressedSize: j(t, n),
                        rleUncompressedSize: j(t, n),
                        rleRawSize: j(t, n),
                        totalAcUncompressedCount: j(t, n),
                        totalDcUncompressedCount: j(t, n),
                        acCompression: j(t, n)
                    };
                    if (r.version < 2) throw new Error("EXRLoader.parse: " + Z.compression + " version " + r.version + " is unsupported");
                    const a = new Array;
                    let s = V(t, n) - 2;
                    for(; s > 0;){
                        const e1 = z(t.buffer, n), i = k(t, n), r = i >> 2 & 3, o = new Int8Array([
                            (i >> 4) - 1
                        ])[0], l = k(t, n);
                        a.push({
                            name: e1,
                            index: o,
                            type: l,
                            compression: r
                        }), s -= e1.length + 3;
                    }
                    const o = Z.channels, l = new Array(e1.channels);
                    for(let t = 0; t < e1.channels; ++t){
                        const n = l[t] = {}, i = o[t];
                        n.name = i.name, n.compression = 0, n.decoded = !1, n.type = i.pixelType, n.pLinear = i.pLinear, n.width = e1.width, n.height = e1.lines;
                    }
                    const c = {
                        idx: new Array(3)
                    };
                    for(let t = 0; t < e1.channels; ++t){
                        const e1 = l[t];
                        for(let n = 0; n < a.length; ++n){
                            const i = a[n];
                            e1.name == i.name && (e1.compression = i.compression, i.index >= 0 && (c.idx[i.index] = t), e1.offset = t);
                        }
                    }
                    let u, h, d;
                    if (r.acCompressedSize > 0) switch(r.acCompression){
                        case 0:
                            u = new Uint16Array(r.totalAcUncompressedCount), y(e1.array, t, n, r.acCompressedSize, u, r.totalAcUncompressedCount);
                            break;
                        case 1:
                            const i1 = ux(e1.array.slice(n.value, n.value + r.totalAcUncompressedCount));
                            u = new Uint16Array(i1.buffer), n.value += r.totalAcUncompressedCount;
                    }
                    if (r.dcCompressedSize > 0) {
                        const t = {
                            array: e1.array,
                            offset: n,
                            size: r.dcCompressedSize
                        };
                        h = new Uint16Array(D(t).buffer), n.value += r.dcCompressedSize;
                    }
                    r.rleRawSize > 0 && (d = b(ux(e1.array.slice(n.value, n.value + r.rleCompressedSize)).buffer), n.value += r.rleCompressedSize);
                    let p = 0;
                    const f = new Array(l.length);
                    for(let e1 = 0; e1 < f.length; ++e1)f[e1] = new Array;
                    for(let t = 0; t < e1.lines; ++t)for(let t = 0; t < l.length; ++t)f[t].push(p), p += l[t].width * e1.type * 2;
                    !function(e1, t, n, i, r, a) {
                        let s = new DataView(a.buffer);
                        const o = n[e1.idx[0]].width, l = n[e1.idx[0]].height, c = Math.floor(o / 8), u = Math.ceil(o / 8), h = Math.ceil(l / 8), d = o - 8 * (u - 1), p = l - 8 * (h - 1), f = {
                            value: 0
                        }, m = new Array(3), g = new Array(3), A = new Array(3), v = new Array(3), M = new Array(3);
                        for(let n = 0; n < 3; ++n)M[n] = t[e1.idx[n]], m[n] = n < 1 ? 0 : m[n - 1] + u * h, g[n] = new Float32Array(64), A[n] = new Uint16Array(64), v[n] = new Uint16Array(64 * u);
                        for(let t = 0; t < h; ++t){
                            let a = 8;
                            t == h - 1 && (a = p);
                            let o = 8;
                            for(let e1 = 0; e1 < u; ++e1){
                                e1 == u - 1 && (o = d);
                                for(let e1 = 0; e1 < 3; ++e1)A[e1].fill(0), A[e1][0] = r[m[e1]++], w(f, i, A[e1]), y = A[e1], (x = g[e1])[0] = H(y[0]), x[1] = H(y[1]), x[2] = H(y[5]), x[3] = H(y[6]), x[4] = H(y[14]), x[5] = H(y[15]), x[6] = H(y[27]), x[7] = H(y[28]), x[8] = H(y[2]), x[9] = H(y[4]), x[10] = H(y[7]), x[11] = H(y[13]), x[12] = H(y[16]), x[13] = H(y[26]), x[14] = H(y[29]), x[15] = H(y[42]), x[16] = H(y[3]), x[17] = H(y[8]), x[18] = H(y[12]), x[19] = H(y[17]), x[20] = H(y[25]), x[21] = H(y[30]), x[22] = H(y[41]), x[23] = H(y[43]), x[24] = H(y[9]), x[25] = H(y[11]), x[26] = H(y[18]), x[27] = H(y[24]), x[28] = H(y[31]), x[29] = H(y[40]), x[30] = H(y[44]), x[31] = H(y[53]), x[32] = H(y[10]), x[33] = H(y[19]), x[34] = H(y[23]), x[35] = H(y[32]), x[36] = H(y[39]), x[37] = H(y[45]), x[38] = H(y[52]), x[39] = H(y[54]), x[40] = H(y[20]), x[41] = H(y[22]), x[42] = H(y[33]), x[43] = H(y[38]), x[44] = H(y[46]), x[45] = H(y[51]), x[46] = H(y[55]), x[47] = H(y[60]), x[48] = H(y[21]), x[49] = H(y[34]), x[50] = H(y[37]), x[51] = H(y[47]), x[52] = H(y[50]), x[53] = H(y[56]), x[54] = H(y[59]), x[55] = H(y[61]), x[56] = H(y[35]), x[57] = H(y[36]), x[58] = H(y[48]), x[59] = H(y[49]), x[60] = H(y[57]), x[61] = H(y[58]), x[62] = H(y[62]), x[63] = H(y[63]), E(g[e1]);
                                T(g);
                                for(let t = 0; t < 3; ++t)S(g[t], v[t], 64 * e1);
                            }
                            let l = 0;
                            for(let i = 0; i < 3; ++i){
                                const r = n[e1.idx[i]].type;
                                for(let e1 = 8 * t; e1 < 8 * t + a; ++e1){
                                    l = M[i][e1];
                                    for(let t = 0; t < c; ++t){
                                        const n = 64 * t + 8 * (7 & e1);
                                        s.setUint16(l + 0 * r, v[i][n + 0], !0), s.setUint16(l + 2 * r, v[i][n + 1], !0), s.setUint16(l + 4 * r, v[i][n + 2], !0), s.setUint16(l + 6 * r, v[i][n + 3], !0), s.setUint16(l + 8 * r, v[i][n + 4], !0), s.setUint16(l + 10 * r, v[i][n + 5], !0), s.setUint16(l + 12 * r, v[i][n + 6], !0), s.setUint16(l + 14 * r, v[i][n + 7], !0), l += 16 * r;
                                    }
                                }
                                if (c != u) for(let e1 = 8 * t; e1 < 8 * t + a; ++e1){
                                    const t = M[i][e1] + 8 * c * 2 * r, n = 64 * c + 8 * (7 & e1);
                                    for(let e1 = 0; e1 < o; ++e1)s.setUint16(t + 2 * e1 * r, v[i][n + e1], !0);
                                }
                            }
                        }
                        var y, x;
                        const _ = new Uint16Array(o);
                        s = new DataView(a.buffer);
                        for(let t = 0; t < 3; ++t){
                            n[e1.idx[t]].decoded = !0;
                            const i = n[e1.idx[t]].type;
                            if (2 == n[t].type) for(let e1 = 0; e1 < l; ++e1){
                                const n = M[t][e1];
                                for(let e1 = 0; e1 < o; ++e1)_[e1] = s.getUint16(n + 2 * e1 * i, !0);
                                for(let e1 = 0; e1 < o; ++e1)s.setFloat32(n + 2 * e1 * i, H(_[e1]), !0);
                            }
                        }
                    }(c, f, l, u, h, i);
                    for(let t = 0; t < l.length; ++t){
                        const n = l[t];
                        if (!n.decoded) {
                            if (2 !== n.compression) throw new Error("EXRLoader.parse: unsupported channel compression");
                            {
                                let r = 0, a = 0;
                                for(let s = 0; s < e1.lines; ++s){
                                    let e1 = f[t][r];
                                    for(let t = 0; t < n.width; ++t){
                                        for(let t = 0; t < 2 * n.type; ++t)i[e1++] = d[a + t * n.width * n.height];
                                        a++;
                                    }
                                    r++;
                                }
                            }
                        }
                    }
                    return new DataView(i.buffer);
                }
                function z(e1, t) {
                    const n = new Uint8Array(e1);
                    let i = 0;
                    for(; 0 != n[t.value + i];)i += 1;
                    const r = (new TextDecoder).decode(n.slice(t.value, t.value + i));
                    return t.value = t.value + i + 1, r;
                }
                function O(e1, t) {
                    const n = e1.getInt32(t.value, !0);
                    return t.value = t.value + 4, n;
                }
                function P(e1, t) {
                    const n = e1.getUint32(t.value, !0);
                    return t.value = t.value + 4, n;
                }
                function U(e1, t) {
                    const n = e1[t.value];
                    return t.value = t.value + 1, n;
                }
                function k(e1, t) {
                    const n = e1.getUint8(t.value);
                    return t.value = t.value + 1, n;
                }
                const j = function(e1, t) {
                    let n;
                    return n = "getBigInt64" in DataView.prototype ? Number(e1.getBigInt64(t.value, !0)) : e1.getUint32(t.value + 4, !0) + Number(e1.getUint32(t.value, !0) << 32), t.value += 8, n;
                };
                function B(e1, t) {
                    const n = e1.getFloat32(t.value, !0);
                    return t.value += 4, n;
                }
                function F(e1, t) {
                    return ru.toHalfFloat(B(e1, t));
                }
                function H(e1) {
                    const t = (31744 & e1) >> 10, n = 1023 & e1;
                    return (e1 >> 15 ? -1 : 1) * (t ? 31 === t ? n ? NaN : 1 / 0 : Math.pow(2, t - 15) * (1 + n / 1024) : n / 1024 * 6103515625e-14);
                }
                function V(e1, t) {
                    const n = e1.getUint16(t.value, !0);
                    return t.value += 2, n;
                }
                function G(e1, t) {
                    return H(V(e1, t));
                }
                function Q(e1, t, n, i, r) {
                    return "string" === i || "stringvector" === i || "iccProfile" === i ? function(e1, t, n) {
                        const i = (new TextDecoder).decode(new Uint8Array(e1).slice(t.value, t.value + n));
                        return t.value = t.value + n, i;
                    }(t, n, r) : "chlist" === i ? function(e1, t, n, i) {
                        const r = n.value, a = [];
                        for(; n.value < r + i - 1;){
                            const i = z(t, n), r = O(e1, n), s = k(e1, n);
                            n.value += 3;
                            const o = O(e1, n), l = O(e1, n);
                            a.push({
                                name: i,
                                pixelType: r,
                                pLinear: s,
                                xSampling: o,
                                ySampling: l
                            });
                        }
                        return n.value += 1, a;
                    }(e1, t, n, r) : "chromaticities" === i ? function(e1, t) {
                        return {
                            redX: B(e1, t),
                            redY: B(e1, t),
                            greenX: B(e1, t),
                            greenY: B(e1, t),
                            blueX: B(e1, t),
                            blueY: B(e1, t),
                            whiteX: B(e1, t),
                            whiteY: B(e1, t)
                        };
                    }(e1, n) : "compression" === i ? function(e1, t) {
                        return [
                            "NO_COMPRESSION",
                            "RLE_COMPRESSION",
                            "ZIPS_COMPRESSION",
                            "ZIP_COMPRESSION",
                            "PIZ_COMPRESSION",
                            "PXR24_COMPRESSION",
                            "B44_COMPRESSION",
                            "B44A_COMPRESSION",
                            "DWAA_COMPRESSION",
                            "DWAB_COMPRESSION"
                        ][k(e1, t)];
                    }(e1, n) : "box2i" === i ? function(e1, t) {
                        return {
                            xMin: P(e1, t),
                            yMin: P(e1, t),
                            xMax: P(e1, t),
                            yMax: P(e1, t)
                        };
                    }(e1, n) : "lineOrder" === i ? function(e1, t) {
                        return [
                            "INCREASING_Y"
                        ][k(e1, t)];
                    }(e1, n) : "float" === i ? B(e1, n) : "v2f" === i ? function(e1, t) {
                        return [
                            B(e1, t),
                            B(e1, t)
                        ];
                    }(e1, n) : "v3f" === i ? function(e1, t) {
                        return [
                            B(e1, t),
                            B(e1, t),
                            B(e1, t)
                        ];
                    }(e1, n) : "int" === i ? O(e1, n) : "rational" === i ? function(e1, t) {
                        return [
                            O(e1, t),
                            P(e1, t)
                        ];
                    }(e1, n) : "timecode" === i ? function(e1, t) {
                        return [
                            P(e1, t),
                            P(e1, t)
                        ];
                    }(e1, n) : "preview" === i ? (n.value += r, "skipped") : void (n.value += r);
                }
                const W = new DataView(e1), Y = new Uint8Array(e1), X = {
                    value: 0
                }, Z = function(e1, t, n) {
                    const i = {};
                    if (20000630 != e1.getUint32(0, !0)) throw new Error("THREE.EXRLoader: Provided file doesn't appear to be in OpenEXR format.");
                    i.version = e1.getUint8(4);
                    const r = e1.getUint8(5);
                    i.spec = {
                        singleTile: !!(2 & r),
                        longName: !!(4 & r),
                        deepFormat: !!(8 & r),
                        multiPart: !!(16 & r)
                    }, n.value = 8;
                    let a = !0;
                    for(; a;){
                        const r = z(t, n);
                        if (0 == r) a = !1;
                        else {
                            const a = z(t, n), s = Q(e1, t, n, a, P(e1, n));
                            void 0 === s ? console.warn("THREE.EXRLoader: Skipped unknown header attribute type '".concat(a, "'.")) : i[r] = s;
                        }
                    }
                    if (-5 & r) throw console.error("THREE.EXRHeader:", i), new Error("THREE.EXRLoader: Provided file is currently unsupported.");
                    return i;
                }(W, e1, X), q = function(e1, t, n, i, r) {
                    const a = {
                        size: 0,
                        viewer: t,
                        array: n,
                        offset: i,
                        width: e1.dataWindow.xMax - e1.dataWindow.xMin + 1,
                        height: e1.dataWindow.yMax - e1.dataWindow.yMin + 1,
                        channels: e1.channels.length,
                        bytesPerLine: null,
                        lines: null,
                        inputSize: null,
                        type: e1.channels[0].pixelType,
                        uncompress: null,
                        getter: null,
                        format: null,
                        colorSpace: Qs
                    };
                    switch(e1.compression){
                        case "NO_COMPRESSION":
                            a.lines = 1, a.uncompress = I;
                            break;
                        case "RLE_COMPRESSION":
                            a.lines = 1, a.uncompress = N;
                            break;
                        case "ZIPS_COMPRESSION":
                            a.lines = 1, a.uncompress = D;
                            break;
                        case "ZIP_COMPRESSION":
                            a.lines = 16, a.uncompress = D;
                            break;
                        case "PIZ_COMPRESSION":
                            a.lines = 32, a.uncompress = C;
                            break;
                        case "PXR24_COMPRESSION":
                            a.lines = 16, a.uncompress = L;
                            break;
                        case "DWAA_COMPRESSION":
                            a.lines = 32, a.uncompress = R;
                            break;
                        case "DWAB_COMPRESSION":
                            a.lines = 256, a.uncompress = R;
                            break;
                        default:
                            throw new Error("EXRLoader.parse: " + e1.compression + " is unsupported");
                    }
                    if (a.scanlineBlockSize = a.lines, 1 == a.type) switch(r){
                        case Na:
                            a.getter = G, a.inputSize = 2;
                            break;
                        case Da:
                            a.getter = V, a.inputSize = 2;
                    }
                    else {
                        if (2 != a.type) throw new Error("EXRLoader.parse: unsupported pixelType " + a.type + " for " + e1.compression + ".");
                        switch(r){
                            case Na:
                                a.getter = B, a.inputSize = 4;
                                break;
                            case Da:
                                a.getter = F, a.inputSize = 4;
                        }
                    }
                    a.blockCount = (e1.dataWindow.yMax + 1) / a.scanlineBlockSize;
                    for(let e1 = 0; e1 < a.blockCount; e1++)j(t, i);
                    a.outputChannels = 3 == a.channels ? 4 : a.channels;
                    const s = a.width * a.height * a.outputChannels;
                    switch(r){
                        case Na:
                            a.byteArray = new Float32Array(s), a.channels < a.outputChannels && a.byteArray.fill(1, 0, s);
                            break;
                        case Da:
                            a.byteArray = new Uint16Array(s), a.channels < a.outputChannels && a.byteArray.fill(15360, 0, s);
                            break;
                        default:
                            console.error("THREE.EXRLoader: unsupported type: ", r);
                    }
                    return a.bytesPerLine = a.width * a.inputSize * a.channels, 4 == a.outputChannels ? (a.format = Oa, a.colorSpace = Qs) : (a.format = Ba, a.colorSpace = Vs), a;
                }(Z, W, Y, X, this.type), K = {
                    value: 0
                }, J = {
                    R: 0,
                    G: 1,
                    B: 2,
                    A: 3,
                    Y: 0
                };
                for(let e1 = 0; e1 < q.height / q.scanlineBlockSize; e1++){
                    const t = P(W, X);
                    q.size = P(W, X), q.lines = t + q.scanlineBlockSize > q.height ? q.height - t : q.scanlineBlockSize;
                    const n = q.size < q.lines * q.bytesPerLine ? q.uncompress(q) : I(q);
                    X.value += q.size;
                    for(let t = 0; t < q.scanlineBlockSize; t++){
                        const i = t + e1 * q.scanlineBlockSize;
                        if (i >= q.height) break;
                        for(let e1 = 0; e1 < q.channels; e1++){
                            const r = J[Z.channels[e1].name];
                            for(let a = 0; a < q.width; a++){
                                K.value = (t * (q.channels * q.width) + e1 * q.width + a) * q.inputSize;
                                const s = (q.height - 1 - i) * (q.width * q.outputChannels) + a * q.outputChannels + r;
                                q.byteArray[s] = q.getter(n, K);
                            }
                        }
                    }
                }
                return {
                    header: Z,
                    width: q.width,
                    height: q.height,
                    data: q.byteArray,
                    format: q.format,
                    colorSpace: q.colorSpace,
                    type: this.type
                };
            }
            setDataType(e1) {
                return this.type = e1, this;
            }
            load(e1, t, n, i) {
                return super.load(e1, function(e1, n) {
                    e1.colorSpace = n.colorSpace, e1.minFilter = va, e1.magFilter = va, e1.generateMipmaps = !1, e1.flipY = !1, t && t(e1, n);
                }, n, i);
            }
        }
        class px {
            static async get(e1) {
                var t;
                const n = await fx.call(px), i = await n.match(e1);
                if (!i) return;
                const { headers: r } = i, a = r.get("expires"), s = null !== (t = r.get("date")) && void 0 !== t ? t : "", o = a && "-1" !== a ? Date.parse(a) : Date.parse(s) + 18e5;
                if (!(Date.now() >= o)) return i;
                await px.delete(e1);
            }
            static async put(e1, t) {
                const n = await fx.call(px), i = t.clone(), r = new Headers([
                    ...i.headers.entries()
                ]);
                r.set("date", (new Date).toUTCString());
                const { body: a, ...s } = i;
                return n.put(e1, new Response(a, {
                    ...s,
                    headers: r
                }));
            }
            static async delete(e1) {
                return (await fx.call(px)).delete(e1);
            }
        }
        async function fx() {
            return caches.open("cache");
        }
        var mx = n(512), gx = n.n(mx);
        function Ax() {
            return gx()('/*! For license information please see widget.module.worker.js.LICENSE.txt */\n(()=>{"use strict";const e="158",t=1,n=2,i=3,r=0,a=1,s=2,o=100,l=101,c=102,h=200,u=201,d=202,p=203,f=204,m=205,g=206,_=207,v=208,x=209,M=210,S=211,y=212,E=213,T=214,b=0,w=1,A=2,R=0,C=1,L=2,P=3,U=4,D=5,N=301,I=302,O=306,F=1e3,z=1001,B=1002,H=1003,V=1004,G=1005,k=1006,W=1007,X=1008,j=1009,q=1012,Y=1014,K=1015,Z=1016,J=1020,Q=1023,$=1026,ee=1027,te=33776,ne=33777,ie=33778,re=33779,ae=36492,se=2300,oe=2301,le=2302,ce=3001,he="",ue="srgb",de="srgb-linear",pe="display-p3",fe="display-p3-linear",me="linear",ge="srgb",_e="rec709",ve="p3",xe=7680,Me=512,Se=513,ye=514,Ee=515,Te=516,be=517,we=518,Ae=519,Re="300 es",Ce=1035,Le=2e3,Pe=2001;class Ue{addEventListener(e,t){void 0===this._listeners&&(this._listeners={});const n=this._listeners;void 0===n[e]&&(n[e]=[]),-1===n[e].indexOf(t)&&n[e].push(t)}hasEventListener(e,t){if(void 0===this._listeners)return!1;const n=this._listeners;return void 0!==n[e]&&-1!==n[e].indexOf(t)}removeEventListener(e,t){if(void 0===this._listeners)return;const n=this._listeners[e];if(void 0!==n){const e=n.indexOf(t);-1!==e&&n.splice(e,1)}}dispatchEvent(e){if(void 0===this._listeners)return;const t=this._listeners[e.type];if(void 0!==t){e.target=this;const n=t.slice(0);for(let t=0,i=n.length;t<i;t++)n[t].call(this,e);e.target=null}}}const De=["00","01","02","03","04","05","06","07","08","09","0a","0b","0c","0d","0e","0f","10","11","12","13","14","15","16","17","18","19","1a","1b","1c","1d","1e","1f","20","21","22","23","24","25","26","27","28","29","2a","2b","2c","2d","2e","2f","30","31","32","33","34","35","36","37","38","39","3a","3b","3c","3d","3e","3f","40","41","42","43","44","45","46","47","48","49","4a","4b","4c","4d","4e","4f","50","51","52","53","54","55","56","57","58","59","5a","5b","5c","5d","5e","5f","60","61","62","63","64","65","66","67","68","69","6a","6b","6c","6d","6e","6f","70","71","72","73","74","75","76","77","78","79","7a","7b","7c","7d","7e","7f","80","81","82","83","84","85","86","87","88","89","8a","8b","8c","8d","8e","8f","90","91","92","93","94","95","96","97","98","99","9a","9b","9c","9d","9e","9f","a0","a1","a2","a3","a4","a5","a6","a7","a8","a9","aa","ab","ac","ad","ae","af","b0","b1","b2","b3","b4","b5","b6","b7","b8","b9","ba","bb","bc","bd","be","bf","c0","c1","c2","c3","c4","c5","c6","c7","c8","c9","ca","cb","cc","cd","ce","cf","d0","d1","d2","d3","d4","d5","d6","d7","d8","d9","da","db","dc","dd","de","df","e0","e1","e2","e3","e4","e5","e6","e7","e8","e9","ea","eb","ec","ed","ee","ef","f0","f1","f2","f3","f4","f5","f6","f7","f8","f9","fa","fb","fc","fd","fe","ff"],Ne=Math.PI/180,Ie=180/Math.PI;function Oe(){const e=4294967295*Math.random()|0,t=4294967295*Math.random()|0,n=4294967295*Math.random()|0,i=4294967295*Math.random()|0;return(De[255&e]+De[e>>8&255]+De[e>>16&255]+De[e>>24&255]+"-"+De[255&t]+De[t>>8&255]+"-"+De[t>>16&15|64]+De[t>>24&255]+"-"+De[63&n|128]+De[n>>8&255]+"-"+De[n>>16&255]+De[n>>24&255]+De[255&i]+De[i>>8&255]+De[i>>16&255]+De[i>>24&255]).toLowerCase()}function Fe(e,t,n){return Math.max(t,Math.min(n,e))}function ze(e,t,n){return(1-n)*e+n*t}function Be(e){return!(e&e-1)&&0!==e}function He(e){return Math.pow(2,Math.floor(Math.log(e)/Math.LN2))}function Ve(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return e/4294967295;case Uint16Array:return e/65535;case Uint8Array:return e/255;case Int32Array:return Math.max(e/2147483647,-1);case Int16Array:return Math.max(e/32767,-1);case Int8Array:return Math.max(e/127,-1);default:throw new Error("Invalid component type.")}}function Ge(e,t){switch(t.constructor){case Float32Array:return e;case Uint32Array:return Math.round(4294967295*e);case Uint16Array:return Math.round(65535*e);case Uint8Array:return Math.round(255*e);case Int32Array:return Math.round(2147483647*e);case Int16Array:return Math.round(32767*e);case Int8Array:return Math.round(127*e);default:throw new Error("Invalid component type.")}}class ke{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;ke.prototype.isVector2=!0,this.x=e,this.y=t}get width(){return this.x}set width(e){this.x=e}get height(){return this.y}set height(e){this.y=e}set(e,t){return this.x=e,this.y=t,this}setScalar(e){return this.x=e,this.y=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;default:throw new Error("index is out of range: "+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;default:throw new Error("index is out of range: "+e)}}clone(){return new this.constructor(this.x,this.y)}copy(e){return this.x=e.x,this.y=e.y,this}add(e){return this.x+=e.x,this.y+=e.y,this}addScalar(e){return this.x+=e,this.y+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this}subScalar(e){return this.x-=e,this.y-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this}multiply(e){return this.x*=e.x,this.y*=e.y,this}multiplyScalar(e){return this.x*=e,this.y*=e,this}divide(e){return this.x/=e.x,this.y/=e.y,this}divideScalar(e){return this.multiplyScalar(1/e)}applyMatrix3(e){const t=this.x,n=this.y,i=e.elements;return this.x=i[0]*t+i[3]*n+i[6],this.y=i[1]*t+i[4]*n+i[7],this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this}clamp(e,t){return this.x=Math.max(e.x,Math.min(t.x,this.x)),this.y=Math.max(e.y,Math.min(t.y,this.y)),this}clampScalar(e,t){return this.x=Math.max(e,Math.min(t,this.x)),this.y=Math.max(e,Math.min(t,this.y)),this}clampLength(e,t){const n=this.length();return this.divideScalar(n||1).multiplyScalar(Math.max(e,Math.min(t,n)))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this}negate(){return this.x=-this.x,this.y=-this.y,this}dot(e){return this.x*e.x+this.y*e.y}cross(e){return this.x*e.y-this.y*e.x}lengthSq(){return this.x*this.x+this.y*this.y}length(){return Math.sqrt(this.x*this.x+this.y*this.y)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)}normalize(){return this.divideScalar(this.length()||1)}angle(){return Math.atan2(-this.y,-this.x)+Math.PI}angleTo(e){const t=Math.sqrt(this.lengthSq()*e.lengthSq());if(0===t)return Math.PI/2;const n=this.dot(e)/t;return Math.acos(Fe(n,-1,1))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){const t=this.x-e.x,n=this.y-e.y;return t*t+n*n}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this}equals(e){return e.x===this.x&&e.y===this.y}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this.x=e[t],this.y=e[t+1],this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e[t]=this.x,e[t+1]=this.y,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this}rotateAround(e,t){const n=Math.cos(t),i=Math.sin(t),r=this.x-e.x,a=this.y-e.y;return this.x=r*n-a*i+e.x,this.y=r*i+a*n+e.y,this}random(){return this.x=Math.random(),this.y=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y}}class We{constructor(e,t,n,i,r,a,s,o,l){We.prototype.isMatrix3=!0,this.elements=[1,0,0,0,1,0,0,0,1],void 0!==e&&this.set(e,t,n,i,r,a,s,o,l)}set(e,t,n,i,r,a,s,o,l){const c=this.elements;return c[0]=e,c[1]=i,c[2]=s,c[3]=t,c[4]=r,c[5]=o,c[6]=n,c[7]=a,c[8]=l,this}identity(){return this.set(1,0,0,0,1,0,0,0,1),this}copy(e){const t=this.elements,n=e.elements;return t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[4]=n[4],t[5]=n[5],t[6]=n[6],t[7]=n[7],t[8]=n[8],this}extractBasis(e,t,n){return e.setFromMatrix3Column(this,0),t.setFromMatrix3Column(this,1),n.setFromMatrix3Column(this,2),this}setFromMatrix4(e){const t=e.elements;return this.set(t[0],t[4],t[8],t[1],t[5],t[9],t[2],t[6],t[10]),this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){const n=e.elements,i=t.elements,r=this.elements,a=n[0],s=n[3],o=n[6],l=n[1],c=n[4],h=n[7],u=n[2],d=n[5],p=n[8],f=i[0],m=i[3],g=i[6],_=i[1],v=i[4],x=i[7],M=i[2],S=i[5],y=i[8];return r[0]=a*f+s*_+o*M,r[3]=a*m+s*v+o*S,r[6]=a*g+s*x+o*y,r[1]=l*f+c*_+h*M,r[4]=l*m+c*v+h*S,r[7]=l*g+c*x+h*y,r[2]=u*f+d*_+p*M,r[5]=u*m+d*v+p*S,r[8]=u*g+d*x+p*y,this}multiplyScalar(e){const t=this.elements;return t[0]*=e,t[3]*=e,t[6]*=e,t[1]*=e,t[4]*=e,t[7]*=e,t[2]*=e,t[5]*=e,t[8]*=e,this}determinant(){const e=this.elements,t=e[0],n=e[1],i=e[2],r=e[3],a=e[4],s=e[5],o=e[6],l=e[7],c=e[8];return t*a*c-t*s*l-n*r*c+n*s*o+i*r*l-i*a*o}invert(){const e=this.elements,t=e[0],n=e[1],i=e[2],r=e[3],a=e[4],s=e[5],o=e[6],l=e[7],c=e[8],h=c*a-s*l,u=s*o-c*r,d=l*r-a*o,p=t*h+n*u+i*d;if(0===p)return this.set(0,0,0,0,0,0,0,0,0);const f=1/p;return e[0]=h*f,e[1]=(i*l-c*n)*f,e[2]=(s*n-i*a)*f,e[3]=u*f,e[4]=(c*t-i*o)*f,e[5]=(i*r-s*t)*f,e[6]=d*f,e[7]=(n*o-l*t)*f,e[8]=(a*t-n*r)*f,this}transpose(){let e;const t=this.elements;return e=t[1],t[1]=t[3],t[3]=e,e=t[2],t[2]=t[6],t[6]=e,e=t[5],t[5]=t[7],t[7]=e,this}getNormalMatrix(e){return this.setFromMatrix4(e).invert().transpose()}transposeIntoArray(e){const t=this.elements;return e[0]=t[0],e[1]=t[3],e[2]=t[6],e[3]=t[1],e[4]=t[4],e[5]=t[7],e[6]=t[2],e[7]=t[5],e[8]=t[8],this}setUvTransform(e,t,n,i,r,a,s){const o=Math.cos(r),l=Math.sin(r);return this.set(n*o,n*l,-n*(o*a+l*s)+a+e,-i*l,i*o,-i*(-l*a+o*s)+s+t,0,0,1),this}scale(e,t){return this.premultiply(Xe.makeScale(e,t)),this}rotate(e){return this.premultiply(Xe.makeRotation(-e)),this}translate(e,t){return this.premultiply(Xe.makeTranslation(e,t)),this}makeTranslation(e,t){return e.isVector2?this.set(1,0,e.x,0,1,e.y,0,0,1):this.set(1,0,e,0,1,t,0,0,1),this}makeRotation(e){const t=Math.cos(e),n=Math.sin(e);return this.set(t,-n,0,n,t,0,0,0,1),this}makeScale(e,t){return this.set(e,0,0,0,t,0,0,0,1),this}equals(e){const t=this.elements,n=e.elements;for(let e=0;e<9;e++)if(t[e]!==n[e])return!1;return!0}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;for(let n=0;n<9;n++)this.elements[n]=e[n+t];return this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;const n=this.elements;return e[t]=n[0],e[t+1]=n[1],e[t+2]=n[2],e[t+3]=n[3],e[t+4]=n[4],e[t+5]=n[5],e[t+6]=n[6],e[t+7]=n[7],e[t+8]=n[8],e}clone(){return(new this.constructor).fromArray(this.elements)}}const Xe=new We;function je(e){for(let t=e.length-1;t>=0;--t)if(e[t]>=65535)return!0;return!1}function qe(e){return document.createElementNS("http://www.w3.org/1999/xhtml",e)}function Ye(){const e=qe("canvas");return e.style.display="block",e}Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array;const Ke={};function Ze(e){e in Ke||(Ke[e]=!0,console.warn(e))}const Je=(new We).set(.8224621,.177538,0,.0331941,.9668058,0,.0170827,.0723974,.9105199),Qe=(new We).set(1.2249401,-.2249404,0,-.0420569,1.0420571,0,-.0196376,-.0786361,1.0982735),$e={[de]:{transfer:me,primaries:_e,toReference:e=>e,fromReference:e=>e},[ue]:{transfer:ge,primaries:_e,toReference:e=>e.convertSRGBToLinear(),fromReference:e=>e.convertLinearToSRGB()},[fe]:{transfer:me,primaries:ve,toReference:e=>e.applyMatrix3(Qe),fromReference:e=>e.applyMatrix3(Je)},[pe]:{transfer:ge,primaries:ve,toReference:e=>e.convertSRGBToLinear().applyMatrix3(Qe),fromReference:e=>e.applyMatrix3(Je).convertLinearToSRGB()}},et=new Set([de,fe]),tt={enabled:!0,_workingColorSpace:de,get legacyMode(){return console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."),!this.enabled},set legacyMode(e){console.warn("THREE.ColorManagement: .legacyMode=false renamed to .enabled=true in r150."),this.enabled=!e},get workingColorSpace(){return this._workingColorSpace},set workingColorSpace(e){if(!et.has(e))throw new Error(\'Unsupported working color space, "\'.concat(e,\'".\'));this._workingColorSpace=e},convert:function(e,t,n){if(!1===this.enabled||t===n||!t||!n)return e;const i=$e[t].toReference;return(0,$e[n].fromReference)(i(e))},fromWorkingColorSpace:function(e,t){return this.convert(e,this._workingColorSpace,t)},toWorkingColorSpace:function(e,t){return this.convert(e,t,this._workingColorSpace)},getPrimaries:function(e){return $e[e].primaries},getTransfer:function(e){return e===he?me:$e[e].transfer}};function nt(e){return e<.04045?.0773993808*e:Math.pow(.9478672986*e+.0521327014,2.4)}function it(e){return e<.0031308?12.92*e:1.055*Math.pow(e,.41666)-.055}let rt;class at{static getDataURL(e){if(/^data:/i.test(e.src))return e.src;if("undefined"==typeof HTMLCanvasElement)return e.src;let t;if(e instanceof HTMLCanvasElement)t=e;else{void 0===rt&&(rt=qe("canvas")),rt.width=e.width,rt.height=e.height;const n=rt.getContext("2d");e instanceof ImageData?n.putImageData(e,0,0):n.drawImage(e,0,0,e.width,e.height),t=rt}return t.width>2048||t.height>2048?(console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons",e),t.toDataURL("image/jpeg",.6)):t.toDataURL("image/png")}static sRGBToLinear(e){if("undefined"!=typeof HTMLImageElement&&e instanceof HTMLImageElement||"undefined"!=typeof HTMLCanvasElement&&e instanceof HTMLCanvasElement||"undefined"!=typeof ImageBitmap&&e instanceof ImageBitmap){const t=qe("canvas");t.width=e.width,t.height=e.height;const n=t.getContext("2d");n.drawImage(e,0,0,e.width,e.height);const i=n.getImageData(0,0,e.width,e.height),r=i.data;for(let e=0;e<r.length;e++)r[e]=255*nt(r[e]/255);return n.putImageData(i,0,0),t}if(e.data){const t=e.data.slice(0);for(let e=0;e<t.length;e++)t instanceof Uint8Array||t instanceof Uint8ClampedArray?t[e]=Math.floor(255*nt(t[e]/255)):t[e]=nt(t[e]);return{data:t,width:e.width,height:e.height}}return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."),e}}let st=0;class ot{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;this.isSource=!0,Object.defineProperty(this,"id",{value:st++}),this.uuid=Oe(),this.data=e,this.version=0}set needsUpdate(e){!0===e&&this.version++}toJSON(e){const t=void 0===e||"string"==typeof e;if(!t&&void 0!==e.images[this.uuid])return e.images[this.uuid];const n={uuid:this.uuid,url:""},i=this.data;if(null!==i){let e;if(Array.isArray(i)){e=[];for(let t=0,n=i.length;t<n;t++)i[t].isDataTexture?e.push(lt(i[t].image)):e.push(lt(i[t]))}else e=lt(i);n.url=e}return t||(e.images[this.uuid]=n),n}}function lt(e){return"undefined"!=typeof HTMLImageElement&&e instanceof HTMLImageElement||"undefined"!=typeof HTMLCanvasElement&&e instanceof HTMLCanvasElement||"undefined"!=typeof ImageBitmap&&e instanceof ImageBitmap?at.getDataURL(e):e.data?{data:Array.from(e.data),width:e.width,height:e.height,type:e.data.constructor.name}:(console.warn("THREE.Texture: Unable to serialize Texture."),{})}let ct=0;class ht extends Ue{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:ht.DEFAULT_IMAGE,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:ht.DEFAULT_MAPPING,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:z,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:z,r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:k,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:X,s=arguments.length>6&&void 0!==arguments[6]?arguments[6]:Q,o=arguments.length>7&&void 0!==arguments[7]?arguments[7]:j,l=arguments.length>8&&void 0!==arguments[8]?arguments[8]:ht.DEFAULT_ANISOTROPY,c=arguments.length>9&&void 0!==arguments[9]?arguments[9]:he;super(),this.isTexture=!0,Object.defineProperty(this,"id",{value:ct++}),this.uuid=Oe(),this.name="",this.source=new ot(e),this.mipmaps=[],this.mapping=t,this.channel=0,this.wrapS=n,this.wrapT=i,this.magFilter=r,this.minFilter=a,this.anisotropy=l,this.format=s,this.internalFormat=null,this.type=o,this.offset=new ke(0,0),this.repeat=new ke(1,1),this.center=new ke(0,0),this.rotation=0,this.matrixAutoUpdate=!0,this.matrix=new We,this.generateMipmaps=!0,this.premultiplyAlpha=!1,this.flipY=!0,this.unpackAlignment=4,"string"==typeof c?this.colorSpace=c:(Ze("THREE.Texture: Property .encoding has been replaced by .colorSpace."),this.colorSpace=c===ce?ue:he),this.userData={},this.version=0,this.onUpdate=null,this.isRenderTargetTexture=!1,this.needsPMREMUpdate=!1}get image(){return this.source.data}set image(e){void 0===e&&(e=null),this.source.data=e}updateMatrix(){this.matrix.setUvTransform(this.offset.x,this.offset.y,this.repeat.x,this.repeat.y,this.rotation,this.center.x,this.center.y)}clone(){return(new this.constructor).copy(this)}copy(e){return this.name=e.name,this.source=e.source,this.mipmaps=e.mipmaps.slice(0),this.mapping=e.mapping,this.channel=e.channel,this.wrapS=e.wrapS,this.wrapT=e.wrapT,this.magFilter=e.magFilter,this.minFilter=e.minFilter,this.anisotropy=e.anisotropy,this.format=e.format,this.internalFormat=e.internalFormat,this.type=e.type,this.offset.copy(e.offset),this.repeat.copy(e.repeat),this.center.copy(e.center),this.rotation=e.rotation,this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrix.copy(e.matrix),this.generateMipmaps=e.generateMipmaps,this.premultiplyAlpha=e.premultiplyAlpha,this.flipY=e.flipY,this.unpackAlignment=e.unpackAlignment,this.colorSpace=e.colorSpace,this.userData=JSON.parse(JSON.stringify(e.userData)),this.needsUpdate=!0,this}toJSON(e){const t=void 0===e||"string"==typeof e;if(!t&&void 0!==e.textures[this.uuid])return e.textures[this.uuid];const n={metadata:{version:4.6,type:"Texture",generator:"Texture.toJSON"},uuid:this.uuid,name:this.name,image:this.source.toJSON(e).uuid,mapping:this.mapping,channel:this.channel,repeat:[this.repeat.x,this.repeat.y],offset:[this.offset.x,this.offset.y],center:[this.center.x,this.center.y],rotation:this.rotation,wrap:[this.wrapS,this.wrapT],format:this.format,internalFormat:this.internalFormat,type:this.type,colorSpace:this.colorSpace,minFilter:this.minFilter,magFilter:this.magFilter,anisotropy:this.anisotropy,flipY:this.flipY,generateMipmaps:this.generateMipmaps,premultiplyAlpha:this.premultiplyAlpha,unpackAlignment:this.unpackAlignment};return Object.keys(this.userData).length>0&&(n.userData=this.userData),t||(e.textures[this.uuid]=n),n}dispose(){this.dispatchEvent({type:"dispose"})}transformUv(e){if(300!==this.mapping)return e;if(e.applyMatrix3(this.matrix),e.x<0||e.x>1)switch(this.wrapS){case F:e.x=e.x-Math.floor(e.x);break;case z:e.x=e.x<0?0:1;break;case B:1===Math.abs(Math.floor(e.x)%2)?e.x=Math.ceil(e.x)-e.x:e.x=e.x-Math.floor(e.x)}if(e.y<0||e.y>1)switch(this.wrapT){case F:e.y=e.y-Math.floor(e.y);break;case z:e.y=e.y<0?0:1;break;case B:1===Math.abs(Math.floor(e.y)%2)?e.y=Math.ceil(e.y)-e.y:e.y=e.y-Math.floor(e.y)}return this.flipY&&(e.y=1-e.y),e}set needsUpdate(e){!0===e&&(this.version++,this.source.needsUpdate=!0)}get encoding(){return Ze("THREE.Texture: Property .encoding has been replaced by .colorSpace."),this.colorSpace===ue?ce:3e3}set encoding(e){Ze("THREE.Texture: Property .encoding has been replaced by .colorSpace."),this.colorSpace=e===ce?ue:he}}ht.DEFAULT_IMAGE=null,ht.DEFAULT_MAPPING=300,ht.DEFAULT_ANISOTROPY=1;class ut{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;ut.prototype.isVector4=!0,this.x=e,this.y=t,this.z=n,this.w=i}get width(){return this.z}set width(e){this.z=e}get height(){return this.w}set height(e){this.w=e}set(e,t,n,i){return this.x=e,this.y=t,this.z=n,this.w=i,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this.w=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setW(e){return this.w=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;case 3:this.w=t;break;default:throw new Error("index is out of range: "+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;case 3:return this.w;default:throw new Error("index is out of range: "+e)}}clone(){return new this.constructor(this.x,this.y,this.z,this.w)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this.w=void 0!==e.w?e.w:1,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this.w+=e.w,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this.w+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this.w=e.w+t.w,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this.w+=e.w*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this.w-=e.w,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this.w-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this.w=e.w-t.w,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this.w*=e.w,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this.w*=e,this}applyMatrix4(e){const t=this.x,n=this.y,i=this.z,r=this.w,a=e.elements;return this.x=a[0]*t+a[4]*n+a[8]*i+a[12]*r,this.y=a[1]*t+a[5]*n+a[9]*i+a[13]*r,this.z=a[2]*t+a[6]*n+a[10]*i+a[14]*r,this.w=a[3]*t+a[7]*n+a[11]*i+a[15]*r,this}divideScalar(e){return this.multiplyScalar(1/e)}setAxisAngleFromQuaternion(e){this.w=2*Math.acos(e.w);const t=Math.sqrt(1-e.w*e.w);return t<1e-4?(this.x=1,this.y=0,this.z=0):(this.x=e.x/t,this.y=e.y/t,this.z=e.z/t),this}setAxisAngleFromRotationMatrix(e){let t,n,i,r;const a=.01,s=.1,o=e.elements,l=o[0],c=o[4],h=o[8],u=o[1],d=o[5],p=o[9],f=o[2],m=o[6],g=o[10];if(Math.abs(c-u)<a&&Math.abs(h-f)<a&&Math.abs(p-m)<a){if(Math.abs(c+u)<s&&Math.abs(h+f)<s&&Math.abs(p+m)<s&&Math.abs(l+d+g-3)<s)return this.set(1,0,0,0),this;t=Math.PI;const e=(l+1)/2,o=(d+1)/2,_=(g+1)/2,v=(c+u)/4,x=(h+f)/4,M=(p+m)/4;return e>o&&e>_?e<a?(n=0,i=.707106781,r=.707106781):(n=Math.sqrt(e),i=v/n,r=x/n):o>_?o<a?(n=.707106781,i=0,r=.707106781):(i=Math.sqrt(o),n=v/i,r=M/i):_<a?(n=.707106781,i=.707106781,r=0):(r=Math.sqrt(_),n=x/r,i=M/r),this.set(n,i,r,t),this}let _=Math.sqrt((m-p)*(m-p)+(h-f)*(h-f)+(u-c)*(u-c));return Math.abs(_)<.001&&(_=1),this.x=(m-p)/_,this.y=(h-f)/_,this.z=(u-c)/_,this.w=Math.acos((l+d+g-1)/2),this}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this.w=Math.min(this.w,e.w),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this.w=Math.max(this.w,e.w),this}clamp(e,t){return this.x=Math.max(e.x,Math.min(t.x,this.x)),this.y=Math.max(e.y,Math.min(t.y,this.y)),this.z=Math.max(e.z,Math.min(t.z,this.z)),this.w=Math.max(e.w,Math.min(t.w,this.w)),this}clampScalar(e,t){return this.x=Math.max(e,Math.min(t,this.x)),this.y=Math.max(e,Math.min(t,this.y)),this.z=Math.max(e,Math.min(t,this.z)),this.w=Math.max(e,Math.min(t,this.w)),this}clampLength(e,t){const n=this.length();return this.divideScalar(n||1).multiplyScalar(Math.max(e,Math.min(t,n)))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this.w=Math.floor(this.w),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this.w=Math.ceil(this.w),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this.w=Math.round(this.w),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this.w=Math.trunc(this.w),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this.w=-this.w,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z+this.w*e.w}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)+Math.abs(this.w)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this.w+=(e.w-this.w)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this.z=e.z+(t.z-e.z)*n,this.w=e.w+(t.w-e.w)*n,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z&&e.w===this.w}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this.w=e[t+3],this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e[t+3]=this.w,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this.w=e.getW(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this.w=Math.random(),this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z,yield this.w}}class dt extends Ue{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};super(),this.isRenderTarget=!0,this.width=e,this.height=t,this.depth=1,this.scissor=new ut(0,0,e,t),this.scissorTest=!1,this.viewport=new ut(0,0,e,t);const i={width:e,height:t,depth:1};void 0!==n.encoding&&(Ze("THREE.WebGLRenderTarget: option.encoding has been replaced by option.colorSpace."),n.colorSpace=n.encoding===ce?ue:he),n=Object.assign({generateMipmaps:!1,internalFormat:null,minFilter:k,depthBuffer:!0,stencilBuffer:!1,depthTexture:null,samples:0},n),this.texture=new ht(i,n.mapping,n.wrapS,n.wrapT,n.magFilter,n.minFilter,n.format,n.type,n.anisotropy,n.colorSpace),this.texture.isRenderTargetTexture=!0,this.texture.flipY=!1,this.texture.generateMipmaps=n.generateMipmaps,this.texture.internalFormat=n.internalFormat,this.depthBuffer=n.depthBuffer,this.stencilBuffer=n.stencilBuffer,this.depthTexture=n.depthTexture,this.samples=n.samples}setSize(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;this.width===e&&this.height===t&&this.depth===n||(this.width=e,this.height=t,this.depth=n,this.texture.image.width=e,this.texture.image.height=t,this.texture.image.depth=n,this.dispose()),this.viewport.set(0,0,e,t),this.scissor.set(0,0,e,t)}clone(){return(new this.constructor).copy(this)}copy(e){this.width=e.width,this.height=e.height,this.depth=e.depth,this.scissor.copy(e.scissor),this.scissorTest=e.scissorTest,this.viewport.copy(e.viewport),this.texture=e.texture.clone(),this.texture.isRenderTargetTexture=!0;const t=Object.assign({},e.texture.image);return this.texture.source=new ot(t),this.depthBuffer=e.depthBuffer,this.stencilBuffer=e.stencilBuffer,null!==e.depthTexture&&(this.depthTexture=e.depthTexture.clone()),this.samples=e.samples,this}dispose(){this.dispatchEvent({type:"dispose"})}}class pt extends dt{constructor(){super(arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,arguments.length>2&&void 0!==arguments[2]?arguments[2]:{}),this.isWebGLRenderTarget=!0}}class ft extends ht{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;super(null),this.isDataArrayTexture=!0,this.image={data:e,width:t,height:n,depth:i},this.magFilter=H,this.minFilter=H,this.wrapR=z,this.generateMipmaps=!1,this.flipY=!1,this.unpackAlignment=1}}class mt extends ht{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;super(null),this.isData3DTexture=!0,this.image={data:e,width:t,height:n,depth:i},this.magFilter=H,this.minFilter=H,this.wrapR=z,this.generateMipmaps=!1,this.flipY=!1,this.unpackAlignment=1}}class gt{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;this.isQuaternion=!0,this._x=e,this._y=t,this._z=n,this._w=i}static slerpFlat(e,t,n,i,r,a,s){let o=n[i+0],l=n[i+1],c=n[i+2],h=n[i+3];const u=r[a+0],d=r[a+1],p=r[a+2],f=r[a+3];if(0===s)return e[t+0]=o,e[t+1]=l,e[t+2]=c,void(e[t+3]=h);if(1===s)return e[t+0]=u,e[t+1]=d,e[t+2]=p,void(e[t+3]=f);if(h!==f||o!==u||l!==d||c!==p){let e=1-s;const t=o*u+l*d+c*p+h*f,n=t>=0?1:-1,i=1-t*t;if(i>Number.EPSILON){const r=Math.sqrt(i),a=Math.atan2(r,t*n);e=Math.sin(e*a)/r,s=Math.sin(s*a)/r}const r=s*n;if(o=o*e+u*r,l=l*e+d*r,c=c*e+p*r,h=h*e+f*r,e===1-s){const e=1/Math.sqrt(o*o+l*l+c*c+h*h);o*=e,l*=e,c*=e,h*=e}}e[t]=o,e[t+1]=l,e[t+2]=c,e[t+3]=h}static multiplyQuaternionsFlat(e,t,n,i,r,a){const s=n[i],o=n[i+1],l=n[i+2],c=n[i+3],h=r[a],u=r[a+1],d=r[a+2],p=r[a+3];return e[t]=s*p+c*h+o*d-l*u,e[t+1]=o*p+c*u+l*h-s*d,e[t+2]=l*p+c*d+s*u-o*h,e[t+3]=c*p-s*h-o*u-l*d,e}get x(){return this._x}set x(e){this._x=e,this._onChangeCallback()}get y(){return this._y}set y(e){this._y=e,this._onChangeCallback()}get z(){return this._z}set z(e){this._z=e,this._onChangeCallback()}get w(){return this._w}set w(e){this._w=e,this._onChangeCallback()}set(e,t,n,i){return this._x=e,this._y=t,this._z=n,this._w=i,this._onChangeCallback(),this}clone(){return new this.constructor(this._x,this._y,this._z,this._w)}copy(e){return this._x=e.x,this._y=e.y,this._z=e.z,this._w=e.w,this._onChangeCallback(),this}setFromEuler(e,t){const n=e._x,i=e._y,r=e._z,a=e._order,s=Math.cos,o=Math.sin,l=s(n/2),c=s(i/2),h=s(r/2),u=o(n/2),d=o(i/2),p=o(r/2);switch(a){case"XYZ":this._x=u*c*h+l*d*p,this._y=l*d*h-u*c*p,this._z=l*c*p+u*d*h,this._w=l*c*h-u*d*p;break;case"YXZ":this._x=u*c*h+l*d*p,this._y=l*d*h-u*c*p,this._z=l*c*p-u*d*h,this._w=l*c*h+u*d*p;break;case"ZXY":this._x=u*c*h-l*d*p,this._y=l*d*h+u*c*p,this._z=l*c*p+u*d*h,this._w=l*c*h-u*d*p;break;case"ZYX":this._x=u*c*h-l*d*p,this._y=l*d*h+u*c*p,this._z=l*c*p-u*d*h,this._w=l*c*h+u*d*p;break;case"YZX":this._x=u*c*h+l*d*p,this._y=l*d*h+u*c*p,this._z=l*c*p-u*d*h,this._w=l*c*h-u*d*p;break;case"XZY":this._x=u*c*h-l*d*p,this._y=l*d*h-u*c*p,this._z=l*c*p+u*d*h,this._w=l*c*h+u*d*p;break;default:console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: "+a)}return!1!==t&&this._onChangeCallback(),this}setFromAxisAngle(e,t){const n=t/2,i=Math.sin(n);return this._x=e.x*i,this._y=e.y*i,this._z=e.z*i,this._w=Math.cos(n),this._onChangeCallback(),this}setFromRotationMatrix(e){const t=e.elements,n=t[0],i=t[4],r=t[8],a=t[1],s=t[5],o=t[9],l=t[2],c=t[6],h=t[10],u=n+s+h;if(u>0){const e=.5/Math.sqrt(u+1);this._w=.25/e,this._x=(c-o)*e,this._y=(r-l)*e,this._z=(a-i)*e}else if(n>s&&n>h){const e=2*Math.sqrt(1+n-s-h);this._w=(c-o)/e,this._x=.25*e,this._y=(i+a)/e,this._z=(r+l)/e}else if(s>h){const e=2*Math.sqrt(1+s-n-h);this._w=(r-l)/e,this._x=(i+a)/e,this._y=.25*e,this._z=(o+c)/e}else{const e=2*Math.sqrt(1+h-n-s);this._w=(a-i)/e,this._x=(r+l)/e,this._y=(o+c)/e,this._z=.25*e}return this._onChangeCallback(),this}setFromUnitVectors(e,t){let n=e.dot(t)+1;return n<Number.EPSILON?(n=0,Math.abs(e.x)>Math.abs(e.z)?(this._x=-e.y,this._y=e.x,this._z=0,this._w=n):(this._x=0,this._y=-e.z,this._z=e.y,this._w=n)):(this._x=e.y*t.z-e.z*t.y,this._y=e.z*t.x-e.x*t.z,this._z=e.x*t.y-e.y*t.x,this._w=n),this.normalize()}angleTo(e){return 2*Math.acos(Math.abs(Fe(this.dot(e),-1,1)))}rotateTowards(e,t){const n=this.angleTo(e);if(0===n)return this;const i=Math.min(1,t/n);return this.slerp(e,i),this}identity(){return this.set(0,0,0,1)}invert(){return this.conjugate()}conjugate(){return this._x*=-1,this._y*=-1,this._z*=-1,this._onChangeCallback(),this}dot(e){return this._x*e._x+this._y*e._y+this._z*e._z+this._w*e._w}lengthSq(){return this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w}length(){return Math.sqrt(this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w)}normalize(){let e=this.length();return 0===e?(this._x=0,this._y=0,this._z=0,this._w=1):(e=1/e,this._x=this._x*e,this._y=this._y*e,this._z=this._z*e,this._w=this._w*e),this._onChangeCallback(),this}multiply(e){return this.multiplyQuaternions(this,e)}premultiply(e){return this.multiplyQuaternions(e,this)}multiplyQuaternions(e,t){const n=e._x,i=e._y,r=e._z,a=e._w,s=t._x,o=t._y,l=t._z,c=t._w;return this._x=n*c+a*s+i*l-r*o,this._y=i*c+a*o+r*s-n*l,this._z=r*c+a*l+n*o-i*s,this._w=a*c-n*s-i*o-r*l,this._onChangeCallback(),this}slerp(e,t){if(0===t)return this;if(1===t)return this.copy(e);const n=this._x,i=this._y,r=this._z,a=this._w;let s=a*e._w+n*e._x+i*e._y+r*e._z;if(s<0?(this._w=-e._w,this._x=-e._x,this._y=-e._y,this._z=-e._z,s=-s):this.copy(e),s>=1)return this._w=a,this._x=n,this._y=i,this._z=r,this;const o=1-s*s;if(o<=Number.EPSILON){const e=1-t;return this._w=e*a+t*this._w,this._x=e*n+t*this._x,this._y=e*i+t*this._y,this._z=e*r+t*this._z,this.normalize(),this._onChangeCallback(),this}const l=Math.sqrt(o),c=Math.atan2(l,s),h=Math.sin((1-t)*c)/l,u=Math.sin(t*c)/l;return this._w=a*h+this._w*u,this._x=n*h+this._x*u,this._y=i*h+this._y*u,this._z=r*h+this._z*u,this._onChangeCallback(),this}slerpQuaternions(e,t,n){return this.copy(e).slerp(t,n)}random(){const e=Math.random(),t=Math.sqrt(1-e),n=Math.sqrt(e),i=2*Math.PI*Math.random(),r=2*Math.PI*Math.random();return this.set(t*Math.cos(i),n*Math.sin(r),n*Math.cos(r),t*Math.sin(i))}equals(e){return e._x===this._x&&e._y===this._y&&e._z===this._z&&e._w===this._w}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this._x=e[t],this._y=e[t+1],this._z=e[t+2],this._w=e[t+3],this._onChangeCallback(),this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e[t]=this._x,e[t+1]=this._y,e[t+2]=this._z,e[t+3]=this._w,e}fromBufferAttribute(e,t){return this._x=e.getX(t),this._y=e.getY(t),this._z=e.getZ(t),this._w=e.getW(t),this}toJSON(){return this.toArray()}_onChange(e){return this._onChangeCallback=e,this}_onChangeCallback(){}*[Symbol.iterator](){yield this._x,yield this._y,yield this._z,yield this._w}}class _t{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;_t.prototype.isVector3=!0,this.x=e,this.y=t,this.z=n}set(e,t,n){return void 0===n&&(n=this.z),this.x=e,this.y=t,this.z=n,this}setScalar(e){return this.x=e,this.y=e,this.z=e,this}setX(e){return this.x=e,this}setY(e){return this.y=e,this}setZ(e){return this.z=e,this}setComponent(e,t){switch(e){case 0:this.x=t;break;case 1:this.y=t;break;case 2:this.z=t;break;default:throw new Error("index is out of range: "+e)}return this}getComponent(e){switch(e){case 0:return this.x;case 1:return this.y;case 2:return this.z;default:throw new Error("index is out of range: "+e)}}clone(){return new this.constructor(this.x,this.y,this.z)}copy(e){return this.x=e.x,this.y=e.y,this.z=e.z,this}add(e){return this.x+=e.x,this.y+=e.y,this.z+=e.z,this}addScalar(e){return this.x+=e,this.y+=e,this.z+=e,this}addVectors(e,t){return this.x=e.x+t.x,this.y=e.y+t.y,this.z=e.z+t.z,this}addScaledVector(e,t){return this.x+=e.x*t,this.y+=e.y*t,this.z+=e.z*t,this}sub(e){return this.x-=e.x,this.y-=e.y,this.z-=e.z,this}subScalar(e){return this.x-=e,this.y-=e,this.z-=e,this}subVectors(e,t){return this.x=e.x-t.x,this.y=e.y-t.y,this.z=e.z-t.z,this}multiply(e){return this.x*=e.x,this.y*=e.y,this.z*=e.z,this}multiplyScalar(e){return this.x*=e,this.y*=e,this.z*=e,this}multiplyVectors(e,t){return this.x=e.x*t.x,this.y=e.y*t.y,this.z=e.z*t.z,this}applyEuler(e){return this.applyQuaternion(xt.setFromEuler(e))}applyAxisAngle(e,t){return this.applyQuaternion(xt.setFromAxisAngle(e,t))}applyMatrix3(e){const t=this.x,n=this.y,i=this.z,r=e.elements;return this.x=r[0]*t+r[3]*n+r[6]*i,this.y=r[1]*t+r[4]*n+r[7]*i,this.z=r[2]*t+r[5]*n+r[8]*i,this}applyNormalMatrix(e){return this.applyMatrix3(e).normalize()}applyMatrix4(e){const t=this.x,n=this.y,i=this.z,r=e.elements,a=1/(r[3]*t+r[7]*n+r[11]*i+r[15]);return this.x=(r[0]*t+r[4]*n+r[8]*i+r[12])*a,this.y=(r[1]*t+r[5]*n+r[9]*i+r[13])*a,this.z=(r[2]*t+r[6]*n+r[10]*i+r[14])*a,this}applyQuaternion(e){const t=this.x,n=this.y,i=this.z,r=e.x,a=e.y,s=e.z,o=e.w,l=2*(a*i-s*n),c=2*(s*t-r*i),h=2*(r*n-a*t);return this.x=t+o*l+a*h-s*c,this.y=n+o*c+s*l-r*h,this.z=i+o*h+r*c-a*l,this}project(e){return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix)}unproject(e){return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld)}transformDirection(e){const t=this.x,n=this.y,i=this.z,r=e.elements;return this.x=r[0]*t+r[4]*n+r[8]*i,this.y=r[1]*t+r[5]*n+r[9]*i,this.z=r[2]*t+r[6]*n+r[10]*i,this.normalize()}divide(e){return this.x/=e.x,this.y/=e.y,this.z/=e.z,this}divideScalar(e){return this.multiplyScalar(1/e)}min(e){return this.x=Math.min(this.x,e.x),this.y=Math.min(this.y,e.y),this.z=Math.min(this.z,e.z),this}max(e){return this.x=Math.max(this.x,e.x),this.y=Math.max(this.y,e.y),this.z=Math.max(this.z,e.z),this}clamp(e,t){return this.x=Math.max(e.x,Math.min(t.x,this.x)),this.y=Math.max(e.y,Math.min(t.y,this.y)),this.z=Math.max(e.z,Math.min(t.z,this.z)),this}clampScalar(e,t){return this.x=Math.max(e,Math.min(t,this.x)),this.y=Math.max(e,Math.min(t,this.y)),this.z=Math.max(e,Math.min(t,this.z)),this}clampLength(e,t){const n=this.length();return this.divideScalar(n||1).multiplyScalar(Math.max(e,Math.min(t,n)))}floor(){return this.x=Math.floor(this.x),this.y=Math.floor(this.y),this.z=Math.floor(this.z),this}ceil(){return this.x=Math.ceil(this.x),this.y=Math.ceil(this.y),this.z=Math.ceil(this.z),this}round(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this.z=Math.round(this.z),this}roundToZero(){return this.x=Math.trunc(this.x),this.y=Math.trunc(this.y),this.z=Math.trunc(this.z),this}negate(){return this.x=-this.x,this.y=-this.y,this.z=-this.z,this}dot(e){return this.x*e.x+this.y*e.y+this.z*e.z}lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z}length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z)}manhattanLength(){return Math.abs(this.x)+Math.abs(this.y)+Math.abs(this.z)}normalize(){return this.divideScalar(this.length()||1)}setLength(e){return this.normalize().multiplyScalar(e)}lerp(e,t){return this.x+=(e.x-this.x)*t,this.y+=(e.y-this.y)*t,this.z+=(e.z-this.z)*t,this}lerpVectors(e,t,n){return this.x=e.x+(t.x-e.x)*n,this.y=e.y+(t.y-e.y)*n,this.z=e.z+(t.z-e.z)*n,this}cross(e){return this.crossVectors(this,e)}crossVectors(e,t){const n=e.x,i=e.y,r=e.z,a=t.x,s=t.y,o=t.z;return this.x=i*o-r*s,this.y=r*a-n*o,this.z=n*s-i*a,this}projectOnVector(e){const t=e.lengthSq();if(0===t)return this.set(0,0,0);const n=e.dot(this)/t;return this.copy(e).multiplyScalar(n)}projectOnPlane(e){return vt.copy(this).projectOnVector(e),this.sub(vt)}reflect(e){return this.sub(vt.copy(e).multiplyScalar(2*this.dot(e)))}angleTo(e){const t=Math.sqrt(this.lengthSq()*e.lengthSq());if(0===t)return Math.PI/2;const n=this.dot(e)/t;return Math.acos(Fe(n,-1,1))}distanceTo(e){return Math.sqrt(this.distanceToSquared(e))}distanceToSquared(e){const t=this.x-e.x,n=this.y-e.y,i=this.z-e.z;return t*t+n*n+i*i}manhattanDistanceTo(e){return Math.abs(this.x-e.x)+Math.abs(this.y-e.y)+Math.abs(this.z-e.z)}setFromSpherical(e){return this.setFromSphericalCoords(e.radius,e.phi,e.theta)}setFromSphericalCoords(e,t,n){const i=Math.sin(t)*e;return this.x=i*Math.sin(n),this.y=Math.cos(t)*e,this.z=i*Math.cos(n),this}setFromCylindrical(e){return this.setFromCylindricalCoords(e.radius,e.theta,e.y)}setFromCylindricalCoords(e,t,n){return this.x=e*Math.sin(t),this.y=n,this.z=e*Math.cos(t),this}setFromMatrixPosition(e){const t=e.elements;return this.x=t[12],this.y=t[13],this.z=t[14],this}setFromMatrixScale(e){const t=this.setFromMatrixColumn(e,0).length(),n=this.setFromMatrixColumn(e,1).length(),i=this.setFromMatrixColumn(e,2).length();return this.x=t,this.y=n,this.z=i,this}setFromMatrixColumn(e,t){return this.fromArray(e.elements,4*t)}setFromMatrix3Column(e,t){return this.fromArray(e.elements,3*t)}setFromEuler(e){return this.x=e._x,this.y=e._y,this.z=e._z,this}setFromColor(e){return this.x=e.r,this.y=e.g,this.z=e.b,this}equals(e){return e.x===this.x&&e.y===this.y&&e.z===this.z}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this.x=e[t],this.y=e[t+1],this.z=e[t+2],this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e[t]=this.x,e[t+1]=this.y,e[t+2]=this.z,e}fromBufferAttribute(e,t){return this.x=e.getX(t),this.y=e.getY(t),this.z=e.getZ(t),this}random(){return this.x=Math.random(),this.y=Math.random(),this.z=Math.random(),this}randomDirection(){const e=2*(Math.random()-.5),t=Math.random()*Math.PI*2,n=Math.sqrt(1-e**2);return this.x=n*Math.cos(t),this.y=n*Math.sin(t),this.z=e,this}*[Symbol.iterator](){yield this.x,yield this.y,yield this.z}}const vt=new _t,xt=new gt;class Mt{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new _t(1/0,1/0,1/0),t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:new _t(-1/0,-1/0,-1/0);this.isBox3=!0,this.min=e,this.max=t}set(e,t){return this.min.copy(e),this.max.copy(t),this}setFromArray(e){this.makeEmpty();for(let t=0,n=e.length;t<n;t+=3)this.expandByPoint(yt.fromArray(e,t));return this}setFromBufferAttribute(e){this.makeEmpty();for(let t=0,n=e.count;t<n;t++)this.expandByPoint(yt.fromBufferAttribute(e,t));return this}setFromPoints(e){this.makeEmpty();for(let t=0,n=e.length;t<n;t++)this.expandByPoint(e[t]);return this}setFromCenterAndSize(e,t){const n=yt.copy(t).multiplyScalar(.5);return this.min.copy(e).sub(n),this.max.copy(e).add(n),this}setFromObject(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];return this.makeEmpty(),this.expandByObject(e,t)}clone(){return(new this.constructor).copy(this)}copy(e){return this.min.copy(e.min),this.max.copy(e.max),this}makeEmpty(){return this.min.x=this.min.y=this.min.z=1/0,this.max.x=this.max.y=this.max.z=-1/0,this}isEmpty(){return this.max.x<this.min.x||this.max.y<this.min.y||this.max.z<this.min.z}getCenter(e){return this.isEmpty()?e.set(0,0,0):e.addVectors(this.min,this.max).multiplyScalar(.5)}getSize(e){return this.isEmpty()?e.set(0,0,0):e.subVectors(this.max,this.min)}expandByPoint(e){return this.min.min(e),this.max.max(e),this}expandByVector(e){return this.min.sub(e),this.max.add(e),this}expandByScalar(e){return this.min.addScalar(-e),this.max.addScalar(e),this}expandByObject(e){let t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];e.updateWorldMatrix(!1,!1);const n=e.geometry;if(void 0!==n){const i=n.getAttribute("position");if(!0===t&&void 0!==i&&!0!==e.isInstancedMesh)for(let t=0,n=i.count;t<n;t++)!0===e.isMesh?e.getVertexPosition(t,yt):yt.fromBufferAttribute(i,t),yt.applyMatrix4(e.matrixWorld),this.expandByPoint(yt);else void 0!==e.boundingBox?(null===e.boundingBox&&e.computeBoundingBox(),Et.copy(e.boundingBox)):(null===n.boundingBox&&n.computeBoundingBox(),Et.copy(n.boundingBox)),Et.applyMatrix4(e.matrixWorld),this.union(Et)}const i=e.children;for(let e=0,n=i.length;e<n;e++)this.expandByObject(i[e],t);return this}containsPoint(e){return!(e.x<this.min.x||e.x>this.max.x||e.y<this.min.y||e.y>this.max.y||e.z<this.min.z||e.z>this.max.z)}containsBox(e){return this.min.x<=e.min.x&&e.max.x<=this.max.x&&this.min.y<=e.min.y&&e.max.y<=this.max.y&&this.min.z<=e.min.z&&e.max.z<=this.max.z}getParameter(e,t){return t.set((e.x-this.min.x)/(this.max.x-this.min.x),(e.y-this.min.y)/(this.max.y-this.min.y),(e.z-this.min.z)/(this.max.z-this.min.z))}intersectsBox(e){return!(e.max.x<this.min.x||e.min.x>this.max.x||e.max.y<this.min.y||e.min.y>this.max.y||e.max.z<this.min.z||e.min.z>this.max.z)}intersectsSphere(e){return this.clampPoint(e.center,yt),yt.distanceToSquared(e.center)<=e.radius*e.radius}intersectsPlane(e){let t,n;return e.normal.x>0?(t=e.normal.x*this.min.x,n=e.normal.x*this.max.x):(t=e.normal.x*this.max.x,n=e.normal.x*this.min.x),e.normal.y>0?(t+=e.normal.y*this.min.y,n+=e.normal.y*this.max.y):(t+=e.normal.y*this.max.y,n+=e.normal.y*this.min.y),e.normal.z>0?(t+=e.normal.z*this.min.z,n+=e.normal.z*this.max.z):(t+=e.normal.z*this.max.z,n+=e.normal.z*this.min.z),t<=-e.constant&&n>=-e.constant}intersectsTriangle(e){if(this.isEmpty())return!1;this.getCenter(Lt),Pt.subVectors(this.max,Lt),Tt.subVectors(e.a,Lt),bt.subVectors(e.b,Lt),wt.subVectors(e.c,Lt),At.subVectors(bt,Tt),Rt.subVectors(wt,bt),Ct.subVectors(Tt,wt);let t=[0,-At.z,At.y,0,-Rt.z,Rt.y,0,-Ct.z,Ct.y,At.z,0,-At.x,Rt.z,0,-Rt.x,Ct.z,0,-Ct.x,-At.y,At.x,0,-Rt.y,Rt.x,0,-Ct.y,Ct.x,0];return!!Nt(t,Tt,bt,wt,Pt)&&(t=[1,0,0,0,1,0,0,0,1],!!Nt(t,Tt,bt,wt,Pt)&&(Ut.crossVectors(At,Rt),t=[Ut.x,Ut.y,Ut.z],Nt(t,Tt,bt,wt,Pt)))}clampPoint(e,t){return t.copy(e).clamp(this.min,this.max)}distanceToPoint(e){return this.clampPoint(e,yt).distanceTo(e)}getBoundingSphere(e){return this.isEmpty()?e.makeEmpty():(this.getCenter(e.center),e.radius=.5*this.getSize(yt).length()),e}intersect(e){return this.min.max(e.min),this.max.min(e.max),this.isEmpty()&&this.makeEmpty(),this}union(e){return this.min.min(e.min),this.max.max(e.max),this}applyMatrix4(e){return this.isEmpty()||(St[0].set(this.min.x,this.min.y,this.min.z).applyMatrix4(e),St[1].set(this.min.x,this.min.y,this.max.z).applyMatrix4(e),St[2].set(this.min.x,this.max.y,this.min.z).applyMatrix4(e),St[3].set(this.min.x,this.max.y,this.max.z).applyMatrix4(e),St[4].set(this.max.x,this.min.y,this.min.z).applyMatrix4(e),St[5].set(this.max.x,this.min.y,this.max.z).applyMatrix4(e),St[6].set(this.max.x,this.max.y,this.min.z).applyMatrix4(e),St[7].set(this.max.x,this.max.y,this.max.z).applyMatrix4(e),this.setFromPoints(St)),this}translate(e){return this.min.add(e),this.max.add(e),this}equals(e){return e.min.equals(this.min)&&e.max.equals(this.max)}}const St=[new _t,new _t,new _t,new _t,new _t,new _t,new _t,new _t],yt=new _t,Et=new Mt,Tt=new _t,bt=new _t,wt=new _t,At=new _t,Rt=new _t,Ct=new _t,Lt=new _t,Pt=new _t,Ut=new _t,Dt=new _t;function Nt(e,t,n,i,r){for(let a=0,s=e.length-3;a<=s;a+=3){Dt.fromArray(e,a);const s=r.x*Math.abs(Dt.x)+r.y*Math.abs(Dt.y)+r.z*Math.abs(Dt.z),o=t.dot(Dt),l=n.dot(Dt),c=i.dot(Dt);if(Math.max(-Math.max(o,l,c),Math.min(o,l,c))>s)return!1}return!0}const It=new Mt,Ot=new _t,Ft=new _t;class zt{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new _t,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:-1;this.center=e,this.radius=t}set(e,t){return this.center.copy(e),this.radius=t,this}setFromPoints(e,t){const n=this.center;void 0!==t?n.copy(t):It.setFromPoints(e).getCenter(n);let i=0;for(let t=0,r=e.length;t<r;t++)i=Math.max(i,n.distanceToSquared(e[t]));return this.radius=Math.sqrt(i),this}copy(e){return this.center.copy(e.center),this.radius=e.radius,this}isEmpty(){return this.radius<0}makeEmpty(){return this.center.set(0,0,0),this.radius=-1,this}containsPoint(e){return e.distanceToSquared(this.center)<=this.radius*this.radius}distanceToPoint(e){return e.distanceTo(this.center)-this.radius}intersectsSphere(e){const t=this.radius+e.radius;return e.center.distanceToSquared(this.center)<=t*t}intersectsBox(e){return e.intersectsSphere(this)}intersectsPlane(e){return Math.abs(e.distanceToPoint(this.center))<=this.radius}clampPoint(e,t){const n=this.center.distanceToSquared(e);return t.copy(e),n>this.radius*this.radius&&(t.sub(this.center).normalize(),t.multiplyScalar(this.radius).add(this.center)),t}getBoundingBox(e){return this.isEmpty()?(e.makeEmpty(),e):(e.set(this.center,this.center),e.expandByScalar(this.radius),e)}applyMatrix4(e){return this.center.applyMatrix4(e),this.radius=this.radius*e.getMaxScaleOnAxis(),this}translate(e){return this.center.add(e),this}expandByPoint(e){if(this.isEmpty())return this.center.copy(e),this.radius=0,this;Ot.subVectors(e,this.center);const t=Ot.lengthSq();if(t>this.radius*this.radius){const e=Math.sqrt(t),n=.5*(e-this.radius);this.center.addScaledVector(Ot,n/e),this.radius+=n}return this}union(e){return e.isEmpty()?this:this.isEmpty()?(this.copy(e),this):(!0===this.center.equals(e.center)?this.radius=Math.max(this.radius,e.radius):(Ft.subVectors(e.center,this.center).setLength(e.radius),this.expandByPoint(Ot.copy(e.center).add(Ft)),this.expandByPoint(Ot.copy(e.center).sub(Ft))),this)}equals(e){return e.center.equals(this.center)&&e.radius===this.radius}clone(){return(new this.constructor).copy(this)}}const Bt=new _t,Ht=new _t,Vt=new _t,Gt=new _t,kt=new _t,Wt=new _t,Xt=new _t;class jt{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new _t,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:new _t(0,0,-1);this.origin=e,this.direction=t}set(e,t){return this.origin.copy(e),this.direction.copy(t),this}copy(e){return this.origin.copy(e.origin),this.direction.copy(e.direction),this}at(e,t){return t.copy(this.origin).addScaledVector(this.direction,e)}lookAt(e){return this.direction.copy(e).sub(this.origin).normalize(),this}recast(e){return this.origin.copy(this.at(e,Bt)),this}closestPointToPoint(e,t){t.subVectors(e,this.origin);const n=t.dot(this.direction);return n<0?t.copy(this.origin):t.copy(this.origin).addScaledVector(this.direction,n)}distanceToPoint(e){return Math.sqrt(this.distanceSqToPoint(e))}distanceSqToPoint(e){const t=Bt.subVectors(e,this.origin).dot(this.direction);return t<0?this.origin.distanceToSquared(e):(Bt.copy(this.origin).addScaledVector(this.direction,t),Bt.distanceToSquared(e))}distanceSqToSegment(e,t,n,i){Ht.copy(e).add(t).multiplyScalar(.5),Vt.copy(t).sub(e).normalize(),Gt.copy(this.origin).sub(Ht);const r=.5*e.distanceTo(t),a=-this.direction.dot(Vt),s=Gt.dot(this.direction),o=-Gt.dot(Vt),l=Gt.lengthSq(),c=Math.abs(1-a*a);let h,u,d,p;if(c>0)if(h=a*o-s,u=a*s-o,p=r*c,h>=0)if(u>=-p)if(u<=p){const e=1/c;h*=e,u*=e,d=h*(h+a*u+2*s)+u*(a*h+u+2*o)+l}else u=r,h=Math.max(0,-(a*u+s)),d=-h*h+u*(u+2*o)+l;else u=-r,h=Math.max(0,-(a*u+s)),d=-h*h+u*(u+2*o)+l;else u<=-p?(h=Math.max(0,-(-a*r+s)),u=h>0?-r:Math.min(Math.max(-r,-o),r),d=-h*h+u*(u+2*o)+l):u<=p?(h=0,u=Math.min(Math.max(-r,-o),r),d=u*(u+2*o)+l):(h=Math.max(0,-(a*r+s)),u=h>0?r:Math.min(Math.max(-r,-o),r),d=-h*h+u*(u+2*o)+l);else u=a>0?-r:r,h=Math.max(0,-(a*u+s)),d=-h*h+u*(u+2*o)+l;return n&&n.copy(this.origin).addScaledVector(this.direction,h),i&&i.copy(Ht).addScaledVector(Vt,u),d}intersectSphere(e,t){Bt.subVectors(e.center,this.origin);const n=Bt.dot(this.direction),i=Bt.dot(Bt)-n*n,r=e.radius*e.radius;if(i>r)return null;const a=Math.sqrt(r-i),s=n-a,o=n+a;return o<0?null:s<0?this.at(o,t):this.at(s,t)}intersectsSphere(e){return this.distanceSqToPoint(e.center)<=e.radius*e.radius}distanceToPlane(e){const t=e.normal.dot(this.direction);if(0===t)return 0===e.distanceToPoint(this.origin)?0:null;const n=-(this.origin.dot(e.normal)+e.constant)/t;return n>=0?n:null}intersectPlane(e,t){const n=this.distanceToPlane(e);return null===n?null:this.at(n,t)}intersectsPlane(e){const t=e.distanceToPoint(this.origin);return 0===t||e.normal.dot(this.direction)*t<0}intersectBox(e,t){let n,i,r,a,s,o;const l=1/this.direction.x,c=1/this.direction.y,h=1/this.direction.z,u=this.origin;return l>=0?(n=(e.min.x-u.x)*l,i=(e.max.x-u.x)*l):(n=(e.max.x-u.x)*l,i=(e.min.x-u.x)*l),c>=0?(r=(e.min.y-u.y)*c,a=(e.max.y-u.y)*c):(r=(e.max.y-u.y)*c,a=(e.min.y-u.y)*c),n>a||r>i?null:((r>n||isNaN(n))&&(n=r),(a<i||isNaN(i))&&(i=a),h>=0?(s=(e.min.z-u.z)*h,o=(e.max.z-u.z)*h):(s=(e.max.z-u.z)*h,o=(e.min.z-u.z)*h),n>o||s>i?null:((s>n||n!=n)&&(n=s),(o<i||i!=i)&&(i=o),i<0?null:this.at(n>=0?n:i,t)))}intersectsBox(e){return null!==this.intersectBox(e,Bt)}intersectTriangle(e,t,n,i,r){kt.subVectors(t,e),Wt.subVectors(n,e),Xt.crossVectors(kt,Wt);let a,s=this.direction.dot(Xt);if(s>0){if(i)return null;a=1}else{if(!(s<0))return null;a=-1,s=-s}Gt.subVectors(this.origin,e);const o=a*this.direction.dot(Wt.crossVectors(Gt,Wt));if(o<0)return null;const l=a*this.direction.dot(kt.cross(Gt));if(l<0)return null;if(o+l>s)return null;const c=-a*Gt.dot(Xt);return c<0?null:this.at(c/s,r)}applyMatrix4(e){return this.origin.applyMatrix4(e),this.direction.transformDirection(e),this}equals(e){return e.origin.equals(this.origin)&&e.direction.equals(this.direction)}clone(){return(new this.constructor).copy(this)}}class qt{constructor(e,t,n,i,r,a,s,o,l,c,h,u,d,p,f,m){qt.prototype.isMatrix4=!0,this.elements=[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1],void 0!==e&&this.set(e,t,n,i,r,a,s,o,l,c,h,u,d,p,f,m)}set(e,t,n,i,r,a,s,o,l,c,h,u,d,p,f,m){const g=this.elements;return g[0]=e,g[4]=t,g[8]=n,g[12]=i,g[1]=r,g[5]=a,g[9]=s,g[13]=o,g[2]=l,g[6]=c,g[10]=h,g[14]=u,g[3]=d,g[7]=p,g[11]=f,g[15]=m,this}identity(){return this.set(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1),this}clone(){return(new qt).fromArray(this.elements)}copy(e){const t=this.elements,n=e.elements;return t[0]=n[0],t[1]=n[1],t[2]=n[2],t[3]=n[3],t[4]=n[4],t[5]=n[5],t[6]=n[6],t[7]=n[7],t[8]=n[8],t[9]=n[9],t[10]=n[10],t[11]=n[11],t[12]=n[12],t[13]=n[13],t[14]=n[14],t[15]=n[15],this}copyPosition(e){const t=this.elements,n=e.elements;return t[12]=n[12],t[13]=n[13],t[14]=n[14],this}setFromMatrix3(e){const t=e.elements;return this.set(t[0],t[3],t[6],0,t[1],t[4],t[7],0,t[2],t[5],t[8],0,0,0,0,1),this}extractBasis(e,t,n){return e.setFromMatrixColumn(this,0),t.setFromMatrixColumn(this,1),n.setFromMatrixColumn(this,2),this}makeBasis(e,t,n){return this.set(e.x,t.x,n.x,0,e.y,t.y,n.y,0,e.z,t.z,n.z,0,0,0,0,1),this}extractRotation(e){const t=this.elements,n=e.elements,i=1/Yt.setFromMatrixColumn(e,0).length(),r=1/Yt.setFromMatrixColumn(e,1).length(),a=1/Yt.setFromMatrixColumn(e,2).length();return t[0]=n[0]*i,t[1]=n[1]*i,t[2]=n[2]*i,t[3]=0,t[4]=n[4]*r,t[5]=n[5]*r,t[6]=n[6]*r,t[7]=0,t[8]=n[8]*a,t[9]=n[9]*a,t[10]=n[10]*a,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromEuler(e){const t=this.elements,n=e.x,i=e.y,r=e.z,a=Math.cos(n),s=Math.sin(n),o=Math.cos(i),l=Math.sin(i),c=Math.cos(r),h=Math.sin(r);if("XYZ"===e.order){const e=a*c,n=a*h,i=s*c,r=s*h;t[0]=o*c,t[4]=-o*h,t[8]=l,t[1]=n+i*l,t[5]=e-r*l,t[9]=-s*o,t[2]=r-e*l,t[6]=i+n*l,t[10]=a*o}else if("YXZ"===e.order){const e=o*c,n=o*h,i=l*c,r=l*h;t[0]=e+r*s,t[4]=i*s-n,t[8]=a*l,t[1]=a*h,t[5]=a*c,t[9]=-s,t[2]=n*s-i,t[6]=r+e*s,t[10]=a*o}else if("ZXY"===e.order){const e=o*c,n=o*h,i=l*c,r=l*h;t[0]=e-r*s,t[4]=-a*h,t[8]=i+n*s,t[1]=n+i*s,t[5]=a*c,t[9]=r-e*s,t[2]=-a*l,t[6]=s,t[10]=a*o}else if("ZYX"===e.order){const e=a*c,n=a*h,i=s*c,r=s*h;t[0]=o*c,t[4]=i*l-n,t[8]=e*l+r,t[1]=o*h,t[5]=r*l+e,t[9]=n*l-i,t[2]=-l,t[6]=s*o,t[10]=a*o}else if("YZX"===e.order){const e=a*o,n=a*l,i=s*o,r=s*l;t[0]=o*c,t[4]=r-e*h,t[8]=i*h+n,t[1]=h,t[5]=a*c,t[9]=-s*c,t[2]=-l*c,t[6]=n*h+i,t[10]=e-r*h}else if("XZY"===e.order){const e=a*o,n=a*l,i=s*o,r=s*l;t[0]=o*c,t[4]=-h,t[8]=l*c,t[1]=e*h+r,t[5]=a*c,t[9]=n*h-i,t[2]=i*h-n,t[6]=s*c,t[10]=r*h+e}return t[3]=0,t[7]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,this}makeRotationFromQuaternion(e){return this.compose(Zt,e,Jt)}lookAt(e,t,n){const i=this.elements;return en.subVectors(e,t),0===en.lengthSq()&&(en.z=1),en.normalize(),Qt.crossVectors(n,en),0===Qt.lengthSq()&&(1===Math.abs(n.z)?en.x+=1e-4:en.z+=1e-4,en.normalize(),Qt.crossVectors(n,en)),Qt.normalize(),$t.crossVectors(en,Qt),i[0]=Qt.x,i[4]=$t.x,i[8]=en.x,i[1]=Qt.y,i[5]=$t.y,i[9]=en.y,i[2]=Qt.z,i[6]=$t.z,i[10]=en.z,this}multiply(e){return this.multiplyMatrices(this,e)}premultiply(e){return this.multiplyMatrices(e,this)}multiplyMatrices(e,t){const n=e.elements,i=t.elements,r=this.elements,a=n[0],s=n[4],o=n[8],l=n[12],c=n[1],h=n[5],u=n[9],d=n[13],p=n[2],f=n[6],m=n[10],g=n[14],_=n[3],v=n[7],x=n[11],M=n[15],S=i[0],y=i[4],E=i[8],T=i[12],b=i[1],w=i[5],A=i[9],R=i[13],C=i[2],L=i[6],P=i[10],U=i[14],D=i[3],N=i[7],I=i[11],O=i[15];return r[0]=a*S+s*b+o*C+l*D,r[4]=a*y+s*w+o*L+l*N,r[8]=a*E+s*A+o*P+l*I,r[12]=a*T+s*R+o*U+l*O,r[1]=c*S+h*b+u*C+d*D,r[5]=c*y+h*w+u*L+d*N,r[9]=c*E+h*A+u*P+d*I,r[13]=c*T+h*R+u*U+d*O,r[2]=p*S+f*b+m*C+g*D,r[6]=p*y+f*w+m*L+g*N,r[10]=p*E+f*A+m*P+g*I,r[14]=p*T+f*R+m*U+g*O,r[3]=_*S+v*b+x*C+M*D,r[7]=_*y+v*w+x*L+M*N,r[11]=_*E+v*A+x*P+M*I,r[15]=_*T+v*R+x*U+M*O,this}multiplyScalar(e){const t=this.elements;return t[0]*=e,t[4]*=e,t[8]*=e,t[12]*=e,t[1]*=e,t[5]*=e,t[9]*=e,t[13]*=e,t[2]*=e,t[6]*=e,t[10]*=e,t[14]*=e,t[3]*=e,t[7]*=e,t[11]*=e,t[15]*=e,this}determinant(){const e=this.elements,t=e[0],n=e[4],i=e[8],r=e[12],a=e[1],s=e[5],o=e[9],l=e[13],c=e[2],h=e[6],u=e[10],d=e[14];return e[3]*(+r*o*h-i*l*h-r*s*u+n*l*u+i*s*d-n*o*d)+e[7]*(+t*o*d-t*l*u+r*a*u-i*a*d+i*l*c-r*o*c)+e[11]*(+t*l*h-t*s*d-r*a*h+n*a*d+r*s*c-n*l*c)+e[15]*(-i*s*c-t*o*h+t*s*u+i*a*h-n*a*u+n*o*c)}transpose(){const e=this.elements;let t;return t=e[1],e[1]=e[4],e[4]=t,t=e[2],e[2]=e[8],e[8]=t,t=e[6],e[6]=e[9],e[9]=t,t=e[3],e[3]=e[12],e[12]=t,t=e[7],e[7]=e[13],e[13]=t,t=e[11],e[11]=e[14],e[14]=t,this}setPosition(e,t,n){const i=this.elements;return e.isVector3?(i[12]=e.x,i[13]=e.y,i[14]=e.z):(i[12]=e,i[13]=t,i[14]=n),this}invert(){const e=this.elements,t=e[0],n=e[1],i=e[2],r=e[3],a=e[4],s=e[5],o=e[6],l=e[7],c=e[8],h=e[9],u=e[10],d=e[11],p=e[12],f=e[13],m=e[14],g=e[15],_=h*m*l-f*u*l+f*o*d-s*m*d-h*o*g+s*u*g,v=p*u*l-c*m*l-p*o*d+a*m*d+c*o*g-a*u*g,x=c*f*l-p*h*l+p*s*d-a*f*d-c*s*g+a*h*g,M=p*h*o-c*f*o-p*s*u+a*f*u+c*s*m-a*h*m,S=t*_+n*v+i*x+r*M;if(0===S)return this.set(0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0);const y=1/S;return e[0]=_*y,e[1]=(f*u*r-h*m*r-f*i*d+n*m*d+h*i*g-n*u*g)*y,e[2]=(s*m*r-f*o*r+f*i*l-n*m*l-s*i*g+n*o*g)*y,e[3]=(h*o*r-s*u*r-h*i*l+n*u*l+s*i*d-n*o*d)*y,e[4]=v*y,e[5]=(c*m*r-p*u*r+p*i*d-t*m*d-c*i*g+t*u*g)*y,e[6]=(p*o*r-a*m*r-p*i*l+t*m*l+a*i*g-t*o*g)*y,e[7]=(a*u*r-c*o*r+c*i*l-t*u*l-a*i*d+t*o*d)*y,e[8]=x*y,e[9]=(p*h*r-c*f*r-p*n*d+t*f*d+c*n*g-t*h*g)*y,e[10]=(a*f*r-p*s*r+p*n*l-t*f*l-a*n*g+t*s*g)*y,e[11]=(c*s*r-a*h*r-c*n*l+t*h*l+a*n*d-t*s*d)*y,e[12]=M*y,e[13]=(c*f*i-p*h*i+p*n*u-t*f*u-c*n*m+t*h*m)*y,e[14]=(p*s*i-a*f*i-p*n*o+t*f*o+a*n*m-t*s*m)*y,e[15]=(a*h*i-c*s*i+c*n*o-t*h*o-a*n*u+t*s*u)*y,this}scale(e){const t=this.elements,n=e.x,i=e.y,r=e.z;return t[0]*=n,t[4]*=i,t[8]*=r,t[1]*=n,t[5]*=i,t[9]*=r,t[2]*=n,t[6]*=i,t[10]*=r,t[3]*=n,t[7]*=i,t[11]*=r,this}getMaxScaleOnAxis(){const e=this.elements,t=e[0]*e[0]+e[1]*e[1]+e[2]*e[2],n=e[4]*e[4]+e[5]*e[5]+e[6]*e[6],i=e[8]*e[8]+e[9]*e[9]+e[10]*e[10];return Math.sqrt(Math.max(t,n,i))}makeTranslation(e,t,n){return e.isVector3?this.set(1,0,0,e.x,0,1,0,e.y,0,0,1,e.z,0,0,0,1):this.set(1,0,0,e,0,1,0,t,0,0,1,n,0,0,0,1),this}makeRotationX(e){const t=Math.cos(e),n=Math.sin(e);return this.set(1,0,0,0,0,t,-n,0,0,n,t,0,0,0,0,1),this}makeRotationY(e){const t=Math.cos(e),n=Math.sin(e);return this.set(t,0,n,0,0,1,0,0,-n,0,t,0,0,0,0,1),this}makeRotationZ(e){const t=Math.cos(e),n=Math.sin(e);return this.set(t,-n,0,0,n,t,0,0,0,0,1,0,0,0,0,1),this}makeRotationAxis(e,t){const n=Math.cos(t),i=Math.sin(t),r=1-n,a=e.x,s=e.y,o=e.z,l=r*a,c=r*s;return this.set(l*a+n,l*s-i*o,l*o+i*s,0,l*s+i*o,c*s+n,c*o-i*a,0,l*o-i*s,c*o+i*a,r*o*o+n,0,0,0,0,1),this}makeScale(e,t,n){return this.set(e,0,0,0,0,t,0,0,0,0,n,0,0,0,0,1),this}makeShear(e,t,n,i,r,a){return this.set(1,n,r,0,e,1,a,0,t,i,1,0,0,0,0,1),this}compose(e,t,n){const i=this.elements,r=t._x,a=t._y,s=t._z,o=t._w,l=r+r,c=a+a,h=s+s,u=r*l,d=r*c,p=r*h,f=a*c,m=a*h,g=s*h,_=o*l,v=o*c,x=o*h,M=n.x,S=n.y,y=n.z;return i[0]=(1-(f+g))*M,i[1]=(d+x)*M,i[2]=(p-v)*M,i[3]=0,i[4]=(d-x)*S,i[5]=(1-(u+g))*S,i[6]=(m+_)*S,i[7]=0,i[8]=(p+v)*y,i[9]=(m-_)*y,i[10]=(1-(u+f))*y,i[11]=0,i[12]=e.x,i[13]=e.y,i[14]=e.z,i[15]=1,this}decompose(e,t,n){const i=this.elements;let r=Yt.set(i[0],i[1],i[2]).length();const a=Yt.set(i[4],i[5],i[6]).length(),s=Yt.set(i[8],i[9],i[10]).length();this.determinant()<0&&(r=-r),e.x=i[12],e.y=i[13],e.z=i[14],Kt.copy(this);const o=1/r,l=1/a,c=1/s;return Kt.elements[0]*=o,Kt.elements[1]*=o,Kt.elements[2]*=o,Kt.elements[4]*=l,Kt.elements[5]*=l,Kt.elements[6]*=l,Kt.elements[8]*=c,Kt.elements[9]*=c,Kt.elements[10]*=c,t.setFromRotationMatrix(Kt),n.x=r,n.y=a,n.z=s,this}makePerspective(e,t,n,i,r,a){let s=arguments.length>6&&void 0!==arguments[6]?arguments[6]:Le;const o=this.elements,l=2*r/(t-e),c=2*r/(n-i),h=(t+e)/(t-e),u=(n+i)/(n-i);let d,p;if(s===Le)d=-(a+r)/(a-r),p=-2*a*r/(a-r);else{if(s!==Pe)throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: "+s);d=-a/(a-r),p=-a*r/(a-r)}return o[0]=l,o[4]=0,o[8]=h,o[12]=0,o[1]=0,o[5]=c,o[9]=u,o[13]=0,o[2]=0,o[6]=0,o[10]=d,o[14]=p,o[3]=0,o[7]=0,o[11]=-1,o[15]=0,this}makeOrthographic(e,t,n,i,r,a){let s=arguments.length>6&&void 0!==arguments[6]?arguments[6]:Le;const o=this.elements,l=1/(t-e),c=1/(n-i),h=1/(a-r),u=(t+e)*l,d=(n+i)*c;let p,f;if(s===Le)p=(a+r)*h,f=-2*h;else{if(s!==Pe)throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: "+s);p=r*h,f=-1*h}return o[0]=2*l,o[4]=0,o[8]=0,o[12]=-u,o[1]=0,o[5]=2*c,o[9]=0,o[13]=-d,o[2]=0,o[6]=0,o[10]=f,o[14]=-p,o[3]=0,o[7]=0,o[11]=0,o[15]=1,this}equals(e){const t=this.elements,n=e.elements;for(let e=0;e<16;e++)if(t[e]!==n[e])return!1;return!0}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;for(let n=0;n<16;n++)this.elements[n]=e[n+t];return this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;const n=this.elements;return e[t]=n[0],e[t+1]=n[1],e[t+2]=n[2],e[t+3]=n[3],e[t+4]=n[4],e[t+5]=n[5],e[t+6]=n[6],e[t+7]=n[7],e[t+8]=n[8],e[t+9]=n[9],e[t+10]=n[10],e[t+11]=n[11],e[t+12]=n[12],e[t+13]=n[13],e[t+14]=n[14],e[t+15]=n[15],e}}const Yt=new _t,Kt=new qt,Zt=new _t(0,0,0),Jt=new _t(1,1,1),Qt=new _t,$t=new _t,en=new _t,tn=new qt,nn=new gt;class rn{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:rn.DEFAULT_ORDER;this.isEuler=!0,this._x=e,this._y=t,this._z=n,this._order=i}get x(){return this._x}set x(e){this._x=e,this._onChangeCallback()}get y(){return this._y}set y(e){this._y=e,this._onChangeCallback()}get z(){return this._z}set z(e){this._z=e,this._onChangeCallback()}get order(){return this._order}set order(e){this._order=e,this._onChangeCallback()}set(e,t,n){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:this._order;return this._x=e,this._y=t,this._z=n,this._order=i,this._onChangeCallback(),this}clone(){return new this.constructor(this._x,this._y,this._z,this._order)}copy(e){return this._x=e._x,this._y=e._y,this._z=e._z,this._order=e._order,this._onChangeCallback(),this}setFromRotationMatrix(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this._order,n=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];const i=e.elements,r=i[0],a=i[4],s=i[8],o=i[1],l=i[5],c=i[9],h=i[2],u=i[6],d=i[10];switch(t){case"XYZ":this._y=Math.asin(Fe(s,-1,1)),Math.abs(s)<.9999999?(this._x=Math.atan2(-c,d),this._z=Math.atan2(-a,r)):(this._x=Math.atan2(u,l),this._z=0);break;case"YXZ":this._x=Math.asin(-Fe(c,-1,1)),Math.abs(c)<.9999999?(this._y=Math.atan2(s,d),this._z=Math.atan2(o,l)):(this._y=Math.atan2(-h,r),this._z=0);break;case"ZXY":this._x=Math.asin(Fe(u,-1,1)),Math.abs(u)<.9999999?(this._y=Math.atan2(-h,d),this._z=Math.atan2(-a,l)):(this._y=0,this._z=Math.atan2(o,r));break;case"ZYX":this._y=Math.asin(-Fe(h,-1,1)),Math.abs(h)<.9999999?(this._x=Math.atan2(u,d),this._z=Math.atan2(o,r)):(this._x=0,this._z=Math.atan2(-a,l));break;case"YZX":this._z=Math.asin(Fe(o,-1,1)),Math.abs(o)<.9999999?(this._x=Math.atan2(-c,l),this._y=Math.atan2(-h,r)):(this._x=0,this._y=Math.atan2(s,d));break;case"XZY":this._z=Math.asin(-Fe(a,-1,1)),Math.abs(a)<.9999999?(this._x=Math.atan2(u,l),this._y=Math.atan2(s,r)):(this._x=Math.atan2(-c,d),this._y=0);break;default:console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: "+t)}return this._order=t,!0===n&&this._onChangeCallback(),this}setFromQuaternion(e,t,n){return tn.makeRotationFromQuaternion(e),this.setFromRotationMatrix(tn,t,n)}setFromVector3(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this._order;return this.set(e.x,e.y,e.z,t)}reorder(e){return nn.setFromEuler(this),this.setFromQuaternion(nn,e)}equals(e){return e._x===this._x&&e._y===this._y&&e._z===this._z&&e._order===this._order}fromArray(e){return this._x=e[0],this._y=e[1],this._z=e[2],void 0!==e[3]&&(this._order=e[3]),this._onChangeCallback(),this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e[t]=this._x,e[t+1]=this._y,e[t+2]=this._z,e[t+3]=this._order,e}_onChange(e){return this._onChangeCallback=e,this}_onChangeCallback(){}*[Symbol.iterator](){yield this._x,yield this._y,yield this._z,yield this._order}}rn.DEFAULT_ORDER="XYZ";class an{constructor(){this.mask=1}set(e){this.mask=1<<e>>>0}enable(e){this.mask|=1<<e}enableAll(){this.mask=-1}toggle(e){this.mask^=1<<e}disable(e){this.mask&=~(1<<e)}disableAll(){this.mask=0}test(e){return!!(this.mask&e.mask)}isEnabled(e){return!!(this.mask&1<<e)}}let sn=0;const on=new _t,ln=new gt,cn=new qt,hn=new _t,un=new _t,dn=new _t,pn=new gt,fn=new _t(1,0,0),mn=new _t(0,1,0),gn=new _t(0,0,1),_n={type:"added"},vn={type:"removed"};class xn extends Ue{constructor(){super(),this.isObject3D=!0,Object.defineProperty(this,"id",{value:sn++}),this.uuid=Oe(),this.name="",this.type="Object3D",this.parent=null,this.children=[],this.up=xn.DEFAULT_UP.clone();const e=new _t,t=new rn,n=new gt,i=new _t(1,1,1);t._onChange((function(){n.setFromEuler(t,!1)})),n._onChange((function(){t.setFromQuaternion(n,void 0,!1)})),Object.defineProperties(this,{position:{configurable:!0,enumerable:!0,value:e},rotation:{configurable:!0,enumerable:!0,value:t},quaternion:{configurable:!0,enumerable:!0,value:n},scale:{configurable:!0,enumerable:!0,value:i},modelViewMatrix:{value:new qt},normalMatrix:{value:new We}}),this.matrix=new qt,this.matrixWorld=new qt,this.matrixAutoUpdate=xn.DEFAULT_MATRIX_AUTO_UPDATE,this.matrixWorldNeedsUpdate=!1,this.matrixWorldAutoUpdate=xn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE,this.layers=new an,this.visible=!0,this.castShadow=!1,this.receiveShadow=!1,this.frustumCulled=!0,this.renderOrder=0,this.animations=[],this.userData={}}onBeforeRender(){}onAfterRender(){}applyMatrix4(e){this.matrixAutoUpdate&&this.updateMatrix(),this.matrix.premultiply(e),this.matrix.decompose(this.position,this.quaternion,this.scale)}applyQuaternion(e){return this.quaternion.premultiply(e),this}setRotationFromAxisAngle(e,t){this.quaternion.setFromAxisAngle(e,t)}setRotationFromEuler(e){this.quaternion.setFromEuler(e,!0)}setRotationFromMatrix(e){this.quaternion.setFromRotationMatrix(e)}setRotationFromQuaternion(e){this.quaternion.copy(e)}rotateOnAxis(e,t){return ln.setFromAxisAngle(e,t),this.quaternion.multiply(ln),this}rotateOnWorldAxis(e,t){return ln.setFromAxisAngle(e,t),this.quaternion.premultiply(ln),this}rotateX(e){return this.rotateOnAxis(fn,e)}rotateY(e){return this.rotateOnAxis(mn,e)}rotateZ(e){return this.rotateOnAxis(gn,e)}translateOnAxis(e,t){return on.copy(e).applyQuaternion(this.quaternion),this.position.add(on.multiplyScalar(t)),this}translateX(e){return this.translateOnAxis(fn,e)}translateY(e){return this.translateOnAxis(mn,e)}translateZ(e){return this.translateOnAxis(gn,e)}localToWorld(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(this.matrixWorld)}worldToLocal(e){return this.updateWorldMatrix(!0,!1),e.applyMatrix4(cn.copy(this.matrixWorld).invert())}lookAt(e,t,n){e.isVector3?hn.copy(e):hn.set(e,t,n);const i=this.parent;this.updateWorldMatrix(!0,!1),un.setFromMatrixPosition(this.matrixWorld),this.isCamera||this.isLight?cn.lookAt(un,hn,this.up):cn.lookAt(hn,un,this.up),this.quaternion.setFromRotationMatrix(cn),i&&(cn.extractRotation(i.matrixWorld),ln.setFromRotationMatrix(cn),this.quaternion.premultiply(ln.invert()))}add(e){if(arguments.length>1){for(let e=0;e<arguments.length;e++)this.add(arguments[e]);return this}return e===this?(console.error("THREE.Object3D.add: object can\'t be added as a child of itself.",e),this):(e&&e.isObject3D?(null!==e.parent&&e.parent.remove(e),e.parent=this,this.children.push(e),e.dispatchEvent(_n)):console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.",e),this)}remove(e){if(arguments.length>1){for(let e=0;e<arguments.length;e++)this.remove(arguments[e]);return this}const t=this.children.indexOf(e);return-1!==t&&(e.parent=null,this.children.splice(t,1),e.dispatchEvent(vn)),this}removeFromParent(){const e=this.parent;return null!==e&&e.remove(this),this}clear(){return this.remove(...this.children)}attach(e){return this.updateWorldMatrix(!0,!1),cn.copy(this.matrixWorld).invert(),null!==e.parent&&(e.parent.updateWorldMatrix(!0,!1),cn.multiply(e.parent.matrixWorld)),e.applyMatrix4(cn),this.add(e),e.updateWorldMatrix(!1,!0),this}getObjectById(e){return this.getObjectByProperty("id",e)}getObjectByName(e){return this.getObjectByProperty("name",e)}getObjectByProperty(e,t){if(this[e]===t)return this;for(let n=0,i=this.children.length;n<i;n++){const i=this.children[n].getObjectByProperty(e,t);if(void 0!==i)return i}}getObjectsByProperty(e,t){let n=[];this[e]===t&&n.push(this);for(let i=0,r=this.children.length;i<r;i++){const r=this.children[i].getObjectsByProperty(e,t);r.length>0&&(n=n.concat(r))}return n}getWorldPosition(e){return this.updateWorldMatrix(!0,!1),e.setFromMatrixPosition(this.matrixWorld)}getWorldQuaternion(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(un,e,dn),e}getWorldScale(e){return this.updateWorldMatrix(!0,!1),this.matrixWorld.decompose(un,pn,e),e}getWorldDirection(e){this.updateWorldMatrix(!0,!1);const t=this.matrixWorld.elements;return e.set(t[8],t[9],t[10]).normalize()}raycast(){}traverse(e){e(this);const t=this.children;for(let n=0,i=t.length;n<i;n++)t[n].traverse(e)}traverseVisible(e){if(!1===this.visible)return;e(this);const t=this.children;for(let n=0,i=t.length;n<i;n++)t[n].traverseVisible(e)}traverseAncestors(e){const t=this.parent;null!==t&&(e(t),t.traverseAncestors(e))}updateMatrix(){this.matrix.compose(this.position,this.quaternion,this.scale),this.matrixWorldNeedsUpdate=!0}updateMatrixWorld(e){this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||e)&&(null===this.parent?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix),this.matrixWorldNeedsUpdate=!1,e=!0);const t=this.children;for(let n=0,i=t.length;n<i;n++){const i=t[n];!0!==i.matrixWorldAutoUpdate&&!0!==e||i.updateMatrixWorld(e)}}updateWorldMatrix(e,t){const n=this.parent;if(!0===e&&null!==n&&!0===n.matrixWorldAutoUpdate&&n.updateWorldMatrix(!0,!1),this.matrixAutoUpdate&&this.updateMatrix(),null===this.parent?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix),!0===t){const e=this.children;for(let t=0,n=e.length;t<n;t++){const n=e[t];!0===n.matrixWorldAutoUpdate&&n.updateWorldMatrix(!1,!0)}}}toJSON(e){const t=void 0===e||"string"==typeof e,n={};t&&(e={geometries:{},materials:{},textures:{},images:{},shapes:{},skeletons:{},animations:{},nodes:{}},n.metadata={version:4.6,type:"Object",generator:"Object3D.toJSON"});const i={};function r(t,n){return void 0===t[n.uuid]&&(t[n.uuid]=n.toJSON(e)),n.uuid}if(i.uuid=this.uuid,i.type=this.type,""!==this.name&&(i.name=this.name),!0===this.castShadow&&(i.castShadow=!0),!0===this.receiveShadow&&(i.receiveShadow=!0),!1===this.visible&&(i.visible=!1),!1===this.frustumCulled&&(i.frustumCulled=!1),0!==this.renderOrder&&(i.renderOrder=this.renderOrder),Object.keys(this.userData).length>0&&(i.userData=this.userData),i.layers=this.layers.mask,i.matrix=this.matrix.toArray(),i.up=this.up.toArray(),!1===this.matrixAutoUpdate&&(i.matrixAutoUpdate=!1),this.isInstancedMesh&&(i.type="InstancedMesh",i.count=this.count,i.instanceMatrix=this.instanceMatrix.toJSON(),null!==this.instanceColor&&(i.instanceColor=this.instanceColor.toJSON())),this.isScene)this.background&&(this.background.isColor?i.background=this.background.toJSON():this.background.isTexture&&(i.background=this.background.toJSON(e).uuid)),this.environment&&this.environment.isTexture&&!0!==this.environment.isRenderTargetTexture&&(i.environment=this.environment.toJSON(e).uuid);else if(this.isMesh||this.isLine||this.isPoints){i.geometry=r(e.geometries,this.geometry);const t=this.geometry.parameters;if(void 0!==t&&void 0!==t.shapes){const n=t.shapes;if(Array.isArray(n))for(let t=0,i=n.length;t<i;t++){const i=n[t];r(e.shapes,i)}else r(e.shapes,n)}}if(this.isSkinnedMesh&&(i.bindMode=this.bindMode,i.bindMatrix=this.bindMatrix.toArray(),void 0!==this.skeleton&&(r(e.skeletons,this.skeleton),i.skeleton=this.skeleton.uuid)),void 0!==this.material)if(Array.isArray(this.material)){const t=[];for(let n=0,i=this.material.length;n<i;n++)t.push(r(e.materials,this.material[n]));i.material=t}else i.material=r(e.materials,this.material);if(this.children.length>0){i.children=[];for(let t=0;t<this.children.length;t++)i.children.push(this.children[t].toJSON(e).object)}if(this.animations.length>0){i.animations=[];for(let t=0;t<this.animations.length;t++){const n=this.animations[t];i.animations.push(r(e.animations,n))}}if(t){const t=a(e.geometries),i=a(e.materials),r=a(e.textures),s=a(e.images),o=a(e.shapes),l=a(e.skeletons),c=a(e.animations),h=a(e.nodes);t.length>0&&(n.geometries=t),i.length>0&&(n.materials=i),r.length>0&&(n.textures=r),s.length>0&&(n.images=s),o.length>0&&(n.shapes=o),l.length>0&&(n.skeletons=l),c.length>0&&(n.animations=c),h.length>0&&(n.nodes=h)}return n.object=i,n;function a(e){const t=[];for(const n in e){const i=e[n];delete i.metadata,t.push(i)}return t}}clone(e){return(new this.constructor).copy(this,e)}copy(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];if(this.name=e.name,this.up.copy(e.up),this.position.copy(e.position),this.rotation.order=e.rotation.order,this.quaternion.copy(e.quaternion),this.scale.copy(e.scale),this.matrix.copy(e.matrix),this.matrixWorld.copy(e.matrixWorld),this.matrixAutoUpdate=e.matrixAutoUpdate,this.matrixWorldNeedsUpdate=e.matrixWorldNeedsUpdate,this.matrixWorldAutoUpdate=e.matrixWorldAutoUpdate,this.layers.mask=e.layers.mask,this.visible=e.visible,this.castShadow=e.castShadow,this.receiveShadow=e.receiveShadow,this.frustumCulled=e.frustumCulled,this.renderOrder=e.renderOrder,this.animations=e.animations.slice(),this.userData=JSON.parse(JSON.stringify(e.userData)),!0===t)for(let t=0;t<e.children.length;t++){const n=e.children[t];this.add(n.clone())}return this}}xn.DEFAULT_UP=new _t(0,1,0),xn.DEFAULT_MATRIX_AUTO_UPDATE=!0,xn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE=!0;const Mn=new _t,Sn=new _t,yn=new _t,En=new _t,Tn=new _t,bn=new _t,wn=new _t,An=new _t,Rn=new _t,Cn=new _t;let Ln=!1;class Pn{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new _t,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:new _t,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:new _t;this.a=e,this.b=t,this.c=n}static getNormal(e,t,n,i){i.subVectors(n,t),Mn.subVectors(e,t),i.cross(Mn);const r=i.lengthSq();return r>0?i.multiplyScalar(1/Math.sqrt(r)):i.set(0,0,0)}static getBarycoord(e,t,n,i,r){Mn.subVectors(i,t),Sn.subVectors(n,t),yn.subVectors(e,t);const a=Mn.dot(Mn),s=Mn.dot(Sn),o=Mn.dot(yn),l=Sn.dot(Sn),c=Sn.dot(yn),h=a*l-s*s;if(0===h)return r.set(-2,-1,-1);const u=1/h,d=(l*o-s*c)*u,p=(a*c-s*o)*u;return r.set(1-d-p,p,d)}static containsPoint(e,t,n,i){return this.getBarycoord(e,t,n,i,En),En.x>=0&&En.y>=0&&En.x+En.y<=1}static getUV(e,t,n,i,r,a,s,o){return!1===Ln&&(console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."),Ln=!0),this.getInterpolation(e,t,n,i,r,a,s,o)}static getInterpolation(e,t,n,i,r,a,s,o){return this.getBarycoord(e,t,n,i,En),o.setScalar(0),o.addScaledVector(r,En.x),o.addScaledVector(a,En.y),o.addScaledVector(s,En.z),o}static isFrontFacing(e,t,n,i){return Mn.subVectors(n,t),Sn.subVectors(e,t),Mn.cross(Sn).dot(i)<0}set(e,t,n){return this.a.copy(e),this.b.copy(t),this.c.copy(n),this}setFromPointsAndIndices(e,t,n,i){return this.a.copy(e[t]),this.b.copy(e[n]),this.c.copy(e[i]),this}setFromAttributeAndIndices(e,t,n,i){return this.a.fromBufferAttribute(e,t),this.b.fromBufferAttribute(e,n),this.c.fromBufferAttribute(e,i),this}clone(){return(new this.constructor).copy(this)}copy(e){return this.a.copy(e.a),this.b.copy(e.b),this.c.copy(e.c),this}getArea(){return Mn.subVectors(this.c,this.b),Sn.subVectors(this.a,this.b),.5*Mn.cross(Sn).length()}getMidpoint(e){return e.addVectors(this.a,this.b).add(this.c).multiplyScalar(1/3)}getNormal(e){return Pn.getNormal(this.a,this.b,this.c,e)}getPlane(e){return e.setFromCoplanarPoints(this.a,this.b,this.c)}getBarycoord(e,t){return Pn.getBarycoord(e,this.a,this.b,this.c,t)}getUV(e,t,n,i,r){return!1===Ln&&(console.warn("THREE.Triangle.getUV() has been renamed to THREE.Triangle.getInterpolation()."),Ln=!0),Pn.getInterpolation(e,this.a,this.b,this.c,t,n,i,r)}getInterpolation(e,t,n,i,r){return Pn.getInterpolation(e,this.a,this.b,this.c,t,n,i,r)}containsPoint(e){return Pn.containsPoint(e,this.a,this.b,this.c)}isFrontFacing(e){return Pn.isFrontFacing(this.a,this.b,this.c,e)}intersectsBox(e){return e.intersectsTriangle(this)}closestPointToPoint(e,t){const n=this.a,i=this.b,r=this.c;let a,s;Tn.subVectors(i,n),bn.subVectors(r,n),An.subVectors(e,n);const o=Tn.dot(An),l=bn.dot(An);if(o<=0&&l<=0)return t.copy(n);Rn.subVectors(e,i);const c=Tn.dot(Rn),h=bn.dot(Rn);if(c>=0&&h<=c)return t.copy(i);const u=o*h-c*l;if(u<=0&&o>=0&&c<=0)return a=o/(o-c),t.copy(n).addScaledVector(Tn,a);Cn.subVectors(e,r);const d=Tn.dot(Cn),p=bn.dot(Cn);if(p>=0&&d<=p)return t.copy(r);const f=d*l-o*p;if(f<=0&&l>=0&&p<=0)return s=l/(l-p),t.copy(n).addScaledVector(bn,s);const m=c*p-d*h;if(m<=0&&h-c>=0&&d-p>=0)return wn.subVectors(r,i),s=(h-c)/(h-c+(d-p)),t.copy(i).addScaledVector(wn,s);const g=1/(m+f+u);return a=f*g,s=u*g,t.copy(n).addScaledVector(Tn,a).addScaledVector(bn,s)}equals(e){return e.a.equals(this.a)&&e.b.equals(this.b)&&e.c.equals(this.c)}}const Un={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,rebeccapurple:6697881,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074},Dn={h:0,s:0,l:0},Nn={h:0,s:0,l:0};function In(e,t,n){return n<0&&(n+=1),n>1&&(n-=1),n<1/6?e+6*(t-e)*n:n<.5?t:n<2/3?e+6*(t-e)*(2/3-n):e}class On{constructor(e,t,n){return this.isColor=!0,this.r=1,this.g=1,this.b=1,this.set(e,t,n)}set(e,t,n){if(void 0===t&&void 0===n){const t=e;t&&t.isColor?this.copy(t):"number"==typeof t?this.setHex(t):"string"==typeof t&&this.setStyle(t)}else this.setRGB(e,t,n);return this}setScalar(e){return this.r=e,this.g=e,this.b=e,this}setHex(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:ue;return e=Math.floor(e),this.r=(e>>16&255)/255,this.g=(e>>8&255)/255,this.b=(255&e)/255,tt.toWorkingColorSpace(this,t),this}setRGB(e,t,n){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:tt.workingColorSpace;return this.r=e,this.g=t,this.b=n,tt.toWorkingColorSpace(this,i),this}setHSL(e,t,n){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:tt.workingColorSpace;if(e=(e%(r=1)+r)%r,t=Fe(t,0,1),n=Fe(n,0,1),0===t)this.r=this.g=this.b=n;else{const i=n<=.5?n*(1+t):n+t-n*t,r=2*n-i;this.r=In(r,i,e+1/3),this.g=In(r,i,e),this.b=In(r,i,e-1/3)}var r;return tt.toWorkingColorSpace(this,i),this}setStyle(e){let t,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:ue;function i(t){void 0!==t&&parseFloat(t)<1&&console.warn("THREE.Color: Alpha component of "+e+" will be ignored.")}if(t=/^(\\w+)\\(([^\\)]*)\\)/.exec(e)){let r;const a=t[1],s=t[2];switch(a){case"rgb":case"rgba":if(r=/^\\s*(\\d+)\\s*,\\s*(\\d+)\\s*,\\s*(\\d+)\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(s))return i(r[4]),this.setRGB(Math.min(255,parseInt(r[1],10))/255,Math.min(255,parseInt(r[2],10))/255,Math.min(255,parseInt(r[3],10))/255,n);if(r=/^\\s*(\\d+)\\%\\s*,\\s*(\\d+)\\%\\s*,\\s*(\\d+)\\%\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(s))return i(r[4]),this.setRGB(Math.min(100,parseInt(r[1],10))/100,Math.min(100,parseInt(r[2],10))/100,Math.min(100,parseInt(r[3],10))/100,n);break;case"hsl":case"hsla":if(r=/^\\s*(\\d*\\.?\\d+)\\s*,\\s*(\\d*\\.?\\d+)\\%\\s*,\\s*(\\d*\\.?\\d+)\\%\\s*(?:,\\s*(\\d*\\.?\\d+)\\s*)?$/.exec(s))return i(r[4]),this.setHSL(parseFloat(r[1])/360,parseFloat(r[2])/100,parseFloat(r[3])/100,n);break;default:console.warn("THREE.Color: Unknown color model "+e)}}else if(t=/^\\#([A-Fa-f\\d]+)$/.exec(e)){const i=t[1],r=i.length;if(3===r)return this.setRGB(parseInt(i.charAt(0),16)/15,parseInt(i.charAt(1),16)/15,parseInt(i.charAt(2),16)/15,n);if(6===r)return this.setHex(parseInt(i,16),n);console.warn("THREE.Color: Invalid hex color "+e)}else if(e&&e.length>0)return this.setColorName(e,n);return this}setColorName(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:ue;const n=Un[e.toLowerCase()];return void 0!==n?this.setHex(n,t):console.warn("THREE.Color: Unknown color "+e),this}clone(){return new this.constructor(this.r,this.g,this.b)}copy(e){return this.r=e.r,this.g=e.g,this.b=e.b,this}copySRGBToLinear(e){return this.r=nt(e.r),this.g=nt(e.g),this.b=nt(e.b),this}copyLinearToSRGB(e){return this.r=it(e.r),this.g=it(e.g),this.b=it(e.b),this}convertSRGBToLinear(){return this.copySRGBToLinear(this),this}convertLinearToSRGB(){return this.copyLinearToSRGB(this),this}getHex(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:ue;return tt.fromWorkingColorSpace(Fn.copy(this),e),65536*Math.round(Fe(255*Fn.r,0,255))+256*Math.round(Fe(255*Fn.g,0,255))+Math.round(Fe(255*Fn.b,0,255))}getHexString(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:ue;return("000000"+this.getHex(e).toString(16)).slice(-6)}getHSL(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:tt.workingColorSpace;tt.fromWorkingColorSpace(Fn.copy(this),t);const n=Fn.r,i=Fn.g,r=Fn.b,a=Math.max(n,i,r),s=Math.min(n,i,r);let o,l;const c=(s+a)/2;if(s===a)o=0,l=0;else{const e=a-s;switch(l=c<=.5?e/(a+s):e/(2-a-s),a){case n:o=(i-r)/e+(i<r?6:0);break;case i:o=(r-n)/e+2;break;case r:o=(n-i)/e+4}o/=6}return e.h=o,e.s=l,e.l=c,e}getRGB(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:tt.workingColorSpace;return tt.fromWorkingColorSpace(Fn.copy(this),t),e.r=Fn.r,e.g=Fn.g,e.b=Fn.b,e}getStyle(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:ue;tt.fromWorkingColorSpace(Fn.copy(this),e);const t=Fn.r,n=Fn.g,i=Fn.b;return e!==ue?"color(".concat(e," ").concat(t.toFixed(3)," ").concat(n.toFixed(3)," ").concat(i.toFixed(3),")"):"rgb(".concat(Math.round(255*t),",").concat(Math.round(255*n),",").concat(Math.round(255*i),")")}offsetHSL(e,t,n){return this.getHSL(Dn),this.setHSL(Dn.h+e,Dn.s+t,Dn.l+n)}add(e){return this.r+=e.r,this.g+=e.g,this.b+=e.b,this}addColors(e,t){return this.r=e.r+t.r,this.g=e.g+t.g,this.b=e.b+t.b,this}addScalar(e){return this.r+=e,this.g+=e,this.b+=e,this}sub(e){return this.r=Math.max(0,this.r-e.r),this.g=Math.max(0,this.g-e.g),this.b=Math.max(0,this.b-e.b),this}multiply(e){return this.r*=e.r,this.g*=e.g,this.b*=e.b,this}multiplyScalar(e){return this.r*=e,this.g*=e,this.b*=e,this}lerp(e,t){return this.r+=(e.r-this.r)*t,this.g+=(e.g-this.g)*t,this.b+=(e.b-this.b)*t,this}lerpColors(e,t,n){return this.r=e.r+(t.r-e.r)*n,this.g=e.g+(t.g-e.g)*n,this.b=e.b+(t.b-e.b)*n,this}lerpHSL(e,t){this.getHSL(Dn),e.getHSL(Nn);const n=ze(Dn.h,Nn.h,t),i=ze(Dn.s,Nn.s,t),r=ze(Dn.l,Nn.l,t);return this.setHSL(n,i,r),this}setFromVector3(e){return this.r=e.x,this.g=e.y,this.b=e.z,this}applyMatrix3(e){const t=this.r,n=this.g,i=this.b,r=e.elements;return this.r=r[0]*t+r[3]*n+r[6]*i,this.g=r[1]*t+r[4]*n+r[7]*i,this.b=r[2]*t+r[5]*n+r[8]*i,this}equals(e){return e.r===this.r&&e.g===this.g&&e.b===this.b}fromArray(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this.r=e[t],this.g=e[t+1],this.b=e[t+2],this}toArray(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return e[t]=this.r,e[t+1]=this.g,e[t+2]=this.b,e}fromBufferAttribute(e,t){return this.r=e.getX(t),this.g=e.getY(t),this.b=e.getZ(t),this}toJSON(){return this.getHex()}*[Symbol.iterator](){yield this.r,yield this.g,yield this.b}}const Fn=new On;On.NAMES=Un;let zn=0;class Bn extends Ue{constructor(){super(),this.isMaterial=!0,Object.defineProperty(this,"id",{value:zn++}),this.uuid=Oe(),this.name="",this.type="Material",this.blending=1,this.side=0,this.vertexColors=!1,this.opacity=1,this.transparent=!1,this.alphaHash=!1,this.blendSrc=204,this.blendDst=205,this.blendEquation=o,this.blendSrcAlpha=null,this.blendDstAlpha=null,this.blendEquationAlpha=null,this.blendColor=new On(0,0,0),this.blendAlpha=0,this.depthFunc=3,this.depthTest=!0,this.depthWrite=!0,this.stencilWriteMask=255,this.stencilFunc=519,this.stencilRef=0,this.stencilFuncMask=255,this.stencilFail=xe,this.stencilZFail=xe,this.stencilZPass=xe,this.stencilWrite=!1,this.clippingPlanes=null,this.clipIntersection=!1,this.clipShadows=!1,this.shadowSide=null,this.colorWrite=!0,this.precision=null,this.polygonOffset=!1,this.polygonOffsetFactor=0,this.polygonOffsetUnits=0,this.dithering=!1,this.alphaToCoverage=!1,this.premultipliedAlpha=!1,this.forceSinglePass=!1,this.visible=!0,this.toneMapped=!0,this.userData={},this.version=0,this._alphaTest=0}get alphaTest(){return this._alphaTest}set alphaTest(e){this._alphaTest>0!=e>0&&this.version++,this._alphaTest=e}onBuild(){}onBeforeRender(){}onBeforeCompile(){}customProgramCacheKey(){return this.onBeforeCompile.toString()}setValues(e){if(void 0!==e)for(const t in e){const n=e[t];if(void 0===n){console.warn("THREE.Material: parameter \'".concat(t,"\' has value of undefined."));continue}const i=this[t];void 0!==i?i&&i.isColor?i.set(n):i&&i.isVector3&&n&&n.isVector3?i.copy(n):this[t]=n:console.warn("THREE.Material: \'".concat(t,"\' is not a property of THREE.").concat(this.type,"."))}}toJSON(e){const t=void 0===e||"string"==typeof e;t&&(e={textures:{},images:{}});const n={metadata:{version:4.6,type:"Material",generator:"Material.toJSON"}};function i(e){const t=[];for(const n in e){const i=e[n];delete i.metadata,t.push(i)}return t}if(n.uuid=this.uuid,n.type=this.type,""!==this.name&&(n.name=this.name),this.color&&this.color.isColor&&(n.color=this.color.getHex()),void 0!==this.roughness&&(n.roughness=this.roughness),void 0!==this.metalness&&(n.metalness=this.metalness),void 0!==this.sheen&&(n.sheen=this.sheen),this.sheenColor&&this.sheenColor.isColor&&(n.sheenColor=this.sheenColor.getHex()),void 0!==this.sheenRoughness&&(n.sheenRoughness=this.sheenRoughness),this.emissive&&this.emissive.isColor&&(n.emissive=this.emissive.getHex()),this.emissiveIntensity&&1!==this.emissiveIntensity&&(n.emissiveIntensity=this.emissiveIntensity),this.specular&&this.specular.isColor&&(n.specular=this.specular.getHex()),void 0!==this.specularIntensity&&(n.specularIntensity=this.specularIntensity),this.specularColor&&this.specularColor.isColor&&(n.specularColor=this.specularColor.getHex()),void 0!==this.shininess&&(n.shininess=this.shininess),void 0!==this.clearcoat&&(n.clearcoat=this.clearcoat),void 0!==this.clearcoatRoughness&&(n.clearcoatRoughness=this.clearcoatRoughness),this.clearcoatMap&&this.clearcoatMap.isTexture&&(n.clearcoatMap=this.clearcoatMap.toJSON(e).uuid),this.clearcoatRoughnessMap&&this.clearcoatRoughnessMap.isTexture&&(n.clearcoatRoughnessMap=this.clearcoatRoughnessMap.toJSON(e).uuid),this.clearcoatNormalMap&&this.clearcoatNormalMap.isTexture&&(n.clearcoatNormalMap=this.clearcoatNormalMap.toJSON(e).uuid,n.clearcoatNormalScale=this.clearcoatNormalScale.toArray()),void 0!==this.iridescence&&(n.iridescence=this.iridescence),void 0!==this.iridescenceIOR&&(n.iridescenceIOR=this.iridescenceIOR),void 0!==this.iridescenceThicknessRange&&(n.iridescenceThicknessRange=this.iridescenceThicknessRange),this.iridescenceMap&&this.iridescenceMap.isTexture&&(n.iridescenceMap=this.iridescenceMap.toJSON(e).uuid),this.iridescenceThicknessMap&&this.iridescenceThicknessMap.isTexture&&(n.iridescenceThicknessMap=this.iridescenceThicknessMap.toJSON(e).uuid),void 0!==this.anisotropy&&(n.anisotropy=this.anisotropy),void 0!==this.anisotropyRotation&&(n.anisotropyRotation=this.anisotropyRotation),this.anisotropyMap&&this.anisotropyMap.isTexture&&(n.anisotropyMap=this.anisotropyMap.toJSON(e).uuid),this.map&&this.map.isTexture&&(n.map=this.map.toJSON(e).uuid),this.matcap&&this.matcap.isTexture&&(n.matcap=this.matcap.toJSON(e).uuid),this.alphaMap&&this.alphaMap.isTexture&&(n.alphaMap=this.alphaMap.toJSON(e).uuid),this.lightMap&&this.lightMap.isTexture&&(n.lightMap=this.lightMap.toJSON(e).uuid,n.lightMapIntensity=this.lightMapIntensity),this.aoMap&&this.aoMap.isTexture&&(n.aoMap=this.aoMap.toJSON(e).uuid,n.aoMapIntensity=this.aoMapIntensity),this.bumpMap&&this.bumpMap.isTexture&&(n.bumpMap=this.bumpMap.toJSON(e).uuid,n.bumpScale=this.bumpScale),this.normalMap&&this.normalMap.isTexture&&(n.normalMap=this.normalMap.toJSON(e).uuid,n.normalMapType=this.normalMapType,n.normalScale=this.normalScale.toArray()),this.displacementMap&&this.displacementMap.isTexture&&(n.displacementMap=this.displacementMap.toJSON(e).uuid,n.displacementScale=this.displacementScale,n.displacementBias=this.displacementBias),this.roughnessMap&&this.roughnessMap.isTexture&&(n.roughnessMap=this.roughnessMap.toJSON(e).uuid),this.metalnessMap&&this.metalnessMap.isTexture&&(n.metalnessMap=this.metalnessMap.toJSON(e).uuid),this.emissiveMap&&this.emissiveMap.isTexture&&(n.emissiveMap=this.emissiveMap.toJSON(e).uuid),this.specularMap&&this.specularMap.isTexture&&(n.specularMap=this.specularMap.toJSON(e).uuid),this.specularIntensityMap&&this.specularIntensityMap.isTexture&&(n.specularIntensityMap=this.specularIntensityMap.toJSON(e).uuid),this.specularColorMap&&this.specularColorMap.isTexture&&(n.specularColorMap=this.specularColorMap.toJSON(e).uuid),this.envMap&&this.envMap.isTexture&&(n.envMap=this.envMap.toJSON(e).uuid,void 0!==this.combine&&(n.combine=this.combine)),void 0!==this.envMapIntensity&&(n.envMapIntensity=this.envMapIntensity),void 0!==this.reflectivity&&(n.reflectivity=this.reflectivity),void 0!==this.refractionRatio&&(n.refractionRatio=this.refractionRatio),this.gradientMap&&this.gradientMap.isTexture&&(n.gradientMap=this.gradientMap.toJSON(e).uuid),void 0!==this.transmission&&(n.transmission=this.transmission),this.transmissionMap&&this.transmissionMap.isTexture&&(n.transmissionMap=this.transmissionMap.toJSON(e).uuid),void 0!==this.thickness&&(n.thickness=this.thickness),this.thicknessMap&&this.thicknessMap.isTexture&&(n.thicknessMap=this.thicknessMap.toJSON(e).uuid),void 0!==this.attenuationDistance&&this.attenuationDistance!==1/0&&(n.attenuationDistance=this.attenuationDistance),void 0!==this.attenuationColor&&(n.attenuationColor=this.attenuationColor.getHex()),void 0!==this.size&&(n.size=this.size),null!==this.shadowSide&&(n.shadowSide=this.shadowSide),void 0!==this.sizeAttenuation&&(n.sizeAttenuation=this.sizeAttenuation),1!==this.blending&&(n.blending=this.blending),0!==this.side&&(n.side=this.side),!0===this.vertexColors&&(n.vertexColors=!0),this.opacity<1&&(n.opacity=this.opacity),!0===this.transparent&&(n.transparent=!0),204!==this.blendSrc&&(n.blendSrc=this.blendSrc),205!==this.blendDst&&(n.blendDst=this.blendDst),this.blendEquation!==o&&(n.blendEquation=this.blendEquation),null!==this.blendSrcAlpha&&(n.blendSrcAlpha=this.blendSrcAlpha),null!==this.blendDstAlpha&&(n.blendDstAlpha=this.blendDstAlpha),null!==this.blendEquationAlpha&&(n.blendEquationAlpha=this.blendEquationAlpha),this.blendColor&&this.blendColor.isColor&&(n.blendColor=this.blendColor.getHex()),0!==this.blendAlpha&&(n.blendAlpha=this.blendAlpha),3!==this.depthFunc&&(n.depthFunc=this.depthFunc),!1===this.depthTest&&(n.depthTest=this.depthTest),!1===this.depthWrite&&(n.depthWrite=this.depthWrite),!1===this.colorWrite&&(n.colorWrite=this.colorWrite),255!==this.stencilWriteMask&&(n.stencilWriteMask=this.stencilWriteMask),519!==this.stencilFunc&&(n.stencilFunc=this.stencilFunc),0!==this.stencilRef&&(n.stencilRef=this.stencilRef),255!==this.stencilFuncMask&&(n.stencilFuncMask=this.stencilFuncMask),this.stencilFail!==xe&&(n.stencilFail=this.stencilFail),this.stencilZFail!==xe&&(n.stencilZFail=this.stencilZFail),this.stencilZPass!==xe&&(n.stencilZPass=this.stencilZPass),!0===this.stencilWrite&&(n.stencilWrite=this.stencilWrite),void 0!==this.rotation&&0!==this.rotation&&(n.rotation=this.rotation),!0===this.polygonOffset&&(n.polygonOffset=!0),0!==this.polygonOffsetFactor&&(n.polygonOffsetFactor=this.polygonOffsetFactor),0!==this.polygonOffsetUnits&&(n.polygonOffsetUnits=this.polygonOffsetUnits),void 0!==this.linewidth&&1!==this.linewidth&&(n.linewidth=this.linewidth),void 0!==this.dashSize&&(n.dashSize=this.dashSize),void 0!==this.gapSize&&(n.gapSize=this.gapSize),void 0!==this.scale&&(n.scale=this.scale),!0===this.dithering&&(n.dithering=!0),this.alphaTest>0&&(n.alphaTest=this.alphaTest),!0===this.alphaHash&&(n.alphaHash=!0),!0===this.alphaToCoverage&&(n.alphaToCoverage=!0),!0===this.premultipliedAlpha&&(n.premultipliedAlpha=!0),!0===this.forceSinglePass&&(n.forceSinglePass=!0),!0===this.wireframe&&(n.wireframe=!0),this.wireframeLinewidth>1&&(n.wireframeLinewidth=this.wireframeLinewidth),"round"!==this.wireframeLinecap&&(n.wireframeLinecap=this.wireframeLinecap),"round"!==this.wireframeLinejoin&&(n.wireframeLinejoin=this.wireframeLinejoin),!0===this.flatShading&&(n.flatShading=!0),!1===this.visible&&(n.visible=!1),!1===this.toneMapped&&(n.toneMapped=!1),!1===this.fog&&(n.fog=!1),Object.keys(this.userData).length>0&&(n.userData=this.userData),t){const t=i(e.textures),r=i(e.images);t.length>0&&(n.textures=t),r.length>0&&(n.images=r)}return n}clone(){return(new this.constructor).copy(this)}copy(e){this.name=e.name,this.blending=e.blending,this.side=e.side,this.vertexColors=e.vertexColors,this.opacity=e.opacity,this.transparent=e.transparent,this.blendSrc=e.blendSrc,this.blendDst=e.blendDst,this.blendEquation=e.blendEquation,this.blendSrcAlpha=e.blendSrcAlpha,this.blendDstAlpha=e.blendDstAlpha,this.blendEquationAlpha=e.blendEquationAlpha,this.blendColor.copy(e.blendColor),this.blendAlpha=e.blendAlpha,this.depthFunc=e.depthFunc,this.depthTest=e.depthTest,this.depthWrite=e.depthWrite,this.stencilWriteMask=e.stencilWriteMask,this.stencilFunc=e.stencilFunc,this.stencilRef=e.stencilRef,this.stencilFuncMask=e.stencilFuncMask,this.stencilFail=e.stencilFail,this.stencilZFail=e.stencilZFail,this.stencilZPass=e.stencilZPass,this.stencilWrite=e.stencilWrite;const t=e.clippingPlanes;let n=null;if(null!==t){const e=t.length;n=new Array(e);for(let i=0;i!==e;++i)n[i]=t[i].clone()}return this.clippingPlanes=n,this.clipIntersection=e.clipIntersection,this.clipShadows=e.clipShadows,this.shadowSide=e.shadowSide,this.colorWrite=e.colorWrite,this.precision=e.precision,this.polygonOffset=e.polygonOffset,this.polygonOffsetFactor=e.polygonOffsetFactor,this.polygonOffsetUnits=e.polygonOffsetUnits,this.dithering=e.dithering,this.alphaTest=e.alphaTest,this.alphaHash=e.alphaHash,this.alphaToCoverage=e.alphaToCoverage,this.premultipliedAlpha=e.premultipliedAlpha,this.forceSinglePass=e.forceSinglePass,this.visible=e.visible,this.toneMapped=e.toneMapped,this.userData=JSON.parse(JSON.stringify(e.userData)),this}dispose(){this.dispatchEvent({type:"dispose"})}set needsUpdate(e){!0===e&&this.version++}}class Hn extends Bn{constructor(e){super(),this.isMeshBasicMaterial=!0,this.type="MeshBasicMaterial",this.color=new On(16777215),this.map=null,this.lightMap=null,this.lightMapIntensity=1,this.aoMap=null,this.aoMapIntensity=1,this.specularMap=null,this.alphaMap=null,this.envMap=null,this.combine=b,this.reflectivity=1,this.refractionRatio=.98,this.wireframe=!1,this.wireframeLinewidth=1,this.wireframeLinecap="round",this.wireframeLinejoin="round",this.fog=!0,this.setValues(e)}copy(e){return super.copy(e),this.color.copy(e.color),this.map=e.map,this.lightMap=e.lightMap,this.lightMapIntensity=e.lightMapIntensity,this.aoMap=e.aoMap,this.aoMapIntensity=e.aoMapIntensity,this.specularMap=e.specularMap,this.alphaMap=e.alphaMap,this.envMap=e.envMap,this.combine=e.combine,this.reflectivity=e.reflectivity,this.refractionRatio=e.refractionRatio,this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this.wireframeLinecap=e.wireframeLinecap,this.wireframeLinejoin=e.wireframeLinejoin,this.fog=e.fog,this}}const Vn=Gn();function Gn(){const e=new ArrayBuffer(4),t=new Float32Array(e),n=new Uint32Array(e),i=new Uint32Array(512),r=new Uint32Array(512);for(let e=0;e<256;++e){const t=e-127;t<-27?(i[e]=0,i[256|e]=32768,r[e]=24,r[256|e]=24):t<-14?(i[e]=1024>>-t-14,i[256|e]=1024>>-t-14|32768,r[e]=-t-1,r[256|e]=-t-1):t<=15?(i[e]=t+15<<10,i[256|e]=t+15<<10|32768,r[e]=13,r[256|e]=13):t<128?(i[e]=31744,i[256|e]=64512,r[e]=24,r[256|e]=24):(i[e]=31744,i[256|e]=64512,r[e]=13,r[256|e]=13)}const a=new Uint32Array(2048),s=new Uint32Array(64),o=new Uint32Array(64);for(let e=1;e<1024;++e){let t=e<<13,n=0;for(;!(8388608&t);)t<<=1,n-=8388608;t&=-8388609,n+=947912704,a[e]=t|n}for(let e=1024;e<2048;++e)a[e]=939524096+(e-1024<<13);for(let e=1;e<31;++e)s[e]=e<<23;s[31]=1199570944,s[32]=2147483648;for(let e=33;e<63;++e)s[e]=2147483648+(e-32<<23);s[63]=3347054592;for(let e=1;e<64;++e)32!==e&&(o[e]=1024);return{floatView:t,uint32View:n,baseTable:i,shiftTable:r,mantissaTable:a,exponentTable:s,offsetTable:o}}const kn={toHalfFloat:function(e){Math.abs(e)>65504&&console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."),e=Fe(e,-65504,65504),Vn.floatView[0]=e;const t=Vn.uint32View[0],n=t>>23&511;return Vn.baseTable[n]+((8388607&t)>>Vn.shiftTable[n])},fromHalfFloat:function(e){const t=e>>10;return Vn.uint32View[0]=Vn.mantissaTable[Vn.offsetTable[t]+(1023&e)]+Vn.exponentTable[t],Vn.floatView[0]}},Wn=new _t,Xn=new ke;class jn{constructor(e,t){let n=arguments.length>2&&void 0!==arguments[2]&&arguments[2];if(Array.isArray(e))throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");this.isBufferAttribute=!0,this.name="",this.array=e,this.itemSize=t,this.count=void 0!==e?e.length/t:0,this.normalized=n,this.usage=35044,this.updateRange={offset:0,count:-1},this.gpuType=K,this.version=0}onUploadCallback(){}set needsUpdate(e){!0===e&&this.version++}setUsage(e){return this.usage=e,this}copy(e){return this.name=e.name,this.array=new e.array.constructor(e.array),this.itemSize=e.itemSize,this.count=e.count,this.normalized=e.normalized,this.usage=e.usage,this.gpuType=e.gpuType,this}copyAt(e,t,n){e*=this.itemSize,n*=t.itemSize;for(let i=0,r=this.itemSize;i<r;i++)this.array[e+i]=t.array[n+i];return this}copyArray(e){return this.array.set(e),this}applyMatrix3(e){if(2===this.itemSize)for(let t=0,n=this.count;t<n;t++)Xn.fromBufferAttribute(this,t),Xn.applyMatrix3(e),this.setXY(t,Xn.x,Xn.y);else if(3===this.itemSize)for(let t=0,n=this.count;t<n;t++)Wn.fromBufferAttribute(this,t),Wn.applyMatrix3(e),this.setXYZ(t,Wn.x,Wn.y,Wn.z);return this}applyMatrix4(e){for(let t=0,n=this.count;t<n;t++)Wn.fromBufferAttribute(this,t),Wn.applyMatrix4(e),this.setXYZ(t,Wn.x,Wn.y,Wn.z);return this}applyNormalMatrix(e){for(let t=0,n=this.count;t<n;t++)Wn.fromBufferAttribute(this,t),Wn.applyNormalMatrix(e),this.setXYZ(t,Wn.x,Wn.y,Wn.z);return this}transformDirection(e){for(let t=0,n=this.count;t<n;t++)Wn.fromBufferAttribute(this,t),Wn.transformDirection(e),this.setXYZ(t,Wn.x,Wn.y,Wn.z);return this}set(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;return this.array.set(e,t),this}getComponent(e,t){let n=this.array[e*this.itemSize+t];return this.normalized&&(n=Ve(n,this.array)),n}setComponent(e,t,n){return this.normalized&&(n=Ge(n,this.array)),this.array[e*this.itemSize+t]=n,this}getX(e){let t=this.array[e*this.itemSize];return this.normalized&&(t=Ve(t,this.array)),t}setX(e,t){return this.normalized&&(t=Ge(t,this.array)),this.array[e*this.itemSize]=t,this}getY(e){let t=this.array[e*this.itemSize+1];return this.normalized&&(t=Ve(t,this.array)),t}setY(e,t){return this.normalized&&(t=Ge(t,this.array)),this.array[e*this.itemSize+1]=t,this}getZ(e){let t=this.array[e*this.itemSize+2];return this.normalized&&(t=Ve(t,this.array)),t}setZ(e,t){return this.normalized&&(t=Ge(t,this.array)),this.array[e*this.itemSize+2]=t,this}getW(e){let t=this.array[e*this.itemSize+3];return this.normalized&&(t=Ve(t,this.array)),t}setW(e,t){return this.normalized&&(t=Ge(t,this.array)),this.array[e*this.itemSize+3]=t,this}setXY(e,t,n){return e*=this.itemSize,this.normalized&&(t=Ge(t,this.array),n=Ge(n,this.array)),this.array[e+0]=t,this.array[e+1]=n,this}setXYZ(e,t,n,i){return e*=this.itemSize,this.normalized&&(t=Ge(t,this.array),n=Ge(n,this.array),i=Ge(i,this.array)),this.array[e+0]=t,this.array[e+1]=n,this.array[e+2]=i,this}setXYZW(e,t,n,i,r){return e*=this.itemSize,this.normalized&&(t=Ge(t,this.array),n=Ge(n,this.array),i=Ge(i,this.array),r=Ge(r,this.array)),this.array[e+0]=t,this.array[e+1]=n,this.array[e+2]=i,this.array[e+3]=r,this}onUpload(e){return this.onUploadCallback=e,this}clone(){return new this.constructor(this.array,this.itemSize).copy(this)}toJSON(){const e={itemSize:this.itemSize,type:this.array.constructor.name,array:Array.from(this.array),normalized:this.normalized};return""!==this.name&&(e.name=this.name),35044!==this.usage&&(e.usage=this.usage),0===this.updateRange.offset&&-1===this.updateRange.count||(e.updateRange=this.updateRange),e}}class qn extends jn{constructor(e,t,n){super(new Uint16Array(e),t,n)}}class Yn extends jn{constructor(e,t,n){super(new Uint32Array(e),t,n)}}class Kn extends jn{constructor(e,t,n){super(new Float32Array(e),t,n)}}let Zn=0;const Jn=new qt,Qn=new xn,$n=new _t,ei=new Mt,ti=new Mt,ni=new _t;class ii extends Ue{constructor(){super(),this.isBufferGeometry=!0,Object.defineProperty(this,"id",{value:Zn++}),this.uuid=Oe(),this.name="",this.type="BufferGeometry",this.index=null,this.attributes={},this.morphAttributes={},this.morphTargetsRelative=!1,this.groups=[],this.boundingBox=null,this.boundingSphere=null,this.drawRange={start:0,count:1/0},this.userData={}}getIndex(){return this.index}setIndex(e){return Array.isArray(e)?this.index=new(je(e)?Yn:qn)(e,1):this.index=e,this}getAttribute(e){return this.attributes[e]}setAttribute(e,t){return this.attributes[e]=t,this}deleteAttribute(e){return delete this.attributes[e],this}hasAttribute(e){return void 0!==this.attributes[e]}addGroup(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;this.groups.push({start:e,count:t,materialIndex:n})}clearGroups(){this.groups=[]}setDrawRange(e,t){this.drawRange.start=e,this.drawRange.count=t}applyMatrix4(e){const t=this.attributes.position;void 0!==t&&(t.applyMatrix4(e),t.needsUpdate=!0);const n=this.attributes.normal;if(void 0!==n){const t=(new We).getNormalMatrix(e);n.applyNormalMatrix(t),n.needsUpdate=!0}const i=this.attributes.tangent;return void 0!==i&&(i.transformDirection(e),i.needsUpdate=!0),null!==this.boundingBox&&this.computeBoundingBox(),null!==this.boundingSphere&&this.computeBoundingSphere(),this}applyQuaternion(e){return Jn.makeRotationFromQuaternion(e),this.applyMatrix4(Jn),this}rotateX(e){return Jn.makeRotationX(e),this.applyMatrix4(Jn),this}rotateY(e){return Jn.makeRotationY(e),this.applyMatrix4(Jn),this}rotateZ(e){return Jn.makeRotationZ(e),this.applyMatrix4(Jn),this}translate(e,t,n){return Jn.makeTranslation(e,t,n),this.applyMatrix4(Jn),this}scale(e,t,n){return Jn.makeScale(e,t,n),this.applyMatrix4(Jn),this}lookAt(e){return Qn.lookAt(e),Qn.updateMatrix(),this.applyMatrix4(Qn.matrix),this}center(){return this.computeBoundingBox(),this.boundingBox.getCenter($n).negate(),this.translate($n.x,$n.y,$n.z),this}setFromPoints(e){const t=[];for(let n=0,i=e.length;n<i;n++){const i=e[n];t.push(i.x,i.y,i.z||0)}return this.setAttribute("position",new Kn(t,3)),this}computeBoundingBox(){null===this.boundingBox&&(this.boundingBox=new Mt);const e=this.attributes.position,t=this.morphAttributes.position;if(e&&e.isGLBufferAttribute)return console.error(\'THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".\',this),void this.boundingBox.set(new _t(-1/0,-1/0,-1/0),new _t(1/0,1/0,1/0));if(void 0!==e){if(this.boundingBox.setFromBufferAttribute(e),t)for(let e=0,n=t.length;e<n;e++){const n=t[e];ei.setFromBufferAttribute(n),this.morphTargetsRelative?(ni.addVectors(this.boundingBox.min,ei.min),this.boundingBox.expandByPoint(ni),ni.addVectors(this.boundingBox.max,ei.max),this.boundingBox.expandByPoint(ni)):(this.boundingBox.expandByPoint(ei.min),this.boundingBox.expandByPoint(ei.max))}}else this.boundingBox.makeEmpty();(isNaN(this.boundingBox.min.x)||isNaN(this.boundingBox.min.y)||isNaN(this.boundingBox.min.z))&&console.error(\'THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.\',this)}computeBoundingSphere(){null===this.boundingSphere&&(this.boundingSphere=new zt);const e=this.attributes.position,t=this.morphAttributes.position;if(e&&e.isGLBufferAttribute)return console.error(\'THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".\',this),void this.boundingSphere.set(new _t,1/0);if(e){const n=this.boundingSphere.center;if(ei.setFromBufferAttribute(e),t)for(let e=0,n=t.length;e<n;e++){const n=t[e];ti.setFromBufferAttribute(n),this.morphTargetsRelative?(ni.addVectors(ei.min,ti.min),ei.expandByPoint(ni),ni.addVectors(ei.max,ti.max),ei.expandByPoint(ni)):(ei.expandByPoint(ti.min),ei.expandByPoint(ti.max))}ei.getCenter(n);let i=0;for(let t=0,r=e.count;t<r;t++)ni.fromBufferAttribute(e,t),i=Math.max(i,n.distanceToSquared(ni));if(t)for(let r=0,a=t.length;r<a;r++){const a=t[r],s=this.morphTargetsRelative;for(let t=0,r=a.count;t<r;t++)ni.fromBufferAttribute(a,t),s&&($n.fromBufferAttribute(e,t),ni.add($n)),i=Math.max(i,n.distanceToSquared(ni))}this.boundingSphere.radius=Math.sqrt(i),isNaN(this.boundingSphere.radius)&&console.error(\'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.\',this)}}computeTangents(){const e=this.index,t=this.attributes;if(null===e||void 0===t.position||void 0===t.normal||void 0===t.uv)return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");const n=e.array,i=t.position.array,r=t.normal.array,a=t.uv.array,s=i.length/3;!1===this.hasAttribute("tangent")&&this.setAttribute("tangent",new jn(new Float32Array(4*s),4));const o=this.getAttribute("tangent").array,l=[],c=[];for(let e=0;e<s;e++)l[e]=new _t,c[e]=new _t;const h=new _t,u=new _t,d=new _t,p=new ke,f=new ke,m=new ke,g=new _t,_=new _t;function v(e,t,n){h.fromArray(i,3*e),u.fromArray(i,3*t),d.fromArray(i,3*n),p.fromArray(a,2*e),f.fromArray(a,2*t),m.fromArray(a,2*n),u.sub(h),d.sub(h),f.sub(p),m.sub(p);const r=1/(f.x*m.y-m.x*f.y);isFinite(r)&&(g.copy(u).multiplyScalar(m.y).addScaledVector(d,-f.y).multiplyScalar(r),_.copy(d).multiplyScalar(f.x).addScaledVector(u,-m.x).multiplyScalar(r),l[e].add(g),l[t].add(g),l[n].add(g),c[e].add(_),c[t].add(_),c[n].add(_))}let x=this.groups;0===x.length&&(x=[{start:0,count:n.length}]);for(let e=0,t=x.length;e<t;++e){const t=x[e],i=t.start;for(let e=i,r=i+t.count;e<r;e+=3)v(n[e+0],n[e+1],n[e+2])}const M=new _t,S=new _t,y=new _t,E=new _t;function T(e){y.fromArray(r,3*e),E.copy(y);const t=l[e];M.copy(t),M.sub(y.multiplyScalar(y.dot(t))).normalize(),S.crossVectors(E,t);const n=S.dot(c[e])<0?-1:1;o[4*e]=M.x,o[4*e+1]=M.y,o[4*e+2]=M.z,o[4*e+3]=n}for(let e=0,t=x.length;e<t;++e){const t=x[e],i=t.start;for(let e=i,r=i+t.count;e<r;e+=3)T(n[e+0]),T(n[e+1]),T(n[e+2])}}computeVertexNormals(){const e=this.index,t=this.getAttribute("position");if(void 0!==t){let n=this.getAttribute("normal");if(void 0===n)n=new jn(new Float32Array(3*t.count),3),this.setAttribute("normal",n);else for(let e=0,t=n.count;e<t;e++)n.setXYZ(e,0,0,0);const i=new _t,r=new _t,a=new _t,s=new _t,o=new _t,l=new _t,c=new _t,h=new _t;if(e)for(let u=0,d=e.count;u<d;u+=3){const d=e.getX(u+0),p=e.getX(u+1),f=e.getX(u+2);i.fromBufferAttribute(t,d),r.fromBufferAttribute(t,p),a.fromBufferAttribute(t,f),c.subVectors(a,r),h.subVectors(i,r),c.cross(h),s.fromBufferAttribute(n,d),o.fromBufferAttribute(n,p),l.fromBufferAttribute(n,f),s.add(c),o.add(c),l.add(c),n.setXYZ(d,s.x,s.y,s.z),n.setXYZ(p,o.x,o.y,o.z),n.setXYZ(f,l.x,l.y,l.z)}else for(let e=0,s=t.count;e<s;e+=3)i.fromBufferAttribute(t,e+0),r.fromBufferAttribute(t,e+1),a.fromBufferAttribute(t,e+2),c.subVectors(a,r),h.subVectors(i,r),c.cross(h),n.setXYZ(e+0,c.x,c.y,c.z),n.setXYZ(e+1,c.x,c.y,c.z),n.setXYZ(e+2,c.x,c.y,c.z);this.normalizeNormals(),n.needsUpdate=!0}}normalizeNormals(){const e=this.attributes.normal;for(let t=0,n=e.count;t<n;t++)ni.fromBufferAttribute(e,t),ni.normalize(),e.setXYZ(t,ni.x,ni.y,ni.z)}toNonIndexed(){function e(e,t){const n=e.array,i=e.itemSize,r=e.normalized,a=new n.constructor(t.length*i);let s=0,o=0;for(let r=0,l=t.length;r<l;r++){s=e.isInterleavedBufferAttribute?t[r]*e.data.stride+e.offset:t[r]*i;for(let e=0;e<i;e++)a[o++]=n[s++]}return new jn(a,i,r)}if(null===this.index)return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."),this;const t=new ii,n=this.index.array,i=this.attributes;for(const r in i){const a=e(i[r],n);t.setAttribute(r,a)}const r=this.morphAttributes;for(const i in r){const a=[],s=r[i];for(let t=0,i=s.length;t<i;t++){const i=e(s[t],n);a.push(i)}t.morphAttributes[i]=a}t.morphTargetsRelative=this.morphTargetsRelative;const a=this.groups;for(let e=0,n=a.length;e<n;e++){const n=a[e];t.addGroup(n.start,n.count,n.materialIndex)}return t}toJSON(){const e={metadata:{version:4.6,type:"BufferGeometry",generator:"BufferGeometry.toJSON"}};if(e.uuid=this.uuid,e.type=this.type,""!==this.name&&(e.name=this.name),Object.keys(this.userData).length>0&&(e.userData=this.userData),void 0!==this.parameters){const t=this.parameters;for(const n in t)void 0!==t[n]&&(e[n]=t[n]);return e}e.data={attributes:{}};const t=this.index;null!==t&&(e.data.index={type:t.array.constructor.name,array:Array.prototype.slice.call(t.array)});const n=this.attributes;for(const t in n){const i=n[t];e.data.attributes[t]=i.toJSON(e.data)}const i={};let r=!1;for(const t in this.morphAttributes){const n=this.morphAttributes[t],a=[];for(let t=0,i=n.length;t<i;t++){const i=n[t];a.push(i.toJSON(e.data))}a.length>0&&(i[t]=a,r=!0)}r&&(e.data.morphAttributes=i,e.data.morphTargetsRelative=this.morphTargetsRelative);const a=this.groups;a.length>0&&(e.data.groups=JSON.parse(JSON.stringify(a)));const s=this.boundingSphere;return null!==s&&(e.data.boundingSphere={center:s.center.toArray(),radius:s.radius}),e}clone(){return(new this.constructor).copy(this)}copy(e){this.index=null,this.attributes={},this.morphAttributes={},this.groups=[],this.boundingBox=null,this.boundingSphere=null;const t={};this.name=e.name;const n=e.index;null!==n&&this.setIndex(n.clone(t));const i=e.attributes;for(const e in i){const n=i[e];this.setAttribute(e,n.clone(t))}const r=e.morphAttributes;for(const e in r){const n=[],i=r[e];for(let e=0,r=i.length;e<r;e++)n.push(i[e].clone(t));this.morphAttributes[e]=n}this.morphTargetsRelative=e.morphTargetsRelative;const a=e.groups;for(let e=0,t=a.length;e<t;e++){const t=a[e];this.addGroup(t.start,t.count,t.materialIndex)}const s=e.boundingBox;null!==s&&(this.boundingBox=s.clone());const o=e.boundingSphere;return null!==o&&(this.boundingSphere=o.clone()),this.drawRange.start=e.drawRange.start,this.drawRange.count=e.drawRange.count,this.userData=e.userData,this}dispose(){this.dispatchEvent({type:"dispose"})}}const ri=new qt,ai=new jt,si=new zt,oi=new _t,li=new _t,ci=new _t,hi=new _t,ui=new _t,di=new _t,pi=new ke,fi=new ke,mi=new ke,gi=new _t,_i=new _t,vi=new _t,xi=new _t,Mi=new _t;class Si extends xn{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new ii,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:new Hn;super(),this.isMesh=!0,this.type="Mesh",this.geometry=e,this.material=t,this.updateMorphTargets()}copy(e,t){return super.copy(e,t),void 0!==e.morphTargetInfluences&&(this.morphTargetInfluences=e.morphTargetInfluences.slice()),void 0!==e.morphTargetDictionary&&(this.morphTargetDictionary=Object.assign({},e.morphTargetDictionary)),this.material=Array.isArray(e.material)?e.material.slice():e.material,this.geometry=e.geometry,this}updateMorphTargets(){const e=this.geometry.morphAttributes,t=Object.keys(e);if(t.length>0){const n=e[t[0]];if(void 0!==n){this.morphTargetInfluences=[],this.morphTargetDictionary={};for(let e=0,t=n.length;e<t;e++){const t=n[e].name||String(e);this.morphTargetInfluences.push(0),this.morphTargetDictionary[t]=e}}}}getVertexPosition(e,t){const n=this.geometry,i=n.attributes.position,r=n.morphAttributes.position,a=n.morphTargetsRelative;t.fromBufferAttribute(i,e);const s=this.morphTargetInfluences;if(r&&s){di.set(0,0,0);for(let n=0,i=r.length;n<i;n++){const i=s[n],o=r[n];0!==i&&(ui.fromBufferAttribute(o,e),a?di.addScaledVector(ui,i):di.addScaledVector(ui.sub(t),i))}t.add(di)}return t}raycast(e,t){const n=this.geometry,i=this.material,r=this.matrixWorld;if(void 0!==i){if(null===n.boundingSphere&&n.computeBoundingSphere(),si.copy(n.boundingSphere),si.applyMatrix4(r),ai.copy(e.ray).recast(e.near),!1===si.containsPoint(ai.origin)){if(null===ai.intersectSphere(si,oi))return;if(ai.origin.distanceToSquared(oi)>(e.far-e.near)**2)return}ri.copy(r).invert(),ai.copy(e.ray).applyMatrix4(ri),null!==n.boundingBox&&!1===ai.intersectsBox(n.boundingBox)||this._computeIntersections(e,t,ai)}}_computeIntersections(e,t,n){let i;const r=this.geometry,a=this.material,s=r.index,o=r.attributes.position,l=r.attributes.uv,c=r.attributes.uv1,h=r.attributes.normal,u=r.groups,d=r.drawRange;if(null!==s)if(Array.isArray(a))for(let r=0,o=u.length;r<o;r++){const o=u[r],p=a[o.materialIndex];for(let r=Math.max(o.start,d.start),a=Math.min(s.count,Math.min(o.start+o.count,d.start+d.count));r<a;r+=3)i=yi(this,p,e,n,l,c,h,s.getX(r),s.getX(r+1),s.getX(r+2)),i&&(i.faceIndex=Math.floor(r/3),i.face.materialIndex=o.materialIndex,t.push(i))}else for(let r=Math.max(0,d.start),o=Math.min(s.count,d.start+d.count);r<o;r+=3)i=yi(this,a,e,n,l,c,h,s.getX(r),s.getX(r+1),s.getX(r+2)),i&&(i.faceIndex=Math.floor(r/3),t.push(i));else if(void 0!==o)if(Array.isArray(a))for(let r=0,s=u.length;r<s;r++){const s=u[r],p=a[s.materialIndex];for(let r=Math.max(s.start,d.start),a=Math.min(o.count,Math.min(s.start+s.count,d.start+d.count));r<a;r+=3)i=yi(this,p,e,n,l,c,h,r,r+1,r+2),i&&(i.faceIndex=Math.floor(r/3),i.face.materialIndex=s.materialIndex,t.push(i))}else for(let r=Math.max(0,d.start),s=Math.min(o.count,d.start+d.count);r<s;r+=3)i=yi(this,a,e,n,l,c,h,r,r+1,r+2),i&&(i.faceIndex=Math.floor(r/3),t.push(i))}}function yi(e,t,n,i,r,a,s,o,l,c){e.getVertexPosition(o,li),e.getVertexPosition(l,ci),e.getVertexPosition(c,hi);const h=function(e,t,n,i,r,a,s,o){let l;if(l=1===t.side?i.intersectTriangle(s,a,r,!0,o):i.intersectTriangle(r,a,s,0===t.side,o),null===l)return null;Mi.copy(o),Mi.applyMatrix4(e.matrixWorld);const c=n.ray.origin.distanceTo(Mi);return c<n.near||c>n.far?null:{distance:c,point:Mi.clone(),object:e}}(e,t,n,i,li,ci,hi,xi);if(h){r&&(pi.fromBufferAttribute(r,o),fi.fromBufferAttribute(r,l),mi.fromBufferAttribute(r,c),h.uv=Pn.getInterpolation(xi,li,ci,hi,pi,fi,mi,new ke)),a&&(pi.fromBufferAttribute(a,o),fi.fromBufferAttribute(a,l),mi.fromBufferAttribute(a,c),h.uv1=Pn.getInterpolation(xi,li,ci,hi,pi,fi,mi,new ke),h.uv2=h.uv1),s&&(gi.fromBufferAttribute(s,o),_i.fromBufferAttribute(s,l),vi.fromBufferAttribute(s,c),h.normal=Pn.getInterpolation(xi,li,ci,hi,gi,_i,vi,new _t),h.normal.dot(i.direction)>0&&h.normal.multiplyScalar(-1));const e={a:o,b:l,c,normal:new _t,materialIndex:0};Pn.getNormal(li,ci,hi,e.normal),h.face=e}return h}class Ei extends ii{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1,r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:1,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:1;super(),this.type="BoxGeometry",this.parameters={width:e,height:t,depth:n,widthSegments:i,heightSegments:r,depthSegments:a};const s=this;i=Math.floor(i),r=Math.floor(r),a=Math.floor(a);const o=[],l=[],c=[],h=[];let u=0,d=0;function p(e,t,n,i,r,a,p,f,m,g,_){const v=a/m,x=p/g,M=a/2,S=p/2,y=f/2,E=m+1,T=g+1;let b=0,w=0;const A=new _t;for(let a=0;a<T;a++){const s=a*x-S;for(let o=0;o<E;o++){const u=o*v-M;A[e]=u*i,A[t]=s*r,A[n]=y,l.push(A.x,A.y,A.z),A[e]=0,A[t]=0,A[n]=f>0?1:-1,c.push(A.x,A.y,A.z),h.push(o/m),h.push(1-a/g),b+=1}}for(let e=0;e<g;e++)for(let t=0;t<m;t++){const n=u+t+E*e,i=u+t+E*(e+1),r=u+(t+1)+E*(e+1),a=u+(t+1)+E*e;o.push(n,i,a),o.push(i,r,a),w+=6}s.addGroup(d,w,_),d+=w,u+=b}p("z","y","x",-1,-1,n,t,e,a,r,0),p("z","y","x",1,-1,n,t,-e,a,r,1),p("x","z","y",1,1,e,n,t,i,a,2),p("x","z","y",1,-1,e,n,-t,i,a,3),p("x","y","z",1,-1,e,t,n,i,r,4),p("x","y","z",-1,-1,e,t,-n,i,r,5),this.setIndex(o),this.setAttribute("position",new Kn(l,3)),this.setAttribute("normal",new Kn(c,3)),this.setAttribute("uv",new Kn(h,2))}copy(e){return super.copy(e),this.parameters=Object.assign({},e.parameters),this}static fromJSON(e){return new Ei(e.width,e.height,e.depth,e.widthSegments,e.heightSegments,e.depthSegments)}}function Ti(e){const t={};for(const n in e){t[n]={};for(const i in e[n]){const r=e[n][i];r&&(r.isColor||r.isMatrix3||r.isMatrix4||r.isVector2||r.isVector3||r.isVector4||r.isTexture||r.isQuaternion)?r.isRenderTargetTexture?(console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."),t[n][i]=null):t[n][i]=r.clone():Array.isArray(r)?t[n][i]=r.slice():t[n][i]=r}}return t}function bi(e){const t={};for(let n=0;n<e.length;n++){const i=Ti(e[n]);for(const e in i)t[e]=i[e]}return t}function wi(e){return null===e.getRenderTarget()?e.outputColorSpace:tt.workingColorSpace}const Ai={clone:Ti,merge:bi};class Ri extends Bn{constructor(e){super(),this.isShaderMaterial=!0,this.type="ShaderMaterial",this.defines={},this.uniforms={},this.uniformsGroups=[],this.vertexShader="void main() {\\n\\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\\n}",this.fragmentShader="void main() {\\n\\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\\n}",this.linewidth=1,this.wireframe=!1,this.wireframeLinewidth=1,this.fog=!1,this.lights=!1,this.clipping=!1,this.forceSinglePass=!0,this.extensions={derivatives:!1,fragDepth:!1,drawBuffers:!1,shaderTextureLOD:!1},this.defaultAttributeValues={color:[1,1,1],uv:[0,0],uv1:[0,0]},this.index0AttributeName=void 0,this.uniformsNeedUpdate=!1,this.glslVersion=null,void 0!==e&&this.setValues(e)}copy(e){return super.copy(e),this.fragmentShader=e.fragmentShader,this.vertexShader=e.vertexShader,this.uniforms=Ti(e.uniforms),this.uniformsGroups=function(e){const t=[];for(let n=0;n<e.length;n++)t.push(e[n].clone());return t}(e.uniformsGroups),this.defines=Object.assign({},e.defines),this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this.fog=e.fog,this.lights=e.lights,this.clipping=e.clipping,this.extensions=Object.assign({},e.extensions),this.glslVersion=e.glslVersion,this}toJSON(e){const t=super.toJSON(e);t.glslVersion=this.glslVersion,t.uniforms={};for(const n in this.uniforms){const i=this.uniforms[n].value;i&&i.isTexture?t.uniforms[n]={type:"t",value:i.toJSON(e).uuid}:i&&i.isColor?t.uniforms[n]={type:"c",value:i.getHex()}:i&&i.isVector2?t.uniforms[n]={type:"v2",value:i.toArray()}:i&&i.isVector3?t.uniforms[n]={type:"v3",value:i.toArray()}:i&&i.isVector4?t.uniforms[n]={type:"v4",value:i.toArray()}:i&&i.isMatrix3?t.uniforms[n]={type:"m3",value:i.toArray()}:i&&i.isMatrix4?t.uniforms[n]={type:"m4",value:i.toArray()}:t.uniforms[n]={value:i}}Object.keys(this.defines).length>0&&(t.defines=this.defines),t.vertexShader=this.vertexShader,t.fragmentShader=this.fragmentShader,t.lights=this.lights,t.clipping=this.clipping;const n={};for(const e in this.extensions)!0===this.extensions[e]&&(n[e]=!0);return Object.keys(n).length>0&&(t.extensions=n),t}}class Ci extends xn{constructor(){super(),this.isCamera=!0,this.type="Camera",this.matrixWorldInverse=new qt,this.projectionMatrix=new qt,this.projectionMatrixInverse=new qt,this.coordinateSystem=Le}copy(e,t){return super.copy(e,t),this.matrixWorldInverse.copy(e.matrixWorldInverse),this.projectionMatrix.copy(e.projectionMatrix),this.projectionMatrixInverse.copy(e.projectionMatrixInverse),this.coordinateSystem=e.coordinateSystem,this}getWorldDirection(e){return super.getWorldDirection(e).negate()}updateMatrixWorld(e){super.updateMatrixWorld(e),this.matrixWorldInverse.copy(this.matrixWorld).invert()}updateWorldMatrix(e,t){super.updateWorldMatrix(e,t),this.matrixWorldInverse.copy(this.matrixWorld).invert()}clone(){return(new this.constructor).copy(this)}}class Li extends Ci{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:50,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:.1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:2e3;super(),this.isPerspectiveCamera=!0,this.type="PerspectiveCamera",this.fov=e,this.zoom=1,this.near=n,this.far=i,this.focus=10,this.aspect=t,this.view=null,this.filmGauge=35,this.filmOffset=0,this.updateProjectionMatrix()}copy(e,t){return super.copy(e,t),this.fov=e.fov,this.zoom=e.zoom,this.near=e.near,this.far=e.far,this.focus=e.focus,this.aspect=e.aspect,this.view=null===e.view?null:Object.assign({},e.view),this.filmGauge=e.filmGauge,this.filmOffset=e.filmOffset,this}setFocalLength(e){const t=.5*this.getFilmHeight()/e;this.fov=2*Ie*Math.atan(t),this.updateProjectionMatrix()}getFocalLength(){const e=Math.tan(.5*Ne*this.fov);return.5*this.getFilmHeight()/e}getEffectiveFOV(){return 2*Ie*Math.atan(Math.tan(.5*Ne*this.fov)/this.zoom)}getFilmWidth(){return this.filmGauge*Math.min(this.aspect,1)}getFilmHeight(){return this.filmGauge/Math.max(this.aspect,1)}setViewOffset(e,t,n,i,r,a){this.aspect=e/t,null===this.view&&(this.view={enabled:!0,fullWidth:1,fullHeight:1,offsetX:0,offsetY:0,width:1,height:1}),this.view.enabled=!0,this.view.fullWidth=e,this.view.fullHeight=t,this.view.offsetX=n,this.view.offsetY=i,this.view.width=r,this.view.height=a,this.updateProjectionMatrix()}clearViewOffset(){null!==this.view&&(this.view.enabled=!1),this.updateProjectionMatrix()}updateProjectionMatrix(){const e=this.near;let t=e*Math.tan(.5*Ne*this.fov)/this.zoom,n=2*t,i=this.aspect*n,r=-.5*i;const a=this.view;if(null!==this.view&&this.view.enabled){const e=a.fullWidth,s=a.fullHeight;r+=a.offsetX*i/e,t-=a.offsetY*n/s,i*=a.width/e,n*=a.height/s}const s=this.filmOffset;0!==s&&(r+=e*s/this.getFilmWidth()),this.projectionMatrix.makePerspective(r,r+i,t,t-n,e,this.far,this.coordinateSystem),this.projectionMatrixInverse.copy(this.projectionMatrix).invert()}toJSON(e){const t=super.toJSON(e);return t.object.fov=this.fov,t.object.zoom=this.zoom,t.object.near=this.near,t.object.far=this.far,t.object.focus=this.focus,t.object.aspect=this.aspect,null!==this.view&&(t.object.view=Object.assign({},this.view)),t.object.filmGauge=this.filmGauge,t.object.filmOffset=this.filmOffset,t}}const Pi=-90;class Ui extends xn{constructor(e,t,n){super(),this.type="CubeCamera",this.renderTarget=n,this.coordinateSystem=null,this.activeMipmapLevel=0;const i=new Li(Pi,1,e,t);i.layers=this.layers,this.add(i);const r=new Li(Pi,1,e,t);r.layers=this.layers,this.add(r);const a=new Li(Pi,1,e,t);a.layers=this.layers,this.add(a);const s=new Li(Pi,1,e,t);s.layers=this.layers,this.add(s);const o=new Li(Pi,1,e,t);o.layers=this.layers,this.add(o);const l=new Li(Pi,1,e,t);l.layers=this.layers,this.add(l)}updateCoordinateSystem(){const e=this.coordinateSystem,t=this.children.concat(),[n,i,r,a,s,o]=t;for(const e of t)this.remove(e);if(e===Le)n.up.set(0,1,0),n.lookAt(1,0,0),i.up.set(0,1,0),i.lookAt(-1,0,0),r.up.set(0,0,-1),r.lookAt(0,1,0),a.up.set(0,0,1),a.lookAt(0,-1,0),s.up.set(0,1,0),s.lookAt(0,0,1),o.up.set(0,1,0),o.lookAt(0,0,-1);else{if(e!==Pe)throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: "+e);n.up.set(0,-1,0),n.lookAt(-1,0,0),i.up.set(0,-1,0),i.lookAt(1,0,0),r.up.set(0,0,1),r.lookAt(0,1,0),a.up.set(0,0,-1),a.lookAt(0,-1,0),s.up.set(0,-1,0),s.lookAt(0,0,1),o.up.set(0,-1,0),o.lookAt(0,0,-1)}for(const e of t)this.add(e),e.updateMatrixWorld()}update(e,t){null===this.parent&&this.updateMatrixWorld();const{renderTarget:n,activeMipmapLevel:i}=this;this.coordinateSystem!==e.coordinateSystem&&(this.coordinateSystem=e.coordinateSystem,this.updateCoordinateSystem());const[r,a,s,o,l,c]=this.children,h=e.getRenderTarget(),u=e.getActiveCubeFace(),d=e.getActiveMipmapLevel(),p=e.xr.enabled;e.xr.enabled=!1;const f=n.texture.generateMipmaps;n.texture.generateMipmaps=!1,e.setRenderTarget(n,0,i),e.render(t,r),e.setRenderTarget(n,1,i),e.render(t,a),e.setRenderTarget(n,2,i),e.render(t,s),e.setRenderTarget(n,3,i),e.render(t,o),e.setRenderTarget(n,4,i),e.render(t,l),n.texture.generateMipmaps=f,e.setRenderTarget(n,5,i),e.render(t,c),e.setRenderTarget(h,u,d),e.xr.enabled=p,n.texture.needsPMREMUpdate=!0}}class Di extends ht{constructor(e,t,n,i,r,a,s,o,l,c){super(e=void 0!==e?e:[],t=void 0!==t?t:N,n,i,r,a,s,o,l,c),this.isCubeTexture=!0,this.flipY=!1}get images(){return this.image}set images(e){this.image=e}}class Ni extends pt{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};super(e,e,t),this.isWebGLCubeRenderTarget=!0;const n={width:e,height:e,depth:1},i=[n,n,n,n,n,n];void 0!==t.encoding&&(Ze("THREE.WebGLCubeRenderTarget: option.encoding has been replaced by option.colorSpace."),t.colorSpace=t.encoding===ce?ue:he),this.texture=new Di(i,t.mapping,t.wrapS,t.wrapT,t.magFilter,t.minFilter,t.format,t.type,t.anisotropy,t.colorSpace),this.texture.isRenderTargetTexture=!0,this.texture.generateMipmaps=void 0!==t.generateMipmaps&&t.generateMipmaps,this.texture.minFilter=void 0!==t.minFilter?t.minFilter:k}fromEquirectangularTexture(e,t){this.texture.type=t.type,this.texture.colorSpace=t.colorSpace,this.texture.generateMipmaps=t.generateMipmaps,this.texture.minFilter=t.minFilter,this.texture.magFilter=t.magFilter;const n=new Ei(5,5,5),i=new Ri({name:"CubemapFromEquirect",uniforms:Ti({tEquirect:{value:null}}),vertexShader:"\\n\\n\\t\\t\\t\\tvarying vec3 vWorldDirection;\\n\\n\\t\\t\\t\\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\\n\\n\\t\\t\\t\\t\\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\\n\\n\\t\\t\\t\\t}\\n\\n\\t\\t\\t\\tvoid main() {\\n\\n\\t\\t\\t\\t\\tvWorldDirection = transformDirection( position, modelMatrix );\\n\\n\\t\\t\\t\\t\\t#include <begin_vertex>\\n\\t\\t\\t\\t\\t#include <project_vertex>\\n\\n\\t\\t\\t\\t}\\n\\t\\t\\t",fragmentShader:"\\n\\n\\t\\t\\t\\tuniform sampler2D tEquirect;\\n\\n\\t\\t\\t\\tvarying vec3 vWorldDirection;\\n\\n\\t\\t\\t\\t#include <common>\\n\\n\\t\\t\\t\\tvoid main() {\\n\\n\\t\\t\\t\\t\\tvec3 direction = normalize( vWorldDirection );\\n\\n\\t\\t\\t\\t\\tvec2 sampleUV = equirectUv( direction );\\n\\n\\t\\t\\t\\t\\tgl_FragColor = texture2D( tEquirect, sampleUV );\\n\\n\\t\\t\\t\\t}\\n\\t\\t\\t",side:1,blending:0});i.uniforms.tEquirect.value=t;const r=new Si(n,i),a=t.minFilter;return t.minFilter===X&&(t.minFilter=k),new Ui(1,10,this).update(e,r),t.minFilter=a,r.geometry.dispose(),r.material.dispose(),this}clear(e,t,n,i){const r=e.getRenderTarget();for(let r=0;r<6;r++)e.setRenderTarget(this,r),e.clear(t,n,i);e.setRenderTarget(r)}}const Ii=new _t,Oi=new _t,Fi=new We;class zi{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new _t(1,0,0),t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;this.isPlane=!0,this.normal=e,this.constant=t}set(e,t){return this.normal.copy(e),this.constant=t,this}setComponents(e,t,n,i){return this.normal.set(e,t,n),this.constant=i,this}setFromNormalAndCoplanarPoint(e,t){return this.normal.copy(e),this.constant=-t.dot(this.normal),this}setFromCoplanarPoints(e,t,n){const i=Ii.subVectors(n,t).cross(Oi.subVectors(e,t)).normalize();return this.setFromNormalAndCoplanarPoint(i,e),this}copy(e){return this.normal.copy(e.normal),this.constant=e.constant,this}normalize(){const e=1/this.normal.length();return this.normal.multiplyScalar(e),this.constant*=e,this}negate(){return this.constant*=-1,this.normal.negate(),this}distanceToPoint(e){return this.normal.dot(e)+this.constant}distanceToSphere(e){return this.distanceToPoint(e.center)-e.radius}projectPoint(e,t){return t.copy(e).addScaledVector(this.normal,-this.distanceToPoint(e))}intersectLine(e,t){const n=e.delta(Ii),i=this.normal.dot(n);if(0===i)return 0===this.distanceToPoint(e.start)?t.copy(e.start):null;const r=-(e.start.dot(this.normal)+this.constant)/i;return r<0||r>1?null:t.copy(e.start).addScaledVector(n,r)}intersectsLine(e){const t=this.distanceToPoint(e.start),n=this.distanceToPoint(e.end);return t<0&&n>0||n<0&&t>0}intersectsBox(e){return e.intersectsPlane(this)}intersectsSphere(e){return e.intersectsPlane(this)}coplanarPoint(e){return e.copy(this.normal).multiplyScalar(-this.constant)}applyMatrix4(e,t){const n=t||Fi.getNormalMatrix(e),i=this.coplanarPoint(Ii).applyMatrix4(e),r=this.normal.applyMatrix3(n).normalize();return this.constant=-i.dot(r),this}translate(e){return this.constant-=e.dot(this.normal),this}equals(e){return e.normal.equals(this.normal)&&e.constant===this.constant}clone(){return(new this.constructor).copy(this)}}const Bi=new zt,Hi=new _t;class Vi{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:new zi,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:new zi,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:new zi,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:new zi,r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:new zi,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:new zi;this.planes=[e,t,n,i,r,a]}set(e,t,n,i,r,a){const s=this.planes;return s[0].copy(e),s[1].copy(t),s[2].copy(n),s[3].copy(i),s[4].copy(r),s[5].copy(a),this}copy(e){const t=this.planes;for(let n=0;n<6;n++)t[n].copy(e.planes[n]);return this}setFromProjectionMatrix(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Le;const n=this.planes,i=e.elements,r=i[0],a=i[1],s=i[2],o=i[3],l=i[4],c=i[5],h=i[6],u=i[7],d=i[8],p=i[9],f=i[10],m=i[11],g=i[12],_=i[13],v=i[14],x=i[15];if(n[0].setComponents(o-r,u-l,m-d,x-g).normalize(),n[1].setComponents(o+r,u+l,m+d,x+g).normalize(),n[2].setComponents(o+a,u+c,m+p,x+_).normalize(),n[3].setComponents(o-a,u-c,m-p,x-_).normalize(),n[4].setComponents(o-s,u-h,m-f,x-v).normalize(),t===Le)n[5].setComponents(o+s,u+h,m+f,x+v).normalize();else{if(t!==Pe)throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: "+t);n[5].setComponents(s,h,f,v).normalize()}return this}intersectsObject(e){if(void 0!==e.boundingSphere)null===e.boundingSphere&&e.computeBoundingSphere(),Bi.copy(e.boundingSphere).applyMatrix4(e.matrixWorld);else{const t=e.geometry;null===t.boundingSphere&&t.computeBoundingSphere(),Bi.copy(t.boundingSphere).applyMatrix4(e.matrixWorld)}return this.intersectsSphere(Bi)}intersectsSprite(e){return Bi.center.set(0,0,0),Bi.radius=.7071067811865476,Bi.applyMatrix4(e.matrixWorld),this.intersectsSphere(Bi)}intersectsSphere(e){const t=this.planes,n=e.center,i=-e.radius;for(let e=0;e<6;e++)if(t[e].distanceToPoint(n)<i)return!1;return!0}intersectsBox(e){const t=this.planes;for(let n=0;n<6;n++){const i=t[n];if(Hi.x=i.normal.x>0?e.max.x:e.min.x,Hi.y=i.normal.y>0?e.max.y:e.min.y,Hi.z=i.normal.z>0?e.max.z:e.min.z,i.distanceToPoint(Hi)<0)return!1}return!0}containsPoint(e){const t=this.planes;for(let n=0;n<6;n++)if(t[n].distanceToPoint(e)<0)return!1;return!0}clone(){return(new this.constructor).copy(this)}}function Gi(){let e=null,t=!1,n=null,i=null;function r(t,a){n(t,a),i=e.requestAnimationFrame(r)}return{start:function(){!0!==t&&null!==n&&(i=e.requestAnimationFrame(r),t=!0)},stop:function(){e.cancelAnimationFrame(i),t=!1},setAnimationLoop:function(e){n=e},setContext:function(t){e=t}}}function ki(e,t){const n=t.isWebGL2,i=new WeakMap;return{get:function(e){return e.isInterleavedBufferAttribute&&(e=e.data),i.get(e)},remove:function(t){t.isInterleavedBufferAttribute&&(t=t.data);const n=i.get(t);n&&(e.deleteBuffer(n.buffer),i.delete(t))},update:function(t,r){if(t.isGLBufferAttribute){const e=i.get(t);return void((!e||e.version<t.version)&&i.set(t,{buffer:t.buffer,type:t.type,bytesPerElement:t.elementSize,version:t.version}))}t.isInterleavedBufferAttribute&&(t=t.data);const a=i.get(t);void 0===a?i.set(t,function(t,i){const r=t.array,a=t.usage,s=e.createBuffer();let o;if(e.bindBuffer(i,s),e.bufferData(i,r,a),t.onUploadCallback(),r instanceof Float32Array)o=e.FLOAT;else if(r instanceof Uint16Array)if(t.isFloat16BufferAttribute){if(!n)throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");o=e.HALF_FLOAT}else o=e.UNSIGNED_SHORT;else if(r instanceof Int16Array)o=e.SHORT;else if(r instanceof Uint32Array)o=e.UNSIGNED_INT;else if(r instanceof Int32Array)o=e.INT;else if(r instanceof Int8Array)o=e.BYTE;else if(r instanceof Uint8Array)o=e.UNSIGNED_BYTE;else{if(!(r instanceof Uint8ClampedArray))throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: "+r);o=e.UNSIGNED_BYTE}return{buffer:s,type:o,bytesPerElement:r.BYTES_PER_ELEMENT,version:t.version}}(t,r)):a.version<t.version&&(function(t,i,r){const a=i.array,s=i.updateRange;e.bindBuffer(r,t),-1===s.count?e.bufferSubData(r,0,a):(n?e.bufferSubData(r,s.offset*a.BYTES_PER_ELEMENT,a,s.offset,s.count):e.bufferSubData(r,s.offset*a.BYTES_PER_ELEMENT,a.subarray(s.offset,s.offset+s.count)),s.count=-1),i.onUploadCallback()}(a.buffer,t,r),a.version=t.version)}}}class Wi extends ii{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:1,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;super(),this.type="PlaneGeometry",this.parameters={width:e,height:t,widthSegments:n,heightSegments:i};const r=e/2,a=t/2,s=Math.floor(n),o=Math.floor(i),l=s+1,c=o+1,h=e/s,u=t/o,d=[],p=[],f=[],m=[];for(let e=0;e<c;e++){const t=e*u-a;for(let n=0;n<l;n++){const i=n*h-r;p.push(i,-t,0),f.push(0,0,1),m.push(n/s),m.push(1-e/o)}}for(let e=0;e<o;e++)for(let t=0;t<s;t++){const n=t+l*e,i=t+l*(e+1),r=t+1+l*(e+1),a=t+1+l*e;d.push(n,i,a),d.push(i,r,a)}this.setIndex(d),this.setAttribute("position",new Kn(p,3)),this.setAttribute("normal",new Kn(f,3)),this.setAttribute("uv",new Kn(m,2))}copy(e){return super.copy(e),this.parameters=Object.assign({},e.parameters),this}static fromJSON(e){return new Wi(e.width,e.height,e.widthSegments,e.heightSegments)}}const Xi={alphahash_fragment:"#ifdef USE_ALPHAHASH\\n\\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\\n#endif",alphahash_pars_fragment:"#ifdef USE_ALPHAHASH\\n\\tconst float ALPHA_HASH_SCALE = 0.05;\\n\\tfloat hash2D( vec2 value ) {\\n\\t\\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\\n\\t}\\n\\tfloat hash3D( vec3 value ) {\\n\\t\\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\\n\\t}\\n\\tfloat getAlphaHashThreshold( vec3 position ) {\\n\\t\\tfloat maxDeriv = max(\\n\\t\\t\\tlength( dFdx( position.xyz ) ),\\n\\t\\t\\tlength( dFdy( position.xyz ) )\\n\\t\\t);\\n\\t\\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\\n\\t\\tvec2 pixScales = vec2(\\n\\t\\t\\texp2( floor( log2( pixScale ) ) ),\\n\\t\\t\\texp2( ceil( log2( pixScale ) ) )\\n\\t\\t);\\n\\t\\tvec2 alpha = vec2(\\n\\t\\t\\thash3D( floor( pixScales.x * position.xyz ) ),\\n\\t\\t\\thash3D( floor( pixScales.y * position.xyz ) )\\n\\t\\t);\\n\\t\\tfloat lerpFactor = fract( log2( pixScale ) );\\n\\t\\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\\n\\t\\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\\n\\t\\tvec3 cases = vec3(\\n\\t\\t\\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\\n\\t\\t\\t( x - 0.5 * a ) / ( 1.0 - a ),\\n\\t\\t\\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\\n\\t\\t);\\n\\t\\tfloat threshold = ( x < ( 1.0 - a ) )\\n\\t\\t\\t? ( ( x < a ) ? cases.x : cases.y )\\n\\t\\t\\t: cases.z;\\n\\t\\treturn clamp( threshold , 1.0e-6, 1.0 );\\n\\t}\\n#endif",alphamap_fragment:"#ifdef USE_ALPHAMAP\\n\\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\\n#endif",alphamap_pars_fragment:"#ifdef USE_ALPHAMAP\\n\\tuniform sampler2D alphaMap;\\n#endif",alphatest_fragment:"#ifdef USE_ALPHATEST\\n\\tif ( diffuseColor.a < alphaTest ) discard;\\n#endif",alphatest_pars_fragment:"#ifdef USE_ALPHATEST\\n\\tuniform float alphaTest;\\n#endif",aomap_fragment:"#ifdef USE_AOMAP\\n\\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\\n\\treflectedLight.indirectDiffuse *= ambientOcclusion;\\n\\t#if defined( USE_CLEARCOAT ) \\n\\t\\tclearcoatSpecularIndirect *= ambientOcclusion;\\n\\t#endif\\n\\t#if defined( USE_SHEEN ) \\n\\t\\tsheenSpecularIndirect *= ambientOcclusion;\\n\\t#endif\\n\\t#if defined( USE_ENVMAP ) && defined( STANDARD )\\n\\t\\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\\n\\t\\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\\n\\t#endif\\n#endif",aomap_pars_fragment:"#ifdef USE_AOMAP\\n\\tuniform sampler2D aoMap;\\n\\tuniform float aoMapIntensity;\\n#endif",begin_vertex:"vec3 transformed = vec3( position );\\n#ifdef USE_ALPHAHASH\\n\\tvPosition = vec3( position );\\n#endif",beginnormal_vertex:"vec3 objectNormal = vec3( normal );\\n#ifdef USE_TANGENT\\n\\tvec3 objectTangent = vec3( tangent.xyz );\\n#endif",bsdfs:"float G_BlinnPhong_Implicit( ) {\\n\\treturn 0.25;\\n}\\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\\n\\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\\n}\\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\\n\\tvec3 halfDir = normalize( lightDir + viewDir );\\n\\tfloat dotNH = saturate( dot( normal, halfDir ) );\\n\\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\\n\\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\\n\\tfloat G = G_BlinnPhong_Implicit( );\\n\\tfloat D = D_BlinnPhong( shininess, dotNH );\\n\\treturn F * ( G * D );\\n} // validated",iridescence_fragment:"#ifdef USE_IRIDESCENCE\\n\\tconst mat3 XYZ_TO_REC709 = mat3(\\n\\t\\t 3.2404542, -0.9692660,  0.0556434,\\n\\t\\t-1.5371385,  1.8760108, -0.2040259,\\n\\t\\t-0.4985314,  0.0415560,  1.0572252\\n\\t);\\n\\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\\n\\t\\tvec3 sqrtF0 = sqrt( fresnel0 );\\n\\t\\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\\n\\t}\\n\\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\\n\\t\\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\\n\\t}\\n\\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\\n\\t\\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\\n\\t}\\n\\tvec3 evalSensitivity( float OPD, vec3 shift ) {\\n\\t\\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\\n\\t\\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\\n\\t\\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\\n\\t\\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\\n\\t\\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\\n\\t\\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\\n\\t\\txyz /= 1.0685e-7;\\n\\t\\tvec3 rgb = XYZ_TO_REC709 * xyz;\\n\\t\\treturn rgb;\\n\\t}\\n\\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\\n\\t\\tvec3 I;\\n\\t\\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\\n\\t\\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\\n\\t\\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\\n\\t\\tif ( cosTheta2Sq < 0.0 ) {\\n\\t\\t\\treturn vec3( 1.0 );\\n\\t\\t}\\n\\t\\tfloat cosTheta2 = sqrt( cosTheta2Sq );\\n\\t\\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\\n\\t\\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\\n\\t\\tfloat T121 = 1.0 - R12;\\n\\t\\tfloat phi12 = 0.0;\\n\\t\\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\\n\\t\\tfloat phi21 = PI - phi12;\\n\\t\\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\\t\\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\\n\\t\\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\\n\\t\\tvec3 phi23 = vec3( 0.0 );\\n\\t\\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\\n\\t\\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\\n\\t\\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\\n\\t\\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\\n\\t\\tvec3 phi = vec3( phi21 ) + phi23;\\n\\t\\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\\n\\t\\tvec3 r123 = sqrt( R123 );\\n\\t\\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\\n\\t\\tvec3 C0 = R12 + Rs;\\n\\t\\tI = C0;\\n\\t\\tvec3 Cm = Rs - T121;\\n\\t\\tfor ( int m = 1; m <= 2; ++ m ) {\\n\\t\\t\\tCm *= r123;\\n\\t\\t\\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\\n\\t\\t\\tI += Cm * Sm;\\n\\t\\t}\\n\\t\\treturn max( I, vec3( 0.0 ) );\\n\\t}\\n#endif",bumpmap_pars_fragment:"#ifdef USE_BUMPMAP\\n\\tuniform sampler2D bumpMap;\\n\\tuniform float bumpScale;\\n\\tvec2 dHdxy_fwd() {\\n\\t\\tvec2 dSTdx = dFdx( vBumpMapUv );\\n\\t\\tvec2 dSTdy = dFdy( vBumpMapUv );\\n\\t\\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\\n\\t\\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\\n\\t\\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\\n\\t\\treturn vec2( dBx, dBy );\\n\\t}\\n\\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\\n\\t\\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\\n\\t\\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\\n\\t\\tvec3 vN = surf_norm;\\n\\t\\tvec3 R1 = cross( vSigmaY, vN );\\n\\t\\tvec3 R2 = cross( vN, vSigmaX );\\n\\t\\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\\n\\t\\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\\n\\t\\treturn normalize( abs( fDet ) * surf_norm - vGrad );\\n\\t}\\n#endif",clipping_planes_fragment:"#if NUM_CLIPPING_PLANES > 0\\n\\tvec4 plane;\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\\n\\t\\tplane = clippingPlanes[ i ];\\n\\t\\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\\n\\t}\\n\\t#pragma unroll_loop_end\\n\\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\\n\\t\\tbool clipped = true;\\n\\t\\t#pragma unroll_loop_start\\n\\t\\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\\n\\t\\t\\tplane = clippingPlanes[ i ];\\n\\t\\t\\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\\n\\t\\t}\\n\\t\\t#pragma unroll_loop_end\\n\\t\\tif ( clipped ) discard;\\n\\t#endif\\n#endif",clipping_planes_pars_fragment:"#if NUM_CLIPPING_PLANES > 0\\n\\tvarying vec3 vClipPosition;\\n\\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\\n#endif",clipping_planes_pars_vertex:"#if NUM_CLIPPING_PLANES > 0\\n\\tvarying vec3 vClipPosition;\\n#endif",clipping_planes_vertex:"#if NUM_CLIPPING_PLANES > 0\\n\\tvClipPosition = - mvPosition.xyz;\\n#endif",color_fragment:"#if defined( USE_COLOR_ALPHA )\\n\\tdiffuseColor *= vColor;\\n#elif defined( USE_COLOR )\\n\\tdiffuseColor.rgb *= vColor;\\n#endif",color_pars_fragment:"#if defined( USE_COLOR_ALPHA )\\n\\tvarying vec4 vColor;\\n#elif defined( USE_COLOR )\\n\\tvarying vec3 vColor;\\n#endif",color_pars_vertex:"#if defined( USE_COLOR_ALPHA )\\n\\tvarying vec4 vColor;\\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\\n\\tvarying vec3 vColor;\\n#endif",color_vertex:"#if defined( USE_COLOR_ALPHA )\\n\\tvColor = vec4( 1.0 );\\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\\n\\tvColor = vec3( 1.0 );\\n#endif\\n#ifdef USE_COLOR\\n\\tvColor *= color;\\n#endif\\n#ifdef USE_INSTANCING_COLOR\\n\\tvColor.xyz *= instanceColor.xyz;\\n#endif",common:"#define PI 3.141592653589793\\n#define PI2 6.283185307179586\\n#define PI_HALF 1.5707963267948966\\n#define RECIPROCAL_PI 0.3183098861837907\\n#define RECIPROCAL_PI2 0.15915494309189535\\n#define EPSILON 1e-6\\n#ifndef saturate\\n#define saturate( a ) clamp( a, 0.0, 1.0 )\\n#endif\\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\\nfloat pow2( const in float x ) { return x*x; }\\nvec3 pow2( const in vec3 x ) { return x*x; }\\nfloat pow3( const in float x ) { return x*x*x; }\\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\\nhighp float rand( const in vec2 uv ) {\\n\\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\\n\\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\\n\\treturn fract( sin( sn ) * c );\\n}\\n#ifdef HIGH_PRECISION\\n\\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\\n#else\\n\\tfloat precisionSafeLength( vec3 v ) {\\n\\t\\tfloat maxComponent = max3( abs( v ) );\\n\\t\\treturn length( v / maxComponent ) * maxComponent;\\n\\t}\\n#endif\\nstruct IncidentLight {\\n\\tvec3 color;\\n\\tvec3 direction;\\n\\tbool visible;\\n};\\nstruct ReflectedLight {\\n\\tvec3 directDiffuse;\\n\\tvec3 directSpecular;\\n\\tvec3 indirectDiffuse;\\n\\tvec3 indirectSpecular;\\n};\\n#ifdef USE_ALPHAHASH\\n\\tvarying vec3 vPosition;\\n#endif\\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\\n\\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\\n}\\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\\n\\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\\n}\\nmat3 transposeMat3( const in mat3 m ) {\\n\\tmat3 tmp;\\n\\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\\n\\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\\n\\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\\n\\treturn tmp;\\n}\\nfloat luminance( const in vec3 rgb ) {\\n\\tconst vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );\\n\\treturn dot( weights, rgb );\\n}\\nbool isPerspectiveMatrix( mat4 m ) {\\n\\treturn m[ 2 ][ 3 ] == - 1.0;\\n}\\nvec2 equirectUv( in vec3 dir ) {\\n\\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\\n\\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\\n\\treturn vec2( u, v );\\n}\\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\\n\\treturn RECIPROCAL_PI * diffuseColor;\\n}\\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\\n\\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\\n\\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\\n}\\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\\n\\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\\n\\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\\n} // validated",cube_uv_reflection_fragment:"#ifdef ENVMAP_TYPE_CUBE_UV\\n\\t#define cubeUV_minMipLevel 4.0\\n\\t#define cubeUV_minTileSize 16.0\\n\\tfloat getFace( vec3 direction ) {\\n\\t\\tvec3 absDirection = abs( direction );\\n\\t\\tfloat face = - 1.0;\\n\\t\\tif ( absDirection.x > absDirection.z ) {\\n\\t\\t\\tif ( absDirection.x > absDirection.y )\\n\\t\\t\\t\\tface = direction.x > 0.0 ? 0.0 : 3.0;\\n\\t\\t\\telse\\n\\t\\t\\t\\tface = direction.y > 0.0 ? 1.0 : 4.0;\\n\\t\\t} else {\\n\\t\\t\\tif ( absDirection.z > absDirection.y )\\n\\t\\t\\t\\tface = direction.z > 0.0 ? 2.0 : 5.0;\\n\\t\\t\\telse\\n\\t\\t\\t\\tface = direction.y > 0.0 ? 1.0 : 4.0;\\n\\t\\t}\\n\\t\\treturn face;\\n\\t}\\n\\tvec2 getUV( vec3 direction, float face ) {\\n\\t\\tvec2 uv;\\n\\t\\tif ( face == 0.0 ) {\\n\\t\\t\\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\\n\\t\\t} else if ( face == 1.0 ) {\\n\\t\\t\\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\\n\\t\\t} else if ( face == 2.0 ) {\\n\\t\\t\\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\\n\\t\\t} else if ( face == 3.0 ) {\\n\\t\\t\\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\\n\\t\\t} else if ( face == 4.0 ) {\\n\\t\\t\\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\\n\\t\\t} else {\\n\\t\\t\\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\\n\\t\\t}\\n\\t\\treturn 0.5 * ( uv + 1.0 );\\n\\t}\\n\\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\\n\\t\\tfloat face = getFace( direction );\\n\\t\\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\\n\\t\\tmipInt = max( mipInt, cubeUV_minMipLevel );\\n\\t\\tfloat faceSize = exp2( mipInt );\\n\\t\\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\\n\\t\\tif ( face > 2.0 ) {\\n\\t\\t\\tuv.y += faceSize;\\n\\t\\t\\tface -= 3.0;\\n\\t\\t}\\n\\t\\tuv.x += face * faceSize;\\n\\t\\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\\n\\t\\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\\n\\t\\tuv.x *= CUBEUV_TEXEL_WIDTH;\\n\\t\\tuv.y *= CUBEUV_TEXEL_HEIGHT;\\n\\t\\t#ifdef texture2DGradEXT\\n\\t\\t\\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\\n\\t\\t#else\\n\\t\\t\\treturn texture2D( envMap, uv ).rgb;\\n\\t\\t#endif\\n\\t}\\n\\t#define cubeUV_r0 1.0\\n\\t#define cubeUV_v0 0.339\\n\\t#define cubeUV_m0 - 2.0\\n\\t#define cubeUV_r1 0.8\\n\\t#define cubeUV_v1 0.276\\n\\t#define cubeUV_m1 - 1.0\\n\\t#define cubeUV_r4 0.4\\n\\t#define cubeUV_v4 0.046\\n\\t#define cubeUV_m4 2.0\\n\\t#define cubeUV_r5 0.305\\n\\t#define cubeUV_v5 0.016\\n\\t#define cubeUV_m5 3.0\\n\\t#define cubeUV_r6 0.21\\n\\t#define cubeUV_v6 0.0038\\n\\t#define cubeUV_m6 4.0\\n\\tfloat roughnessToMip( float roughness ) {\\n\\t\\tfloat mip = 0.0;\\n\\t\\tif ( roughness >= cubeUV_r1 ) {\\n\\t\\t\\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\\n\\t\\t} else if ( roughness >= cubeUV_r4 ) {\\n\\t\\t\\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\\n\\t\\t} else if ( roughness >= cubeUV_r5 ) {\\n\\t\\t\\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\\n\\t\\t} else if ( roughness >= cubeUV_r6 ) {\\n\\t\\t\\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\\n\\t\\t} else {\\n\\t\\t\\tmip = - 2.0 * log2( 1.16 * roughness );\\t\\t}\\n\\t\\treturn mip;\\n\\t}\\n\\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\\n\\t\\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\\n\\t\\tfloat mipF = fract( mip );\\n\\t\\tfloat mipInt = floor( mip );\\n\\t\\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\\n\\t\\tif ( mipF == 0.0 ) {\\n\\t\\t\\treturn vec4( color0, 1.0 );\\n\\t\\t} else {\\n\\t\\t\\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\\n\\t\\t\\treturn vec4( mix( color0, color1, mipF ), 1.0 );\\n\\t\\t}\\n\\t}\\n#endif",defaultnormal_vertex:"vec3 transformedNormal = objectNormal;\\n#ifdef USE_INSTANCING\\n\\tmat3 m = mat3( instanceMatrix );\\n\\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\\n\\ttransformedNormal = m * transformedNormal;\\n#endif\\ntransformedNormal = normalMatrix * transformedNormal;\\n#ifdef FLIP_SIDED\\n\\ttransformedNormal = - transformedNormal;\\n#endif\\n#ifdef USE_TANGENT\\n\\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\\n\\t#ifdef FLIP_SIDED\\n\\t\\ttransformedTangent = - transformedTangent;\\n\\t#endif\\n#endif",displacementmap_pars_vertex:"#ifdef USE_DISPLACEMENTMAP\\n\\tuniform sampler2D displacementMap;\\n\\tuniform float displacementScale;\\n\\tuniform float displacementBias;\\n#endif",displacementmap_vertex:"#ifdef USE_DISPLACEMENTMAP\\n\\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\\n#endif",emissivemap_fragment:"#ifdef USE_EMISSIVEMAP\\n\\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\\n\\ttotalEmissiveRadiance *= emissiveColor.rgb;\\n#endif",emissivemap_pars_fragment:"#ifdef USE_EMISSIVEMAP\\n\\tuniform sampler2D emissiveMap;\\n#endif",colorspace_fragment:"gl_FragColor = linearToOutputTexel( gl_FragColor );",colorspace_pars_fragment:"\\nconst mat3 LINEAR_SRGB_TO_LINEAR_DISPLAY_P3 = mat3(\\n\\tvec3( 0.8224621, 0.177538, 0.0 ),\\n\\tvec3( 0.0331941, 0.9668058, 0.0 ),\\n\\tvec3( 0.0170827, 0.0723974, 0.9105199 )\\n);\\nconst mat3 LINEAR_DISPLAY_P3_TO_LINEAR_SRGB = mat3(\\n\\tvec3( 1.2249401, - 0.2249404, 0.0 ),\\n\\tvec3( - 0.0420569, 1.0420571, 0.0 ),\\n\\tvec3( - 0.0196376, - 0.0786361, 1.0982735 )\\n);\\nvec4 LinearSRGBToLinearDisplayP3( in vec4 value ) {\\n\\treturn vec4( value.rgb * LINEAR_SRGB_TO_LINEAR_DISPLAY_P3, value.a );\\n}\\nvec4 LinearDisplayP3ToLinearSRGB( in vec4 value ) {\\n\\treturn vec4( value.rgb * LINEAR_DISPLAY_P3_TO_LINEAR_SRGB, value.a );\\n}\\nvec4 LinearTransferOETF( in vec4 value ) {\\n\\treturn value;\\n}\\nvec4 sRGBTransferOETF( in vec4 value ) {\\n\\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\\n}\\nvec4 LinearToLinear( in vec4 value ) {\\n\\treturn value;\\n}\\nvec4 LinearTosRGB( in vec4 value ) {\\n\\treturn sRGBTransferOETF( value );\\n}",envmap_fragment:"#ifdef USE_ENVMAP\\n\\t#ifdef ENV_WORLDPOS\\n\\t\\tvec3 cameraToFrag;\\n\\t\\tif ( isOrthographic ) {\\n\\t\\t\\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\\n\\t\\t} else {\\n\\t\\t\\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\\n\\t\\t}\\n\\t\\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\\n\\t\\t#ifdef ENVMAP_MODE_REFLECTION\\n\\t\\t\\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\\n\\t\\t#else\\n\\t\\t\\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\\n\\t\\t#endif\\n\\t#else\\n\\t\\tvec3 reflectVec = vReflect;\\n\\t#endif\\n\\t#ifdef ENVMAP_TYPE_CUBE\\n\\t\\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\\n\\t#else\\n\\t\\tvec4 envColor = vec4( 0.0 );\\n\\t#endif\\n\\t#ifdef ENVMAP_BLENDING_MULTIPLY\\n\\t\\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\\n\\t#elif defined( ENVMAP_BLENDING_MIX )\\n\\t\\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\\n\\t#elif defined( ENVMAP_BLENDING_ADD )\\n\\t\\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\\n\\t#endif\\n#endif",envmap_common_pars_fragment:"#ifdef USE_ENVMAP\\n\\tuniform float envMapIntensity;\\n\\tuniform float flipEnvMap;\\n\\t#ifdef ENVMAP_TYPE_CUBE\\n\\t\\tuniform samplerCube envMap;\\n\\t#else\\n\\t\\tuniform sampler2D envMap;\\n\\t#endif\\n\\t\\n#endif",envmap_pars_fragment:"#ifdef USE_ENVMAP\\n\\tuniform float reflectivity;\\n\\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\\n\\t\\t#define ENV_WORLDPOS\\n\\t#endif\\n\\t#ifdef ENV_WORLDPOS\\n\\t\\tvarying vec3 vWorldPosition;\\n\\t\\tuniform float refractionRatio;\\n\\t#else\\n\\t\\tvarying vec3 vReflect;\\n\\t#endif\\n#endif",envmap_pars_vertex:"#ifdef USE_ENVMAP\\n\\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\\n\\t\\t#define ENV_WORLDPOS\\n\\t#endif\\n\\t#ifdef ENV_WORLDPOS\\n\\t\\t\\n\\t\\tvarying vec3 vWorldPosition;\\n\\t#else\\n\\t\\tvarying vec3 vReflect;\\n\\t\\tuniform float refractionRatio;\\n\\t#endif\\n#endif",envmap_physical_pars_fragment:"#ifdef USE_ENVMAP\\n\\tvec3 getIBLIrradiance( const in vec3 normal ) {\\n\\t\\t#ifdef ENVMAP_TYPE_CUBE_UV\\n\\t\\t\\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\\n\\t\\t\\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\\n\\t\\t\\treturn PI * envMapColor.rgb * envMapIntensity;\\n\\t\\t#else\\n\\t\\t\\treturn vec3( 0.0 );\\n\\t\\t#endif\\n\\t}\\n\\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\\n\\t\\t#ifdef ENVMAP_TYPE_CUBE_UV\\n\\t\\t\\tvec3 reflectVec = reflect( - viewDir, normal );\\n\\t\\t\\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\\n\\t\\t\\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\\n\\t\\t\\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\\n\\t\\t\\treturn envMapColor.rgb * envMapIntensity;\\n\\t\\t#else\\n\\t\\t\\treturn vec3( 0.0 );\\n\\t\\t#endif\\n\\t}\\n\\t#ifdef USE_ANISOTROPY\\n\\t\\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\\n\\t\\t\\t#ifdef ENVMAP_TYPE_CUBE_UV\\n\\t\\t\\t\\tvec3 bentNormal = cross( bitangent, viewDir );\\n\\t\\t\\t\\tbentNormal = normalize( cross( bentNormal, bitangent ) );\\n\\t\\t\\t\\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\\n\\t\\t\\t\\treturn getIBLRadiance( viewDir, bentNormal, roughness );\\n\\t\\t\\t#else\\n\\t\\t\\t\\treturn vec3( 0.0 );\\n\\t\\t\\t#endif\\n\\t\\t}\\n\\t#endif\\n#endif",envmap_vertex:"#ifdef USE_ENVMAP\\n\\t#ifdef ENV_WORLDPOS\\n\\t\\tvWorldPosition = worldPosition.xyz;\\n\\t#else\\n\\t\\tvec3 cameraToVertex;\\n\\t\\tif ( isOrthographic ) {\\n\\t\\t\\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\\n\\t\\t} else {\\n\\t\\t\\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\\n\\t\\t}\\n\\t\\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\\n\\t\\t#ifdef ENVMAP_MODE_REFLECTION\\n\\t\\t\\tvReflect = reflect( cameraToVertex, worldNormal );\\n\\t\\t#else\\n\\t\\t\\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\\n\\t\\t#endif\\n\\t#endif\\n#endif",fog_vertex:"#ifdef USE_FOG\\n\\tvFogDepth = - mvPosition.z;\\n#endif",fog_pars_vertex:"#ifdef USE_FOG\\n\\tvarying float vFogDepth;\\n#endif",fog_fragment:"#ifdef USE_FOG\\n\\t#ifdef FOG_EXP2\\n\\t\\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\\n\\t#else\\n\\t\\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\\n\\t#endif\\n\\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\\n#endif",fog_pars_fragment:"#ifdef USE_FOG\\n\\tuniform vec3 fogColor;\\n\\tvarying float vFogDepth;\\n\\t#ifdef FOG_EXP2\\n\\t\\tuniform float fogDensity;\\n\\t#else\\n\\t\\tuniform float fogNear;\\n\\t\\tuniform float fogFar;\\n\\t#endif\\n#endif",gradientmap_pars_fragment:"#ifdef USE_GRADIENTMAP\\n\\tuniform sampler2D gradientMap;\\n#endif\\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\\n\\tfloat dotNL = dot( normal, lightDirection );\\n\\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\\n\\t#ifdef USE_GRADIENTMAP\\n\\t\\treturn vec3( texture2D( gradientMap, coord ).r );\\n\\t#else\\n\\t\\tvec2 fw = fwidth( coord ) * 0.5;\\n\\t\\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\\n\\t#endif\\n}",lightmap_fragment:"#ifdef USE_LIGHTMAP\\n\\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\\n\\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\\n\\treflectedLight.indirectDiffuse += lightMapIrradiance;\\n#endif",lightmap_pars_fragment:"#ifdef USE_LIGHTMAP\\n\\tuniform sampler2D lightMap;\\n\\tuniform float lightMapIntensity;\\n#endif",lights_lambert_fragment:"LambertMaterial material;\\nmaterial.diffuseColor = diffuseColor.rgb;\\nmaterial.specularStrength = specularStrength;",lights_lambert_pars_fragment:"varying vec3 vViewPosition;\\nstruct LambertMaterial {\\n\\tvec3 diffuseColor;\\n\\tfloat specularStrength;\\n};\\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\\n\\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\\n\\tvec3 irradiance = dotNL * directLight.color;\\n\\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\\n\\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\n#define RE_Direct\\t\\t\\t\\tRE_Direct_Lambert\\n#define RE_IndirectDiffuse\\t\\tRE_IndirectDiffuse_Lambert",lights_pars_begin:"uniform bool receiveShadow;\\nuniform vec3 ambientLightColor;\\n#if defined( USE_LIGHT_PROBES )\\n\\tuniform vec3 lightProbe[ 9 ];\\n#endif\\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\\n\\tfloat x = normal.x, y = normal.y, z = normal.z;\\n\\tvec3 result = shCoefficients[ 0 ] * 0.886227;\\n\\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\\n\\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\\n\\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\\n\\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\\n\\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\\n\\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\\n\\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\\n\\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\\n\\treturn result;\\n}\\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\\n\\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\\n\\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\\n\\treturn irradiance;\\n}\\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\\n\\tvec3 irradiance = ambientLightColor;\\n\\treturn irradiance;\\n}\\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\\n\\t#if defined ( LEGACY_LIGHTS )\\n\\t\\tif ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\\n\\t\\t\\treturn pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );\\n\\t\\t}\\n\\t\\treturn 1.0;\\n\\t#else\\n\\t\\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\\n\\t\\tif ( cutoffDistance > 0.0 ) {\\n\\t\\t\\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\\n\\t\\t}\\n\\t\\treturn distanceFalloff;\\n\\t#endif\\n}\\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\\n\\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\\n}\\n#if NUM_DIR_LIGHTS > 0\\n\\tstruct DirectionalLight {\\n\\t\\tvec3 direction;\\n\\t\\tvec3 color;\\n\\t};\\n\\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\\n\\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\\n\\t\\tlight.color = directionalLight.color;\\n\\t\\tlight.direction = directionalLight.direction;\\n\\t\\tlight.visible = true;\\n\\t}\\n#endif\\n#if NUM_POINT_LIGHTS > 0\\n\\tstruct PointLight {\\n\\t\\tvec3 position;\\n\\t\\tvec3 color;\\n\\t\\tfloat distance;\\n\\t\\tfloat decay;\\n\\t};\\n\\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\\n\\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\\n\\t\\tvec3 lVector = pointLight.position - geometryPosition;\\n\\t\\tlight.direction = normalize( lVector );\\n\\t\\tfloat lightDistance = length( lVector );\\n\\t\\tlight.color = pointLight.color;\\n\\t\\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\\n\\t\\tlight.visible = ( light.color != vec3( 0.0 ) );\\n\\t}\\n#endif\\n#if NUM_SPOT_LIGHTS > 0\\n\\tstruct SpotLight {\\n\\t\\tvec3 position;\\n\\t\\tvec3 direction;\\n\\t\\tvec3 color;\\n\\t\\tfloat distance;\\n\\t\\tfloat decay;\\n\\t\\tfloat coneCos;\\n\\t\\tfloat penumbraCos;\\n\\t};\\n\\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\\n\\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\\n\\t\\tvec3 lVector = spotLight.position - geometryPosition;\\n\\t\\tlight.direction = normalize( lVector );\\n\\t\\tfloat angleCos = dot( light.direction, spotLight.direction );\\n\\t\\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\\n\\t\\tif ( spotAttenuation > 0.0 ) {\\n\\t\\t\\tfloat lightDistance = length( lVector );\\n\\t\\t\\tlight.color = spotLight.color * spotAttenuation;\\n\\t\\t\\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\\n\\t\\t\\tlight.visible = ( light.color != vec3( 0.0 ) );\\n\\t\\t} else {\\n\\t\\t\\tlight.color = vec3( 0.0 );\\n\\t\\t\\tlight.visible = false;\\n\\t\\t}\\n\\t}\\n#endif\\n#if NUM_RECT_AREA_LIGHTS > 0\\n\\tstruct RectAreaLight {\\n\\t\\tvec3 color;\\n\\t\\tvec3 position;\\n\\t\\tvec3 halfWidth;\\n\\t\\tvec3 halfHeight;\\n\\t};\\n\\tuniform sampler2D ltc_1;\\tuniform sampler2D ltc_2;\\n\\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\\n#endif\\n#if NUM_HEMI_LIGHTS > 0\\n\\tstruct HemisphereLight {\\n\\t\\tvec3 direction;\\n\\t\\tvec3 skyColor;\\n\\t\\tvec3 groundColor;\\n\\t};\\n\\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\\n\\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\\n\\t\\tfloat dotNL = dot( normal, hemiLight.direction );\\n\\t\\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\\n\\t\\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\\n\\t\\treturn irradiance;\\n\\t}\\n#endif",lights_toon_fragment:"ToonMaterial material;\\nmaterial.diffuseColor = diffuseColor.rgb;",lights_toon_pars_fragment:"varying vec3 vViewPosition;\\nstruct ToonMaterial {\\n\\tvec3 diffuseColor;\\n};\\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\\n\\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\\n\\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\\n\\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\n#define RE_Direct\\t\\t\\t\\tRE_Direct_Toon\\n#define RE_IndirectDiffuse\\t\\tRE_IndirectDiffuse_Toon",lights_phong_fragment:"BlinnPhongMaterial material;\\nmaterial.diffuseColor = diffuseColor.rgb;\\nmaterial.specularColor = specular;\\nmaterial.specularShininess = shininess;\\nmaterial.specularStrength = specularStrength;",lights_phong_pars_fragment:"varying vec3 vViewPosition;\\nstruct BlinnPhongMaterial {\\n\\tvec3 diffuseColor;\\n\\tvec3 specularColor;\\n\\tfloat specularShininess;\\n\\tfloat specularStrength;\\n};\\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\\n\\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\\n\\tvec3 irradiance = dotNL * directLight.color;\\n\\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n\\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\\n}\\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\\n\\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\n#define RE_Direct\\t\\t\\t\\tRE_Direct_BlinnPhong\\n#define RE_IndirectDiffuse\\t\\tRE_IndirectDiffuse_BlinnPhong",lights_physical_fragment:"PhysicalMaterial material;\\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\\nmaterial.roughness = min( material.roughness, 1.0 );\\n#ifdef IOR\\n\\tmaterial.ior = ior;\\n\\t#ifdef USE_SPECULAR\\n\\t\\tfloat specularIntensityFactor = specularIntensity;\\n\\t\\tvec3 specularColorFactor = specularColor;\\n\\t\\t#ifdef USE_SPECULAR_COLORMAP\\n\\t\\t\\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\\n\\t\\t#endif\\n\\t\\t#ifdef USE_SPECULAR_INTENSITYMAP\\n\\t\\t\\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\\n\\t\\t#endif\\n\\t\\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\\n\\t#else\\n\\t\\tfloat specularIntensityFactor = 1.0;\\n\\t\\tvec3 specularColorFactor = vec3( 1.0 );\\n\\t\\tmaterial.specularF90 = 1.0;\\n\\t#endif\\n\\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\\n#else\\n\\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\\n\\tmaterial.specularF90 = 1.0;\\n#endif\\n#ifdef USE_CLEARCOAT\\n\\tmaterial.clearcoat = clearcoat;\\n\\tmaterial.clearcoatRoughness = clearcoatRoughness;\\n\\tmaterial.clearcoatF0 = vec3( 0.04 );\\n\\tmaterial.clearcoatF90 = 1.0;\\n\\t#ifdef USE_CLEARCOATMAP\\n\\t\\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\\n\\t#endif\\n\\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\\n\\t\\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\\n\\t#endif\\n\\tmaterial.clearcoat = saturate( material.clearcoat );\\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\\n\\tmaterial.clearcoatRoughness += geometryRoughness;\\n\\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\\n#endif\\n#ifdef USE_IRIDESCENCE\\n\\tmaterial.iridescence = iridescence;\\n\\tmaterial.iridescenceIOR = iridescenceIOR;\\n\\t#ifdef USE_IRIDESCENCEMAP\\n\\t\\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\\n\\t#endif\\n\\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\\n\\t\\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\\n\\t#else\\n\\t\\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\\n\\t#endif\\n#endif\\n#ifdef USE_SHEEN\\n\\tmaterial.sheenColor = sheenColor;\\n\\t#ifdef USE_SHEEN_COLORMAP\\n\\t\\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\\n\\t#endif\\n\\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\\n\\t#ifdef USE_SHEEN_ROUGHNESSMAP\\n\\t\\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\\n\\t#endif\\n#endif\\n#ifdef USE_ANISOTROPY\\n\\t#ifdef USE_ANISOTROPYMAP\\n\\t\\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\\n\\t\\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\\n\\t\\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\\n\\t#else\\n\\t\\tvec2 anisotropyV = anisotropyVector;\\n\\t#endif\\n\\tmaterial.anisotropy = length( anisotropyV );\\n\\tanisotropyV /= material.anisotropy;\\n\\tmaterial.anisotropy = saturate( material.anisotropy );\\n\\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\\n\\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x - tbn[ 1 ] * anisotropyV.y;\\n\\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x + tbn[ 0 ] * anisotropyV.y;\\n#endif",lights_physical_pars_fragment:"struct PhysicalMaterial {\\n\\tvec3 diffuseColor;\\n\\tfloat roughness;\\n\\tvec3 specularColor;\\n\\tfloat specularF90;\\n\\t#ifdef USE_CLEARCOAT\\n\\t\\tfloat clearcoat;\\n\\t\\tfloat clearcoatRoughness;\\n\\t\\tvec3 clearcoatF0;\\n\\t\\tfloat clearcoatF90;\\n\\t#endif\\n\\t#ifdef USE_IRIDESCENCE\\n\\t\\tfloat iridescence;\\n\\t\\tfloat iridescenceIOR;\\n\\t\\tfloat iridescenceThickness;\\n\\t\\tvec3 iridescenceFresnel;\\n\\t\\tvec3 iridescenceF0;\\n\\t#endif\\n\\t#ifdef USE_SHEEN\\n\\t\\tvec3 sheenColor;\\n\\t\\tfloat sheenRoughness;\\n\\t#endif\\n\\t#ifdef IOR\\n\\t\\tfloat ior;\\n\\t#endif\\n\\t#ifdef USE_TRANSMISSION\\n\\t\\tfloat transmission;\\n\\t\\tfloat transmissionAlpha;\\n\\t\\tfloat thickness;\\n\\t\\tfloat attenuationDistance;\\n\\t\\tvec3 attenuationColor;\\n\\t#endif\\n\\t#ifdef USE_ANISOTROPY\\n\\t\\tfloat anisotropy;\\n\\t\\tfloat alphaT;\\n\\t\\tvec3 anisotropyT;\\n\\t\\tvec3 anisotropyB;\\n\\t#endif\\n};\\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\\nvec3 sheenSpecularDirect = vec3( 0.0 );\\nvec3 sheenSpecularIndirect = vec3(0.0 );\\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\\n    float x2 = x * x;\\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\\n}\\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\\n\\tfloat a2 = pow2( alpha );\\n\\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\\n\\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\\n\\treturn 0.5 / max( gv + gl, EPSILON );\\n}\\nfloat D_GGX( const in float alpha, const in float dotNH ) {\\n\\tfloat a2 = pow2( alpha );\\n\\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\\n\\treturn RECIPROCAL_PI * a2 / pow2( denom );\\n}\\n#ifdef USE_ANISOTROPY\\n\\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\\n\\t\\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\\n\\t\\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\\n\\t\\tfloat v = 0.5 / ( gv + gl );\\n\\t\\treturn saturate(v);\\n\\t}\\n\\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\\n\\t\\tfloat a2 = alphaT * alphaB;\\n\\t\\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\\n\\t\\thighp float v2 = dot( v, v );\\n\\t\\tfloat w2 = a2 / v2;\\n\\t\\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\\n\\t}\\n#endif\\n#ifdef USE_CLEARCOAT\\n\\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\\n\\t\\tvec3 f0 = material.clearcoatF0;\\n\\t\\tfloat f90 = material.clearcoatF90;\\n\\t\\tfloat roughness = material.clearcoatRoughness;\\n\\t\\tfloat alpha = pow2( roughness );\\n\\t\\tvec3 halfDir = normalize( lightDir + viewDir );\\n\\t\\tfloat dotNL = saturate( dot( normal, lightDir ) );\\n\\t\\tfloat dotNV = saturate( dot( normal, viewDir ) );\\n\\t\\tfloat dotNH = saturate( dot( normal, halfDir ) );\\n\\t\\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\\n\\t\\tvec3 F = F_Schlick( f0, f90, dotVH );\\n\\t\\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\\n\\t\\tfloat D = D_GGX( alpha, dotNH );\\n\\t\\treturn F * ( V * D );\\n\\t}\\n#endif\\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\\n\\tvec3 f0 = material.specularColor;\\n\\tfloat f90 = material.specularF90;\\n\\tfloat roughness = material.roughness;\\n\\tfloat alpha = pow2( roughness );\\n\\tvec3 halfDir = normalize( lightDir + viewDir );\\n\\tfloat dotNL = saturate( dot( normal, lightDir ) );\\n\\tfloat dotNV = saturate( dot( normal, viewDir ) );\\n\\tfloat dotNH = saturate( dot( normal, halfDir ) );\\n\\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\\n\\tvec3 F = F_Schlick( f0, f90, dotVH );\\n\\t#ifdef USE_IRIDESCENCE\\n\\t\\tF = mix( F, material.iridescenceFresnel, material.iridescence );\\n\\t#endif\\n\\t#ifdef USE_ANISOTROPY\\n\\t\\tfloat dotTL = dot( material.anisotropyT, lightDir );\\n\\t\\tfloat dotTV = dot( material.anisotropyT, viewDir );\\n\\t\\tfloat dotTH = dot( material.anisotropyT, halfDir );\\n\\t\\tfloat dotBL = dot( material.anisotropyB, lightDir );\\n\\t\\tfloat dotBV = dot( material.anisotropyB, viewDir );\\n\\t\\tfloat dotBH = dot( material.anisotropyB, halfDir );\\n\\t\\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\\n\\t\\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\\n\\t#else\\n\\t\\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\\n\\t\\tfloat D = D_GGX( alpha, dotNH );\\n\\t#endif\\n\\treturn F * ( V * D );\\n}\\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\\n\\tconst float LUT_SIZE = 64.0;\\n\\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\\n\\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\\n\\tfloat dotNV = saturate( dot( N, V ) );\\n\\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\\n\\tuv = uv * LUT_SCALE + LUT_BIAS;\\n\\treturn uv;\\n}\\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\\n\\tfloat l = length( f );\\n\\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\\n}\\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\\n\\tfloat x = dot( v1, v2 );\\n\\tfloat y = abs( x );\\n\\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\\n\\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\\n\\tfloat v = a / b;\\n\\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\\n\\treturn cross( v1, v2 ) * theta_sintheta;\\n}\\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\\n\\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\\n\\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\\n\\tvec3 lightNormal = cross( v1, v2 );\\n\\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\\n\\tvec3 T1, T2;\\n\\tT1 = normalize( V - N * dot( V, N ) );\\n\\tT2 = - cross( N, T1 );\\n\\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\\n\\tvec3 coords[ 4 ];\\n\\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\\n\\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\\n\\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\\n\\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\\n\\tcoords[ 0 ] = normalize( coords[ 0 ] );\\n\\tcoords[ 1 ] = normalize( coords[ 1 ] );\\n\\tcoords[ 2 ] = normalize( coords[ 2 ] );\\n\\tcoords[ 3 ] = normalize( coords[ 3 ] );\\n\\tvec3 vectorFormFactor = vec3( 0.0 );\\n\\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\\n\\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\\n\\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\\n\\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\\n\\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\\n\\treturn vec3( result );\\n}\\n#if defined( USE_SHEEN )\\nfloat D_Charlie( float roughness, float dotNH ) {\\n\\tfloat alpha = pow2( roughness );\\n\\tfloat invAlpha = 1.0 / alpha;\\n\\tfloat cos2h = dotNH * dotNH;\\n\\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\\n\\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\\n}\\nfloat V_Neubelt( float dotNV, float dotNL ) {\\n\\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\\n}\\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\\n\\tvec3 halfDir = normalize( lightDir + viewDir );\\n\\tfloat dotNL = saturate( dot( normal, lightDir ) );\\n\\tfloat dotNV = saturate( dot( normal, viewDir ) );\\n\\tfloat dotNH = saturate( dot( normal, halfDir ) );\\n\\tfloat D = D_Charlie( sheenRoughness, dotNH );\\n\\tfloat V = V_Neubelt( dotNV, dotNL );\\n\\treturn sheenColor * ( D * V );\\n}\\n#endif\\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\\n\\tfloat dotNV = saturate( dot( normal, viewDir ) );\\n\\tfloat r2 = roughness * roughness;\\n\\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\\n\\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\\n\\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\\n\\treturn saturate( DG * RECIPROCAL_PI );\\n}\\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\\n\\tfloat dotNV = saturate( dot( normal, viewDir ) );\\n\\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\\n\\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\\n\\tvec4 r = roughness * c0 + c1;\\n\\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\\n\\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\\n\\treturn fab;\\n}\\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\\n\\tvec2 fab = DFGApprox( normal, viewDir, roughness );\\n\\treturn specularColor * fab.x + specularF90 * fab.y;\\n}\\n#ifdef USE_IRIDESCENCE\\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\\n#else\\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\\n#endif\\n\\tvec2 fab = DFGApprox( normal, viewDir, roughness );\\n\\t#ifdef USE_IRIDESCENCE\\n\\t\\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\\n\\t#else\\n\\t\\tvec3 Fr = specularColor;\\n\\t#endif\\n\\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\\n\\tfloat Ess = fab.x + fab.y;\\n\\tfloat Ems = 1.0 - Ess;\\n\\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\\n\\tsingleScatter += FssEss;\\n\\tmultiScatter += Fms * Ems;\\n}\\n#if NUM_RECT_AREA_LIGHTS > 0\\n\\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\\n\\t\\tvec3 normal = geometryNormal;\\n\\t\\tvec3 viewDir = geometryViewDir;\\n\\t\\tvec3 position = geometryPosition;\\n\\t\\tvec3 lightPos = rectAreaLight.position;\\n\\t\\tvec3 halfWidth = rectAreaLight.halfWidth;\\n\\t\\tvec3 halfHeight = rectAreaLight.halfHeight;\\n\\t\\tvec3 lightColor = rectAreaLight.color;\\n\\t\\tfloat roughness = material.roughness;\\n\\t\\tvec3 rectCoords[ 4 ];\\n\\t\\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\\t\\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\\n\\t\\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\\n\\t\\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\\n\\t\\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\\n\\t\\tvec4 t1 = texture2D( ltc_1, uv );\\n\\t\\tvec4 t2 = texture2D( ltc_2, uv );\\n\\t\\tmat3 mInv = mat3(\\n\\t\\t\\tvec3( t1.x, 0, t1.y ),\\n\\t\\t\\tvec3(    0, 1,    0 ),\\n\\t\\t\\tvec3( t1.z, 0, t1.w )\\n\\t\\t);\\n\\t\\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\\n\\t\\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\\n\\t\\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\\n\\t}\\n#endif\\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\\n\\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\\n\\tvec3 irradiance = dotNL * directLight.color;\\n\\t#ifdef USE_CLEARCOAT\\n\\t\\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\\n\\t\\tvec3 ccIrradiance = dotNLcc * directLight.color;\\n\\t\\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\\n\\t#endif\\n\\t#ifdef USE_SHEEN\\n\\t\\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\\n\\t#endif\\n\\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\\n\\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\\n\\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\\n}\\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\\n\\t#ifdef USE_CLEARCOAT\\n\\t\\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\\n\\t#endif\\n\\t#ifdef USE_SHEEN\\n\\t\\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\\n\\t#endif\\n\\tvec3 singleScattering = vec3( 0.0 );\\n\\tvec3 multiScattering = vec3( 0.0 );\\n\\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\\n\\t#ifdef USE_IRIDESCENCE\\n\\t\\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\\n\\t#else\\n\\t\\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\\n\\t#endif\\n\\tvec3 totalScattering = singleScattering + multiScattering;\\n\\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\\n\\treflectedLight.indirectSpecular += radiance * singleScattering;\\n\\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\\n\\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\\n}\\n#define RE_Direct\\t\\t\\t\\tRE_Direct_Physical\\n#define RE_Direct_RectArea\\t\\tRE_Direct_RectArea_Physical\\n#define RE_IndirectDiffuse\\t\\tRE_IndirectDiffuse_Physical\\n#define RE_IndirectSpecular\\t\\tRE_IndirectSpecular_Physical\\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\\n\\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\\n}",lights_fragment_begin:"\\nvec3 geometryPosition = - vViewPosition;\\nvec3 geometryNormal = normal;\\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\\nvec3 geometryClearcoatNormal = vec3( 0.0 );\\n#ifdef USE_CLEARCOAT\\n\\tgeometryClearcoatNormal = clearcoatNormal;\\n#endif\\n#ifdef USE_IRIDESCENCE\\n\\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\\n\\tif ( material.iridescenceThickness == 0.0 ) {\\n\\t\\tmaterial.iridescence = 0.0;\\n\\t} else {\\n\\t\\tmaterial.iridescence = saturate( material.iridescence );\\n\\t}\\n\\tif ( material.iridescence > 0.0 ) {\\n\\t\\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\\n\\t\\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\\n\\t}\\n#endif\\nIncidentLight directLight;\\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\\n\\tPointLight pointLight;\\n\\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\\n\\tPointLightShadow pointLightShadow;\\n\\t#endif\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\\n\\t\\tpointLight = pointLights[ i ];\\n\\t\\tgetPointLightInfo( pointLight, geometryPosition, directLight );\\n\\t\\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\\n\\t\\tpointLightShadow = pointLightShadows[ i ];\\n\\t\\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\\n\\t\\t#endif\\n\\t\\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\\n\\t}\\n\\t#pragma unroll_loop_end\\n#endif\\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\\n\\tSpotLight spotLight;\\n\\tvec4 spotColor;\\n\\tvec3 spotLightCoord;\\n\\tbool inSpotLightMap;\\n\\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\\n\\tSpotLightShadow spotLightShadow;\\n\\t#endif\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\\n\\t\\tspotLight = spotLights[ i ];\\n\\t\\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\\n\\t\\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\\n\\t\\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\\n\\t\\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\\n\\t\\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\\n\\t\\t#else\\n\\t\\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\\n\\t\\t#endif\\n\\t\\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\\n\\t\\t\\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\\n\\t\\t\\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\\n\\t\\t\\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\\n\\t\\t\\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\\n\\t\\t#endif\\n\\t\\t#undef SPOT_LIGHT_MAP_INDEX\\n\\t\\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\\n\\t\\tspotLightShadow = spotLightShadows[ i ];\\n\\t\\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\\n\\t\\t#endif\\n\\t\\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\\n\\t}\\n\\t#pragma unroll_loop_end\\n#endif\\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\\n\\tDirectionalLight directionalLight;\\n\\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\\n\\tDirectionalLightShadow directionalLightShadow;\\n\\t#endif\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\\n\\t\\tdirectionalLight = directionalLights[ i ];\\n\\t\\tgetDirectionalLightInfo( directionalLight, directLight );\\n\\t\\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\\n\\t\\tdirectionalLightShadow = directionalLightShadows[ i ];\\n\\t\\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\\n\\t\\t#endif\\n\\t\\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\\n\\t}\\n\\t#pragma unroll_loop_end\\n#endif\\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\\n\\tRectAreaLight rectAreaLight;\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\\n\\t\\trectAreaLight = rectAreaLights[ i ];\\n\\t\\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\\n\\t}\\n\\t#pragma unroll_loop_end\\n#endif\\n#if defined( RE_IndirectDiffuse )\\n\\tvec3 iblIrradiance = vec3( 0.0 );\\n\\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\\n\\t#if defined( USE_LIGHT_PROBES )\\n\\t\\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\\n\\t#endif\\n\\t#if ( NUM_HEMI_LIGHTS > 0 )\\n\\t\\t#pragma unroll_loop_start\\n\\t\\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\\n\\t\\t\\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\\n\\t\\t}\\n\\t\\t#pragma unroll_loop_end\\n\\t#endif\\n#endif\\n#if defined( RE_IndirectSpecular )\\n\\tvec3 radiance = vec3( 0.0 );\\n\\tvec3 clearcoatRadiance = vec3( 0.0 );\\n#endif",lights_fragment_maps:"#if defined( RE_IndirectDiffuse )\\n\\t#ifdef USE_LIGHTMAP\\n\\t\\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\\n\\t\\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\\n\\t\\tirradiance += lightMapIrradiance;\\n\\t#endif\\n\\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\\n\\t\\tiblIrradiance += getIBLIrradiance( geometryNormal );\\n\\t#endif\\n#endif\\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\\n\\t#ifdef USE_ANISOTROPY\\n\\t\\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\\n\\t#else\\n\\t\\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\\n\\t#endif\\n\\t#ifdef USE_CLEARCOAT\\n\\t\\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\\n\\t#endif\\n#endif",lights_fragment_end:"#if defined( RE_IndirectDiffuse )\\n\\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\\n#endif\\n#if defined( RE_IndirectSpecular )\\n\\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\\n#endif",logdepthbuf_fragment:"#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\\n\\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\\n#endif",logdepthbuf_pars_fragment:"#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\\n\\tuniform float logDepthBufFC;\\n\\tvarying float vFragDepth;\\n\\tvarying float vIsPerspective;\\n#endif",logdepthbuf_pars_vertex:"#ifdef USE_LOGDEPTHBUF\\n\\t#ifdef USE_LOGDEPTHBUF_EXT\\n\\t\\tvarying float vFragDepth;\\n\\t\\tvarying float vIsPerspective;\\n\\t#else\\n\\t\\tuniform float logDepthBufFC;\\n\\t#endif\\n#endif",logdepthbuf_vertex:"#ifdef USE_LOGDEPTHBUF\\n\\t#ifdef USE_LOGDEPTHBUF_EXT\\n\\t\\tvFragDepth = 1.0 + gl_Position.w;\\n\\t\\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\\n\\t#else\\n\\t\\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\\n\\t\\t\\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\\n\\t\\t\\tgl_Position.z *= gl_Position.w;\\n\\t\\t}\\n\\t#endif\\n#endif",map_fragment:"#ifdef USE_MAP\\n\\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\\n\\t#ifdef DECODE_VIDEO_TEXTURE\\n\\t\\tsampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );\\n\\t\\n\\t#endif\\n\\tdiffuseColor *= sampledDiffuseColor;\\n#endif",map_pars_fragment:"#ifdef USE_MAP\\n\\tuniform sampler2D map;\\n#endif",map_particle_fragment:"#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\\n\\t#if defined( USE_POINTS_UV )\\n\\t\\tvec2 uv = vUv;\\n\\t#else\\n\\t\\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\\n\\t#endif\\n#endif\\n#ifdef USE_MAP\\n\\tdiffuseColor *= texture2D( map, uv );\\n#endif\\n#ifdef USE_ALPHAMAP\\n\\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\\n#endif",map_particle_pars_fragment:"#if defined( USE_POINTS_UV )\\n\\tvarying vec2 vUv;\\n#else\\n\\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\\n\\t\\tuniform mat3 uvTransform;\\n\\t#endif\\n#endif\\n#ifdef USE_MAP\\n\\tuniform sampler2D map;\\n#endif\\n#ifdef USE_ALPHAMAP\\n\\tuniform sampler2D alphaMap;\\n#endif",metalnessmap_fragment:"float metalnessFactor = metalness;\\n#ifdef USE_METALNESSMAP\\n\\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\\n\\tmetalnessFactor *= texelMetalness.b;\\n#endif",metalnessmap_pars_fragment:"#ifdef USE_METALNESSMAP\\n\\tuniform sampler2D metalnessMap;\\n#endif",morphcolor_vertex:"#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )\\n\\tvColor *= morphTargetBaseInfluence;\\n\\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\\n\\t\\t#if defined( USE_COLOR_ALPHA )\\n\\t\\t\\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\\n\\t\\t#elif defined( USE_COLOR )\\n\\t\\t\\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\\n\\t\\t#endif\\n\\t}\\n#endif",morphnormal_vertex:"#ifdef USE_MORPHNORMALS\\n\\tobjectNormal *= morphTargetBaseInfluence;\\n\\t#ifdef MORPHTARGETS_TEXTURE\\n\\t\\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\\n\\t\\t\\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\\n\\t\\t}\\n\\t#else\\n\\t\\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\\n\\t\\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\\n\\t\\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\\n\\t\\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\\n\\t#endif\\n#endif",morphtarget_pars_vertex:"#ifdef USE_MORPHTARGETS\\n\\tuniform float morphTargetBaseInfluence;\\n\\t#ifdef MORPHTARGETS_TEXTURE\\n\\t\\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\\n\\t\\tuniform sampler2DArray morphTargetsTexture;\\n\\t\\tuniform ivec2 morphTargetsTextureSize;\\n\\t\\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\\n\\t\\t\\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\\n\\t\\t\\tint y = texelIndex / morphTargetsTextureSize.x;\\n\\t\\t\\tint x = texelIndex - y * morphTargetsTextureSize.x;\\n\\t\\t\\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\\n\\t\\t\\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\\n\\t\\t}\\n\\t#else\\n\\t\\t#ifndef USE_MORPHNORMALS\\n\\t\\t\\tuniform float morphTargetInfluences[ 8 ];\\n\\t\\t#else\\n\\t\\t\\tuniform float morphTargetInfluences[ 4 ];\\n\\t\\t#endif\\n\\t#endif\\n#endif",morphtarget_vertex:"#ifdef USE_MORPHTARGETS\\n\\ttransformed *= morphTargetBaseInfluence;\\n\\t#ifdef MORPHTARGETS_TEXTURE\\n\\t\\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\\n\\t\\t\\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\\n\\t\\t}\\n\\t#else\\n\\t\\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\\n\\t\\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\\n\\t\\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\\n\\t\\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\\n\\t\\t#ifndef USE_MORPHNORMALS\\n\\t\\t\\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\\n\\t\\t\\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\\n\\t\\t\\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\\n\\t\\t\\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\\n\\t\\t#endif\\n\\t#endif\\n#endif",normal_fragment_begin:"float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\\n#ifdef FLAT_SHADED\\n\\tvec3 fdx = dFdx( vViewPosition );\\n\\tvec3 fdy = dFdy( vViewPosition );\\n\\tvec3 normal = normalize( cross( fdx, fdy ) );\\n#else\\n\\tvec3 normal = normalize( vNormal );\\n\\t#ifdef DOUBLE_SIDED\\n\\t\\tnormal *= faceDirection;\\n\\t#endif\\n#endif\\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\\n\\t#ifdef USE_TANGENT\\n\\t\\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\\n\\t#else\\n\\t\\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\\n\\t\\t#if defined( USE_NORMALMAP )\\n\\t\\t\\tvNormalMapUv\\n\\t\\t#elif defined( USE_CLEARCOAT_NORMALMAP )\\n\\t\\t\\tvClearcoatNormalMapUv\\n\\t\\t#else\\n\\t\\t\\tvUv\\n\\t\\t#endif\\n\\t\\t);\\n\\t#endif\\n\\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\\n\\t\\ttbn[0] *= faceDirection;\\n\\t\\ttbn[1] *= faceDirection;\\n\\t#endif\\n#endif\\n#ifdef USE_CLEARCOAT_NORMALMAP\\n\\t#ifdef USE_TANGENT\\n\\t\\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\\n\\t#else\\n\\t\\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\\n\\t#endif\\n\\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\\n\\t\\ttbn2[0] *= faceDirection;\\n\\t\\ttbn2[1] *= faceDirection;\\n\\t#endif\\n#endif\\nvec3 nonPerturbedNormal = normal;",normal_fragment_maps:"#ifdef USE_NORMALMAP_OBJECTSPACE\\n\\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\\n\\t#ifdef FLIP_SIDED\\n\\t\\tnormal = - normal;\\n\\t#endif\\n\\t#ifdef DOUBLE_SIDED\\n\\t\\tnormal = normal * faceDirection;\\n\\t#endif\\n\\tnormal = normalize( normalMatrix * normal );\\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\\n\\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\\n\\tmapN.xy *= normalScale;\\n\\tnormal = normalize( tbn * mapN );\\n#elif defined( USE_BUMPMAP )\\n\\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\\n#endif",normal_pars_fragment:"#ifndef FLAT_SHADED\\n\\tvarying vec3 vNormal;\\n\\t#ifdef USE_TANGENT\\n\\t\\tvarying vec3 vTangent;\\n\\t\\tvarying vec3 vBitangent;\\n\\t#endif\\n#endif",normal_pars_vertex:"#ifndef FLAT_SHADED\\n\\tvarying vec3 vNormal;\\n\\t#ifdef USE_TANGENT\\n\\t\\tvarying vec3 vTangent;\\n\\t\\tvarying vec3 vBitangent;\\n\\t#endif\\n#endif",normal_vertex:"#ifndef FLAT_SHADED\\n\\tvNormal = normalize( transformedNormal );\\n\\t#ifdef USE_TANGENT\\n\\t\\tvTangent = normalize( transformedTangent );\\n\\t\\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\\n\\t#endif\\n#endif",normalmap_pars_fragment:"#ifdef USE_NORMALMAP\\n\\tuniform sampler2D normalMap;\\n\\tuniform vec2 normalScale;\\n#endif\\n#ifdef USE_NORMALMAP_OBJECTSPACE\\n\\tuniform mat3 normalMatrix;\\n#endif\\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\\n\\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\\n\\t\\tvec3 q0 = dFdx( eye_pos.xyz );\\n\\t\\tvec3 q1 = dFdy( eye_pos.xyz );\\n\\t\\tvec2 st0 = dFdx( uv.st );\\n\\t\\tvec2 st1 = dFdy( uv.st );\\n\\t\\tvec3 N = surf_norm;\\n\\t\\tvec3 q1perp = cross( q1, N );\\n\\t\\tvec3 q0perp = cross( N, q0 );\\n\\t\\tvec3 T = q1perp * st0.x + q0perp * st1.x;\\n\\t\\tvec3 B = q1perp * st0.y + q0perp * st1.y;\\n\\t\\tfloat det = max( dot( T, T ), dot( B, B ) );\\n\\t\\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\\n\\t\\treturn mat3( T * scale, B * scale, N );\\n\\t}\\n#endif",clearcoat_normal_fragment_begin:"#ifdef USE_CLEARCOAT\\n\\tvec3 clearcoatNormal = nonPerturbedNormal;\\n#endif",clearcoat_normal_fragment_maps:"#ifdef USE_CLEARCOAT_NORMALMAP\\n\\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\\n\\tclearcoatMapN.xy *= clearcoatNormalScale;\\n\\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\\n#endif",clearcoat_pars_fragment:"#ifdef USE_CLEARCOATMAP\\n\\tuniform sampler2D clearcoatMap;\\n#endif\\n#ifdef USE_CLEARCOAT_NORMALMAP\\n\\tuniform sampler2D clearcoatNormalMap;\\n\\tuniform vec2 clearcoatNormalScale;\\n#endif\\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\\n\\tuniform sampler2D clearcoatRoughnessMap;\\n#endif",iridescence_pars_fragment:"#ifdef USE_IRIDESCENCEMAP\\n\\tuniform sampler2D iridescenceMap;\\n#endif\\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\\n\\tuniform sampler2D iridescenceThicknessMap;\\n#endif",opaque_fragment:"#ifdef OPAQUE\\ndiffuseColor.a = 1.0;\\n#endif\\n#ifdef USE_TRANSMISSION\\ndiffuseColor.a *= material.transmissionAlpha;\\n#endif\\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",packing:"vec3 packNormalToRGB( const in vec3 normal ) {\\n\\treturn normalize( normal ) * 0.5 + 0.5;\\n}\\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\\n\\treturn 2.0 * rgb.xyz - 1.0;\\n}\\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\\nconst float ShiftRight8 = 1. / 256.;\\nvec4 packDepthToRGBA( const in float v ) {\\n\\tvec4 r = vec4( fract( v * PackFactors ), v );\\n\\tr.yzw -= r.xyz * ShiftRight8;\\treturn r * PackUpscale;\\n}\\nfloat unpackRGBAToDepth( const in vec4 v ) {\\n\\treturn dot( v, UnpackFactors );\\n}\\nvec2 packDepthToRG( in highp float v ) {\\n\\treturn packDepthToRGBA( v ).yx;\\n}\\nfloat unpackRGToDepth( const in highp vec2 v ) {\\n\\treturn unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );\\n}\\nvec4 pack2HalfToRGBA( vec2 v ) {\\n\\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\\n\\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\\n}\\nvec2 unpackRGBATo2Half( vec4 v ) {\\n\\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\\n}\\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\\n\\treturn ( viewZ + near ) / ( near - far );\\n}\\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\\n\\treturn depth * ( near - far ) - near;\\n}\\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\\n\\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\\n}\\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\\n\\treturn ( near * far ) / ( ( far - near ) * depth - far );\\n}",premultiplied_alpha_fragment:"#ifdef PREMULTIPLIED_ALPHA\\n\\tgl_FragColor.rgb *= gl_FragColor.a;\\n#endif",project_vertex:"vec4 mvPosition = vec4( transformed, 1.0 );\\n#ifdef USE_INSTANCING\\n\\tmvPosition = instanceMatrix * mvPosition;\\n#endif\\nmvPosition = modelViewMatrix * mvPosition;\\ngl_Position = projectionMatrix * mvPosition;",dithering_fragment:"#ifdef DITHERING\\n\\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\\n#endif",dithering_pars_fragment:"#ifdef DITHERING\\n\\tvec3 dithering( vec3 color ) {\\n\\t\\tfloat grid_position = rand( gl_FragCoord.xy );\\n\\t\\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\\n\\t\\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\\n\\t\\treturn color + dither_shift_RGB;\\n\\t}\\n#endif",roughnessmap_fragment:"float roughnessFactor = roughness;\\n#ifdef USE_ROUGHNESSMAP\\n\\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\\n\\troughnessFactor *= texelRoughness.g;\\n#endif",roughnessmap_pars_fragment:"#ifdef USE_ROUGHNESSMAP\\n\\tuniform sampler2D roughnessMap;\\n#endif",shadowmap_pars_fragment:"#if NUM_SPOT_LIGHT_COORDS > 0\\n\\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\\n#endif\\n#if NUM_SPOT_LIGHT_MAPS > 0\\n\\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\\n#endif\\n#ifdef USE_SHADOWMAP\\n\\t#if NUM_DIR_LIGHT_SHADOWS > 0\\n\\t\\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\\n\\t\\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\\n\\t\\tstruct DirectionalLightShadow {\\n\\t\\t\\tfloat shadowBias;\\n\\t\\t\\tfloat shadowNormalBias;\\n\\t\\t\\tfloat shadowRadius;\\n\\t\\t\\tvec2 shadowMapSize;\\n\\t\\t};\\n\\t\\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\\n\\t#endif\\n\\t#if NUM_SPOT_LIGHT_SHADOWS > 0\\n\\t\\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\\n\\t\\tstruct SpotLightShadow {\\n\\t\\t\\tfloat shadowBias;\\n\\t\\t\\tfloat shadowNormalBias;\\n\\t\\t\\tfloat shadowRadius;\\n\\t\\t\\tvec2 shadowMapSize;\\n\\t\\t};\\n\\t\\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\\n\\t#endif\\n\\t#if NUM_POINT_LIGHT_SHADOWS > 0\\n\\t\\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\\n\\t\\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\\n\\t\\tstruct PointLightShadow {\\n\\t\\t\\tfloat shadowBias;\\n\\t\\t\\tfloat shadowNormalBias;\\n\\t\\t\\tfloat shadowRadius;\\n\\t\\t\\tvec2 shadowMapSize;\\n\\t\\t\\tfloat shadowCameraNear;\\n\\t\\t\\tfloat shadowCameraFar;\\n\\t\\t};\\n\\t\\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\\n\\t#endif\\n\\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\\n\\t\\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\\n\\t}\\n\\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\\n\\t\\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\\n\\t}\\n\\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\\n\\t\\tfloat occlusion = 1.0;\\n\\t\\tvec2 distribution = texture2DDistribution( shadow, uv );\\n\\t\\tfloat hard_shadow = step( compare , distribution.x );\\n\\t\\tif (hard_shadow != 1.0 ) {\\n\\t\\t\\tfloat distance = compare - distribution.x ;\\n\\t\\t\\tfloat variance = max( 0.00000, distribution.y * distribution.y );\\n\\t\\t\\tfloat softness_probability = variance / (variance + distance * distance );\\t\\t\\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\\t\\t\\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\\n\\t\\t}\\n\\t\\treturn occlusion;\\n\\t}\\n\\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\\n\\t\\tfloat shadow = 1.0;\\n\\t\\tshadowCoord.xyz /= shadowCoord.w;\\n\\t\\tshadowCoord.z += shadowBias;\\n\\t\\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\\n\\t\\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\\n\\t\\tif ( frustumTest ) {\\n\\t\\t#if defined( SHADOWMAP_TYPE_PCF )\\n\\t\\t\\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\\n\\t\\t\\tfloat dx0 = - texelSize.x * shadowRadius;\\n\\t\\t\\tfloat dy0 = - texelSize.y * shadowRadius;\\n\\t\\t\\tfloat dx1 = + texelSize.x * shadowRadius;\\n\\t\\t\\tfloat dy1 = + texelSize.y * shadowRadius;\\n\\t\\t\\tfloat dx2 = dx0 / 2.0;\\n\\t\\t\\tfloat dy2 = dy0 / 2.0;\\n\\t\\t\\tfloat dx3 = dx1 / 2.0;\\n\\t\\t\\tfloat dy3 = dy1 / 2.0;\\n\\t\\t\\tshadow = (\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\\n\\t\\t\\t) * ( 1.0 / 17.0 );\\n\\t\\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\\n\\t\\t\\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\\n\\t\\t\\tfloat dx = texelSize.x;\\n\\t\\t\\tfloat dy = texelSize.y;\\n\\t\\t\\tvec2 uv = shadowCoord.xy;\\n\\t\\t\\tvec2 f = fract( uv * shadowMapSize + 0.5 );\\n\\t\\t\\tuv -= f * texelSize;\\n\\t\\t\\tshadow = (\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\\n\\t\\t\\t\\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t f.x ) +\\n\\t\\t\\t\\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t f.x ) +\\n\\t\\t\\t\\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t f.y ) +\\n\\t\\t\\t\\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t f.y ) +\\n\\t\\t\\t\\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t\\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t\\t  f.x ),\\n\\t\\t\\t\\t\\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t\\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\\n\\t\\t\\t\\t\\t\\t  f.x ),\\n\\t\\t\\t\\t\\t f.y )\\n\\t\\t\\t) * ( 1.0 / 9.0 );\\n\\t\\t#elif defined( SHADOWMAP_TYPE_VSM )\\n\\t\\t\\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\\n\\t\\t#else\\n\\t\\t\\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\\n\\t\\t#endif\\n\\t\\t}\\n\\t\\treturn shadow;\\n\\t}\\n\\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\\n\\t\\tvec3 absV = abs( v );\\n\\t\\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\\n\\t\\tabsV *= scaleToCube;\\n\\t\\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\\n\\t\\tvec2 planar = v.xy;\\n\\t\\tfloat almostATexel = 1.5 * texelSizeY;\\n\\t\\tfloat almostOne = 1.0 - almostATexel;\\n\\t\\tif ( absV.z >= almostOne ) {\\n\\t\\t\\tif ( v.z > 0.0 )\\n\\t\\t\\t\\tplanar.x = 4.0 - v.x;\\n\\t\\t} else if ( absV.x >= almostOne ) {\\n\\t\\t\\tfloat signX = sign( v.x );\\n\\t\\t\\tplanar.x = v.z * signX + 2.0 * signX;\\n\\t\\t} else if ( absV.y >= almostOne ) {\\n\\t\\t\\tfloat signY = sign( v.y );\\n\\t\\t\\tplanar.x = v.x + 2.0 * signY + 2.0;\\n\\t\\t\\tplanar.y = v.z * signY - 2.0;\\n\\t\\t}\\n\\t\\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\\n\\t}\\n\\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\\n\\t\\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\\n\\t\\tvec3 lightToPosition = shadowCoord.xyz;\\n\\t\\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\\t\\tdp += shadowBias;\\n\\t\\tvec3 bd3D = normalize( lightToPosition );\\n\\t\\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\\n\\t\\t\\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\\n\\t\\t\\treturn (\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\\n\\t\\t\\t\\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\\n\\t\\t\\t) * ( 1.0 / 9.0 );\\n\\t\\t#else\\n\\t\\t\\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\\n\\t\\t#endif\\n\\t}\\n#endif",shadowmap_pars_vertex:"#if NUM_SPOT_LIGHT_COORDS > 0\\n\\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\\n\\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\\n#endif\\n#ifdef USE_SHADOWMAP\\n\\t#if NUM_DIR_LIGHT_SHADOWS > 0\\n\\t\\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\\n\\t\\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\\n\\t\\tstruct DirectionalLightShadow {\\n\\t\\t\\tfloat shadowBias;\\n\\t\\t\\tfloat shadowNormalBias;\\n\\t\\t\\tfloat shadowRadius;\\n\\t\\t\\tvec2 shadowMapSize;\\n\\t\\t};\\n\\t\\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\\n\\t#endif\\n\\t#if NUM_SPOT_LIGHT_SHADOWS > 0\\n\\t\\tstruct SpotLightShadow {\\n\\t\\t\\tfloat shadowBias;\\n\\t\\t\\tfloat shadowNormalBias;\\n\\t\\t\\tfloat shadowRadius;\\n\\t\\t\\tvec2 shadowMapSize;\\n\\t\\t};\\n\\t\\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\\n\\t#endif\\n\\t#if NUM_POINT_LIGHT_SHADOWS > 0\\n\\t\\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\\n\\t\\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\\n\\t\\tstruct PointLightShadow {\\n\\t\\t\\tfloat shadowBias;\\n\\t\\t\\tfloat shadowNormalBias;\\n\\t\\t\\tfloat shadowRadius;\\n\\t\\t\\tvec2 shadowMapSize;\\n\\t\\t\\tfloat shadowCameraNear;\\n\\t\\t\\tfloat shadowCameraFar;\\n\\t\\t};\\n\\t\\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\\n\\t#endif\\n#endif",shadowmap_vertex:"#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\\n\\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\\n\\tvec4 shadowWorldPosition;\\n#endif\\n#if defined( USE_SHADOWMAP )\\n\\t#if NUM_DIR_LIGHT_SHADOWS > 0\\n\\t\\t#pragma unroll_loop_start\\n\\t\\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\\n\\t\\t\\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\\n\\t\\t\\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\\n\\t\\t}\\n\\t\\t#pragma unroll_loop_end\\n\\t#endif\\n\\t#if NUM_POINT_LIGHT_SHADOWS > 0\\n\\t\\t#pragma unroll_loop_start\\n\\t\\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\\n\\t\\t\\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\\n\\t\\t\\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\\n\\t\\t}\\n\\t\\t#pragma unroll_loop_end\\n\\t#endif\\n#endif\\n#if NUM_SPOT_LIGHT_COORDS > 0\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\\n\\t\\tshadowWorldPosition = worldPosition;\\n\\t\\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\\n\\t\\t\\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\\n\\t\\t#endif\\n\\t\\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\\n\\t}\\n\\t#pragma unroll_loop_end\\n#endif",shadowmask_pars_fragment:"float getShadowMask() {\\n\\tfloat shadow = 1.0;\\n\\t#ifdef USE_SHADOWMAP\\n\\t#if NUM_DIR_LIGHT_SHADOWS > 0\\n\\tDirectionalLightShadow directionalLight;\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\\n\\t\\tdirectionalLight = directionalLightShadows[ i ];\\n\\t\\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\\n\\t}\\n\\t#pragma unroll_loop_end\\n\\t#endif\\n\\t#if NUM_SPOT_LIGHT_SHADOWS > 0\\n\\tSpotLightShadow spotLight;\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\\n\\t\\tspotLight = spotLightShadows[ i ];\\n\\t\\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\\n\\t}\\n\\t#pragma unroll_loop_end\\n\\t#endif\\n\\t#if NUM_POINT_LIGHT_SHADOWS > 0\\n\\tPointLightShadow pointLight;\\n\\t#pragma unroll_loop_start\\n\\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\\n\\t\\tpointLight = pointLightShadows[ i ];\\n\\t\\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\\n\\t}\\n\\t#pragma unroll_loop_end\\n\\t#endif\\n\\t#endif\\n\\treturn shadow;\\n}",skinbase_vertex:"#ifdef USE_SKINNING\\n\\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\\n\\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\\n\\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\\n\\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\\n#endif",skinning_pars_vertex:"#ifdef USE_SKINNING\\n\\tuniform mat4 bindMatrix;\\n\\tuniform mat4 bindMatrixInverse;\\n\\tuniform highp sampler2D boneTexture;\\n\\tuniform int boneTextureSize;\\n\\tmat4 getBoneMatrix( const in float i ) {\\n\\t\\tfloat j = i * 4.0;\\n\\t\\tfloat x = mod( j, float( boneTextureSize ) );\\n\\t\\tfloat y = floor( j / float( boneTextureSize ) );\\n\\t\\tfloat dx = 1.0 / float( boneTextureSize );\\n\\t\\tfloat dy = 1.0 / float( boneTextureSize );\\n\\t\\ty = dy * ( y + 0.5 );\\n\\t\\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\\n\\t\\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\\n\\t\\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\\n\\t\\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\\n\\t\\tmat4 bone = mat4( v1, v2, v3, v4 );\\n\\t\\treturn bone;\\n\\t}\\n#endif",skinning_vertex:"#ifdef USE_SKINNING\\n\\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\\n\\tvec4 skinned = vec4( 0.0 );\\n\\tskinned += boneMatX * skinVertex * skinWeight.x;\\n\\tskinned += boneMatY * skinVertex * skinWeight.y;\\n\\tskinned += boneMatZ * skinVertex * skinWeight.z;\\n\\tskinned += boneMatW * skinVertex * skinWeight.w;\\n\\ttransformed = ( bindMatrixInverse * skinned ).xyz;\\n#endif",skinnormal_vertex:"#ifdef USE_SKINNING\\n\\tmat4 skinMatrix = mat4( 0.0 );\\n\\tskinMatrix += skinWeight.x * boneMatX;\\n\\tskinMatrix += skinWeight.y * boneMatY;\\n\\tskinMatrix += skinWeight.z * boneMatZ;\\n\\tskinMatrix += skinWeight.w * boneMatW;\\n\\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\\n\\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\\n\\t#ifdef USE_TANGENT\\n\\t\\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\\n\\t#endif\\n#endif",specularmap_fragment:"float specularStrength;\\n#ifdef USE_SPECULARMAP\\n\\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\\n\\tspecularStrength = texelSpecular.r;\\n#else\\n\\tspecularStrength = 1.0;\\n#endif",specularmap_pars_fragment:"#ifdef USE_SPECULARMAP\\n\\tuniform sampler2D specularMap;\\n#endif",tonemapping_fragment:"#if defined( TONE_MAPPING )\\n\\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\\n#endif",tonemapping_pars_fragment:"#ifndef saturate\\n#define saturate( a ) clamp( a, 0.0, 1.0 )\\n#endif\\nuniform float toneMappingExposure;\\nvec3 LinearToneMapping( vec3 color ) {\\n\\treturn saturate( toneMappingExposure * color );\\n}\\nvec3 ReinhardToneMapping( vec3 color ) {\\n\\tcolor *= toneMappingExposure;\\n\\treturn saturate( color / ( vec3( 1.0 ) + color ) );\\n}\\nvec3 OptimizedCineonToneMapping( vec3 color ) {\\n\\tcolor *= toneMappingExposure;\\n\\tcolor = max( vec3( 0.0 ), color - 0.004 );\\n\\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\\n}\\nvec3 RRTAndODTFit( vec3 v ) {\\n\\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\\n\\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\\n\\treturn a / b;\\n}\\nvec3 ACESFilmicToneMapping( vec3 color ) {\\n\\tconst mat3 ACESInputMat = mat3(\\n\\t\\tvec3( 0.59719, 0.07600, 0.02840 ),\\t\\tvec3( 0.35458, 0.90834, 0.13383 ),\\n\\t\\tvec3( 0.04823, 0.01566, 0.83777 )\\n\\t);\\n\\tconst mat3 ACESOutputMat = mat3(\\n\\t\\tvec3(  1.60475, -0.10208, -0.00327 ),\\t\\tvec3( -0.53108,  1.10813, -0.07276 ),\\n\\t\\tvec3( -0.07367, -0.00605,  1.07602 )\\n\\t);\\n\\tcolor *= toneMappingExposure / 0.6;\\n\\tcolor = ACESInputMat * color;\\n\\tcolor = RRTAndODTFit( color );\\n\\tcolor = ACESOutputMat * color;\\n\\treturn saturate( color );\\n}\\nvec3 CustomToneMapping( vec3 color ) { return color; }",transmission_fragment:"#ifdef USE_TRANSMISSION\\n\\tmaterial.transmission = transmission;\\n\\tmaterial.transmissionAlpha = 1.0;\\n\\tmaterial.thickness = thickness;\\n\\tmaterial.attenuationDistance = attenuationDistance;\\n\\tmaterial.attenuationColor = attenuationColor;\\n\\t#ifdef USE_TRANSMISSIONMAP\\n\\t\\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\\n\\t#endif\\n\\t#ifdef USE_THICKNESSMAP\\n\\t\\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\\n\\t#endif\\n\\tvec3 pos = vWorldPosition;\\n\\tvec3 v = normalize( cameraPosition - pos );\\n\\tvec3 n = inverseTransformDirection( normal, viewMatrix );\\n\\tvec4 transmitted = getIBLVolumeRefraction(\\n\\t\\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\\n\\t\\tpos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,\\n\\t\\tmaterial.attenuationColor, material.attenuationDistance );\\n\\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\\n\\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\\n#endif",transmission_pars_fragment:"#ifdef USE_TRANSMISSION\\n\\tuniform float transmission;\\n\\tuniform float thickness;\\n\\tuniform float attenuationDistance;\\n\\tuniform vec3 attenuationColor;\\n\\t#ifdef USE_TRANSMISSIONMAP\\n\\t\\tuniform sampler2D transmissionMap;\\n\\t#endif\\n\\t#ifdef USE_THICKNESSMAP\\n\\t\\tuniform sampler2D thicknessMap;\\n\\t#endif\\n\\tuniform vec2 transmissionSamplerSize;\\n\\tuniform sampler2D transmissionSamplerMap;\\n\\tuniform mat4 modelMatrix;\\n\\tuniform mat4 projectionMatrix;\\n\\tvarying vec3 vWorldPosition;\\n\\tfloat w0( float a ) {\\n\\t\\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\\n\\t}\\n\\tfloat w1( float a ) {\\n\\t\\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\\n\\t}\\n\\tfloat w2( float a ){\\n\\t\\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\\n\\t}\\n\\tfloat w3( float a ) {\\n\\t\\treturn ( 1.0 / 6.0 ) * ( a * a * a );\\n\\t}\\n\\tfloat g0( float a ) {\\n\\t\\treturn w0( a ) + w1( a );\\n\\t}\\n\\tfloat g1( float a ) {\\n\\t\\treturn w2( a ) + w3( a );\\n\\t}\\n\\tfloat h0( float a ) {\\n\\t\\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\\n\\t}\\n\\tfloat h1( float a ) {\\n\\t\\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\\n\\t}\\n\\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\\n\\t\\tuv = uv * texelSize.zw + 0.5;\\n\\t\\tvec2 iuv = floor( uv );\\n\\t\\tvec2 fuv = fract( uv );\\n\\t\\tfloat g0x = g0( fuv.x );\\n\\t\\tfloat g1x = g1( fuv.x );\\n\\t\\tfloat h0x = h0( fuv.x );\\n\\t\\tfloat h1x = h1( fuv.x );\\n\\t\\tfloat h0y = h0( fuv.y );\\n\\t\\tfloat h1y = h1( fuv.y );\\n\\t\\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\\n\\t\\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\\n\\t\\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\\n\\t\\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\\n\\t\\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\\n\\t\\t\\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\\n\\t}\\n\\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\\n\\t\\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\\n\\t\\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\\n\\t\\tvec2 fLodSizeInv = 1.0 / fLodSize;\\n\\t\\tvec2 cLodSizeInv = 1.0 / cLodSize;\\n\\t\\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\\n\\t\\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\\n\\t\\treturn mix( fSample, cSample, fract( lod ) );\\n\\t}\\n\\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\\n\\t\\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\\n\\t\\tvec3 modelScale;\\n\\t\\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\\n\\t\\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\\n\\t\\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\\n\\t\\treturn normalize( refractionVector ) * thickness * modelScale;\\n\\t}\\n\\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\\n\\t\\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\\n\\t}\\n\\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\\n\\t\\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\\n\\t\\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\\n\\t}\\n\\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\\n\\t\\tif ( isinf( attenuationDistance ) ) {\\n\\t\\t\\treturn vec3( 1.0 );\\n\\t\\t} else {\\n\\t\\t\\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\\n\\t\\t\\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\\t\\t\\treturn transmittance;\\n\\t\\t}\\n\\t}\\n\\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\\n\\t\\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\\n\\t\\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,\\n\\t\\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\\n\\t\\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\\n\\t\\tvec3 refractedRayExit = position + transmissionRay;\\n\\t\\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\\n\\t\\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\\n\\t\\trefractionCoords += 1.0;\\n\\t\\trefractionCoords /= 2.0;\\n\\t\\tvec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\\n\\t\\tvec3 transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\\n\\t\\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\\n\\t\\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\\n\\t\\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\\n\\t\\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\\n\\t}\\n#endif",uv_pars_fragment:"#if defined( USE_UV ) || defined( USE_ANISOTROPY )\\n\\tvarying vec2 vUv;\\n#endif\\n#ifdef USE_MAP\\n\\tvarying vec2 vMapUv;\\n#endif\\n#ifdef USE_ALPHAMAP\\n\\tvarying vec2 vAlphaMapUv;\\n#endif\\n#ifdef USE_LIGHTMAP\\n\\tvarying vec2 vLightMapUv;\\n#endif\\n#ifdef USE_AOMAP\\n\\tvarying vec2 vAoMapUv;\\n#endif\\n#ifdef USE_BUMPMAP\\n\\tvarying vec2 vBumpMapUv;\\n#endif\\n#ifdef USE_NORMALMAP\\n\\tvarying vec2 vNormalMapUv;\\n#endif\\n#ifdef USE_EMISSIVEMAP\\n\\tvarying vec2 vEmissiveMapUv;\\n#endif\\n#ifdef USE_METALNESSMAP\\n\\tvarying vec2 vMetalnessMapUv;\\n#endif\\n#ifdef USE_ROUGHNESSMAP\\n\\tvarying vec2 vRoughnessMapUv;\\n#endif\\n#ifdef USE_ANISOTROPYMAP\\n\\tvarying vec2 vAnisotropyMapUv;\\n#endif\\n#ifdef USE_CLEARCOATMAP\\n\\tvarying vec2 vClearcoatMapUv;\\n#endif\\n#ifdef USE_CLEARCOAT_NORMALMAP\\n\\tvarying vec2 vClearcoatNormalMapUv;\\n#endif\\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\\n\\tvarying vec2 vClearcoatRoughnessMapUv;\\n#endif\\n#ifdef USE_IRIDESCENCEMAP\\n\\tvarying vec2 vIridescenceMapUv;\\n#endif\\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\\n\\tvarying vec2 vIridescenceThicknessMapUv;\\n#endif\\n#ifdef USE_SHEEN_COLORMAP\\n\\tvarying vec2 vSheenColorMapUv;\\n#endif\\n#ifdef USE_SHEEN_ROUGHNESSMAP\\n\\tvarying vec2 vSheenRoughnessMapUv;\\n#endif\\n#ifdef USE_SPECULARMAP\\n\\tvarying vec2 vSpecularMapUv;\\n#endif\\n#ifdef USE_SPECULAR_COLORMAP\\n\\tvarying vec2 vSpecularColorMapUv;\\n#endif\\n#ifdef USE_SPECULAR_INTENSITYMAP\\n\\tvarying vec2 vSpecularIntensityMapUv;\\n#endif\\n#ifdef USE_TRANSMISSIONMAP\\n\\tuniform mat3 transmissionMapTransform;\\n\\tvarying vec2 vTransmissionMapUv;\\n#endif\\n#ifdef USE_THICKNESSMAP\\n\\tuniform mat3 thicknessMapTransform;\\n\\tvarying vec2 vThicknessMapUv;\\n#endif",uv_pars_vertex:"#if defined( USE_UV ) || defined( USE_ANISOTROPY )\\n\\tvarying vec2 vUv;\\n#endif\\n#ifdef USE_MAP\\n\\tuniform mat3 mapTransform;\\n\\tvarying vec2 vMapUv;\\n#endif\\n#ifdef USE_ALPHAMAP\\n\\tuniform mat3 alphaMapTransform;\\n\\tvarying vec2 vAlphaMapUv;\\n#endif\\n#ifdef USE_LIGHTMAP\\n\\tuniform mat3 lightMapTransform;\\n\\tvarying vec2 vLightMapUv;\\n#endif\\n#ifdef USE_AOMAP\\n\\tuniform mat3 aoMapTransform;\\n\\tvarying vec2 vAoMapUv;\\n#endif\\n#ifdef USE_BUMPMAP\\n\\tuniform mat3 bumpMapTransform;\\n\\tvarying vec2 vBumpMapUv;\\n#endif\\n#ifdef USE_NORMALMAP\\n\\tuniform mat3 normalMapTransform;\\n\\tvarying vec2 vNormalMapUv;\\n#endif\\n#ifdef USE_DISPLACEMENTMAP\\n\\tuniform mat3 displacementMapTransform;\\n\\tvarying vec2 vDisplacementMapUv;\\n#endif\\n#ifdef USE_EMISSIVEMAP\\n\\tuniform mat3 emissiveMapTransform;\\n\\tvarying vec2 vEmissiveMapUv;\\n#endif\\n#ifdef USE_METALNESSMAP\\n\\tuniform mat3 metalnessMapTransform;\\n\\tvarying vec2 vMetalnessMapUv;\\n#endif\\n#ifdef USE_ROUGHNESSMAP\\n\\tuniform mat3 roughnessMapTransform;\\n\\tvarying vec2 vRoughnessMapUv;\\n#endif\\n#ifdef USE_ANISOTROPYMAP\\n\\tuniform mat3 anisotropyMapTransform;\\n\\tvarying vec2 vAnisotropyMapUv;\\n#endif\\n#ifdef USE_CLEARCOATMAP\\n\\tuniform mat3 clearcoatMapTransform;\\n\\tvarying vec2 vClearcoatMapUv;\\n#endif\\n#ifdef USE_CLEARCOAT_NORMALMAP\\n\\tuniform mat3 clearcoatNormalMapTransform;\\n\\tvarying vec2 vClearcoatNormalMapUv;\\n#endif\\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\\n\\tuniform mat3 clearcoatRoughnessMapTransform;\\n\\tvarying vec2 vClearcoatRoughnessMapUv;\\n#endif\\n#ifdef USE_SHEEN_COLORMAP\\n\\tuniform mat3 sheenColorMapTransform;\\n\\tvarying vec2 vSheenColorMapUv;\\n#endif\\n#ifdef USE_SHEEN_ROUGHNESSMAP\\n\\tuniform mat3 sheenRoughnessMapTransform;\\n\\tvarying vec2 vSheenRoughnessMapUv;\\n#endif\\n#ifdef USE_IRIDESCENCEMAP\\n\\tuniform mat3 iridescenceMapTransform;\\n\\tvarying vec2 vIridescenceMapUv;\\n#endif\\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\\n\\tuniform mat3 iridescenceThicknessMapTransform;\\n\\tvarying vec2 vIridescenceThicknessMapUv;\\n#endif\\n#ifdef USE_SPECULARMAP\\n\\tuniform mat3 specularMapTransform;\\n\\tvarying vec2 vSpecularMapUv;\\n#endif\\n#ifdef USE_SPECULAR_COLORMAP\\n\\tuniform mat3 specularColorMapTransform;\\n\\tvarying vec2 vSpecularColorMapUv;\\n#endif\\n#ifdef USE_SPECULAR_INTENSITYMAP\\n\\tuniform mat3 specularIntensityMapTransform;\\n\\tvarying vec2 vSpecularIntensityMapUv;\\n#endif\\n#ifdef USE_TRANSMISSIONMAP\\n\\tuniform mat3 transmissionMapTransform;\\n\\tvarying vec2 vTransmissionMapUv;\\n#endif\\n#ifdef USE_THICKNESSMAP\\n\\tuniform mat3 thicknessMapTransform;\\n\\tvarying vec2 vThicknessMapUv;\\n#endif",uv_vertex:"#if defined( USE_UV ) || defined( USE_ANISOTROPY )\\n\\tvUv = vec3( uv, 1 ).xy;\\n#endif\\n#ifdef USE_MAP\\n\\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_ALPHAMAP\\n\\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_LIGHTMAP\\n\\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_AOMAP\\n\\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_BUMPMAP\\n\\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_NORMALMAP\\n\\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_DISPLACEMENTMAP\\n\\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_EMISSIVEMAP\\n\\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_METALNESSMAP\\n\\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_ROUGHNESSMAP\\n\\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_ANISOTROPYMAP\\n\\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_CLEARCOATMAP\\n\\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_CLEARCOAT_NORMALMAP\\n\\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\\n\\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_IRIDESCENCEMAP\\n\\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\\n\\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_SHEEN_COLORMAP\\n\\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_SHEEN_ROUGHNESSMAP\\n\\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_SPECULARMAP\\n\\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_SPECULAR_COLORMAP\\n\\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_SPECULAR_INTENSITYMAP\\n\\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_TRANSMISSIONMAP\\n\\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\\n#endif\\n#ifdef USE_THICKNESSMAP\\n\\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\\n#endif",worldpos_vertex:"#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\\n\\tvec4 worldPosition = vec4( transformed, 1.0 );\\n\\t#ifdef USE_INSTANCING\\n\\t\\tworldPosition = instanceMatrix * worldPosition;\\n\\t#endif\\n\\tworldPosition = modelMatrix * worldPosition;\\n#endif",background_vert:"varying vec2 vUv;\\nuniform mat3 uvTransform;\\nvoid main() {\\n\\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\\n\\tgl_Position = vec4( position.xy, 1.0, 1.0 );\\n}",background_frag:"uniform sampler2D t2D;\\nuniform float backgroundIntensity;\\nvarying vec2 vUv;\\nvoid main() {\\n\\tvec4 texColor = texture2D( t2D, vUv );\\n\\t#ifdef DECODE_VIDEO_TEXTURE\\n\\t\\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\\n\\t#endif\\n\\ttexColor.rgb *= backgroundIntensity;\\n\\tgl_FragColor = texColor;\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n}",backgroundCube_vert:"varying vec3 vWorldDirection;\\n#include <common>\\nvoid main() {\\n\\tvWorldDirection = transformDirection( position, modelMatrix );\\n\\t#include <begin_vertex>\\n\\t#include <project_vertex>\\n\\tgl_Position.z = gl_Position.w;\\n}",backgroundCube_frag:"#ifdef ENVMAP_TYPE_CUBE\\n\\tuniform samplerCube envMap;\\n#elif defined( ENVMAP_TYPE_CUBE_UV )\\n\\tuniform sampler2D envMap;\\n#endif\\nuniform float flipEnvMap;\\nuniform float backgroundBlurriness;\\nuniform float backgroundIntensity;\\nvarying vec3 vWorldDirection;\\n#include <cube_uv_reflection_fragment>\\nvoid main() {\\n\\t#ifdef ENVMAP_TYPE_CUBE\\n\\t\\tvec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\\n\\t#elif defined( ENVMAP_TYPE_CUBE_UV )\\n\\t\\tvec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );\\n\\t#else\\n\\t\\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\\n\\t#endif\\n\\ttexColor.rgb *= backgroundIntensity;\\n\\tgl_FragColor = texColor;\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n}",cube_vert:"varying vec3 vWorldDirection;\\n#include <common>\\nvoid main() {\\n\\tvWorldDirection = transformDirection( position, modelMatrix );\\n\\t#include <begin_vertex>\\n\\t#include <project_vertex>\\n\\tgl_Position.z = gl_Position.w;\\n}",cube_frag:"uniform samplerCube tCube;\\nuniform float tFlip;\\nuniform float opacity;\\nvarying vec3 vWorldDirection;\\nvoid main() {\\n\\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\\n\\tgl_FragColor = texColor;\\n\\tgl_FragColor.a *= opacity;\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n}",depth_vert:"#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvarying vec2 vHighPrecisionZW;\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#ifdef USE_DISPLACEMENTMAP\\n\\t\\t#include <beginnormal_vertex>\\n\\t\\t#include <morphnormal_vertex>\\n\\t\\t#include <skinnormal_vertex>\\n\\t#endif\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\tvHighPrecisionZW = gl_Position.zw;\\n}",depth_frag:"#if DEPTH_PACKING == 3200\\n\\tuniform float opacity;\\n#endif\\n#include <common>\\n#include <packing>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvarying vec2 vHighPrecisionZW;\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( 1.0 );\\n\\t#if DEPTH_PACKING == 3200\\n\\t\\tdiffuseColor.a = opacity;\\n\\t#endif\\n\\t#include <map_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <logdepthbuf_fragment>\\n\\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\\n\\t#if DEPTH_PACKING == 3200\\n\\t\\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\\n\\t#elif DEPTH_PACKING == 3201\\n\\t\\tgl_FragColor = packDepthToRGBA( fragCoordZ );\\n\\t#endif\\n}",distanceRGBA_vert:"#define DISTANCE\\nvarying vec3 vWorldPosition;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#ifdef USE_DISPLACEMENTMAP\\n\\t\\t#include <beginnormal_vertex>\\n\\t\\t#include <morphnormal_vertex>\\n\\t\\t#include <skinnormal_vertex>\\n\\t#endif\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <worldpos_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\tvWorldPosition = worldPosition.xyz;\\n}",distanceRGBA_frag:"#define DISTANCE\\nuniform vec3 referencePosition;\\nuniform float nearDistance;\\nuniform float farDistance;\\nvarying vec3 vWorldPosition;\\n#include <common>\\n#include <packing>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main () {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( 1.0 );\\n\\t#include <map_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\tfloat dist = length( vWorldPosition - referencePosition );\\n\\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\\n\\tdist = saturate( dist );\\n\\tgl_FragColor = packDepthToRGBA( dist );\\n}",equirect_vert:"varying vec3 vWorldDirection;\\n#include <common>\\nvoid main() {\\n\\tvWorldDirection = transformDirection( position, modelMatrix );\\n\\t#include <begin_vertex>\\n\\t#include <project_vertex>\\n}",equirect_frag:"uniform sampler2D tEquirect;\\nvarying vec3 vWorldDirection;\\n#include <common>\\nvoid main() {\\n\\tvec3 direction = normalize( vWorldDirection );\\n\\tvec2 sampleUV = equirectUv( direction );\\n\\tgl_FragColor = texture2D( tEquirect, sampleUV );\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n}",linedashed_vert:"uniform float scale;\\nattribute float lineDistance;\\nvarying float vLineDistance;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\tvLineDistance = scale * lineDistance;\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\t#include <fog_vertex>\\n}",linedashed_frag:"uniform vec3 diffuse;\\nuniform float opacity;\\nuniform float dashSize;\\nuniform float totalSize;\\nvarying float vLineDistance;\\n#include <common>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\\n\\t\\tdiscard;\\n\\t}\\n\\tvec3 outgoingLight = vec3( 0.0 );\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\toutgoingLight = diffuseColor.rgb;\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n}",meshbasic_vert:"#include <common>\\n#include <uv_pars_vertex>\\n#include <envmap_pars_vertex>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\\n\\t\\t#include <beginnormal_vertex>\\n\\t\\t#include <morphnormal_vertex>\\n\\t\\t#include <skinbase_vertex>\\n\\t\\t#include <skinnormal_vertex>\\n\\t\\t#include <defaultnormal_vertex>\\n\\t#endif\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\t#include <worldpos_vertex>\\n\\t#include <envmap_vertex>\\n\\t#include <fog_vertex>\\n}",meshbasic_frag:"uniform vec3 diffuse;\\nuniform float opacity;\\n#ifndef FLAT_SHADED\\n\\tvarying vec3 vNormal;\\n#endif\\n#include <common>\\n#include <dithering_pars_fragment>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <aomap_pars_fragment>\\n#include <lightmap_pars_fragment>\\n#include <envmap_common_pars_fragment>\\n#include <envmap_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <specularmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <specularmap_fragment>\\n\\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\\n\\t#ifdef USE_LIGHTMAP\\n\\t\\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\\n\\t\\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\\n\\t#else\\n\\t\\treflectedLight.indirectDiffuse += vec3( 1.0 );\\n\\t#endif\\n\\t#include <aomap_fragment>\\n\\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\\n\\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\\n\\t#include <envmap_fragment>\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n\\t#include <dithering_fragment>\\n}",meshlambert_vert:"#define LAMBERT\\nvarying vec3 vViewPosition;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <envmap_pars_vertex>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <normal_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <shadowmap_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <normal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\tvViewPosition = - mvPosition.xyz;\\n\\t#include <worldpos_vertex>\\n\\t#include <envmap_vertex>\\n\\t#include <shadowmap_vertex>\\n\\t#include <fog_vertex>\\n}",meshlambert_frag:"#define LAMBERT\\nuniform vec3 diffuse;\\nuniform vec3 emissive;\\nuniform float opacity;\\n#include <common>\\n#include <packing>\\n#include <dithering_pars_fragment>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <aomap_pars_fragment>\\n#include <lightmap_pars_fragment>\\n#include <emissivemap_pars_fragment>\\n#include <envmap_common_pars_fragment>\\n#include <envmap_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <bsdfs>\\n#include <lights_pars_begin>\\n#include <normal_pars_fragment>\\n#include <lights_lambert_pars_fragment>\\n#include <shadowmap_pars_fragment>\\n#include <bumpmap_pars_fragment>\\n#include <normalmap_pars_fragment>\\n#include <specularmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\\n\\tvec3 totalEmissiveRadiance = emissive;\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <specularmap_fragment>\\n\\t#include <normal_fragment_begin>\\n\\t#include <normal_fragment_maps>\\n\\t#include <emissivemap_fragment>\\n\\t#include <lights_lambert_fragment>\\n\\t#include <lights_fragment_begin>\\n\\t#include <lights_fragment_maps>\\n\\t#include <lights_fragment_end>\\n\\t#include <aomap_fragment>\\n\\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\\n\\t#include <envmap_fragment>\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n\\t#include <dithering_fragment>\\n}",meshmatcap_vert:"#define MATCAP\\nvarying vec3 vViewPosition;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <color_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <normal_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <normal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\t#include <fog_vertex>\\n\\tvViewPosition = - mvPosition.xyz;\\n}",meshmatcap_frag:"#define MATCAP\\nuniform vec3 diffuse;\\nuniform float opacity;\\nuniform sampler2D matcap;\\nvarying vec3 vViewPosition;\\n#include <common>\\n#include <dithering_pars_fragment>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <normal_pars_fragment>\\n#include <bumpmap_pars_fragment>\\n#include <normalmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <normal_fragment_begin>\\n\\t#include <normal_fragment_maps>\\n\\tvec3 viewDir = normalize( vViewPosition );\\n\\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\\n\\tvec3 y = cross( viewDir, x );\\n\\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\\n\\t#ifdef USE_MATCAP\\n\\t\\tvec4 matcapColor = texture2D( matcap, uv );\\n\\t#else\\n\\t\\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\\n\\t#endif\\n\\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n\\t#include <dithering_fragment>\\n}",meshnormal_vert:"#define NORMAL\\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\\n\\tvarying vec3 vViewPosition;\\n#endif\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <normal_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <normal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\\n\\tvViewPosition = - mvPosition.xyz;\\n#endif\\n}",meshnormal_frag:"#define NORMAL\\nuniform float opacity;\\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\\n\\tvarying vec3 vViewPosition;\\n#endif\\n#include <packing>\\n#include <uv_pars_fragment>\\n#include <normal_pars_fragment>\\n#include <bumpmap_pars_fragment>\\n#include <normalmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <normal_fragment_begin>\\n\\t#include <normal_fragment_maps>\\n\\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\\n\\t#ifdef OPAQUE\\n\\t\\tgl_FragColor.a = 1.0;\\n\\t#endif\\n}",meshphong_vert:"#define PHONG\\nvarying vec3 vViewPosition;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <envmap_pars_vertex>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <normal_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <shadowmap_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <normal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\tvViewPosition = - mvPosition.xyz;\\n\\t#include <worldpos_vertex>\\n\\t#include <envmap_vertex>\\n\\t#include <shadowmap_vertex>\\n\\t#include <fog_vertex>\\n}",meshphong_frag:"#define PHONG\\nuniform vec3 diffuse;\\nuniform vec3 emissive;\\nuniform vec3 specular;\\nuniform float shininess;\\nuniform float opacity;\\n#include <common>\\n#include <packing>\\n#include <dithering_pars_fragment>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <aomap_pars_fragment>\\n#include <lightmap_pars_fragment>\\n#include <emissivemap_pars_fragment>\\n#include <envmap_common_pars_fragment>\\n#include <envmap_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <bsdfs>\\n#include <lights_pars_begin>\\n#include <normal_pars_fragment>\\n#include <lights_phong_pars_fragment>\\n#include <shadowmap_pars_fragment>\\n#include <bumpmap_pars_fragment>\\n#include <normalmap_pars_fragment>\\n#include <specularmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\\n\\tvec3 totalEmissiveRadiance = emissive;\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <specularmap_fragment>\\n\\t#include <normal_fragment_begin>\\n\\t#include <normal_fragment_maps>\\n\\t#include <emissivemap_fragment>\\n\\t#include <lights_phong_fragment>\\n\\t#include <lights_fragment_begin>\\n\\t#include <lights_fragment_maps>\\n\\t#include <lights_fragment_end>\\n\\t#include <aomap_fragment>\\n\\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\\n\\t#include <envmap_fragment>\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n\\t#include <dithering_fragment>\\n}",meshphysical_vert:"#define STANDARD\\nvarying vec3 vViewPosition;\\n#ifdef USE_TRANSMISSION\\n\\tvarying vec3 vWorldPosition;\\n#endif\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <normal_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <shadowmap_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <normal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\tvViewPosition = - mvPosition.xyz;\\n\\t#include <worldpos_vertex>\\n\\t#include <shadowmap_vertex>\\n\\t#include <fog_vertex>\\n#ifdef USE_TRANSMISSION\\n\\tvWorldPosition = worldPosition.xyz;\\n#endif\\n}",meshphysical_frag:"#define STANDARD\\n#ifdef PHYSICAL\\n\\t#define IOR\\n\\t#define USE_SPECULAR\\n#endif\\nuniform vec3 diffuse;\\nuniform vec3 emissive;\\nuniform float roughness;\\nuniform float metalness;\\nuniform float opacity;\\n#ifdef IOR\\n\\tuniform float ior;\\n#endif\\n#ifdef USE_SPECULAR\\n\\tuniform float specularIntensity;\\n\\tuniform vec3 specularColor;\\n\\t#ifdef USE_SPECULAR_COLORMAP\\n\\t\\tuniform sampler2D specularColorMap;\\n\\t#endif\\n\\t#ifdef USE_SPECULAR_INTENSITYMAP\\n\\t\\tuniform sampler2D specularIntensityMap;\\n\\t#endif\\n#endif\\n#ifdef USE_CLEARCOAT\\n\\tuniform float clearcoat;\\n\\tuniform float clearcoatRoughness;\\n#endif\\n#ifdef USE_IRIDESCENCE\\n\\tuniform float iridescence;\\n\\tuniform float iridescenceIOR;\\n\\tuniform float iridescenceThicknessMinimum;\\n\\tuniform float iridescenceThicknessMaximum;\\n#endif\\n#ifdef USE_SHEEN\\n\\tuniform vec3 sheenColor;\\n\\tuniform float sheenRoughness;\\n\\t#ifdef USE_SHEEN_COLORMAP\\n\\t\\tuniform sampler2D sheenColorMap;\\n\\t#endif\\n\\t#ifdef USE_SHEEN_ROUGHNESSMAP\\n\\t\\tuniform sampler2D sheenRoughnessMap;\\n\\t#endif\\n#endif\\n#ifdef USE_ANISOTROPY\\n\\tuniform vec2 anisotropyVector;\\n\\t#ifdef USE_ANISOTROPYMAP\\n\\t\\tuniform sampler2D anisotropyMap;\\n\\t#endif\\n#endif\\nvarying vec3 vViewPosition;\\n#include <common>\\n#include <packing>\\n#include <dithering_pars_fragment>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <aomap_pars_fragment>\\n#include <lightmap_pars_fragment>\\n#include <emissivemap_pars_fragment>\\n#include <iridescence_fragment>\\n#include <cube_uv_reflection_fragment>\\n#include <envmap_common_pars_fragment>\\n#include <envmap_physical_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <lights_pars_begin>\\n#include <normal_pars_fragment>\\n#include <lights_physical_pars_fragment>\\n#include <transmission_pars_fragment>\\n#include <shadowmap_pars_fragment>\\n#include <bumpmap_pars_fragment>\\n#include <normalmap_pars_fragment>\\n#include <clearcoat_pars_fragment>\\n#include <iridescence_pars_fragment>\\n#include <roughnessmap_pars_fragment>\\n#include <metalnessmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\\n\\tvec3 totalEmissiveRadiance = emissive;\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <roughnessmap_fragment>\\n\\t#include <metalnessmap_fragment>\\n\\t#include <normal_fragment_begin>\\n\\t#include <normal_fragment_maps>\\n\\t#include <clearcoat_normal_fragment_begin>\\n\\t#include <clearcoat_normal_fragment_maps>\\n\\t#include <emissivemap_fragment>\\n\\t#include <lights_physical_fragment>\\n\\t#include <lights_fragment_begin>\\n\\t#include <lights_fragment_maps>\\n\\t#include <lights_fragment_end>\\n\\t#include <aomap_fragment>\\n\\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\\n\\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\\n\\t#include <transmission_fragment>\\n\\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\\n\\t#ifdef USE_SHEEN\\n\\t\\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\\n\\t\\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\\n\\t#endif\\n\\t#ifdef USE_CLEARCOAT\\n\\t\\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\\n\\t\\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\\n\\t\\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\\n\\t#endif\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n\\t#include <dithering_fragment>\\n}",meshtoon_vert:"#define TOON\\nvarying vec3 vViewPosition;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <displacementmap_pars_vertex>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <normal_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <shadowmap_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <normal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <displacementmap_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\tvViewPosition = - mvPosition.xyz;\\n\\t#include <worldpos_vertex>\\n\\t#include <shadowmap_vertex>\\n\\t#include <fog_vertex>\\n}",meshtoon_frag:"#define TOON\\nuniform vec3 diffuse;\\nuniform vec3 emissive;\\nuniform float opacity;\\n#include <common>\\n#include <packing>\\n#include <dithering_pars_fragment>\\n#include <color_pars_fragment>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <aomap_pars_fragment>\\n#include <lightmap_pars_fragment>\\n#include <emissivemap_pars_fragment>\\n#include <gradientmap_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <bsdfs>\\n#include <lights_pars_begin>\\n#include <normal_pars_fragment>\\n#include <lights_toon_pars_fragment>\\n#include <shadowmap_pars_fragment>\\n#include <bumpmap_pars_fragment>\\n#include <normalmap_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\\n\\tvec3 totalEmissiveRadiance = emissive;\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\t#include <normal_fragment_begin>\\n\\t#include <normal_fragment_maps>\\n\\t#include <emissivemap_fragment>\\n\\t#include <lights_toon_fragment>\\n\\t#include <lights_fragment_begin>\\n\\t#include <lights_fragment_maps>\\n\\t#include <lights_fragment_end>\\n\\t#include <aomap_fragment>\\n\\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n\\t#include <dithering_fragment>\\n}",points_vert:"uniform float size;\\nuniform float scale;\\n#include <common>\\n#include <color_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\n#ifdef USE_POINTS_UV\\n\\tvarying vec2 vUv;\\n\\tuniform mat3 uvTransform;\\n#endif\\nvoid main() {\\n\\t#ifdef USE_POINTS_UV\\n\\t\\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\\n\\t#endif\\n\\t#include <color_vertex>\\n\\t#include <morphcolor_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <project_vertex>\\n\\tgl_PointSize = size;\\n\\t#ifdef USE_SIZEATTENUATION\\n\\t\\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\\n\\t\\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\\n\\t#endif\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\t#include <worldpos_vertex>\\n\\t#include <fog_vertex>\\n}",points_frag:"uniform vec3 diffuse;\\nuniform float opacity;\\n#include <common>\\n#include <color_pars_fragment>\\n#include <map_particle_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec3 outgoingLight = vec3( 0.0 );\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_particle_fragment>\\n\\t#include <color_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\toutgoingLight = diffuseColor.rgb;\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n\\t#include <premultiplied_alpha_fragment>\\n}",shadow_vert:"#include <common>\\n#include <fog_pars_vertex>\\n#include <morphtarget_pars_vertex>\\n#include <skinning_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <shadowmap_pars_vertex>\\nvoid main() {\\n\\t#include <beginnormal_vertex>\\n\\t#include <morphnormal_vertex>\\n\\t#include <skinbase_vertex>\\n\\t#include <skinnormal_vertex>\\n\\t#include <defaultnormal_vertex>\\n\\t#include <begin_vertex>\\n\\t#include <morphtarget_vertex>\\n\\t#include <skinning_vertex>\\n\\t#include <project_vertex>\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <worldpos_vertex>\\n\\t#include <shadowmap_vertex>\\n\\t#include <fog_vertex>\\n}",shadow_frag:"uniform vec3 color;\\nuniform float opacity;\\n#include <common>\\n#include <packing>\\n#include <fog_pars_fragment>\\n#include <bsdfs>\\n#include <lights_pars_begin>\\n#include <logdepthbuf_pars_fragment>\\n#include <shadowmap_pars_fragment>\\n#include <shadowmask_pars_fragment>\\nvoid main() {\\n\\t#include <logdepthbuf_fragment>\\n\\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n}",sprite_vert:"uniform float rotation;\\nuniform vec2 center;\\n#include <common>\\n#include <uv_pars_vertex>\\n#include <fog_pars_vertex>\\n#include <logdepthbuf_pars_vertex>\\n#include <clipping_planes_pars_vertex>\\nvoid main() {\\n\\t#include <uv_vertex>\\n\\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\\n\\tvec2 scale;\\n\\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\\n\\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\\n\\t#ifndef USE_SIZEATTENUATION\\n\\t\\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\\n\\t\\tif ( isPerspective ) scale *= - mvPosition.z;\\n\\t#endif\\n\\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\\n\\tvec2 rotatedPosition;\\n\\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\\n\\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\\n\\tmvPosition.xy += rotatedPosition;\\n\\tgl_Position = projectionMatrix * mvPosition;\\n\\t#include <logdepthbuf_vertex>\\n\\t#include <clipping_planes_vertex>\\n\\t#include <fog_vertex>\\n}",sprite_frag:"uniform vec3 diffuse;\\nuniform float opacity;\\n#include <common>\\n#include <uv_pars_fragment>\\n#include <map_pars_fragment>\\n#include <alphamap_pars_fragment>\\n#include <alphatest_pars_fragment>\\n#include <alphahash_pars_fragment>\\n#include <fog_pars_fragment>\\n#include <logdepthbuf_pars_fragment>\\n#include <clipping_planes_pars_fragment>\\nvoid main() {\\n\\t#include <clipping_planes_fragment>\\n\\tvec3 outgoingLight = vec3( 0.0 );\\n\\tvec4 diffuseColor = vec4( diffuse, opacity );\\n\\t#include <logdepthbuf_fragment>\\n\\t#include <map_fragment>\\n\\t#include <alphamap_fragment>\\n\\t#include <alphatest_fragment>\\n\\t#include <alphahash_fragment>\\n\\toutgoingLight = diffuseColor.rgb;\\n\\t#include <opaque_fragment>\\n\\t#include <tonemapping_fragment>\\n\\t#include <colorspace_fragment>\\n\\t#include <fog_fragment>\\n}"},ji={common:{diffuse:{value:new On(16777215)},opacity:{value:1},map:{value:null},mapTransform:{value:new We},alphaMap:{value:null},alphaMapTransform:{value:new We},alphaTest:{value:0}},specularmap:{specularMap:{value:null},specularMapTransform:{value:new We}},envmap:{envMap:{value:null},flipEnvMap:{value:-1},reflectivity:{value:1},ior:{value:1.5},refractionRatio:{value:.98}},aomap:{aoMap:{value:null},aoMapIntensity:{value:1},aoMapTransform:{value:new We}},lightmap:{lightMap:{value:null},lightMapIntensity:{value:1},lightMapTransform:{value:new We}},bumpmap:{bumpMap:{value:null},bumpMapTransform:{value:new We},bumpScale:{value:1}},normalmap:{normalMap:{value:null},normalMapTransform:{value:new We},normalScale:{value:new ke(1,1)}},displacementmap:{displacementMap:{value:null},displacementMapTransform:{value:new We},displacementScale:{value:1},displacementBias:{value:0}},emissivemap:{emissiveMap:{value:null},emissiveMapTransform:{value:new We}},metalnessmap:{metalnessMap:{value:null},metalnessMapTransform:{value:new We}},roughnessmap:{roughnessMap:{value:null},roughnessMapTransform:{value:new We}},gradientmap:{gradientMap:{value:null}},fog:{fogDensity:{value:25e-5},fogNear:{value:1},fogFar:{value:2e3},fogColor:{value:new On(16777215)}},lights:{ambientLightColor:{value:[]},lightProbe:{value:[]},directionalLights:{value:[],properties:{direction:{},color:{}}},directionalLightShadows:{value:[],properties:{shadowBias:{},shadowNormalBias:{},shadowRadius:{},shadowMapSize:{}}},directionalShadowMap:{value:[]},directionalShadowMatrix:{value:[]},spotLights:{value:[],properties:{color:{},position:{},direction:{},distance:{},coneCos:{},penumbraCos:{},decay:{}}},spotLightShadows:{value:[],properties:{shadowBias:{},shadowNormalBias:{},shadowRadius:{},shadowMapSize:{}}},spotLightMap:{value:[]},spotShadowMap:{value:[]},spotLightMatrix:{value:[]},pointLights:{value:[],properties:{color:{},position:{},decay:{},distance:{}}},pointLightShadows:{value:[],properties:{shadowBias:{},shadowNormalBias:{},shadowRadius:{},shadowMapSize:{},shadowCameraNear:{},shadowCameraFar:{}}},pointShadowMap:{value:[]},pointShadowMatrix:{value:[]},hemisphereLights:{value:[],properties:{direction:{},skyColor:{},groundColor:{}}},rectAreaLights:{value:[],properties:{color:{},position:{},width:{},height:{}}},ltc_1:{value:null},ltc_2:{value:null}},points:{diffuse:{value:new On(16777215)},opacity:{value:1},size:{value:1},scale:{value:1},map:{value:null},alphaMap:{value:null},alphaMapTransform:{value:new We},alphaTest:{value:0},uvTransform:{value:new We}},sprite:{diffuse:{value:new On(16777215)},opacity:{value:1},center:{value:new ke(.5,.5)},rotation:{value:0},map:{value:null},mapTransform:{value:new We},alphaMap:{value:null},alphaMapTransform:{value:new We},alphaTest:{value:0}}},qi={basic:{uniforms:bi([ji.common,ji.specularmap,ji.envmap,ji.aomap,ji.lightmap,ji.fog]),vertexShader:Xi.meshbasic_vert,fragmentShader:Xi.meshbasic_frag},lambert:{uniforms:bi([ji.common,ji.specularmap,ji.envmap,ji.aomap,ji.lightmap,ji.emissivemap,ji.bumpmap,ji.normalmap,ji.displacementmap,ji.fog,ji.lights,{emissive:{value:new On(0)}}]),vertexShader:Xi.meshlambert_vert,fragmentShader:Xi.meshlambert_frag},phong:{uniforms:bi([ji.common,ji.specularmap,ji.envmap,ji.aomap,ji.lightmap,ji.emissivemap,ji.bumpmap,ji.normalmap,ji.displacementmap,ji.fog,ji.lights,{emissive:{value:new On(0)},specular:{value:new On(1118481)},shininess:{value:30}}]),vertexShader:Xi.meshphong_vert,fragmentShader:Xi.meshphong_frag},standard:{uniforms:bi([ji.common,ji.envmap,ji.aomap,ji.lightmap,ji.emissivemap,ji.bumpmap,ji.normalmap,ji.displacementmap,ji.roughnessmap,ji.metalnessmap,ji.fog,ji.lights,{emissive:{value:new On(0)},roughness:{value:1},metalness:{value:0},envMapIntensity:{value:1}}]),vertexShader:Xi.meshphysical_vert,fragmentShader:Xi.meshphysical_frag},toon:{uniforms:bi([ji.common,ji.aomap,ji.lightmap,ji.emissivemap,ji.bumpmap,ji.normalmap,ji.displacementmap,ji.gradientmap,ji.fog,ji.lights,{emissive:{value:new On(0)}}]),vertexShader:Xi.meshtoon_vert,fragmentShader:Xi.meshtoon_frag},matcap:{uniforms:bi([ji.common,ji.bumpmap,ji.normalmap,ji.displacementmap,ji.fog,{matcap:{value:null}}]),vertexShader:Xi.meshmatcap_vert,fragmentShader:Xi.meshmatcap_frag},points:{uniforms:bi([ji.points,ji.fog]),vertexShader:Xi.points_vert,fragmentShader:Xi.points_frag},dashed:{uniforms:bi([ji.common,ji.fog,{scale:{value:1},dashSize:{value:1},totalSize:{value:2}}]),vertexShader:Xi.linedashed_vert,fragmentShader:Xi.linedashed_frag},depth:{uniforms:bi([ji.common,ji.displacementmap]),vertexShader:Xi.depth_vert,fragmentShader:Xi.depth_frag},normal:{uniforms:bi([ji.common,ji.bumpmap,ji.normalmap,ji.displacementmap,{opacity:{value:1}}]),vertexShader:Xi.meshnormal_vert,fragmentShader:Xi.meshnormal_frag},sprite:{uniforms:bi([ji.sprite,ji.fog]),vertexShader:Xi.sprite_vert,fragmentShader:Xi.sprite_frag},background:{uniforms:{uvTransform:{value:new We},t2D:{value:null},backgroundIntensity:{value:1}},vertexShader:Xi.background_vert,fragmentShader:Xi.background_frag},backgroundCube:{uniforms:{envMap:{value:null},flipEnvMap:{value:-1},backgroundBlurriness:{value:0},backgroundIntensity:{value:1}},vertexShader:Xi.backgroundCube_vert,fragmentShader:Xi.backgroundCube_frag},cube:{uniforms:{tCube:{value:null},tFlip:{value:-1},opacity:{value:1}},vertexShader:Xi.cube_vert,fragmentShader:Xi.cube_frag},equirect:{uniforms:{tEquirect:{value:null}},vertexShader:Xi.equirect_vert,fragmentShader:Xi.equirect_frag},distanceRGBA:{uniforms:bi([ji.common,ji.displacementmap,{referencePosition:{value:new _t},nearDistance:{value:1},farDistance:{value:1e3}}]),vertexShader:Xi.distanceRGBA_vert,fragmentShader:Xi.distanceRGBA_frag},shadow:{uniforms:bi([ji.lights,ji.fog,{color:{value:new On(0)},opacity:{value:1}}]),vertexShader:Xi.shadow_vert,fragmentShader:Xi.shadow_frag}};qi.physical={uniforms:bi([qi.standard.uniforms,{clearcoat:{value:0},clearcoatMap:{value:null},clearcoatMapTransform:{value:new We},clearcoatNormalMap:{value:null},clearcoatNormalMapTransform:{value:new We},clearcoatNormalScale:{value:new ke(1,1)},clearcoatRoughness:{value:0},clearcoatRoughnessMap:{value:null},clearcoatRoughnessMapTransform:{value:new We},iridescence:{value:0},iridescenceMap:{value:null},iridescenceMapTransform:{value:new We},iridescenceIOR:{value:1.3},iridescenceThicknessMinimum:{value:100},iridescenceThicknessMaximum:{value:400},iridescenceThicknessMap:{value:null},iridescenceThicknessMapTransform:{value:new We},sheen:{value:0},sheenColor:{value:new On(0)},sheenColorMap:{value:null},sheenColorMapTransform:{value:new We},sheenRoughness:{value:1},sheenRoughnessMap:{value:null},sheenRoughnessMapTransform:{value:new We},transmission:{value:0},transmissionMap:{value:null},transmissionMapTransform:{value:new We},transmissionSamplerSize:{value:new ke},transmissionSamplerMap:{value:null},thickness:{value:0},thicknessMap:{value:null},thicknessMapTransform:{value:new We},attenuationDistance:{value:0},attenuationColor:{value:new On(0)},specularColor:{value:new On(1,1,1)},specularColorMap:{value:null},specularColorMapTransform:{value:new We},specularIntensity:{value:1},specularIntensityMap:{value:null},specularIntensityMapTransform:{value:new We},anisotropyVector:{value:new ke},anisotropyMap:{value:null},anisotropyMapTransform:{value:new We}}]),vertexShader:Xi.meshphysical_vert,fragmentShader:Xi.meshphysical_frag};const Yi={r:0,b:0,g:0};function Ki(e,t,n,i,r,a,s){const o=new On(0);let l,c,h=!0===a?0:1,u=null,d=0,p=null;function f(t,n){t.getRGB(Yi,wi(e)),i.buffers.color.setClear(Yi.r,Yi.g,Yi.b,n,s)}return{getClearColor:function(){return o},setClearColor:function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1;o.set(e),h=t,f(o,h)},getClearAlpha:function(){return h},setClearAlpha:function(e){h=e,f(o,h)},render:function(a,m){let g=!1,_=!0===m.isScene?m.background:null;_&&_.isTexture&&(_=(m.backgroundBlurriness>0?n:t).get(_)),null===_?f(o,h):_&&_.isColor&&(f(_,1),g=!0);const v=e.xr.getEnvironmentBlendMode();"additive"===v?i.buffers.color.setClear(0,0,0,1,s):"alpha-blend"===v&&i.buffers.color.setClear(0,0,0,0,s),(e.autoClear||g)&&e.clear(e.autoClearColor,e.autoClearDepth,e.autoClearStencil),_&&(_.isCubeTexture||_.mapping===O)?(void 0===c&&(c=new Si(new Ei(1,1,1),new Ri({name:"BackgroundCubeMaterial",uniforms:Ti(qi.backgroundCube.uniforms),vertexShader:qi.backgroundCube.vertexShader,fragmentShader:qi.backgroundCube.fragmentShader,side:1,depthTest:!1,depthWrite:!1,fog:!1})),c.geometry.deleteAttribute("normal"),c.geometry.deleteAttribute("uv"),c.onBeforeRender=function(e,t,n){this.matrixWorld.copyPosition(n.matrixWorld)},Object.defineProperty(c.material,"envMap",{get:function(){return this.uniforms.envMap.value}}),r.update(c)),c.material.uniforms.envMap.value=_,c.material.uniforms.flipEnvMap.value=_.isCubeTexture&&!1===_.isRenderTargetTexture?-1:1,c.material.uniforms.backgroundBlurriness.value=m.backgroundBlurriness,c.material.uniforms.backgroundIntensity.value=m.backgroundIntensity,c.material.toneMapped=tt.getTransfer(_.colorSpace)!==ge,u===_&&d===_.version&&p===e.toneMapping||(c.material.needsUpdate=!0,u=_,d=_.version,p=e.toneMapping),c.layers.enableAll(),a.unshift(c,c.geometry,c.material,0,0,null)):_&&_.isTexture&&(void 0===l&&(l=new Si(new Wi(2,2),new Ri({name:"BackgroundMaterial",uniforms:Ti(qi.background.uniforms),vertexShader:qi.background.vertexShader,fragmentShader:qi.background.fragmentShader,side:0,depthTest:!1,depthWrite:!1,fog:!1})),l.geometry.deleteAttribute("normal"),Object.defineProperty(l.material,"map",{get:function(){return this.uniforms.t2D.value}}),r.update(l)),l.material.uniforms.t2D.value=_,l.material.uniforms.backgroundIntensity.value=m.backgroundIntensity,l.material.toneMapped=tt.getTransfer(_.colorSpace)!==ge,!0===_.matrixAutoUpdate&&_.updateMatrix(),l.material.uniforms.uvTransform.value.copy(_.matrix),u===_&&d===_.version&&p===e.toneMapping||(l.material.needsUpdate=!0,u=_,d=_.version,p=e.toneMapping),l.layers.enableAll(),a.unshift(l,l.geometry,l.material,0,0,null))}}}function Zi(e,t,n,i){const r=e.getParameter(e.MAX_VERTEX_ATTRIBS),a=i.isWebGL2?null:t.get("OES_vertex_array_object"),s=i.isWebGL2||null!==a,o={},l=p(null);let c=l,h=!1;function u(t){return i.isWebGL2?e.bindVertexArray(t):a.bindVertexArrayOES(t)}function d(t){return i.isWebGL2?e.deleteVertexArray(t):a.deleteVertexArrayOES(t)}function p(e){const t=[],n=[],i=[];for(let e=0;e<r;e++)t[e]=0,n[e]=0,i[e]=0;return{geometry:null,program:null,wireframe:!1,newAttributes:t,enabledAttributes:n,attributeDivisors:i,object:e,attributes:{},index:null}}function f(){const e=c.newAttributes;for(let t=0,n=e.length;t<n;t++)e[t]=0}function m(e){g(e,0)}function g(n,r){const a=c.newAttributes,s=c.enabledAttributes,o=c.attributeDivisors;a[n]=1,0===s[n]&&(e.enableVertexAttribArray(n),s[n]=1),o[n]!==r&&((i.isWebGL2?e:t.get("ANGLE_instanced_arrays"))[i.isWebGL2?"vertexAttribDivisor":"vertexAttribDivisorANGLE"](n,r),o[n]=r)}function _(){const t=c.newAttributes,n=c.enabledAttributes;for(let i=0,r=n.length;i<r;i++)n[i]!==t[i]&&(e.disableVertexAttribArray(i),n[i]=0)}function v(t,n,i,r,a,s,o){!0===o?e.vertexAttribIPointer(t,n,i,a,s):e.vertexAttribPointer(t,n,i,r,a,s)}function x(){M(),h=!0,c!==l&&(c=l,u(c.object))}function M(){l.geometry=null,l.program=null,l.wireframe=!1}return{setup:function(r,l,d,x,M){let S=!1;if(s){const t=function(t,n,r){const s=!0===r.wireframe;let l=o[t.id];void 0===l&&(l={},o[t.id]=l);let c=l[n.id];void 0===c&&(c={},l[n.id]=c);let h=c[s];return void 0===h&&(h=p(i.isWebGL2?e.createVertexArray():a.createVertexArrayOES()),c[s]=h),h}(x,d,l);c!==t&&(c=t,u(c.object)),S=function(e,t,n,i){const r=c.attributes,a=t.attributes;let s=0;const o=n.getAttributes();for(const t in o)if(o[t].location>=0){const n=r[t];let i=a[t];if(void 0===i&&("instanceMatrix"===t&&e.instanceMatrix&&(i=e.instanceMatrix),"instanceColor"===t&&e.instanceColor&&(i=e.instanceColor)),void 0===n)return!0;if(n.attribute!==i)return!0;if(i&&n.data!==i.data)return!0;s++}return c.attributesNum!==s||c.index!==i}(r,x,d,M),S&&function(e,t,n,i){const r={},a=t.attributes;let s=0;const o=n.getAttributes();for(const t in o)if(o[t].location>=0){let n=a[t];void 0===n&&("instanceMatrix"===t&&e.instanceMatrix&&(n=e.instanceMatrix),"instanceColor"===t&&e.instanceColor&&(n=e.instanceColor));const i={};i.attribute=n,n&&n.data&&(i.data=n.data),r[t]=i,s++}c.attributes=r,c.attributesNum=s,c.index=i}(r,x,d,M)}else{const e=!0===l.wireframe;c.geometry===x.id&&c.program===d.id&&c.wireframe===e||(c.geometry=x.id,c.program=d.id,c.wireframe=e,S=!0)}null!==M&&n.update(M,e.ELEMENT_ARRAY_BUFFER),(S||h)&&(h=!1,function(r,a,s,o){if(!1===i.isWebGL2&&(r.isInstancedMesh||o.isInstancedBufferGeometry)&&null===t.get("ANGLE_instanced_arrays"))return;f();const l=o.attributes,c=s.getAttributes(),h=a.defaultAttributeValues;for(const t in c){const a=c[t];if(a.location>=0){let s=l[t];if(void 0===s&&("instanceMatrix"===t&&r.instanceMatrix&&(s=r.instanceMatrix),"instanceColor"===t&&r.instanceColor&&(s=r.instanceColor)),void 0!==s){const t=s.normalized,l=s.itemSize,c=n.get(s);if(void 0===c)continue;const h=c.buffer,u=c.type,d=c.bytesPerElement,p=!0===i.isWebGL2&&(u===e.INT||u===e.UNSIGNED_INT||1013===s.gpuType);if(s.isInterleavedBufferAttribute){const n=s.data,i=n.stride,c=s.offset;if(n.isInstancedInterleavedBuffer){for(let e=0;e<a.locationSize;e++)g(a.location+e,n.meshPerAttribute);!0!==r.isInstancedMesh&&void 0===o._maxInstanceCount&&(o._maxInstanceCount=n.meshPerAttribute*n.count)}else for(let e=0;e<a.locationSize;e++)m(a.location+e);e.bindBuffer(e.ARRAY_BUFFER,h);for(let e=0;e<a.locationSize;e++)v(a.location+e,l/a.locationSize,u,t,i*d,(c+l/a.locationSize*e)*d,p)}else{if(s.isInstancedBufferAttribute){for(let e=0;e<a.locationSize;e++)g(a.location+e,s.meshPerAttribute);!0!==r.isInstancedMesh&&void 0===o._maxInstanceCount&&(o._maxInstanceCount=s.meshPerAttribute*s.count)}else for(let e=0;e<a.locationSize;e++)m(a.location+e);e.bindBuffer(e.ARRAY_BUFFER,h);for(let e=0;e<a.locationSize;e++)v(a.location+e,l/a.locationSize,u,t,l*d,l/a.locationSize*e*d,p)}}else if(void 0!==h){const n=h[t];if(void 0!==n)switch(n.length){case 2:e.vertexAttrib2fv(a.location,n);break;case 3:e.vertexAttrib3fv(a.location,n);break;case 4:e.vertexAttrib4fv(a.location,n);break;default:e.vertexAttrib1fv(a.location,n)}}}}_()}(r,l,d,x),null!==M&&e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,n.get(M).buffer))},reset:x,resetDefaultState:M,dispose:function(){x();for(const e in o){const t=o[e];for(const e in t){const n=t[e];for(const e in n)d(n[e].object),delete n[e];delete t[e]}delete o[e]}},releaseStatesOfGeometry:function(e){if(void 0===o[e.id])return;const t=o[e.id];for(const e in t){const n=t[e];for(const e in n)d(n[e].object),delete n[e];delete t[e]}delete o[e.id]},releaseStatesOfProgram:function(e){for(const t in o){const n=o[t];if(void 0===n[e.id])continue;const i=n[e.id];for(const e in i)d(i[e].object),delete i[e];delete n[e.id]}},initAttributes:f,enableAttribute:m,disableUnusedAttributes:_}}function Ji(e,t,n,i){const r=i.isWebGL2;let a;this.setMode=function(e){a=e},this.render=function(t,i){e.drawArrays(a,t,i),n.update(i,a,1)},this.renderInstances=function(i,s,o){if(0===o)return;let l,c;if(r)l=e,c="drawArraysInstanced";else if(l=t.get("ANGLE_instanced_arrays"),c="drawArraysInstancedANGLE",null===l)return void console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");l[c](a,i,s,o),n.update(s,a,o)}}function Qi(e,t,n){let i;function r(t){if("highp"===t){if(e.getShaderPrecisionFormat(e.VERTEX_SHADER,e.HIGH_FLOAT).precision>0&&e.getShaderPrecisionFormat(e.FRAGMENT_SHADER,e.HIGH_FLOAT).precision>0)return"highp";t="mediump"}return"mediump"===t&&e.getShaderPrecisionFormat(e.VERTEX_SHADER,e.MEDIUM_FLOAT).precision>0&&e.getShaderPrecisionFormat(e.FRAGMENT_SHADER,e.MEDIUM_FLOAT).precision>0?"mediump":"lowp"}const a="undefined"!=typeof WebGL2RenderingContext&&"WebGL2RenderingContext"===e.constructor.name;let s=void 0!==n.precision?n.precision:"highp";const o=r(s);o!==s&&(console.warn("THREE.WebGLRenderer:",s,"not supported, using",o,"instead."),s=o);const l=a||t.has("WEBGL_draw_buffers"),c=!0===n.logarithmicDepthBuffer,h=e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS),u=e.getParameter(e.MAX_VERTEX_TEXTURE_IMAGE_UNITS),d=e.getParameter(e.MAX_TEXTURE_SIZE),p=e.getParameter(e.MAX_CUBE_MAP_TEXTURE_SIZE),f=e.getParameter(e.MAX_VERTEX_ATTRIBS),m=e.getParameter(e.MAX_VERTEX_UNIFORM_VECTORS),g=e.getParameter(e.MAX_VARYING_VECTORS),_=e.getParameter(e.MAX_FRAGMENT_UNIFORM_VECTORS),v=u>0,x=a||t.has("OES_texture_float");return{isWebGL2:a,drawBuffers:l,getMaxAnisotropy:function(){if(void 0!==i)return i;if(!0===t.has("EXT_texture_filter_anisotropic")){const n=t.get("EXT_texture_filter_anisotropic");i=e.getParameter(n.MAX_TEXTURE_MAX_ANISOTROPY_EXT)}else i=0;return i},getMaxPrecision:r,precision:s,logarithmicDepthBuffer:c,maxTextures:h,maxVertexTextures:u,maxTextureSize:d,maxCubemapSize:p,maxAttributes:f,maxVertexUniforms:m,maxVaryings:g,maxFragmentUniforms:_,vertexTextures:v,floatFragmentTextures:x,floatVertexTextures:v&&x,maxSamples:a?e.getParameter(e.MAX_SAMPLES):0}}function $i(e){const t=this;let n=null,i=0,r=!1,a=!1;const s=new zi,o=new We,l={value:null,needsUpdate:!1};function c(e,n,i,r){const a=null!==e?e.length:0;let c=null;if(0!==a){if(c=l.value,!0!==r||null===c){const t=i+4*a,r=n.matrixWorldInverse;o.getNormalMatrix(r),(null===c||c.length<t)&&(c=new Float32Array(t));for(let t=0,n=i;t!==a;++t,n+=4)s.copy(e[t]).applyMatrix4(r,o),s.normal.toArray(c,n),c[n+3]=s.constant}l.value=c,l.needsUpdate=!0}return t.numPlanes=a,t.numIntersection=0,c}this.uniform=l,this.numPlanes=0,this.numIntersection=0,this.init=function(e,t){const n=0!==e.length||t||0!==i||r;return r=t,i=e.length,n},this.beginShadows=function(){a=!0,c(null)},this.endShadows=function(){a=!1},this.setGlobalState=function(e,t){n=c(e,t,0)},this.setState=function(s,o,h){const u=s.clippingPlanes,d=s.clipIntersection,p=s.clipShadows,f=e.get(s);if(!r||null===u||0===u.length||a&&!p)a?c(null):(l.value!==n&&(l.value=n,l.needsUpdate=i>0),t.numPlanes=i,t.numIntersection=0);else{const e=a?0:i,t=4*e;let r=f.clippingState||null;l.value=r,r=c(u,o,t,h);for(let e=0;e!==t;++e)r[e]=n[e];f.clippingState=r,this.numIntersection=d?this.numPlanes:0,this.numPlanes+=e}}}function er(e){let t=new WeakMap;function n(e,t){return 303===t?e.mapping=N:304===t&&(e.mapping=I),e}function i(e){const n=e.target;n.removeEventListener("dispose",i);const r=t.get(n);void 0!==r&&(t.delete(n),r.dispose())}return{get:function(r){if(r&&r.isTexture&&!1===r.isRenderTargetTexture){const a=r.mapping;if(303===a||304===a){if(t.has(r))return n(t.get(r).texture,r.mapping);{const a=r.image;if(a&&a.height>0){const s=new Ni(a.height/2);return s.fromEquirectangularTexture(e,r),t.set(r,s),r.addEventListener("dispose",i),n(s.texture,r.mapping)}return null}}}return r},dispose:function(){t=new WeakMap}}}class tr extends Ci{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:-1,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:-1,r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:.1,a=arguments.length>5&&void 0!==arguments[5]?arguments[5]:2e3;super(),this.isOrthographicCamera=!0,this.type="OrthographicCamera",this.zoom=1,this.view=null,this.left=e,this.right=t,this.top=n,this.bottom=i,this.near=r,this.far=a,this.updateProjectionMatrix()}copy(e,t){return super.copy(e,t),this.left=e.left,this.right=e.right,this.top=e.top,this.bottom=e.bottom,this.near=e.near,this.far=e.far,this.zoom=e.zoom,this.view=null===e.view?null:Object.assign({},e.view),this}setViewOffset(e,t,n,i,r,a){null===this.view&&(this.view={enabled:!0,fullWidth:1,fullHeight:1,offsetX:0,offsetY:0,width:1,height:1}),this.view.enabled=!0,this.view.fullWidth=e,this.view.fullHeight=t,this.view.offsetX=n,this.view.offsetY=i,this.view.width=r,this.view.height=a,this.updateProjectionMatrix()}clearViewOffset(){null!==this.view&&(this.view.enabled=!1),this.updateProjectionMatrix()}updateProjectionMatrix(){const e=(this.right-this.left)/(2*this.zoom),t=(this.top-this.bottom)/(2*this.zoom),n=(this.right+this.left)/2,i=(this.top+this.bottom)/2;let r=n-e,a=n+e,s=i+t,o=i-t;if(null!==this.view&&this.view.enabled){const e=(this.right-this.left)/this.view.fullWidth/this.zoom,t=(this.top-this.bottom)/this.view.fullHeight/this.zoom;r+=e*this.view.offsetX,a=r+e*this.view.width,s-=t*this.view.offsetY,o=s-t*this.view.height}this.projectionMatrix.makeOrthographic(r,a,s,o,this.near,this.far,this.coordinateSystem),this.projectionMatrixInverse.copy(this.projectionMatrix).invert()}toJSON(e){const t=super.toJSON(e);return t.object.zoom=this.zoom,t.object.left=this.left,t.object.right=this.right,t.object.top=this.top,t.object.bottom=this.bottom,t.object.near=this.near,t.object.far=this.far,null!==this.view&&(t.object.view=Object.assign({},this.view)),t}}const nr=[.125,.215,.35,.446,.526,.582],ir=20,rr=new tr,ar=new On;let sr=null,or=0,lr=0;const cr=(1+Math.sqrt(5))/2,hr=1/cr,ur=[new _t(1,1,1),new _t(-1,1,1),new _t(1,1,-1),new _t(-1,1,-1),new _t(0,cr,hr),new _t(0,cr,-hr),new _t(hr,0,cr),new _t(-hr,0,cr),new _t(cr,hr,0),new _t(-cr,hr,0)];class dr{constructor(e){this._renderer=e,this._pingPongRenderTarget=null,this._lodMax=0,this._cubeSize=0,this._lodPlanes=[],this._sizeLods=[],this._sigmas=[],this._blurMaterial=null,this._cubemapMaterial=null,this._equirectMaterial=null,this._compileMaterial(this._blurMaterial)}fromScene(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:.1,i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:100;sr=this._renderer.getRenderTarget(),or=this._renderer.getActiveCubeFace(),lr=this._renderer.getActiveMipmapLevel(),this._setSize(256);const r=this._allocateTargets();return r.depthBuffer=!0,this._sceneToCubeUV(e,n,i,r),t>0&&this._blur(r,0,0,t),this._applyPMREM(r),this._cleanup(r),r}fromEquirectangular(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;return this._fromTexture(e,t)}fromCubemap(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null;return this._fromTexture(e,t)}compileCubemapShader(){null===this._cubemapMaterial&&(this._cubemapMaterial=gr(),this._compileMaterial(this._cubemapMaterial))}compileEquirectangularShader(){null===this._equirectMaterial&&(this._equirectMaterial=mr(),this._compileMaterial(this._equirectMaterial))}dispose(){this._dispose(),null!==this._cubemapMaterial&&this._cubemapMaterial.dispose(),null!==this._equirectMaterial&&this._equirectMaterial.dispose()}_setSize(e){this._lodMax=Math.floor(Math.log2(e)),this._cubeSize=Math.pow(2,this._lodMax)}_dispose(){null!==this._blurMaterial&&this._blurMaterial.dispose(),null!==this._pingPongRenderTarget&&this._pingPongRenderTarget.dispose();for(let e=0;e<this._lodPlanes.length;e++)this._lodPlanes[e].dispose()}_cleanup(e){this._renderer.setRenderTarget(sr,or,lr),e.scissorTest=!1,fr(e,0,0,e.width,e.height)}_fromTexture(e,t){e.mapping===N||e.mapping===I?this._setSize(0===e.image.length?16:e.image[0].width||e.image[0].image.width):this._setSize(e.image.width/4),sr=this._renderer.getRenderTarget(),or=this._renderer.getActiveCubeFace(),lr=this._renderer.getActiveMipmapLevel();const n=t||this._allocateTargets();return this._textureToCubeUV(e,n),this._applyPMREM(n),this._cleanup(n),n}_allocateTargets(){const e=3*Math.max(this._cubeSize,112),t=4*this._cubeSize,n={magFilter:k,minFilter:k,generateMipmaps:!1,type:Z,format:Q,colorSpace:de,depthBuffer:!1},i=pr(e,t,n);if(null===this._pingPongRenderTarget||this._pingPongRenderTarget.width!==e||this._pingPongRenderTarget.height!==t){null!==this._pingPongRenderTarget&&this._dispose(),this._pingPongRenderTarget=pr(e,t,n);const{_lodMax:i}=this;({sizeLods:this._sizeLods,lodPlanes:this._lodPlanes,sigmas:this._sigmas}=function(e){const t=[],n=[],i=[];let r=e;const a=e-4+1+nr.length;for(let s=0;s<a;s++){const a=Math.pow(2,r);n.push(a);let o=1/a;s>e-4?o=nr[s-e+4-1]:0===s&&(o=0),i.push(o);const l=1/(a-2),c=-l,h=1+l,u=[c,c,h,c,h,h,c,c,h,h,c,h],d=6,p=6,f=3,m=2,g=1,_=new Float32Array(f*p*d),v=new Float32Array(m*p*d),x=new Float32Array(g*p*d);for(let e=0;e<d;e++){const t=e%3*2/3-1,n=e>2?0:-1,i=[t,n,0,t+2/3,n,0,t+2/3,n+1,0,t,n,0,t+2/3,n+1,0,t,n+1,0];_.set(i,f*p*e),v.set(u,m*p*e);const r=[e,e,e,e,e,e];x.set(r,g*p*e)}const M=new ii;M.setAttribute("position",new jn(_,f)),M.setAttribute("uv",new jn(v,m)),M.setAttribute("faceIndex",new jn(x,g)),t.push(M),r>4&&r--}return{lodPlanes:t,sizeLods:n,sigmas:i}}(i)),this._blurMaterial=function(e,t,n){const i=new Float32Array(ir),r=new _t(0,1,0);return new Ri({name:"SphericalGaussianBlur",defines:{n:ir,CUBEUV_TEXEL_WIDTH:1/t,CUBEUV_TEXEL_HEIGHT:1/n,CUBEUV_MAX_MIP:"".concat(e,".0")},uniforms:{envMap:{value:null},samples:{value:1},weights:{value:i},latitudinal:{value:!1},dTheta:{value:0},mipInt:{value:0},poleAxis:{value:r}},vertexShader:"\\n\\n\\t\\tprecision mediump float;\\n\\t\\tprecision mediump int;\\n\\n\\t\\tattribute float faceIndex;\\n\\n\\t\\tvarying vec3 vOutputDirection;\\n\\n\\t\\t// RH coordinate system; PMREM face-indexing convention\\n\\t\\tvec3 getDirection( vec2 uv, float face ) {\\n\\n\\t\\t\\tuv = 2.0 * uv - 1.0;\\n\\n\\t\\t\\tvec3 direction = vec3( uv, 1.0 );\\n\\n\\t\\t\\tif ( face == 0.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.zyx; // ( 1, v, u ) pos x\\n\\n\\t\\t\\t} else if ( face == 1.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.xzy;\\n\\t\\t\\t\\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\\n\\n\\t\\t\\t} else if ( face == 2.0 ) {\\n\\n\\t\\t\\t\\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\\n\\n\\t\\t\\t} else if ( face == 3.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.zyx;\\n\\t\\t\\t\\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\\n\\n\\t\\t\\t} else if ( face == 4.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.xzy;\\n\\t\\t\\t\\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\\n\\n\\t\\t\\t} else if ( face == 5.0 ) {\\n\\n\\t\\t\\t\\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\\n\\n\\t\\t\\t}\\n\\n\\t\\t\\treturn direction;\\n\\n\\t\\t}\\n\\n\\t\\tvoid main() {\\n\\n\\t\\t\\tvOutputDirection = getDirection( uv, faceIndex );\\n\\t\\t\\tgl_Position = vec4( position, 1.0 );\\n\\n\\t\\t}\\n\\t",fragmentShader:"\\n\\n\\t\\t\\tprecision mediump float;\\n\\t\\t\\tprecision mediump int;\\n\\n\\t\\t\\tvarying vec3 vOutputDirection;\\n\\n\\t\\t\\tuniform sampler2D envMap;\\n\\t\\t\\tuniform int samples;\\n\\t\\t\\tuniform float weights[ n ];\\n\\t\\t\\tuniform bool latitudinal;\\n\\t\\t\\tuniform float dTheta;\\n\\t\\t\\tuniform float mipInt;\\n\\t\\t\\tuniform vec3 poleAxis;\\n\\n\\t\\t\\t#define ENVMAP_TYPE_CUBE_UV\\n\\t\\t\\t#include <cube_uv_reflection_fragment>\\n\\n\\t\\t\\tvec3 getSample( float theta, vec3 axis ) {\\n\\n\\t\\t\\t\\tfloat cosTheta = cos( theta );\\n\\t\\t\\t\\t// Rodrigues\' axis-angle rotation\\n\\t\\t\\t\\tvec3 sampleDirection = vOutputDirection * cosTheta\\n\\t\\t\\t\\t\\t+ cross( axis, vOutputDirection ) * sin( theta )\\n\\t\\t\\t\\t\\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\\n\\n\\t\\t\\t\\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\\n\\n\\t\\t\\t}\\n\\n\\t\\t\\tvoid main() {\\n\\n\\t\\t\\t\\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\\n\\n\\t\\t\\t\\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\\n\\n\\t\\t\\t\\t\\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\\n\\n\\t\\t\\t\\t}\\n\\n\\t\\t\\t\\taxis = normalize( axis );\\n\\n\\t\\t\\t\\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\\n\\t\\t\\t\\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\\n\\n\\t\\t\\t\\tfor ( int i = 1; i < n; i++ ) {\\n\\n\\t\\t\\t\\t\\tif ( i >= samples ) {\\n\\n\\t\\t\\t\\t\\t\\tbreak;\\n\\n\\t\\t\\t\\t\\t}\\n\\n\\t\\t\\t\\t\\tfloat theta = dTheta * float( i );\\n\\t\\t\\t\\t\\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\\n\\t\\t\\t\\t\\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\\n\\n\\t\\t\\t\\t}\\n\\n\\t\\t\\t}\\n\\t\\t",blending:0,depthTest:!1,depthWrite:!1})}(i,e,t)}return i}_compileMaterial(e){const t=new Si(this._lodPlanes[0],e);this._renderer.compile(t,rr)}_sceneToCubeUV(e,t,n,i){const r=new Li(90,1,t,n),a=[1,-1,1,1,1,1],s=[1,1,1,-1,-1,-1],o=this._renderer,l=o.autoClear,c=o.toneMapping;o.getClearColor(ar),o.toneMapping=R,o.autoClear=!1;const h=new Hn({name:"PMREM.Background",side:1,depthWrite:!1,depthTest:!1}),u=new Si(new Ei,h);let d=!1;const p=e.background;p?p.isColor&&(h.color.copy(p),e.background=null,d=!0):(h.color.copy(ar),d=!0);for(let t=0;t<6;t++){const n=t%3;0===n?(r.up.set(0,a[t],0),r.lookAt(s[t],0,0)):1===n?(r.up.set(0,0,a[t]),r.lookAt(0,s[t],0)):(r.up.set(0,a[t],0),r.lookAt(0,0,s[t]));const l=this._cubeSize;fr(i,n*l,t>2?l:0,l,l),o.setRenderTarget(i),d&&o.render(u,r),o.render(e,r)}u.geometry.dispose(),u.material.dispose(),o.toneMapping=c,o.autoClear=l,e.background=p}_textureToCubeUV(e,t){const n=this._renderer,i=e.mapping===N||e.mapping===I;i?(null===this._cubemapMaterial&&(this._cubemapMaterial=gr()),this._cubemapMaterial.uniforms.flipEnvMap.value=!1===e.isRenderTargetTexture?-1:1):null===this._equirectMaterial&&(this._equirectMaterial=mr());const r=i?this._cubemapMaterial:this._equirectMaterial,a=new Si(this._lodPlanes[0],r);r.uniforms.envMap.value=e;const s=this._cubeSize;fr(t,0,0,3*s,2*s),n.setRenderTarget(t),n.render(a,rr)}_applyPMREM(e){const t=this._renderer,n=t.autoClear;t.autoClear=!1;for(let t=1;t<this._lodPlanes.length;t++){const n=Math.sqrt(this._sigmas[t]*this._sigmas[t]-this._sigmas[t-1]*this._sigmas[t-1]),i=ur[(t-1)%ur.length];this._blur(e,t-1,t,n,i)}t.autoClear=n}_blur(e,t,n,i,r){const a=this._pingPongRenderTarget;this._halfBlur(e,a,t,n,i,"latitudinal",r),this._halfBlur(a,e,n,n,i,"longitudinal",r)}_halfBlur(e,t,n,i,r,a,s){const o=this._renderer,l=this._blurMaterial;"latitudinal"!==a&&"longitudinal"!==a&&console.error("blur direction must be either latitudinal or longitudinal!");const c=new Si(this._lodPlanes[i],l),h=l.uniforms,u=this._sizeLods[n]-1,d=isFinite(r)?Math.PI/(2*u):2*Math.PI/39,p=r/d,f=isFinite(r)?1+Math.floor(3*p):ir;f>ir&&console.warn("sigmaRadians, ".concat(r,", is too large and will clip, as it requested ").concat(f," samples when the maximum is set to ").concat(ir));const m=[];let g=0;for(let e=0;e<ir;++e){const t=e/p,n=Math.exp(-t*t/2);m.push(n),0===e?g+=n:e<f&&(g+=2*n)}for(let e=0;e<m.length;e++)m[e]=m[e]/g;h.envMap.value=e.texture,h.samples.value=f,h.weights.value=m,h.latitudinal.value="latitudinal"===a,s&&(h.poleAxis.value=s);const{_lodMax:_}=this;h.dTheta.value=d,h.mipInt.value=_-n;const v=this._sizeLods[i];fr(t,3*v*(i>_-4?i-_+4:0),4*(this._cubeSize-v),3*v,2*v),o.setRenderTarget(t),o.render(c,rr)}}function pr(e,t,n){const i=new pt(e,t,n);return i.texture.mapping=O,i.texture.name="PMREM.cubeUv",i.scissorTest=!0,i}function fr(e,t,n,i,r){e.viewport.set(t,n,i,r),e.scissor.set(t,n,i,r)}function mr(){return new Ri({name:"EquirectangularToCubeUV",uniforms:{envMap:{value:null}},vertexShader:"\\n\\n\\t\\tprecision mediump float;\\n\\t\\tprecision mediump int;\\n\\n\\t\\tattribute float faceIndex;\\n\\n\\t\\tvarying vec3 vOutputDirection;\\n\\n\\t\\t// RH coordinate system; PMREM face-indexing convention\\n\\t\\tvec3 getDirection( vec2 uv, float face ) {\\n\\n\\t\\t\\tuv = 2.0 * uv - 1.0;\\n\\n\\t\\t\\tvec3 direction = vec3( uv, 1.0 );\\n\\n\\t\\t\\tif ( face == 0.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.zyx; // ( 1, v, u ) pos x\\n\\n\\t\\t\\t} else if ( face == 1.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.xzy;\\n\\t\\t\\t\\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\\n\\n\\t\\t\\t} else if ( face == 2.0 ) {\\n\\n\\t\\t\\t\\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\\n\\n\\t\\t\\t} else if ( face == 3.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.zyx;\\n\\t\\t\\t\\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\\n\\n\\t\\t\\t} else if ( face == 4.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.xzy;\\n\\t\\t\\t\\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\\n\\n\\t\\t\\t} else if ( face == 5.0 ) {\\n\\n\\t\\t\\t\\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\\n\\n\\t\\t\\t}\\n\\n\\t\\t\\treturn direction;\\n\\n\\t\\t}\\n\\n\\t\\tvoid main() {\\n\\n\\t\\t\\tvOutputDirection = getDirection( uv, faceIndex );\\n\\t\\t\\tgl_Position = vec4( position, 1.0 );\\n\\n\\t\\t}\\n\\t",fragmentShader:"\\n\\n\\t\\t\\tprecision mediump float;\\n\\t\\t\\tprecision mediump int;\\n\\n\\t\\t\\tvarying vec3 vOutputDirection;\\n\\n\\t\\t\\tuniform sampler2D envMap;\\n\\n\\t\\t\\t#include <common>\\n\\n\\t\\t\\tvoid main() {\\n\\n\\t\\t\\t\\tvec3 outputDirection = normalize( vOutputDirection );\\n\\t\\t\\t\\tvec2 uv = equirectUv( outputDirection );\\n\\n\\t\\t\\t\\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\\n\\n\\t\\t\\t}\\n\\t\\t",blending:0,depthTest:!1,depthWrite:!1})}function gr(){return new Ri({name:"CubemapToCubeUV",uniforms:{envMap:{value:null},flipEnvMap:{value:-1}},vertexShader:"\\n\\n\\t\\tprecision mediump float;\\n\\t\\tprecision mediump int;\\n\\n\\t\\tattribute float faceIndex;\\n\\n\\t\\tvarying vec3 vOutputDirection;\\n\\n\\t\\t// RH coordinate system; PMREM face-indexing convention\\n\\t\\tvec3 getDirection( vec2 uv, float face ) {\\n\\n\\t\\t\\tuv = 2.0 * uv - 1.0;\\n\\n\\t\\t\\tvec3 direction = vec3( uv, 1.0 );\\n\\n\\t\\t\\tif ( face == 0.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.zyx; // ( 1, v, u ) pos x\\n\\n\\t\\t\\t} else if ( face == 1.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.xzy;\\n\\t\\t\\t\\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\\n\\n\\t\\t\\t} else if ( face == 2.0 ) {\\n\\n\\t\\t\\t\\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\\n\\n\\t\\t\\t} else if ( face == 3.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.zyx;\\n\\t\\t\\t\\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\\n\\n\\t\\t\\t} else if ( face == 4.0 ) {\\n\\n\\t\\t\\t\\tdirection = direction.xzy;\\n\\t\\t\\t\\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\\n\\n\\t\\t\\t} else if ( face == 5.0 ) {\\n\\n\\t\\t\\t\\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\\n\\n\\t\\t\\t}\\n\\n\\t\\t\\treturn direction;\\n\\n\\t\\t}\\n\\n\\t\\tvoid main() {\\n\\n\\t\\t\\tvOutputDirection = getDirection( uv, faceIndex );\\n\\t\\t\\tgl_Position = vec4( position, 1.0 );\\n\\n\\t\\t}\\n\\t",fragmentShader:"\\n\\n\\t\\t\\tprecision mediump float;\\n\\t\\t\\tprecision mediump int;\\n\\n\\t\\t\\tuniform float flipEnvMap;\\n\\n\\t\\t\\tvarying vec3 vOutputDirection;\\n\\n\\t\\t\\tuniform samplerCube envMap;\\n\\n\\t\\t\\tvoid main() {\\n\\n\\t\\t\\t\\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\\n\\n\\t\\t\\t}\\n\\t\\t",blending:0,depthTest:!1,depthWrite:!1})}function _r(e){let t=new WeakMap,n=null;function i(e){const n=e.target;n.removeEventListener("dispose",i);const r=t.get(n);void 0!==r&&(t.delete(n),r.dispose())}return{get:function(r){if(r&&r.isTexture){const a=r.mapping,s=303===a||304===a,o=a===N||a===I;if(s||o){if(r.isRenderTargetTexture&&!0===r.needsPMREMUpdate){r.needsPMREMUpdate=!1;let i=t.get(r);return null===n&&(n=new dr(e)),i=s?n.fromEquirectangular(r,i):n.fromCubemap(r,i),t.set(r,i),i.texture}if(t.has(r))return t.get(r).texture;{const a=r.image;if(s&&a&&a.height>0||o&&a&&function(e){let t=0;for(let n=0;n<6;n++)void 0!==e[n]&&t++;return 6===t}(a)){null===n&&(n=new dr(e));const a=s?n.fromEquirectangular(r):n.fromCubemap(r);return t.set(r,a),r.addEventListener("dispose",i),a.texture}return null}}}return r},dispose:function(){t=new WeakMap,null!==n&&(n.dispose(),n=null)}}}function vr(e){const t={};function n(n){if(void 0!==t[n])return t[n];let i;switch(n){case"WEBGL_depth_texture":i=e.getExtension("WEBGL_depth_texture")||e.getExtension("MOZ_WEBGL_depth_texture")||e.getExtension("WEBKIT_WEBGL_depth_texture");break;case"EXT_texture_filter_anisotropic":i=e.getExtension("EXT_texture_filter_anisotropic")||e.getExtension("MOZ_EXT_texture_filter_anisotropic")||e.getExtension("WEBKIT_EXT_texture_filter_anisotropic");break;case"WEBGL_compressed_texture_s3tc":i=e.getExtension("WEBGL_compressed_texture_s3tc")||e.getExtension("MOZ_WEBGL_compressed_texture_s3tc")||e.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");break;case"WEBGL_compressed_texture_pvrtc":i=e.getExtension("WEBGL_compressed_texture_pvrtc")||e.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");break;default:i=e.getExtension(n)}return t[n]=i,i}return{has:function(e){return null!==n(e)},init:function(e){e.isWebGL2?n("EXT_color_buffer_float"):(n("WEBGL_depth_texture"),n("OES_texture_float"),n("OES_texture_half_float"),n("OES_texture_half_float_linear"),n("OES_standard_derivatives"),n("OES_element_index_uint"),n("OES_vertex_array_object"),n("ANGLE_instanced_arrays")),n("OES_texture_float_linear"),n("EXT_color_buffer_half_float"),n("WEBGL_multisampled_render_to_texture")},get:function(e){const t=n(e);return null===t&&console.warn("THREE.WebGLRenderer: "+e+" extension not supported."),t}}}function xr(e,t,n,i){const r={},a=new WeakMap;function s(e){const o=e.target;null!==o.index&&t.remove(o.index);for(const e in o.attributes)t.remove(o.attributes[e]);for(const e in o.morphAttributes){const n=o.morphAttributes[e];for(let e=0,i=n.length;e<i;e++)t.remove(n[e])}o.removeEventListener("dispose",s),delete r[o.id];const l=a.get(o);l&&(t.remove(l),a.delete(o)),i.releaseStatesOfGeometry(o),!0===o.isInstancedBufferGeometry&&delete o._maxInstanceCount,n.memory.geometries--}function o(e){const n=[],i=e.index,r=e.attributes.position;let s=0;if(null!==i){const e=i.array;s=i.version;for(let t=0,i=e.length;t<i;t+=3){const i=e[t+0],r=e[t+1],a=e[t+2];n.push(i,r,r,a,a,i)}}else{if(void 0===r)return;{const e=r.array;s=r.version;for(let t=0,i=e.length/3-1;t<i;t+=3){const e=t+0,i=t+1,r=t+2;n.push(e,i,i,r,r,e)}}}const o=new(je(n)?Yn:qn)(n,1);o.version=s;const l=a.get(e);l&&t.remove(l),a.set(e,o)}return{get:function(e,t){return!0===r[t.id]||(t.addEventListener("dispose",s),r[t.id]=!0,n.memory.geometries++),t},update:function(n){const i=n.attributes;for(const n in i)t.update(i[n],e.ARRAY_BUFFER);const r=n.morphAttributes;for(const n in r){const i=r[n];for(let n=0,r=i.length;n<r;n++)t.update(i[n],e.ARRAY_BUFFER)}},getWireframeAttribute:function(e){const t=a.get(e);if(t){const n=e.index;null!==n&&t.version<n.version&&o(e)}else o(e);return a.get(e)}}}function Mr(e,t,n,i){const r=i.isWebGL2;let a,s,o;this.setMode=function(e){a=e},this.setIndex=function(e){s=e.type,o=e.bytesPerElement},this.render=function(t,i){e.drawElements(a,i,s,t*o),n.update(i,a,1)},this.renderInstances=function(i,l,c){if(0===c)return;let h,u;if(r)h=e,u="drawElementsInstanced";else if(h=t.get("ANGLE_instanced_arrays"),u="drawElementsInstancedANGLE",null===h)return void console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");h[u](a,l,s,i*o,c),n.update(l,a,c)}}function Sr(e){const t={frame:0,calls:0,triangles:0,points:0,lines:0};return{memory:{geometries:0,textures:0},render:t,programs:null,autoReset:!0,reset:function(){t.calls=0,t.triangles=0,t.points=0,t.lines=0},update:function(n,i,r){switch(t.calls++,i){case e.TRIANGLES:t.triangles+=r*(n/3);break;case e.LINES:t.lines+=r*(n/2);break;case e.LINE_STRIP:t.lines+=r*(n-1);break;case e.LINE_LOOP:t.lines+=r*n;break;case e.POINTS:t.points+=r*n;break;default:console.error("THREE.WebGLInfo: Unknown draw mode:",i)}}}}function yr(e,t){return e[0]-t[0]}function Er(e,t){return Math.abs(t[1])-Math.abs(e[1])}function Tr(e,t,n){const i={},r=new Float32Array(8),a=new WeakMap,s=new ut,o=[];for(let e=0;e<8;e++)o[e]=[e,0];return{update:function(l,c,h){const u=l.morphTargetInfluences;if(!0===t.isWebGL2){const d=c.morphAttributes.position||c.morphAttributes.normal||c.morphAttributes.color,p=void 0!==d?d.length:0;let f=a.get(c);if(void 0===f||f.count!==p){void 0!==f&&f.texture.dispose();const _=void 0!==c.morphAttributes.position,v=void 0!==c.morphAttributes.normal,x=void 0!==c.morphAttributes.color,M=c.morphAttributes.position||[],S=c.morphAttributes.normal||[],y=c.morphAttributes.color||[];let E=0;!0===_&&(E=1),!0===v&&(E=2),!0===x&&(E=3);let T=c.attributes.position.count*E,b=1;T>t.maxTextureSize&&(b=Math.ceil(T/t.maxTextureSize),T=t.maxTextureSize);const w=new Float32Array(T*b*4*p),A=new ft(w,T,b,p);A.type=K,A.needsUpdate=!0;const R=4*E;for(let L=0;L<p;L++){const P=M[L],U=S[L],D=y[L],N=T*b*4*L;for(let I=0;I<P.count;I++){const O=I*R;!0===_&&(s.fromBufferAttribute(P,I),w[N+O+0]=s.x,w[N+O+1]=s.y,w[N+O+2]=s.z,w[N+O+3]=0),!0===v&&(s.fromBufferAttribute(U,I),w[N+O+4]=s.x,w[N+O+5]=s.y,w[N+O+6]=s.z,w[N+O+7]=0),!0===x&&(s.fromBufferAttribute(D,I),w[N+O+8]=s.x,w[N+O+9]=s.y,w[N+O+10]=s.z,w[N+O+11]=4===D.itemSize?s.w:1)}}function C(){A.dispose(),a.delete(c),c.removeEventListener("dispose",C)}f={count:p,texture:A,size:new ke(T,b)},a.set(c,f),c.addEventListener("dispose",C)}let m=0;for(let F=0;F<u.length;F++)m+=u[F];const g=c.morphTargetsRelative?1:1-m;h.getUniforms().setValue(e,"morphTargetBaseInfluence",g),h.getUniforms().setValue(e,"morphTargetInfluences",u),h.getUniforms().setValue(e,"morphTargetsTexture",f.texture,n),h.getUniforms().setValue(e,"morphTargetsTextureSize",f.size)}else{const z=void 0===u?0:u.length;let B=i[c.id];if(void 0===B||B.length!==z){B=[];for(let W=0;W<z;W++)B[W]=[W,0];i[c.id]=B}for(let X=0;X<z;X++){const j=B[X];j[0]=X,j[1]=u[X]}B.sort(Er);for(let q=0;q<8;q++)q<z&&B[q][1]?(o[q][0]=B[q][0],o[q][1]=B[q][1]):(o[q][0]=Number.MAX_SAFE_INTEGER,o[q][1]=0);o.sort(yr);const H=c.morphAttributes.position,V=c.morphAttributes.normal;let G=0;for(let Y=0;Y<8;Y++){const Z=o[Y],J=Z[0],Q=Z[1];J!==Number.MAX_SAFE_INTEGER&&Q?(H&&c.getAttribute("morphTarget"+Y)!==H[J]&&c.setAttribute("morphTarget"+Y,H[J]),V&&c.getAttribute("morphNormal"+Y)!==V[J]&&c.setAttribute("morphNormal"+Y,V[J]),r[Y]=Q,G+=Q):(H&&!0===c.hasAttribute("morphTarget"+Y)&&c.deleteAttribute("morphTarget"+Y),V&&!0===c.hasAttribute("morphNormal"+Y)&&c.deleteAttribute("morphNormal"+Y),r[Y]=0)}const k=c.morphTargetsRelative?1:1-G;h.getUniforms().setValue(e,"morphTargetBaseInfluence",k),h.getUniforms().setValue(e,"morphTargetInfluences",r)}}}}function br(e,t,n,i){let r=new WeakMap;function a(e){const t=e.target;t.removeEventListener("dispose",a),n.remove(t.instanceMatrix),null!==t.instanceColor&&n.remove(t.instanceColor)}return{update:function(s){const o=i.render.frame,l=s.geometry,c=t.get(s,l);if(r.get(c)!==o&&(t.update(c),r.set(c,o)),s.isInstancedMesh&&(!1===s.hasEventListener("dispose",a)&&s.addEventListener("dispose",a),r.get(s)!==o&&(n.update(s.instanceMatrix,e.ARRAY_BUFFER),null!==s.instanceColor&&n.update(s.instanceColor,e.ARRAY_BUFFER),r.set(s,o))),s.isSkinnedMesh){const e=s.skeleton;r.get(e)!==o&&(e.update(),r.set(e,o))}return c},dispose:function(){r=new WeakMap}}}const wr=new ht,Ar=new ft,Rr=new mt,Cr=new Di,Lr=[],Pr=[],Ur=new Float32Array(16),Dr=new Float32Array(9),Nr=new Float32Array(4);function Ir(e,t,n){const i=e[0];if(i<=0||i>0)return e;const r=t*n;let a=Lr[r];if(void 0===a&&(a=new Float32Array(r),Lr[r]=a),0!==t){i.toArray(a,0);for(let i=1,r=0;i!==t;++i)r+=n,e[i].toArray(a,r)}return a}function Or(e,t){if(e.length!==t.length)return!1;for(let n=0,i=e.length;n<i;n++)if(e[n]!==t[n])return!1;return!0}function Fr(e,t){for(let n=0,i=t.length;n<i;n++)e[n]=t[n]}function zr(e,t){let n=Pr[t];void 0===n&&(n=new Int32Array(t),Pr[t]=n);for(let i=0;i!==t;++i)n[i]=e.allocateTextureUnit();return n}function Br(e,t){const n=this.cache;n[0]!==t&&(e.uniform1f(this.addr,t),n[0]=t)}function Hr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y||(e.uniform2f(this.addr,t.x,t.y),n[0]=t.x,n[1]=t.y);else{if(Or(n,t))return;e.uniform2fv(this.addr,t),Fr(n,t)}}function Vr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y&&n[2]===t.z||(e.uniform3f(this.addr,t.x,t.y,t.z),n[0]=t.x,n[1]=t.y,n[2]=t.z);else if(void 0!==t.r)n[0]===t.r&&n[1]===t.g&&n[2]===t.b||(e.uniform3f(this.addr,t.r,t.g,t.b),n[0]=t.r,n[1]=t.g,n[2]=t.b);else{if(Or(n,t))return;e.uniform3fv(this.addr,t),Fr(n,t)}}function Gr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y&&n[2]===t.z&&n[3]===t.w||(e.uniform4f(this.addr,t.x,t.y,t.z,t.w),n[0]=t.x,n[1]=t.y,n[2]=t.z,n[3]=t.w);else{if(Or(n,t))return;e.uniform4fv(this.addr,t),Fr(n,t)}}function kr(e,t){const n=this.cache,i=t.elements;if(void 0===i){if(Or(n,t))return;e.uniformMatrix2fv(this.addr,!1,t),Fr(n,t)}else{if(Or(n,i))return;Nr.set(i),e.uniformMatrix2fv(this.addr,!1,Nr),Fr(n,i)}}function Wr(e,t){const n=this.cache,i=t.elements;if(void 0===i){if(Or(n,t))return;e.uniformMatrix3fv(this.addr,!1,t),Fr(n,t)}else{if(Or(n,i))return;Dr.set(i),e.uniformMatrix3fv(this.addr,!1,Dr),Fr(n,i)}}function Xr(e,t){const n=this.cache,i=t.elements;if(void 0===i){if(Or(n,t))return;e.uniformMatrix4fv(this.addr,!1,t),Fr(n,t)}else{if(Or(n,i))return;Ur.set(i),e.uniformMatrix4fv(this.addr,!1,Ur),Fr(n,i)}}function jr(e,t){const n=this.cache;n[0]!==t&&(e.uniform1i(this.addr,t),n[0]=t)}function qr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y||(e.uniform2i(this.addr,t.x,t.y),n[0]=t.x,n[1]=t.y);else{if(Or(n,t))return;e.uniform2iv(this.addr,t),Fr(n,t)}}function Yr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y&&n[2]===t.z||(e.uniform3i(this.addr,t.x,t.y,t.z),n[0]=t.x,n[1]=t.y,n[2]=t.z);else{if(Or(n,t))return;e.uniform3iv(this.addr,t),Fr(n,t)}}function Kr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y&&n[2]===t.z&&n[3]===t.w||(e.uniform4i(this.addr,t.x,t.y,t.z,t.w),n[0]=t.x,n[1]=t.y,n[2]=t.z,n[3]=t.w);else{if(Or(n,t))return;e.uniform4iv(this.addr,t),Fr(n,t)}}function Zr(e,t){const n=this.cache;n[0]!==t&&(e.uniform1ui(this.addr,t),n[0]=t)}function Jr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y||(e.uniform2ui(this.addr,t.x,t.y),n[0]=t.x,n[1]=t.y);else{if(Or(n,t))return;e.uniform2uiv(this.addr,t),Fr(n,t)}}function Qr(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y&&n[2]===t.z||(e.uniform3ui(this.addr,t.x,t.y,t.z),n[0]=t.x,n[1]=t.y,n[2]=t.z);else{if(Or(n,t))return;e.uniform3uiv(this.addr,t),Fr(n,t)}}function $r(e,t){const n=this.cache;if(void 0!==t.x)n[0]===t.x&&n[1]===t.y&&n[2]===t.z&&n[3]===t.w||(e.uniform4ui(this.addr,t.x,t.y,t.z,t.w),n[0]=t.x,n[1]=t.y,n[2]=t.z,n[3]=t.w);else{if(Or(n,t))return;e.uniform4uiv(this.addr,t),Fr(n,t)}}function ea(e,t,n){const i=this.cache,r=n.allocateTextureUnit();i[0]!==r&&(e.uniform1i(this.addr,r),i[0]=r),n.setTexture2D(t||wr,r)}function ta(e,t,n){const i=this.cache,r=n.allocateTextureUnit();i[0]!==r&&(e.uniform1i(this.addr,r),i[0]=r),n.setTexture3D(t||Rr,r)}function na(e,t,n){const i=this.cache,r=n.allocateTextureUnit();i[0]!==r&&(e.uniform1i(this.addr,r),i[0]=r),n.setTextureCube(t||Cr,r)}function ia(e,t,n){const i=this.cache,r=n.allocateTextureUnit();i[0]!==r&&(e.uniform1i(this.addr,r),i[0]=r),n.setTexture2DArray(t||Ar,r)}function ra(e,t){e.uniform1fv(this.addr,t)}function aa(e,t){const n=Ir(t,this.size,2);e.uniform2fv(this.addr,n)}function sa(e,t){const n=Ir(t,this.size,3);e.uniform3fv(this.addr,n)}function oa(e,t){const n=Ir(t,this.size,4);e.uniform4fv(this.addr,n)}function la(e,t){const n=Ir(t,this.size,4);e.uniformMatrix2fv(this.addr,!1,n)}function ca(e,t){const n=Ir(t,this.size,9);e.uniformMatrix3fv(this.addr,!1,n)}function ha(e,t){const n=Ir(t,this.size,16);e.uniformMatrix4fv(this.addr,!1,n)}function ua(e,t){e.uniform1iv(this.addr,t)}function da(e,t){e.uniform2iv(this.addr,t)}function pa(e,t){e.uniform3iv(this.addr,t)}function fa(e,t){e.uniform4iv(this.addr,t)}function ma(e,t){e.uniform1uiv(this.addr,t)}function ga(e,t){e.uniform2uiv(this.addr,t)}function _a(e,t){e.uniform3uiv(this.addr,t)}function va(e,t){e.uniform4uiv(this.addr,t)}function xa(e,t,n){const i=this.cache,r=t.length,a=zr(n,r);Or(i,a)||(e.uniform1iv(this.addr,a),Fr(i,a));for(let e=0;e!==r;++e)n.setTexture2D(t[e]||wr,a[e])}function Ma(e,t,n){const i=this.cache,r=t.length,a=zr(n,r);Or(i,a)||(e.uniform1iv(this.addr,a),Fr(i,a));for(let e=0;e!==r;++e)n.setTexture3D(t[e]||Rr,a[e])}function Sa(e,t,n){const i=this.cache,r=t.length,a=zr(n,r);Or(i,a)||(e.uniform1iv(this.addr,a),Fr(i,a));for(let e=0;e!==r;++e)n.setTextureCube(t[e]||Cr,a[e])}function ya(e,t,n){const i=this.cache,r=t.length,a=zr(n,r);Or(i,a)||(e.uniform1iv(this.addr,a),Fr(i,a));for(let e=0;e!==r;++e)n.setTexture2DArray(t[e]||Ar,a[e])}class Ea{constructor(e,t,n){this.id=e,this.addr=n,this.cache=[],this.setValue=function(e){switch(e){case 5126:return Br;case 35664:return Hr;case 35665:return Vr;case 35666:return Gr;case 35674:return kr;case 35675:return Wr;case 35676:return Xr;case 5124:case 35670:return jr;case 35667:case 35671:return qr;case 35668:case 35672:return Yr;case 35669:case 35673:return Kr;case 5125:return Zr;case 36294:return Jr;case 36295:return Qr;case 36296:return $r;case 35678:case 36198:case 36298:case 36306:case 35682:return ea;case 35679:case 36299:case 36307:return ta;case 35680:case 36300:case 36308:case 36293:return na;case 36289:case 36303:case 36311:case 36292:return ia}}(t.type)}}class Ta{constructor(e,t,n){this.id=e,this.addr=n,this.cache=[],this.size=t.size,this.setValue=function(e){switch(e){case 5126:return ra;case 35664:return aa;case 35665:return sa;case 35666:return oa;case 35674:return la;case 35675:return ca;case 35676:return ha;case 5124:case 35670:return ua;case 35667:case 35671:return da;case 35668:case 35672:return pa;case 35669:case 35673:return fa;case 5125:return ma;case 36294:return ga;case 36295:return _a;case 36296:return va;case 35678:case 36198:case 36298:case 36306:case 35682:return xa;case 35679:case 36299:case 36307:return Ma;case 35680:case 36300:case 36308:case 36293:return Sa;case 36289:case 36303:case 36311:case 36292:return ya}}(t.type)}}class ba{constructor(e){this.id=e,this.seq=[],this.map={}}setValue(e,t,n){const i=this.seq;for(let r=0,a=i.length;r!==a;++r){const a=i[r];a.setValue(e,t[a.id],n)}}}const wa=/(\\w+)(\\])?(\\[|\\.)?/g;function Aa(e,t){e.seq.push(t),e.map[t.id]=t}function Ra(e,t,n){const i=e.name,r=i.length;for(wa.lastIndex=0;;){const a=wa.exec(i),s=wa.lastIndex;let o=a[1];const l="]"===a[2],c=a[3];if(l&&(o|=0),void 0===c||"["===c&&s+2===r){Aa(n,void 0===c?new Ea(o,e,t):new Ta(o,e,t));break}{let e=n.map[o];void 0===e&&(e=new ba(o),Aa(n,e)),n=e}}}class Ca{constructor(e,t){this.seq=[],this.map={};const n=e.getProgramParameter(t,e.ACTIVE_UNIFORMS);for(let i=0;i<n;++i){const n=e.getActiveUniform(t,i);Ra(n,e.getUniformLocation(t,n.name),this)}}setValue(e,t,n,i){const r=this.map[t];void 0!==r&&r.setValue(e,n,i)}setOptional(e,t,n){const i=t[n];void 0!==i&&this.setValue(e,n,i)}static upload(e,t,n,i){for(let r=0,a=t.length;r!==a;++r){const a=t[r],s=n[a.id];!1!==s.needsUpdate&&a.setValue(e,s.value,i)}}static seqWithValue(e,t){const n=[];for(let i=0,r=e.length;i!==r;++i){const r=e[i];r.id in t&&n.push(r)}return n}}function La(e,t,n){const i=e.createShader(t);return e.shaderSource(i,n),e.compileShader(i),i}const Pa=37297;let Ua=0;function Da(e,t,n){const i=e.getShaderParameter(t,e.COMPILE_STATUS),r=e.getShaderInfoLog(t).trim();if(i&&""===r)return"";const a=/ERROR: 0:(\\d+)/.exec(r);if(a){const i=parseInt(a[1]);return n.toUpperCase()+"\\n\\n"+r+"\\n\\n"+function(e,t){const n=e.split("\\n"),i=[],r=Math.max(t-6,0),a=Math.min(t+6,n.length);for(let e=r;e<a;e++){const r=e+1;i.push("".concat(r===t?">":" "," ").concat(r,": ").concat(n[e]))}return i.join("\\n")}(e.getShaderSource(t),i)}return r}function Na(e,t){const n=function(e){const t=tt.getPrimaries(tt.workingColorSpace),n=tt.getPrimaries(e);let i;switch(t===n?i="":t===ve&&n===_e?i="LinearDisplayP3ToLinearSRGB":t===_e&&n===ve&&(i="LinearSRGBToLinearDisplayP3"),e){case de:case fe:return[i,"LinearTransferOETF"];case ue:case pe:return[i,"sRGBTransferOETF"];default:return console.warn("THREE.WebGLProgram: Unsupported color space:",e),[i,"LinearTransferOETF"]}}(t);return"vec4 ".concat(e,"( vec4 value ) { return ").concat(n[0],"( ").concat(n[1],"( value ) ); }")}function Ia(e,t){let n;switch(t){case C:n="Linear";break;case L:n="Reinhard";break;case P:n="OptimizedCineon";break;case U:n="ACESFilmic";break;case D:n="Custom";break;default:console.warn("THREE.WebGLProgram: Unsupported toneMapping:",t),n="Linear"}return"vec3 "+e+"( vec3 color ) { return "+n+"ToneMapping( color ); }"}function Oa(e){return""!==e}function Fa(e,t){const n=t.numSpotLightShadows+t.numSpotLightMaps-t.numSpotLightShadowsWithMaps;return e.replace(/NUM_DIR_LIGHTS/g,t.numDirLights).replace(/NUM_SPOT_LIGHTS/g,t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g,t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g,n).replace(/NUM_RECT_AREA_LIGHTS/g,t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g,t.numPointLights).replace(/NUM_HEMI_LIGHTS/g,t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g,t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g,t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g,t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g,t.numPointLightShadows)}function za(e,t){return e.replace(/NUM_CLIPPING_PLANES/g,t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g,t.numClippingPlanes-t.numClipIntersection)}const Ba=/^[ \\t]*#include +<([\\w\\d./]+)>/gm;function Ha(e){return e.replace(Ba,Ga)}const Va=new Map([["encodings_fragment","colorspace_fragment"],["encodings_pars_fragment","colorspace_pars_fragment"],["output_fragment","opaque_fragment"]]);function Ga(e,t){let n=Xi[t];if(void 0===n){const e=Va.get(t);if(void 0===e)throw new Error("Can not resolve #include <"+t+">");n=Xi[e],console.warn(\'THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.\',t,e)}return Ha(n)}const ka=/#pragma unroll_loop_start\\s+for\\s*\\(\\s*int\\s+i\\s*=\\s*(\\d+)\\s*;\\s*i\\s*<\\s*(\\d+)\\s*;\\s*i\\s*\\+\\+\\s*\\)\\s*{([\\s\\S]+?)}\\s+#pragma unroll_loop_end/g;function Wa(e){return e.replace(ka,Xa)}function Xa(e,t,n,i){let r="";for(let e=parseInt(t);e<parseInt(n);e++)r+=i.replace(/\\[\\s*i\\s*\\]/g,"[ "+e+" ]").replace(/UNROLLED_LOOP_INDEX/g,e);return r}function ja(e){let t="precision "+e.precision+" float;\\nprecision "+e.precision+" int;";return"highp"===e.precision?t+="\\n#define HIGH_PRECISION":"mediump"===e.precision?t+="\\n#define MEDIUM_PRECISION":"lowp"===e.precision&&(t+="\\n#define LOW_PRECISION"),t}function qa(e,r,a,s){const o=e.getContext(),l=a.defines;let c=a.vertexShader,h=a.fragmentShader;const u=function(e){let r="SHADOWMAP_TYPE_BASIC";return e.shadowMapType===t?r="SHADOWMAP_TYPE_PCF":e.shadowMapType===n?r="SHADOWMAP_TYPE_PCF_SOFT":e.shadowMapType===i&&(r="SHADOWMAP_TYPE_VSM"),r}(a),d=function(e){let t="ENVMAP_TYPE_CUBE";if(e.envMap)switch(e.envMapMode){case N:case I:t="ENVMAP_TYPE_CUBE";break;case O:t="ENVMAP_TYPE_CUBE_UV"}return t}(a),p=function(e){let t="ENVMAP_MODE_REFLECTION";return e.envMap&&e.envMapMode===I&&(t="ENVMAP_MODE_REFRACTION"),t}(a),f=function(e){let t="ENVMAP_BLENDING_NONE";if(e.envMap)switch(e.combine){case b:t="ENVMAP_BLENDING_MULTIPLY";break;case w:t="ENVMAP_BLENDING_MIX";break;case A:t="ENVMAP_BLENDING_ADD"}return t}(a),m=function(e){const t=e.envMapCubeUVHeight;if(null===t)return null;const n=Math.log2(t)-2,i=1/t;return{texelWidth:1/(3*Math.max(Math.pow(2,n),112)),texelHeight:i,maxMip:n}}(a),g=a.isWebGL2?"":function(e){return[e.extensionDerivatives||e.envMapCubeUVHeight||e.bumpMap||e.normalMapTangentSpace||e.clearcoatNormalMap||e.flatShading||"physical"===e.shaderID?"#extension GL_OES_standard_derivatives : enable":"",(e.extensionFragDepth||e.logarithmicDepthBuffer)&&e.rendererExtensionFragDepth?"#extension GL_EXT_frag_depth : enable":"",e.extensionDrawBuffers&&e.rendererExtensionDrawBuffers?"#extension GL_EXT_draw_buffers : require":"",(e.extensionShaderTextureLOD||e.envMap||e.transmission)&&e.rendererExtensionShaderTextureLod?"#extension GL_EXT_shader_texture_lod : enable":""].filter(Oa).join("\\n")}(a),_=function(e){const t=[];for(const n in e){const i=e[n];!1!==i&&t.push("#define "+n+" "+i)}return t.join("\\n")}(l),v=o.createProgram();let x,M,S=a.glslVersion?"#version "+a.glslVersion+"\\n":"";a.isRawShaderMaterial?(x=["#define SHADER_TYPE "+a.shaderType,"#define SHADER_NAME "+a.shaderName,_].filter(Oa).join("\\n"),x.length>0&&(x+="\\n"),M=[g,"#define SHADER_TYPE "+a.shaderType,"#define SHADER_NAME "+a.shaderName,_].filter(Oa).join("\\n"),M.length>0&&(M+="\\n")):(x=[ja(a),"#define SHADER_TYPE "+a.shaderType,"#define SHADER_NAME "+a.shaderName,_,a.instancing?"#define USE_INSTANCING":"",a.instancingColor?"#define USE_INSTANCING_COLOR":"",a.useFog&&a.fog?"#define USE_FOG":"",a.useFog&&a.fogExp2?"#define FOG_EXP2":"",a.map?"#define USE_MAP":"",a.envMap?"#define USE_ENVMAP":"",a.envMap?"#define "+p:"",a.lightMap?"#define USE_LIGHTMAP":"",a.aoMap?"#define USE_AOMAP":"",a.bumpMap?"#define USE_BUMPMAP":"",a.normalMap?"#define USE_NORMALMAP":"",a.normalMapObjectSpace?"#define USE_NORMALMAP_OBJECTSPACE":"",a.normalMapTangentSpace?"#define USE_NORMALMAP_TANGENTSPACE":"",a.displacementMap?"#define USE_DISPLACEMENTMAP":"",a.emissiveMap?"#define USE_EMISSIVEMAP":"",a.anisotropy?"#define USE_ANISOTROPY":"",a.anisotropyMap?"#define USE_ANISOTROPYMAP":"",a.clearcoatMap?"#define USE_CLEARCOATMAP":"",a.clearcoatRoughnessMap?"#define USE_CLEARCOAT_ROUGHNESSMAP":"",a.clearcoatNormalMap?"#define USE_CLEARCOAT_NORMALMAP":"",a.iridescenceMap?"#define USE_IRIDESCENCEMAP":"",a.iridescenceThicknessMap?"#define USE_IRIDESCENCE_THICKNESSMAP":"",a.specularMap?"#define USE_SPECULARMAP":"",a.specularColorMap?"#define USE_SPECULAR_COLORMAP":"",a.specularIntensityMap?"#define USE_SPECULAR_INTENSITYMAP":"",a.roughnessMap?"#define USE_ROUGHNESSMAP":"",a.metalnessMap?"#define USE_METALNESSMAP":"",a.alphaMap?"#define USE_ALPHAMAP":"",a.alphaHash?"#define USE_ALPHAHASH":"",a.transmission?"#define USE_TRANSMISSION":"",a.transmissionMap?"#define USE_TRANSMISSIONMAP":"",a.thicknessMap?"#define USE_THICKNESSMAP":"",a.sheenColorMap?"#define USE_SHEEN_COLORMAP":"",a.sheenRoughnessMap?"#define USE_SHEEN_ROUGHNESSMAP":"",a.mapUv?"#define MAP_UV "+a.mapUv:"",a.alphaMapUv?"#define ALPHAMAP_UV "+a.alphaMapUv:"",a.lightMapUv?"#define LIGHTMAP_UV "+a.lightMapUv:"",a.aoMapUv?"#define AOMAP_UV "+a.aoMapUv:"",a.emissiveMapUv?"#define EMISSIVEMAP_UV "+a.emissiveMapUv:"",a.bumpMapUv?"#define BUMPMAP_UV "+a.bumpMapUv:"",a.normalMapUv?"#define NORMALMAP_UV "+a.normalMapUv:"",a.displacementMapUv?"#define DISPLACEMENTMAP_UV "+a.displacementMapUv:"",a.metalnessMapUv?"#define METALNESSMAP_UV "+a.metalnessMapUv:"",a.roughnessMapUv?"#define ROUGHNESSMAP_UV "+a.roughnessMapUv:"",a.anisotropyMapUv?"#define ANISOTROPYMAP_UV "+a.anisotropyMapUv:"",a.clearcoatMapUv?"#define CLEARCOATMAP_UV "+a.clearcoatMapUv:"",a.clearcoatNormalMapUv?"#define CLEARCOAT_NORMALMAP_UV "+a.clearcoatNormalMapUv:"",a.clearcoatRoughnessMapUv?"#define CLEARCOAT_ROUGHNESSMAP_UV "+a.clearcoatRoughnessMapUv:"",a.iridescenceMapUv?"#define IRIDESCENCEMAP_UV "+a.iridescenceMapUv:"",a.iridescenceThicknessMapUv?"#define IRIDESCENCE_THICKNESSMAP_UV "+a.iridescenceThicknessMapUv:"",a.sheenColorMapUv?"#define SHEEN_COLORMAP_UV "+a.sheenColorMapUv:"",a.sheenRoughnessMapUv?"#define SHEEN_ROUGHNESSMAP_UV "+a.sheenRoughnessMapUv:"",a.specularMapUv?"#define SPECULARMAP_UV "+a.specularMapUv:"",a.specularColorMapUv?"#define SPECULAR_COLORMAP_UV "+a.specularColorMapUv:"",a.specularIntensityMapUv?"#define SPECULAR_INTENSITYMAP_UV "+a.specularIntensityMapUv:"",a.transmissionMapUv?"#define TRANSMISSIONMAP_UV "+a.transmissionMapUv:"",a.thicknessMapUv?"#define THICKNESSMAP_UV "+a.thicknessMapUv:"",a.vertexTangents&&!1===a.flatShading?"#define USE_TANGENT":"",a.vertexColors?"#define USE_COLOR":"",a.vertexAlphas?"#define USE_COLOR_ALPHA":"",a.vertexUv1s?"#define USE_UV1":"",a.vertexUv2s?"#define USE_UV2":"",a.vertexUv3s?"#define USE_UV3":"",a.pointsUvs?"#define USE_POINTS_UV":"",a.flatShading?"#define FLAT_SHADED":"",a.skinning?"#define USE_SKINNING":"",a.morphTargets?"#define USE_MORPHTARGETS":"",a.morphNormals&&!1===a.flatShading?"#define USE_MORPHNORMALS":"",a.morphColors&&a.isWebGL2?"#define USE_MORPHCOLORS":"",a.morphTargetsCount>0&&a.isWebGL2?"#define MORPHTARGETS_TEXTURE":"",a.morphTargetsCount>0&&a.isWebGL2?"#define MORPHTARGETS_TEXTURE_STRIDE "+a.morphTextureStride:"",a.morphTargetsCount>0&&a.isWebGL2?"#define MORPHTARGETS_COUNT "+a.morphTargetsCount:"",a.doubleSided?"#define DOUBLE_SIDED":"",a.flipSided?"#define FLIP_SIDED":"",a.shadowMapEnabled?"#define USE_SHADOWMAP":"",a.shadowMapEnabled?"#define "+u:"",a.sizeAttenuation?"#define USE_SIZEATTENUATION":"",a.numLightProbes>0?"#define USE_LIGHT_PROBES":"",a.useLegacyLights?"#define LEGACY_LIGHTS":"",a.logarithmicDepthBuffer?"#define USE_LOGDEPTHBUF":"",a.logarithmicDepthBuffer&&a.rendererExtensionFragDepth?"#define USE_LOGDEPTHBUF_EXT":"","uniform mat4 modelMatrix;","uniform mat4 modelViewMatrix;","uniform mat4 projectionMatrix;","uniform mat4 viewMatrix;","uniform mat3 normalMatrix;","uniform vec3 cameraPosition;","uniform bool isOrthographic;","#ifdef USE_INSTANCING","\\tattribute mat4 instanceMatrix;","#endif","#ifdef USE_INSTANCING_COLOR","\\tattribute vec3 instanceColor;","#endif","attribute vec3 position;","attribute vec3 normal;","attribute vec2 uv;","#ifdef USE_UV1","\\tattribute vec2 uv1;","#endif","#ifdef USE_UV2","\\tattribute vec2 uv2;","#endif","#ifdef USE_UV3","\\tattribute vec2 uv3;","#endif","#ifdef USE_TANGENT","\\tattribute vec4 tangent;","#endif","#if defined( USE_COLOR_ALPHA )","\\tattribute vec4 color;","#elif defined( USE_COLOR )","\\tattribute vec3 color;","#endif","#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )","\\tattribute vec3 morphTarget0;","\\tattribute vec3 morphTarget1;","\\tattribute vec3 morphTarget2;","\\tattribute vec3 morphTarget3;","\\t#ifdef USE_MORPHNORMALS","\\t\\tattribute vec3 morphNormal0;","\\t\\tattribute vec3 morphNormal1;","\\t\\tattribute vec3 morphNormal2;","\\t\\tattribute vec3 morphNormal3;","\\t#else","\\t\\tattribute vec3 morphTarget4;","\\t\\tattribute vec3 morphTarget5;","\\t\\tattribute vec3 morphTarget6;","\\t\\tattribute vec3 morphTarget7;","\\t#endif","#endif","#ifdef USE_SKINNING","\\tattribute vec4 skinIndex;","\\tattribute vec4 skinWeight;","#endif","\\n"].filter(Oa).join("\\n"),M=[g,ja(a),"#define SHADER_TYPE "+a.shaderType,"#define SHADER_NAME "+a.shaderName,_,a.useFog&&a.fog?"#define USE_FOG":"",a.useFog&&a.fogExp2?"#define FOG_EXP2":"",a.map?"#define USE_MAP":"",a.matcap?"#define USE_MATCAP":"",a.envMap?"#define USE_ENVMAP":"",a.envMap?"#define "+d:"",a.envMap?"#define "+p:"",a.envMap?"#define "+f:"",m?"#define CUBEUV_TEXEL_WIDTH "+m.texelWidth:"",m?"#define CUBEUV_TEXEL_HEIGHT "+m.texelHeight:"",m?"#define CUBEUV_MAX_MIP "+m.maxMip+".0":"",a.lightMap?"#define USE_LIGHTMAP":"",a.aoMap?"#define USE_AOMAP":"",a.bumpMap?"#define USE_BUMPMAP":"",a.normalMap?"#define USE_NORMALMAP":"",a.normalMapObjectSpace?"#define USE_NORMALMAP_OBJECTSPACE":"",a.normalMapTangentSpace?"#define USE_NORMALMAP_TANGENTSPACE":"",a.emissiveMap?"#define USE_EMISSIVEMAP":"",a.anisotropy?"#define USE_ANISOTROPY":"",a.anisotropyMap?"#define USE_ANISOTROPYMAP":"",a.clearcoat?"#define USE_CLEARCOAT":"",a.clearcoatMap?"#define USE_CLEARCOATMAP":"",a.clearcoatRoughnessMap?"#define USE_CLEARCOAT_ROUGHNESSMAP":"",a.clearcoatNormalMap?"#define USE_CLEARCOAT_NORMALMAP":"",a.iridescence?"#define USE_IRIDESCENCE":"",a.iridescenceMap?"#define USE_IRIDESCENCEMAP":"",a.iridescenceThicknessMap?"#define USE_IRIDESCENCE_THICKNESSMAP":"",a.specularMap?"#define USE_SPECULARMAP":"",a.specularColorMap?"#define USE_SPECULAR_COLORMAP":"",a.specularIntensityMap?"#define USE_SPECULAR_INTENSITYMAP":"",a.roughnessMap?"#define USE_ROUGHNESSMAP":"",a.metalnessMap?"#define USE_METALNESSMAP":"",a.alphaMap?"#define USE_ALPHAMAP":"",a.alphaTest?"#define USE_ALPHATEST":"",a.alphaHash?"#define USE_ALPHAHASH":"",a.sheen?"#define USE_SHEEN":"",a.sheenColorMap?"#define USE_SHEEN_COLORMAP":"",a.sheenRoughnessMap?"#define USE_SHEEN_ROUGHNESSMAP":"",a.transmission?"#define USE_TRANSMISSION":"",a.transmissionMap?"#define USE_TRANSMISSIONMAP":"",a.thicknessMap?"#define USE_THICKNESSMAP":"",a.vertexTangents&&!1===a.flatShading?"#define USE_TANGENT":"",a.vertexColors||a.instancingColor?"#define USE_COLOR":"",a.vertexAlphas?"#define USE_COLOR_ALPHA":"",a.vertexUv1s?"#define USE_UV1":"",a.vertexUv2s?"#define USE_UV2":"",a.vertexUv3s?"#define USE_UV3":"",a.pointsUvs?"#define USE_POINTS_UV":"",a.gradientMap?"#define USE_GRADIENTMAP":"",a.flatShading?"#define FLAT_SHADED":"",a.doubleSided?"#define DOUBLE_SIDED":"",a.flipSided?"#define FLIP_SIDED":"",a.shadowMapEnabled?"#define USE_SHADOWMAP":"",a.shadowMapEnabled?"#define "+u:"",a.premultipliedAlpha?"#define PREMULTIPLIED_ALPHA":"",a.numLightProbes>0?"#define USE_LIGHT_PROBES":"",a.useLegacyLights?"#define LEGACY_LIGHTS":"",a.decodeVideoTexture?"#define DECODE_VIDEO_TEXTURE":"",a.logarithmicDepthBuffer?"#define USE_LOGDEPTHBUF":"",a.logarithmicDepthBuffer&&a.rendererExtensionFragDepth?"#define USE_LOGDEPTHBUF_EXT":"","uniform mat4 viewMatrix;","uniform vec3 cameraPosition;","uniform bool isOrthographic;",a.toneMapping!==R?"#define TONE_MAPPING":"",a.toneMapping!==R?Xi.tonemapping_pars_fragment:"",a.toneMapping!==R?Ia("toneMapping",a.toneMapping):"",a.dithering?"#define DITHERING":"",a.opaque?"#define OPAQUE":"",Xi.colorspace_pars_fragment,Na("linearToOutputTexel",a.outputColorSpace),a.useDepthPacking?"#define DEPTH_PACKING "+a.depthPacking:"","\\n"].filter(Oa).join("\\n")),c=Ha(c),c=Fa(c,a),c=za(c,a),h=Ha(h),h=Fa(h,a),h=za(h,a),c=Wa(c),h=Wa(h),a.isWebGL2&&!0!==a.isRawShaderMaterial&&(S="#version 300 es\\n",x=["precision mediump sampler2DArray;","#define attribute in","#define varying out","#define texture2D texture"].join("\\n")+"\\n"+x,M=["precision mediump sampler2DArray;","#define varying in",a.glslVersion===Re?"":"layout(location = 0) out highp vec4 pc_fragColor;",a.glslVersion===Re?"":"#define gl_FragColor pc_fragColor","#define gl_FragDepthEXT gl_FragDepth","#define texture2D texture","#define textureCube texture","#define texture2DProj textureProj","#define texture2DLodEXT textureLod","#define texture2DProjLodEXT textureProjLod","#define textureCubeLodEXT textureLod","#define texture2DGradEXT textureGrad","#define texture2DProjGradEXT textureProjGrad","#define textureCubeGradEXT textureGrad"].join("\\n")+"\\n"+M);const y=S+x+c,E=S+M+h,T=La(o,o.VERTEX_SHADER,y),C=La(o,o.FRAGMENT_SHADER,E);function L(t){if(e.debug.checkShaderErrors){const n=o.getProgramInfoLog(v).trim(),i=o.getShaderInfoLog(T).trim(),r=o.getShaderInfoLog(C).trim();let a=!0,s=!0;if(!1===o.getProgramParameter(v,o.LINK_STATUS))if(a=!1,"function"==typeof e.debug.onShaderError)e.debug.onShaderError(o,v,T,C);else{const e=Da(o,T,"vertex"),t=Da(o,C,"fragment");console.error("THREE.WebGLProgram: Shader Error "+o.getError()+" - VALIDATE_STATUS "+o.getProgramParameter(v,o.VALIDATE_STATUS)+"\\n\\nProgram Info Log: "+n+"\\n"+e+"\\n"+t)}else""!==n?console.warn("THREE.WebGLProgram: Program Info Log:",n):""!==i&&""!==r||(s=!1);s&&(t.diagnostics={runnable:a,programLog:n,vertexShader:{log:i,prefix:x},fragmentShader:{log:r,prefix:M}})}o.deleteShader(T),o.deleteShader(C),P=new Ca(o,v),U=function(e,t){const n={},i=e.getProgramParameter(t,e.ACTIVE_ATTRIBUTES);for(let r=0;r<i;r++){const i=e.getActiveAttrib(t,r),a=i.name;let s=1;i.type===e.FLOAT_MAT2&&(s=2),i.type===e.FLOAT_MAT3&&(s=3),i.type===e.FLOAT_MAT4&&(s=4),n[a]={type:i.type,location:e.getAttribLocation(t,a),locationSize:s}}return n}(o,v)}let P,U;o.attachShader(v,T),o.attachShader(v,C),void 0!==a.index0AttributeName?o.bindAttribLocation(v,0,a.index0AttributeName):!0===a.morphTargets&&o.bindAttribLocation(v,0,"position"),o.linkProgram(v),this.getUniforms=function(){return void 0===P&&L(this),P},this.getAttributes=function(){return void 0===U&&L(this),U};let D=!1===a.rendererExtensionParallelShaderCompile;return this.isReady=function(){return!1===D&&(D=o.getProgramParameter(v,Pa)),D},this.destroy=function(){s.releaseStatesOfProgram(this),o.deleteProgram(v),this.program=void 0},this.type=a.shaderType,this.name=a.shaderName,this.id=Ua++,this.cacheKey=r,this.usedTimes=1,this.program=v,this.vertexShader=T,this.fragmentShader=C,this}let Ya=0;class Ka{constructor(){this.shaderCache=new Map,this.materialCache=new Map}update(e){const t=e.vertexShader,n=e.fragmentShader,i=this._getShaderStage(t),r=this._getShaderStage(n),a=this._getShaderCacheForMaterial(e);return!1===a.has(i)&&(a.add(i),i.usedTimes++),!1===a.has(r)&&(a.add(r),r.usedTimes++),this}remove(e){const t=this.materialCache.get(e);for(const e of t)e.usedTimes--,0===e.usedTimes&&this.shaderCache.delete(e.code);return this.materialCache.delete(e),this}getVertexShaderID(e){return this._getShaderStage(e.vertexShader).id}getFragmentShaderID(e){return this._getShaderStage(e.fragmentShader).id}dispose(){this.shaderCache.clear(),this.materialCache.clear()}_getShaderCacheForMaterial(e){const t=this.materialCache;let n=t.get(e);return void 0===n&&(n=new Set,t.set(e,n)),n}_getShaderStage(e){const t=this.shaderCache;let n=t.get(e);return void 0===n&&(n=new Za(e),t.set(e,n)),n}}class Za{constructor(e){this.id=Ya++,this.code=e,this.usedTimes=0}}function Ja(e,t,n,i,r,a,s){const o=new an,l=new Ka,c=[],h=r.isWebGL2,u=r.logarithmicDepthBuffer,d=r.vertexTextures;let p=r.precision;const f={MeshDepthMaterial:"depth",MeshDistanceMaterial:"distanceRGBA",MeshNormalMaterial:"normal",MeshBasicMaterial:"basic",MeshLambertMaterial:"lambert",MeshPhongMaterial:"phong",MeshToonMaterial:"toon",MeshStandardMaterial:"physical",MeshPhysicalMaterial:"physical",MeshMatcapMaterial:"matcap",LineBasicMaterial:"basic",LineDashedMaterial:"dashed",PointsMaterial:"points",ShadowMaterial:"shadow",SpriteMaterial:"sprite"};function m(e){return 0===e?"uv":"uv".concat(e)}return{getParameters:function(a,o,c,g,_){const v=g.fog,x=_.geometry,M=a.isMeshStandardMaterial?g.environment:null,S=(a.isMeshStandardMaterial?n:t).get(a.envMap||M),y=S&&S.mapping===O?S.image.height:null,E=f[a.type];null!==a.precision&&(p=r.getMaxPrecision(a.precision),p!==a.precision&&console.warn("THREE.WebGLProgram.getParameters:",a.precision,"not supported, using",p,"instead."));const T=x.morphAttributes.position||x.morphAttributes.normal||x.morphAttributes.color,b=void 0!==T?T.length:0;let w,A,C,L,P=0;if(void 0!==x.morphAttributes.position&&(P=1),void 0!==x.morphAttributes.normal&&(P=2),void 0!==x.morphAttributes.color&&(P=3),E){const e=qi[E];w=e.vertexShader,A=e.fragmentShader}else w=a.vertexShader,A=a.fragmentShader,l.update(a),C=l.getVertexShaderID(a),L=l.getFragmentShaderID(a);const U=e.getRenderTarget(),D=!0===_.isInstancedMesh,N=!!a.map,I=!!a.matcap,F=!!S,z=!!a.aoMap,B=!!a.lightMap,H=!!a.bumpMap,V=!!a.normalMap,G=!!a.displacementMap,k=!!a.emissiveMap,W=!!a.metalnessMap,X=!!a.roughnessMap,j=a.anisotropy>0,q=a.clearcoat>0,Y=a.iridescence>0,K=a.sheen>0,Z=a.transmission>0,J=j&&!!a.anisotropyMap,Q=q&&!!a.clearcoatMap,$=q&&!!a.clearcoatNormalMap,ee=q&&!!a.clearcoatRoughnessMap,te=Y&&!!a.iridescenceMap,ne=Y&&!!a.iridescenceThicknessMap,ie=K&&!!a.sheenColorMap,re=K&&!!a.sheenRoughnessMap,ae=!!a.specularMap,se=!!a.specularColorMap,oe=!!a.specularIntensityMap,le=Z&&!!a.transmissionMap,ce=Z&&!!a.thicknessMap,he=!!a.gradientMap,ue=!!a.alphaMap,pe=a.alphaTest>0,fe=!!a.alphaHash,me=!!a.extensions,_e=!!x.attributes.uv1,ve=!!x.attributes.uv2,xe=!!x.attributes.uv3;let Me=R;return a.toneMapped&&(null!==U&&!0!==U.isXRRenderTarget||(Me=e.toneMapping)),{isWebGL2:h,shaderID:E,shaderType:a.type,shaderName:a.name,vertexShader:w,fragmentShader:A,defines:a.defines,customVertexShaderID:C,customFragmentShaderID:L,isRawShaderMaterial:!0===a.isRawShaderMaterial,glslVersion:a.glslVersion,precision:p,instancing:D,instancingColor:D&&null!==_.instanceColor,supportsVertexTextures:d,outputColorSpace:null===U?e.outputColorSpace:!0===U.isXRRenderTarget?U.texture.colorSpace:de,map:N,matcap:I,envMap:F,envMapMode:F&&S.mapping,envMapCubeUVHeight:y,aoMap:z,lightMap:B,bumpMap:H,normalMap:V,displacementMap:d&&G,emissiveMap:k,normalMapObjectSpace:V&&1===a.normalMapType,normalMapTangentSpace:V&&0===a.normalMapType,metalnessMap:W,roughnessMap:X,anisotropy:j,anisotropyMap:J,clearcoat:q,clearcoatMap:Q,clearcoatNormalMap:$,clearcoatRoughnessMap:ee,iridescence:Y,iridescenceMap:te,iridescenceThicknessMap:ne,sheen:K,sheenColorMap:ie,sheenRoughnessMap:re,specularMap:ae,specularColorMap:se,specularIntensityMap:oe,transmission:Z,transmissionMap:le,thicknessMap:ce,gradientMap:he,opaque:!1===a.transparent&&1===a.blending,alphaMap:ue,alphaTest:pe,alphaHash:fe,combine:a.combine,mapUv:N&&m(a.map.channel),aoMapUv:z&&m(a.aoMap.channel),lightMapUv:B&&m(a.lightMap.channel),bumpMapUv:H&&m(a.bumpMap.channel),normalMapUv:V&&m(a.normalMap.channel),displacementMapUv:G&&m(a.displacementMap.channel),emissiveMapUv:k&&m(a.emissiveMap.channel),metalnessMapUv:W&&m(a.metalnessMap.channel),roughnessMapUv:X&&m(a.roughnessMap.channel),anisotropyMapUv:J&&m(a.anisotropyMap.channel),clearcoatMapUv:Q&&m(a.clearcoatMap.channel),clearcoatNormalMapUv:$&&m(a.clearcoatNormalMap.channel),clearcoatRoughnessMapUv:ee&&m(a.clearcoatRoughnessMap.channel),iridescenceMapUv:te&&m(a.iridescenceMap.channel),iridescenceThicknessMapUv:ne&&m(a.iridescenceThicknessMap.channel),sheenColorMapUv:ie&&m(a.sheenColorMap.channel),sheenRoughnessMapUv:re&&m(a.sheenRoughnessMap.channel),specularMapUv:ae&&m(a.specularMap.channel),specularColorMapUv:se&&m(a.specularColorMap.channel),specularIntensityMapUv:oe&&m(a.specularIntensityMap.channel),transmissionMapUv:le&&m(a.transmissionMap.channel),thicknessMapUv:ce&&m(a.thicknessMap.channel),alphaMapUv:ue&&m(a.alphaMap.channel),vertexTangents:!!x.attributes.tangent&&(V||j),vertexColors:a.vertexColors,vertexAlphas:!0===a.vertexColors&&!!x.attributes.color&&4===x.attributes.color.itemSize,vertexUv1s:_e,vertexUv2s:ve,vertexUv3s:xe,pointsUvs:!0===_.isPoints&&!!x.attributes.uv&&(N||ue),fog:!!v,useFog:!0===a.fog,fogExp2:v&&v.isFogExp2,flatShading:!0===a.flatShading,sizeAttenuation:!0===a.sizeAttenuation,logarithmicDepthBuffer:u,skinning:!0===_.isSkinnedMesh,morphTargets:void 0!==x.morphAttributes.position,morphNormals:void 0!==x.morphAttributes.normal,morphColors:void 0!==x.morphAttributes.color,morphTargetsCount:b,morphTextureStride:P,numDirLights:o.directional.length,numPointLights:o.point.length,numSpotLights:o.spot.length,numSpotLightMaps:o.spotLightMap.length,numRectAreaLights:o.rectArea.length,numHemiLights:o.hemi.length,numDirLightShadows:o.directionalShadowMap.length,numPointLightShadows:o.pointShadowMap.length,numSpotLightShadows:o.spotShadowMap.length,numSpotLightShadowsWithMaps:o.numSpotLightShadowsWithMaps,numLightProbes:o.numLightProbes,numClippingPlanes:s.numPlanes,numClipIntersection:s.numIntersection,dithering:a.dithering,shadowMapEnabled:e.shadowMap.enabled&&c.length>0,shadowMapType:e.shadowMap.type,toneMapping:Me,useLegacyLights:e._useLegacyLights,decodeVideoTexture:N&&!0===a.map.isVideoTexture&&tt.getTransfer(a.map.colorSpace)===ge,premultipliedAlpha:a.premultipliedAlpha,doubleSided:2===a.side,flipSided:1===a.side,useDepthPacking:a.depthPacking>=0,depthPacking:a.depthPacking||0,index0AttributeName:a.index0AttributeName,extensionDerivatives:me&&!0===a.extensions.derivatives,extensionFragDepth:me&&!0===a.extensions.fragDepth,extensionDrawBuffers:me&&!0===a.extensions.drawBuffers,extensionShaderTextureLOD:me&&!0===a.extensions.shaderTextureLOD,rendererExtensionFragDepth:h||i.has("EXT_frag_depth"),rendererExtensionDrawBuffers:h||i.has("WEBGL_draw_buffers"),rendererExtensionShaderTextureLod:h||i.has("EXT_shader_texture_lod"),rendererExtensionParallelShaderCompile:i.has("KHR_parallel_shader_compile"),customProgramCacheKey:a.customProgramCacheKey()}},getProgramCacheKey:function(t){const n=[];if(t.shaderID?n.push(t.shaderID):(n.push(t.customVertexShaderID),n.push(t.customFragmentShaderID)),void 0!==t.defines)for(const e in t.defines)n.push(e),n.push(t.defines[e]);return!1===t.isRawShaderMaterial&&(function(e,t){e.push(t.precision),e.push(t.outputColorSpace),e.push(t.envMapMode),e.push(t.envMapCubeUVHeight),e.push(t.mapUv),e.push(t.alphaMapUv),e.push(t.lightMapUv),e.push(t.aoMapUv),e.push(t.bumpMapUv),e.push(t.normalMapUv),e.push(t.displacementMapUv),e.push(t.emissiveMapUv),e.push(t.metalnessMapUv),e.push(t.roughnessMapUv),e.push(t.anisotropyMapUv),e.push(t.clearcoatMapUv),e.push(t.clearcoatNormalMapUv),e.push(t.clearcoatRoughnessMapUv),e.push(t.iridescenceMapUv),e.push(t.iridescenceThicknessMapUv),e.push(t.sheenColorMapUv),e.push(t.sheenRoughnessMapUv),e.push(t.specularMapUv),e.push(t.specularColorMapUv),e.push(t.specularIntensityMapUv),e.push(t.transmissionMapUv),e.push(t.thicknessMapUv),e.push(t.combine),e.push(t.fogExp2),e.push(t.sizeAttenuation),e.push(t.morphTargetsCount),e.push(t.morphAttributeCount),e.push(t.numDirLights),e.push(t.numPointLights),e.push(t.numSpotLights),e.push(t.numSpotLightMaps),e.push(t.numHemiLights),e.push(t.numRectAreaLights),e.push(t.numDirLightShadows),e.push(t.numPointLightShadows),e.push(t.numSpotLightShadows),e.push(t.numSpotLightShadowsWithMaps),e.push(t.numLightProbes),e.push(t.shadowMapType),e.push(t.toneMapping),e.push(t.numClippingPlanes),e.push(t.numClipIntersection),e.push(t.depthPacking)}(n,t),function(e,t){o.disableAll(),t.isWebGL2&&o.enable(0),t.supportsVertexTextures&&o.enable(1),t.instancing&&o.enable(2),t.instancingColor&&o.enable(3),t.matcap&&o.enable(4),t.envMap&&o.enable(5),t.normalMapObjectSpace&&o.enable(6),t.normalMapTangentSpace&&o.enable(7),t.clearcoat&&o.enable(8),t.iridescence&&o.enable(9),t.alphaTest&&o.enable(10),t.vertexColors&&o.enable(11),t.vertexAlphas&&o.enable(12),t.vertexUv1s&&o.enable(13),t.vertexUv2s&&o.enable(14),t.vertexUv3s&&o.enable(15),t.vertexTangents&&o.enable(16),t.anisotropy&&o.enable(17),t.alphaHash&&o.enable(18),e.push(o.mask),o.disableAll(),t.fog&&o.enable(0),t.useFog&&o.enable(1),t.flatShading&&o.enable(2),t.logarithmicDepthBuffer&&o.enable(3),t.skinning&&o.enable(4),t.morphTargets&&o.enable(5),t.morphNormals&&o.enable(6),t.morphColors&&o.enable(7),t.premultipliedAlpha&&o.enable(8),t.shadowMapEnabled&&o.enable(9),t.useLegacyLights&&o.enable(10),t.doubleSided&&o.enable(11),t.flipSided&&o.enable(12),t.useDepthPacking&&o.enable(13),t.dithering&&o.enable(14),t.transmission&&o.enable(15),t.sheen&&o.enable(16),t.opaque&&o.enable(17),t.pointsUvs&&o.enable(18),t.decodeVideoTexture&&o.enable(19),e.push(o.mask)}(n,t),n.push(e.outputColorSpace)),n.push(t.customProgramCacheKey),n.join()},getUniforms:function(e){const t=f[e.type];let n;if(t){const e=qi[t];n=Ai.clone(e.uniforms)}else n=e.uniforms;return n},acquireProgram:function(t,n){let i;for(let e=0,t=c.length;e<t;e++){const t=c[e];if(t.cacheKey===n){i=t,++i.usedTimes;break}}return void 0===i&&(i=new qa(e,n,t,a),c.push(i)),i},releaseProgram:function(e){if(0==--e.usedTimes){const t=c.indexOf(e);c[t]=c[c.length-1],c.pop(),e.destroy()}},releaseShaderCache:function(e){l.remove(e)},programs:c,dispose:function(){l.dispose()}}}function Qa(){let e=new WeakMap;return{get:function(t){let n=e.get(t);return void 0===n&&(n={},e.set(t,n)),n},remove:function(t){e.delete(t)},update:function(t,n,i){e.get(t)[n]=i},dispose:function(){e=new WeakMap}}}function $a(e,t){return e.groupOrder!==t.groupOrder?e.groupOrder-t.groupOrder:e.renderOrder!==t.renderOrder?e.renderOrder-t.renderOrder:e.material.id!==t.material.id?e.material.id-t.material.id:e.z!==t.z?e.z-t.z:e.id-t.id}function es(e,t){return e.groupOrder!==t.groupOrder?e.groupOrder-t.groupOrder:e.renderOrder!==t.renderOrder?e.renderOrder-t.renderOrder:e.z!==t.z?t.z-e.z:e.id-t.id}function ts(){const e=[];let t=0;const n=[],i=[],r=[];function a(n,i,r,a,s,o){let l=e[t];return void 0===l?(l={id:n.id,object:n,geometry:i,material:r,groupOrder:a,renderOrder:n.renderOrder,z:s,group:o},e[t]=l):(l.id=n.id,l.object=n,l.geometry=i,l.material=r,l.groupOrder=a,l.renderOrder=n.renderOrder,l.z=s,l.group=o),t++,l}return{opaque:n,transmissive:i,transparent:r,init:function(){t=0,n.length=0,i.length=0,r.length=0},push:function(e,t,s,o,l,c){const h=a(e,t,s,o,l,c);s.transmission>0?i.push(h):!0===s.transparent?r.push(h):n.push(h)},unshift:function(e,t,s,o,l,c){const h=a(e,t,s,o,l,c);s.transmission>0?i.unshift(h):!0===s.transparent?r.unshift(h):n.unshift(h)},finish:function(){for(let n=t,i=e.length;n<i;n++){const t=e[n];if(null===t.id)break;t.id=null,t.object=null,t.geometry=null,t.material=null,t.group=null}},sort:function(e,t){n.length>1&&n.sort(e||$a),i.length>1&&i.sort(t||es),r.length>1&&r.sort(t||es)}}}function ns(){let e=new WeakMap;return{get:function(t,n){const i=e.get(t);let r;return void 0===i?(r=new ts,e.set(t,[r])):n>=i.length?(r=new ts,i.push(r)):r=i[n],r},dispose:function(){e=new WeakMap}}}function is(){const e={};return{get:function(t){if(void 0!==e[t.id])return e[t.id];let n;switch(t.type){case"DirectionalLight":n={direction:new _t,color:new On};break;case"SpotLight":n={position:new _t,direction:new _t,color:new On,distance:0,coneCos:0,penumbraCos:0,decay:0};break;case"PointLight":n={position:new _t,color:new On,distance:0,decay:0};break;case"HemisphereLight":n={direction:new _t,skyColor:new On,groundColor:new On};break;case"RectAreaLight":n={color:new On,position:new _t,halfWidth:new _t,halfHeight:new _t}}return e[t.id]=n,n}}}let rs=0;function as(e,t){return(t.castShadow?2:0)-(e.castShadow?2:0)+(t.map?1:0)-(e.map?1:0)}function ss(e,t){const n=new is,i=function(){const e={};return{get:function(t){if(void 0!==e[t.id])return e[t.id];let n;switch(t.type){case"DirectionalLight":case"SpotLight":n={shadowBias:0,shadowNormalBias:0,shadowRadius:1,shadowMapSize:new ke};break;case"PointLight":n={shadowBias:0,shadowNormalBias:0,shadowRadius:1,shadowMapSize:new ke,shadowCameraNear:1,shadowCameraFar:1e3}}return e[t.id]=n,n}}}(),r={version:0,hash:{directionalLength:-1,pointLength:-1,spotLength:-1,rectAreaLength:-1,hemiLength:-1,numDirectionalShadows:-1,numPointShadows:-1,numSpotShadows:-1,numSpotMaps:-1,numLightProbes:-1},ambient:[0,0,0],probe:[],directional:[],directionalShadow:[],directionalShadowMap:[],directionalShadowMatrix:[],spot:[],spotLightMap:[],spotShadow:[],spotShadowMap:[],spotLightMatrix:[],rectArea:[],rectAreaLTC1:null,rectAreaLTC2:null,point:[],pointShadow:[],pointShadowMap:[],pointShadowMatrix:[],hemi:[],numSpotLightShadowsWithMaps:0,numLightProbes:0};for(let e=0;e<9;e++)r.probe.push(new _t);const a=new _t,s=new qt,o=new qt;return{setup:function(a,s){let o=0,l=0,c=0;for(let e=0;e<9;e++)r.probe[e].set(0,0,0);let h=0,u=0,d=0,p=0,f=0,m=0,g=0,_=0,v=0,x=0,M=0;a.sort(as);const S=!0===s?Math.PI:1;for(let e=0,t=a.length;e<t;e++){const t=a[e],s=t.color,y=t.intensity,E=t.distance,T=t.shadow&&t.shadow.map?t.shadow.map.texture:null;if(t.isAmbientLight)o+=s.r*y*S,l+=s.g*y*S,c+=s.b*y*S;else if(t.isLightProbe){for(let e=0;e<9;e++)r.probe[e].addScaledVector(t.sh.coefficients[e],y);M++}else if(t.isDirectionalLight){const e=n.get(t);if(e.color.copy(t.color).multiplyScalar(t.intensity*S),t.castShadow){const e=t.shadow,n=i.get(t);n.shadowBias=e.bias,n.shadowNormalBias=e.normalBias,n.shadowRadius=e.radius,n.shadowMapSize=e.mapSize,r.directionalShadow[h]=n,r.directionalShadowMap[h]=T,r.directionalShadowMatrix[h]=t.shadow.matrix,m++}r.directional[h]=e,h++}else if(t.isSpotLight){const e=n.get(t);e.position.setFromMatrixPosition(t.matrixWorld),e.color.copy(s).multiplyScalar(y*S),e.distance=E,e.coneCos=Math.cos(t.angle),e.penumbraCos=Math.cos(t.angle*(1-t.penumbra)),e.decay=t.decay,r.spot[d]=e;const a=t.shadow;if(t.map&&(r.spotLightMap[v]=t.map,v++,a.updateMatrices(t),t.castShadow&&x++),r.spotLightMatrix[d]=a.matrix,t.castShadow){const e=i.get(t);e.shadowBias=a.bias,e.shadowNormalBias=a.normalBias,e.shadowRadius=a.radius,e.shadowMapSize=a.mapSize,r.spotShadow[d]=e,r.spotShadowMap[d]=T,_++}d++}else if(t.isRectAreaLight){const e=n.get(t);e.color.copy(s).multiplyScalar(y),e.halfWidth.set(.5*t.width,0,0),e.halfHeight.set(0,.5*t.height,0),r.rectArea[p]=e,p++}else if(t.isPointLight){const e=n.get(t);if(e.color.copy(t.color).multiplyScalar(t.intensity*S),e.distance=t.distance,e.decay=t.decay,t.castShadow){const e=t.shadow,n=i.get(t);n.shadowBias=e.bias,n.shadowNormalBias=e.normalBias,n.shadowRadius=e.radius,n.shadowMapSize=e.mapSize,n.shadowCameraNear=e.camera.near,n.shadowCameraFar=e.camera.far,r.pointShadow[u]=n,r.pointShadowMap[u]=T,r.pointShadowMatrix[u]=t.shadow.matrix,g++}r.point[u]=e,u++}else if(t.isHemisphereLight){const e=n.get(t);e.skyColor.copy(t.color).multiplyScalar(y*S),e.groundColor.copy(t.groundColor).multiplyScalar(y*S),r.hemi[f]=e,f++}}p>0&&(t.isWebGL2||!0===e.has("OES_texture_float_linear")?(r.rectAreaLTC1=ji.LTC_FLOAT_1,r.rectAreaLTC2=ji.LTC_FLOAT_2):!0===e.has("OES_texture_half_float_linear")?(r.rectAreaLTC1=ji.LTC_HALF_1,r.rectAreaLTC2=ji.LTC_HALF_2):console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")),r.ambient[0]=o,r.ambient[1]=l,r.ambient[2]=c;const y=r.hash;y.directionalLength===h&&y.pointLength===u&&y.spotLength===d&&y.rectAreaLength===p&&y.hemiLength===f&&y.numDirectionalShadows===m&&y.numPointShadows===g&&y.numSpotShadows===_&&y.numSpotMaps===v&&y.numLightProbes===M||(r.directional.length=h,r.spot.length=d,r.rectArea.length=p,r.point.length=u,r.hemi.length=f,r.directionalShadow.length=m,r.directionalShadowMap.length=m,r.pointShadow.length=g,r.pointShadowMap.length=g,r.spotShadow.length=_,r.spotShadowMap.length=_,r.directionalShadowMatrix.length=m,r.pointShadowMatrix.length=g,r.spotLightMatrix.length=_+v-x,r.spotLightMap.length=v,r.numSpotLightShadowsWithMaps=x,r.numLightProbes=M,y.directionalLength=h,y.pointLength=u,y.spotLength=d,y.rectAreaLength=p,y.hemiLength=f,y.numDirectionalShadows=m,y.numPointShadows=g,y.numSpotShadows=_,y.numSpotMaps=v,y.numLightProbes=M,r.version=rs++)},setupView:function(e,t){let n=0,i=0,l=0,c=0,h=0;const u=t.matrixWorldInverse;for(let t=0,d=e.length;t<d;t++){const d=e[t];if(d.isDirectionalLight){const e=r.directional[n];e.direction.setFromMatrixPosition(d.matrixWorld),a.setFromMatrixPosition(d.target.matrixWorld),e.direction.sub(a),e.direction.transformDirection(u),n++}else if(d.isSpotLight){const e=r.spot[l];e.position.setFromMatrixPosition(d.matrixWorld),e.position.applyMatrix4(u),e.direction.setFromMatrixPosition(d.matrixWorld),a.setFromMatrixPosition(d.target.matrixWorld),e.direction.sub(a),e.direction.transformDirection(u),l++}else if(d.isRectAreaLight){const e=r.rectArea[c];e.position.setFromMatrixPosition(d.matrixWorld),e.position.applyMatrix4(u),o.identity(),s.copy(d.matrixWorld),s.premultiply(u),o.extractRotation(s),e.halfWidth.set(.5*d.width,0,0),e.halfHeight.set(0,.5*d.height,0),e.halfWidth.applyMatrix4(o),e.halfHeight.applyMatrix4(o),c++}else if(d.isPointLight){const e=r.point[i];e.position.setFromMatrixPosition(d.matrixWorld),e.position.applyMatrix4(u),i++}else if(d.isHemisphereLight){const e=r.hemi[h];e.direction.setFromMatrixPosition(d.matrixWorld),e.direction.transformDirection(u),h++}}},state:r}}function os(e,t){const n=new ss(e,t),i=[],r=[];return{init:function(){i.length=0,r.length=0},state:{lightsArray:i,shadowsArray:r,lights:n},setupLights:function(e){n.setup(i,e)},setupLightsView:function(e){n.setupView(i,e)},pushLight:function(e){i.push(e)},pushShadow:function(e){r.push(e)}}}function ls(e,t){let n=new WeakMap;return{get:function(i){let r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0;const a=n.get(i);let s;return void 0===a?(s=new os(e,t),n.set(i,[s])):r>=a.length?(s=new os(e,t),a.push(s)):s=a[r],s},dispose:function(){n=new WeakMap}}}class cs extends Bn{constructor(e){super(),this.isMeshDepthMaterial=!0,this.type="MeshDepthMaterial",this.depthPacking=3200,this.map=null,this.alphaMap=null,this.displacementMap=null,this.displacementScale=1,this.displacementBias=0,this.wireframe=!1,this.wireframeLinewidth=1,this.setValues(e)}copy(e){return super.copy(e),this.depthPacking=e.depthPacking,this.map=e.map,this.alphaMap=e.alphaMap,this.displacementMap=e.displacementMap,this.displacementScale=e.displacementScale,this.displacementBias=e.displacementBias,this.wireframe=e.wireframe,this.wireframeLinewidth=e.wireframeLinewidth,this}}class hs extends Bn{constructor(e){super(),this.isMeshDistanceMaterial=!0,this.type="MeshDistanceMaterial",this.map=null,this.alphaMap=null,this.displacementMap=null,this.displacementScale=1,this.displacementBias=0,this.setValues(e)}copy(e){return super.copy(e),this.map=e.map,this.alphaMap=e.alphaMap,this.displacementMap=e.displacementMap,this.displacementScale=e.displacementScale,this.displacementBias=e.displacementBias,this}}function us(e,n,o){let l=new Vi;const c=new ke,h=new ke,u=new ut,d=new cs({depthPacking:3201}),p=new hs,f={},m=o.maxTextureSize,g={[r]:1,[a]:0,[s]:2},_=new Ri({defines:{VSM_SAMPLES:8},uniforms:{shadow_pass:{value:null},resolution:{value:new ke},radius:{value:4}},vertexShader:"void main() {\\n\\tgl_Position = vec4( position, 1.0 );\\n}",fragmentShader:"uniform sampler2D shadow_pass;\\nuniform vec2 resolution;\\nuniform float radius;\\n#include <packing>\\nvoid main() {\\n\\tconst float samples = float( VSM_SAMPLES );\\n\\tfloat mean = 0.0;\\n\\tfloat squared_mean = 0.0;\\n\\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\\n\\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\\n\\tfor ( float i = 0.0; i < samples; i ++ ) {\\n\\t\\tfloat uvOffset = uvStart + i * uvStride;\\n\\t\\t#ifdef HORIZONTAL_PASS\\n\\t\\t\\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\\n\\t\\t\\tmean += distribution.x;\\n\\t\\t\\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\\n\\t\\t#else\\n\\t\\t\\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\\n\\t\\t\\tmean += depth;\\n\\t\\t\\tsquared_mean += depth * depth;\\n\\t\\t#endif\\n\\t}\\n\\tmean = mean / samples;\\n\\tsquared_mean = squared_mean / samples;\\n\\tfloat std_dev = sqrt( squared_mean - mean * mean );\\n\\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\\n}"}),v=_.clone();v.defines.HORIZONTAL_PASS=1;const x=new ii;x.setAttribute("position",new jn(new Float32Array([-1,-1,.5,3,-1,.5,-1,3,.5]),3));const M=new Si(x,_),S=this;this.enabled=!1,this.autoUpdate=!0,this.needsUpdate=!1,this.type=t;let y=this.type;function E(t,i){const r=n.update(M);_.defines.VSM_SAMPLES!==t.blurSamples&&(_.defines.VSM_SAMPLES=t.blurSamples,v.defines.VSM_SAMPLES=t.blurSamples,_.needsUpdate=!0,v.needsUpdate=!0),null===t.mapPass&&(t.mapPass=new pt(c.x,c.y)),_.uniforms.shadow_pass.value=t.map.texture,_.uniforms.resolution.value=t.mapSize,_.uniforms.radius.value=t.radius,e.setRenderTarget(t.mapPass),e.clear(),e.renderBufferDirect(i,null,r,_,M,null),v.uniforms.shadow_pass.value=t.mapPass.texture,v.uniforms.resolution.value=t.mapSize,v.uniforms.radius.value=t.radius,e.setRenderTarget(t.map),e.clear(),e.renderBufferDirect(i,null,r,v,M,null)}function T(t,n,r,a){let s=null;const o=!0===r.isPointLight?t.customDistanceMaterial:t.customDepthMaterial;if(void 0!==o)s=o;else if(s=!0===r.isPointLight?p:d,e.localClippingEnabled&&!0===n.clipShadows&&Array.isArray(n.clippingPlanes)&&0!==n.clippingPlanes.length||n.displacementMap&&0!==n.displacementScale||n.alphaMap&&n.alphaTest>0||n.map&&n.alphaTest>0){const e=s.uuid,t=n.uuid;let i=f[e];void 0===i&&(i={},f[e]=i);let r=i[t];void 0===r&&(r=s.clone(),i[t]=r),s=r}return s.visible=n.visible,s.wireframe=n.wireframe,s.side=a===i?null!==n.shadowSide?n.shadowSide:n.side:null!==n.shadowSide?n.shadowSide:g[n.side],s.alphaMap=n.alphaMap,s.alphaTest=n.alphaTest,s.map=n.map,s.clipShadows=n.clipShadows,s.clippingPlanes=n.clippingPlanes,s.clipIntersection=n.clipIntersection,s.displacementMap=n.displacementMap,s.displacementScale=n.displacementScale,s.displacementBias=n.displacementBias,s.wireframeLinewidth=n.wireframeLinewidth,s.linewidth=n.linewidth,!0===r.isPointLight&&!0===s.isMeshDistanceMaterial&&(e.properties.get(s).light=r),s}function b(t,r,a,s,o){if(!1===t.visible)return;if(t.layers.test(r.layers)&&(t.isMesh||t.isLine||t.isPoints)&&(t.castShadow||t.receiveShadow&&o===i)&&(!t.frustumCulled||l.intersectsObject(t))){t.modelViewMatrix.multiplyMatrices(a.matrixWorldInverse,t.matrixWorld);const i=n.update(t),r=t.material;if(Array.isArray(r)){const n=i.groups;for(let l=0,c=n.length;l<c;l++){const c=n[l],h=r[c.materialIndex];if(h&&h.visible){const n=T(t,h,s,o);e.renderBufferDirect(a,null,i,n,t,c)}}}else if(r.visible){const n=T(t,r,s,o);e.renderBufferDirect(a,null,i,n,t,null)}}const c=t.children;for(let e=0,t=c.length;e<t;e++)b(c[e],r,a,s,o)}this.render=function(t,n,r){if(!1===S.enabled)return;if(!1===S.autoUpdate&&!1===S.needsUpdate)return;if(0===t.length)return;const a=e.getRenderTarget(),s=e.getActiveCubeFace(),o=e.getActiveMipmapLevel(),d=e.state;d.setBlending(0),d.buffers.color.setClear(1,1,1,1),d.buffers.depth.setTest(!0),d.setScissorTest(!1);const p=y!==i&&this.type===i,f=y===i&&this.type!==i;for(let a=0,s=t.length;a<s;a++){const s=t[a],o=s.shadow;if(void 0===o){console.warn("THREE.WebGLShadowMap:",s,"has no shadow.");continue}if(!1===o.autoUpdate&&!1===o.needsUpdate)continue;c.copy(o.mapSize);const g=o.getFrameExtents();if(c.multiply(g),h.copy(o.mapSize),(c.x>m||c.y>m)&&(c.x>m&&(h.x=Math.floor(m/g.x),c.x=h.x*g.x,o.mapSize.x=h.x),c.y>m&&(h.y=Math.floor(m/g.y),c.y=h.y*g.y,o.mapSize.y=h.y)),null===o.map||!0===p||!0===f){const e=this.type!==i?{minFilter:H,magFilter:H}:{};null!==o.map&&o.map.dispose(),o.map=new pt(c.x,c.y,e),o.map.texture.name=s.name+".shadowMap",o.camera.updateProjectionMatrix()}e.setRenderTarget(o.map),e.clear();const _=o.getViewportCount();for(let e=0;e<_;e++){const t=o.getViewport(e);u.set(h.x*t.x,h.y*t.y,h.x*t.z,h.y*t.w),d.viewport(u),o.updateMatrices(s,e),l=o.getFrustum(),b(n,r,o.camera,s,this.type)}!0!==o.isPointLightShadow&&this.type===i&&E(o,r),o.needsUpdate=!1}y=this.type,S.needsUpdate=!1,e.setRenderTarget(a,s,o)}}function ds(e,t,n){const i=n.isWebGL2,r=new function(){let t=!1;const n=new ut;let i=null;const r=new ut(0,0,0,0);return{setMask:function(n){i===n||t||(e.colorMask(n,n,n,n),i=n)},setLocked:function(e){t=e},setClear:function(t,i,a,s,o){!0===o&&(t*=s,i*=s,a*=s),n.set(t,i,a,s),!1===r.equals(n)&&(e.clearColor(t,i,a,s),r.copy(n))},reset:function(){t=!1,i=null,r.set(-1,0,0,0)}}},a=new function(){let t=!1,n=null,i=null,r=null;return{setTest:function(t){t?se(e.DEPTH_TEST):oe(e.DEPTH_TEST)},setMask:function(i){n===i||t||(e.depthMask(i),n=i)},setFunc:function(t){if(i!==t){switch(t){case 0:e.depthFunc(e.NEVER);break;case 1:e.depthFunc(e.ALWAYS);break;case 2:e.depthFunc(e.LESS);break;case 3:default:e.depthFunc(e.LEQUAL);break;case 4:e.depthFunc(e.EQUAL);break;case 5:e.depthFunc(e.GEQUAL);break;case 6:e.depthFunc(e.GREATER);break;case 7:e.depthFunc(e.NOTEQUAL)}i=t}},setLocked:function(e){t=e},setClear:function(t){r!==t&&(e.clearDepth(t),r=t)},reset:function(){t=!1,n=null,i=null,r=null}}},s=new function(){let t=!1,n=null,i=null,r=null,a=null,s=null,o=null,l=null,c=null;return{setTest:function(n){t||(n?se(e.STENCIL_TEST):oe(e.STENCIL_TEST))},setMask:function(i){n===i||t||(e.stencilMask(i),n=i)},setFunc:function(t,n,s){i===t&&r===n&&a===s||(e.stencilFunc(t,n,s),i=t,r=n,a=s)},setOp:function(t,n,i){s===t&&o===n&&l===i||(e.stencilOp(t,n,i),s=t,o=n,l=i)},setLocked:function(e){t=e},setClear:function(t){c!==t&&(e.clearStencil(t),c=t)},reset:function(){t=!1,n=null,i=null,r=null,a=null,s=null,o=null,l=null,c=null}}},b=new WeakMap,w=new WeakMap;let A={},R={},C=new WeakMap,L=[],P=null,U=!1,D=null,N=null,I=null,O=null,F=null,z=null,B=null,H=new On(0,0,0),V=0,G=!1,k=null,W=null,X=null,j=null,q=null;const Y=e.getParameter(e.MAX_COMBINED_TEXTURE_IMAGE_UNITS);let K=!1,Z=0;const J=e.getParameter(e.VERSION);-1!==J.indexOf("WebGL")?(Z=parseFloat(/^WebGL (\\d)/.exec(J)[1]),K=Z>=1):-1!==J.indexOf("OpenGL ES")&&(Z=parseFloat(/^OpenGL ES (\\d)/.exec(J)[1]),K=Z>=2);let Q=null,$={};const ee=e.getParameter(e.SCISSOR_BOX),te=e.getParameter(e.VIEWPORT),ne=(new ut).fromArray(ee),ie=(new ut).fromArray(te);function re(t,n,r,a){const s=new Uint8Array(4),o=e.createTexture();e.bindTexture(t,o),e.texParameteri(t,e.TEXTURE_MIN_FILTER,e.NEAREST),e.texParameteri(t,e.TEXTURE_MAG_FILTER,e.NEAREST);for(let o=0;o<r;o++)!i||t!==e.TEXTURE_3D&&t!==e.TEXTURE_2D_ARRAY?e.texImage2D(n+o,0,e.RGBA,1,1,0,e.RGBA,e.UNSIGNED_BYTE,s):e.texImage3D(n,0,e.RGBA,1,1,a,0,e.RGBA,e.UNSIGNED_BYTE,s);return o}const ae={};function se(t){!0!==A[t]&&(e.enable(t),A[t]=!0)}function oe(t){!1!==A[t]&&(e.disable(t),A[t]=!1)}ae[e.TEXTURE_2D]=re(e.TEXTURE_2D,e.TEXTURE_2D,1),ae[e.TEXTURE_CUBE_MAP]=re(e.TEXTURE_CUBE_MAP,e.TEXTURE_CUBE_MAP_POSITIVE_X,6),i&&(ae[e.TEXTURE_2D_ARRAY]=re(e.TEXTURE_2D_ARRAY,e.TEXTURE_2D_ARRAY,1,1),ae[e.TEXTURE_3D]=re(e.TEXTURE_3D,e.TEXTURE_3D,1,1)),r.setClear(0,0,0,1),a.setClear(1),s.setClear(0),se(e.DEPTH_TEST),a.setFunc(3),ue(!1),de(1),se(e.CULL_FACE),he(0);const le={[o]:e.FUNC_ADD,[l]:e.FUNC_SUBTRACT,[c]:e.FUNC_REVERSE_SUBTRACT};if(i)le[103]=e.MIN,le[104]=e.MAX;else{const e=t.get("EXT_blend_minmax");null!==e&&(le[103]=e.MIN_EXT,le[104]=e.MAX_EXT)}const ce={[h]:e.ZERO,[u]:e.ONE,[d]:e.SRC_COLOR,[f]:e.SRC_ALPHA,[M]:e.SRC_ALPHA_SATURATE,[v]:e.DST_COLOR,[g]:e.DST_ALPHA,[p]:e.ONE_MINUS_SRC_COLOR,[m]:e.ONE_MINUS_SRC_ALPHA,[x]:e.ONE_MINUS_DST_COLOR,[_]:e.ONE_MINUS_DST_ALPHA,[S]:e.CONSTANT_COLOR,[y]:e.ONE_MINUS_CONSTANT_COLOR,[E]:e.CONSTANT_ALPHA,[T]:e.ONE_MINUS_CONSTANT_ALPHA};function he(t,n,i,r,a,s,l,c,h,u){if(0!==t){if(!1===U&&(se(e.BLEND),U=!0),5===t)a=a||n,s=s||i,l=l||r,n===N&&a===F||(e.blendEquationSeparate(le[n],le[a]),N=n,F=a),i===I&&r===O&&s===z&&l===B||(e.blendFuncSeparate(ce[i],ce[r],ce[s],ce[l]),I=i,O=r,z=s,B=l),!1!==c.equals(H)&&h===V||(e.blendColor(c.r,c.g,c.b,h),H.copy(c),V=h),D=t,G=!1;else if(t!==D||u!==G){if(N===o&&F===o||(e.blendEquation(e.FUNC_ADD),N=o,F=o),u)switch(t){case 1:e.blendFuncSeparate(e.ONE,e.ONE_MINUS_SRC_ALPHA,e.ONE,e.ONE_MINUS_SRC_ALPHA);break;case 2:e.blendFunc(e.ONE,e.ONE);break;case 3:e.blendFuncSeparate(e.ZERO,e.ONE_MINUS_SRC_COLOR,e.ZERO,e.ONE);break;case 4:e.blendFuncSeparate(e.ZERO,e.SRC_COLOR,e.ZERO,e.SRC_ALPHA);break;default:console.error("THREE.WebGLState: Invalid blending: ",t)}else switch(t){case 1:e.blendFuncSeparate(e.SRC_ALPHA,e.ONE_MINUS_SRC_ALPHA,e.ONE,e.ONE_MINUS_SRC_ALPHA);break;case 2:e.blendFunc(e.SRC_ALPHA,e.ONE);break;case 3:e.blendFuncSeparate(e.ZERO,e.ONE_MINUS_SRC_COLOR,e.ZERO,e.ONE);break;case 4:e.blendFunc(e.ZERO,e.SRC_COLOR);break;default:console.error("THREE.WebGLState: Invalid blending: ",t)}I=null,O=null,z=null,B=null,H.set(0,0,0),V=0,D=t,G=u}}else!0===U&&(oe(e.BLEND),U=!1)}function ue(t){k!==t&&(t?e.frontFace(e.CW):e.frontFace(e.CCW),k=t)}function de(t){0!==t?(se(e.CULL_FACE),t!==W&&(1===t?e.cullFace(e.BACK):2===t?e.cullFace(e.FRONT):e.cullFace(e.FRONT_AND_BACK))):oe(e.CULL_FACE),W=t}function pe(t,n,i){t?(se(e.POLYGON_OFFSET_FILL),j===n&&q===i||(e.polygonOffset(n,i),j=n,q=i)):oe(e.POLYGON_OFFSET_FILL)}return{buffers:{color:r,depth:a,stencil:s},enable:se,disable:oe,bindFramebuffer:function(t,n){return R[t]!==n&&(e.bindFramebuffer(t,n),R[t]=n,i&&(t===e.DRAW_FRAMEBUFFER&&(R[e.FRAMEBUFFER]=n),t===e.FRAMEBUFFER&&(R[e.DRAW_FRAMEBUFFER]=n)),!0)},drawBuffers:function(i,r){let a=L,s=!1;if(i)if(a=C.get(r),void 0===a&&(a=[],C.set(r,a)),i.isWebGLMultipleRenderTargets){const t=i.texture;if(a.length!==t.length||a[0]!==e.COLOR_ATTACHMENT0){for(let n=0,i=t.length;n<i;n++)a[n]=e.COLOR_ATTACHMENT0+n;a.length=t.length,s=!0}}else a[0]!==e.COLOR_ATTACHMENT0&&(a[0]=e.COLOR_ATTACHMENT0,s=!0);else a[0]!==e.BACK&&(a[0]=e.BACK,s=!0);s&&(n.isWebGL2?e.drawBuffers(a):t.get("WEBGL_draw_buffers").drawBuffersWEBGL(a))},useProgram:function(t){return P!==t&&(e.useProgram(t),P=t,!0)},setBlending:he,setMaterial:function(t,n){2===t.side?oe(e.CULL_FACE):se(e.CULL_FACE);let i=1===t.side;n&&(i=!i),ue(i),1===t.blending&&!1===t.transparent?he(0):he(t.blending,t.blendEquation,t.blendSrc,t.blendDst,t.blendEquationAlpha,t.blendSrcAlpha,t.blendDstAlpha,t.blendColor,t.blendAlpha,t.premultipliedAlpha),a.setFunc(t.depthFunc),a.setTest(t.depthTest),a.setMask(t.depthWrite),r.setMask(t.colorWrite);const o=t.stencilWrite;s.setTest(o),o&&(s.setMask(t.stencilWriteMask),s.setFunc(t.stencilFunc,t.stencilRef,t.stencilFuncMask),s.setOp(t.stencilFail,t.stencilZFail,t.stencilZPass)),pe(t.polygonOffset,t.polygonOffsetFactor,t.polygonOffsetUnits),!0===t.alphaToCoverage?se(e.SAMPLE_ALPHA_TO_COVERAGE):oe(e.SAMPLE_ALPHA_TO_COVERAGE)},setFlipSided:ue,setCullFace:de,setLineWidth:function(t){t!==X&&(K&&e.lineWidth(t),X=t)},setPolygonOffset:pe,setScissorTest:function(t){t?se(e.SCISSOR_TEST):oe(e.SCISSOR_TEST)},activeTexture:function(t){void 0===t&&(t=e.TEXTURE0+Y-1),Q!==t&&(e.activeTexture(t),Q=t)},bindTexture:function(t,n,i){void 0===i&&(i=null===Q?e.TEXTURE0+Y-1:Q);let r=$[i];void 0===r&&(r={type:void 0,texture:void 0},$[i]=r),r.type===t&&r.texture===n||(Q!==i&&(e.activeTexture(i),Q=i),e.bindTexture(t,n||ae[t]),r.type=t,r.texture=n)},unbindTexture:function(){const t=$[Q];void 0!==t&&void 0!==t.type&&(e.bindTexture(t.type,null),t.type=void 0,t.texture=void 0)},compressedTexImage2D:function(){try{e.compressedTexImage2D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},compressedTexImage3D:function(){try{e.compressedTexImage3D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},texImage2D:function(){try{e.texImage2D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},texImage3D:function(){try{e.texImage3D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},updateUBOMapping:function(t,n){let i=w.get(n);void 0===i&&(i=new WeakMap,w.set(n,i));let r=i.get(t);void 0===r&&(r=e.getUniformBlockIndex(n,t.name),i.set(t,r))},uniformBlockBinding:function(t,n){const i=w.get(n).get(t);b.get(n)!==i&&(e.uniformBlockBinding(n,i,t.__bindingPointIndex),b.set(n,i))},texStorage2D:function(){try{e.texStorage2D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},texStorage3D:function(){try{e.texStorage3D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},texSubImage2D:function(){try{e.texSubImage2D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},texSubImage3D:function(){try{e.texSubImage3D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},compressedTexSubImage2D:function(){try{e.compressedTexSubImage2D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},compressedTexSubImage3D:function(){try{e.compressedTexSubImage3D.apply(e,arguments)}catch(e){console.error("THREE.WebGLState:",e)}},scissor:function(t){!1===ne.equals(t)&&(e.scissor(t.x,t.y,t.z,t.w),ne.copy(t))},viewport:function(t){!1===ie.equals(t)&&(e.viewport(t.x,t.y,t.z,t.w),ie.copy(t))},reset:function(){e.disable(e.BLEND),e.disable(e.CULL_FACE),e.disable(e.DEPTH_TEST),e.disable(e.POLYGON_OFFSET_FILL),e.disable(e.SCISSOR_TEST),e.disable(e.STENCIL_TEST),e.disable(e.SAMPLE_ALPHA_TO_COVERAGE),e.blendEquation(e.FUNC_ADD),e.blendFunc(e.ONE,e.ZERO),e.blendFuncSeparate(e.ONE,e.ZERO,e.ONE,e.ZERO),e.blendColor(0,0,0,0),e.colorMask(!0,!0,!0,!0),e.clearColor(0,0,0,0),e.depthMask(!0),e.depthFunc(e.LESS),e.clearDepth(1),e.stencilMask(4294967295),e.stencilFunc(e.ALWAYS,0,4294967295),e.stencilOp(e.KEEP,e.KEEP,e.KEEP),e.clearStencil(0),e.cullFace(e.BACK),e.frontFace(e.CCW),e.polygonOffset(0,0),e.activeTexture(e.TEXTURE0),e.bindFramebuffer(e.FRAMEBUFFER,null),!0===i&&(e.bindFramebuffer(e.DRAW_FRAMEBUFFER,null),e.bindFramebuffer(e.READ_FRAMEBUFFER,null)),e.useProgram(null),e.lineWidth(1),e.scissor(0,0,e.canvas.width,e.canvas.height),e.viewport(0,0,e.canvas.width,e.canvas.height),A={},Q=null,$={},R={},C=new WeakMap,L=[],P=null,U=!1,D=null,N=null,I=null,O=null,F=null,z=null,B=null,H=new On(0,0,0),V=0,G=!1,k=null,W=null,X=null,j=null,q=null,ne.set(0,0,e.canvas.width,e.canvas.height),ie.set(0,0,e.canvas.width,e.canvas.height),r.reset(),a.reset(),s.reset()}}}function ps(e,t,n,i,r,a,s){const o=r.isWebGL2,l=r.maxTextures,c=r.maxCubemapSize,h=r.maxTextureSize,u=r.maxSamples,d=t.has("WEBGL_multisampled_render_to_texture")?t.get("WEBGL_multisampled_render_to_texture"):null,p="undefined"!=typeof navigator&&/OculusBrowser/g.test(navigator.userAgent),f=new WeakMap;let m;const g=new WeakMap;let _=!1;try{_="undefined"!=typeof OffscreenCanvas&&null!==new OffscreenCanvas(1,1).getContext("2d")}catch(e){}function v(e,t){return _?new OffscreenCanvas(e,t):qe("canvas")}function x(e,t,n,i){let r=1;if((e.width>i||e.height>i)&&(r=i/Math.max(e.width,e.height)),r<1||!0===t){if("undefined"!=typeof HTMLImageElement&&e instanceof HTMLImageElement||"undefined"!=typeof HTMLCanvasElement&&e instanceof HTMLCanvasElement||"undefined"!=typeof ImageBitmap&&e instanceof ImageBitmap){const i=t?He:Math.floor,a=i(r*e.width),s=i(r*e.height);void 0===m&&(m=v(a,s));const o=n?v(a,s):m;return o.width=a,o.height=s,o.getContext("2d").drawImage(e,0,0,a,s),console.warn("THREE.WebGLRenderer: Texture has been resized from ("+e.width+"x"+e.height+") to ("+a+"x"+s+")."),o}return"data"in e&&console.warn("THREE.WebGLRenderer: Image in DataTexture is too big ("+e.width+"x"+e.height+")."),e}return e}function M(e){return Be(e.width)&&Be(e.height)}function S(e,t){return e.generateMipmaps&&t&&e.minFilter!==H&&e.minFilter!==k}function y(t){e.generateMipmap(t)}function E(n,i,r,a){let s=arguments.length>4&&void 0!==arguments[4]&&arguments[4];if(!1===o)return i;if(null!==n){if(void 0!==e[n])return e[n];console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'"+n+"\'")}let l=i;if(i===e.RED&&(r===e.FLOAT&&(l=e.R32F),r===e.HALF_FLOAT&&(l=e.R16F),r===e.UNSIGNED_BYTE&&(l=e.R8)),i===e.RED_INTEGER&&(r===e.UNSIGNED_BYTE&&(l=e.R8UI),r===e.UNSIGNED_SHORT&&(l=e.R16UI),r===e.UNSIGNED_INT&&(l=e.R32UI),r===e.BYTE&&(l=e.R8I),r===e.SHORT&&(l=e.R16I),r===e.INT&&(l=e.R32I)),i===e.RG&&(r===e.FLOAT&&(l=e.RG32F),r===e.HALF_FLOAT&&(l=e.RG16F),r===e.UNSIGNED_BYTE&&(l=e.RG8)),i===e.RGBA){const t=s?me:tt.getTransfer(a);r===e.FLOAT&&(l=e.RGBA32F),r===e.HALF_FLOAT&&(l=e.RGBA16F),r===e.UNSIGNED_BYTE&&(l=t===ge?e.SRGB8_ALPHA8:e.RGBA8),r===e.UNSIGNED_SHORT_4_4_4_4&&(l=e.RGBA4),r===e.UNSIGNED_SHORT_5_5_5_1&&(l=e.RGB5_A1)}return l!==e.R16F&&l!==e.R32F&&l!==e.RG16F&&l!==e.RG32F&&l!==e.RGBA16F&&l!==e.RGBA32F||t.get("EXT_color_buffer_float"),l}function T(e,t,n){return!0===S(e,n)||e.isFramebufferTexture&&e.minFilter!==H&&e.minFilter!==k?Math.log2(Math.max(t.width,t.height))+1:void 0!==e.mipmaps&&e.mipmaps.length>0?e.mipmaps.length:e.isCompressedTexture&&Array.isArray(e.image)?t.mipmaps.length:1}function b(t){return t===H||1004===t||t===G?e.NEAREST:e.LINEAR}function w(e){const t=e.target;t.removeEventListener("dispose",w),function(e){const t=i.get(e);if(void 0===t.__webglInit)return;const n=e.source,r=g.get(n);if(r){const i=r[t.__cacheKey];i.usedTimes--,0===i.usedTimes&&R(e),0===Object.keys(r).length&&g.delete(n)}i.remove(e)}(t),t.isVideoTexture&&f.delete(t)}function A(t){const n=t.target;n.removeEventListener("dispose",A),function(t){const n=t.texture,r=i.get(t),a=i.get(n);if(void 0!==a.__webglTexture&&(e.deleteTexture(a.__webglTexture),s.memory.textures--),t.depthTexture&&t.depthTexture.dispose(),t.isWebGLCubeRenderTarget)for(let t=0;t<6;t++){if(Array.isArray(r.__webglFramebuffer[t]))for(let n=0;n<r.__webglFramebuffer[t].length;n++)e.deleteFramebuffer(r.__webglFramebuffer[t][n]);else e.deleteFramebuffer(r.__webglFramebuffer[t]);r.__webglDepthbuffer&&e.deleteRenderbuffer(r.__webglDepthbuffer[t])}else{if(Array.isArray(r.__webglFramebuffer))for(let t=0;t<r.__webglFramebuffer.length;t++)e.deleteFramebuffer(r.__webglFramebuffer[t]);else e.deleteFramebuffer(r.__webglFramebuffer);if(r.__webglDepthbuffer&&e.deleteRenderbuffer(r.__webglDepthbuffer),r.__webglMultisampledFramebuffer&&e.deleteFramebuffer(r.__webglMultisampledFramebuffer),r.__webglColorRenderbuffer)for(let t=0;t<r.__webglColorRenderbuffer.length;t++)r.__webglColorRenderbuffer[t]&&e.deleteRenderbuffer(r.__webglColorRenderbuffer[t]);r.__webglDepthRenderbuffer&&e.deleteRenderbuffer(r.__webglDepthRenderbuffer)}if(t.isWebGLMultipleRenderTargets)for(let t=0,r=n.length;t<r;t++){const r=i.get(n[t]);r.__webglTexture&&(e.deleteTexture(r.__webglTexture),s.memory.textures--),i.remove(n[t])}i.remove(n),i.remove(t)}(n)}function R(t){const n=i.get(t);e.deleteTexture(n.__webglTexture);const r=t.source;delete g.get(r)[n.__cacheKey],s.memory.textures--}let C=0;function L(t,r){const a=i.get(t);if(t.isVideoTexture&&function(e){const t=s.render.frame;f.get(e)!==t&&(f.set(e,t),e.update())}(t),!1===t.isRenderTargetTexture&&t.version>0&&a.__version!==t.version){const e=t.image;if(null===e)console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");else{if(!1!==e.complete)return void O(a,t,r);console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete")}}n.bindTexture(e.TEXTURE_2D,a.__webglTexture,e.TEXTURE0+r)}const P={[F]:e.REPEAT,[z]:e.CLAMP_TO_EDGE,[B]:e.MIRRORED_REPEAT},U={[H]:e.NEAREST,[V]:e.NEAREST_MIPMAP_NEAREST,[G]:e.NEAREST_MIPMAP_LINEAR,[k]:e.LINEAR,[W]:e.LINEAR_MIPMAP_NEAREST,[X]:e.LINEAR_MIPMAP_LINEAR},D={[Me]:e.NEVER,[Ae]:e.ALWAYS,[Se]:e.LESS,[Ee]:e.LEQUAL,[ye]:e.EQUAL,[we]:e.GEQUAL,[Te]:e.GREATER,[be]:e.NOTEQUAL};function N(n,a,s){if(s?(e.texParameteri(n,e.TEXTURE_WRAP_S,P[a.wrapS]),e.texParameteri(n,e.TEXTURE_WRAP_T,P[a.wrapT]),n!==e.TEXTURE_3D&&n!==e.TEXTURE_2D_ARRAY||e.texParameteri(n,e.TEXTURE_WRAP_R,P[a.wrapR]),e.texParameteri(n,e.TEXTURE_MAG_FILTER,U[a.magFilter]),e.texParameteri(n,e.TEXTURE_MIN_FILTER,U[a.minFilter])):(e.texParameteri(n,e.TEXTURE_WRAP_S,e.CLAMP_TO_EDGE),e.texParameteri(n,e.TEXTURE_WRAP_T,e.CLAMP_TO_EDGE),n!==e.TEXTURE_3D&&n!==e.TEXTURE_2D_ARRAY||e.texParameteri(n,e.TEXTURE_WRAP_R,e.CLAMP_TO_EDGE),a.wrapS===z&&a.wrapT===z||console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."),e.texParameteri(n,e.TEXTURE_MAG_FILTER,b(a.magFilter)),e.texParameteri(n,e.TEXTURE_MIN_FILTER,b(a.minFilter)),a.minFilter!==H&&a.minFilter!==k&&console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")),a.compareFunction&&(e.texParameteri(n,e.TEXTURE_COMPARE_MODE,e.COMPARE_REF_TO_TEXTURE),e.texParameteri(n,e.TEXTURE_COMPARE_FUNC,D[a.compareFunction])),!0===t.has("EXT_texture_filter_anisotropic")){const s=t.get("EXT_texture_filter_anisotropic");if(a.magFilter===H)return;if(a.minFilter!==G&&a.minFilter!==X)return;if(a.type===K&&!1===t.has("OES_texture_float_linear"))return;if(!1===o&&a.type===Z&&!1===t.has("OES_texture_half_float_linear"))return;(a.anisotropy>1||i.get(a).__currentAnisotropy)&&(e.texParameterf(n,s.TEXTURE_MAX_ANISOTROPY_EXT,Math.min(a.anisotropy,r.getMaxAnisotropy())),i.get(a).__currentAnisotropy=a.anisotropy)}}function I(t,n){let i=!1;void 0===t.__webglInit&&(t.__webglInit=!0,n.addEventListener("dispose",w));const r=n.source;let a=g.get(r);void 0===a&&(a={},g.set(r,a));const o=function(e){const t=[];return t.push(e.wrapS),t.push(e.wrapT),t.push(e.wrapR||0),t.push(e.magFilter),t.push(e.minFilter),t.push(e.anisotropy),t.push(e.internalFormat),t.push(e.format),t.push(e.type),t.push(e.generateMipmaps),t.push(e.premultiplyAlpha),t.push(e.flipY),t.push(e.unpackAlignment),t.push(e.colorSpace),t.join()}(n);if(o!==t.__cacheKey){void 0===a[o]&&(a[o]={texture:e.createTexture(),usedTimes:0},s.memory.textures++,i=!0),a[o].usedTimes++;const r=a[t.__cacheKey];void 0!==r&&(a[t.__cacheKey].usedTimes--,0===r.usedTimes&&R(n)),t.__cacheKey=o,t.__webglTexture=a[o].texture}return i}function O(t,r,s){let l=e.TEXTURE_2D;(r.isDataArrayTexture||r.isCompressedArrayTexture)&&(l=e.TEXTURE_2D_ARRAY),r.isData3DTexture&&(l=e.TEXTURE_3D);const c=I(t,r),u=r.source;n.bindTexture(l,t.__webglTexture,e.TEXTURE0+s);const d=i.get(u);if(u.version!==d.__version||!0===c){n.activeTexture(e.TEXTURE0+s);const t=tt.getPrimaries(tt.workingColorSpace),i=r.colorSpace===he?null:tt.getPrimaries(r.colorSpace),p=r.colorSpace===he||t===i?e.NONE:e.BROWSER_DEFAULT_WEBGL;e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL,r.flipY),e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,r.premultiplyAlpha),e.pixelStorei(e.UNPACK_ALIGNMENT,r.unpackAlignment),e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL,p);const f=function(e){return!o&&(e.wrapS!==z||e.wrapT!==z||e.minFilter!==H&&e.minFilter!==k)}(r)&&!1===M(r.image);let m=x(r.image,f,!1,h);m=se(r,m);const g=M(m)||o,_=a.convert(r.format,r.colorSpace);let v,b=a.convert(r.type),w=E(r.internalFormat,_,b,r.colorSpace,r.isVideoTexture);N(l,r,g);const A=r.mipmaps,R=o&&!0!==r.isVideoTexture,C=void 0===d.__version||!0===c,L=T(r,m,g);if(r.isDepthTexture)w=e.DEPTH_COMPONENT,o?w=r.type===K?e.DEPTH_COMPONENT32F:r.type===Y?e.DEPTH_COMPONENT24:r.type===J?e.DEPTH24_STENCIL8:e.DEPTH_COMPONENT16:r.type===K&&console.error("WebGLRenderer: Floating point depth texture requires WebGL2."),r.format===$&&w===e.DEPTH_COMPONENT&&r.type!==q&&r.type!==Y&&(console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."),r.type=Y,b=a.convert(r.type)),r.format===ee&&w===e.DEPTH_COMPONENT&&(w=e.DEPTH_STENCIL,r.type!==J&&(console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."),r.type=J,b=a.convert(r.type))),C&&(R?n.texStorage2D(e.TEXTURE_2D,1,w,m.width,m.height):n.texImage2D(e.TEXTURE_2D,0,w,m.width,m.height,0,_,b,null));else if(r.isDataTexture)if(A.length>0&&g){R&&C&&n.texStorage2D(e.TEXTURE_2D,L,w,A[0].width,A[0].height);for(let t=0,i=A.length;t<i;t++)v=A[t],R?n.texSubImage2D(e.TEXTURE_2D,t,0,0,v.width,v.height,_,b,v.data):n.texImage2D(e.TEXTURE_2D,t,w,v.width,v.height,0,_,b,v.data);r.generateMipmaps=!1}else R?(C&&n.texStorage2D(e.TEXTURE_2D,L,w,m.width,m.height),n.texSubImage2D(e.TEXTURE_2D,0,0,0,m.width,m.height,_,b,m.data)):n.texImage2D(e.TEXTURE_2D,0,w,m.width,m.height,0,_,b,m.data);else if(r.isCompressedTexture)if(r.isCompressedArrayTexture){R&&C&&n.texStorage3D(e.TEXTURE_2D_ARRAY,L,w,A[0].width,A[0].height,m.depth);for(let t=0,i=A.length;t<i;t++)v=A[t],r.format!==Q?null!==_?R?n.compressedTexSubImage3D(e.TEXTURE_2D_ARRAY,t,0,0,0,v.width,v.height,m.depth,_,v.data,0,0):n.compressedTexImage3D(e.TEXTURE_2D_ARRAY,t,w,v.width,v.height,m.depth,0,v.data,0,0):console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()"):R?n.texSubImage3D(e.TEXTURE_2D_ARRAY,t,0,0,0,v.width,v.height,m.depth,_,b,v.data):n.texImage3D(e.TEXTURE_2D_ARRAY,t,w,v.width,v.height,m.depth,0,_,b,v.data)}else{R&&C&&n.texStorage2D(e.TEXTURE_2D,L,w,A[0].width,A[0].height);for(let t=0,i=A.length;t<i;t++)v=A[t],r.format!==Q?null!==_?R?n.compressedTexSubImage2D(e.TEXTURE_2D,t,0,0,v.width,v.height,_,v.data):n.compressedTexImage2D(e.TEXTURE_2D,t,w,v.width,v.height,0,v.data):console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()"):R?n.texSubImage2D(e.TEXTURE_2D,t,0,0,v.width,v.height,_,b,v.data):n.texImage2D(e.TEXTURE_2D,t,w,v.width,v.height,0,_,b,v.data)}else if(r.isDataArrayTexture)R?(C&&n.texStorage3D(e.TEXTURE_2D_ARRAY,L,w,m.width,m.height,m.depth),n.texSubImage3D(e.TEXTURE_2D_ARRAY,0,0,0,0,m.width,m.height,m.depth,_,b,m.data)):n.texImage3D(e.TEXTURE_2D_ARRAY,0,w,m.width,m.height,m.depth,0,_,b,m.data);else if(r.isData3DTexture)R?(C&&n.texStorage3D(e.TEXTURE_3D,L,w,m.width,m.height,m.depth),n.texSubImage3D(e.TEXTURE_3D,0,0,0,0,m.width,m.height,m.depth,_,b,m.data)):n.texImage3D(e.TEXTURE_3D,0,w,m.width,m.height,m.depth,0,_,b,m.data);else if(r.isFramebufferTexture){if(C)if(R)n.texStorage2D(e.TEXTURE_2D,L,w,m.width,m.height);else{let t=m.width,i=m.height;for(let r=0;r<L;r++)n.texImage2D(e.TEXTURE_2D,r,w,t,i,0,_,b,null),t>>=1,i>>=1}}else if(A.length>0&&g){R&&C&&n.texStorage2D(e.TEXTURE_2D,L,w,A[0].width,A[0].height);for(let t=0,i=A.length;t<i;t++)v=A[t],R?n.texSubImage2D(e.TEXTURE_2D,t,0,0,_,b,v):n.texImage2D(e.TEXTURE_2D,t,w,_,b,v);r.generateMipmaps=!1}else R?(C&&n.texStorage2D(e.TEXTURE_2D,L,w,m.width,m.height),n.texSubImage2D(e.TEXTURE_2D,0,0,0,_,b,m)):n.texImage2D(e.TEXTURE_2D,0,w,_,b,m);S(r,g)&&y(l),d.__version=u.version,r.onUpdate&&r.onUpdate(r)}t.__version=r.version}function te(t,r,s,o,l,c){const h=a.convert(s.format,s.colorSpace),u=a.convert(s.type),p=E(s.internalFormat,h,u,s.colorSpace);if(!i.get(r).__hasExternalTextures){const t=Math.max(1,r.width>>c),i=Math.max(1,r.height>>c);l===e.TEXTURE_3D||l===e.TEXTURE_2D_ARRAY?n.texImage3D(l,c,p,t,i,r.depth,0,h,u,null):n.texImage2D(l,c,p,t,i,0,h,u,null)}n.bindFramebuffer(e.FRAMEBUFFER,t),ae(r)?d.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER,o,l,i.get(s).__webglTexture,0,re(r)):(l===e.TEXTURE_2D||l>=e.TEXTURE_CUBE_MAP_POSITIVE_X&&l<=e.TEXTURE_CUBE_MAP_NEGATIVE_Z)&&e.framebufferTexture2D(e.FRAMEBUFFER,o,l,i.get(s).__webglTexture,c),n.bindFramebuffer(e.FRAMEBUFFER,null)}function ne(t,n,i){if(e.bindRenderbuffer(e.RENDERBUFFER,t),n.depthBuffer&&!n.stencilBuffer){let r=!0===o?e.DEPTH_COMPONENT24:e.DEPTH_COMPONENT16;if(i||ae(n)){const t=n.depthTexture;t&&t.isDepthTexture&&(t.type===K?r=e.DEPTH_COMPONENT32F:t.type===Y&&(r=e.DEPTH_COMPONENT24));const i=re(n);ae(n)?d.renderbufferStorageMultisampleEXT(e.RENDERBUFFER,i,r,n.width,n.height):e.renderbufferStorageMultisample(e.RENDERBUFFER,i,r,n.width,n.height)}else e.renderbufferStorage(e.RENDERBUFFER,r,n.width,n.height);e.framebufferRenderbuffer(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.RENDERBUFFER,t)}else if(n.depthBuffer&&n.stencilBuffer){const r=re(n);i&&!1===ae(n)?e.renderbufferStorageMultisample(e.RENDERBUFFER,r,e.DEPTH24_STENCIL8,n.width,n.height):ae(n)?d.renderbufferStorageMultisampleEXT(e.RENDERBUFFER,r,e.DEPTH24_STENCIL8,n.width,n.height):e.renderbufferStorage(e.RENDERBUFFER,e.DEPTH_STENCIL,n.width,n.height),e.framebufferRenderbuffer(e.FRAMEBUFFER,e.DEPTH_STENCIL_ATTACHMENT,e.RENDERBUFFER,t)}else{const t=!0===n.isWebGLMultipleRenderTargets?n.texture:[n.texture];for(let r=0;r<t.length;r++){const s=t[r],o=a.convert(s.format,s.colorSpace),l=a.convert(s.type),c=E(s.internalFormat,o,l,s.colorSpace),h=re(n);i&&!1===ae(n)?e.renderbufferStorageMultisample(e.RENDERBUFFER,h,c,n.width,n.height):ae(n)?d.renderbufferStorageMultisampleEXT(e.RENDERBUFFER,h,c,n.width,n.height):e.renderbufferStorage(e.RENDERBUFFER,c,n.width,n.height)}}e.bindRenderbuffer(e.RENDERBUFFER,null)}function ie(t){const r=i.get(t),a=!0===t.isWebGLCubeRenderTarget;if(t.depthTexture&&!r.__autoAllocateDepthBuffer){if(a)throw new Error("target.depthTexture not supported in Cube render targets");!function(t,r){if(r&&r.isWebGLCubeRenderTarget)throw new Error("Depth Texture with cube render targets is not supported");if(n.bindFramebuffer(e.FRAMEBUFFER,t),!r.depthTexture||!r.depthTexture.isDepthTexture)throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");i.get(r.depthTexture).__webglTexture&&r.depthTexture.image.width===r.width&&r.depthTexture.image.height===r.height||(r.depthTexture.image.width=r.width,r.depthTexture.image.height=r.height,r.depthTexture.needsUpdate=!0),L(r.depthTexture,0);const a=i.get(r.depthTexture).__webglTexture,s=re(r);if(r.depthTexture.format===$)ae(r)?d.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.TEXTURE_2D,a,0,s):e.framebufferTexture2D(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.TEXTURE_2D,a,0);else{if(r.depthTexture.format!==ee)throw new Error("Unknown depthTexture format");ae(r)?d.framebufferTexture2DMultisampleEXT(e.FRAMEBUFFER,e.DEPTH_STENCIL_ATTACHMENT,e.TEXTURE_2D,a,0,s):e.framebufferTexture2D(e.FRAMEBUFFER,e.DEPTH_STENCIL_ATTACHMENT,e.TEXTURE_2D,a,0)}}(r.__webglFramebuffer,t)}else if(a){r.__webglDepthbuffer=[];for(let i=0;i<6;i++)n.bindFramebuffer(e.FRAMEBUFFER,r.__webglFramebuffer[i]),r.__webglDepthbuffer[i]=e.createRenderbuffer(),ne(r.__webglDepthbuffer[i],t,!1)}else n.bindFramebuffer(e.FRAMEBUFFER,r.__webglFramebuffer),r.__webglDepthbuffer=e.createRenderbuffer(),ne(r.__webglDepthbuffer,t,!1);n.bindFramebuffer(e.FRAMEBUFFER,null)}function re(e){return Math.min(u,e.samples)}function ae(e){const n=i.get(e);return o&&e.samples>0&&!0===t.has("WEBGL_multisampled_render_to_texture")&&!1!==n.__useRenderToTexture}function se(e,n){const i=e.colorSpace,r=e.format,a=e.type;return!0===e.isCompressedTexture||!0===e.isVideoTexture||e.format===Ce||i!==de&&i!==he&&(tt.getTransfer(i)===ge?!1===o?!0===t.has("EXT_sRGB")&&r===Q?(e.format=Ce,e.minFilter=k,e.generateMipmaps=!1):n=at.sRGBToLinear(n):r===Q&&a===j||console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType."):console.error("THREE.WebGLTextures: Unsupported texture color space:",i)),n}this.allocateTextureUnit=function(){const e=C;return e>=l&&console.warn("THREE.WebGLTextures: Trying to use "+e+" texture units while this GPU supports only "+l),C+=1,e},this.resetTextureUnits=function(){C=0},this.setTexture2D=L,this.setTexture2DArray=function(t,r){const a=i.get(t);t.version>0&&a.__version!==t.version?O(a,t,r):n.bindTexture(e.TEXTURE_2D_ARRAY,a.__webglTexture,e.TEXTURE0+r)},this.setTexture3D=function(t,r){const a=i.get(t);t.version>0&&a.__version!==t.version?O(a,t,r):n.bindTexture(e.TEXTURE_3D,a.__webglTexture,e.TEXTURE0+r)},this.setTextureCube=function(t,r){const s=i.get(t);t.version>0&&s.__version!==t.version?function(t,r,s){if(6!==r.image.length)return;const l=I(t,r),h=r.source;n.bindTexture(e.TEXTURE_CUBE_MAP,t.__webglTexture,e.TEXTURE0+s);const u=i.get(h);if(h.version!==u.__version||!0===l){n.activeTexture(e.TEXTURE0+s);const t=tt.getPrimaries(tt.workingColorSpace),i=r.colorSpace===he?null:tt.getPrimaries(r.colorSpace),d=r.colorSpace===he||t===i?e.NONE:e.BROWSER_DEFAULT_WEBGL;e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL,r.flipY),e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,r.premultiplyAlpha),e.pixelStorei(e.UNPACK_ALIGNMENT,r.unpackAlignment),e.pixelStorei(e.UNPACK_COLORSPACE_CONVERSION_WEBGL,d);const p=r.isCompressedTexture||r.image[0].isCompressedTexture,f=r.image[0]&&r.image[0].isDataTexture,m=[];for(let e=0;e<6;e++)m[e]=p||f?f?r.image[e].image:r.image[e]:x(r.image[e],!1,!0,c),m[e]=se(r,m[e]);const g=m[0],_=M(g)||o,v=a.convert(r.format,r.colorSpace),b=a.convert(r.type),w=E(r.internalFormat,v,b,r.colorSpace),A=o&&!0!==r.isVideoTexture,R=void 0===u.__version||!0===l;let C,L=T(r,g,_);if(N(e.TEXTURE_CUBE_MAP,r,_),p){A&&R&&n.texStorage2D(e.TEXTURE_CUBE_MAP,L,w,g.width,g.height);for(let t=0;t<6;t++){C=m[t].mipmaps;for(let i=0;i<C.length;i++){const a=C[i];r.format!==Q?null!==v?A?n.compressedTexSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i,0,0,a.width,a.height,v,a.data):n.compressedTexImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i,w,a.width,a.height,0,a.data):console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()"):A?n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i,0,0,a.width,a.height,v,b,a.data):n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i,w,a.width,a.height,0,v,b,a.data)}}}else{C=r.mipmaps,A&&R&&(C.length>0&&L++,n.texStorage2D(e.TEXTURE_CUBE_MAP,L,w,m[0].width,m[0].height));for(let t=0;t<6;t++)if(f){A?n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,0,0,0,m[t].width,m[t].height,v,b,m[t].data):n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,0,w,m[t].width,m[t].height,0,v,b,m[t].data);for(let i=0;i<C.length;i++){const r=C[i].image[t].image;A?n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i+1,0,0,r.width,r.height,v,b,r.data):n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i+1,w,r.width,r.height,0,v,b,r.data)}}else{A?n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,0,0,0,v,b,m[t]):n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,0,w,v,b,m[t]);for(let i=0;i<C.length;i++){const r=C[i];A?n.texSubImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i+1,0,0,v,b,r.image[t]):n.texImage2D(e.TEXTURE_CUBE_MAP_POSITIVE_X+t,i+1,w,v,b,r.image[t])}}}S(r,_)&&y(e.TEXTURE_CUBE_MAP),u.__version=h.version,r.onUpdate&&r.onUpdate(r)}t.__version=r.version}(s,t,r):n.bindTexture(e.TEXTURE_CUBE_MAP,s.__webglTexture,e.TEXTURE0+r)},this.rebindTextures=function(t,n,r){const a=i.get(t);void 0!==n&&te(a.__webglFramebuffer,t,t.texture,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,0),void 0!==r&&ie(t)},this.setupRenderTarget=function(t){const l=t.texture,c=i.get(t),h=i.get(l);t.addEventListener("dispose",A),!0!==t.isWebGLMultipleRenderTargets&&(void 0===h.__webglTexture&&(h.__webglTexture=e.createTexture()),h.__version=l.version,s.memory.textures++);const u=!0===t.isWebGLCubeRenderTarget,d=!0===t.isWebGLMultipleRenderTargets,p=M(t)||o;if(u){c.__webglFramebuffer=[];for(let t=0;t<6;t++)if(o&&l.mipmaps&&l.mipmaps.length>0){c.__webglFramebuffer[t]=[];for(let n=0;n<l.mipmaps.length;n++)c.__webglFramebuffer[t][n]=e.createFramebuffer()}else c.__webglFramebuffer[t]=e.createFramebuffer()}else{if(o&&l.mipmaps&&l.mipmaps.length>0){c.__webglFramebuffer=[];for(let t=0;t<l.mipmaps.length;t++)c.__webglFramebuffer[t]=e.createFramebuffer()}else c.__webglFramebuffer=e.createFramebuffer();if(d)if(r.drawBuffers){const n=t.texture;for(let t=0,r=n.length;t<r;t++){const r=i.get(n[t]);void 0===r.__webglTexture&&(r.__webglTexture=e.createTexture(),s.memory.textures++)}}else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");if(o&&t.samples>0&&!1===ae(t)){const i=d?l:[l];c.__webglMultisampledFramebuffer=e.createFramebuffer(),c.__webglColorRenderbuffer=[],n.bindFramebuffer(e.FRAMEBUFFER,c.__webglMultisampledFramebuffer);for(let n=0;n<i.length;n++){const r=i[n];c.__webglColorRenderbuffer[n]=e.createRenderbuffer(),e.bindRenderbuffer(e.RENDERBUFFER,c.__webglColorRenderbuffer[n]);const s=a.convert(r.format,r.colorSpace),o=a.convert(r.type),l=E(r.internalFormat,s,o,r.colorSpace,!0===t.isXRRenderTarget),h=re(t);e.renderbufferStorageMultisample(e.RENDERBUFFER,h,l,t.width,t.height),e.framebufferRenderbuffer(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0+n,e.RENDERBUFFER,c.__webglColorRenderbuffer[n])}e.bindRenderbuffer(e.RENDERBUFFER,null),t.depthBuffer&&(c.__webglDepthRenderbuffer=e.createRenderbuffer(),ne(c.__webglDepthRenderbuffer,t,!0)),n.bindFramebuffer(e.FRAMEBUFFER,null)}}if(u){n.bindTexture(e.TEXTURE_CUBE_MAP,h.__webglTexture),N(e.TEXTURE_CUBE_MAP,l,p);for(let n=0;n<6;n++)if(o&&l.mipmaps&&l.mipmaps.length>0)for(let i=0;i<l.mipmaps.length;i++)te(c.__webglFramebuffer[n][i],t,l,e.COLOR_ATTACHMENT0,e.TEXTURE_CUBE_MAP_POSITIVE_X+n,i);else te(c.__webglFramebuffer[n],t,l,e.COLOR_ATTACHMENT0,e.TEXTURE_CUBE_MAP_POSITIVE_X+n,0);S(l,p)&&y(e.TEXTURE_CUBE_MAP),n.unbindTexture()}else if(d){const r=t.texture;for(let a=0,s=r.length;a<s;a++){const s=r[a],o=i.get(s);n.bindTexture(e.TEXTURE_2D,o.__webglTexture),N(e.TEXTURE_2D,s,p),te(c.__webglFramebuffer,t,s,e.COLOR_ATTACHMENT0+a,e.TEXTURE_2D,0),S(s,p)&&y(e.TEXTURE_2D)}n.unbindTexture()}else{let i=e.TEXTURE_2D;if((t.isWebGL3DRenderTarget||t.isWebGLArrayRenderTarget)&&(o?i=t.isWebGL3DRenderTarget?e.TEXTURE_3D:e.TEXTURE_2D_ARRAY:console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")),n.bindTexture(i,h.__webglTexture),N(i,l,p),o&&l.mipmaps&&l.mipmaps.length>0)for(let n=0;n<l.mipmaps.length;n++)te(c.__webglFramebuffer[n],t,l,e.COLOR_ATTACHMENT0,i,n);else te(c.__webglFramebuffer,t,l,e.COLOR_ATTACHMENT0,i,0);S(l,p)&&y(i),n.unbindTexture()}t.depthBuffer&&ie(t)},this.updateRenderTargetMipmap=function(t){const r=M(t)||o,a=!0===t.isWebGLMultipleRenderTargets?t.texture:[t.texture];for(let s=0,o=a.length;s<o;s++){const o=a[s];if(S(o,r)){const r=t.isWebGLCubeRenderTarget?e.TEXTURE_CUBE_MAP:e.TEXTURE_2D,a=i.get(o).__webglTexture;n.bindTexture(r,a),y(r),n.unbindTexture()}}},this.updateMultisampleRenderTarget=function(t){if(o&&t.samples>0&&!1===ae(t)){const r=t.isWebGLMultipleRenderTargets?t.texture:[t.texture],a=t.width,s=t.height;let o=e.COLOR_BUFFER_BIT;const l=[],c=t.stencilBuffer?e.DEPTH_STENCIL_ATTACHMENT:e.DEPTH_ATTACHMENT,h=i.get(t),u=!0===t.isWebGLMultipleRenderTargets;if(u)for(let t=0;t<r.length;t++)n.bindFramebuffer(e.FRAMEBUFFER,h.__webglMultisampledFramebuffer),e.framebufferRenderbuffer(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0+t,e.RENDERBUFFER,null),n.bindFramebuffer(e.FRAMEBUFFER,h.__webglFramebuffer),e.framebufferTexture2D(e.DRAW_FRAMEBUFFER,e.COLOR_ATTACHMENT0+t,e.TEXTURE_2D,null,0);n.bindFramebuffer(e.READ_FRAMEBUFFER,h.__webglMultisampledFramebuffer),n.bindFramebuffer(e.DRAW_FRAMEBUFFER,h.__webglFramebuffer);for(let n=0;n<r.length;n++){l.push(e.COLOR_ATTACHMENT0+n),t.depthBuffer&&l.push(c);const d=void 0!==h.__ignoreDepthValues&&h.__ignoreDepthValues;if(!1===d&&(t.depthBuffer&&(o|=e.DEPTH_BUFFER_BIT),t.stencilBuffer&&(o|=e.STENCIL_BUFFER_BIT)),u&&e.framebufferRenderbuffer(e.READ_FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.RENDERBUFFER,h.__webglColorRenderbuffer[n]),!0===d&&(e.invalidateFramebuffer(e.READ_FRAMEBUFFER,[c]),e.invalidateFramebuffer(e.DRAW_FRAMEBUFFER,[c])),u){const t=i.get(r[n]).__webglTexture;e.framebufferTexture2D(e.DRAW_FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,t,0)}e.blitFramebuffer(0,0,a,s,0,0,a,s,o,e.NEAREST),p&&e.invalidateFramebuffer(e.READ_FRAMEBUFFER,l)}if(n.bindFramebuffer(e.READ_FRAMEBUFFER,null),n.bindFramebuffer(e.DRAW_FRAMEBUFFER,null),u)for(let t=0;t<r.length;t++){n.bindFramebuffer(e.FRAMEBUFFER,h.__webglMultisampledFramebuffer),e.framebufferRenderbuffer(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0+t,e.RENDERBUFFER,h.__webglColorRenderbuffer[t]);const a=i.get(r[t]).__webglTexture;n.bindFramebuffer(e.FRAMEBUFFER,h.__webglFramebuffer),e.framebufferTexture2D(e.DRAW_FRAMEBUFFER,e.COLOR_ATTACHMENT0+t,e.TEXTURE_2D,a,0)}n.bindFramebuffer(e.DRAW_FRAMEBUFFER,h.__webglMultisampledFramebuffer)}},this.setupDepthRenderbuffer=ie,this.setupFrameBufferTexture=te,this.useMultisampledRTT=ae}function fs(e,t,n){const i=n.isWebGL2;return{convert:function(n){let r,a=arguments.length>1&&void 0!==arguments[1]?arguments[1]:he;const s=tt.getTransfer(a);if(n===j)return e.UNSIGNED_BYTE;if(1017===n)return e.UNSIGNED_SHORT_4_4_4_4;if(1018===n)return e.UNSIGNED_SHORT_5_5_5_1;if(1010===n)return e.BYTE;if(1011===n)return e.SHORT;if(n===q)return e.UNSIGNED_SHORT;if(1013===n)return e.INT;if(n===Y)return e.UNSIGNED_INT;if(n===K)return e.FLOAT;if(n===Z)return i?e.HALF_FLOAT:(r=t.get("OES_texture_half_float"),null!==r?r.HALF_FLOAT_OES:null);if(1021===n)return e.ALPHA;if(n===Q)return e.RGBA;if(1024===n)return e.LUMINANCE;if(1025===n)return e.LUMINANCE_ALPHA;if(n===$)return e.DEPTH_COMPONENT;if(n===ee)return e.DEPTH_STENCIL;if(n===Ce)return r=t.get("EXT_sRGB"),null!==r?r.SRGB_ALPHA_EXT:null;if(1028===n)return e.RED;if(1029===n)return e.RED_INTEGER;if(1030===n)return e.RG;if(1031===n)return e.RG_INTEGER;if(1033===n)return e.RGBA_INTEGER;if(n===te||n===ne||n===ie||n===re)if(s===ge){if(r=t.get("WEBGL_compressed_texture_s3tc_srgb"),null===r)return null;if(n===te)return r.COMPRESSED_SRGB_S3TC_DXT1_EXT;if(n===ne)return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;if(n===ie)return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;if(n===re)return r.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT}else{if(r=t.get("WEBGL_compressed_texture_s3tc"),null===r)return null;if(n===te)return r.COMPRESSED_RGB_S3TC_DXT1_EXT;if(n===ne)return r.COMPRESSED_RGBA_S3TC_DXT1_EXT;if(n===ie)return r.COMPRESSED_RGBA_S3TC_DXT3_EXT;if(n===re)return r.COMPRESSED_RGBA_S3TC_DXT5_EXT}if(35840===n||35841===n||35842===n||35843===n){if(r=t.get("WEBGL_compressed_texture_pvrtc"),null===r)return null;if(35840===n)return r.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;if(35841===n)return r.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;if(35842===n)return r.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;if(35843===n)return r.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG}if(36196===n)return r=t.get("WEBGL_compressed_texture_etc1"),null!==r?r.COMPRESSED_RGB_ETC1_WEBGL:null;if(37492===n||37496===n){if(r=t.get("WEBGL_compressed_texture_etc"),null===r)return null;if(37492===n)return s===ge?r.COMPRESSED_SRGB8_ETC2:r.COMPRESSED_RGB8_ETC2;if(37496===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC:r.COMPRESSED_RGBA8_ETC2_EAC}if(37808===n||37809===n||37810===n||37811===n||37812===n||37813===n||37814===n||37815===n||37816===n||37817===n||37818===n||37819===n||37820===n||37821===n){if(r=t.get("WEBGL_compressed_texture_astc"),null===r)return null;if(37808===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR:r.COMPRESSED_RGBA_ASTC_4x4_KHR;if(37809===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR:r.COMPRESSED_RGBA_ASTC_5x4_KHR;if(37810===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR:r.COMPRESSED_RGBA_ASTC_5x5_KHR;if(37811===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR:r.COMPRESSED_RGBA_ASTC_6x5_KHR;if(37812===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR:r.COMPRESSED_RGBA_ASTC_6x6_KHR;if(37813===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR:r.COMPRESSED_RGBA_ASTC_8x5_KHR;if(37814===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR:r.COMPRESSED_RGBA_ASTC_8x6_KHR;if(37815===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR:r.COMPRESSED_RGBA_ASTC_8x8_KHR;if(37816===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR:r.COMPRESSED_RGBA_ASTC_10x5_KHR;if(37817===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR:r.COMPRESSED_RGBA_ASTC_10x6_KHR;if(37818===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR:r.COMPRESSED_RGBA_ASTC_10x8_KHR;if(37819===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR:r.COMPRESSED_RGBA_ASTC_10x10_KHR;if(37820===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR:r.COMPRESSED_RGBA_ASTC_12x10_KHR;if(37821===n)return s===ge?r.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR:r.COMPRESSED_RGBA_ASTC_12x12_KHR}if(n===ae||36494===n||36495===n){if(r=t.get("EXT_texture_compression_bptc"),null===r)return null;if(n===ae)return s===ge?r.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT:r.COMPRESSED_RGBA_BPTC_UNORM_EXT;if(36494===n)return r.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;if(36495===n)return r.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT}if(36283===n||36284===n||36285===n||36286===n){if(r=t.get("EXT_texture_compression_rgtc"),null===r)return null;if(n===ae)return r.COMPRESSED_RED_RGTC1_EXT;if(36284===n)return r.COMPRESSED_SIGNED_RED_RGTC1_EXT;if(36285===n)return r.COMPRESSED_RED_GREEN_RGTC2_EXT;if(36286===n)return r.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT}return n===J?i?e.UNSIGNED_INT_24_8:(r=t.get("WEBGL_depth_texture"),null!==r?r.UNSIGNED_INT_24_8_WEBGL:null):void 0!==e[n]?e[n]:null}}}class ms extends Li{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];super(),this.isArrayCamera=!0,this.cameras=e}}class gs extends xn{constructor(){super(),this.isGroup=!0,this.type="Group"}}const _s={type:"move"};class vs{constructor(){this._targetRay=null,this._grip=null,this._hand=null}getHandSpace(){return null===this._hand&&(this._hand=new gs,this._hand.matrixAutoUpdate=!1,this._hand.visible=!1,this._hand.joints={},this._hand.inputState={pinching:!1}),this._hand}getTargetRaySpace(){return null===this._targetRay&&(this._targetRay=new gs,this._targetRay.matrixAutoUpdate=!1,this._targetRay.visible=!1,this._targetRay.hasLinearVelocity=!1,this._targetRay.linearVelocity=new _t,this._targetRay.hasAngularVelocity=!1,this._targetRay.angularVelocity=new _t),this._targetRay}getGripSpace(){return null===this._grip&&(this._grip=new gs,this._grip.matrixAutoUpdate=!1,this._grip.visible=!1,this._grip.hasLinearVelocity=!1,this._grip.linearVelocity=new _t,this._grip.hasAngularVelocity=!1,this._grip.angularVelocity=new _t),this._grip}dispatchEvent(e){return null!==this._targetRay&&this._targetRay.dispatchEvent(e),null!==this._grip&&this._grip.dispatchEvent(e),null!==this._hand&&this._hand.dispatchEvent(e),this}connect(e){if(e&&e.hand){const t=this._hand;if(t)for(const n of e.hand.values())this._getHandJoint(t,n)}return this.dispatchEvent({type:"connected",data:e}),this}disconnect(e){return this.dispatchEvent({type:"disconnected",data:e}),null!==this._targetRay&&(this._targetRay.visible=!1),null!==this._grip&&(this._grip.visible=!1),null!==this._hand&&(this._hand.visible=!1),this}update(e,t,n){let i=null,r=null,a=null;const s=this._targetRay,o=this._grip,l=this._hand;if(e&&"visible-blurred"!==t.session.visibilityState){if(l&&e.hand){a=!0;for(const i of e.hand.values()){const e=t.getJointPose(i,n),r=this._getHandJoint(l,i);null!==e&&(r.matrix.fromArray(e.transform.matrix),r.matrix.decompose(r.position,r.rotation,r.scale),r.matrixWorldNeedsUpdate=!0,r.jointRadius=e.radius),r.visible=null!==e}const i=l.joints["index-finger-tip"],r=l.joints["thumb-tip"],s=i.position.distanceTo(r.position),o=.02,c=.005;l.inputState.pinching&&s>o+c?(l.inputState.pinching=!1,this.dispatchEvent({type:"pinchend",handedness:e.handedness,target:this})):!l.inputState.pinching&&s<=o-c&&(l.inputState.pinching=!0,this.dispatchEvent({type:"pinchstart",handedness:e.handedness,target:this}))}else null!==o&&e.gripSpace&&(r=t.getPose(e.gripSpace,n),null!==r&&(o.matrix.fromArray(r.transform.matrix),o.matrix.decompose(o.position,o.rotation,o.scale),o.matrixWorldNeedsUpdate=!0,r.linearVelocity?(o.hasLinearVelocity=!0,o.linearVelocity.copy(r.linearVelocity)):o.hasLinearVelocity=!1,r.angularVelocity?(o.hasAngularVelocity=!0,o.angularVelocity.copy(r.angularVelocity)):o.hasAngularVelocity=!1));null!==s&&(i=t.getPose(e.targetRaySpace,n),null===i&&null!==r&&(i=r),null!==i&&(s.matrix.fromArray(i.transform.matrix),s.matrix.decompose(s.position,s.rotation,s.scale),s.matrixWorldNeedsUpdate=!0,i.linearVelocity?(s.hasLinearVelocity=!0,s.linearVelocity.copy(i.linearVelocity)):s.hasLinearVelocity=!1,i.angularVelocity?(s.hasAngularVelocity=!0,s.angularVelocity.copy(i.angularVelocity)):s.hasAngularVelocity=!1,this.dispatchEvent(_s)))}return null!==s&&(s.visible=null!==i),null!==o&&(o.visible=null!==r),null!==l&&(l.visible=null!==a),this}_getHandJoint(e,t){if(void 0===e.joints[t.jointName]){const n=new gs;n.matrixAutoUpdate=!1,n.visible=!1,e.joints[t.jointName]=n,e.add(n)}return e.joints[t.jointName]}}class xs extends ht{constructor(e,t,n,i,r,a,s,o,l,c){if((c=void 0!==c?c:$)!==$&&c!==ee)throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");void 0===n&&c===$&&(n=Y),void 0===n&&c===ee&&(n=J),super(null,i,r,a,s,o,c,n,l),this.isDepthTexture=!0,this.image={width:e,height:t},this.magFilter=void 0!==s?s:H,this.minFilter=void 0!==o?o:H,this.flipY=!1,this.generateMipmaps=!1,this.compareFunction=null}copy(e){return super.copy(e),this.compareFunction=e.compareFunction,this}toJSON(e){const t=super.toJSON(e);return null!==this.compareFunction&&(t.compareFunction=this.compareFunction),t}}class Ms extends Ue{constructor(e,t){super();const n=this;let i=null,r=1,a=null,s="local-floor",o=1,l=null,c=null,h=null,u=null,d=null,p=null;const f=t.getContextAttributes();let m=null,g=null;const _=[],v=[],x=new Li;x.layers.enable(1),x.viewport=new ut;const M=new Li;M.layers.enable(2),M.viewport=new ut;const S=[x,M],y=new ms;y.layers.enable(1),y.layers.enable(2);let E=null,T=null;function b(e){const t=v.indexOf(e.inputSource);if(-1===t)return;const n=_[t];void 0!==n&&(n.update(e.inputSource,e.frame,l||a),n.dispatchEvent({type:e.type,data:e.inputSource}))}function w(){i.removeEventListener("select",b),i.removeEventListener("selectstart",b),i.removeEventListener("selectend",b),i.removeEventListener("squeeze",b),i.removeEventListener("squeezestart",b),i.removeEventListener("squeezeend",b),i.removeEventListener("end",w),i.removeEventListener("inputsourceschange",A);for(let e=0;e<_.length;e++){const t=v[e];null!==t&&(v[e]=null,_[e].disconnect(t))}E=null,T=null,e.setRenderTarget(m),d=null,u=null,h=null,i=null,g=null,U.stop(),n.isPresenting=!1,n.dispatchEvent({type:"sessionend"})}function A(e){for(let t=0;t<e.removed.length;t++){const n=e.removed[t],i=v.indexOf(n);i>=0&&(v[i]=null,_[i].disconnect(n))}for(let t=0;t<e.added.length;t++){const n=e.added[t];let i=v.indexOf(n);if(-1===i){for(let e=0;e<_.length;e++){if(e>=v.length){v.push(n),i=e;break}if(null===v[e]){v[e]=n,i=e;break}}if(-1===i)break}const r=_[i];r&&r.connect(n)}}this.cameraAutoUpdate=!0,this.enabled=!1,this.isPresenting=!1,this.getController=function(e){let t=_[e];return void 0===t&&(t=new vs,_[e]=t),t.getTargetRaySpace()},this.getControllerGrip=function(e){let t=_[e];return void 0===t&&(t=new vs,_[e]=t),t.getGripSpace()},this.getHand=function(e){let t=_[e];return void 0===t&&(t=new vs,_[e]=t),t.getHandSpace()},this.setFramebufferScaleFactor=function(e){r=e,!0===n.isPresenting&&console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.")},this.setReferenceSpaceType=function(e){s=e,!0===n.isPresenting&&console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.")},this.getReferenceSpace=function(){return l||a},this.setReferenceSpace=function(e){l=e},this.getBaseLayer=function(){return null!==u?u:d},this.getBinding=function(){return h},this.getFrame=function(){return p},this.getSession=function(){return i},this.setSession=async function(c){if(i=c,null!==i){if(m=e.getRenderTarget(),i.addEventListener("select",b),i.addEventListener("selectstart",b),i.addEventListener("selectend",b),i.addEventListener("squeeze",b),i.addEventListener("squeezestart",b),i.addEventListener("squeezeend",b),i.addEventListener("end",w),i.addEventListener("inputsourceschange",A),!0!==f.xrCompatible&&await t.makeXRCompatible(),void 0===i.renderState.layers||!1===e.capabilities.isWebGL2){const n={antialias:void 0!==i.renderState.layers||f.antialias,alpha:!0,depth:f.depth,stencil:f.stencil,framebufferScaleFactor:r};d=new XRWebGLLayer(i,t,n),i.updateRenderState({baseLayer:d}),g=new pt(d.framebufferWidth,d.framebufferHeight,{format:Q,type:j,colorSpace:e.outputColorSpace,stencilBuffer:f.stencil})}else{let n=null,a=null,s=null;f.depth&&(s=f.stencil?t.DEPTH24_STENCIL8:t.DEPTH_COMPONENT24,n=f.stencil?ee:$,a=f.stencil?J:Y);const o={colorFormat:t.RGBA8,depthFormat:s,scaleFactor:r};h=new XRWebGLBinding(i,t),u=h.createProjectionLayer(o),i.updateRenderState({layers:[u]}),g=new pt(u.textureWidth,u.textureHeight,{format:Q,type:j,depthTexture:new xs(u.textureWidth,u.textureHeight,a,void 0,void 0,void 0,void 0,void 0,void 0,n),stencilBuffer:f.stencil,colorSpace:e.outputColorSpace,samples:f.antialias?4:0}),e.properties.get(g).__ignoreDepthValues=u.ignoreDepthValues}g.isXRRenderTarget=!0,this.setFoveation(o),l=null,a=await i.requestReferenceSpace(s),U.setContext(i),U.start(),n.isPresenting=!0,n.dispatchEvent({type:"sessionstart"})}},this.getEnvironmentBlendMode=function(){if(null!==i)return i.environmentBlendMode};const R=new _t,C=new _t;function L(e,t){null===t?e.matrixWorld.copy(e.matrix):e.matrixWorld.multiplyMatrices(t.matrixWorld,e.matrix),e.matrixWorldInverse.copy(e.matrixWorld).invert()}this.updateCamera=function(e){if(null===i)return;y.near=M.near=x.near=e.near,y.far=M.far=x.far=e.far,E===y.near&&T===y.far||(i.updateRenderState({depthNear:y.near,depthFar:y.far}),E=y.near,T=y.far);const t=e.parent,n=y.cameras;L(y,t);for(let e=0;e<n.length;e++)L(n[e],t);2===n.length?function(e,t,n){R.setFromMatrixPosition(t.matrixWorld),C.setFromMatrixPosition(n.matrixWorld);const i=R.distanceTo(C),r=t.projectionMatrix.elements,a=n.projectionMatrix.elements,s=r[14]/(r[10]-1),o=r[14]/(r[10]+1),l=(r[9]+1)/r[5],c=(r[9]-1)/r[5],h=(r[8]-1)/r[0],u=(a[8]+1)/a[0],d=s*h,p=s*u,f=i/(-h+u),m=f*-h;t.matrixWorld.decompose(e.position,e.quaternion,e.scale),e.translateX(m),e.translateZ(f),e.matrixWorld.compose(e.position,e.quaternion,e.scale),e.matrixWorldInverse.copy(e.matrixWorld).invert();const g=s+f,_=o+f,v=d-m,x=p+(i-m),M=l*o/_*g,S=c*o/_*g;e.projectionMatrix.makePerspective(v,x,M,S,g,_),e.projectionMatrixInverse.copy(e.projectionMatrix).invert()}(y,x,M):y.projectionMatrix.copy(x.projectionMatrix),function(e,t,n){null===n?e.matrix.copy(t.matrixWorld):(e.matrix.copy(n.matrixWorld),e.matrix.invert(),e.matrix.multiply(t.matrixWorld)),e.matrix.decompose(e.position,e.quaternion,e.scale),e.updateMatrixWorld(!0),e.projectionMatrix.copy(t.projectionMatrix),e.projectionMatrixInverse.copy(t.projectionMatrixInverse),e.isPerspectiveCamera&&(e.fov=2*Ie*Math.atan(1/e.projectionMatrix.elements[5]),e.zoom=1)}(e,y,t)},this.getCamera=function(){return y},this.getFoveation=function(){if(null!==u||null!==d)return o},this.setFoveation=function(e){o=e,null!==u&&(u.fixedFoveation=e),null!==d&&void 0!==d.fixedFoveation&&(d.fixedFoveation=e)};let P=null;const U=new Gi;U.setAnimationLoop((function(t,i){if(c=i.getViewerPose(l||a),p=i,null!==c){const t=c.views;null!==d&&(e.setRenderTargetFramebuffer(g,d.framebuffer),e.setRenderTarget(g));let n=!1;t.length!==y.cameras.length&&(y.cameras.length=0,n=!0);for(let i=0;i<t.length;i++){const r=t[i];let a=null;if(null!==d)a=d.getViewport(r);else{const t=h.getViewSubImage(u,r);a=t.viewport,0===i&&(e.setRenderTargetTextures(g,t.colorTexture,u.ignoreDepthValues?void 0:t.depthStencilTexture),e.setRenderTarget(g))}let s=S[i];void 0===s&&(s=new Li,s.layers.enable(i),s.viewport=new ut,S[i]=s),s.matrix.fromArray(r.transform.matrix),s.matrix.decompose(s.position,s.quaternion,s.scale),s.projectionMatrix.fromArray(r.projectionMatrix),s.projectionMatrixInverse.copy(s.projectionMatrix).invert(),s.viewport.set(a.x,a.y,a.width,a.height),0===i&&(y.matrix.copy(s.matrix),y.matrix.decompose(y.position,y.quaternion,y.scale)),!0===n&&y.cameras.push(s)}}for(let e=0;e<_.length;e++){const t=v[e],n=_[e];null!==t&&void 0!==n&&n.update(t,i,l||a)}P&&P(t,i),i.detectedPlanes&&n.dispatchEvent({type:"planesdetected",data:i}),p=null})),this.setAnimationLoop=function(e){P=e},this.dispose=function(){}}}function Ss(e,t){function n(e,t){!0===e.matrixAutoUpdate&&e.updateMatrix(),t.value.copy(e.matrix)}function i(i,r){i.opacity.value=r.opacity,r.color&&i.diffuse.value.copy(r.color),r.emissive&&i.emissive.value.copy(r.emissive).multiplyScalar(r.emissiveIntensity),r.map&&(i.map.value=r.map,n(r.map,i.mapTransform)),r.alphaMap&&(i.alphaMap.value=r.alphaMap,n(r.alphaMap,i.alphaMapTransform)),r.bumpMap&&(i.bumpMap.value=r.bumpMap,n(r.bumpMap,i.bumpMapTransform),i.bumpScale.value=r.bumpScale,1===r.side&&(i.bumpScale.value*=-1)),r.normalMap&&(i.normalMap.value=r.normalMap,n(r.normalMap,i.normalMapTransform),i.normalScale.value.copy(r.normalScale),1===r.side&&i.normalScale.value.negate()),r.displacementMap&&(i.displacementMap.value=r.displacementMap,n(r.displacementMap,i.displacementMapTransform),i.displacementScale.value=r.displacementScale,i.displacementBias.value=r.displacementBias),r.emissiveMap&&(i.emissiveMap.value=r.emissiveMap,n(r.emissiveMap,i.emissiveMapTransform)),r.specularMap&&(i.specularMap.value=r.specularMap,n(r.specularMap,i.specularMapTransform)),r.alphaTest>0&&(i.alphaTest.value=r.alphaTest);const a=t.get(r).envMap;if(a&&(i.envMap.value=a,i.flipEnvMap.value=a.isCubeTexture&&!1===a.isRenderTargetTexture?-1:1,i.reflectivity.value=r.reflectivity,i.ior.value=r.ior,i.refractionRatio.value=r.refractionRatio),r.lightMap){i.lightMap.value=r.lightMap;const t=!0===e._useLegacyLights?Math.PI:1;i.lightMapIntensity.value=r.lightMapIntensity*t,n(r.lightMap,i.lightMapTransform)}r.aoMap&&(i.aoMap.value=r.aoMap,i.aoMapIntensity.value=r.aoMapIntensity,n(r.aoMap,i.aoMapTransform))}return{refreshFogUniforms:function(t,n){n.color.getRGB(t.fogColor.value,wi(e)),n.isFog?(t.fogNear.value=n.near,t.fogFar.value=n.far):n.isFogExp2&&(t.fogDensity.value=n.density)},refreshMaterialUniforms:function(e,r,a,s,o){r.isMeshBasicMaterial||r.isMeshLambertMaterial?i(e,r):r.isMeshToonMaterial?(i(e,r),function(e,t){t.gradientMap&&(e.gradientMap.value=t.gradientMap)}(e,r)):r.isMeshPhongMaterial?(i(e,r),function(e,t){e.specular.value.copy(t.specular),e.shininess.value=Math.max(t.shininess,1e-4)}(e,r)):r.isMeshStandardMaterial?(i(e,r),function(e,i){e.metalness.value=i.metalness,i.metalnessMap&&(e.metalnessMap.value=i.metalnessMap,n(i.metalnessMap,e.metalnessMapTransform)),e.roughness.value=i.roughness,i.roughnessMap&&(e.roughnessMap.value=i.roughnessMap,n(i.roughnessMap,e.roughnessMapTransform));t.get(i).envMap&&(e.envMapIntensity.value=i.envMapIntensity)}(e,r),r.isMeshPhysicalMaterial&&function(e,t,i){e.ior.value=t.ior,t.sheen>0&&(e.sheenColor.value.copy(t.sheenColor).multiplyScalar(t.sheen),e.sheenRoughness.value=t.sheenRoughness,t.sheenColorMap&&(e.sheenColorMap.value=t.sheenColorMap,n(t.sheenColorMap,e.sheenColorMapTransform)),t.sheenRoughnessMap&&(e.sheenRoughnessMap.value=t.sheenRoughnessMap,n(t.sheenRoughnessMap,e.sheenRoughnessMapTransform))),t.clearcoat>0&&(e.clearcoat.value=t.clearcoat,e.clearcoatRoughness.value=t.clearcoatRoughness,t.clearcoatMap&&(e.clearcoatMap.value=t.clearcoatMap,n(t.clearcoatMap,e.clearcoatMapTransform)),t.clearcoatRoughnessMap&&(e.clearcoatRoughnessMap.value=t.clearcoatRoughnessMap,n(t.clearcoatRoughnessMap,e.clearcoatRoughnessMapTransform)),t.clearcoatNormalMap&&(e.clearcoatNormalMap.value=t.clearcoatNormalMap,n(t.clearcoatNormalMap,e.clearcoatNormalMapTransform),e.clearcoatNormalScale.value.copy(t.clearcoatNormalScale),1===t.side&&e.clearcoatNormalScale.value.negate())),t.iridescence>0&&(e.iridescence.value=t.iridescence,e.iridescenceIOR.value=t.iridescenceIOR,e.iridescenceThicknessMinimum.value=t.iridescenceThicknessRange[0],e.iridescenceThicknessMaximum.value=t.iridescenceThicknessRange[1],t.iridescenceMap&&(e.iridescenceMap.value=t.iridescenceMap,n(t.iridescenceMap,e.iridescenceMapTransform)),t.iridescenceThicknessMap&&(e.iridescenceThicknessMap.value=t.iridescenceThicknessMap,n(t.iridescenceThicknessMap,e.iridescenceThicknessMapTransform))),t.transmission>0&&(e.transmission.value=t.transmission,e.transmissionSamplerMap.value=i.texture,e.transmissionSamplerSize.value.set(i.width,i.height),t.transmissionMap&&(e.transmissionMap.value=t.transmissionMap,n(t.transmissionMap,e.transmissionMapTransform)),e.thickness.value=t.thickness,t.thicknessMap&&(e.thicknessMap.value=t.thicknessMap,n(t.thicknessMap,e.thicknessMapTransform)),e.attenuationDistance.value=t.attenuationDistance,e.attenuationColor.value.copy(t.attenuationColor)),t.anisotropy>0&&(e.anisotropyVector.value.set(t.anisotropy*Math.cos(t.anisotropyRotation),t.anisotropy*Math.sin(t.anisotropyRotation)),t.anisotropyMap&&(e.anisotropyMap.value=t.anisotropyMap,n(t.anisotropyMap,e.anisotropyMapTransform))),e.specularIntensity.value=t.specularIntensity,e.specularColor.value.copy(t.specularColor),t.specularColorMap&&(e.specularColorMap.value=t.specularColorMap,n(t.specularColorMap,e.specularColorMapTransform)),t.specularIntensityMap&&(e.specularIntensityMap.value=t.specularIntensityMap,n(t.specularIntensityMap,e.specularIntensityMapTransform))}(e,r,o)):r.isMeshMatcapMaterial?(i(e,r),function(e,t){t.matcap&&(e.matcap.value=t.matcap)}(e,r)):r.isMeshDepthMaterial?i(e,r):r.isMeshDistanceMaterial?(i(e,r),function(e,n){const i=t.get(n).light;e.referencePosition.value.setFromMatrixPosition(i.matrixWorld),e.nearDistance.value=i.shadow.camera.near,e.farDistance.value=i.shadow.camera.far}(e,r)):r.isMeshNormalMaterial?i(e,r):r.isLineBasicMaterial?(function(e,t){e.diffuse.value.copy(t.color),e.opacity.value=t.opacity,t.map&&(e.map.value=t.map,n(t.map,e.mapTransform))}(e,r),r.isLineDashedMaterial&&function(e,t){e.dashSize.value=t.dashSize,e.totalSize.value=t.dashSize+t.gapSize,e.scale.value=t.scale}(e,r)):r.isPointsMaterial?function(e,t,i,r){e.diffuse.value.copy(t.color),e.opacity.value=t.opacity,e.size.value=t.size*i,e.scale.value=.5*r,t.map&&(e.map.value=t.map,n(t.map,e.uvTransform)),t.alphaMap&&(e.alphaMap.value=t.alphaMap,n(t.alphaMap,e.alphaMapTransform)),t.alphaTest>0&&(e.alphaTest.value=t.alphaTest)}(e,r,a,s):r.isSpriteMaterial?function(e,t){e.diffuse.value.copy(t.color),e.opacity.value=t.opacity,e.rotation.value=t.rotation,t.map&&(e.map.value=t.map,n(t.map,e.mapTransform)),t.alphaMap&&(e.alphaMap.value=t.alphaMap,n(t.alphaMap,e.alphaMapTransform)),t.alphaTest>0&&(e.alphaTest.value=t.alphaTest)}(e,r):r.isShadowMaterial?(e.color.value.copy(r.color),e.opacity.value=r.opacity):r.isShaderMaterial&&(r.uniformsNeedUpdate=!1)}}}function ys(e,t,n,i){let r={},a={},s=[];const o=n.isWebGL2?e.getParameter(e.MAX_UNIFORM_BUFFER_BINDINGS):0;function l(e,t,n){const i=e.value;if(void 0===n[t]){if("number"==typeof i)n[t]=i;else{const e=Array.isArray(i)?i:[i],r=[];for(let t=0;t<e.length;t++)r.push(e[t].clone());n[t]=r}return!0}if("number"==typeof i){if(n[t]!==i)return n[t]=i,!0}else{const e=Array.isArray(n[t])?n[t]:[n[t]],r=Array.isArray(i)?i:[i];for(let t=0;t<e.length;t++){const n=e[t];if(!1===n.equals(r[t]))return n.copy(r[t]),!0}}return!1}function c(e){const t={boundary:0,storage:0};return"number"==typeof e?(t.boundary=4,t.storage=4):e.isVector2?(t.boundary=8,t.storage=8):e.isVector3||e.isColor?(t.boundary=16,t.storage=12):e.isVector4?(t.boundary=16,t.storage=16):e.isMatrix3?(t.boundary=48,t.storage=48):e.isMatrix4?(t.boundary=64,t.storage=64):e.isTexture?console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group."):console.warn("THREE.WebGLRenderer: Unsupported uniform value type.",e),t}function h(t){const n=t.target;n.removeEventListener("dispose",h);const i=s.indexOf(n.__bindingPointIndex);s.splice(i,1),e.deleteBuffer(r[n.id]),delete r[n.id],delete a[n.id]}return{bind:function(e,t){const n=t.program;i.uniformBlockBinding(e,n)},update:function(n,u){let d=r[n.id];void 0===d&&(function(e){const t=e.uniforms;let n=0;let i=0;for(let e=0,r=t.length;e<r;e++){const r=t[e],a={boundary:0,storage:0},s=Array.isArray(r.value)?r.value:[r.value];for(let e=0,t=s.length;e<t;e++){const t=c(s[e]);a.boundary+=t.boundary,a.storage+=t.storage}r.__data=new Float32Array(a.storage/Float32Array.BYTES_PER_ELEMENT),r.__offset=n,e>0&&(i=n%16,0!==i&&16-i-a.boundary<0&&(n+=16-i,r.__offset=n)),n+=a.storage}i=n%16,i>0&&(n+=16-i),e.__size=n,e.__cache={}}(n),d=function(t){const n=function(){for(let e=0;e<o;e++)if(-1===s.indexOf(e))return s.push(e),e;return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."),0}();t.__bindingPointIndex=n;const i=e.createBuffer(),r=t.__size,a=t.usage;return e.bindBuffer(e.UNIFORM_BUFFER,i),e.bufferData(e.UNIFORM_BUFFER,r,a),e.bindBuffer(e.UNIFORM_BUFFER,null),e.bindBufferBase(e.UNIFORM_BUFFER,n,i),i}(n),r[n.id]=d,n.addEventListener("dispose",h));const p=u.program;i.updateUBOMapping(n,p);const f=t.render.frame;a[n.id]!==f&&(function(t){const n=r[t.id],i=t.uniforms,a=t.__cache;e.bindBuffer(e.UNIFORM_BUFFER,n);for(let t=0,n=i.length;t<n;t++){const n=i[t];if(!0===l(n,t,a)){const t=n.__offset,i=Array.isArray(n.value)?n.value:[n.value];let r=0;for(let a=0;a<i.length;a++){const s=i[a],o=c(s);"number"==typeof s?(n.__data[0]=s,e.bufferSubData(e.UNIFORM_BUFFER,t+r,n.__data)):s.isMatrix3?(n.__data[0]=s.elements[0],n.__data[1]=s.elements[1],n.__data[2]=s.elements[2],n.__data[3]=s.elements[0],n.__data[4]=s.elements[3],n.__data[5]=s.elements[4],n.__data[6]=s.elements[5],n.__data[7]=s.elements[0],n.__data[8]=s.elements[6],n.__data[9]=s.elements[7],n.__data[10]=s.elements[8],n.__data[11]=s.elements[0]):(s.toArray(n.__data,r),r+=o.storage/Float32Array.BYTES_PER_ELEMENT)}e.bufferSubData(e.UNIFORM_BUFFER,t,n.__data)}}e.bindBuffer(e.UNIFORM_BUFFER,null)}(n),a[n.id]=f)},dispose:function(){for(const t in r)e.deleteBuffer(r[t]);s=[],r={},a={}}}}class Es{constructor(){let t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const{canvas:n=Ye(),context:i=null,depth:r=!0,stencil:a=!0,alpha:s=!1,antialias:o=!1,premultipliedAlpha:l=!0,preserveDrawingBuffer:c=!1,powerPreference:h="default",failIfMajorPerformanceCaveat:u=!1}=t;let d;this.isWebGLRenderer=!0,d=null!==i?i.getContextAttributes().alpha:s;const p=new Uint32Array(4),f=new Int32Array(4);let m=null,g=null;const _=[],v=[];this.domElement=n,this.debug={checkShaderErrors:!0,onShaderError:null},this.autoClear=!0,this.autoClearColor=!0,this.autoClearDepth=!0,this.autoClearStencil=!0,this.sortObjects=!0,this.clippingPlanes=[],this.localClippingEnabled=!1,this._outputColorSpace=ue,this._useLegacyLights=!1,this.toneMapping=R,this.toneMappingExposure=1;const x=this;let M=!1,S=0,y=0,E=null,T=-1,b=null;const w=new ut,A=new ut;let C=null;const L=new On(0);let P=0,U=n.width,D=n.height,N=1,I=null,O=null;const F=new ut(0,0,U,D),z=new ut(0,0,U,D);let B=!1;const H=new Vi;let V=!1,G=!1,k=null;const W=new qt,$=new ke,ee=new _t,te={background:null,fog:null,environment:null,overrideMaterial:null,isScene:!0};function ne(){return null===E?N:1}let ie,re,ae,se,oe,le,ce,he,pe,fe,me,ge,_e,ve,xe,Me,Se,ye,Ee,Te,be,we,Ae,Re,Ce=i;function Le(e,t){for(let i=0;i<e.length;i++){const r=e[i],a=n.getContext(r,t);if(null!==a)return a}return null}try{const t={alpha:!0,depth:r,stencil:a,antialias:o,premultipliedAlpha:l,preserveDrawingBuffer:c,powerPreference:h,failIfMajorPerformanceCaveat:u};if("setAttribute"in n&&n.setAttribute("data-engine","three.js r".concat(e)),n.addEventListener("webglcontextlost",De,!1),n.addEventListener("webglcontextrestored",Ne,!1),n.addEventListener("webglcontextcreationerror",Ie,!1),null===Ce){const e=["webgl2","webgl","experimental-webgl"];if(!0===x.isWebGL1Renderer&&e.shift(),Ce=Le(e,t),null===Ce)throw Le(e)?new Error("Error creating WebGL context with your selected attributes."):new Error("Error creating WebGL context.")}"undefined"!=typeof WebGLRenderingContext&&Ce instanceof WebGLRenderingContext&&console.warn("THREE.WebGLRenderer: WebGL 1 support was deprecated in r153 and will be removed in r163."),void 0===Ce.getShaderPrecisionFormat&&(Ce.getShaderPrecisionFormat=function(){return{rangeMin:1,rangeMax:1,precision:1}})}catch(e){throw console.error("THREE.WebGLRenderer: "+e.message),e}function Pe(){ie=new vr(Ce),re=new Qi(Ce,ie,t),ie.init(re),we=new fs(Ce,ie,re),ae=new ds(Ce,ie,re),se=new Sr(Ce),oe=new Qa,le=new ps(Ce,ie,ae,oe,re,we,se),ce=new er(x),he=new _r(x),pe=new ki(Ce,re),Ae=new Zi(Ce,ie,pe,re),fe=new xr(Ce,pe,se,Ae),me=new br(Ce,fe,pe,se),Ee=new Tr(Ce,re,le),Me=new $i(oe),ge=new Ja(x,ce,he,ie,re,Ae,Me),_e=new Ss(x,oe),ve=new ns,xe=new ls(ie,re),ye=new Ki(x,ce,he,ae,me,d,l),Se=new us(x,me,re),Re=new ys(Ce,se,re,ae),Te=new Ji(Ce,ie,se,re),be=new Mr(Ce,ie,se,re),se.programs=ge.programs,x.capabilities=re,x.extensions=ie,x.properties=oe,x.renderLists=ve,x.shadowMap=Se,x.state=ae,x.info=se}Pe();const Ue=new Ms(x,Ce);function De(e){e.preventDefault(),console.log("THREE.WebGLRenderer: Context Lost."),M=!0}function Ne(){console.log("THREE.WebGLRenderer: Context Restored."),M=!1;const e=se.autoReset,t=Se.enabled,n=Se.autoUpdate,i=Se.needsUpdate,r=Se.type;Pe(),se.autoReset=e,Se.enabled=t,Se.autoUpdate=n,Se.needsUpdate=i,Se.type=r}function Ie(e){console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ",e.statusMessage)}function Oe(e){const t=e.target;t.removeEventListener("dispose",Oe),function(e){(function(e){const t=oe.get(e).programs;void 0!==t&&(t.forEach((function(e){ge.releaseProgram(e)})),e.isShaderMaterial&&ge.releaseShaderCache(e))})(e),oe.remove(e)}(t)}function Fe(e,t,n){!0===e.transparent&&2===e.side&&!1===e.forceSinglePass?(e.side=1,e.needsUpdate=!0,Ke(e,t,n),e.side=0,e.needsUpdate=!0,Ke(e,t,n),e.side=2):Ke(e,t,n)}this.xr=Ue,this.getContext=function(){return Ce},this.getContextAttributes=function(){return Ce.getContextAttributes()},this.forceContextLoss=function(){const e=ie.get("WEBGL_lose_context");e&&e.loseContext()},this.forceContextRestore=function(){const e=ie.get("WEBGL_lose_context");e&&e.restoreContext()},this.getPixelRatio=function(){return N},this.setPixelRatio=function(e){void 0!==e&&(N=e,this.setSize(U,D,!1))},this.getSize=function(e){return e.set(U,D)},this.setSize=function(e,t){let i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];Ue.isPresenting?console.warn("THREE.WebGLRenderer: Can\'t change size while VR device is presenting."):(U=e,D=t,n.width=Math.floor(e*N),n.height=Math.floor(t*N),!0===i&&(n.style.width=e+"px",n.style.height=t+"px"),this.setViewport(0,0,e,t))},this.getDrawingBufferSize=function(e){return e.set(U*N,D*N).floor()},this.setDrawingBufferSize=function(e,t,i){U=e,D=t,N=i,n.width=Math.floor(e*i),n.height=Math.floor(t*i),this.setViewport(0,0,e,t)},this.getCurrentViewport=function(e){return e.copy(w)},this.getViewport=function(e){return e.copy(F)},this.setViewport=function(e,t,n,i){e.isVector4?F.set(e.x,e.y,e.z,e.w):F.set(e,t,n,i),ae.viewport(w.copy(F).multiplyScalar(N).floor())},this.getScissor=function(e){return e.copy(z)},this.setScissor=function(e,t,n,i){e.isVector4?z.set(e.x,e.y,e.z,e.w):z.set(e,t,n,i),ae.scissor(A.copy(z).multiplyScalar(N).floor())},this.getScissorTest=function(){return B},this.setScissorTest=function(e){ae.setScissorTest(B=e)},this.setOpaqueSort=function(e){I=e},this.setTransparentSort=function(e){O=e},this.getClearColor=function(e){return e.copy(ye.getClearColor())},this.setClearColor=function(){ye.setClearColor.apply(ye,arguments)},this.getClearAlpha=function(){return ye.getClearAlpha()},this.setClearAlpha=function(){ye.setClearAlpha.apply(ye,arguments)},this.clear=function(){let e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],t=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],n=0;if(!(arguments.length>0&&void 0!==arguments[0])||arguments[0]){let e=!1;if(null!==E){const t=E.texture.format;e=1033===t||1031===t||1029===t}if(e){const e=E.texture.type,t=e===j||e===Y||e===q||e===J||1017===e||1018===e,n=ye.getClearColor(),i=ye.getClearAlpha(),r=n.r,a=n.g,s=n.b;t?(p[0]=r,p[1]=a,p[2]=s,p[3]=i,Ce.clearBufferuiv(Ce.COLOR,0,p)):(f[0]=r,f[1]=a,f[2]=s,f[3]=i,Ce.clearBufferiv(Ce.COLOR,0,f))}else n|=Ce.COLOR_BUFFER_BIT}e&&(n|=Ce.DEPTH_BUFFER_BIT),t&&(n|=Ce.STENCIL_BUFFER_BIT,this.state.buffers.stencil.setMask(4294967295)),Ce.clear(n)},this.clearColor=function(){this.clear(!0,!1,!1)},this.clearDepth=function(){this.clear(!1,!0,!1)},this.clearStencil=function(){this.clear(!1,!1,!0)},this.dispose=function(){n.removeEventListener("webglcontextlost",De,!1),n.removeEventListener("webglcontextrestored",Ne,!1),n.removeEventListener("webglcontextcreationerror",Ie,!1),ve.dispose(),xe.dispose(),oe.dispose(),ce.dispose(),he.dispose(),me.dispose(),Ae.dispose(),Re.dispose(),ge.dispose(),Ue.dispose(),Ue.removeEventListener("sessionstart",Be),Ue.removeEventListener("sessionend",Ve),k&&(k.dispose(),k=null),Ge.stop()},this.renderBufferDirect=function(e,t,n,i,r,a){null===t&&(t=te);const s=r.isMesh&&r.matrixWorld.determinant()<0,o=function(e,t,n,i,r){!0!==t.isScene&&(t=te),le.resetTextureUnits();const a=t.fog,s=i.isMeshStandardMaterial?t.environment:null,o=null===E?x.outputColorSpace:!0===E.isXRRenderTarget?E.texture.colorSpace:de,l=(i.isMeshStandardMaterial?he:ce).get(i.envMap||s),c=!0===i.vertexColors&&!!n.attributes.color&&4===n.attributes.color.itemSize,h=!!n.attributes.tangent&&(!!i.normalMap||i.anisotropy>0),u=!!n.morphAttributes.position,d=!!n.morphAttributes.normal,p=!!n.morphAttributes.color;let f=R;i.toneMapped&&(null!==E&&!0!==E.isXRRenderTarget||(f=x.toneMapping));const m=n.morphAttributes.position||n.morphAttributes.normal||n.morphAttributes.color,_=void 0!==m?m.length:0,v=oe.get(i),M=g.state.lights;if(!0===V&&(!0===G||e!==b)){const t=e===b&&i.id===T;Me.setState(i,e,t)}let S=!1;i.version===v.__version?v.needsLights&&v.lightsStateVersion!==M.state.version||v.outputColorSpace!==o||r.isInstancedMesh&&!1===v.instancing?S=!0:r.isInstancedMesh||!0!==v.instancing?r.isSkinnedMesh&&!1===v.skinning?S=!0:r.isSkinnedMesh||!0!==v.skinning?r.isInstancedMesh&&!0===v.instancingColor&&null===r.instanceColor||r.isInstancedMesh&&!1===v.instancingColor&&null!==r.instanceColor||v.envMap!==l||!0===i.fog&&v.fog!==a?S=!0:void 0===v.numClippingPlanes||v.numClippingPlanes===Me.numPlanes&&v.numIntersection===Me.numIntersection?(v.vertexAlphas!==c||v.vertexTangents!==h||v.morphTargets!==u||v.morphNormals!==d||v.morphColors!==p||v.toneMapping!==f||!0===re.isWebGL2&&v.morphTargetsCount!==_)&&(S=!0):S=!0:S=!0:S=!0:(S=!0,v.__version=i.version);let y=v.currentProgram;!0===S&&(y=Ke(i,t,r));let w=!1,A=!1,C=!1;const L=y.getUniforms(),P=v.uniforms;if(ae.useProgram(y.program)&&(w=!0,A=!0,C=!0),i.id!==T&&(T=i.id,A=!0),w||b!==e){L.setValue(Ce,"projectionMatrix",e.projectionMatrix),L.setValue(Ce,"viewMatrix",e.matrixWorldInverse);const t=L.map.cameraPosition;void 0!==t&&t.setValue(Ce,ee.setFromMatrixPosition(e.matrixWorld)),re.logarithmicDepthBuffer&&L.setValue(Ce,"logDepthBufFC",2/(Math.log(e.far+1)/Math.LN2)),(i.isMeshPhongMaterial||i.isMeshToonMaterial||i.isMeshLambertMaterial||i.isMeshBasicMaterial||i.isMeshStandardMaterial||i.isShaderMaterial)&&L.setValue(Ce,"isOrthographic",!0===e.isOrthographicCamera),b!==e&&(b=e,A=!0,C=!0)}if(r.isSkinnedMesh){L.setOptional(Ce,r,"bindMatrix"),L.setOptional(Ce,r,"bindMatrixInverse");const e=r.skeleton;e&&(re.floatVertexTextures?(null===e.boneTexture&&e.computeBoneTexture(),L.setValue(Ce,"boneTexture",e.boneTexture,le),L.setValue(Ce,"boneTextureSize",e.boneTextureSize)):console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."))}const U=n.morphAttributes;var I,O;if((void 0!==U.position||void 0!==U.normal||void 0!==U.color&&!0===re.isWebGL2)&&Ee.update(r,n,y),(A||v.receiveShadow!==r.receiveShadow)&&(v.receiveShadow=r.receiveShadow,L.setValue(Ce,"receiveShadow",r.receiveShadow)),i.isMeshGouraudMaterial&&null!==i.envMap&&(P.envMap.value=l,P.flipEnvMap.value=l.isCubeTexture&&!1===l.isRenderTargetTexture?-1:1),A&&(L.setValue(Ce,"toneMappingExposure",x.toneMappingExposure),v.needsLights&&(O=C,(I=P).ambientLightColor.needsUpdate=O,I.lightProbe.needsUpdate=O,I.directionalLights.needsUpdate=O,I.directionalLightShadows.needsUpdate=O,I.pointLights.needsUpdate=O,I.pointLightShadows.needsUpdate=O,I.spotLights.needsUpdate=O,I.spotLightShadows.needsUpdate=O,I.rectAreaLights.needsUpdate=O,I.hemisphereLights.needsUpdate=O),a&&!0===i.fog&&_e.refreshFogUniforms(P,a),_e.refreshMaterialUniforms(P,i,N,D,k),Ca.upload(Ce,Ze(v),P,le)),i.isShaderMaterial&&!0===i.uniformsNeedUpdate&&(Ca.upload(Ce,Ze(v),P,le),i.uniformsNeedUpdate=!1),i.isSpriteMaterial&&L.setValue(Ce,"center",r.center),L.setValue(Ce,"modelViewMatrix",r.modelViewMatrix),L.setValue(Ce,"normalMatrix",r.normalMatrix),L.setValue(Ce,"modelMatrix",r.matrixWorld),i.isShaderMaterial||i.isRawShaderMaterial){const e=i.uniformsGroups;for(let t=0,n=e.length;t<n;t++)if(re.isWebGL2){const n=e[t];Re.update(n,y),Re.bind(n,y)}else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.")}return y}(e,t,n,i,r);ae.setMaterial(i,s);let l=n.index,c=1;if(!0===i.wireframe){if(l=fe.getWireframeAttribute(n),void 0===l)return;c=2}const h=n.drawRange,u=n.attributes.position;let d=h.start*c,p=(h.start+h.count)*c;null!==a&&(d=Math.max(d,a.start*c),p=Math.min(p,(a.start+a.count)*c)),null!==l?(d=Math.max(d,0),p=Math.min(p,l.count)):null!=u&&(d=Math.max(d,0),p=Math.min(p,u.count));const f=p-d;if(f<0||f===1/0)return;let m;Ae.setup(r,i,o,n,l);let _=Te;if(null!==l&&(m=pe.get(l),_=be,_.setIndex(m)),r.isMesh)!0===i.wireframe?(ae.setLineWidth(i.wireframeLinewidth*ne()),_.setMode(Ce.LINES)):_.setMode(Ce.TRIANGLES);else if(r.isLine){let e=i.linewidth;void 0===e&&(e=1),ae.setLineWidth(e*ne()),r.isLineSegments?_.setMode(Ce.LINES):r.isLineLoop?_.setMode(Ce.LINE_LOOP):_.setMode(Ce.LINE_STRIP)}else r.isPoints?_.setMode(Ce.POINTS):r.isSprite&&_.setMode(Ce.TRIANGLES);if(r.isInstancedMesh)_.renderInstances(d,f,r.count);else if(n.isInstancedBufferGeometry){const e=void 0!==n._maxInstanceCount?n._maxInstanceCount:1/0,t=Math.min(n.instanceCount,e);_.renderInstances(d,f,t)}else _.render(d,f)},this.compile=function(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;null===n&&(n=e),g=xe.get(n),g.init(),v.push(g),n.traverseVisible((function(e){e.isLight&&e.layers.test(t.layers)&&(g.pushLight(e),e.castShadow&&g.pushShadow(e))})),e!==n&&e.traverseVisible((function(e){e.isLight&&e.layers.test(t.layers)&&(g.pushLight(e),e.castShadow&&g.pushShadow(e))})),g.setupLights(x._useLegacyLights);const i=new Set;return e.traverse((function(e){const t=e.material;if(t)if(Array.isArray(t))for(let r=0;r<t.length;r++){const a=t[r];Fe(a,n,e),i.add(a)}else Fe(t,n,e),i.add(t)})),v.pop(),g=null,i},this.compileAsync=function(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;const i=this.compile(e,t,n);return new Promise((t=>{function n(){i.forEach((function(e){oe.get(e).currentProgram.isReady()&&i.delete(e)})),0!==i.size?setTimeout(n,10):t(e)}null!==ie.get("KHR_parallel_shader_compile")?n():setTimeout(n,10)}))};let ze=null;function Be(){Ge.stop()}function Ve(){Ge.start()}const Ge=new Gi;function We(e,t,n,i){if(!1===e.visible)return;if(e.layers.test(t.layers))if(e.isGroup)n=e.renderOrder;else if(e.isLOD)!0===e.autoUpdate&&e.update(t);else if(e.isLight)g.pushLight(e),e.castShadow&&g.pushShadow(e);else if(e.isSprite){if(!e.frustumCulled||H.intersectsSprite(e)){i&&ee.setFromMatrixPosition(e.matrixWorld).applyMatrix4(W);const t=me.update(e),r=e.material;r.visible&&m.push(e,t,r,n,ee.z,null)}}else if((e.isMesh||e.isLine||e.isPoints)&&(!e.frustumCulled||H.intersectsObject(e))){const t=me.update(e),r=e.material;if(i&&(void 0!==e.boundingSphere?(null===e.boundingSphere&&e.computeBoundingSphere(),ee.copy(e.boundingSphere.center)):(null===t.boundingSphere&&t.computeBoundingSphere(),ee.copy(t.boundingSphere.center)),ee.applyMatrix4(e.matrixWorld).applyMatrix4(W)),Array.isArray(r)){const i=t.groups;for(let a=0,s=i.length;a<s;a++){const s=i[a],o=r[s.materialIndex];o&&o.visible&&m.push(e,t,o,n,ee.z,s)}}else r.visible&&m.push(e,t,r,n,ee.z,null)}const r=e.children;for(let e=0,a=r.length;e<a;e++)We(r[e],t,n,i)}function Xe(e,t,n,i){const r=e.opaque,a=e.transmissive,s=e.transparent;g.setupLightsView(n),!0===V&&Me.setGlobalState(x.clippingPlanes,n),a.length>0&&function(e,t,n,i){if(null!==(!0===n.isScene?n.overrideMaterial:null))return;const r=re.isWebGL2;null===k&&(k=new pt(1,1,{generateMipmaps:!0,type:ie.has("EXT_color_buffer_half_float")?Z:j,minFilter:X,samples:r?4:0})),x.getDrawingBufferSize($),r?k.setSize($.x,$.y):k.setSize(He($.x),He($.y));const a=x.getRenderTarget();x.setRenderTarget(k),x.getClearColor(L),P=x.getClearAlpha(),P<1&&x.setClearColor(16777215,.5),x.clear();const s=x.toneMapping;x.toneMapping=R,je(e,n,i),le.updateMultisampleRenderTarget(k),le.updateRenderTargetMipmap(k);let o=!1;for(let e=0,r=t.length;e<r;e++){const r=t[e],a=r.object,s=r.geometry,l=r.material,c=r.group;if(2===l.side&&a.layers.test(i.layers)){const e=l.side;l.side=1,l.needsUpdate=!0,qe(a,n,i,s,l,c),l.side=e,l.needsUpdate=!0,o=!0}}!0===o&&(le.updateMultisampleRenderTarget(k),le.updateRenderTargetMipmap(k)),x.setRenderTarget(a),x.setClearColor(L,P),x.toneMapping=s}(r,a,t,n),i&&ae.viewport(w.copy(i)),r.length>0&&je(r,t,n),a.length>0&&je(a,t,n),s.length>0&&je(s,t,n),ae.buffers.depth.setTest(!0),ae.buffers.depth.setMask(!0),ae.buffers.color.setMask(!0),ae.setPolygonOffset(!1)}function je(e,t,n){const i=!0===t.isScene?t.overrideMaterial:null;for(let r=0,a=e.length;r<a;r++){const a=e[r],s=a.object,o=a.geometry,l=null===i?a.material:i,c=a.group;s.layers.test(n.layers)&&qe(s,t,n,o,l,c)}}function qe(e,t,n,i,r,a){e.onBeforeRender(x,t,n,i,r,a),e.modelViewMatrix.multiplyMatrices(n.matrixWorldInverse,e.matrixWorld),e.normalMatrix.getNormalMatrix(e.modelViewMatrix),r.onBeforeRender(x,t,n,i,e,a),!0===r.transparent&&2===r.side&&!1===r.forceSinglePass?(r.side=1,r.needsUpdate=!0,x.renderBufferDirect(n,t,i,r,e,a),r.side=0,r.needsUpdate=!0,x.renderBufferDirect(n,t,i,r,e,a),r.side=2):x.renderBufferDirect(n,t,i,r,e,a),e.onAfterRender(x,t,n,i,r,a)}function Ke(e,t,n){!0!==t.isScene&&(t=te);const i=oe.get(e),r=g.state.lights,a=g.state.shadowsArray,s=r.state.version,o=ge.getParameters(e,r.state,a,t,n),l=ge.getProgramCacheKey(o);let c=i.programs;i.environment=e.isMeshStandardMaterial?t.environment:null,i.fog=t.fog,i.envMap=(e.isMeshStandardMaterial?he:ce).get(e.envMap||i.environment),void 0===c&&(e.addEventListener("dispose",Oe),c=new Map,i.programs=c);let h=c.get(l);if(void 0!==h){if(i.currentProgram===h&&i.lightsStateVersion===s)return Je(e,o),h}else o.uniforms=ge.getUniforms(e),e.onBuild(n,o,x),e.onBeforeCompile(o,x),h=ge.acquireProgram(o,l),c.set(l,h),i.uniforms=o.uniforms;const u=i.uniforms;return(e.isShaderMaterial||e.isRawShaderMaterial)&&!0!==e.clipping||(u.clippingPlanes=Me.uniform),Je(e,o),i.needsLights=function(e){return e.isMeshLambertMaterial||e.isMeshToonMaterial||e.isMeshPhongMaterial||e.isMeshStandardMaterial||e.isShadowMaterial||e.isShaderMaterial&&!0===e.lights}(e),i.lightsStateVersion=s,i.needsLights&&(u.ambientLightColor.value=r.state.ambient,u.lightProbe.value=r.state.probe,u.directionalLights.value=r.state.directional,u.directionalLightShadows.value=r.state.directionalShadow,u.spotLights.value=r.state.spot,u.spotLightShadows.value=r.state.spotShadow,u.rectAreaLights.value=r.state.rectArea,u.ltc_1.value=r.state.rectAreaLTC1,u.ltc_2.value=r.state.rectAreaLTC2,u.pointLights.value=r.state.point,u.pointLightShadows.value=r.state.pointShadow,u.hemisphereLights.value=r.state.hemi,u.directionalShadowMap.value=r.state.directionalShadowMap,u.directionalShadowMatrix.value=r.state.directionalShadowMatrix,u.spotShadowMap.value=r.state.spotShadowMap,u.spotLightMatrix.value=r.state.spotLightMatrix,u.spotLightMap.value=r.state.spotLightMap,u.pointShadowMap.value=r.state.pointShadowMap,u.pointShadowMatrix.value=r.state.pointShadowMatrix),i.currentProgram=h,i.uniformsList=null,h}function Ze(e){if(null===e.uniformsList){const t=e.currentProgram.getUniforms();e.uniformsList=Ca.seqWithValue(t.seq,e.uniforms)}return e.uniformsList}function Je(e,t){const n=oe.get(e);n.outputColorSpace=t.outputColorSpace,n.instancing=t.instancing,n.instancingColor=t.instancingColor,n.skinning=t.skinning,n.morphTargets=t.morphTargets,n.morphNormals=t.morphNormals,n.morphColors=t.morphColors,n.morphTargetsCount=t.morphTargetsCount,n.numClippingPlanes=t.numClippingPlanes,n.numIntersection=t.numClipIntersection,n.vertexAlphas=t.vertexAlphas,n.vertexTangents=t.vertexTangents,n.toneMapping=t.toneMapping}Ge.setAnimationLoop((function(e){ze&&ze(e)})),"undefined"!=typeof self&&Ge.setContext(self),this.setAnimationLoop=function(e){ze=e,Ue.setAnimationLoop(e),null===e?Ge.stop():Ge.start()},Ue.addEventListener("sessionstart",Be),Ue.addEventListener("sessionend",Ve),this.render=function(e,t){if(void 0!==t&&!0!==t.isCamera)return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");if(!0===M)return;!0===e.matrixWorldAutoUpdate&&e.updateMatrixWorld(),null===t.parent&&!0===t.matrixWorldAutoUpdate&&t.updateMatrixWorld(),!0===Ue.enabled&&!0===Ue.isPresenting&&(!0===Ue.cameraAutoUpdate&&Ue.updateCamera(t),t=Ue.getCamera()),!0===e.isScene&&e.onBeforeRender(x,e,t,E),g=xe.get(e,v.length),g.init(),v.push(g),W.multiplyMatrices(t.projectionMatrix,t.matrixWorldInverse),H.setFromProjectionMatrix(W),G=this.localClippingEnabled,V=Me.init(this.clippingPlanes,G),m=ve.get(e,_.length),m.init(),_.push(m),We(e,t,0,x.sortObjects),m.finish(),!0===x.sortObjects&&m.sort(I,O),this.info.render.frame++,!0===V&&Me.beginShadows();const n=g.state.shadowsArray;if(Se.render(n,e,t),!0===V&&Me.endShadows(),!0===this.info.autoReset&&this.info.reset(),ye.render(m,e),g.setupLights(x._useLegacyLights),t.isArrayCamera){const n=t.cameras;for(let t=0,i=n.length;t<i;t++){const i=n[t];Xe(m,e,i,i.viewport)}}else Xe(m,e,t);null!==E&&(le.updateMultisampleRenderTarget(E),le.updateRenderTargetMipmap(E)),!0===e.isScene&&e.onAfterRender(x,e,t),Ae.resetDefaultState(),T=-1,b=null,v.pop(),g=v.length>0?v[v.length-1]:null,_.pop(),m=_.length>0?_[_.length-1]:null},this.getActiveCubeFace=function(){return S},this.getActiveMipmapLevel=function(){return y},this.getRenderTarget=function(){return E},this.setRenderTargetTextures=function(e,t,n){oe.get(e.texture).__webglTexture=t,oe.get(e.depthTexture).__webglTexture=n;const i=oe.get(e);i.__hasExternalTextures=!0,i.__hasExternalTextures&&(i.__autoAllocateDepthBuffer=void 0===n,i.__autoAllocateDepthBuffer||!0===ie.has("WEBGL_multisampled_render_to_texture")&&(console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"),i.__useRenderToTexture=!1))},this.setRenderTargetFramebuffer=function(e,t){const n=oe.get(e);n.__webglFramebuffer=t,n.__useDefaultFramebuffer=void 0===t},this.setRenderTarget=function(e){let t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;E=e,S=t,y=n;let i=!0,r=null,a=!1,s=!1;if(e){const o=oe.get(e);void 0!==o.__useDefaultFramebuffer?(ae.bindFramebuffer(Ce.FRAMEBUFFER,null),i=!1):void 0===o.__webglFramebuffer?le.setupRenderTarget(e):o.__hasExternalTextures&&le.rebindTextures(e,oe.get(e.texture).__webglTexture,oe.get(e.depthTexture).__webglTexture);const l=e.texture;(l.isData3DTexture||l.isDataArrayTexture||l.isCompressedArrayTexture)&&(s=!0);const c=oe.get(e).__webglFramebuffer;e.isWebGLCubeRenderTarget?(r=Array.isArray(c[t])?c[t][n]:c[t],a=!0):r=re.isWebGL2&&e.samples>0&&!1===le.useMultisampledRTT(e)?oe.get(e).__webglMultisampledFramebuffer:Array.isArray(c)?c[n]:c,w.copy(e.viewport),A.copy(e.scissor),C=e.scissorTest}else w.copy(F).multiplyScalar(N).floor(),A.copy(z).multiplyScalar(N).floor(),C=B;if(ae.bindFramebuffer(Ce.FRAMEBUFFER,r)&&re.drawBuffers&&i&&ae.drawBuffers(e,r),ae.viewport(w),ae.scissor(A),ae.setScissorTest(C),a){const i=oe.get(e.texture);Ce.framebufferTexture2D(Ce.FRAMEBUFFER,Ce.COLOR_ATTACHMENT0,Ce.TEXTURE_CUBE_MAP_POSITIVE_X+t,i.__webglTexture,n)}else if(s){const i=oe.get(e.texture),r=t||0;Ce.framebufferTextureLayer(Ce.FRAMEBUFFER,Ce.COLOR_ATTACHMENT0,i.__webglTexture,n||0,r)}T=-1},this.readRenderTargetPixels=function(e,t,n,i,r,a,s){if(!e||!e.isWebGLRenderTarget)return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");let o=oe.get(e).__webglFramebuffer;if(e.isWebGLCubeRenderTarget&&void 0!==s&&(o=o[s]),o){ae.bindFramebuffer(Ce.FRAMEBUFFER,o);try{const s=e.texture,o=s.format,l=s.type;if(o!==Q&&we.convert(o)!==Ce.getParameter(Ce.IMPLEMENTATION_COLOR_READ_FORMAT))return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");const c=l===Z&&(ie.has("EXT_color_buffer_half_float")||re.isWebGL2&&ie.has("EXT_color_buffer_float"));if(!(l===j||we.convert(l)===Ce.getParameter(Ce.IMPLEMENTATION_COLOR_READ_TYPE)||l===K&&(re.isWebGL2||ie.has("OES_texture_float")||ie.has("WEBGL_color_buffer_float"))||c))return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");t>=0&&t<=e.width-i&&n>=0&&n<=e.height-r&&Ce.readPixels(t,n,i,r,we.convert(o),we.convert(l),a)}finally{const e=null!==E?oe.get(E).__webglFramebuffer:null;ae.bindFramebuffer(Ce.FRAMEBUFFER,e)}}},this.copyFramebufferToTexture=function(e,t){let n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;const i=Math.pow(2,-n),r=Math.floor(t.image.width*i),a=Math.floor(t.image.height*i);le.setTexture2D(t,0),Ce.copyTexSubImage2D(Ce.TEXTURE_2D,n,0,0,e.x,e.y,r,a),ae.unbindTexture()},this.copyTextureToTexture=function(e,t,n){let i=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0;const r=t.image.width,a=t.image.height,s=we.convert(n.format),o=we.convert(n.type);le.setTexture2D(n,0),Ce.pixelStorei(Ce.UNPACK_FLIP_Y_WEBGL,n.flipY),Ce.pixelStorei(Ce.UNPACK_PREMULTIPLY_ALPHA_WEBGL,n.premultiplyAlpha),Ce.pixelStorei(Ce.UNPACK_ALIGNMENT,n.unpackAlignment),t.isDataTexture?Ce.texSubImage2D(Ce.TEXTURE_2D,i,e.x,e.y,r,a,s,o,t.image.data):t.isCompressedTexture?Ce.compressedTexSubImage2D(Ce.TEXTURE_2D,i,e.x,e.y,t.mipmaps[0].width,t.mipmaps[0].height,s,t.mipmaps[0].data):Ce.texSubImage2D(Ce.TEXTURE_2D,i,e.x,e.y,s,o,t.image),0===i&&n.generateMipmaps&&Ce.generateMipmap(Ce.TEXTURE_2D),ae.unbindTexture()},this.copyTextureToTexture3D=function(e,t,n,i){let r=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0;if(x.isWebGL1Renderer)return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");const a=e.max.x-e.min.x+1,s=e.max.y-e.min.y+1,o=e.max.z-e.min.z+1,l=we.convert(i.format),c=we.convert(i.type);let h;if(i.isData3DTexture)le.setTexture3D(i,0),h=Ce.TEXTURE_3D;else{if(!i.isDataArrayTexture)return void console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");le.setTexture2DArray(i,0),h=Ce.TEXTURE_2D_ARRAY}Ce.pixelStorei(Ce.UNPACK_FLIP_Y_WEBGL,i.flipY),Ce.pixelStorei(Ce.UNPACK_PREMULTIPLY_ALPHA_WEBGL,i.premultiplyAlpha),Ce.pixelStorei(Ce.UNPACK_ALIGNMENT,i.unpackAlignment);const u=Ce.getParameter(Ce.UNPACK_ROW_LENGTH),d=Ce.getParameter(Ce.UNPACK_IMAGE_HEIGHT),p=Ce.getParameter(Ce.UNPACK_SKIP_PIXELS),f=Ce.getParameter(Ce.UNPACK_SKIP_ROWS),m=Ce.getParameter(Ce.UNPACK_SKIP_IMAGES),g=n.isCompressedTexture?n.mipmaps[0]:n.image;Ce.pixelStorei(Ce.UNPACK_ROW_LENGTH,g.width),Ce.pixelStorei(Ce.UNPACK_IMAGE_HEIGHT,g.height),Ce.pixelStorei(Ce.UNPACK_SKIP_PIXELS,e.min.x),Ce.pixelStorei(Ce.UNPACK_SKIP_ROWS,e.min.y),Ce.pixelStorei(Ce.UNPACK_SKIP_IMAGES,e.min.z),n.isDataTexture||n.isData3DTexture?Ce.texSubImage3D(h,r,t.x,t.y,t.z,a,s,o,l,c,g.data):n.isCompressedArrayTexture?(console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."),Ce.compressedTexSubImage3D(h,r,t.x,t.y,t.z,a,s,o,l,g.data)):Ce.texSubImage3D(h,r,t.x,t.y,t.z,a,s,o,l,c,g),Ce.pixelStorei(Ce.UNPACK_ROW_LENGTH,u),Ce.pixelStorei(Ce.UNPACK_IMAGE_HEIGHT,d),Ce.pixelStorei(Ce.UNPACK_SKIP_PIXELS,p),Ce.pixelStorei(Ce.UNPACK_SKIP_ROWS,f),Ce.pixelStorei(Ce.UNPACK_SKIP_IMAGES,m),0===r&&i.generateMipmaps&&Ce.generateMipmap(h),ae.unbindTexture()},this.initTexture=function(e){e.isCubeTexture?le.setTextureCube(e,0):e.isData3DTexture?le.setTexture3D(e,0):e.isDataArrayTexture||e.isCompressedArrayTexture?le.setTexture2DArray(e,0):le.setTexture2D(e,0),ae.unbindTexture()},this.resetState=function(){S=0,y=0,E=null,ae.reset(),Ae.reset()},"undefined"!=typeof __THREE_DEVTOOLS__&&__THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe",{detail:this}))}get coordinateSystem(){return Le}get outputColorSpace(){return this._outputColorSpace}set outputColorSpace(e){this._outputColorSpace=e;const t=this.getContext();t.drawingBufferColorSpace=e===pe?"display-p3":"srgb",t.unpackColorSpace=tt.workingColorSpace===fe?"display-p3":"srgb"}get physicallyCorrectLights(){return console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."),!this.useLegacyLights}set physicallyCorrectLights(e){console.warn("THREE.WebGLRenderer: The property .physicallyCorrectLights has been removed. Set renderer.useLegacyLights instead."),this.useLegacyLights=!e}get outputEncoding(){return console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."),this.outputColorSpace===ue?ce:3e3}set outputEncoding(e){console.warn("THREE.WebGLRenderer: Property .outputEncoding has been removed. Use .outputColorSpace instead."),this.outputColorSpace=e===ce?ue:de}get useLegacyLights(){return console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."),this._useLegacyLights}set useLegacyLights(e){console.warn("THREE.WebGLRenderer: The property .useLegacyLights has been deprecated. Migrate your lighting according to the following guide: https://discourse.threejs.org/t/updates-to-lighting-in-three-js-r155/53733."),this._useLegacyLights=e}}(class extends Es{}).prototype.isWebGL1Renderer=!0;class Ts extends ht{constructor(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1;super(null,arguments.length>5?arguments[5]:void 0,arguments.length>6?arguments[6]:void 0,arguments.length>7?arguments[7]:void 0,arguments.length>8&&void 0!==arguments[8]?arguments[8]:H,arguments.length>9&&void 0!==arguments[9]?arguments[9]:H,arguments.length>3?arguments[3]:void 0,arguments.length>4?arguments[4]:void 0,arguments.length>10?arguments[10]:void 0,arguments.length>11?arguments[11]:void 0),this.isDataTexture=!0,this.image={data:e,width:t,height:n},this.generateMipmaps=!1,this.flipY=!1,this.unpackAlignment=1}}function bs(e,t,n){return!e||!n&&e.constructor===t?e:"number"==typeof t.BYTES_PER_ELEMENT?new t(e):Array.prototype.slice.call(e)}class ws{constructor(e,t,n,i){this.parameterPositions=e,this._cachedIndex=0,this.resultBuffer=void 0!==i?i:new t.constructor(n),this.sampleValues=t,this.valueSize=n,this.settings=null,this.DefaultSettings_={}}evaluate(e){const t=this.parameterPositions;let n=this._cachedIndex,i=t[n],r=t[n-1];e:{t:{let a;n:{i:if(!(e<i)){for(let a=n+2;;){if(void 0===i){if(e<r)break i;return n=t.length,this._cachedIndex=n,this.copySampleValue_(n-1)}if(n===a)break;if(r=i,i=t[++n],e<i)break t}a=t.length;break n}if(e>=r)break e;{const s=t[1];e<s&&(n=2,r=s);for(let a=n-2;;){if(void 0===r)return this._cachedIndex=0,this.copySampleValue_(0);if(n===a)break;if(i=r,r=t[--n-1],e>=r)break t}a=n,n=0}}for(;n<a;){const i=n+a>>>1;e<t[i]?a=i:n=i+1}if(i=t[n],r=t[n-1],void 0===r)return this._cachedIndex=0,this.copySampleValue_(0);if(void 0===i)return n=t.length,this._cachedIndex=n,this.copySampleValue_(n-1)}this._cachedIndex=n,this.intervalChanged_(n,r,i)}return this.interpolate_(n,r,e,i)}getSettings_(){return this.settings||this.DefaultSettings_}copySampleValue_(e){const t=this.resultBuffer,n=this.sampleValues,i=this.valueSize,r=e*i;for(let e=0;e!==i;++e)t[e]=n[r+e];return t}interpolate_(){throw new Error("call to abstract method")}intervalChanged_(){}}class As extends ws{constructor(e,t,n,i){super(e,t,n,i),this._weightPrev=-0,this._offsetPrev=-0,this._weightNext=-0,this._offsetNext=-0,this.DefaultSettings_={endingStart:2400,endingEnd:2400}}intervalChanged_(e,t,n){const i=this.parameterPositions;let r=e-2,a=e+1,s=i[r],o=i[a];if(void 0===s)switch(this.getSettings_().endingStart){case 2401:r=e,s=2*t-n;break;case 2402:r=i.length-2,s=t+i[r]-i[r+1];break;default:r=e,s=n}if(void 0===o)switch(this.getSettings_().endingEnd){case 2401:a=e,o=2*n-t;break;case 2402:a=1,o=n+i[1]-i[0];break;default:a=e-1,o=t}const l=.5*(n-t),c=this.valueSize;this._weightPrev=l/(t-s),this._weightNext=l/(o-n),this._offsetPrev=r*c,this._offsetNext=a*c}interpolate_(e,t,n,i){const r=this.resultBuffer,a=this.sampleValues,s=this.valueSize,o=e*s,l=o-s,c=this._offsetPrev,h=this._offsetNext,u=this._weightPrev,d=this._weightNext,p=(n-t)/(i-t),f=p*p,m=f*p,g=-u*m+2*u*f-u*p,_=(1+u)*m+(-1.5-2*u)*f+(-.5+u)*p+1,v=(-1-d)*m+(1.5+d)*f+.5*p,x=d*m-d*f;for(let e=0;e!==s;++e)r[e]=g*a[c+e]+_*a[l+e]+v*a[o+e]+x*a[h+e];return r}}class Rs extends ws{constructor(e,t,n,i){super(e,t,n,i)}interpolate_(e,t,n,i){const r=this.resultBuffer,a=this.sampleValues,s=this.valueSize,o=e*s,l=o-s,c=(n-t)/(i-t),h=1-c;for(let e=0;e!==s;++e)r[e]=a[l+e]*h+a[o+e]*c;return r}}class Cs extends ws{constructor(e,t,n,i){super(e,t,n,i)}interpolate_(e){return this.copySampleValue_(e-1)}}class Ls{constructor(e,t,n,i){if(void 0===e)throw new Error("THREE.KeyframeTrack: track name is undefined");if(void 0===t||0===t.length)throw new Error("THREE.KeyframeTrack: no keyframes in track named "+e);this.name=e,this.times=bs(t,this.TimeBufferType),this.values=bs(n,this.ValueBufferType),this.setInterpolation(i||this.DefaultInterpolation)}static toJSON(e){const t=e.constructor;let n;if(t.toJSON!==this.toJSON)n=t.toJSON(e);else{n={name:e.name,times:bs(e.times,Array),values:bs(e.values,Array)};const t=e.getInterpolation();t!==e.DefaultInterpolation&&(n.interpolation=t)}return n.type=e.ValueTypeName,n}InterpolantFactoryMethodDiscrete(e){return new Cs(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodLinear(e){return new Rs(this.times,this.values,this.getValueSize(),e)}InterpolantFactoryMethodSmooth(e){return new As(this.times,this.values,this.getValueSize(),e)}setInterpolation(e){let t;switch(e){case se:t=this.InterpolantFactoryMethodDiscrete;break;case oe:t=this.InterpolantFactoryMethodLinear;break;case le:t=this.InterpolantFactoryMethodSmooth}if(void 0===t){const t="unsupported interpolation for "+this.ValueTypeName+" keyframe track named "+this.name;if(void 0===this.createInterpolant){if(e===this.DefaultInterpolation)throw new Error(t);this.setInterpolation(this.DefaultInterpolation)}return console.warn("THREE.KeyframeTrack:",t),this}return this.createInterpolant=t,this}getInterpolation(){switch(this.createInterpolant){case this.InterpolantFactoryMethodDiscrete:return se;case this.InterpolantFactoryMethodLinear:return oe;case this.InterpolantFactoryMethodSmooth:return le}}getValueSize(){return this.values.length/this.times.length}shift(e){if(0!==e){const t=this.times;for(let n=0,i=t.length;n!==i;++n)t[n]+=e}return this}scale(e){if(1!==e){const t=this.times;for(let n=0,i=t.length;n!==i;++n)t[n]*=e}return this}trim(e,t){const n=this.times,i=n.length;let r=0,a=i-1;for(;r!==i&&n[r]<e;)++r;for(;-1!==a&&n[a]>t;)--a;if(++a,0!==r||a!==i){r>=a&&(a=Math.max(a,1),r=a-1);const e=this.getValueSize();this.times=n.slice(r,a),this.values=this.values.slice(r*e,a*e)}return this}validate(){let e=!0;const t=this.getValueSize();t-Math.floor(t)!=0&&(console.error("THREE.KeyframeTrack: Invalid value size in track.",this),e=!1);const n=this.times,i=this.values,r=n.length;0===r&&(console.error("THREE.KeyframeTrack: Track is empty.",this),e=!1);let a=null;for(let t=0;t!==r;t++){const i=n[t];if("number"==typeof i&&isNaN(i)){console.error("THREE.KeyframeTrack: Time is not a valid number.",this,t,i),e=!1;break}if(null!==a&&a>i){console.error("THREE.KeyframeTrack: Out of order keys.",this,t,i,a),e=!1;break}a=i}if(void 0!==i&&(s=i,ArrayBuffer.isView(s)&&!(s instanceof DataView)))for(let t=0,n=i.length;t!==n;++t){const n=i[t];if(isNaN(n)){console.error("THREE.KeyframeTrack: Value is not a valid number.",this,t,n),e=!1;break}}var s;return e}optimize(){const e=this.times.slice(),t=this.values.slice(),n=this.getValueSize(),i=this.getInterpolation()===le,r=e.length-1;let a=1;for(let s=1;s<r;++s){let r=!1;const o=e[s];if(o!==e[s+1]&&(1!==s||o!==e[0]))if(i)r=!0;else{const e=s*n,i=e-n,a=e+n;for(let s=0;s!==n;++s){const n=t[e+s];if(n!==t[i+s]||n!==t[a+s]){r=!0;break}}}if(r){if(s!==a){e[a]=e[s];const i=s*n,r=a*n;for(let e=0;e!==n;++e)t[r+e]=t[i+e]}++a}}if(r>0){e[a]=e[r];for(let e=r*n,i=a*n,s=0;s!==n;++s)t[i+s]=t[e+s];++a}return a!==e.length?(this.times=e.slice(0,a),this.values=t.slice(0,a*n)):(this.times=e,this.values=t),this}clone(){const e=this.times.slice(),t=this.values.slice(),n=new(0,this.constructor)(this.name,e,t);return n.createInterpolant=this.createInterpolant,n}}Ls.prototype.TimeBufferType=Float32Array,Ls.prototype.ValueBufferType=Float32Array,Ls.prototype.DefaultInterpolation=oe;class Ps extends Ls{}Ps.prototype.ValueTypeName="bool",Ps.prototype.ValueBufferType=Array,Ps.prototype.DefaultInterpolation=se,Ps.prototype.InterpolantFactoryMethodLinear=void 0,Ps.prototype.InterpolantFactoryMethodSmooth=void 0;(class extends Ls{}).prototype.ValueTypeName="color";(class extends Ls{}).prototype.ValueTypeName="number";class Us extends ws{constructor(e,t,n,i){super(e,t,n,i)}interpolate_(e,t,n,i){const r=this.resultBuffer,a=this.sampleValues,s=this.valueSize,o=(n-t)/(i-t);let l=e*s;for(let e=l+s;l!==e;l+=4)gt.slerpFlat(r,0,a,l-s,a,l,o);return r}}class Ds extends Ls{InterpolantFactoryMethodLinear(e){return new Us(this.times,this.values,this.getValueSize(),e)}}Ds.prototype.ValueTypeName="quaternion",Ds.prototype.DefaultInterpolation=oe,Ds.prototype.InterpolantFactoryMethodSmooth=void 0;class Ns extends Ls{}Ns.prototype.ValueTypeName="string",Ns.prototype.ValueBufferType=Array,Ns.prototype.DefaultInterpolation=se,Ns.prototype.InterpolantFactoryMethodLinear=void 0,Ns.prototype.InterpolantFactoryMethodSmooth=void 0;(class extends Ls{}).prototype.ValueTypeName="vector";const Is={enabled:!1,files:{},add:function(e,t){!1!==this.enabled&&(this.files[e]=t)},get:function(e){if(!1!==this.enabled)return this.files[e]},remove:function(e){delete this.files[e]},clear:function(){this.files={}}};class Os{constructor(e,t,n){const i=this;let r,a=!1,s=0,o=0;const l=[];this.onStart=void 0,this.onLoad=e,this.onProgress=t,this.onError=n,this.itemStart=function(e){o++,!1===a&&void 0!==i.onStart&&i.onStart(e,s,o),a=!0},this.itemEnd=function(e){s++,void 0!==i.onProgress&&i.onProgress(e,s,o),s===o&&(a=!1,void 0!==i.onLoad&&i.onLoad())},this.itemError=function(e){void 0!==i.onError&&i.onError(e)},this.resolveURL=function(e){return r?r(e):e},this.setURLModifier=function(e){return r=e,this},this.addHandler=function(e,t){return l.push(e,t),this},this.removeHandler=function(e){const t=l.indexOf(e);return-1!==t&&l.splice(t,2),this},this.getHandler=function(e){for(let t=0,n=l.length;t<n;t+=2){const n=l[t],i=l[t+1];if(n.global&&(n.lastIndex=0),n.test(e))return i}return null}}}const Fs=new Os;class zs{constructor(e){this.manager=void 0!==e?e:Fs,this.crossOrigin="anonymous",this.withCredentials=!1,this.path="",this.resourcePath="",this.requestHeader={}}load(){}loadAsync(e,t){const n=this;return new Promise((function(i,r){n.load(e,i,t,r)}))}parse(){}setCrossOrigin(e){return this.crossOrigin=e,this}setWithCredentials(e){return this.withCredentials=e,this}setPath(e){return this.path=e,this}setResourcePath(e){return this.resourcePath=e,this}setRequestHeader(e){return this.requestHeader=e,this}}zs.DEFAULT_MATERIAL_NAME="__DEFAULT";const Bs={};class Hs extends Error{constructor(e,t){super(e),this.response=t}}class Vs extends zs{constructor(e){super(e)}load(e,t,n,i){void 0===e&&(e=""),void 0!==this.path&&(e=this.path+e),e=this.manager.resolveURL(e);const r=Is.get(e);if(void 0!==r)return this.manager.itemStart(e),setTimeout((()=>{t&&t(r),this.manager.itemEnd(e)}),0),r;if(void 0!==Bs[e])return void Bs[e].push({onLoad:t,onProgress:n,onError:i});Bs[e]=[],Bs[e].push({onLoad:t,onProgress:n,onError:i});const a=new Request(e,{headers:new Headers(this.requestHeader),credentials:this.withCredentials?"include":"same-origin"}),s=this.mimeType,o=this.responseType;fetch(a).then((t=>{if(200===t.status||0===t.status){if(0===t.status&&console.warn("THREE.FileLoader: HTTP Status 0 received."),"undefined"==typeof ReadableStream||void 0===t.body||void 0===t.body.getReader)return t;const n=Bs[e],i=t.body.getReader(),r=t.headers.get("Content-Length")||t.headers.get("X-File-Size"),a=r?parseInt(r):0,s=0!==a;let o=0;const l=new ReadableStream({start(e){!function t(){i.read().then((i=>{let{done:r,value:l}=i;if(r)e.close();else{o+=l.byteLength;const i=new ProgressEvent("progress",{lengthComputable:s,loaded:o,total:a});for(let e=0,t=n.length;e<t;e++){const t=n[e];t.onProgress&&t.onProgress(i)}e.enqueue(l),t()}}))}()}});return new Response(l)}throw new Hs(\'fetch for "\'.concat(t.url,\'" responded with \').concat(t.status,": ").concat(t.statusText),t)})).then((e=>{switch(o){case"arraybuffer":return e.arrayBuffer();case"blob":return e.blob();case"document":return e.text().then((e=>(new DOMParser).parseFromString(e,s)));case"json":return e.json();default:if(void 0===s)return e.text();{const t=/charset="?([^;"\\s]*)"?/i.exec(s),n=t&&t[1]?t[1].toLowerCase():void 0,i=new TextDecoder(n);return e.arrayBuffer().then((e=>i.decode(e)))}}})).then((t=>{Is.add(e,t);const n=Bs[e];delete Bs[e];for(let e=0,i=n.length;e<i;e++){const i=n[e];i.onLoad&&i.onLoad(t)}})).catch((t=>{const n=Bs[e];if(void 0===n)throw this.manager.itemError(e),t;delete Bs[e];for(let e=0,i=n.length;e<i;e++){const i=n[e];i.onError&&i.onError(t)}this.manager.itemError(e)})).finally((()=>{this.manager.itemEnd(e)})),this.manager.itemStart(e)}setResponseType(e){return this.responseType=e,this}setMimeType(e){return this.mimeType=e,this}}class Gs extends zs{constructor(e){super(e)}load(e,t,n,i){const r=this,a=new Ts,s=new Vs(this.manager);return s.setResponseType("arraybuffer"),s.setRequestHeader(this.requestHeader),s.setPath(this.path),s.setWithCredentials(r.withCredentials),s.load(e,(function(e){let n;try{n=r.parse(e)}catch(e){if(void 0===i)return void console.error(e);i(e)}void 0!==n.image?a.image=n.image:void 0!==n.data&&(a.image.width=n.width,a.image.height=n.height,a.image.data=n.data),a.wrapS=void 0!==n.wrapS?n.wrapS:z,a.wrapT=void 0!==n.wrapT?n.wrapT:z,a.magFilter=void 0!==n.magFilter?n.magFilter:k,a.minFilter=void 0!==n.minFilter?n.minFilter:k,a.anisotropy=void 0!==n.anisotropy?n.anisotropy:1,void 0!==n.colorSpace?a.colorSpace=n.colorSpace:void 0!==n.encoding&&(a.encoding=n.encoding),void 0!==n.flipY&&(a.flipY=n.flipY),void 0!==n.format&&(a.format=n.format),void 0!==n.type&&(a.type=n.type),void 0!==n.mipmaps&&(a.mipmaps=n.mipmaps,a.minFilter=X),1===n.mipmapCount&&(a.minFilter=k),void 0!==n.generateMipmaps&&(a.generateMipmaps=n.generateMipmaps),a.needsUpdate=!0,t&&t(a,n)}),n,i),a}}const ks="\\\\[\\\\]\\\\.:\\\\/",Ws=new RegExp("["+ks+"]","g"),Xs="[^"+ks+"]",js="[^"+ks.replace("\\\\.","")+"]",qs=new RegExp("^"+/((?:WC+[\\/:])*)/.source.replace("WC",Xs)+/(WCOD+)?/.source.replace("WCOD",js)+/(?:\\.(WC+)(?:\\[(.+)\\])?)?/.source.replace("WC",Xs)+/\\.(WC+)(?:\\[(.+)\\])?/.source.replace("WC",Xs)+"$"),Ys=["material","materials","bones","map"];class Ks{constructor(e,t,n){this.path=t,this.parsedPath=n||Ks.parseTrackName(t),this.node=Ks.findNode(e,this.parsedPath.nodeName),this.rootNode=e,this.getValue=this._getValue_unbound,this.setValue=this._setValue_unbound}static create(e,t,n){return e&&e.isAnimationObjectGroup?new Ks.Composite(e,t,n):new Ks(e,t,n)}static sanitizeNodeName(e){return e.replace(/\\s/g,"_").replace(Ws,"")}static parseTrackName(e){const t=qs.exec(e);if(null===t)throw new Error("PropertyBinding: Cannot parse trackName: "+e);const n={nodeName:t[2],objectName:t[3],objectIndex:t[4],propertyName:t[5],propertyIndex:t[6]},i=n.nodeName&&n.nodeName.lastIndexOf(".");if(void 0!==i&&-1!==i){const e=n.nodeName.substring(i+1);-1!==Ys.indexOf(e)&&(n.nodeName=n.nodeName.substring(0,i),n.objectName=e)}if(null===n.propertyName||0===n.propertyName.length)throw new Error("PropertyBinding: can not parse propertyName from trackName: "+e);return n}static findNode(e,t){if(void 0===t||""===t||"."===t||-1===t||t===e.name||t===e.uuid)return e;if(e.skeleton){const n=e.skeleton.getBoneByName(t);if(void 0!==n)return n}if(e.children){const n=function(e){for(let i=0;i<e.length;i++){const r=e[i];if(r.name===t||r.uuid===t)return r;const a=n(r.children);if(a)return a}return null},i=n(e.children);if(i)return i}return null}_getValue_unavailable(){}_setValue_unavailable(){}_getValue_direct(e,t){e[t]=this.targetObject[this.propertyName]}_getValue_array(e,t){const n=this.resolvedProperty;for(let i=0,r=n.length;i!==r;++i)e[t++]=n[i]}_getValue_arrayElement(e,t){e[t]=this.resolvedProperty[this.propertyIndex]}_getValue_toArray(e,t){this.resolvedProperty.toArray(e,t)}_setValue_direct(e,t){this.targetObject[this.propertyName]=e[t]}_setValue_direct_setNeedsUpdate(e,t){this.targetObject[this.propertyName]=e[t],this.targetObject.needsUpdate=!0}_setValue_direct_setMatrixWorldNeedsUpdate(e,t){this.targetObject[this.propertyName]=e[t],this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_array(e,t){const n=this.resolvedProperty;for(let i=0,r=n.length;i!==r;++i)n[i]=e[t++]}_setValue_array_setNeedsUpdate(e,t){const n=this.resolvedProperty;for(let i=0,r=n.length;i!==r;++i)n[i]=e[t++];this.targetObject.needsUpdate=!0}_setValue_array_setMatrixWorldNeedsUpdate(e,t){const n=this.resolvedProperty;for(let i=0,r=n.length;i!==r;++i)n[i]=e[t++];this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_arrayElement(e,t){this.resolvedProperty[this.propertyIndex]=e[t]}_setValue_arrayElement_setNeedsUpdate(e,t){this.resolvedProperty[this.propertyIndex]=e[t],this.targetObject.needsUpdate=!0}_setValue_arrayElement_setMatrixWorldNeedsUpdate(e,t){this.resolvedProperty[this.propertyIndex]=e[t],this.targetObject.matrixWorldNeedsUpdate=!0}_setValue_fromArray(e,t){this.resolvedProperty.fromArray(e,t)}_setValue_fromArray_setNeedsUpdate(e,t){this.resolvedProperty.fromArray(e,t),this.targetObject.needsUpdate=!0}_setValue_fromArray_setMatrixWorldNeedsUpdate(e,t){this.resolvedProperty.fromArray(e,t),this.targetObject.matrixWorldNeedsUpdate=!0}_getValue_unbound(e,t){this.bind(),this.getValue(e,t)}_setValue_unbound(e,t){this.bind(),this.setValue(e,t)}bind(){let e=this.node;const t=this.parsedPath,n=t.objectName,i=t.propertyName;let r=t.propertyIndex;if(e||(e=Ks.findNode(this.rootNode,t.nodeName),this.node=e),this.getValue=this._getValue_unavailable,this.setValue=this._setValue_unavailable,!e)return void console.warn("THREE.PropertyBinding: No target node found for track: "+this.path+".");if(n){let i=t.objectIndex;switch(n){case"materials":if(!e.material)return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.",this);if(!e.material.materials)return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.",this);e=e.material.materials;break;case"bones":if(!e.skeleton)return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.",this);e=e.skeleton.bones;for(let t=0;t<e.length;t++)if(e[t].name===i){i=t;break}break;case"map":if("map"in e){e=e.map;break}if(!e.material)return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.",this);if(!e.material.map)return void console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.",this);e=e.material.map;break;default:if(void 0===e[n])return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.",this);e=e[n]}if(void 0!==i){if(void 0===e[i])return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.",this,e);e=e[i]}}const a=e[i];if(void 0===a){const n=t.nodeName;return void console.error("THREE.PropertyBinding: Trying to update property for track: "+n+"."+i+" but it wasn\'t found.",e)}let s=this.Versioning.None;this.targetObject=e,void 0!==e.needsUpdate?s=this.Versioning.NeedsUpdate:void 0!==e.matrixWorldNeedsUpdate&&(s=this.Versioning.MatrixWorldNeedsUpdate);let o=this.BindingType.Direct;if(void 0!==r){if("morphTargetInfluences"===i){if(!e.geometry)return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.",this);if(!e.geometry.morphAttributes)return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.",this);void 0!==e.morphTargetDictionary[r]&&(r=e.morphTargetDictionary[r])}o=this.BindingType.ArrayElement,this.resolvedProperty=a,this.propertyIndex=r}else void 0!==a.fromArray&&void 0!==a.toArray?(o=this.BindingType.HasFromToArray,this.resolvedProperty=a):Array.isArray(a)?(o=this.BindingType.EntireArray,this.resolvedProperty=a):this.propertyName=i;this.getValue=this.GetterByBindingType[o],this.setValue=this.SetterByBindingTypeAndVersioning[o][s]}unbind(){this.node=null,this.getValue=this._getValue_unbound,this.setValue=this._setValue_unbound}}Ks.Composite=class{constructor(e,t,n){const i=n||Ks.parseTrackName(t);this._targetGroup=e,this._bindings=e.subscribe_(t,i)}getValue(e,t){this.bind();const n=this._targetGroup.nCachedObjects_,i=this._bindings[n];void 0!==i&&i.getValue(e,t)}setValue(e,t){const n=this._bindings;for(let i=this._targetGroup.nCachedObjects_,r=n.length;i!==r;++i)n[i].setValue(e,t)}bind(){const e=this._bindings;for(let t=this._targetGroup.nCachedObjects_,n=e.length;t!==n;++t)e[t].bind()}unbind(){const e=this._bindings;for(let t=this._targetGroup.nCachedObjects_,n=e.length;t!==n;++t)e[t].unbind()}},Ks.prototype.BindingType={Direct:0,EntireArray:1,ArrayElement:2,HasFromToArray:3},Ks.prototype.Versioning={None:0,NeedsUpdate:1,MatrixWorldNeedsUpdate:2},Ks.prototype.GetterByBindingType=[Ks.prototype._getValue_direct,Ks.prototype._getValue_array,Ks.prototype._getValue_arrayElement,Ks.prototype._getValue_toArray],Ks.prototype.SetterByBindingTypeAndVersioning=[[Ks.prototype._setValue_direct,Ks.prototype._setValue_direct_setNeedsUpdate,Ks.prototype._setValue_direct_setMatrixWorldNeedsUpdate],[Ks.prototype._setValue_array,Ks.prototype._setValue_array_setNeedsUpdate,Ks.prototype._setValue_array_setMatrixWorldNeedsUpdate],[Ks.prototype._setValue_arrayElement,Ks.prototype._setValue_arrayElement_setNeedsUpdate,Ks.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate],[Ks.prototype._setValue_fromArray,Ks.prototype._setValue_fromArray_setNeedsUpdate,Ks.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate]],new Float32Array(1),"undefined"!=typeof __THREE_DEVTOOLS__&&__THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register",{detail:{revision:e}})),"undefined"!=typeof window&&(window.__THREE__?console.warn("WARNING: Multiple instances of Three.js being imported."):window.__THREE__=e);var Zs=function(e){return URL.createObjectURL(new Blob([e],{type:"text/javascript"}))};try{URL.revokeObjectURL(Zs(""))}catch(e){Zs=function(e){return"data:application/javascript;charset=UTF-8,"+encodeURI(e)}}var Js=Uint8Array,Qs=Uint16Array,$s=Uint32Array,eo=new Js([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),to=new Js([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),no=new Js([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),io=function(e,t){for(var n=new Qs(31),i=0;i<31;++i)n[i]=t+=1<<e[i-1];var r=new $s(n[30]);for(i=1;i<30;++i)for(var a=n[i];a<n[i+1];++a)r[a]=a-n[i]<<5|i;return[n,r]},ro=io(eo,2),ao=ro[0],so=ro[1];ao[28]=258,so[258]=28;for(var oo=io(to,0),lo=oo[0],co=(oo[1],new Qs(32768)),ho=0;ho<32768;++ho){var uo=(43690&ho)>>>1|(21845&ho)<<1;uo=(61680&(uo=(52428&uo)>>>2|(13107&uo)<<2))>>>4|(3855&uo)<<4,co[ho]=((65280&uo)>>>8|(255&uo)<<8)>>>1}var po=function(e,t,n){for(var i=e.length,r=0,a=new Qs(t);r<i;++r)++a[e[r]-1];var s,o=new Qs(t);for(r=0;r<t;++r)o[r]=o[r-1]+a[r-1]<<1;if(n){s=new Qs(1<<t);var l=15-t;for(r=0;r<i;++r)if(e[r])for(var c=r<<4|e[r],h=t-e[r],u=o[e[r]-1]++<<h,d=u|(1<<h)-1;u<=d;++u)s[co[u]>>>l]=c}else for(s=new Qs(i),r=0;r<i;++r)e[r]&&(s[r]=co[o[e[r]-1]++]>>>15-e[r]);return s},fo=new Js(288);for(ho=0;ho<144;++ho)fo[ho]=8;for(ho=144;ho<256;++ho)fo[ho]=9;for(ho=256;ho<280;++ho)fo[ho]=7;for(ho=280;ho<288;++ho)fo[ho]=8;var mo=new Js(32);for(ho=0;ho<32;++ho)mo[ho]=5;var go=po(fo,9,1),_o=po(mo,5,1),vo=function(e){for(var t=e[0],n=1;n<e.length;++n)e[n]>t&&(t=e[n]);return t},xo=function(e,t,n){var i=t/8|0;return(e[i]|e[i+1]<<8)>>(7&t)&n},Mo=function(e,t){var n=t/8|0;return(e[n]|e[n+1]<<8|e[n+2]<<16)>>(7&t)},So=function(e,t,n){var i=e.length;if(!i||n&&!n.l&&i<5)return t||new Js(0);var r=!t||n,a=!n||n.i;n||(n={}),t||(t=new Js(3*i));var s,o=function(e){var n=t.length;if(e>n){var i=new Js(Math.max(2*n,e));i.set(t),t=i}},l=n.f||0,c=n.p||0,h=n.b||0,u=n.l,d=n.d,p=n.m,f=n.n,m=8*i;do{if(!u){n.f=l=xo(e,c,1);var g=xo(e,c+1,3);if(c+=3,!g){var _=e[(s=c,(R=(s/8|0)+(7&s&&1)+4)-4)]|e[R-3]<<8,v=R+_;if(v>i){if(a)throw"unexpected EOF";break}r&&o(h+_),t.set(e.subarray(R,v),h),n.b=h+=_,n.p=c=8*v;continue}if(1==g)u=go,d=_o,p=9,f=5;else{if(2!=g)throw"invalid block type";var x=xo(e,c,31)+257,M=xo(e,c+10,15)+4,S=x+xo(e,c+5,31)+1;c+=14;for(var y=new Js(S),E=new Js(19),T=0;T<M;++T)E[no[T]]=xo(e,c+3*T,7);c+=3*M;var b=vo(E),w=(1<<b)-1,A=po(E,b,1);for(T=0;T<S;){var R,C=A[xo(e,c,w)];if(c+=15&C,(R=C>>>4)<16)y[T++]=R;else{var L=0,P=0;for(16==R?(P=3+xo(e,c,3),c+=2,L=y[T-1]):17==R?(P=3+xo(e,c,7),c+=3):18==R&&(P=11+xo(e,c,127),c+=7);P--;)y[T++]=L}}var U=y.subarray(0,x),D=y.subarray(x);p=vo(U),f=vo(D),u=po(U,p,1),d=po(D,f,1)}if(c>m){if(a)throw"unexpected EOF";break}}r&&o(h+131072);for(var N=(1<<p)-1,I=(1<<f)-1,O=c;;O=c){var F=(L=u[Mo(e,c)&N])>>>4;if((c+=15&L)>m){if(a)throw"unexpected EOF";break}if(!L)throw"invalid length/literal";if(F<256)t[h++]=F;else{if(256==F){O=c,u=null;break}var z=F-254;if(F>264){var B=eo[T=F-257];z=xo(e,c,(1<<B)-1)+ao[T],c+=B}var H=d[Mo(e,c)&I],V=H>>>4;if(!H)throw"invalid distance";if(c+=15&H,D=lo[V],V>3&&(B=to[V],D+=Mo(e,c)&(1<<B)-1,c+=B),c>m){if(a)throw"unexpected EOF";break}r&&o(h+131072);for(var G=h+z;h<G;h+=4)t[h]=t[h-D],t[h+1]=t[h+1-D],t[h+2]=t[h+2-D],t[h+3]=t[h+3-D];h=G}}n.l=u,n.p=O,n.b=h,u&&(l=1,n.m=p,n.d=d,n.n=f)}while(!l);return h==t.length?t:function(e,t,n){(null==t||t<0)&&(t=0),(null==n||n>e.length)&&(n=e.length);var i=new(e instanceof Qs?Qs:e instanceof $s?$s:Js)(n-t);return i.set(e.subarray(t,n)),i}(t,0,h)},yo=new Js(0);function Eo(e,t){return So((function(e){if(8!=(15&e[0])||e[0]>>>4>7||(e[0]<<8|e[1])%31)throw"invalid zlib data";if(32&e[1])throw"invalid zlib data: preset dictionaries not supported"}(e),e.subarray(2,-4)),t)}var To="undefined"!=typeof TextDecoder&&new TextDecoder;try{To.decode(yo,{stream:!0})}catch(e){}class bo extends Gs{constructor(e){super(e),this.type=Z}parse(e){const t=65536,n=14,i=65537,r=Math.pow(2.7182818,2.2),a={l:0,c:0,lc:0};function s(e,t,n,i,r){for(;n<e;)t=t<<8|F(i,r),n+=8;n-=e,a.l=t>>n&(1<<e)-1,a.c=t,a.lc=n}const o=new Array(59);function l(e){return 63&e}function c(e){return e>>6}const h={c:0,lc:0};function u(e,t,n,i){e=e<<8|F(n,i),t+=8,h.c=e,h.lc=t}const d={c:0,lc:0};function p(e,t,n,i,r,a,s,o,l){if(e==t){i<8&&(u(n,i,r,a),n=h.c,i=h.lc);let e=n>>(i-=8);if(e=new Uint8Array([e])[0],o.value+e>l)return!1;const t=s[o.value-1];for(;e-- >0;)s[o.value++]=t}else{if(!(o.value<l))return!1;s[o.value++]=e}d.c=n,d.lc=i}function f(e){return 65535&e}function m(e){const t=f(e);return t>32767?t-65536:t}const g={a:0,b:0};function _(e,t){const n=m(e),i=m(t),r=n+(1&i)+(i>>1),a=r,s=r-i;g.a=a,g.b=s}function v(e,t){const n=f(e),i=f(t),r=n-(i>>1)&65535,a=i+r-32768&65535;g.a=a,g.b=r}function x(e,t,n,i,r,a,s){const o=s<16384,l=n>r?r:n;let c,h,u=1;for(;u<=l;)u<<=1;for(u>>=1,c=u,u>>=1;u>=1;){h=0;const s=h+a*(r-c),l=a*u,d=a*c,p=i*u,f=i*c;let m,x,M,S;for(;h<=s;h+=d){let r=h;const a=h+i*(n-c);for(;r<=a;r+=f){const n=r+p,i=r+l,a=i+p;o?(_(e[r+t],e[i+t]),m=g.a,M=g.b,_(e[n+t],e[a+t]),x=g.a,S=g.b,_(m,x),e[r+t]=g.a,e[n+t]=g.b,_(M,S),e[i+t]=g.a,e[a+t]=g.b):(v(e[r+t],e[i+t]),m=g.a,M=g.b,v(e[n+t],e[a+t]),x=g.a,S=g.b,v(m,x),e[r+t]=g.a,e[n+t]=g.b,v(M,S),e[i+t]=g.a,e[a+t]=g.b)}if(n&u){const n=r+l;o?_(e[r+t],e[n+t]):v(e[r+t],e[n+t]),m=g.a,e[n+t]=g.b,e[r+t]=m}}if(r&u){let r=h;const a=h+i*(n-c);for(;r<=a;r+=f){const n=r+p;o?_(e[r+t],e[n+t]):v(e[r+t],e[n+t]),m=g.a,e[n+t]=g.b,e[r+t]=m}}c=u,u>>=1}return h}function M(e,t,r,f,m,g){const _=r.value,v=O(t,r),x=O(t,r);r.value+=4;const M=O(t,r);if(r.value+=4,v<0||v>=i||x<0||x>=i)throw new Error("Something wrong with HUF_ENCSIZE");const S=new Array(i),y=new Array(16384);if(function(e){for(let t=0;t<16384;t++)e[t]={},e[t].len=0,e[t].lit=0,e[t].p=null}(y),function(e,t,n,r,l,c){const h=t;let u=0,d=0;for(;r<=l;r++){if(h.value-t.value>n)return!1;s(6,u,d,e,h);const i=a.l;if(u=a.c,d=a.lc,c[r]=i,63==i){if(h.value-t.value>n)throw new Error("Something wrong with hufUnpackEncTable");s(8,u,d,e,h);let i=a.l+6;if(u=a.c,d=a.lc,r+i>l+1)throw new Error("Something wrong with hufUnpackEncTable");for(;i--;)c[r++]=0;r--}else if(i>=59){let e=i-59+2;if(r+e>l+1)throw new Error("Something wrong with hufUnpackEncTable");for(;e--;)c[r++]=0;r--}}!function(e){for(let e=0;e<=58;++e)o[e]=0;for(let t=0;t<i;++t)o[e[t]]+=1;let t=0;for(let e=58;e>0;--e){const n=t+o[e]>>1;o[e]=t,t=n}for(let t=0;t<i;++t){const n=e[t];n>0&&(e[t]=n|o[n]++<<6)}}(c)}(e,r,f-(r.value-_),v,x,S),M>8*(f-(r.value-_)))throw new Error("Something wrong with hufUncompress");!function(e,t,i,r){for(;t<=i;t++){const i=c(e[t]),a=l(e[t]);if(i>>a)throw new Error("Invalid table entry");if(a>n){const e=r[i>>a-n];if(e.len)throw new Error("Invalid table entry");if(e.lit++,e.p){const t=e.p;e.p=new Array(e.lit);for(let n=0;n<e.lit-1;++n)e.p[n]=t[n]}else e.p=new Array(1);e.p[e.lit-1]=t}else if(a){let e=0;for(let s=1<<n-a;s>0;s--){const s=r[(i<<n-a)+e];if(s.len||s.p)throw new Error("Invalid table entry");s.len=a,s.lit=t,e++}}}}(S,v,x,y),function(e,t,i,r,a,s,o,f,m){let g=0,_=0;const v=o,x=Math.trunc(r.value+(a+7)/8);for(;r.value<x;)for(u(g,_,i,r),g=h.c,_=h.lc;_>=n;){const a=t[g>>_-n&16383];if(a.len)_-=a.len,p(a.lit,s,g,_,i,r,f,m,v),g=d.c,_=d.lc;else{if(!a.p)throw new Error("hufDecode issues");let t;for(t=0;t<a.lit;t++){const n=l(e[a.p[t]]);for(;_<n&&r.value<x;)u(g,_,i,r),g=h.c,_=h.lc;if(_>=n&&c(e[a.p[t]])==(g>>_-n&(1<<n)-1)){_-=n,p(a.p[t],s,g,_,i,r,f,m,v),g=d.c,_=d.lc;break}}if(t==a.lit)throw new Error("hufDecode issues")}}const M=8-a&7;for(g>>=M,_-=M;_>0;){const e=t[g<<n-_&16383];if(!e.len)throw new Error("hufDecode issues");_-=e.len,p(e.lit,s,g,_,i,r,f,m,v),g=d.c,_=d.lc}}(S,y,e,r,M,x,g,m,{value:0})}function S(e){for(let t=1;t<e.length;t++){const n=e[t-1]+e[t]-128;e[t]=n}}function y(e,t){let n=0,i=Math.floor((e.length+1)/2),r=0;const a=e.length-1;for(;!(r>a||(t[r++]=e[n++],r>a));)t[r++]=e[i++]}function E(e){let t=e.byteLength;const n=new Array;let i=0;const r=new DataView(e);for(;t>0;){const e=r.getInt8(i++);if(e<0){const a=-e;t-=a+1;for(let e=0;e<a;e++)n.push(r.getUint8(i++))}else{const a=e;t-=2;const s=r.getUint8(i++);for(let e=0;e<a+1;e++)n.push(s)}}return n}function T(e,t,n){let i,r=1;for(;r<64;)i=t[e.value],65280==i?r=64:i>>8==255?r+=255&i:(n[r]=i,r++),e.value++}function b(e){const t=.5*Math.cos(.7853975),n=.5*Math.cos(3.14159/16),i=.5*Math.cos(3.14159/8),r=.5*Math.cos(3*3.14159/16),a=.5*Math.cos(.981746875),s=.5*Math.cos(3*3.14159/8),o=.5*Math.cos(1.374445625),l=new Array(4),c=new Array(4),h=new Array(4),u=new Array(4);for(let d=0;d<8;++d){const p=8*d;l[0]=i*e[p+2],l[1]=s*e[p+2],l[2]=i*e[p+6],l[3]=s*e[p+6],c[0]=n*e[p+1]+r*e[p+3]+a*e[p+5]+o*e[p+7],c[1]=r*e[p+1]-o*e[p+3]-n*e[p+5]-a*e[p+7],c[2]=a*e[p+1]-n*e[p+3]+o*e[p+5]+r*e[p+7],c[3]=o*e[p+1]-a*e[p+3]+r*e[p+5]-n*e[p+7],h[0]=t*(e[p+0]+e[p+4]),h[3]=t*(e[p+0]-e[p+4]),h[1]=l[0]+l[3],h[2]=l[1]-l[2],u[0]=h[0]+h[1],u[1]=h[3]+h[2],u[2]=h[3]-h[2],u[3]=h[0]-h[1],e[p+0]=u[0]+c[0],e[p+1]=u[1]+c[1],e[p+2]=u[2]+c[2],e[p+3]=u[3]+c[3],e[p+4]=u[3]-c[3],e[p+5]=u[2]-c[2],e[p+6]=u[1]-c[1],e[p+7]=u[0]-c[0]}for(let d=0;d<8;++d)l[0]=i*e[16+d],l[1]=s*e[16+d],l[2]=i*e[48+d],l[3]=s*e[48+d],c[0]=n*e[8+d]+r*e[24+d]+a*e[40+d]+o*e[56+d],c[1]=r*e[8+d]-o*e[24+d]-n*e[40+d]-a*e[56+d],c[2]=a*e[8+d]-n*e[24+d]+o*e[40+d]+r*e[56+d],c[3]=o*e[8+d]-a*e[24+d]+r*e[40+d]-n*e[56+d],h[0]=t*(e[d]+e[32+d]),h[3]=t*(e[d]-e[32+d]),h[1]=l[0]+l[3],h[2]=l[1]-l[2],u[0]=h[0]+h[1],u[1]=h[3]+h[2],u[2]=h[3]-h[2],u[3]=h[0]-h[1],e[0+d]=u[0]+c[0],e[8+d]=u[1]+c[1],e[16+d]=u[2]+c[2],e[24+d]=u[3]+c[3],e[32+d]=u[3]-c[3],e[40+d]=u[2]-c[2],e[48+d]=u[1]-c[1],e[56+d]=u[0]-c[0]}function w(e){for(let t=0;t<64;++t){const n=e[0][t],i=e[1][t],r=e[2][t];e[0][t]=n+1.5747*r,e[1][t]=n-.1873*i-.4682*r,e[2][t]=n+1.8556*i}}function A(e,t,n){for(let a=0;a<64;++a)t[n+a]=kn.toHalfFloat((i=e[a])<=1?Math.sign(i)*Math.pow(Math.abs(i),2.2):Math.sign(i)*Math.pow(r,Math.abs(i)-1));var i}function R(e){return new DataView(e.array.buffer,e.offset.value,e.size)}function C(e){const t=e.viewer.buffer.slice(e.offset.value,e.offset.value+e.size),n=new Uint8Array(E(t)),i=new Uint8Array(n.length);return S(n),y(n,i),new DataView(i.buffer)}function L(e){const t=Eo(e.array.slice(e.offset.value,e.offset.value+e.size)),n=new Uint8Array(t.length);return S(t),y(t,n),new DataView(n.buffer)}function P(e){const n=e.viewer,i={value:e.offset.value},r=new Uint16Array(e.width*e.scanlineBlockSize*(e.channels*e.type)),a=new Uint8Array(8192);let s=0;const o=new Array(e.channels);for(let t=0;t<e.channels;t++)o[t]={},o[t].start=s,o[t].end=o[t].start,o[t].nx=e.width,o[t].ny=e.lines,o[t].size=e.type,s+=o[t].nx*o[t].ny*o[t].size;const l=k(n,i),c=k(n,i);if(c>=8192)throw new Error("Something is wrong with PIZ_COMPRESSION BITMAP_SIZE");if(l<=c)for(let e=0;e<c-l+1;e++)a[e+l]=z(n,i);const h=new Uint16Array(t),u=function(e,n){let i=0;for(let r=0;r<t;++r)(0==r||e[r>>3]&1<<(7&r))&&(n[i++]=r);const r=i-1;for(;i<t;)n[i++]=0;return r}(a,h),d=O(n,i);M(e.array,n,i,d,r,s);for(let t=0;t<e.channels;++t){const e=o[t];for(let n=0;n<o[t].size;++n)x(r,e.start+n,e.nx,e.size,e.ny,e.nx*e.size,u)}!function(e,t,n){for(let i=0;i<n;++i)t[i]=e[t[i]]}(h,r,s);let p=0;const f=new Uint8Array(r.buffer.byteLength);for(let t=0;t<e.lines;t++)for(let t=0;t<e.channels;t++){const e=o[t],n=e.nx*e.size,i=new Uint8Array(r.buffer,2*e.end,2*n);f.set(i,p),p+=2*n,e.end+=n}return new DataView(f.buffer)}function U(e){const t=Eo(e.array.slice(e.offset.value,e.offset.value+e.size)),n=e.lines*e.channels*e.width,i=1==e.type?new Uint16Array(n):new Uint32Array(n);let r=0,a=0;const s=new Array(4);for(let n=0;n<e.lines;n++)for(let n=0;n<e.channels;n++){let n=0;switch(e.type){case 1:s[0]=r,s[1]=s[0]+e.width,r=s[1]+e.width;for(let r=0;r<e.width;++r)n+=t[s[0]++]<<8|t[s[1]++],i[a]=n,a++;break;case 2:s[0]=r,s[1]=s[0]+e.width,s[2]=s[1]+e.width,r=s[2]+e.width;for(let r=0;r<e.width;++r)n+=t[s[0]++]<<24|t[s[1]++]<<16|t[s[2]++]<<8,i[a]=n,a++}}return new DataView(i.buffer)}function D(e){const t=e.viewer,n={value:e.offset.value},i=new Uint8Array(e.width*e.lines*(e.channels*e.type*2)),r={version:B(t,n),unknownUncompressedSize:B(t,n),unknownCompressedSize:B(t,n),acCompressedSize:B(t,n),dcCompressedSize:B(t,n),rleCompressedSize:B(t,n),rleUncompressedSize:B(t,n),rleRawSize:B(t,n),totalAcUncompressedCount:B(t,n),totalDcUncompressedCount:B(t,n),acCompression:B(t,n)};if(r.version<2)throw new Error("EXRLoader.parse: "+J.compression+" version "+r.version+" is unsupported");const a=new Array;let s=k(t,n)-2;for(;s>0;){const e=N(t.buffer,n),i=z(t,n),r=i>>2&3,o=new Int8Array([(i>>4)-1])[0],l=z(t,n);a.push({name:e,index:o,type:l,compression:r}),s-=e.length+3}const o=J.channels,l=new Array(e.channels);for(let t=0;t<e.channels;++t){const n=l[t]={},i=o[t];n.name=i.name,n.compression=0,n.decoded=!1,n.type=i.pixelType,n.pLinear=i.pLinear,n.width=e.width,n.height=e.lines}const c={idx:new Array(3)};for(let t=0;t<e.channels;++t){const e=l[t];for(let n=0;n<a.length;++n){const i=a[n];e.name==i.name&&(e.compression=i.compression,i.index>=0&&(c.idx[i.index]=t),e.offset=t)}}let h,u,d;if(r.acCompressedSize>0)switch(r.acCompression){case 0:h=new Uint16Array(r.totalAcUncompressedCount),M(e.array,t,n,r.acCompressedSize,h,r.totalAcUncompressedCount);break;case 1:const i=Eo(e.array.slice(n.value,n.value+r.totalAcUncompressedCount));h=new Uint16Array(i.buffer),n.value+=r.totalAcUncompressedCount}if(r.dcCompressedSize>0){const t={array:e.array,offset:n,size:r.dcCompressedSize};u=new Uint16Array(L(t).buffer),n.value+=r.dcCompressedSize}r.rleRawSize>0&&(d=E(Eo(e.array.slice(n.value,n.value+r.rleCompressedSize)).buffer),n.value+=r.rleCompressedSize);let p=0;const f=new Array(l.length);for(let e=0;e<f.length;++e)f[e]=new Array;for(let t=0;t<e.lines;++t)for(let t=0;t<l.length;++t)f[t].push(p),p+=l[t].width*e.type*2;!function(e,t,n,i,r,a){let s=new DataView(a.buffer);const o=n[e.idx[0]].width,l=n[e.idx[0]].height,c=Math.floor(o/8),h=Math.ceil(o/8),u=Math.ceil(l/8),d=o-8*(h-1),p=l-8*(u-1),f={value:0},m=new Array(3),g=new Array(3),_=new Array(3),v=new Array(3),x=new Array(3);for(let n=0;n<3;++n)x[n]=t[e.idx[n]],m[n]=n<1?0:m[n-1]+h*u,g[n]=new Float32Array(64),_[n]=new Uint16Array(64),v[n]=new Uint16Array(64*h);for(let t=0;t<u;++t){let a=8;t==u-1&&(a=p);let o=8;for(let e=0;e<h;++e){e==h-1&&(o=d);for(let e=0;e<3;++e)_[e].fill(0),_[e][0]=r[m[e]++],T(f,i,_[e]),M=_[e],(S=g[e])[0]=G(M[0]),S[1]=G(M[1]),S[2]=G(M[5]),S[3]=G(M[6]),S[4]=G(M[14]),S[5]=G(M[15]),S[6]=G(M[27]),S[7]=G(M[28]),S[8]=G(M[2]),S[9]=G(M[4]),S[10]=G(M[7]),S[11]=G(M[13]),S[12]=G(M[16]),S[13]=G(M[26]),S[14]=G(M[29]),S[15]=G(M[42]),S[16]=G(M[3]),S[17]=G(M[8]),S[18]=G(M[12]),S[19]=G(M[17]),S[20]=G(M[25]),S[21]=G(M[30]),S[22]=G(M[41]),S[23]=G(M[43]),S[24]=G(M[9]),S[25]=G(M[11]),S[26]=G(M[18]),S[27]=G(M[24]),S[28]=G(M[31]),S[29]=G(M[40]),S[30]=G(M[44]),S[31]=G(M[53]),S[32]=G(M[10]),S[33]=G(M[19]),S[34]=G(M[23]),S[35]=G(M[32]),S[36]=G(M[39]),S[37]=G(M[45]),S[38]=G(M[52]),S[39]=G(M[54]),S[40]=G(M[20]),S[41]=G(M[22]),S[42]=G(M[33]),S[43]=G(M[38]),S[44]=G(M[46]),S[45]=G(M[51]),S[46]=G(M[55]),S[47]=G(M[60]),S[48]=G(M[21]),S[49]=G(M[34]),S[50]=G(M[37]),S[51]=G(M[47]),S[52]=G(M[50]),S[53]=G(M[56]),S[54]=G(M[59]),S[55]=G(M[61]),S[56]=G(M[35]),S[57]=G(M[36]),S[58]=G(M[48]),S[59]=G(M[49]),S[60]=G(M[57]),S[61]=G(M[58]),S[62]=G(M[62]),S[63]=G(M[63]),b(g[e]);w(g);for(let t=0;t<3;++t)A(g[t],v[t],64*e)}let l=0;for(let i=0;i<3;++i){const r=n[e.idx[i]].type;for(let e=8*t;e<8*t+a;++e){l=x[i][e];for(let t=0;t<c;++t){const n=64*t+8*(7&e);s.setUint16(l+0*r,v[i][n+0],!0),s.setUint16(l+2*r,v[i][n+1],!0),s.setUint16(l+4*r,v[i][n+2],!0),s.setUint16(l+6*r,v[i][n+3],!0),s.setUint16(l+8*r,v[i][n+4],!0),s.setUint16(l+10*r,v[i][n+5],!0),s.setUint16(l+12*r,v[i][n+6],!0),s.setUint16(l+14*r,v[i][n+7],!0),l+=16*r}}if(c!=h)for(let e=8*t;e<8*t+a;++e){const t=x[i][e]+8*c*2*r,n=64*c+8*(7&e);for(let e=0;e<o;++e)s.setUint16(t+2*e*r,v[i][n+e],!0)}}}var M,S;const y=new Uint16Array(o);s=new DataView(a.buffer);for(let t=0;t<3;++t){n[e.idx[t]].decoded=!0;const i=n[e.idx[t]].type;if(2==n[t].type)for(let e=0;e<l;++e){const n=x[t][e];for(let e=0;e<o;++e)y[e]=s.getUint16(n+2*e*i,!0);for(let e=0;e<o;++e)s.setFloat32(n+2*e*i,G(y[e]),!0)}}}(c,f,l,h,u,i);for(let t=0;t<l.length;++t){const n=l[t];if(!n.decoded){if(2!==n.compression)throw new Error("EXRLoader.parse: unsupported channel compression");{let r=0,a=0;for(let s=0;s<e.lines;++s){let e=f[t][r];for(let t=0;t<n.width;++t){for(let t=0;t<2*n.type;++t)i[e++]=d[a+t*n.width*n.height];a++}r++}}}}return new DataView(i.buffer)}function N(e,t){const n=new Uint8Array(e);let i=0;for(;0!=n[t.value+i];)i+=1;const r=(new TextDecoder).decode(n.slice(t.value,t.value+i));return t.value=t.value+i+1,r}function I(e,t){const n=e.getInt32(t.value,!0);return t.value=t.value+4,n}function O(e,t){const n=e.getUint32(t.value,!0);return t.value=t.value+4,n}function F(e,t){const n=e[t.value];return t.value=t.value+1,n}function z(e,t){const n=e.getUint8(t.value);return t.value=t.value+1,n}const B=function(e,t){let n;return n="getBigInt64"in DataView.prototype?Number(e.getBigInt64(t.value,!0)):e.getUint32(t.value+4,!0)+Number(e.getUint32(t.value,!0)<<32),t.value+=8,n};function H(e,t){const n=e.getFloat32(t.value,!0);return t.value+=4,n}function V(e,t){return kn.toHalfFloat(H(e,t))}function G(e){const t=(31744&e)>>10,n=1023&e;return(e>>15?-1:1)*(t?31===t?n?NaN:1/0:Math.pow(2,t-15)*(1+n/1024):n/1024*6103515625e-14)}function k(e,t){const n=e.getUint16(t.value,!0);return t.value+=2,n}function W(e,t){return G(k(e,t))}function X(e,t,n,i,r){return"string"===i||"stringvector"===i||"iccProfile"===i?function(e,t,n){const i=(new TextDecoder).decode(new Uint8Array(e).slice(t.value,t.value+n));return t.value=t.value+n,i}(t,n,r):"chlist"===i?function(e,t,n,i){const r=n.value,a=[];for(;n.value<r+i-1;){const i=N(t,n),r=I(e,n),s=z(e,n);n.value+=3;const o=I(e,n),l=I(e,n);a.push({name:i,pixelType:r,pLinear:s,xSampling:o,ySampling:l})}return n.value+=1,a}(e,t,n,r):"chromaticities"===i?function(e,t){return{redX:H(e,t),redY:H(e,t),greenX:H(e,t),greenY:H(e,t),blueX:H(e,t),blueY:H(e,t),whiteX:H(e,t),whiteY:H(e,t)}}(e,n):"compression"===i?function(e,t){return["NO_COMPRESSION","RLE_COMPRESSION","ZIPS_COMPRESSION","ZIP_COMPRESSION","PIZ_COMPRESSION","PXR24_COMPRESSION","B44_COMPRESSION","B44A_COMPRESSION","DWAA_COMPRESSION","DWAB_COMPRESSION"][z(e,t)]}(e,n):"box2i"===i?function(e,t){return{xMin:O(e,t),yMin:O(e,t),xMax:O(e,t),yMax:O(e,t)}}(e,n):"lineOrder"===i?function(e,t){return["INCREASING_Y"][z(e,t)]}(e,n):"float"===i?H(e,n):"v2f"===i?function(e,t){return[H(e,t),H(e,t)]}(e,n):"v3f"===i?function(e,t){return[H(e,t),H(e,t),H(e,t)]}(e,n):"int"===i?I(e,n):"rational"===i?function(e,t){return[I(e,t),O(e,t)]}(e,n):"timecode"===i?function(e,t){return[O(e,t),O(e,t)]}(e,n):"preview"===i?(n.value+=r,"skipped"):void(n.value+=r)}const j=new DataView(e),q=new Uint8Array(e),Y={value:0},J=function(e,t,n){const i={};if(20000630!=e.getUint32(0,!0))throw new Error("THREE.EXRLoader: Provided file doesn\'t appear to be in OpenEXR format.");i.version=e.getUint8(4);const r=e.getUint8(5);i.spec={singleTile:!!(2&r),longName:!!(4&r),deepFormat:!!(8&r),multiPart:!!(16&r)},n.value=8;let a=!0;for(;a;){const r=N(t,n);if(0==r)a=!1;else{const a=N(t,n),s=X(e,t,n,a,O(e,n));void 0===s?console.warn("THREE.EXRLoader: Skipped unknown header attribute type \'".concat(a,"\'.")):i[r]=s}}if(-5&r)throw console.error("THREE.EXRHeader:",i),new Error("THREE.EXRLoader: Provided file is currently unsupported.");return i}(j,e,Y),$=function(e,t,n,i,r){const a={size:0,viewer:t,array:n,offset:i,width:e.dataWindow.xMax-e.dataWindow.xMin+1,height:e.dataWindow.yMax-e.dataWindow.yMin+1,channels:e.channels.length,bytesPerLine:null,lines:null,inputSize:null,type:e.channels[0].pixelType,uncompress:null,getter:null,format:null,colorSpace:de};switch(e.compression){case"NO_COMPRESSION":a.lines=1,a.uncompress=R;break;case"RLE_COMPRESSION":a.lines=1,a.uncompress=C;break;case"ZIPS_COMPRESSION":a.lines=1,a.uncompress=L;break;case"ZIP_COMPRESSION":a.lines=16,a.uncompress=L;break;case"PIZ_COMPRESSION":a.lines=32,a.uncompress=P;break;case"PXR24_COMPRESSION":a.lines=16,a.uncompress=U;break;case"DWAA_COMPRESSION":a.lines=32,a.uncompress=D;break;case"DWAB_COMPRESSION":a.lines=256,a.uncompress=D;break;default:throw new Error("EXRLoader.parse: "+e.compression+" is unsupported")}if(a.scanlineBlockSize=a.lines,1==a.type)switch(r){case K:a.getter=W,a.inputSize=2;break;case Z:a.getter=k,a.inputSize=2}else{if(2!=a.type)throw new Error("EXRLoader.parse: unsupported pixelType "+a.type+" for "+e.compression+".");switch(r){case K:a.getter=H,a.inputSize=4;break;case Z:a.getter=V,a.inputSize=4}}a.blockCount=(e.dataWindow.yMax+1)/a.scanlineBlockSize;for(let e=0;e<a.blockCount;e++)B(t,i);a.outputChannels=3==a.channels?4:a.channels;const s=a.width*a.height*a.outputChannels;switch(r){case K:a.byteArray=new Float32Array(s),a.channels<a.outputChannels&&a.byteArray.fill(1,0,s);break;case Z:a.byteArray=new Uint16Array(s),a.channels<a.outputChannels&&a.byteArray.fill(15360,0,s);break;default:console.error("THREE.EXRLoader: unsupported type: ",r)}return a.bytesPerLine=a.width*a.inputSize*a.channels,4==a.outputChannels?(a.format=Q,a.colorSpace=de):(a.format=1028,a.colorSpace=he),a}(J,j,q,Y,this.type),ee={value:0},te={R:0,G:1,B:2,A:3,Y:0};for(let e=0;e<$.height/$.scanlineBlockSize;e++){const t=O(j,Y);$.size=O(j,Y),$.lines=t+$.scanlineBlockSize>$.height?$.height-t:$.scanlineBlockSize;const n=$.size<$.lines*$.bytesPerLine?$.uncompress($):R($);Y.value+=$.size;for(let t=0;t<$.scanlineBlockSize;t++){const i=t+e*$.scanlineBlockSize;if(i>=$.height)break;for(let e=0;e<$.channels;e++){const r=te[J.channels[e].name];for(let a=0;a<$.width;a++){ee.value=(t*($.channels*$.width)+e*$.width+a)*$.inputSize;const s=($.height-1-i)*($.width*$.outputChannels)+a*$.outputChannels+r;$.byteArray[s]=$.getter(n,ee)}}}}return{header:J,width:$.width,height:$.height,data:$.byteArray,format:$.format,colorSpace:$.colorSpace,type:this.type}}setDataType(e){return this.type=e,this}load(e,t,n,i){return super.load(e,(function(e,n){e.colorSpace=n.colorSpace,e.minFilter=k,e.magFilter=k,e.generateMipmaps=!1,e.flipY=!1,t&&t(e,n)}),n,i)}}onmessage=e=>{const t=new bo;t.type=K,postMessage(t.parse(e.data))}})();', "Worker", void 0, void 0);
        }
        var vx = n(229), Mx = n.n(vx);
        function yx(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        dn({
            useProxies: "never"
        });
        const xx = "granted", _x = new class {
            constructor(){
                yx(this, "parser", null), yx(this, "deviceOrientationStatus", "denied"), yx(this, "setDeviceOrientationStatus", (e1)=>(this.deviceOrientationStatus = e1, e1)), yx(this, "requestDeviceOrientation", async ()=>{
                    try {
                        return DeviceOrientationEvent.requestPermission ? await DeviceOrientationEvent.requestPermission().then((e1)=>this.setDeviceOrientationStatus(e1)) : this.setDeviceOrientationStatus(xx);
                    } catch (e1) {
                        console.log(e1);
                    }
                }), Rn(this), this.parser = new (Mx());
            }
            get device() {
                return this.parser.getDevice();
            }
            get isMobile() {
                return "mobile" === this.device.type;
            }
            get isTablet() {
                return "tablet" === this.device.type;
            }
            get isMobileDevice() {
                return this.isMobile || this.isTablet;
            }
            get deviceOrientationGranted() {
                return this.deviceOrientationStatus === xx;
            }
        };
        class bx {
            static async load(e1) {
                let t = await px.get(e1);
                t || (t = await fetch(e1, {
                    method: "GET",
                    cache: "no-cache"
                }), await px.put(e1, t));
                const n = await t.arrayBuffer();
                return bx.parse(n).catch((e1)=>console.warn(e1));
            }
            static async parse(e1) {
                if (window.Worker && !_x.isMobile) return new Promise((t, n)=>{
                    const i = new Ax(e1);
                    i.onmessage = (e1)=>t(e1.data), i.onerror = (e1)=>n(e1), i.postMessage(e1);
                });
                const t = new dx;
                return t.type = Na, t.parse(e1);
            }
        }
        function wx(e1, t, n) {
            Ex(e1, t), t.set(e1, n);
        }
        function Ex(e1, t) {
            if (t.has(e1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
        }
        function Tx(e1, t) {
            return e1.get(Ix(e1, t));
        }
        function Sx(e1, t, n) {
            return e1.set(Ix(e1, t), n), n;
        }
        function Ix(e1, t, n) {
            if ("function" == typeof e1 ? e1 === t : e1.has(t)) return arguments.length < 3 ? t : n;
            throw new TypeError("Private element is not present on this object");
        }
        var Nx = new WeakMap, Dx = new WeakMap, Cx = new WeakMap, Lx = new WeakSet;
        async function Rx(e1) {
            const t = new bA, n = await t.loadAsync(e1);
            return n.center = new Jo(.5, .5), n.colorSpace = Gs, n.minFilter = _a, n.magFilter = va, n.anisotropy = 8, n;
        }
        async function zx(e1) {
            return bx.load(e1);
        }
        const Ox = new class {
            constructor(){
                var e1;
                Ex(this, e1 = Lx), e1.add(this), wx(this, Nx, void 0), wx(this, Dx, void 0), wx(this, Cx, void 0), Sx(Nx, this, {}), Sx(Dx, this, {}), Sx(Cx, this, {});
            }
            async getTexture(e1) {
                return e1 ? _x.isMobile ? Ix(Lx, this, Rx).call(this, e1) : (Tx(Nx, this)[e1] || await this.cacheTexture(e1), Tx(Nx, this)[e1]) : null;
            }
            async getDepth(e1) {
                return e1 ? _x.isMobile ? await bx.load(e1) : (Tx(Dx, this)[e1] || await this.cacheDepth(e1), Tx(Dx, this)[e1]) : null;
            }
            async cacheTexture(e1) {
                if (e1) {
                    if (!this.isCached(e1)) {
                        if (this.isLoading(e1)) await Uy(()=>this.isLoading(e1));
                        else {
                            Tx(Cx, this)[e1] = !0;
                            try {
                                Tx(Nx, this)[e1] = await Ix(Lx, this, Rx).call(this, e1);
                            } catch (t) {
                                console.warn(e1, t);
                            }
                            Tx(Cx, this)[e1] = !1;
                        }
                    }
                } else console.warn("Cache empty url skipped!");
            }
            async cacheDepth(e1) {
                if (e1) {
                    if (!this.isCached(e1)) {
                        if (this.isLoading(e1)) await Uy(()=>this.isLoading(e1));
                        else {
                            Tx(Cx, this)[e1] = !0;
                            try {
                                Tx(Dx, this)[e1] = await Ix(Lx, this, zx).call(this, e1);
                            } catch (t) {
                                console.warn(e1, t);
                            }
                            Tx(Cx, this)[e1] = !1;
                        }
                    }
                } else console.warn("Cache empty url skipped!");
            }
            isCached(e1) {
                return null != Tx(Nx, this)[e1] || null != Tx(Dx, this)[e1];
            }
            isLoading(e1) {
                return Tx(Cx, this)[e1];
            }
            invalidate(e1) {
                delete Tx(Nx, this)[e1], delete Tx(Dx, this)[e1], delete Tx(Cx, this)[e1];
            }
            clearTextures() {
                Object.keys(Tx(Nx, this)).forEach((e1)=>{
                    delete Tx(Cx, this)[e1];
                }), Sx(Nx, this, {});
            }
            clearDepthTextures() {
                Object.keys(Tx(Dx, this)).forEach((e1)=>{
                    delete Tx(Cx, this)[e1];
                }), Sx(Dx, this, {});
            }
            clear() {
                Sx(Nx, this, {}), Sx(Dx, this, {}), Sx(Cx, this, {});
            }
        }, Px = (e1)=>{
            const t = new xl(e1);
            return t.center = new Jo(.5, .5), t.colorSpace = Gs, t.minFilter = _a, t.magFilter = va, t.needsUpdate = !0, t;
        }, Ux = (e1, t, n)=>e1.find((e1)=>e1.ID === t).Vertices.map((e1)=>{
                const t = n.find((t)=>t.ID === e1);
                return [
                    t.Location.X,
                    t.Location.Y
                ];
            }), kx = (e1, t)=>{
            const { Rooms: n } = e1.Floors[Bi.currentFloorIndex].Units[0];
            return n.find((e1)=>{
                let { ID: n } = e1;
                return n === t;
            }) || null;
        }, jx = (e1, t)=>{
            const { CameraPoints: n } = e1.Floors[Bi.currentFloorIndex];
            return (null == n ? void 0 : n.find((e1)=>{
                let { ID: n } = e1;
                return n === t;
            })) || null;
        }, Bx = (e1, t)=>t.reduce((t, n)=>{
                const i = Dy([
                    e1,
                    [
                        n.userData.left,
                        n.userData.top
                    ]
                ]);
                return i < t.length ? {
                    panorama: n,
                    length: i
                } : t;
            }, {
                length: 1 / 0,
                panorama: null
            }), Fx = async (e1, t)=>await new Promise((n)=>{
                const i = setInterval(()=>{
                    if (t < 0 && e1.opacity <= 0 || t > 0 && e1.opacity >= 1) return clearInterval(i), n();
                    e1.opacity = Math.min(1, e1.opacity + t);
                }, 1);
            }), Hx = async (e1)=>await Fx(e1, -0.01), Vx = async (e1)=>await Fx(e1, .01), Gx = (e1)=>Ko.DEG2RAD * e1, Qx = (e1)=>Ko.RAD2DEG * e1, Wx = (e1, t, n)=>{
            const { data: i, width: r, height: a } = n, s = i.length / a, o = (Math.round(a - t * a) - 1) * s + 4 * Math.round(e1 * r), [l, c, u, h] = i.slice(o, o + 4);
            return {
                R: l,
                G: c,
                B: u,
                A: h
            };
        }, Yx = (e1, t, n)=>{
            const { data: i, width: r, height: a } = n, s = 4 * r, o = (Math.round(a - t * a) - 1) * s + 4 * Math.round(e1 * r), [l, c, u, h] = i.slice(o, o + 4);
            return {
                R: l,
                G: c,
                B: u,
                A: h
            };
        }, Xx = (e1, t)=>{
            const n = e1.X - t.X, i = e1.Y - t.Y;
            return n * n + i * i;
        }, Zx = (e1, t, n)=>{
            const i = e1.clone().sub(t).normalize(), r = e1.clone().sub(n).normalize();
            return i.cross(r);
        }, qx = (e1)=>e1.map((e1)=>e1.replace(/\.(png|jpe?g|webp|svg)/, "_RoomIDs.exr"));
        function Kx(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const Jx = class extends kp {
            constructor(e1, t){
                super(), Kx(this, "_tempPointer", new Jo), Kx(this, "_raycaster", new Pv), Kx(this, "_tempMatrix", new oc), Kx(this, "_pointer", new Jo), Kx(this, "deepChildren", []), Kx(this, "_hoverElement", void 0), Kx(this, "controller1", void 0), Kx(this, "controller2", void 0), Kx(this, "_renderer", void 0), Kx(this, "_camera", void 0), Kx(this, "updateDeepChildren", ()=>{
                    const e1 = [];
                    this.traverse((t)=>{
                        t.interactive && e1.push(t);
                    }, []), this.deepChildren = e1;
                }), this._camera = t, this._renderer = e1, this._renderer.domElement.addEventListener("pointermove", this.onPointerEvent.bind(this)), this._renderer.domElement.addEventListener("pointerdown", this.onPointerDown.bind(this)), this._renderer.domElement.addEventListener("pointerup", this.onPointerEvent.bind(this)), this._renderer.domElement.addEventListener("mousemove", this.onPointerEvent.bind(this)), this.controller1 = this.createController(0), this.controller2 = this.createController(1);
            }
            get hover() {
                return this._pointer.hover || this.controller1.hover || this.controller2.hover;
            }
            get cursor() {
                return this._pointer._hoverElement ? this._pointer._hoverElement.isLinkSphere ? "" : this._pointer._hoverElement.isDoor ? "url(".concat("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE1MThfOTMyKSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTAuMjc1NCA2LjIyOTIxQzEwLjI3NTQgNS44OTk4NiAxMC40ODgyIDUuNjA4MzMgMTAuODAxOCA1LjUwODJMMjcuMDYzNyAwLjMxNTAxNEMyNy41NTE2IDAuMTU5MTkxIDI4LjA1IDAuNTIzNTEyIDI4LjA1IDEuMDM2MDJWNDguOTk2OEMyOC4wNSA0OS40ODQ0IDI3LjU5NTggNDkuODQ0OCAyNy4xMjEzIDQ5LjczMzdMMTAuODU5NCA0NS45MjUzQzEwLjUxNzMgNDUuODQ1MyAxMC4yNzU0IDQ1LjU0IDEwLjI3NTQgNDUuMTg4NVY2LjIyOTIxWk0yNS40MDI3IDI2LjExMDhDMjQuOTg1IDI2LjExMDggMjQuNjQ2NCAyNS43NzIgMjQuNjQ2NCAyNS4zNTRWMjQuMjE4OEMyNC42NDY0IDIzLjgwMDggMjQuOTg1IDIzLjQ2MTkgMjUuNDAyNyAyMy40NjE5QzI1LjgyMDUgMjMuNDYxOSAyNi4xNTkxIDIzLjgwMDggMjYuMTU5MSAyNC4yMTg4VjI1LjM1NEMyNi4xNTkxIDI1Ljc3MiAyNS44MjA1IDI2LjExMDggMjUuNDAyNyAyNi4xMTA4Wk0zMC42OTczIDUuMjk3ODhDMzAuNjk3MyA1LjcxNTg4IDMxLjAzNTkgNi4wNTQ3MiAzMS40NTM2IDYuMDU0NzJIMzguMjYwOUMzOC42Nzg3IDYuMDU0NzIgMzkuMDE3MyA2LjM5MzU3IDM5LjAxNzMgNi44MTE1NlY0My44OTY1QzM5LjAxNzMgNDQuMzE0NSAzOC42Nzg3IDQ0LjY1MzMgMzguMjYwOSA0NC42NTMzSDMxLjQ1MzZDMzEuMDM1OSA0NC42NTMzIDMwLjY5NzMgNDQuOTkyMiAzMC42OTczIDQ1LjQxMDJDMzAuNjk3MyA0NS44MjgyIDMxLjAzNTkgNDYuMTY3IDMxLjQ1MzYgNDYuMTY3SDM5Ljc3MzdDNDAuMTkxNCA0Ni4xNjcgNDAuNTMgNDUuODI4MiA0MC41MyA0NS40MTAyVjUuMjk3ODhDNDAuNTMgNC44Nzk5IDQwLjE5MTQgNC41NDEwNSAzOS43NzM3IDQuNTQxMDVIMzEuNDUzNkMzMS4wMzU5IDQuNTQxMDUgMzAuNjk3MyA0Ljg3OTkgMzAuNjk3MyA1LjI5Nzg4WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xNTE4XzkzMiI+CjxyZWN0IHdpZHRoPSIzNi45NjI5IiBoZWlnaHQ9IjQ5Ljk1MTIiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2LjU0Mjk3KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", ") 25 25, pointer") : "pointer" : "";
            }
            add() {
                super.add(...arguments), this.updateDeepChildren();
            }
            createControllerLine(e1) {
                const t = new Sm(new Cl(0, 0, 0), new Cl(0, 0, -500)), n = new Cg(t, 100, .002, 100, !1), i = new Ug({
                    color: new Zc(16777215),
                    side: hr
                }), r = new Vu(n, i);
                return r.isVrControllerLine = !0, r.defaultDistance = 500, r.renderOrder = 7, e1.distanceLine = r, e1.add(r), r;
            }
            createControllerCircle(e1) {
                const t = document.createElement("canvas"), n = t.getContext("2d");
                t.width = 128, t.height = 128, n.beginPath(), n.arc(t.width / 2, t.height / 2, t.width / 4, 0, 2 * Math.PI, !1), n.strokeStyle = "rgba(255, 255, 255, 1)", n.fillStyle = "rgba(20, 20, 20, 0.26)", n.lineWidth = 10, n.fill(), n.stroke();
                const i = Px(t), r = new $p({
                    color: new Zc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    side: hr,
                    map: i,
                    opacity: 1
                }), a = new ff(r);
                return a.isVrControllerCircle = !0, a.scale.setScalar(.05), a.renderOrder = 7, e1.distanceCircle = a, e1.add(a), a;
            }
            createController(e1) {
                const t = this._renderer.xr.getController(e1);
                t.isVrController = !0, this.createControllerLine(t), this.createControllerCircle(t);
                const n = new by, i = new Ny, r = this._renderer.xr.getControllerGrip(e1);
                r.add(n.createControllerModel(r)), r.isVrControllerGrip = !0;
                const a = this._renderer.xr.getHand(e1);
                return a.add(i.createHandModel(a, "mesh")), a.isVrHand = !0, t.addEventListener("move", this.onXRControllerEvent.bind(this)), t.addEventListener("select", this.onXRControllerEvent.bind(this)), this.add(t, r, a), t;
            }
            getIntersections() {
                return this._raycaster.intersectObjects(this.deepChildren, !1).filter((e1)=>e1.object.visible && e1.object.parent).sort((e1)=>e1.object.isLinkSphere ? 1 : -1);
            }
            onPointerDown(e1) {
                let { clientX: t, clientY: n } = e1;
                this._tempPointer.x = Number(t.toFixed(0)), this._tempPointer.y = Number(n.toFixed(0));
            }
            onPointerEvent(e1) {
                var t;
                const n = Math.abs(this._tempPointer.x - Number(e1.clientX.toFixed(0))) < 10, i = Math.abs(this._tempPointer.y - Number(e1.clientY.toFixed(0))) < 10, r = "pointerup" === e1.type ? "click" : e1.type;
                if (!("click" !== r || n && i)) return;
                const a = this._renderer.domElement.getBoundingClientRect();
                this._pointer.x = (e1.clientX - a.left) / a.width * 2 - 1, this._pointer.y = -(e1.clientY - a.top) / a.height * 2 + 1, this._raycaster.setFromCamera(this._pointer, this._camera);
                const s = this.getIntersections();
                s.length > 0 && this.onIntersection(s, r, this._pointer) || (null === (t = this._pointer._hoverElement) || void 0 === t || t.dispatchEvent({
                    type: "hoverend",
                    controller: null
                }), this._pointer._hoverElement = null, this._pointer.hover = !1);
            }
            onXRControllerEvent(e1) {
                var t;
                const n = {
                    move: "mousemove",
                    select: "click"
                }, i = e1.target;
                this._tempMatrix.identity().extractRotation(i.matrixWorld), this._raycaster.ray.origin.setFromMatrixPosition(i.matrixWorld), this._raycaster.ray.direction.set(0, 0, -1).applyMatrix4(this._tempMatrix);
                const r = this.getIntersections();
                r.length > 0 && this.onIntersection(r, n[e1.type], i) ? i.distanceCircle.material.depthTest = !1 : (i.distanceCircle.material.depthTest = !0, this.updateControllerPointer(i, 500), null === (t = i._hoverElement) || void 0 === t || t.dispatchEvent({
                    type: "hoverend",
                    controller: i
                }), i._hoverElement = null, i.hover = !1);
            }
            onIntersection(e1, t, n) {
                this.deepChildren.forEach((t)=>{
                    if (!t.isLinkSphere) return;
                    const i = e1.some((e1)=>e1.object.uuid === t.uuid);
                    t.dispatchEvent({
                        type: i ? "hoverstart" : "hoverend",
                        controller: n
                    });
                });
                const i = e1[0];
                if (!i) return null;
                const { object: r } = i, a = {
                    x: i.uv.x,
                    y: 1 - i.uv.y
                };
                return r.dispatchEvent({
                    type: "hoverstart",
                    data: a,
                    controller: n
                }), r.dispatchEvent({
                    type: t,
                    data: a,
                    controller: n
                }), n && n.isVrController && this.updateControllerPointer(n, i.distance), n._hoverElement && n._hoverElement.uuid !== r.uuid && n._hoverElement.dispatchEvent({
                    type: "hoverend",
                    controller: n
                }), n._hoverElement = r, n.hover = !0, r;
            }
            updateControllerPointer(e1, t) {
                e1.distanceCircle.position.z = -t;
                const n = t / e1.distanceLine.defaultDistance;
                e1.distanceLine.scale.set(1, 1, n);
            }
        }, $x = [
            "StraightStair_01",
            "StraightStairWithTurn_01",
            "HelicalStair_01",
            "QuarterLandingStair_01",
            "HalfLandingStair_01"
        ];
        function e_(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const t_ = class extends Vu {
            constructor(e1){
                super(), e_(this, "interactive", !0), e_(this, "_visible", !0), e_(this, "isDoor", !0), this.userData = e1, this.position.copy(e1.position), this.rotation.copy(e1.rotation), this.renderOrder = 3, this.visible = !1, this.createGeometry(), this.createMaterial(), this.onHoverEnd(), this.addEventListeners();
            }
            get visible() {
                return this._visible;
            }
            set visible(e1) {
                this._visible = e1, this.sprite && (this.sprite.visible = e1 ? _x.isMobileDevice : e1);
            }
            createGeometry() {
                return this.geometry = new dh(this.userData.width, this.userData.height, 10, 10), this;
            }
            async createMaterial() {
                const e1 = new Ug({
                    color: new Zc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: hr,
                    opacity: 0
                });
                return this.material = e1, this;
            }
            addEventListeners() {
                return this.addEventListener("select", ()=>this.onClick()), this.addEventListener("click", ()=>this.onClick()), this.addEventListener("hoverstart", ()=>this.onHoverStart()), this.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
            onHoverStart() {}
            onHoverEnd() {}
            onClick() {}
        };
        function n_(e1) {
            if (void 0 === e1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e1;
        }
        function i_(e1, t) {
            e1.prototype = Object.create(t.prototype), e1.prototype.constructor = e1, e1.__proto__ = t;
        }
        var r_, a_, s_, o_, l_, c_, u_, h_, d_, p_, f_, m_, g_, A_, v_, M_, y_, x_ = {
            autoSleep: 120,
            force3D: "auto",
            nullTargetWarn: 1,
            units: {
                lineHeight: ""
            }
        }, __ = {
            duration: .5,
            overwrite: !1,
            delay: 0
        }, b_ = 1e8, w_ = 1e-8, E_ = 2 * Math.PI, T_ = E_ / 4, S_ = 0, I_ = Math.sqrt, N_ = Math.cos, D_ = Math.sin, C_ = function(e1) {
            return "string" == typeof e1;
        }, L_ = function(e1) {
            return "function" == typeof e1;
        }, R_ = function(e1) {
            return "number" == typeof e1;
        }, z_ = function(e1) {
            return void 0 === e1;
        }, O_ = function(e1) {
            return "object" == typeof e1;
        }, P_ = function(e1) {
            return !1 !== e1;
        }, U_ = function() {
            return "undefined" != typeof window;
        }, k_ = function(e1) {
            return L_(e1) || C_(e1);
        }, j_ = "function" == typeof ArrayBuffer && ArrayBuffer.isView || function() {}, B_ = Array.isArray, F_ = /(?:-?\.?\d|\.)+/gi, H_ = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, V_ = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, G_ = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, Q_ = /[+-]=-?[.\d]+/, W_ = /[^,'"\[\]\s]+/gi, Y_ = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, X_ = {}, Z_ = {}, q_ = function(e1) {
            return (Z_ = Eb(e1, X_)) && EE;
        }, K_ = function(e1, t) {
            return console.warn("Invalid property", e1, "set to", t, "Missing plugin? gsap.registerPlugin()");
        }, J_ = function(e1, t) {
            return !t && console.warn(e1);
        }, $_ = function(e1, t) {
            return e1 && (X_[e1] = t) && Z_ && (Z_[e1] = t) || X_;
        }, eb = function() {
            return 0;
        }, tb = {
            suppressEvents: !0,
            isStart: !0,
            kill: !1
        }, nb = {
            suppressEvents: !0,
            kill: !1
        }, ib = {
            suppressEvents: !0
        }, rb = {}, ab = [], sb = {}, ob = {}, lb = {}, cb = 30, ub = [], hb = "", db = function(e1) {
            var t, n, i = e1[0];
            if (O_(i) || L_(i) || (e1 = [
                e1
            ]), !(t = (i._gsap || {}).harness)) {
                for(n = ub.length; n-- && !ub[n].targetTest(i););
                t = ub[n];
            }
            for(n = e1.length; n--;)e1[n] && (e1[n]._gsap || (e1[n]._gsap = new jw(e1[n], t))) || e1.splice(n, 1);
            return e1;
        }, pb = function(e1) {
            return e1._gsap || db(nw(e1))[0]._gsap;
        }, fb = function(e1, t, n) {
            return (n = e1[t]) && L_(n) ? e1[t]() : z_(n) && e1.getAttribute && e1.getAttribute(t) || n;
        }, mb = function(e1, t) {
            return (e1 = e1.split(",")).forEach(t) || e1;
        }, gb = function(e1) {
            return Math.round(1e5 * e1) / 1e5 || 0;
        }, Ab = function(e1) {
            return Math.round(1e7 * e1) / 1e7 || 0;
        }, vb = function(e1, t) {
            var n = t.charAt(0), i = parseFloat(t.substr(2));
            return e1 = parseFloat(e1), "+" === n ? e1 + i : "-" === n ? e1 - i : "*" === n ? e1 * i : e1 / i;
        }, Mb = function(e1, t) {
            for(var n = t.length, i = 0; e1.indexOf(t[i]) < 0 && ++i < n;);
            return i < n;
        }, yb = function() {
            var e1, t, n = ab.length, i = ab.slice(0);
            for(sb = {}, ab.length = 0, e1 = 0; e1 < n; e1++)(t = i[e1]) && t._lazy && (t.render(t._lazy[0], t._lazy[1], !0)._lazy = 0);
        }, xb = function(e1, t, n, i) {
            ab.length && !a_ && yb(), e1.render(t, n, i || a_ && t < 0 && (e1._initted || e1._startAt)), ab.length && !a_ && yb();
        }, _b = function(e1) {
            var t = parseFloat(e1);
            return (t || 0 === t) && (e1 + "").match(W_).length < 2 ? t : C_(e1) ? e1.trim() : e1;
        }, bb = function(e1) {
            return e1;
        }, wb = function(e1, t) {
            for(var n in t)n in e1 || (e1[n] = t[n]);
            return e1;
        }, Eb = function(e1, t) {
            for(var n in t)e1[n] = t[n];
            return e1;
        }, Tb = function e1(t, n) {
            for(var i in n)"__proto__" !== i && "constructor" !== i && "prototype" !== i && (t[i] = O_(n[i]) ? e1(t[i] || (t[i] = {}), n[i]) : n[i]);
            return t;
        }, Sb = function(e1, t) {
            var n, i = {};
            for(n in e1)n in t || (i[n] = e1[n]);
            return i;
        }, Ib = function(e1) {
            var t, n = e1.parent || o_, i = e1.keyframes ? (t = B_(e1.keyframes), function(e1, n) {
                for(var i in n)i in e1 || "duration" === i && t || "ease" === i || (e1[i] = n[i]);
            }) : wb;
            if (P_(e1.inherit)) for(; n;)i(e1, n.vars.defaults), n = n.parent || n._dp;
            return e1;
        }, Nb = function(e1, t, n, i, r) {
            void 0 === n && (n = "_first"), void 0 === i && (i = "_last");
            var a, s = e1[i];
            if (r) for(a = t[r]; s && s[r] > a;)s = s._prev;
            return s ? (t._next = s._next, s._next = t) : (t._next = e1[n], e1[n] = t), t._next ? t._next._prev = t : e1[i] = t, t._prev = s, t.parent = t._dp = e1, t;
        }, Db = function(e1, t, n, i) {
            void 0 === n && (n = "_first"), void 0 === i && (i = "_last");
            var r = t._prev, a = t._next;
            r ? r._next = a : e1[n] === t && (e1[n] = a), a ? a._prev = r : e1[i] === t && (e1[i] = r), t._next = t._prev = t.parent = null;
        }, Cb = function(e1, t) {
            e1.parent && (!t || e1.parent.autoRemoveChildren) && e1.parent.remove && e1.parent.remove(e1), e1._act = 0;
        }, Lb = function(e1, t) {
            if (e1 && (!t || t._end > e1._dur || t._start < 0)) for(var n = e1; n;)n._dirty = 1, n = n.parent;
            return e1;
        }, Rb = function(e1, t, n, i) {
            return e1._startAt && (a_ ? e1._startAt.revert(nb) : e1.vars.immediateRender && !e1.vars.autoRevert || e1._startAt.render(t, !0, i));
        }, zb = function e1(t) {
            return !t || t._ts && e1(t.parent);
        }, Ob = function(e1) {
            return e1._repeat ? Pb(e1._tTime, e1 = e1.duration() + e1._rDelay) * e1 : 0;
        }, Pb = function(e1, t) {
            var n = Math.floor(e1 /= t);
            return e1 && n === e1 ? n - 1 : n;
        }, Ub = function(e1, t) {
            return (e1 - t._start) * t._ts + (t._ts >= 0 ? 0 : t._dirty ? t.totalDuration() : t._tDur);
        }, kb = function(e1) {
            return e1._end = Ab(e1._start + (e1._tDur / Math.abs(e1._ts || e1._rts || w_) || 0));
        }, jb = function(e1, t) {
            var n = e1._dp;
            return n && n.smoothChildTiming && e1._ts && (e1._start = Ab(n._time - (e1._ts > 0 ? t / e1._ts : ((e1._dirty ? e1.totalDuration() : e1._tDur) - t) / -e1._ts)), kb(e1), n._dirty || Lb(n, e1)), e1;
        }, Bb = function(e1, t) {
            var n;
            if ((t._time || !t._dur && t._initted || t._start < e1._time && (t._dur || !t.add)) && (n = Ub(e1.rawTime(), t), (!t._dur || Jb(0, t.totalDuration(), n) - t._tTime > w_) && t.render(n, !0)), Lb(e1, t)._dp && e1._initted && e1._time >= e1._dur && e1._ts) {
                if (e1._dur < e1.duration()) for(n = e1; n._dp;)n.rawTime() >= 0 && n.totalTime(n._tTime), n = n._dp;
                e1._zTime = -0.00000001;
            }
        }, Fb = function(e1, t, n, i) {
            return t.parent && Cb(t), t._start = Ab((R_(n) ? n : n || e1 !== o_ ? Zb(e1, n, t) : e1._time) + t._delay), t._end = Ab(t._start + (t.totalDuration() / Math.abs(t.timeScale()) || 0)), Nb(e1, t, "_first", "_last", e1._sort ? "_start" : 0), Qb(t) || (e1._recent = t), i || Bb(e1, t), e1._ts < 0 && jb(e1, e1._tTime), e1;
        }, Hb = function(e1, t) {
            return (X_.ScrollTrigger || K_("scrollTrigger", t)) && X_.ScrollTrigger.create(t, e1);
        }, Vb = function(e1, t, n, i, r) {
            return Yw(e1, t, r), e1._initted ? !n && e1._pt && !a_ && (e1._dur && !1 !== e1.vars.lazy || !e1._dur && e1.vars.lazy) && d_ !== Tw.frame ? (ab.push(e1), e1._lazy = [
                r,
                i
            ], 1) : void 0 : 1;
        }, Gb = function e1(t) {
            var n = t.parent;
            return n && n._ts && n._initted && !n._lock && (n.rawTime() < 0 || e1(n));
        }, Qb = function(e1) {
            var t = e1.data;
            return "isFromStart" === t || "isStart" === t;
        }, Wb = function(e1, t, n, i) {
            var r = e1._repeat, a = Ab(t) || 0, s = e1._tTime / e1._tDur;
            return s && !i && (e1._time *= a / e1._dur), e1._dur = a, e1._tDur = r ? r < 0 ? 1e10 : Ab(a * (r + 1) + e1._rDelay * r) : a, s > 0 && !i && jb(e1, e1._tTime = e1._tDur * s), e1.parent && kb(e1), n || Lb(e1.parent, e1), e1;
        }, Yb = function(e1) {
            return e1 instanceof Fw ? Lb(e1) : Wb(e1, e1._dur);
        }, Xb = {
            _start: 0,
            endTime: eb,
            totalDuration: eb
        }, Zb = function e1(t, n, i) {
            var r, a, s, o = t.labels, l = t._recent || Xb, c = t.duration() >= b_ ? l.endTime(!1) : t._dur;
            return C_(n) && (isNaN(n) || n in o) ? (a = n.charAt(0), s = "%" === n.substr(-1), r = n.indexOf("="), "<" === a || ">" === a ? (r >= 0 && (n = n.replace(/=/, "")), ("<" === a ? l._start : l.endTime(l._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) * (s ? (r < 0 ? l : i).totalDuration() / 100 : 1)) : r < 0 ? (n in o || (o[n] = c), o[n]) : (a = parseFloat(n.charAt(r - 1) + n.substr(r + 1)), s && i && (a = a / 100 * (B_(i) ? i[0] : i).totalDuration()), r > 1 ? e1(t, n.substr(0, r - 1), i) + a : c + a)) : null == n ? c : +n;
        }, qb = function(e1, t, n) {
            var i, r, a = R_(t[1]), s = (a ? 2 : 1) + (e1 < 2 ? 0 : 1), o = t[s];
            if (a && (o.duration = t[1]), o.parent = n, e1) {
                for(i = o, r = n; r && !("immediateRender" in i);)i = r.vars.defaults || {}, r = P_(r.vars.inherit) && r.parent;
                o.immediateRender = P_(i.immediateRender), e1 < 2 ? o.runBackwards = 1 : o.startAt = t[s - 1];
            }
            return new Jw(t[0], o, t[s + 1]);
        }, Kb = function(e1, t) {
            return e1 || 0 === e1 ? t(e1) : t;
        }, Jb = function(e1, t, n) {
            return n < e1 ? e1 : n > t ? t : n;
        }, $b = function(e1, t) {
            return C_(e1) && (t = Y_.exec(e1)) ? t[1] : "";
        }, ew = [].slice, tw = function(e1, t) {
            return e1 && O_(e1) && "length" in e1 && (!t && !e1.length || e1.length - 1 in e1 && O_(e1[0])) && !e1.nodeType && e1 !== l_;
        }, nw = function(e1, t, n) {
            return s_ && !t && s_.selector ? s_.selector(e1) : !C_(e1) || n || !c_ && Sw() ? B_(e1) ? function(e1, t, n) {
                return void 0 === n && (n = []), e1.forEach(function(e1) {
                    var i;
                    return C_(e1) && !t || tw(e1, 1) ? (i = n).push.apply(i, nw(e1)) : n.push(e1);
                }) || n;
            }(e1, n) : tw(e1) ? ew.call(e1, 0) : e1 ? [
                e1
            ] : [] : ew.call((t || u_).querySelectorAll(e1), 0);
        }, iw = function(e1) {
            return e1 = nw(e1)[0] || J_("Invalid scope") || {}, function(t) {
                var n = e1.current || e1.nativeElement || e1;
                return nw(t, n.querySelectorAll ? n : n === e1 ? J_("Invalid scope") || u_.createElement("div") : e1);
            };
        }, rw = function(e1) {
            return e1.sort(function() {
                return .5 - Math.random();
            });
        }, aw = function(e1) {
            if (L_(e1)) return e1;
            var t = O_(e1) ? e1 : {
                each: e1
            }, n = zw(t.ease), i = t.from || 0, r = parseFloat(t.base) || 0, a = {}, s = i > 0 && i < 1, o = isNaN(i) || s, l = t.axis, c = i, u = i;
            return C_(i) ? c = u = ({
                center: .5,
                edges: .5,
                end: 1
            })[i] || 0 : !s && o && (c = i[0], u = i[1]), function(e1, s, h) {
                var d, p, f, m, g, A, v, M, y, x = (h || t).length, _ = a[x];
                if (!_) {
                    if (!(y = "auto" === t.grid ? 0 : (t.grid || [
                        1,
                        b_
                    ])[1])) {
                        for(v = -b_; v < (v = h[y++].getBoundingClientRect().left) && y < x;);
                        y < x && y--;
                    }
                    for(_ = a[x] = [], d = o ? Math.min(y, x) * c - .5 : i % y, p = y === b_ ? 0 : o ? x * u / y - .5 : i / y | 0, v = 0, M = b_, A = 0; A < x; A++)f = A % y - d, m = p - (A / y | 0), _[A] = g = l ? Math.abs("y" === l ? m : f) : I_(f * f + m * m), g > v && (v = g), g < M && (M = g);
                    "random" === i && rw(_), _.max = v - M, _.min = M, _.v = x = (parseFloat(t.amount) || parseFloat(t.each) * (y > x ? x - 1 : l ? "y" === l ? x / y : y : Math.max(y, x / y)) || 0) * ("edges" === i ? -1 : 1), _.b = x < 0 ? r - x : r, _.u = $b(t.amount || t.each) || 0, n = n && x < 0 ? Lw(n) : n;
                }
                return x = (_[e1] - _.min) / _.max || 0, Ab(_.b + (n ? n(x) : x) * _.v) + _.u;
            };
        }, sw = function(e1) {
            var t = Math.pow(10, ((e1 + "").split(".")[1] || "").length);
            return function(n) {
                var i = Ab(Math.round(parseFloat(n) / e1) * e1 * t);
                return (i - i % 1) / t + (R_(n) ? 0 : $b(n));
            };
        }, ow = function(e1, t) {
            var n, i, r = B_(e1);
            return !r && O_(e1) && (n = r = e1.radius || b_, e1.values ? (e1 = nw(e1.values), (i = !R_(e1[0])) && (n *= n)) : e1 = sw(e1.increment)), Kb(t, r ? L_(e1) ? function(t) {
                return i = e1(t), Math.abs(i - t) <= n ? i : t;
            } : function(t) {
                for(var r, a, s = parseFloat(i ? t.x : t), o = parseFloat(i ? t.y : 0), l = b_, c = 0, u = e1.length; u--;)(r = i ? (r = e1[u].x - s) * r + (a = e1[u].y - o) * a : Math.abs(e1[u] - s)) < l && (l = r, c = u);
                return c = !n || l <= n ? e1[c] : t, i || c === t || R_(t) ? c : c + $b(t);
            } : sw(e1));
        }, lw = function(e1, t, n, i) {
            return Kb(B_(e1) ? !t : !0 === n ? (n = 0, false) : !i, function() {
                return B_(e1) ? e1[~~(Math.random() * e1.length)] : (n = n || 1e-5, i = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) && Math.floor(Math.round((e1 - n / 2 + Math.random() * (t - e1 + .99 * n)) / n) * n * i) / i;
            });
        }, cw = function(e1, t, n) {
            return Kb(n, function(n) {
                return e1[~~t(n)];
            });
        }, uw = function(e1) {
            for(var t, n, i, r, a = 0, s = ""; ~(t = e1.indexOf("random(", a));)i = e1.indexOf(")", t), r = "[" === e1.charAt(t + 7), n = e1.substr(t + 7, i - t - 7).match(r ? W_ : F_), s += e1.substr(a, t - a) + lw(r ? n : +n[0], r ? 0 : +n[1], +n[2] || 1e-5), a = i + 1;
            return s + e1.substr(a, e1.length - a);
        }, hw = function(e1, t, n, i, r) {
            var a = t - e1, s = i - n;
            return Kb(r, function(t) {
                return n + ((t - e1) / a * s || 0);
            });
        }, dw = function(e1, t, n) {
            var i, r, a, s = e1.labels, o = b_;
            for(i in s)(r = s[i] - t) < 0 == !!n && r && o > (r = Math.abs(r)) && (a = i, o = r);
            return a;
        }, pw = function(e1, t, n) {
            var i, r, a, s = e1.vars, o = s[t], l = s_, c = e1._ctx;
            if (o) return i = s[t + "Params"], r = s.callbackScope || e1, n && ab.length && yb(), c && (s_ = c), a = i ? o.apply(r, i) : o.call(r), s_ = l, a;
        }, fw = function(e1) {
            return Cb(e1), e1.scrollTrigger && e1.scrollTrigger.kill(!!a_), e1.progress() < 1 && pw(e1, "onInterrupt"), e1;
        }, mw = [], gw = function(e1) {
            if (e1) {
                if (e1 = !e1.name && e1.default || e1, U_() || e1.headless) {
                    var t = e1.name, n = L_(e1), i = t && !n && e1.init ? function() {
                        this._props = [];
                    } : e1, r = {
                        init: eb,
                        render: oE,
                        add: Qw,
                        kill: cE,
                        modifier: lE,
                        rawVars: 0
                    }, a = {
                        targetTest: 0,
                        get: 0,
                        getSetter: iE,
                        aliases: {},
                        register: 0
                    };
                    if (Sw(), e1 !== i) {
                        if (ob[t]) return;
                        wb(i, wb(Sb(e1, r), a)), Eb(i.prototype, Eb(r, Sb(e1, a))), ob[i.prop = t] = i, e1.targetTest && (ub.push(i), rb[t] = 1), t = ("css" === t ? "CSS" : t.charAt(0).toUpperCase() + t.substr(1)) + "Plugin";
                    }
                    $_(t, i), e1.register && e1.register(EE, i, dE);
                } else mw.push(e1);
            }
        }, Aw = 255, vw = {
            aqua: [
                0,
                Aw,
                Aw
            ],
            lime: [
                0,
                Aw,
                0
            ],
            silver: [
                192,
                192,
                192
            ],
            black: [
                0,
                0,
                0
            ],
            maroon: [
                128,
                0,
                0
            ],
            teal: [
                0,
                128,
                128
            ],
            blue: [
                0,
                0,
                Aw
            ],
            navy: [
                0,
                0,
                128
            ],
            white: [
                Aw,
                Aw,
                Aw
            ],
            olive: [
                128,
                128,
                0
            ],
            yellow: [
                Aw,
                Aw,
                0
            ],
            orange: [
                Aw,
                165,
                0
            ],
            gray: [
                128,
                128,
                128
            ],
            purple: [
                128,
                0,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            red: [
                Aw,
                0,
                0
            ],
            pink: [
                Aw,
                192,
                203
            ],
            cyan: [
                0,
                Aw,
                Aw
            ],
            transparent: [
                Aw,
                Aw,
                Aw,
                0
            ]
        }, Mw = function(e1, t, n) {
            return (6 * (e1 += e1 < 0 ? 1 : e1 > 1 ? -1 : 0) < 1 ? t + (n - t) * e1 * 6 : e1 < .5 ? n : 3 * e1 < 2 ? t + (n - t) * (2 / 3 - e1) * 6 : t) * Aw + .5 | 0;
        }, yw = function(e1, t, n) {
            var i, r, a, s, o, l, c, u, h, d, p = e1 ? R_(e1) ? [
                e1 >> 16,
                e1 >> 8 & Aw,
                e1 & Aw
            ] : 0 : vw.black;
            if (!p) {
                if ("," === e1.substr(-1) && (e1 = e1.substr(0, e1.length - 1)), vw[e1]) p = vw[e1];
                else if ("#" === e1.charAt(0)) {
                    if (e1.length < 6 && (i = e1.charAt(1), r = e1.charAt(2), a = e1.charAt(3), e1 = "#" + i + i + r + r + a + a + (5 === e1.length ? e1.charAt(4) + e1.charAt(4) : "")), 9 === e1.length) return [
                        (p = parseInt(e1.substr(1, 6), 16)) >> 16,
                        p >> 8 & Aw,
                        p & Aw,
                        parseInt(e1.substr(7), 16) / 255
                    ];
                    p = [
                        (e1 = parseInt(e1.substr(1), 16)) >> 16,
                        e1 >> 8 & Aw,
                        e1 & Aw
                    ];
                } else if ("hsl" === e1.substr(0, 3)) {
                    if (p = d = e1.match(F_), t) {
                        if (~e1.indexOf("=")) return p = e1.match(H_), n && p.length < 4 && (p[3] = 1), p;
                    } else s = +p[0] % 360 / 360, o = +p[1] / 100, i = 2 * (l = +p[2] / 100) - (r = l <= .5 ? l * (o + 1) : l + o - l * o), p.length > 3 && (p[3] *= 1), p[0] = Mw(s + 1 / 3, i, r), p[1] = Mw(s, i, r), p[2] = Mw(s - 1 / 3, i, r);
                } else p = e1.match(F_) || vw.transparent;
                p = p.map(Number);
            }
            return t && !d && (i = p[0] / Aw, r = p[1] / Aw, a = p[2] / Aw, l = ((c = Math.max(i, r, a)) + (u = Math.min(i, r, a))) / 2, c === u ? s = o = 0 : (h = c - u, o = l > .5 ? h / (2 - c - u) : h / (c + u), s = c === i ? (r - a) / h + (r < a ? 6 : 0) : c === r ? (a - i) / h + 2 : (i - r) / h + 4, s *= 60), p[0] = ~~(s + .5), p[1] = ~~(100 * o + .5), p[2] = ~~(100 * l + .5)), n && p.length < 4 && (p[3] = 1), p;
        }, xw = function(e1) {
            var t = [], n = [], i = -1;
            return e1.split(bw).forEach(function(e1) {
                var r = e1.match(V_) || [];
                t.push.apply(t, r), n.push(i += r.length + 1);
            }), t.c = n, t;
        }, _w = function(e1, t, n) {
            var i, r, a, s, o = "", l = (e1 + o).match(bw), c = t ? "hsla(" : "rgba(", u = 0;
            if (!l) return e1;
            if (l = l.map(function(e1) {
                return (e1 = yw(e1, t, 1)) && c + (t ? e1[0] + "," + e1[1] + "%," + e1[2] + "%," + e1[3] : e1.join(",")) + ")";
            }), n && (a = xw(e1), (i = n.c).join(o) !== a.c.join(o))) for(s = (r = e1.replace(bw, "1").split(V_)).length - 1; u < s; u++)o += r[u] + (~i.indexOf(u) ? l.shift() || c + "0,0,0,0)" : (a.length ? a : l.length ? l : n).shift());
            if (!r) for(s = (r = e1.split(bw)).length - 1; u < s; u++)o += r[u] + l[u];
            return o + r[s];
        }, bw = function() {
            var e1, t = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
            for(e1 in vw)t += "|" + e1 + "\\b";
            return new RegExp(t + ")", "gi");
        }(), ww = /hsl[a]?\(/, Ew = function(e1) {
            var t, n = e1.join(" ");
            if (bw.lastIndex = 0, bw.test(n)) return t = ww.test(n), e1[1] = _w(e1[1], t), e1[0] = _w(e1[0], t, xw(e1[1])), !0;
        }, Tw = function() {
            var e1, t, n, i, r, a, s = Date.now, o = 500, l = 33, c = s(), u = c, h = 1e3 / 240, d = h, p = [], f = function n(f) {
                var m, g, A, v, M = s() - u, y = !0 === f;
                if ((M > o || M < 0) && (c += M - l), ((m = (A = (u += M) - c) - d) > 0 || y) && (v = ++i.frame, r = A - 1e3 * i.time, i.time = A /= 1e3, d += m + (m >= h ? 4 : h - m), g = 1), y || (e1 = t(n)), g) for(a = 0; a < p.length; a++)p[a](A, r, v, f);
            };
            return i = {
                time: 0,
                frame: 0,
                tick: function() {
                    f(!0);
                },
                deltaRatio: function(e1) {
                    return r / (1e3 / (e1 || 60));
                },
                wake: function() {
                    h_ && (!c_ && U_() && (l_ = c_ = window, u_ = l_.document || {}, X_.gsap = EE, (l_.gsapVersions || (l_.gsapVersions = [])).push(EE.version), q_(Z_ || l_.GreenSockGlobals || !l_.gsap && l_ || {}), mw.forEach(gw)), n = "undefined" != typeof requestAnimationFrame && requestAnimationFrame, e1 && i.sleep(), t = n || function(e1) {
                        return setTimeout(e1, d - 1e3 * i.time + 1 | 0);
                    }, f_ = 1, f(2));
                },
                sleep: function() {
                    (n ? cancelAnimationFrame : clearTimeout)(e1), f_ = 0, t = eb;
                },
                lagSmoothing: function(e1, t) {
                    o = e1 || 1 / 0, l = Math.min(t || 33, o);
                },
                fps: function(e1) {
                    h = 1e3 / (e1 || 240), d = 1e3 * i.time + h;
                },
                add: function(e1, t, n) {
                    var r = t ? function(t, n, a, s) {
                        e1(t, n, a, s), i.remove(r);
                    } : e1;
                    return i.remove(e1), p[n ? "unshift" : "push"](r), Sw(), r;
                },
                remove: function(e1, t) {
                    ~(t = p.indexOf(e1)) && p.splice(t, 1) && a >= t && a--;
                },
                _listeners: p
            }, i;
        }(), Sw = function() {
            return !f_ && Tw.wake();
        }, Iw = {}, Nw = /^[\d.\-M][\d.\-,\s]/, Dw = /["']/g, Cw = function(e1) {
            for(var t, n, i, r = {}, a = e1.substr(1, e1.length - 3).split(":"), s = a[0], o = 1, l = a.length; o < l; o++)n = a[o], t = o !== l - 1 ? n.lastIndexOf(",") : n.length, i = n.substr(0, t), r[s] = isNaN(i) ? i.replace(Dw, "").trim() : +i, s = n.substr(t + 1).trim();
            return r;
        }, Lw = function(e1) {
            return function(t) {
                return 1 - e1(1 - t);
            };
        }, Rw = function e1(t, n) {
            for(var i, r = t._first; r;)r instanceof Fw ? e1(r, n) : !r.vars.yoyoEase || r._yoyo && r._repeat || r._yoyo === n || (r.timeline ? e1(r.timeline, n) : (i = r._ease, r._ease = r._yEase, r._yEase = i, r._yoyo = n)), r = r._next;
        }, zw = function(e1, t) {
            return e1 && (L_(e1) ? e1 : Iw[e1] || function(e1) {
                var t, n, i, r, a = (e1 + "").split("("), s = Iw[a[0]];
                return s && a.length > 1 && s.config ? s.config.apply(null, ~e1.indexOf("{") ? [
                    Cw(a[1])
                ] : (t = e1, n = t.indexOf("(") + 1, i = t.indexOf(")"), r = t.indexOf("(", n), t.substring(n, ~r && r < i ? t.indexOf(")", i + 1) : i)).split(",").map(_b)) : Iw._CE && Nw.test(e1) ? Iw._CE("", e1) : s;
            }(e1)) || t;
        }, Ow = function(e1, t, n, i) {
            void 0 === n && (n = function(e1) {
                return 1 - t(1 - e1);
            }), void 0 === i && (i = function(e1) {
                return e1 < .5 ? t(2 * e1) / 2 : 1 - t(2 * (1 - e1)) / 2;
            });
            var r, a = {
                easeIn: t,
                easeOut: n,
                easeInOut: i
            };
            return mb(e1, function(e1) {
                for(var t in Iw[e1] = X_[e1] = a, Iw[r = e1.toLowerCase()] = n, a)Iw[r + ("easeIn" === t ? ".in" : "easeOut" === t ? ".out" : ".inOut")] = Iw[e1 + "." + t] = a[t];
            }), a;
        }, Pw = function(e1) {
            return function(t) {
                return t < .5 ? (1 - e1(1 - 2 * t)) / 2 : .5 + e1(2 * (t - .5)) / 2;
            };
        }, Uw = function e1(t, n, i) {
            var r = n >= 1 ? n : 1, a = (i || (t ? .3 : .45)) / (n < 1 ? n : 1), s = a / E_ * (Math.asin(1 / r) || 0), o = function(e1) {
                return 1 === e1 ? 1 : r * Math.pow(2, -10 * e1) * D_((e1 - s) * a) + 1;
            }, l = "out" === t ? o : "in" === t ? function(e1) {
                return 1 - o(1 - e1);
            } : Pw(o);
            return a = E_ / a, l.config = function(n, i) {
                return e1(t, n, i);
            }, l;
        }, kw = function e1(t, n) {
            void 0 === n && (n = 1.70158);
            var i = function(e1) {
                return e1 ? --e1 * e1 * ((n + 1) * e1 + n) + 1 : 0;
            }, r = "out" === t ? i : "in" === t ? function(e1) {
                return 1 - i(1 - e1);
            } : Pw(i);
            return r.config = function(n) {
                return e1(t, n);
            }, r;
        };
        mb("Linear,Quad,Cubic,Quart,Quint,Strong", function(e1, t) {
            var n = t < 5 ? t + 1 : t;
            Ow(e1 + ",Power" + (n - 1), t ? function(e1) {
                return Math.pow(e1, n);
            } : function(e1) {
                return e1;
            }, function(e1) {
                return 1 - Math.pow(1 - e1, n);
            }, function(e1) {
                return e1 < .5 ? Math.pow(2 * e1, n) / 2 : 1 - Math.pow(2 * (1 - e1), n) / 2;
            });
        }), Iw.Linear.easeNone = Iw.none = Iw.Linear.easeIn, Ow("Elastic", Uw("in"), Uw("out"), Uw()), m_ = 7.5625, v_ = 2 * (A_ = 1 / (g_ = 2.75)), M_ = 2.5 * A_, Ow("Bounce", function(e1) {
            return 1 - y_(1 - e1);
        }, y_ = function(e1) {
            return e1 < A_ ? m_ * e1 * e1 : e1 < v_ ? m_ * Math.pow(e1 - 1.5 / g_, 2) + .75 : e1 < M_ ? m_ * (e1 -= 2.25 / g_) * e1 + .9375 : m_ * Math.pow(e1 - 2.625 / g_, 2) + .984375;
        }), Ow("Expo", function(e1) {
            return e1 ? Math.pow(2, 10 * (e1 - 1)) : 0;
        }), Ow("Circ", function(e1) {
            return -(I_(1 - e1 * e1) - 1);
        }), Ow("Sine", function(e1) {
            return 1 === e1 ? 1 : 1 - N_(e1 * T_);
        }), Ow("Back", kw("in"), kw("out"), kw()), Iw.SteppedEase = Iw.steps = X_.SteppedEase = {
            config: function(e1, t) {
                void 0 === e1 && (e1 = 1);
                var n = 1 / e1, i = e1 + (t ? 0 : 1), r = t ? 1 : 0;
                return function(e1) {
                    return ((i * Jb(0, .99999999, e1) | 0) + r) * n;
                };
            }
        }, __.ease = Iw["quad.out"], mb("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(e1) {
            return hb += e1 + "," + e1 + "Params,";
        });
        var jw = function(e1, t) {
            this.id = S_++, e1._gsap = this, this.target = e1, this.harness = t, this.get = t ? t.get : fb, this.set = t ? t.getSetter : iE;
        }, Bw = function() {
            function e1(e1) {
                this.vars = e1, this._delay = +e1.delay || 0, (this._repeat = e1.repeat === 1 / 0 ? -2 : e1.repeat || 0) && (this._rDelay = e1.repeatDelay || 0, this._yoyo = !!e1.yoyo || !!e1.yoyoEase), this._ts = 1, Wb(this, +e1.duration, 1, 1), this.data = e1.data, s_ && (this._ctx = s_, s_.data.push(this)), f_ || Tw.wake();
            }
            var t = e1.prototype;
            return t.delay = function(e1) {
                return e1 || 0 === e1 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + e1 - this._delay), this._delay = e1, this) : this._delay;
            }, t.duration = function(e1) {
                return arguments.length ? this.totalDuration(this._repeat > 0 ? e1 + (e1 + this._rDelay) * this._repeat : e1) : this.totalDuration() && this._dur;
            }, t.totalDuration = function(e1) {
                return arguments.length ? (this._dirty = 0, Wb(this, this._repeat < 0 ? e1 : (e1 - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
            }, t.totalTime = function(e1, t) {
                if (Sw(), !arguments.length) return this._tTime;
                var n = this._dp;
                if (n && n.smoothChildTiming && this._ts) {
                    for(jb(this, e1), !n._dp || n.parent || Bb(n, this); n && n.parent;)n.parent._time !== n._start + (n._ts >= 0 ? n._tTime / n._ts : (n.totalDuration() - n._tTime) / -n._ts) && n.totalTime(n._tTime, !0), n = n.parent;
                    !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && e1 < this._tDur || this._ts < 0 && e1 > 0 || !this._tDur && !e1) && Fb(this._dp, this, this._start - this._delay);
                }
                return (this._tTime !== e1 || !this._dur && !t || this._initted && Math.abs(this._zTime) === w_ || !e1 && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = e1), xb(this, e1, t)), this;
            }, t.time = function(e1, t) {
                return arguments.length ? this.totalTime(Math.min(this.totalDuration(), e1 + Ob(this)) % (this._dur + this._rDelay) || (e1 ? this._dur : 0), t) : this._time;
            }, t.totalProgress = function(e1, t) {
                return arguments.length ? this.totalTime(this.totalDuration() * e1, t) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() > 0 ? 1 : 0;
            }, t.progress = function(e1, t) {
                return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? e1 : 1 - e1) + Ob(this), t) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
            }, t.iteration = function(e1, t) {
                var n = this.duration() + this._rDelay;
                return arguments.length ? this.totalTime(this._time + (e1 - 1) * n, t) : this._repeat ? Pb(this._tTime, n) + 1 : 1;
            }, t.timeScale = function(e1, t) {
                if (!arguments.length) return -0.00000001 === this._rts ? 0 : this._rts;
                if (this._rts === e1) return this;
                var n = this.parent && this._ts ? Ub(this.parent._time, this) : this._tTime;
                return this._rts = +e1 || 0, this._ts = this._ps || -0.00000001 === e1 ? 0 : this._rts, this.totalTime(Jb(-Math.abs(this._delay), this._tDur, n), !1 !== t), kb(this), function(e1) {
                    for(var t = e1.parent; t && t.parent;)t._dirty = 1, t.totalDuration(), t = t.parent;
                    return e1;
                }(this);
            }, t.paused = function(e1) {
                return arguments.length ? (this._ps !== e1 && (this._ps = e1, e1 ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (Sw(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && Math.abs(this._zTime) !== w_ && (this._tTime -= w_)))), this) : this._ps;
            }, t.startTime = function(e1) {
                if (arguments.length) {
                    this._start = e1;
                    var t = this.parent || this._dp;
                    return t && (t._sort || !this.parent) && Fb(t, this, e1 - this._delay), this;
                }
                return this._start;
            }, t.endTime = function(e1) {
                return this._start + (P_(e1) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
            }, t.rawTime = function(e1) {
                var t = this.parent || this._dp;
                return t ? e1 && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? Ub(t.rawTime(e1), this) : this._tTime : this._tTime;
            }, t.revert = function(e1) {
                void 0 === e1 && (e1 = ib);
                var t = a_;
                return a_ = e1, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(e1), this.totalTime(-0.01, e1.suppressEvents)), "nested" !== this.data && !1 !== e1.kill && this.kill(), a_ = t, this;
            }, t.globalTime = function(e1) {
                for(var t = this, n = arguments.length ? e1 : t.rawTime(); t;)n = t._start + n / (Math.abs(t._ts) || 1), t = t._dp;
                return !this.parent && this._sat ? this._sat.globalTime(e1) : n;
            }, t.repeat = function(e1) {
                return arguments.length ? (this._repeat = e1 === 1 / 0 ? -2 : e1, Yb(this)) : -2 === this._repeat ? 1 / 0 : this._repeat;
            }, t.repeatDelay = function(e1) {
                if (arguments.length) {
                    var t = this._time;
                    return this._rDelay = e1, Yb(this), t ? this.time(t) : this;
                }
                return this._rDelay;
            }, t.yoyo = function(e1) {
                return arguments.length ? (this._yoyo = e1, this) : this._yoyo;
            }, t.seek = function(e1, t) {
                return this.totalTime(Zb(this, e1), P_(t));
            }, t.restart = function(e1, t) {
                return this.play().totalTime(e1 ? -this._delay : 0, P_(t));
            }, t.play = function(e1, t) {
                return null != e1 && this.seek(e1, t), this.reversed(!1).paused(!1);
            }, t.reverse = function(e1, t) {
                return null != e1 && this.seek(e1 || this.totalDuration(), t), this.reversed(!0).paused(!1);
            }, t.pause = function(e1, t) {
                return null != e1 && this.seek(e1, t), this.paused(!0);
            }, t.resume = function() {
                return this.paused(!1);
            }, t.reversed = function(e1) {
                return arguments.length ? (!!e1 !== this.reversed() && this.timeScale(-this._rts || (e1 ? -0.00000001 : 0)), this) : this._rts < 0;
            }, t.invalidate = function() {
                return this._initted = this._act = 0, this._zTime = -0.00000001, this;
            }, t.isActive = function() {
                var e1, t = this.parent || this._dp, n = this._start;
                return !(t && !(this._ts && this._initted && t.isActive() && (e1 = t.rawTime(!0)) >= n && e1 < this.endTime(!0) - w_));
            }, t.eventCallback = function(e1, t, n) {
                var i = this.vars;
                return arguments.length > 1 ? (t ? (i[e1] = t, n && (i[e1 + "Params"] = n), "onUpdate" === e1 && (this._onUpdate = t)) : delete i[e1], this) : i[e1];
            }, t.then = function(e1) {
                var t = this;
                return new Promise(function(n) {
                    var i = L_(e1) ? e1 : bb, r = function() {
                        var e1 = t.then;
                        t.then = null, L_(i) && (i = i(t)) && (i.then || i === t) && (t.then = e1), n(i), t.then = e1;
                    };
                    t._initted && 1 === t.totalProgress() && t._ts >= 0 || !t._tTime && t._ts < 0 ? r() : t._prom = r;
                });
            }, t.kill = function() {
                fw(this);
            }, e1;
        }();
        wb(Bw.prototype, {
            _time: 0,
            _start: 0,
            _end: 0,
            _tTime: 0,
            _tDur: 0,
            _dirty: 0,
            _repeat: 0,
            _yoyo: !1,
            parent: null,
            _initted: !1,
            _rDelay: 0,
            _ts: 1,
            _dp: 0,
            ratio: 0,
            _zTime: -0.00000001,
            _prom: 0,
            _ps: !1,
            _rts: 1
        });
        var Fw = function(e1) {
            function t(t, n) {
                var i;
                return void 0 === t && (t = {}), (i = e1.call(this, t) || this).labels = {}, i.smoothChildTiming = !!t.smoothChildTiming, i.autoRemoveChildren = !!t.autoRemoveChildren, i._sort = P_(t.sortChildren), o_ && Fb(t.parent || o_, n_(i), n), t.reversed && i.reverse(), t.paused && i.paused(!0), t.scrollTrigger && Hb(n_(i), t.scrollTrigger), i;
            }
            i_(t, e1);
            var n = t.prototype;
            return n.to = function(e1, t, n) {
                return qb(0, arguments, this), this;
            }, n.from = function(e1, t, n) {
                return qb(1, arguments, this), this;
            }, n.fromTo = function(e1, t, n, i) {
                return qb(2, arguments, this), this;
            }, n.set = function(e1, t, n) {
                return t.duration = 0, t.parent = this, Ib(t).repeatDelay || (t.repeat = 0), t.immediateRender = !!t.immediateRender, new Jw(e1, t, Zb(this, n), 1), this;
            }, n.call = function(e1, t, n) {
                return Fb(this, Jw.delayedCall(0, e1, t), n);
            }, n.staggerTo = function(e1, t, n, i, r, a, s) {
                return n.duration = t, n.stagger = n.stagger || i, n.onComplete = a, n.onCompleteParams = s, n.parent = this, new Jw(e1, n, Zb(this, r)), this;
            }, n.staggerFrom = function(e1, t, n, i, r, a, s) {
                return n.runBackwards = 1, Ib(n).immediateRender = P_(n.immediateRender), this.staggerTo(e1, t, n, i, r, a, s);
            }, n.staggerFromTo = function(e1, t, n, i, r, a, s, o) {
                return i.startAt = n, Ib(i).immediateRender = P_(i.immediateRender), this.staggerTo(e1, t, i, r, a, s, o);
            }, n.render = function(e1, t, n) {
                var i, r, a, s, o, l, c, u, h, d, p, f, m = this._time, g = this._dirty ? this.totalDuration() : this._tDur, A = this._dur, v = e1 <= 0 ? 0 : Ab(e1), M = this._zTime < 0 != e1 < 0 && (this._initted || !A);
                if (this !== o_ && v > g && e1 >= 0 && (v = g), v !== this._tTime || n || M) {
                    if (m !== this._time && A && (v += this._time - m, e1 += this._time - m), i = v, h = this._start, l = !(u = this._ts), M && (A || (m = this._zTime), (e1 || !t) && (this._zTime = e1)), this._repeat) {
                        if (p = this._yoyo, o = A + this._rDelay, this._repeat < -1 && e1 < 0) return this.totalTime(100 * o + e1, t, n);
                        if (i = Ab(v % o), v === g ? (s = this._repeat, i = A) : ((s = ~~(v / o)) && s === v / o && (i = A, s--), i > A && (i = A)), d = Pb(this._tTime, o), !m && this._tTime && d !== s && this._tTime - d * o - this._dur <= 0 && (d = s), p && 1 & s && (i = A - i, f = 1), s !== d && !this._lock) {
                            var y = p && 1 & d, x = y === (p && 1 & s);
                            if (s < d && (y = !y), m = y ? 0 : v % A ? A : v, this._lock = 1, this.render(m || (f ? 0 : Ab(s * o)), t, !A)._lock = 0, this._tTime = v, !t && this.parent && pw(this, "onRepeat"), this.vars.repeatRefresh && !f && (this.invalidate()._lock = 1), m && m !== this._time || l !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) return this;
                            if (A = this._dur, g = this._tDur, x && (this._lock = 2, m = y ? A : -0.0001, this.render(m, !0), this.vars.repeatRefresh && !f && this.invalidate()), this._lock = 0, !this._ts && !l) return this;
                            Rw(this, f);
                        }
                    }
                    if (this._hasPause && !this._forcing && this._lock < 2 && (c = function(e1, t, n) {
                        var i;
                        if (n > t) for(i = e1._first; i && i._start <= n;){
                            if ("isPause" === i.data && i._start > t) return i;
                            i = i._next;
                        }
                        else for(i = e1._last; i && i._start >= n;){
                            if ("isPause" === i.data && i._start < t) return i;
                            i = i._prev;
                        }
                    }(this, Ab(m), Ab(i)), c && (v -= i - (i = c._start))), this._tTime = v, this._time = i, this._act = !u, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = e1, m = 0), !m && i && !t && !s && (pw(this, "onStart"), this._tTime !== v)) return this;
                    if (i >= m && e1 >= 0) for(r = this._first; r;){
                        if (a = r._next, (r._act || i >= r._start) && r._ts && c !== r) {
                            if (r.parent !== this) return this.render(e1, t, n);
                            if (r.render(r._ts > 0 ? (i - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (i - r._start) * r._ts, t, n), i !== this._time || !this._ts && !l) {
                                c = 0, a && (v += this._zTime = -0.00000001);
                                break;
                            }
                        }
                        r = a;
                    }
                    else {
                        r = this._last;
                        for(var _ = e1 < 0 ? e1 : i; r;){
                            if (a = r._prev, (r._act || _ <= r._end) && r._ts && c !== r) {
                                if (r.parent !== this) return this.render(e1, t, n);
                                if (r.render(r._ts > 0 ? (_ - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (_ - r._start) * r._ts, t, n || a_ && (r._initted || r._startAt)), i !== this._time || !this._ts && !l) {
                                    c = 0, a && (v += this._zTime = _ ? -0.00000001 : w_);
                                    break;
                                }
                            }
                            r = a;
                        }
                    }
                    if (c && !t && (this.pause(), c.render(i >= m ? 0 : -0.00000001)._zTime = i >= m ? 1 : -1, this._ts)) return this._start = h, kb(this), this.render(e1, t, n);
                    this._onUpdate && !t && pw(this, "onUpdate", !0), (v === g && this._tTime >= this.totalDuration() || !v && m) && (h !== this._start && Math.abs(u) === Math.abs(this._ts) || this._lock || ((e1 || !A) && (v === g && this._ts > 0 || !v && this._ts < 0) && Cb(this, 1), t || e1 < 0 && !m || !v && !m && g || (pw(this, v === g && e1 >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(v < g && this.timeScale() > 0) && this._prom())));
                }
                return this;
            }, n.add = function(e1, t) {
                var n = this;
                if (R_(t) || (t = Zb(this, t, e1)), !(e1 instanceof Bw)) {
                    if (B_(e1)) return e1.forEach(function(e1) {
                        return n.add(e1, t);
                    }), this;
                    if (C_(e1)) return this.addLabel(e1, t);
                    if (!L_(e1)) return this;
                    e1 = Jw.delayedCall(0, e1);
                }
                return this !== e1 ? Fb(this, e1, t) : this;
            }, n.getChildren = function(e1, t, n, i) {
                void 0 === e1 && (e1 = !0), void 0 === t && (t = !0), void 0 === n && (n = !0), void 0 === i && (i = -b_);
                for(var r = [], a = this._first; a;)a._start >= i && (a instanceof Jw ? t && r.push(a) : (n && r.push(a), e1 && r.push.apply(r, a.getChildren(!0, t, n)))), a = a._next;
                return r;
            }, n.getById = function(e1) {
                for(var t = this.getChildren(1, 1, 1), n = t.length; n--;)if (t[n].vars.id === e1) return t[n];
            }, n.remove = function(e1) {
                return C_(e1) ? this.removeLabel(e1) : L_(e1) ? this.killTweensOf(e1) : (Db(this, e1), e1 === this._recent && (this._recent = this._last), Lb(this));
            }, n.totalTime = function(t, n) {
                return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = Ab(Tw.time - (this._ts > 0 ? t / this._ts : (this.totalDuration() - t) / -this._ts))), e1.prototype.totalTime.call(this, t, n), this._forcing = 0, this) : this._tTime;
            }, n.addLabel = function(e1, t) {
                return this.labels[e1] = Zb(this, t), this;
            }, n.removeLabel = function(e1) {
                return delete this.labels[e1], this;
            }, n.addPause = function(e1, t, n) {
                var i = Jw.delayedCall(0, t || eb, n);
                return i.data = "isPause", this._hasPause = 1, Fb(this, i, Zb(this, e1));
            }, n.removePause = function(e1) {
                var t = this._first;
                for(e1 = Zb(this, e1); t;)t._start === e1 && "isPause" === t.data && Cb(t), t = t._next;
            }, n.killTweensOf = function(e1, t, n) {
                for(var i = this.getTweensOf(e1, n), r = i.length; r--;)Hw !== i[r] && i[r].kill(e1, t);
                return this;
            }, n.getTweensOf = function(e1, t) {
                for(var n, i = [], r = nw(e1), a = this._first, s = R_(t); a;)a instanceof Jw ? Mb(a._targets, r) && (s ? (!Hw || a._initted && a._ts) && a.globalTime(0) <= t && a.globalTime(a.totalDuration()) > t : !t || a.isActive()) && i.push(a) : (n = a.getTweensOf(r, t)).length && i.push.apply(i, n), a = a._next;
                return i;
            }, n.tweenTo = function(e1, t) {
                t = t || {};
                var n, i = this, r = Zb(i, e1), a = t, s = a.startAt, o = a.onStart, l = a.onStartParams, c = a.immediateRender, u = Jw.to(i, wb({
                    ease: t.ease || "none",
                    lazy: !1,
                    immediateRender: !1,
                    time: r,
                    overwrite: "auto",
                    duration: t.duration || Math.abs((r - (s && "time" in s ? s.time : i._time)) / i.timeScale()) || w_,
                    onStart: function() {
                        if (i.pause(), !n) {
                            var e1 = t.duration || Math.abs((r - (s && "time" in s ? s.time : i._time)) / i.timeScale());
                            u._dur !== e1 && Wb(u, e1, 0, 1).render(u._time, !0, !0), n = 1;
                        }
                        o && o.apply(u, l || []);
                    }
                }, t));
                return c ? u.render(0) : u;
            }, n.tweenFromTo = function(e1, t, n) {
                return this.tweenTo(t, wb({
                    startAt: {
                        time: Zb(this, e1)
                    }
                }, n));
            }, n.recent = function() {
                return this._recent;
            }, n.nextLabel = function(e1) {
                return void 0 === e1 && (e1 = this._time), dw(this, Zb(this, e1));
            }, n.previousLabel = function(e1) {
                return void 0 === e1 && (e1 = this._time), dw(this, Zb(this, e1), 1);
            }, n.currentLabel = function(e1) {
                return arguments.length ? this.seek(e1, !0) : this.previousLabel(this._time + w_);
            }, n.shiftChildren = function(e1, t, n) {
                void 0 === n && (n = 0);
                for(var i, r = this._first, a = this.labels; r;)r._start >= n && (r._start += e1, r._end += e1), r = r._next;
                if (t) for(i in a)a[i] >= n && (a[i] += e1);
                return Lb(this);
            }, n.invalidate = function(t) {
                var n = this._first;
                for(this._lock = 0; n;)n.invalidate(t), n = n._next;
                return e1.prototype.invalidate.call(this, t);
            }, n.clear = function(e1) {
                void 0 === e1 && (e1 = !0);
                for(var t, n = this._first; n;)t = n._next, this.remove(n), n = t;
                return this._dp && (this._time = this._tTime = this._pTime = 0), e1 && (this.labels = {}), Lb(this);
            }, n.totalDuration = function(e1) {
                var t, n, i, r = 0, a = this, s = a._last, o = b_;
                if (arguments.length) return a.timeScale((a._repeat < 0 ? a.duration() : a.totalDuration()) / (a.reversed() ? -e1 : e1));
                if (a._dirty) {
                    for(i = a.parent; s;)t = s._prev, s._dirty && s.totalDuration(), (n = s._start) > o && a._sort && s._ts && !a._lock ? (a._lock = 1, Fb(a, s, n - s._delay, 1)._lock = 0) : o = n, n < 0 && s._ts && (r -= n, (!i && !a._dp || i && i.smoothChildTiming) && (a._start += n / a._ts, a._time -= n, a._tTime -= n), a.shiftChildren(-n, !1, -Infinity), o = 0), s._end > r && s._ts && (r = s._end), s = t;
                    Wb(a, a === o_ && a._time > r ? a._time : r, 1, 1), a._dirty = 0;
                }
                return a._tDur;
            }, t.updateRoot = function(e1) {
                if (o_._ts && (xb(o_, Ub(e1, o_)), d_ = Tw.frame), Tw.frame >= cb) {
                    cb += x_.autoSleep || 120;
                    var t = o_._first;
                    if ((!t || !t._ts) && x_.autoSleep && Tw._listeners.length < 2) {
                        for(; t && !t._ts;)t = t._next;
                        t || Tw.sleep();
                    }
                }
            }, t;
        }(Bw);
        wb(Fw.prototype, {
            _lock: 0,
            _hasPause: 0,
            _forcing: 0
        });
        var Hw, Vw, Gw = function(e1, t, n, i, r, a, s) {
            var o, l, c, u, h, d, p, f, m = new dE(this._pt, e1, t, 0, 1, sE, null, r), g = 0, A = 0;
            for(m.b = n, m.e = i, n += "", (p = ~(i += "").indexOf("random(")) && (i = uw(i)), a && (a(f = [
                n,
                i
            ], e1, t), n = f[0], i = f[1]), l = n.match(G_) || []; o = G_.exec(i);)u = o[0], h = i.substring(g, o.index), c ? c = (c + 1) % 5 : "rgba(" === h.substr(-5) && (c = 1), u !== l[A++] && (d = parseFloat(l[A - 1]) || 0, m._pt = {
                _next: m._pt,
                p: h || 1 === A ? h : ",",
                s: d,
                c: "=" === u.charAt(1) ? vb(d, u) - d : parseFloat(u) - d,
                m: c && c < 4 ? Math.round : 0
            }, g = G_.lastIndex);
            return m.c = g < i.length ? i.substring(g, i.length) : "", m.fp = s, (Q_.test(i) || p) && (m.e = 0), this._pt = m, m;
        }, Qw = function(e1, t, n, i, r, a, s, o, l, c) {
            L_(i) && (i = i(r || 0, e1, a));
            var u, h = e1[t], d = "get" !== n ? n : L_(h) ? l ? e1[t.indexOf("set") || !L_(e1["get" + t.substr(3)]) ? t : "get" + t.substr(3)](l) : e1[t]() : h, p = L_(h) ? l ? tE : eE : $w;
            if (C_(i) && (~i.indexOf("random(") && (i = uw(i)), "=" === i.charAt(1) && ((u = vb(d, i) + ($b(d) || 0)) || 0 === u) && (i = u)), !c || d !== i || Vw) return isNaN(d * i) || "" === i ? (!h && !(t in e1) && K_(t, i), Gw.call(this, e1, t, d, i, p, o || x_.stringFilter, l)) : (u = new dE(this._pt, e1, t, +d || 0, i - (d || 0), "boolean" == typeof h ? aE : rE, 0, p), l && (u.fp = l), s && u.modifier(s, this, e1), this._pt = u);
        }, Ww = function(e1, t, n, i, r, a) {
            var s, o, l, c;
            if (ob[e1] && !1 !== (s = new ob[e1]).init(r, s.rawVars ? t[e1] : function(e1, t, n, i, r) {
                if (L_(e1) && (e1 = Zw(e1, r, t, n, i)), !O_(e1) || e1.style && e1.nodeType || B_(e1) || j_(e1)) return C_(e1) ? Zw(e1, r, t, n, i) : e1;
                var a, s = {};
                for(a in e1)s[a] = Zw(e1[a], r, t, n, i);
                return s;
            }(t[e1], i, r, a, n), n, i, a) && (n._pt = o = new dE(n._pt, r, e1, 0, 1, s.render, s, 0, s.priority), n !== p_)) for(l = n._ptLookup[n._targets.indexOf(r)], c = s._props.length; c--;)l[s._props[c]] = o;
            return s;
        }, Yw = function e1(t, n, i) {
            var r, a, s, o, l, c, u, h, d, p, f, m, g, A = t.vars, v = A.ease, M = A.startAt, y = A.immediateRender, x = A.lazy, _ = A.onUpdate, b = A.runBackwards, w = A.yoyoEase, E = A.keyframes, T = A.autoRevert, S = t._dur, I = t._startAt, N = t._targets, D = t.parent, C = D && "nested" === D.data ? D.vars.targets : N, L = "auto" === t._overwrite && !r_, R = t.timeline;
            if (R && (!E || !v) && (v = "none"), t._ease = zw(v, __.ease), t._yEase = w ? Lw(zw(!0 === w ? v : w, __.ease)) : 0, w && t._yoyo && !t._repeat && (w = t._yEase, t._yEase = t._ease, t._ease = w), t._from = !R && !!A.runBackwards, !R || E && !A.stagger) {
                if (m = (h = N[0] ? pb(N[0]).harness : 0) && A[h.prop], r = Sb(A, rb), I && (I._zTime < 0 && I.progress(1), n < 0 && b && y && !T ? I.render(-1, !0) : I.revert(b && S ? nb : tb), I._lazy = 0), M) {
                    if (Cb(t._startAt = Jw.set(N, wb({
                        data: "isStart",
                        overwrite: !1,
                        parent: D,
                        immediateRender: !0,
                        lazy: !I && P_(x),
                        startAt: null,
                        delay: 0,
                        onUpdate: _ && function() {
                            return pw(t, "onUpdate");
                        },
                        stagger: 0
                    }, M))), t._startAt._dp = 0, t._startAt._sat = t, n < 0 && (a_ || !y && !T) && t._startAt.revert(nb), y && S && n <= 0 && i <= 0) return void (n && (t._zTime = n));
                } else if (b && S && !I) {
                    if (n && (y = !1), s = wb({
                        overwrite: !1,
                        data: "isFromStart",
                        lazy: y && !I && P_(x),
                        immediateRender: y,
                        stagger: 0,
                        parent: D
                    }, r), m && (s[h.prop] = m), Cb(t._startAt = Jw.set(N, s)), t._startAt._dp = 0, t._startAt._sat = t, n < 0 && (a_ ? t._startAt.revert(nb) : t._startAt.render(-1, !0)), t._zTime = n, y) {
                        if (!n) return;
                    } else e1(t._startAt, w_, w_);
                }
                for(t._pt = t._ptCache = 0, x = S && P_(x) || x && !S, a = 0; a < N.length; a++){
                    if (u = (l = N[a])._gsap || db(N)[a]._gsap, t._ptLookup[a] = p = {}, sb[u.id] && ab.length && yb(), f = C === N ? a : C.indexOf(l), h && !1 !== (d = new h).init(l, m || r, t, f, C) && (t._pt = o = new dE(t._pt, l, d.name, 0, 1, d.render, d, 0, d.priority), d._props.forEach(function(e1) {
                        p[e1] = o;
                    }), d.priority && (c = 1)), !h || m) for(s in r)ob[s] && (d = Ww(s, r, t, f, l, C)) ? d.priority && (c = 1) : p[s] = o = Qw.call(t, l, s, "get", r[s], f, C, 0, A.stringFilter);
                    t._op && t._op[a] && t.kill(l, t._op[a]), L && t._pt && (Hw = t, o_.killTweensOf(l, p, t.globalTime(n)), g = !t.parent, Hw = 0), t._pt && x && (sb[u.id] = 1);
                }
                c && hE(t), t._onInit && t._onInit(t);
            }
            t._onUpdate = _, t._initted = (!t._op || t._pt) && !g, E && n <= 0 && R.render(b_, !0, !0);
        }, Xw = function(e1, t, n, i) {
            var r, a, s = t.ease || i || "power1.inOut";
            if (B_(t)) a = n[e1] || (n[e1] = []), t.forEach(function(e1, n) {
                return a.push({
                    t: n / (t.length - 1) * 100,
                    v: e1,
                    e: s
                });
            });
            else for(r in t)a = n[r] || (n[r] = []), "ease" === r || a.push({
                t: parseFloat(e1),
                v: t[r],
                e: s
            });
        }, Zw = function(e1, t, n, i, r) {
            return L_(e1) ? e1.call(t, n, i, r) : C_(e1) && ~e1.indexOf("random(") ? uw(e1) : e1;
        }, qw = hb + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", Kw = {};
        mb(qw + ",id,stagger,delay,duration,paused,scrollTrigger", function(e1) {
            return Kw[e1] = 1;
        });
        var Jw = function(e1) {
            function t(t, n, i, r) {
                var a;
                "number" == typeof n && (i.duration = n, n = i, i = null);
                var s, o, l, c, u, h, d, p, f = (a = e1.call(this, r ? n : Ib(n)) || this).vars, m = f.duration, g = f.delay, A = f.immediateRender, v = f.stagger, M = f.overwrite, y = f.keyframes, x = f.defaults, _ = f.scrollTrigger, b = f.yoyoEase, w = n.parent || o_, E = (B_(t) || j_(t) ? R_(t[0]) : "length" in n) ? [
                    t
                ] : nw(t);
                if (a._targets = E.length ? db(E) : J_("GSAP target " + t + " not found. https://gsap.com", !x_.nullTargetWarn) || [], a._ptLookup = [], a._overwrite = M, y || v || k_(m) || k_(g)) {
                    if (n = a.vars, (s = a.timeline = new Fw({
                        data: "nested",
                        defaults: x || {},
                        targets: w && "nested" === w.data ? w.vars.targets : E
                    })).kill(), s.parent = s._dp = n_(a), s._start = 0, v || k_(m) || k_(g)) {
                        if (c = E.length, d = v && aw(v), O_(v)) for(u in v)~qw.indexOf(u) && (p || (p = {}), p[u] = v[u]);
                        for(o = 0; o < c; o++)(l = Sb(n, Kw)).stagger = 0, b && (l.yoyoEase = b), p && Eb(l, p), h = E[o], l.duration = +Zw(m, n_(a), o, h, E), l.delay = (+Zw(g, n_(a), o, h, E) || 0) - a._delay, !v && 1 === c && l.delay && (a._delay = g = l.delay, a._start += g, l.delay = 0), s.to(h, l, d ? d(o, h, E) : 0), s._ease = Iw.none;
                        s.duration() ? m = g = 0 : a.timeline = 0;
                    } else if (y) {
                        Ib(wb(s.vars.defaults, {
                            ease: "none"
                        })), s._ease = zw(y.ease || n.ease || "none");
                        var T, S, I, N = 0;
                        if (B_(y)) y.forEach(function(e1) {
                            return s.to(E, e1, ">");
                        }), s.duration();
                        else {
                            for(u in l = {}, y)"ease" === u || "easeEach" === u || Xw(u, y[u], l, y.easeEach);
                            for(u in l)for(T = l[u].sort(function(e1, t) {
                                return e1.t - t.t;
                            }), N = 0, o = 0; o < T.length; o++)(I = {
                                ease: (S = T[o]).e,
                                duration: (S.t - (o ? T[o - 1].t : 0)) / 100 * m
                            })[u] = S.v, s.to(E, I, N), N += I.duration;
                            s.duration() < m && s.to({}, {
                                duration: m - s.duration()
                            });
                        }
                    }
                    m || a.duration(m = s.duration());
                } else a.timeline = 0;
                return !0 !== M || r_ || (Hw = n_(a), o_.killTweensOf(E), Hw = 0), Fb(w, n_(a), i), n.reversed && a.reverse(), n.paused && a.paused(!0), (A || !m && !y && a._start === Ab(w._time) && P_(A) && zb(n_(a)) && "nested" !== w.data) && (a._tTime = -0.00000001, a.render(Math.max(0, -g) || 0)), _ && Hb(n_(a), _), a;
            }
            i_(t, e1);
            var n = t.prototype;
            return n.render = function(e1, t, n) {
                var i, r, a, s, o, l, c, u, h, d = this._time, p = this._tDur, f = this._dur, m = e1 < 0, g = e1 > p - w_ && !m ? p : e1 < w_ ? 0 : e1;
                if (f) {
                    if (g !== this._tTime || !e1 || n || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== m) {
                        if (i = g, u = this.timeline, this._repeat) {
                            if (s = f + this._rDelay, this._repeat < -1 && m) return this.totalTime(100 * s + e1, t, n);
                            if (i = Ab(g % s), g === p ? (a = this._repeat, i = f) : ((a = ~~(g / s)) && a === Ab(g / s) && (i = f, a--), i > f && (i = f)), (l = this._yoyo && 1 & a) && (h = this._yEase, i = f - i), o = Pb(this._tTime, s), i === d && !n && this._initted && a === o) return this._tTime = g, this;
                            a !== o && (u && this._yEase && Rw(u, l), this.vars.repeatRefresh && !l && !this._lock && this._time !== s && this._initted && (this._lock = n = 1, this.render(Ab(s * a), !0).invalidate()._lock = 0));
                        }
                        if (!this._initted) {
                            if (Vb(this, m ? e1 : i, n, t, g)) return this._tTime = 0, this;
                            if (!(d === this._time || n && this.vars.repeatRefresh && a !== o)) return this;
                            if (f !== this._dur) return this.render(e1, t, n);
                        }
                        if (this._tTime = g, this._time = i, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = c = (h || this._ease)(i / f), this._from && (this.ratio = c = 1 - c), i && !d && !t && !a && (pw(this, "onStart"), this._tTime !== g)) return this;
                        for(r = this._pt; r;)r.r(c, r.d), r = r._next;
                        u && u.render(e1 < 0 ? e1 : u._dur * u._ease(i / this._dur), t, n) || this._startAt && (this._zTime = e1), this._onUpdate && !t && (m && Rb(this, e1, 0, n), pw(this, "onUpdate")), this._repeat && a !== o && this.vars.onRepeat && !t && this.parent && pw(this, "onRepeat"), g !== this._tDur && g || this._tTime !== g || (m && !this._onUpdate && Rb(this, e1, 0, !0), (e1 || !f) && (g === this._tDur && this._ts > 0 || !g && this._ts < 0) && Cb(this, 1), t || m && !d || !(g || d || l) || (pw(this, g === p ? "onComplete" : "onReverseComplete", !0), this._prom && !(g < p && this.timeScale() > 0) && this._prom()));
                    }
                } else !function(e1, t, n, i) {
                    var r, a, s, o = e1.ratio, l = t < 0 || !t && (!e1._start && Gb(e1) && (e1._initted || !Qb(e1)) || (e1._ts < 0 || e1._dp._ts < 0) && !Qb(e1)) ? 0 : 1, c = e1._rDelay, u = 0;
                    if (c && e1._repeat && (u = Jb(0, e1._tDur, t), a = Pb(u, c), e1._yoyo && 1 & a && (l = 1 - l), a !== Pb(e1._tTime, c) && (o = 1 - l, e1.vars.repeatRefresh && e1._initted && e1.invalidate())), l !== o || a_ || i || e1._zTime === w_ || !t && e1._zTime) {
                        if (!e1._initted && Vb(e1, t, i, n, u)) return;
                        for(s = e1._zTime, e1._zTime = t || (n ? w_ : 0), n || (n = t && !s), e1.ratio = l, e1._from && (l = 1 - l), e1._time = 0, e1._tTime = u, r = e1._pt; r;)r.r(l, r.d), r = r._next;
                        t < 0 && Rb(e1, t, 0, !0), e1._onUpdate && !n && pw(e1, "onUpdate"), u && e1._repeat && !n && e1.parent && pw(e1, "onRepeat"), (t >= e1._tDur || t < 0) && e1.ratio === l && (l && Cb(e1, 1), n || a_ || (pw(e1, l ? "onComplete" : "onReverseComplete", !0), e1._prom && e1._prom()));
                    } else e1._zTime || (e1._zTime = t);
                }(this, e1, t, n);
                return this;
            }, n.targets = function() {
                return this._targets;
            }, n.invalidate = function(t) {
                return (!t || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(t), e1.prototype.invalidate.call(this, t);
            }, n.resetTo = function(e1, t, n, i, r) {
                f_ || Tw.wake(), this._ts || this.play();
                var a = Math.min(this._dur, (this._dp._time - this._start) * this._ts);
                return this._initted || Yw(this, a), function(e1, t, n, i, r, a, s, o) {
                    var l, c, u, h, d = (e1._pt && e1._ptCache || (e1._ptCache = {}))[t];
                    if (!d) for(d = e1._ptCache[t] = [], u = e1._ptLookup, h = e1._targets.length; h--;){
                        if ((l = u[h][t]) && l.d && l.d._pt) for(l = l.d._pt; l && l.p !== t && l.fp !== t;)l = l._next;
                        if (!l) return Vw = 1, e1.vars[t] = "+=0", Yw(e1, s), Vw = 0, o ? J_(t + " not eligible for reset") : 1;
                        d.push(l);
                    }
                    for(h = d.length; h--;)(l = (c = d[h])._pt || c).s = !i && 0 !== i || r ? l.s + (i || 0) + a * l.c : i, l.c = n - l.s, c.e && (c.e = gb(n) + $b(c.e)), c.b && (c.b = l.s + $b(c.b));
                }(this, e1, t, n, i, this._ease(a / this._dur), a, r) ? this.resetTo(e1, t, n, i, 1) : (jb(this, 0), this.parent || Nb(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
            }, n.kill = function(e1, t) {
                if (void 0 === t && (t = "all"), !(e1 || t && "all" !== t)) return this._lazy = this._pt = 0, this.parent ? fw(this) : this;
                if (this.timeline) {
                    var n = this.timeline.totalDuration();
                    return this.timeline.killTweensOf(e1, t, Hw && !0 !== Hw.vars.overwrite)._first || fw(this), this.parent && n !== this.timeline.totalDuration() && Wb(this, this._dur * this.timeline._tDur / n, 0, 1), this;
                }
                var i, r, a, s, o, l, c, u = this._targets, h = e1 ? nw(e1) : u, d = this._ptLookup, p = this._pt;
                if ((!t || "all" === t) && function(e1, t) {
                    for(var n = e1.length, i = n === t.length; i && n-- && e1[n] === t[n];);
                    return n < 0;
                }(u, h)) return "all" === t && (this._pt = 0), fw(this);
                for(i = this._op = this._op || [], "all" !== t && (C_(t) && (o = {}, mb(t, function(e1) {
                    return o[e1] = 1;
                }), t = o), t = function(e1, t) {
                    var n, i, r, a, s = e1[0] ? pb(e1[0]).harness : 0, o = s && s.aliases;
                    if (!o) return t;
                    for(i in n = Eb({}, t), o)if ((i in n)) for(r = (a = o[i].split(",")).length; r--;)n[a[r]] = n[i];
                    return n;
                }(u, t)), c = u.length; c--;)if (~h.indexOf(u[c])) for(o in r = d[c], "all" === t ? (i[c] = t, s = r, a = {}) : (a = i[c] = i[c] || {}, s = t), s)(l = r && r[o]) && ("kill" in l.d && !0 !== l.d.kill(o) || Db(this, l, "_pt"), delete r[o]), "all" !== a && (a[o] = 1);
                return this._initted && !this._pt && p && fw(this), this;
            }, t.to = function(e1, n) {
                return new t(e1, n, arguments[2]);
            }, t.from = function(e1, t) {
                return qb(1, arguments);
            }, t.delayedCall = function(e1, n, i, r) {
                return new t(n, 0, {
                    immediateRender: !1,
                    lazy: !1,
                    overwrite: !1,
                    delay: e1,
                    onComplete: n,
                    onReverseComplete: n,
                    onCompleteParams: i,
                    onReverseCompleteParams: i,
                    callbackScope: r
                });
            }, t.fromTo = function(e1, t, n) {
                return qb(2, arguments);
            }, t.set = function(e1, n) {
                return n.duration = 0, n.repeatDelay || (n.repeat = 0), new t(e1, n);
            }, t.killTweensOf = function(e1, t, n) {
                return o_.killTweensOf(e1, t, n);
            }, t;
        }(Bw);
        wb(Jw.prototype, {
            _targets: [],
            _lazy: 0,
            _startAt: 0,
            _op: 0,
            _onInit: 0
        }), mb("staggerTo,staggerFrom,staggerFromTo", function(e1) {
            Jw[e1] = function() {
                var t = new Fw, n = ew.call(arguments, 0);
                return n.splice("staggerFromTo" === e1 ? 5 : 4, 0, 0), t[e1].apply(t, n);
            };
        });
        var $w = function(e1, t, n) {
            return e1[t] = n;
        }, eE = function(e1, t, n) {
            return e1[t](n);
        }, tE = function(e1, t, n, i) {
            return e1[t](i.fp, n);
        }, nE = function(e1, t, n) {
            return e1.setAttribute(t, n);
        }, iE = function(e1, t) {
            return L_(e1[t]) ? eE : z_(e1[t]) && e1.setAttribute ? nE : $w;
        }, rE = function(e1, t) {
            return t.set(t.t, t.p, Math.round(1e6 * (t.s + t.c * e1)) / 1e6, t);
        }, aE = function(e1, t) {
            return t.set(t.t, t.p, !!(t.s + t.c * e1), t);
        }, sE = function(e1, t) {
            var n = t._pt, i = "";
            if (!e1 && t.b) i = t.b;
            else if (1 === e1 && t.e) i = t.e;
            else {
                for(; n;)i = n.p + (n.m ? n.m(n.s + n.c * e1) : Math.round(1e4 * (n.s + n.c * e1)) / 1e4) + i, n = n._next;
                i += t.c;
            }
            t.set(t.t, t.p, i, t);
        }, oE = function(e1, t) {
            for(var n = t._pt; n;)n.r(e1, n.d), n = n._next;
        }, lE = function(e1, t, n, i) {
            for(var r, a = this._pt; a;)r = a._next, a.p === i && a.modifier(e1, t, n), a = r;
        }, cE = function(e1) {
            for(var t, n, i = this._pt; i;)n = i._next, i.p === e1 && !i.op || i.op === e1 ? Db(this, i, "_pt") : i.dep || (t = 1), i = n;
            return !t;
        }, uE = function(e1, t, n, i) {
            i.mSet(e1, t, i.m.call(i.tween, n, i.mt), i);
        }, hE = function(e1) {
            for(var t, n, i, r, a = e1._pt; a;){
                for(t = a._next, n = i; n && n.pr > a.pr;)n = n._next;
                (a._prev = n ? n._prev : r) ? a._prev._next = a : i = a, (a._next = n) ? n._prev = a : r = a, a = t;
            }
            e1._pt = i;
        }, dE = function() {
            function e1(e1, t, n, i, r, a, s, o, l) {
                this.t = t, this.s = i, this.c = r, this.p = n, this.r = a || rE, this.d = s || this, this.set = o || $w, this.pr = l || 0, this._next = e1, e1 && (e1._prev = this);
            }
            return e1.prototype.modifier = function(e1, t, n) {
                this.mSet = this.mSet || this.set, this.set = uE, this.m = e1, this.mt = n, this.tween = t;
            }, e1;
        }();
        mb(hb + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(e1) {
            return rb[e1] = 1;
        }), X_.TweenMax = X_.TweenLite = Jw, X_.TimelineLite = X_.TimelineMax = Fw, o_ = new Fw({
            sortChildren: !1,
            defaults: __,
            autoRemoveChildren: !0,
            id: "root",
            smoothChildTiming: !0
        }), x_.stringFilter = Ew;
        var pE = [], fE = {}, mE = [], gE = 0, AE = 0, vE = function(e1) {
            return (fE[e1] || mE).map(function(e1) {
                return e1();
            });
        }, ME = function() {
            var e1 = Date.now(), t = [];
            e1 - gE > 2 && (vE("matchMediaInit"), pE.forEach(function(e1) {
                var n, i, r, a, s = e1.queries, o = e1.conditions;
                for(i in s)(n = l_.matchMedia(s[i]).matches) && (r = 1), n !== o[i] && (o[i] = n, a = 1);
                a && (e1.revert(), r && t.push(e1));
            }), vE("matchMediaRevert"), t.forEach(function(e1) {
                return e1.onMatch(e1, function(t) {
                    return e1.add(null, t);
                });
            }), gE = e1, vE("matchMedia"));
        }, yE = function() {
            function e1(e1, t) {
                this.selector = t && iw(t), this.data = [], this._r = [], this.isReverted = !1, this.id = AE++, e1 && this.add(e1);
            }
            var t = e1.prototype;
            return t.add = function(e1, t, n) {
                L_(e1) && (n = t, t = e1, e1 = L_);
                var i = this, r = function() {
                    var e1, r = s_, a = i.selector;
                    return r && r !== i && r.data.push(i), n && (i.selector = iw(n)), s_ = i, e1 = t.apply(i, arguments), L_(e1) && i._r.push(e1), s_ = r, i.selector = a, i.isReverted = !1, e1;
                };
                return i.last = r, e1 === L_ ? r(i, function(e1) {
                    return i.add(null, e1);
                }) : e1 ? i[e1] = r : r;
            }, t.ignore = function(e1) {
                var t = s_;
                s_ = null, e1(this), s_ = t;
            }, t.getTweens = function() {
                var t = [];
                return this.data.forEach(function(n) {
                    return n instanceof e1 ? t.push.apply(t, n.getTweens()) : n instanceof Jw && !(n.parent && "nested" === n.parent.data) && t.push(n);
                }), t;
            }, t.clear = function() {
                this._r.length = this.data.length = 0;
            }, t.kill = function(e1, t) {
                var n = this;
                if (e1 ? function() {
                    for(var t, i = n.getTweens(), r = n.data.length; r--;)"isFlip" === (t = n.data[r]).data && (t.revert(), t.getChildren(!0, !0, !1).forEach(function(e1) {
                        return i.splice(i.indexOf(e1), 1);
                    }));
                    for(i.map(function(e1) {
                        return {
                            g: e1._dur || e1._delay || e1._sat && !e1._sat.vars.immediateRender ? e1.globalTime(0) : -1 / 0,
                            t: e1
                        };
                    }).sort(function(e1, t) {
                        return t.g - e1.g || -1 / 0;
                    }).forEach(function(t) {
                        return t.t.revert(e1);
                    }), r = n.data.length; r--;)(t = n.data[r]) instanceof Fw ? "nested" !== t.data && (t.scrollTrigger && t.scrollTrigger.revert(), t.kill()) : !(t instanceof Jw) && t.revert && t.revert(e1);
                    n._r.forEach(function(t) {
                        return t(e1, n);
                    }), n.isReverted = !0;
                }() : this.data.forEach(function(e1) {
                    return e1.kill && e1.kill();
                }), this.clear(), t) for(var i = pE.length; i--;)pE[i].id === this.id && pE.splice(i, 1);
            }, t.revert = function(e1) {
                this.kill(e1 || {});
            }, e1;
        }(), xE = function() {
            function e1(e1) {
                this.contexts = [], this.scope = e1, s_ && s_.data.push(this);
            }
            var t = e1.prototype;
            return t.add = function(e1, t, n) {
                O_(e1) || (e1 = {
                    matches: e1
                });
                var i, r, a, s = new yE(0, n || this.scope), o = s.conditions = {};
                for(r in s_ && !s.selector && (s.selector = s_.selector), this.contexts.push(s), t = s.add("onMatch", t), s.queries = e1, e1)"all" === r ? a = 1 : (i = l_.matchMedia(e1[r])) && (pE.indexOf(s) < 0 && pE.push(s), (o[r] = i.matches) && (a = 1), i.addListener ? i.addListener(ME) : i.addEventListener("change", ME));
                return a && t(s, function(e1) {
                    return s.add(null, e1);
                }), this;
            }, t.revert = function(e1) {
                this.kill(e1 || {});
            }, t.kill = function(e1) {
                this.contexts.forEach(function(t) {
                    return t.kill(e1, !0);
                });
            }, e1;
        }(), _E = {
            registerPlugin: function() {
                for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
                t.forEach(function(e1) {
                    return gw(e1);
                });
            },
            timeline: function(e1) {
                return new Fw(e1);
            },
            getTweensOf: function(e1, t) {
                return o_.getTweensOf(e1, t);
            },
            getProperty: function(e1, t, n, i) {
                C_(e1) && (e1 = nw(e1)[0]);
                var r = pb(e1 || {}).get, a = n ? bb : _b;
                return "native" === n && (n = ""), e1 ? t ? a((ob[t] && ob[t].get || r)(e1, t, n, i)) : function(t, n, i) {
                    return a((ob[t] && ob[t].get || r)(e1, t, n, i));
                } : e1;
            },
            quickSetter: function(e1, t, n) {
                if ((e1 = nw(e1)).length > 1) {
                    var i = e1.map(function(e1) {
                        return EE.quickSetter(e1, t, n);
                    }), r = i.length;
                    return function(e1) {
                        for(var t = r; t--;)i[t](e1);
                    };
                }
                e1 = e1[0] || {};
                var a = ob[t], s = pb(e1), o = s.harness && (s.harness.aliases || {})[t] || t, l = a ? function(t) {
                    var i = new a;
                    p_._pt = 0, i.init(e1, n ? t + n : t, p_, 0, [
                        e1
                    ]), i.render(1, i), p_._pt && oE(1, p_);
                } : s.set(e1, o);
                return a ? l : function(t) {
                    return l(e1, o, n ? t + n : t, s, 1);
                };
            },
            quickTo: function(e1, t, n) {
                var i, r = EE.to(e1, Eb(((i = {})[t] = "+=0.1", i.paused = !0, i), n || {})), a = function(e1, n, i) {
                    return r.resetTo(t, e1, n, i);
                };
                return a.tween = r, a;
            },
            isTweening: function(e1) {
                return o_.getTweensOf(e1, !0).length > 0;
            },
            defaults: function(e1) {
                return e1 && e1.ease && (e1.ease = zw(e1.ease, __.ease)), Tb(__, e1 || {});
            },
            config: function(e1) {
                return Tb(x_, e1 || {});
            },
            registerEffect: function(e1) {
                var t = e1.name, n = e1.effect, i = e1.plugins, r = e1.defaults, a = e1.extendTimeline;
                (i || "").split(",").forEach(function(e1) {
                    return e1 && !ob[e1] && !X_[e1] && J_(t + " effect requires " + e1 + " plugin.");
                }), lb[t] = function(e1, t, i) {
                    return n(nw(e1), wb(t || {}, r), i);
                }, a && (Fw.prototype[t] = function(e1, n, i) {
                    return this.add(lb[t](e1, O_(n) ? n : (i = n) && {}, this), i);
                });
            },
            registerEase: function(e1, t) {
                Iw[e1] = zw(t);
            },
            parseEase: function(e1, t) {
                return arguments.length ? zw(e1, t) : Iw;
            },
            getById: function(e1) {
                return o_.getById(e1);
            },
            exportRoot: function(e1, t) {
                void 0 === e1 && (e1 = {});
                var n, i, r = new Fw(e1);
                for(r.smoothChildTiming = P_(e1.smoothChildTiming), o_.remove(r), r._dp = 0, r._time = r._tTime = o_._time, n = o_._first; n;)i = n._next, !t && !n._dur && n instanceof Jw && n.vars.onComplete === n._targets[0] || Fb(r, n, n._start - n._delay), n = i;
                return Fb(o_, r, 0), r;
            },
            context: function(e1, t) {
                return e1 ? new yE(e1, t) : s_;
            },
            matchMedia: function(e1) {
                return new xE(e1);
            },
            matchMediaRefresh: function() {
                return pE.forEach(function(e1) {
                    var t, n, i = e1.conditions;
                    for(n in i)i[n] && (i[n] = !1, t = 1);
                    t && e1.revert();
                }) || ME();
            },
            addEventListener: function(e1, t) {
                var n = fE[e1] || (fE[e1] = []);
                ~n.indexOf(t) || n.push(t);
            },
            removeEventListener: function(e1, t) {
                var n = fE[e1], i = n && n.indexOf(t);
                i >= 0 && n.splice(i, 1);
            },
            utils: {
                wrap: function e1(t, n, i) {
                    var r = n - t;
                    return B_(t) ? cw(t, e1(0, t.length), n) : Kb(i, function(e1) {
                        return (r + (e1 - t) % r) % r + t;
                    });
                },
                wrapYoyo: function e1(t, n, i) {
                    var r = n - t, a = 2 * r;
                    return B_(t) ? cw(t, e1(0, t.length - 1), n) : Kb(i, function(e1) {
                        return t + ((e1 = (a + (e1 - t) % a) % a || 0) > r ? a - e1 : e1);
                    });
                },
                distribute: aw,
                random: lw,
                snap: ow,
                normalize: function(e1, t, n) {
                    return hw(e1, t, 0, 1, n);
                },
                getUnit: $b,
                clamp: function(e1, t, n) {
                    return Kb(n, function(n) {
                        return Jb(e1, t, n);
                    });
                },
                splitColor: yw,
                toArray: nw,
                selector: iw,
                mapRange: hw,
                pipe: function() {
                    for(var e1 = arguments.length, t = new Array(e1), n = 0; n < e1; n++)t[n] = arguments[n];
                    return function(e1) {
                        return t.reduce(function(e1, t) {
                            return t(e1);
                        }, e1);
                    };
                },
                unitize: function(e1, t) {
                    return function(n) {
                        return e1(parseFloat(n)) + (t || $b(n));
                    };
                },
                interpolate: function e1(t, n, i, r) {
                    var a = isNaN(t + n) ? 0 : function(e1) {
                        return (1 - e1) * t + e1 * n;
                    };
                    if (!a) {
                        var s, o, l, c, u, h = C_(t), d = {};
                        if (!0 === i && (r = 1) && (i = null), h) t = {
                            p: t
                        }, n = {
                            p: n
                        };
                        else if (B_(t) && !B_(n)) {
                            for(l = [], c = t.length, u = c - 2, o = 1; o < c; o++)l.push(e1(t[o - 1], t[o]));
                            c--, a = function(e1) {
                                e1 *= c;
                                var t = Math.min(u, ~~e1);
                                return l[t](e1 - t);
                            }, i = n;
                        } else r || (t = Eb(B_(t) ? [] : {}, t));
                        if (!l) {
                            for(s in n)Qw.call(d, t, s, "get", n[s]);
                            a = function(e1) {
                                return oE(e1, d) || (h ? t.p : t);
                            };
                        }
                    }
                    return Kb(i, a);
                },
                shuffle: rw
            },
            install: q_,
            effects: lb,
            ticker: Tw,
            updateRoot: Fw.updateRoot,
            plugins: ob,
            globalTimeline: o_,
            core: {
                PropTween: dE,
                globals: $_,
                Tween: Jw,
                Timeline: Fw,
                Animation: Bw,
                getCache: pb,
                _removeLinkedListItem: Db,
                reverting: function() {
                    return a_;
                },
                context: function(e1) {
                    return e1 && s_ && (s_.data.push(e1), e1._ctx = s_), s_;
                },
                suppressOverwrites: function(e1) {
                    return r_ = e1;
                }
            }
        };
        mb("to,from,fromTo,delayedCall,set,killTweensOf", function(e1) {
            return _E[e1] = Jw[e1];
        }), Tw.add(Fw.updateRoot), p_ = _E.to({}, {
            duration: 0
        });
        var bE = function(e1, t) {
            for(var n = e1._pt; n && n.p !== t && n.op !== t && n.fp !== t;)n = n._next;
            return n;
        }, wE = function(e1, t) {
            return {
                name: e1,
                rawVars: 1,
                init: function(e1, n, i) {
                    i._onInit = function(e1) {
                        var i, r;
                        if (C_(n) && (i = {}, mb(n, function(e1) {
                            return i[e1] = 1;
                        }), n = i), t) {
                            for(r in i = {}, n)i[r] = t(n[r]);
                            n = i;
                        }
                        !function(e1, t) {
                            var n, i, r, a = e1._targets;
                            for(n in t)for(i = a.length; i--;)(r = e1._ptLookup[i][n]) && (r = r.d) && (r._pt && (r = bE(r, n)), r && r.modifier && r.modifier(t[n], e1, a[i], n));
                        }(e1, n);
                    };
                }
            };
        }, EE = _E.registerPlugin({
            name: "attr",
            init: function(e1, t, n, i, r) {
                var a, s, o;
                for(a in this.tween = n, t)o = e1.getAttribute(a) || "", (s = this.add(e1, "setAttribute", (o || 0) + "", t[a], i, r, 0, 0, a)).op = a, s.b = o, this._props.push(a);
            },
            render: function(e1, t) {
                for(var n = t._pt; n;)a_ ? n.set(n.t, n.p, n.b, n) : n.r(e1, n.d), n = n._next;
            }
        }, {
            name: "endArray",
            init: function(e1, t) {
                for(var n = t.length; n--;)this.add(e1, n, e1[n] || 0, t[n], 0, 0, 0, 0, 0, 1);
            }
        }, wE("roundProps", sw), wE("modifiers"), wE("snap", ow)) || _E;
        Jw.version = Fw.version = EE.version = "3.12.5", h_ = 1, U_() && Sw(), Iw.Power0, Iw.Power1, Iw.Power2, Iw.Power3, Iw.Power4, Iw.Linear, Iw.Quad, Iw.Cubic, Iw.Quart, Iw.Quint, Iw.Strong, Iw.Elastic, Iw.Back, Iw.SteppedEase, Iw.Bounce, Iw.Sine, Iw.Expo, Iw.Circ;
        var TE, SE, IE, NE, DE, CE, LE, RE, zE = {}, OE = 180 / Math.PI, PE = Math.PI / 180, UE = Math.atan2, kE = /([A-Z])/g, jE = /(left|right|width|margin|padding|x)/i, BE = /[\s,\(]\S/, FE = {
            autoAlpha: "opacity,visibility",
            scale: "scaleX,scaleY",
            alpha: "opacity"
        }, HE = function(e1, t) {
            return t.set(t.t, t.p, Math.round(1e4 * (t.s + t.c * e1)) / 1e4 + t.u, t);
        }, VE = function(e1, t) {
            return t.set(t.t, t.p, 1 === e1 ? t.e : Math.round(1e4 * (t.s + t.c * e1)) / 1e4 + t.u, t);
        }, GE = function(e1, t) {
            return t.set(t.t, t.p, e1 ? Math.round(1e4 * (t.s + t.c * e1)) / 1e4 + t.u : t.b, t);
        }, QE = function(e1, t) {
            var n = t.s + t.c * e1;
            t.set(t.t, t.p, ~~(n + (n < 0 ? -0.5 : .5)) + t.u, t);
        }, WE = function(e1, t) {
            return t.set(t.t, t.p, e1 ? t.e : t.b, t);
        }, YE = function(e1, t) {
            return t.set(t.t, t.p, 1 !== e1 ? t.b : t.e, t);
        }, XE = function(e1, t, n) {
            return e1.style[t] = n;
        }, ZE = function(e1, t, n) {
            return e1.style.setProperty(t, n);
        }, qE = function(e1, t, n) {
            return e1._gsap[t] = n;
        }, KE = function(e1, t, n) {
            return e1._gsap.scaleX = e1._gsap.scaleY = n;
        }, JE = function(e1, t, n, i, r) {
            var a = e1._gsap;
            a.scaleX = a.scaleY = n, a.renderTransform(r, a);
        }, $E = function(e1, t, n, i, r) {
            var a = e1._gsap;
            a[t] = n, a.renderTransform(r, a);
        }, eT = "transform", tT = eT + "Origin", nT = function e1(t, n) {
            var i = this, r = this.target, a = r.style, s = r._gsap;
            if (t in zE && a) {
                if (this.tfm = this.tfm || {}, "transform" === t) return FE.transform.split(",").forEach(function(t) {
                    return e1.call(i, t, n);
                });
                if (~(t = FE[t] || t).indexOf(",") ? t.split(",").forEach(function(e1) {
                    return i.tfm[e1] = yT(r, e1);
                }) : this.tfm[t] = s.x ? s[t] : yT(r, t), t === tT && (this.tfm.zOrigin = s.zOrigin), this.props.indexOf(eT) >= 0) return;
                s.svg && (this.svgo = r.getAttribute("data-svg-origin"), this.props.push(tT, n, "")), t = eT;
            }
            (a || n) && this.props.push(t, n, a[t]);
        }, iT = function(e1) {
            e1.translate && (e1.removeProperty("translate"), e1.removeProperty("scale"), e1.removeProperty("rotate"));
        }, rT = function() {
            var e1, t, n = this.props, i = this.target, r = i.style, a = i._gsap;
            for(e1 = 0; e1 < n.length; e1 += 3)n[e1 + 1] ? i[n[e1]] = n[e1 + 2] : n[e1 + 2] ? r[n[e1]] = n[e1 + 2] : r.removeProperty("--" === n[e1].substr(0, 2) ? n[e1] : n[e1].replace(kE, "-$1").toLowerCase());
            if (this.tfm) {
                for(t in this.tfm)a[t] = this.tfm[t];
                a.svg && (a.renderTransform(), i.setAttribute("data-svg-origin", this.svgo || "")), (e1 = LE()) && e1.isStart || r[eT] || (iT(r), a.zOrigin && r[tT] && (r[tT] += " " + a.zOrigin + "px", a.zOrigin = 0, a.renderTransform()), a.uncache = 1);
            }
        }, aT = function(e1, t) {
            var n = {
                target: e1,
                props: [],
                revert: rT,
                save: nT
            };
            return e1._gsap || EE.core.getCache(e1), t && t.split(",").forEach(function(e1) {
                return n.save(e1);
            }), n;
        }, sT = function(e1, t) {
            var n = SE.createElementNS ? SE.createElementNS((t || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), e1) : SE.createElement(e1);
            return n && n.style ? n : SE.createElement(e1);
        }, oT = function e1(t, n, i) {
            var r = getComputedStyle(t);
            return r[n] || r.getPropertyValue(n.replace(kE, "-$1").toLowerCase()) || r.getPropertyValue(n) || !i && e1(t, cT(n) || n, 1) || "";
        }, lT = "O,Moz,ms,Ms,Webkit".split(","), cT = function(e1, t, n) {
            var i = (t || DE).style, r = 5;
            if (e1 in i && !n) return e1;
            for(e1 = e1.charAt(0).toUpperCase() + e1.substr(1); r-- && !(lT[r] + e1 in i););
            return r < 0 ? null : (3 === r ? "ms" : r >= 0 ? lT[r] : "") + e1;
        }, uT = function() {
            "undefined" != typeof window && window.document && (TE = window, SE = TE.document, IE = SE.documentElement, DE = sT("div") || {
                style: {}
            }, sT("div"), eT = cT(eT), tT = eT + "Origin", DE.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", RE = !!cT("perspective"), LE = EE.core.reverting, NE = 1);
        }, hT = function e1(t) {
            var n, i = sT("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), r = this.parentNode, a = this.nextSibling, s = this.style.cssText;
            if (IE.appendChild(i), i.appendChild(this), this.style.display = "block", t) try {
                n = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = e1;
            } catch (e1) {}
            else this._gsapBBox && (n = this._gsapBBox());
            return r && (a ? r.insertBefore(this, a) : r.appendChild(this)), IE.removeChild(i), this.style.cssText = s, n;
        }, dT = function(e1, t) {
            for(var n = t.length; n--;)if (e1.hasAttribute(t[n])) return e1.getAttribute(t[n]);
        }, pT = function(e1) {
            var t;
            try {
                t = e1.getBBox();
            } catch (n) {
                t = hT.call(e1, !0);
            }
            return t && (t.width || t.height) || e1.getBBox === hT || (t = hT.call(e1, !0)), !t || t.width || t.x || t.y ? t : {
                x: +dT(e1, [
                    "x",
                    "cx",
                    "x1"
                ]) || 0,
                y: +dT(e1, [
                    "y",
                    "cy",
                    "y1"
                ]) || 0,
                width: 0,
                height: 0
            };
        }, fT = function(e1) {
            return !(!e1.getCTM || e1.parentNode && !e1.ownerSVGElement || !pT(e1));
        }, mT = function(e1, t) {
            if (t) {
                var n, i = e1.style;
                t in zE && t !== tT && (t = eT), i.removeProperty ? ("ms" !== (n = t.substr(0, 2)) && "webkit" !== t.substr(0, 6) || (t = "-" + t), i.removeProperty("--" === n ? t : t.replace(kE, "-$1").toLowerCase())) : i.removeAttribute(t);
            }
        }, gT = function(e1, t, n, i, r, a) {
            var s = new dE(e1._pt, t, n, 0, 1, a ? YE : WE);
            return e1._pt = s, s.b = i, s.e = r, e1._props.push(n), s;
        }, AT = {
            deg: 1,
            rad: 1,
            turn: 1
        }, vT = {
            grid: 1,
            flex: 1
        }, MT = function e1(t, n, i, r) {
            var a, s, o, l, c = parseFloat(i) || 0, u = (i + "").trim().substr((c + "").length) || "px", h = DE.style, d = jE.test(n), p = "svg" === t.tagName.toLowerCase(), f = (p ? "client" : "offset") + (d ? "Width" : "Height"), m = 100, g = "px" === r, A = "%" === r;
            if (r === u || !c || AT[r] || AT[u]) return c;
            if ("px" !== u && !g && (c = e1(t, n, i, "px")), l = t.getCTM && fT(t), (A || "%" === u) && (zE[n] || ~n.indexOf("adius"))) return a = l ? t.getBBox()[d ? "width" : "height"] : t[f], gb(A ? c / a * m : c / 100 * a);
            if (h[d ? "width" : "height"] = m + (g ? u : r), s = ~n.indexOf("adius") || "em" === r && t.appendChild && !p ? t : t.parentNode, l && (s = (t.ownerSVGElement || {}).parentNode), s && s !== SE && s.appendChild || (s = SE.body), (o = s._gsap) && A && o.width && d && o.time === Tw.time && !o.uncache) return gb(c / o.width * m);
            if (!A || "height" !== n && "width" !== n) (A || "%" === u) && !vT[oT(s, "display")] && (h.position = oT(t, "position")), s === t && (h.position = "static"), s.appendChild(DE), a = DE[f], s.removeChild(DE), h.position = "absolute";
            else {
                var v = t.style[n];
                t.style[n] = m + r, a = t[f], v ? t.style[n] = v : mT(t, n);
            }
            return d && A && ((o = pb(s)).time = Tw.time, o.width = s[f]), gb(g ? a * c / m : a && c ? m / a * c : 0);
        }, yT = function(e1, t, n, i) {
            var r;
            return NE || uT(), t in FE && "transform" !== t && ~(t = FE[t]).indexOf(",") && (t = t.split(",")[0]), zE[t] && "transform" !== t ? (r = LT(e1, i), r = "transformOrigin" !== t ? r[t] : r.svg ? r.origin : RT(oT(e1, tT)) + " " + r.zOrigin + "px") : (!(r = e1.style[t]) || "auto" === r || i || ~(r + "").indexOf("calc(")) && (r = ET[t] && ET[t](e1, t, n) || oT(e1, t) || fb(e1, t) || ("opacity" === t ? 1 : 0)), n && !~(r + "").trim().indexOf(" ") ? MT(e1, t, r, n) + n : r;
        }, xT = function(e1, t, n, i) {
            if (!n || "none" === n) {
                var r = cT(t, e1, 1), a = r && oT(e1, r, 1);
                a && a !== n ? (t = r, n = a) : "borderColor" === t && (n = oT(e1, "borderTopColor"));
            }
            var s, o, l, c, u, h, d, p, f, m, g, A = new dE(this._pt, e1.style, t, 0, 1, sE), v = 0, M = 0;
            if (A.b = n, A.e = i, n += "", "auto" == (i += "") && (h = e1.style[t], e1.style[t] = i, i = oT(e1, t) || i, h ? e1.style[t] = h : mT(e1, t)), Ew(s = [
                n,
                i
            ]), i = s[1], l = (n = s[0]).match(V_) || [], (i.match(V_) || []).length) {
                for(; o = V_.exec(i);)d = o[0], f = i.substring(v, o.index), u ? u = (u + 1) % 5 : "rgba(" !== f.substr(-5) && "hsla(" !== f.substr(-5) || (u = 1), d !== (h = l[M++] || "") && (c = parseFloat(h) || 0, g = h.substr((c + "").length), "=" === d.charAt(1) && (d = vb(c, d) + g), p = parseFloat(d), m = d.substr((p + "").length), v = V_.lastIndex - m.length, m || (m = m || x_.units[t] || g, v === i.length && (i += m, A.e += m)), g !== m && (c = MT(e1, t, h, m) || 0), A._pt = {
                    _next: A._pt,
                    p: f || 1 === M ? f : ",",
                    s: c,
                    c: p - c,
                    m: u && u < 4 || "zIndex" === t ? Math.round : 0
                });
                A.c = v < i.length ? i.substring(v, i.length) : "";
            } else A.r = "display" === t && "none" === i ? YE : WE;
            return Q_.test(i) && (A.e = 0), this._pt = A, A;
        }, _T = {
            top: "0%",
            bottom: "100%",
            left: "0%",
            right: "100%",
            center: "50%"
        }, bT = function(e1) {
            var t = e1.split(" "), n = t[0], i = t[1] || "50%";
            return "top" !== n && "bottom" !== n && "left" !== i && "right" !== i || (e1 = n, n = i, i = e1), t[0] = _T[n] || n, t[1] = _T[i] || i, t.join(" ");
        }, wT = function(e1, t) {
            if (t.tween && t.tween._time === t.tween._dur) {
                var n, i, r, a = t.t, s = a.style, o = t.u, l = a._gsap;
                if ("all" === o || !0 === o) s.cssText = "", i = 1;
                else for(r = (o = o.split(",")).length; --r > -1;)n = o[r], zE[n] && (i = 1, n = "transformOrigin" === n ? tT : eT), mT(a, n);
                i && (mT(a, eT), l && (l.svg && a.removeAttribute("transform"), LT(a, 1), l.uncache = 1, iT(s)));
            }
        }, ET = {
            clearProps: function(e1, t, n, i, r) {
                if ("isFromStart" !== r.data) {
                    var a = e1._pt = new dE(e1._pt, t, n, 0, 0, wT);
                    return a.u = i, a.pr = -10, a.tween = r, e1._props.push(n), 1;
                }
            }
        }, TT = [
            1,
            0,
            0,
            1,
            0,
            0
        ], ST = {}, IT = function(e1) {
            return "matrix(1, 0, 0, 1, 0, 0)" === e1 || "none" === e1 || !e1;
        }, NT = function(e1) {
            var t = oT(e1, eT);
            return IT(t) ? TT : t.substr(7).match(H_).map(gb);
        }, DT = function(e1, t) {
            var n, i, r, a, s = e1._gsap || pb(e1), o = e1.style, l = NT(e1);
            return s.svg && e1.getAttribute("transform") ? "1,0,0,1,0,0" === (l = [
                (r = e1.transform.baseVal.consolidate().matrix).a,
                r.b,
                r.c,
                r.d,
                r.e,
                r.f
            ]).join(",") ? TT : l : (l !== TT || e1.offsetParent || e1 === IE || s.svg || (r = o.display, o.display = "block", (n = e1.parentNode) && e1.offsetParent || (a = 1, i = e1.nextElementSibling, IE.appendChild(e1)), l = NT(e1), r ? o.display = r : mT(e1, "display"), a && (i ? n.insertBefore(e1, i) : n ? n.appendChild(e1) : IE.removeChild(e1))), t && l.length > 6 ? [
                l[0],
                l[1],
                l[4],
                l[5],
                l[12],
                l[13]
            ] : l);
        }, CT = function(e1, t, n, i, r, a) {
            var s, o, l, c = e1._gsap, u = r || DT(e1, !0), h = c.xOrigin || 0, d = c.yOrigin || 0, p = c.xOffset || 0, f = c.yOffset || 0, m = u[0], g = u[1], A = u[2], v = u[3], M = u[4], y = u[5], x = t.split(" "), _ = parseFloat(x[0]) || 0, b = parseFloat(x[1]) || 0;
            n ? u !== TT && (o = m * v - g * A) && (l = _ * (-g / o) + b * (m / o) - (m * y - g * M) / o, _ = _ * (v / o) + b * (-A / o) + (A * y - v * M) / o, b = l) : (_ = (s = pT(e1)).x + (~x[0].indexOf("%") ? _ / 100 * s.width : _), b = s.y + (~(x[1] || x[0]).indexOf("%") ? b / 100 * s.height : b)), i || !1 !== i && c.smooth ? (M = _ - h, y = b - d, c.xOffset = p + (M * m + y * A) - M, c.yOffset = f + (M * g + y * v) - y) : c.xOffset = c.yOffset = 0, c.xOrigin = _, c.yOrigin = b, c.smooth = !!i, c.origin = t, c.originIsAbsolute = !!n, e1.style[tT] = "0px 0px", a && (gT(a, c, "xOrigin", h, _), gT(a, c, "yOrigin", d, b), gT(a, c, "xOffset", p, c.xOffset), gT(a, c, "yOffset", f, c.yOffset)), e1.setAttribute("data-svg-origin", _ + " " + b);
        }, LT = function(e1, t) {
            var n = e1._gsap || new jw(e1);
            if ("x" in n && !t && !n.uncache) return n;
            var i, r, a, s, o, l, c, u, h, d, p, f, m, g, A, v, M, y, x, _, b, w, E, T, S, I, N, D, C, L, R, z, O = e1.style, P = n.scaleX < 0, U = "px", k = "deg", j = getComputedStyle(e1), B = oT(e1, tT) || "0";
            return i = r = a = l = c = u = h = d = p = 0, s = o = 1, n.svg = !(!e1.getCTM || !fT(e1)), j.translate && ("none" === j.translate && "none" === j.scale && "none" === j.rotate || (O[eT] = ("none" !== j.translate ? "translate3d(" + (j.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + ("none" !== j.rotate ? "rotate(" + j.rotate + ") " : "") + ("none" !== j.scale ? "scale(" + j.scale.split(" ").join(",") + ") " : "") + ("none" !== j[eT] ? j[eT] : "")), O.scale = O.rotate = O.translate = "none"), g = DT(e1, n.svg), n.svg && (n.uncache ? (S = e1.getBBox(), B = n.xOrigin - S.x + "px " + (n.yOrigin - S.y) + "px", T = "") : T = !t && e1.getAttribute("data-svg-origin"), CT(e1, T || B, !!T || n.originIsAbsolute, !1 !== n.smooth, g)), f = n.xOrigin || 0, m = n.yOrigin || 0, g !== TT && (y = g[0], x = g[1], _ = g[2], b = g[3], i = w = g[4], r = E = g[5], 6 === g.length ? (s = Math.sqrt(y * y + x * x), o = Math.sqrt(b * b + _ * _), l = y || x ? UE(x, y) * OE : 0, (h = _ || b ? UE(_, b) * OE + l : 0) && (o *= Math.abs(Math.cos(h * PE))), n.svg && (i -= f - (f * y + m * _), r -= m - (f * x + m * b))) : (z = g[6], L = g[7], N = g[8], D = g[9], C = g[10], R = g[11], i = g[12], r = g[13], a = g[14], c = (A = UE(z, C)) * OE, A && (T = w * (v = Math.cos(-A)) + N * (M = Math.sin(-A)), S = E * v + D * M, I = z * v + C * M, N = w * -M + N * v, D = E * -M + D * v, C = z * -M + C * v, R = L * -M + R * v, w = T, E = S, z = I), u = (A = UE(-_, C)) * OE, A && (v = Math.cos(-A), R = b * (M = Math.sin(-A)) + R * v, y = T = y * v - N * M, x = S = x * v - D * M, _ = I = _ * v - C * M), l = (A = UE(x, y)) * OE, A && (T = y * (v = Math.cos(A)) + x * (M = Math.sin(A)), S = w * v + E * M, x = x * v - y * M, E = E * v - w * M, y = T, w = S), c && Math.abs(c) + Math.abs(l) > 359.9 && (c = l = 0, u = 180 - u), s = gb(Math.sqrt(y * y + x * x + _ * _)), o = gb(Math.sqrt(E * E + z * z)), A = UE(w, E), h = Math.abs(A) > 2e-4 ? A * OE : 0, p = R ? 1 / (R < 0 ? -R : R) : 0), n.svg && (T = e1.getAttribute("transform"), n.forceCSS = e1.setAttribute("transform", "") || !IT(oT(e1, eT)), T && e1.setAttribute("transform", T))), Math.abs(h) > 90 && Math.abs(h) < 270 && (P ? (s *= -1, h += l <= 0 ? 180 : -180, l += l <= 0 ? 180 : -180) : (o *= -1, h += h <= 0 ? 180 : -180)), t = t || n.uncache, n.x = i - ((n.xPercent = i && (!t && n.xPercent || (Math.round(e1.offsetWidth / 2) === Math.round(-i) ? -50 : 0))) ? e1.offsetWidth * n.xPercent / 100 : 0) + U, n.y = r - ((n.yPercent = r && (!t && n.yPercent || (Math.round(e1.offsetHeight / 2) === Math.round(-r) ? -50 : 0))) ? e1.offsetHeight * n.yPercent / 100 : 0) + U, n.z = a + U, n.scaleX = gb(s), n.scaleY = gb(o), n.rotation = gb(l) + k, n.rotationX = gb(c) + k, n.rotationY = gb(u) + k, n.skewX = h + k, n.skewY = d + k, n.transformPerspective = p + U, (n.zOrigin = parseFloat(B.split(" ")[2]) || !t && n.zOrigin || 0) && (O[tT] = RT(B)), n.xOffset = n.yOffset = 0, n.force3D = x_.force3D, n.renderTransform = n.svg ? BT : RE ? jT : OT, n.uncache = 0, n;
        }, RT = function(e1) {
            return (e1 = e1.split(" "))[0] + " " + e1[1];
        }, zT = function(e1, t, n) {
            var i = $b(t);
            return gb(parseFloat(t) + parseFloat(MT(e1, "x", n + "px", i))) + i;
        }, OT = function(e1, t) {
            t.z = "0px", t.rotationY = t.rotationX = "0deg", t.force3D = 0, jT(e1, t);
        }, PT = "0deg", UT = "0px", kT = ") ", jT = function(e1, t) {
            var n = t || this, i = n.xPercent, r = n.yPercent, a = n.x, s = n.y, o = n.z, l = n.rotation, c = n.rotationY, u = n.rotationX, h = n.skewX, d = n.skewY, p = n.scaleX, f = n.scaleY, m = n.transformPerspective, g = n.force3D, A = n.target, v = n.zOrigin, M = "", y = "auto" === g && e1 && 1 !== e1 || !0 === g;
            if (v && (u !== PT || c !== PT)) {
                var x, _ = parseFloat(c) * PE, b = Math.sin(_), w = Math.cos(_);
                _ = parseFloat(u) * PE, x = Math.cos(_), a = zT(A, a, b * x * -v), s = zT(A, s, -Math.sin(_) * -v), o = zT(A, o, w * x * -v + v);
            }
            m !== UT && (M += "perspective(" + m + kT), (i || r) && (M += "translate(" + i + "%, " + r + "%) "), (y || a !== UT || s !== UT || o !== UT) && (M += o !== UT || y ? "translate3d(" + a + ", " + s + ", " + o + ") " : "translate(" + a + ", " + s + kT), l !== PT && (M += "rotate(" + l + kT), c !== PT && (M += "rotateY(" + c + kT), u !== PT && (M += "rotateX(" + u + kT), h === PT && d === PT || (M += "skew(" + h + ", " + d + kT), 1 === p && 1 === f || (M += "scale(" + p + ", " + f + kT), A.style[eT] = M || "translate(0, 0)";
        }, BT = function(e1, t) {
            var n, i, r, a, s, o = t || this, l = o.xPercent, c = o.yPercent, u = o.x, h = o.y, d = o.rotation, p = o.skewX, f = o.skewY, m = o.scaleX, g = o.scaleY, A = o.target, v = o.xOrigin, M = o.yOrigin, y = o.xOffset, x = o.yOffset, _ = o.forceCSS, b = parseFloat(u), w = parseFloat(h);
            d = parseFloat(d), p = parseFloat(p), (f = parseFloat(f)) && (p += f = parseFloat(f), d += f), d || p ? (d *= PE, p *= PE, n = Math.cos(d) * m, i = Math.sin(d) * m, r = Math.sin(d - p) * -g, a = Math.cos(d - p) * g, p && (f *= PE, s = Math.tan(p - f), r *= s = Math.sqrt(1 + s * s), a *= s, f && (s = Math.tan(f), n *= s = Math.sqrt(1 + s * s), i *= s)), n = gb(n), i = gb(i), r = gb(r), a = gb(a)) : (n = m, a = g, i = r = 0), (b && !~(u + "").indexOf("px") || w && !~(h + "").indexOf("px")) && (b = MT(A, "x", u, "px"), w = MT(A, "y", h, "px")), (v || M || y || x) && (b = gb(b + v - (v * n + M * r) + y), w = gb(w + M - (v * i + M * a) + x)), (l || c) && (s = A.getBBox(), b = gb(b + l / 100 * s.width), w = gb(w + c / 100 * s.height)), s = "matrix(" + n + "," + i + "," + r + "," + a + "," + b + "," + w + ")", A.setAttribute("transform", s), _ && (A.style[eT] = s);
        }, FT = function(e1, t, n, i, r) {
            var a, s, o = 360, l = C_(r), c = parseFloat(r) * (l && ~r.indexOf("rad") ? OE : 1) - i, u = i + c + "deg";
            return l && ("short" === (a = r.split("_")[1]) && (c %= o) != c % 180 && (c += c < 0 ? o : -360), "cw" === a && c < 0 ? c = (c + 36e9) % o - ~~(c / o) * o : "ccw" === a && c > 0 && (c = (c - 36e9) % o - ~~(c / o) * o)), e1._pt = s = new dE(e1._pt, t, n, i, c, VE), s.e = u, s.u = "deg", e1._props.push(n), s;
        }, HT = function(e1, t) {
            for(var n in t)e1[n] = t[n];
            return e1;
        }, VT = function(e1, t, n) {
            var i, r, a, s, o, l, c, u = HT({}, n._gsap), h = n.style;
            for(r in u.svg ? (a = n.getAttribute("transform"), n.setAttribute("transform", ""), h[eT] = t, i = LT(n, 1), mT(n, eT), n.setAttribute("transform", a)) : (a = getComputedStyle(n)[eT], h[eT] = t, i = LT(n, 1), h[eT] = a), zE)(a = u[r]) !== (s = i[r]) && "perspective,force3D,transformOrigin,svgOrigin".indexOf(r) < 0 && (o = $b(a) !== (c = $b(s)) ? MT(n, r, a, c) : parseFloat(a), l = parseFloat(s), e1._pt = new dE(e1._pt, i, r, o, l - o, HE), e1._pt.u = c || 0, e1._props.push(r));
            HT(i, u);
        };
        mb("padding,margin,Width,Radius", function(e1, t) {
            var n = "Top", i = "Right", r = "Bottom", a = "Left", s = (t < 3 ? [
                n,
                i,
                r,
                a
            ] : [
                n + a,
                n + i,
                r + i,
                r + a
            ]).map(function(n) {
                return t < 2 ? e1 + n : "border" + n + e1;
            });
            ET[t > 1 ? "border" + e1 : e1] = function(e1, t, n, i, r) {
                var a, o;
                if (arguments.length < 4) return a = s.map(function(t) {
                    return yT(e1, t, n);
                }), 5 === (o = a.join(" ")).split(a[0]).length ? a[0] : o;
                a = (i + "").split(" "), o = {}, s.forEach(function(e1, t) {
                    return o[e1] = a[t] = a[t] || a[(t - 1) / 2 | 0];
                }), e1.init(t, o, r);
            };
        });
        var GT, QT, WT = {
            name: "css",
            register: uT,
            targetTest: function(e1) {
                return e1.style && e1.nodeType;
            },
            init: function(e1, t, n, i, r) {
                var a, s, o, l, c, u, h, d, p, f, m, g, A, v, M, y, x = this._props, _ = e1.style, b = n.vars.startAt;
                for(h in NE || uT(), this.styles = this.styles || aT(e1), y = this.styles.props, this.tween = n, t)if ("autoRound" !== h && (s = t[h], !ob[h] || !Ww(h, t, n, i, e1, r))) {
                    if (c = typeof s, u = ET[h], "function" === c && (c = typeof (s = s.call(n, i, e1, r))), "string" === c && ~s.indexOf("random(") && (s = uw(s)), u) u(this, e1, h, s, n) && (M = 1);
                    else if ("--" === h.substr(0, 2)) a = (getComputedStyle(e1).getPropertyValue(h) + "").trim(), s += "", bw.lastIndex = 0, bw.test(a) || (d = $b(a), p = $b(s)), p ? d !== p && (a = MT(e1, h, a, p) + p) : d && (s += d), this.add(_, "setProperty", a, s, i, r, 0, 0, h), x.push(h), y.push(h, 0, _[h]);
                    else if ("undefined" !== c) {
                        if (b && h in b ? (a = "function" == typeof b[h] ? b[h].call(n, i, e1, r) : b[h], C_(a) && ~a.indexOf("random(") && (a = uw(a)), $b(a + "") || "auto" === a || (a += x_.units[h] || $b(yT(e1, h)) || ""), "=" === (a + "").charAt(1) && (a = yT(e1, h))) : a = yT(e1, h), l = parseFloat(a), (f = "string" === c && "=" === s.charAt(1) && s.substr(0, 2)) && (s = s.substr(2)), o = parseFloat(s), h in FE && ("autoAlpha" === h && (1 === l && "hidden" === yT(e1, "visibility") && o && (l = 0), y.push("visibility", 0, _.visibility), gT(this, _, "visibility", l ? "inherit" : "hidden", o ? "inherit" : "hidden", !o)), "scale" !== h && "transform" !== h && ~(h = FE[h]).indexOf(",") && (h = h.split(",")[0])), m = h in zE) {
                            if (this.styles.save(h), g || ((A = e1._gsap).renderTransform && !t.parseTransform || LT(e1, t.parseTransform), v = !1 !== t.smoothOrigin && A.smooth, (g = this._pt = new dE(this._pt, _, eT, 0, 1, A.renderTransform, A, 0, -1)).dep = 1), "scale" === h) this._pt = new dE(this._pt, A, "scaleY", A.scaleY, (f ? vb(A.scaleY, f + o) : o) - A.scaleY || 0, HE), this._pt.u = 0, x.push("scaleY", h), h += "X";
                            else {
                                if ("transformOrigin" === h) {
                                    y.push(tT, 0, _[tT]), s = bT(s), A.svg ? CT(e1, s, 0, v, 0, this) : ((p = parseFloat(s.split(" ")[2]) || 0) !== A.zOrigin && gT(this, A, "zOrigin", A.zOrigin, p), gT(this, _, h, RT(a), RT(s)));
                                    continue;
                                }
                                if ("svgOrigin" === h) {
                                    CT(e1, s, 1, v, 0, this);
                                    continue;
                                }
                                if (h in ST) {
                                    FT(this, A, h, l, f ? vb(l, f + s) : s);
                                    continue;
                                }
                                if ("smoothOrigin" === h) {
                                    gT(this, A, "smooth", A.smooth, s);
                                    continue;
                                }
                                if ("force3D" === h) {
                                    A[h] = s;
                                    continue;
                                }
                                if ("transform" === h) {
                                    VT(this, s, e1);
                                    continue;
                                }
                            }
                        } else h in _ || (h = cT(h) || h);
                        if (m || (o || 0 === o) && (l || 0 === l) && !BE.test(s) && h in _) o || (o = 0), (d = (a + "").substr((l + "").length)) !== (p = $b(s) || (h in x_.units ? x_.units[h] : d)) && (l = MT(e1, h, a, p)), this._pt = new dE(this._pt, m ? A : _, h, l, (f ? vb(l, f + o) : o) - l, m || "px" !== p && "zIndex" !== h || !1 === t.autoRound ? HE : QE), this._pt.u = p || 0, d !== p && "%" !== p && (this._pt.b = a, this._pt.r = GE);
                        else if (h in _) xT.call(this, e1, h, a, f ? f + s : s);
                        else if (h in e1) this.add(e1, h, a || e1[h], f ? f + s : s, i, r);
                        else if ("parseTransform" !== h) {
                            K_(h, s);
                            continue;
                        }
                        m || (h in _ ? y.push(h, 0, _[h]) : y.push(h, 1, a || e1[h])), x.push(h);
                    }
                }
                M && hE(this);
            },
            render: function(e1, t) {
                if (t.tween._time || !LE()) for(var n = t._pt; n;)n.r(e1, n.d), n = n._next;
                else t.styles.revert();
            },
            get: yT,
            aliases: FE,
            getSetter: function(e1, t, n) {
                var i = FE[t];
                return i && i.indexOf(",") < 0 && (t = i), t in zE && t !== tT && (e1._gsap.x || yT(e1, "x")) ? n && CE === n ? "scale" === t ? KE : qE : (CE = n || {}, "scale" === t ? JE : $E) : e1.style && !z_(e1.style[t]) ? XE : ~t.indexOf("-") ? ZE : iE(e1, t);
            },
            core: {
                _removeProperty: mT,
                _getMatrix: DT
            }
        };
        EE.utils.checkPrefix = cT, EE.core.getStyleSaver = aT, QT = mb("x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + (GT = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", function(e1) {
            zE[e1] = 1;
        }), mb(GT, function(e1) {
            x_.units[e1] = "deg", ST[e1] = 1;
        }), FE[QT[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + GT, mb("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", function(e1) {
            var t = e1.split(":");
            FE[t[1]] = QT[t[0]];
        }), mb("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(e1) {
            x_.units[e1] = "px";
        }), EE.registerPlugin(WT);
        var YT = EE.registerPlugin(WT) || EE;
        YT.core.Tween;
        const XT = class extends kp {
            constructor(e1){
                var t, n, i;
                super(), t = this, i = !0, (n = function(e1) {
                    var t = function(e1) {
                        if ("object" != typeof e1 || !e1) return e1;
                        var t = e1[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var n = t.call(e1, "string");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == typeof t ? t : t + "";
                }(n = "_visible")) in t ? Object.defineProperty(t, n, {
                    value: i,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[n] = i, this.userData = e1, this.visible = !1, this.createHoverArea(), this.createPoint().then(()=>this.addEventListeners());
            }
            get visible() {
                return this._visible;
            }
            set visible(e1) {
                this._visible = e1, this.hoverArea && (this.hoverArea.visible = e1), this.point && (this.point.visible = e1);
            }
            async createPoint() {
                const e1 = new dh(30, 30, 10, 10), t = new bA, n = await t.loadAsync(this.userData.icon);
                n.center = new Jo(.5, .5), n.colorSpace = Gs, n.minFilter = _a, n.magFilter = va, n.anisotropy = 8;
                const i = new Ug({
                    color: new Zc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: hr,
                    map: n,
                    opacity: _x.isMobileDevice ? .5 : 0
                });
                this.point = new Vu(e1, i), this.point.position.copy(this.userData.position), this.point.rotation.x = Math.PI / 2, this.point.visible = this.visible, this.point.interactive = !0, this.point.renderOrder = 3, this.point.isLink = !0, this.point.updateOpacity = YT.quickTo(this.point.material, "opacity", {
                    ease: "back",
                    duration: .5
                }), this.add(this.point);
            }
            createHoverArea() {
                const e1 = new Um(125, 10, 10), t = new Ug({
                    color: new Zc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: hr,
                    opacity: 0
                });
                this.hoverArea = new Vu(e1, t), this.hoverArea.position.copy(this.userData.position), this.hoverArea.rotation.x = Math.PI / 2, this.hoverArea.visible = this.visible, this.hoverArea.isLinkSphere = !0, this.hoverArea.interactive = !0, this.hoverArea.renderOrder = 2, this.add(this.hoverArea);
            }
            addEventListeners() {
                return this.point.addEventListener("select", ()=>this.onClick()), this.point.addEventListener("click", ()=>this.onClick()), this.point.addEventListener("hoverstart", ()=>this.onHoverStart()), this.point.addEventListener("hoverend", ()=>this.onHoverEnd()), this.hoverArea.addEventListener("hoverstart", ()=>this.onHoverStart()), this.hoverArea.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            dispose() {
                this.point && (this.point.material.dispose(), this.point.removeFromParent()), this.hoverArea && (this.hoverArea.material.dispose(), this.hoverArea.removeFromParent()), this.removeFromParent();
            }
            onHoverStart() {
                _x.isMobileDevice || this.point.updateOpacity(1);
            }
            onHoverEnd() {
                _x.isMobileDevice || this.point.updateOpacity(0);
            }
            onClick() {}
        };
        const ZT = {
            hasRealSize: !1,
            realSize: 300,
            realSizeMobileScale: 1,
            realSizeMinDistance: 100,
            realSizeDistanceMinScale: .1,
            hoverScale: 1.2
        };
        class qT extends ff {
            constructor(e1){
                var t, n, i;
                super(), t = this, i = !0, (n = function(e1) {
                    var t = function(e1) {
                        if ("object" != typeof e1 || !e1) return e1;
                        var t = e1[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var n = t.call(e1, "string");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == typeof t ? t : t + "";
                }(n = "interactive")) in t ? Object.defineProperty(t, n, {
                    value: i,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[n] = i, this.userData = e1, this.position.copy(e1.position), this.renderOrder = 3, this.visible = !1, this.onHoverEnd(), this.createMaterial().then(()=>this.addEventListeners());
            }
            get options() {
                return {
                    ...ZT,
                    ...Bi.config.defaultLinkOptions
                };
            }
            get hasRealSize() {
                return Boolean(this.options.hasRealSize);
            }
            get hoverScale() {
                return this.options.hoverScale;
            }
            get distanceScale() {
                if (!this.hasRealSize) return 1;
                const e1 = this.options.realSizeMinDistance;
                if (!e1) return 1;
                const { x: t, z: n } = this.position, i = Math.sqrt(t * t + n * n);
                return i > e1 ? 1 : Math.max(this.options.realSizeDistanceMinScale, i / e1);
            }
            get spriteScale() {
                if (!this.hasRealSize) return this.userData.scale;
                const e1 = (_x.isMobile ? this.options.realSizeMobileScale : 1) * this.options.realSize * this.distanceScale;
                return this.userData.scale * e1;
            }
            createGeometry() {
                return this.geometry = new dh(1, 1, 10, 10), this;
            }
            async createMaterial() {
                const e1 = await Ox.getTexture(this.userData.icon);
                return e1 ? (e1.center = new Jo(.5, .5), e1.colorSpace = Gs, e1.minFilter = _a, e1.magFilter = va, e1.anisotropy = 8, this.material = new $p({
                    color: new Zc(16777215),
                    sizeAttenuation: this.hasRealSize,
                    transparent: !0,
                    depthTest: !1,
                    side: hr,
                    map: e1,
                    opacity: 1
                }), this) : this;
            }
            addEventListeners() {
                return this.addEventListener("select", ()=>this.onClick()), this.addEventListener("click", ()=>this.onClick()), this.addEventListener("hoverstart", ()=>this.onHoverStart()), this.addEventListener("hoverend", ()=>this.onHoverEnd()), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
            onHoverStart() {
                this.scale.setScalar(this.spriteScale * this.hoverScale);
            }
            onHoverEnd() {
                this.scale.setScalar(this.spriteScale);
            }
            onClick() {}
        }
        function KT(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        function JT(e1, t) {
            return e1.get(function(e1, t, n) {
                if ("function" == typeof e1 ? e1 === t : e1.has(t)) return arguments.length < 3 ? t : n;
                throw new TypeError("Private element is not present on this object");
            }(e1, t));
        }
        var $T = new WeakMap;
        const eS = class extends Vu {
            constructor(e1, t){
                var n, i, r;
                super(t), KT(this, "depthMap", null), KT(this, "loaded", !1), KT(this, "links", []), r = [], function(e1, t) {
                    if (t.has(e1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
                }(n = this, i = $T), i.set(n, r), this.renderOrder = 0, this.userData = e1;
            }
            get panoramaId() {
                return this.userData.camera_id;
            }
            async loadDepth() {
                performance.mark("start downloadingDepth");
                try {
                    this.depthMap = await Ox.getDepth(this.userData.images.scene_depth);
                } catch (e1) {
                    this.depthMap = null, console.error("Error loading depthMap");
                }
                performance.mark("finish start downloadingDepth"), performance.measure("downloadingDepth", "start downloadingDepth", "finish start downloadingDepth");
            }
            async loadMask() {
                try {
                    this.mask = await Ox.getDepth(this.userData.images.object_ids);
                } catch (e1) {
                    this.mask = null, console.error("Error loading mask");
                }
            }
            async load() {
                return this.userData.images.scene_depth && await this.loadDepth().then(()=>this.removeBlockedLinks()), this.userData.images.object_ids && await this.loadMask(), await this.createMaterial().then(()=>this.loaded = !0);
            }
            removeBlockedLinks() {
                const e1 = [];
                this.links.forEach((t)=>{
                    const { delta: n, distance: i } = ((e1, t)=>{
                        const { direction: n } = (new sc).lookAt(e1), i = (1 + Math.atan2(n.z, n.x) / Math.PI) / 2, r = Math.acos(n.y) / Math.PI, { R: a } = Wx(i, r, t), s = a || 140, o = (new Cl).distanceTo(e1);
                        return {
                            depth: s,
                            distance: o,
                            delta: o - s
                        };
                    })(t.userData.position, this.depthMap);
                    if (n > 40 || i > 800) return t.dispose();
                    e1.push(t);
                });
            }
            createLinks(e1) {
                return this.createCameraPoints(), this.createDoors(e1), this;
            }
            createCameraPoints() {
                for (const e1 of this.userData.roomPanoramas){
                    if (e1 === this.panoramaId) continue;
                    const t = jx(Bi.config.json, e1);
                    t && this.createLink(e1, t.Location, !1);
                }
                return this;
            }
            createDoors(e1) {
                var t, n;
                const i = Bi.config.json.Floors[Bi.currentFloorIndex], r = null !== (t = i.Apertures) && void 0 !== t ? t : [], a = null !== (n = i.Doors) && void 0 !== n ? n : [], s = kx(Bi.config.json, this.userData.room_id), { Rooms: o } = i.Units[0];
                for (const { Location: t, Walls: n, ...i } of [
                    ...a,
                    ...r
                ]){
                    if (!n.some((e1)=>s.Walls.some((t)=>t === e1))) continue;
                    const r = o.find((e1)=>{
                        const t = e1.Walls.some((e1)=>n.some((t)=>e1 === t)), i = e1.ID === s.ID;
                        return t && !i;
                    });
                    if (!r) continue;
                    const a = e1.filter((e1)=>{
                        let { userData: t } = e1;
                        return t.room_id === r.ID;
                    }), { panorama: l } = Bx([
                        t.X,
                        t.Y
                    ], a);
                    l && this.createLink(l.panoramaId, t, !0, i);
                }
                return this;
            }
            createLink(e1, t) {
                var n;
                let i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], r = arguments.length > 3 ? arguments[3] : void 0;
                const a = (null === (n = this.userData.cameraData) || void 0 === n ? void 0 : n.Location.Z) || 140, s = [
                    this.userData.left,
                    this.userData.top
                ], o = t.X - s[0], l = t.Y - s[1], c = i ? r.Height / 2 - a : -a, u = new Cl(o, c, l);
                u.applyAxisAngle(new Cl(0, 1, 0), Math.PI / 2);
                const h = {
                    panoramaId: this.panoramaId,
                    position: u,
                    targetId: e1
                };
                if (i) {
                    const e1 = Bi.config.panoramaIcons.door, t = Bi.config.interactiveDoors ? new t_({
                        ...h,
                        rotation: new Ac(0, Gx(r.Rotation.Yaw + 90), 0),
                        height: r.Height,
                        width: r.Width,
                        scale: .1,
                        icon: e1,
                        loc: this.userData.cameraData.Location
                    }) : new qT({
                        ...h,
                        scale: .1,
                        icon: e1
                    });
                    return this.links.push(t), t;
                }
                const d = Bi.config.interactiveCameraPoints ? Bi.config.panoramaIcons.interactiveSpot : Bi.config.panoramaIcons.spot, p = Bi.config.interactiveCameraPoints ? new XT({
                    ...h,
                    icon: d,
                    scale: 1
                }) : new qT({
                    ...h,
                    scale: .1,
                    icon: d
                });
                return this.links.push(p), p;
            }
            addEventListener(e1, t) {
                "materialcreate" === e1 ? JT($T, this).push({
                    type: e1,
                    listener: t
                }) : super.addEventListener(e1, t);
            }
            invoke(e1, t) {
                JT($T, this).forEach((n)=>{
                    e1 === n.type && n.listener(t);
                });
            }
        }, tS = class extends eS {
            constructor(e1){
                performance.mark("start creating SphereGeometry");
                const t = new Sg(1e3, 512, 512).scale(-1, 1, 1);
                performance.mark("finish creating SphereGeometry"), performance.measure("creating SphereGeometry", "start creating SphereGeometry", "finish creating SphereGeometry"), super(e1, t), this.userData.image = e1.images.sphere || e1.images[0];
            }
            async createBareshellMaterial() {
                if (this.bareshellMaterial) return this.material = this.bareshellMaterial, this.bareshellMaterial;
                const e1 = await Ox.getTexture(this.userData.image.replace(/\.jpe?g|\.webp/, (e1)=>{
                    switch(e1){
                        case ".jpg":
                        case ".jpeg":
                            return "_Unfurnished.jpg";
                        case ".webp":
                            return "_Unfurnished.webp";
                        default:
                            return e1;
                    }
                }));
                return this.material = new Ug({
                    transparent: !0,
                    side: cr,
                    map: e1,
                    opacity: 0
                }), this.bareshellMaterial = this.material, this;
            }
            async createDefaultMaterial() {
                if (this.defaultMaterial) return this.material = this.defaultMaterial, this.defaultMaterial;
                const e1 = await Ox.getTexture(this.userData.image);
                return this.material = new Ug({
                    transparent: !0,
                    side: cr,
                    map: e1,
                    opacity: 0
                }), this.defaultMaterial = this.material, this;
            }
            async createMaterial() {
                const e1 = await (BI.bareshell ? this.createBareshellMaterial() : this.createDefaultMaterial());
                return this.invoke("materialcreate"), e1;
            }
            async fadeOut() {
                return await Hx(this.material).then(()=>this.visible = !1);
            }
            async fadeIn() {
                return this.visible = !0, await Vx(this.material);
            }
        }, nS = class extends eS {
            constructor(e1){
                performance.mark("start creating BoxGeometry");
                const t = new Qu(2e3, 2e3, 2e3).scale(-1, 1, 1);
                performance.mark("finish creating BoxGeometry"), performance.measure("creating BoxGeometry", "start creating BoxGeometry", "finish creating BoxGeometry"), super(e1, t), this.userData.cubemap = [
                    {
                        url: e1.images.front,
                        rotation: 0
                    },
                    {
                        url: e1.images.back,
                        rotation: 0
                    },
                    {
                        url: e1.images.top,
                        rotation: 90
                    },
                    {
                        url: e1.images.bottom,
                        rotation: 270
                    },
                    {
                        url: e1.images.left,
                        rotation: 0
                    },
                    {
                        url: e1.images.right,
                        rotation: 0
                    }
                ];
            }
            async loadSides() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                const { cubemap: t } = this.userData;
                let n = 0;
                const i = t.length, r = new Array(t.length);
                return new Promise((a)=>{
                    const s = ()=>{
                        n++, n === i && a(r);
                    };
                    t.forEach((t, n)=>{
                        let i = t.url;
                        if (e1) {
                            const e1 = /(Panorama_\d_\d_\d_([a-zA-Zа-яА-Я0-9-]+)\/.+)\.[a-zA-Z0-9]+/gm, n = t.url.match(e1)[0], r = n.replace("/", "_Unfurnished/");
                            i = t.url.replace(n, r);
                        }
                        Ox.getTexture(i).then((e1)=>{
                            e1.rotation = Gx(t.rotation), r[n] = e1, s();
                        }).catch(s);
                    });
                });
            }
            async createBareshellMaterial() {
                if (this.bareshellMaterial) return this.material = this.bareshellMaterial, this.bareshellMaterial;
                const e1 = await this.loadSides(!0);
                this.material = e1.map((e1)=>new Ug({
                        transparent: !0,
                        side: cr,
                        opacity: 0,
                        map: e1
                    })), this.bareshellMaterial = this.material;
            }
            async createDefaultMaterial() {
                if (this.defaultMaterial) return this.material = this.defaultMaterial, this.defaultMaterial;
                const e1 = await this.loadSides();
                this.material = e1.map((e1)=>new Ug({
                        transparent: !0,
                        side: cr,
                        opacity: 0,
                        map: e1
                    })), this.defaultMaterial = this.material;
            }
            async createMaterial() {
                const e1 = await (BI.bareshell ? this.createBareshellMaterial() : this.createDefaultMaterial());
                return this.invoke("materialcreate"), e1;
            }
            async fadeOut() {
                const e1 = this.material.map(Hx);
                return await Promise.all(e1).then(()=>this.visible = !1);
            }
            async fadeIn() {
                this.visible = !0;
                const e1 = this.material.map(Vx);
                return await Promise.all(e1);
            }
        };
        function iS(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const rS = class extends kp {
            constructor(e1){
                super(), iS(this, "type", "sphere"), iS(this, "items", []), iS(this, "floorIndex", void 0), this.floorIndex = e1;
            }
            getCreatedPanoramas() {
                const { json: e1 } = Bi.config, t = e1.Floors[Bi.currentFloorIndex];
                if (!t) return this.items.map((e1)=>{
                    const t = {
                        svgPathActions: [],
                        roomPanoramas: [],
                        rotation: 0,
                        points: [],
                        left: 0,
                        top: 0,
                        ...e1
                    };
                    return this.createPanorama(t);
                });
                const { primaryCameraPointId: n } = Bi, i = jx(e1, n), { Walls: r } = t, { Vertices: a } = e1;
                return this.items.reduce((t, n)=>{
                    var s;
                    performance.mark("start getting rooms, cameras, svg paths ...");
                    const o = jx(e1, n.camera_id), l = kx(e1, n.room_id), c = this.items.reduce((e1, t)=>t.room_id !== n.room_id ? e1 : [
                            ...e1,
                            t.camera_id
                        ], []), u = ((e1, t, n)=>{
                        const i = e1.Walls.reduce((e1, i)=>{
                            const r = t.find((e1)=>e1.ID === i);
                            return Ux(t, r.ID, n).forEach((t)=>e1.push(t)), e1;
                        }, []);
                        return i;
                    })(l, r, a), h = l.Walls.reduce((e1, t, n)=>{
                        const i = r.find((e1)=>e1.ID === t), [s, o] = Ux(r, t, a), l = [];
                        return 0 === n && e1.push({
                            type: "M",
                            x: s[0],
                            y: s[1]
                        }), e1.push({
                            type: "L",
                            x: s[0],
                            y: s[1]
                        }), i.ControlPoint && l.push({
                            type: "Q",
                            x: i.ControlPoint.Location.X,
                            y: i.ControlPoint.Location.Y,
                            dx: o[0],
                            dy: o[1]
                        }), l.push({
                            type: "L",
                            x: o[0],
                            y: o[1]
                        }), [
                            ...e1,
                            ...l
                        ];
                    }, []);
                    performance.mark("finish getting rooms, cameras, svg paths ..."), performance.measure("getting rooms, cameras, svg paths ...", "start getting rooms, cameras, svg paths ...", "finish getting rooms, cameras, svg paths ...");
                    const [d, p] = o ? [
                        o.Location.X,
                        o.Location.Y
                    ] : function(e1) {
                        let t = 0, n = 0, i = e1.length;
                        for(let r = 0; r < i; r++){
                            const i = e1[r];
                            t += i[0], n += i[1];
                        }
                        return [
                            t / i,
                            n / i
                        ];
                    }(u), f = -1 * Gx((null === (s = o.Rotation) || void 0 === s ? void 0 : s.Yaw) || 0), m = {
                        svgPathActions: [],
                        roomPanoramas: [],
                        rotation: 0,
                        points: [],
                        left: 0,
                        top: 0,
                        ...n,
                        cameraData: o || null,
                        roomPanoramas: c,
                        svgPathActions: h,
                        rotation: f,
                        points: u,
                        left: d,
                        top: p
                    }, g = this.createPanorama(m);
                    return i && i.ID === o.ID ? (t.unshift(g), t) : i || l.ID !== Bi.initialPanoramaRoomId ? (t.push(g), t) : (t.unshift(g), t);
                }, []);
            }
            createPanoramas(e1, t) {
                this.items = e1, this.type = t, performance.mark("start create panorama's data");
                const n = this.getCreatedPanoramas();
                return performance.mark("finish create panorama's data"), performance.measure("creating panorama's data", "start create panorama's data", "finish create panorama's data"), n.forEach((e1, t)=>{
                    e1.userData.panorama_index = t, Bi.config.json && e1.createLinks(n);
                }), n;
            }
            createPanorama(e1) {
                const t = "cube" === this.type ? new nS(e1) : new tS(e1);
                return t.addEventListener("materialcreate", ()=>{
                    ((e1, t)=>{
                        var n, i, r;
                        if (_x.isMobile) return;
                        const { currentFloorIndex: a, config: s } = Bi, o = null == e1 || null === (n = e1.Floors) || void 0 === n || null === (n = n[a]) || void 0 === n ? void 0 : n.CameraPoints;
                        if (!o) return void console.warn("Panorama cache: can't get floor cameras!");
                        const l = null === (i = s.panoramaData) || void 0 === i ? void 0 : i.items;
                        if (!l) return void console.warn("Panorama cache: can't get panorama images data!");
                        let c = null;
                        const u = [];
                        if (o.forEach((e1)=>{
                            var n;
                            if (e1.ID === t) return void (c = e1);
                            const i = null === (n = l.find((t)=>t.camera_id === e1.ID)) || void 0 === n ? void 0 : n.images;
                            if (i) {
                                const t = {
                                    id: e1.ID,
                                    images: i.sphere ? [
                                        i.sphere
                                    ] : [
                                        i.front,
                                        i.back,
                                        i.left,
                                        i.right,
                                        i.top,
                                        i.bottom
                                    ],
                                    depths: [],
                                    location: e1.Location
                                };
                                s.enablePreloadMasks && Bi.isCapable("ruler") && t.depths.push(i.scene_depth, i.object_ids), u.push(t);
                            }
                        }), !c) return;
                        const h = null !== (r = Bi.config.preloadPerPanoramaCount) && void 0 !== r ? r : 3;
                        u.length > h && u.sort((e1, t)=>{
                            if (Bi.config.forcePreloadNonCached) {
                                const n = Number(e1.images.every((e1)=>Ox.isCached(e1))), i = Number(t.images.every((e1)=>Ox.isCached(e1)));
                                if (n || i) return n - i;
                            }
                            return Xx(e1.location, c.Location) - Xx(t.location, c.Location);
                        });
                        const d = Math.min(h, u.length);
                        for(let e1 = 0; e1 < d; e1++){
                            const { images: t, depths: n } = u[e1];
                            t.forEach((e1)=>Ox.cacheTexture(e1)), n.forEach((e1)=>Ox.cacheDepth(e1));
                        }
                    })(Bi.config.json, t.panoramaId);
                }), t.visible = !1, this.add(t), t;
            }
        };
        const aS = class extends Qp {
            constructor(){
                var e1, t, n;
                super({
                    preserveDrawingBuffer: !0,
                    antialias: !0,
                    alpha: !0
                }), e1 = this, n = void 0, (t = function(e1) {
                    var t = function(e1) {
                        if ("object" != typeof e1 || !e1) return e1;
                        var t = e1[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var n = t.call(e1, "string");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == typeof t ? t : t + "";
                }(t = "currentVrSession")) in e1 ? Object.defineProperty(e1, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e1[t] = n, this.toneMapping = Kr, this.toneMappingExposure = 1, this.setPixelRatio(window.devicePixelRatio), this.setClearColor(new Zc(0), 0), this.setClearAlpha(1), this.xr.setReferenceSpaceType("local"), this.xr.enabled = !0;
            }
            async checkVrSessionSupport() {
                try {
                    return await navigator.xr.isSessionSupported("immersive-vr");
                } catch (e1) {
                    return !1;
                }
            }
            async onSessionStarted(e1) {
                e1.addEventListener("end", this.onSessionEnded.bind(this)), await this.xr.setSession(e1), this.xr.setFoveation(0), this.currentVrSession = e1;
            }
            onSessionEnded() {
                this.currentVrSession.removeEventListener("end", this.onSessionEnded.bind(this)), this.currentVrSession = null;
            }
            async enterVR() {
                return await navigator.xr.requestSession("immersive-vr", {
                    optionalFeatures: [
                        "local-floor",
                        "bounded-floor",
                        "hand-tracking",
                        "layers"
                    ]
                }).then(this.onSessionStarted.bind(this));
            }
            async exitVR() {
                if (this.currentVrSession) return await this.xr.getSession().end();
            }
        };
        function sS(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const oS = class {
            constructor(e1, t){
                sS(this, "deviceOrientation", {}), sS(this, "screenOrientation", 0), sS(this, "alphaOffsetAngle", 0), sS(this, "connected", !1), sS(this, "enabled", !1), sS(this, "domElement", void 0), sS(this, "alpha", 0), sS(this, "tempX", 0), sS(this, "tempY", 0), sS(this, "rotY", 0), sS(this, "rotX", 0), sS(this, "camera", void 0), this.camera = e1, this.camera.rotation.reorder("YXZ"), this.domElement = t || document;
            }
            enable() {
                this.enabled = !0;
            }
            disable() {
                this.enabled = !1;
            }
            connect() {
                this.onScreenOrientationChange(), window.addEventListener("orientationchange", this.onScreenOrientationChange.bind(this)), window.addEventListener("deviceorientation", this.onDeviceOrientationChange.bind(this)), window.addEventListener("deviceorientation", this.update.bind(this)), this.domElement.addEventListener("touchstart", this.onTouchStart.bind(this)), this.domElement.addEventListener("touchmove", this.onTouchMove.bind(this)), this.connected = !0;
            }
            disconnect() {
                window.removeEventListener("orientationchange", this.onScreenOrientationChange.bind(this)), window.removeEventListener("deviceorientation", this.onDeviceOrientationChange.bind(this)), window.removeEventListener("deviceorientation", this.update.bind(this)), this.domElement.removeEventListener("touchstart", this.onTouchStart), this.domElement.removeEventListener("touchmove", this.onTouchMove), this.connected = !1;
            }
            onDeviceOrientationChange(e1) {
                this.deviceOrientation = e1;
            }
            onScreenOrientationChange() {
                this.screenOrientation = window.orientation || 0;
            }
            onTouchStart(e1) {
                e1.preventDefault(), e1.stopPropagation(), this.tempX = e1.touches[0].pageX, this.tempY = e1.touches[0].pageY;
            }
            onTouchMove(e1) {
                e1.preventDefault(), e1.stopPropagation(), this.rotY += Gx((e1.touches[0].pageX - this.tempX) / 4), this.rotX += Gx((this.tempY - e1.touches[0].pageY) / 4), this.updateAlphaOffsetAngle(this.rotY), this.tempX = e1.touches[0].pageX, this.tempY = e1.touches[0].pageY;
            }
            setCameraQuaternion(e1, t, n, i, r) {
                const a = new Cl(0, 0, 1), s = new Ac, o = new Dl, l = new Dl(-Math.sqrt(.5), 0, 0, Math.sqrt(.5)), c = new Dl, u = new Dl;
                let h = null;
                0 === this.screenOrientation ? (h = new Cl(1, 0, 0), c.setFromAxisAngle(h, -this.rotX)) : 180 === this.screenOrientation ? (h = new Cl(1, 0, 0), c.setFromAxisAngle(h, this.rotX)) : 90 === this.screenOrientation ? (h = new Cl(0, 1, 0), c.setFromAxisAngle(h, this.rotX)) : -90 === this.screenOrientation && (h = new Cl(0, 1, 0), c.setFromAxisAngle(h, -this.rotX)), l.multiply(c), l.multiply(u), s.set(n, t, -i, "YXZ"), e1.setFromEuler(s), e1.multiply(l), e1.multiply(o.setFromAxisAngle(a, -r));
            }
            updateAlphaOffsetAngle(e1) {
                this.alphaOffsetAngle = e1, this.update();
            }
            update() {
                if (!1 === this.enabled) return;
                const e1 = this.deviceOrientation.alpha ? Gx(this.deviceOrientation.alpha + 90) + this.alphaOffsetAngle : 0, t = this.deviceOrientation.beta ? Gx(this.deviceOrientation.beta) : 0, n = this.deviceOrientation.gamma ? Gx(this.deviceOrientation.gamma) : 0, i = this.screenOrientation ? Gx(this.screenOrientation) : 0;
                this.setCameraQuaternion(this.camera.quaternion, e1, t, n, i), this.alpha = e1;
            }
            dispose() {
                this.disconnect();
            }
        }, lS = Object.freeze({
            NONE: 0,
            ROTATE: 1,
            TRUCK: 2,
            OFFSET: 4,
            DOLLY: 8,
            ZOOM: 16,
            TOUCH_ROTATE: 32,
            TOUCH_TRUCK: 64,
            TOUCH_OFFSET: 128,
            TOUCH_DOLLY: 256,
            TOUCH_ZOOM: 512,
            TOUCH_DOLLY_TRUCK: 1024,
            TOUCH_DOLLY_OFFSET: 2048,
            TOUCH_DOLLY_ROTATE: 4096,
            TOUCH_ZOOM_TRUCK: 8192,
            TOUCH_ZOOM_OFFSET: 16384,
            TOUCH_ZOOM_ROTATE: 32768
        });
        function cS(e1) {
            return e1.isPerspectiveCamera;
        }
        function uS(e1) {
            return e1.isOrthographicCamera;
        }
        const hS = 2 * Math.PI, dS = Math.PI / 2, pS = 1e-5, fS = Math.PI / 180;
        function mS(e1, t, n) {
            return Math.max(t, Math.min(n, e1));
        }
        function gS(e1) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : pS;
            return Math.abs(e1) < t;
        }
        function AS(e1, t) {
            return gS(e1 - t, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : pS);
        }
        function vS(e1, t) {
            return Math.round(e1 / t) * t;
        }
        function MS(e1) {
            return isFinite(e1) ? e1 : e1 < 0 ? -Number.MAX_VALUE : Number.MAX_VALUE;
        }
        function yS(e1) {
            return Math.abs(e1) < Number.MAX_VALUE ? e1 : e1 * (1 / 0);
        }
        function xS(e1, t, n, i) {
            let r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1 / 0, a = arguments.length > 5 ? arguments[5] : void 0;
            const s = 2 / (i = Math.max(1e-4, i)), o = s * a, l = 1 / (1 + o + .48 * o * o + .235 * o * o * o);
            let c = e1 - t;
            const u = t, h = r * i;
            c = mS(c, -h, h), t = e1 - c;
            const d = (n.value + s * c) * a;
            n.value = (n.value - s * d) * l;
            let p = t + (c + d) * l;
            return u - e1 > 0 == p > u && (p = u, n.value = (p - u) / a), p;
        }
        function _S(e1, t, n, i) {
            let r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1 / 0, a = arguments.length > 5 ? arguments[5] : void 0, s = arguments.length > 6 ? arguments[6] : void 0;
            const o = 2 / (i = Math.max(1e-4, i)), l = o * a, c = 1 / (1 + l + .48 * l * l + .235 * l * l * l);
            let u = t.x, h = t.y, d = t.z, p = e1.x - u, f = e1.y - h, m = e1.z - d;
            const g = u, A = h, v = d, M = r * i, y = p * p + f * f + m * m;
            if (y > M * M) {
                const e1 = Math.sqrt(y);
                p = p / e1 * M, f = f / e1 * M, m = m / e1 * M;
            }
            u = e1.x - p, h = e1.y - f, d = e1.z - m;
            const x = (n.x + o * p) * a, _ = (n.y + o * f) * a, b = (n.z + o * m) * a;
            n.x = (n.x - o * x) * c, n.y = (n.y - o * _) * c, n.z = (n.z - o * b) * c, s.x = u + (p + x) * c, s.y = h + (f + _) * c, s.z = d + (m + b) * c;
            const w = g - e1.x, E = A - e1.y, T = v - e1.z;
            return w * (s.x - g) + E * (s.y - A) + T * (s.z - v) > 0 && (s.x = g, s.y = A, s.z = v, n.x = (s.x - g) / a, n.y = (s.y - A) / a, n.z = (s.z - v) / a), s;
        }
        function bS(e1, t) {
            t.set(0, 0), e1.forEach((e1)=>{
                t.x += e1.clientX, t.y += e1.clientY;
            }), t.x /= e1.length, t.y /= e1.length;
        }
        function wS(e1, t) {
            return !!uS(e1) && (console.warn("".concat(t, " is not supported in OrthographicCamera")), !0);
        }
        class ES {
            constructor(){
                this._listeners = {};
            }
            addEventListener(e1, t) {
                const n = this._listeners;
                void 0 === n[e1] && (n[e1] = []), -1 === n[e1].indexOf(t) && n[e1].push(t);
            }
            hasEventListener(e1, t) {
                const n = this._listeners;
                return void 0 !== n[e1] && -1 !== n[e1].indexOf(t);
            }
            removeEventListener(e1, t) {
                const n = this._listeners[e1];
                if (void 0 !== n) {
                    const e1 = n.indexOf(t);
                    -1 !== e1 && n.splice(e1, 1);
                }
            }
            removeAllEventListeners(e1) {
                e1 ? Array.isArray(this._listeners[e1]) && (this._listeners[e1].length = 0) : this._listeners = {};
            }
            dispatchEvent(e1) {
                const t = this._listeners[e1.type];
                if (void 0 !== t) {
                    e1.target = this;
                    const n = t.slice(0);
                    for(let t = 0, i = n.length; t < i; t++)n[t].call(this, e1);
                }
            }
        }
        var TS;
        const SS = 1 / 8, IS = /Mac/.test(null === (TS = null === globalThis || void 0 === globalThis ? void 0 : globalThis.navigator) || void 0 === TS ? void 0 : TS.platform);
        let NS, DS, CS, LS, RS, zS, OS, PS, US, kS, jS, BS, FS, HS, VS, GS, QS, WS, YS, XS, ZS, qS, KS;
        class JS extends ES {
            static install(e1) {
                NS = e1.THREE, DS = Object.freeze(new NS.Vector3(0, 0, 0)), CS = Object.freeze(new NS.Vector3(0, 1, 0)), LS = Object.freeze(new NS.Vector3(0, 0, 1)), RS = new NS.Vector2, zS = new NS.Vector3, OS = new NS.Vector3, PS = new NS.Vector3, US = new NS.Vector3, kS = new NS.Vector3, jS = new NS.Vector3, BS = new NS.Vector3, FS = new NS.Vector3, HS = new NS.Vector3, VS = new NS.Spherical, GS = new NS.Spherical, QS = new NS.Box3, WS = new NS.Box3, YS = new NS.Sphere, XS = new NS.Quaternion, ZS = new NS.Quaternion, qS = new NS.Matrix4, KS = new NS.Raycaster;
            }
            static get ACTION() {
                return lS;
            }
            constructor(e1, t){
                super(), this.minPolarAngle = 0, this.maxPolarAngle = Math.PI, this.minAzimuthAngle = -1 / 0, this.maxAzimuthAngle = 1 / 0, this.minDistance = Number.EPSILON, this.maxDistance = 1 / 0, this.infinityDolly = !1, this.minZoom = .01, this.maxZoom = 1 / 0, this.smoothTime = .25, this.draggingSmoothTime = .125, this.maxSpeed = 1 / 0, this.azimuthRotateSpeed = 1, this.polarRotateSpeed = 1, this.dollySpeed = 1, this.dollyDragInverted = !1, this.truckSpeed = 2, this.dollyToCursor = !1, this.dragToOffset = !1, this.verticalDragToForward = !1, this.boundaryFriction = 0, this.restThreshold = .01, this.colliderMeshes = [], this.cancel = ()=>{}, this._enabled = !0, this._state = lS.NONE, this._viewport = null, this._changedDolly = 0, this._changedZoom = 0, this._hasRested = !0, this._boundaryEnclosesCamera = !1, this._needsUpdate = !0, this._updatedLastTime = !1, this._elementRect = new DOMRect, this._isDragging = !1, this._dragNeedsUpdate = !0, this._activePointers = [], this._lockedPointer = null, this._interactiveArea = new DOMRect(0, 0, 1, 1), this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._isUserControllingOffset = !1, this._isUserControllingZoom = !1, this._lastDollyDirection = 0, this._thetaVelocity = {
                    value: 0
                }, this._phiVelocity = {
                    value: 0
                }, this._radiusVelocity = {
                    value: 0
                }, this._targetVelocity = new NS.Vector3, this._focalOffsetVelocity = new NS.Vector3, this._zoomVelocity = {
                    value: 0
                }, this._truckInternal = (e1, t, n)=>{
                    let i, r;
                    if (cS(this._camera)) {
                        const n = zS.copy(this._camera.position).sub(this._target), a = this._camera.getEffectiveFOV() * fS, s = n.length() * Math.tan(.5 * a);
                        i = this.truckSpeed * e1 * s / this._elementRect.height, r = this.truckSpeed * t * s / this._elementRect.height;
                    } else {
                        if (!uS(this._camera)) return;
                        {
                            const n = this._camera;
                            i = e1 * (n.right - n.left) / n.zoom / this._elementRect.width, r = t * (n.top - n.bottom) / n.zoom / this._elementRect.height;
                        }
                    }
                    this.verticalDragToForward ? (n ? this.setFocalOffset(this._focalOffsetEnd.x + i, this._focalOffsetEnd.y, this._focalOffsetEnd.z, !0) : this.truck(i, 0, !0), this.forward(-r, !0)) : n ? this.setFocalOffset(this._focalOffsetEnd.x + i, this._focalOffsetEnd.y + r, this._focalOffsetEnd.z, !0) : this.truck(i, r, !0);
                }, this._rotateInternal = (e1, t)=>{
                    const n = hS * this.azimuthRotateSpeed * e1 / this._elementRect.height, i = hS * this.polarRotateSpeed * t / this._elementRect.height;
                    this.rotate(n, i, !0);
                }, this._dollyInternal = (e1, t, n)=>{
                    const i = Math.pow(.95, -e1 * this.dollySpeed), r = this._sphericalEnd.radius, a = this._sphericalEnd.radius * i, s = mS(a, this.minDistance, this.maxDistance), o = s - a;
                    this.infinityDolly && this.dollyToCursor ? this._dollyToNoClamp(a, !0) : this.infinityDolly && !this.dollyToCursor ? (this.dollyInFixed(o, !0), this._dollyToNoClamp(s, !0)) : this._dollyToNoClamp(s, !0), this.dollyToCursor && (this._changedDolly += (this.infinityDolly ? a : s) - r, this._dollyControlCoord.set(t, n)), this._lastDollyDirection = Math.sign(-e1);
                }, this._zoomInternal = (e1, t, n)=>{
                    const i = Math.pow(.95, e1 * this.dollySpeed), r = this._zoom, a = this._zoom * i;
                    this.zoomTo(a, !0), this.dollyToCursor && (this._changedZoom += a - r, this._dollyControlCoord.set(t, n));
                }, void 0 === NS && console.error("camera-controls: `THREE` is undefined. You must first run `CameraControls.install( { THREE: THREE } )`. Check the docs for further information."), this._camera = e1, this._yAxisUpSpace = (new NS.Quaternion).setFromUnitVectors(this._camera.up, CS), this._yAxisUpSpaceInverse = this._yAxisUpSpace.clone().invert(), this._state = lS.NONE, this._target = new NS.Vector3, this._targetEnd = this._target.clone(), this._focalOffset = new NS.Vector3, this._focalOffsetEnd = this._focalOffset.clone(), this._spherical = (new NS.Spherical).setFromVector3(zS.copy(this._camera.position).applyQuaternion(this._yAxisUpSpace)), this._sphericalEnd = this._spherical.clone(), this._lastDistance = this._spherical.radius, this._zoom = this._camera.zoom, this._zoomEnd = this._zoom, this._lastZoom = this._zoom, this._nearPlaneCorners = [
                    new NS.Vector3,
                    new NS.Vector3,
                    new NS.Vector3,
                    new NS.Vector3
                ], this._updateNearPlaneCorners(), this._boundary = new NS.Box3(new NS.Vector3(-1 / 0, -1 / 0, -1 / 0), new NS.Vector3(1 / 0, 1 / 0, 1 / 0)), this._cameraUp0 = this._camera.up.clone(), this._target0 = this._target.clone(), this._position0 = this._camera.position.clone(), this._zoom0 = this._zoom, this._focalOffset0 = this._focalOffset.clone(), this._dollyControlCoord = new NS.Vector2, this.mouseButtons = {
                    left: lS.ROTATE,
                    middle: lS.DOLLY,
                    right: lS.TRUCK,
                    wheel: cS(this._camera) ? lS.DOLLY : uS(this._camera) ? lS.ZOOM : lS.NONE
                }, this.touches = {
                    one: lS.TOUCH_ROTATE,
                    two: cS(this._camera) ? lS.TOUCH_DOLLY_TRUCK : uS(this._camera) ? lS.TOUCH_ZOOM_TRUCK : lS.NONE,
                    three: lS.TOUCH_TRUCK
                };
                const n = new NS.Vector2, i = new NS.Vector2, r = new NS.Vector2, a = (e1)=>{
                    if (!this._enabled || !this._domElement) return;
                    if (0 !== this._interactiveArea.left || 0 !== this._interactiveArea.top || 1 !== this._interactiveArea.width || 1 !== this._interactiveArea.height) {
                        const t = this._domElement.getBoundingClientRect(), n = e1.clientX / t.width, i = e1.clientY / t.height;
                        if (n < this._interactiveArea.left || n > this._interactiveArea.right || i < this._interactiveArea.top || i > this._interactiveArea.bottom) return;
                    }
                    const t = "mouse" !== e1.pointerType ? null : 1 & ~e1.buttons ? 4 & ~e1.buttons ? 2 & ~e1.buttons ? null : 2 : 4 : 1;
                    if (null !== t) {
                        const e1 = this._findPointerByMouseButton(t);
                        e1 && this._disposePointer(e1);
                    }
                    if (!(1 & ~e1.buttons) && this._lockedPointer) return;
                    const n = {
                        pointerId: e1.pointerId,
                        clientX: e1.clientX,
                        clientY: e1.clientY,
                        deltaX: 0,
                        deltaY: 0,
                        mouseButton: t
                    };
                    this._activePointers.push(n), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.ownerDocument.addEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.addEventListener("pointerup", o), this._isDragging = !0, h(e1);
                }, s = (e1)=>{
                    e1.cancelable && e1.preventDefault();
                    const t = e1.pointerId, n = this._lockedPointer || this._findPointerById(t);
                    if (n) {
                        if (n.clientX = e1.clientX, n.clientY = e1.clientY, n.deltaX = e1.movementX, n.deltaY = e1.movementY, this._state = 0, "touch" === e1.pointerType) switch(this._activePointers.length){
                            case 1:
                                this._state = this.touches.one;
                                break;
                            case 2:
                                this._state = this.touches.two;
                                break;
                            case 3:
                                this._state = this.touches.three;
                        }
                        else (!this._isDragging && this._lockedPointer || this._isDragging && !(1 & ~e1.buttons)) && (this._state = this._state | this.mouseButtons.left), this._isDragging && !(4 & ~e1.buttons) && (this._state = this._state | this.mouseButtons.middle), this._isDragging && !(2 & ~e1.buttons) && (this._state = this._state | this.mouseButtons.right);
                        d();
                    }
                }, o = (e1)=>{
                    const t = this._findPointerById(e1.pointerId);
                    if (!t || t !== this._lockedPointer) {
                        if (t && this._disposePointer(t), "touch" === e1.pointerType) switch(this._activePointers.length){
                            case 0:
                                this._state = lS.NONE;
                                break;
                            case 1:
                                this._state = this.touches.one;
                                break;
                            case 2:
                                this._state = this.touches.two;
                                break;
                            case 3:
                                this._state = this.touches.three;
                        }
                        else this._state = lS.NONE;
                        p();
                    }
                };
                let l = -1;
                const c = (e1)=>{
                    if (!this._domElement) return;
                    if (!this._enabled || this.mouseButtons.wheel === lS.NONE) return;
                    if (0 !== this._interactiveArea.left || 0 !== this._interactiveArea.top || 1 !== this._interactiveArea.width || 1 !== this._interactiveArea.height) {
                        const t = this._domElement.getBoundingClientRect(), n = e1.clientX / t.width, i = e1.clientY / t.height;
                        if (n < this._interactiveArea.left || n > this._interactiveArea.right || i < this._interactiveArea.top || i > this._interactiveArea.bottom) return;
                    }
                    if (e1.preventDefault(), this.dollyToCursor || this.mouseButtons.wheel === lS.ROTATE || this.mouseButtons.wheel === lS.TRUCK) {
                        const e1 = performance.now();
                        l - e1 < 1e3 && this._getClientRect(this._elementRect), l = e1;
                    }
                    const t = IS ? -1 : -3, n = 1 === e1.deltaMode ? e1.deltaY / t : e1.deltaY / (10 * t), i = this.dollyToCursor ? (e1.clientX - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, r = this.dollyToCursor ? (e1.clientY - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                    switch(this.mouseButtons.wheel){
                        case lS.ROTATE:
                            this._rotateInternal(e1.deltaX, e1.deltaY), this._isUserControllingRotate = !0;
                            break;
                        case lS.TRUCK:
                            this._truckInternal(e1.deltaX, e1.deltaY, !1), this._isUserControllingTruck = !0;
                            break;
                        case lS.OFFSET:
                            this._truckInternal(e1.deltaX, e1.deltaY, !0), this._isUserControllingOffset = !0;
                            break;
                        case lS.DOLLY:
                            this._dollyInternal(-n, i, r), this._isUserControllingDolly = !0;
                            break;
                        case lS.ZOOM:
                            this._zoomInternal(-n, i, r), this._isUserControllingZoom = !0;
                    }
                    this.dispatchEvent({
                        type: "control"
                    });
                }, u = (e1)=>{
                    if (this._domElement && this._enabled) {
                        if (this.mouseButtons.right === JS.ACTION.NONE) {
                            const t = e1 instanceof PointerEvent ? e1.pointerId : 0, n = this._findPointerById(t);
                            return n && this._disposePointer(n), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                                passive: !1
                            }), void this._domElement.ownerDocument.removeEventListener("pointerup", o);
                        }
                        e1.preventDefault();
                    }
                }, h = (e1)=>{
                    if (this._enabled) {
                        if (bS(this._activePointers, RS), this._getClientRect(this._elementRect), n.copy(RS), i.copy(RS), this._activePointers.length >= 2) {
                            const e1 = RS.x - this._activePointers[1].clientX, t = RS.y - this._activePointers[1].clientY, n = Math.sqrt(e1 * e1 + t * t);
                            r.set(0, n);
                            const a = .5 * (this._activePointers[0].clientX + this._activePointers[1].clientX), s = .5 * (this._activePointers[0].clientY + this._activePointers[1].clientY);
                            i.set(a, s);
                        }
                        if (this._state = 0, e1) {
                            if ("pointerType" in e1 && "touch" === e1.pointerType) switch(this._activePointers.length){
                                case 1:
                                    this._state = this.touches.one;
                                    break;
                                case 2:
                                    this._state = this.touches.two;
                                    break;
                                case 3:
                                    this._state = this.touches.three;
                            }
                            else this._lockedPointer || !!(1 & ~e1.buttons) || (this._state = this._state | this.mouseButtons.left), !(4 & ~e1.buttons) && (this._state = this._state | this.mouseButtons.middle), !(2 & ~e1.buttons) && (this._state = this._state | this.mouseButtons.right);
                        } else this._lockedPointer && (this._state = this._state | this.mouseButtons.left);
                        (this._state & lS.ROTATE) !== lS.ROTATE && (this._state & lS.TOUCH_ROTATE) !== lS.TOUCH_ROTATE && (this._state & lS.TOUCH_DOLLY_ROTATE) !== lS.TOUCH_DOLLY_ROTATE && (this._state & lS.TOUCH_ZOOM_ROTATE) !== lS.TOUCH_ZOOM_ROTATE || (this._sphericalEnd.theta = this._spherical.theta, this._sphericalEnd.phi = this._spherical.phi, this._thetaVelocity.value = 0, this._phiVelocity.value = 0), (this._state & lS.TRUCK) !== lS.TRUCK && (this._state & lS.TOUCH_TRUCK) !== lS.TOUCH_TRUCK && (this._state & lS.TOUCH_DOLLY_TRUCK) !== lS.TOUCH_DOLLY_TRUCK && (this._state & lS.TOUCH_ZOOM_TRUCK) !== lS.TOUCH_ZOOM_TRUCK || (this._targetEnd.copy(this._target), this._targetVelocity.set(0, 0, 0)), (this._state & lS.DOLLY) !== lS.DOLLY && (this._state & lS.TOUCH_DOLLY) !== lS.TOUCH_DOLLY && (this._state & lS.TOUCH_DOLLY_TRUCK) !== lS.TOUCH_DOLLY_TRUCK && (this._state & lS.TOUCH_DOLLY_OFFSET) !== lS.TOUCH_DOLLY_OFFSET && (this._state & lS.TOUCH_DOLLY_ROTATE) !== lS.TOUCH_DOLLY_ROTATE || (this._sphericalEnd.radius = this._spherical.radius, this._radiusVelocity.value = 0), (this._state & lS.ZOOM) !== lS.ZOOM && (this._state & lS.TOUCH_ZOOM) !== lS.TOUCH_ZOOM && (this._state & lS.TOUCH_ZOOM_TRUCK) !== lS.TOUCH_ZOOM_TRUCK && (this._state & lS.TOUCH_ZOOM_OFFSET) !== lS.TOUCH_ZOOM_OFFSET && (this._state & lS.TOUCH_ZOOM_ROTATE) !== lS.TOUCH_ZOOM_ROTATE || (this._zoomEnd = this._zoom, this._zoomVelocity.value = 0), (this._state & lS.OFFSET) !== lS.OFFSET && (this._state & lS.TOUCH_OFFSET) !== lS.TOUCH_OFFSET && (this._state & lS.TOUCH_DOLLY_OFFSET) !== lS.TOUCH_DOLLY_OFFSET && (this._state & lS.TOUCH_ZOOM_OFFSET) !== lS.TOUCH_ZOOM_OFFSET || (this._focalOffsetEnd.copy(this._focalOffset), this._focalOffsetVelocity.set(0, 0, 0)), this.dispatchEvent({
                            type: "controlstart"
                        });
                    }
                }, d = ()=>{
                    if (!this._enabled || !this._dragNeedsUpdate) return;
                    this._dragNeedsUpdate = !1, bS(this._activePointers, RS);
                    const e1 = this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement ? this._lockedPointer || this._activePointers[0] : null, t = e1 ? -e1.deltaX : i.x - RS.x, a = e1 ? -e1.deltaY : i.y - RS.y;
                    if (i.copy(RS), (this._state & lS.ROTATE) !== lS.ROTATE && (this._state & lS.TOUCH_ROTATE) !== lS.TOUCH_ROTATE && (this._state & lS.TOUCH_DOLLY_ROTATE) !== lS.TOUCH_DOLLY_ROTATE && (this._state & lS.TOUCH_ZOOM_ROTATE) !== lS.TOUCH_ZOOM_ROTATE || (this._rotateInternal(t, a), this._isUserControllingRotate = !0), (this._state & lS.DOLLY) === lS.DOLLY || (this._state & lS.ZOOM) === lS.ZOOM) {
                        const e1 = this.dollyToCursor ? (n.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, t = this.dollyToCursor ? (n.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0, i = this.dollyDragInverted ? -1 : 1;
                        (this._state & lS.DOLLY) === lS.DOLLY ? (this._dollyInternal(i * a * SS, e1, t), this._isUserControllingDolly = !0) : (this._zoomInternal(i * a * SS, e1, t), this._isUserControllingZoom = !0);
                    }
                    if ((this._state & lS.TOUCH_DOLLY) === lS.TOUCH_DOLLY || (this._state & lS.TOUCH_ZOOM) === lS.TOUCH_ZOOM || (this._state & lS.TOUCH_DOLLY_TRUCK) === lS.TOUCH_DOLLY_TRUCK || (this._state & lS.TOUCH_ZOOM_TRUCK) === lS.TOUCH_ZOOM_TRUCK || (this._state & lS.TOUCH_DOLLY_OFFSET) === lS.TOUCH_DOLLY_OFFSET || (this._state & lS.TOUCH_ZOOM_OFFSET) === lS.TOUCH_ZOOM_OFFSET || (this._state & lS.TOUCH_DOLLY_ROTATE) === lS.TOUCH_DOLLY_ROTATE || (this._state & lS.TOUCH_ZOOM_ROTATE) === lS.TOUCH_ZOOM_ROTATE) {
                        const e1 = RS.x - this._activePointers[1].clientX, t = RS.y - this._activePointers[1].clientY, n = Math.sqrt(e1 * e1 + t * t), a = r.y - n;
                        r.set(0, n);
                        const s = this.dollyToCursor ? (i.x - this._elementRect.x) / this._elementRect.width * 2 - 1 : 0, o = this.dollyToCursor ? (i.y - this._elementRect.y) / this._elementRect.height * -2 + 1 : 0;
                        (this._state & lS.TOUCH_DOLLY) === lS.TOUCH_DOLLY || (this._state & lS.TOUCH_DOLLY_ROTATE) === lS.TOUCH_DOLLY_ROTATE || (this._state & lS.TOUCH_DOLLY_TRUCK) === lS.TOUCH_DOLLY_TRUCK || (this._state & lS.TOUCH_DOLLY_OFFSET) === lS.TOUCH_DOLLY_OFFSET ? (this._dollyInternal(a * SS, s, o), this._isUserControllingDolly = !0) : (this._zoomInternal(a * SS, s, o), this._isUserControllingZoom = !0);
                    }
                    (this._state & lS.TRUCK) !== lS.TRUCK && (this._state & lS.TOUCH_TRUCK) !== lS.TOUCH_TRUCK && (this._state & lS.TOUCH_DOLLY_TRUCK) !== lS.TOUCH_DOLLY_TRUCK && (this._state & lS.TOUCH_ZOOM_TRUCK) !== lS.TOUCH_ZOOM_TRUCK || (this._truckInternal(t, a, !1), this._isUserControllingTruck = !0), (this._state & lS.OFFSET) !== lS.OFFSET && (this._state & lS.TOUCH_OFFSET) !== lS.TOUCH_OFFSET && (this._state & lS.TOUCH_DOLLY_OFFSET) !== lS.TOUCH_DOLLY_OFFSET && (this._state & lS.TOUCH_ZOOM_OFFSET) !== lS.TOUCH_ZOOM_OFFSET || (this._truckInternal(t, a, !0), this._isUserControllingOffset = !0), this.dispatchEvent({
                        type: "control"
                    });
                }, p = ()=>{
                    bS(this._activePointers, RS), i.copy(RS), this._dragNeedsUpdate = !1, (0 === this._activePointers.length || 1 === this._activePointers.length && this._activePointers[0] === this._lockedPointer) && (this._isDragging = !1), 0 === this._activePointers.length && this._domElement && (this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this.dispatchEvent({
                        type: "controlend"
                    }));
                };
                this.lockPointer = ()=>{
                    this._enabled && this._domElement && (this.cancel(), this._lockedPointer = {
                        pointerId: -1,
                        clientX: 0,
                        clientY: 0,
                        deltaX: 0,
                        deltaY: 0,
                        mouseButton: null
                    }, this._activePointers.push(this._lockedPointer), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.requestPointerLock(), this._domElement.ownerDocument.addEventListener("pointerlockchange", f), this._domElement.ownerDocument.addEventListener("pointerlockerror", m), this._domElement.ownerDocument.addEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.addEventListener("pointerup", o), h());
                }, this.unlockPointer = ()=>{
                    var e1, t, n;
                    null !== this._lockedPointer && (this._disposePointer(this._lockedPointer), this._lockedPointer = null), null === (e1 = this._domElement) || void 0 === e1 || e1.ownerDocument.exitPointerLock(), null === (t = this._domElement) || void 0 === t || t.ownerDocument.removeEventListener("pointerlockchange", f), null === (n = this._domElement) || void 0 === n || n.ownerDocument.removeEventListener("pointerlockerror", m), this.cancel();
                };
                const f = ()=>{
                    this._domElement && this._domElement.ownerDocument.pointerLockElement === this._domElement || this.unlockPointer();
                }, m = ()=>{
                    this.unlockPointer();
                };
                this._addAllEventListeners = (e1)=>{
                    this._domElement = e1, this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none", this._domElement.addEventListener("pointerdown", a), this._domElement.addEventListener("pointercancel", o), this._domElement.addEventListener("wheel", c, {
                        passive: !1
                    }), this._domElement.addEventListener("contextmenu", u);
                }, this._removeAllEventListeners = ()=>{
                    this._domElement && (this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = "", this._domElement.removeEventListener("pointerdown", a), this._domElement.removeEventListener("pointercancel", o), this._domElement.removeEventListener("wheel", c, {
                        passive: !1
                    }), this._domElement.removeEventListener("contextmenu", u), this._domElement.ownerDocument.removeEventListener("pointermove", s, {
                        passive: !1
                    }), this._domElement.ownerDocument.removeEventListener("pointerup", o), this._domElement.ownerDocument.removeEventListener("pointerlockchange", f), this._domElement.ownerDocument.removeEventListener("pointerlockerror", m));
                }, this.cancel = ()=>{
                    this._state !== lS.NONE && (this._state = lS.NONE, this._activePointers.length = 0, p());
                }, t && this.connect(t), this.update(0);
            }
            get camera() {
                return this._camera;
            }
            set camera(e1) {
                this._camera = e1, this.updateCameraUp(), this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0;
            }
            get enabled() {
                return this._enabled;
            }
            set enabled(e1) {
                this._enabled = e1, this._domElement && (e1 ? (this._domElement.style.touchAction = "none", this._domElement.style.userSelect = "none", this._domElement.style.webkitUserSelect = "none") : (this.cancel(), this._domElement.style.touchAction = "", this._domElement.style.userSelect = "", this._domElement.style.webkitUserSelect = ""));
            }
            get active() {
                return !this._hasRested;
            }
            get currentAction() {
                return this._state;
            }
            get distance() {
                return this._spherical.radius;
            }
            set distance(e1) {
                this._spherical.radius === e1 && this._sphericalEnd.radius === e1 || (this._spherical.radius = e1, this._sphericalEnd.radius = e1, this._needsUpdate = !0);
            }
            get azimuthAngle() {
                return this._spherical.theta;
            }
            set azimuthAngle(e1) {
                this._spherical.theta === e1 && this._sphericalEnd.theta === e1 || (this._spherical.theta = e1, this._sphericalEnd.theta = e1, this._needsUpdate = !0);
            }
            get polarAngle() {
                return this._spherical.phi;
            }
            set polarAngle(e1) {
                this._spherical.phi === e1 && this._sphericalEnd.phi === e1 || (this._spherical.phi = e1, this._sphericalEnd.phi = e1, this._needsUpdate = !0);
            }
            get boundaryEnclosesCamera() {
                return this._boundaryEnclosesCamera;
            }
            set boundaryEnclosesCamera(e1) {
                this._boundaryEnclosesCamera = e1, this._needsUpdate = !0;
            }
            set interactiveArea(e1) {
                this._interactiveArea.width = mS(e1.width, 0, 1), this._interactiveArea.height = mS(e1.height, 0, 1), this._interactiveArea.x = mS(e1.x, 0, 1 - this._interactiveArea.width), this._interactiveArea.y = mS(e1.y, 0, 1 - this._interactiveArea.height);
            }
            addEventListener(e1, t) {
                super.addEventListener(e1, t);
            }
            removeEventListener(e1, t) {
                super.removeEventListener(e1, t);
            }
            rotate(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return this.rotateTo(this._sphericalEnd.theta + e1, this._sphericalEnd.phi + t, n);
            }
            rotateAzimuthTo(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.rotateTo(e1, this._sphericalEnd.phi, t);
            }
            rotatePolarTo(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.rotateTo(this._sphericalEnd.theta, e1, t);
            }
            rotateTo(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                this._isUserControllingRotate = !1;
                const i = mS(e1, this.minAzimuthAngle, this.maxAzimuthAngle), r = mS(t, this.minPolarAngle, this.maxPolarAngle);
                this._sphericalEnd.theta = i, this._sphericalEnd.phi = r, this._sphericalEnd.makeSafe(), this._needsUpdate = !0, n || (this._spherical.theta = this._sphericalEnd.theta, this._spherical.phi = this._sphericalEnd.phi);
                const a = !n || AS(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && AS(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold);
                return this._createOnRestPromise(a);
            }
            dolly(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.dollyTo(this._sphericalEnd.radius - e1, t);
            }
            dollyTo(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this._isUserControllingDolly = !1, this._lastDollyDirection = 0, this._changedDolly = 0, this._dollyToNoClamp(mS(e1, this.minDistance, this.maxDistance), t);
            }
            _dollyToNoClamp(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                const n = this._sphericalEnd.radius;
                if (this.colliderMeshes.length >= 1) {
                    const t = this._collisionTest(), i = AS(t, this._spherical.radius);
                    if (!(n > e1) && i) return Promise.resolve();
                    this._sphericalEnd.radius = Math.min(e1, t);
                } else this._sphericalEnd.radius = e1;
                this._needsUpdate = !0, t || (this._spherical.radius = this._sphericalEnd.radius);
                const i = !t || AS(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(i);
            }
            dollyInFixed(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this._targetEnd.add(this._getCameraDirection(US).multiplyScalar(e1)), t || this._target.copy(this._targetEnd);
                const n = !t || AS(this._target.x, this._targetEnd.x, this.restThreshold) && AS(this._target.y, this._targetEnd.y, this.restThreshold) && AS(this._target.z, this._targetEnd.z, this.restThreshold);
                return this._createOnRestPromise(n);
            }
            zoom(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return this.zoomTo(this._zoomEnd + e1, t);
            }
            zoomTo(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                this._isUserControllingZoom = !1, this._zoomEnd = mS(e1, this.minZoom, this.maxZoom), this._needsUpdate = !0, t || (this._zoom = this._zoomEnd);
                const n = !t || AS(this._zoom, this._zoomEnd, this.restThreshold);
                return this._changedZoom = 0, this._createOnRestPromise(n);
            }
            pan(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return console.warn("`pan` has been renamed to `truck`"), this.truck(e1, t, n);
            }
            truck(e1, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                this._camera.updateMatrix(), kS.setFromMatrixColumn(this._camera.matrix, 0), jS.setFromMatrixColumn(this._camera.matrix, 1), kS.multiplyScalar(e1), jS.multiplyScalar(-t);
                const i = zS.copy(kS).add(jS), r = OS.copy(this._targetEnd).add(i);
                return this.moveTo(r.x, r.y, r.z, n);
            }
            forward(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                zS.setFromMatrixColumn(this._camera.matrix, 0), zS.crossVectors(this._camera.up, zS), zS.multiplyScalar(e1);
                const n = OS.copy(this._targetEnd).add(zS);
                return this.moveTo(n.x, n.y, n.z, t);
            }
            elevate(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                return zS.copy(this._camera.up).multiplyScalar(e1), this.moveTo(this._targetEnd.x + zS.x, this._targetEnd.y + zS.y, this._targetEnd.z + zS.z, t);
            }
            moveTo(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                this._isUserControllingTruck = !1;
                const r = zS.set(e1, t, n).sub(this._targetEnd);
                this._encloseToBoundary(this._targetEnd, r, this.boundaryFriction), this._needsUpdate = !0, i || this._target.copy(this._targetEnd);
                const a = !i || AS(this._target.x, this._targetEnd.x, this.restThreshold) && AS(this._target.y, this._targetEnd.y, this.restThreshold) && AS(this._target.z, this._targetEnd.z, this.restThreshold);
                return this._createOnRestPromise(a);
            }
            lookInDirectionOf(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                const r = zS.set(e1, t, n).sub(this._targetEnd).normalize().multiplyScalar(-this._sphericalEnd.radius).add(this._targetEnd);
                return this.setPosition(r.x, r.y, r.z, i);
            }
            fitToBox(e1, t) {
                let { cover: n = !1, paddingLeft: i = 0, paddingRight: r = 0, paddingBottom: a = 0, paddingTop: s = 0 } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                const o = [], l = e1.isBox3 ? QS.copy(e1) : QS.setFromObject(e1);
                l.isEmpty() && (console.warn("camera-controls: fitTo() cannot be used with an empty box. Aborting"), Promise.resolve());
                const c = vS(this._sphericalEnd.theta, dS), u = vS(this._sphericalEnd.phi, dS);
                o.push(this.rotateTo(c, u, t));
                const h = zS.setFromSpherical(this._sphericalEnd).normalize(), d = XS.setFromUnitVectors(h, LS), p = AS(Math.abs(h.y), 1);
                p && d.multiply(ZS.setFromAxisAngle(CS, c)), d.multiply(this._yAxisUpSpaceInverse);
                const f = WS.makeEmpty();
                OS.copy(l.min).applyQuaternion(d), f.expandByPoint(OS), OS.copy(l.min).setX(l.max.x).applyQuaternion(d), f.expandByPoint(OS), OS.copy(l.min).setY(l.max.y).applyQuaternion(d), f.expandByPoint(OS), OS.copy(l.max).setZ(l.min.z).applyQuaternion(d), f.expandByPoint(OS), OS.copy(l.min).setZ(l.max.z).applyQuaternion(d), f.expandByPoint(OS), OS.copy(l.max).setY(l.min.y).applyQuaternion(d), f.expandByPoint(OS), OS.copy(l.max).setX(l.min.x).applyQuaternion(d), f.expandByPoint(OS), OS.copy(l.max).applyQuaternion(d), f.expandByPoint(OS), f.min.x -= i, f.min.y -= a, f.max.x += r, f.max.y += s, d.setFromUnitVectors(LS, h), p && d.premultiply(ZS.invert()), d.premultiply(this._yAxisUpSpace);
                const m = f.getSize(zS), g = f.getCenter(OS).applyQuaternion(d);
                if (cS(this._camera)) {
                    const e1 = this.getDistanceToFitBox(m.x, m.y, m.z, n);
                    o.push(this.moveTo(g.x, g.y, g.z, t)), o.push(this.dollyTo(e1, t)), o.push(this.setFocalOffset(0, 0, 0, t));
                } else if (uS(this._camera)) {
                    const e1 = this._camera, i = e1.right - e1.left, r = e1.top - e1.bottom, a = n ? Math.max(i / m.x, r / m.y) : Math.min(i / m.x, r / m.y);
                    o.push(this.moveTo(g.x, g.y, g.z, t)), o.push(this.zoomTo(a, t)), o.push(this.setFocalOffset(0, 0, 0, t));
                }
                return Promise.all(o);
            }
            fitToSphere(e1, t) {
                const n = [], i = "isObject3D" in e1 ? JS.createBoundingSphere(e1, YS) : YS.copy(e1);
                if (n.push(this.moveTo(i.center.x, i.center.y, i.center.z, t)), cS(this._camera)) {
                    const e1 = this.getDistanceToFitSphere(i.radius);
                    n.push(this.dollyTo(e1, t));
                } else if (uS(this._camera)) {
                    const e1 = this._camera.right - this._camera.left, r = this._camera.top - this._camera.bottom, a = 2 * i.radius, s = Math.min(e1 / a, r / a);
                    n.push(this.zoomTo(s, t));
                }
                return n.push(this.setFocalOffset(0, 0, 0, t)), Promise.all(n);
            }
            setLookAt(e1, t, n, i, r, a) {
                let s = arguments.length > 6 && void 0 !== arguments[6] && arguments[6];
                this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = 0, this._changedDolly = 0;
                const o = OS.set(i, r, a), l = zS.set(e1, t, n);
                this._targetEnd.copy(o), this._sphericalEnd.setFromVector3(l.sub(o).applyQuaternion(this._yAxisUpSpace)), this.normalizeRotations(), this._needsUpdate = !0, s || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
                const c = !s || AS(this._target.x, this._targetEnd.x, this.restThreshold) && AS(this._target.y, this._targetEnd.y, this.restThreshold) && AS(this._target.z, this._targetEnd.z, this.restThreshold) && AS(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && AS(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && AS(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(c);
            }
            lerpLookAt(e1, t, n, i, r, a, s, o, l, c, u, h, d) {
                let p = arguments.length > 13 && void 0 !== arguments[13] && arguments[13];
                this._isUserControllingRotate = !1, this._isUserControllingDolly = !1, this._isUserControllingTruck = !1, this._lastDollyDirection = 0, this._changedDolly = 0;
                const f = zS.set(i, r, a), m = OS.set(e1, t, n);
                VS.setFromVector3(m.sub(f).applyQuaternion(this._yAxisUpSpace));
                const g = PS.set(c, u, h), A = OS.set(s, o, l);
                GS.setFromVector3(A.sub(g).applyQuaternion(this._yAxisUpSpace)), this._targetEnd.copy(f.lerp(g, d));
                const v = GS.theta - VS.theta, M = GS.phi - VS.phi, y = GS.radius - VS.radius;
                this._sphericalEnd.set(VS.radius + y * d, VS.phi + M * d, VS.theta + v * d), this.normalizeRotations(), this._needsUpdate = !0, p || (this._target.copy(this._targetEnd), this._spherical.copy(this._sphericalEnd));
                const x = !p || AS(this._target.x, this._targetEnd.x, this.restThreshold) && AS(this._target.y, this._targetEnd.y, this.restThreshold) && AS(this._target.z, this._targetEnd.z, this.restThreshold) && AS(this._spherical.theta, this._sphericalEnd.theta, this.restThreshold) && AS(this._spherical.phi, this._sphericalEnd.phi, this.restThreshold) && AS(this._spherical.radius, this._sphericalEnd.radius, this.restThreshold);
                return this._createOnRestPromise(x);
            }
            setPosition(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                return this.setLookAt(e1, t, n, this._targetEnd.x, this._targetEnd.y, this._targetEnd.z, i);
            }
            setTarget(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                const r = this.getPosition(zS), a = this.setLookAt(r.x, r.y, r.z, e1, t, n, i);
                return this._sphericalEnd.phi = mS(this._sphericalEnd.phi, this.minPolarAngle, this.maxPolarAngle), a;
            }
            setFocalOffset(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                this._isUserControllingOffset = !1, this._focalOffsetEnd.set(e1, t, n), this._needsUpdate = !0, i || this._focalOffset.copy(this._focalOffsetEnd);
                const r = !i || AS(this._focalOffset.x, this._focalOffsetEnd.x, this.restThreshold) && AS(this._focalOffset.y, this._focalOffsetEnd.y, this.restThreshold) && AS(this._focalOffset.z, this._focalOffsetEnd.z, this.restThreshold);
                return this._createOnRestPromise(r);
            }
            setOrbitPoint(e1, t, n) {
                this._camera.updateMatrixWorld(), kS.setFromMatrixColumn(this._camera.matrixWorldInverse, 0), jS.setFromMatrixColumn(this._camera.matrixWorldInverse, 1), BS.setFromMatrixColumn(this._camera.matrixWorldInverse, 2);
                const i = zS.set(e1, t, n), r = i.distanceTo(this._camera.position), a = i.sub(this._camera.position);
                kS.multiplyScalar(a.x), jS.multiplyScalar(a.y), BS.multiplyScalar(a.z), zS.copy(kS).add(jS).add(BS), zS.z = zS.z + r, this.dollyTo(r, !1), this.setFocalOffset(-zS.x, zS.y, -zS.z, !1), this.moveTo(e1, t, n, !1);
            }
            setBoundary(e1) {
                if (!e1) return this._boundary.min.set(-1 / 0, -1 / 0, -1 / 0), this._boundary.max.set(1 / 0, 1 / 0, 1 / 0), void (this._needsUpdate = !0);
                this._boundary.copy(e1), this._boundary.clampPoint(this._targetEnd, this._targetEnd), this._needsUpdate = !0;
            }
            setViewport(e1, t, n, i) {
                null !== e1 ? (this._viewport = this._viewport || new NS.Vector4, "number" == typeof e1 ? this._viewport.set(e1, t, n, i) : this._viewport.copy(e1)) : this._viewport = null;
            }
            getDistanceToFitBox(e1, t, n) {
                let i = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                if (wS(this._camera, "getDistanceToFitBox")) return this._spherical.radius;
                const r = e1 / t, a = this._camera.getEffectiveFOV() * fS, s = this._camera.aspect;
                return .5 * ((i ? r > s : r < s) ? t : e1 / s) / Math.tan(.5 * a) + .5 * n;
            }
            getDistanceToFitSphere(e1) {
                if (wS(this._camera, "getDistanceToFitSphere")) return this._spherical.radius;
                const t = this._camera.getEffectiveFOV() * fS, n = 2 * Math.atan(Math.tan(.5 * t) * this._camera.aspect), i = 1 < this._camera.aspect ? t : n;
                return e1 / Math.sin(.5 * i);
            }
            getTarget(e1) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return (e1 && e1.isVector3 ? e1 : new NS.Vector3).copy(t ? this._targetEnd : this._target);
            }
            getPosition(e1) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return (e1 && e1.isVector3 ? e1 : new NS.Vector3).setFromSpherical(t ? this._sphericalEnd : this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(t ? this._targetEnd : this._target);
            }
            getSpherical(e1) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return (e1 || new NS.Spherical).copy(t ? this._sphericalEnd : this._spherical);
            }
            getFocalOffset(e1) {
                let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                return (e1 && e1.isVector3 ? e1 : new NS.Vector3).copy(t ? this._focalOffsetEnd : this._focalOffset);
            }
            normalizeRotations() {
                this._sphericalEnd.theta = this._sphericalEnd.theta % hS, this._sphericalEnd.theta < 0 && (this._sphericalEnd.theta += hS), this._spherical.theta += hS * Math.round((this._sphericalEnd.theta - this._spherical.theta) / hS);
            }
            reset() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (!AS(this._camera.up.x, this._cameraUp0.x) || !AS(this._camera.up.y, this._cameraUp0.y) || !AS(this._camera.up.z, this._cameraUp0.z)) {
                    this._camera.up.copy(this._cameraUp0);
                    const e1 = this.getPosition(zS);
                    this.updateCameraUp(), this.setPosition(e1.x, e1.y, e1.z);
                }
                const t = [
                    this.setLookAt(this._position0.x, this._position0.y, this._position0.z, this._target0.x, this._target0.y, this._target0.z, e1),
                    this.setFocalOffset(this._focalOffset0.x, this._focalOffset0.y, this._focalOffset0.z, e1),
                    this.zoomTo(this._zoom0, e1)
                ];
                return Promise.all(t);
            }
            saveState() {
                this._cameraUp0.copy(this._camera.up), this.getTarget(this._target0), this.getPosition(this._position0), this._zoom0 = this._zoom, this._focalOffset0.copy(this._focalOffset);
            }
            updateCameraUp() {
                this._yAxisUpSpace.setFromUnitVectors(this._camera.up, CS), this._yAxisUpSpaceInverse.copy(this._yAxisUpSpace).invert();
            }
            applyCameraUp() {
                const e1 = zS.subVectors(this._target, this._camera.position).normalize(), t = OS.crossVectors(e1, this._camera.up);
                this._camera.up.crossVectors(t, e1).normalize(), this._camera.updateMatrixWorld();
                const n = this.getPosition(zS);
                this.updateCameraUp(), this.setPosition(n.x, n.y, n.z);
            }
            update(e1) {
                const t = this._sphericalEnd.theta - this._spherical.theta, n = this._sphericalEnd.phi - this._spherical.phi, i = this._sphericalEnd.radius - this._spherical.radius, r = FS.subVectors(this._targetEnd, this._target), a = HS.subVectors(this._focalOffsetEnd, this._focalOffset), s = this._zoomEnd - this._zoom;
                if (gS(t)) this._thetaVelocity.value = 0, this._spherical.theta = this._sphericalEnd.theta;
                else {
                    const t = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.theta = xS(this._spherical.theta, this._sphericalEnd.theta, this._thetaVelocity, t, 1 / 0, e1), this._needsUpdate = !0;
                }
                if (gS(n)) this._phiVelocity.value = 0, this._spherical.phi = this._sphericalEnd.phi;
                else {
                    const t = this._isUserControllingRotate ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.phi = xS(this._spherical.phi, this._sphericalEnd.phi, this._phiVelocity, t, 1 / 0, e1), this._needsUpdate = !0;
                }
                if (gS(i)) this._radiusVelocity.value = 0, this._spherical.radius = this._sphericalEnd.radius;
                else {
                    const t = this._isUserControllingDolly ? this.draggingSmoothTime : this.smoothTime;
                    this._spherical.radius = xS(this._spherical.radius, this._sphericalEnd.radius, this._radiusVelocity, t, this.maxSpeed, e1), this._needsUpdate = !0;
                }
                if (gS(r.x) && gS(r.y) && gS(r.z)) this._targetVelocity.set(0, 0, 0), this._target.copy(this._targetEnd);
                else {
                    const t = this._isUserControllingTruck ? this.draggingSmoothTime : this.smoothTime;
                    _S(this._target, this._targetEnd, this._targetVelocity, t, this.maxSpeed, e1, this._target), this._needsUpdate = !0;
                }
                if (gS(a.x) && gS(a.y) && gS(a.z)) this._focalOffsetVelocity.set(0, 0, 0), this._focalOffset.copy(this._focalOffsetEnd);
                else {
                    const t = this._isUserControllingOffset ? this.draggingSmoothTime : this.smoothTime;
                    _S(this._focalOffset, this._focalOffsetEnd, this._focalOffsetVelocity, t, this.maxSpeed, e1, this._focalOffset), this._needsUpdate = !0;
                }
                if (gS(s)) this._zoomVelocity.value = 0, this._zoom = this._zoomEnd;
                else {
                    const t = this._isUserControllingZoom ? this.draggingSmoothTime : this.smoothTime;
                    this._zoom = xS(this._zoom, this._zoomEnd, this._zoomVelocity, t, 1 / 0, e1);
                }
                if (this.dollyToCursor) {
                    if (cS(this._camera) && 0 !== this._changedDolly) {
                        const e1 = this._spherical.radius - this._lastDistance, t = this._camera, n = this._getCameraDirection(US), i = zS.copy(n).cross(t.up).normalize();
                        0 === i.lengthSq() && (i.x = 1);
                        const r = OS.crossVectors(i, n), a = this._sphericalEnd.radius * Math.tan(t.getEffectiveFOV() * fS * .5), s = (this._sphericalEnd.radius - e1 - this._sphericalEnd.radius) / this._sphericalEnd.radius, o = PS.copy(this._targetEnd).add(i.multiplyScalar(this._dollyControlCoord.x * a * t.aspect)).add(r.multiplyScalar(this._dollyControlCoord.y * a)), l = zS.copy(this._targetEnd).lerp(o, s), c = 1 === this._lastDollyDirection && this._spherical.radius <= this.minDistance, u = -1 === this._lastDollyDirection && this.maxDistance <= this._spherical.radius;
                        if (this.infinityDolly && (c || u)) {
                            this._sphericalEnd.radius -= e1, this._spherical.radius -= e1;
                            const t = OS.copy(n).multiplyScalar(-e1);
                            l.add(t);
                        }
                        this._boundary.clampPoint(l, l);
                        const h = OS.subVectors(l, this._targetEnd);
                        this._targetEnd.copy(l), this._target.add(h), this._changedDolly -= e1, gS(this._changedDolly) && (this._changedDolly = 0);
                    } else if (uS(this._camera) && 0 !== this._changedZoom) {
                        const e1 = this._zoom - this._lastZoom, t = this._camera, n = zS.set(this._dollyControlCoord.x, this._dollyControlCoord.y, (t.near + t.far) / (t.near - t.far)).unproject(t), i = OS.set(0, 0, -1).applyQuaternion(t.quaternion), r = PS.copy(n).add(i.multiplyScalar(-n.dot(t.up))), a = -(this._zoom - e1 - this._zoom) / this._zoom, s = this._getCameraDirection(US), o = this._targetEnd.dot(s), l = zS.copy(this._targetEnd).lerp(r, a), c = l.dot(s), u = s.multiplyScalar(c - o);
                        l.sub(u), this._boundary.clampPoint(l, l);
                        const h = OS.subVectors(l, this._targetEnd);
                        this._targetEnd.copy(l), this._target.add(h), this._changedZoom -= e1, gS(this._changedZoom) && (this._changedZoom = 0);
                    }
                }
                this._camera.zoom !== this._zoom && (this._camera.zoom = this._zoom, this._camera.updateProjectionMatrix(), this._updateNearPlaneCorners(), this._needsUpdate = !0), this._dragNeedsUpdate = !0;
                const o = this._collisionTest();
                this._spherical.radius = Math.min(this._spherical.radius, o), this._spherical.makeSafe(), this._camera.position.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse).add(this._target), this._camera.lookAt(this._target), (!gS(this._focalOffset.x) || !gS(this._focalOffset.y) || !gS(this._focalOffset.z)) && (this._camera.updateMatrixWorld(), kS.setFromMatrixColumn(this._camera.matrix, 0), jS.setFromMatrixColumn(this._camera.matrix, 1), BS.setFromMatrixColumn(this._camera.matrix, 2), kS.multiplyScalar(this._focalOffset.x), jS.multiplyScalar(-this._focalOffset.y), BS.multiplyScalar(this._focalOffset.z), zS.copy(kS).add(jS).add(BS), this._camera.position.add(zS)), this._boundaryEnclosesCamera && this._encloseToBoundary(this._camera.position.copy(this._target), zS.setFromSpherical(this._spherical).applyQuaternion(this._yAxisUpSpaceInverse), 1);
                const l = this._needsUpdate;
                return l && !this._updatedLastTime ? (this._hasRested = !1, this.dispatchEvent({
                    type: "wake"
                }), this.dispatchEvent({
                    type: "update"
                })) : l ? (this.dispatchEvent({
                    type: "update"
                }), gS(t, this.restThreshold) && gS(n, this.restThreshold) && gS(i, this.restThreshold) && gS(r.x, this.restThreshold) && gS(r.y, this.restThreshold) && gS(r.z, this.restThreshold) && gS(a.x, this.restThreshold) && gS(a.y, this.restThreshold) && gS(a.z, this.restThreshold) && gS(s, this.restThreshold) && !this._hasRested && (this._hasRested = !0, this.dispatchEvent({
                    type: "rest"
                }))) : !l && this._updatedLastTime && this.dispatchEvent({
                    type: "sleep"
                }), this._lastDistance = this._spherical.radius, this._lastZoom = this._zoom, this._updatedLastTime = l, this._needsUpdate = !1, l;
            }
            toJSON() {
                return JSON.stringify({
                    enabled: this._enabled,
                    minDistance: this.minDistance,
                    maxDistance: MS(this.maxDistance),
                    minZoom: this.minZoom,
                    maxZoom: MS(this.maxZoom),
                    minPolarAngle: this.minPolarAngle,
                    maxPolarAngle: MS(this.maxPolarAngle),
                    minAzimuthAngle: MS(this.minAzimuthAngle),
                    maxAzimuthAngle: MS(this.maxAzimuthAngle),
                    smoothTime: this.smoothTime,
                    draggingSmoothTime: this.draggingSmoothTime,
                    dollySpeed: this.dollySpeed,
                    truckSpeed: this.truckSpeed,
                    dollyToCursor: this.dollyToCursor,
                    verticalDragToForward: this.verticalDragToForward,
                    target: this._targetEnd.toArray(),
                    position: zS.setFromSpherical(this._sphericalEnd).add(this._targetEnd).toArray(),
                    zoom: this._zoomEnd,
                    focalOffset: this._focalOffsetEnd.toArray(),
                    target0: this._target0.toArray(),
                    position0: this._position0.toArray(),
                    zoom0: this._zoom0,
                    focalOffset0: this._focalOffset0.toArray()
                });
            }
            fromJSON(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                const n = JSON.parse(e1);
                this.enabled = n.enabled, this.minDistance = n.minDistance, this.maxDistance = yS(n.maxDistance), this.minZoom = n.minZoom, this.maxZoom = yS(n.maxZoom), this.minPolarAngle = n.minPolarAngle, this.maxPolarAngle = yS(n.maxPolarAngle), this.minAzimuthAngle = yS(n.minAzimuthAngle), this.maxAzimuthAngle = yS(n.maxAzimuthAngle), this.smoothTime = n.smoothTime, this.draggingSmoothTime = n.draggingSmoothTime, this.dollySpeed = n.dollySpeed, this.truckSpeed = n.truckSpeed, this.dollyToCursor = n.dollyToCursor, this.verticalDragToForward = n.verticalDragToForward, this._target0.fromArray(n.target0), this._position0.fromArray(n.position0), this._zoom0 = n.zoom0, this._focalOffset0.fromArray(n.focalOffset0), this.moveTo(n.target[0], n.target[1], n.target[2], t), VS.setFromVector3(zS.fromArray(n.position).sub(this._targetEnd).applyQuaternion(this._yAxisUpSpace)), this.rotateTo(VS.theta, VS.phi, t), this.dollyTo(VS.radius, t), this.zoomTo(n.zoom, t), this.setFocalOffset(n.focalOffset[0], n.focalOffset[1], n.focalOffset[2], t), this._needsUpdate = !0;
            }
            connect(e1) {
                this._domElement ? console.warn("camera-controls is already connected.") : (e1.setAttribute("data-camera-controls-version", "2.8.5"), this._addAllEventListeners(e1), this._getClientRect(this._elementRect));
            }
            disconnect() {
                this.cancel(), this._removeAllEventListeners(), this._domElement && (this._domElement.removeAttribute("data-camera-controls-version"), this._domElement = void 0);
            }
            dispose() {
                this.removeAllEventListeners(), this.disconnect();
            }
            _getTargetDirection(e1) {
                return e1.setFromSpherical(this._spherical).divideScalar(this._spherical.radius).applyQuaternion(this._yAxisUpSpaceInverse);
            }
            _getCameraDirection(e1) {
                return this._getTargetDirection(e1).negate();
            }
            _findPointerById(e1) {
                return this._activePointers.find((t)=>t.pointerId === e1);
            }
            _findPointerByMouseButton(e1) {
                return this._activePointers.find((t)=>t.mouseButton === e1);
            }
            _disposePointer(e1) {
                this._activePointers.splice(this._activePointers.indexOf(e1), 1);
            }
            _encloseToBoundary(e1, t, n) {
                const i = t.lengthSq();
                if (0 === i) return e1;
                const r = OS.copy(t).add(e1), a = this._boundary.clampPoint(r, PS).sub(r), s = a.lengthSq();
                if (0 === s) return e1.add(t);
                if (s === i) return e1;
                if (0 === n) return e1.add(t).add(a);
                {
                    const i = 1 + n * s / t.dot(a);
                    return e1.add(OS.copy(t).multiplyScalar(i)).add(a.multiplyScalar(1 - n));
                }
            }
            _updateNearPlaneCorners() {
                if (cS(this._camera)) {
                    const e1 = this._camera, t = e1.near, n = e1.getEffectiveFOV() * fS, i = Math.tan(.5 * n) * t, r = i * e1.aspect;
                    this._nearPlaneCorners[0].set(-r, -i, 0), this._nearPlaneCorners[1].set(r, -i, 0), this._nearPlaneCorners[2].set(r, i, 0), this._nearPlaneCorners[3].set(-r, i, 0);
                } else if (uS(this._camera)) {
                    const e1 = this._camera, t = 1 / e1.zoom, n = e1.left * t, i = e1.right * t, r = e1.top * t, a = e1.bottom * t;
                    this._nearPlaneCorners[0].set(n, r, 0), this._nearPlaneCorners[1].set(i, r, 0), this._nearPlaneCorners[2].set(i, a, 0), this._nearPlaneCorners[3].set(n, a, 0);
                }
            }
            _collisionTest() {
                let e1 = 1 / 0;
                if (!(this.colliderMeshes.length >= 1)) return e1;
                if (wS(this._camera, "_collisionTest")) return e1;
                const t = this._getTargetDirection(US);
                qS.lookAt(DS, t, this._camera.up);
                for(let n = 0; n < 4; n++){
                    const i = OS.copy(this._nearPlaneCorners[n]);
                    i.applyMatrix4(qS);
                    const r = PS.addVectors(this._target, i);
                    KS.set(r, t), KS.far = this._spherical.radius + 1;
                    const a = KS.intersectObjects(this.colliderMeshes);
                    0 !== a.length && a[0].distance < e1 && (e1 = a[0].distance);
                }
                return e1;
            }
            _getClientRect(e1) {
                if (!this._domElement) return;
                const t = this._domElement.getBoundingClientRect();
                return e1.x = t.left, e1.y = t.top, this._viewport ? (e1.x += this._viewport.x, e1.y += t.height - this._viewport.w - this._viewport.y, e1.width = this._viewport.z, e1.height = this._viewport.w) : (e1.width = t.width, e1.height = t.height), e1;
            }
            _createOnRestPromise(e1) {
                return e1 ? Promise.resolve() : (this._hasRested = !1, this.dispatchEvent({
                    type: "transitionstart"
                }), new Promise((e1)=>{
                    const t = ()=>{
                        this.removeEventListener("rest", t), e1();
                    };
                    this.addEventListener("rest", t);
                }));
            }
            _addAllEventListeners(e1) {}
            _removeAllEventListeners() {}
            get dampingFactor() {
                return console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead."), 0;
            }
            set dampingFactor(e1) {
                console.warn(".dampingFactor has been deprecated. use smoothTime (in seconds) instead.");
            }
            get draggingDampingFactor() {
                return console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead."), 0;
            }
            set draggingDampingFactor(e1) {
                console.warn(".draggingDampingFactor has been deprecated. use draggingSmoothTime (in seconds) instead.");
            }
            static createBoundingSphere(e1) {
                const t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new NS.Sphere, n = t.center;
                QS.makeEmpty(), e1.traverseVisible((e1)=>{
                    e1.isMesh && QS.expandByObject(e1);
                }), QS.getCenter(n);
                let i = 0;
                return e1.traverseVisible((e1)=>{
                    if (!e1.isMesh) return;
                    const t = e1, r = t.geometry.clone();
                    r.applyMatrix4(t.matrixWorld);
                    const a = r.attributes.position;
                    for(let e1 = 0, t = a.count; e1 < t; e1++)zS.fromBufferAttribute(a, e1), i = Math.max(i, n.distanceToSquared(zS));
                }), t.radius = Math.sqrt(i), t;
            }
        }
        function $S(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        JS.install({
            THREE: e1
        });
        const eI = class extends JS {
            constructor(e1, t){
                super(t, e1.domElement), $S(this, "disableAutoRotate", !1), $S(this, "userDragging", !1), $S(this, "_renderer", void 0), $S(this, "_camera", void 0), this._renderer = e1, this._camera = t, this.mouseButtons.middle = JS.ACTION.NONE, this.mouseButtons.left = JS.ACTION.ROTATE, this.mouseButtons.right = JS.ACTION.NONE, this.mouseButtons.wheel = JS.ACTION.NONE, this.touches.three = JS.ACTION.NONE, this.touches.two = JS.ACTION.NONE, this.touches.one = JS.ACTION.TOUCH_ROTATE, this.verticalDragToForward = !0, this.azimuthRotateSpeed = -0.25, this.polarRotateSpeed = -0.25, this.maxDistance = .001, this.truckSpeed = 1e4, this.minDistance = 0, this.dollySpeed = 0, this.minZoom = 1, this.maxZoom = 2, this.rotateTo(0, Math.PI / 2), this.setDefaultPosition(), this.addListeners();
            }
            setDefaultPosition() {
                this.moveTo(0, 0, 0), this.dollyTo(1e-9), this.zoomTo(1);
            }
            onRest() {
                this.removeEventListener("rest", this.onRest), this.disableAutoRotate = !1, this.holding = !1;
            }
            onControlStart() {
                this.currentAction !== JS.ACTION.NONE && (this.removeEventListener("rest", this.onRest), this.disableAutoRotate = !0, this.holding = !0);
            }
            onControlEnd() {
                this.active ? this.addEventListener("rest", this.onRest) : this.onRest();
            }
            onTransitionStart() {
                this.holding || (this.disableAutoRotate = !0, this.addEventListener("rest", this.onRest));
            }
            addListeners() {
                this.addEventListener("transitionstart", this.onTransitionStart), this.addEventListener("controlstart", this.onControlStart), this.addEventListener("controlend", this.onControlEnd);
            }
        };
        function tI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const nI = class extends Ju {
            constructor(e1){
                super(60, 1, .1, 1e4), tI(this, "deviceOrientationControls", void 0), tI(this, "controls", void 0), this.controls = new eI(e1, this), this.deviceOrientationControls = new oS(this, e1.domElement);
            }
        };
        const iI = class extends Zp {
            constructor(){
                var e1, t, n;
                super(), e1 = this, n = void 0, (t = function(e1) {
                    var t = function(e1) {
                        if ("object" != typeof e1 || !e1) return e1;
                        var t = e1[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var n = t.call(e1, "string");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == typeof t ? t : t + "";
                }(t = "controls")) in e1 ? Object.defineProperty(e1, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e1[t] = n, this.background = new Zc(16777215), this.add(new jA(new Zc(16777215), 3));
            }
        };
        function rI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const aI = class extends Vu {
            constructor(){
                super(), rI(this, "canvas", document.createElement("canvas")), rI(this, "interactive", !0), rI(this, "height", 775), rI(this, "width", 775), this.canvas.height = this.height, this.canvas.width = this.width, this.createGeomtery(), this.createMaterial(), this.addEventListener("select", (e1)=>this.onClick(e1)), this.addEventListener("click", (e1)=>this.onClick(e1)), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {}
            onHoverStart() {
                this.scale.setScalar(1.15);
            }
            onHoverEnd() {
                this.scale.setScalar(1);
            }
            createGeomtery() {
                this.geometry = new dh(this.width, this.height, 100, 100);
            }
            createMaterial() {
                return this.material = new Ug({
                    color: new Zc(16777215),
                    transparent: !0,
                    side: hr,
                    opacity: 1
                }), this;
            }
            async loadImage(e1) {
                const t = await fetch(e1, {
                    method: "GET",
                    cache: "no-cache"
                }), n = await t.blob();
                return await Ry(URL.createObjectURL(n));
            }
            setVisibility(e1) {
                this.visible = e1, this.scale.setScalar(e1 ? 1 : 0);
            }
            async updateMaterial(e1) {
                const t = "".concat(e1 + 1, " ").concat(Oy("floor")), n = Bi.config.colors.mainText, i = Bi.getFloorConfig(e1);
                return this.loadImage(i.planImage).then((e1)=>{
                    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(255, 255, 255, 1)", zy(this.context, 0, 0, this.canvas.width, this.canvas.height, 50), this.context.fill(), this.context.drawImage(e1, 165, 75, 450, 450), this.context.textAlign = "center", this.context.font = "Bold 80px/1 Roboto Mono", this.context.fillStyle = n, this.context.fillColor = n, this.context.fillText(t, this.canvas.width / 2, this.canvas.height - 100), this.context.fillRect((this.canvas.width - 430) / 2, this.canvas.height - 55, 430, 5), this.material.map || (this.material.map = Px(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0;
                }), this;
            }
        };
        function sI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const oI = class extends Vu {
            constructor(){
                super(), sI(this, "canvas", document.createElement("canvas")), sI(this, "height", 700), sI(this, "width", 700), this.canvas.height = this.height, this.canvas.width = this.width, this.createGeomtery(), this.createMaterial(), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeomtery() {
                this.geometry = new dh(this.width, this.height, 100, 100);
            }
            createMaterial() {
                return this.material = new Ug({
                    color: new Zc(16777215),
                    transparent: !0,
                    side: hr,
                    opacity: 1
                }), this;
            }
            updateMaterial() {
                const e1 = "".concat(Bi.currentFloorIndex + 1, " ").concat(Oy("floor")), t = Bi.config.colors.mainText;
                return this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.textAlign = "center", this.context.font = "Bold 140px/1 Roboto Mono", this.context.fillStyle = t, this.context.fillColor = t, this.context.fillText(e1, this.canvas.width / 2, this.canvas.height / 2), this.context.fillRect(0, this.canvas.height / 2 + 50, this.canvas.width, 5), this.material.map || (this.material.map = Px(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0, this;
            }
        };
        function lI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const cI = class extends Vu {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 400;
                super(), lI(this, "canvas", document.createElement("canvas")), lI(this, "isContainer", !0), this.canvas.width = e1, this.canvas.height = 120, this.createGeometry(), this.createMaterial(), this.renderOrder = 5;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeometry() {
                return this.geometry = new dh(this.canvas.width, this.canvas.height, 10, 10), this;
            }
            createMaterial() {
                this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(20, 20, 20, 0.26)", zy(this.context, 0, 0, this.canvas.width, this.canvas.height, 64), this.context.fill();
                const e1 = Px(this.canvas);
                return this.material = new Ug({
                    color: new Zc(16777215),
                    transparent: !0,
                    side: hr,
                    map: e1,
                    opacity: 1
                }), this;
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function uI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const hI = class extends Vu {
            constructor(e1){
                super(), uI(this, "canvas", document.createElement("canvas")), uI(this, "interactive", !0), uI(this, "isButton", !0), this.canvas.height = 92, this.canvas.width = 92, this.createGeometry(), this.createMaterial(), this.update(e1), this.addEventListener("select", (e1)=>this.onClick(e1)), this.addEventListener("click", (e1)=>this.onClick(e1)), this.position.set(0, 0, 1), this.renderOrder = 6;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            onClick() {}
            createGeometry() {
                return this.geometry = new dh(this.canvas.width, this.canvas.height, 10, 10), this;
            }
            createMaterial() {
                return this.material = new Ug({
                    color: new Zc(16777215),
                    transparent: !0,
                    side: hr,
                    opacity: 1
                }), this;
            }
            update(e1) {
                return Ry(e1).then((e1)=>{
                    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = "rgba(255, 255, 255, 1)", zy(this.context, 0, 0, this.canvas.width, this.canvas.height, 46), this.context.fill(), this.context.drawImage(e1, 20, 20, 52, 52), this.material.map || (this.material.map = Px(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0;
                }), this;
            }
            setVisibility(e1) {
                this.visible = e1, this.scale.setScalar(e1 ? 1 : 0);
            }
        };
        function dI(e1, t) {
            let n = e1[0], i = e1[1], r = !1;
            for(let e1 = 0, a = t.length - 1; e1 < t.length; a = e1++){
                const s = t[e1][0], o = t[e1][1], l = t[a][0], c = t[a][1];
                o > i != c > i && n < (l - s) * (i - o) / (c - o) + s && (r = !r);
            }
            return r;
        }
        function pI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const fI = class extends kp {
            constructor(){
                super(), pI(this, "planScale", new Jo(1, 1)), pI(this, "currentPanoramasGroup", void 0), pI(this, "padding", 16), pI(this, "rooms", []), this.scale.set(1, -1, 1), this.renderOrder = 6;
            }
            updateScale(e1) {
                let { X: t, Y: n } = e1;
                return this.planScale.x = t, this.planScale.y = n, this.deleteRooms(), this.createRooms(this.currentPanoramasGroup), this;
            }
            showRoomById(e1) {
                return this.rooms.forEach((t)=>{
                    t.material.opacity = t.userData.id === e1 ? .3 : 0;
                }), this;
            }
            createRooms(e1) {
                return this.currentPanoramasGroup = e1, this.currentPanoramasGroup.children.forEach((e1)=>{
                    let { userData: t, panoramaId: n } = e1;
                    const i = t.points.map((e1)=>{
                        let [t, n] = e1;
                        return [
                            this.padding + 2 * t * this.planScale.x,
                            this.padding + 2 * n * this.planScale.y
                        ];
                    }).filter((e1)=>{
                        let [t, n] = e1;
                        return !isNaN(t) && !isNaN(n);
                    });
                    if (!i.length) return;
                    const r = this.padding + 2 * t.left * this.planScale.x, a = this.padding + 2 * t.top * this.planScale.y, s = new Ym;
                    s.moveTo(i[0][0], i[0][1]), i.forEach((e1)=>{
                        let [t, n] = e1;
                        return s.lineTo(t, n);
                    });
                    const o = new Tg(s), l = new Ug({
                        color: new Zc(Bi.config.colors.main),
                        transparent: !0,
                        side: hr,
                        opacity: 0
                    }), c = new Vu(o, l);
                    c.userData = {
                        id: n,
                        points: i,
                        left: r,
                        top: a
                    }, this.rooms.push(c), this.add(c);
                }), this;
            }
            deleteRooms() {
                return this.rooms.forEach((e1)=>{
                    e1.material.dispose(), e1.removeFromParent();
                }), this.rooms = [], this;
            }
        };
        function mI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const gI = class extends Vu {
            constructor(){
                super(), mI(this, "height", 140), mI(this, "width", 140), this.createGeometry(), this.createMaterial(), this.renderOrder = 7;
            }
            createGeometry() {
                return this.geometry = new dh(this.width, this.height, 10, 10), this;
            }
            createMaterial() {
                const e1 = this.width / 2, t = this.height / 2, n = Math.PI / 3 * 4, i = n + Math.PI / 3, r = document.createElement("canvas"), a = r.getContext("2d");
                return r.height = this.height, r.width = this.width, a.clearRect(0, 0, this.width, this.height), a.globalAlpha = .4, a.beginPath(), a.moveTo(e1, t), a.fillStyle = Bi.config.colors.main, a.arc(e1, t, 70, n, i), a.lineTo(e1, t), a.fill(), a.closePath(), a.globalAlpha = 1, a.beginPath(), a.fillStyle = Bi.config.colors.main, a.arc(e1, t, 16, 0, 2 * Math.PI), a.fill(), a.closePath(), a.beginPath(), a.fillStyle = "rgba(255, 255, 255, 1)", a.arc(e1, t, 12, 0, 2 * Math.PI), a.fill(), a.closePath(), a.beginPath(), a.fillStyle = Bi.config.colors.main, a.arc(e1, t, 8, 0, 2 * Math.PI), a.fill(), a.closePath(), this.material = new Ug({
                    map: Px(r),
                    color: new Zc(16777215),
                    transparent: !0,
                    depthTest: !1,
                    side: hr,
                    opacity: 1
                }), this;
            }
            update(e1, t, n) {
                this.position.set(e1, t, 10), this.rotation.set(0, 0, n);
            }
        };
        function AI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const vI = class extends Vu {
            constructor(){
                super(), AI(this, "planScale", new Jo(1, 1)), AI(this, "pointer", new Jo(-1, -1)), AI(this, "interactive", !0), AI(this, "boundingScale", 4), AI(this, "padding", 16), AI(this, "hoverRoom", void 0), AI(this, "fovLayer", void 0), AI(this, "height", void 0), AI(this, "width", void 0), this.height = 200, this.width = 200, this.createGeometry(), this.createMaterial(), this.creteRoomsLayer(), this.createFovLayer(), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this.addEventListener("click", this.handleClick), this.renderOrder = 5;
            }
            createGeometry() {
                return this.geometry = new dh(this.width, this.height, 100, 100), this;
            }
            createMaterial() {
                return this.material = new Ug({
                    color: new Zc(16777215),
                    transparent: !0,
                    side: hr,
                    opacity: 1
                }), this;
            }
            async loadImage(e1) {
                const t = await fetch(e1, {
                    method: "GET",
                    cache: "no-cache"
                }), n = await t.blob();
                return this.image = new Image, this.image.onload = ()=>this.updateMaterial(), this.image.src = URL.createObjectURL(n), this;
            }
            createFovLayer() {
                return this.fovLayer = new gI, this.add(this.fovLayer), this;
            }
            creteRoomsLayer() {
                return this.roomsLayer = new fI, this.add(this.roomsLayer), this;
            }
            setDisabledState(e1) {
                this.disabled = e1;
            }
            setVisibility(e1) {
                this.visible = e1, this.scale.setScalar(e1 ? this.boundingScale : 0);
            }
            onHoverStart(e1) {
                const { x: t, y: n } = e1.data, i = this.height * n, r = this.width * t;
                this.pointer.x = r, this.pointer.y = i;
            }
            onHoverEnd() {
                this.pointer.x = -1, this.pointer.y = -1;
            }
            handleClick() {
                this.hoverRoom && (this.onClick(this.hoverRoom.userData.id), this.dispatchEvent({
                    type: "closemap"
                }));
            }
            onClick() {}
            updateMaterial() {
                const e1 = document.createElement("canvas"), t = e1.getContext("2d");
                return e1.height = this.height, e1.width = this.width, t.fillStyle = "rgba(255, 255, 255, 1)", zy(t, 0, 0, this.width, this.height, 20), t.fill(), this.image && t.drawImage(this.image, this.padding, this.padding, this.width - 2 * this.padding, this.height - 2 * this.padding), this.material.map && this.material.map.dispose(), this.material.map = Px(e1), this.material.needsUpdate = !0, this;
            }
            updateSize(e1, t) {
                this.height = t + 2 * this.padding, this.width = e1 + 2 * this.padding, this.roomsLayer.position.set(-this.width / 2, this.height / 2, 5), this.createGeometry();
                const n = Math.min(this.width / this.height, 1);
                return this.boundingScale = 5 * n, this.setVisibility(this.visible), this;
            }
            updateScale(e1) {
                let { X: t, Y: n } = e1;
                return this.planScale.x = t, this.planScale.y = n, this.roomsLayer.updateScale({
                    X: t,
                    Y: n
                }), this;
            }
            updateRoomsLayer(e1) {
                return this.roomsLayer.deleteRooms(), this.roomsLayer.createRooms(e1), this;
            }
            update(e1, t, n) {
                var i;
                if (n) {
                    const e1 = this.roomsLayer.rooms.filter((e1)=>dI([
                            this.pointer.x,
                            this.pointer.y
                        ], e1.userData.points));
                    this.hoverRoom = Bx([
                        this.pointer.x,
                        this.pointer.y
                    ], e1).panorama;
                }
                if (this.roomsLayer.showRoomById((null === (i = this.hoverRoom) || void 0 === i ? void 0 : i.userData.id) || null), !this.disabled && t) {
                    const n = this.padding + 2 * t.userData.left * this.planScale.x, i = this.padding + 2 * t.userData.top * this.planScale.y, r = this.height / 2, a = n - this.width / 2, s = -1 * (i - r);
                    this.fovLayer.update(a, s, e1);
                }
                return this;
            }
        }, MI = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE4NDhfNjI0KSI+CjxwYXRoIGQ9Ik0xOC44MjI2IDEuODc0ODlMMS44NzUwNSAxOC44MjI0QzEuNDc2MDEgMTkuMjIxNCAxLjQ0MTUgMTkuODMzOSAxLjc5Nzk3IDIwLjE5MDRMNy44MDk0OCAyNi4yMDE5QzguMTY1OTUgMjYuNTU4MyA4Ljc3ODQyIDI2LjUyMzggOS4xNzc0NiAyNi4xMjQ4TDI2LjEyNSA5LjE3NzI5QzI2LjUyNCA4Ljc3ODI1IDI2LjU1ODUgOC4xNjU3OSAyNi4yMDIgNy44MDkzMkwyMC4xOTA1IDEuNzk3ODFDMTkuODM0MSAxLjQ0MTM0IDE5LjIyMTYgMS40NzU4NSAxOC44MjI2IDEuODc0ODlaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS41MjUgNi4zMjg2MUwxOS42MTIyIDEwLjQxNTgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjkyNjkgMTAuOTI2OEwxNC4wMTQyIDE0LjAxNCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4zMjg3NCAxNS41MjQ5TDEwLjQxNiAxOS42MTIxIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTg0OF82MjQiPgo8cmVjdCB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
        function yI(e1, t, n) {
            (function(e1, t) {
                if (t.has(e1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(e1, t), t.set(e1, n);
        }
        function xI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        function _I(e1, t) {
            return e1.get(wI(e1, t));
        }
        function bI(e1, t, n) {
            return e1.set(wI(e1, t), n), n;
        }
        function wI(e1, t, n) {
            if ("function" == typeof e1 ? e1 === t : e1.has(t)) return arguments.length < 3 ? t : n;
            throw new TypeError("Private element is not present on this object");
        }
        var EI = new WeakMap, TI = new WeakMap;
        const SI = class extends kp {
            constructor(){
                super(), xI(this, "mapGroup", new kp), yI(this, EI, void 0), yI(this, TI, void 0), xI(this, "prevFloorButton", void 0), xI(this, "nextFloorButton", void 0), xI(this, "rulerButton", void 0), xI(this, "floorTitle", void 0), xI(this, "exitButton", void 0), xI(this, "mapButton", void 0), xI(this, "container", void 0), xI(this, "map", void 0), this.createContainer(), this.createButtons(), this.createMap(), this.createFloorTitle(), this.createPrevFloorButton(), this.createNextFloorButton(), this.closeMap(), this.mapButton.setVisibility(!1), this.setVisibility(!1), this.mapGroup.position.set(0, 2e3, -2500), this.mapGroup.rotation.set(Gx(30), 0, 0), this.add(this.mapGroup);
            }
            set rulerButtonAvailable(e1) {
                bI(EI, this, e1), this.map.visible || this.setRulerButtonVisibility(e1);
            }
            set mapButtonAvailable(e1) {
                bI(TI, this, e1), this.map.visible || this.setMapButtonVisibility(e1);
            }
            onRulerButtonClick() {}
            onExitButtonClick() {}
            createContainer() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 400;
                if (this.container) {
                    const t = new cI(e1);
                    this.container.geometry = t.geometry.clone(), this.container.material = t.material.clone(), t.dispose();
                } else this.container = new cI(e1), this.add(this.container);
                return this;
            }
            createButtons() {
                return this.exitButton = new hI("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjE2NjEgNC44MzM5OEwxNCAxNC4wMDAxTTE0IDE0LjAwMDFMNC44MzM4IDIzLjE2NjNNMTQgMTQuMDAwMUwyMy4xNjYxIDIzLjE2NjNNMTQgMTQuMDAwMUw0LjgzMzggNC44MzM5OCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"), this.exitButton.onClick = (e1)=>{
                    if (this.map.visible) return this.closeMap();
                    this.onExitButtonClick(e1);
                }, this.rulerButton = new hI(MI), this.rulerButton.onClick = (e1)=>this.onRulerButtonClick(e1), this.mapButton = new hI("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0LjIxMTQgMjQuNDIxMUgzLjc4ODY1QzMuNjI3NDggMjQuNDIxMSAzLjQ5NjgzIDI0LjI5MDQgMy40OTY4MyAyNC4xMjkzTDMuNDk2NzcgNC4wNjYyNEMzLjQ5Njc3IDMuOTA1MDcgMy42Mjc0MiAzLjc3NDQxIDMuNzg4NTkgMy43NzQ0MUgyNC4yMTE0QzI0LjM3MjUgMy43NzQ0MSAyNC41MDMyIDMuOTA1MDcgMjQuNTAzMiA0LjA2NjI0VjI0LjEyOTNDMjQuNTAzMiAyNC4yOTA0IDI0LjM3MjUgMjQuNDIxMSAyNC4yMTE0IDI0LjQyMTFaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIvPgo8cGF0aCBkPSJNNC4wMDE0NiAxMC4wNDU0SDEzLjM2ODRDMTMuNTI5NiAxMC4wNDU0IDEzLjY2MDIgMTAuMTc2MSAxMy42NjAyIDEwLjMzNzJWMjQuMjA1OSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNDU5MSIvPgo8cGF0aCBkPSJNMjQuNTAzMiAxMS4wNjU2SDE4LjM2NTFDMTguMjA0IDExLjA2NTYgMTguMDczMyAxMC45MzQ5IDE4LjA3MzMgMTAuNzczOFYzLjU3OTEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjQ1OTEiLz4KPC9zdmc+Cg=="), this.mapButton.onClick = (e1)=>this.openMap(e1), this.add(this.exitButton, this.rulerButton, this.mapButton), this;
            }
            createMap() {
                return this.map = new vI, this.map.addEventListener("closemap", this.closeMap.bind(this)), this.mapGroup.add(this.map), this;
            }
            createFloorTitle() {
                return this.floorTitle = new oI, this.mapGroup.add(this.floorTitle), this;
            }
            createNextFloorButton() {
                return this.nextFloorButton = new aI, this.mapGroup.add(this.nextFloorButton), this;
            }
            createPrevFloorButton() {
                return this.prevFloorButton = new aI, this.mapGroup.add(this.prevFloorButton), this;
            }
            openMap() {
                this.floorTitle.updateMaterial(), this.prevFloorButton.updateMaterial(Bi.prevFloorIndex), this.nextFloorButton.updateMaterial(Bi.nextFloorIndex), this.mapGroup.visible = !0, this.map.setVisibility(!0), this.rulerButton.setVisibility(!1), this.setMapButtonVisibility(!1);
                const e1 = Bi.configParams.floors.length > 1;
                this.prevFloorButton.setVisibility(e1), this.nextFloorButton.setVisibility(e1);
            }
            closeMap() {
                this.mapGroup.visible = !1, this.map.setVisibility(!1), this.rulerButton.setVisibility(_I(EI, this)), this.setMapButtonVisibility(!0), this.prevFloorButton.setVisibility(!1), this.nextFloorButton.setVisibility(!1);
            }
            setRulerButtonVisibility(e1) {
                this.rulerButton.setVisibility(e1), this.updateButtonsPositions();
            }
            setMapButtonVisibility(e1) {
                this.mapButton.setVisibility(e1), this.updateButtonsPositions();
            }
            setVisibility(e1) {
                e1 ? (this.setRulerButtonVisibility(_I(EI, this)), this.setMapButtonVisibility(_I(TI, this))) : (this.setRulerButtonVisibility(!1), this.setMapButtonVisibility(!1)), this.exitButton.setVisibility(e1), this.container.visible = e1, this.visible = e1, this.scale.setScalar(e1 ? 6e-4 : 0);
            }
            setRulerIcon(e1) {
                return e1 ? this.rulerButton.update("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE4NDhfNjU5KSI+CjxwYXRoIGQ9Ik0xOC44MjI2IDEuODc0ODlMMS44NzUwNSAxOC44MjI0QzEuNDc2MDEgMTkuMjIxNCAxLjQ0MTUgMTkuODMzOSAxLjc5Nzk3IDIwLjE5MDRMNy44MDk0OCAyNi4yMDE5QzguMTY1OTUgMjYuNTU4MyA4Ljc3ODQyIDI2LjUyMzggOS4xNzc0NiAyNi4xMjQ4TDI2LjEyNSA5LjE3NzI5QzI2LjUyNCA4Ljc3ODI1IDI2LjU1ODUgOC4xNjU3OSAyNi4yMDIgNy44MDkzMkwyMC4xOTA1IDEuNzk3ODFDMTkuODM0MSAxLjQ0MTM0IDE5LjIyMTYgMS40NzU4NSAxOC44MjI2IDEuODc0ODlaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS41MjUgNi4zMjg2MUwxOS42MTIyIDEwLjQxNTgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjkyNjkgMTAuOTI2OEwxNC4wMTQyIDE0LjAxNCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4zMjg3NCAxNS41MjQ5TDEwLjQxNiAxOS42MTIxIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxyZWN0IHg9IjEwLjYyNDYiIHk9IjYuMjkzNDYiIHdpZHRoPSIxNS44MDAyIiBoZWlnaHQ9IjMuNjYxNiIgdHJhbnNmb3JtPSJyb3RhdGUoNDUgMTAuNjI0NiA2LjI5MzQ2KSIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTMuMDA2MjkgNC43MTE0M0wyMi45OTM4IDI1LjI4NzkiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xODQ4XzY1OSI+CjxyZWN0IHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K") : this.rulerButton.update(MI);
            }
            updateButtonsPositions() {
                return this.map.visible ? (this.exitButton.position.x = 0, void this.createContainer(120)) : this.mapButton.visible ? this.rulerButton.visible ? (this.rulerButton.position.x = 0, this.exitButton.position.x = 140, this.mapButton.position.x = -140, void this.createContainer(400)) : (this.exitButton.position.x = 70, this.mapButton.position.x = -70, void this.createContainer(260)) : this.rulerButton.visible ? (this.rulerButton.position.x = -70, this.exitButton.position.x = 70, void this.createContainer(260)) : (this.exitButton.position.x = 0, void this.createContainer(120));
            }
            updateFloorMaterials() {
                this.floorTitle.updateMaterial(), this.prevFloorButton.updateMaterial(Bi.prevFloorIndex), this.nextFloorButton.updateMaterial(Bi.nextFloorIndex);
            }
            updateFloorTitlePosition() {
                const e1 = 210 + this.map.height * this.map.scale.y / 2;
                this.floorTitle.position.set(0, e1, 0);
            }
            updateFloorButtonsPositions() {
                const { width: e1, height: t } = this.nextFloorButton, n = t / 2 - this.map.height * this.map.scale.y / 2, i = e1 / 2 + 200 + this.map.width * this.map.scale.x / 2;
                this.prevFloorButton.position.set(-i, n, 0), this.nextFloorButton.position.set(i, n, 0);
            }
            update(e1, t, n, i) {
                this.map.visible && this.map.update(t, n, i);
                const r = new Cl(.025, -0.5, -0.9);
                r.applyMatrix4(e1.matrixWorld);
                const a = new Ac(0, 0, 0);
                a.setFromRotationMatrix(e1.matrixWorld), this.position.copy(r), this.rotation.copy(a), this.rotateX(Gx(-30)), this.updateMatrix(), this.updateFloorTitlePosition(), this.updateFloorButtonsPositions();
            }
        };
        const II = class extends Vu {
            constructor(){
                var e1, t, n;
                super(), e1 = this, n = !0, (t = function(e1) {
                    var t = function(e1) {
                        if ("object" != typeof e1 || !e1) return e1;
                        var t = e1[Symbol.toPrimitive];
                        if (void 0 !== t) {
                            var n = t.call(e1, "string");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e1);
                    }(e1);
                    return "symbol" == typeof t ? t : t + "";
                }(t = "isDistanceLine")) in e1 ? Object.defineProperty(e1, t, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e1[t] = n, this.createGeometry(), this.createMaterial(), this.renderOrder = 3;
            }
            createGeometry(e1, t) {
                const n = new Sm(e1, t);
                return this.geometry = new Cg(n, 100, .1, 100, !1), this;
            }
            createMaterial() {
                return this.material = new Ug({
                    color: new Zc(4275774),
                    transparent: !0,
                    depthTest: !1,
                    side: hr,
                    opacity: 1
                }), this;
            }
            update(e1, t) {
                return this.createGeometry(e1, t), this;
            }
            dispose() {
                this.material.dispose(), this.removeFromParent();
            }
        };
        function NI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const DI = class extends ff {
            constructor(e1){
                super(), NI(this, "canvas", document.createElement("canvas")), NI(this, "isCenterPoint", !0), NI(this, "interactive", !0), NI(this, "materialValue", 0), NI(this, "ruler", void 0), this.ruler = e1;
                const t = .15 * this.fontScale;
                this.canvas.width = 256, this.canvas.height = 128, this.scale.set(t, t / (this.canvas.width / this.canvas.height), t), this.renderOrder = 5, this.createMaterial();
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            get fontSize() {
                var e1, t;
                return null !== (e1 = null === (t = Bi.config.ruler_options) || void 0 === t ? void 0 : t.font_size) && void 0 !== e1 ? e1 : 38;
            }
            get fontScale() {
                return this.fontSize / 38;
            }
            onClick() {
                this.ruler.dispose();
            }
            onHoverStart() {
                this.updateMaterial(this.materialValue, "rgba(255, 99, 64, 0.8)", "rgba(255, 255, 255, 1)");
            }
            onHoverEnd() {
                this.updateMaterial(this.materialValue);
            }
            addEventListeners() {
                return this.addEventListener("select", this.onClick), this.addEventListener("click", this.onClick), this.addEventListener("hoverstart", this.onHoverStart), this.addEventListener("hoverend", this.onHoverEnd), this;
            }
            createMaterial() {
                return this.material = new $p({
                    color: new Zc(16777215),
                    sizeAttenuation: !1,
                    transparent: !0,
                    depthTest: !1,
                    side: hr,
                    opacity: 1
                }), this;
            }
            updateMaterial(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "rgba(255, 255, 255, 0.8)", n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : Bi.config.colors.mainText;
                this.materialValue = e1;
                const i = "".concat(Number(e1 / 100).toFixed(2), " m "), r = "".concat(Number(.0328084 * e1).toFixed(2), " ft");
                return this.context.clearRect(0, 0, this.canvas.width, this.canvas.height), this.context.beginPath(), this.context.fillStyle = t, zy(this.context, 0, 0, this.canvas.width, this.canvas.height, 55), this.context.fill(), this.context.textAlign = "center", this.context.font = "Bold 38px/1 Roboto Mono", this.context.fillStyle = n, this.context.fillText(r, this.canvas.width / 2, 100), this.context.fillText(i, this.canvas.width / 2, 50), this.material.map || (this.material.map = Px(this.canvas)), this.material.map.needsUpdate = !0, this.material.needsUpdate = !0, this;
            }
            updatePosition(e1, t) {
                const n = new Sm(e1, t).getPoint(.5, new Cl);
                return this.position.copy(n), this;
            }
            update(e1, t, n) {
                return this.updateMaterial(e1), this.updatePosition(t, n), this;
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function CI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const LI = class extends Vu {
            constructor(){
                super(), CI(this, "canvas", document.createElement("canvas")), CI(this, "isPoint", !0), this.canvas.width = 128, this.canvas.height = 128, this.createGeometry(), this.createMaterial(), this.renderOrder = 4;
            }
            get context() {
                return this.canvas.getContext("2d");
            }
            createGeometry() {
                return this.geometry = new dh(15, 15, 10, 10), this.geometry.rotateX(-Math.PI / 2), this;
            }
            createMaterial() {
                const e1 = this.canvas.width / 2, t = this.canvas.height / 2;
                this.context.beginPath(), this.context.arc(e1, t, this.canvas.width / 4, 0, 2 * Math.PI, !1), this.context.fillStyle = "rgba(255, 255, 255, 1)", this.context.fill(), this.context.lineWidth = 15, this.context.strokeStyle = Bi.config.colors.main, this.context.stroke();
                const n = Px(this.canvas);
                return this.material = new Ug({
                    color: new Zc(16777215),
                    transparent: !0,
                    depthWrite: !1,
                    depthTest: !1,
                    side: hr,
                    map: n,
                    opacity: 1
                }), this;
            }
            update(e1, t) {
                let n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                return this.position.copy(e1), n ? (this.quaternion.slerp(t, .5), this) : (this.quaternion.copy(t), this);
            }
            dispose() {
                this.material.map.dispose(), this.material.dispose(), this.removeFromParent();
            }
        };
        function RI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        const zI = class extends kp {
            constructor(e1){
                super(), RI(this, "distanceLine", null), RI(this, "centerPoint", null), RI(this, "secondPoint", null), RI(this, "firstPoint", null), RI(this, "isRuler", !0), this.userData = {
                    panoramaId: e1
                };
            }
            get distance() {
                return this.firstPoint && this.secondPoint ? this.firstPoint.position.distanceTo(this.secondPoint.position) : 0;
            }
            createRest(e1, t) {
                return this.createSecondPoint(e1, t), this.createDistanceLine(), this.createCenterPoint(), this;
            }
            createFirstPoint(e1, t) {
                return this.firstPoint = (new LI).update(e1, t, !1), this.add(this.firstPoint), this;
            }
            createSecondPoint(e1, t) {
                return this.secondPoint = (new LI).update(e1, t, !1), this.add(this.secondPoint), this;
            }
            createDistanceLine() {
                return this.distanceLine = new II, this.add(this.distanceLine), this;
            }
            createCenterPoint() {
                return this.centerPoint = new DI(this), this.add(this.centerPoint), this;
            }
            update(e1, t) {
                var n, i, r;
                return null === (n = this.secondPoint) || void 0 === n || n.update(e1, t, !0), null === (i = this.centerPoint) || void 0 === i || i.update(this.distance, this.firstPoint.position, this.secondPoint.position), null === (r = this.distanceLine) || void 0 === r || r.update(this.firstPoint.position, this.secondPoint.position), this;
            }
            dispose() {
                var e1, t, n, i;
                return null === (e1 = this.firstPoint) || void 0 === e1 || e1.dispose(), null === (t = this.secondPoint) || void 0 === t || t.dispose(), null === (n = this.centerPoint) || void 0 === n || n.dispose(), null === (i = this.distanceLine) || void 0 === i || i.dispose(), this.removeFromParent(), this;
            }
        }, OI = "data:image/svg+xml;base64,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", PI = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjgzNTQgMi4xNDA3OEwyLjM3NzE4IDIxLjU5OUMxLjkxOTAyIDIyLjA1NzIgMS44Nzk0IDIyLjc2MDQgMi4yODg2OCAyMy4xNjk3TDkuMTkwNzggMzAuMDcxOEM5LjYwMDA2IDMwLjQ4MSAxMC4zMDMzIDMwLjQ0MTQgMTAuNzYxNCAyOS45ODMzTDMwLjIxOTcgMTAuNTI1QzMwLjY3NzggMTAuMDY2OSAzMC43MTc0IDkuMzYzNjYgMzAuMzA4MiA4Ljk1NDM4TDIzLjQwNjEgMi4wNTIyOEMyMi45OTY4IDEuNjQyOTkgMjIuMjkzNiAxLjY4MjYyIDIxLjgzNTQgMi4xNDA3OFoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTguMDQ5MyA3LjI1NDI3TDIyLjc0MjEgMTEuOTQ3IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyLjc3IDEyLjUzMzZMMTYuMzE0NiAxNi4wNzgyIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMi41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuNDkwNzIgMTcuODEyOUwxMi4xODM1IDIyLjUwNTYiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", UI = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuMTYzMiAyNC45MDY3VjUuOTA2NjhIOC45NjI1N0wwLjQ4Mjg1NyA4Ljg5NVYxMi4wNTNMNS40MDQ4NCAxMC4zMzA0VjI0LjkwNjdIOS4xNjMyWiIgZmlsbD0iIzQxM0UzRSIvPgo8cGF0aCBkPSJNMjMuMTI2NiAxNS4xOTc5TDE5Ljk5NjkgMTAuNzg3MkgxNS45OTc4TDIwLjgzOTUgMTcuNzE2NEwxNS44MTA1IDI0LjkwNjdIMTkuODM2NEwyMy4xNCAyMC4yODcyTDI2LjQ3MDQgMjQuOTA2N0gzMC40ODI5TDI1LjQ1MzkgMTcuNzE2NEwzMC4zMDkgMTAuNzg3MkgyNi4zMDk5TDIzLjEyNjYgMTUuMTk3OVoiIGZpbGw9IiM0MTNFM0UiLz4KPC9zdmc+Cg==";
        function kI(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        dn({
            useProxies: "never"
        });
        const jI = new class {
            constructor(){
                kI(this, "currentAutoRotateIcon", OI), kI(this, "currentRulerIcon", PI), kI(this, "currentFovIcon", UI), kI(this, "currentFovText", "1x"), kI(this, "rulerInstructionShown", !1), kI(this, "tempPointer", new Jo), kI(this, "raycaster", new Pv), kI(this, "tempMatrix", new oc), kI(this, "vrSessionSupported", !1), kI(this, "rulerButtonEnabled", !1), kI(this, "rulersGroup", new kp), kI(this, "renderer", new aS), kI(this, "floorsGroup", new kp), kI(this, "initialPanoramaId", null), kI(this, "rulerModeEnabled", !1), kI(this, "autoRotateState", !1), kI(this, "pointer", new Jo), kI(this, "panoramasGroup", null), kI(this, "initialized", !1), kI(this, "clock", new av), kI(this, "scene", new iI), kI(this, "animation", !1), kI(this, "currentPanoramaId", void 0), kI(this, "interactiveGroup", void 0), kI(this, "tempRuler", null), kI(this, "currentPanorama", void 0), kI(this, "loading", !1), kI(this, "vrControlPanel", void 0), kI(this, "maskCursor", void 0), kI(this, "camera", void 0), kI(this, "bareshell", !1), kI(this, "isFirstRender", !0), kI(this, "onMouseMove", (e1)=>{
                    let { clientX: t, clientY: n } = e1;
                    this.pointer.x = t / Bi.config.width * 2 - 1, this.pointer.y = -n / Bi.config.height * 2 + 1;
                }), kI(this, "onPointerDown", (e1)=>{
                    let { clientX: t, clientY: n } = e1;
                    this.tempPointer.x = Number(t.toFixed(0)), this.tempPointer.y = Number(n.toFixed(0)), this.onMouseMove({
                        clientX: t,
                        clientY: n
                    });
                }), kI(this, "onPointerUp", (e1)=>{
                    let { clientX: t, clientY: n } = e1;
                    if (this.interactiveGroup.hover || !this.currentPanorama) return;
                    const i = Math.abs(this.tempPointer.x - Number(t.toFixed(0))) < 10, r = Math.abs(this.tempPointer.y - Number(n.toFixed(0))) < 10;
                    i && r && (this.rulerModeEnabled ? this.addRulerPoint() : this.onMaskObjectClick());
                }), kI(this, "onControllerMove", (e1)=>{
                    const t = e1.target;
                    this.tempMatrix.identity().extractRotation(t.matrixWorld), this.raycaster.ray.origin.setFromMatrixPosition(t.matrixWorld), this.raycaster.ray.direction.set(0, 0, -1).applyMatrix4(this.tempMatrix);
                }), kI(this, "onControllerSelect", ()=>{
                    this.rulerModeEnabled ? this.addRulerPoint() : this.onMaskObjectClick();
                }), kI(this, "onMaskObjectClick", ()=>{}), Rn(this), this.camera = new nI(this.renderer), this.interactiveGroup = new Jx(this.renderer, this.camera), this.floorsGroup.rotation.y = Math.PI, this.scene.add(this.interactiveGroup, this.rulersGroup, this.floorsGroup), this.addEventListeners();
            }
            get currentViewAngle() {
                const e1 = this.currentCamera.getWorldDirection(new Cl), t = new Cl(-1, 0, 0), n = e1.x * t.x + e1.z * t.z, i = Math.sqrt(Math.pow(e1.x, 2) + Math.pow(e1.z, 2)), r = Math.sqrt(Math.pow(t.x, 2) + Math.pow(t.z, 2)), a = Math.acos(n / (i * r));
                return Math.sign(e1.z) * a;
            }
            get currentCamera() {
                return this.renderer.xr.getCamera().cameras[0] || this.camera;
            }
            get currentControls() {
                return this.camera.deviceOrientationControls.enabled ? this.camera.deviceOrientationControls : this.camera.controls;
            }
            getPanoramaById(e1) {
                return this.panoramasGroup.children.find((t)=>{
                    let { panoramaId: n } = t;
                    return n === e1;
                });
            }
            setLoadingState(e1) {
                this.loading = e1;
            }
            setInitializedState(e1) {
                this.initialized = e1;
            }
            setBareshell(e1) {
                this.bareshell = e1;
            }
            updateWindowSize(e1, t) {
                return this.renderer.setSize(e1, t), this.camera.aspect = e1 / t, this.camera.updateProjectionMatrix(), this.render();
            }
            enableRender() {
                this.renderer.setAnimationLoop(this.render.bind(this));
            }
            disableRender() {
                this.renderer.setAnimationLoop(null);
            }
            render() {
                const e1 = this.clock.getDelta();
                this.currentControls.update(e1), this.camera.updateProjectionMatrix(), this.autoRotateState && !this.camera.controls.disableAutoRotate && (this.camera.controls.azimuthAngle -= Gx(10 * e1)), this.renderer.currentVrSession || this.raycaster.setFromCamera(this.pointer, this.camera), _x.isMobileDevice || (this.tempRuler ? this.updateRuler() : this.updateMask()), this.maskCursor ? this.renderer.domElement.style.cursor = this.maskCursor : this.interactiveGroup.hover && this.interactiveGroup.cursor.length > 0 ? this.renderer.domElement.style.cursor = this.interactiveGroup.cursor : this.rulerModeEnabled ? this.renderer.domElement.style.cursor = "none" : this.camera.controls.holding ? this.renderer.domElement.style.cursor = "grabbing" : this.renderer.domElement.style.cursor = "grab";
                const t = document.querySelector(".widget-tab__panorama-map__fov");
                t && t.style.setProperty("--rotate", -this.currentViewAngle);
                const n = document.querySelector(".camera--current");
                return n && n.style.setProperty("--rotate", -this.currentViewAngle), this.renderer.currentVrSession && this.vrControlPanel.update(this.currentCamera, this.currentViewAngle, this.getPanoramaById(this.currentPanoramaId), this.panoramasGroup), this.renderer.render(this.scene, this.camera), this.isFirstRender && (this.isFirstRender = !1, performance.mark("first render")), this;
            }
            async init(e1, t, n) {
                return this.vrControlPanel = new SI, this.interactiveGroup.add(this.vrControlPanel), this.vrControlPanel.onRulerButtonClick = this.toggleRulerMode.bind(this), this.vrControlPanel.onExitButtonClick = this.exitVr.bind(this), this.vrControlPanel.map.onClick = this.setCurrentPanoramaById.bind(this), this.vrControlPanel.prevFloorButton.onClick = ()=>Bi.setPrevFloorIndex(), this.vrControlPanel.nextFloorButton.onClick = ()=>Bi.setNextFloorIndex(), this.setRulerButtonState(!1), this.cameraFovValues = {
                    x1: Bi.config.panoramaFov,
                    x2: Bi.config.panoramaFov / 2,
                    x05: 1.35 * Bi.config.panoramaFov
                }, this.setCameraFov(this.cameraFovValues[Bi.scales[0]]), this.checkVrSessionSupport(), await this.createPanoramasGroup(e1, t, n), this.setInitializedState(!0), this;
            }
            async createPanoramasGroup(e1, t, n) {
                performance.mark("start creatingPanoramas");
                const i = new rS(n);
                return this.floorsGroup.add(i), this.setCurrentPanoramasGroup(n), this.createPanoramas(e1, t), await this.setInitialCurrentPanorama(), this.interactiveGroup.updateDeepChildren(), this;
            }
            addEventListeners() {
                const { domElement: e1 } = this.renderer;
                e1.addEventListener("contextmenu", (e1)=>e1.preventDefault()), e1.addEventListener("pointerdown", this.onPointerDown), e1.addEventListener("pointerup", this.onPointerUp), e1.addEventListener("mousemove", this.onMouseMove);
            }
            async enterVr() {
                return await this.renderer.enterVR().then(()=>{
                    this.vrControlPanel.setVisibility(!0);
                });
            }
            async exitVr() {
                return await this.renderer.exitVR().then(()=>{
                    this.camera.fov = this.cameraFov, this.vrControlPanel.setVisibility(!1);
                });
            }
            async checkVrSessionSupport() {
                const e1 = await this.renderer.checkVrSessionSupport();
                return this.setVrSessionSupport(e1), this.vrSessionSupported;
            }
            setVrSessionSupport(e1) {
                this.vrSessionSupported = e1;
            }
            resetMaskOptions() {
                this.onMaskObjectClick = ()=>{}, this.maskCursor = null;
            }
            setMaskObjectStairs(e1) {
                const t = e1.RoomID === this.currentPanorama.userData.room_id, n = "url(".concat(t ? "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI1NjZfMikiPgo8cGF0aCBkPSJNMi43MDIyMSAxNS4yOTgxTDE0LjQ0NjggMy41NTM0NiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQuOTA0MzMgMy41NTM0N0wxNC40NDY4IDMuNTUzNDdMMTQuNDQ2OSAxMy4wOTYiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00NS4xOTA0IDQ2LjMzMzNINC44MDk1N0M0LjE3ODM5IDQ2LjMzMzMgMy42NjY3MiA0NS44MjE2IDMuNjY2NzIgNDUuMTkwNFYzNy45OTQ3QzMuNjY2NzIgMzcuMzYzNSA0LjE3ODM5IDM2Ljg1MTggNC44MDk1NyAzNi44NTE4SDEzLjAyNzZDMTMuNjU4OCAzNi44NTE4IDE0LjE3MDUgMzYuMzQwMSAxNC4xNzA1IDM1LjcwOVYyNy4yNDM0QzE0LjE3MDUgMjYuNjEyMiAxNC42ODIyIDI2LjEwMDUgMTUuMzEzNCAyNi4xMDA1SDI0LjE4MjhDMjQuODE0IDI2LjEwMDUgMjUuMzI1NyAyNS41ODg5IDI1LjMyNTcgMjQuOTU3N1YxNS41NjA5QzI1LjMyNTcgMTQuOTI5NyAyNS44MzczIDE0LjQxOCAyNi40Njg1IDE0LjQxOEgzNC42ODY2QzM1LjMxNzggMTQuNDE4IDM1LjgyOTUgMTMuOTA2NCAzNS44Mjk1IDEzLjI3NTJWNC44MDk2QzM1LjgyOTUgNC4xNzg0MiAzNi4zNDExIDMuNjY2NzUgMzYuOTcyMyAzLjY2Njc1SDQ1LjE5MDRDNDUuODIxNiAzLjY2Njc1IDQ2LjMzMzIgNC4xNzg0MiA0Ni4zMzMyIDQuODA5NlY0NS4xOTA0QzQ2LjMzMzIgNDUuODIxNiA0NS44MjE2IDQ2LjMzMzMgNDUuMTkwNCA0Ni4zMzMzWiIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI1NjZfMiI+CjxyZWN0IHdpZHRoPSI0Ny45OTk4IiBoZWlnaHQ9IjQ3Ljk5OTgiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDA2IDEuMDAwMjQpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==" : "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI1NTFfMTcyKSI+CjxwYXRoIGQ9Ik0xNC40NDY4IDMuNTUzNDZMMi43MDIyIDE1LjI5ODEiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMi4yNDQ3IDE1LjI5ODFMMi43MDIyIDE1LjI5ODFMMi43MDIyIDUuNzU1NTciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00NS4xOTA0IDQ2LjMzMzNINC44MDk1N0M0LjE3ODM5IDQ2LjMzMzMgMy42NjY3MiA0NS44MjE2IDMuNjY2NzIgNDUuMTkwNFYzNy45OTQ3QzMuNjY2NzIgMzcuMzYzNSA0LjE3ODM5IDM2Ljg1MTggNC44MDk1NyAzNi44NTE4SDEzLjAyNzZDMTMuNjU4OCAzNi44NTE4IDE0LjE3MDUgMzYuMzQwMSAxNC4xNzA1IDM1LjcwOVYyNy4yNDM0QzE0LjE3MDUgMjYuNjEyMiAxNC42ODIyIDI2LjEwMDUgMTUuMzEzNCAyNi4xMDA1SDI0LjE4MjhDMjQuODE0IDI2LjEwMDUgMjUuMzI1NyAyNS41ODg5IDI1LjMyNTcgMjQuOTU3N1YxNS41NjA5QzI1LjMyNTcgMTQuOTI5NyAyNS44MzczIDE0LjQxOCAyNi40Njg1IDE0LjQxOEgzNC42ODY2QzM1LjMxNzggMTQuNDE4IDM1LjgyOTUgMTMuOTA2NCAzNS44Mjk1IDEzLjI3NTJWNC44MDk2QzM1LjgyOTUgNC4xNzg0MiAzNi4zNDExIDMuNjY2NzUgMzYuOTcyMyAzLjY2Njc1SDQ1LjE5MDRDNDUuODIxNiAzLjY2Njc1IDQ2LjMzMzIgNC4xNzg0MiA0Ni4zMzMyIDQuODA5NlY0NS4xOTA0QzQ2LjMzMzIgNDUuODIxNiA0NS44MjE2IDQ2LjMzMzMgNDUuMTkwNCA0Ni4zMzMzWiIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI1NTFfMTcyIj4KPHJlY3Qgd2lkdGg9IjQ3Ljk5OTgiIGhlaWdodD0iNDcuOTk5OCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDYgMS4wMDAyNCkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K", ") 25 25, pointer"), i = t ? Bi.nextFloorIndex : Bi.prevFloorIndex, r = t ? e1.UpperFloorCameraPointID : e1.LowerFloorCameraPointID, { CameraPoints: a } = Bi.config.json.Floors[i], { id: s } = a.reduce((t, n)=>{
                    const i = [
                        n.Location.X,
                        n.Location.Y
                    ], r = Dy([
                        [
                            e1.Location.X,
                            e1.Location.Y
                        ],
                        i
                    ]);
                    return r < t.length ? {
                        id: n.ID,
                        length: r
                    } : t;
                }, {
                    length: 1 / 0,
                    id: null
                });
                this.initialPanoramaId = r || s, this.maskCursor = n, this.onMaskObjectClick = ()=>t ? Bi.setNextFloorIndex() : Bi.setPrevFloorIndex();
            }
            setMaskObjectDefault() {
                this.maskCursor = "pointer", this.onMaskObjectClick = ()=>{};
            }
            updateMask() {
                const e1 = this.getObjectFromMask(), t = $x.some((t)=>(null == e1 ? void 0 : e1.Model) === t);
                return e1 ? t ? this.setMaskObjectStairs(e1) : this.setMaskObjectDefault() : this.resetMaskOptions();
            }
            getObjectFromMask() {
                if (!this.currentPanorama || !this.currentPanorama.mask) return;
                if (!Bi.config.json || !Bi.config.json.ObjectMaskColorPairs) return;
                if (this.interactiveGroup.hover) return;
                const { direction: e1 } = this.raycaster.ray, t = (1 + Math.atan2(e1.z, e1.x) / Math.PI) / 2, n = Math.acos(e1.y) / Math.PI, { R: i } = Wx(t, n, this.currentPanorama.mask), r = Math.round(i), a = Bi.config.json.ObjectMaskColorPairs.find((e1)=>e1.MaskColorID.R === r);
                return a && "Furniture" === a.Type && kx(Bi.config.json, this.currentPanorama.userData.room_id) ? ((e1, t)=>{
                    for (const n of e1.Floors)for (const e1 of n.Units)for (const n of e1.Rooms)for (const e1 of n.Furniture)if (e1.ID === t) return e1;
                    return null;
                })(Bi.config.json, a.ObjectID) : void 0;
            }
            setRulerInstructionShown(e1) {
                this.rulerInstructionShown = e1;
            }
            setRulerButtonState(e1) {
                this.rulerButtonEnabled = e1, this.vrControlPanel.rulerButtonAvailable = e1;
            }
            setRulerMode(e1) {
                this.rulerModeEnabled = e1, this.vrControlPanel.setRulerIcon(e1), this.rulersGroup.children.forEach((t)=>{
                    const n = !!e1 && t.userData.panoramaId === this.currentPanorama.panoramaId;
                    t.centerPoint && (t.centerPoint.visible = n), t.visible = n;
                }), e1 ? (this.currentRulerIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjkyMjggMTcuODIyTDI1LjM1NSAxNS4zODk3TDMwLjIxOTYgMTAuNTI1MUMzMC42Nzc4IDEwLjA2NyAzMC43MTc0IDkuMzYzNzggMzAuMzA4MSA4Ljk1NDVMMjMuNDA2IDIuMDUyNEMyMi45OTY3IDEuNjQzMTIgMjIuMjkzNSAxLjY4Mjc0IDIxLjgzNTQgMi4xNDA5TDE2Ljk3MDggNy4wMDU0NkwxNC41Mzg1IDkuNDM3NzRNMTkuMzE3OCAyMS40MjdMMTAuNzYxNCAyOS45ODM0QzEwLjMwMzIgMzAuNDQxNSA5LjYgMzAuNDgxMiA5LjE5MDcyIDMwLjA3MTlMMi4yODg2MiAyMy4xNjk4QzEuODc5MzMgMjIuNzYwNSAxLjkxODk2IDIyLjA1NzMgMi4zNzcxMiAyMS41OTkxTDEwLjc2MTQgMTMuMjE0OSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOC4wNDkzIDcuMjU0MzlMMjIuNzQyIDExLjk0NzEiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy40OTA2IDE3LjgxM0wxMi4xODM0IDIyLjUwNTciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMS41NDkyNiAzLjQ5NjA5TDI5LjEwMjMgMzAuODExMyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIuMjgzMjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", _x.isMobileDevice || this.createTempRuler()) : (this.currentRulerIcon = PI, this.destroyTempRuler());
            }
            toggleRulerMode(e1) {
                this.setRulerMode(!this.rulerModeEnabled), e1 && e1.controller && (this.interactiveGroup.controller1.removeEventListener("select", this.onControllerSelect), this.interactiveGroup.controller1.removeEventListener("move", this.onControllerMove), this.interactiveGroup.controller2.removeEventListener("select", this.onControllerSelect), this.interactiveGroup.controller2.removeEventListener("move", this.onControllerMove), e1.controller.addEventListener("select", this.onControllerSelect), e1.controller.addEventListener("move", this.onControllerMove));
            }
            getRulerPoint() {
                const { direction: e1 } = this.raycaster.ray, t = (1 + Math.atan2(e1.z, e1.x) / Math.PI) / 2, n = Math.acos(e1.y) / Math.PI, { R: i } = Wx(t, n, this.currentPanorama.depthMap), r = i || 140;
                return {
                    depthValue: r,
                    position: e1.clone().multiplyScalar(r).add(this.currentCamera.position),
                    quaternion: this.getRulerPointQuaternion()
                };
            }
            getRulerPointQuaternion() {
                const { width: e1, height: t } = this.currentPanorama.depthMap, { direction: n } = this.raycaster.ray, i = [
                    {
                        x: -1,
                        y: -1
                    },
                    {
                        x: 0,
                        y: -1
                    },
                    {
                        x: 1,
                        y: -1
                    },
                    {
                        x: -1,
                        y: 0
                    },
                    {
                        x: 0,
                        y: 0
                    },
                    {
                        x: 1,
                        y: 0
                    },
                    {
                        x: -1,
                        y: 1
                    },
                    {
                        x: 0,
                        y: 1
                    },
                    {
                        x: 1,
                        y: 1
                    }
                ], r = (1 + Math.atan2(n.z, n.x) / Math.PI) / 2, a = Math.acos(n.y) / Math.PI, s = 1 / t, o = 1 / e1, l = Math.round(Math.sqrt(i.length)), c = i.map((e1)=>{
                    let { x: t, y: n } = e1;
                    const i = r + o * t, l = a + s * n, { R: c } = Wx(i, l, this.currentPanorama.depthMap), u = c || 140, h = ((e1, t)=>{
                        const n = new Cl;
                        return n.x = Math.cos((2 * e1 - 1) * Math.PI) * Math.sin(t * Math.PI), n.z = Math.sin((2 * e1 - 1) * Math.PI) * Math.sin(t * Math.PI), n.y = Math.cos(t * Math.PI), n;
                    })(i, l);
                    return h.clone().multiplyScalar(u).add(this.currentCamera.position);
                }), u = new Cl(0, 0, 0);
                for(let e1 = 0; e1 < l - 1; e1++)for(let t = 0; t < l - 1; t++){
                    const n = e1 * l + t, i = (e1 + 1) * l + t, r = c[n], a = c[n + 1], s = c[i], o = c[i + 1];
                    u.add(Zx(r, a, s)), u.add(Zx(a, o, s));
                }
                u.normalize();
                const h = new Cl(0, Math.sign(n.y), 0), d = (new Cl).crossVectors(h, u), p = u.angleTo(h);
                return (new Dl).setFromAxisAngle(d, p);
            }
            updateRuler() {
                if (this.interactiveGroup.hover) return;
                const { position: e1, quaternion: t } = this.getRulerPoint();
                return this.tempRuler.secondPoint ? this.tempRuler.update(e1, t) : this.tempRuler.firstPoint.update(e1, t);
            }
            finishRuler() {
                return this.interactiveGroup.add(this.tempRuler.centerPoint), this.tempRuler.centerPoint.addEventListeners(), this.tempRuler = null, this;
            }
            addRulerPoint() {
                if (this.interactiveGroup.hover) return;
                const { position: e1, quaternion: t } = this.getRulerPoint();
                return _x.isMobileDevice ? this.tempRuler ? void (this.tempRuler.firstPoint && (this.tempRuler.createRest(e1, t), this.updateRuler(), this.finishRuler())) : this.createTempRuler() : this.tempRuler.secondPoint ? (this.finishRuler(), this.createTempRuler()) : this.tempRuler.createRest(e1, t);
            }
            createTempRuler() {
                const { position: e1, quaternion: t } = this.getRulerPoint();
                return this.tempRuler = new zI(this.currentPanorama.panoramaId), this.tempRuler.createFirstPoint(e1, t), this.rulersGroup.add(this.tempRuler), this;
            }
            destroyTempRuler() {
                return this.tempRuler ? (this.tempRuler.dispose(), this.tempRuler = null, this) : this;
            }
            setCameraFov(e1) {
                this.camera.fov = e1, this.cameraFov = e1, e1 === this.cameraFovValues.x1 && (this.currentFovIcon = UI, this.currentFovText = "1x"), e1 === this.cameraFovValues.x2 && (this.currentFovIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjcwNzYgMjQuOTA2N1YyMS45OTc5SDUuMTYyMTRMOC44MjY0MSAxOC4yMTUxQzkuNDU5NDEgMTcuNTgwMyAxMC4wMzQ1IDE2Ljk3NTkgMTAuNTUxNiAxNi40MDJDMTEuMDY4NyAxNS44MTkzIDExLjUxNDQgMTUuMjQ5NyAxMS44ODg5IDE0LjY5MzJDMTIuMjU0NCAxNC4xMzY3IDEyLjUzNTMgMTMuNTc1OCAxMi43MzE0IDEzLjAxMDVDMTIuOTM2NSAxMi40MzY2IDEzLjAzOSAxMS44MzY2IDEzLjAzOSAxMS4yMTA0QzEzLjAzOSAxMC4zODQzIDEyLjkwNTIgOS42MzIxMiAxMi42Mzc4IDguOTUzODNDMTIuMzcwMyA4LjI2Njg0IDExLjk4MjUgNy42Nzk4NiAxMS40NzQzIDcuMTkyODhDMTAuOTU3MiA2LjcwNTkxIDEwLjMxNTMgNi4zMjc2MyA5LjU0ODU2IDYuMDU4MDVDOC43OTA3NSA1Ljc4ODQ3IDcuOTE3MDMgNS42NTM2OSA2LjkyNzQxIDUuNjUzNjlDNS44OTMyMSA1LjY1MzY5IDQuOTQ4MTcgNS44MTg5MSA0LjA5MjI4IDYuMTQ5MzZDMy4yNDUzMSA2LjQ3MTExIDIuNTIzMTYgNi45MTQ2MSAxLjkyNTgyIDcuNDc5ODVDMS4zMTk1NiA4LjA0NTA5IDAuODUxNSA4LjcwNTk5IDAuNTIxNjI3IDkuNDYyNTVDMC4xOTE3NTQgMTAuMjEwNCAwLjAyNjgxNzMgMTEuMDA2MSAwLjAyNjgxNzMgMTEuODQ5NkgzLjc1Nzk1QzMuNzU3OTUgMTEuMzM2NSAzLjgyNDgyIDEwLjg4IDMuOTU4NTUgMTAuNDhDNC4wOTIyOCAxMC4wOCA0LjI4ODQyIDkuNzQ1MTcgNC41NDY5NyA5LjQ3NTU5QzQuNzk2NjEgOS4yMTQ3MSA1LjEwODY1IDkuMDE5MDUgNS40ODMxIDguODg4NjFDNS44NjY0NyA4Ljc0OTQ3IDYuMzA3NzggOC42Nzk5IDYuODA3MDUgOC42Nzk5QzcuMTkwNDIgOC42Nzk5IDcuNTM4MTIgOC43NDA3NyA3Ljg1MDE2IDguODYyNTJDOC4xNzExMiA4Ljk4NDI2IDguNDQ3NSA5LjE1ODE4IDguNjc5MyA5LjM4NDI4QzguOTAyMTkgOS42MTkwNyA5LjA3NjA0IDkuOTAxNjkgOS4yMDA4NiAxMC4yMzIxQzkuMzI1NjggMTAuNTYyNiA5LjM4ODA5IDEwLjk0MDkgOS4zODgwOSAxMS4zNjdDOS4zODgwOSAxMS42NTM5IDkuMzM5MDUgMTEuOTQ5NiA5LjI0MDk4IDEyLjI1NEM5LjE1MTgzIDEyLjU1ODMgOS4wMDQ3MiAxMi44ODQ0IDguNzk5NjYgMTMuMjMyM0M4LjU4NTY5IDEzLjU4ODggOC4zMDkzMSAxMy45ODAxIDcuOTcwNTIgMTQuNDA2MkM3LjYzMTczIDE0LjgzMjMgNy4yMTcxNiAxNS4zMDYzIDYuNzI2ODEgMTUuODI4TDAuNDI4MDE1IDIyLjQyODNWMjQuOTA2N0gxMy43MDc2WiIgZmlsbD0iIzQxM0UzRSIvPgo8cGF0aCBkPSJNMjQuMDQ1MiAxNS4yMDE5TDIwLjkxNTggMTAuNzkzSDE2LjkxNzJMMjEuNzU4MyAxNy43MTk0TDE2LjczIDI0LjkwNjdIMjAuNzU1M0wyNC4wNTg1IDIwLjI4OTFMMjcuMzg4NSAyNC45MDY3SDMxLjQwMDRMMjYuMzcyMSAxNy43MTk0TDMxLjIyNjYgMTAuNzkzSDI3LjIyOEwyNC4wNDUyIDE1LjIwMTlaIiBmaWxsPSIjNDEzRTNFIi8+Cjwvc3ZnPgo=", this.currentFovText = "2x"), e1 === this.cameraFovValues.x05 && (this.currentFovIcon = "data:image/svg+xml;base64,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", this.currentFovText = "0.5x");
            }
            toggleFov() {
                const e1 = Object.entries(this.cameraFovValues).find((e1)=>{
                    let [t, n] = e1;
                    return n === this.camera.fov;
                })[0], t = Bi.scales.findIndex((t)=>t === e1);
                Bi.scales[t + 1] ? this.setCameraFov(this.cameraFovValues[Bi.scales[t + 1]]) : this.setCameraFov(this.cameraFovValues[Bi.scales[0]]);
            }
            setAutoRotateState(e1) {
                this.autoRotateState = e1, this.currentAutoRotateIcon = e1 ? "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzgiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzOCAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjc2IDI2LjQxNDNDMjUuNDIxIDI2LjA2NjYgMjcuOTA3NCAyNS4zMjI1IDI5Ljk2ODUgMjQuMjM4M0MzMi45MDcxIDIyLjY5MjYgMzQuNzc1MyAyMC41NjM5IDM1LjIxNjMgMTguMjU4OEMzNS42NTczIDE1Ljk1MzcgMzQuNjQwMSAxMy42MzM4IDMyLjM1OTEgMTEuNzQyMkMzMC4wNzgxIDkuODUwNTEgMjYuNjkzMSA4LjUxOTY4IDIyLjg1MDUgOC4wMDM4NUMxOS4wMDggNy40ODgwMiAxNC45NzczIDcuODIzMzQgMTEuNTI4MiA4Ljk0NTc3QzguMDc5MTEgMTAuMDY4MiA1LjQ1MzM5IDExLjg5OTEgNC4xNTI1MiAxNC4wODg3QzMuODE4MTEgMTQuNjUxNiAzLjU3NzI4IDE1LjIyOCAzLjQyOTY1IDE1LjgxMDMiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTI1LjI1MzYgMTkuNDMzM0wxOS45Njg3IDI2LjA4MzlMMjYuMDg3MyAzMC45NDYzIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNC40Nzg1IDIwLjk2OTdMNS40MTAyMyAzMC4wMzgiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0LjQ3ODUgMzAuMDM4TDUuNDEwMjMgMjAuOTY5NyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K" : OI;
            }
            toggleAutoRotate() {
                this.setAutoRotateState(!this.autoRotateState), this.autoRotateState ? this.camera.deviceOrientationControls.disable() : _x.deviceOrientationGranted && this.camera.deviceOrientationControls.enable();
            }
            setCurrentPanoramasGroup(e1) {
                const t = this.floorsGroup.children.find((t)=>t.floorIndex === e1);
                if (t) return this.panoramasGroup = t, this.vrControlPanel.map.updateRoomsLayer(t), this.vrControlPanel.updateFloorMaterials(), this;
            }
            async setCurrentPanoramaById(e1) {
                var t;
                if ((null === (t = this.currentPanorama) || void 0 === t ? void 0 : t.panoramaId) === e1) return;
                const n = this.getPanoramaById(e1);
                if (this.animation || !n) return this;
                if (this.setCurrentPanoramaId(e1), this.animation = !0, Bi.config.bareshell && n.loaded && (this.setLoadingState(!0), performance.mark("start downloadingPanoramas"), await n.load(), performance.mark("finish downloadingPanoramas"), performance.measure("downloadingPanorama", "start downloadingPanoramas", "finish downloadingPanoramas"), this.setLoadingState(!1)), !n.loaded && (this.setLoadingState(!0), performance.mark("start downloadingPanoramas"), await n.load(), performance.mark("finish downloadingPanoramas"), performance.measure("downloadingPanoramas", "start downloadingPanoramas", "finish downloadingPanoramas"), this.setLoadingState(!1), Bi.config.enableCameraRotationBetweenPanoramas && 0 !== n.userData.rotation)) {
                    const e1 = !!Bi.config.enableCameraTransitionBetweenPanoramas && this.currentPanorama;
                    setTimeout(()=>{
                        this.camera.controls.normalizeRotations();
                        const t = Qx(this.camera.controls.azimuthAngle), i = Qx(n.userData.rotation), r = Gx(((e1, t)=>{
                            const n = (t - e1) % 360;
                            return n > 180 ? n - 360 : n < -180 ? n + 360 : n;
                        })(t, i));
                        this.camera.controls.rotate(r, 0, e1);
                    }, e1 ? 200 : 0);
                }
                for (const e1 of (null === (i = this.currentPanorama) || void 0 === i ? void 0 : i.links) || []){
                    var i;
                    e1.visible = !1;
                }
                for (const e1 of n.links)e1.visible = !0;
                if (this.rulerModeEnabled) for (const t of this.rulersGroup.children){
                    const n = t.userData.panoramaId === e1;
                    t.centerPoint && (t.centerPoint.visible = n), t.visible = n;
                }
                this.currentPanorama && (this.currentPanorama.renderOrder = 0), n.renderOrder = 1, n.visible = !0, await n.fadeIn(), this.currentPanorama && (await this.currentPanorama.fadeOut(), this.currentPanorama.visible = !1);
                const r = null !== n.depthMap;
                return this.setCurrentPanorama(n), this.animation = !1, this.destroyTempRuler(), this.setRulerButtonState(r), this.rulerModeEnabled && this.setRulerMode(r), this;
            }
            setCurrentPanoramaId(e1) {
                this.currentPanoramaId = e1;
            }
            setCurrentPanorama(e1) {
                this.currentPanorama = e1;
            }
            async setInitialCurrentPanorama() {
                const e1 = this.panoramasGroup.children.find((e1)=>0 === e1.userData.panorama_index), t = this.initialPanoramaId || (null == e1 ? void 0 : e1.panoramaId) || null;
                return this.setCurrentPanoramaById(t).then(()=>{
                    this.initialPanoramaId = null;
                });
            }
            createPanoramas(e1, t) {
                const n = this.panoramasGroup.createPanoramas(e1, t);
                for (const e1 of n)for (const t of e1.links)t.onClick = ()=>this.setCurrentPanoramaById(t.userData.targetId), this.interactiveGroup.add(t);
                return this;
            }
        }, BI = jI;
        if (!t.useState) throw new Error("mobx-react-lite requires React with Hooks support");
        var FI = n(834);
        function HI(e1) {
            e1();
        }
        function VI(e1) {
            var t;
            return fn(Mi(e1, t));
        }
        var GI = function() {
            function e1(e1) {
                var t = this;
                Object.defineProperty(this, "finalize", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: e1
                }), Object.defineProperty(this, "registrations", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: new Map
                }), Object.defineProperty(this, "sweepTimeout", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: void 0
                }), Object.defineProperty(this, "sweep", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: function(e1) {
                        void 0 === e1 && (e1 = 1e4), clearTimeout(t.sweepTimeout), t.sweepTimeout = void 0;
                        var n = Date.now();
                        t.registrations.forEach(function(i, r) {
                            n - i.registeredAt >= e1 && (t.finalize(i.value), t.registrations.delete(r));
                        }), t.registrations.size > 0 && t.scheduleSweep();
                    }
                }), Object.defineProperty(this, "finalizeAllImmediately", {
                    enumerable: !0,
                    configurable: !0,
                    writable: !0,
                    value: function() {
                        t.sweep(0);
                    }
                });
            }
            return Object.defineProperty(e1.prototype, "register", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function(e1, t, n) {
                    this.registrations.set(n, {
                        value: t,
                        registeredAt: Date.now()
                    }), this.scheduleSweep();
                }
            }), Object.defineProperty(e1.prototype, "unregister", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function(e1) {
                    this.registrations.delete(e1);
                }
            }), Object.defineProperty(e1.prototype, "scheduleSweep", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function() {
                    void 0 === this.sweepTimeout && (this.sweepTimeout = setTimeout(this.sweep, 1e4));
                }
            }), e1;
        }(), QI = new ("undefined" != typeof FinalizationRegistry ? FinalizationRegistry : GI)(function(e1) {
            var t;
            null === (t = e1.reaction) || void 0 === t || t.dispose(), e1.reaction = null;
        }), WI = !1;
        function YI() {
            return WI;
        }
        var XI = function(e1, t) {
            var n = "function" == typeof Symbol && e1[Symbol.iterator];
            if (!n) return e1;
            var i, r, a = n.call(e1), s = [];
            try {
                for(; (void 0 === t || t-- > 0) && !(i = a.next()).done;)s.push(i.value);
            } catch (e1) {
                r = {
                    error: e1
                };
            } finally{
                try {
                    i && !i.done && (n = a.return) && n.call(a);
                } finally{
                    if (r) throw r.error;
                }
            }
            return s;
        };
        function ZI(e1) {
            return "observer".concat(e1);
        }
        var qI = function() {};
        function KI() {
            return new qI;
        }
        var JI = "function" == typeof Symbol && Symbol.for, $I = JI ? Symbol.for("react.forward_ref") : "function" == typeof t.forwardRef && (0, t.forwardRef)(function(e1) {
            return null;
        }).$$typeof, eN = JI ? Symbol.for("react.memo") : "function" == typeof t.memo && (0, t.memo)(function(e1) {
            return null;
        }).$$typeof;
        function tN(e1, n) {
            var i;
            if (eN && e1.$$typeof === eN) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
            if (YI()) return e1;
            var r = null !== (i = null == n ? void 0 : n.forwardRef) && void 0 !== i && i, a = e1, s = e1.displayName || e1.name;
            if ($I && e1.$$typeof === $I && (r = !0, "function" != typeof (a = e1.render))) throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
            var o, l, c = function(e1, n) {
                return function(e1, n) {
                    if (void 0 === n && (n = "observed"), YI()) return e1();
                    var i = XI(t.useState(KI), 1)[0], r = XI(t.useState(), 2)[1], a = function() {
                        return r([]);
                    }, s = t.useRef(null);
                    s.current || (s.current = {
                        reaction: null,
                        mounted: !1,
                        changedBeforeMount: !1
                    });
                    var o, l, c = s.current;
                    if (c.reaction || (c.reaction = new Vt(ZI(n), function() {
                        c.mounted ? a() : c.changedBeforeMount = !0;
                    }), QI.register(i, c, c)), t.useDebugValue(c.reaction, VI), t.useEffect(function() {
                        return QI.unregister(c), c.mounted = !0, c.reaction ? c.changedBeforeMount && (c.changedBeforeMount = !1, a()) : (c.reaction = new Vt(ZI(n), function() {
                            a();
                        }), a()), function() {
                            c.reaction.dispose(), c.reaction = null, c.mounted = !1, c.changedBeforeMount = !1;
                        };
                    }, []), c.reaction.track(function() {
                        try {
                            o = e1();
                        } catch (e1) {
                            l = e1;
                        }
                    }), l) throw l;
                    return o;
                }(function() {
                    return a(e1, n);
                }, s);
            };
            return "" !== s && (c.displayName = s), e1.contextTypes && (c.contextTypes = e1.contextTypes), r && (c = (0, t.forwardRef)(c)), o = e1, l = c = (0, t.memo)(c), Object.keys(o).forEach(function(e1) {
                nN[e1] || Object.defineProperty(l, e1, Object.getOwnPropertyDescriptor(o, e1));
            }), c;
        }
        var nN = {
            $$typeof: !0,
            render: !0,
            compare: !0,
            type: !0,
            displayName: !0
        };
        !function(e1) {
            e1 || (e1 = HI), dn({
                reactionScheduler: e1
            });
        }(FI.unstable_batchedUpdates), QI.finalizeAllImmediately;
        const iN = {
            smallMobile: 374,
            mobile: 670,
            tablet: 1100,
            laptop: 1440
        }, rN = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA1MSA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5LjQwODkgMTAuMjc2OUwxMS4wMzQ1IDM4LjY1MTMiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTM5LjQwODkgMzguNjUxM0wxMS4wMzQ1IDEwLjI3NjkiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==", aN = tN(()=>Xi.enabled ? Xi.active ? t.createElement("button", {
                type: "button",
                className: "widget-exit-fullscreen",
                onClick: ()=>Xi.exit()
            }, t.createElement("img", {
                src: rN,
                alt: "exit-fullscreen"
            })) : t.createElement("button", {
                type: "button",
                className: "widget-enter-fullscreen",
                onClick: ()=>Xi.enter()
            }, t.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTEiIHZpZXdCb3g9IjAgMCA1MCA1MSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxLjI1IDkuODc1SDQwLjYyNVYxOS4yNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjkuNjg3NSAyMC44MTI1TDQwLjYyNSA5Ljg3NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTguNzUgNDEuMTI1SDkuMzc1VjMxLjc1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMC4zMTI1IDMwLjE4NzVMOS4zNzUgNDEuMTI1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=",
                alt: "enter-fullscreen"
            })) : null), sN = tN(()=>{
            const [e1, n] = (0, t.useState)(!1), i = (e1)=>Oy("floor", e1), r = Bi.config.floors.map((e1, t)=>({
                    label: i(t + 1),
                    value: t,
                    class: "floors-select--block-item",
                    classActive: "floors-select--block-item floors-select--block-item--active"
                }));
            return (0, t.useEffect)(()=>{
                document.addEventListener("click", (e1)=>{
                    e1.target.closest(".floors-select") || n(!1);
                });
            }, []), r.length > 1 && t.createElement("div", {
                id: "floors-select",
                onClick: ()=>n(!e1),
                className: "floors-select"
            }, t.createElement("div", {
                className: "floors-select--text"
            }, i(Bi.currentFloorIndex + 1)), e1 && t.createElement("div", {
                className: "floors-select--block"
            }, r.map((e1)=>t.createElement("div", {
                    key: e1.value,
                    onClick: ()=>((e1)=>{
                            let { value: t } = e1;
                            Bi.setCurrentFloorIndex(t), n(!1);
                        })(e1),
                    className: Bi.currentFloorIndex === e1.value ? e1.classActive : e1.class
                }, e1.label))));
        }), oN = sN, lN = tN(()=>{
            const [e1, n] = (0, t.useState)(!1);
            return t.createElement("button", {
                type: "button",
                className: "widget-tab-button",
                disabled: e1,
                onClick: async ()=>{
                    n(!0), BI.enterVr().finally(()=>n(!1));
                }
            }, "VR");
        }), cN = (e1)=>{
            let { active: n, text: i, img: r, onClick: a } = e1;
            return t.createElement("button", {
                type: "button",
                className: "widget-tab-button ".concat(n ? "widget-tab-button--active" : ""),
                onClick: a
            }, i, Boolean(r) && t.createElement("img", {
                src: r,
                alt: "icon"
            }));
        }, uN = (e1)=>{
            let { href: n, text: i } = e1;
            return t.createElement("a", {
                href: n,
                target: "_blank",
                rel: "noreferrer"
            }, t.createElement("span", null, "made by"), " ", i);
        };
        var hN = n(300), dN = n.n(hN);
        function pN(e1, t, n) {
            (function(e1, t) {
                if (t.has(e1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(e1, t), t.set(e1, n);
        }
        function fN(e1, t) {
            return e1.get(gN(e1, t));
        }
        function mN(e1, t, n) {
            return e1.set(gN(e1, t), n), n;
        }
        function gN(e1, t, n) {
            if ("function" == typeof e1 ? e1 === t : e1.has(t)) return arguments.length < 3 ? t : n;
            throw new TypeError("Private element is not present on this object");
        }
        var AN = new WeakMap, vN = new WeakMap, MN = new WeakMap;
        const yN = class {
            constructor(e1, t){
                pN(this, AN, null), pN(this, vN, null), pN(this, MN, null), mN(vN, this, t), mN(MN, this, {
                    container: {
                        mousedown: (e1)=>{
                            0 === e1.button && mN(AN, this, e1.pageX);
                        },
                        touchstart: (e1)=>mN(AN, this, e1.touches[0].clientX),
                        touchend: ()=>mN(AN, this, null)
                    },
                    prev: {
                        mousedown: (t)=>{
                            t.preventDefault(), e1.play(!0);
                        },
                        mouseup: (t)=>{
                            t.preventDefault(), e1.stop();
                        },
                        touchstart: (t)=>{
                            t.preventDefault(), e1.prev();
                        }
                    },
                    next: {
                        mousedown: (t)=>{
                            t.preventDefault(), e1.play();
                        },
                        mouseup: (t)=>{
                            t.preventDefault(), e1.stop();
                        },
                        touchstart: (t)=>{
                            t.preventDefault(), e1.next();
                        }
                    },
                    global: {
                        mouseup: ()=>mN(AN, this, null),
                        mousemove: (t)=>{
                            fN(AN, this) && Math.abs(fN(AN, this) - t.pageX) > fN(vN, this).dragTolerance && (e1.stop(), fN(AN, this) > t.pageX ? e1.prev() : e1.next(), mN(AN, this, t.pageX));
                        },
                        touchmove: (t)=>{
                            2 !== t.touches.length && (1 === t.touches.length && t.stopPropagation(), fN(AN, this) && Math.abs(fN(AN, this) - t.touches[0].clientX) > fN(vN, this).swipeTolerance && (e1.stop(), fN(AN, this) > t.touches[0].clientX ? e1.prev() : e1.next(), mN(AN, this, t.touches[0].clientX)));
                        },
                        keydown: (t)=>{
                            [
                                37,
                                39
                            ].includes(t.keyCode) && e1.play(37 === t.keyCode);
                        },
                        keyup: (t)=>{
                            [
                                37,
                                39
                            ].includes(t.keyCode) && e1.stop();
                        }
                    }
                }), this._initEvents();
            }
            destroy() {
                fN(vN, this).swipeTarget.removeEventListener("mousedown", fN(MN, this).container.mousedown), fN(vN, this).swipeTarget.removeEventListener("touchstart", fN(MN, this).container.touchstart), fN(vN, this).swipeTarget.removeEventListener("touchend", fN(MN, this).container.touchend), n.g.removeEventListener("mouseup", fN(MN, this).global.mouseup), n.g.removeEventListener("mousemove", fN(MN, this).global.mousemove), fN(vN, this).parentElement.removeEventListener("touchmove", fN(MN, this).global.touchmove), n.g.removeEventListener("keydown", fN(MN, this).global.keydown), n.g.removeEventListener("keyup", fN(MN, this).global.keyup), fN(vN, this).prev && (fN(vN, this).prev.removeEventListener("mousedown", fN(MN, this).prev.mousedown), fN(vN, this).prev.removeEventListener("mouseup", fN(MN, this).prev.mouseup), fN(vN, this).prev.removeEventListener("touchstart", fN(MN, this).prev.touchstart)), fN(vN, this).next && (fN(vN, this).next.removeEventListener("mousedown", fN(MN, this).next.mousedown), fN(vN, this).next.removeEventListener("mouseup", fN(MN, this).next.mouseup), fN(vN, this).next.removeEventListener("touchstart", fN(MN, this).next.touchstart));
            }
            _initEvents() {
                fN(vN, this).draggable && (fN(vN, this).swipeTarget.addEventListener("mousedown", fN(MN, this).container.mousedown), n.g.addEventListener("mouseup", fN(MN, this).global.mouseup), n.g.addEventListener("mousemove", fN(MN, this).global.mousemove)), fN(vN, this).swipeable && (fN(vN, this).swipeTarget.addEventListener("touchstart", fN(MN, this).container.touchstart), fN(vN, this).swipeTarget.addEventListener("touchend", fN(MN, this).container.touchend), fN(vN, this).parentElement.addEventListener("touchmove", fN(MN, this).global.touchmove)), fN(vN, this).keys && (n.g.addEventListener("keydown", fN(MN, this).global.keydown), n.g.addEventListener("keyup", fN(MN, this).global.keyup)), fN(vN, this).prev && (fN(vN, this).prev.addEventListener("mousedown", fN(MN, this).prev.mousedown), fN(vN, this).prev.addEventListener("mouseup", fN(MN, this).prev.mouseup), fN(vN, this).prev.addEventListener("touchstart", fN(MN, this).prev.touchstart)), fN(vN, this).next && (fN(vN, this).next.addEventListener("mousedown", fN(MN, this).next.mousedown), fN(vN, this).next.addEventListener("mouseup", fN(MN, this).next.mouseup), fN(vN, this).next.addEventListener("touchstart", fN(MN, this).next.touchstart));
            }
        };
        function xN(e1, t, n) {
            (function(e1, t) {
                if (t.has(e1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
            })(e1, t), t.set(e1, n);
        }
        function _N(e1, t) {
            return e1.get(wN(e1, t));
        }
        function bN(e1, t, n) {
            return e1.set(wN(e1, t), n), n;
        }
        function wN(e1, t, n) {
            if ("function" == typeof e1 ? e1 === t : e1.has(t)) return arguments.length < 3 ? t : n;
            throw new TypeError("Private element is not present on this object");
        }
        var EN = new WeakMap, TN = new WeakMap, SN = new WeakMap, IN = new WeakMap, NN = new WeakMap, DN = new WeakMap;
        const CN = class {
            constructor(e1, t){
                xN(this, EN, null), xN(this, TN, 0), xN(this, SN, null), xN(this, IN, !1), xN(this, NN, null), xN(this, DN, !1), this.container = e1, bN(EN, this, Object.assign({
                    width: 300,
                    height: 300,
                    aspectRatio: 0,
                    count: 0,
                    perRow: 0,
                    speed: 100,
                    dragTolerance: 10,
                    swipeTolerance: 10,
                    draggable: !0,
                    swipeable: !0,
                    keys: !0,
                    inverted: !1
                }, t)), _N(EN, this).swipeTarget = _N(EN, this).swipeTarget || this.container, bN(DN, this, !Array.isArray(_N(EN, this).image)), this.sprite || (_N(EN, this).count = _N(EN, this).image.length), Object.freeze(_N(EN, this)), bN(NN, this, new yN(this, _N(EN, this))), this._windowResizeListener = this._windowResizeListener.bind(this), this._initContainer();
            }
            get isResponsive() {
                return _N(EN, this).aspectRatio > 0;
            }
            get containerWidth() {
                return this.isResponsive ? this.container.clientWidth : _N(EN, this).width;
            }
            get containerHeight() {
                return this.isResponsive ? this.container.clientWidth * _N(EN, this).aspectRatio : _N(EN, this).height;
            }
            get index() {
                return _N(TN, this);
            }
            get looping() {
                return _N(IN, this);
            }
            get sprite() {
                return _N(DN, this);
            }
            next() {
                this.goto(_N(EN, this).inverted ? _N(TN, this) - 1 : _N(TN, this) + 1);
            }
            prev() {
                this.goto(_N(EN, this).inverted ? _N(TN, this) + 1 : _N(TN, this) - 1);
            }
            goto(e1) {
                bN(TN, this, (_N(EN, this).count + e1) % _N(EN, this).count), this._update();
            }
            play(e1) {
                this.looping || (this._loop(e1), bN(IN, this, !0));
            }
            stop() {
                this.looping && (n.g.clearTimeout(_N(SN, this)), bN(IN, this, !1));
            }
            toggle(e1) {
                this.looping ? this.stop() : this.play(e1);
            }
            destroy() {
                this.stop(), _N(NN, this).destroy(), this.container.style.width = "", this.container.style.height = "", this.container.style.backgroundImage = "", this.container.style.backgroundPositionX = "", this.container.style.backgroundPositionY = "", this.container.style.backgroundSize = "", this.isResponsive && window.removeEventListener("resize", this._windowResizeListener);
            }
            _loop(e1) {
                e1 ? this.prev() : this.next(), bN(SN, this, n.g.setTimeout(()=>{
                    this._loop(e1);
                }, _N(EN, this).speed));
            }
            _update() {
                this.sprite ? (this.container.style.backgroundPositionX = -_N(TN, this) % _N(EN, this).perRow * this.containerWidth + "px", this.container.style.backgroundPositionY = -Math.floor(_N(TN, this) / _N(EN, this).perRow) * this.containerHeight + "px") : this.container.style.backgroundImage = 'url("'.concat(_N(EN, this).image[_N(TN, this)], '")');
            }
            _windowResizeListener() {
                this.container.style.height = this.containerHeight + "px", this._update();
            }
            _initContainer() {
                if (this.isResponsive || (this.container.style.width = this.containerWidth + "px"), this.container.style.height = this.containerHeight + "px", this.sprite) {
                    this.container.style.backgroundImage = 'url("'.concat(_N(EN, this).image, '")');
                    const e1 = _N(EN, this).perRow, t = Math.ceil(_N(EN, this).count / _N(EN, this).perRow);
                    this.container.style.backgroundSize = 100 * e1 + "% " + 100 * t + "%";
                }
                this.isResponsive && window.addEventListener("resize", this._windowResizeListener), this._update();
            }
        }, LN = (e1)=>{
            let { initialized: n, images: i, activeIndex: r } = e1;
            return t.createElement(t.Fragment, null, t.createElement("div", {
                className: "widget-tab__threesixty ".concat(n ? "widget-tab__threesixty--active" : "")
            }, t.createElement("div", {
                className: "widget-tab__threesixty-container",
                onTouchMove: (e1)=>{
                    e1.touches.length > 1 || n || e1.stopPropagation();
                }
            }, i.map((e1, n)=>t.createElement("img", {
                    className: r === n ? "active" : "",
                    alt: "rotation-view-".concat(n),
                    key: n,
                    src: e1
                })))));
        }, RN = (e1)=>{
            let { steps: n = [], disabled: i = !1, onClick: r = ()=>{} } = e1;
            const a = Oy("instructions-hint-text");
            return t.createElement("div", {
                className: "widget-instructions",
                onClick: ()=>{
                    i || r();
                }
            }, t.createElement("div", {
                className: "widget-instructions__content",
                onClick: (e1)=>e1.stopPropagation()
            }, t.createElement("div", {
                className: "widget-instructions__steps"
            }, n.map((e1, n)=>{
                let { text: i, icon: r } = e1;
                return t.createElement("div", {
                    className: "widget-instructions__step",
                    key: n
                }, t.createElement("img", {
                    src: r,
                    alt: "step-icon"
                }), t.createElement("p", null, i));
            })), t.createElement("button", {
                disabled: i,
                onClick: r,
                type: "button"
            }, Oy("ok")), Boolean(a) && t.createElement("div", {
                className: "widget-instructions__hint"
            }, t.createElement("p", null, a))));
        };
        class zN {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                zN.prototype.isVector4 = !0, this.x = e1, this.y = t, this.z = n, this.w = i;
            }
            get width() {
                return this.z;
            }
            set width(e1) {
                this.z = e1;
            }
            get height() {
                return this.w;
            }
            set height(e1) {
                this.w = e1;
            }
            set(e1, t, n, i) {
                return this.x = e1, this.y = t, this.z = n, this.w = i, this;
            }
            setScalar(e1) {
                return this.x = e1, this.y = e1, this.z = e1, this.w = e1, this;
            }
            setX(e1) {
                return this.x = e1, this;
            }
            setY(e1) {
                return this.y = e1, this;
            }
            setZ(e1) {
                return this.z = e1, this;
            }
            setW(e1) {
                return this.w = e1, this;
            }
            setComponent(e1, t) {
                switch(e1){
                    case 0:
                        this.x = t;
                        break;
                    case 1:
                        this.y = t;
                        break;
                    case 2:
                        this.z = t;
                        break;
                    case 3:
                        this.w = t;
                        break;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
                return this;
            }
            getComponent(e1) {
                switch(e1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    case 3:
                        return this.w;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z, this.w);
            }
            copy(e1) {
                return this.x = e1.x, this.y = e1.y, this.z = e1.z, this.w = void 0 !== e1.w ? e1.w : 1, this;
            }
            add(e1) {
                return this.x += e1.x, this.y += e1.y, this.z += e1.z, this.w += e1.w, this;
            }
            addScalar(e1) {
                return this.x += e1, this.y += e1, this.z += e1, this.w += e1, this;
            }
            addVectors(e1, t) {
                return this.x = e1.x + t.x, this.y = e1.y + t.y, this.z = e1.z + t.z, this.w = e1.w + t.w, this;
            }
            addScaledVector(e1, t) {
                return this.x += e1.x * t, this.y += e1.y * t, this.z += e1.z * t, this.w += e1.w * t, this;
            }
            sub(e1) {
                return this.x -= e1.x, this.y -= e1.y, this.z -= e1.z, this.w -= e1.w, this;
            }
            subScalar(e1) {
                return this.x -= e1, this.y -= e1, this.z -= e1, this.w -= e1, this;
            }
            subVectors(e1, t) {
                return this.x = e1.x - t.x, this.y = e1.y - t.y, this.z = e1.z - t.z, this.w = e1.w - t.w, this;
            }
            multiply(e1) {
                return this.x *= e1.x, this.y *= e1.y, this.z *= e1.z, this.w *= e1.w, this;
            }
            multiplyScalar(e1) {
                return this.x *= e1, this.y *= e1, this.z *= e1, this.w *= e1, this;
            }
            applyMatrix4(e1) {
                const t = this.x, n = this.y, i = this.z, r = this.w, a = e1.elements;
                return this.x = a[0] * t + a[4] * n + a[8] * i + a[12] * r, this.y = a[1] * t + a[5] * n + a[9] * i + a[13] * r, this.z = a[2] * t + a[6] * n + a[10] * i + a[14] * r, this.w = a[3] * t + a[7] * n + a[11] * i + a[15] * r, this;
            }
            divideScalar(e1) {
                return this.multiplyScalar(1 / e1);
            }
            setAxisAngleFromQuaternion(e1) {
                this.w = 2 * Math.acos(e1.w);
                const t = Math.sqrt(1 - e1.w * e1.w);
                return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e1.x / t, this.y = e1.y / t, this.z = e1.z / t), this;
            }
            setAxisAngleFromRotationMatrix(e1) {
                let t, n, i, r;
                const a = .01, s = .1, o = e1.elements, l = o[0], c = o[4], u = o[8], h = o[1], d = o[5], p = o[9], f = o[2], m = o[6], g = o[10];
                if (Math.abs(c - h) < a && Math.abs(u - f) < a && Math.abs(p - m) < a) {
                    if (Math.abs(c + h) < s && Math.abs(u + f) < s && Math.abs(p + m) < s && Math.abs(l + d + g - 3) < s) return this.set(1, 0, 0, 0), this;
                    t = Math.PI;
                    const e1 = (l + 1) / 2, o = (d + 1) / 2, A = (g + 1) / 2, v = (c + h) / 4, M = (u + f) / 4, y = (p + m) / 4;
                    return e1 > o && e1 > A ? e1 < a ? (n = 0, i = .707106781, r = .707106781) : (n = Math.sqrt(e1), i = v / n, r = M / n) : o > A ? o < a ? (n = .707106781, i = 0, r = .707106781) : (i = Math.sqrt(o), n = v / i, r = y / i) : A < a ? (n = .707106781, i = .707106781, r = 0) : (r = Math.sqrt(A), n = M / r, i = y / r), this.set(n, i, r, t), this;
                }
                let A = Math.sqrt((m - p) * (m - p) + (u - f) * (u - f) + (h - c) * (h - c));
                return Math.abs(A) < .001 && (A = 1), this.x = (m - p) / A, this.y = (u - f) / A, this.z = (h - c) / A, this.w = Math.acos((l + d + g - 1) / 2), this;
            }
            min(e1) {
                return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this.z = Math.min(this.z, e1.z), this.w = Math.min(this.w, e1.w), this;
            }
            max(e1) {
                return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this.z = Math.max(this.z, e1.z), this.w = Math.max(this.w, e1.w), this;
            }
            clamp(e1, t) {
                return this.x = Math.max(e1.x, Math.min(t.x, this.x)), this.y = Math.max(e1.y, Math.min(t.y, this.y)), this.z = Math.max(e1.z, Math.min(t.z, this.z)), this.w = Math.max(e1.w, Math.min(t.w, this.w)), this;
            }
            clampScalar(e1, t) {
                return this.x = Math.max(e1, Math.min(t, this.x)), this.y = Math.max(e1, Math.min(t, this.y)), this.z = Math.max(e1, Math.min(t, this.z)), this.w = Math.max(e1, Math.min(t, this.w)), this;
            }
            clampLength(e1, t) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(e1, Math.min(t, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
            }
            dot(e1) {
                return this.x * e1.x + this.y * e1.y + this.z * e1.z + this.w * e1.w;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(e1) {
                return this.normalize().multiplyScalar(e1);
            }
            lerp(e1, t) {
                return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this.z += (e1.z - this.z) * t, this.w += (e1.w - this.w) * t, this;
            }
            lerpVectors(e1, t, n) {
                return this.x = e1.x + (t.x - e1.x) * n, this.y = e1.y + (t.y - e1.y) * n, this.z = e1.z + (t.z - e1.z) * n, this.w = e1.w + (t.w - e1.w) * n, this;
            }
            equals(e1) {
                return e1.x === this.x && e1.y === this.y && e1.z === this.z && e1.w === this.w;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.x = e1[t], this.y = e1[t + 1], this.z = e1[t + 2], this.w = e1[t + 3], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.x, e1[t + 1] = this.y, e1[t + 2] = this.z, e1[t + 3] = this.w, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.x = e1.getX(t), this.y = e1.getY(t), this.z = e1.getZ(t), this.w = e1.getW(t), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z, yield this.w;
            }
        }
        const ON = {
            enabled: !1,
            files: {},
            add: function(e1, t) {
                !1 !== this.enabled && (this.files[e1] = t);
            },
            get: function(e1) {
                if (!1 !== this.enabled) return this.files[e1];
            },
            remove: function(e1) {
                delete this.files[e1];
            },
            clear: function() {
                this.files = {};
            }
        };
        class PN {
            constructor(e1, t, n){
                const i = this;
                let r, a = !1, s = 0, o = 0;
                const l = [];
                this.onStart = void 0, this.onLoad = e1, this.onProgress = t, this.onError = n, this.itemStart = function(e1) {
                    o++, !1 === a && void 0 !== i.onStart && i.onStart(e1, s, o), a = !0;
                }, this.itemEnd = function(e1) {
                    s++, void 0 !== i.onProgress && i.onProgress(e1, s, o), s === o && (a = !1, void 0 !== i.onLoad && i.onLoad());
                }, this.itemError = function(e1) {
                    void 0 !== i.onError && i.onError(e1);
                }, this.resolveURL = function(e1) {
                    return r ? r(e1) : e1;
                }, this.setURLModifier = function(e1) {
                    return r = e1, this;
                }, this.addHandler = function(e1, t) {
                    return l.push(e1, t), this;
                }, this.removeHandler = function(e1) {
                    const t = l.indexOf(e1);
                    return -1 !== t && l.splice(t, 2), this;
                }, this.getHandler = function(e1) {
                    for(let t = 0, n = l.length; t < n; t += 2){
                        const n = l[t], i = l[t + 1];
                        if (n.global && (n.lastIndex = 0), n.test(e1)) return i;
                    }
                    return null;
                };
            }
        }
        const UN = new PN;
        class kN {
            constructor(e1){
                this.manager = void 0 !== e1 ? e1 : UN, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
            }
            load() {}
            loadAsync(e1, t) {
                const n = this;
                return new Promise(function(i, r) {
                    n.load(e1, i, t, r);
                });
            }
            parse() {}
            setCrossOrigin(e1) {
                return this.crossOrigin = e1, this;
            }
            setWithCredentials(e1) {
                return this.withCredentials = e1, this;
            }
            setPath(e1) {
                return this.path = e1, this;
            }
            setResourcePath(e1) {
                return this.resourcePath = e1, this;
            }
            setRequestHeader(e1) {
                return this.requestHeader = e1, this;
            }
        }
        function jN(e1) {
            return document.createElementNS("http://www.w3.org/1999/xhtml", e1);
        }
        kN.DEFAULT_MATERIAL_NAME = "__DEFAULT", Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array;
        const BN = {};
        function FN(e1) {
            e1 in BN || (BN[e1] = !0, console.warn(e1));
        }
        class HN extends kN {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                void 0 !== this.path && (e1 = this.path + e1), e1 = this.manager.resolveURL(e1);
                const r = this, a = ON.get(e1);
                if (void 0 !== a) return r.manager.itemStart(e1), setTimeout(function() {
                    t && t(a), r.manager.itemEnd(e1);
                }, 0), a;
                const s = jN("img");
                function o() {
                    c(), ON.add(e1, this), t && t(this), r.manager.itemEnd(e1);
                }
                function l(t) {
                    c(), i && i(t), r.manager.itemError(e1), r.manager.itemEnd(e1);
                }
                function c() {
                    s.removeEventListener("load", o, !1), s.removeEventListener("error", l, !1);
                }
                return s.addEventListener("load", o, !1), s.addEventListener("error", l, !1), "data:" !== e1.slice(0, 5) && void 0 !== this.crossOrigin && (s.crossOrigin = this.crossOrigin), r.manager.itemStart(e1), s.src = e1, s;
            }
        }
        class VN {
            addEventListener(e1, t) {
                void 0 === this._listeners && (this._listeners = {});
                const n = this._listeners;
                void 0 === n[e1] && (n[e1] = []), -1 === n[e1].indexOf(t) && n[e1].push(t);
            }
            hasEventListener(e1, t) {
                if (void 0 === this._listeners) return !1;
                const n = this._listeners;
                return void 0 !== n[e1] && -1 !== n[e1].indexOf(t);
            }
            removeEventListener(e1, t) {
                if (void 0 === this._listeners) return;
                const n = this._listeners[e1];
                if (void 0 !== n) {
                    const e1 = n.indexOf(t);
                    -1 !== e1 && n.splice(e1, 1);
                }
            }
            dispatchEvent(e1) {
                if (void 0 === this._listeners) return;
                const t = this._listeners[e1.type];
                if (void 0 !== t) {
                    e1.target = this;
                    const n = t.slice(0);
                    for(let t = 0, i = n.length; t < i; t++)n[t].call(this, e1);
                    e1.target = null;
                }
            }
        }
        const GN = 1001, QN = 3001, WN = "srgb", YN = 2e3, XN = [
            "00",
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "0a",
            "0b",
            "0c",
            "0d",
            "0e",
            "0f",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "1a",
            "1b",
            "1c",
            "1d",
            "1e",
            "1f",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "2a",
            "2b",
            "2c",
            "2d",
            "2e",
            "2f",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "3a",
            "3b",
            "3c",
            "3d",
            "3e",
            "3f",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "4a",
            "4b",
            "4c",
            "4d",
            "4e",
            "4f",
            "50",
            "51",
            "52",
            "53",
            "54",
            "55",
            "56",
            "57",
            "58",
            "59",
            "5a",
            "5b",
            "5c",
            "5d",
            "5e",
            "5f",
            "60",
            "61",
            "62",
            "63",
            "64",
            "65",
            "66",
            "67",
            "68",
            "69",
            "6a",
            "6b",
            "6c",
            "6d",
            "6e",
            "6f",
            "70",
            "71",
            "72",
            "73",
            "74",
            "75",
            "76",
            "77",
            "78",
            "79",
            "7a",
            "7b",
            "7c",
            "7d",
            "7e",
            "7f",
            "80",
            "81",
            "82",
            "83",
            "84",
            "85",
            "86",
            "87",
            "88",
            "89",
            "8a",
            "8b",
            "8c",
            "8d",
            "8e",
            "8f",
            "90",
            "91",
            "92",
            "93",
            "94",
            "95",
            "96",
            "97",
            "98",
            "99",
            "9a",
            "9b",
            "9c",
            "9d",
            "9e",
            "9f",
            "a0",
            "a1",
            "a2",
            "a3",
            "a4",
            "a5",
            "a6",
            "a7",
            "a8",
            "a9",
            "aa",
            "ab",
            "ac",
            "ad",
            "ae",
            "af",
            "b0",
            "b1",
            "b2",
            "b3",
            "b4",
            "b5",
            "b6",
            "b7",
            "b8",
            "b9",
            "ba",
            "bb",
            "bc",
            "bd",
            "be",
            "bf",
            "c0",
            "c1",
            "c2",
            "c3",
            "c4",
            "c5",
            "c6",
            "c7",
            "c8",
            "c9",
            "ca",
            "cb",
            "cc",
            "cd",
            "ce",
            "cf",
            "d0",
            "d1",
            "d2",
            "d3",
            "d4",
            "d5",
            "d6",
            "d7",
            "d8",
            "d9",
            "da",
            "db",
            "dc",
            "dd",
            "de",
            "df",
            "e0",
            "e1",
            "e2",
            "e3",
            "e4",
            "e5",
            "e6",
            "e7",
            "e8",
            "e9",
            "ea",
            "eb",
            "ec",
            "ed",
            "ee",
            "ef",
            "f0",
            "f1",
            "f2",
            "f3",
            "f4",
            "f5",
            "f6",
            "f7",
            "f8",
            "f9",
            "fa",
            "fb",
            "fc",
            "fd",
            "fe",
            "ff"
        ];
        function ZN() {
            const e1 = 4294967295 * Math.random() | 0, t = 4294967295 * Math.random() | 0, n = 4294967295 * Math.random() | 0, i = 4294967295 * Math.random() | 0;
            return (XN[255 & e1] + XN[e1 >> 8 & 255] + XN[e1 >> 16 & 255] + XN[e1 >> 24 & 255] + "-" + XN[255 & t] + XN[t >> 8 & 255] + "-" + XN[t >> 16 & 15 | 64] + XN[t >> 24 & 255] + "-" + XN[63 & n | 128] + XN[n >> 8 & 255] + "-" + XN[n >> 16 & 255] + XN[n >> 24 & 255] + XN[255 & i] + XN[i >> 8 & 255] + XN[i >> 16 & 255] + XN[i >> 24 & 255]).toLowerCase();
        }
        function qN(e1, t, n) {
            return Math.max(t, Math.min(n, e1));
        }
        Math.PI, Math.PI;
        class KN {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                KN.prototype.isVector2 = !0, this.x = e1, this.y = t;
            }
            get width() {
                return this.x;
            }
            set width(e1) {
                this.x = e1;
            }
            get height() {
                return this.y;
            }
            set height(e1) {
                this.y = e1;
            }
            set(e1, t) {
                return this.x = e1, this.y = t, this;
            }
            setScalar(e1) {
                return this.x = e1, this.y = e1, this;
            }
            setX(e1) {
                return this.x = e1, this;
            }
            setY(e1) {
                return this.y = e1, this;
            }
            setComponent(e1, t) {
                switch(e1){
                    case 0:
                        this.x = t;
                        break;
                    case 1:
                        this.y = t;
                        break;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
                return this;
            }
            getComponent(e1) {
                switch(e1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y);
            }
            copy(e1) {
                return this.x = e1.x, this.y = e1.y, this;
            }
            add(e1) {
                return this.x += e1.x, this.y += e1.y, this;
            }
            addScalar(e1) {
                return this.x += e1, this.y += e1, this;
            }
            addVectors(e1, t) {
                return this.x = e1.x + t.x, this.y = e1.y + t.y, this;
            }
            addScaledVector(e1, t) {
                return this.x += e1.x * t, this.y += e1.y * t, this;
            }
            sub(e1) {
                return this.x -= e1.x, this.y -= e1.y, this;
            }
            subScalar(e1) {
                return this.x -= e1, this.y -= e1, this;
            }
            subVectors(e1, t) {
                return this.x = e1.x - t.x, this.y = e1.y - t.y, this;
            }
            multiply(e1) {
                return this.x *= e1.x, this.y *= e1.y, this;
            }
            multiplyScalar(e1) {
                return this.x *= e1, this.y *= e1, this;
            }
            divide(e1) {
                return this.x /= e1.x, this.y /= e1.y, this;
            }
            divideScalar(e1) {
                return this.multiplyScalar(1 / e1);
            }
            applyMatrix3(e1) {
                const t = this.x, n = this.y, i = e1.elements;
                return this.x = i[0] * t + i[3] * n + i[6], this.y = i[1] * t + i[4] * n + i[7], this;
            }
            min(e1) {
                return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this;
            }
            max(e1) {
                return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this;
            }
            clamp(e1, t) {
                return this.x = Math.max(e1.x, Math.min(t.x, this.x)), this.y = Math.max(e1.y, Math.min(t.y, this.y)), this;
            }
            clampScalar(e1, t) {
                return this.x = Math.max(e1, Math.min(t, this.x)), this.y = Math.max(e1, Math.min(t, this.y)), this;
            }
            clampLength(e1, t) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(e1, Math.min(t, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this;
            }
            dot(e1) {
                return this.x * e1.x + this.y * e1.y;
            }
            cross(e1) {
                return this.x * e1.y - this.y * e1.x;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            angle() {
                return Math.atan2(-this.y, -this.x) + Math.PI;
            }
            angleTo(e1) {
                const t = Math.sqrt(this.lengthSq() * e1.lengthSq());
                if (0 === t) return Math.PI / 2;
                const n = this.dot(e1) / t;
                return Math.acos(qN(n, -1, 1));
            }
            distanceTo(e1) {
                return Math.sqrt(this.distanceToSquared(e1));
            }
            distanceToSquared(e1) {
                const t = this.x - e1.x, n = this.y - e1.y;
                return t * t + n * n;
            }
            manhattanDistanceTo(e1) {
                return Math.abs(this.x - e1.x) + Math.abs(this.y - e1.y);
            }
            setLength(e1) {
                return this.normalize().multiplyScalar(e1);
            }
            lerp(e1, t) {
                return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this;
            }
            lerpVectors(e1, t, n) {
                return this.x = e1.x + (t.x - e1.x) * n, this.y = e1.y + (t.y - e1.y) * n, this;
            }
            equals(e1) {
                return e1.x === this.x && e1.y === this.y;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.x = e1[t], this.y = e1[t + 1], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.x, e1[t + 1] = this.y, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.x = e1.getX(t), this.y = e1.getY(t), this;
            }
            rotateAround(e1, t) {
                const n = Math.cos(t), i = Math.sin(t), r = this.x - e1.x, a = this.y - e1.y;
                return this.x = r * n - a * i + e1.x, this.y = r * i + a * n + e1.y, this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y;
            }
        }
        class JN {
            constructor(e1, t, n, i, r, a, s, o, l){
                JN.prototype.isMatrix3 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== e1 && this.set(e1, t, n, i, r, a, s, o, l);
            }
            set(e1, t, n, i, r, a, s, o, l) {
                const c = this.elements;
                return c[0] = e1, c[1] = i, c[2] = s, c[3] = t, c[4] = r, c[5] = o, c[6] = n, c[7] = a, c[8] = l, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
            }
            copy(e1) {
                const t = this.elements, n = e1.elements;
                return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], this;
            }
            extractBasis(e1, t, n) {
                return e1.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
            }
            setFromMatrix4(e1) {
                const t = e1.elements;
                return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this;
            }
            multiply(e1) {
                return this.multiplyMatrices(this, e1);
            }
            premultiply(e1) {
                return this.multiplyMatrices(e1, this);
            }
            multiplyMatrices(e1, t) {
                const n = e1.elements, i = t.elements, r = this.elements, a = n[0], s = n[3], o = n[6], l = n[1], c = n[4], u = n[7], h = n[2], d = n[5], p = n[8], f = i[0], m = i[3], g = i[6], A = i[1], v = i[4], M = i[7], y = i[2], x = i[5], _ = i[8];
                return r[0] = a * f + s * A + o * y, r[3] = a * m + s * v + o * x, r[6] = a * g + s * M + o * _, r[1] = l * f + c * A + u * y, r[4] = l * m + c * v + u * x, r[7] = l * g + c * M + u * _, r[2] = h * f + d * A + p * y, r[5] = h * m + d * v + p * x, r[8] = h * g + d * M + p * _, this;
            }
            multiplyScalar(e1) {
                const t = this.elements;
                return t[0] *= e1, t[3] *= e1, t[6] *= e1, t[1] *= e1, t[4] *= e1, t[7] *= e1, t[2] *= e1, t[5] *= e1, t[8] *= e1, this;
            }
            determinant() {
                const e1 = this.elements, t = e1[0], n = e1[1], i = e1[2], r = e1[3], a = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8];
                return t * a * c - t * s * l - n * r * c + n * s * o + i * r * l - i * a * o;
            }
            invert() {
                const e1 = this.elements, t = e1[0], n = e1[1], i = e1[2], r = e1[3], a = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8], u = c * a - s * l, h = s * o - c * r, d = l * r - a * o, p = t * u + n * h + i * d;
                if (0 === p) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                const f = 1 / p;
                return e1[0] = u * f, e1[1] = (i * l - c * n) * f, e1[2] = (s * n - i * a) * f, e1[3] = h * f, e1[4] = (c * t - i * o) * f, e1[5] = (i * r - s * t) * f, e1[6] = d * f, e1[7] = (n * o - l * t) * f, e1[8] = (a * t - n * r) * f, this;
            }
            transpose() {
                let e1;
                const t = this.elements;
                return e1 = t[1], t[1] = t[3], t[3] = e1, e1 = t[2], t[2] = t[6], t[6] = e1, e1 = t[5], t[5] = t[7], t[7] = e1, this;
            }
            getNormalMatrix(e1) {
                return this.setFromMatrix4(e1).invert().transpose();
            }
            transposeIntoArray(e1) {
                const t = this.elements;
                return e1[0] = t[0], e1[1] = t[3], e1[2] = t[6], e1[3] = t[1], e1[4] = t[4], e1[5] = t[7], e1[6] = t[2], e1[7] = t[5], e1[8] = t[8], this;
            }
            setUvTransform(e1, t, n, i, r, a, s) {
                const o = Math.cos(r), l = Math.sin(r);
                return this.set(n * o, n * l, -n * (o * a + l * s) + a + e1, -i * l, i * o, -i * (-l * a + o * s) + s + t, 0, 0, 1), this;
            }
            scale(e1, t) {
                return this.premultiply($N.makeScale(e1, t)), this;
            }
            rotate(e1) {
                return this.premultiply($N.makeRotation(-e1)), this;
            }
            translate(e1, t) {
                return this.premultiply($N.makeTranslation(e1, t)), this;
            }
            makeTranslation(e1, t) {
                return e1.isVector2 ? this.set(1, 0, e1.x, 0, 1, e1.y, 0, 0, 1) : this.set(1, 0, e1, 0, 1, t, 0, 0, 1), this;
            }
            makeRotation(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(t, -n, 0, n, t, 0, 0, 0, 1), this;
            }
            makeScale(e1, t) {
                return this.set(e1, 0, 0, 0, t, 0, 0, 0, 1), this;
            }
            equals(e1) {
                const t = this.elements, n = e1.elements;
                for(let e1 = 0; e1 < 9; e1++)if (t[e1] !== n[e1]) return !1;
                return !0;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                for(let n = 0; n < 9; n++)this.elements[n] = e1[n + t];
                return this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.elements;
                return e1[t] = n[0], e1[t + 1] = n[1], e1[t + 2] = n[2], e1[t + 3] = n[3], e1[t + 4] = n[4], e1[t + 5] = n[5], e1[t + 6] = n[6], e1[t + 7] = n[7], e1[t + 8] = n[8], e1;
            }
            clone() {
                return (new this.constructor).fromArray(this.elements);
            }
        }
        const $N = new JN;
        function eD(e1) {
            return e1 < .04045 ? .0773993808 * e1 : Math.pow(.9478672986 * e1 + .0521327014, 2.4);
        }
        let tD;
        new Set([
            "srgb-linear",
            "display-p3-linear"
        ]);
        class nD {
            static getDataURL(e1) {
                if (/^data:/i.test(e1.src)) return e1.src;
                if ("undefined" == typeof HTMLCanvasElement) return e1.src;
                let t;
                if (e1 instanceof HTMLCanvasElement) t = e1;
                else {
                    void 0 === tD && (tD = jN("canvas")), tD.width = e1.width, tD.height = e1.height;
                    const n = tD.getContext("2d");
                    e1 instanceof ImageData ? n.putImageData(e1, 0, 0) : n.drawImage(e1, 0, 0, e1.width, e1.height), t = tD;
                }
                return t.width > 2048 || t.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", e1), t.toDataURL("image/jpeg", .6)) : t.toDataURL("image/png");
            }
            static sRGBToLinear(e1) {
                if ("undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap) {
                    const t = jN("canvas");
                    t.width = e1.width, t.height = e1.height;
                    const n = t.getContext("2d");
                    n.drawImage(e1, 0, 0, e1.width, e1.height);
                    const i = n.getImageData(0, 0, e1.width, e1.height), r = i.data;
                    for(let e1 = 0; e1 < r.length; e1++)r[e1] = 255 * eD(r[e1] / 255);
                    return n.putImageData(i, 0, 0), t;
                }
                if (e1.data) {
                    const t = e1.data.slice(0);
                    for(let e1 = 0; e1 < t.length; e1++)t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[e1] = Math.floor(255 * eD(t[e1] / 255)) : t[e1] = eD(t[e1]);
                    return {
                        data: t,
                        width: e1.width,
                        height: e1.height
                    };
                }
                return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e1;
            }
        }
        let iD = 0;
        class rD {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                this.isSource = !0, Object.defineProperty(this, "id", {
                    value: iD++
                }), this.uuid = ZN(), this.data = e1, this.version = 0;
            }
            set needsUpdate(e1) {
                !0 === e1 && this.version++;
            }
            toJSON(e1) {
                const t = void 0 === e1 || "string" == typeof e1;
                if (!t && void 0 !== e1.images[this.uuid]) return e1.images[this.uuid];
                const n = {
                    uuid: this.uuid,
                    url: ""
                }, i = this.data;
                if (null !== i) {
                    let e1;
                    if (Array.isArray(i)) {
                        e1 = [];
                        for(let t = 0, n = i.length; t < n; t++)i[t].isDataTexture ? e1.push(aD(i[t].image)) : e1.push(aD(i[t]));
                    } else e1 = aD(i);
                    n.url = e1;
                }
                return t || (e1.images[this.uuid] = n), n;
            }
        }
        function aD(e1) {
            return "undefined" != typeof HTMLImageElement && e1 instanceof HTMLImageElement || "undefined" != typeof HTMLCanvasElement && e1 instanceof HTMLCanvasElement || "undefined" != typeof ImageBitmap && e1 instanceof ImageBitmap ? nD.getDataURL(e1) : e1.data ? {
                data: Array.from(e1.data),
                width: e1.width,
                height: e1.height,
                type: e1.data.constructor.name
            } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
        }
        let sD = 0;
        class oD extends VN {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : oD.DEFAULT_IMAGE, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : oD.DEFAULT_MAPPING, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : GN, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : GN, r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1006, a = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 1008, s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 1023, o = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : 1009, l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : oD.DEFAULT_ANISOTROPY, c = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : "";
                super(), this.isTexture = !0, Object.defineProperty(this, "id", {
                    value: sD++
                }), this.uuid = ZN(), this.name = "", this.source = new rD(e1), this.mipmaps = [], this.mapping = t, this.channel = 0, this.wrapS = n, this.wrapT = i, this.magFilter = r, this.minFilter = a, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = o, this.offset = new KN(0, 0), this.repeat = new KN(1, 1), this.center = new KN(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new JN, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, "string" == typeof c ? this.colorSpace = c : (FN("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = c === QN ? WN : ""), this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
            }
            get image() {
                return this.source.data;
            }
            set image(e1) {
                void 0 === e1 && (e1 = null), this.source.data = e1;
            }
            updateMatrix() {
                this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
            }
            clone() {
                return (new this.constructor).copy(this);
            }
            copy(e1) {
                return this.name = e1.name, this.source = e1.source, this.mipmaps = e1.mipmaps.slice(0), this.mapping = e1.mapping, this.channel = e1.channel, this.wrapS = e1.wrapS, this.wrapT = e1.wrapT, this.magFilter = e1.magFilter, this.minFilter = e1.minFilter, this.anisotropy = e1.anisotropy, this.format = e1.format, this.internalFormat = e1.internalFormat, this.type = e1.type, this.offset.copy(e1.offset), this.repeat.copy(e1.repeat), this.center.copy(e1.center), this.rotation = e1.rotation, this.matrixAutoUpdate = e1.matrixAutoUpdate, this.matrix.copy(e1.matrix), this.generateMipmaps = e1.generateMipmaps, this.premultiplyAlpha = e1.premultiplyAlpha, this.flipY = e1.flipY, this.unpackAlignment = e1.unpackAlignment, this.colorSpace = e1.colorSpace, this.userData = JSON.parse(JSON.stringify(e1.userData)), this.needsUpdate = !0, this;
            }
            toJSON(e1) {
                const t = void 0 === e1 || "string" == typeof e1;
                if (!t && void 0 !== e1.textures[this.uuid]) return e1.textures[this.uuid];
                const n = {
                    metadata: {
                        version: 4.6,
                        type: "Texture",
                        generator: "Texture.toJSON"
                    },
                    uuid: this.uuid,
                    name: this.name,
                    image: this.source.toJSON(e1).uuid,
                    mapping: this.mapping,
                    channel: this.channel,
                    repeat: [
                        this.repeat.x,
                        this.repeat.y
                    ],
                    offset: [
                        this.offset.x,
                        this.offset.y
                    ],
                    center: [
                        this.center.x,
                        this.center.y
                    ],
                    rotation: this.rotation,
                    wrap: [
                        this.wrapS,
                        this.wrapT
                    ],
                    format: this.format,
                    internalFormat: this.internalFormat,
                    type: this.type,
                    colorSpace: this.colorSpace,
                    minFilter: this.minFilter,
                    magFilter: this.magFilter,
                    anisotropy: this.anisotropy,
                    flipY: this.flipY,
                    generateMipmaps: this.generateMipmaps,
                    premultiplyAlpha: this.premultiplyAlpha,
                    unpackAlignment: this.unpackAlignment
                };
                return Object.keys(this.userData).length > 0 && (n.userData = this.userData), t || (e1.textures[this.uuid] = n), n;
            }
            dispose() {
                this.dispatchEvent({
                    type: "dispose"
                });
            }
            transformUv(e1) {
                if (300 !== this.mapping) return e1;
                if (e1.applyMatrix3(this.matrix), e1.x < 0 || e1.x > 1) switch(this.wrapS){
                    case 1e3:
                        e1.x = e1.x - Math.floor(e1.x);
                        break;
                    case GN:
                        e1.x = e1.x < 0 ? 0 : 1;
                        break;
                    case 1002:
                        1 === Math.abs(Math.floor(e1.x) % 2) ? e1.x = Math.ceil(e1.x) - e1.x : e1.x = e1.x - Math.floor(e1.x);
                }
                if (e1.y < 0 || e1.y > 1) switch(this.wrapT){
                    case 1e3:
                        e1.y = e1.y - Math.floor(e1.y);
                        break;
                    case GN:
                        e1.y = e1.y < 0 ? 0 : 1;
                        break;
                    case 1002:
                        1 === Math.abs(Math.floor(e1.y) % 2) ? e1.y = Math.ceil(e1.y) - e1.y : e1.y = e1.y - Math.floor(e1.y);
                }
                return this.flipY && (e1.y = 1 - e1.y), e1;
            }
            set needsUpdate(e1) {
                !0 === e1 && (this.version++, this.source.needsUpdate = !0);
            }
            get encoding() {
                return FN("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace === WN ? QN : 3e3;
            }
            set encoding(e1) {
                FN("THREE.Texture: Property .encoding has been replaced by .colorSpace."), this.colorSpace = e1 === QN ? WN : "";
            }
        }
        oD.DEFAULT_IMAGE = null, oD.DEFAULT_MAPPING = 300, oD.DEFAULT_ANISOTROPY = 1;
        class lD extends kN {
            constructor(e1){
                super(e1);
            }
            load(e1, t, n, i) {
                const r = new oD, a = new HN(this.manager);
                return a.setCrossOrigin(this.crossOrigin), a.setPath(this.path), a.load(e1, function(e1) {
                    r.image = e1, r.needsUpdate = !0, void 0 !== t && t(r);
                }, n, i), r;
            }
        }
        class cD extends oD {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
                super(null, arguments.length > 5 ? arguments[5] : void 0, arguments.length > 6 ? arguments[6] : void 0, arguments.length > 7 ? arguments[7] : void 0, arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 1003, arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 1003, arguments.length > 3 ? arguments[3] : void 0, arguments.length > 4 ? arguments[4] : void 0, arguments.length > 10 ? arguments[10] : void 0, arguments.length > 11 ? arguments[11] : void 0), this.isDataTexture = !0, this.image = {
                    data: e1,
                    width: t,
                    height: n
                }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
            }
        }
        function uD(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        dn({
            useProxies: "never"
        });
        const hD = new class {
            constructor(){
                uD(this, "roomMask", null), uD(this, "currentColor", {
                    R: 0,
                    G: 0,
                    B: 0,
                    A: 0
                }), uD(this, "fixedColor", {
                    R: 0,
                    G: 0,
                    B: 0,
                    A: 0
                }), uD(this, "textureImg", null), uD(this, "textureMask", null), Rn(this);
            }
            getCurrentColorVector() {
                return new zN(this.currentColor.R, this.currentColor.G, this.currentColor.B, this.currentColor.A);
            }
            getFixedColorVector() {
                return new zN(this.fixedColor.R, this.fixedColor.G, this.fixedColor.B, this.fixedColor.A);
            }
            setRoomMask(e1) {
                this.roomMask = e1;
            }
            setCurrentColor(e1) {
                this.currentColor = e1;
            }
            setFixedColor(e1) {
                this.fixedColor = e1;
            }
            setTextureImg(e1) {
                const t = new lD;
                this.textureImg = t.load(e1);
            }
            setTextureMask(e1) {
                const t = new cD(e1.data, e1.width, e1.height);
                t.needsUpdate = !0, t.type = Na, this.textureMask = t;
            }
        }, dD = tN((e1)=>{
            let { imgs: n, masks: i, activeIndex: r, visible: a } = e1;
            const s = (0, t.useRef)(null), [o, l] = (0, t.useState)(null);
            (0, t.useEffect)(()=>{
                (async ()=>{
                    const e1 = await Ox.getDepth(i[r]);
                    e1 && (hD.setTextureImg(n[r]), hD.setTextureMask(e1), hD.setRoomMask(e1), o || h());
                })();
            }, [
                r
            ]);
            const c = (e1, t)=>{
                const n = document.getElementsByClassName("widget-tab__isometry-container")[0].style.transform.match(/\((.*?)\)/)[1].split(",")[0], i = e1.getBoundingClientRect(), r = t.clientX - i.left, a = t.clientY - i.top, s = r / (n * e1.offsetWidth), o = a / (n * e1.offsetHeight);
                return Yx(s.toFixed(2), o.toFixed(2), hD.roomMask);
            }, u = (e1, t)=>{
                const n = c(e1, t);
                hD.setCurrentColor(n);
            }, h = ()=>{
                const e1 = s.current, t = new bh(-1, 1, 1, -1, 0, 1), n = new Zp, i = new dh(2, 2), r = {
                    texture1: {
                        value: hD.textureImg
                    },
                    texture2: {
                        value: hD.textureMask
                    },
                    color: {
                        type: "vec4",
                        value: new _l
                    },
                    fixedColor: {
                        type: "vec4",
                        value: new _l
                    }
                }, a = new qu({
                    uniforms: r,
                    fragmentShader: "\n      varying vec2 vUv;\n\n      uniform vec4 color;\n      uniform vec4 fixedColor;\n      uniform sampler2D texture1; \n      uniform sampler2D texture2; \n\n      void main()	{\n        vec4 color1 = texture2D(texture1, vUv);\n        vec4 color2 = texture2D(texture2, vUv);\n\n        if (color2 == vec4(0.0, 0.0, 0.0, 1.0)) {\n          gl_FragColor = color1;\n        } else if (color2.r == fixedColor.r) {\n          gl_FragColor = mix(color1, vec4(95.0/255.0, 68.0/255.0, 155.0/255.0, 1.0), 0.6);\n        } else if (color2.r == color.r) {\n          gl_FragColor = mix(color1, vec4(95.0/255.0, 68.0/255.0, 155.0/255.0, 1.0), 0.3);\n        } else {\n          gl_FragColor = color1;\n        }\n      }\n\n  ",
                    vertexShader: "\n      varying vec2 vUv;\n\n      void main()	{\n\n          vUv = uv;\n          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n\n      }\n  "
                }), o = new Vu(i, a);
                n.add(o);
                const h = new Qp({
                    preserveDrawingBuffer: !0,
                    antialias: !0,
                    alpha: !0
                });
                h.toneMapping = Kr, h.toneMappingExposure = 1, h.setPixelRatio(window.devicePixelRatio), h.setSize(3 * e1.offsetWidth, 3 * e1.offsetHeight), h.render(n, t), h.setAnimationLoop(()=>{
                    r.texture1.value = hD.textureImg, r.texture2.value = hD.textureMask, r.color = {
                        type: "vec4",
                        value: hD.getCurrentColorVector()
                    }, r.fixedColor = {
                        type: "vec4",
                        value: hD.getFixedColorVector()
                    }, h.render(n, t);
                }), e1.appendChild(h.domElement), l(h), ((e1, t)=>{
                    t.addEventListener("mousemove", (e1)=>{
                        u(t, e1);
                    }), t.addEventListener("onTouchStart", (e1)=>{
                        u(t, e1);
                    }), t.addEventListener("onTouchMove", (e1)=>{
                        u(t, e1);
                    }), t.addEventListener("onTouchEnd", (e1)=>{
                        u(t, e1);
                    }), t.addEventListener("click", (e1)=>{
                        ((e1, t)=>{
                            const n = c(e1, t);
                            hD.setFixedColor(n);
                        })(t, e1);
                    }), window.addEventListener("resize", ()=>e1.setSize(3 * t.offsetWidth, 3 * t.offsetHeight));
                })(h, e1);
            };
            return t.createElement("div", {
                ref: s,
                className: "widget-tab__isometry-shader ".concat(a ? "" : "hidden")
            });
        }), pD = dD, fD = (e1)=>{
            let { topViewImage: n, topViewMask: i, activeIndex: r, currentStep: a, planImage: s, images: o, masks: l = [], steps: c, setCurrentStep: u, setActiveIndex: h } = e1;
            const d = "renders" === a ? [
                n,
                ...o
            ] : o, p = [];
            p.push(null != i ? i : ""), l && p.push(...l);
            const f = (e1)=>{
                e1.preventDefault();
                const t = r + 1;
                h(d[t] ? t : 0);
            }, m = (e1)=>{
                e1.preventDefault();
                const t = r - 1;
                h(d[t] ? t : d.length - 1);
            };
            let g = {
                x: 0,
                y: 0
            };
            const A = ()=>g = {
                    x: 0,
                    y: 0
                };
            return t.createElement(t.Fragment, null, t.createElement("div", {
                className: "widget-tab__isometry"
            }, t.createElement("div", {
                className: "widget-tab__isometry-container",
                onTouchStart: (e1)=>{
                    if (e1.touches.length > 1) return;
                    const t = e1.touches[0];
                    g = {
                        x: t.screenX
                    };
                },
                onTouchMove: (e1)=>{
                    if (e1.touches.length > 1) return;
                    e1.stopPropagation();
                    const t = e1.touches[0], n = g.x - t.screenX;
                    "carousel" === a && 0 !== g.x && (n >= 100 ? (f(), A()) : n <= -100 && (m(), A()));
                },
                onTouchEnd: A
            }, t.createElement("img", {
                className: "widget-tab__isometry--plan ".concat("plan" === a ? "active" : ""),
                src: s,
                alt: "plan-view"
            }), "renders" !== a && t.createElement(t.Fragment, null, t.createElement("img", {
                className: "widget-tab__isometry--top-view ".concat("topView" === a ? "active" : ""),
                src: n,
                alt: "top-view"
            }), null == o ? void 0 : o.map((e1, n)=>t.createElement("img", {
                    className: "carousel" === a && r === n ? "active" : "",
                    alt: "rotation-view-".concat(n),
                    key: n,
                    src: e1
                }))), "renders" === a && t.createElement(t.Fragment, null, t.createElement(pD, {
                imgs: d,
                masks: p,
                activeIndex: r,
                visible: i && l || !l && i && 0 === r || l && !i && 0 !== r
            }), !i && t.createElement("img", {
                className: "widget-tab__isometry--top-view ".concat(0 === r ? "active" : ""),
                src: n,
                alt: "top-view"
            }), !l && t.createElement(t.Fragment, null, null == o ? void 0 : o.map((e1, n)=>t.createElement("img", {
                    className: r === n + 1 ? "active" : "",
                    alt: "rotation-view-".concat(n),
                    key: n,
                    src: e1
                })))))), ("carousel" === a || "renders" === a) && t.createElement("div", {
                className: "widget-tab__isometry-arrows"
            }, t.createElement("button", {
                className: "widget-tab__isometry-arrow widget-tab__isometry-arrow--prev",
                onClick: (e1)=>m(e1)
            }, t.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI3IDE2SDUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE0IDdMNSAxNkwxNCAyNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K",
                alt: "arrow-left"
            })), t.createElement("span", null, r + 1, "/", d.length), t.createElement("button", {
                className: "widget-tab__isometry-arrow widget-tab__isometry-arrow--next",
                onClick: (e1)=>f(e1)
            }, t.createElement("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMTZIMjciIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE4IDdMMjcgMTZMMTggMjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==",
                alt: "arrow-right"
            }))), t.createElement("div", {
                className: "widget-tab__isometry-buttons"
            }, c.length > 1 && t.createElement("button", {
                className: "widget-tab__isometry-button",
                onClick: ()=>u((()=>{
                        const e1 = c.findIndex((e1)=>e1 === a);
                        return c[e1 + 1] || c[0];
                    })())
            }, t.createElement("img", {
                src: (()=>{
                    switch(a){
                        case "carousel":
                            return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI1LjUxNDcgMzlMNy41IDMxLjVMMTYuMjUgMjcuNzVMMjAuNjI1IDI1Ljg3NUwyNSAyNy43NUwyOS4zNzUgMjUuODc1TDMzLjc1IDI3Ljc1TDQyLjUgMzEuNUwyNS41MTQ3IDM5WiIgZmlsbD0iI0M0QzRDNCIvPgo8cGF0aCBkPSJNMzAuMTUwOSAyNS4xMjVMMzQuOTM0IDI3LjI1TDQ0LjUgMzEuNUwyNS4zNjc5IDQwTDUuNSAzMS41TDE1LjQzNCAyNy4yNUwyMC40MDA5IDI1LjEyNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS41IDE4LjVMMjUuMzY3OSAxMEw0NC41IDE4LjVMMjUuMzY3OSAyN0w1LjUgMTguNVoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIzLjE1MjcxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
                        case "plan":
                        default:
                            return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNDkiIHZpZXdCb3g9IjAgMCA1MCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM4Ljk5NzIgMzguODk5NEgxMS4wMDM2QzEwLjc4MjcgMzguODk5NCAxMC42MDM2IDM4LjcyMDMgMTAuNjAzNiAzOC40OTk0TDEwLjYwMzUgMTAuOTk4OUMxMC42MDM1IDEwLjc3OCAxMC43ODI2IDEwLjU5ODkgMTEuMDAzNSAxMC41OTg5SDM4Ljk5NzJDMzkuMjE4MSAxMC41OTg5IDM5LjM5NzIgMTAuNzc4IDM5LjM5NzIgMTAuOTk4OVYzOC40OTk0QzM5LjM5NzIgMzguNzIwMyAzOS4yMTgxIDM4Ljg5OTQgMzguOTk3MiAzOC44OTk0WiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiLz4KPHBhdGggZD0iTTEyLjE2OTkgMTkuMTk0NkgyNC4xMzQxQzI0LjM1NTEgMTkuMTk0NiAyNC41MzQxIDE5LjM3MzcgMjQuNTM0MSAxOS41OTQ2VjM3LjMyMTQiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0zNy44MjA2IDIwLjU5NDVIMzAuOTg0QzMwLjc2MzEgMjAuNTk0NSAzMC41ODQgMjAuNDE1NCAzMC41ODQgMjAuMTk0NVYxMi4xNjg3IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMiIvPgo8L3N2Zz4K";
                        case "topView":
                            return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA1MCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMTY5OTIgMzUuODU1N0wyNC44MzcgNDMuMTc3TDQxLjg0OTcgMzUuODU1NyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjYuMzMwMSA0My4xOTQ2TDguODMwMDggMzUuNjk0NkwyNS44MzAxIDI4LjE5NDZMNDIuODMwMSAzNS42OTQ2TDI2LjMzMDEgNDMuMTk0NloiIGZpbGw9IiNDNEM0QzQiLz4KPHBhdGggZD0iTTcuMTY5OTIgMzUuODE5NlYxMy44NTU3TDI0LjgzNyA2LjUzNDQyTDQxLjg0OTcgMTMuODU1N1YzNS44MTk2IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNC44MzU5IDYuNjk0NThWMjguMTU4NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjMuMTUyNzEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy4xNjk5MiAzNi41MTU5TDI0LjgzNyAyOS4xOTQ2TDQxLjg0OTcgMzYuNTE1OUwyNC44MzcgNDMuODM3Mkw3LjE2OTkyIDM2LjUxNTlaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMy4xNTI3MSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
                    }
                })(),
                alt: "".concat(a, "-icon")
            }))));
        }, mD = "data:image/svg+xml;base64,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", gD = (e1)=>{
            let { planImage: n, topViewImage: i, topViewMask: r, images: a, masks: s, mode: o, disabled: l = !1 } = e1;
            const c = [
                {
                    icon: mD,
                    text: Oy("rotate-plan")
                }
            ], [u, h] = (0, t.useState)(!1), [d, p] = (0, t.useState)(null), [f, m] = (0, t.useState)(0), [g, A] = (0, t.useState)(null), [v] = (0, t.useState)((()=>{
                const e1 = [], t = !Bi.config.defaultButtonsStyle && (Bi.config.hasTopViewMask || Bi.config.hasMiddleCutMasks);
                return a && a.length > 0 && !t && e1.push("carousel"), n && e1.push("plan"), i && !t && e1.push("topView"), t && (a || i) && e1.push("renders"), e1.filter((e1)=>Bi.config.availableRotationSteps.includes(e1));
            })()), [M, y] = (0, t.useState)(v[0]);
            function x() {
                m(this.index);
            }
            return (0, t.useEffect)(()=>{
                performance.mark("opening rotation mode");
                const e1 = document.querySelector(".widget-tab__threesixty-container"), t = document.querySelector(".widget-tab__isometry-container"), n = o === Zi.THREESIXTY ? e1 : t, i = dN()(n, {
                    beforeMouseDown: ()=>!0,
                    onTouch: ()=>!1,
                    zoomDoubleClickSpeed: 1,
                    minZoom: .5,
                    maxZoom: 3
                });
                p(i);
            }, []), t.createElement("div", {
                className: "widget-tab__rotation",
                onContextMenu: Ly
            }, o === Zi.THREESIXTY && t.createElement(LN, {
                initialized: u,
                activeIndex: f,
                images: a
            }), o === Zi.DEFAULT && t.createElement(fD, {
                setActiveIndex: m,
                setCurrentStep: (e1)=>{
                    const { scale: t } = d.getTransform();
                    d.pause(), d.zoomTo(0, 0, 1 / t), d.moveTo(0, 0), d.resume(), y(e1);
                },
                topViewImage: i,
                topViewMask: r,
                activeIndex: f,
                currentStep: M,
                planImage: n,
                images: a,
                masks: s,
                steps: v
            }), o === Zi.THREESIXTY && !u && t.createElement(RN, {
                onClick: ()=>{
                    h(!0);
                    const e1 = document.querySelector(".widget-tab__threesixty-container"), t = document.querySelector(".widget-tab__rotation"), n = new CN(e1, {
                        image: [
                            ...a
                        ],
                        parentElement: t,
                        inverted: !0,
                        speed: 300
                    });
                    n._update = x, d.on("panstart", ()=>{
                        n.stop(), n._update = ()=>{};
                    }), d.on("panend", ()=>{
                        n.goto(n.index), n._update = x;
                    }), A(n);
                },
                steps: c,
                disabled: l
            }));
        }, AD = tN(()=>((0, t.useEffect)(()=>{
                BI.setAutoRotateState(Bi.autoRotatePanarama);
            }, []), t.createElement("button", {
                className: "widget-tab__panorama-controls-button widget-tab__panorama-controls-button--rotation",
                onClick: ()=>BI.toggleAutoRotate()
            }, t.createElement("img", {
                src: BI.currentAutoRotateIcon,
                alt: "rotation-icon"
            })))), vD = tN((e1)=>{
            let { onClick: n } = e1;
            return t.createElement("button", {
                className: "widget-tab__panorama-controls-button widget-tab__panorama-controls-button--ruler",
                disabled: !BI.rulerButtonEnabled,
                onClick: n
            }, t.createElement("img", {
                src: BI.currentRulerIcon,
                alt: "ruler-icon"
            }));
        }), MD = tN(()=>{
            const e1 = Bi.config.scaleButtonType;
            return t.createElement("button", {
                className: "widget-tab__panorama-controls-button widget-tab__panorama-controls-button--scale",
                onClick: ()=>BI.toggleFov()
            }, "img" === e1 && t.createElement("img", {
                src: BI.currentFovIcon,
                alt: "scale-icon"
            }), "img" !== e1 && t.createElement("span", null, BI.currentFovText));
        }), yD = ()=>t.createElement("button", {
                className: "widget-tab__panorama-controls-button--bareshell"
            }, t.createElement("p", {
                className: "widget-tab__panorama-controls-button--bareshell-text"
            }, BI.bareshell ? "Bareshell" : "Furnished"), t.createElement("div", {
                className: "widget-tab__panorama-controls-button--bareshell-switch"
            }, t.createElement("div", {
                className: "widget-tab__panorama-controls-button--bareshell-switch-label",
                htmlFor: "bareshell-switch"
            }, t.createElement("span", {
                className: "widget-tab__panorama-controls-button--bareshell-switch-button ".concat(BI.bareshell ? "checked" : "")
            })))), xD = (e1)=>{
            let { absolute: n, size: i = "lg" } = e1;
            return t.createElement("div", {
                className: "widget-loader widget-loader--".concat(i, " ").concat(n ? "widget-loader--absolute" : "")
            }, t.createElement("div", null), t.createElement("div", null), t.createElement("div", null), t.createElement("div", null));
        }, _D = tN((e1)=>{
            let { disabled: n } = e1;
            const { planImage: i, json: r } = Bi.config, [a, s] = (0, t.useState)({
                width: "200px",
                height: "auto"
            }), [o, l] = (0, t.useState)(!0), [c, u] = (0, t.useState)({
                X: 1,
                Y: 1
            }), [h, d] = (0, t.useState)(!1), p = ()=>{
                const e1 = document.querySelector(".widget-tab__panorama-map img"), t = e1.naturalWidth / e1.naturalHeight || 1, n = Bi.config.height - 200;
                let i = 200, a = i / t;
                a >= n && (a = n, i = a * t);
                const o = ((e1, t)=>{
                    let { width: n, height: i } = e1;
                    if (!t) return {
                        X: 1,
                        Y: 1
                    };
                    const r = ((e1)=>{
                        var t, n, i, r, a;
                        const s = e1.Meta;
                        if (!s) return {
                            X: e1.Scale.X,
                            Y: e1.Scale.X
                        };
                        const o = Bi.currentFloorIndex, l = null === (t = s.BackgroundsTransforms) || void 0 === t ? void 0 : t[o], c = null === (n = s.WidgetInfo) || void 0 === n || null === (n = n.PlanBounds) || void 0 === n ? void 0 : n[o];
                        if (null != l && l.Modified && c) return {
                            Width: c.Right,
                            Height: c.Bottom
                        };
                        const u = null === (i = s.FloorsScales) || void 0 === i ? void 0 : i[o];
                        return {
                            X: null !== (r = null == u ? void 0 : u.X) && void 0 !== r ? r : e1.Scale.X,
                            Y: null !== (a = null == u ? void 0 : u.Y) && void 0 !== a ? a : e1.Scale.X
                        };
                    })(t);
                    if (r.Width && r.Height) return {
                        X: n / r.Width,
                        Y: i / r.Height
                    };
                    const a = i * (1024 / n);
                    return {
                        X: n / 1024 / r.X,
                        Y: i / a / r.Y
                    };
                })({
                    width: i,
                    height: a
                }, r);
                s({
                    width: "".concat(i, "px"),
                    height: "".concat(a, "px")
                }), u(o), BI.updateWindowSize(Bi.config.width, Bi.config.height), BI.vrControlPanel.map.updateSize(2 * i, 2 * a), BI.vrControlPanel.map.updateScale(o);
            }, f = ()=>{
                Bi.showControls(), d(!1);
            };
            return (0, t.useEffect)(p, [
                Bi.config.width,
                Bi.config.height,
                Bi.currentFloorIndex
            ]), t.createElement(t.Fragment, null, h && t.createElement("div", {
                className: "widget-tab__panorama-close-map",
                onClick: f
            }, t.createElement("img", {
                src: rN,
                alt: "close-map"
            })), h && t.createElement("div", {
                className: "map-overlay map-overlay--visible",
                onClick: f
            }), t.createElement("div", {
                className: (()=>{
                    let e1 = "widget-tab__panorama-map";
                    return Bi.config.bareshell && (e1 += " widget-tab__panorama-map--bottom"), o && (e1 += " widget-tab__panorama-map--hidden"), h && (e1 += " widget-tab__panorama-map--scaled"), e1;
                })()
            }, t.createElement("img", {
                src: i,
                style: a,
                alt: "plan",
                onLoad: ()=>{
                    p(), l(!r || n), BI.vrControlPanel.map.setDisabledState(!r || n), BI.vrControlPanel.map.loadImage(i).then(()=>{
                        BI.vrControlPanel.mapButtonAvailable = !0;
                    });
                }
            }), !o && t.createElement(t.Fragment, null, t.createElement("div", {
                className: "widget-tab__panorama-map__fov",
                style: (()=>{
                    const e1 = BI.getPanoramaById(BI.currentPanoramaId);
                    if (!e1) return {
                        display: "none"
                    };
                    const { left: t, top: n } = e1.userData;
                    return {
                        "--x": "".concat(t * c.X, "px"),
                        "--y": "".concat(n * c.Y, "px")
                    };
                })()
            }, t.createElement("div", {
                className: "widget-tab__panorama-map__fov-direction"
            }), t.createElement("div", {
                className: "widget-tab__panorama-map__fov-dot"
            })), t.createElement("svg", {
                style: {
                    width: a.width
                },
                key: "X-".concat(c.X, "-Y-").concat(c.Y),
                onClick: (e1)=>{
                    if (BI.loading) return;
                    if (Bi.config.width <= iN.tablet && !h) return Bi.hideControls(), void d(!0);
                    const t = document.querySelector(".widget-tab__panorama-map"), n = t.getBoundingClientRect().width / t.offsetWidth, i = document.querySelector(".widget-tab__panorama-map img").getBoundingClientRect(), { clientX: r, clientY: a } = e1, s = (r - i.left) / n / c.X, o = (a - i.top) / n / c.Y, l = BI.panoramasGroup.children.filter((e1)=>{
                        let { userData: t } = e1;
                        return dI([
                            s,
                            o
                        ], t.points);
                    }), { panorama: u } = Bx([
                        s,
                        o
                    ], l);
                    f(), u && BI.setCurrentPanoramaById(u.panoramaId);
                }
            }, BI.panoramasGroup.children.map((e1, n)=>{
                let { userData: i } = e1;
                const r = i.svgPathActions.reduce((e1, t)=>{
                    const n = t.x * c.X, i = t.y * c.Y;
                    let r = "".concat(t.type, " ").concat(n, " ").concat(i);
                    if ("Q" === t.type) {
                        const e1 = t.dx * c.X, n = t.dy * c.Y;
                        r += " ".concat(e1, " ").concat(n);
                    }
                    return "".concat(e1, " ").concat(r);
                }, "");
                return t.createElement("path", {
                    key: n,
                    d: r
                });
            })))));
        }), bD = (e1, t, n, i)=>{
            const r = 1 - e1;
            return {
                x: r * r * t.Location.X + 2 * r * e1 * n.Location.X + e1 * e1 * i.Location.X,
                y: r * r * t.Location.Y + 2 * r * e1 * n.Location.Y + e1 * e1 * i.Location.Y
            };
        }, wD = (e1, t)=>{
            const n = e1.length;
            for(let i = 0; i < n; i++){
                const n = e1[i];
                if (n.ID === t) return n;
            }
            return null;
        }, ED = (e1, t, n, i, r)=>{
            const a = [
                {
                    x: -n,
                    y: -i
                },
                {
                    x: n,
                    y: -i
                },
                {
                    x: n,
                    y: i
                },
                {
                    x: -n,
                    y: i
                }
            ], s = Math.cos(r), o = Math.sin(r);
            for(let n = 0; n < 4; n++){
                const i = a[n], r = e1 + i.x * s - i.y * o;
                i.y = t + i.y * s + i.x * o, i.x = r;
            }
            return a;
        };
        class TD {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
                this.isQuaternion = !0, this._x = e1, this._y = t, this._z = n, this._w = i;
            }
            static slerpFlat(e1, t, n, i, r, a, s) {
                let o = n[i + 0], l = n[i + 1], c = n[i + 2], u = n[i + 3];
                const h = r[a + 0], d = r[a + 1], p = r[a + 2], f = r[a + 3];
                if (0 === s) return e1[t + 0] = o, e1[t + 1] = l, e1[t + 2] = c, void (e1[t + 3] = u);
                if (1 === s) return e1[t + 0] = h, e1[t + 1] = d, e1[t + 2] = p, void (e1[t + 3] = f);
                if (u !== f || o !== h || l !== d || c !== p) {
                    let e1 = 1 - s;
                    const t = o * h + l * d + c * p + u * f, n = t >= 0 ? 1 : -1, i = 1 - t * t;
                    if (i > Number.EPSILON) {
                        const r = Math.sqrt(i), a = Math.atan2(r, t * n);
                        e1 = Math.sin(e1 * a) / r, s = Math.sin(s * a) / r;
                    }
                    const r = s * n;
                    if (o = o * e1 + h * r, l = l * e1 + d * r, c = c * e1 + p * r, u = u * e1 + f * r, e1 === 1 - s) {
                        const e1 = 1 / Math.sqrt(o * o + l * l + c * c + u * u);
                        o *= e1, l *= e1, c *= e1, u *= e1;
                    }
                }
                e1[t] = o, e1[t + 1] = l, e1[t + 2] = c, e1[t + 3] = u;
            }
            static multiplyQuaternionsFlat(e1, t, n, i, r, a) {
                const s = n[i], o = n[i + 1], l = n[i + 2], c = n[i + 3], u = r[a], h = r[a + 1], d = r[a + 2], p = r[a + 3];
                return e1[t] = s * p + c * u + o * d - l * h, e1[t + 1] = o * p + c * h + l * u - s * d, e1[t + 2] = l * p + c * d + s * h - o * u, e1[t + 3] = c * p - s * u - o * h - l * d, e1;
            }
            get x() {
                return this._x;
            }
            set x(e1) {
                this._x = e1, this._onChangeCallback();
            }
            get y() {
                return this._y;
            }
            set y(e1) {
                this._y = e1, this._onChangeCallback();
            }
            get z() {
                return this._z;
            }
            set z(e1) {
                this._z = e1, this._onChangeCallback();
            }
            get w() {
                return this._w;
            }
            set w(e1) {
                this._w = e1, this._onChangeCallback();
            }
            set(e1, t, n, i) {
                return this._x = e1, this._y = t, this._z = n, this._w = i, this._onChangeCallback(), this;
            }
            clone() {
                return new this.constructor(this._x, this._y, this._z, this._w);
            }
            copy(e1) {
                return this._x = e1.x, this._y = e1.y, this._z = e1.z, this._w = e1.w, this._onChangeCallback(), this;
            }
            setFromEuler(e1, t) {
                const n = e1._x, i = e1._y, r = e1._z, a = e1._order, s = Math.cos, o = Math.sin, l = s(n / 2), c = s(i / 2), u = s(r / 2), h = o(n / 2), d = o(i / 2), p = o(r / 2);
                switch(a){
                    case "XYZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "YXZ":
                        this._x = h * c * u + l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "ZXY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "ZYX":
                        this._x = h * c * u - l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    case "YZX":
                        this._x = h * c * u + l * d * p, this._y = l * d * u + h * c * p, this._z = l * c * p - h * d * u, this._w = l * c * u - h * d * p;
                        break;
                    case "XZY":
                        this._x = h * c * u - l * d * p, this._y = l * d * u - h * c * p, this._z = l * c * p + h * d * u, this._w = l * c * u + h * d * p;
                        break;
                    default:
                        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + a);
                }
                return !1 !== t && this._onChangeCallback(), this;
            }
            setFromAxisAngle(e1, t) {
                const n = t / 2, i = Math.sin(n);
                return this._x = e1.x * i, this._y = e1.y * i, this._z = e1.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
            }
            setFromRotationMatrix(e1) {
                const t = e1.elements, n = t[0], i = t[4], r = t[8], a = t[1], s = t[5], o = t[9], l = t[2], c = t[6], u = t[10], h = n + s + u;
                if (h > 0) {
                    const e1 = .5 / Math.sqrt(h + 1);
                    this._w = .25 / e1, this._x = (c - o) * e1, this._y = (r - l) * e1, this._z = (a - i) * e1;
                } else if (n > s && n > u) {
                    const e1 = 2 * Math.sqrt(1 + n - s - u);
                    this._w = (c - o) / e1, this._x = .25 * e1, this._y = (i + a) / e1, this._z = (r + l) / e1;
                } else if (s > u) {
                    const e1 = 2 * Math.sqrt(1 + s - n - u);
                    this._w = (r - l) / e1, this._x = (i + a) / e1, this._y = .25 * e1, this._z = (o + c) / e1;
                } else {
                    const e1 = 2 * Math.sqrt(1 + u - n - s);
                    this._w = (a - i) / e1, this._x = (r + l) / e1, this._y = (o + c) / e1, this._z = .25 * e1;
                }
                return this._onChangeCallback(), this;
            }
            setFromUnitVectors(e1, t) {
                let n = e1.dot(t) + 1;
                return n < Number.EPSILON ? (n = 0, Math.abs(e1.x) > Math.abs(e1.z) ? (this._x = -e1.y, this._y = e1.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -e1.z, this._z = e1.y, this._w = n)) : (this._x = e1.y * t.z - e1.z * t.y, this._y = e1.z * t.x - e1.x * t.z, this._z = e1.x * t.y - e1.y * t.x, this._w = n), this.normalize();
            }
            angleTo(e1) {
                return 2 * Math.acos(Math.abs(qN(this.dot(e1), -1, 1)));
            }
            rotateTowards(e1, t) {
                const n = this.angleTo(e1);
                if (0 === n) return this;
                const i = Math.min(1, t / n);
                return this.slerp(e1, i), this;
            }
            identity() {
                return this.set(0, 0, 0, 1);
            }
            invert() {
                return this.conjugate();
            }
            conjugate() {
                return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
            }
            dot(e1) {
                return this._x * e1._x + this._y * e1._y + this._z * e1._z + this._w * e1._w;
            }
            lengthSq() {
                return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
            }
            length() {
                return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
            }
            normalize() {
                let e1 = this.length();
                return 0 === e1 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e1 = 1 / e1, this._x = this._x * e1, this._y = this._y * e1, this._z = this._z * e1, this._w = this._w * e1), this._onChangeCallback(), this;
            }
            multiply(e1) {
                return this.multiplyQuaternions(this, e1);
            }
            premultiply(e1) {
                return this.multiplyQuaternions(e1, this);
            }
            multiplyQuaternions(e1, t) {
                const n = e1._x, i = e1._y, r = e1._z, a = e1._w, s = t._x, o = t._y, l = t._z, c = t._w;
                return this._x = n * c + a * s + i * l - r * o, this._y = i * c + a * o + r * s - n * l, this._z = r * c + a * l + n * o - i * s, this._w = a * c - n * s - i * o - r * l, this._onChangeCallback(), this;
            }
            slerp(e1, t) {
                if (0 === t) return this;
                if (1 === t) return this.copy(e1);
                const n = this._x, i = this._y, r = this._z, a = this._w;
                let s = a * e1._w + n * e1._x + i * e1._y + r * e1._z;
                if (s < 0 ? (this._w = -e1._w, this._x = -e1._x, this._y = -e1._y, this._z = -e1._z, s = -s) : this.copy(e1), s >= 1) return this._w = a, this._x = n, this._y = i, this._z = r, this;
                const o = 1 - s * s;
                if (o <= Number.EPSILON) {
                    const e1 = 1 - t;
                    return this._w = e1 * a + t * this._w, this._x = e1 * n + t * this._x, this._y = e1 * i + t * this._y, this._z = e1 * r + t * this._z, this.normalize(), this._onChangeCallback(), this;
                }
                const l = Math.sqrt(o), c = Math.atan2(l, s), u = Math.sin((1 - t) * c) / l, h = Math.sin(t * c) / l;
                return this._w = a * u + this._w * h, this._x = n * u + this._x * h, this._y = i * u + this._y * h, this._z = r * u + this._z * h, this._onChangeCallback(), this;
            }
            slerpQuaternions(e1, t, n) {
                return this.copy(e1).slerp(t, n);
            }
            random() {
                const e1 = Math.random(), t = Math.sqrt(1 - e1), n = Math.sqrt(e1), i = 2 * Math.PI * Math.random(), r = 2 * Math.PI * Math.random();
                return this.set(t * Math.cos(i), n * Math.sin(r), n * Math.cos(r), t * Math.sin(i));
            }
            equals(e1) {
                return e1._x === this._x && e1._y === this._y && e1._z === this._z && e1._w === this._w;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this._x = e1[t], this._y = e1[t + 1], this._z = e1[t + 2], this._w = e1[t + 3], this._onChangeCallback(), this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this._x, e1[t + 1] = this._y, e1[t + 2] = this._z, e1[t + 3] = this._w, e1;
            }
            fromBufferAttribute(e1, t) {
                return this._x = e1.getX(t), this._y = e1.getY(t), this._z = e1.getZ(t), this._w = e1.getW(t), this;
            }
            toJSON() {
                return this.toArray();
            }
            _onChange(e1) {
                return this._onChangeCallback = e1, this;
            }
            _onChangeCallback() {}
            *[Symbol.iterator]() {
                yield this._x, yield this._y, yield this._z, yield this._w;
            }
        }
        class SD {
            constructor(){
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
                SD.prototype.isVector3 = !0, this.x = e1, this.y = t, this.z = n;
            }
            set(e1, t, n) {
                return void 0 === n && (n = this.z), this.x = e1, this.y = t, this.z = n, this;
            }
            setScalar(e1) {
                return this.x = e1, this.y = e1, this.z = e1, this;
            }
            setX(e1) {
                return this.x = e1, this;
            }
            setY(e1) {
                return this.y = e1, this;
            }
            setZ(e1) {
                return this.z = e1, this;
            }
            setComponent(e1, t) {
                switch(e1){
                    case 0:
                        this.x = t;
                        break;
                    case 1:
                        this.y = t;
                        break;
                    case 2:
                        this.z = t;
                        break;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
                return this;
            }
            getComponent(e1) {
                switch(e1){
                    case 0:
                        return this.x;
                    case 1:
                        return this.y;
                    case 2:
                        return this.z;
                    default:
                        throw new Error("index is out of range: " + e1);
                }
            }
            clone() {
                return new this.constructor(this.x, this.y, this.z);
            }
            copy(e1) {
                return this.x = e1.x, this.y = e1.y, this.z = e1.z, this;
            }
            add(e1) {
                return this.x += e1.x, this.y += e1.y, this.z += e1.z, this;
            }
            addScalar(e1) {
                return this.x += e1, this.y += e1, this.z += e1, this;
            }
            addVectors(e1, t) {
                return this.x = e1.x + t.x, this.y = e1.y + t.y, this.z = e1.z + t.z, this;
            }
            addScaledVector(e1, t) {
                return this.x += e1.x * t, this.y += e1.y * t, this.z += e1.z * t, this;
            }
            sub(e1) {
                return this.x -= e1.x, this.y -= e1.y, this.z -= e1.z, this;
            }
            subScalar(e1) {
                return this.x -= e1, this.y -= e1, this.z -= e1, this;
            }
            subVectors(e1, t) {
                return this.x = e1.x - t.x, this.y = e1.y - t.y, this.z = e1.z - t.z, this;
            }
            multiply(e1) {
                return this.x *= e1.x, this.y *= e1.y, this.z *= e1.z, this;
            }
            multiplyScalar(e1) {
                return this.x *= e1, this.y *= e1, this.z *= e1, this;
            }
            multiplyVectors(e1, t) {
                return this.x = e1.x * t.x, this.y = e1.y * t.y, this.z = e1.z * t.z, this;
            }
            applyEuler(e1) {
                return this.applyQuaternion(ND.setFromEuler(e1));
            }
            applyAxisAngle(e1, t) {
                return this.applyQuaternion(ND.setFromAxisAngle(e1, t));
            }
            applyMatrix3(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.elements;
                return this.x = r[0] * t + r[3] * n + r[6] * i, this.y = r[1] * t + r[4] * n + r[7] * i, this.z = r[2] * t + r[5] * n + r[8] * i, this;
            }
            applyNormalMatrix(e1) {
                return this.applyMatrix3(e1).normalize();
            }
            applyMatrix4(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.elements, a = 1 / (r[3] * t + r[7] * n + r[11] * i + r[15]);
                return this.x = (r[0] * t + r[4] * n + r[8] * i + r[12]) * a, this.y = (r[1] * t + r[5] * n + r[9] * i + r[13]) * a, this.z = (r[2] * t + r[6] * n + r[10] * i + r[14]) * a, this;
            }
            applyQuaternion(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.x, a = e1.y, s = e1.z, o = e1.w, l = 2 * (a * i - s * n), c = 2 * (s * t - r * i), u = 2 * (r * n - a * t);
                return this.x = t + o * l + a * u - s * c, this.y = n + o * c + s * l - r * u, this.z = i + o * u + r * c - a * l, this;
            }
            project(e1) {
                return this.applyMatrix4(e1.matrixWorldInverse).applyMatrix4(e1.projectionMatrix);
            }
            unproject(e1) {
                return this.applyMatrix4(e1.projectionMatrixInverse).applyMatrix4(e1.matrixWorld);
            }
            transformDirection(e1) {
                const t = this.x, n = this.y, i = this.z, r = e1.elements;
                return this.x = r[0] * t + r[4] * n + r[8] * i, this.y = r[1] * t + r[5] * n + r[9] * i, this.z = r[2] * t + r[6] * n + r[10] * i, this.normalize();
            }
            divide(e1) {
                return this.x /= e1.x, this.y /= e1.y, this.z /= e1.z, this;
            }
            divideScalar(e1) {
                return this.multiplyScalar(1 / e1);
            }
            min(e1) {
                return this.x = Math.min(this.x, e1.x), this.y = Math.min(this.y, e1.y), this.z = Math.min(this.z, e1.z), this;
            }
            max(e1) {
                return this.x = Math.max(this.x, e1.x), this.y = Math.max(this.y, e1.y), this.z = Math.max(this.z, e1.z), this;
            }
            clamp(e1, t) {
                return this.x = Math.max(e1.x, Math.min(t.x, this.x)), this.y = Math.max(e1.y, Math.min(t.y, this.y)), this.z = Math.max(e1.z, Math.min(t.z, this.z)), this;
            }
            clampScalar(e1, t) {
                return this.x = Math.max(e1, Math.min(t, this.x)), this.y = Math.max(e1, Math.min(t, this.y)), this.z = Math.max(e1, Math.min(t, this.z)), this;
            }
            clampLength(e1, t) {
                const n = this.length();
                return this.divideScalar(n || 1).multiplyScalar(Math.max(e1, Math.min(t, n)));
            }
            floor() {
                return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
            }
            ceil() {
                return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
            }
            round() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
            }
            roundToZero() {
                return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
            }
            negate() {
                return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
            }
            dot(e1) {
                return this.x * e1.x + this.y * e1.y + this.z * e1.z;
            }
            lengthSq() {
                return this.x * this.x + this.y * this.y + this.z * this.z;
            }
            length() {
                return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
            }
            manhattanLength() {
                return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
            }
            normalize() {
                return this.divideScalar(this.length() || 1);
            }
            setLength(e1) {
                return this.normalize().multiplyScalar(e1);
            }
            lerp(e1, t) {
                return this.x += (e1.x - this.x) * t, this.y += (e1.y - this.y) * t, this.z += (e1.z - this.z) * t, this;
            }
            lerpVectors(e1, t, n) {
                return this.x = e1.x + (t.x - e1.x) * n, this.y = e1.y + (t.y - e1.y) * n, this.z = e1.z + (t.z - e1.z) * n, this;
            }
            cross(e1) {
                return this.crossVectors(this, e1);
            }
            crossVectors(e1, t) {
                const n = e1.x, i = e1.y, r = e1.z, a = t.x, s = t.y, o = t.z;
                return this.x = i * o - r * s, this.y = r * a - n * o, this.z = n * s - i * a, this;
            }
            projectOnVector(e1) {
                const t = e1.lengthSq();
                if (0 === t) return this.set(0, 0, 0);
                const n = e1.dot(this) / t;
                return this.copy(e1).multiplyScalar(n);
            }
            projectOnPlane(e1) {
                return ID.copy(this).projectOnVector(e1), this.sub(ID);
            }
            reflect(e1) {
                return this.sub(ID.copy(e1).multiplyScalar(2 * this.dot(e1)));
            }
            angleTo(e1) {
                const t = Math.sqrt(this.lengthSq() * e1.lengthSq());
                if (0 === t) return Math.PI / 2;
                const n = this.dot(e1) / t;
                return Math.acos(qN(n, -1, 1));
            }
            distanceTo(e1) {
                return Math.sqrt(this.distanceToSquared(e1));
            }
            distanceToSquared(e1) {
                const t = this.x - e1.x, n = this.y - e1.y, i = this.z - e1.z;
                return t * t + n * n + i * i;
            }
            manhattanDistanceTo(e1) {
                return Math.abs(this.x - e1.x) + Math.abs(this.y - e1.y) + Math.abs(this.z - e1.z);
            }
            setFromSpherical(e1) {
                return this.setFromSphericalCoords(e1.radius, e1.phi, e1.theta);
            }
            setFromSphericalCoords(e1, t, n) {
                const i = Math.sin(t) * e1;
                return this.x = i * Math.sin(n), this.y = Math.cos(t) * e1, this.z = i * Math.cos(n), this;
            }
            setFromCylindrical(e1) {
                return this.setFromCylindricalCoords(e1.radius, e1.theta, e1.y);
            }
            setFromCylindricalCoords(e1, t, n) {
                return this.x = e1 * Math.sin(t), this.y = n, this.z = e1 * Math.cos(t), this;
            }
            setFromMatrixPosition(e1) {
                const t = e1.elements;
                return this.x = t[12], this.y = t[13], this.z = t[14], this;
            }
            setFromMatrixScale(e1) {
                const t = this.setFromMatrixColumn(e1, 0).length(), n = this.setFromMatrixColumn(e1, 1).length(), i = this.setFromMatrixColumn(e1, 2).length();
                return this.x = t, this.y = n, this.z = i, this;
            }
            setFromMatrixColumn(e1, t) {
                return this.fromArray(e1.elements, 4 * t);
            }
            setFromMatrix3Column(e1, t) {
                return this.fromArray(e1.elements, 3 * t);
            }
            setFromEuler(e1) {
                return this.x = e1._x, this.y = e1._y, this.z = e1._z, this;
            }
            setFromColor(e1) {
                return this.x = e1.r, this.y = e1.g, this.z = e1.b, this;
            }
            equals(e1) {
                return e1.x === this.x && e1.y === this.y && e1.z === this.z;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return this.x = e1[t], this.y = e1[t + 1], this.z = e1[t + 2], this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                return e1[t] = this.x, e1[t + 1] = this.y, e1[t + 2] = this.z, e1;
            }
            fromBufferAttribute(e1, t) {
                return this.x = e1.getX(t), this.y = e1.getY(t), this.z = e1.getZ(t), this;
            }
            random() {
                return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
            }
            randomDirection() {
                const e1 = 2 * (Math.random() - .5), t = Math.random() * Math.PI * 2, n = Math.sqrt(1 - e1 ** 2);
                return this.x = n * Math.cos(t), this.y = n * Math.sin(t), this.z = e1, this;
            }
            *[Symbol.iterator]() {
                yield this.x, yield this.y, yield this.z;
            }
        }
        const ID = new SD, ND = new TD;
        class DD {
            constructor(e1, t, n, i, r, a, s, o, l, c, u, h, d, p, f, m){
                DD.prototype.isMatrix4 = !0, this.elements = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ], void 0 !== e1 && this.set(e1, t, n, i, r, a, s, o, l, c, u, h, d, p, f, m);
            }
            set(e1, t, n, i, r, a, s, o, l, c, u, h, d, p, f, m) {
                const g = this.elements;
                return g[0] = e1, g[4] = t, g[8] = n, g[12] = i, g[1] = r, g[5] = a, g[9] = s, g[13] = o, g[2] = l, g[6] = c, g[10] = u, g[14] = h, g[3] = d, g[7] = p, g[11] = f, g[15] = m, this;
            }
            identity() {
                return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            clone() {
                return (new DD).fromArray(this.elements);
            }
            copy(e1) {
                const t = this.elements, n = e1.elements;
                return t[0] = n[0], t[1] = n[1], t[2] = n[2], t[3] = n[3], t[4] = n[4], t[5] = n[5], t[6] = n[6], t[7] = n[7], t[8] = n[8], t[9] = n[9], t[10] = n[10], t[11] = n[11], t[12] = n[12], t[13] = n[13], t[14] = n[14], t[15] = n[15], this;
            }
            copyPosition(e1) {
                const t = this.elements, n = e1.elements;
                return t[12] = n[12], t[13] = n[13], t[14] = n[14], this;
            }
            setFromMatrix3(e1) {
                const t = e1.elements;
                return this.set(t[0], t[3], t[6], 0, t[1], t[4], t[7], 0, t[2], t[5], t[8], 0, 0, 0, 0, 1), this;
            }
            extractBasis(e1, t, n) {
                return e1.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
            }
            makeBasis(e1, t, n) {
                return this.set(e1.x, t.x, n.x, 0, e1.y, t.y, n.y, 0, e1.z, t.z, n.z, 0, 0, 0, 0, 1), this;
            }
            extractRotation(e1) {
                const t = this.elements, n = e1.elements, i = 1 / CD.setFromMatrixColumn(e1, 0).length(), r = 1 / CD.setFromMatrixColumn(e1, 1).length(), a = 1 / CD.setFromMatrixColumn(e1, 2).length();
                return t[0] = n[0] * i, t[1] = n[1] * i, t[2] = n[2] * i, t[3] = 0, t[4] = n[4] * r, t[5] = n[5] * r, t[6] = n[6] * r, t[7] = 0, t[8] = n[8] * a, t[9] = n[9] * a, t[10] = n[10] * a, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
            }
            makeRotationFromEuler(e1) {
                const t = this.elements, n = e1.x, i = e1.y, r = e1.z, a = Math.cos(n), s = Math.sin(n), o = Math.cos(i), l = Math.sin(i), c = Math.cos(r), u = Math.sin(r);
                if ("XYZ" === e1.order) {
                    const e1 = a * c, n = a * u, i = s * c, r = s * u;
                    t[0] = o * c, t[4] = -o * u, t[8] = l, t[1] = n + i * l, t[5] = e1 - r * l, t[9] = -s * o, t[2] = r - e1 * l, t[6] = i + n * l, t[10] = a * o;
                } else if ("YXZ" === e1.order) {
                    const e1 = o * c, n = o * u, i = l * c, r = l * u;
                    t[0] = e1 + r * s, t[4] = i * s - n, t[8] = a * l, t[1] = a * u, t[5] = a * c, t[9] = -s, t[2] = n * s - i, t[6] = r + e1 * s, t[10] = a * o;
                } else if ("ZXY" === e1.order) {
                    const e1 = o * c, n = o * u, i = l * c, r = l * u;
                    t[0] = e1 - r * s, t[4] = -a * u, t[8] = i + n * s, t[1] = n + i * s, t[5] = a * c, t[9] = r - e1 * s, t[2] = -a * l, t[6] = s, t[10] = a * o;
                } else if ("ZYX" === e1.order) {
                    const e1 = a * c, n = a * u, i = s * c, r = s * u;
                    t[0] = o * c, t[4] = i * l - n, t[8] = e1 * l + r, t[1] = o * u, t[5] = r * l + e1, t[9] = n * l - i, t[2] = -l, t[6] = s * o, t[10] = a * o;
                } else if ("YZX" === e1.order) {
                    const e1 = a * o, n = a * l, i = s * o, r = s * l;
                    t[0] = o * c, t[4] = r - e1 * u, t[8] = i * u + n, t[1] = u, t[5] = a * c, t[9] = -s * c, t[2] = -l * c, t[6] = n * u + i, t[10] = e1 - r * u;
                } else if ("XZY" === e1.order) {
                    const e1 = a * o, n = a * l, i = s * o, r = s * l;
                    t[0] = o * c, t[4] = -u, t[8] = l * c, t[1] = e1 * u + r, t[5] = a * c, t[9] = n * u - i, t[2] = i * u - n, t[6] = s * c, t[10] = r * u + e1;
                }
                return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
            }
            makeRotationFromQuaternion(e1) {
                return this.compose(RD, e1, zD);
            }
            lookAt(e1, t, n) {
                const i = this.elements;
                return UD.subVectors(e1, t), 0 === UD.lengthSq() && (UD.z = 1), UD.normalize(), OD.crossVectors(n, UD), 0 === OD.lengthSq() && (1 === Math.abs(n.z) ? UD.x += 1e-4 : UD.z += 1e-4, UD.normalize(), OD.crossVectors(n, UD)), OD.normalize(), PD.crossVectors(UD, OD), i[0] = OD.x, i[4] = PD.x, i[8] = UD.x, i[1] = OD.y, i[5] = PD.y, i[9] = UD.y, i[2] = OD.z, i[6] = PD.z, i[10] = UD.z, this;
            }
            multiply(e1) {
                return this.multiplyMatrices(this, e1);
            }
            premultiply(e1) {
                return this.multiplyMatrices(e1, this);
            }
            multiplyMatrices(e1, t) {
                const n = e1.elements, i = t.elements, r = this.elements, a = n[0], s = n[4], o = n[8], l = n[12], c = n[1], u = n[5], h = n[9], d = n[13], p = n[2], f = n[6], m = n[10], g = n[14], A = n[3], v = n[7], M = n[11], y = n[15], x = i[0], _ = i[4], b = i[8], w = i[12], E = i[1], T = i[5], S = i[9], I = i[13], N = i[2], D = i[6], C = i[10], L = i[14], R = i[3], z = i[7], O = i[11], P = i[15];
                return r[0] = a * x + s * E + o * N + l * R, r[4] = a * _ + s * T + o * D + l * z, r[8] = a * b + s * S + o * C + l * O, r[12] = a * w + s * I + o * L + l * P, r[1] = c * x + u * E + h * N + d * R, r[5] = c * _ + u * T + h * D + d * z, r[9] = c * b + u * S + h * C + d * O, r[13] = c * w + u * I + h * L + d * P, r[2] = p * x + f * E + m * N + g * R, r[6] = p * _ + f * T + m * D + g * z, r[10] = p * b + f * S + m * C + g * O, r[14] = p * w + f * I + m * L + g * P, r[3] = A * x + v * E + M * N + y * R, r[7] = A * _ + v * T + M * D + y * z, r[11] = A * b + v * S + M * C + y * O, r[15] = A * w + v * I + M * L + y * P, this;
            }
            multiplyScalar(e1) {
                const t = this.elements;
                return t[0] *= e1, t[4] *= e1, t[8] *= e1, t[12] *= e1, t[1] *= e1, t[5] *= e1, t[9] *= e1, t[13] *= e1, t[2] *= e1, t[6] *= e1, t[10] *= e1, t[14] *= e1, t[3] *= e1, t[7] *= e1, t[11] *= e1, t[15] *= e1, this;
            }
            determinant() {
                const e1 = this.elements, t = e1[0], n = e1[4], i = e1[8], r = e1[12], a = e1[1], s = e1[5], o = e1[9], l = e1[13], c = e1[2], u = e1[6], h = e1[10], d = e1[14];
                return e1[3] * (+r * o * u - i * l * u - r * s * h + n * l * h + i * s * d - n * o * d) + e1[7] * (+t * o * d - t * l * h + r * a * h - i * a * d + i * l * c - r * o * c) + e1[11] * (+t * l * u - t * s * d - r * a * u + n * a * d + r * s * c - n * l * c) + e1[15] * (-i * s * c - t * o * u + t * s * h + i * a * u - n * a * h + n * o * c);
            }
            transpose() {
                const e1 = this.elements;
                let t;
                return t = e1[1], e1[1] = e1[4], e1[4] = t, t = e1[2], e1[2] = e1[8], e1[8] = t, t = e1[6], e1[6] = e1[9], e1[9] = t, t = e1[3], e1[3] = e1[12], e1[12] = t, t = e1[7], e1[7] = e1[13], e1[13] = t, t = e1[11], e1[11] = e1[14], e1[14] = t, this;
            }
            setPosition(e1, t, n) {
                const i = this.elements;
                return e1.isVector3 ? (i[12] = e1.x, i[13] = e1.y, i[14] = e1.z) : (i[12] = e1, i[13] = t, i[14] = n), this;
            }
            invert() {
                const e1 = this.elements, t = e1[0], n = e1[1], i = e1[2], r = e1[3], a = e1[4], s = e1[5], o = e1[6], l = e1[7], c = e1[8], u = e1[9], h = e1[10], d = e1[11], p = e1[12], f = e1[13], m = e1[14], g = e1[15], A = u * m * l - f * h * l + f * o * d - s * m * d - u * o * g + s * h * g, v = p * h * l - c * m * l - p * o * d + a * m * d + c * o * g - a * h * g, M = c * f * l - p * u * l + p * s * d - a * f * d - c * s * g + a * u * g, y = p * u * o - c * f * o - p * s * h + a * f * h + c * s * m - a * u * m, x = t * A + n * v + i * M + r * y;
                if (0 === x) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                const _ = 1 / x;
                return e1[0] = A * _, e1[1] = (f * h * r - u * m * r - f * i * d + n * m * d + u * i * g - n * h * g) * _, e1[2] = (s * m * r - f * o * r + f * i * l - n * m * l - s * i * g + n * o * g) * _, e1[3] = (u * o * r - s * h * r - u * i * l + n * h * l + s * i * d - n * o * d) * _, e1[4] = v * _, e1[5] = (c * m * r - p * h * r + p * i * d - t * m * d - c * i * g + t * h * g) * _, e1[6] = (p * o * r - a * m * r - p * i * l + t * m * l + a * i * g - t * o * g) * _, e1[7] = (a * h * r - c * o * r + c * i * l - t * h * l - a * i * d + t * o * d) * _, e1[8] = M * _, e1[9] = (p * u * r - c * f * r - p * n * d + t * f * d + c * n * g - t * u * g) * _, e1[10] = (a * f * r - p * s * r + p * n * l - t * f * l - a * n * g + t * s * g) * _, e1[11] = (c * s * r - a * u * r - c * n * l + t * u * l + a * n * d - t * s * d) * _, e1[12] = y * _, e1[13] = (c * f * i - p * u * i + p * n * h - t * f * h - c * n * m + t * u * m) * _, e1[14] = (p * s * i - a * f * i - p * n * o + t * f * o + a * n * m - t * s * m) * _, e1[15] = (a * u * i - c * s * i + c * n * o - t * u * o - a * n * h + t * s * h) * _, this;
            }
            scale(e1) {
                const t = this.elements, n = e1.x, i = e1.y, r = e1.z;
                return t[0] *= n, t[4] *= i, t[8] *= r, t[1] *= n, t[5] *= i, t[9] *= r, t[2] *= n, t[6] *= i, t[10] *= r, t[3] *= n, t[7] *= i, t[11] *= r, this;
            }
            getMaxScaleOnAxis() {
                const e1 = this.elements, t = e1[0] * e1[0] + e1[1] * e1[1] + e1[2] * e1[2], n = e1[4] * e1[4] + e1[5] * e1[5] + e1[6] * e1[6], i = e1[8] * e1[8] + e1[9] * e1[9] + e1[10] * e1[10];
                return Math.sqrt(Math.max(t, n, i));
            }
            makeTranslation(e1, t, n) {
                return e1.isVector3 ? this.set(1, 0, 0, e1.x, 0, 1, 0, e1.y, 0, 0, 1, e1.z, 0, 0, 0, 1) : this.set(1, 0, 0, e1, 0, 1, 0, t, 0, 0, 1, n, 0, 0, 0, 1), this;
            }
            makeRotationX(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(1, 0, 0, 0, 0, t, -n, 0, 0, n, t, 0, 0, 0, 0, 1), this;
            }
            makeRotationY(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(t, 0, n, 0, 0, 1, 0, 0, -n, 0, t, 0, 0, 0, 0, 1), this;
            }
            makeRotationZ(e1) {
                const t = Math.cos(e1), n = Math.sin(e1);
                return this.set(t, -n, 0, 0, n, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
            }
            makeRotationAxis(e1, t) {
                const n = Math.cos(t), i = Math.sin(t), r = 1 - n, a = e1.x, s = e1.y, o = e1.z, l = r * a, c = r * s;
                return this.set(l * a + n, l * s - i * o, l * o + i * s, 0, l * s + i * o, c * s + n, c * o - i * a, 0, l * o - i * s, c * o + i * a, r * o * o + n, 0, 0, 0, 0, 1), this;
            }
            makeScale(e1, t, n) {
                return this.set(e1, 0, 0, 0, 0, t, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
            }
            makeShear(e1, t, n, i, r, a) {
                return this.set(1, n, r, 0, e1, 1, a, 0, t, i, 1, 0, 0, 0, 0, 1), this;
            }
            compose(e1, t, n) {
                const i = this.elements, r = t._x, a = t._y, s = t._z, o = t._w, l = r + r, c = a + a, u = s + s, h = r * l, d = r * c, p = r * u, f = a * c, m = a * u, g = s * u, A = o * l, v = o * c, M = o * u, y = n.x, x = n.y, _ = n.z;
                return i[0] = (1 - (f + g)) * y, i[1] = (d + M) * y, i[2] = (p - v) * y, i[3] = 0, i[4] = (d - M) * x, i[5] = (1 - (h + g)) * x, i[6] = (m + A) * x, i[7] = 0, i[8] = (p + v) * _, i[9] = (m - A) * _, i[10] = (1 - (h + f)) * _, i[11] = 0, i[12] = e1.x, i[13] = e1.y, i[14] = e1.z, i[15] = 1, this;
            }
            decompose(e1, t, n) {
                const i = this.elements;
                let r = CD.set(i[0], i[1], i[2]).length();
                const a = CD.set(i[4], i[5], i[6]).length(), s = CD.set(i[8], i[9], i[10]).length();
                this.determinant() < 0 && (r = -r), e1.x = i[12], e1.y = i[13], e1.z = i[14], LD.copy(this);
                const o = 1 / r, l = 1 / a, c = 1 / s;
                return LD.elements[0] *= o, LD.elements[1] *= o, LD.elements[2] *= o, LD.elements[4] *= l, LD.elements[5] *= l, LD.elements[6] *= l, LD.elements[8] *= c, LD.elements[9] *= c, LD.elements[10] *= c, t.setFromRotationMatrix(LD), n.x = r, n.y = a, n.z = s, this;
            }
            makePerspective(e1, t, n, i, r, a) {
                let s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : YN;
                const o = this.elements, l = 2 * r / (t - e1), c = 2 * r / (n - i), u = (t + e1) / (t - e1), h = (n + i) / (n - i);
                let d, p;
                if (s === YN) d = -(a + r) / (a - r), p = -2 * a * r / (a - r);
                else {
                    if (2001 !== s) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + s);
                    d = -a / (a - r), p = -a * r / (a - r);
                }
                return o[0] = l, o[4] = 0, o[8] = u, o[12] = 0, o[1] = 0, o[5] = c, o[9] = h, o[13] = 0, o[2] = 0, o[6] = 0, o[10] = d, o[14] = p, o[3] = 0, o[7] = 0, o[11] = -1, o[15] = 0, this;
            }
            makeOrthographic(e1, t, n, i, r, a) {
                let s = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : YN;
                const o = this.elements, l = 1 / (t - e1), c = 1 / (n - i), u = 1 / (a - r), h = (t + e1) * l, d = (n + i) * c;
                let p, f;
                if (s === YN) p = (a + r) * u, f = -2 * u;
                else {
                    if (2001 !== s) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + s);
                    p = r * u, f = -1 * u;
                }
                return o[0] = 2 * l, o[4] = 0, o[8] = 0, o[12] = -h, o[1] = 0, o[5] = 2 * c, o[9] = 0, o[13] = -d, o[2] = 0, o[6] = 0, o[10] = f, o[14] = -p, o[3] = 0, o[7] = 0, o[11] = 0, o[15] = 1, this;
            }
            equals(e1) {
                const t = this.elements, n = e1.elements;
                for(let e1 = 0; e1 < 16; e1++)if (t[e1] !== n[e1]) return !1;
                return !0;
            }
            fromArray(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                for(let n = 0; n < 16; n++)this.elements[n] = e1[n + t];
                return this;
            }
            toArray() {
                let e1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
                const n = this.elements;
                return e1[t] = n[0], e1[t + 1] = n[1], e1[t + 2] = n[2], e1[t + 3] = n[3], e1[t + 4] = n[4], e1[t + 5] = n[5], e1[t + 6] = n[6], e1[t + 7] = n[7], e1[t + 8] = n[8], e1[t + 9] = n[9], e1[t + 10] = n[10], e1[t + 11] = n[11], e1[t + 12] = n[12], e1[t + 13] = n[13], e1[t + 14] = n[14], e1[t + 15] = n[15], e1;
            }
        }
        const CD = new SD, LD = new DD, RD = new SD(0, 0, 0), zD = new SD(1, 1, 1), OD = new SD, PD = new SD, UD = new SD, kD = (e1)=>Math.cos(e1 * Math.PI / 180), jD = (e1)=>Math.sin(e1 * Math.PI / 180), BD = (e1)=>Math.tan(e1 * Math.PI / 180), FD = function(e1, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 21;
            const i = new DD(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -t.X, -t.Y, -t.Z, 1), r = -90, a = -90, s = new DD(kD(a), -jD(a), 0, 0, jD(a), kD(a), 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), o = new DD(kD(r), 0, -jD(r), 0, 0, 1, 0, 0, jD(r), 0, kD(r), 0, 0, 0, 0, 1), l = new DD(1, 0, 0, 0, 0, kD(0), jD(0), 0, 0, -jD(0), kD(0), 0, 0, 0, 0, 1), c = s.multiply(o).multiply(l).multiply(new DD(0, 0, 1, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1)), u = n / 2, h = new DD(1 / BD(u), 0, 0, 0, 0, 1 / BD(u), 0, 0, 0, 0, 0, 1, 0, 0, 1, 0), d = i.multiply(c).multiply(h), { X: p, Y: f, Z: m } = e1, g = ((e1, t)=>{
                const n = t.elements;
                return new zN(e1.x * n[0] + e1.y * n[1] + e1.z * n[2] + e1.w * n[3], e1.x * n[4] + e1.y * n[5] + e1.z * n[6] + e1.w * n[7], e1.x * n[8] + e1.y * n[9] + e1.z * n[10] + e1.w * n[11], e1.x * n[12] + e1.y * n[13] + e1.z * n[14] + e1.w * n[15]);
            })(new zN(p, f, m, 1), d);
            if (g.w > 0) {
                const e1 = 1 / g.w;
                return {
                    x: g.x * e1 / 2 + .5,
                    y: 1 - g.y * e1 / 2 - .5
                };
            }
            return null;
        }, HD = "#version 300 es", VD = "".concat(HD, "\n  precision lowp float;\n\n  in vec2 iPos;\n  in vec2 iTexCoord;\n\n  out vec2 vTexCoord;\n  out vec2 vAltTexCoord;\n\n  void main()	{\n    vTexCoord = iTexCoord;\n    vAltTexCoord = vec2(iTexCoord.x, 1.0 - iTexCoord.y);\n    gl_Position = vec4(iPos, 0, 1);\n  }\n"), GD = "".concat(HD, "\n  precision lowp float;\n  precision lowp int;\n\n  in vec2 vTexCoord;\n  in vec2 vAltTexCoord;\n\n  out vec4 oColor;\n\n  uniform vec4 uColor;\n  uniform sampler2D uTexture0;\n  uniform sampler2D uTexture1;\n\n  void main()	{\n    vec4 color1 = texture(uTexture0, vTexCoord);\n    vec4 color2 = texture(uTexture1, vAltTexCoord);\n\n    int r = int(uColor.r);\n    int rColor = int(color2.r);\n\n    if (r != 0 && r == rColor) {\n      vec4 uSelectColor = vec4(1.0, 0.65, 0.0, 1.0);\n\n      float t = 0.7;\n      oColor = color1 * t + uSelectColor * (1.0 - t);\n    } else {\n      oColor = color1;\n    }\n  }\n");
        function QD(e1, t, n) {
            WD(e1, t), t.set(e1, n);
        }
        function WD(e1, t) {
            if (t.has(e1)) throw new TypeError("Cannot initialize the same private elements twice on an object");
        }
        function YD(e1, t, n) {
            return (t = function(e1) {
                var t = function(e1) {
                    if ("object" != typeof e1 || !e1) return e1;
                    var t = e1[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e1, "string");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e1);
                }(e1);
                return "symbol" == typeof t ? t : t + "";
            }(t)) in e1 ? Object.defineProperty(e1, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e1[t] = n, e1;
        }
        function XD(e1, t) {
            return e1.get(ZD(e1, t));
        }
        function ZD(e1, t, n) {
            if ("function" == typeof e1 ? e1 === t : e1.has(t)) return arguments.length < 3 ? t : n;
            throw new TypeError("Private element is not present on this object");
        }
        var qD = new WeakSet, KD = new WeakMap, JD = new WeakMap;
        function $D() {
            const e1 = this._gl, t = e1.createVertexArray();
            e1.bindVertexArray(t);
            const n = e1.createBuffer();
            e1.bindBuffer(e1.ARRAY_BUFFER, n), e1.bufferData(e1.ARRAY_BUFFER, new Float32Array([
                -1,
                1,
                1,
                1,
                1,
                -1,
                -1,
                -1
            ]), e1.STATIC_DRAW), e1.vertexAttribPointer(0, 2, e1.FLOAT, !1, 0, 0), e1.enableVertexAttribArray(0);
            const i = e1.createBuffer();
            e1.bindBuffer(e1.ARRAY_BUFFER, i), e1.bufferData(e1.ARRAY_BUFFER, new Float32Array([
                0,
                0,
                1,
                0,
                1,
                1,
                0,
                1
            ]), e1.STATIC_DRAW), e1.vertexAttribPointer(1, 2, e1.FLOAT, !1, 0, 0), e1.enableVertexAttribArray(1);
            const r = e1.createBuffer();
            e1.bindBuffer(e1.ELEMENT_ARRAY_BUFFER, r), e1.bufferData(e1.ELEMENT_ARRAY_BUFFER, new Uint16Array([
                0,
                1,
                2,
                0,
                2,
                3
            ]), e1.STATIC_DRAW), this._vao && e1.deleteVertexArray(this._vao), this._posBuf && e1.deleteBuffer(this._posBuf), this._texCoordBuf && e1.deleteBuffer(this._texCoordBuf), this._ebo && e1.deleteBuffer(this._ebo), this._vao = t, this._posBuf = n, this._texCoordBuf = i, this._ebo = r;
        }
        function eC() {
            const e1 = this._gl, t = this._program;
            this._uColorLocation = e1.getUniformLocation(t, "uColor"), e1.uniform1i(e1.getUniformLocation(t, "uTexture0"), 0), e1.uniform1i(e1.getUniformLocation(t, "uTexture1"), 1);
        }
        async function tC(e1) {
            const t = this._gl, n = XD(JD, this);
            return new Promise((i)=>{
                const r = new Image;
                r.crossOrigin = "anonymous", r.onload = ()=>{
                    const e1 = t.createTexture();
                    t.bindTexture(t.TEXTURE_2D, e1), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, r), n(r.width) && n(r.height) ? (t.generateMipmap(t.TEXTURE_2D), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.REPEAT), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR_MIPMAP_LINEAR)) : (t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR)), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), i(e1);
                }, r.onerror = (e1)=>{
                    console.error(e1), i(null);
                }, r.src = e1;
            });
        }
        async function nC(e1) {
            const t = this._gl, n = t.createTexture();
            return t.bindTexture(t.TEXTURE_2D, n), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA32F, e1.width, e1.height, 0, t.RGBA, t.FLOAT, e1.data.slice()), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.NEAREST), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.NEAREST), n;
        }
        function iC(e1, t) {
            const n = this._gl, i = XD(KD, this), r = i(n, n.VERTEX_SHADER, e1), a = i(n, n.FRAGMENT_SHADER, t);
            if (!r || !a) return r && n.deleteShader(r), a && n.deleteShader(a), null;
            const s = n.createProgram();
            return n.attachShader(s, r), n.attachShader(s, a), n.linkProgram(s), n.deleteShader(r), n.deleteShader(a), n.getProgramParameter(s, n.LINK_STATUS) ? (n.useProgram(s), s) : (console.error("Failed to link program:", n.getProgramInfoLog(s)), n.deleteProgram(s), null);
        }
        const rC = new class {
            constructor(){
                var e1;
                WD(this, e1 = qD), e1.add(this), YD(this, "_textures", []), YD(this, "_canvas", void 0), YD(this, "_gl", void 0), YD(this, "_program", void 0), YD(this, "_vao", void 0), YD(this, "_ebo", void 0), YD(this, "_posBuf", void 0), YD(this, "_texCoordBuf", void 0), YD(this, "_uColorLocation", void 0), QD(this, KD, (e1, t, n)=>{
                    const i = e1.createShader(t);
                    return e1.shaderSource(i, n), e1.compileShader(i), e1.getShaderParameter(i, e1.COMPILE_STATUS) ? i : (console.error("Failed to load shader:", e1.getShaderInfoLog(i)), e1.deleteShader(i), null);
                }), QD(this, JD, (e1)=>!(e1 & e1 - 1));
            }
            async init(e1) {
                this._canvas = e1, this._gl = e1.getContext("webgl2"), this._program && this._gl.deleteProgram(this._program), this._program = ZD(qD, this, iC).call(this, VD, GD), ZD(qD, this, $D).call(this), ZD(qD, this, eC).call(this);
            }
            async setTextures(e1, t) {
                const n = this._gl;
                this._textures.forEach((e1)=>{
                    e1 && n.deleteTexture(e1);
                }), this._textures = new Array(2), e1 && (this._textures[0] = await ZD(qD, this, tC).call(this, e1)), t && (this._textures[1] = await ZD(qD, this, nC).call(this, t));
            }
            draw(e1) {
                const t = this._gl;
                t.clearColor(1, 1, 1, 1), t.clear(t.COLOR_BUFFER_BIT), this._textures.forEach((e1, n)=>{
                    t.activeTexture(t.TEXTURE0 + n), t.bindTexture(t.TEXTURE_2D, e1);
                }), e1 ? t.uniform4f(this._uColorLocation, e1.R, e1.G, e1.B, e1.A) : t.uniform4f(this._uColorLocation, 0, 0, 0, 0), t.drawElements(t.TRIANGLES, 6, t.UNSIGNED_SHORT, 0);
            }
        }, aC = "top-view-mask", sC = tN((e1)=>{
            let { disabled: n } = e1;
            const { currentFloorIndex: i } = Bi, { json: r, topViewImage: a, bareshell: s, topViewResolutionUpscale: o } = Bi.config, l = BI.currentPanoramaId, c = 200, u = 200, [h, d] = (0, t.useState)(!0), [p, f] = (0, t.useState)(!1), [m, g] = (0, t.useState)(null), A = (0, t.useMemo)(()=>((e1, t)=>{
                    const n = e1.Floors[t];
                    if (!n) return null;
                    let i = 1 / 0, r = 1 / 0, a = n.Location.Z, s = -1 / 0, o = -1 / 0, l = n.Location.Z + n.Height;
                    const c = ((e1, t)=>{
                        const n = [];
                        return ((e1, t)=>{
                            const n = t.length;
                            for(let i = 0; i < n; i++){
                                const n = t[i], r = ED(n.Location.X, n.Location.Y, n.Extent.X, n.Extent.Y, n.Rotation.Yaw * Math.PI / 180);
                                for(let t = 0; t < 4; t++)e1.push(r[t]);
                            }
                        })(n, e1.Decors), ((e1, t, n)=>{
                            const i = t.length, r = new Set;
                            for(let a = 0; a < i; a++){
                                const i = t[a];
                                if (!i.IsExterior) continue;
                                const s = wD(n, i.Vertices[0]), o = i.ControlPoint, l = wD(n, i.Vertices[1]);
                                if (r.has(s) || (e1.push({
                                    x: s.Location.X,
                                    y: s.Location.Y
                                }), r.add(s.ID)), o) {
                                    const t = 1 / 21, n = 1 - t;
                                    for(let i = t; i <= n; i += t)e1.push(bD(i, s, o, l));
                                }
                                r.has(l) || (e1.push({
                                    x: l.Location.X,
                                    y: l.Location.Y
                                }), r.add(l.ID));
                            }
                        })(n, e1.Walls, t), n;
                    })(n, e1.Vertices), u = c.length;
                    for(let e1 = 0; e1 < u; e1++){
                        const { x: t, y: n } = c[e1];
                        t < i && (i = t), t > s && (s = t), n < r && (r = n), n > o && (o = n);
                    }
                    return {
                        Origin: {
                            X: (i + s) / 2,
                            Y: (r + o) / 2,
                            Z: (a + l) / 2
                        },
                        Extent: {
                            X: (s - i) / 2,
                            Y: (o - r) / 2,
                            Z: (l - a) / 2
                        }
                    };
                })(r, i), []), v = (0, t.useMemo)(()=>(function(e1) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50;
                    const n = BD((arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 21) / 2), i = Math.max(e1.Extent.X, e1.Extent.Y) + t, r = e1.Extent.Z + i / n;
                    return {
                        X: e1.Origin.X,
                        Y: e1.Origin.Y,
                        Z: e1.Origin.Z + r
                    };
                })(A), [
                i
            ]), M = (0, t.useMemo)(()=>{
                if (!v) return [];
                const e1 = r.Floors[i];
                return e1.CameraPoints.map((t)=>{
                    const { X: n, Y: i } = t.Location, r = e1.Location.Z + t.Location.Z;
                    return {
                        id: t.ID,
                        roomId: t.RoomID,
                        position: FD({
                            X: n,
                            Y: i,
                            Z: r
                        }, v)
                    };
                });
            }, [
                i,
                v,
                c
            ]);
            (0, t.useEffect)(()=>{
                d(!0), r && !n && y().then(()=>{
                    d(!1);
                });
            }, [
                a
            ]);
            const y = async ()=>{
                const e1 = await Ox.getDepth(b);
                g(e1), e1 || console.warn("Failed to load top view color mask: ".concat(b));
                const t = document.getElementById(aC);
                t && (await rC.init(t), await rC.setTextures(a, e1), rC.draw());
            }, x = ()=>{
                hD.setCurrentColor({
                    r: 0,
                    g: 0,
                    b: 0,
                    a: 0
                }), rC.draw();
            }, _ = ()=>{
                Bi.showControls(), f(!1);
            }, [b] = qx([
                a
            ]), w = {
                width: c,
                height: u
            }, E = {
                width: c * o,
                height: u * o
            };
            return t.createElement(t.Fragment, null, p && t.createElement(t.Fragment, null, t.createElement("div", {
                className: "widget-tab__panorama-close-map",
                onClick: _
            }, t.createElement("img", {
                src: rN,
                alt: "close-map"
            })), t.createElement("div", {
                className: "map-overlay map-overlay--visible",
                onClick: _
            })), t.createElement("div", {
                className: (()=>{
                    const e1 = [
                        "widget-tab__panorama-top-view-map"
                    ];
                    return s && e1.push("widget-tab__panorama-top-view-map--bottom"), h && e1.push("widget-tab__panorama-top-view-map--hidden"), p && e1.push("widget-tab__panorama-top-view-map--scaled"), e1.join(" ");
                })()
            }, t.createElement("div", {
                className: "display-wrapper"
            }, t.createElement("canvas", {
                id: aC,
                width: E.width,
                height: E.height,
                style: w,
                onClick: (e1)=>{
                    if (Bi.config.width <= iN.tablet && !p) return x(), Bi.hideControls(), void f(!0);
                    if (!document.getElementById(aC)) return;
                    _();
                    const t = e1.nativeEvent.layerX / c, n = e1.nativeEvent.layerY / u, i = hD.currentColor, a = r.RoomColorIDPairs.find((e1)=>e1.ColorID.R === i.R && e1.ColorID.G === i.G && e1.ColorID.B === i.B);
                    let s = M;
                    a && (s = s.filter((e1)=>e1.roomId === a.ObjectID));
                    const [o] = s.sort((e1, i)=>{
                        const r = e1.position.x - t, a = e1.position.y - n, s = i.position.x - t, o = i.position.y - n;
                        return r * r + a * a - (s * s + o * o);
                    });
                    o && BI.setCurrentPanoramaById(o.id);
                },
                onMouseMove: (e1)=>{
                    if (!m || h) return;
                    const t = e1.nativeEvent.layerX / c, n = e1.nativeEvent.layerY / u;
                    if (t < 0 || n < 0 || t > 1 || n > 1) return;
                    const { R: i, G: r, B: a, A: s } = Yx(t, n, m);
                    e1.target.style.cursor = 0 === i ? "default" : "pointer";
                    const o = {
                        R: i,
                        G: r,
                        B: a,
                        A: s
                    };
                    rC.draw(o), hD.setCurrentColor(o);
                },
                onMouseLeave: x
            }), M.map((e1)=>{
                const n = e1.id === l ? "camera camera--current" : "camera", i = {
                    left: e1.position.x * c,
                    top: e1.position.y * c
                };
                return t.createElement("span", {
                    className: n,
                    key: e1.id,
                    style: i
                });
            }))));
        }), oC = tN((e1)=>{
            let { disabled: n } = e1;
            const i = Bi.isCapable("top_view_as_miniplan") || Boolean(Bi.config.forceTopViewOnMap), r = Boolean(Bi.config.topViewImage), a = i && r;
            i && !r && console.warn("Top view map requested, but image missed!");
            const s = a ? sC : _D;
            return t.createElement(s, {
                disabled: n
            });
        }), lC = "data:image/svg+xml;base64,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", cC = tN((e1)=>{
            let { items: n, type: i, disabled: r } = e1;
            const a = [
                {
                    icon: mD,
                    text: Oy("rotate-plan")
                },
                {
                    icon: lC,
                    text: Oy("research-plan")
                }
            ], s = [
                {
                    icon: mD,
                    text: Oy("create-points")
                },
                {
                    icon: lC,
                    text: Oy("delete-points")
                }
            ], [o, l] = (0, t.useState)(!1), [c, u] = (0, t.useState)(Bi.instructionVisible), h = ()=>BI.updateWindowSize(Bi.config.width, Bi.config.height);
            return (0, t.useEffect)(()=>{
                performance.mark("opening panorama mode"), BI.enableRender();
                const e1 = document.querySelector(".widget-tab__panorama-overlay");
                return e1.appendChild(BI.renderer.domElement), ()=>{
                    BI.setInitialCurrentPanorama(), BI.camera.deviceOrientationControls.disable(), BI.setCameraFov(BI.cameraFovValues.x1), BI.camera.controls.setDefaultPosition(), BI.setAutoRotateState(!1), BI.setRulerMode(!1), BI.disableRender(), e1.innerHTML = "";
                };
            }, []), (0, t.useEffect)(()=>{
                const e1 = BI.floorsGroup.children.some((e1)=>e1.floorIndex === Bi.currentFloorIndex);
                return BI.initialized ? e1 ? (BI.setCurrentPanoramasGroup(Bi.currentFloorIndex), void BI.setInitialCurrentPanorama()) : (BI.setLoadingState(!0), void BI.createPanoramasGroup(n, i, Bi.currentFloorIndex).finally(()=>BI.setLoadingState(!1))) : (BI.setLoadingState(!0), performance.mark("start PanaramaStore Init"), void BI.init(n, i, Bi.currentFloorIndex).finally(()=>BI.setLoadingState(!1)));
            }, [
                Bi.currentFloorIndex
            ]), (0, t.useEffect)(h, [
                Bi.config.width,
                Bi.config.height
            ]), t.createElement(t.Fragment, null, t.createElement("div", {
                className: "widget-tab__panorama"
            }, BI.loading && t.createElement(xD, {
                absolute: !0
            }), t.createElement("div", {
                className: "widget-tab__panorama-overlay",
                onContextMenu: Ly
            }), BI.currentPanorama && t.createElement(oC, {
                disabled: r
            }), BI.currentPanorama && t.createElement("div", {
                className: "".concat(Bi.config.bareshell ? "widget-tab__panorama-controls-container" : "")
            }, t.createElement("div", {
                className: "widget-tab__panorama-controls"
            }, BI.currentPanorama.userData.images.scene_depth && t.createElement(vD, {
                onClick: ()=>{
                    BI.toggleRulerMode(), BI.rulerInstructionShown || l(!0);
                }
            }), t.createElement(MD, null), t.createElement(AD, null)), Bi.config.bareshell && t.createElement("div", {
                onClick: async ()=>{
                    BI.setBareshell(!BI.bareshell), BI.currentPanorama && (BI.setLoadingState(!0), await BI.currentPanorama.fadeOut(), await BI.currentPanorama.createMaterial(), await BI.currentPanorama.fadeIn(), BI.setLoadingState(!1));
                },
                className: "widget-tab__panorama-controls"
            }, t.createElement(yD, {
                isBareshell: BI.bareshell
            })))), c && t.createElement(RN, {
                disabled: r,
                steps: a,
                onClick: async ()=>{
                    if (u(!1), h(), !_x.isMobile && !_x.isTablet) return;
                    if (!Bi.configParams.enableGyroscope) return;
                    if (BI.camera.deviceOrientationControls.connected) return BI.camera.deviceOrientationControls.enable();
                    if (await _x.requestDeviceOrientation() !== xx) return;
                    const e1 = ()=>{
                        window.removeEventListener("deviceorientation", e1), BI.camera.deviceOrientationControls.connect(), setTimeout(()=>BI.camera.deviceOrientationControls.enable(), 250);
                    };
                    window.addEventListener("deviceorientation", e1);
                }
            }), o && t.createElement(RN, {
                steps: s,
                onClick: ()=>{
                    BI.setRulerInstructionShown(!0), l(!1);
                }
            }));
        }), uC = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5LjUyNzcgOS44MjM0MUwzNC4xODI0IDUuNDI3MzZDMzMuOTc2OSA1LjI1ODM5IDMzLjcxOTIgNS4xNjYwMiAzMy40NTMyIDUuMTY2MDJIMTMuMzMwMkMxMy4wNTcgNS4xNjYwMiAxMi43OTI4IDUuMjYzNDUgMTIuNTg1IDUuNDQwOEw3LjQ0NTg4IDkuODI2NzdDNy4yNDI5NyA5Ljk5OTk0IDcuMzY1NDQgMTAuMzMyMSA3LjYzMjIgMTAuMzMyMUgzOS4zNDU0QzM5LjYxNDcgMTAuMzMyMSAzOS43MzU3IDkuOTk0NSAzOS41Mjc3IDkuODIzNDFaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0xMC4zNzk4IDIyLjM4NjdDMTAuMzc5OCAyMi44MDA5IDEwLjcxNTUgMjMuMTM2NyAxMS4xMjk4IDIzLjEzNjdDMTEuNTQ0IDIzLjEzNjcgMTEuODc5OCAyMi44MDA5IDExLjg3OTggMjIuMzg2N0wxMC4zNzk4IDIyLjM4NjdaTTExLjg3OTggMjIuMzg2N0wxMS44Nzk4IDEwLjMzMjZMMTAuMzc5OCAxMC4zMzI2TDEwLjM3OTggMjIuMzg2N0wxMS44Nzk4IDIyLjM4NjdaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0zNC40MjQzIDIyLjM4NjdDMzQuNDI0MyAyMi44MDA5IDM0Ljc2MDEgMjMuMTM2NyAzNS4xNzQzIDIzLjEzNjdDMzUuNTg4NSAyMy4xMzY3IDM1LjkyNDMgMjIuODAwOSAzNS45MjQzIDIyLjM4NjdMMzQuNDI0MyAyMi4zODY3Wk0zNS45MjQzIDIyLjM4NjdMMzUuOTI0MyAxMC4zMzI2TDM0LjQyNDMgMTAuMzMyNkwzNC40MjQzIDIyLjM4NjdMMzUuOTI0MyAyMi4zODY3WiIgZmlsbD0iIzQxM0UzRSIvPgo8cGF0aCBkPSJNMTQuNjk1NCAxNi45MDYyQzE0LjY5NTQgMTcuMzIwNSAxNS4wMzEyIDE3LjY1NjIgMTUuNDQ1NCAxNy42NTYyQzE1Ljg1OTYgMTcuNjU2MyAxNi4xOTU0IDE3LjMyMDUgMTYuMTk1NCAxNi45MDYzTDE0LjY5NTQgMTYuOTA2MlpNMTYuMTk1NCAxNi45MDYzTDE2LjE5NTQgMTAuMzMxM0wxNC42OTU0IDEwLjMzMTNMMTQuNjk1NCAxNi45MDYyTDE2LjE5NTQgMTYuOTA2M1oiIGZpbGw9IiM0MTNFM0UiLz4KPHBhdGggZD0iTTMwLjEwODYgMTYuOTA2MkMzMC4xMDg2IDE3LjMyMDUgMzAuNDQ0NCAxNy42NTYyIDMwLjg1ODYgMTcuNjU2MkMzMS4yNzI4IDE3LjY1NjMgMzEuNjA4NiAxNy4zMjA1IDMxLjYwODYgMTYuOTA2M0wzMC4xMDg2IDE2LjkwNjJaTTMxLjYwODYgMTYuOTA2M0wzMS42MDg2IDEwLjMzMTNMMzAuMTA4NiAxMC4zMzEzTDMwLjEwODYgMTYuOTA2MkwzMS42MDg2IDE2LjkwNjNaIiBmaWxsPSIjNDEzRTNFIi8+Cjwvc3ZnPgo=", hC = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjA2OTIgMTMuOTU3SDMzLjczMzUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjMuNDAxMyAxMC4xMzA4VjcuODM0ODFDMjMuNDAxMyA3LjAyMjg4IDIzLjcxOTQgNi4yNDQyMSAyNC4yODU0IDUuNjcwMDlDMjQuODUxNSA1LjA5NTk3IDI1LjYxOTIgNC43NzM0NCAyNi40MTk4IDQuNzczNDRIMzMuNzc3MUMzNC41Nzc3IDQuNzczNDQgMzUuMzQ1NCA1LjA5NTk3IDM1LjkxMTUgNS42NzAwOUMzNi40Nzc2IDYuMjQ0MjEgMzYuNzk1NiA3LjAyMjg4IDM2Ljc5NTYgNy44MzQ4MVYxMC4xMzA4IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjAwNjQgMTAuMTMwOFY3LjgzNDgxQzEwLjAwNjQgNy4wMjI4OCAxMC4zMjQ0IDYuMjQ0MjEgMTAuODkwNCA1LjY3MDA5QzExLjQ1NjUgNS4wOTU5NyAxMi4yMjQyIDQuNzczNDQgMTMuMDI0OCA0Ljc3MzQ0SDIwLjM4MjJDMjEuMTgyNyA0Ljc3MzQ0IDIxLjk1MDQgNS4wOTU5NyAyMi41MTY1IDUuNjcwMDlDMjMuMDgyNiA2LjI0NDIxIDIzLjQwMDYgNy4wMjI4OCAyMy40MDA2IDcuODM0ODFWMTAuMTMwOCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy4wNzA3IDE3LjAxODlWMTMuMTkyMkMxMy4wNzA3IDEyLjU4NjcgMTIuODkxMiAxMS45OTQ5IDEyLjU1NDggMTEuNDkxNEMxMi4yMTg0IDEwLjk4OCAxMS43NDAzIDEwLjU5NTYgMTEuMTgwOSAxMC4zNjM5QzEwLjYyMTUgMTAuMTMyMiAxMC4wMDU5IDEwLjA3MTYgOS40MTIxIDEwLjE4OTdDOC44MTgyNSAxMC4zMDc4IDguMjcyNzcgMTAuNTk5NCA3Ljg0NDYzIDExLjAyNzVDNy40MTY0OSAxMS40NTU3IDcuMTI0OTIgMTIuMDAxMSA3LjAwNjggMTIuNTk1QzYuODg4NjcgMTMuMTg4OCA2Ljk0OTMgMTMuODA0NCA3LjE4MTAxIDE0LjM2MzhDNy40MTI3MSAxNC45MjMyIDcuODA1MSAxNS40MDEzIDguMzA4NTQgMTUuNzM3N0M4LjgxMTk4IDE2LjA3NDEgOS40MDM4NiAxNi4yNTM2IDEwLjAwOTMgMTYuMjUzNlYyMC4wODAzQzEwLjAwOTMgMjAuMjgzMyAxMC4wOSAyMC40NzggMTAuMjMzNSAyMC42MjE1QzEwLjM3NyAyMC43NjUgMTAuNTcxNyAyMC44NDU3IDEwLjc3NDcgMjAuODQ1N0gzNi4wMzFDMzYuMjM0IDIwLjg0NTcgMzYuNDI4NiAyMC43NjUgMzYuNTcyMiAyMC42MjE1QzM2LjcxNTcgMjAuNDc4IDM2Ljc5NjMgMjAuMjgzMyAzNi43OTYzIDIwLjA4MDNWMTYuMjUzNkMzNy40MDE4IDE2LjI1MzYgMzcuOTkzNyAxNi4wNzQxIDM4LjQ5NzEgMTUuNzM3N0MzOS4wMDA2IDE1LjQwMTMgMzkuMzkzIDE0LjkyMzIgMzkuNjI0NyAxNC4zNjM4QzM5Ljg1NjQgMTMuODA0NCAzOS45MTcgMTMuMTg4OCAzOS43OTg5IDEyLjU5NUMzOS42ODA4IDEyLjAwMTEgMzkuMzg5MiAxMS40NTU3IDM4Ljk2MSAxMS4wMjc1QzM4LjUzMjkgMTAuNTk5NCAzNy45ODc0IDEwLjMwNzggMzcuMzkzNiAxMC4xODk3QzM2Ljc5OTcgMTAuMDcxNiAzNi4xODQyIDEwLjEzMjIgMzUuNjI0OCAxMC4zNjM5QzM1LjA2NTQgMTAuNTk1NiAzNC41ODczIDEwLjk4OCAzNC4yNTA5IDExLjQ5MTRDMzMuOTE0NSAxMS45OTQ5IDMzLjczNSAxMi41ODY3IDMzLjczNSAxMy4xOTIyVjE3LjAxODkiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K", dC = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjY4MDUgMTkuNjAxNlYyMi4wMzkxIiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMzLjQ2ODkgMTkuNjAxNlYyMi4wMzkxIiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwLjcwODIgMTAuMDU0N1Y1Ljk5MjE5QzEwLjcwODIgNS40NTM0NyAxMC45Njc0IDQuOTM2ODEgMTEuNDI4OSA0LjU1NTg4QzExLjg5MDMgNC4xNzQ5NCAxMi41MTYyIDMuOTYwOTQgMTMuMTY4NyAzLjk2MDk0QzEzLjgyMTMgMy45NjA5NCAxNC40NDcxIDQuMTc0OTQgMTQuOTA4NiA0LjU1NTg4QzE1LjM3IDQuOTM2ODEgMTUuNjI5MyA1LjQ1MzQ3IDE1LjYyOTMgNS45OTIxOSIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zMy45NDIxIDkuMjQyMTlIMjUuNjU0NlYxNC4xMTcySDMzLjk0MjFWOS4yNDIxOVoiIHN0cm9rZT0iIzE0MTQxNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzQuNzk5MyAxMC4wNTQ3SDM4LjczNjJDMzguOTk3MiAxMC4wNTQ3IDM5LjI0NzUgMTAuMTQwMyAzOS40MzIxIDEwLjI5MjdDMzkuNjE2NyAxMC40NDUgMzkuNzIwNCAxMC42NTE3IDM5LjcyMDQgMTAuODY3MlYxNC43MjY2QzM5LjcyMDQgMTYuMDE5NSAzOS4wOTgyIDE3LjI1OTUgMzcuOTkwOCAxOC4xNzM3QzM2Ljg4MzMgMTkuMDg3OSAzNS4zODEzIDE5LjYwMTYgMzMuODE1MSAxOS42MDE2SDEyLjMzMDNDMTAuNzY0MSAxOS42MDE2IDkuMjYyMDcgMTkuMDg3OSA4LjE1NDYxIDE4LjE3MzdDNy4wNDcxNiAxNy4yNTk1IDYuNDI1IDE2LjAxOTUgNi40MjUgMTQuNzI2NlYxMC44NjcyQzYuNDI1IDEwLjY1MTcgNi41Mjg3IDEwLjQ0NSA2LjcxMzI3IDEwLjI5MjdDNi44OTc4NSAxMC4xNDAzIDcuMTQ4MTggMTAuMDU0NyA3LjQwOTIxIDEwLjA1NDdIMjUuNjUwNyIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", pC = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQ1OTYgMjMuNTMzNlYyLjQ2NzEzTDI0LjMxNTcgMi40NjY4TTE2LjQ1OTYgMjMuNTMzNkgzMC4zOTYzTTE2LjQ1OTYgMjMuNTMzNkwyNC4zMTU3IDIwLjA1OTFWMi40NjY4TTE2LjQ1OTYgMjMuNTMzNkg5Ljc2NjZNMzAuMzk2MyAyMy41MzM2VjIuNDY3MTNMMjQuMzE1NyAyLjQ2NjhNMzAuMzk2MyAyMy41MzM2SDM3Ljg0OTdNMjEuNTEwNiAxMS41MTM2TDE5LjgxNDYgMTIuMzgyMyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=", fC = "data:image/svg+xml;base64,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", mC = {
            Kitchen: {
                name: "Kitchen",
                img: uC
            },
            BrownTilesKitchen: {
                name: "Kitchen",
                img: uC
            },
            Living: {
                name: "Living",
                img: hC
            },
            KitchenLiving: {
                name: "KitchLiv",
                img: hC
            },
            Bedroom: {
                name: "Bedroom",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM4Ljk1ODUgMjIuMzg1NVYxNS40OTc0QzM4Ljk1ODUgMTQuNTQ2NCAzOC4xODc1IDEzLjc3NTQgMzcuMjM2NCAxMy43NzU0SDEwLjI1ODFDOS4zMDcwOCAxMy43NzU0IDguNTM2MSAxNC41NDY0IDguNTM2MSAxNS40OTc0VjIyLjM4NTUiIHN0cm9rZT0iIzE0MTQxNCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjEuNzM4MiAxMi42Mjc2VjEwLjMzMTZDMjEuNzM4MiA5LjY5NzU4IDIxLjIyNDMgOS4xODM1OSAyMC41OTAyIDkuMTgzNTlIMTYuNDkwOEMxNS45ODIgOS4xODM1OSAxNS41MzQgOS41MTg0MyAxNS4zODk4IDEwLjAwNjNMMTQuNzExNCAxMi4zMDI0QzE0LjQ5NDEgMTMuMDM3OSAxNS4wNDU0IDEzLjc3NTYgMTUuODEyNCAxMy43NzU2SDIwLjU5MDJDMjEuMjI0MyAxMy43NzU2IDIxLjczODIgMTMuMjYxNyAyMS43MzgyIDEyLjYyNzZaIiBzdHJva2U9IiMxNDE0MTQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0yNS43NTYzIDEyLjYyNzZWMTAuMzMxNkMyNS43NTYzIDkuNjk3NTggMjYuMjcwMyA5LjE4MzU5IDI2LjkwNDMgOS4xODM1OUgzMS4wMDM4QzMxLjUxMjUgOS4xODM1OSAzMS45NjA2IDkuNTE4NDMgMzIuMTA0NyAxMC4wMDYzTDMyLjc4MzEgMTIuMzAyNEMzMy4wMDA0IDEzLjAzNzkgMzIuNDQ5MSAxMy43NzU2IDMxLjY4MjEgMTMuNzc1NkgyNi45MDQzQzI2LjI3MDMgMTMuNzc1NiAyNS43NTYzIDEzLjI2MTcgMjUuNzU2MyAxMi42Mjc2WiIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNOC41MzYxIDIwLjA4OThIMzguOTU4NSIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMzUuNTE0NCAxMy4yMDIzVjguMDM2MjZDMzUuNTE0NCA2Ljc2ODIgMzQuNDg2NSA1Ljc0MDIzIDMzLjIxODQgNS43NDAyM0gxNC4yNzYyQzEzLjAwODEgNS43NDAyMyAxMS45ODAxIDYuNzY4MiAxMS45ODAxIDguMDM2MjZWMTMuMjAyMyIgc3Ryb2tlPSIjMTQxNDE0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
            },
            Kid_room: {
                name: "Kid room",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjI0ODIgMjIuNzVDMjguNjMyNSAyMi43NSAzMi45OTc0IDE4LjM4NDggMzIuOTk3NCAxM0MzMi45OTc0IDcuNjE1MjIgMjguNjMyNSAzLjI1IDIzLjI0ODIgMy4yNUMxNy44NjM4IDMuMjUgMTMuNDk5IDcuNjE1MjIgMTMuNDk5IDEzQzEzLjQ5OSAxOC4zODQ4IDE3Ljg2MzggMjIuNzUgMjMuMjQ4MiAyMi43NVoiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkuNTkyMiAxNC4yMTg4QzIwLjI2NTIgMTQuMjE4OCAyMC44MTA4IDEzLjY3MzEgMjAuODEwOCAxM0MyMC44MTA4IDEyLjMyNjkgMjAuMjY1MiAxMS43ODEyIDE5LjU5MjIgMTEuNzgxMkMxOC45MTkxIDExLjc4MTIgMTguMzczNSAxMi4zMjY5IDE4LjM3MzUgMTNDMTguMzczNSAxMy42NzMxIDE4LjkxOTEgMTQuMjE4OCAxOS41OTIyIDE0LjIxODhaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0yNi45MDQxIDE0LjIxODhDMjcuNTc3MSAxNC4yMTg4IDI4LjEyMjcgMTMuNjczMSAyOC4xMjI3IDEzQzI4LjEyMjcgMTIuMzI2OSAyNy41NzcxIDExLjc4MTIgMjYuOTA0MSAxMS43ODEyQzI2LjIzMSAxMS43ODEyIDI1LjY4NTQgMTIuMzI2OSAyNS42ODU0IDEzQzI1LjY4NTQgMTMuNjczMSAyNi4yMzEgMTQuMjE4OCAyNi45MDQxIDE0LjIxODhaIiBmaWxsPSIjNDEzRTNFIi8+CjxwYXRoIGQ9Ik0yNS45MzkzIDE3LjA2MjVDMjUuMTQxNyAxNy41OTIyIDI0LjIwNTYgMTcuODc0OCAyMy4yNDgxIDE3Ljg3NDhDMjIuMjkwNyAxNy44NzQ4IDIxLjM1NDUgMTcuNTkyMiAyMC41NTY5IDE3LjA2MjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjMuMjQ4MiAzLjI1QzIxLjYyMzMgNS4yODEyNSAyMS42MjMzIDcuMzEyNSAyMS42MjMzIDcuMzEyNUMyMS42MjMzIDcuNzQzNDggMjEuNzk0NSA4LjE1NjggMjIuMDk5MiA4LjQ2MTU1QzIyLjQwMzkgOC43NjYyOSAyMi44MTcyIDguOTM3NSAyMy4yNDgyIDguOTM3NUMyMy42NzkxIDguOTM3NSAyNC4wOTI0IDguNzY2MjkgMjQuMzk3MSA4LjQ2MTU1QzI0LjcwMTggOC4xNTY4IDI0Ljg3MyA3Ljc0MzQ4IDI0Ljg3MyA3LjMxMjUiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"
            },
            Hall: {
                name: "Hall",
                img: pC
            },
            Bathroom: {
                name: "Bathroom",
                img: dC
            },
            BathLaminate: {
                name: "Bathroom",
                img: dC
            },
            CombinedBathroom: {
                name: "CombBath",
                img: dC
            },
            LightWoodBath: {
                name: "Bathroom",
                img: dC
            },
            BrownTilesBath: {
                name: "Bathroom",
                img: dC
            },
            Toilet: {
                name: "Toilet",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA0NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2Ljc1IDExLjM3NVY0LjA2MjVDMTYuNzUgMy44NDcwMSAxNi44MzU2IDMuNjQwMzUgMTYuOTg4IDMuNDg3OThDMTcuMTQwMyAzLjMzNTYgMTcuMzQ3IDMuMjUgMTcuNTYyNSAzLjI1SDI4LjkzNzVDMjkuMTUzIDMuMjUgMjkuMzU5NyAzLjMzNTYgMjkuNTEyIDMuNDg3OThDMjkuNjY0NCAzLjY0MDM1IDI5Ljc1IDMuODQ3MDEgMjkuNzUgNC4wNjI1VjExLjM3NSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMCA2LjVIMjEuNjI1IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMyLjE4NzUgMTEuMzc1QzMyLjE4NzUgMTMuNzQ1NCAzMS4yNDU5IDE2LjAxODcgMjkuNTY5OCAxNy42OTQ4QzI3Ljg5MzcgMTkuMzcwOSAyNS42MjA0IDIwLjMxMjUgMjMuMjUgMjAuMzEyNUMyMC44Nzk2IDIwLjMxMjUgMTguNjA2MyAxOS4zNzA5IDE2LjkzMDIgMTcuNjk0OEMxNS4yNTQxIDE2LjAxODcgMTQuMzEyNSAxMy43NDU0IDE0LjMxMjUgMTEuMzc1SDMyLjE4NzVaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE5Ljc1NjMgMTkuNjAxNkwxOS4zMTk1IDIyLjYzODNDMTkuMzAzNiAyMi43NTMxIDE5LjMxMjQgMjIuODcgMTkuMzQ1NCAyMi45ODEyQzE5LjM3ODQgMjMuMDkyMyAxOS40MzQ4IDIzLjE5NTEgMTkuNTEwOCAyMy4yODI2QzE5LjU4NjggMjMuMzcwMiAxOS42ODA2IDIzLjQ0MDUgMTkuNzg2IDIzLjQ4ODdDMTkuODkxNCAyMy41MzcgMjAuMDA2IDIzLjU2MjIgMjAuMTIxOSAyMy41NjI1SDI2LjM3ODFDMjYuNDk0MSAyMy41NjIyIDI2LjYwODYgMjMuNTM3IDI2LjcxNCAyMy40ODg3QzI2LjgxOTQgMjMuNDQwNSAyNi45MTMzIDIzLjM3MDIgMjYuOTg5MyAyMy4yODI2QzI3LjA2NTMgMjMuMTk1MSAyNy4xMjE2IDIzLjA5MjMgMjcuMTU0NiAyMi45ODEyQzI3LjE4NzYgMjIuODcgMjcuMTk2NCAyMi43NTMxIDI3LjE4MDUgMjIuNjM4M0wyNi43NDM4IDE5LjYwMTYiIHN0cm9rZT0iIzQxM0UzRSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"
            },
            Balcony: {
                name: "Balcony",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCA1NyAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjI0MzIgMTUuOTgwN1YxNS40ODc4QzE1LjI0MzIgMTQuMzgzMyAxNi4xMzg2IDEzLjQ4NzggMTcuMjQzMiAxMy40ODc4SDE5LjM3OTNNNDAuNDM5MyAxNS45ODA3VjE1LjQ4NzhDNDAuNDM5MyAxNC4zODMzIDM5LjU0MzkgMTMuNDg3OCAzOC40MzkzIDEzLjQ4NzhIMzYuMzAzMU0zNi4zMDMxIDEwLjg1NTdWMy4zMjIyN0gyNy44NDEyTTE5LjM3OTMgMTAuODU1N1YzLjMyMjI3SDI3Ljg0MTJNMjcuODQxMiAzLjMyMjI3VjEwLjg1NTdNMTYuMzQ2MSAyMi4xMTRIMTkuMzc5M00zOS4zMzYzIDIyLjExNEgzNi4zMDMxTTI3Ljg0MTIgMjIuMTE0VjEzLjQ4NzhNMjcuODQxMiAyMi4xMTRIMzIuMDI5MU0yNy44NDEyIDIyLjExNEgyMy42MTAyTTI3Ljg0MTIgMTMuNDg3OEgzMi4wMjkxTTI3Ljg0MTIgMTMuNDg3OEgxOS4zNzkzTTMyLjAyOTEgMTMuNDg3OFYyMi4xMTRNMzIuMDI5MSAxMy40ODc4SDM2LjMwMzFNMzIuMDI5MSAyMi4xMTRIMzYuMzAzMU0zNi4zMDMxIDIyLjExNFYxMy40ODc4TTE5LjM3OTMgMTMuNDg3OFYyMi4xMTRNMTkuMzc5MyAyMi4xMTRIMjMuNjEwMk0yMy42MTAyIDIyLjExNFYxMy42Mjg0IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41Ii8+Cjwvc3ZnPgo="
            },
            Hallway: {
                name: "Hallway",
                img: pC
            },
            Cabinet: {
                name: "Cabinet",
                img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTciIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCA1NyAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM5IDkuNzI2NTZIMTdDMTYuNDQ3NyA5LjcyNjU2IDE2IDEwLjE3NDMgMTYgMTAuNzI2NlYyNi43MjY2QzE2IDI3LjI3ODggMTYuNDQ3NyAyNy43MjY2IDE3IDI3LjcyNjZIMzlDMzkuNTUyMyAyNy43MjY2IDQwIDI3LjI3ODggNDAgMjYuNzI2NlYxMC43MjY2QzQwIDEwLjE3NDMgMzkuNTUyMyA5LjcyNjU2IDM5IDkuNzI2NTZaIiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMzIDkuNzI2NTZWNy43MjY1NkMzMyA3LjE5NjEzIDMyLjc4OTMgNi42ODc0MiAzMi40MTQyIDYuMzEyMzVDMzIuMDM5MSA1LjkzNzI4IDMxLjUzMDQgNS43MjY1NiAzMSA1LjcyNjU2SDI1QzI0LjQ2OTYgNS43MjY1NiAyMy45NjA5IDUuOTM3MjggMjMuNTg1OCA2LjMxMjM1QzIzLjIxMDcgNi42ODc0MiAyMyA3LjE5NjEzIDIzIDcuNzI2NTZWOS43MjY1NiIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00MCAxNi41MTM3QzM2LjM1MjkgMTguNjIzIDMyLjIxMzIgMTkuNzMxMiAyOCAxOS43MjYyQzIzLjc4NjEgMTkuNzM3MSAxOS42NDQ4IDE4LjYyODUgMTYgMTYuNTEzNyIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yNi41IDE1LjcyNjZIMjkuNSIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="
            },
            Wardrobe: {
                name: "Wardrobe",
                img: "data:image/svg+xml;base64,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"
            },
            Terrace: {
                name: "Terrace",
                img: fC
            },
            Terrace_2: {
                name: "Terrace",
                img: fC
            },
            Garage: {
                name: "Garage",
                img: "data:image/svg+xml;base64,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"
            },
            Gym: {
                name: "Gym",
                img: "data:image/svg+xml;base64,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"
            },
            Carpet: {
                name: "Pooja Room",
                img: uC
            }
        }, gC = tN(()=>{
            const e1 = (0, t.useRef)(null), n = e1.current, [i, r] = (0, t.useState)(!1), a = Bi.config.json.Floors[Bi.currentFloorIndex].Units[0].Rooms, s = [];
            Object.keys(mC).forEach((e1)=>{
                const t = a.filter((t)=>t.Type === e1 && "Flipped" !== t.WallsState && "Gap" !== t.CeilingState);
                t.length > 1 && t.forEach((e1, n)=>t[n].Numeric = n + 1), s.push(...t);
            });
            const o = function(e1) {
                var t;
                let n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                const i = null !== (t = e1.getAttribute("data-test-id")) && void 0 !== t ? t : e1.closest("div").getAttribute("data-test-id");
                i && (n ? hD.setFixedColor({
                    R: Number(i),
                    G: 0,
                    B: 0,
                    A: 0
                }) : hD.setCurrentColor({
                    R: Number(i),
                    G: 0,
                    B: 0,
                    A: 0
                }));
            };
            return (0, t.useEffect)(()=>{
                n && n.addEventListener("mousedown", (e1)=>{
                    const t = e1.screenX, i = n.scrollLeft;
                    let r = !0;
                    const a = (e1)=>{
                        if (r) {
                            const r = t - e1.screenX;
                            n.scrollLeft = i + r;
                        }
                    }, s = ()=>{
                        r = !1, n.removeEventListener("mousemove", a), n.removeEventListener("mouseup", s), n.removeEventListener("mouseleave", o);
                    }, o = ()=>{
                        r = !1, n.removeEventListener("mousemove", a), n.removeEventListener("mouseup", s), n.removeEventListener("mouseleave", o);
                    };
                    n.addEventListener("mousemove", a), n.addEventListener("mouseup", s), n.addEventListener("mouseleave", o);
                });
            }, [
                n
            ]), (0, t.useEffect)(()=>{
                const e1 = s.findIndex((e1)=>e1.ColorID);
                e1 >= 0 && hD.setFixedColor(s[e1].ColorID);
            }, []), t.createElement(t.Fragment, null, t.createElement("div", {
                ref: e1,
                className: "widget-tab-rooms",
                onClick: (e1)=>o(e1.target, !0),
                onMouseMove: (e1)=>o(e1.target)
            }, t.createElement("div", {
                className: "widget-tab-rooms-switch"
            }, t.createElement("input", {
                onChange: ()=>{
                    r((e1)=>!e1);
                },
                className: "widget-tab-rooms-switch-checkbox",
                id: "area-type-switch",
                type: "checkbox"
            }), t.createElement("label", {
                className: "widget-tab-rooms-switch-label",
                htmlFor: "area-type-switch"
            }, t.createElement("span", {
                className: "widget-tab-rooms-switch-button"
            }), t.createElement("div", {
                className: "widget-tab-rooms-switch-text"
            }, t.createElement("p", {
                className: "widget-tab-rooms-switch-text-item ".concat(i ? "" : "active")
            }, "Feet"), t.createElement("p", {
                className: "widget-tab-rooms-switch-text-item ".concat(i ? "active" : "")
            }, "Meter")))), t.createElement("div", {
                className: "widget-tab-rooms-container"
            }, s.map((e1)=>{
                var n, r, a, s, o;
                return t.createElement("div", {
                    "data-test-id": null === (n = e1.ColorID) || void 0 === n ? void 0 : n.R,
                    className: "widget-tab-rooms-item ".concat((o = null === (r = e1.ColorID) || void 0 === r ? void 0 : r.R, o === hD.currentColor.R || o === hD.fixedColor.R ? "widget-tab-rooms-item-active" : "")),
                    key: e1.ID
                }, t.createElement("img", {
                    className: "widget-tab-rooms-item-img",
                    src: (a = e1.Type, null === (s = Object.entries(mC).find((e1)=>{
                        let [t, n] = e1;
                        return t === a;
                    })) || void 0 === s ? void 0 : s[1].img),
                    alt: "icon"
                }), t.createElement("p", {
                    className: "widget-tab-rooms-item-type"
                }, ((e1, t)=>{
                    var n;
                    const i = null === (n = Object.entries(mC).find((t)=>{
                        let [n, i] = t;
                        return n === e1;
                    })) || void 0 === n ? void 0 : n[1].name;
                    return t ? "".concat(i, " ").concat(t) : i;
                })(e1.Type, e1.Numeric)), t.createElement("p", {
                    className: "widget-tab-rooms-item-area"
                }, ((e1)=>{
                    var t, n;
                    const r = e1.Length * e1.Width;
                    return Math.abs(r / e1.Area - 1) >= .15 ? i ? "".concat(e1.Area.toFixed(1), "m\xb2") : "".concat(((e1)=>{
                        const t = Math.floor(e1 * Math.pow(Cy, 2)), n = 144 * (e1 * Math.pow(Cy, 2) - t);
                        return "".concat(t, "'").concat(Math.round(n), '"');
                    })(e1.Area)) : i ? "".concat(null === (t = e1.Width) || void 0 === t ? void 0 : t.toFixed(1), "m x ").concat(null === (n = e1.Length) || void 0 === n ? void 0 : n.toFixed(1), "m") : "".concat(Py(e1.Width), " x ").concat(Py(e1.Length));
                })(e1)));
            }))));
        }), AC = tN(()=>{
            var e1, n, i, r, a, s, o, l, c, u, h;
            const { config: d } = Bi, p = {
                width: d.width,
                height: d.height,
                "--main-color": d.colors.main,
                "--main-text": d.colors.mainText
            }, f = !Bi.config.defaultButtonsStyle && (Bi.config.hasTopViewMask || Bi.config.hasMiddleCutMasks), [m, g] = (0, t.useState)(d.tabs[0]), A = function(e1) {
                let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                if (t && !Bi.config.hasTopViewMask) return null;
                if (!t && !Bi.config.hasMiddleCutMasks) return null;
                const n = e1.map(qx);
                return t ? n[0] : n;
            }, v = {
                default: {
                    rotation: t.createElement(gD, {
                        disabled: !d.rotationData || !d.rotationData.items.length,
                        topViewImage: d.topViewImage,
                        images: (null === (e1 = d.rotationData) || void 0 === e1 ? void 0 : e1.items) || [],
                        type: (null === (n = d.rotationData) || void 0 === n ? void 0 : n.type) || "top_down",
                        planImage: d.planImage,
                        mode: d.rotationMode
                    }),
                    panorama: t.createElement(cC, {
                        disabled: !d.panoramaData || !d.panoramaData.items.length,
                        items: (null === (i = d.panoramaData) || void 0 === i ? void 0 : i.items) || [],
                        type: (null === (r = d.panoramaData) || void 0 === r ? void 0 : r.type) || "sphere",
                        planImage: d.planImage,
                        json: d.json
                    })
                },
                area: {
                    rotation: t.createElement(gD, {
                        disabled: !d.rotationData || !d.rotationData.items.length,
                        type: (null === (a = d.rotationData) || void 0 === a ? void 0 : a.type) || "top_down",
                        planImage: d.planImage,
                        mode: d.rotationMode,
                        key: "plan"
                    }),
                    panorama: t.createElement(cC, {
                        disabled: !d.panoramaData || !d.panoramaData.items.length,
                        items: (null === (s = d.panoramaData) || void 0 === s ? void 0 : s.items) || [],
                        type: (null === (o = d.panoramaData) || void 0 === o ? void 0 : o.type) || "sphere",
                        json: d.json
                    }),
                    area: t.createElement(gD, {
                        disabled: !d.rotationData || !d.rotationData.items.length,
                        topViewImage: d.topViewImage,
                        topViewMask: A([
                            d.topViewImage
                        ], !0),
                        images: (null === (l = d.rotationData) || void 0 === l ? void 0 : l.items) || [],
                        masks: A((null === (c = d.rotationData) || void 0 === c ? void 0 : c.items) || []),
                        type: (null === (u = d.rotationData) || void 0 === u ? void 0 : u.type) || "top_down",
                        mode: d.rotationMode,
                        key: "area"
                    })
                }
            };
            var M;
            return (0, t.useEffect)(()=>{
                Xi.init();
            }, []), (0, t.useEffect)(()=>{
                d.tabs.some((e1)=>e1 === m) || g(d.tabs[0]);
            }, [
                d,
                m
            ]), t.createElement("main", {
                className: (M = d.width, Object.keys(iN).filter((e1)=>M <= iN[e1])).reduce((e1, t)=>e1 + " widget-application--".concat(t), "widget-application"),
                id: "widget-application",
                style: p
            }, t.createElement("section", {
                className: "widget-tab widget-tab--".concat(m)
            }, v[f ? "area" : "default"][m]), d.logo && t.createElement("a", {
                href: (null === (h = d.branding) || void 0 === h ? void 0 : h.url) || d.logoUrl,
                className: "widget-logo",
                target: "_blank",
                rel: "noreferrer"
            }, t.createElement("img", {
                src: d.logo,
                alt: "logo"
            })), Bi.controlsVisible && t.createElement(aN, null), t.createElement("div", {
                className: "widget-tab-buttons ".concat(f ? "widget-tab-buttons-vertical" : "")
            }, ({
                default: [
                    {
                        tab: "rotation",
                        text: "2D"
                    },
                    {
                        tab: "panorama",
                        text: "3D"
                    }
                ],
                area: [
                    {
                        tab: "rotation",
                        text: "2D"
                    },
                    {
                        tab: "area",
                        text: "3D"
                    },
                    {
                        tab: "panorama",
                        img: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDEiIGhlaWdodD0iMzEiIHZpZXdCb3g9IjAgMCA0MSAzMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMyLjc1OTUgNC4xMDUyQzMyLjc1OTUgMy42Njg4IDMyLjg0MTMgMy4yNTk2OCAzMy4wMDUgMi44Nzc4M0MzMy4xNzY0IDIuNDg4MTkgMzMuNDA2MyAyLjE0NTMgMzMuNjk0NyAxLjg0OTE4QzMzLjk4MyAxLjU2MDg0IDM0LjMxODEgMS4zMzA5NSAzNC42OTk5IDEuMTU5NTFDMzUuMDgxOCAwLjk4ODA2NSAzNS40OTA5IDAuOTAyMzQ0IDM1LjkyNzMgMC45MDIzNDRDMzYuMzQ4MSAwLjkwMjM0NCAzNi43NDU2IDAuOTg4MDY1IDM3LjExOTYgMS4xNTk1MUMzNy41MDE1IDEuMzMwOTUgMzcuODMyNyAxLjU2MDg0IDM4LjExMzIgMS44NDkxOEMzOC4zOTM4IDIuMTQ1MyAzOC42MTU4IDIuNDg4MTkgMzguNzc5NSAyLjg3NzgzQzM4Ljk0MzEgMy4yNTk2OCAzOS4wMjUgMy42Njg4IDM5LjAyNSA0LjEwNTJDMzkuMDI1IDQuNTQ5NCAzOC45NDMxIDQuOTYyNDIgMzguNzc5NSA1LjM0NDI3QzM4LjYxNTggNS43MjYxMiAzOC4zOTM4IDYuMDYxMjEgMzguMTEzMiA2LjM0OTU1QzM3LjgzMjcgNi42Mzc4OCAzNy41MDE1IDYuODYzODcgMzcuMTE5NiA3LjAyNzUyQzM2Ljc0NTYgNy4xOTExNyAzNi4zNDgxIDcuMjczIDM1LjkyNzMgNy4yNzNDMzUuNDkwOSA3LjI3MyAzNS4wODE4IDcuMTkxMTcgMzQuNjk5OSA3LjAyNzUyQzM0LjMxODEgNi44NjM4NyAzMy45ODMgNi42Mzc4OCAzMy42OTQ3IDYuMzQ5NTVDMzMuNDA2MyA2LjA2MTIxIDMzLjE3NjQgNS43MjYxMiAzMy4wMDUgNS4zNDQyN0MzMi44NDEzIDQuOTYyNDIgMzIuNzU5NSA0LjU0OTQgMzIuNzU5NSA0LjEwNTJaTTM0LjQ1NDUgNC4xMDUyQzM0LjQ1NDUgNC4zMTU2MSAzNC40OTM0IDQuNTEwNDMgMzQuNTcxNCA0LjY4OTY3QzM0LjY0OTMgNC44NjExMSAzNC43NTg0IDUuMDA5MTggMzQuODk4NyA1LjEzMzg2QzM1LjAzMTEgNS4yNjYzNCAzNS4xODMxIDUuMzcxNTQgMzUuMzU0NSA1LjQ0OTQ3QzM1LjUzMzggNS41MTk2MSAzNS43MjQ3IDUuNTU0NjggMzUuOTI3MyA1LjU1NDY4QzM2LjEyMjEgNS41NTQ2OCAzNi4zMDUzIDUuNTE5NjEgMzYuNDc2NyA1LjQ0OTQ3QzM2LjY1NTkgNS4zNzkzNCAzNi44MDc5IDUuMjc4MDMgMzYuOTMyNiA1LjE0NTU1QzM3LjA1NzMgNS4wMjA4NiAzNy4xNTQ3IDQuODY4OSAzNy4yMjQ4IDQuNjg5NjdDMzcuMzAyOCA0LjUxMDQzIDM3LjM0MTcgNC4zMTU2MSAzNy4zNDE3IDQuMTA1MkMzNy4zNDE3IDMuODk0OCAzNy4zMDI4IDMuNjk5OTggMzcuMjI0OCAzLjUyMDc0QzM3LjE1NDcgMy4zMzM3MSAzNy4wNTczIDMuMTcwMDYgMzYuOTMyNiAzLjAyOTc5QzM2LjgwNzkgMi44OTczMSAzNi42NTU5IDIuNzk2MDEgMzYuNDc2NyAyLjcyNTg3QzM2LjMwNTMgMi42NDc5NCAzNi4xMjIxIDIuNjA4OTggMzUuOTI3MyAyLjYwODk4QzM1LjcyNDcgMi42MDg5OCAzNS41MzM4IDIuNjQ3OTQgMzUuMzU0NSAyLjcyNTg3QzM1LjE4MzEgMi43OTYwMSAzNS4wMzExIDIuODk3MzEgMzQuODk4NyAzLjAyOTc5QzM0Ljc1ODQgMy4xNzAwNiAzNC42NDkzIDMuMzMzNzEgMzQuNTcxNCAzLjUyMDc0QzM0LjQ5MzQgMy42OTk5OCAzNC40NTQ1IDMuODk0OCAzNC40NTQ1IDQuMTA1MloiIGZpbGw9IiM0MTNFM0UiLz4KPHBhdGggZD0iTTMyLjczMTcgMTQuMTY2NUMzMi43MzE3IDE0Ljg0MzMgMzIuNjUyNSAxNS40NDA4IDMyLjQ5NDEgMTUuOTU5MkMzMi4zNDA1IDE2LjQ3MjcgMzIuMTE3MyAxNi45MDIzIDMxLjgyNDUgMTcuMjQ3OUMzMS41MzE4IDE3LjU5ODMgMzEuMTc0MiAxNy44NjIyIDMwLjc1MTggMTguMDM5OEMzMC4zMjk1IDE4LjIxNzQgMjkuODU0MyAxOC4zMDYyIDI5LjMyNjMgMTguMzA2MkMyOC44MDMyIDE4LjMwNjIgMjguMzMwNCAxOC4yMTc0IDI3LjkwODEgMTguMDM5OEMyNy40ODU3IDE3Ljg2MjIgMjcuMTI4MSAxNy41OTgzIDI2LjgzNTMgMTcuMjQ3OUMyNi41Mzc4IDE2LjkwMjMgMjYuMzA3NCAxNi40NzI3IDI2LjE0NDIgMTUuOTU5MkMyNS45ODU4IDE1LjQ0MDggMjUuOTA2NiAxNC44NDMzIDI1LjkwNjYgMTQuMTY2NVYxMS42NjExQzI1LjkwNjYgMTAuOTg0NCAyNS45ODU4IDEwLjM4OTIgMjYuMTQ0MiA5Ljg3NTY5QzI2LjMwMjYgOS4zNTczMyAyNi41MzA2IDguOTIyOTcgMjYuODI4MSA4LjU3MjZDMjcuMTIwOSA4LjIyNzAzIDI3LjQ3NjEgNy45NjU0NSAyNy44OTM3IDcuNzg3ODZDMjguMzE2IDcuNjEwMjggMjguNzg4OCA3LjUyMTQ4IDI5LjMxMTkgNy41MjE0OEMyOS44Mzk5IDcuNTIxNDggMzAuMzE1MSA3LjYxMDI4IDMwLjczNzQgNy43ODc4NkMzMS4xNTk4IDcuOTY1NDUgMzEuNTE5OCA4LjIyNzAzIDMxLjgxNzMgOC41NzI2QzMyLjExMDEgOC45MjI5NyAzMi4zMzU3IDkuMzU3MzMgMzIuNDk0MSA5Ljg3NTY5QzMyLjY1MjUgMTAuMzg5MiAzMi43MzE3IDEwLjk4NDQgMzIuNzMxNyAxMS42NjExVjE0LjE2NjVaTTI3LjkyMjQgMTMuMzAyNkwzMC43MTU4IDExLjIyMkMzMC43MDYyIDEwLjgyODQgMzAuNjYzIDEwLjQ5MjQgMzAuNTg2MiAxMC4yMTQxQzMwLjUxNDIgOS45MzA4OSAzMC40MDYyIDkuNzA1MzEgMzAuMjYyMyA5LjUzNzMyQzMwLjE1MTkgOS40MDI5MyAzMC4wMTUxIDkuMzA0NTQgMjkuODUxOSA5LjI0MjE0QzI5LjY5MzUgOS4xNzQ5NSAyOS41MTM1IDkuMTQxMzUgMjkuMzExOSA5LjE0MTM1QzI5LjA4NjQgOS4xNDEzNSAyOC44ODcyIDkuMTg0NTUgMjguNzE0NCA5LjI3MDk0QzI4LjU0NjQgOS4zNTI1MyAyOC40MDQ4IDkuNDc3MzIgMjguMjg5NiA5LjY0NTMxQzI4LjE2NDggOS44MjI5IDI4LjA3MTIgMTAuMDUzMyAyOC4wMDg4IDEwLjMzNjVDMjcuOTUxMiAxMC42MTk2IDI3LjkyMjQgMTAuOTU1NiAyNy45MjI0IDExLjM0NDRWMTIuNTAzNUMyNy45MjI0IDEyLjczMzkgMjcuOTIyNCAxMi44ODc0IDI3LjkyMjQgMTIuOTY0MkMyNy45MjI0IDEzLjA0MSAyNy45MjI0IDEzLjE1MzggMjcuOTIyNCAxMy4zMDI2Wk0zMC43MTU4IDE0LjQ2ODlWMTMuMjUyMkMzMC43MTU4IDEzLjA5MzggMzAuNzE1OCAxMi45Nzg2IDMwLjcxNTggMTIuOTA2NkMzMC43MTU4IDEyLjgyOTggMzAuNzE1OCAxMi43MjE5IDMwLjcxNTggMTIuNTgyN0wyNy45MjI0IDE0LjY1NjFDMjcuOTMyIDE0Ljk3MjkgMjcuOTYzMiAxNS4yNTM2IDI4LjAxNiAxNS40OTg0QzI4LjA3MzYgMTUuNzQzMiAyOC4xNTI4IDE1Ljk0NzIgMjguMjUzNiAxNi4xMTA0QzI4LjM2ODggMTYuMzA3MiAyOC41MTUyIDE2LjQ1MzUgMjguNjkyOCAxNi41NDk1QzI4Ljg3MDQgMTYuNjQ1NSAyOS4wODE2IDE2LjY5MzUgMjkuMzI2MyAxNi42OTM1QzI5LjU1MTkgMTYuNjkzNSAyOS43NTExIDE2LjY1MjcgMjkuOTIzOSAxNi41NzExQzMwLjA5NjcgMTYuNDg0NyAzMC4yNDA3IDE2LjM1NTIgMzAuMzU1OSAxNi4xODI0QzMwLjQ3NTggMTYgMzAuNTY0NiAxNS43NjcyIDMwLjYyMjIgMTUuNDg0QzMwLjY4NDYgMTUuMTk2MSAzMC43MTU4IDE0Ljg1NzcgMzAuNzE1OCAxNC40Njg5WiIgZmlsbD0iIzQxM0UzRSIvPgo8cGF0aCBkPSJNMjIuMzY0OCA3LjU4NTk0VjkuMjQ5SDIyLjI0OTZDMjEuNzIxNyA5LjI0OSAyMS4yNTM3IDkuMzE4NiAyMC44NDU3IDkuNDU3NzhDMjAuNDQyNiA5LjU5Njk3IDIwLjA5OTQgOS43OTM3NiAxOS44MTYyIDEwLjA0ODFDMTkuNTI4MyAxMC4zMDI1IDE5LjMwMDMgMTAuNjA3MyAxOS4xMzIzIDEwLjk2MjVDMTguOTY5MSAxMS4zMTc2IDE4Ljg2NTkgMTEuNzEzNiAxOC44MjI3IDEyLjE1MDRDMTguOTMzMSAxMi4wMzA0IDE5LjA2MDMgMTEuOTEyOCAxOS4yMDQzIDExLjc5NzZDMTkuMzQ4MyAxMS42Nzc2IDE5LjUxMTUgMTEuNTY5NiAxOS42OTM4IDExLjQ3MzZDMTkuODcxNCAxMS4zODI0IDIwLjA2NTggMTEuMzA4IDIwLjI3NyAxMS4yNTA0QzIwLjQ4ODIgMTEuMTkyOCAyMC43MTYyIDExLjE2NCAyMC45NjA5IDExLjE2NEMyMS40NjAxIDExLjE2NCAyMS44OTQ1IDExLjI2IDIyLjI2NCAxMS40NTJDMjIuNjM4NCAxMS42MzkyIDIyLjk1MDQgMTEuODkzNiAyMy4yIDEyLjIxNTJDMjMuNDQ5NSAxMi41NDE1IDIzLjYzNDMgMTIuOTIwNyAyMy43NTQzIDEzLjM1MjdDMjMuODc5MSAxMy43Nzk4IDIzLjk0MTUgMTQuMjMxIDIzLjk0MTUgMTQuNzA2MkMyMy45NDE1IDE1LjIxNDkgMjMuODU5OSAxNS42ODc3IDIzLjY5NjcgMTYuMTI0NEMyMy41MzM1IDE2LjU2MTIgMjMuMzAwNyAxNi45NDA0IDIyLjk5ODQgMTcuMjYxOUMyMi42OTYgMTcuNTgzNSAyMi4zMjg4IDE3LjgzNzkgMjEuODk2OSAxOC4wMjUxQzIxLjQ2NDkgMTguMjA3NSAyMC45ODAxIDE4LjI5ODcgMjAuNDQyNiAxOC4yOTg3QzE5Ljg4MSAxOC4yOTg3IDE5LjM3NDcgMTguMTk1NSAxOC45MjM1IDE3Ljk4OTFDMTguNDcyMyAxNy43Nzc5IDE4LjA5MDggMTcuNDg3NSAxNy43Nzg4IDE3LjExOEMxNy40NjIgMTYuNzQ4NCAxNy4yMTcyIDE2LjMxMTYgMTcuMDQ0NSAxNS44MDc3QzE2Ljg3NjUgMTUuMjk4OSAxNi43OTI1IDE0Ljc0NDUgMTYuNzkyNSAxNC4xNDQ2VjEzLjM3NDNDMTYuNzkyNSAxMi41NDM5IDE2LjkwNTMgMTEuNzc2IDE3LjEzMDkgMTEuMDcwNUMxNy4zNTY0IDEwLjM2MDEgMTcuNjkyNCA5Ljc0NTc2IDE4LjEzODggOS4yMjc0QzE4LjU4NTEgOC43MTM4NCAxOS4xMzk1IDguMzEzMDggMTkuODAxOCA4LjAyNTFDMjAuNDY0MiA3LjczMjMzIDIxLjIyOTcgNy41ODU5NCAyMi4wOTg0IDcuNTg1OTRIMjIuMzY0OFpNMjAuMzc3OCAxMi43Njk1QzIwLjE4NTggMTIuNzY5NSAyMC4wMDU4IDEyLjc5ODMgMTkuODM3OCAxMi44NTU5QzE5LjY2OTggMTIuOTA4NyAxOS41MTYzIDEyLjk4NTUgMTkuMzc3MSAxMy4wODYzQzE5LjI1NzEgMTMuMTc3NSAxOS4xNDY3IDEzLjI4MzEgMTkuMDQ1OSAxMy40MDMxQzE4Ljk0OTkgMTMuNTIzMSAxOC44NjgzIDEzLjY1NSAxOC44MDExIDEzLjc5OVYxNC4zODk0QzE4LjgwMTEgMTQuNzczMyAxOC44Mzk1IDE1LjEwOTMgMTguOTE2MyAxNS4zOTczQzE4Ljk5NzkgMTUuNjg1MyAxOS4xMTA3IDE1LjkyMjkgMTkuMjU0NyAxNi4xMUMxOS4zOTg3IDE2LjMwMiAxOS41NjkxIDE2LjQ0NiAxOS43NjU4IDE2LjU0MkMxOS45NjI2IDE2LjYzOCAyMC4xNzYyIDE2LjY4NiAyMC40MDY2IDE2LjY4NkMyMC42NDE4IDE2LjY4NiAyMC44NTUzIDE2LjYzOCAyMS4wNDczIDE2LjU0MkMyMS4yMzkzIDE2LjQ0MTIgMjEuNDAyNSAxNi4zMDQ0IDIxLjUzNjkgMTYuMTMxNkMyMS42NzEzIDE1Ljk1ODkgMjEuNzc0NSAxNS43NTQ5IDIxLjg0NjUgMTUuNTE5N0MyMS45MTg1IDE1LjI3OTcgMjEuOTU0NSAxNS4wMTgxIDIxLjk1NDUgMTQuNzM1QzIxLjk1NDUgMTQuNDUxOCAyMS45MTg1IDE0LjE5MDIgMjEuODQ2NSAxMy45NTAyQzIxLjc3NDUgMTMuNzEwMiAyMS42NzEzIDEzLjUwMTUgMjEuNTM2OSAxMy4zMjM5QzIxLjQwMjUgMTMuMTUxMSAyMS4yMzY5IDEzLjAxNjcgMjEuMDQwMSAxMi45MjA3QzIwLjg0ODEgMTIuODE5OSAyMC42Mjc0IDEyLjc2OTUgMjAuMzc3OCAxMi43Njk1WiIgZmlsbD0iIzQxM0UzRSIvPgo8cGF0aCBkPSJNMTAuMjEyIDEyLjAzNjFIMTEuMjk5MUMxMS41ODcxIDEyLjAzNjEgMTEuODM0MyAxMS45OTc3IDEyLjA0MDYgMTEuOTIwOUMxMi4yNTE4IDExLjgzOTMgMTIuNDIyMiAxMS43MjY2IDEyLjU1MTggMTEuNTgyNkMxMi42NzE4IDExLjQ1NzggMTIuNzYwNiAxMS4zMDY2IDEyLjgxODIgMTEuMTI5QzEyLjg4MDYgMTAuOTQ2NiAxMi45MTE4IDEwLjc0OTggMTIuOTExOCAxMC41Mzg3QzEyLjkxMTggMTAuMzMyMyAxMi44ODA2IDEwLjE0NTEgMTIuODE4MiA5Ljk3NzA5QzEyLjc2MDYgOS44MDQzMSAxMi42NzE4IDkuNjU1NTIgMTIuNTUxOCA5LjUzMDczQzEyLjQzMTggOS40MTA3NCAxMi4yNzgyIDkuMzE3MTUgMTIuMDkxIDkuMjQ5OTZDMTEuOTA4NyA5LjE4Mjc2IDExLjY5NTEgOS4xNDkxNiAxMS40NTAzIDkuMTQ5MTZDMTEuMjQ4NyA5LjE0OTE2IDExLjA1OTEgOS4xNzc5NiAxMC44ODE1IDkuMjM1NTZDMTAuNzA4OCA5LjI5MzE1IDEwLjU1NzYgOS4zNzQ3NCAxMC40MjggOS40ODAzNEMxMC4yOTM2IDkuNTkwNzMgMTAuMTg4IDkuNzIyNzIgMTAuMTExMiA5Ljg3NjNDMTAuMDM0NCAxMC4wMjk5IDkuOTk2MDIgMTAuMjAyNyA5Ljk5NjAyIDEwLjM5NDdINy45OTQ1OEM3Ljk5NDU4IDkuOTY3NSA4LjA4MDk4IDkuNTc4NzMgOC4yNTM3NiA5LjIyODM2QzguNDMxMzUgOC44Nzc5OSA4LjY3MzczIDguNTc1NjEgOC45ODA5IDguMzIxMjNDOS4yODgwOCA4LjA3MTY1IDkuNjQ4MDUgNy44NzcyNyAxMC4wNjA4IDcuNzM4MDhDMTAuNDc4NCA3LjU5ODg5IDEwLjkyNzEgNy41MjkzIDExLjQwNzEgNy41MjkzQzExLjkyNTUgNy41MjkzIDEyLjQwMDYgNy41OTQwOSAxMi44MzI2IDcuNzIzNjhDMTMuMjY0NSA3Ljg0ODQ3IDEzLjYzNDEgOC4wMzU2NiAxMy45NDEzIDguMjg1MjNDMTQuMjQ4NSA4LjUzOTYxIDE0LjQ4NiA4Ljg1Mzk5IDE0LjY1NCA5LjIyODM2QzE0LjgyNjggOS41OTc5MyAxNC45MTMyIDEwLjAyNzUgMTQuOTEzMiAxMC41MTcxQzE0LjkxMzIgMTAuNzQyNiAxNC44Nzk2IDEwLjk2NTggMTQuODEyNCAxMS4xODY2QzE0Ljc0NTIgMTEuNDAyNiAxNC42NDY4IDExLjYwOSAxNC41MTcyIDExLjgwNTdDMTQuMzg3NyAxMi4wMDI1IDE0LjIyNjkgMTIuMTg0OSAxNC4wMzQ5IDEyLjM1MjlDMTMuODQyOSAxMi41MTYxIDEzLjYyMjEgMTIuNjU3NyAxMy4zNzI1IDEyLjc3NzdDMTMuNjY1MyAxMi44ODMzIDEzLjkxNzMgMTMuMDE3NiAxNC4xMjg1IDEzLjE4MDhDMTQuMzQ0NSAxMy4zNDQgMTQuNTIyIDEzLjUyODggMTQuNjYxMiAxMy43MzUyQzE0LjgwMDQgMTMuOTQ2NCAxNC45MDM2IDE0LjE3NjggMTQuOTcwOCAxNC40MjYzQzE1LjAzOCAxNC42NzU5IDE1LjA3MTYgMTQuOTM5OSAxNS4wNzE2IDE1LjIxODNDMTUuMDcxNiAxNS43MDc4IDE0Ljk3OCAxNi4xNDQ2IDE0Ljc5MDggMTYuNTI4NkMxNC42MDM2IDE2LjkxMjUgMTQuMzQ2OSAxNy4yMzQxIDE0LjAyMDUgMTcuNDkzM0MxMy42OTQxIDE3Ljc1NzMgMTMuMzA1MyAxNy45NTg4IDEyLjg1NDIgMTguMDk4QzEyLjQwNzggMTguMjMyNCAxMS45MjU1IDE4LjI5OTYgMTEuNDA3MSAxOC4yOTk2QzEwLjk2MDcgMTguMjk5NiAxMC41MjQgMTguMjM5NiAxMC4wOTY4IDE4LjExOTZDOS42NzQ0NCAxNy45OTQ4IDkuMjk3NjggMTcuODA3NyA4Ljk2NjUgMTcuNTU4MUM4LjYzNTMzIDE3LjMxMzMgOC4zNjg5NSAxNy4wMDM3IDguMTY3MzcgMTYuNjI5M0M3Ljk3MDU4IDE2LjI1NSA3Ljg3MjE5IDE1LjgxMzQgNy44NzIxOSAxNS4zMDQ3SDkuODczNjNDOS44NzM2MyAxNS41MDYyIDkuOTEyMDIgMTUuNjkzNCA5Ljk4ODgyIDE1Ljg2NjJDMTAuMDY1NiAxNi4wMzQyIDEwLjE3NiAxNi4xNzgyIDEwLjMyIDE2LjI5ODJDMTAuNDU5MiAxNi40MjMgMTAuNjI0OCAxNi41MjE0IDEwLjgxNjggMTYuNTkzNEMxMS4wMDg3IDE2LjY2MDUgMTEuMjE5OSAxNi42OTQxIDExLjQ1MDMgMTYuNjk0MUMxMS43MDk1IDE2LjY5NDEgMTEuOTQyMyAxNi42NTgxIDEyLjE0ODYgMTYuNTg2MkMxMi4zNTUgMTYuNTE0MiAxMi41Mjc4IDE2LjQwODYgMTIuNjY3IDE2LjI2OTRDMTIuODAxNCAxNi4xNDQ2IDEyLjkwMjIgMTUuOTkxIDEyLjk2OTQgMTUuODA4NkMxMy4wNDE0IDE1LjYyNjIgMTMuMDc3NCAxNS40MjIyIDEzLjA3NzQgMTUuMTk2N0MxMy4wNzc0IDE0LjkxMzUgMTMuMDM2NiAxNC42NzExIDEyLjk1NSAxNC40Njk1QzEyLjg3MzQgMTQuMjY3OSAxMi43NTU4IDE0LjEwMjQgMTIuNjAyMiAxMy45NzI4QzEyLjQ0MzggMTMuODQzMiAxMi4yNTQyIDEzLjc0NzIgMTIuMDMzNSAxMy42ODQ4QzExLjgxNzUgMTMuNjIyNCAxMS41NzI3IDEzLjU5MTIgMTEuMjk5MSAxMy41OTEySDEwLjIxMlYxMi4wMzYxWiIgZmlsbD0iIzQxM0UzRSIvPgo8cGF0aCBkPSJNNS4xNTMzNCAxMy4xNTQzQzIuNDcwOTMgMTQuNzk0IDEuMDg3NDMgMTcuMTA3NyAxLjYwNjAxIDE5LjEwNTdDMi4xMjQ1OSAyMS4xMDM4IDQuMzIxNTUgMjIuOTQ5IDcuNzc3MjggMjQuMjg4OEMxMC4yMDExIDI1LjIyODYgMTQuNTkyNCAyNi40Njg2IDE3LjcyMTYgMjYuNzdNMjYuMTAwNSAyNi4xNzVDMzEuMzM3MyAyNS43MjI2IDM1Ljk4MDggMjMuMTc5OSAzNy43NTU2IDIxLjMyMjVDMzkuNTMwMyAxOS40NjUgMzkuNjY1NyAxNy4zODkxIDM4LjEzNiAxNS40OTExQzM3LjYxNDIgMTQuODQzNyAzNi45MTEyIDE0LjIzMjYgMzYuMDUwNCAxMy42Njk2IiBzdHJva2U9IiM0MTNFM0UiIHN0cm9rZS13aWR0aD0iMi4wOTQ3MiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNi42MjMyIDIzLjg2MjJMMTkuNzAzMSAyNi42MjE0TDE2LjQxNjYgMjkuMDI4NCIgc3Ryb2tlPSIjNDEzRTNFIiBzdHJva2Utd2lkdGg9IjIuMDk0NzIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"
                    }
                ]
            })[f ? "area" : "default"].map((e1, n)=>!Bi.isTabIncluded(e1.tab) || d.tabs.length < 2 ? null : Bi.controlsVisible ? t.createElement(cN, {
                    key: n,
                    text: e1.text,
                    img: e1.img,
                    active: m === e1.tab,
                    onClick: ()=>g(e1.tab)
                }) : null), "panorama" === m && BI.vrSessionSupported && BI.currentPanorama && !_x.isMobileDevice && t.createElement(lN, null)), "area" === m && t.createElement(gC, null), t.createElement("div", {
                className: "widget-watermark-button"
            }, t.createElement(uN, {
                href: d.branding ? d.branding.url : (()=>{
                    const e1 = Oy("made-by-link");
                    return "en" === ki.currentLocale ? e1 + "?utm_source=widget&utm_medium=widget" : e1;
                })(),
                text: d.branding ? d.branding.name : Oy("made-by-text")
            })), t.createElement(oN, null));
        }), vC = class {
            constructor(e1){
                let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                const i = {
                    ...Ki,
                    ...n
                }, r = document.querySelector(e1);
                if (!r) throw new Error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0439\u0442\u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442: ".concat(e1));
                r.addEventListener("wheel", (e1)=>e1.preventDefault()), n.width || (i.width = r.offsetWidth), n.height || (i.height = r.offsetHeight), n.panoramaFov && "number" == typeof n.panoramaFov || (i.panoramaFov = Ki.panoramaFov), n.panoramaIcons && "object" == typeof n.panoramaIcons ? i.panoramaIcons = {
                    ...Ki.panoramaIcons,
                    ...n.panoramaIcons
                } : i.panoramaIcons = {
                    ...Ki.panoramaIcons
                }, i.containerElement = r, Bi.setConfig(i), Xi.resize(i), i.resizable && new ResizeObserver(()=>this.onResize()).observe(r), FI.render(t.createElement(AC, null), r);
            }
            get options() {
                return Bi.config;
            }
            get panoramaStore() {
                return BI;
            }
            updateSize(e1) {
                const t = {
                    ...this.options,
                    ...e1
                };
                Bi.setConfig(t), Xi.resize(t);
            }
            onResize() {
                const { offsetWidth: e1, offsetHeight: t } = this.options.containerElement;
                this.updateSize({
                    width: e1,
                    height: t
                });
            }
            on(e1, t) {
                Bi.addEventListener(e1, t);
            }
        };
    })(), $a5056a6656605403$exports = i;
})();



const $8f6a480bb40b134f$var$WIDGET_API_URL = "https://backend.estate.hart-digital.com";
const $8f6a480bb40b134f$var$WIDGET_STAGE_API_URL = "https://backend-stage.estate.hart-digital.com";
const $8f6a480bb40b134f$var$HIDE_PRELOADER_DELAY_AFTER_LOAD = 500;
const $8f6a480bb40b134f$var$hidePreloader = ()=>{
    const preloader = document.querySelector(".widget-preloader-frame");
    if (preloader) preloader.classList.add("hidden");
    else console.error("Preloader not found!");
};
const $8f6a480bb40b134f$var$showWhiteBack = ()=>{
    const back = document.querySelector(".w-back");
    back.style.display = "block";
};
const $8f6a480bb40b134f$var$hideWhiteBack = ()=>{
    const back = document.querySelector(".w-back");
    back.style.display = "none";
};
const $8f6a480bb40b134f$var$updateScaleText = (scaleButton)=>{
    const img = scaleButton.querySelector("img");
    const span = scaleButton.querySelector("span");
    if (img && span) {
        const dataTail05 = "Ii8+Cjwvc3ZnPgo=";
        span.innerHTML = img.src.endsWith(dataTail05) ? "0.5x" : "1x";
    }
};
const $8f6a480bb40b134f$var$removeButtonsAndHideContainer = ()=>{
    const controlsContainer = document.querySelector(".widget-tab__panorama-controls");
    const rotationButton = document.querySelector(".widget-tab__panorama-controls-button--rotation");
    const rulerButton = document.querySelector(".widget-tab__panorama-controls-button--ruler");
    const button3D = document.querySelectorAll(".widget-tab-button")[1];
    button3D.addEventListener("click", ()=>{
        const interval = setInterval(()=>{
            const scaleButton = document.querySelector(".widget-tab__panorama-controls-button--scale");
            const rotationButton = document.querySelector(".widget-tab__panorama-controls-button--rotation");
            if (scaleButton && rotationButton) {
                clearInterval(interval);
                rotationButton.remove();
            }
        }, 0.01);
        rotationButton.remove();
    });
    if (rotationButton) rotationButton.remove();
    if (controlsContainer && !rulerButton) controlsContainer.style.display = "none";
};
const $8f6a480bb40b134f$var$startRulerTime = ()=>{
    const rulerTime = setInterval(()=>{
        const select = document.querySelector(".floors-select");
        const ruler = document.querySelector(".widget-tab__panorama-controls-button--ruler");
        if (select && ruler) {
            select.before(ruler);
            clearInterval(rulerTime);
        }
    }, 100);
};
const $8f6a480bb40b134f$var$startScaleTime = ()=>{
    const scaleTime = setInterval(()=>{
        const select = document.querySelector(".widget-tab-button--active");
        const scale = document.querySelector(".widget-tab__panorama-controls-button--scale");
        if (select && scale) {
            select.after(scale);
            if (!scale.querySelector("span")) {
                const span = document.createElement("span");
                scale.appendChild(span);
                $8f6a480bb40b134f$var$updateScaleText(scale);
            }
            clearInterval(scaleTime);
        }
    }, 100);
};
const $8f6a480bb40b134f$var$startSelectFloorTime = ()=>{
    const selectTime = setInterval(()=>{
        const buttons = document.querySelector(".widget-tab-buttons");
        const select = document.querySelector(".floors-select");
        if (select && buttons) {
            buttons.append(select);
            clearInterval(selectTime);
        }
    }, 100);
};
const $8f6a480bb40b134f$var$setDefaultScale = ()=>{
    const selectTime = setInterval(()=>{
        const scale = document.querySelector(".widget-tab__panorama-controls-button--scale");
        if (scale) {
            scale.click();
            clearInterval(selectTime);
        }
    }, 100);
};
const $8f6a480bb40b134f$var$copyWidgetEvents = ()=>{
    document.querySelector(".widget-tab-buttons .widget-tab__isometry-arrow--prev").addEventListener("click", ()=>{
        document.querySelector(".widget-tab__rotation .widget-tab__isometry-arrow--prev").click();
        document.querySelector(".widget-tab-buttons span").innerHTML = document.querySelector(".widget-tab__rotation span").innerHTML;
    });
    document.querySelector(".widget-tab-buttons .widget-tab__isometry-arrow--next").addEventListener("click", ()=>{
        document.querySelector(".widget-tab__rotation .widget-tab__isometry-arrow--next").click();
        document.querySelector(".widget-tab-buttons span").innerHTML = document.querySelector(".widget-tab__rotation span").innerHTML;
    });
    document.querySelector(".widget-tab__isometry-button").addEventListener("click", ()=>{
        document.querySelector(".widget-tab-buttons .widget-tab__isometry-arrows").remove();
        $8f6a480bb40b134f$var$startArrowsTime();
    });
};
const $8f6a480bb40b134f$var$startArrowsTime = ()=>{
    const arrowsTime = setInterval(()=>{
        const buttons = document.querySelector(".widget-tab-buttons");
        const arrows = document.querySelector(".widget-tab__isometry-arrows");
        if (buttons && arrows) {
            buttons.append(arrows.cloneNode(true));
            $8f6a480bb40b134f$var$copyWidgetEvents();
            clearInterval(arrowsTime);
        }
    }, 100);
};
const $8f6a480bb40b134f$var$redesignButtons = ()=>{
    $8f6a480bb40b134f$var$startSelectFloorTime();
    $8f6a480bb40b134f$var$startRulerTime();
    $8f6a480bb40b134f$var$startScaleTime();
    $8f6a480bb40b134f$var$startArrowsTime();
    document.addEventListener("click", (e)=>{
        if (e.target.innerHTML === "2D") {
            const buttons = document.querySelector(".widget-tab-buttons");
            const ruler = document.querySelector(".widget-tab__panorama-controls-button--ruler");
            const scale = document.querySelector(".widget-tab__panorama-controls-button--scale");
            buttons.removeChild(scale);
            $8f6a480bb40b134f$var$startScaleTime();
            if (ruler) {
                buttons.removeChild(ruler);
                $8f6a480bb40b134f$var$startRulerTime();
            }
        } else if (e.target.innerHTML === "3D") {
            $8f6a480bb40b134f$var$showWhiteBack();
            $8f6a480bb40b134f$var$setDefaultScale();
            const buttons = document.querySelector(".widget-tab-buttons");
            const arrows = document.querySelector(".widget-tab__isometry-arrows");
            buttons.removeChild(arrows);
            $8f6a480bb40b134f$var$startArrowsTime();
            setTimeout(()=>$8f6a480bb40b134f$var$hideWhiteBack(), 100);
        } else if (e.target.className.endsWith("controls-button--scale")) $8f6a480bb40b134f$var$updateScaleText(e.target);
    });
};
const $8f6a480bb40b134f$var$observeDOM = (callback)=>{
    const observer = new MutationObserver(()=>{
        if (document.querySelector(".widget-tab__panorama-controls-button--scale")) {
            observer.disconnect();
            callback();
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};
$8f6a480bb40b134f$var$observeDOM($8f6a480bb40b134f$var$removeButtonsAndHideContainer);
const $8f6a480bb40b134f$var$getText = (lang)=>{
    if (lang === "ru") return "\u041E\u0442\u0434\u0435\u043B\u043A\u0430 \u0438 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u044B \u043C\u0435\u0431\u0435\u043B\u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u044B \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u043F\u0440\u0438\u043C\u0435\u0440\u0430 \u0438 \u043D\u0435 \u0432\u0445\u043E\u0434\u044F\u0442 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u0430\u0436\u0438";
    return "Apartments serve illustrational purpose only, design may vary";
};
const $8f6a480bb40b134f$var$createWidget = async ()=>{
    const searchParams = new URLSearchParams(window.location.search);
    const env = searchParams.get("env");
    const widgetApiHandler = new (0, $a5056a6656605403$exports.ApiStore)(env?.toLowerCase() === "stage" ? $8f6a480bb40b134f$var$WIDGET_STAGE_API_URL : $8f6a480bb40b134f$var$WIDGET_API_URL);
    const planId = searchParams.get("id");
    const planData = await widgetApiHandler.loadWidgetData(planId);
    const langRu = searchParams.get("lang") === "ru";
    if (langRu) document.getElementById("widget").classList.add("widget-ru");
    const primaryCameraPointId = searchParams.get("primaryCameraPointId");
    const options = {
        ...planData.parsed,
        API_URL: $8f6a480bb40b134f$var$WIDGET_API_URL,
        rotationMode: (0, $a5056a6656605403$exports.rotationModes).DEFAULT,
        tabs: [
            "panorama",
            "rotation"
        ],
        locale: langRu ? "ru" : "en",
        colors: {
            main: "#FFD180",
            mainText: "#252525"
        },
        dictionaryOverrides: {
            floor: "Floor $0",
            "instructions-hint-text": $8f6a480bb40b134f$var$getText(langRu ? "ru" : "en")
        },
        scales: [
            "x05",
            "x1"
        ],
        scaleButtonType: "text",
        primaryCameraPointId: primaryCameraPointId,
        ruler_options: {
            font_size: 76
        }
    };
    new (0, $a5056a6656605403$exports.Widget)("#widget", options);
};
// 'https://www.evometa.com/'
$8f6a480bb40b134f$var$createWidget().then(()=>{
    $8f6a480bb40b134f$var$redesignButtons();
    setTimeout($8f6a480bb40b134f$var$hidePreloader, $8f6a480bb40b134f$var$HIDE_PRELOADER_DELAY_AFTER_LOAD);
});


//# sourceMappingURL=index.f6484e3e.js.map
